import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React79 from 'react';
import React79__default, { createContext, useContext, useMemo, useRef, useEffect, useCallback, useState, useLayoutEffect, useId, Suspense, lazy, useSyncExternalStore } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { EventBusContext, useTraitScopeChain, useCurrentPagePath, useGameAudioContextOptional, useRenderSlot, useNavStack, useEntitySchemaOptional, RenderSlotProvider, useEntityBindingSnapshot, useTraitScope, TraitScopeProvider } from '@almadar/ui/providers';
export { GameAudioContext, GameAudioProvider, useGameAudioContext, useNavStack } from '@almadar/ui/providers';
import { createLogger, isLogLevelEnabled } from '@almadar/logger';
import * as LucideIcons2 from 'lucide-react';
import { X, List, Printer, ChevronRight, ChevronLeft, Check, Copy, RotateCcw, Play, Terminal, CheckCircle, XCircle, ChevronDown, Search, ChevronUp, MoreHorizontal, ArrowLeft, DollarSign, Package, Calendar, Pencil, Eye, Image as Image$1, Upload, ZoomIn, TrendingUp, TrendingDown, Minus, AlertCircle, Circle, Clock, CheckCircle2, Loader2, Code, FileText, WrapText, HelpCircle, Bold, Italic, Underline, Strikethrough, Heading1, Heading2, Heading3, ListOrdered, Quote, Link as Link$1, GitBranch, Plus, ArrowRight, Trash, Menu as Menu$1, AlertTriangle, Trash2, Eraser, ZoomOut, Download, Lightbulb, PauseCircle, Link2 } from 'lucide-react';
import { useTranslate } from '@almadar/ui/hooks';
import { useUISlots, useTheme } from '@almadar/ui/context';
import { evaluate, createMinimalContext } from '@almadar/evaluator';
import { createContextFromBindings, interpolateValue } from '@almadar/runtime';
import { UI_SLOTS, getNestedValue, mergeEntityFrame, isFileValue, isInlineTrait, isSecretConfigType, isRenderBindingMarker } from '@almadar/core';
import { createPortal } from 'react-dom';
import { wrapCallbackForEvent, perfStart, perfEnd } from '@almadar/runtime/ui';
import { Link, Outlet, useLocation } from 'react-router-dom';
import ELK from 'elkjs/lib/elk.bundled.js';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-light.js';
import dark from 'react-syntax-highlighter/dist/esm/styles/prism/vsc-dark-plus.js';
import { orbLanguage, loloLanguage, ORB_COLORS, translateLolo, translateOrb } from '@almadar/syntax';
import { coreTables } from '@almadar/core/i18n';
import langJson from 'react-syntax-highlighter/dist/esm/languages/prism/json.js';
import langJavascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript.js';
import langTypescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript.js';
import langJsx from 'react-syntax-highlighter/dist/esm/languages/prism/jsx.js';
import langTsx from 'react-syntax-highlighter/dist/esm/languages/prism/tsx.js';
import langCss from 'react-syntax-highlighter/dist/esm/languages/prism/css.js';
import langMarkdown from 'react-syntax-highlighter/dist/esm/languages/prism/markdown.js';
import langBash from 'react-syntax-highlighter/dist/esm/languages/prism/bash.js';
import langYaml from 'react-syntax-highlighter/dist/esm/languages/prism/yaml.js';
import langRust from 'react-syntax-highlighter/dist/esm/languages/prism/rust.js';
import langPython from 'react-syntax-highlighter/dist/esm/languages/prism/python.js';
import langSql from 'react-syntax-highlighter/dist/esm/languages/prism/sql.js';
import langDiff from 'react-syntax-highlighter/dist/esm/languages/prism/diff.js';
import langToml from 'react-syntax-highlighter/dist/esm/languages/prism/toml.js';
import langGo from 'react-syntax-highlighter/dist/esm/languages/prism/go.js';
import langGraphql from 'react-syntax-highlighter/dist/esm/languages/prism/graphql.js';
import langClojure from 'react-syntax-highlighter/dist/esm/languages/prism/clojure.js';
import langHaskell from 'react-syntax-highlighter/dist/esm/languages/prism/haskell.js';
import langLisp from 'react-syntax-highlighter/dist/esm/languages/prism/lisp.js';
import langScheme from 'react-syntax-highlighter/dist/esm/languages/prism/scheme.js';
import langScala from 'react-syntax-highlighter/dist/esm/languages/prism/scala.js';
import langElixir from 'react-syntax-highlighter/dist/esm/languages/prism/elixir.js';
import langErlang from 'react-syntax-highlighter/dist/esm/languages/prism/erlang.js';
import langElm from 'react-syntax-highlighter/dist/esm/languages/prism/elm.js';
import langFsharp from 'react-syntax-highlighter/dist/esm/languages/prism/fsharp.js';
import langOcaml from 'react-syntax-highlighter/dist/esm/languages/prism/ocaml.js';
import langJava from 'react-syntax-highlighter/dist/esm/languages/prism/java.js';
import langC from 'react-syntax-highlighter/dist/esm/languages/prism/c.js';
import langCpp from 'react-syntax-highlighter/dist/esm/languages/prism/cpp.js';
import langCsharp from 'react-syntax-highlighter/dist/esm/languages/prism/csharp.js';
import langObjectivec from 'react-syntax-highlighter/dist/esm/languages/prism/objectivec.js';
import langPhp from 'react-syntax-highlighter/dist/esm/languages/prism/php.js';
import langRuby from 'react-syntax-highlighter/dist/esm/languages/prism/ruby.js';
import langSwift from 'react-syntax-highlighter/dist/esm/languages/prism/swift.js';
import langKotlin from 'react-syntax-highlighter/dist/esm/languages/prism/kotlin.js';
import langLua from 'react-syntax-highlighter/dist/esm/languages/prism/lua.js';
import langR from 'react-syntax-highlighter/dist/esm/languages/prism/r.js';
import langDart from 'react-syntax-highlighter/dist/esm/languages/prism/dart.js';
import langJulia from 'react-syntax-highlighter/dist/esm/languages/prism/julia.js';
import langFortran from 'react-syntax-highlighter/dist/esm/languages/prism/fortran.js';
import langPerl from 'react-syntax-highlighter/dist/esm/languages/prism/perl.js';
import langPowershell from 'react-syntax-highlighter/dist/esm/languages/prism/powershell.js';
import langMakefile from 'react-syntax-highlighter/dist/esm/languages/prism/makefile.js';
import langNginx from 'react-syntax-highlighter/dist/esm/languages/prism/nginx.js';
import langIni from 'react-syntax-highlighter/dist/esm/languages/prism/ini.js';
import langClike from 'react-syntax-highlighter/dist/esm/languages/prism/clike.js';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import { DndContext, useSensors, useSensor, PointerSensor, KeyboardSensor, useDroppable, pointerWithin, rectIntersection, closestCorners } from '@dnd-kit/core';
import { useSortable, arrayMove, sortableKeyboardCoordinates, SortableContext, rectSortingStrategy, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ordered, lib } from 'emojilib';
import { useNodeId, ReactFlowProvider, Handle, Position } from '@xyflow/react';
import { forceSimulation, forceLink, forceManyBody, forceCollide, forceX, forceY } from 'd3-force';
import { SELF_OVERLAY_PATTERN_TYPES, isDrawHostPattern, getPatternDefinition as getPatternDefinition$1, getPatternFieldsContract, getComponentForPattern as getComponentForPattern$1 } from '@almadar/core/patterns';
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function buildForkPaths(x, y, branches, scale) {
  const inLength = 30 * scale;
  const outLength = 30 * scale;
  const fanSpread = 20 * scale;
  const junctionX = x + inLength;
  const paths = [];
  paths.push(`M ${x} ${y} L ${junctionX} ${y}`);
  for (let i = 0; i < branches; i++) {
    const fraction = branches === 1 ? 0 : i / (branches - 1) * 2 - 1;
    const endY = y + fraction * fanSpread;
    const endX = junctionX + outLength;
    const cpX = junctionX + outLength * 0.5;
    paths.push(`M ${junctionX} ${y} C ${cpX} ${y} ${cpX} ${endY} ${endX} ${endY}`);
  }
  return paths;
}
function buildMergePaths(x, y, branches, scale) {
  const inLength = 30 * scale;
  const outLength = 30 * scale;
  const fanSpread = 20 * scale;
  const junctionX = x + inLength;
  const paths = [];
  for (let i = 0; i < branches; i++) {
    const fraction = branches === 1 ? 0 : i / (branches - 1) * 2 - 1;
    const startY = y + fraction * fanSpread;
    const cpX = x + inLength * 0.5;
    paths.push(`M ${x} ${startY} C ${cpX} ${startY} ${cpX} ${y} ${junctionX} ${y}`);
  }
  paths.push(`M ${junctionX} ${y} L ${junctionX + outLength} ${y}`);
  return paths;
}
function buildDiamondPoints(x, y, scale) {
  const w = 20 * scale;
  const h = 14 * scale;
  return [
    `${x + w} ${y}`,
    `${x + w * 2} ${y + h}`,
    `${x + w} ${y + h * 2}`,
    `${x} ${y + h}`
  ].join(" ");
}
var SvgBranch;
var init_SvgBranch = __esm({
  "components/core/atoms/svg/SvgBranch.tsx"() {
    "use client";
    SvgBranch = ({
      x = 5,
      y = 50,
      variant = "fork",
      branches = 2,
      size = 1,
      color = "var(--color-primary)",
      opacity = 1,
      className,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      let inner;
      if (variant === "diamond") {
        const points = buildDiamondPoints(x, y, size);
        inner = /* @__PURE__ */ jsx("g", { className, opacity, children: /* @__PURE__ */ jsx(
          "polygon",
          {
            points,
            fill: "none",
            stroke: color,
            strokeWidth: 2,
            strokeLinejoin: "round"
          }
        ) });
      } else {
        const paths = variant === "fork" ? buildForkPaths(x, y, branches, size) : buildMergePaths(x, y, branches, size);
        inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
          paths.map((d, i) => /* @__PURE__ */ jsx(
            "path",
            {
              d,
              fill: "none",
              stroke: color,
              strokeWidth: 2,
              strokeLinecap: "round"
            },
            i
          )),
          variant === "fork" && /* @__PURE__ */ jsx("circle", { cx: x + 30 * size, cy: y, r: 3, fill: color }),
          variant === "merge" && /* @__PURE__ */ jsx("circle", { cx: x + 30 * size, cy: y, r: 3, fill: color })
        ] });
      }
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return /* @__PURE__ */ jsx(Fragment, { children: inner });
    };
    SvgBranch.displayName = "SvgBranch";
  }
});
var SvgConnection;
var init_SvgConnection = __esm({
  "components/core/atoms/svg/SvgConnection.tsx"() {
    "use client";
    SvgConnection = ({
      x1 = 10,
      y1 = 50,
      x2 = 90,
      y2 = 50,
      variant = "solid",
      color = "var(--color-primary)",
      strokeWidth = 1.5,
      opacity = 1,
      className,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const dashProps = variant === "solid" ? {} : {
        strokeDasharray: "8 6"
      };
      const inner = /* @__PURE__ */ jsx(
        "line",
        {
          className: [
            variant === "animated" ? "almadar-svg-flow-dash" : void 0,
            className
          ].filter(Boolean).join(" ") || void 0,
          x1,
          y1,
          x2,
          y2,
          stroke: color,
          strokeWidth,
          strokeLinecap: "round",
          opacity,
          ...dashProps
        }
      );
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgConnection.displayName = "SvgConnection";
  }
});
var flowIdCounter, DEFAULT_POINTS, SvgFlow;
var init_SvgFlow = __esm({
  "components/core/atoms/svg/SvgFlow.tsx"() {
    "use client";
    flowIdCounter = 0;
    DEFAULT_POINTS = [[10, 50], [50, 20], [90, 50]];
    SvgFlow = ({
      points = DEFAULT_POINTS,
      color = "var(--color-primary)",
      strokeWidth = 1.5,
      animated = false,
      opacity = 1,
      className,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const markerId = React79__default.useMemo(() => {
        flowIdCounter += 1;
        return `almadar-flow-arrow-${flowIdCounter}`;
      }, []);
      if (points.length < 2) {
        return null;
      }
      const pathData = points.map((pt, i) => `${i === 0 ? "M" : "L"}${pt[0]},${pt[1]}`).join(" ");
      const inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
          "marker",
          {
            id: markerId,
            markerWidth: "8",
            markerHeight: "6",
            refX: "7",
            refY: "3",
            orient: "auto",
            markerUnits: "strokeWidth",
            children: /* @__PURE__ */ jsx("path", { d: "M0,0 L8,3 L0,6 Z", fill: color })
          }
        ) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: pathData,
            fill: "none",
            stroke: color,
            strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            markerEnd: `url(#${markerId})`,
            className: animated ? "almadar-svg-flow-dash" : void 0,
            strokeDasharray: animated ? "8 6" : void 0
          }
        )
      ] });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgFlow.displayName = "SvgFlow";
  }
});
var SvgGrid;
var init_SvgGrid = __esm({
  "components/core/atoms/svg/SvgGrid.tsx"() {
    "use client";
    SvgGrid = ({
      x = 10,
      y = 10,
      cols = 4,
      rows: rows2 = 3,
      spacing = 20,
      nodeRadius = 3,
      color = "var(--color-primary)",
      opacity = 1,
      className,
      highlights = [],
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const highlightSet = new Set(highlights);
      const inner = /* @__PURE__ */ jsx("g", { className, opacity, children: Array.from({ length: rows2 }).map(
        (_, row) => Array.from({ length: cols }).map((_2, col) => {
          const index = row * cols + col;
          const isHighlighted = highlightSet.has(index);
          const cx = x + col * spacing;
          const cy = y + row * spacing;
          return /* @__PURE__ */ jsx(
            "circle",
            {
              cx,
              cy,
              r: isHighlighted ? nodeRadius * 1.6 : nodeRadius,
              fill: color,
              opacity: isHighlighted ? 1 : 0.4
            },
            index
          );
        })
      ) });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgGrid.displayName = "SvgGrid";
  }
});
var SvgLobe;
var init_SvgLobe = __esm({
  "components/core/atoms/svg/SvgLobe.tsx"() {
    "use client";
    SvgLobe = ({
      cx = 50,
      cy = 50,
      rx = 14,
      ry = 20,
      rotation = 0,
      shells = 2,
      color = "var(--color-primary)",
      opacity = 1,
      className,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const clampedShells = Math.max(1, Math.min(3, shells));
      const renderShell = (shellIndex) => {
        const scale = shellIndex === 0 ? 1 : 1 - shellIndex * 0.3;
        const shellOpacity = shellIndex === 0 ? 1 : 0.5;
        const sRx = rx * scale;
        const sRy = ry * scale;
        return /* @__PURE__ */ jsxs("g", { opacity: shellOpacity, children: [
          /* @__PURE__ */ jsx(
            "ellipse",
            {
              cx,
              cy: cy - sRy,
              rx: sRx,
              ry: sRy,
              fill: "none",
              stroke: color,
              strokeWidth: 1.5
            }
          ),
          /* @__PURE__ */ jsx(
            "ellipse",
            {
              cx,
              cy: cy + sRy,
              rx: sRx,
              ry: sRy,
              fill: "none",
              stroke: color,
              strokeWidth: 1.5
            }
          )
        ] }, shellIndex);
      };
      const inner = /* @__PURE__ */ jsx(
        "g",
        {
          className,
          opacity,
          transform: `rotate(${rotation}, ${cx}, ${cy})`,
          children: Array.from({ length: clampedShells }, (_, i) => renderShell(i))
        }
      );
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgLobe.displayName = "SvgLobe";
  }
});
function getNodePositions(cx, cy, count, radius) {
  return Array.from({ length: count }).map((_, i) => {
    const angle = i / count * Math.PI * 2 - Math.PI / 2;
    return {
      x: cx + Math.cos(angle) * radius,
      y: cy + Math.sin(angle) * radius
    };
  });
}
function getConnections(count, density) {
  const allPairs = [];
  for (let i = 0; i < count; i++) {
    for (let j = i + 1; j < count; j++) {
      allPairs.push([i, j]);
    }
  }
  const connectCount = Math.round(allPairs.length * Math.max(0, Math.min(1, density)));
  return allPairs.slice(0, connectCount);
}
var SvgMesh;
var init_SvgMesh = __esm({
  "components/core/atoms/svg/SvgMesh.tsx"() {
    "use client";
    SvgMesh = ({
      cx = 60,
      cy = 60,
      nodes = 6,
      radius = 50,
      color = "var(--color-primary)",
      connectionDensity = 0.5,
      opacity = 1,
      className,
      asRoot = true,
      width = 120,
      height = 120
    }) => {
      const positions = getNodePositions(cx, cy, nodes, radius);
      const connections = getConnections(nodes, connectionDensity);
      const inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        connections.map(([a, b]) => /* @__PURE__ */ jsx(
          "line",
          {
            x1: positions[a].x,
            y1: positions[a].y,
            x2: positions[b].x,
            y2: positions[b].y,
            stroke: color,
            strokeWidth: 1,
            opacity: 0.3
          },
          `${a}-${b}`
        )),
        positions.map((pos, i) => /* @__PURE__ */ jsx(
          "circle",
          {
            cx: pos.x,
            cy: pos.y,
            r: 4,
            fill: color
          },
          i
        ))
      ] });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgMesh.displayName = "SvgMesh";
  }
});
var TextLines, CodeBrackets, AppRect, FlowArrow, SvgMorph;
var init_SvgMorph = __esm({
  "components/core/atoms/svg/SvgMorph.tsx"() {
    "use client";
    TextLines = ({
      x,
      y,
      scale,
      color
    }) => {
      const widths = [28, 22, 26];
      return /* @__PURE__ */ jsx("g", { children: widths.map((w, i) => /* @__PURE__ */ jsx(
        "rect",
        {
          x,
          y: y + i * 8 * scale,
          width: w * scale,
          height: 3 * scale,
          rx: 1.5 * scale,
          fill: color,
          opacity: 0.7 - i * 0.1
        },
        i
      )) });
    };
    TextLines.displayName = "TextLines";
    CodeBrackets = ({
      x,
      y,
      scale,
      color
    }) => {
      const h = 20 * scale;
      const w = 8 * scale;
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: `M ${x + w} ${y} L ${x} ${y + h / 2} L ${x + w} ${y + h}`,
            fill: "none",
            stroke: color,
            strokeWidth: 2 * scale,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: `M ${x + w * 2} ${y} L ${x + w * 3} ${y + h / 2} L ${x + w * 2} ${y + h}`,
            fill: "none",
            stroke: color,
            strokeWidth: 2 * scale,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] });
    };
    CodeBrackets.displayName = "CodeBrackets";
    AppRect = ({
      x,
      y,
      scale,
      color
    }) => {
      const w = 22 * scale;
      const h = 20 * scale;
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            x,
            y,
            width: w,
            height: h,
            rx: 4 * scale,
            fill: "none",
            stroke: color,
            strokeWidth: 2 * scale
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: x + 4 * scale,
            y: y + 4 * scale,
            width: w - 8 * scale,
            height: 3 * scale,
            rx: 1 * scale,
            fill: color,
            opacity: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: x + 4 * scale,
            y: y + 10 * scale,
            width: (w - 8 * scale) * 0.6,
            height: 3 * scale,
            rx: 1 * scale,
            fill: color,
            opacity: 0.3
          }
        )
      ] });
    };
    AppRect.displayName = "AppRect";
    FlowArrow = ({ x1, y, x2, scale, color }) => {
      const arrowSize = 4 * scale;
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(
          "line",
          {
            x1,
            y1: y,
            x2: x2 - arrowSize,
            y2: y,
            stroke: color,
            strokeWidth: 1.5 * scale,
            strokeDasharray: `${3 * scale} ${3 * scale}`,
            opacity: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "polygon",
          {
            points: `${x2} ${y}, ${x2 - arrowSize} ${y - arrowSize / 2}, ${x2 - arrowSize} ${y + arrowSize / 2}`,
            fill: color,
            opacity: 0.6
          }
        )
      ] });
    };
    FlowArrow.displayName = "FlowArrow";
    SvgMorph = ({
      x = 5,
      y = 10,
      size = 1,
      variant = "generic",
      color = "var(--color-primary)",
      opacity = 1,
      className,
      asRoot = true,
      width = 130,
      height = 50
    }) => {
      const gap = 40 * size;
      const midY = y + 10 * size;
      let inner;
      if (variant === "text-to-code") {
        const leftEnd = x + 30 * size;
        const rightStart = leftEnd + gap;
        inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
          /* @__PURE__ */ jsx(TextLines, { x, y, scale: size, color }),
          /* @__PURE__ */ jsx(FlowArrow, { x1: leftEnd, y: midY, x2: rightStart, scale: size, color }),
          /* @__PURE__ */ jsx(CodeBrackets, { x: rightStart, y, scale: size, color })
        ] });
      } else if (variant === "code-to-app") {
        const leftEnd = x + 26 * size;
        const rightStart = leftEnd + gap;
        inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
          /* @__PURE__ */ jsx(CodeBrackets, { x, y, scale: size, color }),
          /* @__PURE__ */ jsx(FlowArrow, { x1: leftEnd, y: midY, x2: rightStart, scale: size, color }),
          /* @__PURE__ */ jsx(AppRect, { x: rightStart, y, scale: size, color })
        ] });
      } else {
        const circleR = 10 * size;
        const circleX = x + circleR;
        const squareStart = x + circleR * 2 + gap;
        const squareSize = circleR * 2;
        inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: circleX,
              cy: midY,
              r: circleR,
              fill: "none",
              stroke: color,
              strokeWidth: 2 * size
            }
          ),
          /* @__PURE__ */ jsx(
            FlowArrow,
            {
              x1: circleX + circleR + 2 * size,
              y: midY,
              x2: squareStart,
              scale: size,
              color
            }
          ),
          /* @__PURE__ */ jsx(
            "rect",
            {
              x: squareStart,
              y: midY - circleR,
              width: squareSize,
              height: squareSize,
              rx: 3 * size,
              fill: "none",
              stroke: color,
              strokeWidth: 2 * size
            }
          )
        ] });
      }
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return /* @__PURE__ */ jsx(Fragment, { children: inner });
    };
    SvgMorph.displayName = "SvgMorph";
  }
});
var SvgNode;
var init_SvgNode = __esm({
  "components/core/atoms/svg/SvgNode.tsx"() {
    "use client";
    SvgNode = ({
      x = 50,
      y = 50,
      r = 6,
      variant = "filled",
      color = "var(--color-primary)",
      opacity = 1,
      className,
      label,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        variant === "pulse" && /* @__PURE__ */ jsx(
          "circle",
          {
            cx: x,
            cy: y,
            r: r * 2,
            fill: "none",
            stroke: color,
            strokeWidth: 1,
            opacity: 0.3,
            className: "almadar-svg-pulse-ring"
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: x,
            cy: y,
            r,
            fill: variant === "stroked" ? "none" : color,
            stroke: variant === "stroked" ? color : "none",
            strokeWidth: variant === "stroked" ? 2 : 0
          }
        ),
        label && /* @__PURE__ */ jsx(
          "text",
          {
            x,
            y: y + r + 14,
            textAnchor: "middle",
            fill: color,
            fontSize: 11,
            fontFamily: "inherit",
            children: label
          }
        )
      ] });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgNode.displayName = "SvgNode";
  }
});
var PULSE_KEYFRAMES, SvgPulse;
var init_SvgPulse = __esm({
  "components/core/atoms/svg/SvgPulse.tsx"() {
    "use client";
    PULSE_KEYFRAMES = `
@keyframes almadar-svg-pulse-expand {
  0% {
    transform: scale(0.3);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
`;
    SvgPulse = ({
      cx = 70,
      cy = 70,
      rings = 3,
      maxRadius = 60,
      color = "var(--color-primary)",
      animated = true,
      opacity = 1,
      className,
      asRoot = true,
      width = 140,
      height = 140
    }) => {
      const inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        animated && /* @__PURE__ */ jsx("style", { children: PULSE_KEYFRAMES }),
        Array.from({ length: rings }).map((_, i) => {
          const ringRadius = (i + 1) / rings * maxRadius;
          const ringOpacity = 1 - i / rings * 0.6;
          const delay = i * 0.6;
          return /* @__PURE__ */ jsx(
            "circle",
            {
              cx,
              cy,
              r: ringRadius,
              fill: "none",
              stroke: color,
              strokeWidth: 1.5,
              opacity: animated ? void 0 : ringOpacity * 0.4,
              style: animated ? {
                transformOrigin: `${cx}px ${cy}px`,
                animation: `almadar-svg-pulse-expand 2s ease-out ${delay}s infinite`
              } : void 0
            },
            i
          );
        }),
        /* @__PURE__ */ jsx("circle", { cx, cy, r: 3, fill: color })
      ] });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgPulse.displayName = "SvgPulse";
  }
});
var ringIdCounter, SvgRing;
var init_SvgRing = __esm({
  "components/core/atoms/svg/SvgRing.tsx"() {
    "use client";
    ringIdCounter = 0;
    SvgRing = ({
      cx = 50,
      cy = 50,
      r = 40,
      variant = "solid",
      color = "var(--color-primary)",
      strokeWidth = 1.5,
      opacity = 1,
      className,
      label,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const gradientId = React79__default.useMemo(() => {
        ringIdCounter += 1;
        return `almadar-ring-glow-${ringIdCounter}`;
      }, []);
      const inner = /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        variant === "glow" && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("radialGradient", { id: gradientId, cx: "50%", cy: "50%", r: "50%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: color, stopOpacity: 0.15 }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: color, stopOpacity: 0 })
          ] }) }),
          /* @__PURE__ */ jsx("circle", { cx, cy, r, fill: `url(#${gradientId})` })
        ] }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx,
            cy,
            r,
            fill: "none",
            stroke: color,
            strokeWidth,
            strokeDasharray: variant === "dashed" ? "6 4" : void 0
          }
        ),
        label && /* @__PURE__ */ jsx(
          "text",
          {
            x: cx,
            y: cy - r - 6,
            textAnchor: "middle",
            fill: color,
            fontSize: 11,
            fontFamily: "inherit",
            children: label
          }
        )
      ] });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgRing.displayName = "SvgRing";
  }
});
var SHIELD_PATH, CHECK_PATH, SvgShield;
var init_SvgShield = __esm({
  "components/core/atoms/svg/SvgShield.tsx"() {
    "use client";
    SHIELD_PATH = "M15,2 C15,2 5,5 2,6 C2,6 2,18 5,24 C8,30 15,34 15,34 C15,34 22,30 25,24 C28,18 28,6 28,6 C25,5 15,2 15,2 Z";
    CHECK_PATH = "M10,18 L14,22 L21,13";
    SvgShield = ({
      x = 50,
      y = 50,
      size = 1,
      variant = "outline",
      color = "var(--color-primary)",
      opacity = 1,
      className,
      asRoot = true,
      width = 100,
      height = 100
    }) => {
      const inner = /* @__PURE__ */ jsxs(
        "g",
        {
          className,
          opacity,
          transform: `translate(${x - 15 * size}, ${y - 18 * size}) scale(${size})`,
          children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                d: SHIELD_PATH,
                fill: variant === "filled" || variant === "check" ? color : "none",
                stroke: color,
                strokeWidth: 2,
                strokeLinejoin: "round"
              }
            ),
            variant === "check" && /* @__PURE__ */ jsx(
              "path",
              {
                d: CHECK_PATH,
                fill: "none",
                stroke: variant === "check" ? "white" : color,
                strokeWidth: 2.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            )
          ]
        }
      );
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, children: inner });
      }
      return inner;
    };
    SvgShield.displayName = "SvgShield";
  }
});
var SvgStack;
var init_SvgStack = __esm({
  "components/core/atoms/svg/SvgStack.tsx"() {
    "use client";
    SvgStack = ({
      x = 10,
      y = 40,
      layers: rawLayers = 3,
      width = 60,
      height = 40,
      color = "var(--color-primary)",
      opacity = 1,
      className,
      labels,
      asRoot = true,
      svgWidth = 90,
      svgHeight = 80
    }) => {
      const layers = Math.max(2, Math.min(4, rawLayers));
      const verticalOffset = 8;
      const horizontalOffset = 4;
      const inner = /* @__PURE__ */ jsx("g", { className, opacity, children: Array.from({ length: layers }).map((_, i) => {
        const layerIndex = layers - 1 - i;
        const layerX = x + layerIndex * horizontalOffset;
        const layerY = y - layerIndex * verticalOffset;
        const layerOpacity = 0.3 + layerIndex / (layers - 1) * 0.7;
        const label = labels?.[layerIndex];
        return /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(
            "rect",
            {
              x: layerX,
              y: layerY,
              width,
              height,
              rx: 6,
              ry: 6,
              fill: color,
              opacity: layerOpacity,
              stroke: color,
              strokeWidth: 1,
              strokeOpacity: layerOpacity * 0.6
            }
          ),
          label && /* @__PURE__ */ jsx(
            "text",
            {
              x: layerX + width / 2,
              y: layerY + height / 2 + 4,
              textAnchor: "middle",
              fill: "white",
              fontSize: 10,
              fontFamily: "inherit",
              opacity: layerOpacity,
              children: label
            }
          )
        ] }, layerIndex);
      }) });
      if (asRoot) {
        return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${svgWidth} ${svgHeight}`, width: svgWidth, height: svgHeight, children: inner });
      }
      return inner;
    };
    SvgStack.displayName = "SvgStack";
  }
});

// components/core/atoms/svg/index.ts
var init_svg = __esm({
  "components/core/atoms/svg/index.ts"() {
    init_SvgBranch();
    init_SvgConnection();
    init_SvgFlow();
    init_SvgGrid();
    init_SvgLobe();
    init_SvgMesh();
    init_SvgMorph();
    init_SvgNode();
    init_SvgPulse();
    init_SvgRing();
    init_SvgShield();
    init_SvgStack();
  }
});
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var init_cn = __esm({
  "lib/cn.ts"() {
  }
});

// hooks/useEventBus.ts
var useEventBus_exports = {};
__export(useEventBus_exports, {
  default: () => useEventBus_default,
  getGlobalEventBus: () => getGlobalEventBus,
  setGlobalEventBus: () => setGlobalEventBus,
  useEmitEvent: () => useEmitEvent,
  useEventBus: () => useEventBus,
  useEventListener: () => useEventListener,
  useEventSubscription: () => useEventSubscription
});
function setGlobalEventBus(bus) {
  if (typeof window !== "undefined") {
    window.__kflowEventBus = bus;
  }
}
function getGlobalEventBus() {
  if (typeof window !== "undefined") {
    return window.__kflowEventBus ?? null;
  }
  return null;
}
function useEventBus() {
  const context = useContext(EventBusContext);
  const baseBus = context ?? getGlobalEventBus() ?? fallbackEventBus;
  const chain = useTraitScopeChain();
  return useMemo(() => {
    if (chain.length === 0) {
      return {
        ...baseBus,
        emit: (type, payload, source) => {
          if (typeof type === "string" && type.startsWith("UI:") && !type.slice(3).includes(".") && !source?.trait) {
            scopeLog.warn("emit:bare-key-no-scope", { type });
          }
          baseBus.emit(type, payload, source);
        }
      };
    }
    return {
      ...baseBus,
      emit: (type, payload, source) => {
        if (typeof type === "string" && type.startsWith("UI:")) {
          const tail = type.slice(3);
          const isQualified = tail.includes(".");
          const event = isQualified ? tail.split(".").slice(2).join(".") : tail;
          if (!event) {
            baseBus.emit(type, payload, source);
            return;
          }
          const keys = /* @__PURE__ */ new Set();
          if (isQualified) keys.add(type);
          for (const sc of chain) {
            keys.add(`UI:${sc.orbital}.${sc.trait}.${event}`);
          }
          if (keys.size > 1) {
            scopeLog.info("emit:fan-out", {
              from: type,
              keys: Array.from(keys),
              chainDepth: chain.length
            });
          }
          for (const key of keys) baseBus.emit(key, payload, source);
          return;
        }
        baseBus.emit(type, payload, source);
      }
    };
  }, [baseBus, chain]);
}
function useEventListener(event, handler) {
  const eventBus = useEventBus();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  useEffect(() => {
    const wrappedHandler = (evt) => {
      handlerRef.current(evt);
    };
    const unsub = eventBus.on(event, wrappedHandler);
    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, [event, eventBus]);
}
function useEmitEvent() {
  const eventBus = useEventBus();
  return useCallback(
    (type, payload, source) => {
      eventBus.emit(type, payload, source);
    },
    [eventBus]
  );
}
var log, subLog, scopeLog, fallbackListeners, fallbackAnyListeners, fallbackEventBus, useEventSubscription, useEventBus_default;
var init_useEventBus = __esm({
  "hooks/useEventBus.ts"() {
    "use client";
    log = createLogger("almadar:eventbus");
    subLog = createLogger("almadar:eventbus:subscribe");
    scopeLog = createLogger("almadar:ui:trait-scope");
    fallbackListeners = /* @__PURE__ */ new Map();
    fallbackAnyListeners = /* @__PURE__ */ new Set();
    fallbackEventBus = {
      emit: (type, payload, source) => {
        const event = {
          type,
          payload,
          timestamp: Date.now(),
          source
        };
        const handlers = fallbackListeners.get(type);
        log.debug("emit", { type, payloadKeys: payload ? Object.keys(payload).length : 0, listenerCount: (handlers?.size ?? 0) + fallbackAnyListeners.size });
        if (handlers) {
          handlers.forEach((handler) => {
            try {
              handler(event);
            } catch (error) {
              log.error("Error in listener", { type, error: error instanceof Error ? error : String(error) });
            }
          });
        }
        fallbackAnyListeners.forEach((handler) => {
          try {
            handler(event);
          } catch (error) {
            log.error("Error in onAny listener", { type, error: error instanceof Error ? error : String(error) });
          }
        });
      },
      on: (type, listener) => {
        if (!fallbackListeners.has(type)) {
          fallbackListeners.set(type, /* @__PURE__ */ new Set());
        }
        fallbackListeners.get(type).add(listener);
        subLog.debug("subscribe", { type, totalListeners: fallbackListeners.get(type).size });
        return () => {
          const handlers = fallbackListeners.get(type);
          if (handlers) {
            handlers.delete(listener);
            if (handlers.size === 0) {
              fallbackListeners.delete(type);
            }
          }
        };
      },
      once: (type, listener) => {
        const wrappedListener = (event) => {
          fallbackListeners.get(type)?.delete(wrappedListener);
          listener(event);
        };
        return fallbackEventBus.on(type, wrappedListener);
      },
      hasListeners: (type) => {
        const handlers = fallbackListeners.get(type);
        return handlers !== void 0 && handlers.size > 0;
      },
      onAny: (listener) => {
        fallbackAnyListeners.add(listener);
        subLog.debug("subscribe:any", { totalAnyListeners: fallbackAnyListeners.size });
        return () => {
          fallbackAnyListeners.delete(listener);
        };
      }
    };
    useEventSubscription = useEventListener;
    useEventBus_default = useEventBus;
  }
});
function getCurrentIconFamily() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return DEFAULT_FAMILY;
  }
  const raw = getComputedStyle(document.documentElement).getPropertyValue("--icon-family").trim().replace(/^["']|["']$/g, "");
  return VALID_FAMILIES.includes(raw) ? raw : DEFAULT_FAMILY;
}
function ensureObserver() {
  if (typeof window === "undefined" || observer) return;
  observer = new MutationObserver(() => {
    const next = getCurrentIconFamily();
    if (next !== cachedFamily) {
      cachedFamily = next;
      listeners.forEach((fn) => fn());
    }
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme", "style"]
  });
  cachedFamily = getCurrentIconFamily();
}
function subscribeIconFamily(notify) {
  ensureObserver();
  listeners.add(notify);
  return () => {
    listeners.delete(notify);
  };
}
function getIconFamilySnapshot() {
  if (cachedFamily !== null) return cachedFamily;
  cachedFamily = getCurrentIconFamily();
  return cachedFamily;
}
function getIconFamilyServerSnapshot() {
  return DEFAULT_FAMILY;
}
function useIconFamily() {
  return useSyncExternalStore(
    subscribeIconFamily,
    getIconFamilySnapshot,
    getIconFamilyServerSnapshot
  );
}
function kebabToPascal(name) {
  return name.split("-").map((part) => {
    if (/^\d+$/.test(part)) return part;
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join("");
}
function isComponentLike(v) {
  return v != null && (typeof v === "function" || typeof v === "object");
}
function resolveLucide(name) {
  if (lucideAliases[name]) return lucideAliases[name];
  const pascal = kebabToPascal(name);
  const lucideMap = LucideIcons2;
  const direct = lucideMap[pascal];
  if (isComponentLike(direct)) return direct;
  const asIs = lucideMap[name];
  if (isComponentLike(asIs)) return asIs;
  return LucideIcons2.HelpCircle;
}
function makeLucideAdapter(name) {
  const LucideComp = resolveLucide(name);
  const Adapter = (props) => /* @__PURE__ */ jsx(
    LucideComp,
    {
      className: props.className,
      strokeWidth: props.strokeWidth,
      style: props.style,
      size: props.size
    }
  );
  Adapter.displayName = `Lucide.${name}`;
  return Adapter;
}
function resolveIconForFamily(name, _family) {
  return makeLucideAdapter(name);
}
var DEFAULT_FAMILY, VALID_FAMILIES, cachedFamily, listeners, observer, lucideAliases;
var init_iconFamily = __esm({
  "lib/iconFamily.tsx"() {
    "use client";
    DEFAULT_FAMILY = "lucide";
    VALID_FAMILIES = [DEFAULT_FAMILY];
    cachedFamily = null;
    listeners = /* @__PURE__ */ new Set();
    observer = null;
    lucideAliases = {
      close: LucideIcons2.X,
      trash: LucideIcons2.Trash2,
      loader: LucideIcons2.Loader2,
      stop: LucideIcons2.Square,
      volume: LucideIcons2.Volume2,
      "volume-off": LucideIcons2.VolumeX,
      refresh: LucideIcons2.RefreshCw,
      share: LucideIcons2.Share2,
      "sort-asc": LucideIcons2.ArrowUpNarrowWide,
      "sort-desc": LucideIcons2.ArrowDownNarrowWide
    };
  }
});
function kebabToPascal2(name) {
  return name.split("-").map((part) => {
    if (/^\d+$/.test(part)) return part;
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join("");
}
function resolveIcon(name) {
  const cached = resolvedCache.get(name);
  if (cached) return cached;
  const resolved = doResolve(name);
  resolvedCache.set(name, resolved);
  return resolved;
}
function doResolve(name) {
  if (iconAliases[name]) return iconAliases[name];
  const isComponentLike2 = (v) => v != null && (typeof v === "function" || typeof v === "object");
  const pascalName = kebabToPascal2(name);
  const lucideMap = LucideIcons2;
  const directLookup = lucideMap[pascalName];
  if (isComponentLike2(directLookup)) return directLookup;
  const asIs = lucideMap[name];
  if (isComponentLike2(asIs)) return asIs;
  return LucideIcons2.HelpCircle;
}
var colorTokenClasses, iconAliases, resolvedCache, sizeClasses, animationClasses, Icon;
var init_Icon = __esm({
  "components/core/atoms/Icon.tsx"() {
    "use client";
    init_cn();
    init_iconFamily();
    colorTokenClasses = {
      primary: "text-primary",
      secondary: "text-secondary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      muted: "text-muted-foreground"
    };
    iconAliases = {
      "close": LucideIcons2.X,
      "trash": LucideIcons2.Trash2,
      "loader": LucideIcons2.Loader2,
      "stop": LucideIcons2.Square,
      "volume": LucideIcons2.Volume2,
      "volume-off": LucideIcons2.VolumeX,
      "refresh": LucideIcons2.RefreshCw,
      "share": LucideIcons2.Share2,
      "sort-asc": LucideIcons2.ArrowUpNarrowWide,
      "sort-desc": LucideIcons2.ArrowDownNarrowWide
    };
    resolvedCache = /* @__PURE__ */ new Map();
    sizeClasses = {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "h-icon-default w-icon-default",
      lg: "w-6 h-6",
      xl: "w-8 h-8"
    };
    animationClasses = {
      none: "",
      spin: "animate-spin",
      pulse: "animate-pulse"
    };
    Icon = ({
      icon,
      name,
      size = "md",
      color,
      animation = "none",
      className,
      strokeWidth,
      style
    }) => {
      const directIcon = typeof icon === "string" ? void 0 : icon;
      const effectiveName = typeof icon === "string" && icon !== "" ? icon : name;
      const effectiveStrokeWidth = strokeWidth != null && strokeWidth > 0 ? strokeWidth : void 0;
      const family = useIconFamily();
      const RenderedComponent = React79__default.useMemo(() => {
        if (directIcon) return null;
        return effectiveName ? resolveIconForFamily(effectiveName) : null;
      }, [directIcon, effectiveName, family]);
      const inlineStyle = {
        ...effectiveStrokeWidth === void 0 ? { strokeWidth: "var(--icon-stroke-width, 2)" } : {},
        ...style
      };
      const resolvedColor = color ? color in colorTokenClasses ? colorTokenClasses[color] : color : "text-current";
      const composedClassName = cn(
        sizeClasses[size],
        animationClasses[animation],
        resolvedColor,
        className
      );
      if (directIcon) {
        const Direct = directIcon;
        return /* @__PURE__ */ jsx(
          Direct,
          {
            className: composedClassName,
            strokeWidth: effectiveStrokeWidth,
            style: inlineStyle
          }
        );
      }
      if (RenderedComponent) {
        return /* @__PURE__ */ jsx(
          RenderedComponent,
          {
            className: composedClassName,
            strokeWidth: effectiveStrokeWidth,
            style: inlineStyle
          }
        );
      }
      const Fallback = LucideIcons2.HelpCircle;
      return /* @__PURE__ */ jsx(
        Fallback,
        {
          className: composedClassName,
          strokeWidth: effectiveStrokeWidth,
          style: inlineStyle
        }
      );
    };
    Icon.displayName = "Icon";
  }
});

// lib/atlasSlice.ts
function isTilesheet(a) {
  return typeof a.tileWidth === "number";
}
function isSpriteSheetAtlas(a) {
  const s = a;
  return typeof s.frameWidth === "number" && typeof s.frameHeight === "number" && typeof s.animations === "object";
}
function getAtlas(url, onReady) {
  if (atlasCache.has(url)) return atlasCache.get(url) ?? void 0;
  atlasCache.set(url, void 0);
  fetch(url).then((r) => r.json()).then((json) => {
    atlasCache.set(url, json);
    onReady();
  }).catch(() => {
    atlasCache.set(url, null);
    onReady();
  });
  return void 0;
}
function atlasFailed(url) {
  return atlasCache.get(url) === null;
}
function subRectFor(atlas, sprite) {
  if (isTilesheet(atlas)) {
    let col;
    let row;
    if (sprite.includes(",")) {
      const [c, r] = sprite.split(",").map((n) => Number(n.trim()));
      col = c;
      row = r;
    } else {
      const i = Number(sprite);
      if (!Number.isFinite(i)) return null;
      col = i % atlas.columns;
      row = Math.floor(i / atlas.columns);
    }
    if (!Number.isFinite(col) || !Number.isFinite(row) || col < 0 || row < 0 || col >= atlas.columns || row >= atlas.rows) return null;
    const margin = atlas.margin ?? 0;
    const spacing = atlas.spacing ?? 0;
    return {
      sx: margin + col * (atlas.tileWidth + spacing),
      sy: margin + row * (atlas.tileHeight + spacing),
      sw: atlas.tileWidth,
      sh: atlas.tileHeight
    };
  }
  if (isSpriteSheetAtlas(atlas)) return null;
  const st = atlas.subTextures[sprite];
  if (!st) return null;
  return { sx: st.x, sy: st.y, sw: st.width, sh: st.height };
}
function isAtlasAsset(asset) {
  return !!asset && typeof asset.atlas === "string" && typeof asset.sprite === "string";
}
function resolveAssetSource(img, asset, onReady) {
  if (isAtlasAsset(asset)) {
    const atlas = getAtlas(asset.atlas, onReady);
    if (!atlas) return null;
    const rect = subRectFor(atlas, asset.sprite);
    if (!rect) return null;
    return { img, rect, aspect: rect.sw / rect.sh };
  }
  const natW = img.naturalWidth || 1;
  const natH = img.naturalHeight || 1;
  return { img, rect: null, aspect: natW / natH };
}
function blit(ctx, src, dx, dy, dw, dh) {
  if (src.rect) ctx.drawImage(src.img, src.rect.sx, src.rect.sy, src.rect.sw, src.rect.sh, dx, dy, dw, dh);
  else ctx.drawImage(src.img, dx, dy, dw, dh);
}
var atlasCache;
var init_atlasSlice = __esm({
  "lib/atlasSlice.ts"() {
    "use client";
    atlasCache = /* @__PURE__ */ new Map();
  }
});
function useAtlasSliceDataUrl(asset) {
  const [, bump] = React79.useReducer((x) => x + 1, 0);
  if (!isAtlasAsset(asset)) return void 0;
  const key = `${asset.atlas}#${asset.sprite}`;
  const cached = sliceDataUrlCache.get(key);
  if (cached) return cached;
  const atlas = getAtlas(asset.atlas, bump);
  const img = asset?.url ? getSheetImage(asset.url, bump) : null;
  if (!atlas || !img) return void 0;
  const rect = subRectFor(atlas, asset.sprite);
  if (!rect) return void 0;
  const canvas = document.createElement("canvas");
  canvas.width = rect.sw;
  canvas.height = rect.sh;
  const ctx = canvas.getContext("2d");
  if (!ctx) return void 0;
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(img, rect.sx, rect.sy, rect.sw, rect.sh, 0, 0, rect.sw, rect.sh);
  const url = canvas.toDataURL();
  sliceDataUrlCache.set(key, url);
  return url;
}
function AtlasPanel({ asset, borderSlice = 16, borderWidth = 16, mode = "nineSlice", className, style, children, "aria-hidden": ariaHidden }) {
  const dataUrl = useAtlasSliceDataUrl(asset);
  const skin = !dataUrl ? {} : mode === "repeat" ? { backgroundImage: `url(${dataUrl})`, backgroundRepeat: "repeat" } : {
    borderStyle: "solid",
    borderWidth,
    borderImageSource: `url(${dataUrl})`,
    borderImageSlice: `${borderSlice} fill`,
    borderImageWidth: borderWidth,
    borderImageRepeat: "stretch",
    imageRendering: "pixelated"
  };
  return /* @__PURE__ */ jsx("span", { "aria-hidden": ariaHidden, className: cn("inline-block", className), style: { ...skin, ...style }, children });
}
function getSheetImage(url, onReady) {
  const cached = imageCache.get(url);
  if (cached) return cached;
  (imageWaiters.get(url) ?? imageWaiters.set(url, /* @__PURE__ */ new Set()).get(url)).add(onReady);
  if (!imageCache.has(url)) {
    imageCache.set(url, null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      imageCache.set(url, img);
      imageWaiters.get(url)?.forEach((fn) => fn());
      imageWaiters.delete(url);
    };
    img.src = url;
  }
  return null;
}
function AtlasImage({
  asset,
  size,
  width,
  height,
  fill = false,
  fit = "contain",
  alt,
  className,
  style,
  "aria-hidden": ariaHidden
}) {
  const [, bump] = React79.useReducer((x) => x + 1, 0);
  const canvasRef = React79.useRef(null);
  const sliced = isAtlasAsset(asset);
  const atlas = sliced ? getAtlas(asset.atlas, bump) : void 0;
  const img = sliced && asset?.url ? getSheetImage(asset.url, bump) : null;
  const rect = sliced && atlas ? subRectFor(atlas, asset.sprite) : null;
  React79.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !img || !rect) return;
    canvas.width = rect.sw;
    canvas.height = rect.sh;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    ctx.clearRect(0, 0, rect.sw, rect.sh);
    ctx.drawImage(img, rect.sx, rect.sy, rect.sw, rect.sh, 0, 0, rect.sw, rect.sh);
  }, [img, rect?.sx, rect?.sy, rect?.sw, rect?.sh]);
  const w = fill ? "100%" : width ?? size;
  const h = fill ? "100%" : height ?? size;
  const boxStyle = {
    ...fill ? { position: "absolute", inset: 0 } : {},
    width: w,
    height: h,
    objectFit: fit,
    imageRendering: "pixelated",
    ...style
  };
  if (!asset?.url) return null;
  if (sliced) {
    if (!rect || !img) {
      return /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: cn("inline-block flex-shrink-0", className), style: { ...boxStyle, objectFit: void 0 } });
    }
    return /* @__PURE__ */ jsx(
      "canvas",
      {
        ref: canvasRef,
        role: ariaHidden ? void 0 : "img",
        "aria-hidden": ariaHidden,
        "aria-label": ariaHidden ? void 0 : alt ?? asset.name ?? asset.category ?? "",
        className: cn("flex-shrink-0", className),
        style: boxStyle
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "img",
    {
      src: asset.url,
      alt: alt ?? asset.name ?? asset.category ?? "",
      "aria-hidden": ariaHidden,
      ...typeof w === "number" ? { width: w } : {},
      ...typeof h === "number" ? { height: h } : {},
      className: cn("flex-shrink-0", className),
      style: boxStyle
    }
  );
}
var sliceDataUrlCache, imageCache, imageWaiters;
var init_AtlasImage = __esm({
  "components/core/atoms/AtlasImage.tsx"() {
    "use client";
    init_atlasSlice();
    init_cn();
    sliceDataUrlCache = /* @__PURE__ */ new Map();
    AtlasPanel.displayName = "AtlasPanel";
    imageCache = /* @__PURE__ */ new Map();
    imageWaiters = /* @__PURE__ */ new Map();
    AtlasImage.displayName = "AtlasImage";
  }
});
function isIconLike(v) {
  return typeof v.render === "function";
}
function resolveIconProp(value, sizeClass) {
  if (!value) return null;
  if (typeof value === "string") {
    return /* @__PURE__ */ jsx(Icon, { name: value, className: sizeClass });
  }
  if (typeof value === "function") {
    const IconComp = value;
    return /* @__PURE__ */ jsx(IconComp, { className: sizeClass });
  }
  if (React79__default.isValidElement(value)) {
    return value;
  }
  if (typeof value === "object" && value !== null && isIconLike(value)) {
    const IconComp = value;
    return /* @__PURE__ */ jsx(IconComp, { className: sizeClass });
  }
  return value;
}
var variantStyles, sizeStyles, iconSizeStyles, Button;
var init_Button = __esm({
  "components/core/atoms/Button.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Icon();
    init_AtlasImage();
    variantStyles = {
      primary: [
        "bg-primary text-primary-foreground",
        "border-none",
        "shadow-sm",
        "hover:bg-primary-hover hover:shadow-lg",
        "active:scale-[var(--active-scale)] active:shadow-sm"
      ].join(" "),
      secondary: [
        "bg-transparent text-accent",
        "border border-accent",
        "hover:bg-accent hover:text-accent-foreground hover:border-accent",
        "active:scale-[var(--active-scale)]"
      ].join(" "),
      ghost: [
        "bg-transparent text-muted-foreground",
        "border border-transparent",
        "hover:text-primary-foreground hover:bg-primary hover:border-primary",
        "active:scale-[var(--active-scale)]"
      ].join(" "),
      danger: [
        "bg-surface text-error",
        "border-[length:var(--border-width)] border-error",
        "shadow-sm",
        "hover:bg-error hover:text-error-foreground hover:shadow-lg",
        "active:scale-[var(--active-scale)] active:shadow-sm"
      ].join(" "),
      success: [
        "bg-surface text-success",
        "border-[length:var(--border-width)] border-success",
        "shadow-sm",
        "hover:bg-success hover:text-success-foreground hover:shadow-lg",
        "active:scale-[var(--active-scale)] active:shadow-sm"
      ].join(" "),
      warning: [
        "bg-surface text-warning",
        "border-[length:var(--border-width)] border-warning",
        "shadow-sm",
        "hover:bg-warning hover:text-warning-foreground hover:shadow-lg",
        "active:scale-[var(--active-scale)] active:shadow-sm"
      ].join(" "),
      // "default" is an alias for secondary
      default: [
        "bg-secondary text-secondary-foreground",
        "border-[length:var(--border-width-thin)] border-border",
        "hover:bg-secondary-hover",
        "active:scale-[var(--active-scale)]"
      ].join(" ")
    };
    variantStyles.destructive = variantStyles.danger;
    sizeStyles = {
      sm: "h-button-sm px-3 text-sm",
      md: "h-button-md px-4 text-sm",
      lg: "h-button-lg px-6 text-base"
    };
    iconSizeStyles = {
      sm: "h-icon-default w-icon-default",
      md: "h-icon-default w-icon-default",
      lg: "h-icon-default w-icon-default"
    };
    Button = React79__default.forwardRef(
      ({
        className,
        variant = "primary",
        size = "md",
        isLoading = false,
        disabled,
        leftIcon,
        rightIcon,
        icon: iconProp,
        iconRight: iconRightProp,
        iconAsset,
        action,
        actionPayload,
        label,
        children,
        onClick,
        "data-testid": dataTestId,
        ...props
      }, ref) => {
        const eventBus = useEventBus();
        const leftIconValue = leftIcon || iconProp;
        const rightIconValue = rightIcon || iconRightProp;
        const px = size === "sm" ? 16 : size === "lg" ? 20 : 16;
        const resolvedLeftIcon = iconAsset?.url ? /* @__PURE__ */ jsx(AtlasImage, { asset: iconAsset, size: px, alt: iconAsset.name ?? iconAsset.category ?? "", className: "flex-shrink-0" }) : resolveIconProp(leftIconValue, iconSizeStyles[size]);
        const resolvedRightIcon = resolveIconProp(rightIconValue, iconSizeStyles[size]);
        const handleClick = (e) => {
          if (action) {
            eventBus.emit(`UI:${action}`, actionPayload ?? {});
          }
          onClick?.(e);
        };
        return /* @__PURE__ */ jsxs(
          "button",
          {
            ref,
            type: "button",
            disabled: disabled || isLoading,
            className: cn(
              "relative inline-flex items-center justify-center gap-2",
              "font-medium",
              "rounded-sm",
              "cursor-pointer",
              "chrome-button",
              "transition-all duration-normal",
              "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-offset-[length:var(--focus-ring-offset)]",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              variantStyles[variant],
              sizeStyles[size],
              className
            ),
            onClick: handleClick,
            ...props,
            "data-testid": dataTestId ?? (action ? `action-${action}` : void 0),
            children: [
              isLoading ? /* @__PURE__ */ jsx(Loader2, { className: "h-icon-default w-icon-default animate-spin" }) : resolvedLeftIcon && /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", children: resolvedLeftIcon }),
              (Array.isArray(children) ? children.length > 0 : Boolean(children)) ? children : label,
              resolvedRightIcon && !isLoading && /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", children: resolvedRightIcon })
            ]
          }
        );
      }
    );
    Button.displayName = "Button";
  }
});
var Input;
var init_Input = __esm({
  "components/core/atoms/Input.tsx"() {
    init_cn();
    init_Icon();
    init_useEventBus();
    Input = React79__default.forwardRef(
      ({
        className,
        inputType,
        type: htmlType,
        label,
        helperText,
        error,
        leftIcon,
        rightIcon,
        icon: iconProp,
        clearable,
        onClear,
        action,
        value,
        options,
        rows: rows2 = 3,
        onChange,
        ...props
      }, ref) => {
        const { t } = useTranslate();
        const eventBus = useEventBus();
        const type = inputType || htmlType || "text";
        const isDeclarative = typeof onChange === "string";
        const [localValue, setLocalValue] = React79__default.useState(value);
        const pendingEchoRef = React79__default.useRef(/* @__PURE__ */ new Set());
        React79__default.useEffect(() => {
          if (!isDeclarative) return;
          const incoming = value == null ? "" : String(value);
          if (pendingEchoRef.current.has(incoming)) {
            pendingEchoRef.current.delete(incoming);
            return;
          }
          pendingEchoRef.current.clear();
          setLocalValue(value);
        }, [value, isDeclarative]);
        const displayValue = isDeclarative ? localValue : value;
        const resolveIconNode = (i, cls) => {
          if (!i) return null;
          if (typeof i === "string") return /* @__PURE__ */ jsx(Icon, { name: i, className: cls });
          const C = i;
          return /* @__PURE__ */ jsx(C, { className: cls });
        };
        const iconCls = "h-icon-default w-icon-default";
        const IconComponent = typeof iconProp === "string" ? resolveIcon(iconProp) : iconProp;
        const resolvedLeftIcon = (leftIcon ? resolveIconNode(leftIcon, iconCls) : null) || IconComponent && /* @__PURE__ */ jsx(IconComponent, { className: iconCls });
        const showClearButton = clearable && displayValue && String(displayValue).length > 0;
        const isMultiline = type === "textarea";
        const baseClassName = cn(
          "block w-full rounded-sm transition-all duration-fast",
          "border-[length:var(--border-width-thin)] border-border",
          isMultiline ? "px-3 py-2 text-sm" : "h-input-md px-3 text-sm",
          "bg-card hover:bg-muted focus:bg-card",
          "text-foreground placeholder:text-muted-foreground",
          "focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring",
          "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-muted",
          error ? "border-error focus:border-error focus:ring-error" : "",
          resolvedLeftIcon && "pl-10",
          (rightIcon || showClearButton) && "pr-10",
          className
        );
        const handleChange = (e) => {
          if (typeof onChange === "string") {
            const target = e.target;
            const payload = type === "checkbox" ? { checked: target.checked } : { value: target.value };
            if (type !== "checkbox") {
              pendingEchoRef.current.add(target.value);
              setLocalValue(target.value);
            }
            eventBus.emit(`UI:${onChange}`, payload);
          } else {
            onChange?.(e);
          }
        };
        const handleClear = () => {
          if (typeof onClear === "string") {
            eventBus.emit(`UI:${onClear}`, {});
          } else {
            onClear?.();
          }
        };
        const handleKeyDown = (e) => {
          if (!action || e.key !== "Enter") return;
          const raw = e.currentTarget.value;
          if (type === "number") {
            if (raw.trim() === "") return;
            const numeric = Number(raw);
            if (Number.isNaN(numeric)) return;
            eventBus.emit(`UI:${action}`, { value: numeric });
            return;
          }
          eventBus.emit(`UI:${action}`, { value: raw });
        };
        const wrapField = (field, fullWidth = true) => /* @__PURE__ */ jsxs("div", { className: fullWidth ? "w-full" : "w-fit", children: [
          label && /* @__PURE__ */ jsx("label", { className: "block text-sm font-medium text-foreground mb-1", children: label }),
          field,
          (helperText || error) && /* @__PURE__ */ jsx("p", { className: cn("mt-1 text-xs", error ? "text-error" : "text-muted-foreground"), children: error ?? helperText })
        ] });
        if (type === "select") {
          return wrapField(
            /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
              resolvedLeftIcon && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-muted-foreground", children: resolvedLeftIcon }),
              /* @__PURE__ */ jsxs(
                "select",
                {
                  ref,
                  value: displayValue,
                  onChange: handleChange,
                  className: cn(baseClassName, "appearance-none pr-10", className),
                  ...props,
                  children: [
                    /* @__PURE__ */ jsx("option", { value: "", children: t("form.selectPlaceholder", { label: "" }) }),
                    options?.map((opt) => /* @__PURE__ */ jsx("option", { value: opt.value, children: opt.label }, opt.value))
                  ]
                }
              ),
              /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-muted-foreground", children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "h-icon-default w-icon-default" }) })
            ] })
          );
        }
        if (type === "textarea") {
          return wrapField(
            /* @__PURE__ */ jsx("div", { className: "relative w-full", children: /* @__PURE__ */ jsx(
              "textarea",
              {
                ref,
                value: displayValue,
                onChange: handleChange,
                rows: rows2,
                className: baseClassName,
                ...props
              }
            ) })
          );
        }
        if (type === "checkbox") {
          return wrapField(
            /* @__PURE__ */ jsx(
              "input",
              {
                ref,
                type: "checkbox",
                checked: props.checked,
                onChange: handleChange,
                className: cn(
                  "h-icon-default w-icon-default rounded-sm",
                  "border-border",
                  "text-primary focus:ring-ring",
                  "disabled:opacity-50 disabled:cursor-not-allowed",
                  className
                ),
                ...props
              }
            ),
            false
          );
        }
        return wrapField(
          /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
            resolvedLeftIcon && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-muted-foreground", children: resolvedLeftIcon }),
            /* @__PURE__ */ jsx(
              "input",
              {
                ref,
                type,
                value: displayValue,
                onChange: handleChange,
                onKeyDown: handleKeyDown,
                className: baseClassName,
                ...props
              }
            ),
            showClearButton && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: handleClear,
                className: "absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground hover:text-foreground",
                children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "h-icon-default w-icon-default" })
              }
            ),
            rightIcon && !showClearButton && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground", children: resolveIconNode(rightIcon, iconCls) })
          ] })
        );
      }
    );
    Input.displayName = "Input";
  }
});
var Label;
var init_Label = __esm({
  "components/core/atoms/Label.tsx"() {
    init_cn();
    Label = React79__default.forwardRef(
      ({ className, required, children, ...props }, ref) => {
        return /* @__PURE__ */ jsxs(
          "label",
          {
            ref,
            className: cn(
              "block text-sm font-bold text-foreground",
              className
            ),
            ...props,
            children: [
              children,
              required && /* @__PURE__ */ jsx("span", { className: "text-error ml-1", children: "*" })
            ]
          }
        );
      }
    );
    Label.displayName = "Label";
  }
});
var Textarea;
var init_Textarea = __esm({
  "components/core/atoms/Textarea.tsx"() {
    init_cn();
    init_useEventBus();
    Textarea = React79__default.forwardRef(
      ({ className, error, onChange, action, onKeyDown, ...props }, ref) => {
        const eventBus = useEventBus();
        const handleChange = (e) => {
          if (typeof onChange === "string") {
            eventBus.emit(`UI:${onChange}`, { value: e.target.value });
          } else {
            onChange?.(e);
          }
        };
        const handleKeyDown = (e) => {
          onKeyDown?.(e);
          if (!action || e.key !== "Enter" || !(e.metaKey || e.ctrlKey)) return;
          e.preventDefault();
          eventBus.emit(`UI:${action}`, { value: e.currentTarget.value });
        };
        return /* @__PURE__ */ jsx(
          "textarea",
          {
            ref,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            className: cn(
              "block w-full border-[length:var(--border-width)] shadow-sm",
              "px-3 py-2 text-sm text-foreground",
              "bg-card",
              "placeholder:text-[var(--color-placeholder)]",
              "focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-ring",
              "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed",
              "resize-y min-h-20",
              error ? "border-error focus:border-error" : "border-border focus:border-primary",
              className
            ),
            ...props
          }
        );
      }
    );
    Textarea.displayName = "Textarea";
  }
});
function dispatchValueChange(onValueChange, eventBus, value) {
  if (typeof onValueChange === "string") {
    eventBus.emit(`UI:${onValueChange}`, { value });
  } else {
    onValueChange?.(value);
  }
}
function flatOptions(opts, groups) {
  const flat = opts ?? [];
  const grp = (groups ?? []).flatMap((g) => g.options);
  return [...flat, ...grp];
}
function NativeSelect({
  className,
  options,
  groups,
  placeholder,
  error,
  onChange,
  onValueChange,
  action,
  value,
  ...props
}) {
  const eventBus = useEventBus();
  const handleChange = (e) => {
    if (typeof onChange === "string") {
      eventBus.emit(`UI:${onChange}`, { value: e.target.value });
    } else {
      onChange?.(e);
    }
    dispatchValueChange(onValueChange, eventBus, e.target.value);
    if (action) {
      eventBus.emit(`UI:${action}`, { value: e.target.value });
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ jsxs(
      "select",
      {
        onChange: handleChange,
        value,
        className: cn(
          "block w-full border-[length:var(--border-width)] shadow-sm appearance-none",
          "px-3 py-2 pr-10 text-sm text-foreground font-medium",
          "bg-card",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-ring",
          "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed",
          error ? "border-error focus:border-error" : "border-border focus:border-primary",
          className
        ),
        ...props,
        children: [
          placeholder && /* @__PURE__ */ jsx("option", { value: "", disabled: true, children: placeholder }),
          options?.map((option) => /* @__PURE__ */ jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)),
          groups?.map((group) => /* @__PURE__ */ jsx("optgroup", { label: group.label, children: group.options.map((option) => /* @__PURE__ */ jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)) }, group.label))
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none", children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "h-icon-default w-icon-default text-foreground" }) })
  ] });
}
function RichSelect({
  className,
  options,
  groups,
  placeholder,
  error,
  onChange,
  onValueChange,
  action,
  value,
  multiple,
  searchable,
  clearable,
  disabled
}) {
  const eventBus = useEventBus();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);
  const selected = multiple ? Array.isArray(value) ? value : value ? [value] : [] : value ? [value] : [];
  const all = flatOptions(options, groups);
  const filtered = searchable && search ? all.filter((o) => o.label.toLowerCase().includes(search.toLowerCase())) : all;
  const toggle = (optValue) => {
    let next;
    if (multiple) {
      next = selected.includes(optValue) ? selected.filter((v) => v !== optValue) : [...selected, optValue];
    } else {
      next = optValue;
      setOpen(false);
    }
    if (typeof onChange === "string") {
      eventBus.emit(`UI:${onChange}`, { value: next });
    }
    dispatchValueChange(onValueChange, eventBus, next);
    if (action) {
      eventBus.emit(`UI:${action}`, { value: next });
    }
  };
  const clear = (e) => {
    e.stopPropagation();
    const next = multiple ? [] : "";
    if (typeof onChange === "string") {
      eventBus.emit(`UI:${onChange}`, { value: next });
    }
    dispatchValueChange(onValueChange, eventBus, next);
    if (action) {
      eventBus.emit(`UI:${action}`, { value: next });
    }
  };
  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const displayLabel = selected.length === 0 ? placeholder ?? "" : multiple ? `${selected.length} selected` : all.find((o) => o.value === selected[0])?.label ?? selected[0];
  const hasValue = selected.length > 0;
  const renderOptions = (opts) => opts.map((opt) => /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      dir: opt.dir,
      disabled: opt.disabled,
      onClick: () => !opt.disabled && toggle(opt.value),
      className: cn(
        "w-full flex items-center justify-between px-3 py-1.5 text-sm text-start",
        "hover:bg-muted transition-colors",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        selected.includes(opt.value) && "text-primary font-medium"
      ),
      children: [
        /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-2 min-w-0", children: [
          opt.icon != null && /* @__PURE__ */ jsx("span", { className: "shrink-0 flex items-center", children: opt.icon }),
          /* @__PURE__ */ jsxs("span", { className: "flex flex-col min-w-0", children: [
            /* @__PURE__ */ jsx("span", { children: opt.label }),
            opt.secondaryLabel != null && /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground font-normal", children: opt.secondaryLabel })
          ] })
        ] }),
        selected.includes(opt.value) && /* @__PURE__ */ jsx(Icon, { name: "check", className: "h-icon-default w-icon-default shrink-0" })
      ]
    },
    opt.value
  ));
  return /* @__PURE__ */ jsxs("div", { ref: containerRef, className: cn("relative w-full", className), children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        disabled,
        onClick: () => !disabled && setOpen((o) => !o),
        className: cn(
          "block w-full border-[length:var(--border-width)] shadow-sm",
          "px-3 py-2 pr-10 text-sm text-start font-medium",
          "bg-card rounded-sm",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-ring",
          "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed",
          error ? "border-error focus:border-error" : "border-border focus:border-primary",
          !hasValue && "text-muted-foreground"
        ),
        children: displayLabel
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center gap-1 pointer-events-none", children: [
      clearable && hasValue && /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: clear,
          className: "pointer-events-auto text-muted-foreground hover:text-foreground",
          children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "h-icon-default w-icon-default" })
        }
      ),
      /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "h-icon-default w-icon-default text-foreground" })
    ] }),
    open && /* @__PURE__ */ jsxs("div", { className: cn(
      "absolute z-50 mt-1 w-full",
      "bg-card border-[length:var(--border-width)] border-border",
      "rounded-sm shadow-elevation-popover py-1 max-h-60 overflow-y-auto"
    ), children: [
      searchable && /* @__PURE__ */ jsx("div", { className: "px-2 pb-1 border-b border-border", children: /* @__PURE__ */ jsx(
        "input",
        {
          autoFocus: true,
          type: "text",
          value: search,
          onChange: (e) => setSearch(e.target.value),
          placeholder: "Search\u2026",
          className: cn(
            "w-full px-2 py-1 text-sm bg-transparent",
            "focus:outline-none text-foreground placeholder:text-muted-foreground"
          )
        }
      ) }),
      groups && groups.length > 0 ? groups.map((g) => {
        const groupFiltered = searchable && search ? g.options.filter((o) => o.label.toLowerCase().includes(search.toLowerCase())) : g.options;
        if (groupFiltered.length === 0) return null;
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: "px-3 py-1 text-xs font-semibold text-muted-foreground uppercase tracking-wide", children: g.label }),
          renderOptions(groupFiltered)
        ] }, g.label);
      }) : renderOptions(filtered)
    ] })
  ] });
}
var Select;
var init_Select = __esm({
  "components/core/atoms/Select.tsx"() {
    init_cn();
    init_Icon();
    init_useEventBus();
    Select = React79__default.forwardRef(
      (props, _ref) => {
        const { multiple, searchable, clearable } = props;
        if (multiple || searchable || clearable) {
          return /* @__PURE__ */ jsx(RichSelect, { ...props });
        }
        return /* @__PURE__ */ jsx(NativeSelect, { ...props });
      }
    );
    Select.displayName = "Select";
  }
});
var Checkbox;
var init_Checkbox = __esm({
  "components/core/atoms/Checkbox.tsx"() {
    init_cn();
    init_useEventBus();
    Checkbox = React79__default.forwardRef(
      ({ className, label, id, onChange, ...props }, ref) => {
        const inputId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;
        const eventBus = useEventBus();
        const handleChange = (e) => {
          if (typeof onChange === "string") {
            eventBus.emit(`UI:${onChange}`, { checked: e.target.checked });
          } else {
            onChange?.(e);
          }
        };
        return /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
          /* @__PURE__ */ jsx("div", { className: "relative flex items-center", children: /* @__PURE__ */ jsx(
            "input",
            {
              ref,
              type: "checkbox",
              id: inputId,
              onChange: handleChange,
              className: cn(
                "peer h-4 w-4 border-[length:var(--border-width)] border-border",
                "accent-primary focus:ring-ring focus:ring-offset-0",
                "bg-card checked:bg-primary",
                "disabled:opacity-50 disabled:cursor-not-allowed",
                className
              ),
              ...props
            }
          ) }),
          label && /* @__PURE__ */ jsx(
            "label",
            {
              htmlFor: inputId,
              className: "ml-2 text-sm text-foreground font-medium cursor-pointer select-none",
              children: label
            }
          )
        ] });
      }
    );
    Checkbox.displayName = "Checkbox";
  }
});
var sizeStyles2, Spinner;
var init_Spinner = __esm({
  "components/core/atoms/Spinner.tsx"() {
    init_cn();
    init_Icon();
    sizeStyles2 = {
      xs: "h-3 w-3",
      sm: "h-icon-default w-icon-default",
      md: "h-6 w-6",
      lg: "h-8 w-8"
    };
    Spinner = React79__default.forwardRef(
      ({ className, size = "md", overlay, ...props }, ref) => {
        if (overlay) {
          return /* @__PURE__ */ jsx(
            "div",
            {
              ref,
              className: cn(
                "absolute inset-0 z-10 flex items-center justify-center",
                "bg-background/60 backdrop-blur-sm",
                className
              ),
              ...props,
              children: /* @__PURE__ */ jsx(Icon, { name: "loader", className: cn("animate-spin text-foreground", sizeStyles2[size]) })
            }
          );
        }
        return /* @__PURE__ */ jsx(
          "div",
          {
            ref,
            className: cn("text-foreground", className),
            ...props,
            children: /* @__PURE__ */ jsx(Icon, { name: "loader", className: cn("animate-spin", sizeStyles2[size]) })
          }
        );
      }
    );
    Spinner.displayName = "Spinner";
  }
});
var variantStyles2, paddingStyles, shadowStyles, lookStyles, Card, CardHeader, CardTitle, CardContent, CardBody, CardFooter;
var init_Card = __esm({
  "components/core/atoms/Card.tsx"() {
    init_cn();
    init_useEventBus();
    init_Spinner();
    variantStyles2 = {
      default: [
        "bg-card",
        "border-[length:var(--border-width)] border-border",
        "shadow-elevation-card",
        "transition-all duration-normal",
        "hover:shadow-elevation-dialog hover:translate-y-[var(--hover-translate-y)]"
      ].join(" "),
      bordered: [
        "bg-card",
        "border-[length:var(--border-width)] border-border",
        "shadow-elevation-card",
        "transition-all duration-normal",
        "hover:shadow-elevation-dialog hover:translate-y-[var(--hover-translate-y)]"
      ].join(" "),
      elevated: [
        "bg-card",
        "border-[length:var(--border-width)] border-border",
        "shadow",
        "transition-all duration-normal",
        "hover:shadow-elevation-dialog hover:translate-y-[var(--hover-translate-y)]"
      ].join(" "),
      // Interactive variant with theme-specific hover effects
      interactive: [
        "bg-card",
        "border-[length:var(--border-width)] border-border",
        "shadow",
        "cursor-pointer",
        "transition-all duration-normal",
        "hover:shadow-elevation-dialog"
      ].join(" ")
    };
    paddingStyles = {
      none: "",
      sm: "p-card-sm",
      md: "p-card-md",
      lg: "p-card-lg"
    };
    shadowStyles = {
      none: "shadow-none",
      sm: "shadow-elevation-card",
      md: "shadow",
      lg: "shadow-elevation-dialog"
    };
    lookStyles = {
      elevated: "",
      "flat-bordered": "shadow-none border-[length:var(--border-width)] border-border",
      "borderless-divider": "shadow-none border-0 border-b border-border rounded-none",
      ticket: "shadow-none border-dashed border-[length:var(--border-width)] border-border",
      invoice: "shadow-none border-[length:var(--border-width-thick)] border-border rounded-sm",
      chip: "shadow-none rounded-pill border-[length:var(--border-width)] border-border",
      "tile-image-first": "p-0 overflow-hidden"
    };
    Card = React79__default.forwardRef(
      ({
        className,
        variant = "bordered",
        padding = "md",
        title,
        subtitle,
        shadow,
        look = "elevated",
        children,
        action,
        loading,
        onClick,
        ...props
      }, ref) => {
        const eventBus = useEventBus();
        const handleClick = action ? (e) => {
          eventBus.emit(`UI:${action}`, {});
          onClick?.(e);
        } : onClick;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            ref,
            className: cn(
              "rounded-container relative",
              "transition-all duration-normal",
              "chrome-panel",
              variantStyles2[variant],
              paddingStyles[padding],
              lookStyles[look],
              shadow && shadowStyles[shadow],
              className
            ),
            onClick: handleClick,
            ...props,
            children: [
              loading && /* @__PURE__ */ jsx(Spinner, { overlay: true, size: "md" }),
              (title || subtitle) && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
                title && /* @__PURE__ */ jsx("h3", { className: "text-lg text-card-foreground font-bold", children: title }),
                subtitle && /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground mt-1", children: subtitle })
              ] }),
              children
            ]
          }
        );
      }
    );
    Card.displayName = "Card";
    CardHeader = React79__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("mb-4", className), ...props }));
    CardHeader.displayName = "CardHeader";
    CardTitle = React79__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
      "h3",
      {
        ref,
        className: cn(
          "text-lg text-card-foreground",
          "font-bold",
          className
        ),
        ...props
      }
    ));
    CardTitle.displayName = "CardTitle";
    CardContent = React79__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("", className), ...props }));
    CardContent.displayName = "CardContent";
    CardBody = CardContent;
    CardBody.displayName = "CardBody";
    CardFooter = React79__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        className: cn("mt-4 flex items-center", className),
        ...props
      }
    ));
    CardFooter.displayName = "CardFooter";
  }
});
var variantStyles3, sizeStyles3, Badge;
var init_Badge = __esm({
  "components/core/atoms/Badge.tsx"() {
    init_cn();
    init_Icon();
    init_AtlasImage();
    variantStyles3 = {
      default: [
        "bg-muted text-foreground",
        "border-[length:var(--border-width-thin)] border-border"
      ].join(" "),
      primary: "bg-primary text-primary-foreground",
      secondary: "bg-secondary text-secondary-foreground",
      success: [
        "bg-surface text-success",
        "border-[length:var(--border-width)] border-success"
      ].join(" "),
      warning: [
        "bg-surface text-warning",
        "border-[length:var(--border-width)] border-warning"
      ].join(" "),
      danger: [
        "bg-surface text-error",
        "border-[length:var(--border-width)] border-error"
      ].join(" "),
      error: [
        "bg-surface text-error",
        "border-[length:var(--border-width)] border-error"
      ].join(" "),
      info: [
        "bg-surface text-info",
        "border-[length:var(--border-width)] border-info"
      ].join(" "),
      neutral: [
        "bg-muted text-muted-foreground",
        "border-[length:var(--border-width-thin)] border-border"
      ].join(" ")
    };
    sizeStyles3 = {
      sm: "px-2 py-0.5 text-xs",
      md: "px-2.5 py-1 text-sm",
      lg: "px-3 py-1.5 text-base"
    };
    Badge = React79__default.forwardRef(
      ({ className, variant = "default", size = "sm", amount, label, icon, iconAsset, children, onRemove, removeLabel, ...props }, ref) => {
        const iconSizes3 = {
          sm: "h-icon-default w-icon-default",
          md: "h-icon-default w-icon-default",
          lg: "h-icon-default w-icon-default"
        };
        const iconPx = size === "lg" ? 20 : 16;
        const resolvedIcon = iconAsset?.url ? /* @__PURE__ */ jsx(AtlasImage, { asset: iconAsset, size: iconPx, alt: iconAsset.name ?? iconAsset.category ?? "", className: "flex-shrink-0" }) : typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: iconSizes3[size] }) : icon ? /* @__PURE__ */ jsx(Icon, { icon, className: iconSizes3[size] }) : null;
        const hasText = Boolean(children) || amount != null || label !== void 0 && label !== null && label !== "";
        if (!hasText && !resolvedIcon && !onRemove) return null;
        return /* @__PURE__ */ jsxs(
          "span",
          {
            ref,
            className: cn(
              "inline-flex items-center gap-1 font-bold rounded-sm",
              variantStyles3[variant],
              sizeStyles3[size],
              onRemove && "pr-1",
              className
            ),
            ...props,
            children: [
              resolvedIcon,
              children || (amount != null ? `${label ? `${label} ` : ""}${amount}` : label),
              onRemove ? /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  "aria-label": removeLabel ?? "Remove",
                  onClick: (e) => {
                    e.stopPropagation();
                    onRemove();
                  },
                  className: cn(
                    "inline-flex items-center justify-center rounded-sm",
                    "hover:bg-foreground/10 focus:outline-none focus-visible:ring-1 focus-visible:ring-ring",
                    "transition-colors",
                    size === "sm" ? "w-4 h-4 ml-0.5" : size === "md" ? "w-5 h-5 ml-1" : "w-6 h-6 ml-1"
                  ),
                  children: /* @__PURE__ */ jsx(X, { className: iconSizes3[size] })
                }
              ) : null
            ]
          }
        );
      }
    );
    Badge.displayName = "Badge";
  }
});
function GameIcon({ assetUrl, icon, size = "md", alt, className }) {
  const px = typeof size === "number" ? size : sizeMap[size];
  useIconFamily();
  if (assetUrl?.url) {
    return /* @__PURE__ */ jsx(
      AtlasImage,
      {
        asset: assetUrl,
        size: px,
        alt: alt ?? assetUrl.category ?? "",
        className: cn("flex-shrink-0", className)
      }
    );
  }
  const I = typeof icon === "string" ? resolveIconForFamily(icon) : icon;
  return /* @__PURE__ */ jsx(I, { width: px, height: px, className: cn("flex-shrink-0", className) });
}
var sizeMap;
var init_GameIcon = __esm({
  "components/core/atoms/GameIcon.tsx"() {
    "use client";
    init_cn();
    init_iconFamily();
    init_AtlasImage();
    sizeMap = {
      sm: 16,
      md: 24,
      lg: 32
    };
    GameIcon.displayName = "GameIcon";
  }
});
var variantStyles4, sizeStyles4, iconSizes, FilterPill;
var init_FilterPill = __esm({
  "components/core/atoms/FilterPill.tsx"() {
    init_cn();
    init_useEventBus();
    init_Icon();
    variantStyles4 = {
      default: [
        "bg-muted text-foreground",
        "border-[length:var(--border-width-thin)] border-border"
      ].join(" "),
      primary: "bg-primary/10 text-primary border-[length:var(--border-width)] border-primary",
      secondary: "bg-secondary/10 text-secondary-foreground border-[length:var(--border-width)] border-secondary",
      success: [
        "bg-surface text-success",
        "border-[length:var(--border-width)] border-success"
      ].join(" "),
      warning: [
        "bg-surface text-warning",
        "border-[length:var(--border-width)] border-warning"
      ].join(" "),
      danger: [
        "bg-surface text-error",
        "border-[length:var(--border-width)] border-error"
      ].join(" "),
      info: [
        "bg-surface text-info",
        "border-[length:var(--border-width)] border-info"
      ].join(" "),
      neutral: [
        "bg-muted text-muted-foreground",
        "border-[length:var(--border-width-thin)] border-border"
      ].join(" ")
    };
    sizeStyles4 = {
      sm: "px-2 py-0.5 text-xs",
      md: "px-2.5 py-1 text-sm",
      lg: "px-3 py-1.5 text-base"
    };
    iconSizes = {
      sm: "w-3 h-3",
      md: "w-3.5 h-3.5",
      lg: "w-4 h-4"
    };
    FilterPill = React79__default.forwardRef(
      ({
        className,
        variant = "default",
        size = "sm",
        label,
        icon,
        onRemove,
        removable = true,
        onClick,
        clickEvent,
        removeEvent,
        children,
        ...props
      }, ref) => {
        const eventBus = useEventBus();
        const { t } = useTranslate();
        const payloadLabel = typeof children === "string" || typeof children === "number" ? children : label;
        const handleClick = useCallback(() => {
          onClick?.();
          if (clickEvent) eventBus.emit(`UI:${clickEvent}`, { label: payloadLabel });
        }, [onClick, clickEvent, eventBus, payloadLabel]);
        const handleRemove = useCallback(() => {
          onRemove?.();
          if (removeEvent) eventBus.emit(`UI:${removeEvent}`, { label: payloadLabel });
        }, [onRemove, removeEvent, eventBus, payloadLabel]);
        const resolvedIcon = typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: iconSizes[size] }) : icon ? /* @__PURE__ */ jsx(Icon, { icon, className: iconSizes[size] }) : null;
        return /* @__PURE__ */ jsxs(
          "span",
          {
            ref,
            className: cn(
              "inline-flex items-center gap-1 font-bold rounded-pill",
              variantStyles4[variant],
              sizeStyles4[size],
              (onClick || clickEvent) && "cursor-pointer",
              className
            ),
            onClick: onClick || clickEvent ? handleClick : void 0,
            ...props,
            children: [
              resolvedIcon,
              /* @__PURE__ */ jsx("span", { children: children ?? label }),
              removable && (onRemove || removeEvent) && /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  onClick: (e) => {
                    e.stopPropagation();
                    handleRemove();
                  },
                  "aria-label": t("aria.removeFilter"),
                  className: cn(
                    "ml-0.5 rounded-full hover:bg-foreground/10 transition-colors flex items-center justify-center"
                  ),
                  children: /* @__PURE__ */ jsx(Icon, { name: "x", className: iconSizes[size] })
                }
              )
            ]
          }
        );
      }
    );
    FilterPill.displayName = "FilterPill";
  }
});
function generateInitials(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
var sizeClasses2, iconSizeClasses, statusSizeClasses, statusClasses, badgeSizeClasses, Avatar;
var init_Avatar = __esm({
  "components/core/atoms/Avatar.tsx"() {
    "use client";
    init_Icon();
    init_cn();
    init_useEventBus();
    sizeClasses2 = {
      xs: "w-6 h-6 text-xs",
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg",
      xl: "w-16 h-16 text-xl"
    };
    iconSizeClasses = {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6",
      xl: "w-8 h-8"
    };
    statusSizeClasses = {
      xs: "w-1.5 h-1.5",
      sm: "w-2 h-2",
      md: "w-2.5 h-2.5",
      lg: "w-3 h-3",
      xl: "w-4 h-4"
    };
    statusClasses = {
      online: "bg-success",
      offline: "bg-muted-foreground",
      away: "bg-warning",
      busy: "bg-error"
    };
    badgeSizeClasses = {
      xs: "w-3 h-3 text-xs",
      sm: "w-4 h-4 text-xs",
      md: "w-5 h-5 text-xs",
      lg: "w-6 h-6 text-sm",
      xl: "w-7 h-7 text-base"
    };
    Avatar = ({
      src,
      alt,
      name,
      initials: providedInitials,
      icon: iconProp,
      size = "md",
      status,
      badge,
      className,
      onClick,
      action,
      actionPayload
    }) => {
      const eventBus = useEventBus();
      const [imgFailed, setImgFailed] = React79__default.useState(false);
      React79__default.useEffect(() => {
        setImgFailed(false);
      }, [src]);
      const initials = providedInitials ?? (name ? generateInitials(name) : void 0);
      const IconComponent = typeof iconProp === "string" ? resolveIcon(iconProp) : iconProp;
      const hasIcon = !!IconComponent;
      const hasInitials = !!initials && !(hasIcon && !providedInitials);
      const getInitialsBackground = () => "bg-primary text-primary-foreground";
      const isClickable = action || onClick;
      const handleClick = () => {
        if (action) {
          eventBus.emit(`UI:${action}`, actionPayload ?? {});
        }
        onClick?.();
      };
      return /* @__PURE__ */ jsxs("div", { className: "relative inline-block", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "relative inline-flex items-center justify-center",
              "bg-muted border-[length:var(--border-width)] border-border",
              "overflow-hidden",
              sizeClasses2[size],
              isClickable && "cursor-pointer hover:bg-[var(--color-surface-hover)] transition-colors",
              className
            ),
            onClick: isClickable ? handleClick : void 0,
            role: isClickable ? "button" : void 0,
            tabIndex: isClickable ? 0 : void 0,
            children: src && !imgFailed ? /* @__PURE__ */ jsx(
              "img",
              {
                src,
                alt: alt || "Avatar",
                className: "w-full h-full object-cover",
                onError: () => setImgFailed(true)
              }
            ) : hasInitials ? /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "w-full h-full flex items-center justify-center font-bold",
                  getInitialsBackground()
                ),
                children: initials.substring(0, 2).toUpperCase()
              }
            ) : hasIcon && IconComponent ? /* @__PURE__ */ jsx(
              IconComponent,
              {
                className: cn(
                  "text-foreground",
                  iconSizeClasses[size]
                )
              }
            ) : /* @__PURE__ */ jsx(
              Icon,
              {
                name: "user",
                className: cn(
                  "text-foreground",
                  iconSizeClasses[size]
                )
              }
            )
          }
        ),
        status && /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "absolute bottom-0 right-0 border-2 border-card",
              statusClasses[status],
              statusSizeClasses[size]
            ),
            "aria-label": `Status: ${status}`
          }
        ),
        badge !== void 0 && /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "absolute -top-1 -right-1 flex items-center justify-center",
              "bg-primary text-primary-foreground font-bold",
              "border-2 border-card",
              badgeSizeClasses[size]
            ),
            "aria-label": `Badge: ${badge}`,
            children: typeof badge === "number" && badge > 99 ? "99+" : badge
          }
        )
      ] });
    };
    Avatar.displayName = "Avatar";
  }
});
function useTapReveal(options = {}) {
  const { onReveal, onDismiss, refs, enabled = true } = options;
  const [revealed, setRevealed] = useState(false);
  const onRevealRef = useRef(onReveal);
  const onDismissRef = useRef(onDismiss);
  onRevealRef.current = onReveal;
  onDismissRef.current = onDismiss;
  const reveal = useCallback(() => {
    setRevealed((wasRevealed) => {
      if (!wasRevealed) onRevealRef.current?.();
      return true;
    });
  }, []);
  const dismiss = useCallback(() => {
    setRevealed((wasRevealed) => {
      if (wasRevealed) onDismissRef.current?.();
      return false;
    });
  }, []);
  const onPointerDown = useCallback(
    (e) => {
      if (!enabled || e.pointerType === "mouse") return;
      if (revealed) dismiss();
      else reveal();
    },
    [enabled, revealed, reveal, dismiss]
  );
  useEffect(() => {
    if (!revealed || typeof document === "undefined") return;
    const onDocDown = (ev) => {
      const target = ev.target;
      if (!(target instanceof Node)) return;
      const inside = (refs ?? []).some((r) => r.current?.contains(target));
      if (!inside) dismiss();
    };
    const id = setTimeout(() => document.addEventListener("pointerdown", onDocDown), 0);
    return () => {
      clearTimeout(id);
      document.removeEventListener("pointerdown", onDocDown);
    };
  }, [revealed, refs, dismiss]);
  return { revealed, triggerProps: { onPointerDown }, reveal, dismiss };
}
var init_useTapReveal = __esm({
  "hooks/useTapReveal.ts"() {
  }
});
var paddingStyles2, paddingXStyles, paddingYStyles, marginStyles, marginXStyles, marginYStyles, bgStyles, roundedStyles, shadowStyles2, displayStyles, overflowStyles, positionStyles, Box;
var init_Box = __esm({
  "components/core/atoms/Box.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_useTapReveal();
    paddingStyles2 = {
      none: "p-0",
      xs: "p-1",
      sm: "p-2",
      md: "p-4",
      lg: "p-6",
      xl: "p-8",
      "2xl": "p-12"
    };
    paddingXStyles = {
      none: "px-0",
      xs: "px-1",
      sm: "px-2",
      md: "px-4",
      lg: "px-6",
      xl: "px-8",
      "2xl": "px-12"
    };
    paddingYStyles = {
      none: "py-0",
      xs: "py-1",
      sm: "py-2",
      md: "py-4",
      lg: "py-6",
      xl: "py-8",
      "2xl": "py-12"
    };
    marginStyles = {
      none: "m-0",
      xs: "m-1",
      sm: "m-2",
      md: "m-4",
      lg: "m-6",
      xl: "m-8",
      "2xl": "m-12",
      auto: "m-auto"
    };
    marginXStyles = {
      none: "mx-0",
      xs: "mx-1",
      sm: "mx-2",
      md: "mx-4",
      lg: "mx-6",
      xl: "mx-8",
      "2xl": "mx-12",
      auto: "mx-auto"
    };
    marginYStyles = {
      none: "my-0",
      xs: "my-1",
      sm: "my-2",
      md: "my-4",
      lg: "my-6",
      xl: "my-8",
      "2xl": "my-12",
      auto: "my-auto"
    };
    bgStyles = {
      transparent: "bg-transparent",
      primary: "bg-primary text-primary-foreground",
      secondary: "bg-secondary text-secondary-foreground",
      muted: "bg-muted text-foreground",
      accent: "bg-accent text-accent-foreground",
      surface: "bg-card",
      overlay: "bg-card/80 backdrop-blur-sm"
    };
    roundedStyles = {
      none: "rounded-none",
      sm: "rounded-sm",
      md: "rounded-md",
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-xl",
      full: "rounded-full"
    };
    shadowStyles2 = {
      none: "shadow-none",
      sm: "shadow-sm",
      md: "shadow",
      lg: "shadow-lg",
      xl: "shadow-lg"
    };
    displayStyles = {
      block: "block",
      inline: "inline",
      "inline-block": "inline-block",
      flex: "flex",
      "inline-flex": "inline-flex",
      grid: "grid"
    };
    overflowStyles = {
      auto: "overflow-auto",
      hidden: "overflow-hidden",
      visible: "overflow-visible",
      scroll: "overflow-scroll"
    };
    positionStyles = {
      relative: "relative",
      absolute: "absolute",
      fixed: "fixed",
      sticky: "sticky"
    };
    Box = React79__default.forwardRef(
      ({
        padding,
        paddingX,
        paddingY,
        margin,
        marginX,
        marginY,
        bg = "transparent",
        border = false,
        rounded = "none",
        shadow = "none",
        display,
        fullWidth = false,
        fullHeight = false,
        overflow,
        position,
        className,
        children,
        as: Component = "div",
        action,
        actionPayload,
        hoverEvent,
        tapReveal = true,
        maxWidth,
        onClick,
        onMouseEnter,
        onMouseLeave,
        onPointerDown,
        ...rest
      }, ref) => {
        const eventBus = useEventBus();
        const handleClick = useCallback((e) => {
          if (action) {
            e.stopPropagation();
            eventBus.emit(`UI:${action}`, actionPayload ?? {});
          }
          onClick?.(e);
        }, [action, actionPayload, eventBus, onClick]);
        const handleMouseEnter = useCallback((e) => {
          if (hoverEvent) {
            eventBus.emit(`UI:${hoverEvent}`, { hovered: true });
          }
          onMouseEnter?.(e);
        }, [hoverEvent, eventBus, onMouseEnter]);
        const handleMouseLeave = useCallback((e) => {
          if (hoverEvent) {
            eventBus.emit(`UI:${hoverEvent}`, { hovered: false });
          }
          onMouseLeave?.(e);
        }, [hoverEvent, eventBus, onMouseLeave]);
        const { triggerProps } = useTapReveal({
          enabled: tapReveal && !!hoverEvent,
          onReveal: useCallback(() => {
            if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: true });
          }, [hoverEvent, eventBus]),
          onDismiss: useCallback(() => {
            if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: false });
          }, [hoverEvent, eventBus])
        });
        const handlePointerDown = useCallback((e) => {
          if (hoverEvent && tapReveal) triggerProps.onPointerDown(e);
          onPointerDown?.(e);
        }, [hoverEvent, tapReveal, triggerProps, onPointerDown]);
        const isClickable = action || onClick;
        return React79__default.createElement(
          Component,
          {
            ref,
            className: cn(
              padding && paddingStyles2[padding],
              paddingX && paddingXStyles[paddingX],
              paddingY && paddingYStyles[paddingY],
              margin && marginStyles[margin],
              marginX && marginXStyles[marginX],
              marginY && marginYStyles[marginY],
              bgStyles[bg],
              border && "border-[length:var(--border-width)] border-border",
              roundedStyles[rounded],
              shadowStyles2[shadow],
              display && displayStyles[display],
              fullWidth && "w-full",
              fullHeight && "h-full",
              overflow && overflowStyles[overflow],
              position && positionStyles[position],
              isClickable && "cursor-pointer",
              className
            ),
            onClick: isClickable ? handleClick : void 0,
            onMouseEnter: hoverEvent || onMouseEnter ? handleMouseEnter : void 0,
            onMouseLeave: hoverEvent || onMouseLeave ? handleMouseLeave : void 0,
            onPointerDown: hoverEvent && tapReveal || onPointerDown ? handlePointerDown : void 0,
            style: maxWidth ? { maxWidth, ...rest.style } : rest.style,
            ...rest
          },
          children
        );
      }
    );
    Box.displayName = "Box";
  }
});
var Center;
var init_Center = __esm({
  "components/core/atoms/Center.tsx"() {
    init_cn();
    Center = ({
      inline = false,
      horizontal = true,
      vertical = true,
      minHeight,
      fullHeight = false,
      fullWidth = false,
      className,
      style,
      children,
      as: Component = "div"
    }) => {
      const mergedStyle = minHeight ? { minHeight, ...style } : style;
      return React79__default.createElement(Component, {
        className: cn(
          inline ? "inline-flex" : "flex",
          horizontal && "justify-center",
          vertical && "items-center",
          fullHeight && "h-full",
          fullWidth && "w-full",
          className
        ),
        style: mergedStyle,
        children
      });
    };
  }
});
var variantStyles5, Divider;
var init_Divider = __esm({
  "components/core/atoms/Divider.tsx"() {
    init_cn();
    variantStyles5 = {
      solid: "border-solid",
      dashed: "border-dashed",
      dotted: "border-dotted"
    };
    Divider = ({
      orientation = "horizontal",
      label,
      variant = "solid",
      className
    }) => {
      if (orientation === "vertical") {
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "w-0 h-full border-l border-border",
              variantStyles5[variant],
              className
            ),
            role: "separator",
            "aria-orientation": "vertical"
          }
        );
      }
      if (label) {
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn("flex items-center gap-3 my-4", className),
            role: "separator",
            "aria-label": label,
            children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "flex-1 h-0 border-t border-border",
                    variantStyles5[variant]
                  )
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "text-sm text-foreground font-bold uppercase tracking-wide", children: label }),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "flex-1 h-0 border-t border-border",
                    variantStyles5[variant]
                  )
                }
              )
            ]
          }
        );
      }
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "w-full h-0 border-t border-border my-4",
            variantStyles5[variant],
            className
          ),
          role: "separator",
          "aria-orientation": "horizontal"
        }
      );
    };
    Divider.displayName = "Divider";
  }
});
var colorClasses, circularSizeClasses, ProgressBar;
var init_ProgressBar = __esm({
  "components/core/atoms/ProgressBar.tsx"() {
    init_cn();
    colorClasses = {
      default: "bg-primary",
      primary: "bg-primary",
      success: "bg-success",
      warning: "bg-warning",
      error: "bg-error",
      danger: "bg-error"
    };
    circularSizeClasses = {
      sm: "w-16 h-16",
      md: "w-24 h-24",
      lg: "w-32 h-32"
    };
    ProgressBar = ({
      value,
      max = 100,
      progressType = "linear",
      variant = "primary",
      color,
      showPercentage = false,
      showLabel = false,
      label,
      size = "md",
      steps = 5,
      className
    }) => {
      const percentage = Math.min(Math.max(value / max * 100, 0), 100);
      const effectiveColor = color ?? variant;
      const effectiveShowPercentage = showPercentage || showLabel;
      if (progressType === "linear") {
        const showHeader = label || effectiveShowPercentage;
        return /* @__PURE__ */ jsxs("div", { className: cn("w-full", className), children: [
          showHeader && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-1.5", children: [
            label && /* @__PURE__ */ jsx("span", { className: "text-sm font-bold text-foreground", children: label }),
            effectiveShowPercentage && /* @__PURE__ */ jsxs("span", { className: cn("text-sm text-foreground font-medium", !label && "ml-auto"), children: [
              Math.round(percentage),
              "%"
            ] })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "w-full h-2 bg-muted border border-border overflow-hidden", children: /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "h-full transition-all duration-normal ease-emphasized",
                colorClasses[effectiveColor]
              ),
              style: { width: `${percentage}%` },
              role: "progressbar",
              "aria-valuenow": value,
              "aria-valuemin": 0,
              "aria-valuemax": max,
              "aria-label": label || `Progress: ${Math.round(percentage)}%`
            }
          ) })
        ] });
      }
      if (progressType === "circular") {
        const radius = size === "sm" ? 28 : size === "md" ? 40 : 56;
        const circumference = 2 * Math.PI * radius;
        const offset = circumference - percentage / 100 * circumference;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn(
              "relative inline-flex items-center justify-center",
              className
            ),
            children: [
              /* @__PURE__ */ jsxs(
                "svg",
                {
                  className: cn("transform -rotate-90", circularSizeClasses[size]),
                  viewBox: "0 0 100 100",
                  children: [
                    /* @__PURE__ */ jsx(
                      "circle",
                      {
                        cx: "50",
                        cy: "50",
                        r: radius,
                        stroke: "currentColor",
                        strokeWidth: "8",
                        fill: "none",
                        className: "text-muted"
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "circle",
                      {
                        cx: "50",
                        cy: "50",
                        r: radius,
                        stroke: "currentColor",
                        strokeWidth: "8",
                        fill: "none",
                        strokeDasharray: circumference,
                        strokeDashoffset: offset,
                        strokeLinecap: "round",
                        className: cn(
                          "transition-all duration-normal ease-emphasized",
                          colorClasses[effectiveColor]
                        )
                      }
                    )
                  ]
                }
              ),
              effectiveShowPercentage && /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsxs("span", { className: "text-sm font-bold text-foreground", children: [
                Math.round(percentage),
                "%"
              ] }) })
            ]
          }
        );
      }
      if (progressType === "stepped") {
        const stepValue = max / steps;
        const activeSteps = Math.floor(value / stepValue);
        const partialStep = value % stepValue / stepValue;
        const showStepHeader = label || effectiveShowPercentage;
        return /* @__PURE__ */ jsxs("div", { className: cn("w-full", className), children: [
          showStepHeader && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-2", children: [
            label && /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-foreground", children: label }),
            effectiveShowPercentage && /* @__PURE__ */ jsxs("span", { className: cn("text-sm text-muted-foreground", !label && "ml-auto"), children: [
              Math.round(percentage),
              "%"
            ] })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex gap-1", children: Array.from({ length: steps }).map((_, index) => {
            const isActive = index < activeSteps;
            const isPartial = index === activeSteps && partialStep > 0;
            return /* @__PURE__ */ jsx(
              "div",
              {
                className: "flex-1 h-2 bg-muted border border-border overflow-hidden",
                children: /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: cn(
                      "h-full transition-all duration-normal ease-emphasized",
                      (isActive || isPartial) && colorClasses[effectiveColor]
                    ),
                    style: {
                      width: isPartial ? `${partialStep * 100}%` : isActive ? "100%" : "0%"
                    }
                  }
                )
              },
              index
            );
          }) })
        ] });
      }
      return null;
    };
    ProgressBar.displayName = "ProgressBar";
  }
});
var sizeClasses3, dotSizeClasses, Radio;
var init_Radio = __esm({
  "components/core/atoms/Radio.tsx"() {
    init_cn();
    init_useEventBus();
    sizeClasses3 = {
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6"
    };
    dotSizeClasses = {
      sm: "w-2 h-2",
      md: "w-2.5 h-2.5",
      lg: "w-3 h-3"
    };
    Radio = React79__default.forwardRef(
      ({
        label,
        helperText,
        error,
        size = "md",
        className,
        id,
        checked,
        disabled,
        options,
        value,
        action,
        name,
        onChange,
        ...props
      }, ref) => {
        const reactId = React79__default.useId();
        const baseId = id || `radio-${reactId}`;
        const hasError = !!error;
        const eventBus = useEventBus();
        const [selected, setSelected] = React79__default.useState(value);
        React79__default.useEffect(() => {
          if (value !== void 0) setSelected(value);
        }, [value]);
        const pick = (next, e) => {
          setSelected(next);
          if (action) eventBus.emit(`UI:${action}`, { value: next });
          onChange?.(e);
        };
        const control = (key, inputId, isChecked2, input) => /* @__PURE__ */ jsxs("div", { className: "relative flex-shrink-0 mt-0.5", children: [
          input,
          /* @__PURE__ */ jsx(
            "label",
            {
              htmlFor: inputId,
              className: cn(
                "flex items-center justify-center",
                "border-[length:var(--border-width)] transition-all cursor-pointer",
                sizeClasses3[size],
                hasError ? "border-error peer-focus-visible:ring-error/20" : "border-border peer-focus-visible:ring-ring/20",
                isChecked2 ? hasError ? "border-error" : "border-primary bg-primary" : "",
                "peer-focus:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2",
                disabled && "opacity-50 cursor-not-allowed",
                !disabled && "hover:border-[var(--color-border-hover)]"
              ),
              children: isChecked2 && /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "transition-all",
                    dotSizeClasses[size],
                    hasError ? "bg-error" : "bg-primary-foreground"
                  )
                }
              )
            }
          )
        ] }, key);
        const optionLabel = (inputId, text) => /* @__PURE__ */ jsx("div", { className: "flex-1 min-w-0", children: /* @__PURE__ */ jsx(
          "label",
          {
            htmlFor: inputId,
            className: cn(
              "block text-sm font-medium cursor-pointer select-none",
              hasError ? "text-error" : "text-foreground",
              disabled && "opacity-50 cursor-not-allowed"
            ),
            children: text
          }
        ) });
        const helper = helperText || error ? /* @__PURE__ */ jsxs("div", { className: "mt-1.5 ml-8", children: [
          error && /* @__PURE__ */ jsx("p", { id: `${baseId}-error`, className: "text-sm text-error font-medium", role: "alert", children: error }),
          !error && helperText && /* @__PURE__ */ jsx("p", { id: `${baseId}-helper`, className: "text-sm text-muted-foreground", children: helperText })
        ] }) : null;
        if (options && options.length > 0) {
          const groupName = name || baseId;
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-3", role: "radiogroup", "aria-invalid": hasError, children: options.map((opt, i) => {
              const inputId = `${baseId}-${i}`;
              const isChecked2 = selected === opt;
              return /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
                control(
                  opt,
                  inputId,
                  isChecked2,
                  /* @__PURE__ */ jsx(
                    "input",
                    {
                      type: "radio",
                      id: inputId,
                      name: groupName,
                      value: opt,
                      checked: isChecked2,
                      disabled,
                      onChange: (e) => pick(opt, e),
                      className: cn("sr-only peer", className)
                    }
                  )
                ),
                optionLabel(inputId, opt)
              ] }, opt);
            }) }),
            helper
          ] });
        }
        const isChecked = checked !== void 0 ? !!checked : selected === (value ?? baseId);
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
            control(
              baseId,
              baseId,
              isChecked,
              /* @__PURE__ */ jsx(
                "input",
                {
                  ref,
                  type: "radio",
                  id: baseId,
                  checked: isChecked,
                  disabled,
                  onChange: (e) => pick(value ?? baseId, e),
                  className: cn("sr-only peer", className),
                  "aria-invalid": hasError,
                  "aria-describedby": error ? `${baseId}-error` : helperText ? `${baseId}-helper` : void 0,
                  ...props
                }
              )
            ),
            label && optionLabel(baseId, label)
          ] }),
          helper
        ] });
      }
    );
    Radio.displayName = "Radio";
  }
});
var COLOR_VAR, Sparkline;
var init_Sparkline = __esm({
  "components/core/atoms/Sparkline.tsx"() {
    init_cn();
    COLOR_VAR = {
      primary: "var(--color-primary)",
      success: "var(--color-success)",
      warning: "var(--color-warning)",
      error: "var(--color-error)",
      info: "var(--color-info)",
      muted: "var(--color-muted-foreground)"
    };
    Sparkline = ({
      data,
      color = "auto",
      width = 80,
      height = 32,
      strokeWidth = 2,
      fill = false,
      className
    }) => {
      if (data.length < 2) return null;
      const pad = 2;
      const min = Math.min(...data);
      const max = Math.max(...data);
      const range = max - min || 1;
      const points = data.map((v, i) => {
        const x = pad + i / (data.length - 1) * (width - pad * 2);
        const y = pad + (1 - (v - min) / range) * (height - pad * 2);
        return `${x},${y}`;
      }).join(" ");
      const resolvedColor = color === "auto" ? data[data.length - 1] >= data[0] ? COLOR_VAR.success : COLOR_VAR.error : COLOR_VAR[color];
      const areaPath = fill ? `M ${pad},${height - pad} L ${points.split(" ").join(" L ")} L ${width - pad},${height - pad} Z` : null;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          width,
          height,
          viewBox: `0 0 ${width} ${height}`,
          className: cn("flex-shrink-0", className),
          "aria-hidden": "true",
          children: [
            areaPath && /* @__PURE__ */ jsx("path", { d: areaPath, fill: resolvedColor, opacity: 0.15 }),
            /* @__PURE__ */ jsx(
              "polyline",
              {
                fill: "none",
                stroke: resolvedColor,
                strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points
              }
            )
          ]
        }
      );
    };
    Sparkline.displayName = "Sparkline";
  }
});
var Switch;
var init_Switch = __esm({
  "components/core/atoms/Switch.tsx"() {
    "use client";
    init_cn();
    Switch = React79.forwardRef(
      ({
        checked,
        defaultChecked = false,
        onChange,
        disabled = false,
        label,
        id,
        name,
        className
      }, ref) => {
        const [isChecked, setIsChecked] = React79.useState(
          checked !== void 0 ? checked : defaultChecked
        );
        React79.useEffect(() => {
          if (checked !== void 0) {
            setIsChecked(checked);
          }
        }, [checked]);
        const handleClick = () => {
          if (disabled) return;
          const newValue = !isChecked;
          if (checked === void 0) {
            setIsChecked(newValue);
          }
          onChange?.(newValue);
        };
        return /* @__PURE__ */ jsxs("div", { className: cn("inline-flex items-center gap-2", className), children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              ref,
              type: "button",
              role: "switch",
              "aria-checked": isChecked,
              "aria-label": label,
              id,
              name,
              disabled,
              onClick: handleClick,
              className: cn(
                // Fixed rem sizes instead of spacing tokens: themes like atelier
                // redefine --space-11 to 68px, which makes w-11 enormous and leaves
                // the thumb stuck near the left edge. The switch geometry must stay
                // proportional regardless of a theme's density scale.
                "relative inline-flex h-[1.5rem] w-[2.75rem] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-fast",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
                isChecked ? "bg-primary" : "bg-muted",
                disabled && "cursor-not-allowed opacity-50"
              ),
              children: /* @__PURE__ */ jsx(
                "span",
                {
                  className: cn(
                    "pointer-events-none block h-[1.25rem] w-[1.25rem] rounded-full bg-background shadow-lg ring-0 transition-transform duration-fast",
                    isChecked ? "translate-x-[1.25rem]" : "translate-x-0"
                  )
                }
              )
            }
          ),
          label && /* @__PURE__ */ jsx(
            "label",
            {
              htmlFor: id,
              className: cn(
                "text-sm font-medium leading-none cursor-pointer",
                disabled && "cursor-not-allowed opacity-70"
              ),
              onClick: handleClick,
              children: label
            }
          )
        ] });
      }
    );
    Switch.displayName = "Switch";
  }
});
var horizontalSizes, verticalSizes, Spacer;
var init_Spacer = __esm({
  "components/core/atoms/Spacer.tsx"() {
    init_cn();
    horizontalSizes = {
      xs: "w-1",
      sm: "w-2",
      md: "w-4",
      lg: "w-6",
      xl: "w-8",
      "2xl": "w-12"
    };
    verticalSizes = {
      xs: "h-1",
      sm: "h-2",
      md: "h-4",
      lg: "h-6",
      xl: "h-8",
      "2xl": "h-12"
    };
    Spacer = ({
      size = "auto",
      axis = "horizontal",
      className
    }) => {
      if (size === "auto") {
        return /* @__PURE__ */ jsx("div", { className: cn("flex-1", className), "aria-hidden": "true" });
      }
      const sizeClass = axis === "horizontal" ? horizontalSizes[size] : verticalSizes[size];
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn("flex-shrink-0", sizeClass, className),
          "aria-hidden": "true"
        }
      );
    };
  }
});
var gapStyles, alignStyles, justifyStyles, Stack, VStack, HStack;
var init_Stack = __esm({
  "components/core/atoms/Stack.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    gapStyles = {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8",
      "2xl": "gap-12"
    };
    alignStyles = {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline"
    };
    justifyStyles = {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
      evenly: "justify-evenly"
    };
    Stack = ({
      direction = "vertical",
      gap = "md",
      align = "stretch",
      justify = "start",
      wrap = false,
      reverse = false,
      flex = false,
      className,
      style,
      children,
      as: Component = "div",
      onClick,
      onKeyDown,
      role,
      tabIndex,
      action,
      actionPayload,
      responsive = false
    }) => {
      const eventBus = useEventBus();
      const handleClick = (e) => {
        if (action) {
          eventBus.emit(`UI:${action}`, actionPayload ?? {});
        }
        onClick?.(e);
      };
      const isHorizontal = direction === "horizontal";
      const directionClass = responsive && isHorizontal ? reverse ? "flex-col-reverse md:flex-row-reverse" : "flex-col md:flex-row" : isHorizontal ? reverse ? "flex-row-reverse" : "flex-row" : reverse ? "flex-col-reverse" : "flex-col";
      return React79__default.createElement(
        Component,
        {
          className: cn(
            "flex",
            directionClass,
            gapStyles[gap],
            alignStyles[align],
            justifyStyles[justify],
            wrap && "flex-wrap",
            flex && "flex-1",
            className
          ),
          style,
          onClick: action || onClick ? handleClick : void 0,
          onKeyDown,
          role,
          tabIndex
        },
        children
      );
    };
    VStack = (props) => /* @__PURE__ */ jsx(Stack, { direction: "vertical", ...props });
    HStack = (props) => /* @__PURE__ */ jsx(Stack, { direction: "horizontal", ...props });
  }
});
var TextHighlight;
var init_TextHighlight = __esm({
  "components/core/atoms/TextHighlight.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    TextHighlight = ({
      highlightType,
      isActive = false,
      onClick,
      onMouseEnter,
      onMouseLeave,
      annotationId,
      className,
      children,
      action,
      hoverEvent
    }) => {
      const eventBus = useEventBus();
      const baseStyles = "cursor-pointer transition-all duration-fast";
      const typeStyles = {
        question: cn(
          // Blue border for questions
          "bg-card border-b-2 border-primary",
          "hover:bg-muted",
          isActive && "bg-primary/10 ring-2 ring-primary"
        ),
        note: cn(
          // Yellow border for notes
          "bg-card border-b-2 border-warning",
          "hover:bg-muted",
          isActive && "bg-warning/10 ring-2 ring-warning"
        )
      };
      return /* @__PURE__ */ jsx(
        "span",
        {
          "data-highlight": "true",
          "data-highlight-type": highlightType,
          "data-annotation-id": annotationId,
          className: cn(baseStyles, typeStyles[highlightType], className),
          onClick: () => {
            if (action) eventBus.emit(`UI:${action}`, { annotationId });
            onClick?.();
          },
          onMouseEnter: () => {
            if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: true, annotationId });
            onMouseEnter?.();
          },
          onMouseLeave: () => {
            if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: false, annotationId });
            onMouseLeave?.();
          },
          onPointerDown: (e) => {
            if (e.pointerType === "mouse") return;
            if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: true, annotationId });
            onMouseEnter?.();
          },
          role: "button",
          tabIndex: 0,
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              if (action) eventBus.emit(`UI:${action}`, { annotationId });
              onClick?.();
            }
          },
          children
        }
      );
    };
    TextHighlight.displayName = "TextHighlight";
  }
});

// lib/format.ts
function humanizeFieldName(name) {
  return name.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2").replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()).replace(/\b([A-Z])([A-Z]+)\b/g, (_, first, rest) => first + rest.toLowerCase()).trim();
}
function humanizeEnumValue(value) {
  return /^[a-z0-9]+(?:[_-][a-z0-9]+)+$/.test(value) ? humanizeFieldName(value) : value;
}
function formatDate(value) {
  if (!value) return "";
  const d = new Date(String(value));
  if (isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(void 0, { year: "numeric", month: "short", day: "numeric" });
}
function formatTime(value) {
  if (!value) return "";
  const d = new Date(String(value));
  if (isNaN(d.getTime())) return String(value);
  return d.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit" });
}
function formatDateTime(value) {
  if (!value) return "";
  const d = new Date(String(value));
  if (isNaN(d.getTime())) return String(value);
  return `${formatDate(value)} ${formatTime(value)}`;
}
function asYesNo(value) {
  return value === false || value === 0 || String(value) === "false" ? "No" : "Yes";
}
function formatValue(value, format) {
  if (value === void 0 || value === null) return "";
  if (typeof value === "boolean") return asYesNo(value);
  switch (format) {
    case "date":
      return formatDate(value);
    case "time":
      return formatTime(value);
    case "datetime":
      return formatDateTime(value);
    case "currency":
      return typeof value === "number" ? `$${value.toFixed(2)}` : String(value);
    case "number":
      return typeof value === "number" ? value.toLocaleString() : String(value);
    case "percent":
      return typeof value === "number" ? `${Math.round(value)}%` : String(value);
    case "boolean":
      return asYesNo(value);
    default:
      return String(value);
  }
}
function compareCellValues(a, b) {
  const aEmpty = a === null || a === void 0 || a === "";
  const bEmpty = b === null || b === void 0 || b === "";
  if (aEmpty || bEmpty) return aEmpty && bEmpty ? 0 : aEmpty ? 1 : -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
  const aNum = Number(a);
  const bNum = Number(b);
  if (Number.isFinite(aNum) && Number.isFinite(bNum)) return aNum - bNum;
  const aTime = dateLikeTime(a);
  const bTime = dateLikeTime(b);
  if (aTime !== null && bTime !== null) return aTime - bTime;
  return String(a).localeCompare(String(b));
}
function dateLikeTime(value) {
  if (value instanceof Date) return value.getTime();
  const text = String(value);
  if (!/\d/.test(text) || !/[-/:T]/.test(text)) return null;
  const time = Date.parse(text);
  return Number.isNaN(time) ? null : time;
}
function sortRows(rows2, field, direction = "asc") {
  if (!field) return rows2;
  const dir = direction === "desc" ? -1 : 1;
  return [...rows2].sort((a, b) => dir * compareCellValues(a?.[field], b?.[field]));
}
var init_format = __esm({
  "lib/format.ts"() {
  }
});

// components/core/atoms/Typography.tsx
var Typography_exports = {};
__export(Typography_exports, {
  Typography: () => Typography
});
var variantStyles6, colorStyles, weightStyles, defaultElements, typographySizeStyles, overflowStyles2, Typography;
var init_Typography = __esm({
  "components/core/atoms/Typography.tsx"() {
    init_cn();
    init_format();
    variantStyles6 = {
      h1: "text-4xl font-bold tracking-tight text-foreground",
      h2: "text-3xl font-bold tracking-tight text-foreground",
      h3: "text-2xl font-bold text-foreground",
      h4: "text-xl font-bold text-foreground",
      h5: "text-lg font-bold text-foreground",
      h6: "text-base font-bold text-foreground",
      heading: "text-2xl font-bold text-foreground",
      subheading: "text-lg font-semibold text-foreground",
      body1: "text-base font-normal text-foreground",
      body2: "text-sm font-normal text-foreground",
      body: "text-base font-normal text-foreground",
      caption: "text-xs font-normal text-muted-foreground",
      overline: "text-xs uppercase tracking-wide font-bold text-muted-foreground",
      small: "text-sm font-normal text-foreground",
      large: "text-lg font-medium text-foreground",
      label: "text-sm font-medium text-foreground"
    };
    colorStyles = {
      primary: "text-foreground",
      secondary: "text-muted-foreground",
      muted: "text-muted-foreground",
      error: "text-error",
      success: "text-success",
      warning: "text-warning",
      inherit: "text-inherit"
    };
    weightStyles = {
      // Neutral: an atom default of "none" must not override the variant's baked
      // weight (C-PATTERN-ENUM-BLOCKS-NEUTRAL-OVERRIDE — `variant={h2}` rendered
      // tiny because the ui-typography atom's `weight: light`/`size: xs` defaults
      // clobbered every variant).
      none: "",
      light: "font-light",
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold"
    };
    defaultElements = {
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      heading: "h2",
      subheading: "h3",
      body1: "p",
      body2: "p",
      body: "p",
      caption: "span",
      overline: "span",
      small: "span",
      large: "p",
      label: "span"
    };
    typographySizeStyles = {
      none: "",
      xs: "text-xs",
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl"
    };
    overflowStyles2 = {
      visible: "overflow-visible",
      hidden: "overflow-hidden",
      wrap: "break-words overflow-hidden",
      "clamp-2": "overflow-hidden line-clamp-2",
      "clamp-3": "overflow-hidden line-clamp-3"
    };
    Typography = ({
      variant: variantProp,
      level,
      color = "primary",
      align,
      weight,
      size,
      truncate = false,
      overflow,
      as,
      id,
      className,
      style,
      format,
      content,
      children
    }) => {
      const variant = variantProp ?? (level ? `h${level}` : "body1");
      const Component = as || defaultElements[variant];
      let body = children ?? content;
      if (format !== void 0 && format !== "none" && (typeof body === "string" || typeof body === "number" || body instanceof Date)) {
        body = formatValue(body, format);
      }
      return React79__default.createElement(
        Component,
        {
          id,
          className: cn(
            variantStyles6[variant],
            colorStyles[color],
            weight && weightStyles[weight],
            size && typographySizeStyles[size],
            align && `text-${align}`,
            // `min-w-0` rides along with truncate/wrap/clamp: a flex or grid
            // item's default `min-width: auto` refuses to shrink below its
            // content's intrinsic width, so ellipsis/wrap silently does nothing
            // in the single most common placement (a row next to a fixed-width
            // control) unless the item can also shrink to zero. (Spelled out as
            // just "truncate", not "truncate overflow-hidden text-ellipsis" —
            // tailwind-merge treats those as the same conflict group and drops
            // "truncate" as the earlier-declared class, silently losing its
            // `white-space: nowrap`.)
            truncate && "truncate min-w-0",
            overflow && cn(overflowStyles2[overflow], overflow !== "visible" && "min-w-0"),
            className
          ),
          style
        },
        body
      );
    };
    Typography.displayName = "Typography";
  }
});
var sizeClasses4, iconSizes2, ThemeToggle;
var init_ThemeToggle = __esm({
  "components/core/atoms/ThemeToggle.tsx"() {
    "use client";
    init_Icon();
    init_cn();
    sizeClasses4 = {
      sm: "p-1.5",
      md: "p-2",
      lg: "p-2.5"
    };
    iconSizes2 = {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    };
    ThemeToggle = ({
      className,
      size = "md",
      showLabel = false
    }) => {
      const { resolvedMode, toggleMode } = useTheme();
      const isDark = resolvedMode === "dark";
      return /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          onClick: toggleMode,
          className: cn(
            "inline-flex items-center justify-center gap-2",
            "text-foreground",
            "hover:bg-muted border-[length:var(--border-width)] border-transparent hover:border-border",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            "transition-colors duration-fast",
            sizeClasses4[size],
            className
          ),
          "aria-label": isDark ? "Switch to light mode" : "Switch to dark mode",
          title: isDark ? "Switch to light mode" : "Switch to dark mode",
          children: [
            isDark ? /* @__PURE__ */ jsx(
              Icon,
              {
                name: "sun",
                className: cn(iconSizes2[size], "text-foreground")
              }
            ) : /* @__PURE__ */ jsx(
              Icon,
              {
                name: "moon",
                className: cn(iconSizes2[size], "text-foreground")
              }
            ),
            showLabel && /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: isDark ? "Light" : "Dark" })
          ]
        }
      );
    };
    ThemeToggle.displayName = "ThemeToggle";
  }
});
function isMotionEnabled() {
  if (typeof document === "undefined") return true;
  if (motionEnabledCache !== null) return motionEnabledCache;
  const v = getComputedStyle(document.documentElement).getPropertyValue("--motion-enable").trim().toLowerCase();
  motionEnabledCache = v !== "off";
  return motionEnabledCache;
}
function usePresence(show, opts) {
  const { animation, animate = true, onExited } = opts;
  const [mounted, setMounted] = useState(show);
  const [exiting, setExiting] = useState(false);
  const prev = useRef(show);
  const onExitedRef = useRef(onExited);
  onExitedRef.current = onExited;
  const safeTimer = useRef(null);
  const clearSafe = useCallback(() => {
    if (safeTimer.current) {
      clearTimeout(safeTimer.current);
      safeTimer.current = null;
    }
  }, []);
  const finishExit = useCallback(() => {
    clearSafe();
    setExiting(false);
    setMounted(false);
    onExitedRef.current?.();
  }, [clearSafe]);
  useLayoutEffect(() => {
    const moving = animate && isMotionEnabled();
    if (show && !prev.current) {
      setExiting(false);
      setMounted(true);
    } else if (!show && prev.current) {
      if (moving) {
        setExiting(true);
        clearSafe();
        safeTimer.current = setTimeout(finishExit, SAFE_EXIT_MS);
      } else {
        setMounted(false);
        setExiting(false);
      }
    }
    prev.current = show;
  }, [show, animate, clearSafe, finishExit]);
  useEffect(() => () => clearSafe(), [clearSafe]);
  const disabled = !animate || !isMotionEnabled();
  const className = disabled ? "" : show ? `animate-${animation}-in` : `animate-${animation}-out`;
  const onAnimationEnd = useCallback(
    (e) => {
      if (e.target !== e.currentTarget) return;
      if (exiting) finishExit();
    },
    [exiting, finishExit]
  );
  return { mounted, exiting, className, onAnimationEnd };
}
var SAFE_EXIT_MS, motionEnabledCache, Presence;
var init_Presence = __esm({
  "components/core/atoms/Presence.tsx"() {
    "use client";
    init_cn();
    SAFE_EXIT_MS = 1e3;
    motionEnabledCache = null;
    Presence = ({ show, className, children, ...opts }) => {
      const { mounted, className: animClass, onAnimationEnd } = usePresence(show, opts);
      if (!mounted) return null;
      return /* @__PURE__ */ jsx("div", { className: cn(animClass, className), onAnimationEnd, children });
    };
    Presence.displayName = "Presence";
  }
});
var Overlay;
var init_Overlay = __esm({
  "components/core/atoms/Overlay.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Presence();
    Overlay = ({
      isVisible = true,
      onClick,
      className,
      blur = false,
      action
    }) => {
      const eventBus = useEventBus();
      const { mounted, className: animClass, onAnimationEnd } = usePresence(isVisible, { animation: "overlay" });
      if (!mounted) return null;
      const handleClick = (e) => {
        if (action) {
          eventBus.emit(`UI:${action}`, {});
        }
        onClick?.(e);
      };
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "fixed inset-0 z-40",
            blur && "backdrop-blur-sm",
            animClass,
            className
          ),
          style: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
          onClick: action || onClick ? handleClick : void 0,
          onAnimationEnd,
          "aria-hidden": "true"
        }
      );
    };
  }
});
var FlipContainer;
var init_FlipContainer = __esm({
  "components/core/atoms/FlipContainer.tsx"() {
    "use client";
    init_cn();
    init_Box();
    FlipContainer = ({
      flipped,
      className,
      children,
      onClick
    }) => {
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("relative w-full cursor-pointer", className),
          style: { perspective: "1000px" },
          onClick,
          children: /* @__PURE__ */ jsx(
            Box,
            {
              className: "relative w-full h-full transition-transform duration-slow",
              style: {
                transformStyle: "preserve-3d",
                transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)"
              },
              children
            }
          )
        }
      );
    };
    FlipContainer.displayName = "FlipContainer";
  }
});
var Dialog;
var init_Dialog = __esm({
  "components/core/atoms/Dialog.tsx"() {
    init_cn();
    Dialog = React79__default.forwardRef(
      ({
        role = "dialog",
        "aria-modal": ariaModal = true,
        className,
        children,
        ...rest
      }, ref) => /* @__PURE__ */ jsx(
        "dialog",
        {
          ref,
          role,
          "aria-modal": ariaModal,
          className: cn(className),
          ...rest,
          children
        }
      )
    );
    Dialog.displayName = "Dialog";
  }
});
var Aside;
var init_Aside = __esm({
  "components/core/atoms/Aside.tsx"() {
    init_cn();
    Aside = React79__default.forwardRef(
      ({ className, children, ...rest }, ref) => /* @__PURE__ */ jsx("aside", { ref, className: cn(className), ...rest, children })
    );
    Aside.displayName = "Aside";
  }
});
function toSharedContext(ctx) {
  return createMinimalContext(
    {
      formValues: ctx.formValues,
      globalVariables: ctx.globalVariables,
      localVariables: ctx.localVariables ?? {},
      ...ctx.entity
    },
    {},
    "active"
  );
}
var ConditionalWrapper;
var init_ConditionalWrapper = __esm({
  "components/core/atoms/ConditionalWrapper.tsx"() {
    init_Box();
    ConditionalWrapper = ({
      condition,
      context,
      children,
      fallback = null,
      animate = false
    }) => {
      if (!condition) {
        return /* @__PURE__ */ jsx(Fragment, { children });
      }
      const sharedContext = toSharedContext(context);
      const result = evaluate(condition, sharedContext);
      const isVisible = Boolean(result);
      if (animate) {
        return /* @__PURE__ */ jsx(
          Box,
          {
            overflow: "hidden",
            className: `transition-all duration-fast ${isVisible ? "opacity-100 max-h-[1000px]" : "opacity-0 max-h-0"}`,
            children: isVisible ? children : fallback
          }
        );
      }
      return isVisible ? /* @__PURE__ */ jsx(Fragment, { children }) : /* @__PURE__ */ jsx(Fragment, { children: fallback });
    };
    ConditionalWrapper.displayName = "ConditionalWrapper";
  }
});
var positionStyles2, arrowStyles, LawReferenceTooltip;
var init_LawReferenceTooltip = __esm({
  "components/core/atoms/LawReferenceTooltip.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_Typography();
    init_Divider();
    init_cn();
    init_useTapReveal();
    positionStyles2 = {
      top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
      bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
      left: "right-full top-1/2 -translate-y-1/2 mr-2",
      right: "left-full top-1/2 -translate-y-1/2 ml-2"
    };
    arrowStyles = {
      top: "top-full left-1/2 -translate-x-1/2 border-t-foreground border-l-transparent border-r-transparent border-b-transparent",
      bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-foreground border-l-transparent border-r-transparent border-t-transparent",
      left: "left-full top-1/2 -translate-y-1/2 border-l-foreground border-t-transparent border-b-transparent border-r-transparent",
      right: "right-full top-1/2 -translate-y-1/2 border-r-foreground border-t-transparent border-b-transparent border-l-transparent"
    };
    LawReferenceTooltip = ({
      reference,
      children,
      position = "top",
      className
    }) => {
      const { t } = useTranslate();
      const [isVisible, setIsVisible] = React79__default.useState(false);
      const timeoutRef = React79__default.useRef(null);
      const triggerRef = React79__default.useRef(null);
      const handleMouseEnter = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setIsVisible(true), 200);
      };
      const handleMouseLeave = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setIsVisible(false);
      };
      const { revealed, triggerProps } = useTapReveal({ refs: [triggerRef] });
      const open = isVisible || revealed;
      React79__default.useEffect(() => {
        return () => {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
      }, []);
      return /* @__PURE__ */ jsxs(
        Box,
        {
          ref: triggerRef,
          as: "span",
          position: "relative",
          display: "inline-block",
          className,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onFocus: handleMouseEnter,
          onBlur: handleMouseLeave,
          onPointerDown: triggerProps.onPointerDown,
          children: [
            children,
            open && /* @__PURE__ */ jsxs(
              Box,
              {
                padding: "sm",
                rounded: "lg",
                position: "absolute",
                className: cn(
                  "z-50 w-64 bg-foreground text-background shadow-elevation-popover",
                  positionStyles2[position]
                ),
                role: "tooltip",
                children: [
                  /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                    /* @__PURE__ */ jsxs(
                      Typography,
                      {
                        variant: "label",
                        weight: "semibold",
                        className: "text-warning",
                        children: [
                          reference.law,
                          " ",
                          reference.article
                        ]
                      }
                    ),
                    reference.lawName && /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        className: "text-muted-foreground",
                        children: reference.lawName
                      }
                    ),
                    reference.clause && /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsx(Divider, { className: "border-border" }),
                      /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "caption",
                          className: "text-background leading-relaxed",
                          children: reference.clause
                        }
                      )
                    ] }),
                    reference.link && /* @__PURE__ */ jsx(
                      "a",
                      {
                        href: reference.link,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: (e) => e.stopPropagation(),
                        className: "text-xs text-info hover:text-info/80 underline cursor-pointer",
                        children: t("lawReference.viewFullText")
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      as: "span",
                      position: "absolute",
                      className: cn("w-0 h-0 border-4", arrowStyles[position])
                    }
                  )
                ]
              }
            )
          ]
        }
      );
    };
    LawReferenceTooltip.displayName = "LawReferenceTooltip";
  }
});
function DayCell({
  date,
  isToday = false,
  onClick,
  className
}) {
  const safeDate = date instanceof Date && !Number.isNaN(date.getTime()) ? date : /* @__PURE__ */ new Date();
  const handleClick = useCallback(() => {
    onClick?.(safeDate);
  }, [onClick, safeDate]);
  const dayAbbr = DAY_ABBREVIATIONS[safeDate.getDay()];
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "p-2 text-center cursor-pointer hover:bg-muted transition-colors",
        isToday && "bg-primary/10",
        className
      ),
      onClick: handleClick,
      children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "small",
            className: cn(
              "font-medium",
              isToday ? "text-primary" : "text-muted-foreground"
            ),
            children: dayAbbr
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            rounded: "full",
            className: cn(
              "h-8 w-8 mx-auto items-center justify-center",
              isToday && "bg-primary text-primary-foreground"
            ),
            children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "font-semibold", children: safeDate.getDate() })
          }
        )
      ]
    }
  );
}
var DAY_ABBREVIATIONS;
var init_DayCell = __esm({
  "components/core/atoms/DayCell.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Typography();
    DAY_ABBREVIATIONS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    DayCell.displayName = "DayCell";
  }
});
function TimeSlotCell({
  time,
  onClick,
  className,
  children,
  isOccupied = false
}) {
  const handleClick = useCallback(() => {
    onClick?.(time);
  }, [onClick, time]);
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: cn(
        "p-1 min-h-[60px] cursor-pointer hover:bg-muted transition-colors",
        isOccupied && "bg-muted/30",
        className
      ),
      onClick: handleClick,
      children
    }
  );
}
var init_TimeSlotCell = __esm({
  "components/core/atoms/TimeSlotCell.tsx"() {
    "use client";
    init_cn();
    init_Box();
    TimeSlotCell.displayName = "TimeSlotCell";
  }
});
var statusColors, pulseRingColors, sizeStyles5, StatusDot;
var init_StatusDot = __esm({
  "components/core/atoms/StatusDot.tsx"() {
    init_cn();
    statusColors = {
      online: "bg-success",
      offline: "bg-muted-foreground",
      away: "bg-warning",
      busy: "bg-error",
      warning: "bg-warning",
      critical: "bg-error"
    };
    pulseRingColors = {
      online: "ring-success",
      offline: "ring-muted-foreground",
      away: "ring-warning",
      busy: "ring-error",
      warning: "ring-warning",
      critical: "ring-error"
    };
    sizeStyles5 = {
      sm: "w-2 h-2",
      md: "w-2.5 h-2.5",
      lg: "w-3 h-3"
    };
    StatusDot = React79__default.forwardRef(
      ({ className, status = "offline", pulse = false, size = "md", label, ...props }, ref) => {
        return /* @__PURE__ */ jsx(
          "span",
          {
            ref,
            className: cn(
              "inline-block rounded-full flex-shrink-0",
              statusColors[status],
              sizeStyles5[size],
              pulse && [
                "animate-pulse",
                "ring-2 ring-offset-1",
                pulseRingColors[status],
                "ring-opacity-40"
              ],
              className
            ),
            role: "status",
            "aria-label": label ?? status,
            ...props
          }
        );
      }
    );
    StatusDot.displayName = "StatusDot";
  }
});
function resolveDirection(value, direction) {
  if (direction) return direction;
  if (value === void 0 || value === 0) return "flat";
  return value > 0 ? "up" : "down";
}
function resolveColor(dir, invert) {
  if (dir === "flat") return "text-muted-foreground";
  const isPositive = dir === "up";
  const isGood = invert ? !isPositive : isPositive;
  return isGood ? "text-success" : "text-error";
}
var sizeStyles6, iconNameMap, TrendIndicator;
var init_TrendIndicator = __esm({
  "components/core/atoms/TrendIndicator.tsx"() {
    init_Icon();
    init_cn();
    sizeStyles6 = {
      sm: { icon: "w-3 h-3", text: "text-xs" },
      md: { icon: "w-4 h-4", text: "text-sm" },
      lg: { icon: "w-5 h-5", text: "text-base" }
    };
    iconNameMap = {
      up: "trending-up",
      down: "trending-down",
      flat: "arrow-right"
    };
    TrendIndicator = React79__default.forwardRef(
      ({
        className,
        value,
        direction,
        showValue = true,
        invert = false,
        label,
        size = "md",
        ...props
      }, ref) => {
        const hasValue = typeof value === "number" && Number.isFinite(value);
        if (!hasValue && !direction) return null;
        const dir = resolveDirection(hasValue ? value : void 0, direction);
        const colorClass = resolveColor(dir, invert);
        const iconName = iconNameMap[dir];
        const styles = sizeStyles6[size];
        const formattedValue = hasValue ? `${value > 0 ? "+" : ""}${value}%` : void 0;
        const ariaLabel = label ?? (formattedValue ? `${dir} ${formattedValue}` : dir);
        return /* @__PURE__ */ jsxs(
          "span",
          {
            ref,
            className: cn(
              "inline-flex items-center gap-1 font-medium",
              colorClass,
              styles.text,
              className
            ),
            role: "status",
            "aria-label": ariaLabel,
            ...props,
            children: [
              /* @__PURE__ */ jsx(Icon, { name: iconName, className: styles.icon }),
              showValue && formattedValue && /* @__PURE__ */ jsx("span", { children: formattedValue })
            ]
          }
        );
      }
    );
    TrendIndicator.displayName = "TrendIndicator";
  }
});
function useSafeEventBus() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var trackSizes, thumbSizes, RangeSlider;
var init_RangeSlider = __esm({
  "components/core/atoms/RangeSlider.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    trackSizes = {
      sm: "h-1",
      md: "h-1.5",
      lg: "h-2"
    };
    thumbSizes = {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    };
    RangeSlider = React79__default.forwardRef(
      ({
        className,
        min = 0,
        max = 100,
        value = 0,
        step = 1,
        showTooltip = false,
        showTicks = false,
        buffered,
        size = "md",
        disabled = false,
        action,
        actionPayload,
        onChange,
        formatValue: formatValue4,
        ...props
      }, ref) => {
        const [isDragging, setIsDragging] = useState(false);
        const [showTip, setShowTip] = useState(false);
        const inputRef = useRef(null);
        const eventBus = useSafeEventBus();
        const percentage = max !== min ? (value - min) / (max - min) * 100 : 0;
        const bufferedPercentage = buffered !== void 0 ? Math.min(buffered, 100) : void 0;
        const displayValue = formatValue4 ? formatValue4(value) : String(value);
        const handleChange = useCallback(
          (e) => {
            const newValue = Number(e.target.value);
            onChange?.(newValue);
            if (action) {
              eventBus.emit(`UI:${action}`, { ...actionPayload, value: newValue });
            }
          },
          [onChange, action, actionPayload, eventBus]
        );
        const tickCount = showTicks ? Math.min(Math.floor((max - min) / step), 20) : 0;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            ref,
            className: cn(
              "relative w-full",
              disabled && "opacity-50 cursor-not-allowed",
              className
            ),
            ...props,
            children: [
              /* @__PURE__ */ jsxs("div", { className: "relative w-full py-2", children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: cn(
                      "absolute inset-x-0 rounded-full bg-muted",
                      trackSizes[size]
                    ),
                    style: { top: "50%", transform: "translateY(-50%)" }
                  }
                ),
                bufferedPercentage !== void 0 && /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: cn(
                      "absolute rounded-full bg-muted-foreground opacity-30",
                      trackSizes[size]
                    ),
                    style: {
                      top: "50%",
                      transform: "translateY(-50%)",
                      left: 0,
                      width: `${bufferedPercentage}%`
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: cn(
                      "absolute rounded-full bg-primary",
                      trackSizes[size]
                    ),
                    style: {
                      top: "50%",
                      transform: "translateY(-50%)",
                      left: 0,
                      width: `${percentage}%`
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    ref: inputRef,
                    type: "range",
                    min,
                    max,
                    step,
                    value,
                    disabled,
                    onChange: handleChange,
                    onMouseDown: () => {
                      setIsDragging(true);
                      setShowTip(true);
                    },
                    onMouseUp: () => {
                      setIsDragging(false);
                      setShowTip(false);
                    },
                    onTouchStart: () => {
                      setIsDragging(true);
                      setShowTip(true);
                    },
                    onTouchEnd: () => {
                      setIsDragging(false);
                      setShowTip(false);
                    },
                    onFocus: () => setShowTip(true),
                    onBlur: () => {
                      if (!isDragging) setShowTip(false);
                    },
                    className: cn(
                      "absolute inset-0 w-full opacity-0 cursor-pointer",
                      disabled && "cursor-not-allowed",
                      // Thumb sizing via pseudo-element
                      "[&::-webkit-slider-thumb]:appearance-none",
                      "[&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5",
                      "[&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5"
                    ),
                    style: { height: "100%", margin: 0 },
                    "aria-label": props["aria-label"] ?? "Range slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-valuetext": displayValue
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: cn(
                      "absolute rounded-full bg-primary-foreground",
                      "border-2 border-primary",
                      "shadow-sm",
                      "pointer-events-none",
                      "transition-transform duration-instant",
                      isDragging && "scale-[var(--hover-scale)]",
                      thumbSizes[size]
                    ),
                    style: {
                      top: "50%",
                      transform: `translateY(-50%) translateX(-50%)${isDragging ? " scale(var(--hover-scale))" : ""}`,
                      left: `${percentage}%`
                    }
                  }
                ),
                showTooltip && showTip && /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: cn(
                      "absolute -top-8 px-2 py-0.5 rounded",
                      "bg-foreground text-background",
                      "text-xs font-medium whitespace-nowrap",
                      "pointer-events-none"
                    ),
                    style: {
                      left: `${percentage}%`,
                      transform: "translateX(-50%)"
                    },
                    children: displayValue
                  }
                )
              ] }),
              showTicks && tickCount > 0 && /* @__PURE__ */ jsx("div", { className: "relative w-full h-2 mt-1", children: Array.from({ length: tickCount + 1 }, (_, i) => {
                const tickPercent = i / tickCount * 100;
                return /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: "absolute w-px h-1.5 bg-muted-foreground",
                    style: { left: `${tickPercent}%` }
                  },
                  i
                );
              }) })
            ]
          }
        );
      }
    );
    RangeSlider.displayName = "RangeSlider";
  }
});
function easeOut(t) {
  return t * (2 - t);
}
function formatDisplay(value, format, decimals) {
  switch (format) {
    case "currency":
      return `$${value.toFixed(2)}`;
    case "percent":
      return `${Math.round(value)}%`;
    case "number":
      return value.toLocaleString();
    default:
      return value.toFixed(decimals);
  }
}
var AnimatedCounter;
var init_AnimatedCounter = __esm({
  "components/marketing/atoms/AnimatedCounter.tsx"() {
    "use client";
    init_cn();
    init_Typography();
    AnimatedCounter = ({
      value: rawValue,
      duration = 600,
      prefix,
      suffix,
      format,
      className
    }) => {
      const numericRaw = typeof rawValue === "number" ? rawValue : Number.parseFloat(String(rawValue ?? ""));
      const value = !Number.isNaN(numericRaw) ? numericRaw : 0;
      const [displayValue, setDisplayValue] = useState(value);
      const previousValueRef = useRef(value);
      const animationFrameRef = useRef(null);
      useEffect(() => {
        const from = previousValueRef.current;
        const to = value;
        previousValueRef.current = value;
        if (from === to) {
          setDisplayValue(to);
          return;
        }
        if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
          setDisplayValue(to);
          return;
        }
        const startTime = performance.now();
        const diff = to - from;
        function animate(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = easeOut(progress);
          setDisplayValue(from + diff * easedProgress);
          if (progress < 1) {
            animationFrameRef.current = requestAnimationFrame(animate);
          } else {
            setDisplayValue(to);
          }
        }
        animationFrameRef.current = requestAnimationFrame(animate);
        return () => {
          if (animationFrameRef.current !== null) {
            cancelAnimationFrame(animationFrameRef.current);
          }
        };
      }, [value, duration]);
      const decimalPlaces = Number.isInteger(value) ? 0 : String(value).split(".")[1]?.length ?? 0;
      const formattedValue = formatDisplay(displayValue, format, decimalPlaces);
      return /* @__PURE__ */ jsxs(Typography, { variant: "h3", className: cn("tabular-nums", className), children: [
        prefix,
        formattedValue,
        suffix
      ] });
    };
    AnimatedCounter.displayName = "AnimatedCounter";
  }
});
function useInfiniteScroll(onLoadMore, options = {}) {
  const { rootMargin = "200px", hasMore = true, isLoading = false } = options;
  const observerRef = useRef(null);
  const callbackRef = useRef(onLoadMore);
  callbackRef.current = onLoadMore;
  const hasMoreRef = useRef(hasMore);
  hasMoreRef.current = hasMore;
  const isLoadingRef = useRef(isLoading);
  isLoadingRef.current = isLoading;
  useEffect(() => {
    return () => {
      observerRef.current?.disconnect();
    };
  }, []);
  const sentinelRef = useCallback((node) => {
    observerRef.current?.disconnect();
    if (!node) return;
    observerRef.current = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && hasMoreRef.current && !isLoadingRef.current) {
          callbackRef.current();
        }
      },
      { rootMargin }
    );
    observerRef.current.observe(node);
  }, [rootMargin]);
  return { sentinelRef };
}
var init_useInfiniteScroll = __esm({
  "hooks/useInfiniteScroll.ts"() {
    "use client";
  }
});
var InfiniteScrollSentinel;
var init_InfiniteScrollSentinel = __esm({
  "components/core/atoms/InfiniteScrollSentinel.tsx"() {
    "use client";
    init_cn();
    init_useInfiniteScroll();
    init_useEventBus();
    init_Box();
    init_Spinner();
    InfiniteScrollSentinel = ({
      loadMoreEvent,
      loadMorePayload,
      isLoading = false,
      hasMore = true,
      threshold = "200px",
      className
    }) => {
      const eventBus = useEventBus();
      const onLoadMore = useCallback(() => {
        eventBus.emit(`UI:${loadMoreEvent}`, loadMorePayload ?? {});
      }, [eventBus, loadMoreEvent, loadMorePayload]);
      const { sentinelRef } = useInfiniteScroll(onLoadMore, {
        rootMargin: threshold,
        hasMore,
        isLoading
      });
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: cn("flex items-center justify-center py-4", className),
          children: [
            /* @__PURE__ */ jsx(Box, { ref: sentinelRef, className: "h-1 w-full", "aria-hidden": "true" }),
            isLoading && /* @__PURE__ */ jsx(Spinner, { size: "sm" })
          ]
        }
      );
    };
    InfiniteScrollSentinel.displayName = "InfiniteScrollSentinel";
  }
});

// components/core/atoms/fx.ts
function resolveFxView(item, presets) {
  const row = presets?.find((p) => p.type === item.type);
  if (!row) return item;
  return {
    ...item,
    space: item.space ?? row.space,
    effect: item.effect ?? row.effect,
    color: item.color ?? row.color,
    size: item.size ?? row.size,
    vx: item.vx ?? row.vx,
    vy: item.vy ?? row.vy,
    vz: item.vz ?? row.vz,
    particleCount: item.particleCount ?? row.particleCount,
    animation: item.animation ?? row.animation,
    shape: row.shape,
    count: row.count,
    glow: row.glow,
    gravity: row.gravity,
    color2: row.color2
  };
}
function fxLifecycle(item, epochNowMs, tickMs) {
  const maxTtl = Math.max(item.maxTtl ?? item.ttl, item.ttl, 1);
  const lifeMs = maxTtl * tickMs;
  const ageMs = item.bornAt !== void 0 && epochNowMs > 0 ? Math.max(0, epochNowMs - item.bornAt) : (1 - item.ttl / maxTtl) * lifeMs;
  const progress = Math.min(1, Math.max(0, ageMs / lifeMs));
  return { lifeMs, ageMs, progress, fade: 1 - progress };
}
function fxHash01(seed, salt) {
  let h = 2166136261 ^ salt;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 13;
  h = Math.imul(h, 1274126177);
  h ^= h >>> 16;
  return (h >>> 0) / 4294967296;
}
function createConfettiParticles(count, seed) {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    color: CONFETTI_COLORS[Math.floor(fxHash01(seed, i * 7 + 1) * CONFETTI_COLORS.length)],
    left: 30 + fxHash01(seed, i * 7 + 2) * 40,
    delay: fxHash01(seed, i * 7 + 3) * 300,
    angle: fxHash01(seed, i * 7 + 4) * 360,
    distance: 40 + fxHash01(seed, i * 7 + 5) * 80,
    rotation: fxHash01(seed, i * 7 + 6) * 720 - 360,
    size: 4 + fxHash01(seed, i * 7 + 7) * 6
  }));
}
var CONFETTI_COLORS, CONFETTI_BURST_KEYFRAMES;
var init_fx = __esm({
  "components/core/atoms/fx.ts"() {
    CONFETTI_COLORS = [
      "var(--color-primary)",
      "var(--color-success)",
      "var(--color-warning)",
      "var(--color-error)",
      "gold",
      "dodgerblue"
    ];
    CONFETTI_BURST_KEYFRAMES = `
@keyframes confetti-burst {
  0% {
    opacity: 1;
    transform: translate(0, 0) rotate(0deg) scale(1);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(var(--confetti-tx), var(--confetti-ty)) rotate(var(--confetti-rotate)) scale(0.5);
  }
}
`;
  }
});
var ConfettiEffect;
var init_ConfettiEffect = __esm({
  "components/core/atoms/ConfettiEffect.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_fx();
    ConfettiEffect = ({
      trigger,
      duration = 2e3,
      particleCount = 30,
      className
    }) => {
      const [particles, setParticles] = useState([]);
      const previousTriggerRef = useRef(false);
      const burstRef = useRef(0);
      useEffect(() => {
        const wasFalse = !previousTriggerRef.current;
        previousTriggerRef.current = trigger;
        if (trigger && wasFalse) {
          burstRef.current += 1;
          const newParticles = createConfettiParticles(particleCount, `confetti-${burstRef.current}`);
          setParticles(newParticles);
          const timer = window.setTimeout(() => {
            setParticles([]);
          }, duration);
          return () => {
            window.clearTimeout(timer);
          };
        }
        return void 0;
      }, [trigger, particleCount, duration]);
      if (particles.length === 0) {
        return null;
      }
      return /* @__PURE__ */ jsxs(
        Box,
        {
          position: "absolute",
          className: cn(
            "inset-0 pointer-events-none overflow-hidden z-50",
            className
          ),
          "aria-hidden": "true",
          children: [
            particles.map((p) => {
              const rad = p.angle * Math.PI / 180;
              const tx = Math.cos(rad) * p.distance;
              const ty = Math.sin(rad) * p.distance - 20;
              return /* @__PURE__ */ jsx(
                Box,
                {
                  className: "absolute rounded-sm",
                  style: {
                    left: `${p.left}%`,
                    top: "50%",
                    width: p.size,
                    height: p.size,
                    backgroundColor: p.color,
                    animation: `confetti-burst ${duration - p.delay}ms ease-out ${p.delay}ms forwards`,
                    opacity: 0,
                    "--confetti-tx": `${tx}px`,
                    "--confetti-ty": `${ty}px`,
                    "--confetti-rotate": `${p.rotation}deg`
                  }
                },
                p.id
              );
            }),
            /* @__PURE__ */ jsx("style", { children: CONFETTI_BURST_KEYFRAMES })
          ]
        }
      );
    };
    ConfettiEffect.displayName = "ConfettiEffect";
  }
});
var TypewriterText;
var init_TypewriterText = __esm({
  "components/core/atoms/TypewriterText.tsx"() {
    "use client";
    init_cn();
    init_Typography();
    TypewriterText = ({
      text,
      speed = 40,
      startDelay = 0,
      className,
      onComplete
    }) => {
      const safeText = typeof text === "string" ? text : String(text ?? "");
      const [charCount, setCharCount] = useState(0);
      const [started, setStarted] = useState(startDelay === 0);
      const onCompleteRef = useRef(onComplete);
      onCompleteRef.current = onComplete;
      useEffect(() => {
        if (startDelay <= 0) {
          setStarted(true);
          return void 0;
        }
        setStarted(false);
        setCharCount(0);
        const delayTimer = window.setTimeout(() => {
          setStarted(true);
        }, startDelay);
        return () => {
          window.clearTimeout(delayTimer);
        };
      }, [startDelay, text]);
      useEffect(() => {
        setCharCount(0);
      }, [text]);
      useEffect(() => {
        if (!started) return void 0;
        if (charCount >= safeText.length) {
          onCompleteRef.current?.();
          return void 0;
        }
        const interval = window.setInterval(() => {
          setCharCount((prev) => {
            const next = prev + 1;
            if (next >= safeText.length) {
              window.clearInterval(interval);
            }
            return next;
          });
        }, speed);
        return () => {
          window.clearInterval(interval);
        };
      }, [started, text, speed, charCount]);
      const isComplete = charCount >= safeText.length;
      const displayedText = safeText.slice(0, charCount);
      return /* @__PURE__ */ jsxs(Typography, { variant: "body", className: cn("inline", className), children: [
        displayedText,
        !isComplete && /* @__PURE__ */ jsx(
          "span",
          {
            className: "inline-block w-[2px] h-[1em] bg-foreground ml-[1px] align-text-bottom animate-pulse",
            "aria-hidden": "true"
          }
        )
      ] });
    };
    TypewriterText.displayName = "TypewriterText";
  }
});
var levelToVariant, alignClasses, alignToStack, SectionHeader;
var init_SectionHeader = __esm({
  "components/core/atoms/SectionHeader.tsx"() {
    init_cn();
    init_Stack();
    init_Typography();
    levelToVariant = {
      1: "h1",
      2: "h2",
      3: "h3"
    };
    alignClasses = {
      center: "text-center",
      left: "text-left",
      right: "text-right"
    };
    alignToStack = {
      center: "center",
      left: "start",
      right: "end"
    };
    SectionHeader = ({ title, subtitle, align = "center", level = 2, className }) => {
      const variant = levelToVariant[level];
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "sm",
          align: alignToStack[align],
          className: cn(alignClasses[align], className),
          children: [
            /* @__PURE__ */ jsx(Typography, { variant, weight: "bold", children: title }),
            subtitle ? /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: subtitle }) : null
          ]
        }
      );
    };
    SectionHeader.displayName = "SectionHeader";
  }
});
var sizeClasses5, MarketingStatCard;
var init_MarketingStatCard = __esm({
  "components/marketing/atoms/MarketingStatCard.tsx"() {
    init_cn();
    init_Stack();
    init_Typography();
    sizeClasses5 = {
      sm: "text-2xl",
      md: "text-4xl",
      lg: "text-5xl"
    };
    MarketingStatCard = ({ value, label, size = "md", className }) => {
      return /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "center", className: cn(className), children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            weight: "bold",
            color: "primary",
            className: cn(sizeClasses5[size]),
            children: value
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: label })
      ] });
    };
    MarketingStatCard.displayName = "MarketingStatCard";
  }
});
var backgroundClasses, paddingClasses, ContentSection;
var init_ContentSection = __esm({
  "components/marketing/atoms/ContentSection.tsx"() {
    init_cn();
    init_Box();
    backgroundClasses = {
      default: "",
      alt: "bg-surface",
      dark: "bg-foreground text-background",
      gradient: [
        "bg-gradient-to-b",
        "from-[var(--color-primary)]/5",
        "to-[var(--color-secondary)]/5"
      ].join(" ")
    };
    paddingClasses = {
      sm: "py-12",
      md: "py-16",
      lg: "py-24"
    };
    ContentSection = React79__default.forwardRef(
      ({ children, background = "default", padding = "lg", id, className }, ref) => {
        return /* @__PURE__ */ jsx(
          Box,
          {
            ref,
            as: "section",
            id,
            className: cn(
              backgroundClasses[background],
              paddingClasses[padding],
              className
            ),
            children: /* @__PURE__ */ jsx(Box, { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children })
          }
        );
      }
    );
    ContentSection.displayName = "ContentSection";
  }
});
function lineIntersection(x1, y1, x2, y2, x3, y3, x4, y4) {
  const denom = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
  if (Math.abs(denom) < 1e-10) return [(x1 + x3) / 2, (y1 + y3) / 2];
  const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denom;
  return [x1 + t * (x2 - x1), y1 + t * (y2 - y1)];
}
function f(n) {
  return n.toFixed(3);
}
function picStar(cx, cy, R, n, theta, extent) {
  const verts = [];
  for (let k = 0; k < n; k++) {
    const angle = PI / n + k * (2 * PI) / n;
    verts.push([cx + R * Math.cos(angle), cy + R * Math.sin(angle)]);
  }
  const mids = [];
  for (let k = 0; k < n; k++) {
    const next = (k + 1) % n;
    mids.push([(verts[k][0] + verts[next][0]) / 2, (verts[k][1] + verts[next][1]) / 2]);
  }
  const innerPts = [];
  for (let k = 0; k < n; k++) {
    const next = (k + 1) % n;
    const M1 = mids[k];
    const M2 = mids[next];
    const edx1 = verts[(k + 1) % n][0] - verts[k][0];
    const edy1 = verts[(k + 1) % n][1] - verts[k][1];
    const elen1 = Math.sqrt(edx1 * edx1 + edy1 * edy1);
    const tx1 = edx1 / elen1;
    const ty1 = edy1 / elen1;
    const r1x = tx1 * Math.cos(theta) + ty1 * Math.sin(theta);
    const r1y = -tx1 * Math.sin(theta) + ty1 * Math.cos(theta);
    const edx2 = verts[(next + 1) % n][0] - verts[next][0];
    const edy2 = verts[(next + 1) % n][1] - verts[next][1];
    const elen2 = Math.sqrt(edx2 * edx2 + edy2 * edy2);
    const tx2 = edx2 / elen2;
    const ty2 = edy2 / elen2;
    const bTheta = PI - theta;
    const r2x = tx2 * Math.cos(bTheta) + ty2 * Math.sin(bTheta);
    const r2y = -tx2 * Math.sin(bTheta) + ty2 * Math.cos(bTheta);
    const P = lineIntersection(
      M1[0],
      M1[1],
      M1[0] + r1x * extent,
      M1[1] + r1y * extent,
      M2[0],
      M2[1],
      M2[0] + r2x * extent,
      M2[1] + r2y * extent
    );
    innerPts.push(P);
  }
  const starPath = mids.map((m, k) => {
    const inner = innerPts[k];
    const nextMid = mids[(k + 1) % n];
    return `M ${f(m[0])},${f(m[1])} L ${f(inner[0])},${f(inner[1])} L ${f(nextMid[0])},${f(nextMid[1])}`;
  }).join(" ");
  return { starPath, mids, verts };
}
function Star8({ size, color, strokeWidth }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const R = a / (2 * Math.sin(PI / 8));
  const theta = 67.5 * PI / 180;
  const { starPath, mids } = picStar(cx, cy, R, 8, theta, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = mids[dists[0].i];
    const m2 = mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Star6({ size, color, strokeWidth }) {
  const w = size;
  const h = size * (2 / Math.sqrt(3));
  const cx = w / 2;
  const cy = h / 2;
  const a = w / Math.sqrt(3);
  const R = a;
  const theta = 60 * PI / 180;
  const { starPath, mids, verts } = picStar(cx, cy, R, 6, theta, w);
  const triPaths = [];
  for (let k = 0; k < 6; k++) {
    const v = verts[k];
    const m1 = mids[(k + 5) % 6];
    const m2 = mids[k];
    triPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    triPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Khatam({ size, color, strokeWidth }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const R = a / (2 * Math.sin(PI / 8));
  const theta = 72 * PI / 180;
  const { starPath, mids } = picStar(cx, cy, R, 8, theta, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = mids[dists[0].i];
    const m2 = mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  const orbitR = R * 0.35;
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)),
    /* @__PURE__ */ jsx("circle", { cx, cy, r: orbitR, opacity: "0.4" })
  ] });
}
function RosetteDouble({ size, color, strokeWidth }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const Router = a / (2 * Math.sin(PI / 8));
  const Rinner = Router * 0.45;
  const outer = picStar(cx, cy, Router, 8, 72 * PI / 180, s);
  const inner = picStar(cx, cy, Rinner, 8, 68 * PI / 180, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = outer.mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = outer.mids[dists[0].i];
    const m2 = outer.mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  const connectors = [];
  for (let k = 0; k < 8; k++) {
    const om = outer.mids[k];
    const im = inner.mids[k];
    connectors.push(`M ${f(im[0])},${f(im[1])} L ${f(om[0])},${f(om[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: outer.starPath }),
    /* @__PURE__ */ jsx("path", { d: inner.starPath, opacity: "0.7" }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, `c${i}`)),
    connectors.map((d, i) => /* @__PURE__ */ jsx("path", { d, opacity: "0.4" }, `n${i}`))
  ] });
}
function RosetteFilled({ size, color, strokeWidth }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const Router = a / (2 * Math.sin(PI / 8));
  const theta = 72 * PI / 180;
  const outer = picStar(cx, cy, Router, 8, theta, s);
  const Rinner = Router * 0.35;
  const inner6 = picStar(cx, cy, Rinner, 6, 60 * PI / 180, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = outer.mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = outer.mids[dists[0].i];
    const m2 = outer.mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  const triPaths = [];
  for (let k = 0; k < 6; k++) {
    const v = inner6.verts[k];
    const m1 = inner6.mids[(k + 5) % 6];
    const m2 = inner6.mids[k];
    triPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  const orbitR = Router * 0.35;
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: outer.starPath }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, `c${i}`)),
    /* @__PURE__ */ jsx("circle", { cx, cy, r: orbitR, opacity: "0.3" }),
    /* @__PURE__ */ jsx("path", { d: inner6.starPath, opacity: "0.6" }),
    triPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d, opacity: "0.5" }, `t${i}`))
  ] });
}
function Star10({ size, color, strokeWidth }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const R = s * 0.42;
  const theta = 72 * PI / 180;
  const { starPath, mids, verts } = picStar(cx, cy, R, 10, theta, s);
  const edgePaths = [];
  for (let k = 0; k < 10; k++) {
    const v = verts[k];
    const m1 = mids[(k + 9) % 10];
    const m2 = mids[k];
    edgePaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    edgePaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Star12({ size, color, strokeWidth }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const R = s * 0.44;
  const theta = 75 * PI / 180;
  const { starPath, mids, verts } = picStar(cx, cy, R, 12, theta, s);
  const triPaths = [];
  for (let k = 0; k < 12; k++) {
    const v = verts[k];
    const m1 = mids[(k + 11) % 12];
    const m2 = mids[k];
    triPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    triPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Seigaiha({ size, color, strokeWidth }) {
  const s = size;
  const r = s / 2;
  const paths = [];
  const centers = [
    [s / 2, s * 0.6],
    [0, s * 0.1],
    [s, s * 0.1]
  ];
  for (const [cx, cy] of centers) {
    for (let ring = 1; ring <= 3; ring++) {
      const cr = r * (ring / 3);
      paths.push(
        `M ${f(cx - cr)},${f(cy)} A ${f(cr)} ${f(cr)} 0 0 1 ${f(cx + cr)},${f(cy)}`
      );
    }
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function GreekKey({ size, color, strokeWidth }) {
  const s = size;
  const u = s / 4;
  const paths = [
    // Outer frame
    `M 0,0 L ${f(s)},0`,
    `M 0,${f(s)} L ${f(s)},${f(s)}`,
    // Spiral from left
    `M 0,${f(u)} L ${f(3 * u)},${f(u)} L ${f(3 * u)},${f(3 * u)} L ${f(u)},${f(3 * u)} L ${f(u)},${f(2 * u)} L ${f(2 * u)},${f(2 * u)}`,
    // Spiral from right (mirrored, offset)
    `M ${f(s)},${f(3 * u)} L ${f(s - 3 * u)},${f(3 * u)} L ${f(s - 3 * u)},${f(u)} L ${f(s - u)},${f(u)} L ${f(s - u)},${f(2 * u)} L ${f(s - 2 * u)},${f(2 * u)}`,
    // Vertical connectors at edges
    `M 0,0 L 0,${f(u)}`,
    `M ${f(s)},0 L ${f(s)},${f(u)}`,
    `M 0,${f(3 * u)} L 0,${f(s)}`,
    `M ${f(s)},${f(3 * u)} L ${f(s)},${f(s)}`
  ];
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function CelticKnot({ size, color, strokeWidth }) {
  const s = size;
  const q = s / 4;
  const r = q * 0.9;
  const paths = [
    // Band 1: diagonal with curves at crossings
    `M 0,0 Q ${f(q)},${f(q)} ${f(2 * q)},${f(2 * q)}`,
    `M ${f(2 * q)},${f(2 * q)} Q ${f(3 * q)},${f(3 * q)} ${f(s)},${f(s)}`,
    // Band 2: other diagonal
    `M ${f(s)},0 Q ${f(3 * q)},${f(q)} ${f(2 * q)},${f(2 * q)}`,
    `M ${f(2 * q)},${f(2 * q)} Q ${f(q)},${f(3 * q)} 0,${f(s)}`,
    // Outer loops that connect bands at tile edges for continuous weave
    `M 0,0 Q ${f(-q * 0.3)},${f(2 * q)} 0,${f(s)}`,
    `M ${f(s)},0 Q ${f(s + q * 0.3)},${f(2 * q)} ${f(s)},${f(s)}`,
    `M 0,0 Q ${f(2 * q)},${f(-q * 0.3)} ${f(s)},0`,
    `M 0,${f(s)} Q ${f(2 * q)},${f(s + q * 0.3)} ${f(s)},${f(s)}`,
    // Inner circle at crossing
    `M ${f(2 * q + r * 0.3)},${f(2 * q)} A ${f(r * 0.3)} ${f(r * 0.3)} 0 1 1 ${f(2 * q + r * 0.3)},${f(2 * q + 1e-3)}`
  ];
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function Kolam({ size, color, strokeWidth }) {
  const s = size;
  const u = s / 4;
  const dotR = s * 0.015;
  const dots = [];
  for (let row = 1; row <= 3; row++) {
    for (let col = 1; col <= 3; col++) {
      dots.push([col * u, row * u]);
    }
  }
  const curves = [];
  for (let row = 1; row <= 3; row++) {
    const y = row * u;
    for (let col = 1; col < 3; col++) {
      const x1 = col * u;
      const x2 = (col + 1) * u;
      const mx = (x1 + x2) / 2;
      const bulge = u * 0.4;
      curves.push(`M ${f(x1)},${f(y)} C ${f(mx)},${f(y - bulge)} ${f(mx)},${f(y - bulge)} ${f(x2)},${f(y)}`);
      curves.push(`M ${f(x1)},${f(y)} C ${f(mx)},${f(y + bulge)} ${f(mx)},${f(y + bulge)} ${f(x2)},${f(y)}`);
    }
  }
  for (let col = 1; col <= 3; col++) {
    const x = col * u;
    for (let row = 1; row < 3; row++) {
      const y1 = row * u;
      const y2 = (row + 1) * u;
      const my = (y1 + y2) / 2;
      const bulge = u * 0.4;
      curves.push(`M ${f(x)},${f(y1)} C ${f(x - bulge)},${f(my)} ${f(x - bulge)},${f(my)} ${f(x)},${f(y2)}`);
      curves.push(`M ${f(x)},${f(y1)} C ${f(x + bulge)},${f(my)} ${f(x + bulge)},${f(my)} ${f(x)},${f(y2)}`);
    }
  }
  for (let k = 1; k <= 3; k++) {
    curves.push(`M ${f(k * u)},${f(u)} C ${f(k * u)},${f(u * 0.5)} ${f(k * u)},${f(u * 0.5)} ${f(k * u)},0`);
    curves.push(`M ${f(k * u)},${f(3 * u)} C ${f(k * u)},${f(3.5 * u)} ${f(k * u)},${f(3.5 * u)} ${f(k * u)},${f(s)}`);
    curves.push(`M ${f(u)},${f(k * u)} C ${f(u * 0.5)},${f(k * u)} ${f(u * 0.5)},${f(k * u)} 0,${f(k * u)}`);
    curves.push(`M ${f(3 * u)},${f(k * u)} C ${f(3.5 * u)},${f(k * u)} ${f(3.5 * u)},${f(k * u)} ${f(s)},${f(k * u)}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    curves.map((d, i) => /* @__PURE__ */ jsx("path", { d }, `c${i}`)),
    dots.map(([x, y], i) => /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: dotR, fill: color, opacity: "0.5" }, `d${i}`))
  ] });
}
function Arch({ size, color, strokeWidth }) {
  const w = size;
  const h = size * 1.5;
  const cx = w / 2;
  const paths = [];
  for (let ring = 0; ring < 4; ring++) {
    const scale = 1 - ring * 0.2;
    const archW = w * 0.48 * scale;
    const archH = h * 0.7 * scale;
    const baseY = h * 0.85;
    const tipY = baseY - archH;
    const lx = cx - archW;
    const rx = cx + archW;
    const offset = archW * 0.3;
    const lcx = lx + offset;
    const rdx = cx - lcx;
    const rdy = baseY - tipY;
    const radius = Math.sqrt(rdx * rdx + rdy * rdy);
    paths.push(
      `M ${f(lx)},${f(baseY)} A ${f(radius)} ${f(radius)} 0 0 1 ${f(cx)},${f(tipY)} A ${f(radius)} ${f(radius)} 0 0 1 ${f(rx)},${f(baseY)}`
    );
    if (ring === 0) {
      paths.push(`M ${f(lx)},${f(baseY)} L ${f(rx)},${f(baseY)}`);
    }
  }
  const innerScale = 1 - 3 * 0.2;
  const keyR = w * 0.48 * innerScale * 0.35;
  const keyY = h * 0.85 - h * 0.7 * innerScale * 0.4;
  paths.push(
    `M ${f(cx + keyR)},${f(keyY)} A ${f(keyR)} ${f(keyR)} 0 1 1 ${f(cx + keyR)},${f(keyY + 1e-3)}`
  );
  const spR = w * 0.15;
  paths.push(`M 0,0 A ${f(spR)} ${f(spR)} 0 0 0 ${f(spR)},${f(spR)}`);
  paths.push(`M ${f(w)},0 A ${f(spR)} ${f(spR)} 0 0 1 ${f(w - spR)},${f(spR)}`);
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function ArabesqueVine({ size, color, strokeWidth }) {
  const w = size;
  const h = size * 1.2;
  const cx = w / 2;
  const paths = [];
  const amp = w * 0.3;
  const segments = 3;
  const segH = h / segments;
  for (let i = 0; i < segments; i++) {
    const y0 = i * segH;
    const y1 = y0 + segH;
    const dir = i % 2 === 0 ? 1 : -1;
    paths.push(
      `M ${f(cx)},${f(y0)} C ${f(cx + amp * dir)},${f(y0 + segH * 0.33)} ${f(cx - amp * dir)},${f(y0 + segH * 0.66)} ${f(cx)},${f(y1)}`
    );
    const branchY = y0 + segH * 0.5;
    const branchX = cx + amp * dir * 0.15;
    const tendrilLen = w * 0.25;
    const tlx = branchX - tendrilLen;
    const tly = branchY - tendrilLen * 0.4;
    paths.push(
      `M ${f(branchX)},${f(branchY)} C ${f(branchX - tendrilLen * 0.5)},${f(branchY - tendrilLen * 0.8)} ${f(tlx - tendrilLen * 0.2)},${f(tly + tendrilLen * 0.3)} ${f(tlx)},${f(tly)}`
    );
    paths.push(
      `M ${f(tlx)},${f(tly)} C ${f(tlx + tendrilLen * 0.3)},${f(tly + tendrilLen * 0.5)} ${f(branchX - tendrilLen * 0.2)},${f(branchY + tendrilLen * 0.3)} ${f(branchX)},${f(branchY)}`
    );
    const trx = branchX + tendrilLen;
    const try_ = branchY + tendrilLen * 0.4;
    paths.push(
      `M ${f(branchX)},${f(branchY)} C ${f(branchX + tendrilLen * 0.5)},${f(branchY + tendrilLen * 0.8)} ${f(trx + tendrilLen * 0.2)},${f(try_ - tendrilLen * 0.3)} ${f(trx)},${f(try_)}`
    );
    paths.push(
      `M ${f(trx)},${f(try_)} C ${f(trx - tendrilLen * 0.3)},${f(try_ - tendrilLen * 0.5)} ${f(branchX + tendrilLen * 0.2)},${f(branchY - tendrilLen * 0.3)} ${f(branchX)},${f(branchY)}`
    );
    const spiralR = tendrilLen * 0.15;
    paths.push(
      `M ${f(tlx)},${f(tly)} A ${f(spiralR)} ${f(spiralR)} 0 1 0 ${f(tlx + spiralR * 2)},${f(tly)}`
    );
    paths.push(
      `M ${f(trx)},${f(try_)} A ${f(spiralR)} ${f(spiralR)} 0 1 1 ${f(trx - spiralR * 2)},${f(try_)}`
    );
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function ArabesqueNet({ size, color, strokeWidth }) {
  const s = size;
  const cells = 4;
  const cellW = s / cells;
  const cellH = s / cells;
  const paths = [];
  for (let row = 0; row < cells; row++) {
    for (let col = 0; col < cells; col++) {
      const cx = col * cellW + cellW / 2;
      const cy = row * cellH + cellH / 2;
      const hw = cellW * 0.5;
      const hh = cellH * 0.5;
      const bulge = cellW * 0.25;
      paths.push(
        `M ${f(cx)},${f(cy - hh)} Q ${f(cx + bulge)},${f(cy - bulge)} ${f(cx + hw)},${f(cy)}`
      );
      paths.push(
        `M ${f(cx + hw)},${f(cy)} Q ${f(cx + bulge)},${f(cy + bulge)} ${f(cx)},${f(cy + hh)}`
      );
      paths.push(
        `M ${f(cx)},${f(cy + hh)} Q ${f(cx - bulge)},${f(cy + bulge)} ${f(cx - hw)},${f(cy)}`
      );
      paths.push(
        `M ${f(cx - hw)},${f(cy)} Q ${f(cx - bulge)},${f(cy - bulge)} ${f(cx)},${f(cy - hh)}`
      );
    }
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function getTileDimensions(variant, size) {
  if (variant === "star6") {
    return { width: size, height: size * (2 / Math.sqrt(3)) };
  }
  if (variant === "arch") {
    return { width: size, height: size * 1.5 };
  }
  if (variant === "arabesque-vine") {
    return { width: size, height: size * 1.2 };
  }
  return { width: size, height: size };
}
var PI, VARIANT_MAP, PatternTile;
var init_PatternTile = __esm({
  "components/marketing/atoms/PatternTile.tsx"() {
    "use client";
    PI = Math.PI;
    VARIANT_MAP = {
      "star8": Star8,
      "star6": Star6,
      "khatam": Khatam,
      "star10": Star10,
      "star12": Star12,
      "rosette-double": RosetteDouble,
      "rosette-filled": RosetteFilled,
      "seigaiha": Seigaiha,
      "greek-key": GreekKey,
      "celtic-knot": CelticKnot,
      "kolam": Kolam,
      "arch": Arch,
      "arabesque-vine": ArabesqueVine,
      "arabesque-net": ArabesqueNet
    };
    PatternTile = ({
      variant = "star8",
      size = 60,
      color = "var(--color-primary)",
      strokeWidth = 0.5,
      className
    }) => {
      const Variant = VARIANT_MAP[variant];
      return /* @__PURE__ */ jsx("g", { className, children: /* @__PURE__ */ jsx(Variant, { size, color, strokeWidth }) });
    };
    PatternTile.displayName = "PatternTile";
  }
});
var initialStyles, animatedStyles, AnimatedReveal;
var init_AnimatedReveal = __esm({
  "components/marketing/atoms/AnimatedReveal.tsx"() {
    "use client";
    init_cn();
    initialStyles = {
      "fade-up": { opacity: 0, transform: "translateY(24px)" },
      "fade-down": { opacity: 0, transform: "translateY(-24px)" },
      "fade-in": { opacity: 0 },
      "fade-left": { opacity: 0, transform: "translateX(24px)" },
      "fade-right": { opacity: 0, transform: "translateX(-24px)" },
      "scale": { opacity: 0, transform: "scale(0.92)" },
      "scale-up": { opacity: 0, transform: "scale(0.92) translateY(16px)" },
      "none": {}
    };
    animatedStyles = {
      "fade-up": { opacity: 1, transform: "translateY(0)" },
      "fade-down": { opacity: 1, transform: "translateY(0)" },
      "fade-in": { opacity: 1 },
      "fade-left": { opacity: 1, transform: "translateX(0)" },
      "fade-right": { opacity: 1, transform: "translateX(0)" },
      "scale": { opacity: 1, transform: "scale(1)" },
      "scale-up": { opacity: 1, transform: "scale(1) translateY(0)" },
      "none": {}
    };
    AnimatedReveal = React79__default.forwardRef(
      ({
        trigger = "scroll",
        animation = "fade-up",
        duration = 600,
        delay = 0,
        threshold = 0.15,
        once = true,
        animate: manualAnimate,
        easing = "cubic-bezier(0.16, 1, 0.3, 1)",
        children,
        className,
        style,
        ...props
      }, forwardedRef) => {
        const [isAnimated, setIsAnimated] = useState(false);
        const internalRef = useRef(null);
        const hasAnimated = useRef(false);
        const setRef = useCallback(
          (node) => {
            internalRef.current = node;
            if (typeof forwardedRef === "function") forwardedRef(node);
            else if (forwardedRef) forwardedRef.current = node;
          },
          [forwardedRef]
        );
        useEffect(() => {
          if (trigger !== "scroll") return;
          const el = internalRef.current;
          if (!el) return;
          const observer2 = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                if (once && hasAnimated.current) return;
                hasAnimated.current = true;
                setIsAnimated(true);
              } else if (!once) {
                setIsAnimated(false);
              }
            },
            { threshold }
          );
          observer2.observe(el);
          return () => observer2.disconnect();
        }, [trigger, threshold, once]);
        const handleMouseEnter = trigger === "hover" ? () => setIsAnimated(true) : void 0;
        const handleMouseLeave = trigger === "hover" ? () => {
          if (!once || !hasAnimated.current) {
            hasAnimated.current = true;
            setIsAnimated(false);
          }
        } : void 0;
        useEffect(() => {
          if (trigger === "manual" && manualAnimate !== void 0) {
            setIsAnimated(manualAnimate);
          }
        }, [trigger, manualAnimate]);
        const active = isAnimated;
        const currentStyle = active ? animatedStyles[animation] : initialStyles[animation];
        return /* @__PURE__ */ jsx(
          "div",
          {
            ref: setRef,
            className: cn("will-change-[opacity,transform]", className),
            style: {
              ...currentStyle,
              transitionProperty: "opacity, transform",
              transitionDuration: `${duration}ms`,
              transitionDelay: `${delay}ms`,
              transitionTimingFunction: easing,
              ...style
            },
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            ...props,
            children: typeof children === "function" ? children(active) : children
          }
        );
      }
    );
    AnimatedReveal.displayName = "AnimatedReveal";
  }
});
function useFetchedSvg(src) {
  const [svg, setSvg] = useState(null);
  const cache2 = useRef({});
  useEffect(() => {
    if (!src) {
      setSvg(null);
      return;
    }
    if (cache2.current[src]) {
      setSvg(cache2.current[src]);
      return;
    }
    let cancelled = false;
    fetch(src).then((res) => {
      if (!res.ok) throw new Error(`Failed to fetch SVG: ${res.status}`);
      return res.text();
    }).then((text) => {
      if (cancelled) return;
      cache2.current[src] = text;
      setSvg(text);
    }).catch(() => {
      if (!cancelled) setSvg(null);
    });
    return () => {
      cancelled = true;
    };
  }, [src]);
  return svg;
}
function applyDrawAnimation(container, animate, duration, delay, easing) {
  const paths = container.querySelectorAll("path, line, polyline, polygon, circle, ellipse, rect");
  paths.forEach((el) => {
    if ("getTotalLength" in el && typeof el.getTotalLength === "function") {
      const len = el.getTotalLength();
      el.style.strokeDasharray = `${len}`;
      el.style.strokeDashoffset = animate ? "0" : `${len}`;
      el.style.transition = `stroke-dashoffset ${duration}ms ${easing} ${delay}ms`;
    }
  });
}
function applyFillAnimation(container, animate, duration, delay, easing, fillColor) {
  const paths = container.querySelectorAll("path, circle, ellipse, rect, polygon");
  paths.forEach((el) => {
    if ("getTotalLength" in el && typeof el.getTotalLength === "function") {
      const geom = el;
      const len = geom.getTotalLength();
      geom.style.strokeDasharray = `${len}`;
      geom.style.strokeDashoffset = animate ? "0" : `${len}`;
      geom.style.transition = `stroke-dashoffset ${duration * 0.6}ms ${easing} ${delay}ms, fill-opacity ${duration * 0.4}ms ${easing} ${delay + duration * 0.6}ms`;
    }
    if (fillColor) el.style.fill = fillColor;
    el.style.fillOpacity = animate ? "1" : "0";
  });
}
function applyPulseAnimation(container, animate, duration) {
  const svg = container.querySelector("svg");
  if (!svg) return;
  if (animate) {
    svg.style.animation = `ag-pulse ${duration}ms ease-in-out infinite`;
  } else {
    svg.style.animation = "none";
  }
}
function applyMorphAnimation(container, animate, duration, delay, easing) {
  const paths = container.querySelectorAll("path, circle, ellipse, rect, polygon");
  paths.forEach((el) => {
    el.style.transition = `all ${duration}ms ${easing} ${delay}ms`;
    el.style.transform = animate ? "scale(1)" : "scale(0)";
    el.style.transformOrigin = "center";
    el.style.opacity = animate ? "1" : "0";
  });
}
var AnimatedGraphic;
var init_AnimatedGraphic = __esm({
  "components/marketing/atoms/AnimatedGraphic.tsx"() {
    "use client";
    init_cn();
    AnimatedGraphic = React79__default.forwardRef(
      ({
        src,
        svgContent,
        animation = "draw",
        animate = false,
        duration = 1200,
        delay = 0,
        easing = "cubic-bezier(0.16, 1, 0.3, 1)",
        width,
        height,
        strokeColor,
        fillColor,
        alt,
        className,
        style,
        children,
        ...props
      }, ref) => {
        const containerRef = useRef(null);
        const fetchedSvg = useFetchedSvg(svgContent ? void 0 : src);
        const resolvedSvg = svgContent ?? fetchedSvg;
        const prevAnimateRef = useRef(animate);
        const setRef = React79__default.useCallback(
          (node) => {
            containerRef.current = node;
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
          },
          [ref]
        );
        useEffect(() => {
          const el = containerRef.current;
          if (!el || !strokeColor) return;
          const paths = el.querySelectorAll("path, line, polyline, polygon, circle, ellipse, rect");
          paths.forEach((p) => {
            p.style.stroke = strokeColor;
          });
        }, [resolvedSvg, strokeColor]);
        useEffect(() => {
          const el = containerRef.current;
          if (!el || !resolvedSvg) return;
          if (animation === "draw" || animation === "fill") {
            const paths = el.querySelectorAll("path, line, polyline, polygon, circle, ellipse, rect");
            paths.forEach((p) => {
              if ("getTotalLength" in p && typeof p.getTotalLength === "function") {
                const len = p.getTotalLength();
                p.style.strokeDasharray = `${len}`;
                p.style.strokeDashoffset = `${len}`;
              }
              if (animation === "fill") {
                p.style.fillOpacity = "0";
              }
            });
          }
          if (animation === "morph") {
            const paths = el.querySelectorAll("path, circle, ellipse, rect, polygon");
            paths.forEach((p) => {
              p.style.transform = "scale(0)";
              p.style.transformOrigin = "center";
              p.style.opacity = "0";
            });
          }
        }, [resolvedSvg, animation]);
        useEffect(() => {
          const el = containerRef.current;
          if (!el) return;
          const id = requestAnimationFrame(() => {
            switch (animation) {
              case "draw":
                applyDrawAnimation(el, animate, duration, delay, easing);
                break;
              case "fill":
                applyFillAnimation(el, animate, duration, delay, easing, fillColor);
                break;
              case "pulse":
                applyPulseAnimation(el, animate, duration);
                break;
              case "morph":
                applyMorphAnimation(el, animate, duration, delay, easing);
                break;
            }
          });
          prevAnimateRef.current = animate;
          return () => cancelAnimationFrame(id);
        }, [animate, animation, duration, delay, easing, fillColor, resolvedSvg]);
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("style", { children: `@keyframes ag-pulse { 0%, 100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.04); opacity: 0.85; } }` }),
          /* @__PURE__ */ jsx(
            "div",
            {
              ref: setRef,
              className: cn("inline-flex items-center justify-center", className),
              style: { width, height, ...style },
              role: alt ? "img" : void 0,
              "aria-label": alt,
              ...props,
              children: resolvedSvg ? /* @__PURE__ */ jsx(
                "div",
                {
                  className: "w-full h-full [&>svg]:w-full [&>svg]:h-full",
                  dangerouslySetInnerHTML: { __html: resolvedSvg }
                }
              ) : children
            }
          )
        ] });
      }
    );
    AnimatedGraphic.displayName = "AnimatedGraphic";
  }
});
function resolveMarkerExpression(expression, entity, config, state) {
  const ctx = createContextFromBindings({
    entity,
    payload: {},
    state,
    ...config !== void 0 ? { config } : {}
  });
  return interpolateValue(expression, ctx);
}
function isPlainObject(value) {
  if (value === null || value === void 0 || typeof value !== "object") return false;
  if (Array.isArray(value)) return false;
  if (React79__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  if (typeof value === "function") return false;
  return true;
}
function isEvaluatorResolvedData(value) {
  return evaluatorResolvedData.has(value);
}
function brandResolved(value) {
  if (value !== null && typeof value === "object" && !React79__default.isValidElement(value) && !(value instanceof Date)) {
    resolvedMarkerFree.add(value);
  }
}
function subtreeHasMarker(value) {
  if (resolvedMarkerFree.has(value)) return false;
  const cached = markerPresenceCache.get(value);
  if (cached !== void 0) return cached;
  let found = false;
  const children = Array.isArray(value) ? value : Object.values(value);
  for (const child of children) {
    if (isRenderBindingMarker(child)) {
      found = true;
      break;
    }
    if (Array.isArray(child) || isPlainObject(child)) {
      if (subtreeHasMarker(child)) {
        found = true;
        break;
      }
    }
  }
  markerPresenceCache.set(value, found);
  return found;
}
function walkValue(value, scopeTrait, entity, config, state) {
  if (isRenderBindingMarker(value)) {
    const cached = markerResolutionCache.get(value);
    if (cached !== void 0 && cached.entity === entity && cached.config === config && cached.state === state) {
      return { resolved: cached.resolved, changed: false };
    }
    const resolved = resolveMarkerExpression(value.expression, entity, config, state);
    markerResolutionCache.set(value, { entity, config, state, resolved });
    if (resolved !== null && typeof resolved === "object" && !React79__default.isValidElement(resolved) && !(resolved instanceof Date)) {
      resolvedMarkerFree.add(resolved);
      evaluatorResolvedData.add(resolved);
    }
    return { resolved, changed: true };
  }
  if (Array.isArray(value)) {
    if (!subtreeHasMarker(value)) {
      brandResolved(value);
      return { resolved: value, changed: false };
    }
    const out = [];
    let changed = false;
    for (const item of value) {
      const element = item;
      const wasMarker = isRenderBindingMarker(element);
      const { resolved, changed: itemChanged } = walkValue(element, scopeTrait, entity, config, state);
      if (wasMarker && Array.isArray(resolved)) {
        out.push(...resolved);
        changed = true;
        continue;
      }
      out.push(resolved);
      if (itemChanged) changed = true;
    }
    brandResolved(out);
    return changed ? { resolved: out, changed: true } : { resolved: value, changed: false };
  }
  if (isPlainObject(value)) {
    if (!subtreeHasMarker(value)) {
      brandResolved(value);
      return { resolved: value, changed: false };
    }
    const sourceTrait = value._sourceTrait;
    if (typeof sourceTrait === "string" && sourceTrait !== scopeTrait) {
      return { resolved: value, changed: false };
    }
    const out = {};
    let changed = false;
    for (const [key, item] of Object.entries(value)) {
      const { resolved, changed: itemChanged } = walkValue(item, scopeTrait, entity, config, state);
      out[key] = resolved;
      if (itemChanged) changed = true;
    }
    brandResolved(out);
    return changed ? { resolved: out, changed: true } : { resolved: value, changed: false };
  }
  return { resolved: value, changed: false };
}
function resolveRenderBindingMarkers(props, scopeTrait, entity, config, state) {
  if (resolvedMarkerFree.has(props)) return props;
  const out = {};
  let changed = false;
  for (const [key, value] of Object.entries(props)) {
    const { resolved, changed: propChanged } = walkValue(value, scopeTrait, entity, config, state);
    out[key] = resolved;
    if (propChanged) changed = true;
  }
  brandResolved(out);
  return changed ? out : props;
}
var markerPresenceCache, markerResolutionCache, resolvedMarkerFree, evaluatorResolvedData;
var init_resolve_render_bindings = __esm({
  "lib/resolve-render-bindings.ts"() {
    "use client";
    markerPresenceCache = /* @__PURE__ */ new WeakMap();
    markerResolutionCache = /* @__PURE__ */ new WeakMap();
    resolvedMarkerFree = /* @__PURE__ */ new WeakSet();
    evaluatorResolvedData = /* @__PURE__ */ new WeakSet();
  }
});

// lib/portalRoot.ts
function lastThemedElement(selector, portalRoot) {
  const matches = Array.from(document.querySelectorAll(selector)).filter(
    (el) => el !== document.documentElement && el !== portalRoot
  );
  return matches[matches.length - 1] ?? null;
}
function getOrCreatePortalRoot() {
  let root = document.getElementById("ui-slot-portal-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "ui-slot-portal-root";
    root.style.position = "relative";
    root.style.zIndex = "9999";
    document.body.appendChild(root);
  }
  const themed = lastThemedElement('[data-theme*="-"]', root) ?? lastThemedElement("[data-theme]", root);
  if (themed) {
    const theme = themed.getAttribute("data-theme");
    if (theme && root.getAttribute("data-theme") !== theme) {
      root.setAttribute("data-theme", theme);
    }
  }
  return root;
}
var init_portalRoot = __esm({
  "lib/portalRoot.ts"() {
  }
});
var sizeClasses6, minWidthClasses, lookStyles2, Modal;
var init_Modal = __esm({
  "components/core/molecules/Modal.tsx"() {
    "use client";
    init_Box();
    init_Button();
    init_Dialog();
    init_Typography();
    init_cn();
    init_portalRoot();
    init_useEventBus();
    init_Presence();
    sizeClasses6 = {
      sm: "max-w-md",
      md: "max-w-2xl",
      lg: "max-w-3xl",
      xl: "max-w-5xl",
      full: "max-w-full mx-4"
    };
    minWidthClasses = {
      sm: "min-w-[400px] max-sm:min-w-0",
      md: "min-w-[520px] max-sm:min-w-0",
      lg: "min-w-[600px] max-sm:min-w-0",
      xl: "min-w-[700px] max-sm:min-w-0",
      full: "min-w-0"
    };
    lookStyles2 = {
      "centered-card": "",
      "top-sheet": "top-0 rounded-t-none rounded-b-container max-w-full w-full",
      "side-drawer": "right-0 top-0 bottom-0 h-full rounded-l-container rounded-r-none w-[400px] max-w-full",
      "full-screen": "inset-0 rounded-none w-full h-full max-w-full"
    };
    Modal = ({
      isOpen = true,
      onClose = () => {
      },
      onExited,
      title,
      children = null,
      footer,
      size = "md",
      showCloseButton = true,
      closeOnOverlayClick = true,
      closeOnEscape = true,
      className,
      closeEvent,
      swipeDownToClose = true,
      look = "centered-card"
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const modalRef = useRef(null);
      const previousActiveElement = useRef(null);
      const [dragY, setDragY] = useState(0);
      const dragStartY = useRef(0);
      const isDragging = useRef(false);
      const { mounted, exiting, onAnimationEnd: handleAnimEnd } = usePresence(isOpen, {
        animation: "modal",
        onExited
      });
      useEffect(() => {
        if (isOpen) {
          previousActiveElement.current = document.activeElement;
          const focusableElements = modalRef.current?.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstElement = focusableElements?.[0];
          firstElement?.focus();
        } else {
          previousActiveElement.current?.focus();
        }
      }, [isOpen]);
      useEffect(() => {
        if (!isOpen || !closeOnEscape) return;
        const handleEscape = (e) => {
          if (e.key === "Escape") {
            if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
            onClose();
          }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
      }, [isOpen, closeOnEscape, onClose, closeEvent, eventBus]);
      useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
        return () => {
          document.body.style.overflow = "";
        };
      }, [isOpen]);
      if (typeof document === "undefined") return null;
      if (!mounted) return null;
      const dialogAnim = exiting ? "animate-modal-out" : "animate-modal-in";
      const overlayAnim = exiting ? "animate-overlay-out" : "animate-overlay-in";
      const handleClose = () => {
        if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
        onClose();
      };
      const handleOverlayClick = (e) => {
        if (closeOnOverlayClick && e.target === e.currentTarget) {
          handleClose();
        }
      };
      return createPortal(
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "fixed inset-0 z-[1000]",
              "flex items-start justify-center px-4 pb-4 pt-[10vh]",
              "max-sm:items-stretch max-sm:p-0 max-sm:pt-0",
              overlayAnim
            ),
            style: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
            onClick: handleOverlayClick,
            children: /* @__PURE__ */ jsxs(
              Dialog,
              {
                ref: modalRef,
                open: true,
                className: cn(
                  // Reset browser-default dialog chrome — we own styling. `static`
                  // overrides the user-agent `position: absolute` so the parent
                  // flex container's `justify-center` actually centers the dialog
                  // (without this, the dialog drops out of flex flow and `m-0`
                  // kills the user-agent's `margin: auto` centering, pinning the
                  // dialog to top-left).
                  "static m-0 p-0 border-0 bg-transparent",
                  // Pre-existing dialog frame
                  "pointer-events-auto w-full flex flex-col bg-surface border shadow-elevation-dialog rounded-container",
                  // Desktop sizing + viewport-aware floor.
                  sizeClasses6[size],
                  minWidthClasses[size],
                  "max-h-[80vh]",
                  // Mobile: take the entire screen. Override desktop max-w cap,
                  // full height, no rounded corners, no min-width.
                  "max-sm:max-w-none max-sm:max-h-none max-sm:w-full max-sm:h-full max-sm:rounded-none",
                  lookStyles2[look],
                  className,
                  dialogAnim
                ),
                onAnimationEnd: handleAnimEnd,
                style: dragY > 0 ? {
                  transform: `translateY(${dragY}px)`,
                  transition: isDragging.current ? "none" : "transform 200ms ease-out"
                } : void 0,
                ...title && { "aria-labelledby": "modal-title" },
                children: [
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: "hidden max-sm:flex justify-center py-2 cursor-grab active:cursor-grabbing touch-none",
                      onPointerDown: (e) => {
                        if (!swipeDownToClose) return;
                        dragStartY.current = e.clientY;
                        isDragging.current = true;
                        e.target.setPointerCapture(e.pointerId);
                      },
                      onPointerMove: (e) => {
                        if (!isDragging.current) return;
                        const dy = Math.max(0, e.clientY - dragStartY.current);
                        setDragY(dy);
                      },
                      onPointerUp: () => {
                        if (!isDragging.current) return;
                        isDragging.current = false;
                        if (dragY > 100) {
                          handleClose();
                        }
                        setDragY(0);
                      },
                      onPointerCancel: () => {
                        isDragging.current = false;
                        setDragY(0);
                      },
                      children: /* @__PURE__ */ jsx(Box, { className: "w-10 h-1 rounded-full bg-border" })
                    }
                  ),
                  (title || showCloseButton) && /* @__PURE__ */ jsxs(
                    Box,
                    {
                      className: cn(
                        "px-6 py-4 flex items-center justify-between",
                        "border-b-[length:var(--border-width)] border-border"
                      ),
                      children: [
                        title && /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "h2", id: "modal-title", children: title }),
                        showCloseButton && /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: "ghost",
                            size: "sm",
                            icon: "x",
                            onClick: handleClose,
                            "data-event": "CLOSE",
                            "aria-label": t("aria.closeModal")
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto p-6", children }),
                  footer && /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: cn(
                        "px-6 py-4 bg-muted",
                        "border-t-[length:var(--border-width)] border-border"
                      ),
                      children: footer
                    }
                  )
                ]
              }
            )
          }
        ),
        getOrCreatePortalRoot()
      );
    };
    Modal.displayName = "Modal";
  }
});
var sizeWidths, Drawer;
var init_Drawer = __esm({
  "components/core/molecules/Drawer.tsx"() {
    "use client";
    init_Box();
    init_Button();
    init_Typography();
    init_Overlay();
    init_Presence();
    init_cn();
    init_useEventBus();
    sizeWidths = {
      sm: "w-full sm:w-80",
      // 320px
      md: "w-full sm:w-96",
      // 384px
      lg: "w-full sm:w-[480px]",
      xl: "w-full sm:w-[640px]",
      full: "w-screen"
    };
    Drawer = ({
      isOpen = true,
      onClose = () => {
      },
      title,
      children = null,
      footer,
      position = "right",
      width = "md",
      showCloseButton = true,
      closeOnOverlayClick = true,
      closeOnEscape = true,
      className,
      closeEvent
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const drawerRef = useRef(null);
      const previousActiveElement = useRef(null);
      useEffect(() => {
        if (isOpen) {
          previousActiveElement.current = document.activeElement;
          const focusableElements = drawerRef.current?.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstElement = focusableElements?.[0];
          firstElement?.focus();
        } else {
          previousActiveElement.current?.focus();
        }
      }, [isOpen]);
      useEffect(() => {
        if (!isOpen || !closeOnEscape) return;
        const handleEscape = (e) => {
          if (e.key === "Escape") {
            if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
            onClose();
          }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
      }, [isOpen, closeOnEscape, onClose, closeEvent, eventBus]);
      const { mounted, className: drawerAnim, onAnimationEnd } = usePresence(isOpen, { animation: "drawer" });
      useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
        return () => {
          document.body.style.overflow = "";
        };
      }, [isOpen]);
      if (!mounted) return null;
      const handleClose = () => {
        if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
        onClose();
      };
      const handleOverlayClick = (e) => {
        if (closeOnOverlayClick && e.target === e.currentTarget) {
          handleClose();
        }
      };
      const widthClass = width in sizeWidths ? sizeWidths[width] : "";
      const widthStyle = width in sizeWidths ? void 0 : { width };
      const positionClasses2 = position === "right" ? "right-0 border-l" : "left-0 border-r";
      const drawerSign = position === "right" ? 1 : -1;
      const slideTransform = position === "right" ? "translateX(100%)" : "translateX(-100%)";
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Overlay,
          {
            isVisible: isOpen,
            onClick: handleOverlayClick,
            className: "z-40"
          }
        ),
        /* @__PURE__ */ jsxs(
          Box,
          {
            ref: drawerRef,
            bg: "surface",
            border: true,
            shadow: "xl",
            className: cn(
              "fixed top-0 bottom-0 z-50",
              "flex flex-col max-h-screen",
              positionClasses2,
              widthClass,
              drawerAnim,
              className
            ),
            style: { ...widthStyle, "--motion-drawer-sign": drawerSign, "--motion-drawer-enter-from-transform": slideTransform, "--motion-drawer-exit-to-transform": slideTransform },
            role: "dialog",
            "aria-modal": "true",
            onAnimationEnd,
            ...title && { "aria-labelledby": "drawer-title" },
            children: [
              (title || showCloseButton) && /* @__PURE__ */ jsxs(
                Box,
                {
                  className: cn(
                    "px-6 py-4 flex items-center justify-between shrink-0",
                    "border-b-[length:var(--border-width)] border-border"
                  ),
                  children: [
                    title && /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "h2", id: "drawer-title", children: title }),
                    showCloseButton && /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        size: "sm",
                        icon: "x",
                        onClick: handleClose,
                        "aria-label": t("aria.closeDrawer"),
                        className: cn(!title && "ml-auto")
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto p-6", children }),
              footer && /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn(
                    "px-6 py-4 shrink-0 bg-muted",
                    "border-t-[length:var(--border-width)] border-border"
                  ),
                  children: footer
                }
              )
            ]
          }
        )
      ] });
    };
    Drawer.displayName = "Drawer";
  }
});
var variantClasses, iconMap, iconColors, Toast;
var init_Toast = __esm({
  "components/core/molecules/Toast.tsx"() {
    "use client";
    init_Box();
    init_Icon();
    init_Typography();
    init_Button();
    init_Badge();
    init_cn();
    init_useEventBus();
    variantClasses = {
      success: "bg-card border-[length:var(--border-width)] border-success",
      error: "bg-card border-[length:var(--border-width)] border-error",
      info: "bg-card border-[length:var(--border-width)] border-info",
      warning: "bg-card border-[length:var(--border-width)] border-warning"
    };
    iconMap = {
      success: "check-circle",
      error: "alert-circle",
      info: "info",
      warning: "alert-triangle"
    };
    iconColors = {
      success: "text-success",
      error: "text-error",
      info: "text-info",
      warning: "text-warning"
    };
    Toast = ({
      variant = "info",
      message,
      title,
      duration = 5e3,
      dismissible = true,
      onDismiss,
      actionLabel,
      onAction,
      badge,
      className,
      dismissEvent,
      actionEvent
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const [leaving, setLeaving] = useState(false);
      const doRealDismiss = () => {
        if (dismissEvent) eventBus.emit(`UI:${dismissEvent}`, {});
        onDismiss?.();
      };
      const handleDismiss = () => {
        if (leaving) return;
        setLeaving(true);
      };
      const handleAction = () => {
        if (actionEvent) eventBus.emit(`UI:${actionEvent}`, {});
        onAction?.();
      };
      const handleAnimEnd = (e) => {
        if (e.target !== e.currentTarget) return;
        if (leaving) doRealDismiss();
      };
      useEffect(() => {
        if (duration <= 0 || !onDismiss && !dismissEvent) {
          return;
        }
        const timer = setTimeout(() => {
          handleDismiss();
        }, duration);
        return () => clearTimeout(timer);
      }, [duration, onDismiss, dismissEvent]);
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            // `min-w-[300px]` only kicks in at `sm:` and above so a phone
            // viewport doesn't get a toast wider than the screen near the
            // edge. `max-w-[calc(100vw-2rem)]` clamps to viewport too.
            "border-l-4 p-4 shadow-elevation-toast min-w-0 sm:min-w-[300px] max-w-md max-w-[calc(100vw-2rem)]",
            "rounded-sm",
            leaving ? "animate-toast-out" : "animate-toast-in",
            variantClasses[variant],
            className
          ),
          role: "alert",
          onAnimationEnd: handleAnimEnd,
          children: /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-3", children: [
            /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 mt-0.5", children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: iconMap[variant],
                size: "md",
                className: iconColors[variant]
              }
            ) }),
            /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
              title && /* @__PURE__ */ jsx(Typography, { variant: "h6", className: "mb-1", children: title }),
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-sm", children: message }),
              actionLabel && (onAction || actionEvent) && /* @__PURE__ */ jsx(Box, { className: "mt-3", children: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleAction, children: actionLabel }) })
            ] }),
            /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-2 flex-shrink-0", children: [
              badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: badge }),
              dismissible && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  icon: "x",
                  onClick: handleDismiss,
                  "aria-label": t("aria.closeToast"),
                  className: "flex-shrink-0"
                }
              )
            ] })
          ] })
        }
      );
    };
    Toast.displayName = "Toast";
  }
});
function refId(obj) {
  if (obj === null || obj === void 0 || typeof obj !== "object") return null;
  const existing = refIds.get(obj);
  if (existing !== void 0) return existing;
  const id = nextRefId++;
  refIds.set(obj, id);
  return id;
}
var slotLog, refIds, nextRefId;
var init_slot_types = __esm({
  "types/slot-types.ts"() {
    slotLog = createLogger("almadar:ui:slot-render");
    refIds = /* @__PURE__ */ new WeakMap();
    nextRefId = 1;
  }
});
var SlotContainedContext;
var init_slotContained = __esm({
  "lib/slotContained.ts"() {
    "use client";
    SlotContainedContext = createContext(false);
  }
});
var ErrorState;
var init_ErrorState = __esm({
  "components/core/molecules/ErrorState.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Box();
    init_Stack();
    init_Typography();
    init_Icon();
    init_useEventBus();
    ErrorState = ({
      title,
      message,
      description,
      onRetry,
      className,
      retryEvent
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleRetry = () => {
        if (retryEvent) eventBus.emit(`UI:${retryEvent}`, {});
        onRetry?.();
      };
      const resolvedTitle = title ?? t("error.generic");
      const resolvedMessage = message ?? description ?? t("error.occurred");
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          align: "center",
          className: cn(
            "justify-center py-12 text-center",
            className
          ),
          children: [
            /* @__PURE__ */ jsx(Box, { className: "mb-4 rounded-full bg-error/10 p-3", children: /* @__PURE__ */ jsx(Icon, { name: "alert-circle", className: "h-8 w-8 text-error" }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "text-lg font-medium text-foreground", children: resolvedTitle }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "mt-1 text-muted-foreground max-w-sm", children: resolvedMessage }),
            (onRetry || retryEvent) && /* @__PURE__ */ jsx(Button, { variant: "secondary", className: "mt-4", onClick: handleRetry, children: t("error.retry") })
          ]
        }
      );
    };
    ErrorState.displayName = "ErrorState";
  }
});
var DefaultFallback, ErrorBoundary;
var init_ErrorBoundary = __esm({
  "components/core/molecules/ErrorBoundary.tsx"() {
    "use client";
    init_cn();
    init_ErrorState();
    DefaultFallback = ({ error, onRetry }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsx(
        ErrorState,
        {
          title: t("error.somethingWentWrong"),
          message: error.message,
          onRetry
        }
      );
    };
    ErrorBoundary = class extends React79__default.Component {
      constructor(props) {
        super(props);
        __publicField(this, "reset", () => {
          this.setState({ error: null });
        });
        this.state = { error: null };
      }
      static getDerivedStateFromError(error) {
        return { error };
      }
      componentDidCatch(error, errorInfo) {
        this.props.onError?.(error, errorInfo);
      }
      render() {
        const { error } = this.state;
        const { children, fallback, className } = this.props;
        if (error) {
          const fallbackNode = typeof fallback === "function" ? fallback(error, this.reset) : fallback || /* @__PURE__ */ jsx(DefaultFallback, { error, onRetry: this.reset });
          return className ? /* @__PURE__ */ jsx("div", { className: cn(className), children: fallbackNode }) : fallbackNode;
        }
        return children;
      }
    };
    __publicField(ErrorBoundary, "displayName", "ErrorBoundary");
  }
});
function SkeletonLine({ className }) {
  return /* @__PURE__ */ jsx(Box, { className: cn(pulseClass, "h-4", className) });
}
function SkeletonBlock({ className }) {
  return /* @__PURE__ */ jsx(Box, { className: cn(pulseClass, className) });
}
function HeaderSkeleton({ className }) {
  return /* @__PURE__ */ jsxs(HStack, { className: cn("items-center justify-between px-6 py-5", className), children: [
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "flex-1", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-7 w-48" }),
      /* @__PURE__ */ jsx(SkeletonLine, { className: "w-64" })
    ] }),
    /* @__PURE__ */ jsxs(HStack, { gap: "sm", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-9 w-24 rounded-md" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-9 w-32 rounded-md" })
    ] })
  ] });
}
function TableSkeleton({ rows: rows2 = 5, columns = 4, className }) {
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("border border-border rounded-lg overflow-hidden", className), children: [
    /* @__PURE__ */ jsx(HStack, { className: "px-4 py-3 bg-muted/30 border-b border-border", children: Array.from({ length: columns }).map((_, i) => /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-4 flex-1 mx-2" }, i)) }),
    Array.from({ length: rows2 }).map((_, rowIdx) => /* @__PURE__ */ jsx(
      HStack,
      {
        className: cn(
          "px-4 py-3",
          rowIdx < rows2 - 1 && "border-b border-border"
        ),
        children: Array.from({ length: columns }).map((_2, colIdx) => /* @__PURE__ */ jsx(SkeletonLine, { className: "flex-1 mx-2" }, colIdx))
      },
      rowIdx
    ))
  ] });
}
function FormSkeleton({ fields = 4, className }) {
  return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("p-6", className), children: [
    /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-40" }),
    Array.from({ length: fields }).map((_, i) => /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-4 w-24" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-full rounded-md" })
    ] }, i)),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", className: "justify-end pt-2", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-20 rounded-md" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-24 rounded-md" })
    ] })
  ] });
}
function CardSkeleton({ className }) {
  return /* @__PURE__ */ jsxs(
    VStack,
    {
      gap: "md",
      className: cn(
        "p-5 border border-border rounded-lg",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(HStack, { className: "items-center", gap: "md", children: [
          /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-10 rounded-full" }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1", children: [
            /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-5 w-32" }),
            /* @__PURE__ */ jsx(SkeletonLine, { className: "w-48" })
          ] })
        ] }),
        /* @__PURE__ */ jsx(SkeletonLine, { className: "w-full" }),
        /* @__PURE__ */ jsx(SkeletonLine, { className: "w-3/4" }),
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "pt-2", children: [
          /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-16 rounded-full" }),
          /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-20 rounded-full" })
        ] })
      ]
    }
  );
}
function TextSkeleton({ rows: rows2 = 3, className }) {
  return /* @__PURE__ */ jsx(VStack, { gap: "sm", className, children: Array.from({ length: rows2 }).map((_, i) => /* @__PURE__ */ jsx(
    SkeletonLine,
    {
      className: i === rows2 - 1 ? "w-2/3" : "w-full"
    },
    i
  )) });
}
function Skeleton({
  variant = "text",
  rows: rows2,
  columns,
  fields,
  className
}) {
  const { t: _t } = useTranslate();
  switch (variant) {
    case "header":
      return /* @__PURE__ */ jsx(HeaderSkeleton, { className });
    case "table":
      return /* @__PURE__ */ jsx(TableSkeleton, { rows: rows2, columns, className });
    case "form":
      return /* @__PURE__ */ jsx(FormSkeleton, { fields, className });
    case "card":
      return /* @__PURE__ */ jsx(CardSkeleton, { className });
    case "text":
      return /* @__PURE__ */ jsx(TextSkeleton, { rows: rows2, className });
    default:
      return /* @__PURE__ */ jsx(TextSkeleton, { rows: rows2, className });
  }
}
var pulseClass;
var init_Skeleton = __esm({
  "components/core/molecules/Skeleton.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Stack();
    pulseClass = "almadar-shimmer animate-shimmer rounded";
    Skeleton.displayName = "Skeleton";
  }
});
function getKnownPatterns() {
  return Object.keys(componentMapping);
}
function getPatternDefinition(type) {
  return patternRegistry[type];
}
var componentMapping, patternRegistry;
var init_pattern_resolver = __esm({
  "lib/pattern-resolver.ts"() {
    createLogger("almadar:ui:pattern-resolver");
    componentMapping = {};
    patternRegistry = {};
  }
});

// lib/slot-definitions.ts
function isPortalSlot(slot) {
  return SLOT_DEFINITIONS[slot]?.type === "portal";
}
var SLOT_DEFINITIONS;
var init_slot_definitions = __esm({
  "lib/slot-definitions.ts"() {
    SLOT_DEFINITIONS = {
      // -------------------------------------------------------------------------
      // Inline Slots - Render in place within the component tree
      // -------------------------------------------------------------------------
      main: {
        name: "main",
        type: "inline"
      },
      sidebar: {
        name: "sidebar",
        type: "inline"
      },
      // -------------------------------------------------------------------------
      // Portal Slots - Render to document.body via React Portal
      // -------------------------------------------------------------------------
      modal: {
        name: "modal",
        type: "portal",
        portalTarget: "body",
        zIndex: 1e3
      },
      drawer: {
        name: "drawer",
        type: "portal",
        portalTarget: "body",
        zIndex: 900
      },
      overlay: {
        name: "overlay",
        type: "portal",
        portalTarget: "body",
        zIndex: 1100
      },
      center: {
        name: "center",
        type: "portal",
        portalTarget: "body",
        zIndex: 1e3
      },
      toast: {
        name: "toast",
        type: "portal",
        portalTarget: "body",
        zIndex: 1200
      },
      // -------------------------------------------------------------------------
      // Game HUD Slots - Portal for game overlay UI
      // -------------------------------------------------------------------------
      "hud-top": {
        name: "hud-top",
        type: "portal",
        portalTarget: "body",
        zIndex: 500
      },
      "hud-bottom": {
        name: "hud-bottom",
        type: "portal",
        portalTarget: "body",
        zIndex: 500
      },
      floating: {
        name: "floating",
        type: "portal",
        portalTarget: "body",
        zIndex: 800
      }
    };
  }
});
var init_renderer = __esm({
  "renderer/index.ts"() {
    init_slot_definitions();
  }
});
var init_wrapCallbackForEvent = __esm({
  "lib/wrapCallbackForEvent.ts"() {
  }
});
var sizeStyles7, paddingStyles3, Container;
var init_Container = __esm({
  "components/core/molecules/Container.tsx"() {
    init_cn();
    sizeStyles7 = {
      xs: "max-w-xs",
      // 320px
      sm: "max-w-screen-sm",
      // 640px
      md: "max-w-screen-md",
      // 768px
      lg: "max-w-screen-lg",
      // 1024px
      xl: "max-w-screen-xl",
      // 1280px
      "2xl": "max-w-screen-2xl",
      // 1536px
      full: "max-w-full"
    };
    paddingStyles3 = {
      none: "px-0",
      // Mobile-tighter, desktop-identical: fixed px-6 on a 360px phone eats ~13% of
      // the viewport, so each token steps down below the sm breakpoint.
      sm: "px-3 sm:px-4",
      md: "px-4 sm:px-6",
      lg: "px-4 sm:px-6 md:px-8",
      xl: "px-4 sm:px-8 md:px-12"
    };
    Container = ({
      size,
      maxWidth,
      padding = "md",
      center = true,
      className,
      children,
      as: Component = "div"
    }) => {
      const resolvedSize = maxWidth ?? size ?? "lg";
      return React79__default.createElement(
        Component,
        {
          className: cn(
            "w-full",
            sizeStyles7[resolvedSize],
            paddingStyles3[padding],
            center && "mx-auto",
            className
          )
        },
        children
      );
    };
    Container.displayName = "Container";
  }
});
var InstallBox;
var init_InstallBox = __esm({
  "components/marketing/molecules/InstallBox.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Typography();
    init_Button();
    InstallBox = ({
      command,
      label,
      className
    }) => {
      const [copied, setCopied] = useState(false);
      const handleCopy = useCallback(() => {
        void navigator.clipboard.writeText(command);
        setCopied(true);
        const timer = setTimeout(() => setCopied(false), 2e3);
        return () => clearTimeout(timer);
      }, [command]);
      return /* @__PURE__ */ jsxs(Box, { className: cn("inline-block", className), children: [
        label && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "mb-1", children: label }),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "bg-surface rounded-container border-[length:var(--border-width)] border-border",
            padding: "md",
            children: /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  className: "font-mono flex-1 min-w-0 select-all",
                  truncate: true,
                  children: command
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  leftIcon: copied ? "check" : "copy",
                  onClick: handleCopy,
                  className: "flex-shrink-0",
                  "aria-label": copied ? "Copied" : "Copy to clipboard",
                  children: copied ? "Copied" : "Copy"
                }
              )
            ] })
          }
        )
      ] });
    };
    InstallBox.displayName = "InstallBox";
  }
});
var tagVariantMap, backgroundStyles, MarketingImage, HeroSection;
var init_HeroSection = __esm({
  "components/marketing/molecules/HeroSection.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Badge();
    init_Typography();
    init_Button();
    init_InstallBox();
    tagVariantMap = {
      primary: "primary",
      secondary: "secondary",
      accent: "info"
    };
    backgroundStyles = {
      dark: "bg-foreground text-background",
      // A single bracket value: joining this as two array entries put a space
      // inside the class (Tailwind splits utilities on whitespace), so neither
      // half was a valid utility and the gradient rendered as nothing.
      gradient: "bg-[radial-gradient(ellipse_at_top,var(--color-primary)/0.08,transparent_60%),radial-gradient(ellipse_at_bottom_right,var(--color-accent)/0.06,transparent_50%)] bg-background",
      subtle: "bg-muted/30"
    };
    MarketingImage = ({ src, alt, className }) => /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat",
          className
        ),
        style: { backgroundImage: `url(${src})` },
        role: "img",
        "aria-label": alt
      }
    );
    MarketingImage.displayName = "MarketingImage";
    HeroSection = ({
      tag,
      tagVariant = "primary",
      title,
      titleAccent,
      subtitle,
      primaryAction,
      secondaryAction,
      installCommand,
      image,
      imagePosition = "below",
      background = "subtle",
      align = "center",
      backgroundElement,
      children,
      className
    }) => {
      const isCenter = align === "center";
      const isDark = background === "dark";
      const titleNode = titleAccent ? /* @__PURE__ */ jsxs(
        Typography,
        {
          variant: "h1",
          align: isCenter ? "center" : "left",
          className: cn(
            "max-w-3xl leading-tight",
            isDark && "text-background"
          ),
          children: [
            title,
            " ",
            /* @__PURE__ */ jsx(
              Typography,
              {
                as: "span",
                variant: "h1",
                className: "text-primary",
                children: titleAccent
              }
            )
          ]
        }
      ) : /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "h1",
          align: isCenter ? "center" : "left",
          className: cn(
            "max-w-3xl leading-tight",
            isDark && "text-background"
          ),
          children: title
        }
      );
      const textContent = /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "lg",
          align: isCenter ? "center" : "start",
          className: cn(
            isCenter && "items-center",
            imagePosition === "right" ? "flex-1" : "w-full"
          ),
          children: [
            tag && /* @__PURE__ */ jsx(Badge, { variant: tagVariantMap[tagVariant] ?? "primary", size: "md", children: tag }),
            titleNode,
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "body1",
                color: "muted",
                align: isCenter ? "center" : "left",
                className: "max-w-xl",
                children: subtitle
              }
            ),
            installCommand && /* @__PURE__ */ jsx(InstallBox, { command: installCommand }),
            (primaryAction || secondaryAction) && /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "center", children: [
              primaryAction && /* @__PURE__ */ jsx(
                "a",
                {
                  href: primaryAction.href,
                  target: primaryAction.href.startsWith("http") ? "_blank" : void 0,
                  rel: primaryAction.href.startsWith("http") ? "noopener noreferrer" : void 0,
                  className: "no-underline",
                  children: /* @__PURE__ */ jsx(Button, { variant: "primary", size: "lg", children: primaryAction.label })
                }
              ),
              secondaryAction && /* @__PURE__ */ jsx(
                "a",
                {
                  href: secondaryAction.href,
                  target: secondaryAction.href.startsWith("http") ? "_blank" : void 0,
                  rel: secondaryAction.href.startsWith("http") ? "noopener noreferrer" : void 0,
                  className: "no-underline",
                  children: /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "lg", children: secondaryAction.label })
                }
              )
            ] }),
            children
          ]
        }
      );
      const imageNode = image && /* @__PURE__ */ jsx(
        MarketingImage,
        {
          src: image.src,
          alt: image.alt,
          className: cn(
            imagePosition === "right" ? "w-full max-w-[280px] max-h-[280px]" : "w-full min-h-[400px]"
          )
        }
      );
      const innerContent = image && imagePosition === "right" ? /* @__PURE__ */ jsxs(HStack, { gap: "xl", align: "center", className: "w-full max-w-7xl", responsive: true, children: [
        textContent,
        imageNode
      ] }) : /* @__PURE__ */ jsxs(VStack, { gap: "xl", align: isCenter ? "center" : "start", className: "w-full max-w-7xl", children: [
        textContent,
        image && imagePosition === "below" && imageNode
      ] });
      return /* @__PURE__ */ jsxs(
        Box,
        {
          as: "header",
          className: cn(
            "w-full min-h-[60vh] flex items-center justify-center",
            "py-20",
            "relative overflow-hidden",
            backgroundStyles[background],
            className
          ),
          children: [
            backgroundElement,
            image && imagePosition === "background" && /* @__PURE__ */ jsx(
              MarketingImage,
              {
                src: image.src,
                alt: image.alt,
                className: "absolute inset-0 w-full h-full opacity-20"
              }
            ),
            /* @__PURE__ */ jsx(Box, { className: "relative z-10 w-full flex justify-center px-4 sm:px-6 lg:px-8", children: innerContent })
          ]
        }
      );
    };
    HeroSection.displayName = "HeroSection";
  }
});
var maxWidthMap, ArticleSection;
var init_ArticleSection = __esm({
  "components/marketing/molecules/ArticleSection.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    maxWidthMap = {
      sm: "max-w-full sm:max-w-xl md:max-w-2xl",
      md: "max-w-full sm:max-w-2xl md:max-w-3xl",
      lg: "max-w-full sm:max-w-3xl md:max-w-4xl"
    };
    ArticleSection = ({
      title,
      children,
      maxWidth = "md",
      className
    }) => {
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "w-full",
            className
          ),
          padding: "md",
          children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", align: "start", className: cn("w-full mx-auto", maxWidthMap[maxWidth]), children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h2", children: title }),
            /* @__PURE__ */ jsx(Box, { className: "w-full", children })
          ] })
        }
      );
    };
    ArticleSection.displayName = "ArticleSection";
  }
});
var TeamCard;
var init_TeamCard = __esm({
  "components/marketing/molecules/TeamCard.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Card();
    init_Stack();
    init_Avatar();
    init_Typography();
    TeamCard = ({
      name,
      nameAr,
      role,
      bio,
      avatar,
      className
    }) => {
      const avatarSrc = typeof avatar === "string" ? avatar : void 0;
      const avatarInitials = typeof avatar === "object" && avatar !== null ? avatar.initials : void 0;
      return /* @__PURE__ */ jsx(Card, { variant: "bordered", padding: "lg", className: cn("w-full", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", align: "center", children: [
        /* @__PURE__ */ jsx(
          Avatar,
          {
            src: avatarSrc,
            initials: avatarInitials,
            name: !avatarSrc && !avatarInitials ? name : void 0,
            size: "lg"
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "text-center", children: name }),
        nameAr && /* @__PURE__ */ jsx(Box, { className: "text-center", style: { direction: "rtl" }, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", children: nameAr }) }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-center", children: role }),
        /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-center", children: bio })
      ] }) });
    };
    TeamCard.displayName = "TeamCard";
  }
});
var gapStyles2, colStyles, SimpleGrid;
var init_SimpleGrid = __esm({
  "components/core/molecules/SimpleGrid.tsx"() {
    init_Box();
    init_cn();
    gapStyles2 = {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    };
    colStyles = {
      1: "grid-cols-1",
      2: "grid-cols-1 sm:grid-cols-2 @max-sm:!grid-cols-1",
      3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1",
      4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1",
      5: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 @max-xl:!grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1",
      6: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 @max-xl:!grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1"
    };
    SimpleGrid = ({
      minChildWidth = 250,
      maxCols,
      cols,
      gap = "md",
      className,
      children
    }) => {
      if (cols) {
        return /* @__PURE__ */ jsx(Box, { className: cn("grid", colStyles[cols], gapStyles2[gap], className), children });
      }
      const minWidth = typeof minChildWidth === "number" ? `${minChildWidth}px` : minChildWidth;
      const templateColumns = maxCols ? `repeat(auto-fit, minmax(min(${minWidth}, 100%), 1fr))` : `repeat(auto-fit, minmax(${minWidth}, 1fr))`;
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("grid", gapStyles2[gap], className),
          style: {
            gridTemplateColumns: templateColumns,
            // Limit max columns if specified
            ...maxCols && { maxWidth: `calc(${maxCols} * (${minWidth} + var(--gap, 1rem)))` }
          },
          children
        }
      );
    };
    SimpleGrid.displayName = "SimpleGrid";
  }
});
var CaseStudyCard;
var init_CaseStudyCard = __esm({
  "components/marketing/molecules/CaseStudyCard.tsx"() {
    "use client";
    init_cn();
    init_Card();
    init_Stack();
    init_Badge();
    init_Typography();
    init_Button();
    CaseStudyCard = ({
      title,
      description,
      category,
      categoryColor,
      href,
      linkLabel = "Read more",
      className
    }) => {
      const handleClick = () => {
        window.open(href, "_blank", "noopener,noreferrer");
      };
      return /* @__PURE__ */ jsx(Card, { variant: "interactive", className: cn(className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", align: "start", children: [
        /* @__PURE__ */ jsx(
          Badge,
          {
            size: "sm",
            style: categoryColor ? { backgroundColor: categoryColor, color: "white" } : void 0,
            children: category
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "h3", children: title }),
        /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: description }),
        /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "ghost",
            size: "sm",
            onClick: handleClick,
            className: "text-primary -ml-2",
            children: [
              linkLabel,
              " \u2192"
            ]
          }
        )
      ] }) });
    };
    CaseStudyCard.displayName = "CaseStudyCard";
  }
});
var CTABanner;
var init_CTABanner = __esm({
  "components/marketing/molecules/CTABanner.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    init_Button();
    CTABanner = ({
      title,
      subtitle,
      primaryAction,
      secondaryAction,
      background = "alt",
      align = "center",
      className
    }) => {
      const handleAction = (href) => {
        window.open(href, "_blank", "noopener,noreferrer");
      };
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "py-16",
            background === "alt" && "bg-surface",
            background === "dark" && "bg-surface",
            background === "gradient" && "bg-surface",
            background === "primary" && "bg-surface",
            className
          ),
          children: /* @__PURE__ */ jsxs(
            VStack,
            {
              gap: "lg",
              align: align === "center" ? "center" : "start",
              className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h2", align, children: title }),
                subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", align, children: subtitle }),
                (primaryAction || secondaryAction) && /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "center", children: [
                  primaryAction && /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "primary",
                      size: "lg",
                      onClick: () => handleAction(primaryAction.href),
                      children: primaryAction.label
                    }
                  ),
                  secondaryAction && /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "secondary",
                      size: "lg",
                      onClick: () => handleAction(secondaryAction.href),
                      children: secondaryAction.label
                    }
                  )
                ] })
              ]
            }
          )
        }
      );
    };
    CTABanner.displayName = "CTABanner";
  }
});
var AboutPageTemplate;
var init_AboutPageTemplate = __esm({
  "components/marketing/templates/AboutPageTemplate.tsx"() {
    init_cn();
    init_Stack();
    init_Box();
    init_Typography();
    init_Container();
    init_HeroSection();
    init_ArticleSection();
    init_TeamCard();
    init_SimpleGrid();
    init_CaseStudyCard();
    init_CTABanner();
    init_SectionHeader();
    AboutPageTemplate = ({
      entity,
      className
    }) => {
      const { t } = useTranslate();
      const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
      if (!resolved) return null;
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("w-full", className), children: [
        resolved.hero && /* @__PURE__ */ jsx(
          HeroSection,
          {
            tag: resolved.hero.tag,
            title: resolved.hero.title,
            titleAccent: resolved.hero.titleAccent,
            subtitle: resolved.hero.subtitle,
            primaryAction: resolved.hero.primaryAction,
            secondaryAction: resolved.hero.secondaryAction,
            background: resolved.hero.background
          }
        ),
        (Array.isArray(resolved.articles) ? resolved.articles : []).map((article, index) => /* @__PURE__ */ jsx(
          Box,
          {
            className: cn("py-12", index % 2 !== 0 && "bg-muted/20"),
            children: /* @__PURE__ */ jsx(Container, { size: "lg", padding: "lg", children: /* @__PURE__ */ jsx(ArticleSection, { title: article.title, children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: article.content }) }) })
          },
          `article-${index}`
        )),
        resolved.team && resolved.team.length > 0 && /* @__PURE__ */ jsx(Box, { className: "bg-muted/20 py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          /* @__PURE__ */ jsx(SectionHeader, { title: t("template.ourTeam") }),
          /* @__PURE__ */ jsx(
            SimpleGrid,
            {
              cols: Math.min(resolved.team.length, 4),
              gap: "lg",
              children: resolved.team.map((member) => /* @__PURE__ */ jsx(
                TeamCard,
                {
                  name: member.name,
                  nameAr: member.nameAr,
                  role: member.role,
                  bio: member.bio,
                  avatar: member.avatar
                },
                member.id
              ))
            }
          )
        ] }) }) }),
        resolved.caseStudies && resolved.caseStudies.length > 0 && /* @__PURE__ */ jsx(Box, { className: "py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          /* @__PURE__ */ jsx(SectionHeader, { title: t("template.caseStudies") }),
          /* @__PURE__ */ jsx(
            SimpleGrid,
            {
              cols: Math.min(resolved.caseStudies.length, 3),
              gap: "lg",
              children: resolved.caseStudies.map((study) => /* @__PURE__ */ jsx(
                CaseStudyCard,
                {
                  title: study.title,
                  description: study.description,
                  category: study.category,
                  categoryColor: study.categoryColor,
                  href: study.href,
                  linkLabel: study.linkLabel
                },
                study.id
              ))
            }
          )
        ] }) }) }),
        resolved.ctaTitle && /* @__PURE__ */ jsx(
          CTABanner,
          {
            title: resolved.ctaTitle,
            primaryAction: resolved.ctaAction,
            background: "dark"
          }
        )
      ] });
    };
    AboutPageTemplate.displayName = "AboutPageTemplate";
  }
});
function generateItemId(item, index) {
  if (item.id) return item.id;
  const headerText = item.header ?? item.title;
  if (typeof headerText === "string") {
    return `accordion-${headerText.toLowerCase().replace(/\s+/g, "-")}-${index}`;
  }
  return `accordion-item-${index}`;
}
function normalizeItem(item, index) {
  return {
    ...item,
    id: generateItemId(item, index),
    header: item.header ?? item.title ?? ""
  };
}
var Accordion;
var init_Accordion = __esm({
  "components/core/molecules/Accordion.tsx"() {
    "use client";
    init_Icon();
    init_Typography();
    init_cn();
    init_useEventBus();
    Accordion = ({
      items,
      multiple = false,
      defaultOpenItems,
      defaultOpen,
      openItems: controlledOpenItems,
      onItemToggle,
      className,
      toggleEvent
    }) => {
      const eventBus = useEventBus();
      const normalizedItems = items.map(
        (item, index) => normalizeItem(item, index)
      );
      const resolveDefaultOpen = () => {
        if (defaultOpenItems) return defaultOpenItems;
        if (defaultOpen) {
          return defaultOpen.filter((index) => index >= 0 && index < normalizedItems.length).map((index) => normalizedItems[index].id);
        }
        return normalizedItems.filter((item) => item.defaultOpen).map((item) => item.id);
      };
      const [internalOpenItems, setInternalOpenItems] = useState(
        new Set(resolveDefaultOpen())
      );
      const openItemsSet = controlledOpenItems ? new Set(controlledOpenItems) : internalOpenItems;
      const handleToggle = (itemId) => {
        const isOpen = openItemsSet.has(itemId);
        const newOpenItems = new Set(openItemsSet);
        if (isOpen) {
          newOpenItems.delete(itemId);
        } else {
          if (!multiple) {
            newOpenItems.clear();
          }
          newOpenItems.add(itemId);
        }
        if (controlledOpenItems === void 0) {
          setInternalOpenItems(newOpenItems);
        }
        onItemToggle?.(itemId, !isOpen);
        if (toggleEvent) eventBus.emit(`UI:${toggleEvent}`, { itemId, isOpen: !isOpen });
      };
      return /* @__PURE__ */ jsx("div", { className: cn("w-full", className), children: normalizedItems.map((item, index) => {
        const isOpen = openItemsSet.has(item.id);
        const isDisabled = item.disabled;
        return /* @__PURE__ */ jsx("div", { className: index > 0 ? "mt-2" : "", children: /* @__PURE__ */ jsxs("div", { className: "border-2 border-border overflow-hidden", children: [
          /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              onClick: () => !isDisabled && handleToggle(item.id),
              disabled: isDisabled,
              className: cn(
                "w-full flex items-center justify-between px-4 py-3",
                "bg-card",
                "hover:bg-muted",
                "transition-colors duration-fast",
                "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset",
                "disabled:opacity-50 disabled:cursor-not-allowed",
                isOpen && "bg-muted font-bold"
              ),
              "aria-expanded": isOpen,
              "aria-controls": `accordion-content-${item.id}`,
              children: [
                /* @__PURE__ */ jsx("div", { className: "flex-1 text-left", children: typeof item.header === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "medium", children: item.header }) : item.header }),
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "chevron-down",
                    size: "sm",
                    className: cn(
                      "transition-transform duration-fast",
                      isOpen && "transform rotate-180"
                    )
                  }
                )
              ]
            }
          ),
          isOpen && /* @__PURE__ */ jsx(
            "div",
            {
              id: `accordion-content-${item.id}`,
              className: "px-4 py-3 bg-card border-t-2 border-border",
              children: item.content
            }
          )
        ] }) }, item.id);
      }) });
    };
    Accordion.displayName = "Accordion";
  }
});
function ActionTile({
  action,
  size = "md",
  disabled = false,
  categoryColors,
  className
}) {
  useTranslate();
  const config = SIZE_CONFIG[size];
  const catColor = categoryColors?.[action.category];
  const handleDragStart = useCallback((e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    e.dataTransfer.setData(DRAG_MIME, JSON.stringify(action));
    e.dataTransfer.effectAllowed = "copy";
  }, [action, disabled]);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      className: cn(
        "flex-col items-center gap-1 rounded-container border-2 transition-all select-none",
        config.px,
        disabled ? "opacity-40 cursor-not-allowed border-border bg-muted" : "cursor-grab active:cursor-grabbing hover:scale-105 hover:shadow-md border-border bg-card",
        className
      ),
      style: {
        backgroundColor: !disabled && catColor ? catColor.bg : void 0,
        borderColor: !disabled && catColor ? catColor.border : void 0
      },
      draggable: !disabled,
      onDragStart: handleDragStart,
      children: [
        action.iconUrl ? /* @__PURE__ */ jsx("img", { src: action.iconUrl.url, alt: "", className: "w-8 h-8 object-contain" }) : /* @__PURE__ */ jsx(Typography, { variant: "body1", className: cn(config.icon, "leading-none"), children: action.iconEmoji || "\u2726" }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", className: cn(config.text, "text-foreground font-medium whitespace-nowrap"), children: action.name })
      ]
    }
  );
}
var DRAG_MIME, SIZE_CONFIG;
var init_ActionTile = __esm({
  "components/game/molecules/ActionTile.tsx"() {
    init_atoms();
    init_cn();
    DRAG_MIME = "application/x-almadar-slot-item";
    SIZE_CONFIG = {
      sm: { px: "px-2 py-1", icon: "text-lg", text: "text-xs" },
      md: { px: "px-3 py-2", icon: "text-2xl", text: "text-sm" },
      lg: { px: "px-4 py-3", icon: "text-3xl", text: "text-base" }
    };
    ActionTile.displayName = "ActionTile";
  }
});
function ActionPalette({
  actions,
  usedActionIds = [],
  allowDuplicates = true,
  categoryColors,
  size = "md",
  label,
  className
}) {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-lg bg-card border border-border", className), gap: "sm", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-muted-foreground font-medium", children: label ?? t("sequencer.actions") }),
    /* @__PURE__ */ jsx(HStack, { className: "flex-wrap", gap: "sm", children: (actions ?? []).map((action) => /* @__PURE__ */ jsx(
      ActionTile,
      {
        action,
        size,
        categoryColors,
        disabled: !allowDuplicates && usedActionIds.includes(action.id)
      },
      action.id
    )) })
  ] });
}
var init_ActionPalette = __esm({
  "components/game/molecules/ActionPalette.tsx"() {
    init_atoms();
    init_cn();
    init_ActionTile();
    ActionPalette.displayName = "ActionPalette";
  }
});
var ActivationBlock;
var init_ActivationBlock = __esm({
  "components/core/molecules/ActivationBlock.tsx"() {
    "use client";
    init_useEventBus();
    init_cn();
    ActivationBlock = ({
      question,
      savedResponse,
      saveEvent = "SAVE_ACTIVATION",
      className
    }) => {
      const [response, setResponse] = useState(savedResponse ?? "");
      const [isExpanded, setIsExpanded] = useState(!savedResponse);
      const { emit } = useEventBus();
      const handleSubmit = () => {
        emit(`UI:${saveEvent}`, { response });
        setIsExpanded(false);
      };
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "bg-primary/10 border-2 border-primary rounded-lg p-5 mb-6",
            className
          ),
          children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
            /* @__PURE__ */ jsx(Lightbulb, { className: "text-primary flex-shrink-0 mt-1", size: 24 }),
            /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
              /* @__PURE__ */ jsx("h4", { className: "font-semibold text-primary mb-2", children: "Before You Begin..." }),
              /* @__PURE__ */ jsx("p", { className: "text-foreground mb-3 text-sm md:text-base", children: question }),
              isExpanded ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(
                  "textarea",
                  {
                    className: "w-full p-3 border border-input rounded-md bg-card text-foreground focus:ring-2 focus:ring-ring focus:border-transparent text-sm",
                    placeholder: "Jot down your thoughts...",
                    value: response,
                    onChange: (e) => setResponse(e.target.value),
                    rows: 3
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "flex gap-2 mt-3", children: [
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: handleSubmit,
                      className: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary-hover text-sm font-medium transition-colors",
                      children: "Continue to Lesson \u2192"
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: () => {
                        emit(`UI:${saveEvent}`, { response: "" });
                        setIsExpanded(false);
                      },
                      className: "px-4 py-2 text-primary hover:underline text-sm",
                      children: "Skip for now"
                    }
                  )
                ] })
              ] }) : /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => setIsExpanded(true),
                  className: "text-sm text-primary hover:underline font-medium",
                  children: "\u2713 Answered \xB7 Edit response"
                }
              )
            ] })
          ] })
        }
      );
    };
    ActivationBlock.displayName = "ActivationBlock";
  }
});
var variantBorderClasses, variantIconColors, iconMap2, Alert;
var init_Alert = __esm({
  "components/core/molecules/Alert.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Icon();
    init_Typography();
    init_useEventBus();
    variantBorderClasses = {
      info: "border-info",
      success: "border-success",
      warning: "border-warning",
      error: "border-error"
    };
    variantIconColors = {
      info: "text-info",
      success: "text-success",
      warning: "text-warning",
      error: "text-error"
    };
    iconMap2 = {
      info: "info",
      success: "check-circle",
      warning: "alert-triangle",
      error: "alert-circle"
    };
    Alert = ({
      children,
      message,
      variant = "info",
      title,
      dismissible = false,
      onDismiss,
      onClose,
      actions,
      className,
      dismissEvent
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleDismissCallback = onDismiss || onClose;
      const handleDismiss = () => {
        if (dismissEvent) eventBus.emit(`UI:${dismissEvent}`, {});
        handleDismissCallback?.();
      };
      const content = children ?? message;
      return /* @__PURE__ */ jsx(
        Box,
        {
          bg: "surface",
          border: true,
          shadow: "sm",
          padding: "md",
          rounded: "sm",
          className: cn(variantBorderClasses[variant], className),
          role: "alert",
          children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
            /* @__PURE__ */ jsx("div", { className: "flex-shrink-0 mt-0.5", children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: iconMap2[variant],
                size: "md",
                className: variantIconColors[variant]
              }
            ) }),
            /* @__PURE__ */ jsxs("div", { className: "flex-1 min-w-0", children: [
              title && /* @__PURE__ */ jsx(Typography, { variant: "h6", className: "mb-1", children: title }),
              /* @__PURE__ */ jsx(Typography, { variant: "body2", children: content }),
              actions && /* @__PURE__ */ jsx("div", { className: "mt-3 flex gap-2", children: actions })
            ] }),
            (dismissible || dismissEvent || handleDismissCallback) && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: handleDismiss,
                className: cn(
                  "flex-shrink-0 p-1 transition-colors rounded-sm",
                  "hover:bg-muted"
                ),
                "aria-label": t("aria.closeAlert"),
                children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "sm" })
              }
            )
          ] })
        }
      );
    };
    Alert.displayName = "Alert";
  }
});
var FloatingActionButton;
var init_FloatingActionButton = __esm({
  "components/core/molecules/FloatingActionButton.tsx"() {
    "use client";
    init_Button();
    init_Box();
    init_Stack();
    init_Typography();
    init_cn();
    init_useEventBus();
    FloatingActionButton = ({
      action,
      actionPayload,
      actions,
      icon,
      onClick,
      variant,
      label,
      position = "bottom-right",
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolvedAction = icon ? {
        icon,
        onClick: () => {
          if (action) eventBus.emit(`UI:${action}`, actionPayload ?? {});
          onClick?.();
        },
        label,
        variant
      } : void 0;
      const [isExpanded, setIsExpanded] = useState(false);
      const fabRef = useRef(null);
      useEffect(() => {
        if (!isExpanded || !actions || actions.length <= 1) return;
        const handleClickOutside = (event) => {
          if (fabRef.current && !fabRef.current.contains(event.target)) {
            setIsExpanded(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, [isExpanded, actions]);
      const positionClasses2 = {
        "bottom-right": "bottom-6 right-6",
        "bottom-left": "bottom-6 left-6",
        "bottom-center": "bottom-6 left-1/2 -translate-x-1/2",
        "top-right": "top-6 right-6",
        "top-left": "top-6 left-6",
        "top-center": "top-6 left-1/2 -translate-x-1/2"
      };
      if (resolvedAction && (!actions || actions.length === 0)) {
        return /* @__PURE__ */ jsx(Box, { className: cn("fixed z-50", positionClasses2[position], className), children: /* @__PURE__ */ jsx(
          Button,
          {
            variant: resolvedAction.variant || "primary",
            size: "lg",
            icon: resolvedAction.icon,
            onClick: resolvedAction.onClick,
            className: "rounded-full shadow-lg",
            "aria-label": resolvedAction.label || "Action",
            children: resolvedAction.label && /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: resolvedAction.label })
          }
        ) });
      }
      if (actions && actions.length > 0) {
        const handleMainClick = () => {
          if (actions.length === 1) {
            if (actions[0].event) eventBus.emit(`UI:${actions[0].event}`, { actionId: actions[0].id });
            actions[0].onClick?.();
          } else {
            setIsExpanded(!isExpanded);
          }
        };
        return /* @__PURE__ */ jsxs(
          Box,
          {
            ref: fabRef,
            className: cn(
              "fixed z-50 flex flex-col items-end gap-3",
              positionClasses2[position],
              position.includes("left") && "items-start",
              className
            ),
            children: [
              isExpanded && actions.length > 1 && /* @__PURE__ */ jsx(
                VStack,
                {
                  className: cn(
                    "gap-3",
                    position.includes("left") ? "items-start" : "items-end"
                  ),
                  children: actions.map((actionItem, index) => /* @__PURE__ */ jsxs(
                    HStack,
                    {
                      align: "center",
                      gap: "sm",
                      className: "transition-all duration-fast",
                      style: {
                        opacity: isExpanded ? 1 : 0,
                        transform: isExpanded ? "translateY(0)" : "translateY(10px)",
                        transitionDelay: `${index * 50}ms`
                      },
                      children: [
                        position.includes("right") && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground dark:text-foreground bg-card dark:bg-card px-2 py-1 rounded shadow-sm whitespace-nowrap", children: actionItem.label }),
                        /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: actionItem.variant || "primary",
                            size: "lg",
                            icon: actionItem.icon,
                            onClick: () => {
                              setIsExpanded(false);
                              if (actionItem.event) eventBus.emit(`UI:${actionItem.event}`, { actionId: actionItem.id });
                              actionItem.onClick?.();
                            },
                            className: "rounded-full shadow-lg",
                            "aria-label": actionItem.label,
                            children: /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: actionItem.label })
                          }
                        ),
                        position.includes("left") && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground dark:text-foreground bg-card dark:bg-card px-2 py-1 rounded shadow-sm whitespace-nowrap", children: actionItem.label })
                      ]
                    },
                    actionItem.id
                  ))
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: isExpanded ? "secondary" : "primary",
                  size: "lg",
                  icon: isExpanded ? "x" : "plus",
                  onClick: handleMainClick,
                  className: "rounded-full shadow-lg transition-all duration-normal",
                  "aria-label": isExpanded ? "Close actions" : "Open actions",
                  "aria-expanded": isExpanded,
                  children: /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: isExpanded ? t("common.close") : t("common.open") })
                }
              )
            ]
          }
        );
      }
      return null;
    };
    FloatingActionButton.displayName = "FloatingActionButton";
  }
});
function ButtonPattern({
  action,
  onClick,
  event,
  icon,
  iconPosition,
  ...rest
}) {
  const resolvedAction = action ?? onClick ?? event;
  const iconProps = iconPosition === "right" ? { iconRight: icon } : { icon };
  return /* @__PURE__ */ jsx(Button, { ...rest, action: resolvedAction, ...iconProps });
}
function TextPattern({
  content,
  variant = "body",
  size = "md",
  weight = "normal",
  color,
  align,
  className
}) {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      variant,
      size,
      weight,
      className,
      style: { color, textAlign: align },
      children: content
    }
  );
}
function LabelPattern({
  text,
  htmlFor,
  required = false,
  className
}) {
  return /* @__PURE__ */ jsx(Label, { htmlFor, required, className, children: text });
}
function AlertPattern({
  message,
  title,
  variant = "info",
  dismissible = false,
  onDismiss,
  className
}) {
  const { emit } = useEventBus();
  const handleDismiss = () => {
    if (onDismiss) {
      emit(`UI:${onDismiss}`, {});
    }
  };
  return /* @__PURE__ */ jsx(
    Alert,
    {
      message,
      title,
      variant,
      dismissible,
      onDismiss: dismissible ? handleDismiss : void 0,
      className
    }
  );
}
var init_ComponentPatterns = __esm({
  "components/core/organisms/ComponentPatterns.tsx"() {
    "use client";
    init_useEventBus();
    init_Button();
    init_Label();
    init_Typography();
    init_Alert();
    init_FloatingActionButton();
    ButtonPattern.displayName = "ButtonPattern";
    TextPattern.displayName = "TextPattern";
    LabelPattern.displayName = "LabelPattern";
    AlertPattern.displayName = "AlertPattern";
  }
});
var init_perf = __esm({
  "lib/perf.ts"() {
  }
});
function getState() {
  if (typeof window !== "undefined") {
    const w = window;
    if (!w.__verificationRegistryState) {
      w.__verificationRegistryState = {
        checks: /* @__PURE__ */ new Map(),
        transitions: [],
        bridgeHealth: null,
        listeners: /* @__PURE__ */ new Set(),
        traitSnapshots: /* @__PURE__ */ new Map()
      };
    }
    return w.__verificationRegistryState;
  }
  return {
    checks: /* @__PURE__ */ new Map(),
    transitions: [],
    bridgeHealth: null,
    listeners: /* @__PURE__ */ new Set(),
    traitSnapshots: /* @__PURE__ */ new Map()
  };
}
function getAllChecks() {
  return Array.from(getState().checks.values());
}
function getTransitions() {
  return [...getState().transitions];
}
function getBridgeHealth() {
  const bh = getState().bridgeHealth;
  return bh ? { ...bh } : null;
}
function getSummary() {
  const allChecks = getAllChecks();
  return {
    totalChecks: allChecks.length,
    passed: allChecks.filter((c) => c.status === "pass").length,
    failed: allChecks.filter((c) => c.status === "fail").length,
    warnings: allChecks.filter((c) => c.status === "warn").length,
    pending: allChecks.filter((c) => c.status === "pending").length
  };
}
function getSnapshot() {
  return {
    checks: getAllChecks(),
    transitions: getTransitions(),
    bridge: getBridgeHealth(),
    summary: getSummary(),
    traits: getTraitSnapshots()
  };
}
function getTraitSnapshots() {
  const snapshots = [];
  for (const [traitName, getter] of getState().traitSnapshots.entries()) {
    try {
      snapshots.push(getter());
    } catch (err) {
      log3.error("traitSnapshot getter failed", { trait: traitName, err: String(err) });
    }
  }
  return snapshots;
}
function subscribeToVerification(listener) {
  getState().listeners.add(listener);
  return () => getState().listeners.delete(listener);
}
function defaultGetTraitState(traitName) {
  const getter = getState().traitSnapshots.get(traitName);
  if (getter === void 0) return void 0;
  try {
    return getter().currentState;
  } catch {
    return void 0;
  }
}
function exposeOnWindow() {
  if (typeof window === "undefined") return;
  if (!window.__orbitalVerification) {
    window.__orbitalVerification = {
      getSnapshot,
      getChecks: getAllChecks,
      getTransitions,
      getBridge: getBridgeHealth,
      getSummary,
      waitForTransition,
      getTraitSnapshots,
      getTraitState: defaultGetTraitState
    };
  } else {
    if (!window.__orbitalVerification.getTraitSnapshots) {
      window.__orbitalVerification.getTraitSnapshots = getTraitSnapshots;
    }
    if (!window.__orbitalVerification.getTraitState) {
      window.__orbitalVerification.getTraitState = defaultGetTraitState;
    }
  }
}
function waitForTransition(event, timeoutMs = 1e4) {
  return new Promise((resolve) => {
    const existing = getState().transitions.find((t) => t.event === event);
    if (existing) {
      resolve(existing);
      return;
    }
    const timeout = setTimeout(() => {
      unsub();
      resolve(null);
    }, timeoutMs);
    const unsub = subscribeToVerification(() => {
      const found = getState().transitions.find((t) => t.event === event);
      if (found) {
        clearTimeout(timeout);
        unsub();
        resolve(found);
      }
    });
  });
}
function bindCanvasCapture(captureFn) {
  if (typeof window === "undefined") return;
  exposeOnWindow();
  if (window.__orbitalVerification) {
    window.__orbitalVerification.captureFrame = captureFn;
  }
}
function bindLastDrawables(getDrawables) {
  if (typeof window === "undefined") return;
  exposeOnWindow();
  if (window.__orbitalVerification) {
    window.__orbitalVerification.getLastDrawables = getDrawables;
  }
}
function updateAssetStatus(url, status) {
  if (typeof window === "undefined") return;
  exposeOnWindow();
  if (window.__orbitalVerification) {
    if (!window.__orbitalVerification.assetStatus) {
      window.__orbitalVerification.assetStatus = {};
    }
    window.__orbitalVerification.assetStatus[url] = status;
  }
}
var log3;
var init_verificationRegistry = __esm({
  "lib/verificationRegistry.ts"() {
    log3 = createLogger("almadar:bridge");
    exposeOnWindow();
  }
});

// lib/imageCache.ts
function startLoad(url, onReady, existing) {
  const img = new Image();
  img.crossOrigin = "anonymous";
  const entry = existing ?? { img, status: "pending" };
  entry.img = img;
  if (onReady) entry.onReady = onReady;
  img.onload = () => {
    entry.status = "loaded";
    updateAssetStatus(url, "loaded");
    entry.onReady?.();
  };
  img.onerror = () => {
    entry.status = "failed";
    entry.failedAt = Date.now();
    updateAssetStatus(url, "failed");
    entry.onReady?.();
  };
  img.src = url;
  return entry;
}
function getOrLoadImage(url, onReady) {
  if (!url || typeof window === "undefined") return null;
  const existing = cache.get(url);
  if (existing) {
    if (existing.status === "loaded") return existing.img;
    if (existing.status === "pending" && onReady) existing.onReady = onReady;
    if (existing.status === "failed" && Date.now() - (existing.failedAt ?? 0) >= RETRY_AFTER_MS) {
      existing.failedAt = Date.now();
      startLoad(url, onReady, existing);
    }
    return null;
  }
  const entry = startLoad(url, onReady);
  cache.set(url, entry);
  updateAssetStatus(url, "pending");
  return null;
}
function getImageStatus(url) {
  return cache.get(url)?.status;
}
var RETRY_AFTER_MS, cache;
var init_imageCache = __esm({
  "lib/imageCache.ts"() {
    "use client";
    init_verificationRegistry();
    RETRY_AFTER_MS = 5e3;
    cache = /* @__PURE__ */ new Map();
  }
});

// lib/webPainter2d.ts
function makeNoiseTile(alpha, color) {
  const tile = document.createElement("canvas");
  tile.width = NOISE_CELLS;
  tile.height = NOISE_CELLS;
  const t = tile.getContext("2d");
  if (t) {
    t.fillStyle = color;
    for (let y = 0; y < NOISE_CELLS; y++) {
      for (let x = 0; x < NOISE_CELLS; x++) {
        t.globalAlpha = noiseHash(x, y) * alpha;
        t.fillRect(x, y, 1, 1);
      }
    }
  }
  return tile;
}
function createWebPainter(ctx, onAssetLoad) {
  let vw = 0;
  let vh = 0;
  const patternCache = /* @__PURE__ */ new Map();
  const tracePoly = (points, closed) => {
    if (points.length === 0) return;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (let i = 1; i < points.length; i++) ctx.lineTo(points[i].x, points[i].y);
    if (closed) ctx.closePath();
  };
  const toCanvasPattern = (style) => {
    const key = JSON.stringify(style);
    let pattern = patternCache.get(key);
    if (pattern === void 0) {
      if (style.kind === "noise") {
        pattern = ctx.createPattern(makeNoiseTile(style.alpha ?? 0.12, style.color ?? "#000000"), "repeat");
      } else {
        const img = getOrLoadImage(style.url, onAssetLoad);
        if (!img) return "rgba(0,0,0,0)";
        pattern = ctx.createPattern(img, "repeat");
      }
      if (pattern && style.scale !== void 0 && style.scale !== 1) {
        pattern.setTransform(new DOMMatrix().scale(style.scale));
      }
      patternCache.set(key, pattern);
    }
    return pattern ?? "rgba(0,0,0,0)";
  };
  const toCanvasStyle = (style) => {
    if (typeof style === "string") return style;
    if (style.kind === "noise" || style.kind === "image") return toCanvasPattern(style);
    const g = style.kind === "linear" ? ctx.createLinearGradient(style.x1, style.y1, style.x2, style.y2) : style.kind === "conic" ? ctx.createConicGradient(style.angle, style.cx, style.cy) : ctx.createRadialGradient(style.cx, style.cy, 0, style.cx, style.cy, style.r);
    for (const stop of style.stops) g.addColorStop(stop.offset, stop.color);
    return g;
  };
  return {
    setViewport(width, height, dpr) {
      vw = width;
      vh = height;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    },
    clear() {
      ctx.clearRect(0, 0, vw, vh);
    },
    save() {
      ctx.save();
    },
    restore() {
      ctx.restore();
    },
    translate(x, y) {
      ctx.translate(x, y);
    },
    scale(sx, sy) {
      ctx.scale(sx, sy);
    },
    rotate(radians) {
      ctx.rotate(radians);
    },
    setAlpha(alpha) {
      ctx.globalAlpha = alpha;
    },
    setShadow(shadow) {
      ctx.shadowColor = shadow ? shadow.color : "transparent";
      ctx.shadowBlur = shadow ? shadow.blur : 0;
    },
    setBlend(mode) {
      ctx.globalCompositeOperation = mode ?? "source-over";
    },
    setLineDash(pattern, offset = 0) {
      ctx.setLineDash(pattern ? [...pattern] : []);
      ctx.lineDashOffset = offset;
    },
    setBlur(px) {
      ctx.filter = px && px > 0 ? `blur(${px}px)` : "none";
    },
    clipPath(d) {
      ctx.clip(new Path2D(d));
    },
    resolveTexture(url) {
      const img = getOrLoadImage(url, onAssetLoad);
      if (!img) return null;
      let handle = handleByImage.get(img);
      if (!handle) {
        handle = { width: img.naturalWidth, height: img.naturalHeight };
        handleByImage.set(img, handle);
        imageByHandle.set(handle, img);
      }
      return handle;
    },
    blit(tex, dest, src) {
      const img = imageByHandle.get(tex);
      if (!img) return;
      const dw = dest.w ?? (src ? src.w : tex.width);
      const dh = dest.h ?? (src ? src.h : tex.height);
      if (src) {
        ctx.drawImage(img, src.x, src.y, src.w, src.h, dest.x, dest.y, dw, dh);
      } else {
        ctx.drawImage(img, dest.x, dest.y, dw, dh);
      }
    },
    blitTransformed(tex, src, affine) {
      const img = imageByHandle.get(tex);
      if (!img) return;
      ctx.save();
      ctx.transform(affine[0], affine[1], affine[2], affine[3], affine[4], affine[5]);
      ctx.drawImage(img, src.x, src.y, src.w, src.h, src.x, src.y, src.w, src.h);
      ctx.restore();
    },
    fillRect(x, y, w, h, style) {
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fillRect(x, y, w, h);
    },
    strokeRect(x, y, w, h, style, lineWidth = 1) {
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.strokeRect(x, y, w, h);
    },
    fillPoly(points, style) {
      if (points.length === 0) return;
      tracePoly(points, true);
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fill();
    },
    strokePoly(points, style, lineWidth = 1, closed = false) {
      if (points.length === 0) return;
      tracePoly(points, closed);
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.stroke();
    },
    fillEllipse(cx, cy, rx, ry, style) {
      ctx.beginPath();
      ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fill();
    },
    strokeEllipse(cx, cy, rx, ry, style, lineWidth = 1) {
      ctx.beginPath();
      ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.stroke();
    },
    fillPath(d, style) {
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fill(new Path2D(d));
    },
    strokePath(d, style, lineWidth = 1) {
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.stroke(new Path2D(d));
    },
    text(str2, x, y, style) {
      if (style.font) ctx.font = style.font;
      ctx.fillStyle = style.color;
      ctx.textAlign = style.align ?? "left";
      ctx.textBaseline = style.baseline ?? "alphabetic";
      ctx.fillText(str2, x, y);
    }
  };
}
var handleByImage, imageByHandle, noiseHash, NOISE_CELLS;
var init_webPainter2d = __esm({
  "lib/webPainter2d.ts"() {
    "use client";
    init_imageCache();
    handleByImage = /* @__PURE__ */ new WeakMap();
    imageByHandle = /* @__PURE__ */ new WeakMap();
    noiseHash = (x, y) => {
      const s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
      return s - Math.floor(s);
    };
    NOISE_CELLS = 32;
  }
});

// lib/drawable/contract.ts
function isValidScenePos(pos) {
  return Number.isFinite(pos?.x) && Number.isFinite(pos?.y);
}
function spriteRect(projector, node, natural) {
  const tw = projector.tileWidth;
  const fallbackW = projector.worldPixelDirect ? natural?.w ?? 0 : tw;
  const fallbackH = projector.worldPixelDirect ? natural?.h ?? 0 : tw;
  const w = node.width !== void 0 ? node.width * tw : fallbackW;
  const h = node.height !== void 0 ? node.height * tw : fallbackH;
  const anchor = node.anchor ?? "top-left";
  const p = projector.anchorPoint(node.position, anchor);
  return {
    x: anchor === "top-left" ? p.x : p.x - w / 2,
    y: anchor === "ground" ? p.y - h : anchor === "center" ? p.y - h / 2 : p.y,
    w,
    h
  };
}
var init_contract = __esm({
  "lib/drawable/contract.ts"() {
  }
});

// lib/spriteSheetConstants.ts
var SHEET_COLUMNS, SPRITE_SHEET_LAYOUT;
var init_spriteSheetConstants = __esm({
  "lib/spriteSheetConstants.ts"() {
    SHEET_COLUMNS = 8;
    SPRITE_SHEET_LAYOUT = {
      idle: { row: 0, frames: 4, frameRate: 6, loop: true },
      walk: { row: 1, frames: 8, frameRate: 10, loop: true },
      attack: { row: 2, frames: 6, frameRate: 12, loop: false },
      hit: { row: 3, frames: 3, frameRate: 8, loop: false },
      death: { row: 4, frames: 6, frameRate: 8, loop: false }
    };
  }
});
function inferDirection(dx, dy) {
  if (dx === 0 && dy === 0) return "se";
  if (dx >= 0 && dy >= 0) return "se";
  if (dx <= 0 && dy >= 0) return "sw";
  if (dx >= 0 && dy <= 0) return "ne";
  return "nw";
}
function resolveSheetDirection(facing) {
  switch (facing) {
    case "se":
      return { sheetDir: "se", flipX: false };
    case "sw":
      return { sheetDir: "sw", flipX: false };
    case "ne":
      return { sheetDir: "sw", flipX: true };
    case "nw":
      return { sheetDir: "se", flipX: true };
  }
}
function frameRect(frame, row, columns, frameWidth, frameHeight) {
  return {
    sx: frame % columns * frameWidth,
    sy: row * frameHeight,
    sw: frameWidth,
    sh: frameHeight
  };
}
function getCurrentFrameFromDef(def, elapsed) {
  const frameDuration = 1e3 / def.frameRate;
  const totalDuration = def.frames * frameDuration;
  if (def.loop) {
    const frame2 = Math.floor(elapsed % totalDuration / frameDuration);
    return { frame: frame2, finished: false };
  }
  if (elapsed >= totalDuration) {
    return { frame: def.frames - 1, finished: true };
  }
  const frame = Math.floor(elapsed / frameDuration);
  return { frame, finished: false };
}
function getCurrentFrame(animName, elapsed) {
  const def = SPRITE_SHEET_LAYOUT[animName] ?? { frames: 4, frameRate: 6, loop: true };
  return getCurrentFrameFromDef(def, elapsed);
}
function resolveFrame(sheetUrls, frameDims, animState) {
  if (!sheetUrls) return null;
  const real = sheetUrls[animState.direction];
  const { sheetUrl, flipX } = real ? { sheetUrl: real, flipX: false } : (() => {
    const legacy = resolveSheetDirection(animState.direction);
    return { sheetUrl: sheetUrls[legacy.sheetDir], flipX: legacy.flipX };
  })();
  if (!sheetUrl) return null;
  const def = SPRITE_SHEET_LAYOUT[animState.animation] ?? { row: 0, frames: 4};
  const { frame } = getCurrentFrame(animState.animation, animState.elapsed);
  const rect = frameRect(frame, def.row, def.frames, frameDims.width, frameDims.height);
  return {
    sheetUrl,
    sx: rect.sx,
    sy: rect.sy,
    sw: rect.sw,
    sh: rect.sh,
    flipX
  };
}
function createUnitAnimationState(unitId) {
  return {
    unitId,
    animation: "idle",
    direction: "se",
    frame: 0,
    elapsed: 0,
    queuedAnimation: null,
    finished: false
  };
}
function transitionAnimation(state, newAnim, direction) {
  if (state.animation === "death" && state.finished) return state;
  if (state.animation === newAnim && SPRITE_SHEET_LAYOUT[newAnim]?.loop) {
    return direction ? { ...state, direction } : state;
  }
  return {
    ...state,
    animation: newAnim,
    direction: direction ?? state.direction,
    frame: 0,
    elapsed: 0,
    queuedAnimation: null,
    finished: false
  };
}
function tickAnimationState(state, deltaMs) {
  const newElapsed = state.elapsed + deltaMs;
  const { frame, finished } = getCurrentFrame(state.animation, newElapsed);
  const def = SPRITE_SHEET_LAYOUT[state.animation];
  if (finished && !def?.loop && !state.finished) {
    if (state.animation === "death") {
      return { ...state, elapsed: newElapsed, frame, finished: true };
    }
    const nextAnim = state.queuedAnimation ?? "idle";
    return {
      ...state,
      animation: nextAnim,
      elapsed: 0,
      frame: 0,
      queuedAnimation: null,
      finished: false
    };
  }
  return { ...state, elapsed: newElapsed, frame, finished };
}
var init_spriteAnimation = __esm({
  "lib/spriteAnimation.ts"() {
    init_spriteSheetConstants();
  }
});
function warnMissingOnce(reason, node) {
  const key = `${reason}:${node.asset.url}:${String(node.asset.atlas)}:${String(node.asset.sprite)}`;
  if (loggedMissing.has(key)) return;
  loggedMissing.add(key);
  spriteLog.warn("draw-sprite asset unresolvable \u2014 painting fallback square", { reason, url: node.asset.url, atlas: node.asset.atlas, sprite: node.asset.sprite });
}
function paintFallbackSquare(painter, node, dctx, reason) {
  warnMissingOnce(reason, node);
  const tw = dctx.projector.tileWidth;
  const natural = dctx.projector.worldPixelDirect ? FALLBACK_WORLD_PX : tw;
  const rect = spriteRect(dctx.projector, node, { w: natural, h: natural });
  painter.save();
  if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
  painter.fillRect(rect.x, rect.y, rect.w, rect.h, "#9b8f7f");
  painter.strokeRect(rect.x, rect.y, rect.w, rect.h, "#5e564b", Math.max(1, tw / 32));
  painter.restore();
}
function isAnimatedSprite(node) {
  return node.animation !== void 0 && typeof node.asset?.atlas === "string";
}
function DrawSprite(_props) {
  return null;
}
var spriteLog, loggedMissing, FALLBACK_WORLD_PX, paintSprite;
var init_DrawSprite = __esm({
  "components/game/atoms/DrawSprite.tsx"() {
    "use client";
    init_atlasSlice();
    init_spriteAnimation();
    init_imageCache();
    init_contract();
    spriteLog = createLogger("almadar:ui:draw-sprite");
    loggedMissing = /* @__PURE__ */ new Set();
    FALLBACK_WORLD_PX = 32;
    paintSprite = (painter, node, dctx) => {
      if (!node.asset?.url || !isValidScenePos(node.position)) return;
      const tex = painter.resolveTexture(node.asset.url);
      if (!tex) {
        if (getImageStatus(node.asset.url) === "failed") paintFallbackSquare(painter, node, dctx, "texture-failed");
        return;
      }
      let src = typeof node.frame === "object" ? node.frame : void 0;
      if (!src && node.animation !== void 0 && typeof node.asset.atlas === "string") {
        const atlas = getAtlas(node.asset.atlas, dctx.invalidate);
        if (!atlas) {
          if (atlasFailed(node.asset.atlas)) paintFallbackSquare(painter, node, dctx, "atlas-failed");
          return;
        }
        if (isSpriteSheetAtlas(atlas)) {
          const def = atlas.animations[node.animation];
          if (!def) {
            paintFallbackSquare(painter, node, dctx, "sprite-missing");
            return;
          }
          const { frame } = getCurrentFrameFromDef(node.loop === void 0 ? def : { ...def, loop: node.loop }, node.clockMs ?? dctx.time);
          const r = frameRect(frame, def.row, atlas.columns, atlas.frameWidth, atlas.frameHeight);
          if (![r.sx, r.sy, r.sw, r.sh].every(Number.isFinite)) {
            paintFallbackSquare(painter, node, dctx, "sprite-missing");
            return;
          }
          src = { x: r.sx, y: r.sy, w: r.sw, h: r.sh };
        }
      }
      if (!src && isAtlasAsset(node.asset)) {
        const atlas = getAtlas(node.asset.atlas, dctx.invalidate);
        if (!atlas) {
          if (atlasFailed(node.asset.atlas)) paintFallbackSquare(painter, node, dctx, "atlas-failed");
          return;
        }
        const r = subRectFor(atlas, node.asset.sprite);
        if (!r) {
          paintFallbackSquare(painter, node, dctx, "sprite-missing");
          return;
        }
        src = { x: r.sx, y: r.sy, w: r.sw, h: r.sh };
      }
      const rect = spriteRect(dctx.projector, node, src ? { w: src.w, h: src.h } : { w: tex.width, h: tex.height });
      const { w, h } = rect;
      const dx = rect.x;
      const dy = rect.y;
      painter.save();
      if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
      if (node.shadow) painter.setShadow(node.shadow);
      if (node.rotation) {
        const cx = dx + w / 2;
        const cy = dy + h / 2;
        painter.translate(cx, cy);
        painter.rotate(node.rotation);
        painter.translate(-cx, -cy);
      }
      if (node.flipX) {
        const cx = dx + w / 2;
        painter.translate(cx, 0);
        painter.scale(-1, 1);
        painter.translate(-cx, 0);
      }
      painter.blit(tex, { x: dx, y: dy, w, h }, src);
      painter.restore();
    };
  }
});
var DrawableRegistryContext;
var init_registry = __esm({
  "lib/drawable/registry.ts"() {
    DrawableRegistryContext = createContext(null);
  }
});
function isAnimatedShape(node) {
  return Boolean(node.animation && node.animation.durationMs > 0 && node.animation.keyframes.length > 0);
}
function applyShapeAnimation(node, timeMs) {
  const anim = node.animation;
  if (!anim || !(anim.durationMs > 0) || anim.keyframes.length === 0) return node;
  const frames = [...anim.keyframes].sort((a, b) => a.at - b.at);
  const cycle = timeMs / anim.durationMs;
  const t = anim.loop === false ? Math.min(cycle, 1) : cycle - Math.floor(cycle);
  const out = { ...node };
  const trackValue = (key) => {
    const defined = frames.filter((f3) => f3[key] !== void 0);
    if (defined.length === 0) return void 0;
    let prev;
    let next;
    for (const f3 of defined) {
      if (f3.at <= t) prev = f3;
      else if (!next) next = f3;
    }
    if (!prev) return defined[0][key];
    if (!next) return prev[key];
    const span = next.at - prev.at;
    const k = span > 0 ? (t - prev.at) / span : 1;
    const a = prev[key];
    const b = next[key];
    if (typeof a === "number" && typeof b === "number") return lerp(a, b, k);
    return a;
  };
  for (const key of NUMERIC_TRACKS) {
    const v = trackValue(key);
    if (v !== void 0) out[key] = v;
  }
  const fill = trackValue("fill");
  if (fill !== void 0) out.fill = fill;
  const stroke = trackValue("stroke");
  if (stroke !== void 0) out.stroke = stroke;
  const shadowFrames = frames.filter((f3) => f3.shadow !== void 0);
  if (shadowFrames.length > 0) {
    const sh = trackValue("shadow");
    if (sh !== void 0) {
      let prevSh;
      let nextSh;
      for (const f3 of shadowFrames) {
        if (f3.at <= t) prevSh = f3;
        else if (!nextSh) nextSh = f3;
      }
      if (prevSh?.shadow && nextSh?.shadow) {
        const span = nextSh.at - prevSh.at;
        const k = span > 0 ? (t - prevSh.at) / span : 1;
        out.shadow = { color: prevSh.shadow.color, blur: lerp(prevSh.shadow.blur, nextSh.shadow.blur, k) };
      } else {
        out.shadow = sh;
      }
    }
  }
  return out;
}
function gradientStyle(g, ox, oy, scale) {
  if (g.kind === "linear") {
    if (!g.from || !g.to) return void 0;
    return {
      kind: "linear",
      x1: ox + g.from.x * scale,
      y1: oy + g.from.y * scale,
      x2: ox + g.to.x * scale,
      y2: oy + g.to.y * scale,
      stops: g.stops
    };
  }
  if (g.kind === "conic") {
    if (!g.center) return void 0;
    return {
      kind: "conic",
      cx: ox + g.center.x * scale,
      cy: oy + g.center.y * scale,
      angle: g.angle ?? 0,
      stops: g.stops
    };
  }
  if (!g.center || g.radius === void 0) return void 0;
  return {
    kind: "radial",
    cx: ox + g.center.x * scale,
    cy: oy + g.center.y * scale,
    r: g.radius * scale,
    stops: g.stops
  };
}
function patternStyle(p, unit) {
  if (p.kind === "image") {
    if (!p.url) return void 0;
    return { kind: "image", url: p.url, scale: (p.scale ?? 1) / unit };
  }
  return { kind: "noise", scale: (p.scale ?? 2) / unit, alpha: p.alpha, color: p.color };
}
function DrawShape(props) {
  const register = useContext(DrawableRegistryContext);
  if (register) {
    const { opacity, ...rest } = props;
    const node = {
      ...rest,
      type: "draw-shape",
      ...opacity !== void 0 && opacity > 0 ? { opacity } : {}
    };
    register(node);
  }
  return null;
}
var NUMERIC_TRACKS, lerp, paintShape;
var init_DrawShape = __esm({
  "components/game/atoms/DrawShape.tsx"() {
    "use client";
    init_contract();
    init_registry();
    NUMERIC_TRACKS = [
      "offsetX",
      "offsetY",
      "rotate",
      "opacity",
      "radiusX",
      "radiusY",
      "width",
      "height",
      "strokeWidth",
      "strokeDashOffset",
      "blur"
    ];
    lerp = (a, b, k) => a + (b - a) * k;
    paintShape = (painter, rawNode, dctx) => {
      const node = dctx.time > 0 ? applyShapeAnimation(rawNode, dctx.time) : rawNode;
      if (!isValidScenePos(node.position)) return;
      painter.save();
      if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
      const origin = dctx.projector.project(node.position);
      const tileWidth = dctx.projector.tileWidth;
      const groupScale = dctx.groupScale ?? 1;
      const strokePx = (node.strokeWidth ?? 1) / groupScale;
      if (node.blendMode) painter.setBlend(node.blendMode);
      if (node.strokeDash && node.strokeDash.length > 0) {
        painter.setLineDash(
          node.strokeDash.map((v) => v / groupScale),
          (node.strokeDashOffset ?? 0) / groupScale
        );
      }
      if (node.blur !== void 0 && node.blur > 0) painter.setBlur(node.blur / groupScale);
      if (node.rotate) {
        const pivot = node.pivot ?? { x: 0.5, y: 0.5 };
        const px = origin.x + pivot.x * tileWidth;
        const py = origin.y + pivot.y * tileWidth;
        painter.translate(px, py);
        painter.rotate(node.rotate);
        painter.translate(-px, -py);
      }
      if (node.shadow) painter.setShadow({ color: node.shadow.color, blur: node.shadow.blur * tileWidth * groupScale });
      const fill = node.fill === "none" ? void 0 : node.fill;
      const stroke = node.stroke === "none" ? void 0 : node.stroke;
      const pxFill = node.gradient ? gradientStyle(node.gradient, origin.x, origin.y, tileWidth) ?? fill : fill;
      const pxStroke = node.strokeGradient ? gradientStyle(node.strokeGradient, origin.x, origin.y, tileWidth) ?? stroke : stroke;
      const patFill = node.fillPattern ? patternStyle(node.fillPattern, groupScale) : void 0;
      switch (node.shape) {
        case "cell": {
          const pts = dctx.projector.cellPath(node.position);
          if (pxFill) painter.fillPoly(pts, pxFill);
          if (patFill) painter.fillPoly(pts, patFill);
          if (pxStroke) painter.strokePoly(pts, pxStroke, strokePx, true);
          break;
        }
        case "rect": {
          const p = dctx.projector.anchorPoint(node.position, node.anchor ?? "top-left");
          const tw = dctx.projector.tileWidth;
          const x = p.x + (node.offsetX ?? 0) * tw;
          const y = p.y + (node.offsetY ?? 0) * tw;
          const w = (node.width ?? 0) * tw;
          const h = (node.height ?? 0) * tw;
          if (pxFill) painter.fillRect(x, y, w, h, pxFill);
          if (patFill) painter.fillRect(x, y, w, h, patFill);
          if (pxStroke) painter.strokeRect(x, y, w, h, pxStroke, strokePx);
          break;
        }
        case "ellipse": {
          const p = dctx.projector.anchorPoint(node.position, node.anchor ?? "ground");
          const tw = dctx.projector.tileWidth;
          const cx = p.x + (node.offsetX ?? 0) * tw;
          const cy = p.y + (node.offsetY ?? 0) * tw;
          const rx = (node.radiusX ?? 0) * tw;
          const ry = (node.radiusY ?? node.radiusX ?? 0) * tw;
          if (pxFill) painter.fillEllipse(cx, cy, rx, ry, pxFill);
          if (patFill) painter.fillEllipse(cx, cy, rx, ry, patFill);
          if (pxStroke) painter.strokeEllipse(cx, cy, rx, ry, pxStroke, strokePx);
          break;
        }
        case "poly": {
          const pts = (node.points ?? []).map((pt) => ({
            x: origin.x + ((node.offsetX ?? 0) + pt.x) * tileWidth,
            y: origin.y + ((node.offsetY ?? 0) + pt.y) * tileWidth
          }));
          if (pxFill) painter.fillPoly(pts, pxFill);
          if (patFill) painter.fillPoly(pts, patFill);
          if (pxStroke) painter.strokePoly(pts, pxStroke, strokePx, true);
          break;
        }
        case "path": {
          if (!node.d) break;
          painter.translate(origin.x + (node.offsetX ?? 0) * tileWidth, origin.y + (node.offsetY ?? 0) * tileWidth);
          painter.scale(tileWidth, tileWidth);
          if (node.strokeDash && node.strokeDash.length > 0) {
            painter.setLineDash(
              node.strokeDash.map((v) => v / (groupScale * tileWidth)),
              (node.strokeDashOffset ?? 0) / (groupScale * tileWidth)
            );
          }
          if (node.blur !== void 0 && node.blur > 0) painter.setBlur(node.blur / (groupScale * tileWidth));
          const localFill = node.gradient ? gradientStyle(node.gradient, 0, 0, 1) ?? fill : fill;
          const localStroke = node.strokeGradient ? gradientStyle(node.strokeGradient, 0, 0, 1) ?? stroke : stroke;
          const localPat = node.fillPattern ? patternStyle(node.fillPattern, groupScale * tileWidth) : void 0;
          if (localFill) painter.fillPath(node.d, localFill);
          if (localPat) painter.fillPath(node.d, localPat);
          if (localStroke) painter.strokePath(node.d, localStroke, strokePx / tileWidth);
          break;
        }
      }
      painter.restore();
    };
  }
});

// components/game/atoms/DrawText.tsx
function DrawText(_props) {
  return null;
}
var paintText;
var init_DrawText = __esm({
  "components/game/atoms/DrawText.tsx"() {
    "use client";
    init_contract();
    paintText = (painter, node, dctx) => {
      if (!isValidScenePos(node.position)) return;
      const p = dctx.projector.anchorPoint(node.position, node.anchor ?? "center");
      const x = p.x + (node.offsetX ?? 0);
      const y = p.y + (node.offsetY ?? 0);
      painter.save();
      if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
      painter.text(node.text, x, y, { color: node.color, font: node.font, align: node.align, baseline: node.baseline });
      painter.restore();
    };
  }
});
function isAnimatedGroup(node) {
  return Boolean(node.animation && node.animation.durationMs > 0 && node.animation.keyframes.length > 0);
}
function DrawGroup(props) {
  const register = useContext(DrawableRegistryContext);
  if (register) register({ ...props, type: "draw-group" });
  return null;
}
var init_DrawGroup = __esm({
  "components/game/atoms/DrawGroup.tsx"() {
    "use client";
    init_registry();
  }
});

// lib/skinning.ts
function composeAffine(a, b) {
  return [
    a[0] * b[0] + a[2] * b[1],
    a[1] * b[0] + a[3] * b[1],
    a[0] * b[2] + a[2] * b[3],
    a[1] * b[2] + a[3] * b[3],
    a[0] * b[4] + a[2] * b[5] + a[4],
    a[1] * b[4] + a[3] * b[5] + a[5]
  ];
}
function invertAffine(m) {
  const det = m[0] * m[3] - m[1] * m[2];
  if (!Number.isFinite(det) || Math.abs(det) < 1e-12) return IDENTITY;
  const inv = 1 / det;
  return [
    m[3] * inv,
    -m[1] * inv,
    -m[2] * inv,
    m[0] * inv,
    (m[2] * m[5] - m[3] * m[4]) * inv,
    (m[1] * m[4] - m[0] * m[5]) * inv
  ];
}
function applyAffine(m, x, y) {
  return [m[0] * x + m[2] * y + m[4], m[1] * x + m[3] * y + m[5]];
}
function rotationAbout(pivot, degrees) {
  const r = degrees * Math.PI / 180;
  const cos = Math.cos(r);
  const sin = Math.sin(r);
  const [px, py] = pivot;
  return [cos, sin, -sin, cos, px - cos * px + sin * py, py - sin * px - cos * py];
}
function computeWorldMatrices(bones, pose) {
  const indexByName = /* @__PURE__ */ new Map();
  bones.forEach((b, i) => indexByName.set(b.name, i));
  const world = new Array(bones.length);
  const visiting = /* @__PURE__ */ new Set();
  const resolve = (i) => {
    const cached = world[i];
    if (cached) return cached;
    if (visiting.has(i)) return IDENTITY;
    visiting.add(i);
    const b = bones[i];
    const parentIndex = b.parent === null ? void 0 : indexByName.get(b.parent);
    const parentWorld = parentIndex === void 0 ? IDENTITY : resolve(parentIndex);
    const local = rotationAbout(b.pivot, pose[b.name] ?? 0);
    const m = composeAffine(parentWorld, local);
    visiting.delete(i);
    world[i] = m;
    return m;
  };
  return bones.map((_, i) => resolve(i));
}
function skinVertices(mesh, bindWorld, curWorld) {
  const skinMats = /* @__PURE__ */ new Map();
  const skinMat = (bone) => {
    let m = skinMats.get(bone);
    if (!m) {
      m = composeAffine(curWorld[bone] ?? IDENTITY, invertAffine(bindWorld[bone] ?? IDENTITY));
      skinMats.set(bone, m);
    }
    return m;
  };
  return mesh.vertices.map((v) => {
    if (v.weights.length === 0) return [v.x, v.y];
    let x = 0;
    let y = 0;
    for (const { bone, w } of v.weights) {
      const [bx, by] = applyAffine(skinMat(bone), v.x, v.y);
      x += w * bx;
      y += w * by;
    }
    return [x, y];
  });
}
function triangleAffine(src, dst) {
  const [s0, s1, s2] = src;
  const det = s0[0] * (s1[1] - s2[1]) + s1[0] * (s2[1] - s0[1]) + s2[0] * (s0[1] - s1[1]);
  if (!Number.isFinite(det) || Math.abs(det) < 1e-12) return null;
  const [d0, d1, d2] = dst;
  const a = (d0[0] * (s1[1] - s2[1]) + d1[0] * (s2[1] - s0[1]) + d2[0] * (s0[1] - s1[1])) / det;
  const c = (d0[0] * (s2[0] - s1[0]) + d1[0] * (s0[0] - s2[0]) + d2[0] * (s1[0] - s0[0])) / det;
  const e = (d0[0] * (s1[0] * s2[1] - s2[0] * s1[1]) + d1[0] * (s2[0] * s0[1] - s0[0] * s2[1]) + d2[0] * (s0[0] * s1[1] - s1[0] * s0[1])) / det;
  const b = (d0[1] * (s1[1] - s2[1]) + d1[1] * (s2[1] - s0[1]) + d2[1] * (s0[1] - s1[1])) / det;
  const d = (d0[1] * (s2[0] - s1[0]) + d1[1] * (s0[0] - s2[0]) + d2[1] * (s1[0] - s0[0])) / det;
  const f3 = (d0[1] * (s1[0] * s2[1] - s2[0] * s1[1]) + d1[1] * (s2[0] * s0[1] - s0[0] * s2[1]) + d2[1] * (s0[0] * s1[1] - s1[0] * s0[1])) / det;
  return [a, b, c, d, e, f3];
}
function isRigBundle(json) {
  return json.mesh !== void 0 || json.bones !== void 0;
}
function getRigBundle(url, onReady) {
  if (meshCache.has(url)) return meshCache.get(url) ?? void 0;
  meshCache.set(url, void 0);
  fetch(url).then((r) => {
    if (!r.ok) throw new Error(`rigbundle fetch failed: HTTP ${r.status}`);
    return r.json();
  }).then((json) => {
    const ok = isRigBundle(json) || Array.isArray(json.vertices);
    if (!ok) throw new Error("rigbundle payload is neither a SkinMesh nor a rigbundle");
    meshCache.set(url, json);
    onReady();
  }).catch(() => {
    meshCache.set(url, null);
    onReady();
  });
  return void 0;
}
function skinMeshFailed(url) {
  return meshCache.get(url) === null;
}
function vertexBounds(points) {
  if (points.length === 0) return null;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const [x, y] of points) {
    if (x < minX) minX = x;
    if (y < minY) minY = y;
    if (x > maxX) maxX = x;
    if (y > maxY) maxY = y;
  }
  return { minX, minY, maxX, maxY };
}
var IDENTITY, meshCache;
var init_skinning = __esm({
  "lib/skinning.ts"() {
    IDENTITY = [1, 0, 0, 1, 0, 0];
    meshCache = /* @__PURE__ */ new Map();
  }
});
function warnMissingOnce2(reason, node) {
  const key = `${reason}:${node.asset.url}:${String(node.meshUrl)}`;
  if (loggedMissing2.has(key)) return;
  loggedMissing2.add(key);
  skinnedLog.warn("draw-skinned-mesh unresolvable \u2014 painting fallback", { reason, url: node.asset.url, meshUrl: node.meshUrl });
}
function dominantBone(v) {
  let best = -1;
  let bestW = 0;
  for (const { bone, w } of v.weights) {
    if (w > bestW) {
      bestW = w;
      best = bone;
    }
  }
  return best;
}
function resolveSkinPose(node, clip) {
  const effectiveClip = clip ?? node.clip;
  if (effectiveClip && node.frame !== void 0 && effectiveClip.frames.length > 0) {
    return effectiveClip.frames[node.frame % effectiveClip.frames.length];
  }
  return node.pose ?? {};
}
function resolveRig(node, dctx) {
  const fetched = node.meshUrl ? getRigBundle(node.meshUrl, dctx.invalidate) : void 0;
  if (node.meshUrl && fetched === void 0) return void 0;
  const rb = fetched && isRigBundle(fetched) ? fetched : void 0;
  const mesh = node.mesh ?? rb?.mesh ?? (!rb ? fetched : void 0);
  if (!mesh) return void 0;
  const bones = node.bones.length > 0 ? node.bones : rb?.bones ?? [];
  if (bones.length === 0) return void 0;
  const clip = node.clip ?? (node.clipName ? rb?.clips?.[node.clipName] : void 0);
  return { mesh, bones, clip };
}
function meshHasPixelUVs(mesh) {
  const cached = pixelUVByMesh.get(mesh);
  if (cached !== void 0) return cached;
  let pixel = false;
  for (const v of mesh.vertices) {
    if (v.u < 0 || v.u > 1 || v.v < 0 || v.v > 1) {
      pixel = true;
      break;
    }
  }
  pixelUVByMesh.set(mesh, pixel);
  return pixel;
}
function paintMeshPass(painter, node, bones, mesh, tex, dctx, pose, opacity) {
  const bindWorld = computeWorldMatrices(bones, {});
  const curWorld = computeWorldMatrices(bones, pose);
  const skinned = skinVertices(mesh, bindWorld, curWorld);
  const origin = dctx.projector.project(node.position);
  const tw = dctx.projector.tileWidth;
  painter.save();
  if (opacity !== 1) painter.setAlpha(opacity);
  for (const [i0, i1, i2] of mesh.triangles) {
    const v0 = mesh.vertices[i0];
    const v1 = mesh.vertices[i1];
    const v2 = mesh.vertices[i2];
    const p0 = skinned[i0];
    const p1 = skinned[i1];
    const p2 = skinned[i2];
    if (!v0 || !v1 || !v2 || !p0 || !p1 || !p2) continue;
    const dst = [
      [origin.x + p0[0] * tw, origin.y + p0[1] * tw],
      [origin.x + p1[0] * tw, origin.y + p1[1] * tw],
      [origin.x + p2[0] * tw, origin.y + p2[1] * tw]
    ];
    if (node.weightsOverlay || !tex) {
      if (!node.weightsOverlay) continue;
      const bone = dominantBone(v0);
      painter.fillPoly(
        dst.map(([x, y]) => ({ x, y })),
        WEIGHT_PALETTE[(bone % WEIGHT_PALETTE.length + WEIGHT_PALETTE.length) % WEIGHT_PALETTE.length]
      );
      continue;
    }
    const pixelUV = meshHasPixelUVs(mesh);
    const uv = pixelUV ? [[v0.u, v0.v], [v1.u, v1.v], [v2.u, v2.v]] : [
      [v0.u * tex.width, v0.v * tex.height],
      [v1.u * tex.width, v1.v * tex.height],
      [v2.u * tex.width, v2.v * tex.height]
    ];
    const affine = triangleAffine(uv, dst);
    if (!affine) continue;
    painter.save();
    painter.clipPath(`M ${dst[0][0]} ${dst[0][1]} L ${dst[1][0]} ${dst[1][1]} L ${dst[2][0]} ${dst[2][1]} Z`);
    painter.blitTransformed(tex, { x: 0, y: 0, w: tex.width, h: tex.height }, affine);
    painter.restore();
  }
  painter.restore();
}
function DrawSkinnedMesh(props) {
  const register = useContext(DrawableRegistryContext);
  if (register) register({ ...props, type: "draw-skinned-mesh" });
  return null;
}
var skinnedLog, loggedMissing2, WEIGHT_PALETTE, pixelUVByMesh, paintSkinnedMesh;
var init_DrawSkinnedMesh = __esm({
  "components/game/atoms/DrawSkinnedMesh.tsx"() {
    "use client";
    init_imageCache();
    init_contract();
    init_registry();
    init_skinning();
    skinnedLog = createLogger("almadar:ui:draw-skinned-mesh");
    loggedMissing2 = /* @__PURE__ */ new Set();
    WEIGHT_PALETTE = Array.from({ length: 10 }, (_, i) => `hsl(${i * 36 % 360}, 70%, 55%)`);
    pixelUVByMesh = /* @__PURE__ */ new WeakMap();
    paintSkinnedMesh = (painter, node, dctx) => {
      if (!isValidScenePos(node.position)) return;
      const rig = resolveRig(node, dctx);
      if (!rig) {
        if (node.meshUrl && skinMeshFailed(node.meshUrl)) warnMissingOnce2("mesh-failed", node);
        else if (!node.mesh && !node.meshUrl) warnMissingOnce2("mesh-missing", node);
        return;
      }
      const tex = node.weightsOverlay ? null : painter.resolveTexture(node.asset.url);
      if (!node.weightsOverlay && !tex) {
        if (getImageStatus(node.asset.url) === "failed") warnMissingOnce2("texture-failed", node);
        return;
      }
      if (node.ghost && rig.clip && rig.clip.frames.length > 0) {
        paintMeshPass(painter, node, rig.bones, rig.mesh, tex, dctx, rig.clip.frames[node.ghost.frame % rig.clip.frames.length], node.ghost.opacity);
      }
      paintMeshPass(painter, node, rig.bones, rig.mesh, tex, dctx, resolveSkinPose(node, rig.clip), node.opacity ?? 1);
    };
  }
});
function applyMeshAnimation(node, timeMs) {
  const anim = node.animation;
  if (!anim || !(anim.durationMs > 0) || anim.keyframes.length === 0) return null;
  const frames = [...anim.keyframes].sort((a, b) => a.at - b.at);
  const cycle = timeMs / anim.durationMs;
  const t = anim.loop === false ? Math.min(cycle, 1) : cycle - Math.floor(cycle);
  const trackValue = (key) => {
    const defined = frames.filter((f3) => f3[key] !== void 0);
    if (defined.length === 0) return void 0;
    let prev;
    let next;
    for (const f3 of defined) {
      if (f3.at <= t) prev = f3;
      else if (!next) next = f3;
    }
    if (!prev) return defined[0][key];
    if (!next) return prev[key];
    const span = next.at - prev.at;
    const k = span > 0 ? (t - prev.at) / span : 1;
    const a = prev[key];
    const b = next[key];
    if (typeof a === "number" && typeof b === "number") return lerp2(a, b, k);
    return a;
  };
  const num2 = {};
  for (const key of NUMERIC_TRACKS2) {
    const v = trackValue(key);
    if (v !== void 0) num2[key] = v;
  }
  return {
    offset: [num2.offsetX ?? 0, num2.offsetY ?? 0, num2.offsetZ ?? 0],
    rotate: [num2.rotateX ?? 0, num2.rotateY ?? 0, num2.rotateZ ?? 0],
    scale: num2.scale ?? 1,
    opacity: num2.opacity,
    emissiveIntensity: num2.emissiveIntensity,
    color: trackValue("color"),
    emissive: trackValue("emissive")
  };
}
function DrawMesh(props) {
  const register = useContext(DrawableRegistryContext);
  if (register) register({ ...props, type: "draw-mesh" });
  return null;
}
var lerp2, NUMERIC_TRACKS2;
var init_DrawMesh = __esm({
  "components/game/atoms/DrawMesh.tsx"() {
    "use client";
    init_registry();
    lerp2 = (a, b, k) => a + (b - a) * k;
    NUMERIC_TRACKS2 = [
      "offsetX",
      "offsetY",
      "offsetZ",
      "rotateX",
      "rotateY",
      "rotateZ",
      "scale",
      "opacity",
      "emissiveIntensity"
    ];
  }
});

// components/game/molecules/DrawSpriteLayer.tsx
function DrawSpriteLayer(_props) {
  return null;
}
var paintSpriteLayer;
var init_DrawSpriteLayer = __esm({
  "components/game/molecules/DrawSpriteLayer.tsx"() {
    "use client";
    init_DrawSprite();
    paintSpriteLayer = (painter, node, dctx) => {
      for (const item of node.items) {
        paintSprite(painter, item, dctx);
      }
    };
  }
});

// components/game/molecules/DrawShapeLayer.tsx
function DrawShapeLayer(_props) {
  return null;
}
var paintShapeLayer;
var init_DrawShapeLayer = __esm({
  "components/game/molecules/DrawShapeLayer.tsx"() {
    "use client";
    init_DrawShape();
    paintShapeLayer = (painter, node, dctx) => {
      for (const item of node.items) {
        paintShape(painter, item, dctx);
      }
    };
  }
});

// components/game/molecules/DrawTextLayer.tsx
function DrawTextLayer(_props) {
  return null;
}
var paintTextLayer;
var init_DrawTextLayer = __esm({
  "components/game/molecules/DrawTextLayer.tsx"() {
    "use client";
    init_DrawText();
    paintTextLayer = (painter, node, dctx) => {
      for (const item of node.items) {
        paintText(painter, item, dctx);
      }
    };
  }
});

// components/game/molecules/DrawFxLayer.tsx
function fxPosition(view, dim, ageSec) {
  const g = view.gravity ?? 0;
  const fall = 0.5 * g * ageSec * ageSec;
  {
    const base2 = view.position ?? { x: view.x, y: view.z ?? view.y ?? 0 };
    if (!Number.isFinite(base2.x) || !Number.isFinite(base2.y)) return void 0;
    return {
      x: base2.x + (view.vx ?? 0) * ageSec,
      y: base2.y + (view.vz ?? 0) * ageSec + fall
    };
  }
}
function sparkShape(view, pos, i, fade, progress) {
  const size = view.size ?? 0.5;
  const angle = fxHash01(view.id, i * 3) * Math.PI * 2;
  const dist = size * (0.4 + 0.6 * fxHash01(view.id, i * 3 + 1)) * easeOut2(progress);
  const r = size * (0.06 + 0.06 * fxHash01(view.id, i * 3 + 2));
  const color = view.color ?? DEFAULT_SPARK_COLOR;
  return {
    type: "draw-shape",
    shape: "ellipse",
    position: { ...pos, x: pos.x + Math.cos(angle) * dist, y: pos.y + Math.sin(angle) * dist },
    anchor: "center",
    radiusX: r,
    fill: color,
    blendMode: "lighter",
    opacity: fade,
    ...view.glow ? { shadow: { color, blur: view.glow } } : {}
  };
}
function proceduralShapes(view, pos, fade, progress) {
  const size = view.size ?? 0.5;
  const color = view.color ?? DEFAULT_SPARK_COLOR;
  switch (view.shape ?? "spark") {
    case "ring": {
      return [
        {
          type: "draw-shape",
          shape: "ellipse",
          position: pos,
          anchor: "center",
          radiusX: size * easeOut2(progress),
          stroke: view.color2 ?? color,
          strokeWidth: 2,
          blendMode: "lighter",
          opacity: fade,
          ...view.glow ? { shadow: { color, blur: view.glow } } : {}
        }
      ];
    }
    case "puff": {
      const count = view.count ?? 3;
      return Array.from({ length: count }, (_, i) => {
        const angle = fxHash01(view.id, i * 5) * Math.PI * 2;
        const drift = size * 0.3 * fxHash01(view.id, i * 5 + 1) * easeOut2(progress);
        return {
          type: "draw-shape",
          shape: "ellipse",
          position: { ...pos, x: pos.x + Math.cos(angle) * drift, y: pos.y + Math.sin(angle) * drift },
          anchor: "center",
          radiusX: size * (0.15 + 0.35 * progress) * (0.7 + 0.6 * fxHash01(view.id, i * 5 + 2)),
          fill: i === 0 && view.color2 ? view.color2 : color,
          opacity: fade * 0.6,
          ...view.glow ? { shadow: { color, blur: view.glow } } : {}
        };
      });
    }
    case "streak": {
      const count = view.count ?? 5;
      return Array.from({ length: count }, (_, i) => {
        const angle = fxHash01(view.id, i * 3) * Math.PI * 2;
        const inner = size * (0.2 + 0.8 * easeOut2(progress)) * (0.6 + 0.4 * fxHash01(view.id, i * 3 + 1));
        const len = size * 0.35;
        return {
          type: "draw-shape",
          shape: "ellipse",
          position: pos,
          anchor: "center",
          offsetX: inner + len / 2,
          offsetY: 0,
          radiusX: len / 2,
          radiusY: size * 0.04,
          rotate: angle,
          fill: color,
          blendMode: "lighter",
          opacity: fade,
          ...view.glow ? { shadow: { color, blur: view.glow } } : {}
        };
      });
    }
    default: {
      const count = view.count ?? 6;
      return Array.from({ length: count }, (_, i) => sparkShape(view, pos, i, fade, progress));
    }
  }
}
function expandFxItem(view, node, epochNowMs, dim, projector, fontFamily) {
  if (view.space === "screen") return [];
  const tickMs = node.tickMs ?? DEFAULT_TICK_MS;
  const { ageMs, progress, fade } = fxLifecycle(view, epochNowMs, tickMs);
  if (progress >= 1) return [];
  const pos = fxPosition(view, dim, ageMs / 1e3);
  if (!pos) return [];
  const out = [];
  const artItems = node.art?.[view.type]?.["idle"];
  const sprite = node.sprites?.[view.type];
  if (Array.isArray(artItems)) {
    out.push({
      type: "draw-group",
      position: pos,
      opacity: fade,
      ...view.size !== void 0 ? { scale: view.size } : {},
      items: artItems
    });
  } else if (sprite?.url) {
    const spriteSize = view.size ?? 0.6;
    out.push({
      type: "draw-sprite",
      position: pos,
      asset: sprite,
      anchor: "center",
      width: spriteSize,
      height: spriteSize,
      opacity: fade,
      animation: view.animation ?? sprite.animations?.[0],
      // One-shot fx rows (burst) play from the item's birth, not wall-time.
      clockMs: ageMs
    });
  } else {
    out.push(...proceduralShapes(view, pos, fade, progress));
  }
  if (view.message) {
    const pxSize = projector && view.size !== void 0 ? Math.max(10, Math.round(view.size * projector.tileWidth)) : void 0;
    const family = fontFamily ?? "system-ui, sans-serif";
    const text = {
      type: "draw-text",
      text: view.message,
      position: pos,
      offsetY: -(0.15 + 0.55 * progress),
      color: view.color ?? node.textColor ?? DEFAULT_TEXT_COLOR,
      opacity: fade,
      font: `bold ${pxSize ?? 14}px ${family}`
    };
    out.push(text);
  }
  return out;
}
function expandFxLayer(node, epochNowMs, dim, projector, fontFamily) {
  if (!Array.isArray(node.items)) return [];
  const out = [];
  for (const item of node.items) {
    if (!item || typeof item.id !== "string") continue;
    out.push(...expandFxItem(resolveFxView(item, node.presets), node, epochNowMs, dim, projector, fontFamily));
  }
  return out;
}
function DrawFxLayer(_props) {
  return null;
}
var DEFAULT_TICK_MS, DEFAULT_TEXT_COLOR, DEFAULT_SPARK_COLOR, easeOut2;
var init_DrawFxLayer = __esm({
  "components/game/molecules/DrawFxLayer.tsx"() {
    "use client";
    init_fx();
    DEFAULT_TICK_MS = 500;
    DEFAULT_TEXT_COLOR = "#ffe066";
    DEFAULT_SPARK_COLOR = "#ffffff";
    easeOut2 = (t) => 1 - (1 - t) * (1 - t);
  }
});
function paintDrawable(painter, node, dctx) {
  switch (node.type) {
    case "draw-sprite":
      paintSprite(painter, node, dctx);
      break;
    case "draw-shape":
      paintShape(painter, node, dctx);
      break;
    case "draw-text":
      paintText(painter, node, dctx);
      break;
    case "draw-group": {
      if (!isValidScenePos(node.position)) break;
      if (!Array.isArray(node.items)) break;
      const p = dctx.projector.project(node.position);
      const anim = dctx.time > 0 && isAnimatedGroup(node) ? applyMeshAnimation(node, dctx.time) : null;
      const tw = dctx.projector.tileWidth;
      painter.save();
      painter.translate(p.x + (anim ? anim.offset[0] * tw : 0), p.y + (anim ? anim.offset[1] * tw : 0));
      const scale = (node.scale ?? 1) * (anim?.scale ?? 1);
      if (scale !== 1) painter.scale(scale, scale);
      const rotate = (node.rotate ?? 0) + (node.rotation?.[2] ?? 0) + (anim?.rotate[2] ?? 0);
      if (rotate !== 0) painter.rotate(rotate);
      const opacity = (node.opacity ?? 1) * (anim?.opacity ?? 1);
      if (opacity !== 1) painter.setAlpha(opacity);
      if (node.clip) {
        painter.scale(tw, tw);
        painter.clipPath(node.clip);
        painter.scale(1 / tw, 1 / tw);
      }
      const childCtx = scale !== 1 ? { ...dctx, groupScale: (dctx.groupScale ?? 1) * scale } : dctx;
      for (const item of node.items) paintDrawable(painter, item, childCtx);
      painter.restore();
      break;
    }
    case "draw-mesh":
      warnUnsupported2d("draw-mesh");
      break;
    case "draw-skinned-mesh":
      paintSkinnedMesh(painter, node, dctx);
      break;
    case "draw-sprite-layer":
      paintSpriteLayer(painter, node, dctx);
      break;
    case "draw-shape-layer":
      paintShapeLayer(painter, node, dctx);
      break;
    case "draw-text-layer":
      paintTextLayer(painter, node, dctx);
      break;
    case "draw-fx-layer": {
      const epochNow = dctx.time > 0 && typeof performance !== "undefined" ? performance.timeOrigin + dctx.time : 0;
      for (const child of expandFxLayer(node, epochNow, "2d", dctx.projector, dctx.fontFamily)) paintDrawable(painter, child, dctx);
      break;
    }
  }
}
var paint2dLog, warnedUnsupported2d, warnUnsupported2d;
var init_paintDispatch = __esm({
  "lib/drawable/paintDispatch.ts"() {
    init_contract();
    init_DrawSprite();
    init_DrawShape();
    init_DrawText();
    init_DrawGroup();
    init_DrawSkinnedMesh();
    init_DrawMesh();
    init_DrawSpriteLayer();
    init_DrawShapeLayer();
    init_DrawTextLayer();
    init_DrawFxLayer();
    paint2dLog = createLogger("almadar:ui:drawable-2d");
    warnedUnsupported2d = /* @__PURE__ */ new Set();
    warnUnsupported2d = (kind) => {
      if (warnedUnsupported2d.has(kind)) return;
      warnedUnsupported2d.add(kind);
      paint2dLog.warn("unsupported drawable kind on the 2D painter \u2014 skipped", { kind });
    };
  }
});
function themeBodyFont(el) {
  if (typeof getComputedStyle !== "function") return "system-ui, sans-serif";
  const v = getComputedStyle(el).getPropertyValue("--font-family-body").trim();
  return v || "system-ui, sans-serif";
}
function resolveColor2(color, ctx, fallback) {
  if (!color) return fallback;
  if (color.startsWith("var(")) {
    ctx.canvas.style;
    const m = /^var\((--[^,)]+)(?:,\s*([^)]+))?\)$/.exec(color);
    if (m) {
      const computed = getComputedStyle(ctx.canvas).getPropertyValue(m[1]).trim();
      return computed || m[2]?.trim() || fallback;
    }
  }
  return color;
}
function shapeBounds(shape) {
  switch (shape.type) {
    case "line":
    case "arrow":
      if (shape.x1 == null || shape.y1 == null || shape.x2 == null || shape.y2 == null) return null;
      return {
        x: Math.min(shape.x1, shape.x2) - 6,
        y: Math.min(shape.y1, shape.y2) - 6,
        w: Math.abs(shape.x2 - shape.x1) + 12,
        h: Math.abs(shape.y2 - shape.y1) + 12
      };
    case "circle":
      if (shape.x == null || shape.y == null || shape.radius == null) return null;
      return {
        x: shape.x - shape.radius - 4,
        y: shape.y - shape.radius - 4,
        w: shape.radius * 2 + 8,
        h: shape.radius * 2 + 8
      };
    case "ellipse":
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) return null;
      return {
        x: shape.x - shape.width / 2 - 4,
        y: shape.y - shape.height / 2 - 4,
        w: shape.width + 8,
        h: shape.height + 8
      };
    case "rect":
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) return null;
      return { x: shape.x - 4, y: shape.y - 4, w: shape.width + 8, h: shape.height + 8 };
    case "polygon":
      if (!shape.points || shape.points.length === 0) return null;
      {
        const xs = shape.points.map((p) => p.x);
        const ys = shape.points.map((p) => p.y);
        const minX = Math.min(...xs);
        const minY = Math.min(...ys);
        return {
          x: minX - 4,
          y: minY - 4,
          w: Math.max(...xs) - minX + 8,
          h: Math.max(...ys) - minY + 8
        };
      }
    case "text":
      if (shape.x == null || shape.y == null) return null;
      return { x: shape.x - 4, y: shape.y - (shape.fontSize ?? 14) - 4, w: 120, h: (shape.fontSize ?? 14) + 8 };
    default:
      return null;
  }
}
function drawArrowHead(ctx, x1, y1, x2, y2, size) {
  const angle = Math.atan2(y2 - y1, x2 - x1);
  ctx.beginPath();
  ctx.moveTo(x2, y2);
  ctx.lineTo(x2 - size * Math.cos(angle - Math.PI / 6), y2 - size * Math.sin(angle - Math.PI / 6));
  ctx.lineTo(x2 - size * Math.cos(angle + Math.PI / 6), y2 - size * Math.sin(angle + Math.PI / 6));
  ctx.closePath();
  ctx.fill();
}
function drawShape(ctx, shape, width, height, allShapes, fontFamily) {
  ctx.save();
  const opacity = shape.opacity ?? 1;
  ctx.globalAlpha = opacity;
  const stroke = resolveColor2(shape.color, ctx, "#333333");
  const fill = shape.fill ? resolveColor2(shape.fill, ctx, "#cccccc") : void 0;
  ctx.lineWidth = shape.lineWidth ?? 2;
  const dashPattern = shape.dash ? DASH_PATTERNS[shape.dash] : void 0;
  if (dashPattern) ctx.setLineDash([...dashPattern]);
  switch (shape.type) {
    case "grid": {
      const step = shape.step ?? 40;
      ctx.strokeStyle = stroke;
      ctx.globalAlpha = opacity * 0.25;
      ctx.lineWidth = 1;
      ctx.beginPath();
      for (let x = 0; x <= width; x += step) {
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
      }
      for (let y = 0; y <= height; y += step) {
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
      }
      ctx.stroke();
      break;
    }
    case "axis": {
      const axis = shape.axis ?? "x";
      ctx.strokeStyle = stroke;
      ctx.lineWidth = shape.lineWidth ?? 2;
      ctx.beginPath();
      if (axis === "x") {
        ctx.moveTo(0, height / 2);
        ctx.lineTo(width, height / 2);
      } else {
        ctx.moveTo(width / 2, 0);
        ctx.lineTo(width / 2, height);
      }
      ctx.stroke();
      break;
    }
    case "line": {
      if (shape.x1 == null || shape.y1 == null || shape.x2 == null || shape.y2 == null) break;
      ctx.strokeStyle = stroke;
      ctx.beginPath();
      ctx.moveTo(shape.x1, shape.y1);
      ctx.lineTo(shape.x2, shape.y2);
      ctx.stroke();
      break;
    }
    case "arrow": {
      if (shape.x1 == null || shape.y1 == null || shape.x2 == null || shape.y2 == null) break;
      ctx.strokeStyle = stroke;
      ctx.fillStyle = stroke;
      ctx.beginPath();
      ctx.moveTo(shape.x1, shape.y1);
      ctx.lineTo(shape.x2, shape.y2);
      ctx.stroke();
      drawArrowHead(ctx, shape.x1, shape.y1, shape.x2, shape.y2, 10);
      break;
    }
    case "circle": {
      if (shape.x == null || shape.y == null || shape.radius == null) break;
      ctx.beginPath();
      ctx.arc(shape.x, shape.y, shape.radius, 0, Math.PI * 2);
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
      }
      ctx.strokeStyle = stroke;
      ctx.stroke();
      break;
    }
    case "ellipse": {
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) break;
      const startAngle = (shape.startAngle ?? 0) * Math.PI / 180;
      const endAngle = (shape.endAngle ?? 360) * Math.PI / 180;
      ctx.beginPath();
      ctx.ellipse(shape.x, shape.y, shape.width / 2, shape.height / 2, 0, startAngle, endAngle);
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
      }
      ctx.strokeStyle = stroke;
      ctx.stroke();
      break;
    }
    case "rect": {
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) break;
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fillRect(shape.x, shape.y, shape.width, shape.height);
      }
      ctx.strokeStyle = stroke;
      ctx.strokeRect(shape.x, shape.y, shape.width, shape.height);
      break;
    }
    case "polygon": {
      if (!shape.points || shape.points.length < 2) break;
      ctx.beginPath();
      ctx.moveTo(shape.points[0].x, shape.points[0].y);
      for (let i = 1; i < shape.points.length; i++) {
        ctx.lineTo(shape.points[i].x, shape.points[i].y);
      }
      ctx.closePath();
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
      }
      ctx.strokeStyle = stroke;
      ctx.stroke();
      break;
    }
    case "path": {
      if (!shape.path) break;
      const p = new Path2D(shape.path);
      ctx.lineJoin = "round";
      ctx.lineCap = "round";
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill(p);
      }
      ctx.strokeStyle = stroke;
      ctx.stroke(p);
      break;
    }
    case "text": {
      if (shape.x == null || shape.y == null || !shape.text) break;
      ctx.fillStyle = stroke;
      ctx.font = `${shape.fontSize ?? 14}px ${shape.fontFamily ?? fontFamily ?? themeBodyFont(ctx.canvas)}`;
      ctx.textAlign = shape.align ?? "left";
      ctx.textBaseline = "middle";
      ctx.fillText(shape.text, shape.x, shape.y);
      break;
    }
    case "venn-region": {
      const resolveCircles = (ids) => (ids ?? []).flatMap((id) => {
        const c = allShapes.find((s) => s.type === "circle" && s.id === id);
        return c && c.x != null && c.y != null && c.radius != null ? [{ x: c.x, y: c.y, radius: c.radius }] : [];
      });
      const inside = resolveCircles(shape.inside);
      if (inside.length === 0) break;
      const outside = resolveCircles(shape.outside);
      const off = document.createElement("canvas");
      off.width = ctx.canvas.width;
      off.height = ctx.canvas.height;
      const octx = off.getContext("2d");
      if (!octx) break;
      octx.setTransform(ctx.getTransform());
      for (const c of inside) {
        const p = new Path2D();
        p.arc(c.x, c.y, c.radius, 0, Math.PI * 2);
        octx.clip(p);
      }
      octx.fillStyle = fill ?? stroke;
      octx.fillRect(0, 0, width, height);
      octx.globalCompositeOperation = "destination-out";
      for (const c of outside) {
        const p = new Path2D();
        p.arc(c.x, c.y, c.radius, 0, Math.PI * 2);
        octx.fill(p);
      }
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(off, 0, 0);
      ctx.restore();
      break;
    }
  }
  ctx.restore();
}
function readoutShapes(readouts, width, fontFamily) {
  const out = [];
  const chipH = 18;
  const gap = 6;
  let rightEdge = width - 6;
  let rowY = 6;
  for (const readout of readouts) {
    const text = `${readout.label}: ${String(readout.value)}`;
    const chipW = Math.min(170, Math.max(34, text.length * 6 + 12));
    let chipX = rightEdge - chipW;
    if (chipX < 4) {
      rowY += chipH + 4;
      rightEdge = width - 6;
      chipX = rightEdge - chipW;
    }
    const color = readout.color ?? "#334155";
    out.push({ type: "rect", x: chipX, y: rowY, width: chipW, height: chipH, color, fill: color });
    out.push({
      type: "text",
      x: chipX + chipW / 2,
      y: rowY + chipH / 2,
      text,
      color: "#ffffff",
      fontSize: 10,
      align: "center",
      fontFamily
    });
    rightEdge = chipX - gap;
  }
  return out;
}
function traceShapes(panel, k, width, height, fontFamily) {
  const w = panel.width ?? Math.round(width * 0.32);
  const h = panel.height ?? Math.round(height * 0.28);
  const x = panel.x ?? width - w - 8;
  const y = panel.y ?? height - h - 8 - k * (h + 8);
  const allSamples = panel.series.flatMap((series) => series.samples);
  let xLo = Math.min(...allSamples.map((p) => p.x));
  let xHi = Math.max(...allSamples.map((p) => p.x));
  let yLo = Math.min(...allSamples.map((p) => p.y));
  let yHi = Math.max(...allSamples.map((p) => p.y));
  if (xLo === xHi) {
    xLo -= 1;
    xHi += 1;
  }
  if (yLo === yHi) {
    yLo -= 1;
    yHi += 1;
  }
  const backgroundColor = panel.backgroundColor ?? "#ffffff";
  const frameColor = panel.frameColor ?? "#94a3b8";
  const out = [];
  out.push({
    type: "rect",
    x,
    y,
    width: w,
    height: h,
    color: backgroundColor,
    fill: backgroundColor,
    opacity: panel.backgroundOpacity ?? 0.85
  });
  out.push({ type: "rect", x, y, width: w, height: h, color: frameColor, lineWidth: 1 });
  panel.series.forEach((series, j) => {
    const color = series.color ?? TRACE_SERIES_COLORS[j % TRACE_SERIES_COLORS.length];
    const mapped = series.samples.map((p) => ({
      x: x + 4 + (p.x - xLo) / (xHi - xLo) * (w - 8),
      y: y + h - 4 - (p.y - yLo) / (yHi - yLo) * (h - 8)
    }));
    for (let i = 1; i < mapped.length; i++) {
      out.push({
        type: "line",
        x1: mapped[i - 1].x,
        y1: mapped[i - 1].y,
        x2: mapped[i].x,
        y2: mapped[i].y,
        color,
        lineWidth: 1.5
      });
    }
    if (mapped.length > 0) {
      const last = mapped[mapped.length - 1];
      out.push({ type: "circle", x: last.x, y: last.y, radius: 2, color, fill: color });
    }
    if (series.label) {
      out.push({ type: "text", x: x + 6, y: y + 10 + 11 * j, text: series.label, color, fontSize: 9, fontFamily });
    }
  });
  if (panel.yLabel) {
    out.push({ type: "text", x: x + w - 6, y: y + 10, text: panel.yLabel, color: "#6b7280", fontSize: 9, align: "right", fontFamily });
  }
  if (panel.xLabel) {
    out.push({ type: "text", x: x + w - 6, y: y + h - 6, text: panel.xLabel, color: "#6b7280", fontSize: 9, align: "right", fontFamily });
  }
  return out;
}
function drawableNeedsAnimation(nodes) {
  if (!nodes) return false;
  return nodes.some((node) => {
    if (node.type === "draw-sprite") return node.animation !== void 0;
    if (node.type === "draw-fx-layer") return Array.isArray(node.items) && node.items.length > 0;
    if (node.type === "draw-sprite-layer") return Array.isArray(node.items) && node.items.some((it) => it.animation !== void 0);
    if (node.type === "draw-group") return Array.isArray(node.items) && drawableNeedsAnimation(node.items);
    return false;
  });
}
var DASH_PATTERNS, TRACE_SERIES_COLORS, LearningCanvas;
var init_LearningCanvas = __esm({
  "components/learning/atoms/LearningCanvas.tsx"() {
    "use client";
    init_cn();
    init_perf();
    init_useEventBus();
    init_webPainter2d();
    init_paintDispatch();
    DASH_PATTERNS = { solid: [], dashed: [6, 4], dotted: [2, 3] };
    TRACE_SERIES_COLORS = ["#2563eb", "#dc2626", "#16a34a", "#f59e0b"];
    LearningCanvas = ({
      className,
      width = 600,
      height = 400,
      backgroundColor,
      fontFamily,
      shapes = [],
      drawables,
      projector,
      readouts,
      traces,
      interactive = false,
      animate = false,
      onShapeClick,
      onShapeHover,
      isLoading,
      error
    }) => {
      const canvasRef = useRef(null);
      const eventBus = useEventBus();
      const animRef = useRef(0);
      const hoverIndexRef = useRef(-1);
      const [drawVersion, setDrawVersion] = useState(0);
      const invalidateRef = useRef(() => setDrawVersion((v) => v + 1));
      const needsAnim = useMemo(() => drawableNeedsAnimation(drawables), [drawables]);
      const findShapeAt = useCallback((clientX, clientY) => {
        const canvas = canvasRef.current;
        if (!canvas) return -1;
        const rect = canvas.getBoundingClientRect();
        const x = clientX - rect.left;
        const y = clientY - rect.top;
        for (let i = shapes.length - 1; i >= 0; i--) {
          const b = shapeBounds(shapes[i]);
          if (b && x >= b.x && x <= b.x + b.w && y >= b.y && y <= b.y + b.h) {
            return i;
          }
        }
        return -1;
      }, [shapes]);
      const derivedShapes = useMemo(() => {
        if (!traces?.length && !readouts?.length) return shapes;
        const traceOut = (traces ?? []).flatMap((panel, k) => traceShapes(panel, k, width, height, fontFamily));
        const readoutOut = readouts?.length ? readoutShapes(readouts, width, fontFamily) : [];
        return [...shapes, ...traceOut, ...readoutOut];
      }, [shapes, traces, readouts, width, height, fontFamily]);
      const draw = useCallback(() => {
        const _perfT = perfStart("learningcanvas:paint");
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        const dpr = typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1;
        canvas.width = Math.max(1, Math.floor(width * dpr));
        canvas.height = Math.max(1, Math.floor(height * dpr));
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, width, height);
        if (backgroundColor) {
          ctx.fillStyle = resolveColor2(backgroundColor, ctx, backgroundColor);
          ctx.fillRect(0, 0, width, height);
        }
        for (const shape of derivedShapes) {
          if (shape.type !== "text") drawShape(ctx, shape, width, height, derivedShapes, fontFamily);
        }
        for (const shape of derivedShapes) {
          if (shape.type === "text") drawShape(ctx, shape, width, height, derivedShapes, fontFamily);
        }
        if (drawables?.length && projector) {
          const painter = createWebPainter(ctx, invalidateRef.current);
          const timeMs = needsAnim && typeof performance !== "undefined" ? performance.now() : 0;
          const dctx = { projector, time: timeMs, invalidate: invalidateRef.current, fontFamily: fontFamily || themeBodyFont(canvas) };
          for (const node of drawables) {
            paintDrawable(painter, node, dctx);
          }
        }
        perfEnd("learningcanvas:paint", _perfT);
      }, [width, height, backgroundColor, derivedShapes, drawables, projector, needsAnim]);
      useEffect(() => {
        draw();
      }, [draw, drawVersion]);
      useEffect(() => {
        const shouldAnimate = animate || needsAnim;
        if (!shouldAnimate) return;
        const loop = () => {
          draw();
          animRef.current = requestAnimationFrame(loop);
        };
        animRef.current = requestAnimationFrame(loop);
        return () => cancelAnimationFrame(animRef.current);
      }, [animate, needsAnim, draw]);
      const handlePointerMove = useCallback(
        (e) => {
          if (!interactive) return;
          const idx = findShapeAt(e.clientX, e.clientY);
          if (idx !== hoverIndexRef.current) {
            hoverIndexRef.current = idx;
            if (idx >= 0) {
              const shape = shapes[idx];
              const payload = { id: shape.id, type: shape.type, index: idx };
              if (onShapeHover) onShapeHover(payload);
              else if (eventBus) eventBus.emit(`UI:SHAPE_HOVER`, payload);
            }
          }
        },
        [interactive, onShapeHover, eventBus, findShapeAt, shapes]
      );
      const handleClick = useCallback(
        (e) => {
          if (!interactive) return;
          const idx = findShapeAt(e.clientX, e.clientY);
          if (idx >= 0) {
            const shape = shapes[idx];
            const payload = { id: shape.id, type: shape.type, index: idx };
            if (onShapeClick) onShapeClick(payload);
            else if (eventBus) eventBus.emit(`UI:SHAPE_CLICK`, payload);
          }
        },
        [interactive, onShapeClick, eventBus, findShapeAt, shapes]
      );
      if (isLoading || error) {
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "flex items-center justify-center rounded border border-border bg-surface",
              className
            ),
            style: { width, height },
            children: error ? /* @__PURE__ */ jsx("span", { className: "text-sm text-destructive", children: error.message }) : /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: "Loading canvas\u2026" })
          }
        );
      }
      return /* @__PURE__ */ jsx(
        "canvas",
        {
          ref: canvasRef,
          className: cn("block touch-none rounded border border-border", className),
          style: { width, height },
          onClick: handleClick,
          onPointerMove: handlePointerMove
        }
      );
    };
  }
});
function layoutCircle(nodes, width, height) {
  const cx = width / 2;
  const cy = height / 2;
  const radius = Math.max(10, Math.min(cx, cy) - 40);
  const positions = /* @__PURE__ */ new Map();
  const n = nodes.length;
  nodes.forEach((node, i) => {
    const angle = 2 * Math.PI * i / Math.max(n, 1) - Math.PI / 2;
    positions.set(node.id, { x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) });
  });
  return positions;
}
function layoutTree(nodes, edges, root, width, height) {
  const nodeIds = nodes.map((n) => n.id);
  const idSet = new Set(nodeIds);
  const childrenOf = /* @__PURE__ */ new Map();
  const hasIncoming = /* @__PURE__ */ new Set();
  for (const e of edges) {
    if (!idSet.has(e.from) || !idSet.has(e.to)) continue;
    const list = childrenOf.get(e.from) ?? [];
    list.push(e.to);
    childrenOf.set(e.from, list);
    hasIncoming.add(e.to);
  }
  const depth = /* @__PURE__ */ new Map();
  const treeChildren = /* @__PURE__ */ new Map();
  const visited = /* @__PURE__ */ new Set();
  const bfsFrom = (start) => {
    if (visited.has(start)) return;
    visited.add(start);
    depth.set(start, 0);
    const queue = [start];
    while (queue.length > 0) {
      const u = queue.shift();
      for (const v of childrenOf.get(u) ?? []) {
        if (visited.has(v)) continue;
        visited.add(v);
        depth.set(v, (depth.get(u) ?? 0) + 1);
        const list = treeChildren.get(u) ?? [];
        list.push(v);
        treeChildren.set(u, list);
        queue.push(v);
      }
    }
  };
  const primaryRoot = root && idSet.has(root) ? root : nodeIds.find((id) => !hasIncoming.has(id)) ?? nodeIds[0];
  const rootsOrder = [];
  if (primaryRoot !== void 0) {
    bfsFrom(primaryRoot);
    rootsOrder.push(primaryRoot);
  }
  for (const id of nodeIds) {
    if (!visited.has(id)) {
      bfsFrom(id);
      rootsOrder.push(id);
    }
  }
  let leafCounter = 0;
  const xSlot = /* @__PURE__ */ new Map();
  const assignXSlot = (u) => {
    const children = treeChildren.get(u) ?? [];
    if (children.length === 0) {
      const slot = leafCounter++;
      xSlot.set(u, slot);
      return slot;
    }
    const childSlots = children.map(assignXSlot);
    const avg = childSlots.reduce((a, b) => a + b, 0) / childSlots.length;
    xSlot.set(u, avg);
    return avg;
  };
  for (const r of rootsOrder) assignXSlot(r);
  let maxDepth = 0;
  for (const d of depth.values()) maxDepth = Math.max(maxDepth, d);
  const colWidth = width / Math.max(1, leafCounter);
  const rowHeight = height / (maxDepth + 1);
  const positions = /* @__PURE__ */ new Map();
  for (const id of nodeIds) {
    const slot = xSlot.get(id) ?? 0;
    const d = depth.get(id) ?? 0;
    positions.set(id, { x: slot * colWidth + colWidth / 2, y: d * rowHeight + rowHeight / 2 });
  }
  return positions;
}
function layoutLayered(nodes, edges, width, height) {
  const nodeIds = nodes.map((n) => n.id);
  const idSet = new Set(nodeIds);
  const adj = /* @__PURE__ */ new Map();
  const remainingIndegree = /* @__PURE__ */ new Map();
  for (const id of nodeIds) remainingIndegree.set(id, 0);
  for (const e of edges) {
    if (!idSet.has(e.from) || !idSet.has(e.to)) continue;
    const list = adj.get(e.from) ?? [];
    list.push(e.to);
    adj.set(e.from, list);
    remainingIndegree.set(e.to, (remainingIndegree.get(e.to) ?? 0) + 1);
  }
  const layer = /* @__PURE__ */ new Map();
  const dequeued = /* @__PURE__ */ new Set();
  const queue = [];
  for (const id of nodeIds) {
    if ((remainingIndegree.get(id) ?? 0) === 0) {
      layer.set(id, 0);
      queue.push(id);
    }
  }
  while (queue.length > 0) {
    const u = queue.shift();
    dequeued.add(u);
    for (const v of adj.get(u) ?? []) {
      const candidate = (layer.get(u) ?? 0) + 1;
      layer.set(v, Math.max(layer.get(v) ?? 0, candidate));
      remainingIndegree.set(v, (remainingIndegree.get(v) ?? 0) - 1);
      if ((remainingIndegree.get(v) ?? 0) === 0 && !dequeued.has(v)) {
        queue.push(v);
      }
    }
  }
  let baseMaxLayer = 0;
  for (const id of nodeIds) {
    if (dequeued.has(id)) baseMaxLayer = Math.max(baseMaxLayer, layer.get(id) ?? 0);
  }
  const cycleLayer = baseMaxLayer + 1;
  let maxLayer = baseMaxLayer;
  for (const id of nodeIds) {
    if (!dequeued.has(id)) {
      layer.set(id, cycleLayer);
      maxLayer = cycleLayer;
    }
  }
  const colWidth = width / Math.max(1, maxLayer + 1);
  const byLayer = /* @__PURE__ */ new Map();
  for (const id of nodeIds) {
    const l = layer.get(id) ?? 0;
    const list = byLayer.get(l) ?? [];
    list.push(id);
    byLayer.set(l, list);
  }
  const positions = /* @__PURE__ */ new Map();
  for (const [l, ids] of byLayer) {
    const rowHeight = height / ids.length;
    ids.forEach((id, i) => {
      positions.set(id, { x: l * colWidth + colWidth / 2, y: i * rowHeight + rowHeight / 2 });
    });
  }
  return positions;
}
function computePositions(nodes, edges, layout, root, width, height) {
  switch (layout) {
    case "circle":
      return layoutCircle(nodes, width, height);
    case "tree":
      return layoutTree(nodes, edges, root, width, height);
    case "layered":
      return layoutLayered(nodes, edges, width, height);
    case "manual":
    default: {
      const positions = /* @__PURE__ */ new Map();
      for (const n of nodes) positions.set(n.id, { x: n.x ?? 0, y: n.y ?? 0 });
      return positions;
    }
  }
}
var NODE_STATE_COLOR, EDGE_STATE_COLOR, DEFAULT_NODE_RADIUS, AlgoGraphCanvas;
var init_AlgoGraphCanvas = __esm({
  "components/learning/molecules/AlgoGraphCanvas.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_LearningCanvas();
    NODE_STATE_COLOR = {
      unvisited: "#cbd5e1",
      frontier: "#f59e0b",
      current: "#ef4444",
      visited: "#22c55e",
      goal: "#8b5cf6",
      path: "#0ea5e9"
    };
    EDGE_STATE_COLOR = {
      default: "#9ca3af",
      tree: "#16a34a",
      relaxed: "#f59e0b",
      candidate: "#38bdf8",
      path: "#dc2626"
    };
    DEFAULT_NODE_RADIUS = 18;
    AlgoGraphCanvas = ({
      className,
      width = 600,
      height = 400,
      title,
      backgroundColor,
      nodes = [],
      edges = [],
      layout = "manual",
      root,
      shapes = [],
      interactive = false,
      animate = false,
      onShapeClick,
      onNodeClick,
      isLoading,
      error
    }) => {
      const nodeById = useMemo(() => {
        const m = /* @__PURE__ */ new Map();
        for (const n of nodes) m.set(n.id, n);
        return m;
      }, [nodes]);
      const nodeIndexById = useMemo(() => {
        const m = /* @__PURE__ */ new Map();
        nodes.forEach((n, i) => m.set(n.id, i));
        return m;
      }, [nodes]);
      const derivedShapes = useMemo(() => {
        const out = [];
        const positions = computePositions(nodes, edges, layout, root, width, height);
        const edgeGeoms = [];
        for (const e of edges) {
          const a = nodeById.get(e.from);
          const b = nodeById.get(e.to);
          const posA = positions.get(e.from);
          const posB = positions.get(e.to);
          if (!a || !b || !posA || !posB) continue;
          const rA = a.radius ?? DEFAULT_NODE_RADIUS;
          const rB = b.radius ?? DEFAULT_NODE_RADIUS;
          const dx = posB.x - posA.x;
          const dy = posB.y - posA.y;
          const dist = Math.max(1e-6, Math.hypot(dx, dy));
          const ux = dx / dist;
          const uy = dy / dist;
          edgeGeoms.push({
            directed: e.directed ?? false,
            x1: posA.x + ux * rA,
            y1: posA.y + uy * rA,
            x2: posB.x - ux * rB,
            y2: posB.y - uy * rB,
            color: e.color ?? EDGE_STATE_COLOR[e.state ?? "default"],
            label: e.label ?? (e.weight != null ? String(e.weight) : void 0)
          });
        }
        for (const g of edgeGeoms) {
          out.push({
            type: g.directed ? "arrow" : "line",
            x1: g.x1,
            y1: g.y1,
            x2: g.x2,
            y2: g.y2,
            color: g.color,
            lineWidth: 2
          });
        }
        for (const g of edgeGeoms) {
          if (g.label === void 0) continue;
          const midX = (g.x1 + g.x2) / 2;
          const midY = (g.y1 + g.y2) / 2;
          const dx = g.x2 - g.x1;
          const dy = g.y2 - g.y1;
          const dist = Math.max(1e-6, Math.hypot(dx, dy));
          const perpX = -(dy / dist);
          const perpY = dx / dist;
          out.push({
            type: "text",
            x: midX + perpX * 10,
            y: midY + perpY * 10,
            text: g.label,
            fontSize: 11,
            align: "center",
            color: "#374151"
          });
        }
        const nodeGeoms = [];
        for (const n of nodes) {
          const pos = positions.get(n.id);
          if (!pos) continue;
          nodeGeoms.push({
            id: n.id,
            x: pos.x,
            y: pos.y,
            radius: n.radius ?? DEFAULT_NODE_RADIUS,
            color: n.color ?? NODE_STATE_COLOR[n.state ?? "unvisited"],
            label: n.label,
            badge: n.badge
          });
        }
        for (const g of nodeGeoms) {
          out.push({ type: "circle", id: g.id, x: g.x, y: g.y, radius: g.radius, color: g.color, fill: `${g.color}33` });
        }
        const badgeGeoms = [];
        for (const g of nodeGeoms) {
          if (!g.badge || g.badge.text === "") continue;
          const w = Math.min(42, Math.max(18, g.badge.text.length * 6 + 10));
          badgeGeoms.push({
            cx: g.x + g.radius * 0.75,
            cy: g.y - g.radius * 0.75,
            w,
            h: 14,
            // Borderless pill: same color drives both stroke and fill.
            color: g.badge.color ?? "#1e293b",
            text: g.badge.text
          });
        }
        for (const b of badgeGeoms) {
          out.push({ type: "rect", x: b.cx - b.w / 2, y: b.cy - b.h / 2, width: b.w, height: b.h, color: b.color, fill: b.color });
        }
        for (const b of badgeGeoms) {
          out.push({ type: "text", x: b.cx, y: b.cy, text: b.text, fontSize: 9, align: "center", color: "#ffffff" });
        }
        for (const g of nodeGeoms) {
          if (g.label === void 0) continue;
          out.push({
            type: "text",
            x: g.x,
            y: g.y + g.radius + 14,
            text: g.label,
            fontSize: 12,
            align: "center",
            color: "#111827"
          });
        }
        out.push(...shapes);
        return out;
      }, [nodes, edges, layout, root, width, height, nodeById, shapes]);
      const handleShapeClick = useCallback(
        (payload) => {
          if (payload.type === "circle" && payload.id) {
            const node = nodeById.get(payload.id);
            const idx = nodeIndexById.get(payload.id);
            if (node && idx !== void 0) {
              onNodeClick?.({ id: node.id, label: node.label, index: idx });
            }
          }
          onShapeClick?.(payload);
        },
        [nodeById, nodeIndexById, onNodeClick, onShapeClick]
      );
      return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        /* @__PURE__ */ jsx(
          LearningCanvas,
          {
            width,
            height,
            backgroundColor,
            shapes: derivedShapes,
            interactive,
            animate,
            onShapeClick: onShapeClick || onNodeClick ? handleShapeClick : void 0,
            isLoading,
            error
          }
        )
      ] }) });
    };
  }
});
var DEFAULT_BAR_COLOR, DEFAULT_CELL_COLOR, DEFAULT_POINTER_COLOR, POINTER_BAND, TOP_PAD, PANEL_FAMILY_ORDER, RANGE_COLOR_DEFAULT, RANGE_FILL_OPACITY, BRACKET_TOP_OFFSET, BRACKET_ROW_H, BRACKET_TICK_H, BRACKET_LABEL_OFFSET, SLOT_EMPTY_FILL, SLOT_EMPTY_STROKE, SLOT_FILLED_STROKE, SLOT_HIGHLIGHT_DEFAULT, SLOT_VALUE_TEXT_COLOR, FRAME_ACTIVE_COLOR, FRAME_RETURNING_COLOR, FRAME_DONE_COLOR, FRAME_RIM_COLOR, FRAME_LABEL_COLOR, FRAME_DETAIL_COLOR, FRAME_TWO_LINE_MIN_H, FRAME_STRIP_H, FRAME_GAP, FRAME_BOTTOM_PAD, FRAME_MIN_H, BUCKET_INDEX_FILL, BUCKET_INDEX_STROKE, BUCKET_INDEX_TEXT, BUCKET_ENTRY_TEXT, BUCKET_ENTRY_DEFAULT, BUCKET_ENTRY_HIGHLIGHT, BUCKET_ENTRY_PROBING, BUCKET_ENTRY_MIN_W, BUCKET_ENTRY_MAX_W, AXIS_LABEL_COLOR, AXIS_LABEL_FONT_SIZE, CORNER_TEXT_COLOR, CORNER_FONT_SIZE, CORNER_MIN_CELL, CORNER_INSET_X, CORNER_INSET_Y, AUX_PRIMARY_RATIO, AUX_LABEL_BAND, AUX_BASELINE_PAD, AlgorithmCanvas;
var init_AlgorithmCanvas = __esm({
  "components/learning/molecules/AlgorithmCanvas.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_LearningCanvas();
    DEFAULT_BAR_COLOR = "#3b82f6";
    DEFAULT_CELL_COLOR = "#e5e7eb";
    DEFAULT_POINTER_COLOR = "#dc2626";
    POINTER_BAND = 34;
    TOP_PAD = 26;
    PANEL_FAMILY_ORDER = ["bars", "slots", "cells", "buckets", "frames"];
    RANGE_COLOR_DEFAULT = "#3b82f6";
    RANGE_FILL_OPACITY = 0.15;
    BRACKET_TOP_OFFSET = 16;
    BRACKET_ROW_H = 14;
    BRACKET_TICK_H = 6;
    BRACKET_LABEL_OFFSET = 6;
    SLOT_EMPTY_FILL = "#f1f5f9";
    SLOT_EMPTY_STROKE = "#cbd5e1";
    SLOT_FILLED_STROKE = "#9ca3af";
    SLOT_HIGHLIGHT_DEFAULT = "#f59e0b";
    SLOT_VALUE_TEXT_COLOR = "#ffffff";
    FRAME_ACTIVE_COLOR = "#3b82f6";
    FRAME_RETURNING_COLOR = "#f59e0b";
    FRAME_DONE_COLOR = "#94a3b8";
    FRAME_RIM_COLOR = {
      active: "#1d4ed8",
      returning: "#b45309",
      done: "#64748b"
    };
    FRAME_LABEL_COLOR = "#ffffff";
    FRAME_DETAIL_COLOR = "#e2e8f0";
    FRAME_TWO_LINE_MIN_H = 22;
    FRAME_STRIP_H = 44;
    FRAME_GAP = 6;
    FRAME_BOTTOM_PAD = 8;
    FRAME_MIN_H = 12;
    BUCKET_INDEX_FILL = "#e2e8f0";
    BUCKET_INDEX_STROKE = "#9ca3af";
    BUCKET_INDEX_TEXT = "#374151";
    BUCKET_ENTRY_TEXT = "#ffffff";
    BUCKET_ENTRY_DEFAULT = "#3b82f6";
    BUCKET_ENTRY_HIGHLIGHT = "#f59e0b";
    BUCKET_ENTRY_PROBING = "#38bdf8";
    BUCKET_ENTRY_MIN_W = 24;
    BUCKET_ENTRY_MAX_W = 64;
    AXIS_LABEL_COLOR = "#6b7280";
    AXIS_LABEL_FONT_SIZE = 10;
    CORNER_TEXT_COLOR = "#111827";
    CORNER_FONT_SIZE = 7;
    CORNER_MIN_CELL = 28;
    CORNER_INSET_X = 3;
    CORNER_INSET_Y = 6;
    AUX_PRIMARY_RATIO = 0.6;
    AUX_LABEL_BAND = 18;
    AUX_BASELINE_PAD = 8;
    AlgorithmCanvas = ({
      className,
      width = 600,
      height = 400,
      title,
      backgroundColor,
      bars = [],
      cells = [],
      pointers = [],
      ranges = [],
      slots = [],
      slotOrientation = "horizontal",
      frames = [],
      buckets = [],
      auxBars = [],
      rowLabels = [],
      colLabels = [],
      shapes = [],
      interactive = false,
      animate = false,
      onShapeClick,
      isLoading,
      error
    }) => {
      const derivedShapes = useMemo(() => {
        const out = [];
        const presence = {
          bars: bars.length > 0,
          slots: slots.length > 0,
          cells: cells.length > 0,
          buckets: buckets.length > 0,
          frames: frames.length > 0
        };
        const panelCount = PANEL_FAMILY_ORDER.filter((f3) => presence[f3]).length;
        const panelHeight = height / Math.max(1, panelCount);
        const panelY = { bars: 0, slots: 0, cells: 0, buckets: 0, frames: 0 };
        let compactIndex = 0;
        PANEL_FAMILY_ORDER.forEach((f3) => {
          if (presence[f3]) {
            panelY[f3] = compactIndex * panelHeight;
            compactIndex += 1;
          }
        });
        if (bars.length > 0) {
          const panelYBars = panelY.bars;
          const slot = width / bars.length;
          const barW = slot * 0.8;
          const gap = slot * 0.1;
          const bracketRanges = ranges.filter((r) => r.kind === "bracket");
          const bracketCount = bracketRanges.length;
          const bracketHeadroom = bracketCount > 0 ? BRACKET_TOP_OFFSET + bracketCount * BRACKET_ROW_H : 0;
          const hasAux = auxBars.length > 0;
          const primaryH = hasAux ? panelHeight * AUX_PRIMARY_RATIO : panelHeight;
          const baseline = panelYBars + primaryH - POINTER_BAND;
          const usableH = baseline - (panelYBars + TOP_PAD + bracketHeadroom);
          const maxV = Math.max(1, ...bars.map((b) => Number.isFinite(b.value) ? b.value : 0));
          bars.forEach((bar, i) => {
            const v = Number.isFinite(bar.value) ? bar.value : 0;
            const bh = Math.max(0, v / maxV * usableH);
            const x = i * slot + gap;
            const color = bar.color ?? DEFAULT_BAR_COLOR;
            out.push({
              type: "rect",
              id: `bar-${i}`,
              x,
              y: baseline - bh,
              width: barW,
              height: bh,
              color,
              fill: color
            });
            const label = bar.label ?? (bars.length <= 24 ? String(v) : void 0);
            if (label) {
              out.push({
                type: "text",
                x: x + barW / 2,
                y: baseline - bh - 8,
                text: label,
                color: "#374151",
                fontSize: 11,
                align: "center"
              });
            }
          });
          ranges.forEach((r) => {
            const kind = r.kind ?? "fill";
            if (kind !== "fill") return;
            const color = r.color ?? RANGE_COLOR_DEFAULT;
            out.push({
              type: "rect",
              x: r.from * slot,
              y: panelYBars,
              width: (r.to - r.from + 1) * slot,
              height: primaryH,
              color,
              fill: color,
              opacity: RANGE_FILL_OPACITY
            });
            if (r.label) {
              out.push({
                type: "text",
                x: r.from * slot + 4,
                // Sits below the bracket block (if any) so fill and bracket labels never collide.
                y: panelYBars + 10 + bracketHeadroom,
                text: r.label,
                color,
                fontSize: 10,
                align: "left"
              });
            }
          });
          bracketRanges.forEach((r, i) => {
            const bracketY = panelYBars + BRACKET_TOP_OFFSET + i * BRACKET_ROW_H;
            const x1 = r.from * slot + slot * 0.1;
            const x2 = (r.to + 1) * slot - slot * 0.1;
            const color = r.color ?? RANGE_COLOR_DEFAULT;
            out.push({ type: "line", x1, y1: bracketY, x2, y2: bracketY, color, lineWidth: 2 });
            out.push({ type: "line", x1, y1: bracketY, x2: x1, y2: bracketY + BRACKET_TICK_H, color, lineWidth: 2 });
            out.push({ type: "line", x1: x2, y1: bracketY, x2, y2: bracketY + BRACKET_TICK_H, color, lineWidth: 2 });
            if (r.label) {
              out.push({
                type: "text",
                x: (x1 + x2) / 2,
                y: bracketY - BRACKET_LABEL_OFFSET,
                text: r.label,
                color,
                fontSize: 10,
                align: "center"
              });
            }
          });
          if (hasAux) {
            const auxH = panelHeight - primaryH;
            const slot2 = width / auxBars.length;
            const auxBaseline = panelYBars + primaryH + auxH - AUX_BASELINE_PAD;
            const auxUsableH = auxBaseline - (panelYBars + primaryH + AUX_LABEL_BAND);
            const maxAuxV = Math.max(1, ...auxBars.map((b) => Number.isFinite(b.value) ? b.value : 0));
            auxBars.forEach((bar, i) => {
              const v = Number.isFinite(bar.value) ? bar.value : 0;
              const bh = Math.max(0, v / maxAuxV * auxUsableH);
              const x = i * slot2 + slot2 * 0.1;
              const w = slot2 * 0.8;
              const color = bar.color ?? DEFAULT_BAR_COLOR;
              out.push({
                type: "rect",
                id: `auxbar-${i}`,
                x,
                y: auxBaseline - bh,
                width: w,
                height: bh,
                color,
                fill: color
              });
              const label = bar.label ?? (auxBars.length <= 24 ? String(v) : void 0);
              if (label) {
                out.push({
                  type: "text",
                  x: x + w / 2,
                  y: auxBaseline - bh - 8,
                  text: label,
                  color: "#374151",
                  fontSize: 11,
                  align: "center"
                });
              }
            });
          }
          pointers.forEach((p) => {
            if (p.index < 0 || p.index >= bars.length) return;
            const cx = p.index * slot + slot / 2;
            const color = p.color ?? DEFAULT_POINTER_COLOR;
            out.push({
              type: "arrow",
              x1: cx,
              y1: panelYBars + primaryH - 18,
              x2: cx,
              y2: baseline + 4,
              color,
              lineWidth: 2
            });
            if (p.label) {
              out.push({
                type: "text",
                x: cx,
                y: panelYBars + primaryH - 8,
                text: p.label,
                color,
                fontSize: 11,
                align: "center"
              });
            }
          });
        }
        if (slots.length > 0) {
          const panelYSlots = panelY.slots;
          const n = slots.length;
          const vertical = slotOrientation === "vertical";
          const vBoxH = panelHeight / n;
          const vBoxW = Math.min(width * 0.5, 120);
          const vBoxX = (width - vBoxW) / 2;
          const hCellW = width / n;
          const hBoxW = hCellW * 0.82;
          const hBoxH = Math.min(panelHeight * 0.6, 48);
          const hBoxY = panelYSlots + (panelHeight - hBoxH) / 2;
          const slotBox = (i) => vertical ? { x: vBoxX, y: panelYSlots + panelHeight - (i + 1) * vBoxH, width: vBoxW, height: vBoxH } : { x: i * hCellW + (hCellW - hBoxW) / 2, y: hBoxY, width: hBoxW, height: hBoxH };
          slots.forEach((s, i) => {
            const box = slotBox(i);
            const state = s.state ?? "filled";
            const fill = state === "empty" ? SLOT_EMPTY_FILL : state === "highlight" ? s.color ?? SLOT_HIGHLIGHT_DEFAULT : s.color ?? DEFAULT_BAR_COLOR;
            const stroke = state === "empty" ? SLOT_EMPTY_STROKE : SLOT_FILLED_STROKE;
            out.push({
              type: "rect",
              id: `slot-${i}`,
              x: box.x,
              y: box.y,
              width: box.width,
              height: box.height,
              color: stroke,
              fill
            });
            if (s.value != null && state !== "empty") {
              out.push({
                type: "text",
                x: box.x + box.width / 2,
                y: box.y + box.height / 2,
                text: String(s.value),
                color: SLOT_VALUE_TEXT_COLOR,
                fontSize: 12,
                align: "center"
              });
            }
          });
          if (bars.length === 0) {
            pointers.forEach((p) => {
              if (p.index < 0 || p.index >= slots.length) return;
              const box = slotBox(p.index);
              const color = p.color ?? DEFAULT_POINTER_COLOR;
              if (vertical) {
                const cy = box.y + box.height / 2;
                out.push({
                  type: "arrow",
                  x1: box.x + box.width + 34,
                  y1: cy,
                  x2: box.x + box.width + 4,
                  y2: cy,
                  color,
                  lineWidth: 2
                });
                if (p.label) {
                  out.push({
                    type: "text",
                    x: box.x + box.width + 38,
                    y: cy,
                    text: p.label,
                    color,
                    fontSize: 11,
                    align: "left"
                  });
                }
              } else {
                const cx = box.x + box.width / 2;
                out.push({
                  type: "arrow",
                  x1: cx,
                  y1: panelYSlots + panelHeight - 18,
                  x2: cx,
                  y2: box.y + box.height + 4,
                  color,
                  lineWidth: 2
                });
                if (p.label) {
                  out.push({
                    type: "text",
                    x: cx,
                    y: panelYSlots + panelHeight - 8,
                    text: p.label,
                    color,
                    fontSize: 11,
                    align: "center"
                  });
                }
              }
            });
          }
        }
        if (cells.length > 0) {
          const panelYCells = panelY.cells;
          const maxCol = Math.max(0, ...cells.map((c) => c.col)) + 1;
          const maxRow = Math.max(0, ...cells.map((c) => c.row)) + 1;
          const colLabelH = colLabels.length > 0 ? 16 : 0;
          const rowLabelW = rowLabels.length > 0 ? 20 : 0;
          const gridX0 = rowLabelW;
          const gridY0 = panelYCells + colLabelH;
          const cw = (width - rowLabelW) / maxCol;
          const ch = (panelHeight - colLabelH) / maxRow;
          cells.forEach((c, i) => {
            const x = gridX0 + c.col * cw;
            const y = gridY0 + c.row * ch;
            const color = c.color ?? DEFAULT_CELL_COLOR;
            out.push({
              type: "rect",
              id: `cell-${i}`,
              x: x + 1,
              y: y + 1,
              width: cw - 2,
              height: ch - 2,
              color: "#9ca3af",
              fill: color
            });
            const label = c.label ?? (c.value != null ? String(c.value) : void 0);
            if (label && cw >= 18 && ch >= 14) {
              out.push({
                type: "text",
                x: x + cw / 2,
                y: y + ch / 2,
                text: label,
                color: "#111827",
                fontSize: 12,
                align: "center"
              });
            }
            if (c.corner && cw >= CORNER_MIN_CELL && ch >= CORNER_MIN_CELL) {
              const { tl, tr, bl, br } = c.corner;
              if (tl) {
                out.push({
                  type: "text",
                  x: x + CORNER_INSET_X,
                  y: y + CORNER_INSET_Y,
                  text: tl,
                  color: CORNER_TEXT_COLOR,
                  fontSize: CORNER_FONT_SIZE,
                  align: "left"
                });
              }
              if (tr) {
                out.push({
                  type: "text",
                  x: x + cw - CORNER_INSET_X,
                  y: y + CORNER_INSET_Y,
                  text: tr,
                  color: CORNER_TEXT_COLOR,
                  fontSize: CORNER_FONT_SIZE,
                  align: "right"
                });
              }
              if (bl) {
                out.push({
                  type: "text",
                  x: x + CORNER_INSET_X,
                  y: y + ch - CORNER_INSET_Y,
                  text: bl,
                  color: CORNER_TEXT_COLOR,
                  fontSize: CORNER_FONT_SIZE,
                  align: "left"
                });
              }
              if (br) {
                out.push({
                  type: "text",
                  x: x + cw - CORNER_INSET_X,
                  y: y + ch - CORNER_INSET_Y,
                  text: br,
                  color: CORNER_TEXT_COLOR,
                  fontSize: CORNER_FONT_SIZE,
                  align: "right"
                });
              }
            }
          });
          colLabels.forEach((l) => {
            out.push({
              type: "text",
              x: gridX0 + l.index * cw + cw / 2,
              y: panelYCells + colLabelH / 2,
              text: l.text,
              color: l.color ?? AXIS_LABEL_COLOR,
              fontSize: AXIS_LABEL_FONT_SIZE,
              align: "center"
            });
          });
          rowLabels.forEach((l) => {
            out.push({
              type: "text",
              x: rowLabelW - 6,
              y: gridY0 + l.index * ch + ch / 2,
              text: l.text,
              color: l.color ?? AXIS_LABEL_COLOR,
              fontSize: AXIS_LABEL_FONT_SIZE,
              align: "right"
            });
          });
        }
        if (buckets.length > 0) {
          const panelYBuckets = panelY.buckets;
          const bucketCount = Math.max(0, ...buckets.map((b) => b.index)) + 1;
          const rowH = panelHeight / bucketCount;
          const indexColW = Math.min(width * 0.12, 40);
          const maxChainLen = Math.max(1, ...buckets.map((b) => b.entries.length));
          const entryW = Math.min(BUCKET_ENTRY_MAX_W, Math.max(BUCKET_ENTRY_MIN_W, (width - indexColW - 8) / maxChainLen));
          const maxVisible = Math.floor((width - indexColW - 4) / entryW);
          buckets.forEach((b) => {
            const rowY = panelYBuckets + b.index * rowH;
            out.push({
              type: "rect",
              id: `bucket-index-${b.index}`,
              x: 2,
              y: rowY + 2,
              width: indexColW - 4,
              height: rowH - 4,
              color: BUCKET_INDEX_STROKE,
              fill: BUCKET_INDEX_FILL
            });
            out.push({
              type: "text",
              x: 2 + (indexColW - 4) / 2,
              y: rowY + rowH / 2,
              text: String(b.index),
              color: BUCKET_INDEX_TEXT,
              fontSize: 10,
              align: "center"
            });
            const overflow = b.entries.length > maxVisible;
            const visibleCount = overflow ? Math.max(0, maxVisible - 1) : b.entries.length;
            for (let j = 0; j < visibleCount; j++) {
              const entry = b.entries[j];
              const ex = indexColW + 4 + j * entryW;
              const state = entry.state ?? "default";
              const fill = state === "highlight" ? entry.color ?? BUCKET_ENTRY_HIGHLIGHT : state === "probing" ? entry.color ?? BUCKET_ENTRY_PROBING : entry.color ?? BUCKET_ENTRY_DEFAULT;
              out.push({
                type: "rect",
                id: `bucket-${b.index}-${j}`,
                x: ex,
                y: rowY + 2,
                width: entryW - 2,
                height: rowH - 4,
                color: fill,
                fill
              });
              if (entryW >= 20 && rowH >= 16) {
                out.push({
                  type: "text",
                  x: ex + (entryW - 2) / 2,
                  y: rowY + rowH / 2,
                  text: entry.label,
                  color: BUCKET_ENTRY_TEXT,
                  fontSize: 10,
                  align: "center"
                });
              }
            }
            if (overflow) {
              const ex = indexColW + 4 + visibleCount * entryW;
              out.push({
                type: "rect",
                id: `bucket-${b.index}-overflow`,
                x: ex,
                y: rowY + 2,
                width: entryW - 2,
                height: rowH - 4,
                color: BUCKET_ENTRY_DEFAULT,
                fill: BUCKET_ENTRY_DEFAULT
              });
              out.push({
                type: "text",
                x: ex + (entryW - 2) / 2,
                y: rowY + rowH / 2,
                text: `+${b.entries.length - visibleCount}`,
                color: BUCKET_ENTRY_TEXT,
                fontSize: 10,
                align: "center"
              });
            }
          });
        }
        if (frames.length > 0) {
          const panelYFrames = panelY.frames;
          const n = frames.length;
          const maxStride = (panelHeight - FRAME_BOTTOM_PAD - TOP_PAD) / n;
          const stride = Math.min(FRAME_STRIP_H + FRAME_GAP, maxStride);
          const frameH = Math.max(FRAME_MIN_H, stride - FRAME_GAP);
          const x = 8;
          const w = width - 16;
          const bottom = panelYFrames + panelHeight - FRAME_BOTTOM_PAD;
          frames.forEach((f3, i) => {
            const y = bottom - i * stride - frameH;
            const state = f3.state ?? "active";
            const fill = state === "returning" ? f3.color ?? FRAME_RETURNING_COLOR : state === "done" ? f3.color ?? FRAME_DONE_COLOR : f3.color ?? FRAME_ACTIVE_COLOR;
            const rim = f3.color ?? FRAME_RIM_COLOR[state] ?? FRAME_RIM_COLOR.active;
            out.push({ type: "rect", id: `frame-${i}`, x, y, width: w, height: frameH, color: rim, fill });
            if (frameH >= FRAME_TWO_LINE_MIN_H) {
              out.push({
                type: "text",
                x: 16,
                y: y + frameH * 0.35,
                text: f3.label,
                color: FRAME_LABEL_COLOR,
                fontSize: 11,
                align: "left"
              });
              if (f3.detail) {
                out.push({
                  type: "text",
                  x: 16,
                  y: y + frameH * 0.72,
                  text: f3.detail,
                  color: FRAME_DETAIL_COLOR,
                  fontSize: 10,
                  align: "left"
                });
              }
            } else {
              out.push({
                type: "text",
                x: 16,
                y: y + frameH / 2,
                text: f3.label,
                color: FRAME_LABEL_COLOR,
                fontSize: 10,
                align: "left"
              });
            }
          });
        }
        out.push(...shapes);
        return out;
      }, [bars, cells, pointers, ranges, slots, slotOrientation, frames, buckets, auxBars, rowLabels, colLabels, shapes, width, height]);
      return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        /* @__PURE__ */ jsx(
          LearningCanvas,
          {
            width,
            height,
            backgroundColor,
            shapes: derivedShapes,
            interactive,
            animate,
            onShapeClick,
            isLoading,
            error
          }
        )
      ] }) });
    };
  }
});
var AuthLayout;
var init_AuthLayout = __esm({
  "components/marketing/templates/AuthLayout.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    AuthLayout = ({
      appName = "My App",
      logo,
      backgroundImage,
      showBranding = true,
      brandingContent
    }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsxs(Box, { className: "min-h-screen flex", children: [
        showBranding && /* @__PURE__ */ jsxs(
          VStack,
          {
            className: cn(
              "hidden lg:flex lg:w-1/2 bg-primary relative overflow-hidden",
              "justify-between p-12"
            ),
            style: backgroundImage ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover"
            } : void 0,
            gap: "none",
            children: [
              /* @__PURE__ */ jsx(Box, { className: "absolute inset-0 bg-gradient-to-br from-primary/90 to-primary-hover/90" }),
              /* @__PURE__ */ jsx(Box, { className: "relative z-10", children: /* @__PURE__ */ jsxs(Link, { to: "/", className: "flex items-center gap-3", children: [
                logo || /* @__PURE__ */ jsx(Box, { className: "w-10 h-10 bg-[var(--color-card)]/20 rounded-xl flex items-center justify-center backdrop-blur", children: /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body1",
                    className: "text-[var(--color-foreground)] font-bold text-lg",
                    children: appName.charAt(0).toUpperCase()
                  }
                ) }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body1",
                    className: "text-2xl font-bold text-[var(--color-foreground)]",
                    children: appName
                  }
                )
              ] }) }),
              /* @__PURE__ */ jsx(Box, { className: "relative z-10", children: brandingContent || /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
                /* @__PURE__ */ jsxs(
                  Typography,
                  {
                    variant: "h1",
                    className: "text-4xl font-bold text-[var(--color-foreground)] leading-tight",
                    children: [
                      "Welcome to ",
                      appName
                    ]
                  }
                ),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body1",
                    className: "text-lg text-[var(--color-foreground)]/80 max-w-md",
                    children: "Sign in to access your dashboard and manage your account."
                  }
                ),
                /* @__PURE__ */ jsxs(Box, { className: "mt-12 p-6 bg-[var(--color-card)]/10 rounded-xl backdrop-blur", children: [
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "body1",
                      className: "text-[var(--color-foreground)]/90 italic",
                      children: '"This platform has transformed how we work. Highly recommended!"'
                    }
                  ),
                  /* @__PURE__ */ jsxs(HStack, { className: "mt-4", gap: "sm", align: "center", children: [
                    /* @__PURE__ */ jsx(Box, { className: "w-10 h-10 bg-[var(--color-card)]/20 rounded-full" }),
                    /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
                      /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "body1",
                          className: "text-[var(--color-foreground)] font-medium",
                          children: "Jane Doe"
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "body1",
                          className: "text-[var(--color-foreground)]/60 text-sm",
                          children: "CEO, Example Co."
                        }
                      )
                    ] })
                  ] })
                ] })
              ] }) }),
              /* @__PURE__ */ jsx(Box, { className: "absolute -bottom-32 -right-32 w-96 h-96 bg-[var(--color-card)]/5 rounded-full" }),
              /* @__PURE__ */ jsx(Box, { className: "absolute -top-16 -right-16 w-64 h-64 bg-[var(--color-card)]/5 rounded-full" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-1 flex items-center justify-center p-6 sm:p-12",
              "bg-background"
            ),
            children: /* @__PURE__ */ jsxs(Box, { className: "w-full max-w-md", children: [
              /* @__PURE__ */ jsx(Box, { className: "lg:hidden mb-8 text-center", children: /* @__PURE__ */ jsxs(Link, { to: "/", className: "inline-flex items-center gap-3", children: [
                logo || /* @__PURE__ */ jsx(Box, { className: "w-12 h-12 bg-primary rounded-xl flex items-center justify-center", children: /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body1",
                    className: "text-[var(--color-foreground)] font-bold text-xl",
                    children: appName.charAt(0).toUpperCase()
                  }
                ) }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body1",
                    className: "text-2xl font-bold text-foreground",
                    children: appName
                  }
                )
              ] }) }),
              /* @__PURE__ */ jsx(Outlet, {})
            ] })
          }
        )
      ] });
    };
    AuthLayout.displayName = "AuthLayout";
  }
});

// components/avl/types/avl-atom-types.ts
function getStateRole(name, isInitial, isTerminal, transitionCount, maxTransitionCount) {
  if (isInitial) return "initial";
  if (isTerminal) return "terminal";
  if (/error|fail|invalid/i.test(name)) return "error";
  if (transitionCount != null && maxTransitionCount != null && transitionCount === maxTransitionCount && transitionCount >= 3) return "hub";
  return "default";
}
var STATE_COLORS, EFFECT_CATEGORY_COLORS, EFFECT_TYPE_TO_CATEGORY, CONNECTION_COLORS;
var init_avl_atom_types = __esm({
  "components/avl/types/avl-atom-types.ts"() {
    STATE_COLORS = {
      initial: { fill: "#22C55E1F", border: "#16A34A" },
      terminal: { fill: "#EF44441F", border: "#DC2626" },
      hub: { fill: "#3B82F61F", border: "#2563EB" },
      error: { fill: "#F59E0B1F", border: "#D97706" },
      default: { fill: "#6B72801F", border: "#4B5563" }
    };
    EFFECT_CATEGORY_COLORS = {
      ui: { color: "#8B5CF6", bg: "#8B5CF614" },
      data: { color: "#3B82F6", bg: "#3B82F614" },
      communication: { color: "#F97316", bg: "#F9731614" },
      lifecycle: { color: "#10B981", bg: "#10B98114" },
      control: { color: "#6B7280", bg: "#6B728014" }
    };
    EFFECT_TYPE_TO_CATEGORY = {
      "render-ui": "ui",
      "navigate": "ui",
      "set": "data",
      "persist": "data",
      "fetch": "data",
      "emit": "communication",
      "call-service": "communication",
      "spawn": "lifecycle",
      "despawn": "lifecycle",
      "do": "control",
      "if": "control",
      "log": "control"
    };
    CONNECTION_COLORS = {
      forward: { color: "#1E293B", width: 2, dash: "none" },
      backward: { color: "#94A3B8", width: 1.5, dash: "6 3" },
      selfLoop: { color: "#CBD5E1", width: 1, dash: "3 2" },
      emitListen: { color: "#F97316", width: 1.5, dash: "4 3" }
    };
  }
});
function computeWidth(explicit, transitionCount) {
  if (explicit != null) return explicit;
  if (transitionCount == null) return 100;
  if (transitionCount >= 5) return 160;
  if (transitionCount >= 3) return 130;
  return 100;
}
var AvlState;
var init_AvlState = __esm({
  "components/avl/atoms/AvlState.tsx"() {
    "use client";
    init_avl_atom_types();
    AvlState = ({
      x = 0,
      y = 0,
      name,
      isInitial = false,
      isTerminal = false,
      width: explicitWidth,
      height = 40,
      color = "var(--color-primary)",
      opacity = 1,
      className,
      role,
      transitionCount
    }) => {
      const width = computeWidth(explicitWidth, transitionCount);
      const rx = height / 2;
      const roleColors = role ? STATE_COLORS[role] : null;
      const fillColor = roleColors ? roleColors.fill : "none";
      const strokeColor = roleColors ? roleColors.border : color;
      const textColor = roleColors ? roleColors.border : color;
      return /* @__PURE__ */ jsxs("g", { className, opacity, transform: `translate(${x},${y})`, children: [
        isInitial && /* @__PURE__ */ jsx(
          "circle",
          {
            cx: -16,
            cy: height / 2,
            r: 6,
            fill: strokeColor
          }
        ),
        isTerminal && /* @__PURE__ */ jsx(
          "rect",
          {
            x: -4,
            y: -4,
            width: width + 8,
            height: height + 8,
            rx: rx + 4,
            ry: rx + 4,
            fill: "none",
            stroke: strokeColor,
            strokeWidth: 1,
            opacity: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: 0,
            y: 0,
            width,
            height,
            rx,
            ry: rx,
            fill: fillColor,
            stroke: strokeColor,
            strokeWidth: 2
          }
        ),
        name && /* @__PURE__ */ jsx(
          "text",
          {
            x: width / 2,
            y: height / 2,
            textAnchor: "middle",
            dominantBaseline: "central",
            fill: textColor,
            fontSize: role ? 14 : 11,
            fontWeight: role ? 600 : 400,
            fontFamily: "inherit",
            children: name
          }
        )
      ] });
    };
    AvlState.displayName = "AvlState";
  }
});
function effectIcon(type, x, y, s, color) {
  switch (type) {
    case "render-ui":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { x: x - s, y: y - s, width: s * 2, height: s * 2, fill: "none", stroke: color, strokeWidth: 1.5, rx: 1 }),
        /* @__PURE__ */ jsx("line", { x1: x, y1: y - s, x2: x, y2: y + s, stroke: color, strokeWidth: 1 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y, x2: x + s, y2: y, stroke: color, strokeWidth: 1 })
      ] });
    case "set":
      return /* @__PURE__ */ jsx(
        "path",
        {
          d: `M${x - s * 0.6},${y + s} L${x - s},${y + s * 0.4} L${x + s * 0.4},${y - s} L${x + s},${y - s * 0.4} Z`,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5,
          strokeLinejoin: "round"
        }
      );
    case "persist":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("ellipse", { cx: x, cy: y - s * 0.6, rx: s, ry: s * 0.4, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.6, x2: x - s, y2: y + s * 0.4, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x + s, y1: y - s * 0.6, x2: x + s, y2: y + s * 0.4, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("ellipse", { cx: x, cy: y + s * 0.4, rx: s, ry: s * 0.4, fill: "none", stroke: color, strokeWidth: 1.5 })
      ] });
    case "fetch":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x, y1: y - s, x2: x, y2: y + s * 0.6, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x - s * 0.5},${y + s * 0.1} ${x},${y + s} ${x + s * 0.5},${y + s * 0.1}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
      ] });
    case "emit":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s * 0.3, fill: color }),
        /* @__PURE__ */ jsx("path", { d: `M${x - s * 0.7},${y - s * 0.7} A${s},${s} 0 0,1 ${x + s * 0.7},${y - s * 0.7}`, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("path", { d: `M${x - s},${y - s} A${s * 1.4},${s * 1.4} 0 0,1 ${x + s},${y - s}`, fill: "none", stroke: color, strokeWidth: 1, opacity: 0.6 })
      ] });
    case "navigate":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y, x2: x + s * 0.6, y2: y, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x + s * 0.1},${y - s * 0.5} ${x + s},${y} ${x + s * 0.1},${y + s * 0.5}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
      ] });
    case "call-service":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.3, x2: x + s, y2: y - s * 0.3, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x + s * 0.5},${y - s * 0.7} ${x + s},${y - s * 0.3} ${x + s * 0.5},${y + s * 0.1}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" }),
        /* @__PURE__ */ jsx("line", { x1: x + s, y1: y + s * 0.3, x2: x - s, y2: y + s * 0.3, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x - s * 0.5},${y - s * 0.1} ${x - s},${y + s * 0.3} ${x - s * 0.5},${y + s * 0.7}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
      ] });
    case "spawn":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x - s * 0.5, y1: y, x2: x + s * 0.5, y2: y, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x, y1: y - s * 0.5, x2: x, y2: y + s * 0.5, stroke: color, strokeWidth: 1.5 })
      ] });
    case "despawn":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x - s * 0.5, y1: y, x2: x + s * 0.5, y2: y, stroke: color, strokeWidth: 1.5 })
      ] });
    case "do":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polygon", { points: `${x - s * 0.3},${y - s * 0.5} ${x + s * 0.5},${y} ${x - s * 0.3},${y + s * 0.5}`, fill: color })
      ] });
    case "if":
      return /* @__PURE__ */ jsx(
        "polygon",
        {
          points: `${x},${y - s} ${x + s * 0.7},${y} ${x},${y + s} ${x - s * 0.7},${y}`,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5,
          strokeLinejoin: "round"
        }
      );
    case "log":
      return /* @__PURE__ */ jsx(
        "text",
        {
          x,
          y,
          textAnchor: "middle",
          dominantBaseline: "central",
          fill: color,
          fontSize: s * 2.2,
          fontFamily: "serif",
          children: "\xB6"
        }
      );
  }
}
var AvlEffect;
var init_AvlEffect = __esm({
  "components/avl/atoms/AvlEffect.tsx"() {
    "use client";
    init_avl_atom_types();
    AvlEffect = ({
      x = 0,
      y = 0,
      effectType,
      size = 8,
      label,
      color = "var(--color-primary)",
      opacity = 1,
      className,
      showBackground = false
    }) => {
      const category = EFFECT_TYPE_TO_CATEGORY[effectType] ?? "control";
      const catColors = EFFECT_CATEGORY_COLORS[category];
      const iconColor = showBackground ? catColors.color : color;
      return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        showBackground && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: size * 1.2, fill: catColors.bg }),
          /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: size * 1.2, fill: "none", stroke: catColors.color, strokeWidth: 0.5, opacity: 0.3 })
        ] }),
        effectIcon(effectType, x, y, size, iconColor),
        label && /* @__PURE__ */ jsx(
          "text",
          {
            x,
            y: y + size + 10,
            textAnchor: "middle",
            fill: iconColor,
            fontSize: 11,
            fontWeight: 500,
            fontFamily: "inherit",
            opacity: 0.7,
            children: label
          }
        )
      ] });
    };
    AvlEffect.displayName = "AvlEffect";
  }
});
var MAX_VISIBLE_EFFECTS, AvlTransitionLane;
var init_AvlTransitionLane = __esm({
  "components/avl/molecules/AvlTransitionLane.tsx"() {
    "use client";
    init_AvlEffect();
    init_avl_atom_types();
    MAX_VISIBLE_EFFECTS = 6;
    AvlTransitionLane = ({
      event,
      guard,
      effects,
      width,
      x = 0,
      y = 0,
      isBackward = false,
      isSelfLoop = false,
      color = "var(--color-primary)",
      onTransitionClick
    }) => {
      const rowHeight = 22;
      const padding = 8;
      const eventRow = padding;
      const guardRow = guard ? eventRow + rowHeight : eventRow;
      const effectsRow = guard ? guardRow + rowHeight : eventRow + rowHeight;
      const totalHeight = effectsRow + (effects.length > 0 ? rowHeight + padding : padding);
      const connStyle = isSelfLoop ? CONNECTION_COLORS.selfLoop : isBackward ? CONNECTION_COLORS.backward : CONNECTION_COLORS.forward;
      const visibleEffects = effects.slice(0, MAX_VISIBLE_EFFECTS);
      const overflow = effects.length - MAX_VISIBLE_EFFECTS;
      const effectSpacing = 28;
      return /* @__PURE__ */ jsxs(
        "g",
        {
          transform: `translate(${x},${y})`,
          style: { cursor: onTransitionClick ? "pointer" : "default" },
          onClick: onTransitionClick,
          role: onTransitionClick ? "button" : void 0,
          children: [
            /* @__PURE__ */ jsx(
              "rect",
              {
                x: 0,
                y: 0,
                width,
                height: totalHeight,
                rx: 6,
                fill: connStyle.color,
                fillOpacity: 0.03,
                stroke: connStyle.color,
                strokeWidth: 0.5,
                strokeOpacity: 0.15,
                strokeDasharray: connStyle.dash === "none" ? void 0 : connStyle.dash
              }
            ),
            /* @__PURE__ */ jsx(
              "text",
              {
                x: padding + 14,
                y: eventRow + rowHeight * 0.65,
                fontSize: 14,
                fontWeight: 600,
                fill: color,
                fontFamily: "inherit",
                children: event
              }
            ),
            /* @__PURE__ */ jsx(
              "text",
              {
                x: padding + 4,
                y: eventRow + rowHeight * 0.65,
                fontSize: 10,
                fill: color,
                opacity: 0.5,
                children: "\u26A1"
              }
            ),
            guard && /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "polygon",
                {
                  points: `${padding + 6},${guardRow + rowHeight * 0.35} ${padding + 10},${guardRow + rowHeight * 0.15} ${padding + 14},${guardRow + rowHeight * 0.35} ${padding + 10},${guardRow + rowHeight * 0.55}`,
                  fill: "none",
                  stroke: color,
                  strokeWidth: 1,
                  opacity: 0.5
                }
              ),
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: padding + 20,
                  y: guardRow + rowHeight * 0.6,
                  fontSize: 12,
                  fontWeight: 400,
                  fill: color,
                  opacity: 0.6,
                  fontFamily: "inherit",
                  children: guard
                }
              )
            ] }),
            visibleEffects.length > 0 && /* @__PURE__ */ jsxs("g", { children: [
              visibleEffects.map((eff, i) => /* @__PURE__ */ jsx(
                AvlEffect,
                {
                  x: padding + 12 + i * effectSpacing,
                  y: effectsRow + rowHeight * 0.5,
                  effectType: eff.type,
                  size: 10,
                  showBackground: true
                },
                i
              )),
              overflow > 0 && /* @__PURE__ */ jsxs(
                "text",
                {
                  x: padding + 12 + visibleEffects.length * effectSpacing,
                  y: effectsRow + rowHeight * 0.6,
                  fontSize: 10,
                  fill: color,
                  opacity: 0.5,
                  fontFamily: "inherit",
                  children: [
                    "+",
                    overflow
                  ]
                }
              )
            ] })
          ]
        }
      );
    };
    AvlTransitionLane.displayName = "AvlTransitionLane";
  }
});
var GUTTER_WIDTH, EVENT_SPACING, HEADER_Y, EVENT_START_Y, AvlSwimLane;
var init_AvlSwimLane = __esm({
  "components/avl/molecules/AvlSwimLane.tsx"() {
    "use client";
    init_avl_atom_types();
    GUTTER_WIDTH = 120;
    EVENT_SPACING = 24;
    HEADER_Y = 16;
    EVENT_START_Y = 36;
    AvlSwimLane = ({
      listenedEvents,
      emittedEvents,
      centerWidth,
      height,
      color = "var(--color-primary)",
      children
    }) => {
      const rightX = GUTTER_WIDTH + centerWidth;
      const totalWidth = rightX + GUTTER_WIDTH;
      const emitColor = CONNECTION_COLORS.emitListen.color;
      return /* @__PURE__ */ jsxs("g", { children: [
        listenedEvents.length > 0 && /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(
            "text",
            {
              x: 8,
              y: HEADER_Y,
              fontSize: 10,
              fontWeight: 600,
              fill: color,
              opacity: 0.4,
              fontFamily: "inherit",
              children: "LISTENS"
            }
          ),
          listenedEvents.map((evt, i) => {
            const ey = EVENT_START_Y + i * EVENT_SPACING;
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "polygon",
                {
                  points: `${4},${ey} ${12},${ey - 5} ${12},${ey + 5}`,
                  fill: emitColor,
                  opacity: 0.6
                }
              ),
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: 16,
                  y: ey + 4,
                  fontSize: 11,
                  fontWeight: 500,
                  fill: color,
                  opacity: 0.6,
                  fontFamily: "inherit",
                  children: evt
                }
              ),
              /* @__PURE__ */ jsx(
                "line",
                {
                  x1: GUTTER_WIDTH - 4,
                  y1: ey,
                  x2: GUTTER_WIDTH,
                  y2: ey,
                  stroke: emitColor,
                  strokeWidth: 1,
                  strokeDasharray: "3 2",
                  opacity: 0.4
                }
              )
            ] }, evt + i);
          })
        ] }),
        /* @__PURE__ */ jsx(
          "line",
          {
            x1: GUTTER_WIDTH,
            y1: 0,
            x2: GUTTER_WIDTH,
            y2: height,
            stroke: color,
            strokeWidth: 0.5,
            strokeDasharray: "4 3",
            opacity: 0.12
          }
        ),
        /* @__PURE__ */ jsx("g", { transform: `translate(${GUTTER_WIDTH}, 0)`, children }),
        /* @__PURE__ */ jsx(
          "line",
          {
            x1: rightX,
            y1: 0,
            x2: rightX,
            y2: height,
            stroke: color,
            strokeWidth: 0.5,
            strokeDasharray: "4 3",
            opacity: 0.12
          }
        ),
        emittedEvents.length > 0 && /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(
            "text",
            {
              x: rightX + 8,
              y: HEADER_Y,
              fontSize: 10,
              fontWeight: 600,
              fill: color,
              opacity: 0.4,
              fontFamily: "inherit",
              children: "EMITS"
            }
          ),
          emittedEvents.map((evt, i) => {
            const ey = EVENT_START_Y + i * EVENT_SPACING;
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: totalWidth - 18,
                  y: ey + 4,
                  fontSize: 11,
                  fontWeight: 500,
                  fill: color,
                  opacity: 0.6,
                  fontFamily: "inherit",
                  textAnchor: "end",
                  children: evt
                }
              ),
              /* @__PURE__ */ jsx(
                "polygon",
                {
                  points: `${totalWidth - 4},${ey} ${totalWidth - 12},${ey - 5} ${totalWidth - 12},${ey + 5}`,
                  fill: emitColor,
                  opacity: 0.6
                }
              ),
              /* @__PURE__ */ jsx(
                "line",
                {
                  x1: rightX,
                  y1: ey,
                  x2: rightX + 4,
                  y2: ey,
                  stroke: emitColor,
                  strokeWidth: 1,
                  strokeDasharray: "3 2",
                  opacity: 0.4
                }
              )
            ] }, evt + i);
          })
        ] })
      ] });
    };
    AvlSwimLane.displayName = "AvlSwimLane";
  }
});
function stateWidth(transitionCount) {
  if (transitionCount >= 5) return 160;
  if (transitionCount >= 3) return 130;
  return 110;
}
async function computeTraitLayout(data) {
  const transitionCounts = {};
  for (const s of data.states) transitionCounts[s.name] = 0;
  for (const t of data.transitions) {
    transitionCounts[t.from] = (transitionCounts[t.from] ?? 0) + 1;
    transitionCounts[t.to] = (transitionCounts[t.to] ?? 0) + 1;
  }
  const maxTC = Math.max(...Object.values(transitionCounts), 0);
  const LABEL_BASE_W = 100;
  const LABEL_H = 44;
  const elkGraph = {
    id: "root",
    layoutOptions: {
      "elk.algorithm": "layered",
      "elk.direction": "RIGHT",
      "elk.spacing.nodeNode": "80",
      "elk.spacing.edgeNode": "30",
      "elk.spacing.edgeEdge": "24",
      "elk.spacing.edgeLabel": "10",
      "elk.spacing.labelLabel": "8",
      "elk.layered.spacing.nodeNodeBetweenLayers": "100",
      "elk.edgeLabels.placement": "CENTER",
      "elk.layered.mergeEdges": "false",
      "elk.layered.nodePlacement.strategy": "NETWORK_SIMPLEX"
    },
    children: data.states.map((s) => {
      const tc = transitionCounts[s.name] ?? 0;
      const w = stateWidth(tc);
      return {
        id: s.name,
        width: w,
        height: STATE_H,
        labels: [{ text: s.name, width: w - 10, height: 14 }]
      };
    }),
    edges: data.transitions.map((t, i) => {
      const textW = Math.max(t.event.length * 8, 60);
      const iconsW = Math.min(t.effects.length, 6) * 28 + 20;
      const labelW = Math.max(textW, iconsW, LABEL_BASE_W);
      return {
        id: `e${i}`,
        sources: [t.from],
        targets: [t.to],
        labels: [{
          text: t.event,
          width: labelW,
          height: LABEL_H
        }]
      };
    })
  };
  const layout = await elk.layout(elkGraph);
  const layoutChildren = layout.children ?? [];
  const layoutEdges = layout.edges ?? [];
  const nodeXMap = {};
  for (const n of layoutChildren) {
    nodeXMap[n.id] = n.x ?? 0;
  }
  const nodes = layoutChildren.map((n) => {
    const name = n.id;
    const stateInfo = data.states.find((s) => s.name === name);
    const tc = transitionCounts[name] ?? 0;
    return {
      id: name,
      x: n.x ?? 0,
      y: n.y ?? 0,
      width: n.width ?? 110,
      height: n.height ?? STATE_H,
      isInitial: stateInfo?.isInitial ?? void 0,
      isTerminal: stateInfo?.isTerminal ?? void 0,
      role: getStateRole(name, stateInfo?.isInitial ?? void 0, stateInfo?.isTerminal ?? void 0, tc, maxTC),
      transitionCount: tc
    };
  });
  const edges = layoutEdges.map((e, i) => {
    const t = data.transitions[i];
    const labels = e.labels ?? [];
    const label = labels[0];
    const sections = e.sections ?? [];
    const points = [];
    for (const section of sections) {
      const bendPoints = section.bendPoints ?? [];
      points.push({ x: section.startPoint.x, y: section.startPoint.y });
      for (const bp of bendPoints) points.push({ x: bp.x, y: bp.y });
      points.push({ x: section.endPoint.x, y: section.endPoint.y });
    }
    const isSelf = t.from === t.to;
    const isBackward = !isSelf && (nodeXMap[t.to] ?? 0) <= (nodeXMap[t.from] ?? 0);
    const lw = label?.width ?? LABEL_BASE_W;
    const lh = label?.height ?? LABEL_H;
    return {
      id: e.id,
      from: t.from,
      to: t.to,
      event: t.event,
      effects: t.effects,
      guard: !!t.guard,
      guardExpr: typeof t.guard === "string" ? t.guard : void 0,
      index: t.index,
      labelX: label?.x ?? 0,
      labelY: label?.y ?? 0,
      labelW: lw,
      labelH: lh,
      points,
      isSelf,
      isBackward
    };
  });
  return {
    nodes,
    edges,
    width: layout.width ?? 600,
    height: layout.height ?? 400
  };
}
function edgePath(points) {
  if (points.length === 0) return "";
  let d = `M ${points[0].x},${points[0].y}`;
  for (let i = 1; i < points.length; i++) d += ` L ${points[i].x},${points[i].y}`;
  return d;
}
var STATE_H, elk;
var init_avl_elk_layout = __esm({
  "components/avl/lib/avl-elk-layout.ts"() {
    init_avl_atom_types();
    STATE_H = 40;
    elk = new ELK();
  }
});
var log4, SWIM_GUTTER, CENTER_W, BehaviorView;
var init_BehaviorView = __esm({
  "components/avl/molecules/BehaviorView.tsx"() {
    "use client";
    init_AvlState();
    init_AvlTransitionLane();
    init_AvlSwimLane();
    init_avl_atom_types();
    init_avl_elk_layout();
    log4 = createLogger("almadar:ui:avl:behavior-view");
    SWIM_GUTTER = 120;
    CENTER_W = 360;
    BehaviorView = ({ data }) => {
      const { t } = useTranslate();
      const [layout, setLayout] = useState(null);
      const traitName = data.traits[0]?.name;
      const traitData = traitName ? data.traitDetails[traitName] : void 0;
      const dataKey = useMemo(() => JSON.stringify(traitData), [traitData]);
      useEffect(() => {
        if (!traitData) return;
        computeTraitLayout(traitData).then(setLayout).catch((err) => log4.error("compute-trait-layout-failed", { error: err instanceof Error ? err : String(err) }));
      }, [dataKey]);
      if (!traitData) {
        return /* @__PURE__ */ jsx("div", { className: "rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-4 text-center text-[var(--color-muted-foreground)] text-sm", children: t("avl.noTraitData") });
      }
      if (!layout) {
        return /* @__PURE__ */ jsx("div", { className: "rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-4 text-center text-[var(--color-muted-foreground)] text-sm", children: t("avl.computingLayout") });
      }
      const hasExternal = traitData.listenedEvents.length > 0 || traitData.emittedEvents.length > 0;
      const viewW = hasExternal ? SWIM_GUTTER + CENTER_W + SWIM_GUTTER : CENTER_W + 60;
      const machineOffsetX = hasExternal ? 0 : 30;
      const padding = 20;
      const availW = CENTER_W - padding * 2;
      const availH = 300;
      const scale = Math.min(1, availW / layout.width, availH / layout.height);
      const scaledH = layout.height * scale;
      const scaledW = layout.width * scale;
      const offsetX = padding + (availW - scaledW) / 2;
      const offsetY = 50 + (availH - scaledH) / 2;
      const machineHeight = scaledH + 100;
      const renderMachine = /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("text", { x: CENTER_W / 2, y: 20, textAnchor: "middle", fill: "var(--color-foreground)", fontSize: 18, fontWeight: "700", fontFamily: "inherit", children: traitData.name }),
        /* @__PURE__ */ jsx("text", { x: CENTER_W / 2, y: 36, textAnchor: "middle", fill: "var(--color-muted-foreground)", fontSize: 11, opacity: 0.5, fontFamily: "inherit", children: t("avl.onEntity", { entity: traitData.linkedEntity }) }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsx("marker", { id: "bvArrow", viewBox: "0 0 10 10", refX: "9", refY: "5", markerWidth: "6", markerHeight: "6", orient: "auto-start-reverse", children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: CONNECTION_COLORS.forward.color, opacity: 0.7 }) }),
          /* @__PURE__ */ jsx("marker", { id: "bvArrowBack", viewBox: "0 0 10 10", refX: "9", refY: "5", markerWidth: "6", markerHeight: "6", orient: "auto-start-reverse", children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: CONNECTION_COLORS.backward.color, opacity: 0.5 }) })
        ] }),
        /* @__PURE__ */ jsxs("g", { transform: `translate(${offsetX},${offsetY}) scale(${scale})`, children: [
          layout.edges.map((edge) => {
            const conn = edge.isSelf ? CONNECTION_COLORS.selfLoop : edge.isBackward ? CONNECTION_COLORS.backward : CONNECTION_COLORS.forward;
            const marker = edge.isBackward || edge.isSelf ? "url(#bvArrowBack)" : "url(#bvArrow)";
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: edgePath(edge.points),
                  fill: "none",
                  stroke: conn.color,
                  strokeWidth: conn.width,
                  strokeDasharray: conn.dash === "none" ? void 0 : conn.dash,
                  opacity: 0.5,
                  markerEnd: marker
                }
              ),
              /* @__PURE__ */ jsx(
                AvlTransitionLane,
                {
                  x: edge.labelX,
                  y: edge.labelY,
                  event: edge.event,
                  guard: edge.guardExpr,
                  effects: edge.effects.map((e) => ({ type: e.type })),
                  width: edge.labelW,
                  isBackward: edge.isBackward,
                  isSelfLoop: edge.isSelf
                }
              )
            ] }, edge.id);
          }),
          layout.nodes.map((node) => /* @__PURE__ */ jsx(
            AvlState,
            {
              x: node.x,
              y: node.y,
              width: node.width,
              height: node.height,
              name: node.id,
              isInitial: node.isInitial,
              isTerminal: node.isTerminal,
              role: node.role,
              transitionCount: node.transitionCount
            },
            node.id
          ))
        ] })
      ] });
      const svgH = machineHeight + 20;
      if (!hasExternal) {
        return /* @__PURE__ */ jsx("div", { className: "rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] overflow-hidden", children: /* @__PURE__ */ jsx("svg", { width: viewW, height: svgH, viewBox: `0 0 ${viewW} ${svgH}`, children: /* @__PURE__ */ jsx("g", { transform: `translate(${machineOffsetX}, 0)`, children: renderMachine }) }) });
      }
      return /* @__PURE__ */ jsx("div", { className: "rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] overflow-hidden", children: /* @__PURE__ */ jsx("svg", { width: viewW, height: svgH, viewBox: `0 0 ${viewW} ${svgH}`, children: /* @__PURE__ */ jsx(
        AvlSwimLane,
        {
          listenedEvents: traitData.listenedEvents,
          emittedEvents: traitData.emittedEvents,
          centerWidth: CENTER_W,
          height: machineHeight,
          children: renderMachine
        }
      ) }) });
    };
    BehaviorView.displayName = "BehaviorView";
  }
});
function LearningScene3D({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  drawables,
  camera,
  lighting,
  post,
  showGrid = false,
  shadows,
  interactive,
  isLoading,
  error,
  onItemClick
}) {
  const instanceId = useId().replace(/[^a-zA-Z0-9]/g, "");
  const clickEvent = onItemClick ? `LEARNING_SCENE_3D.ITEM_CLICK.${instanceId}` : void 0;
  const onItemClickRef = useRef(onItemClick);
  onItemClickRef.current = onItemClick;
  useEventListener(`UI:${clickEvent ?? "LEARNING_SCENE_3D.ITEM_CLICK.__disabled"}`, (event) => {
    const unitId = event.payload?.unitId;
    if (typeof unitId === "string") onItemClickRef.current?.(unitId);
  });
  if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" && post?.bloom) {
    const unknownKeys = Object.keys(post.bloom).filter((k) => !KNOWN_BLOOM_KEYS.has(k));
    if (unknownKeys.length > 0) {
      sceneLog.debug("post.bloom has unrecognized keys \u2014 only intensity/threshold/smoothing are read", { unknownKeys });
    }
  }
  const props3d = {
    drawables,
    isLoading,
    error: error ? error.message : null,
    cameraMode: camera?.mode ?? "perspective",
    ...camera?.zoom !== void 0 ? { zoom: camera.zoom } : {},
    ...camera?.fov !== void 0 ? { fov: camera.fov } : {},
    ...camera?.azimuth !== void 0 ? { azimuth: camera.azimuth } : {},
    ...camera?.elevation !== void 0 ? { elevation: camera.elevation } : {},
    ...camera?.target !== void 0 ? { followTarget: camera.target } : {},
    backgroundColor,
    showGrid,
    ...shadows !== void 0 ? { shadows } : {},
    ...interactive !== void 0 ? { controlsEnabled: interactive } : {},
    lighting,
    post,
    ...clickEvent !== void 0 ? { unitClickEvent: clickEvent } : {}
  };
  return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx("div", { style: { width, height, display: "flex" }, children: /* @__PURE__ */ jsx(Suspense, { fallback: null, children: /* @__PURE__ */ jsx(Canvas3DHost, { ...props3d }) }) })
  ] }) });
}
function meshSphere(id, x, y, z, radius, color, opts) {
  return {
    type: "draw-mesh",
    ...id !== void 0 ? { id } : {},
    shape: opts?.shape ?? "sphere",
    position: { x, y, z },
    radius,
    pivot: "center",
    segments: opts?.segments ?? 24,
    material: { color, ...opts?.material },
    ...opts?.opacity !== void 0 ? { opacity: opts.opacity } : {}
  };
}
function axisRotation(from, to) {
  const wx = to[0] - from[0];
  const wy = to[2] - from[2];
  const wz = to[1] - from[1];
  const len = Math.sqrt(wx * wx + wy * wy + wz * wz);
  const tilt = Math.acos(Math.min(1, Math.max(-1, len > 0 ? wy / len : 1)));
  return [0, Math.atan2(wz, -wx), tilt];
}
function segmentLength(from, to) {
  const dx = to[0] - from[0];
  const dy = to[1] - from[1];
  const dz = to[2] - from[2];
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}
function cylinderBetween(from, to, radius, color) {
  const len = segmentLength(from, to);
  if (len < 1e-6) return null;
  return {
    type: "draw-mesh",
    shape: "cylinder",
    position: { x: (from[0] + to[0]) / 2, y: (from[1] + to[1]) / 2, z: (from[2] + to[2]) / 2 },
    radius,
    height: len,
    rotation: axisRotation(from, to),
    pivot: "center",
    segments: 12,
    material: { color }
  };
}
function arrowBetween(from, to, color, shaftRadius = 0.08, id) {
  const len = segmentLength(from, to);
  if (len < 1e-6) return null;
  const tipLen = Math.min(shaftRadius * 8, len * 0.35);
  const k = (len - tipLen) / len;
  const delta = [to[0] - from[0], to[1] - from[1], to[2] - from[2]];
  const shaftEnd = [delta[0] * k, delta[1] * k, delta[2] * k];
  const tipStart = shaftEnd;
  const tipEnd = delta;
  const shaft = cylinderBetween([0, 0, 0], shaftEnd, shaftRadius, color);
  const tipLenActual = segmentLength(tipStart, tipEnd);
  const tip = {
    type: "draw-mesh",
    shape: "cone",
    position: {
      x: (tipStart[0] + tipEnd[0]) / 2,
      y: (tipStart[1] + tipEnd[1]) / 2,
      z: (tipStart[2] + tipEnd[2]) / 2
    },
    radius: shaftRadius * 3,
    height: tipLenActual,
    rotation: axisRotation(tipStart, tipEnd),
    pivot: "center",
    segments: 12,
    material: { color }
  };
  return {
    type: "draw-group",
    ...id !== void 0 ? { id } : {},
    position: { x: from[0], y: from[1], z: from[2] },
    items: tipLenActual < 1e-6 ? shaft ? [shaft] : [] : shaft ? [shaft, tip] : [tip]
  };
}
function billboardLabel(text, x, y, z, opts) {
  return {
    type: "draw-text",
    text,
    position: { x, y, z },
    color: opts?.color ?? "#111827"
  };
}
function labelColorForBackground(backgroundColor) {
  const m = /^#(?:([0-9a-f]{3})|([0-9a-f]{6}))$/i.exec(backgroundColor ?? "");
  if (!m) return "#111827";
  const hex = m[1] !== void 0 ? m[1].split("").map((c) => c + c).join("") : m[2];
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance < 0.5 ? "#e5e7eb" : "#111827";
}
function get3DClickPayload(onShapeClick, idToIndex) {
  if (!onShapeClick) return void 0;
  return (id) => onShapeClick({ id, index: idToIndex.get(id) ?? -1 });
}
function polylineTube(points, radius, color, opts) {
  const maxSegments = opts?.maxSegments ?? 128;
  let pts = points;
  if (pts.length - 1 > maxSegments) {
    const step = (pts.length - 1) / maxSegments;
    const kept = [pts[0]];
    for (let s = 1; s < maxSegments; s++) kept.push(pts[Math.round(s * step)]);
    kept.push(pts[pts.length - 1]);
    pts = kept;
  }
  const out = [];
  for (let i = 0; i < pts.length - 1; i++) {
    const seg = cylinderBetween(pts[i], pts[i + 1], radius, color);
    if (seg) out.push(opts?.opacity !== void 0 ? { ...seg, opacity: opts.opacity } : seg);
  }
  return out;
}
function heightFieldMesh(spec) {
  const { nx, ny, heights, spacing = 1, x = 0, y = 0 } = spec;
  const flatShading = spec.flatShading ?? true;
  const vertices = [];
  for (let iy = 0; iy < ny; iy++) {
    for (let ix = 0; ix < nx; ix++) {
      vertices.push([
        x + (ix - (nx - 1) / 2) * spacing,
        y + (iy - (ny - 1) / 2) * spacing,
        heights[iy * nx + ix] ?? 0
      ]);
    }
  }
  const bands = [...spec.bands ?? []].sort((a, b) => (a.min ?? -Infinity) - (b.min ?? -Infinity));
  const facesByBand = /* @__PURE__ */ new Map();
  for (let iy = 0; iy < ny - 1; iy++) {
    for (let ix = 0; ix < nx - 1; ix++) {
      const v00 = iy * nx + ix;
      const v10 = iy * nx + ix + 1;
      const v01 = (iy + 1) * nx + ix;
      const v11 = (iy + 1) * nx + ix + 1;
      for (const face of [[v00, v10, v01], [v10, v11, v01]]) {
        const centroid = (vertices[face[0]][2] + vertices[face[1]][2] + vertices[face[2]][2]) / 3;
        let band = null;
        for (const b of bands) {
          if ((b.min ?? -Infinity) <= centroid) band = b;
        }
        const key = bands.length > 0 ? band : null;
        const list = facesByBand.get(key) ?? [];
        list.push(face);
        facesByBand.set(key, list);
      }
    }
  }
  const out = [];
  for (const [band, faces] of facesByBand) {
    if (faces.length === 0) continue;
    out.push({
      type: "draw-mesh",
      shape: "polyhedron",
      position: { x: 0, y: 0, z: 0 },
      vertices,
      faces,
      pivot: "center",
      material: { color: band?.color ?? spec.color ?? "#64748b", flatShading, side: "double" },
      ...spec.opacity !== void 0 ? { opacity: spec.opacity } : {}
    });
  }
  return out;
}
function arrowField(vectors, opts) {
  const scale = opts?.scale ?? 1;
  const out = [];
  for (const v of vectors) {
    const to = [
      v.from[0] + v.delta[0] * scale,
      v.from[1] + v.delta[1] * scale,
      v.from[2] + v.delta[2] * scale
    ];
    const arrow = arrowBetween(v.from, to, v.color ?? "#dc2626", v.width, v.id);
    if (arrow) out.push(arrow);
    if (v.label) out.push(billboardLabel(v.label, to[0], to[1], to[2], { color: opts?.labelColor }));
  }
  return out;
}
function helixDrawables(spec, opts) {
  const count = spec.count ?? spec.rungs?.length ?? 0;
  const rungs = Array.from({ length: count }, (_, i) => spec.rungs?.[i] ?? {});
  const radius = spec.radius ?? 1;
  const rise = spec.rise ?? 0.34;
  const twistRad = (spec.twistDeg ?? 36) * (Math.PI / 180);
  const strandAColor = spec.strandAColor ?? "#38bdf8";
  const strandBColor = spec.strandBColor ?? "#fb923c";
  const backboneRadius = spec.backboneRadius ?? 0.16;
  const rungRadius = spec.rungRadius ?? 0.12;
  const cx = spec.x ?? 0;
  const cy = spec.y ?? 0;
  const cz = spec.z ?? 0;
  const unwoundCount = spec.unwoundCount ?? 0;
  const unwindSpread = spec.unwindSpread ?? 1.8;
  const strandA = [];
  const strandB = [];
  for (let i = 0; i < count; i++) {
    const yi = cy + (i - (count - 1) / 2) * rise;
    const theta = i * twistRad;
    const s = i < unwoundCount ? unwindSpread : 1;
    strandA.push([cx + s * radius * Math.cos(theta), yi, cz + s * radius * Math.sin(theta)]);
    strandB.push([cx + s * radius * Math.cos(theta + Math.PI), yi, cz + s * radius * Math.sin(theta + Math.PI)]);
  }
  const out = [];
  for (let i = 0; i < count; i++) {
    out.push(meshSphere(`hx-a-${i}`, strandA[i][0], strandA[i][1], strandA[i][2], backboneRadius, strandAColor));
    out.push(meshSphere(`hx-b-${i}`, strandB[i][0], strandB[i][1], strandB[i][2], backboneRadius, strandBColor));
    if (i > 0) {
      const segA = cylinderBetween(strandA[i - 1], strandA[i], backboneRadius, strandAColor);
      if (segA) out.push(segA);
      const segB = cylinderBetween(strandB[i - 1], strandB[i], backboneRadius, strandBColor);
      if (segB) out.push(segB);
    }
    const rung = rungs[i];
    const rungColor = rung.color ?? "#94a3b8";
    const rod = cylinderBetween(strandA[i], strandB[i], rungRadius, rungColor);
    if (rod) out.push(rod);
    const mid = [
      (strandA[i][0] + strandB[i][0]) / 2,
      (strandA[i][1] + strandB[i][1]) / 2,
      (strandA[i][2] + strandB[i][2]) / 2
    ];
    const markerRadius = rung.radius ?? rungRadius;
    out.push(meshSphere(rung.id, mid[0], mid[1], mid[2], markerRadius, rungColor));
    if (rung.label) out.push(billboardLabel(rung.label, mid[0], mid[1], mid[2] + markerRadius, { color: opts?.labelColor }));
  }
  return out;
}
function latticeDrawables(spec, opts) {
  const nx = spec.nx ?? 2;
  const ny = spec.ny ?? 2;
  const nz = spec.nz ?? 2;
  const latticeConstant = spec.latticeConstant ?? 2;
  const bondRadius = spec.bondRadius ?? 0.06;
  const highlightCell = spec.highlightCell ?? false;
  const dimColor = spec.dimColor ?? "#475569";
  const showLabels = spec.showLabels ?? false;
  const selectedColor = spec.selectedColor ?? "#f59e0b";
  const posByKey = /* @__PURE__ */ new Map();
  const inCellByKey = /* @__PURE__ */ new Map();
  const out = [];
  for (const site of spec.basis) {
    const snx = site.xEdge ? nx + 1 : nx;
    const sny = site.yEdge ? ny + 1 : ny;
    const snz = site.zEdge ? nz + 1 : nz;
    for (let i = 0; i < snx; i++) {
      for (let j = 0; j < sny; j++) {
        for (let k = 0; k < snz; k++) {
          const key = `${site.key}-${i}-${j}-${k}`;
          const inCell = i + site.dx <= 1 && j + site.dy <= 1 && k + site.dz <= 1;
          const pos = [
            (i + site.dx) * latticeConstant - nx * latticeConstant / 2,
            (j + site.dy) * latticeConstant - ny * latticeConstant / 2,
            (k + site.dz) * latticeConstant - nz * latticeConstant / 2
          ];
          posByKey.set(key, pos);
          inCellByKey.set(key, inCell);
          const isSelected = spec.selectedId === `lat-${key}`;
          const color = isSelected ? selectedColor : highlightCell && !inCell ? dimColor : site.color ?? "#2563eb";
          const radius = (site.radius ?? 0.3) * (isSelected ? 1.4 : 1);
          out.push(meshSphere(`lat-${key}`, pos[0], pos[1], pos[2], radius, color));
          if (showLabels && site.element) {
            out.push(billboardLabel(site.element, pos[0], pos[1], pos[2] + radius, { color: opts?.labelColor }));
          }
        }
      }
    }
  }
  const basisByKey = new Map(spec.basis.map((s) => [s.key, s]));
  for (const bond of spec.bonds ?? []) {
    const fromSite = basisByKey.get(bond.from);
    const toSite = basisByKey.get(bond.to);
    if (!fromSite || !toSite) continue;
    const fnx = fromSite.xEdge ? nx + 1 : nx;
    const fny = fromSite.yEdge ? ny + 1 : ny;
    const fnz = fromSite.zEdge ? nz + 1 : nz;
    const tnx = toSite.xEdge ? nx + 1 : nx;
    const tny = toSite.yEdge ? ny + 1 : ny;
    const tnz = toSite.zEdge ? nz + 1 : nz;
    const bdx = bond.dx ?? 0;
    const bdy = bond.dy ?? 0;
    const bdz = bond.dz ?? 0;
    for (let i = 0; i < fnx; i++) {
      for (let j = 0; j < fny; j++) {
        for (let k = 0; k < fnz; k++) {
          const ti = i + bdx;
          const tj = j + bdy;
          const tk = k + bdz;
          if (ti < 0 || ti >= tnx || tj < 0 || tj >= tny || tk < 0 || tk >= tnz) continue;
          const fromKey = `${fromSite.key}-${i}-${j}-${k}`;
          const toKey = `${toSite.key}-${ti}-${tj}-${tk}`;
          const fromPos = posByKey.get(fromKey);
          const toPos = posByKey.get(toKey);
          if (!fromPos || !toPos) continue;
          const dimmed = highlightCell && !(inCellByKey.get(fromKey) && inCellByKey.get(toKey));
          const seg = cylinderBetween(fromPos, toPos, bondRadius, dimmed ? dimColor : bond.color ?? "#6b7280");
          if (seg) out.push(seg);
        }
      }
    }
  }
  return out;
}
var sceneLog, KNOWN_BLOOM_KEYS, Canvas3DHost;
var init_learningScene3D = __esm({
  "components/learning/molecules/learningScene3D.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_useEventBus();
    sceneLog = createLogger("almadar:ui:learning-scene-3d");
    KNOWN_BLOOM_KEYS = /* @__PURE__ */ new Set(["intensity", "threshold", "smoothing"]);
    Canvas3DHost = lazy(
      () => import('@almadar/ui/components/molecules/game/three').then((m) => ({ default: m.Canvas3DHost }))
    );
    LearningScene3D.displayName = "LearningScene3D";
  }
});
var biologyLog, BIO_BAND_COLORS, BIO_STAGE_FILL, BIO_STAGE_TEXT, BiologyCanvas;
var init_BiologyCanvas = __esm({
  "components/learning/molecules/BiologyCanvas.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_LearningCanvas();
    init_learningScene3D();
    biologyLog = createLogger("almadar:ui:biology-canvas");
    BIO_BAND_COLORS = ["#dcfce7", "#fef9c3", "#fee2e2", "#e0e7ff"];
    BIO_STAGE_FILL = {
      pending: "#e2e8f0",
      active: "#3b82f6",
      done: "#94a3b8"
    };
    BIO_STAGE_TEXT = {
      pending: "#64748b",
      active: "#ffffff",
      done: "#ffffff"
    };
    BiologyCanvas = ({
      className,
      width = 600,
      height = 400,
      title,
      backgroundColor,
      mode = "2d",
      camera,
      lighting,
      post,
      nodes = [],
      edges = [],
      compartments = [],
      bands = [],
      stages = [],
      stageStyle = "timeline",
      helix,
      helix3d,
      shapes = [],
      readouts,
      traces,
      showGrid,
      shadows,
      interactive,
      animate = false,
      onShapeClick,
      isLoading,
      error
    }) => {
      const derivedShapes = useMemo(() => {
        const out = [];
        const nodeById = /* @__PURE__ */ new Map();
        for (const n of nodes) {
          if (n.id) nodeById.set(n.id, n);
        }
        const bandCount = bands.length;
        for (let i = 0; i < bandCount; i++) {
          const band = bands[i];
          const bandColor = band.color ?? BIO_BAND_COLORS[i % BIO_BAND_COLORS.length];
          const bandY = i * height / bandCount;
          const bandH = height / bandCount;
          out.push({
            type: "rect",
            x: 0,
            y: bandY,
            width,
            height: bandH,
            color: bandColor,
            fill: bandColor,
            opacity: 0.45
          });
          if (band.label) {
            out.push({
              type: "text",
              x: 8,
              y: bandY + 14,
              text: band.label,
              color: "#6b7280",
              fontSize: 10
            });
          }
        }
        for (const c of compartments) {
          const color = c.color ?? "#16a34a";
          out.push({
            type: "ellipse",
            x: c.x,
            y: c.y,
            width: c.width,
            height: c.height,
            color,
            fill: c.fill ?? `${color}1A`,
            lineWidth: c.lineWidth ?? 2,
            ...c.dash ? { dash: c.dash } : {}
          });
          if (c.label) {
            out.push({
              type: "text",
              x: c.x,
              y: c.y - c.height / 2 + 14,
              text: c.label,
              color: "#111827",
              fontSize: 11,
              align: "center"
            });
          }
        }
        if (helix) {
          const hx = helix.x ?? 24;
          const hy = helix.y ?? height * 0.25;
          const hw = helix.width ?? width - 48;
          const hh = helix.height ?? height * 0.5;
          const rungs = helix.rungs;
          const n = rungs.length;
          const cy = hy + hh / 2;
          const colorA = helix.colorA ?? "#2563eb";
          const colorB = helix.colorB ?? "#dc2626";
          const rungColor = helix.rungColor ?? "#94a3b8";
          const fork = helix.fork ?? 0;
          const maxSep = Math.min(hh - 8, 96);
          const strandA = [];
          const strandB = [];
          const rungGeoms = [];
          for (let i = 0; i < n; i++) {
            const rx = hx + (i + 0.5) * hw / n;
            const t = (i + 0.5) / n;
            const paired = t >= fork;
            const sep = paired ? 28 : 28 + (maxSep - 28) * ((fork - t) / fork);
            strandA.push({ x: rx, y: cy - sep / 2 });
            strandB.push({ x: rx, y: cy + sep / 2 });
            rungGeoms.push({ rx, sep, rung: rungs[i], paired });
          }
          for (let i = 1; i < n; i++) {
            out.push({ type: "line", x1: strandA[i - 1].x, y1: strandA[i - 1].y, x2: strandA[i].x, y2: strandA[i].y, color: colorA, lineWidth: 3 });
          }
          for (let i = 1; i < n; i++) {
            out.push({ type: "line", x1: strandB[i - 1].x, y1: strandB[i - 1].y, x2: strandB[i].x, y2: strandB[i].y, color: colorB, lineWidth: 3 });
          }
          for (const g of rungGeoms) {
            const rColor = g.rung.color ?? (g.rung.state === "new" ? "#16a34a" : rungColor);
            const topY = cy - g.sep / 2;
            const bottomY = cy + g.sep / 2;
            if (g.paired) {
              out.push({ type: "line", x1: g.rx, y1: topY, x2: g.rx, y2: bottomY, color: rColor });
              if (g.rung.a) {
                out.push({ type: "text", x: g.rx, y: cy - g.sep / 4, text: g.rung.a, fontSize: 9, align: "center", color: "#374151" });
              }
              if (g.rung.b) {
                out.push({ type: "text", x: g.rx, y: cy + g.sep / 4, text: g.rung.b, fontSize: 9, align: "center", color: "#374151" });
              }
            } else {
              const stubTopY = topY + 8;
              const stubBottomY = bottomY - 8;
              out.push({ type: "line", x1: g.rx, y1: topY, x2: g.rx, y2: stubTopY, color: rColor });
              out.push({ type: "line", x1: g.rx, y1: bottomY, x2: g.rx, y2: stubBottomY, color: rColor });
              if (g.rung.a) {
                out.push({ type: "text", x: g.rx, y: stubTopY + 6, text: g.rung.a, fontSize: 9, align: "center", color: "#374151" });
              }
              if (g.rung.b) {
                out.push({ type: "text", x: g.rx, y: stubBottomY - 6, text: g.rung.b, fontSize: 9, align: "center", color: "#374151" });
              }
            }
          }
        }
        for (const e of edges) {
          const a = nodeById.get(e.from);
          const b = nodeById.get(e.to);
          if (!a || !b) continue;
          const color = e.color ?? "#9ca3af";
          if (e.directed) {
            const rA = a.radius ?? 16;
            const rB = b.radius ?? 16;
            const dx = b.x - a.x;
            const dy = b.y - a.y;
            const dist = Math.max(1e-6, Math.hypot(dx, dy));
            const ux = dx / dist;
            const uy = dy / dist;
            out.push({
              type: "arrow",
              x1: a.x + ux * rA,
              y1: a.y + uy * rA,
              x2: b.x - ux * rB,
              y2: b.y - uy * rB,
              color,
              lineWidth: 2
            });
          } else {
            out.push({
              type: "line",
              x1: a.x,
              y1: a.y,
              x2: b.x,
              y2: b.y,
              color,
              lineWidth: 2
            });
          }
          if (e.label) {
            out.push({
              type: "text",
              x: (a.x + b.x) / 2 + 4,
              y: (a.y + b.y) / 2 - 4,
              text: e.label,
              color: "#374151",
              fontSize: 11
            });
          }
        }
        for (const n of nodes) {
          const state = n.state ?? "default";
          const muted = state === "muted";
          out.push({
            type: "circle",
            x: n.x,
            y: n.y,
            radius: n.radius ?? 16,
            color: n.color ?? "#16a34a",
            fill: `${n.color ?? "#16a34a"}33`,
            id: n.id,
            ...muted ? { opacity: 0.35 } : {}
          });
          if (state === "highlight") {
            out.push({
              type: "circle",
              x: n.x,
              y: n.y,
              radius: (n.radius ?? 16) + 4,
              color: "#f59e0b",
              lineWidth: 2
            });
          }
          if (n.label) {
            out.push({
              type: "text",
              x: n.x,
              y: n.y + (n.radius ?? 16) + 14,
              text: n.label,
              ...muted ? { opacity: 0.35 } : {},
              color: "#111827",
              fontSize: 12,
              align: "center"
            });
          }
        }
        const stageCount = stages.length;
        if (stageCount > 0) {
          if (stageStyle === "ring") {
            const cx = width / 2;
            const cy = height / 2;
            const R = Math.min(width, height) / 2 - 48;
            const ringPoints = [];
            for (let i = 0; i < stageCount; i++) {
              const angleRad = (-90 + 360 * i / stageCount) * Math.PI / 180;
              ringPoints.push({ x: cx + R * Math.cos(angleRad), y: cy + R * Math.sin(angleRad) });
            }
            if (stageCount >= 2) {
              for (let i = 0; i < stageCount - 1; i++) {
                const p1 = ringPoints[i];
                const p2 = ringPoints[i + 1];
                const dx = p2.x - p1.x;
                const dy = p2.y - p1.y;
                const dist = Math.max(1e-6, Math.hypot(dx, dy));
                const ux = dx / dist;
                const uy = dy / dist;
                out.push({
                  type: "arrow",
                  x1: p1.x + ux * 46,
                  y1: p1.y + uy * 46,
                  x2: p2.x - ux * 46,
                  y2: p2.y - uy * 46,
                  color: "#94a3b8"
                });
              }
            }
            for (let i = 0; i < stageCount; i++) {
              const stage = stages[i];
              const state = stage.state ?? "pending";
              const fill = stage.color ?? BIO_STAGE_FILL[state];
              const w = Math.max(26, Math.min(84, stage.label.length * 6 + 10));
              const h = 18;
              const p = ringPoints[i];
              out.push({ type: "rect", x: p.x - w / 2, y: p.y - h / 2, width: w, height: h, color: fill, fill });
              out.push({ type: "text", x: p.x, y: p.y, text: stage.label, color: BIO_STAGE_TEXT[state], fontSize: 10, align: "center" });
            }
          } else {
            const stripY = height - 32;
            const slotW = (width - 16) / stageCount;
            const chipGeoms = [];
            for (let i = 0; i < stageCount; i++) {
              chipGeoms.push({ x: 8 + i * slotW + 5, w: slotW - 10 });
            }
            for (let i = 0; i < stageCount - 1; i++) {
              const midY = stripY + 13;
              out.push({
                type: "arrow",
                x1: chipGeoms[i].x + chipGeoms[i].w,
                y1: midY,
                x2: chipGeoms[i + 1].x,
                y2: midY,
                color: "#94a3b8"
              });
            }
            for (let i = 0; i < stageCount; i++) {
              const stage = stages[i];
              const state = stage.state ?? "pending";
              const fill = stage.color ?? BIO_STAGE_FILL[state];
              const g = chipGeoms[i];
              out.push({ type: "rect", x: g.x, y: stripY, width: g.w, height: 26, color: fill, fill });
              out.push({
                type: "text",
                x: g.x + g.w / 2,
                y: stripY + 13,
                text: stage.label,
                color: BIO_STAGE_TEXT[state],
                fontSize: 10,
                align: "center"
              });
            }
          }
        }
        out.push(...shapes);
        return out;
      }, [nodes, edges, compartments, bands, stages, stageStyle, helix, shapes, width, height]);
      const drawables3D = useMemo(() => {
        if (mode !== "3d") return [];
        if (shapes.length > 0) {
          biologyLog.debug("shapes ignored in 3D mode (pixel-authored 2D vocabulary)", { count: shapes.length });
        }
        if (compartments.length > 0 || bands.length > 0 || stages.length > 0 || helix) {
          biologyLog.debug("2D-only families ignored in 3D mode (pixel-authored 2D vocabulary)", {
            compartments: compartments.length,
            bands: bands.length,
            stages: stages.length,
            helix: helix != null
          });
        }
        if (animate) {
          biologyLog.debug("animate ignored in 3D mode (motion is entity-state driven)");
        }
        const out = [];
        const labelColor = labelColorForBackground(backgroundColor);
        const nodeById = /* @__PURE__ */ new Map();
        for (const n of nodes) {
          if (n.id) nodeById.set(n.id, n);
        }
        for (const e of edges) {
          const a = nodeById.get(e.from);
          const b = nodeById.get(e.to);
          if (!a || !b) continue;
          const edgeRadius = Math.max(0.04, Math.min(a.radius ?? 0.5, b.radius ?? 0.5) * 0.12);
          const edge = cylinderBetween([a.x, a.y, a.z ?? 0], [b.x, b.y, b.z ?? 0], edgeRadius, e.color ?? "#9ca3af");
          if (edge) out.push(edge);
          if (e.label) {
            out.push(
              billboardLabel(
                e.label,
                (a.x + b.x) / 2,
                (a.y + b.y) / 2,
                ((a.z ?? 0) + (b.z ?? 0)) / 2,
                { color: labelColor }
              )
            );
          }
        }
        for (const n of nodes) {
          const radius = n.radius ?? 0.5;
          const nz = n.z ?? 0;
          out.push(meshSphere(n.id, n.x, n.y, nz, radius, n.color ?? "#16a34a", { shape: n.shape, ...n.opacity !== void 0 ? { opacity: n.opacity } : {} }));
          if (n.label) {
            out.push(billboardLabel(n.label, n.x, n.y, nz + radius, { color: labelColor }));
          }
        }
        if (helix3d) {
          out.push(...helixDrawables(helix3d, { labelColor }));
        }
        return out;
      }, [mode, nodes, edges, shapes, compartments, bands, stages, helix, helix3d, animate, backgroundColor]);
      const nodeIndexById = useMemo(() => {
        const m = /* @__PURE__ */ new Map();
        (helix3d?.rungs ?? []).forEach((rung, i) => {
          if (rung.id) m.set(rung.id, i);
        });
        nodes.forEach((n, i) => {
          if (n.id) m.set(n.id, i);
        });
        return m;
      }, [nodes, helix3d]);
      if (mode === "3d") {
        return /* @__PURE__ */ jsx(
          LearningScene3D,
          {
            className,
            width,
            height,
            title,
            backgroundColor,
            drawables: drawables3D,
            camera,
            lighting,
            post,
            showGrid,
            shadows,
            interactive,
            isLoading,
            error,
            onItemClick: get3DClickPayload(onShapeClick, nodeIndexById)
          }
        );
      }
      return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        /* @__PURE__ */ jsx(
          LearningCanvas,
          {
            width,
            height,
            backgroundColor,
            shapes: derivedShapes,
            readouts,
            traces,
            interactive: interactive ?? false,
            animate,
            onShapeClick,
            isLoading,
            error
          }
        )
      ] }) });
    };
  }
});

// node_modules/.pnpm/katex@0.16.47/node_modules/katex/dist/katex.min.css
var init_katex_min = __esm({
  "node_modules/.pnpm/katex@0.16.47/node_modules/katex/dist/katex.min.css"() {
  }
});
var Tabs;
var init_Tabs = __esm({
  "components/core/molecules/Tabs.tsx"() {
    "use client";
    init_Icon();
    init_Badge();
    init_Typography();
    init_Box();
    init_cn();
    init_useEventBus();
    Tabs = ({
      items,
      tabs,
      defaultActiveTab,
      activeTab: controlledActiveTab,
      onTabChange,
      tabChangeEvent,
      variant = "default",
      orientation = "horizontal",
      className
    }) => {
      const rawItems = items ?? tabs ?? [];
      const safeItems = rawItems.map(({ id, value, ...rest }) => ({
        ...rest,
        id: id || value || ""
      }));
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const initialActive = safeItems.find((item) => item.active)?.id;
      const [internalActiveTab, setInternalActiveTab] = useState(
        defaultActiveTab || initialActive || safeItems[0]?.id || ""
      );
      const activeTab = controlledActiveTab !== void 0 ? controlledActiveTab : internalActiveTab;
      const tabRefs = useRef({});
      const handleTabChange = (tabId, tabEvent) => {
        if (controlledActiveTab === void 0) {
          setInternalActiveTab(tabId);
        }
        onTabChange?.(tabId);
        if (tabChangeEvent) {
          eventBus.emit(`UI:${tabChangeEvent}`, { tabId });
        }
        if (tabEvent) {
          eventBus.emit(`UI:${tabEvent}`, { tabId });
        }
      };
      const handleKeyDown = (e, index) => {
        const prevKey = orientation === "vertical" ? "ArrowUp" : "ArrowLeft";
        const nextKey = orientation === "vertical" ? "ArrowDown" : "ArrowRight";
        if (e.key === prevKey || e.key === nextKey) {
          e.preventDefault();
          const direction = e.key === prevKey ? -1 : 1;
          const nextIndex = (index + direction + safeItems.length) % safeItems.length;
          const nextTab = safeItems[nextIndex];
          if (nextTab && !nextTab.disabled) {
            handleTabChange(nextTab.id);
            tabRefs.current[nextTab.id]?.focus();
          }
        } else if (e.key === "Home" || e.key === "End") {
          e.preventDefault();
          const targetIndex = e.key === "Home" ? 0 : safeItems.length - 1;
          const targetTab = safeItems[targetIndex];
          if (targetTab && !targetTab.disabled) {
            handleTabChange(targetTab.id);
            tabRefs.current[targetTab.id]?.focus();
          }
        }
      };
      const activeTabContent = safeItems.find((item) => item.id === activeTab)?.content;
      if (safeItems.length === 0) {
        return /* @__PURE__ */ jsx(Box, { className: cn("w-full", className), children: /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", className: "py-4", children: t("empty.noItems") }) });
      }
      const variantClasses2 = {
        default: [
          "border-b-[length:var(--border-width)] border-transparent",
          "hover:border-muted-foreground",
          "data-[active=true]:border-primary"
        ].join(" "),
        pills: [
          "rounded-sm",
          "data-[active=true]:bg-primary",
          "data-[active=true]:text-primary-foreground"
        ].join(" "),
        underline: [
          "border-b-[length:var(--border-width)] border-transparent",
          "data-[active=true]:border-primary"
        ].join(" ")
      };
      return /* @__PURE__ */ jsxs(Box, { className: cn("w-full", className), children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            role: "tablist",
            className: cn(
              "flex",
              // Horizontal tab strip becomes a horizontally-scrollable lane
              // below its container width — phones with many tabs scroll
              // instead of clipping. `snap-x` snaps to each tab; the
              // scrollbar is hidden for a cleaner affordance (the swipe
              // gesture is the discoverability cue).
              orientation === "horizontal" ? "flex-row border-b-[length:var(--border-width)] border-border overflow-x-auto snap-x snap-mandatory [&::-webkit-scrollbar]:hidden" : "flex-col border-r-[length:var(--border-width)] border-border",
              variant === "pills" && "gap-1 p-1 bg-muted border-0 rounded-md",
              variant === "underline" && orientation === "vertical" && "border-b-0"
            ),
            children: safeItems.map((item, index) => {
              const isActive = item.id === activeTab;
              const isDisabled = item.disabled;
              return /* @__PURE__ */ jsxs(
                Box,
                {
                  as: "button",
                  ref: (el) => {
                    tabRefs.current[item.id] = el;
                  },
                  role: "tab",
                  "aria-selected": isActive,
                  "aria-controls": `tabpanel-${item.id}`,
                  "aria-disabled": isDisabled,
                  onClick: () => !isDisabled && handleTabChange(item.id, item.event),
                  onKeyDown: (e) => handleKeyDown(e, index),
                  "data-active": isActive,
                  className: cn(
                    "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-all whitespace-nowrap",
                    orientation === "horizontal" && "snap-start shrink-0",
                    "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
                    isDisabled && "opacity-50 cursor-not-allowed",
                    variantClasses2[variant],
                    isActive ? variant === "pills" ? "text-primary-foreground font-bold" : "text-foreground font-bold" : "text-muted-foreground hover:text-foreground"
                  ),
                  children: [
                    item.iconAsset?.url ? /* @__PURE__ */ jsx("img", { src: item.iconAsset.url, alt: item.iconAsset.name ?? item.iconAsset.category ?? "", width: 16, height: 16, style: { imageRendering: "pixelated", objectFit: "contain", width: 16, height: 16 }, className: "flex-shrink-0" }) : item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm" })),
                    /* @__PURE__ */ jsx(Typography, { variant: "small", weight: isActive ? "semibold" : "normal", className: "!text-inherit", children: item.label }),
                    item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: item.badge })
                  ]
                },
                item.id
              );
            })
          }
        ),
        activeTabContent !== void 0 && activeTabContent !== null && /* @__PURE__ */ jsx(
          Box,
          {
            role: "tabpanel",
            id: `tabpanel-${activeTab}`,
            "aria-labelledby": `tab-${activeTab}`,
            className: "mt-4",
            children: activeTabContent
          }
        )
      ] });
    };
    Tabs.displayName = "Tabs";
  }
});
var LoadingState;
var init_LoadingState = __esm({
  "components/core/molecules/LoadingState.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Stack();
    init_Typography();
    LoadingState = ({
      title,
      message,
      className,
      fullPage = false
    }) => {
      const { t } = useTranslate();
      const displayMessage = message ?? t("common.loading");
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          align: "center",
          className: cn(
            "justify-center",
            fullPage ? "fixed inset-0 z-[1000] py-12 bg-background/80 backdrop-blur-sm animate-overlay-in" : "py-12",
            className
          ),
          children: [
            /* @__PURE__ */ jsx(Spinner, { size: "lg" }),
            title && /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "mt-4 text-lg font-semibold text-foreground", children: title }),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "small",
                className: cn(
                  "text-muted-foreground",
                  title ? "mt-2" : "mt-4"
                ),
                children: displayMessage
              }
            )
          ]
        }
      );
    };
    LoadingState.displayName = "LoadingState";
  }
});
var ICON_NAME_ALIASES, lookStyles3, EmptyState;
var init_EmptyState = __esm({
  "components/core/molecules/EmptyState.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Box();
    init_Icon();
    init_Stack();
    init_Typography();
    init_useEventBus();
    ICON_NAME_ALIASES = {
      check: "check-circle",
      error: "x-circle",
      warning: "alert-circle"
    };
    lookStyles3 = {
      "icon-only": "",
      illustrated: "[&_svg]:w-32 [&_svg]:h-32",
      "text-only": "[&_svg]:hidden",
      mascot: "[&_svg]:w-24 [&_svg]:h-24 [&_svg]:rounded-pill"
    };
    EmptyState = ({
      icon,
      title,
      message,
      description,
      actionLabel,
      onAction,
      className,
      destructive,
      variant,
      actionEvent,
      look = "icon-only"
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleAction = () => {
        if (actionEvent) eventBus.emit(`UI:${actionEvent}`, {});
        onAction?.();
      };
      const iconName = typeof icon === "string" ? ICON_NAME_ALIASES[icon] ?? icon : void 0;
      const iconComponent = typeof icon === "function" ? icon : void 0;
      const hasIcon = Boolean(iconName || iconComponent);
      const isDestructive = destructive || variant === "error";
      const isSuccess = variant === "success";
      const displayText = title || message || t("empty.noItems");
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          align: "center",
          className: cn(
            "justify-center py-12 text-center",
            lookStyles3[look],
            className
          ),
          children: [
            hasIcon && /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "mb-4 rounded-full p-3",
                  isDestructive ? "bg-error/10" : isSuccess ? "bg-success/10" : "bg-muted"
                ),
                children: /* @__PURE__ */ jsx(
                  Icon,
                  {
                    ...iconName ? { name: iconName } : { icon: iconComponent },
                    className: cn(
                      "h-8 w-8",
                      isDestructive ? "text-error" : isSuccess ? "text-success" : "text-muted-foreground"
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "h3",
                className: cn(
                  "text-lg font-medium",
                  isDestructive ? "text-error" : isSuccess ? "text-success" : "text-foreground"
                ),
                children: displayText
              }
            ),
            description && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "mt-1 text-muted-foreground max-w-sm", children: description }),
            actionLabel && (onAction || actionEvent) && /* @__PURE__ */ jsx(
              Button,
              {
                className: "mt-4",
                variant: isDestructive ? "danger" : "primary",
                onClick: handleAction,
                children: actionLabel
              }
            )
          ]
        }
      );
    };
    EmptyState.displayName = "EmptyState";
  }
});

// lib/editorMotions.ts
function isEditorMotion(value) {
  return EDITOR_MOTION_SET.has(value);
}
function isEditorOperator(value) {
  return EDITOR_OPERATOR_SET.has(value);
}
function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function computeLines(text) {
  const lines = [];
  let start = 0;
  for (let i = 0; i <= text.length; i++) {
    if (i === text.length || text[i] === "\n") {
      lines.push({ start, end: i });
      start = i + 1;
    }
  }
  return lines;
}
function lineIndexAt(lines, pos) {
  for (let i = 0; i < lines.length; i++) {
    if (pos <= lines[i].end) return i;
  }
  return lines.length - 1;
}
function findWords(text) {
  const words = [];
  const re = /\w+|\S+/g;
  let m;
  while ((m = re.exec(text)) !== null) {
    words.push({ start: m.index, end: m.index + m[0].length });
  }
  return words;
}
function nextWordStart(text, pos) {
  for (const w of findWords(text)) {
    if (w.start > pos) return w.start;
  }
  return text.length;
}
function prevWordStart(text, pos) {
  let result = 0;
  for (const w of findWords(text)) {
    if (w.start < pos) result = w.start;
    else break;
  }
  return result;
}
function nextWordEnd(text, pos) {
  for (const w of findWords(text)) {
    const lastChar = w.end - 1;
    if (lastChar > pos) return lastChar;
  }
  return text.length > 0 ? text.length - 1 : 0;
}
function firstNonBlank(text, line) {
  let i = line.start;
  while (i < line.end && (text[i] === " " || text[i] === "	")) i++;
  return i;
}
function nextParagraphBoundary(lines, fromLineIdx, textLength) {
  for (let i = fromLineIdx + 1; i < lines.length; i++) {
    if (lines[i].start === lines[i].end) return lines[i].start;
  }
  return textLength;
}
function prevParagraphBoundary(lines, fromLineIdx) {
  for (let i = fromLineIdx - 1; i >= 0; i--) {
    if (lines[i].start === lines[i].end) return lines[i].start;
  }
  return 0;
}
function matchBracket(text, pos) {
  const ch = text[pos];
  const partner = ch !== void 0 ? BRACKET_PARTNER[ch] : void 0;
  if (partner === void 0) return null;
  let depth = 1;
  if (OPEN_BRACKETS.has(ch)) {
    for (let i = pos + 1; i < text.length; i++) {
      if (text[i] === ch) depth++;
      else if (text[i] === partner) {
        depth--;
        if (depth === 0) return i;
      }
    }
  } else {
    for (let i = pos - 1; i >= 0; i--) {
      if (text[i] === ch) depth++;
      else if (text[i] === partner) {
        depth--;
        if (depth === 0) return i;
      }
    }
  }
  return null;
}
function applyMotion(text, caret, motion, count) {
  const n = Math.max(1, count);
  const lines = computeLines(text);
  const lineIdx = lineIndexAt(lines, caret);
  const line = lines[lineIdx];
  switch (motion) {
    case "left":
      return clamp(caret - n, line.start, line.end);
    case "right":
      return clamp(caret + n, line.start, line.end);
    case "up": {
      const col = caret - line.start;
      const targetIdx = clamp(lineIdx - n, 0, lines.length - 1);
      const target = lines[targetIdx];
      return clamp(target.start + col, target.start, target.end);
    }
    case "down": {
      const col = caret - line.start;
      const targetIdx = clamp(lineIdx + n, 0, lines.length - 1);
      const target = lines[targetIdx];
      return clamp(target.start + col, target.start, target.end);
    }
    case "word-forward": {
      let pos = caret;
      for (let i = 0; i < n; i++) pos = nextWordStart(text, pos);
      return pos;
    }
    case "word-back": {
      let pos = caret;
      for (let i = 0; i < n; i++) pos = prevWordStart(text, pos);
      return pos;
    }
    case "word-end": {
      let pos = caret;
      for (let i = 0; i < n; i++) pos = nextWordEnd(text, pos);
      return pos;
    }
    case "line-start":
      return line.start;
    case "line-end":
      return line.end > line.start ? line.end - 1 : line.start;
    case "first-nonblank":
      return firstNonBlank(text, line);
    case "doc-start":
      return 0;
    case "doc-end":
      return text.length;
    case "paragraph-forward": {
      let pos = caret;
      for (let i = 0; i < n; i++) {
        pos = nextParagraphBoundary(lines, lineIndexAt(lines, pos), text.length);
      }
      return pos;
    }
    case "paragraph-back": {
      let pos = caret;
      for (let i = 0; i < n; i++) {
        pos = prevParagraphBoundary(lines, lineIndexAt(lines, pos));
      }
      return pos;
    }
    case "match-bracket": {
      const chAtCaret = text[caret];
      if (chAtCaret !== void 0 && BRACKET_PARTNER[chAtCaret] !== void 0) {
        const target = matchBracket(text, caret);
        return target === null ? caret : target;
      }
      for (let i = caret; i < line.end; i++) {
        if (BRACKET_PARTNER[text[i]] !== void 0) {
          const target = matchBracket(text, i);
          return target === null ? caret : target;
        }
      }
      return caret;
    }
    case "line":
    case "selection":
      return caret;
    default: {
      const _exhaustive = motion;
      return _exhaustive;
    }
  }
}
function motionRange(text, caret, motion, count, selection) {
  if (motion === "selection") {
    if (!selection) return [caret, caret];
    return [Math.min(selection[0], selection[1]), Math.max(selection[0], selection[1])];
  }
  const lines = computeLines(text);
  if (motion === "line") {
    const n = Math.max(1, count);
    const startIdx = lineIndexAt(lines, caret);
    const endIdx = clamp(startIdx + n - 1, 0, lines.length - 1);
    const start2 = lines[startIdx].start;
    const rawEnd = lines[endIdx].end;
    const end2 = rawEnd < text.length ? rawEnd + 1 : rawEnd;
    return [start2, end2];
  }
  const newCaret = applyMotion(text, caret, motion, count);
  let start = Math.min(caret, newCaret);
  let end = Math.max(caret, newCaret);
  if ((motion === "word-end" || motion === "line-end" || motion === "match-bracket") && newCaret !== caret) {
    end = Math.min(Math.max(caret, newCaret) + 1, text.length);
  } else if (motion === "word-forward" && newCaret > caret) {
    const startLine = lineIndexAt(lines, caret);
    const endLine = lineIndexAt(lines, newCaret);
    if (endLine !== startLine) {
      end = lines[startLine].end;
    }
  }
  return [start, end];
}
function toggleCase(s) {
  return s.replace(/[a-zA-Z]/g, (c) => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase());
}
function applyJoin(text, caret, count, register, registerLinewise) {
  const lines = computeLines(text);
  const startIdx = lineIndexAt(lines, caret);
  const n = Math.max(2, count);
  const endIdx = clamp(startIdx + n - 1, 0, lines.length - 1);
  if (endIdx <= startIdx) {
    return { text, caret, register, registerLinewise };
  }
  const joinCaret = lines[startIdx].end;
  let joined = text.slice(lines[startIdx].start, lines[startIdx].end);
  for (let i = startIdx + 1; i <= endIdx; i++) {
    const raw = text.slice(lines[i].start, lines[i].end);
    joined += " " + raw.replace(/^[ \t]+/, "");
  }
  const newText = text.slice(0, lines[startIdx].start) + joined + text.slice(lines[endIdx].end);
  return { text: newText, caret: joinCaret, register, registerLinewise };
}
function applyIndent(text, start, end, operator, register, registerLinewise) {
  const lines = computeLines(text);
  const startLineIdx = lineIndexAt(lines, start);
  const lastTouchedPos = end > start ? end - 1 : start;
  const endLineIdx = lineIndexAt(lines, lastTouchedPos);
  let result = text;
  for (let i = endLineIdx; i >= startLineIdx; i--) {
    const lineStart = lines[i].start;
    if (operator === "indent") {
      result = result.slice(0, lineStart) + INDENT_UNIT + result.slice(lineStart);
    } else if (result[lineStart] === "	") {
      result = result.slice(0, lineStart) + result.slice(lineStart + 1);
    } else {
      let removeCount = 0;
      while (removeCount < INDENT_UNIT.length && result[lineStart + removeCount] === " ") removeCount++;
      result = result.slice(0, lineStart) + result.slice(lineStart + removeCount);
    }
  }
  const newLines = computeLines(result);
  const caret = firstNonBlank(result, newLines[startLineIdx]);
  return { text: result, caret, register, registerLinewise };
}
function applyPut(text, caret, operator, register, registerLinewise, count) {
  if (register.length === 0) {
    return { text, caret, register, registerLinewise };
  }
  const content = register.repeat(count);
  const lines = computeLines(text);
  const line = lines[lineIndexAt(lines, caret)];
  if (registerLinewise) {
    if (operator === "put-before") {
      const insertPos3 = line.start;
      return {
        text: text.slice(0, insertPos3) + content + text.slice(insertPos3),
        caret: insertPos3,
        register,
        registerLinewise
      };
    }
    const nextLineIdx = lineIndexAt(lines, caret) + 1;
    if (nextLineIdx < lines.length) {
      const insertPos3 = lines[nextLineIdx].start;
      return {
        text: text.slice(0, insertPos3) + content + text.slice(insertPos3),
        caret: insertPos3,
        register,
        registerLinewise
      };
    }
    const insertPos2 = text.length;
    return {
      text: text.slice(0, insertPos2) + "\n" + content,
      caret: insertPos2 + 1,
      register,
      registerLinewise
    };
  }
  const insertPos = operator === "put-before" ? clamp(caret, 0, text.length) : clamp(caret + 1, line.start, line.end);
  return {
    text: text.slice(0, insertPos) + content + text.slice(insertPos),
    caret: insertPos + content.length - 1,
    register,
    registerLinewise
  };
}
function applyOperator(input) {
  const { text, caret, operator, motion, register, registerLinewise } = input;
  const count = Math.max(1, input.count);
  const start = clamp(input.range[0], 0, text.length);
  const end = clamp(input.range[1], start, text.length);
  switch (operator) {
    case "yank":
      return { text, caret: start, register: text.slice(start, end), registerLinewise: motion === "line" };
    case "delete":
    case "replace": {
      const removed = text.slice(start, end);
      return {
        text: text.slice(0, start) + text.slice(end),
        caret: start,
        register: removed,
        registerLinewise: motion === "line"
      };
    }
    case "change": {
      if (motion === "line") {
        const hasTrailingNewline = end > start && text[end - 1] === "\n";
        const removeEnd = hasTrailingNewline ? end - 1 : end;
        const removed2 = text.slice(start, removeEnd);
        return {
          text: text.slice(0, start) + text.slice(removeEnd),
          caret: start,
          register: removed2,
          registerLinewise: true
        };
      }
      const removed = text.slice(start, end);
      return {
        text: text.slice(0, start) + text.slice(end),
        caret: start,
        register: removed,
        registerLinewise: false
      };
    }
    case "put":
    case "put-before":
      return applyPut(text, caret, operator, register, registerLinewise, count);
    case "join":
      return applyJoin(text, caret, count, register, registerLinewise);
    case "toggle-case": {
      const toggled = toggleCase(text.slice(start, end));
      return { text: text.slice(0, start) + toggled + text.slice(end), caret: end, register, registerLinewise };
    }
    case "indent":
    case "dedent":
      return applyIndent(text, start, end, operator, register, registerLinewise);
    case "undo":
    case "redo":
      return { text, caret, register, registerLinewise };
    default: {
      const _exhaustive = operator;
      return _exhaustive;
    }
  }
}
var EDITOR_MOTIONS, EDITOR_OPERATORS, EDITOR_MOTION_SET, EDITOR_OPERATOR_SET, INDENT_UNIT, BRACKET_PARTNER, OPEN_BRACKETS;
var init_editorMotions = __esm({
  "lib/editorMotions.ts"() {
    EDITOR_MOTIONS = [
      "left",
      "right",
      "up",
      "down",
      "word-forward",
      "word-back",
      "word-end",
      "line-start",
      "line-end",
      "first-nonblank",
      "doc-start",
      "doc-end",
      "paragraph-forward",
      "paragraph-back",
      "line",
      "selection",
      "match-bracket"
    ];
    EDITOR_OPERATORS = [
      "delete",
      "yank",
      "change",
      "put",
      "put-before",
      "undo",
      "redo",
      "join",
      "toggle-case",
      "indent",
      "dedent",
      "replace"
    ];
    EDITOR_MOTION_SET = new Set(EDITOR_MOTIONS);
    EDITOR_OPERATOR_SET = new Set(EDITOR_OPERATORS);
    INDENT_UNIT = "  ";
    BRACKET_PARTNER = {
      "(": ")",
      ")": "(",
      "[": "]",
      "]": "[",
      "{": "}",
      "}": "{"
    };
    OPEN_BRACKETS = /* @__PURE__ */ new Set(["(", "[", "{"]);
  }
});
function isMotionPayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.motion === "string" && typeof payload.count === "number";
}
function isOperatePayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.operator === "string" && typeof payload.motion === "string" && typeof payload.count === "number";
}
function isInsertTextPayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.text === "string";
}
function isSetModePayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.mode === "string" && typeof payload.caret === "string";
}
function typedDelta(prev, next) {
  const maxPrefix = Math.min(prev.length, next.length);
  let prefixLen = 0;
  while (prefixLen < maxPrefix && prev[prefixLen] === next[prefixLen]) prefixLen++;
  const maxSuffix = Math.min(prev.length - prefixLen, next.length - prefixLen);
  let suffixLen = 0;
  while (suffixLen < maxSuffix && prev[prev.length - 1 - suffixLen] === next[next.length - 1 - suffixLen]) {
    suffixLen++;
  }
  const removed = prev.slice(prefixLen, prev.length - suffixLen);
  const inserted = next.slice(prefixLen, next.length - suffixLen);
  return removed + inserted;
}
function useEditorCapabilities(args) {
  const [caretMode, setCaretMode] = useState("bar");
  const registerRef = useRef("");
  const registerLinewiseRef = useRef(false);
  const pastRef = useRef([]);
  const futureRef = useRef([]);
  const openTypingStepRef = useRef(false);
  const insertSessionOpenRef = useRef(false);
  const closeOpenTypingStep = useCallback(() => {
    openTypingStepRef.current = false;
  }, []);
  const pushHistoryStep = useCallback(
    (text, caret) => {
      closeOpenTypingStep();
      pastRef.current.push({ text, caret });
      futureRef.current = [];
    },
    [closeOpenTypingStep]
  );
  const recordKeystroke = useCallback(
    (prevText, prevCaret, nextText) => {
      if (!openTypingStepRef.current) {
        pastRef.current.push({ text: prevText, caret: prevCaret });
        futureRef.current = [];
        openTypingStepRef.current = true;
      }
      if (!insertSessionOpenRef.current && /\s/.test(typedDelta(prevText, nextText))) {
        openTypingStepRef.current = false;
      }
    },
    []
  );
  const performUndo = useCallback(
    (count) => {
      const ta = args.textareaRef.current;
      if (!ta) return;
      closeOpenTypingStep();
      let moved = false;
      for (let i = 0; i < Math.max(1, count) && pastRef.current.length > 0; i++) {
        const prev = pastRef.current.pop();
        futureRef.current.push({ text: ta.value, caret: ta.selectionStart });
        ta.value = prev.text;
        ta.setSelectionRange(prev.caret, prev.caret);
        moved = true;
      }
      if (moved) args.applyChange(ta.value, "capability");
    },
    [args, closeOpenTypingStep]
  );
  const performRedo = useCallback(
    (count) => {
      const ta = args.textareaRef.current;
      if (!ta) return;
      closeOpenTypingStep();
      let moved = false;
      for (let i = 0; i < Math.max(1, count) && futureRef.current.length > 0; i++) {
        const next = futureRef.current.pop();
        pastRef.current.push({ text: ta.value, caret: ta.selectionStart });
        ta.value = next.text;
        ta.setSelectionRange(next.caret, next.caret);
        moved = true;
      }
      if (moved) args.applyChange(ta.value, "capability");
    },
    [args, closeOpenTypingStep]
  );
  const undo = useCallback(() => performUndo(1), [performUndo]);
  const redo = useCallback(() => performRedo(1), [performRedo]);
  const wasFocusedRef = useRef(args.focused);
  useEffect(() => {
    if (wasFocusedRef.current && !args.focused) {
      setCaretMode("bar");
    }
    wasFocusedRef.current = args.focused;
  }, [args.focused]);
  useEventListener(`UI:${args.events.onMotion}`, (evt) => {
    if (!args.editorId || !isMotionPayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    const { motion, count } = evt.payload;
    if (!isEditorMotion(motion)) {
      console.warn(`useEditorCapabilities: ignoring MOTION with unknown motion "${motion}"`);
      return;
    }
    const ta = args.textareaRef.current;
    if (!ta) return;
    const newCaret = applyMotion(ta.value, ta.selectionStart, motion, count);
    if (ta.selectionStart !== ta.selectionEnd) {
      ta.setSelectionRange(ta.selectionStart, newCaret);
    } else {
      ta.setSelectionRange(newCaret, newCaret);
    }
  });
  useEventListener(`UI:${args.events.onOperate}`, (evt) => {
    if (!args.editorId || !isOperatePayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    const { operator, motion, count } = evt.payload;
    if (!isEditorOperator(operator)) {
      console.warn(`useEditorCapabilities: ignoring OPERATE with unknown operator "${operator}"`);
      return;
    }
    if (!isEditorMotion(motion)) {
      console.warn(`useEditorCapabilities: ignoring OPERATE with unknown motion "${motion}"`);
      return;
    }
    const ta = args.textareaRef.current;
    if (!ta) return;
    if (operator === "undo") {
      performUndo(count);
      return;
    }
    if (operator === "redo") {
      performRedo(count);
      return;
    }
    pushHistoryStep(ta.value, ta.selectionStart);
    const selection = motion === "selection" ? [ta.selectionStart, ta.selectionEnd] : void 0;
    const range = motionRange(ta.value, ta.selectionStart, motion, count, selection);
    const result = applyOperator({
      text: ta.value,
      caret: ta.selectionStart,
      range,
      operator,
      motion,
      count,
      register: registerRef.current,
      registerLinewise: registerLinewiseRef.current
    });
    registerRef.current = result.register;
    registerLinewiseRef.current = result.registerLinewise;
    if (operator === "yank") {
      ta.setSelectionRange(result.caret, result.caret);
    } else {
      ta.value = result.text;
      ta.setSelectionRange(result.caret, result.caret);
    }
    args.applyChange(ta.value, "capability");
  });
  useEventListener(`UI:${args.events.onInsertText}`, (evt) => {
    if (!args.editorId || !isInsertTextPayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    const ta = args.textareaRef.current;
    if (!ta) return;
    pushHistoryStep(ta.value, ta.selectionStart);
    ta.setRangeText(evt.payload.text, ta.selectionStart, ta.selectionEnd, "end");
    args.applyChange(ta.value, "capability");
  });
  useEventListener(`UI:${args.events.onSetMode}`, (evt) => {
    if (!args.editorId || !isSetModePayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    closeOpenTypingStep();
    insertSessionOpenRef.current = evt.payload.mode === "INSERT";
    setCaretMode(evt.payload.caret);
  });
  return { caretMode, recordKeystroke, undo, redo };
}
var init_useEditorCapabilities = __esm({
  "components/core/molecules/markdown/useEditorCapabilities.ts"() {
    "use client";
    init_useEventBus();
    init_editorMotions();
  }
});
function registerCodeLanguageLoader(loader) {
  codeLanguageLoader = loader;
}
function isLanguageRegistered(lang) {
  return CODE_LANGUAGE_SET.has(lang) || dynamicallyLoaded.has(lang);
}
async function loadPrismLanguage(lang) {
  if (isLanguageRegistered(lang)) return;
  try {
    const grammar = codeLanguageLoader ? await codeLanguageLoader(lang) : null;
    SyntaxHighlighter.registerLanguage(lang, grammar ?? langClike);
    dynamicallyLoaded.add(lang);
  } catch {
    dynamicallyLoaded.add(lang);
  }
}
function computeFoldRegions(code) {
  const lines = code.split("\n");
  const regions = [];
  const stack = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    let inString = false;
    for (let j = 0; j < line.length; j++) {
      const ch = line[j];
      if (ch === "\\" && inString) {
        j++;
        continue;
      }
      if (ch === '"') {
        inString = !inString;
        continue;
      }
      if (inString) continue;
      if (ch === "{" || ch === "[") {
        stack.push({ line: i, bracket: ch });
      } else if (ch === "}" || ch === "]") {
        const open = stack.pop();
        if (open && open.line < i) {
          regions.push({
            start: open.line,
            end: i,
            closeBracket: ch
          });
        }
      }
    }
  }
  return regions.sort((a, b) => a.start - b.start);
}
function toCodeLanguage(value) {
  if (!value) return "text";
  return value.toLowerCase();
}
function generateDiff(oldVal, newVal) {
  const oldLines = oldVal.split("\n");
  const newLines = newVal.split("\n");
  const diff = [];
  const maxLen = Math.max(oldLines.length, newLines.length);
  for (let i = 0; i < maxLen; i++) {
    const oldLine = oldLines[i];
    const newLine = newLines[i];
    if (oldLine === newLine) {
      diff.push({ type: "context", content: oldLine ?? "", lineNumber: i + 1 });
    } else {
      if (oldLine !== void 0) diff.push({ type: "remove", content: oldLine, lineNumber: i + 1 });
      if (newLine !== void 0) diff.push({ type: "add", content: newLine, lineNumber: i + 1 });
    }
  }
  return diff;
}
function useLanguageReady(language) {
  const [ready, setReady] = useState(() => isLanguageRegistered(language));
  useEffect(() => {
    if (isLanguageRegistered(language)) {
      if (!ready) setReady(true);
      return;
    }
    let active = true;
    loadPrismLanguage(language).then(() => {
      if (active) setReady(true);
    });
    return () => {
      active = false;
    };
  }, [language]);
  return ready;
}
function resolveHighlightStyle(lang) {
  if (lang === "orb") return orbStyle;
  if (lang === "lolo") return loloStyle;
  return dark;
}
function plainCodeColorOf(style) {
  return style['code[class*="language-"]']?.color ?? "#d4d4d4";
}
function buildLineProps(errorLines, extraClassName) {
  return (lineNumber) => {
    const base = {
      "data-line": String(lineNumber - 1),
      ...extraClassName ? { className: extraClassName } : {}
    };
    const severity = errorLines?.get(lineNumber);
    if (!severity) return base;
    return {
      ...base,
      style: {
        display: "block",
        backgroundColor: severity === "error" ? "rgba(248, 113, 113, 0.18)" : "rgba(251, 191, 36, 0.18)",
        // amber-400 @ 18%
        borderLeft: `3px solid ${severity === "error" ? "#ef4444" : "#f59e0b"}`,
        paddingLeft: "0.5rem",
        marginLeft: "-0.5rem"
      }
    };
  };
}
function translateProgram(source, language, lang) {
  if (lang === "en") return source;
  if (language === "lolo") return translateLolo(source, lang);
  if (language === "orb") {
    const translated = translateOrb(source, lang);
    return typeof translated === "string" ? translated : source;
  }
  return source;
}
var dynamicallyLoaded, codeLanguageLoader, orbStyleOverrides, orbStyle, loloStyleOverrides, loloStyle, log5, CODE_LANGUAGES, CODE_LANGUAGE_SET, DIFF_STYLES, DIFF_STYLE_FALLBACK, LINE_PROPS_FN, HIDDEN_LINE_NUMBERS, HIGHLIGHT_CAPACITY_BYTES, MONO_FONT_FAMILY, VIEWER_LINE_NUMBER_STYLE, CodeBlock;
var init_CodeBlock = __esm({
  "components/core/molecules/markdown/CodeBlock.tsx"() {
    init_cn();
    init_atoms();
    init_Tabs();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    init_Box();
    init_Button();
    init_Badge();
    init_Stack();
    init_Textarea();
    init_Icon();
    init_useEventBus();
    init_useEditorCapabilities();
    SyntaxHighlighter.registerLanguage("json", langJson);
    SyntaxHighlighter.registerLanguage("javascript", langJavascript);
    SyntaxHighlighter.registerLanguage("js", langJavascript);
    SyntaxHighlighter.registerLanguage("typescript", langTypescript);
    SyntaxHighlighter.registerLanguage("ts", langTypescript);
    SyntaxHighlighter.registerLanguage("jsx", langJsx);
    SyntaxHighlighter.registerLanguage("tsx", langTsx);
    SyntaxHighlighter.registerLanguage("css", langCss);
    SyntaxHighlighter.registerLanguage("markdown", langMarkdown);
    SyntaxHighlighter.registerLanguage("md", langMarkdown);
    SyntaxHighlighter.registerLanguage("bash", langBash);
    SyntaxHighlighter.registerLanguage("shell", langBash);
    SyntaxHighlighter.registerLanguage("sh", langBash);
    SyntaxHighlighter.registerLanguage("yaml", langYaml);
    SyntaxHighlighter.registerLanguage("yml", langYaml);
    SyntaxHighlighter.registerLanguage("rust", langRust);
    SyntaxHighlighter.registerLanguage("python", langPython);
    SyntaxHighlighter.registerLanguage("py", langPython);
    SyntaxHighlighter.registerLanguage("sql", langSql);
    SyntaxHighlighter.registerLanguage("diff", langDiff);
    SyntaxHighlighter.registerLanguage("toml", langToml);
    SyntaxHighlighter.registerLanguage("go", langGo);
    SyntaxHighlighter.registerLanguage("graphql", langGraphql);
    SyntaxHighlighter.registerLanguage("clojure", langClojure);
    SyntaxHighlighter.registerLanguage("clj", langClojure);
    SyntaxHighlighter.registerLanguage("edn", langClojure);
    SyntaxHighlighter.registerLanguage("haskell", langHaskell);
    SyntaxHighlighter.registerLanguage("hs", langHaskell);
    SyntaxHighlighter.registerLanguage("lisp", langLisp);
    SyntaxHighlighter.registerLanguage("scheme", langScheme);
    SyntaxHighlighter.registerLanguage("scala", langScala);
    SyntaxHighlighter.registerLanguage("elixir", langElixir);
    SyntaxHighlighter.registerLanguage("ex", langElixir);
    SyntaxHighlighter.registerLanguage("exs", langElixir);
    SyntaxHighlighter.registerLanguage("erlang", langErlang);
    SyntaxHighlighter.registerLanguage("erl", langErlang);
    SyntaxHighlighter.registerLanguage("elm", langElm);
    SyntaxHighlighter.registerLanguage("fsharp", langFsharp);
    SyntaxHighlighter.registerLanguage("fs", langFsharp);
    SyntaxHighlighter.registerLanguage("fsx", langFsharp);
    SyntaxHighlighter.registerLanguage("ocaml", langOcaml);
    SyntaxHighlighter.registerLanguage("ml", langOcaml);
    SyntaxHighlighter.registerLanguage("java", langJava);
    SyntaxHighlighter.registerLanguage("c", langC);
    SyntaxHighlighter.registerLanguage("cpp", langCpp);
    SyntaxHighlighter.registerLanguage("c++", langCpp);
    SyntaxHighlighter.registerLanguage("cc", langCpp);
    SyntaxHighlighter.registerLanguage("cxx", langCpp);
    SyntaxHighlighter.registerLanguage("hpp", langCpp);
    SyntaxHighlighter.registerLanguage("h", langCpp);
    SyntaxHighlighter.registerLanguage("csharp", langCsharp);
    SyntaxHighlighter.registerLanguage("cs", langCsharp);
    SyntaxHighlighter.registerLanguage("objectivec", langObjectivec);
    SyntaxHighlighter.registerLanguage("objc", langObjectivec);
    SyntaxHighlighter.registerLanguage("php", langPhp);
    SyntaxHighlighter.registerLanguage("ruby", langRuby);
    SyntaxHighlighter.registerLanguage("rb", langRuby);
    SyntaxHighlighter.registerLanguage("swift", langSwift);
    SyntaxHighlighter.registerLanguage("kotlin", langKotlin);
    SyntaxHighlighter.registerLanguage("kt", langKotlin);
    SyntaxHighlighter.registerLanguage("lua", langLua);
    SyntaxHighlighter.registerLanguage("r", langR);
    SyntaxHighlighter.registerLanguage("dart", langDart);
    SyntaxHighlighter.registerLanguage("julia", langJulia);
    SyntaxHighlighter.registerLanguage("fortran", langFortran);
    SyntaxHighlighter.registerLanguage("f90", langFortran);
    SyntaxHighlighter.registerLanguage("f95", langFortran);
    SyntaxHighlighter.registerLanguage("perl", langPerl);
    SyntaxHighlighter.registerLanguage("pl", langPerl);
    SyntaxHighlighter.registerLanguage("powershell", langPowershell);
    SyntaxHighlighter.registerLanguage("ps1", langPowershell);
    SyntaxHighlighter.registerLanguage("makefile", langMakefile);
    SyntaxHighlighter.registerLanguage("make", langMakefile);
    SyntaxHighlighter.registerLanguage("nginx", langNginx);
    SyntaxHighlighter.registerLanguage("ini", langIni);
    SyntaxHighlighter.registerLanguage("clike", langClike);
    SyntaxHighlighter.registerLanguage("orb", orbLanguage);
    SyntaxHighlighter.registerLanguage("lolo", loloLanguage);
    dynamicallyLoaded = /* @__PURE__ */ new Set();
    codeLanguageLoader = null;
    orbStyleOverrides = {
      "orb-binding": { color: ORB_COLORS.dark.binding, fontWeight: "bold" },
      "orb-effect": { color: ORB_COLORS.dark.effect, fontWeight: "bold" },
      "orb-event": { color: ORB_COLORS.dark.event },
      "orb-slot": { color: ORB_COLORS.dark.uiSlot },
      "orb-structural": { color: ORB_COLORS.dark.structural },
      "orb-field-type": { color: ORB_COLORS.dark.fieldType },
      "orb-persistence": { color: ORB_COLORS.dark.persistence },
      "orb-pattern": { color: ORB_COLORS.dark.pattern },
      "orb-behavior": { color: ORB_COLORS.dark.behavior },
      "orb-unknown-op": { color: ORB_COLORS.dark.error, textDecoration: "wavy underline" },
      "orb-op-arithmetic": { color: ORB_COLORS.dark.arithmetic, fontWeight: "bold" },
      "orb-op-comparison": { color: ORB_COLORS.dark.comparison },
      "orb-op-logic": { color: ORB_COLORS.dark.logic },
      "orb-op-string": { color: ORB_COLORS.dark.string },
      "orb-op-collection": { color: ORB_COLORS.dark.collection },
      "orb-op-time": { color: ORB_COLORS.dark.time },
      "orb-op-control": { color: ORB_COLORS.dark.control },
      "orb-op-async": { color: ORB_COLORS.dark.async }
    };
    orbStyle = { ...dark, ...orbStyleOverrides };
    loloStyleOverrides = {
      "lolo-binding": { color: ORB_COLORS.dark.binding, fontWeight: "bold" },
      "lolo-event": { color: ORB_COLORS.dark.event },
      "lolo-effect": { color: ORB_COLORS.dark.effect, fontWeight: "bold" },
      "keyword": { color: ORB_COLORS.dark.loloKeyword },
      "lolo-constructor": { color: ORB_COLORS.dark.loloConstructor },
      "lolo-arrow": { color: ORB_COLORS.dark.loloArrow },
      "lolo-reference": { color: ORB_COLORS.dark.loloReference },
      "lolo-type": { color: ORB_COLORS.dark.fieldType },
      "lolo-persistence": { color: ORB_COLORS.dark.persistence },
      "lolo-unknown-op": { color: ORB_COLORS.dark.error },
      "lolo-op-arithmetic": { color: ORB_COLORS.dark.arithmetic, fontWeight: "bold" },
      "lolo-op-comparison": { color: ORB_COLORS.dark.comparison },
      "lolo-op-logic": { color: ORB_COLORS.dark.logic },
      "lolo-op-string": { color: ORB_COLORS.dark.string },
      "lolo-op-collection": { color: ORB_COLORS.dark.collection },
      "lolo-op-time": { color: ORB_COLORS.dark.time },
      "lolo-op-control": { color: ORB_COLORS.dark.control },
      "lolo-op-async": { color: ORB_COLORS.dark.async }
    };
    loloStyle = { ...dark, ...loloStyleOverrides };
    log5 = createLogger("almadar:ui:markdown-code");
    CODE_LANGUAGES = [
      "text",
      "json",
      "javascript",
      "js",
      "typescript",
      "ts",
      "jsx",
      "tsx",
      "css",
      "markdown",
      "md",
      "bash",
      "shell",
      "sh",
      "yaml",
      "yml",
      "rust",
      "python",
      "py",
      "sql",
      "diff",
      "toml",
      "go",
      "graphql",
      "html",
      "xml",
      "clojure",
      "clj",
      "edn",
      "haskell",
      "hs",
      "lisp",
      "scheme",
      "scala",
      "elixir",
      "ex",
      "exs",
      "erlang",
      "erl",
      "elm",
      "fsharp",
      "fs",
      "fsx",
      "ocaml",
      "ml",
      "java",
      "c",
      "cpp",
      "c++",
      "cc",
      "cxx",
      "hpp",
      "h",
      "csharp",
      "cs",
      "objectivec",
      "objc",
      "php",
      "ruby",
      "rb",
      "swift",
      "kotlin",
      "kt",
      "lua",
      "r",
      "dart",
      "julia",
      "fortran",
      "f90",
      "f95",
      "perl",
      "pl",
      "powershell",
      "ps1",
      "makefile",
      "make",
      "nginx",
      "ini",
      "orb",
      "lolo"
    ];
    CODE_LANGUAGE_SET = new Set(CODE_LANGUAGES);
    DIFF_STYLES = {
      add: { bg: "bg-success/10", prefix: "+", text: "text-success" },
      added: { bg: "bg-success/10", prefix: "+", text: "text-success" },
      remove: { bg: "bg-error/10", prefix: "-", text: "text-error" },
      removed: { bg: "bg-error/10", prefix: "-", text: "text-error" },
      context: { bg: "", prefix: " ", text: "text-foreground" },
      unchanged: { bg: "", prefix: " ", text: "text-foreground" }
    };
    DIFF_STYLE_FALLBACK = { bg: "", prefix: " ", text: "text-foreground" };
    LINE_PROPS_FN = (n) => ({ "data-line": String(n - 1) });
    HIDDEN_LINE_NUMBERS = { display: "none" };
    HIGHLIGHT_CAPACITY_BYTES = 512 * 1024;
    MONO_FONT_FAMILY = 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace';
    VIEWER_LINE_NUMBER_STYLE = {
      minWidth: "2.5em",
      paddingRight: "1rem",
      textAlign: "right",
      userSelect: "none",
      opacity: 0.5,
      fontVariantNumeric: "tabular-nums"
    };
    CodeBlock = React79__default.memo(
      ({
        code: rawCode,
        language = "text",
        showCopyButton = true,
        showLanguageBadge = true,
        maxHeight = "60vh",
        foldable: foldableProp,
        className,
        editable = false,
        onChange,
        errorLines,
        // viewer props
        title,
        mode = "code",
        diff: propDiff,
        oldValue,
        newValue,
        showLineNumbers = false,
        wordWrap = false,
        files,
        naturalLanguages,
        actions,
        isLoading = false,
        error,
        showCopy,
        // editor capability surface — P1 wires these
        editorId,
        onEditorFocus = "EDITOR_FOCUS",
        onEditorBlur = "EDITOR_BLUR",
        onMotion = "MOTION",
        onOperate = "OPERATE",
        onInsertText = "INSERT_TEXT",
        onSetMode = "SET_MODE",
        motions = [
          "left",
          "right",
          "up",
          "down",
          "word-forward",
          "word-back",
          "word-end",
          "line-start",
          "line-end",
          "first-nonblank",
          "doc-start",
          "doc-end",
          "paragraph-forward",
          "paragraph-back",
          "line",
          "selection",
          "match-bracket"
        ],
        operators = [
          "delete",
          "yank",
          "change",
          "put",
          "put-before",
          "undo",
          "redo",
          "join",
          "toggle-case",
          "indent",
          "dedent",
          "replace"
        ]
      }) => {
        const englishCode = typeof rawCode === "string" ? rawCode : String(rawCode ?? "");
        const naturalTabs = !editable && naturalLanguages && naturalLanguages.length > 1 ? naturalLanguages : void 0;
        const [naturalLanguage, setNaturalLanguage] = useState(() => naturalTabs?.[0] ?? "en");
        const activeNaturalLanguage = naturalTabs?.includes(naturalLanguage) === true ? naturalLanguage : naturalTabs?.[0] ?? "en";
        const translationCache = useMemo(() => /* @__PURE__ */ new Map(), [englishCode, files]);
        const translateFor = useCallback(
          (source, sourceLanguage, cacheKey) => {
            if (activeNaturalLanguage === "en") return source;
            const key = `${cacheKey}|${sourceLanguage}|${activeNaturalLanguage}`;
            const hit = translationCache.get(key);
            if (hit !== void 0) return hit;
            const translated = translateProgram(source, sourceLanguage, activeNaturalLanguage);
            translationCache.set(key, translated);
            return translated;
          },
          [translationCache, activeNaturalLanguage]
        );
        const code = translateFor(englishCode, language, "code");
        const naturalTabItems = naturalTabs?.map((lang) => ({
          id: `lang-${lang}`,
          label: coreTables[lang].meta.name,
          content: null
        }));
        const naturalTabStrip = naturalTabs && naturalTabItems ? /* @__PURE__ */ jsx(
          Box,
          {
            className: "border-b border-border",
            dir: coreTables[activeNaturalLanguage].meta.rtl ? "rtl" : "ltr",
            "data-testid": "codeblock-language-tabs",
            children: /* @__PURE__ */ jsx(
              Tabs,
              {
                tabs: naturalTabItems,
                activeTab: `lang-${activeNaturalLanguage}`,
                onTabChange: (id) => {
                  const next = naturalTabs.find((lang) => `lang-${lang}` === id);
                  if (next) setNaturalLanguage(next);
                }
              }
            )
          }
        ) : null;
        const activeStyle = resolveHighlightStyle(language);
        const overCapacity = code.length > HIGHLIGHT_CAPACITY_BYTES;
        const plainCodeColor = plainCodeColorOf(activeStyle);
        const eventBus = useEventBus();
        const { t } = useTranslate();
        const scrollRef = useRef(null);
        const codeRef = useRef(null);
        const savedScrollLeftRef = useRef(0);
        const [copied, setCopied] = useState(false);
        const [wrap, setWrap] = useState(wordWrap);
        const [activeFileIndex, setActiveFileIndex] = useState(0);
        const activeFile = files?.[activeFileIndex];
        const activeLanguage = activeFile?.language ?? language;
        const activeCode = activeFile ? translateFor(activeFile.code, activeLanguage, `file-${activeFileIndex}`) : code;
        const languageReady = useLanguageReady(activeLanguage);
        const viewerStyle = resolveHighlightStyle(activeLanguage);
        const viewerPlainCodeColor = plainCodeColorOf(viewerStyle);
        const diffLines = useMemo(() => {
          if (propDiff) return propDiff;
          if (mode === "diff" && oldValue !== void 0 && newValue !== void 0) {
            return generateDiff(oldValue, newValue);
          }
          return null;
        }, [propDiff, mode, oldValue, newValue]);
        const isViewerMode = !!(title || files || showLineNumbers || diffLines || mode === "diff" || actions);
        const effectiveCopy = showCopy ?? showCopyButton;
        const [editableValue, setEditableValue] = useState(code);
        const [editableTextareaKey, setEditableTextareaKey] = useState(0);
        const lastPropCodeRef = useRef(code);
        const editableTextareaRef = useRef(null);
        const editableOverlayRef = useRef(null);
        const [isFocused, setIsFocused] = useState(false);
        const prevCaretRef = useRef(0);
        const [caretIndex, setCaretIndex] = useState(0);
        const caretMirrorRef = useRef(null);
        const caretMarkerRef = useRef(null);
        const [caretGeometry, setCaretGeometry] = useState(null);
        useEffect(() => {
          if (code !== lastPropCodeRef.current) {
            lastPropCodeRef.current = code;
            setEditableValue(code);
            setEditableTextareaKey((k) => k + 1);
          }
        }, [code]);
        const handleEditableScroll = useCallback(() => {
          const ta = editableTextareaRef.current;
          const ov = editableOverlayRef.current;
          if (ta && ov) {
            ov.scrollTop = ta.scrollTop;
            ov.scrollLeft = ta.scrollLeft;
          }
        }, []);
        const handleEditableChange = useCallback((v, _origin) => {
          lastPropCodeRef.current = v;
          setEditableValue(v);
          const ta = editableTextareaRef.current;
          if (ta) setCaretIndex(ta.selectionStart);
          onChange?.(v);
        }, [onChange]);
        const { caretMode, recordKeystroke, undo, redo } = useEditorCapabilities({
          editorId: editable ? editorId : void 0,
          textareaRef: editableTextareaRef,
          events: { onMotion, onOperate, onInsertText, onSetMode },
          focused: isFocused,
          applyChange: handleEditableChange
        });
        const handleEditableKeyDown = useCallback(
          (e) => {
            const ta = editableTextareaRef.current;
            if (ta) prevCaretRef.current = ta.selectionStart;
            const mod = e.metaKey || e.ctrlKey;
            if (!mod) return;
            const key = e.key.toLowerCase();
            if (key === "z" && !e.shiftKey) {
              e.preventDefault();
              undo();
            } else if (key === "z" && e.shiftKey || key === "y") {
              e.preventDefault();
              redo();
            }
          },
          [undo, redo]
        );
        const showBlockCaret = isFocused && caretMode !== "bar";
        useLayoutEffect(() => {
          if (!showBlockCaret) return;
          const ta = editableTextareaRef.current;
          const mirror = caretMirrorRef.current;
          const marker = caretMarkerRef.current;
          if (!ta || !mirror || !marker) return;
          const computed = window.getComputedStyle(ta);
          const MIRRORED_PROPS = [
            "font-family",
            "font-size",
            "font-weight",
            "font-style",
            "letter-spacing",
            "line-height",
            "padding-top",
            "padding-right",
            "padding-bottom",
            "padding-left",
            "border-top-width",
            "border-right-width",
            "border-bottom-width",
            "border-left-width",
            "box-sizing",
            "width",
            "white-space",
            "word-break",
            "overflow-wrap",
            "tab-size"
          ];
          for (const prop of MIRRORED_PROPS) {
            mirror.style.setProperty(prop, computed.getPropertyValue(prop));
          }
          const lineHeight = parseFloat(computed.getPropertyValue("line-height"));
          setCaretGeometry({
            top: marker.offsetTop,
            left: marker.offsetLeft,
            lineHeight: Number.isFinite(lineHeight) ? lineHeight : 0
          });
        }, [showBlockCaret, editableValue, caretIndex]);
        const errorLineProps = useMemo(() => buildLineProps(errorLines), [errorLines]);
        const viewerLineProps = useMemo(
          () => buildLineProps(errorLines, "px-4 py-0.5 hover:bg-muted/50"),
          [errorLines]
        );
        const isFoldable = foldableProp ?? true;
        const [collapsed, setCollapsed] = useState(() => /* @__PURE__ */ new Set());
        const foldRegions = useMemo(
          () => isFoldable && !overCapacity ? computeFoldRegions(code) : [],
          [code, isFoldable, overCapacity]
        );
        const foldStartMap = useMemo(() => {
          const m = /* @__PURE__ */ new Map();
          for (const r of foldRegions) m.set(r.start, r);
          return m;
        }, [foldRegions]);
        const hiddenLines = useMemo(() => {
          const h = /* @__PURE__ */ new Set();
          for (const r of foldRegions) {
            if (!collapsed.has(r.start)) continue;
            for (let i = r.start + 1; i <= r.end; i++) h.add(i);
          }
          return h;
        }, [foldRegions, collapsed]);
        const collapsedRef = useRef(collapsed);
        collapsedRef.current = collapsed;
        const foldStartMapRef = useRef(foldStartMap);
        foldStartMapRef.current = foldStartMap;
        const hiddenLinesRef = useRef(hiddenLines);
        hiddenLinesRef.current = hiddenLines;
        const toggleFold = useCallback((lineNum) => {
          setCollapsed((prev) => {
            const next = new Set(prev);
            if (next.has(lineNum)) next.delete(lineNum);
            else next.add(lineNum);
            return next;
          });
        }, []);
        const toggleFoldRef = useRef(toggleFold);
        toggleFoldRef.current = toggleFold;
        useEffect(() => {
          setCollapsed(/* @__PURE__ */ new Set());
        }, [code]);
        const editableOverCapacity = editableValue.length > HIGHLIGHT_CAPACITY_BYTES;
        const editableHighlightedElement = useMemo(
          () => editableOverCapacity ? /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                padding: "1rem",
                margin: 0,
                whiteSpace: "pre",
                minWidth: "100%",
                color: plainCodeColor,
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
                fontSize: "13px",
                lineHeight: "1.5"
              },
              children: editableValue || " "
            }
          ) : /* @__PURE__ */ jsx(
            SyntaxHighlighter,
            {
              PreTag: "div",
              language,
              style: activeStyle,
              wrapLines: errorLines && errorLines.size > 0,
              lineProps: errorLineProps,
              customStyle: {
                backgroundColor: "transparent",
                borderRadius: 0,
                padding: "1rem",
                margin: 0,
                whiteSpace: "pre",
                minWidth: "100%",
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
                fontSize: "13px",
                lineHeight: "1.5"
              },
              codeTagProps: {
                style: {
                  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
                  fontSize: "13px",
                  lineHeight: "1.5"
                }
              },
              children: editableValue || " "
            }
          ),
          [editableValue, editableOverCapacity, plainCodeColor, language, activeStyle, errorLines, errorLineProps, languageReady]
        );
        const highlightedElement = useMemo(
          () => overCapacity ? /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                margin: 0,
                whiteSpace: "pre",
                minWidth: "100%",
                color: plainCodeColor
              },
              children: code
            }
          ) : /* @__PURE__ */ jsx(
            SyntaxHighlighter,
            {
              PreTag: "div",
              language,
              style: activeStyle,
              wrapLines: true,
              showLineNumbers: true,
              showInlineLineNumbers: false,
              lineNumberContainerStyle: HIDDEN_LINE_NUMBERS,
              lineProps: LINE_PROPS_FN,
              customStyle: {
                backgroundColor: "transparent",
                borderRadius: 0,
                padding: 0,
                margin: 0,
                whiteSpace: "pre",
                minWidth: "100%"
              },
              children: code
            }
          ),
          [code, overCapacity, plainCodeColor, language, activeStyle, languageReady]
        );
        const viewerOverCapacity = activeCode.length > HIGHLIGHT_CAPACITY_BYTES;
        const viewerHighlightedElement = useMemo(
          () => viewerOverCapacity ? /* @__PURE__ */ jsx(
            "div",
            {
              className: "px-4 py-0.5",
              style: {
                margin: 0,
                whiteSpace: wrap ? "pre-wrap" : "pre",
                wordBreak: wrap ? "break-all" : "normal",
                color: viewerPlainCodeColor,
                fontFamily: MONO_FONT_FAMILY,
                fontSize: "12px",
                lineHeight: "1.6"
              },
              children: activeCode
            }
          ) : /* @__PURE__ */ jsx(
            SyntaxHighlighter,
            {
              PreTag: "div",
              language: activeLanguage,
              style: viewerStyle,
              wrapLines: true,
              wrapLongLines: wrap,
              showLineNumbers,
              lineNumberStyle: VIEWER_LINE_NUMBER_STYLE,
              lineProps: viewerLineProps,
              customStyle: {
                backgroundColor: "transparent",
                borderRadius: 0,
                padding: "0.25rem 0",
                margin: 0,
                whiteSpace: wrap ? "pre-wrap" : "pre",
                wordBreak: wrap ? "break-all" : "normal",
                fontFamily: MONO_FONT_FAMILY,
                fontSize: "12px",
                lineHeight: "1.6"
              },
              codeTagProps: { style: { fontFamily: MONO_FONT_FAMILY, fontSize: "12px", lineHeight: "1.6" } },
              children: activeCode
            }
          ),
          [activeCode, viewerOverCapacity, viewerPlainCodeColor, activeLanguage, viewerStyle, wrap, showLineNumbers, viewerLineProps, languageReady]
        );
        const diffOverCapacity = useMemo(
          () => !!diffLines && diffLines.reduce((n, l) => n + l.content.length + 1, 0) > HIGHLIGHT_CAPACITY_BYTES,
          [diffLines]
        );
        const diffRowElements = useMemo(() => {
          if (!diffLines) return null;
          return diffLines.map((line, idx) => {
            const style = DIFF_STYLES[line.type] ?? DIFF_STYLE_FALLBACK;
            return /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "start", className: cn(style.bg, "px-4 py-0.5"), children: [
              showLineNumbers && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  color: "secondary",
                  className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
                  children: line.lineNumber ?? ""
                }
              ),
              /* @__PURE__ */ jsxs(
                Typography,
                {
                  variant: "caption",
                  className: cn("font-mono flex-1 min-w-0", style.text, wrap ? "whitespace-pre-wrap break-all" : "whitespace-pre"),
                  children: [
                    /* @__PURE__ */ jsx(Box, { as: "span", className: "select-none opacity-50 mr-2", children: style.prefix }),
                    diffOverCapacity ? line.content || " " : /* @__PURE__ */ jsx(
                      SyntaxHighlighter,
                      {
                        PreTag: "span",
                        CodeTag: "span",
                        language: activeLanguage,
                        style: viewerStyle,
                        customStyle: {
                          display: "inline",
                          background: "transparent",
                          padding: 0,
                          margin: 0,
                          whiteSpace: wrap ? "pre-wrap" : "pre",
                          wordBreak: wrap ? "break-all" : "normal",
                          fontFamily: "inherit",
                          fontSize: "inherit",
                          lineHeight: "inherit"
                        },
                        codeTagProps: {
                          style: {
                            whiteSpace: wrap ? "pre-wrap" : "pre",
                            fontFamily: "inherit",
                            fontSize: "inherit"
                          }
                        },
                        children: line.content || " "
                      }
                    )
                  ]
                }
              )
            ] }, idx);
          });
        }, [diffLines, showLineNumbers, wrap, diffOverCapacity, activeLanguage, viewerStyle, languageReady]);
        useLayoutEffect(() => {
          const container = codeRef.current;
          if (!container) return;
          container.querySelectorAll(".fold-toggle, .fold-summary").forEach((el) => el.remove());
          const lineEls = container.querySelectorAll("[data-line]");
          if (!isFoldable || foldRegions.length === 0) {
            lineEls.forEach((el) => {
              el.style.display = "";
              el.style.position = "";
              el.style.paddingLeft = "";
            });
            return;
          }
          lineEls.forEach((el) => {
            const num2 = parseInt(el.getAttribute("data-line") ?? "-1", 10);
            if (hiddenLines.has(num2)) {
              el.style.display = "none";
              return;
            }
            el.style.display = "";
            el.style.position = "relative";
            el.style.paddingLeft = "1.2em";
            const region = foldStartMap.get(num2);
            if (!region) return;
            const isCollapsed = collapsed.has(num2);
            const toggle = document.createElement("span");
            toggle.className = "fold-toggle";
            toggle.textContent = isCollapsed ? "\u25B6" : "\u25BC";
            toggle.style.cssText = "position:absolute;left:0;top:0;width:1.2em;text-align:center;cursor:pointer;color:#858585;font-size:10px;user-select:none;line-height:inherit;height:100%";
            toggle.addEventListener("click", (e) => {
              e.stopPropagation();
              toggleFoldRef.current(num2);
            });
            el.insertBefore(toggle, el.firstChild);
            if (isCollapsed) {
              const summary = document.createElement("span");
              summary.className = "fold-summary";
              summary.style.cssText = "color:#858585;font-style:italic";
              const count = region.end - region.start - 1;
              summary.textContent = ` ... ${count} line${count !== 1 ? "s" : ""} ${region.closeBracket}`;
              el.appendChild(summary);
            }
          });
        }, [collapsed, hiddenLines, foldStartMap, foldRegions, isFoldable]);
        useLayoutEffect(() => {
          const el = scrollRef.current;
          return () => {
            if (el) savedScrollLeftRef.current = el.scrollLeft;
          };
        }, [language, code]);
        useLayoutEffect(() => {
          const el = scrollRef.current;
          if (el) el.scrollLeft = savedScrollLeftRef.current;
        }, [language, code]);
        useEffect(() => {
          const el = scrollRef.current;
          if (!el) return;
          const handle = () => {
            savedScrollLeftRef.current = el.scrollLeft;
          };
          el.addEventListener("scroll", handle, { passive: true });
          return () => el.removeEventListener("scroll", handle);
        }, [language, code]);
        const handleCopy = async () => {
          try {
            await navigator.clipboard.writeText(activeCode);
            setCopied(true);
            eventBus.emit("UI:COPY_CODE", { language: activeLanguage, success: true });
            setTimeout(() => setCopied(false), 2e3);
          } catch (err) {
            log5.error("Failed to copy code", { error: err instanceof Error ? err : String(err) });
            eventBus.emit("UI:COPY_CODE", { language: activeLanguage, success: false });
          }
        };
        const handleSelectionCopy = useCallback((e) => {
          if (hiddenLinesRef.current.size === 0) return;
          const sel = typeof window !== "undefined" ? window.getSelection() : null;
          if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
          const lineOf = (node) => {
            const start = node instanceof HTMLElement ? node : node?.parentElement ?? null;
            const lineEl = start?.closest("[data-line]");
            if (!lineEl) return null;
            const n = parseInt(lineEl.getAttribute("data-line") ?? "", 10);
            return Number.isNaN(n) ? null : n;
          };
          const range = sel.getRangeAt(0);
          let a = lineOf(range.startContainer);
          let b = lineOf(range.endContainer);
          if (a === null || b === null) {
            const container = codeRef.current;
            if (!container) return;
            let min = Infinity, max = -Infinity;
            container.querySelectorAll("[data-line]").forEach((el) => {
              if (!sel.containsNode(el, true)) return;
              const n = parseInt(el.getAttribute("data-line") ?? "", 10);
              if (!Number.isNaN(n)) {
                min = Math.min(min, n);
                max = Math.max(max, n);
              }
            });
            if (min === Infinity) return;
            a = a ?? min;
            b = b ?? max;
          }
          if (a > b) [a, b] = [b, a];
          let touchesFold = false;
          for (let i = a; i <= b; i++) {
            if (hiddenLinesRef.current.has(i) || foldStartMapRef.current.has(i) && collapsedRef.current.has(i)) {
              touchesFold = true;
              break;
            }
          }
          if (!touchesFold) return;
          let endLine = b;
          let changed = true;
          while (changed) {
            changed = false;
            foldStartMapRef.current.forEach((region, start) => {
              if (start >= a && start <= endLine && collapsedRef.current.has(start) && region.end > endLine) {
                endLine = region.end;
                changed = true;
              }
            });
          }
          const full = activeCode.split("\n").slice(a, endLine + 1).join("\n");
          e.clipboardData.setData("text/plain", full);
          e.preventDefault();
        }, [code]);
        if (isLoading) {
          return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
        }
        if (error) {
          return /* @__PURE__ */ jsx(ErrorState, { title: t("display.codeViewerError"), message: error.message, className });
        }
        if (isViewerMode && !activeCode && !diffLines) {
          return /* @__PURE__ */ jsx(EmptyState, { icon: Code, title: t("display.noCode"), description: "No code to display.", className });
        }
        if (isViewerMode) {
          const tabItems = files?.map((file, idx) => ({
            id: `file-${idx}`,
            label: file.label,
            content: null
          }));
          return /* @__PURE__ */ jsx(Card, { className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [
            naturalTabStrip,
            tabItems && tabItems.length > 1 && /* @__PURE__ */ jsx(Box, { className: "border-b border-border", children: /* @__PURE__ */ jsx(
              Tabs,
              {
                tabs: tabItems,
                activeTab: `file-${activeFileIndex}`,
                onTabChange: (id) => {
                  const idx = parseInt(id.replace("file-", ""), 10);
                  setActiveFileIndex(idx);
                }
              }
            ) }),
            /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "sm",
                align: "center",
                justify: "between",
                className: "px-4 py-2 border-b border-border bg-muted/30",
                children: [
                  /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
                    /* @__PURE__ */ jsx(Icon, { icon: mode === "diff" ? FileText : Code, size: "sm", className: "text-muted-foreground" }),
                    title && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "truncate", children: title }),
                    activeLanguage && activeLanguage !== "text" && /* @__PURE__ */ jsx(Badge, { variant: "default", children: activeLanguage })
                  ] }),
                  /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        size: "sm",
                        icon: WrapText,
                        onClick: () => setWrap(!wrap),
                        className: cn(wrap && "text-primary")
                      }
                    ),
                    effectiveCopy && /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        size: "sm",
                        icon: copied ? Check : Copy,
                        onClick: handleCopy,
                        className: cn(copied && "text-success")
                      }
                    ),
                    actions?.map((action, idx) => /* @__PURE__ */ jsx(
                      Badge,
                      {
                        variant: "default",
                        className: "cursor-pointer hover:opacity-80 transition-opacity",
                        onClick: () => {
                          if (action.event) eventBus.emit(`UI:${action.event}`, {});
                        },
                        children: action.label
                      },
                      idx
                    ))
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ jsx(Box, { className: "overflow-auto bg-muted/20", style: { maxHeight }, dir: "ltr", children: diffLines ? /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column" }, className: "font-mono text-xs", children: diffRowElements }) : /* @__PURE__ */ jsx("div", { className: "font-mono text-xs", children: viewerHighlightedElement }) })
          ] }) });
        }
        const hasHeader = showLanguageBadge || effectiveCopy;
        return /* @__PURE__ */ jsxs(Box, { className: `relative group not-prose ${className || ""}`, style: { display: "flex", flexDirection: "column", height: "100%" }, children: [
          hasHeader && /* @__PURE__ */ jsxs(
            HStack,
            {
              justify: "between",
              align: "center",
              className: "px-3 py-2 bg-[var(--color-card)] rounded-t-lg border-b border-border",
              children: [
                showLanguageBadge && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: language }),
                effectiveCopy && /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: handleCopy,
                    className: "opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity text-muted-foreground hover:text-foreground",
                    "aria-label": t("common.copy"),
                    children: copied ? /* @__PURE__ */ jsx(Icon, { name: "check", className: "w-4 h-4 text-success" }) : /* @__PURE__ */ jsx(Icon, { name: "copy", className: "w-4 h-4" })
                  }
                )
              ]
            }
          ),
          naturalTabStrip,
          editable ? (
            /* GAP-77 / GAP-82 / GAP-83: editable mode = transparent textarea on
                         top of a Prism-highlighted SyntaxHighlighter overlay.
            
                         Layout: BOTH children are `position: absolute, inset: 0` so neither
                         contributes to flow. The parent Box has `height: 100%` so it fills
                         whatever container the consumer provides (the consumer is
                         responsible for giving the parent a real height — usually via flex
                         column with `minHeight: 0`).
            
                         Stacking: the overlay is FIRST in DOM order so it paints first
                         (behind), the textarea is SECOND so it paints second (on top). No
                         explicit z-index — DOM order alone determines stacking inside the
                         parent's stacking context. The textarea has `color: transparent`
                         plus `WebkitTextFillColor: transparent` (Safari) so its glyphs
                         never paint, but the caret stays visible via `caretColor`.
            
                         Scroll sync: textarea scrolls naturally; `handleEditableScroll`
                         mirrors its scrollTop/scrollLeft onto the overlay div so the
                         highlighted spans stay aligned with the textarea content.
            
                         Error highlights (GAP-80): `errorLines` prop accepts a Map of
                         1-based line numbers → severity. The overlay's SyntaxHighlighter
                         uses `wrapLines` + `lineProps` to paint a colored background on
                         those lines. */
            /* @__PURE__ */ jsxs(
              Box,
              {
                style: {
                  position: "relative",
                  flex: 1,
                  minHeight: 0,
                  maxHeight,
                  backgroundColor: "#1e1e1e",
                  borderRadius: hasHeader ? "0 0 0.5rem 0.5rem" : "0.5rem",
                  overflow: "hidden"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      ref: editableOverlayRef,
                      "aria-hidden": true,
                      style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        pointerEvents: "none"
                      },
                      children: editableHighlightedElement
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Textarea,
                    {
                      ref: editableTextareaRef,
                      defaultValue: code,
                      onChange: (e) => {
                        const next = e.target.value;
                        recordKeystroke(editableValue, prevCaretRef.current, next);
                        handleEditableChange(next, "keystroke");
                      },
                      onScroll: handleEditableScroll,
                      onSelect: (e) => setCaretIndex(e.currentTarget.selectionStart),
                      onKeyUp: (e) => setCaretIndex(e.currentTarget.selectionStart),
                      onClick: (e) => setCaretIndex(e.currentTarget.selectionStart),
                      onKeyDown: handleEditableKeyDown,
                      onFocus: () => {
                        setIsFocused(true);
                        if (editorId) eventBus.emit(`UI:${onEditorFocus}`, { editorId });
                      },
                      onBlur: () => {
                        setIsFocused(false);
                        if (editorId) eventBus.emit(`UI:${onEditorBlur}`, { editorId });
                      },
                      spellCheck: false,
                      style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        padding: "1rem",
                        margin: 0,
                        border: "none",
                        outline: "none",
                        resize: "none",
                        backgroundColor: "transparent",
                        color: "transparent",
                        caretColor: caretMode === "block" ? "transparent" : "#e6e6e6",
                        WebkitTextFillColor: "transparent",
                        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
                        fontSize: "13px",
                        lineHeight: "1.5",
                        whiteSpace: "pre",
                        overflowWrap: "normal",
                        overflow: "auto"
                      }
                    },
                    editableTextareaKey
                  ),
                  showBlockCaret && /* @__PURE__ */ jsxs(
                    "div",
                    {
                      ref: caretMirrorRef,
                      "aria-hidden": true,
                      "data-testid": "editor-caret-mirror",
                      style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        padding: "1rem",
                        margin: 0,
                        border: "none",
                        visibility: "hidden",
                        pointerEvents: "none"
                      },
                      children: [
                        editableValue.slice(0, caretIndex),
                        /* @__PURE__ */ jsx("span", { ref: caretMarkerRef, "data-testid": "editor-caret-marker", children: "\u200B" })
                      ]
                    }
                  ),
                  showBlockCaret && caretGeometry && /* @__PURE__ */ jsx(
                    "span",
                    {
                      "aria-hidden": true,
                      "data-testid": "editor-caret",
                      style: {
                        position: "absolute",
                        top: caretGeometry.top,
                        left: caretGeometry.left,
                        width: "1ch",
                        height: caretMode === "block" ? caretGeometry.lineHeight || "1.2em" : "2px",
                        backgroundColor: caretMode === "block" ? "rgba(230, 230, 230, 0.5)" : void 0,
                        borderBottom: caretMode === "underline" ? "2px solid #e6e6e6" : void 0,
                        pointerEvents: "none"
                      }
                    }
                  )
                ]
              }
            )
          ) : /* @__PURE__ */ jsx(
            "div",
            {
              ref: scrollRef,
              onCopy: handleSelectionCopy,
              dir: "ltr",
              className: "[&_code]:!bg-transparent [&_code]:!p-0 [&_code]:!border-0 [&_code]:!shadow-none [&_span]:!bg-transparent",
              style: {
                flex: 1,
                minHeight: 0,
                overflowX: "auto",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                maxHeight,
                overscrollBehavior: "auto",
                touchAction: "pan-x pan-y",
                contain: "paint",
                backgroundColor: "#1e1e1e",
                borderRadius: hasHeader ? "0 0 0.5rem 0.5rem" : "0.5rem"
              },
              children: /* @__PURE__ */ jsx("div", { ref: codeRef, style: { padding: "1rem" }, children: highlightedElement })
            }
          )
        ] });
      },
      (prev, next) => prev.language === next.language && prev.code === next.code && prev.showCopyButton === next.showCopyButton && prev.showCopy === next.showCopy && prev.maxHeight === next.maxHeight && prev.foldable === next.foldable && prev.editable === next.editable && prev.onChange === next.onChange && prev.errorLines === next.errorLines && prev.mode === next.mode && prev.title === next.title && prev.diff === next.diff && prev.files === next.files && prev.naturalLanguages === next.naturalLanguages && prev.actions === next.actions && prev.isLoading === next.isLoading && prev.error === next.error && prev.editorId === next.editorId && prev.onEditorFocus === next.onEditorFocus && prev.onEditorBlur === next.onEditorBlur && prev.onMotion === next.onMotion && prev.onOperate === next.onOperate && prev.onInsertText === next.onInsertText && prev.onSetMode === next.onSetMode && prev.motions === next.motions && prev.operators === next.operators
    );
    CodeBlock.displayName = "CodeBlock";
  }
});

// components/core/molecules/markdown/mermaidSource.ts
function isQuoted(label) {
  const trimmed = label.trim();
  return trimmed.length === 0 || trimmed.startsWith('"') && trimmed.endsWith('"') && trimmed.length > 1;
}
function quote(label) {
  return `"${label.replace(/"/g, "#quot;")}"`;
}
function isIdentifierChar(ch) {
  return /[A-Za-z0-9_\-.]/.test(ch);
}
function declaredType(code) {
  for (const line of code.split("\n")) {
    const trimmed = line.trim();
    if (trimmed.length === 0 || trimmed.startsWith("%%")) continue;
    return trimmed;
  }
  return "";
}
function isFlowchart(code) {
  return FLOWCHART_DIRECTIVE.test(declaredType(code));
}
function quoteNodeLabels(code) {
  let out = "";
  let i = 0;
  while (i < code.length) {
    const shape = NODE_SHAPES.find(([open2]) => code.startsWith(open2, i));
    const precededByIdentifier = i > 0 && isIdentifierChar(code[i - 1] ?? "");
    if (shape === void 0 || !precededByIdentifier) {
      out += code[i];
      i += 1;
      continue;
    }
    const [open, close] = shape;
    const contentStart = i + open.length;
    const closeAt = code.indexOf(close, contentStart);
    const newlineAt = code.indexOf("\n", contentStart);
    if (closeAt === -1 || newlineAt !== -1 && newlineAt < closeAt) {
      out += code[i];
      i += 1;
      continue;
    }
    const label = code.slice(contentStart, closeAt);
    out += open + (isQuoted(label) ? label : quote(label)) + close;
    i = closeAt + close.length;
  }
  return out;
}
function quoteEdgeLabels(code) {
  return code.split("\n").map((line) => {
    let out = "";
    let rest = line;
    for (; ; ) {
      const open = rest.indexOf("|");
      if (open === -1) break;
      const close = rest.indexOf("|", open + 1);
      if (close === -1) break;
      const label = rest.slice(open + 1, close);
      out += rest.slice(0, open + 1) + (isQuoted(label) ? label : quote(label)) + "|";
      rest = rest.slice(close + 1);
    }
    return out + rest;
  }).join("\n");
}
function quoteSubgraphTitles(code) {
  return code.split("\n").map((line) => {
    const match = /^(\s*subgraph\s+)(.+?)(\s*)$/.exec(line);
    if (match === null) return line;
    const [, prefix, title, trailing] = match;
    if (title === void 0 || prefix === void 0) return line;
    if (isQuoted(title) || title.includes("[")) return line;
    return prefix + quote(title) + (trailing ?? "");
  }).join("\n");
}
function mermaidRepairCandidates(code) {
  if (!isFlowchart(code)) return [];
  const nodes = quoteNodeLabels(code);
  const nodesAndEdges = quoteEdgeLabels(nodes);
  const all = quoteSubgraphTitles(nodesAndEdges);
  const ordered2 = [nodes, nodesAndEdges, all];
  const seen = /* @__PURE__ */ new Set([code]);
  const candidates = [];
  for (const candidate of ordered2) {
    if (seen.has(candidate)) continue;
    seen.add(candidate);
    candidates.push(candidate);
  }
  return candidates;
}
var NODE_SHAPES, FLOWCHART_DIRECTIVE;
var init_mermaidSource = __esm({
  "components/core/molecules/markdown/mermaidSource.ts"() {
    NODE_SHAPES = [
      ["[[", "]]"],
      ["[(", ")]"],
      ["([", "])"],
      ["((", "))"],
      ["{{", "}}"],
      ["[", "]"],
      ["(", ")"],
      ["{", "}"]
    ];
    FLOWCHART_DIRECTIVE = /^(?:graph|flowchart)\b/;
  }
});
function loadMermaid() {
  mermaidModule ?? (mermaidModule = import('mermaid').then((m) => m.default));
  return mermaidModule;
}
var log6, mermaidModule, MermaidDiagram;
var init_MermaidDiagram = __esm({
  "components/core/molecules/markdown/MermaidDiagram.tsx"() {
    init_Box();
    init_Typography();
    init_CodeBlock();
    init_mermaidSource();
    init_cn();
    log6 = createLogger("almadar:ui:mermaid-diagram");
    mermaidModule = null;
    MermaidDiagram = React79__default.memo(
      ({ code, className }) => {
        const { resolvedMode } = useTheme();
        const { t } = useTranslate();
        const containerRef = useRef(null);
        const [unrenderable, setUnrenderable] = useState(false);
        const reactId = useId();
        useEffect(() => {
          let active = true;
          void (async () => {
            const mermaid = await loadMermaid();
            mermaid.initialize({
              startOnLoad: false,
              securityLevel: "strict",
              theme: resolvedMode === "dark" ? "dark" : "default",
              // Mermaid's default is to append its "Syntax error in text" bomb
              // graphic to <body> on a failed parse, outside any error boundary —
              // the catch below owns failure presentation (source + log), so the
              // library must not paint its own.
              suppressErrorRendering: true
            });
            const domId = `mermaid-${reactId.replace(/[^a-zA-Z0-9]/g, "")}`;
            let firstError = null;
            for (const [index, source] of [code, ...mermaidRepairCandidates(code)].entries()) {
              try {
                const { svg } = await mermaid.render(domId, source);
                if (!active) return;
                const container = containerRef.current;
                if (container === null) return;
                container.innerHTML = svg;
                container.dataset.mermaidRepaired = String(index > 0);
                setUnrenderable(false);
                if (index > 0) log6.debug("mermaid:repaired", { candidate: index });
                return;
              } catch (err) {
                firstError ?? (firstError = err instanceof Error ? err : new Error(String(err)));
              }
            }
            if (!active) return;
            log6.warn("mermaid:unrenderable", { error: firstError?.message ?? "", code });
            setUnrenderable(true);
          })();
          return () => {
            active = false;
          };
        }, [code, resolvedMode, reactId]);
        return /* @__PURE__ */ jsxs(Box, { className: cn("not-prose my-4", className), children: [
          unrenderable && /* @__PURE__ */ jsxs(Box, { className: "space-y-2 mb-2", "data-testid": "mermaid-unrenderable", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("mermaid.unrenderable") }),
            /* @__PURE__ */ jsx(CodeBlock, { code, language: "mermaid" })
          ] }),
          /* @__PURE__ */ jsx(
            Box,
            {
              ref: containerRef,
              "data-testid": "mermaid-diagram",
              className: "overflow-x-auto",
              style: unrenderable ? { display: "none" } : void 0
            }
          )
        ] });
      },
      (prev, next) => prev.code === next.code && prev.className === next.className
    );
    MermaidDiagram.displayName = "MermaidDiagram";
  }
});
var MarkdownContent;
var init_MarkdownContent = __esm({
  "components/core/molecules/markdown/MarkdownContent.tsx"() {
    init_katex_min();
    init_Box();
    init_CodeBlock();
    init_MermaidDiagram();
    init_cn();
    MarkdownContent = React79__default.memo(
      ({ content, direction = "ltr", className }) => {
        const { t: _t } = useTranslate();
        const safeContent = typeof content === "string" ? content : String(content ?? "");
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: cn("prose max-w-none", className),
            style: {
              color: "var(--color-foreground)",
              "--tw-prose-body": "var(--color-foreground)",
              "--tw-prose-headings": "var(--color-foreground)",
              "--tw-prose-lead": "var(--color-muted-foreground)",
              "--tw-prose-links": "var(--color-primary)",
              "--tw-prose-bold": "var(--color-foreground)",
              "--tw-prose-counters": "var(--color-muted-foreground)",
              "--tw-prose-bullets": "var(--color-muted-foreground)",
              "--tw-prose-hr": "var(--color-border)",
              "--tw-prose-quotes": "var(--color-foreground)",
              "--tw-prose-quote-borders": "var(--color-primary)",
              "--tw-prose-captions": "var(--color-muted-foreground)",
              "--tw-prose-code": "var(--color-foreground)",
              "--tw-prose-pre-code": "var(--color-foreground)",
              "--tw-prose-pre-bg": "var(--color-muted)",
              "--tw-prose-th-borders": "var(--color-border)",
              "--tw-prose-td-borders": "var(--color-border)",
              direction
            },
            children: /* @__PURE__ */ jsx(
              ReactMarkdown,
              {
                remarkPlugins: [remarkMath, remarkGfm],
                rehypePlugins: [
                  [rehypeKatex, { strict: false, throwOnError: false }]
                ],
                components: {
                  code({
                    className: codeClassName,
                    children,
                    inline,
                    ...props
                  }) {
                    if (!inline) {
                      const match = /language-(\w+)/.exec(codeClassName ?? "");
                      const code = String(children).replace(/\n$/, "");
                      if (match?.[1] === "mermaid") {
                        return /* @__PURE__ */ jsx(MermaidDiagram, { code });
                      }
                      if (match) {
                        return /* @__PURE__ */ jsx(
                          CodeBlock,
                          {
                            code,
                            language: toCodeLanguage(match[1]),
                            maxHeight: "60vh"
                          }
                        );
                      }
                      return /* @__PURE__ */ jsx(
                        "code",
                        {
                          ...props,
                          className: codeClassName,
                          style: {
                            backgroundColor: "var(--color-muted)",
                            color: "var(--color-foreground)",
                            border: "1px solid var(--color-border)",
                            padding: "0.125rem 0.375rem",
                            borderRadius: "0.25rem",
                            fontSize: "0.875em",
                            fontFamily: "ui-monospace, monospace",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word"
                          },
                          children
                        }
                      );
                    }
                    return /* @__PURE__ */ jsx(
                      "code",
                      {
                        ...props,
                        className: codeClassName,
                        style: {
                          backgroundColor: "var(--color-muted)",
                          color: "var(--color-foreground)",
                          border: "1px solid var(--color-border)",
                          padding: "0.125rem 0.375rem",
                          borderRadius: "0.25rem",
                          fontSize: "0.875em",
                          fontFamily: "ui-monospace, monospace"
                        },
                        children
                      }
                    );
                  },
                  // Style links
                  a({ href, children, ...props }) {
                    return /* @__PURE__ */ jsx(
                      "a",
                      {
                        href,
                        ...props,
                        className: "text-[var(--color-primary)] hover:underline",
                        target: href?.startsWith("http") ? "_blank" : void 0,
                        rel: href?.startsWith("http") ? "noopener noreferrer" : void 0,
                        children
                      }
                    );
                  },
                  // Style tables
                  table({ children, ...props }) {
                    return /* @__PURE__ */ jsx("div", { className: "overflow-x-auto my-4", children: /* @__PURE__ */ jsx(
                      "table",
                      {
                        ...props,
                        className: "min-w-full border-collapse border border-[var(--color-border)]",
                        children
                      }
                    ) });
                  },
                  th({ children, ...props }) {
                    return /* @__PURE__ */ jsx(
                      "th",
                      {
                        ...props,
                        className: "border border-[var(--color-border)] bg-[var(--color-muted)] px-4 py-2 text-left font-semibold",
                        children
                      }
                    );
                  },
                  td({ children, ...props }) {
                    return /* @__PURE__ */ jsx(
                      "td",
                      {
                        ...props,
                        className: "border border-[var(--color-border)] px-4 py-2",
                        children
                      }
                    );
                  },
                  // Strip <pre> wrapper so block code renders inline when needed
                  pre({ children }) {
                    return /* @__PURE__ */ jsx(Fragment, { children });
                  },
                  // Style blockquotes
                  blockquote({ children, ...props }) {
                    return /* @__PURE__ */ jsx(
                      "blockquote",
                      {
                        ...props,
                        className: "border-l-4 border-[var(--color-primary)] pl-4 italic text-[var(--color-foreground)] my-4",
                        children
                      }
                    );
                  }
                },
                children: safeContent
              }
            )
          }
        );
      },
      (prev, next) => prev.content === next.content && prev.className === next.className && prev.direction === next.direction
    );
    MarkdownContent.displayName = "MarkdownContent";
  }
});

// lib/lessonSegmentUtils.ts
function parseMarkdownWithCodeBlocks(content) {
  const segments = [];
  const codeBlockRegex = /```([^\n\r]*)\r?\n([\s\S]*?)```/g;
  let lastIndex = 0;
  let match;
  while ((match = codeBlockRegex.exec(content)) !== null) {
    const before = content.slice(lastIndex, match.index);
    if (before.trim()) {
      segments.push({ type: "markdown", content: before });
    }
    const tokens = match[1].trim().split(/\s+/).filter(Boolean);
    let rawLanguage = tokens[0] ?? "text";
    const suffixRunnable = rawLanguage.endsWith("-runnable");
    const runnable = suffixRunnable || tokens.includes("run");
    const baseLanguage = suffixRunnable ? rawLanguage.slice(0, -"-runnable".length) || "text" : rawLanguage;
    segments.push({ type: "code", language: baseLanguage, content: match[2].trim(), runnable });
    lastIndex = codeBlockRegex.lastIndex;
  }
  const remaining = content.slice(lastIndex);
  if (remaining.trim()) {
    segments.push({ type: "markdown", content: remaining });
  }
  return segments;
}
var init_lessonSegmentUtils = __esm({
  "lib/lessonSegmentUtils.ts"() {
  }
});
var BLOOM_CONFIG, BloomQuizBlock;
var init_BloomQuizBlock = __esm({
  "components/core/molecules/BloomQuizBlock.tsx"() {
    "use client";
    init_MarkdownContent();
    init_CodeBlock();
    init_lessonSegmentUtils();
    init_useEventBus();
    init_cn();
    BLOOM_CONFIG = {
      remember: { color: "bg-secondary text-secondary-foreground", bgColor: "bg-muted", label: "Remember" },
      understand: { color: "bg-info text-info-foreground", bgColor: "bg-info/10", label: "Understand" },
      apply: { color: "bg-success text-success-foreground", bgColor: "bg-success/10", label: "Apply" },
      analyze: { color: "bg-warning text-warning-foreground", bgColor: "bg-warning/10", label: "Analyze" },
      evaluate: { color: "bg-accent text-accent-foreground", bgColor: "bg-accent/10", label: "Evaluate" },
      create: { color: "bg-primary text-primary-foreground", bgColor: "bg-primary/10", label: "Create" }
    };
    BloomQuizBlock = ({
      level,
      question,
      answer,
      index,
      isAnswered,
      answerEvent = "ANSWER_BLOOM",
      className
    }) => {
      const [revealed, setRevealed] = useState(false);
      const config = BLOOM_CONFIG[level];
      const { emit } = useEventBus();
      const questionSegments = useMemo(() => parseMarkdownWithCodeBlocks(question), [question]);
      const answerSegments = useMemo(() => parseMarkdownWithCodeBlocks(answer), [answer]);
      const handleReveal = () => {
        if (!revealed) {
          emit(`UI:${answerEvent}`, { index: index ?? 0, level });
        }
        setRevealed(!revealed);
      };
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "rounded-lg border border-primary p-4 my-4 transition-all",
            config.bgColor,
            className
          ),
          children: [
            /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-3", children: [
              /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 flex-wrap", children: [
                index !== void 0 && /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground font-medium text-sm", children: [
                  "Question ",
                  index + 1
                ] }),
                /* @__PURE__ */ jsx("span", { className: cn(config.color, "text-xs px-2 py-1 rounded-full font-medium"), children: config.label })
              ] }),
              isAnswered && /* @__PURE__ */ jsx(CheckCircle, { className: "text-success flex-shrink-0", size: 20 })
            ] }),
            /* @__PURE__ */ jsx("div", { className: "font-semibold text-primary mb-3 space-y-2", children: questionSegments.map(
              (segment, idx) => segment.type === "markdown" ? /* @__PURE__ */ jsx(MarkdownContent, { content: segment.content }, `q-md-${idx}`) : /* @__PURE__ */ jsx(
                CodeBlock,
                {
                  language: segment.language ?? "text",
                  code: segment.content
                },
                `q-code-${idx}`
              )
            ) }),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "inline-flex items-center rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary-hover transition-colors",
                onClick: handleReveal,
                children: revealed ? "Hide Answer" : "Reveal Answer"
              }
            ),
            revealed && /* @__PURE__ */ jsxs("div", { className: "rounded-lg bg-card/80 p-3 text-sm text-foreground shadow-sm border border-primary mt-3 space-y-2", children: [
              /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground mb-1 font-medium uppercase tracking-wide", children: "Answer:" }),
              answerSegments.map(
                (segment, idx) => segment.type === "markdown" ? /* @__PURE__ */ jsx(MarkdownContent, { content: segment.content }, `a-md-${idx}`) : /* @__PURE__ */ jsx(
                  CodeBlock,
                  {
                    language: segment.language ?? "text",
                    code: segment.content
                  },
                  `a-code-${idx}`
                )
              )
            ] })
          ]
        }
      );
    };
    BloomQuizBlock.displayName = "BloomQuizBlock";
  }
});
var MIN_DIAGRAM_WIDTH, ScaledDiagram;
var init_ScaledDiagram = __esm({
  "components/core/molecules/ScaledDiagram.tsx"() {
    init_Box();
    init_cn();
    MIN_DIAGRAM_WIDTH = 200;
    ScaledDiagram = ({
      children,
      className
    }) => {
      const { t: _t } = useTranslate();
      const wrapperRef = useRef(null);
      const contentRef = useRef(null);
      const [layout, setLayout] = useState(null);
      const measure = useCallback(() => {
        const wrapper = wrapperRef.current;
        const content = contentRef.current;
        if (!wrapper || !content) return;
        const containerW = wrapper.clientWidth;
        if (containerW <= 0) return;
        let diagramW = 0;
        let diagramH = 0;
        const children2 = content.children;
        for (let i = 0; i < children2.length; i++) {
          const child = children2[i];
          const w = child.style?.width;
          const h = child.style?.height;
          if (w && /^\d+/.test(w) && h && /^\d+/.test(h)) {
            diagramW = parseFloat(w);
            diagramH = parseFloat(h);
            break;
          }
          if (child.offsetWidth > MIN_DIAGRAM_WIDTH) {
            diagramW = child.offsetWidth;
            diagramH = child.offsetHeight;
            break;
          }
        }
        if (diagramW < MIN_DIAGRAM_WIDTH || diagramH <= 0) {
          setLayout(null);
          return;
        }
        const s = Math.min(1, containerW / diagramW);
        setLayout({ scale: s, height: diagramH * s });
      }, []);
      useEffect(() => {
        const content = contentRef.current;
        if (!content) return;
        let raf1 = requestAnimationFrame(() => {
          requestAnimationFrame(() => measure());
        });
        const mo = new MutationObserver(() => {
          requestAnimationFrame(() => measure());
        });
        mo.observe(content, { childList: true, subtree: true, attributes: true });
        return () => {
          cancelAnimationFrame(raf1);
          mo.disconnect();
        };
      }, [measure, children]);
      useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const ro = new ResizeObserver(() => measure());
        ro.observe(wrapper);
        return () => ro.disconnect();
      }, [measure]);
      const hasLayout = layout !== null;
      return /* @__PURE__ */ jsx(
        Box,
        {
          ref: wrapperRef,
          className: cn("w-full", className),
          style: {
            // Only clip overflow once we have a valid measurement
            overflow: hasLayout ? "hidden" : void 0,
            height: hasLayout ? layout.height : void 0
          },
          children: /* @__PURE__ */ jsx(
            Box,
            {
              ref: contentRef,
              style: {
                width: "max-content",
                transformOrigin: "top left",
                transform: hasLayout && layout.scale < 1 ? `scale(${layout.scale})` : void 0
              },
              children
            }
          )
        }
      );
    };
    ScaledDiagram.displayName = "ScaledDiagram";
  }
});
function useLongPress(onLongPress, options = {}) {
  const { duration = 500, moveThreshold = 10 } = options;
  const timerRef = useRef(null);
  const startPos = useRef({ x: 0, y: 0 });
  const isPressedRef = useRef(false);
  const firedRef = useRef(false);
  const cancel = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    isPressedRef.current = false;
  }, []);
  const onPointerDown = useCallback((e) => {
    firedRef.current = false;
    startPos.current = { x: e.clientX, y: e.clientY };
    isPressedRef.current = true;
    timerRef.current = setTimeout(() => {
      firedRef.current = true;
      isPressedRef.current = false;
      onLongPress();
    }, duration);
  }, [duration, onLongPress]);
  const onPointerMove = useCallback((e) => {
    if (!isPressedRef.current) return;
    const dx = e.clientX - startPos.current.x;
    const dy = e.clientY - startPos.current.y;
    if (Math.sqrt(dx * dx + dy * dy) > moveThreshold) {
      cancel();
    }
  }, [moveThreshold, cancel]);
  const onPointerUp = useCallback(() => {
    cancel();
  }, [cancel]);
  const onPointerCancel = useCallback(() => {
    cancel();
  }, [cancel]);
  return {
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onPointerCancel,
    isPressed: isPressedRef.current
  };
}
var init_useLongPress = __esm({
  "hooks/useLongPress.ts"() {
    "use client";
  }
});
function Card2({
  title,
  subtitle,
  image,
  actions,
  children,
  onClick,
  className = "",
  action,
  longPressEvent,
  longPressPayload
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const isClickable = !!onClick || !!action;
  const handleLongPress = useCallback(() => {
    if (longPressEvent) {
      eventBus.emit(`UI:${longPressEvent}`, longPressPayload ?? {});
    }
  }, [longPressEvent, longPressPayload, eventBus]);
  const longPress = useLongPress(handleLongPress);
  const handleClick = () => {
    if (action) eventBus.emit(`UI:${action}`, {});
    onClick?.();
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `
        bg-card
        border border-border
        rounded-container shadow-elevation-card
        ${isClickable ? "cursor-pointer hover:shadow-elevation-dialog transition-shadow" : ""}
        ${className}
      `,
      onClick: isClickable ? handleClick : void 0,
      role: isClickable ? "button" : void 0,
      tabIndex: isClickable ? 0 : void 0,
      onKeyDown: isClickable ? (e) => e.key === "Enter" && handleClick() : void 0,
      ...longPressEvent ? {
        onPointerDown: longPress.onPointerDown,
        onPointerMove: longPress.onPointerMove,
        onPointerUp: longPress.onPointerUp,
        onPointerCancel: longPress.onPointerCancel
      } : {},
      children: [
        image && /* @__PURE__ */ jsx("div", { className: "aspect-video w-full overflow-hidden rounded-t-lg", children: /* @__PURE__ */ jsx(
          "img",
          {
            src: image,
            alt: title || t("card.imageAlt"),
            className: "w-full h-full object-cover"
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: "p-4", children: [
          (title || subtitle) && /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
            title && /* @__PURE__ */ jsx("h3", { className: "text-lg font-semibold text-card-foreground", children: title }),
            subtitle && /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground mt-1", children: subtitle })
          ] }),
          children && /* @__PURE__ */ jsx("div", { className: "text-card-foreground", children }),
          actions && actions.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2 mt-4 pt-4 border-t border-border", children: actions.map((action2, index) => /* @__PURE__ */ jsx(
            "button",
            {
              onClick: (e) => {
                e.stopPropagation();
                if (action2.event) eventBus.emit(`UI:${action2.event}`, { label: action2.label });
                action2.onClick?.();
              },
              disabled: action2.disabled,
              className: `
                  px-3 py-1.5 text-sm font-medium rounded-sm
                  transition-colors
                  ${action2.variant === "primary" ? "bg-primary text-primary-foreground hover:bg-primary-hover disabled:opacity-50" : action2.variant === "danger" ? "bg-error text-error-foreground hover:opacity-90 disabled:opacity-50" : "bg-muted text-foreground hover:bg-[var(--color-surface-hover)]"}
                  disabled:cursor-not-allowed
                `,
              children: action2.label
            },
            index
          )) })
        ] })
      ]
    }
  );
}
var init_Card2 = __esm({
  "components/core/molecules/Card.tsx"() {
    "use client";
    init_useEventBus();
    init_useLongPress();
    Card2.displayName = "Card";
  }
});
var QuizBlock;
var init_QuizBlock = __esm({
  "components/core/molecules/QuizBlock.tsx"() {
    init_Card2();
    init_Stack();
    init_Typography();
    init_Button();
    init_Icon();
    init_Box();
    init_cn();
    QuizBlock = ({
      question,
      answer,
      className
    }) => {
      const { t } = useTranslate();
      const [revealed, setRevealed] = useState(false);
      return /* @__PURE__ */ jsx(Card2, { className: cn("my-4 border-primary", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-4", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
          /* @__PURE__ */ jsx(Icon, { icon: HelpCircle, size: "sm", className: "text-primary mt-0.5 shrink-0" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body", className: "font-medium", children: question })
        ] }),
        revealed ? /* @__PURE__ */ jsx(Box, { className: "pl-7 pt-2 border-t border-border", children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-foreground", children: answer }) }) : null,
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            onClick: () => setRevealed((r) => !r),
            className: "self-start ml-7",
            children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "caption", children: revealed ? t("quiz.hideAnswer") : t("quiz.showAnswer") }),
              revealed ? /* @__PURE__ */ jsx(Icon, { name: "chevron-up", className: "w-3.5 h-3.5" }) : /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "w-3.5 h-3.5" })
            ] })
          }
        )
      ] }) });
    };
    QuizBlock.displayName = "QuizBlock";
  }
});
var StateNode, TransitionBundleArrow, BundleTooltip, EntityBox, OutputsBox, Legend, StateMachineView;
var init_StateMachineView = __esm({
  "components/core/organisms/StateMachineView.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_Stack();
    init_Typography();
    init_Button();
    init_Icon();
    init_useEventBus();
    init_cn();
    init_portalRoot();
    StateNode = ({ state, config }) => {
      const { t } = useTranslate();
      const size = state.radius * 2;
      let borderColor = config.colors.nodeBorder;
      let borderWidth = 2;
      if (state.isInitial) {
        borderColor = config.colors.initialNode;
        borderWidth = 3;
      } else if (state.isFinal) {
        borderColor = config.colors.finalNode;
        borderWidth = 3;
      }
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: "absolute flex items-center justify-center cursor-pointer transition-all hover:scale-105",
          style: {
            left: state.x - state.radius,
            top: state.y - state.radius,
            width: size,
            height: size,
            zIndex: 5
          },
          action: "STATE_CLICK",
          actionPayload: { stateName: state.name },
          title: state.description,
          children: [
            /* @__PURE__ */ jsxs(
              Box,
              {
                className: "absolute inset-0 rounded-full flex items-center justify-center",
                style: {
                  backgroundColor: config.colors.node,
                  border: `${borderWidth}px solid ${borderColor}`
                },
                children: [
                  state.isFinal && /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: "absolute rounded-full",
                      style: {
                        width: size - 12,
                        height: size - 12,
                        border: `2px solid ${borderColor}`
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "label",
                      weight: "semibold",
                      align: "center",
                      className: "px-2",
                      style: {
                        color: config.colors.nodeText,
                        fontSize: "18px",
                        fontFamily: "Inter, sans-serif"
                      },
                      children: state.name
                    }
                  )
                ]
              }
            ),
            state.isInitial && /* @__PURE__ */ jsxs(
              "svg",
              {
                className: "absolute",
                style: {
                  left: -45,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: 40,
                  height: 20
                },
                children: [
                  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
                    "marker",
                    {
                      id: "initial-arrow",
                      viewBox: "0 0 10 10",
                      refX: "8",
                      refY: "5",
                      markerWidth: "6",
                      markerHeight: "6",
                      orient: "auto",
                      children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: config.colors.initial })
                    }
                  ) }),
                  /* @__PURE__ */ jsx(
                    "path",
                    {
                      d: "M 0 10 L 35 10",
                      stroke: config.colors.initial,
                      strokeWidth: "2",
                      fill: "none",
                      markerEnd: "url(#initial-arrow)"
                    }
                  )
                ]
              }
            )
          ]
        }
      );
    };
    TransitionBundleArrow = ({ bundle, states, bundleIndex, config, onClick, onHover }) => {
      const { t } = useTranslate();
      const groupRef = useRef(null);
      const fromState = states.find((s) => s.name === bundle.from);
      const toState = states.find((s) => s.name === bundle.to);
      if (!fromState || !toState) return null;
      const isSelfLoop = bundle.from === bundle.to;
      const dx = toState.x - fromState.x;
      const dy = toState.y - fromState.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (isSelfLoop) {
        const loopRadius = 50 + bundleIndex * 25;
        const loopDirection = bundleIndex % 2 === 0 ? -1 : 1;
        const startAngle = loopDirection === -1 ? -0.5 : 0.5;
        const endAngle = loopDirection === -1 ? 0.5 : -0.5;
        const startX2 = fromState.x + Math.cos(Math.PI / 2 * loopDirection + startAngle) * fromState.radius;
        const startY2 = fromState.y + Math.sin(Math.PI / 2 * loopDirection + startAngle) * fromState.radius;
        const endX2 = fromState.x + Math.cos(Math.PI / 2 * loopDirection + endAngle) * fromState.radius;
        const endY2 = fromState.y + Math.sin(Math.PI / 2 * loopDirection + endAngle) * fromState.radius;
        const isSingle2 = bundle.labels.length === 1;
        const labelText2 = isSingle2 ? bundle.labels[0].event : t("stateMachine.eventCount", { count: bundle.labels.length });
        const bundleColor2 = isSingle2 ? config.colors.arrow : "var(--color-accent)";
        const labelWidth2 = labelText2.length * 9 + (isSingle2 ? 24 : 40);
        const cx = fromState.x;
        const cy = fromState.y + (fromState.radius + loopRadius) * loopDirection;
        const loopPath = `M ${startX2} ${startY2} A ${loopRadius} ${loopRadius} 0 1 ${loopDirection === -1 ? 1 : 0} ${endX2} ${endY2}`;
        const labelX2 = cx;
        const labelY2 = cy + loopRadius * loopDirection * 0.5;
        const uniqueMarkerId2 = `arrow-self-${bundle.id}`;
        const handleMouseEnter2 = () => {
          if (groupRef.current) {
            const rect = groupRef.current.getBoundingClientRect();
            onHover(bundle, rect.left + rect.width / 2, rect.top - 8);
          }
        };
        const handleMouseLeave2 = () => {
          onHover(null, 0, 0);
        };
        const handlePointerDown2 = (e) => {
          if (e.pointerType === "mouse") return;
          handleMouseEnter2();
        };
        return /* @__PURE__ */ jsxs(
          "g",
          {
            ref: groupRef,
            className: "transition-bundle cursor-pointer",
            "data-bundle-id": bundle.id,
            onClick: () => onClick?.(bundle),
            onMouseEnter: handleMouseEnter2,
            onMouseLeave: handleMouseLeave2,
            onPointerDown: handlePointerDown2,
            style: { pointerEvents: "auto" },
            children: [
              /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
                "marker",
                {
                  id: uniqueMarkerId2,
                  viewBox: "0 0 10 10",
                  refX: "8",
                  refY: "5",
                  markerWidth: "8",
                  markerHeight: "8",
                  orient: "auto",
                  children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: bundleColor2 })
                }
              ) }),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: loopPath,
                  stroke: bundleColor2,
                  strokeWidth: isSingle2 ? 1.5 : 2.5,
                  fill: "none",
                  markerEnd: `url(#${uniqueMarkerId2})`
                }
              ),
              /* @__PURE__ */ jsx(
                "rect",
                {
                  x: labelX2 - labelWidth2 / 2,
                  y: labelY2 - 14,
                  width: labelWidth2,
                  height: 28,
                  rx: isSingle2 ? 4 : 14,
                  fill: isSingle2 ? config.colors.background : "var(--color-accent)",
                  stroke: bundleColor2,
                  strokeWidth: isSingle2 ? 1 : 0
                }
              ),
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: labelX2,
                  y: labelY2 + 5,
                  textAnchor: "middle",
                  fill: isSingle2 ? config.colors.arrowText : "var(--color-accent-foreground)",
                  fontFamily: "JetBrains Mono, monospace",
                  fontSize: "13px",
                  fontWeight: isSingle2 ? 600 : 700,
                  children: labelText2
                }
              )
            ]
          }
        );
      }
      if (dist === 0) return null;
      const nx = dx / dist;
      const ny = dy / dist;
      const startX = fromState.x + nx * fromState.radius;
      const startY = fromState.y + ny * fromState.radius;
      const endX = toState.x - nx * (toState.radius + 8);
      const endY = toState.y - ny * (toState.radius + 8);
      const intermediateStates = states.filter((s) => {
        if (s.name === bundle.from || s.name === bundle.to) return false;
        const t2 = ((s.x - fromState.x) * dx + (s.y - fromState.y) * dy) / (dist * dist);
        if (t2 < 0.1 || t2 > 0.9) return false;
        const projX = fromState.x + t2 * dx;
        const projY = fromState.y + t2 * dy;
        const distToLine = Math.sqrt((s.x - projX) ** 2 + (s.y - projY) ** 2);
        return distToLine < s.radius + 80;
      });
      const baseCurveDirection = bundle.isReverse ? 1 : -1;
      const laneOffset = 55 + bundleIndex * 55;
      let avoidanceOffset = 0;
      if (intermediateStates.length > 0) {
        const midXObst = (fromState.x + toState.x) / 2;
        const midYObst = (fromState.y + toState.y) / 2;
        const perpDirX = -ny;
        const perpDirY = nx;
        let obstaclesAbove = 0;
        let obstaclesBelow = 0;
        intermediateStates.forEach((s) => {
          const relX = s.x - midXObst;
          const relY = s.y - midYObst;
          const perpDist = relX * perpDirX + relY * perpDirY;
          if (perpDist > 0) obstaclesAbove++;
          else obstaclesBelow++;
        });
        avoidanceOffset = obstaclesAbove > obstaclesBelow ? -100 : 100;
      }
      const baseOffset = bundle.isBidirectional ? 60 : 40;
      const curveAmount = (baseOffset + laneOffset) * baseCurveDirection + avoidanceOffset;
      const midX = (startX + endX) / 2;
      const midY = (startY + endY) / 2;
      const perpX = -ny * curveAmount;
      const perpY = nx * curveAmount;
      const controlX = midX + perpX;
      const controlY = midY + perpY;
      const isSingle = bundle.labels.length === 1;
      const labelText = isSingle ? bundle.labels[0].event : t("stateMachine.eventCount", { count: bundle.labels.length });
      const labelWidth = labelText.length * 9 + (isSingle ? 24 : 40);
      const bundleColor = isSingle ? config.colors.arrow : "var(--color-accent)";
      const curveMidpoint = {
        x: 0.25 * startX + 0.5 * controlX + 0.25 * endX,
        y: 0.25 * startY + 0.5 * controlY + 0.25 * endY
      };
      const labelX = curveMidpoint.x;
      const labelY = curveMidpoint.y;
      const handleMouseEnter = useCallback(() => {
        if (groupRef.current) {
          const rect = groupRef.current.getBoundingClientRect();
          onHover(bundle, rect.left + rect.width / 2, rect.top - 8);
        }
      }, [bundle, onHover]);
      const handleMouseLeave = useCallback(() => {
        onHover(null, 0, 0);
      }, [onHover]);
      const handlePointerDown = useCallback((e) => {
        if (e.pointerType === "mouse") return;
        handleMouseEnter();
      }, [handleMouseEnter]);
      const uniqueMarkerId = `arrow-${bundle.id}`;
      const hasDetails = bundle.labels.some((l) => l.hasDetails);
      return /* @__PURE__ */ jsxs(
        "g",
        {
          ref: groupRef,
          className: "transition-bundle cursor-pointer",
          "data-bundle-id": bundle.id,
          onClick: () => onClick?.(bundle),
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onPointerDown: handlePointerDown,
          style: { pointerEvents: "auto" },
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
              "marker",
              {
                id: uniqueMarkerId,
                viewBox: "0 0 10 10",
                refX: "8",
                refY: "5",
                markerWidth: "8",
                markerHeight: "8",
                orient: "auto",
                children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: bundleColor })
              }
            ) }),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: `M ${startX} ${startY} Q ${controlX} ${controlY} ${endX} ${endY}`,
                stroke: bundleColor,
                strokeWidth: isSingle ? 1.5 : 2.5,
                fill: "none",
                markerEnd: `url(#${uniqueMarkerId})`
              }
            ),
            /* @__PURE__ */ jsx(
              "rect",
              {
                x: labelX - labelWidth / 2,
                y: labelY - 14,
                width: labelWidth,
                height: 28,
                rx: isSingle ? 4 : 14,
                fill: isSingle ? config.colors.background : "var(--color-accent)",
                stroke: bundleColor,
                strokeWidth: isSingle ? 1 : 0
              }
            ),
            /* @__PURE__ */ jsx(
              "text",
              {
                x: labelX,
                y: labelY + 5,
                textAnchor: "middle",
                fill: isSingle ? config.colors.arrowText : "var(--color-accent-foreground)",
                fontFamily: "JetBrains Mono, monospace",
                fontSize: "13px",
                fontWeight: isSingle ? 600 : 700,
                children: labelText
              }
            ),
            isSingle && hasDetails && /* @__PURE__ */ jsx(
              "circle",
              {
                cx: labelX + labelWidth / 2 - 6,
                cy: labelY - 10,
                r: 4,
                fill: config.colors.guardText
              }
            ),
            !isSingle && /* @__PURE__ */ jsx(
              "circle",
              {
                cx: labelX + labelWidth / 2 - 4,
                cy: labelY - 10,
                r: 8,
                fill: "var(--color-error)",
                stroke: "var(--color-error-foreground)",
                strokeWidth: 1
              }
            )
          ]
        }
      );
    };
    BundleTooltip = ({ tooltip, config }) => {
      const { t } = useTranslate();
      if (!tooltip.visible || !tooltip.bundle) return null;
      const { bundle } = tooltip;
      const isSingle = bundle.labels.length === 1;
      const estimatedHeight = isSingle ? bundle.labels[0].guardText || bundle.labels[0].effectTexts.length > 0 ? 120 : 60 : Math.min(400, 80 + bundle.labels.length * 60);
      const wouldGoOffTop = tooltip.y - estimatedHeight < 20;
      const safeX = Math.max(200, Math.min(tooltip.x, window.innerWidth - 200));
      const safeY = wouldGoOffTop ? tooltip.y + 40 : tooltip.y;
      const transform = wouldGoOffTop ? "translateX(-50%)" : "translate(-50%, -100%)";
      return createPortal(
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "fixed z-50 animate-in fade-in-0 zoom-in-95 duration-fast",
              tooltip.pinned ? "pointer-events-auto" : "pointer-events-none"
            ),
            style: {
              left: safeX,
              top: safeY,
              transform,
              maxHeight: "calc(100vh - 40px)",
              overflow: "auto"
            },
            children: /* @__PURE__ */ jsxs(
              Box,
              {
                className: "rounded-lg shadow-xl border px-4 py-3 max-w-lg relative bg-card",
                style: {
                  borderColor: tooltip.pinned ? "var(--color-success)" : isSingle ? config.colors.nodeBorder : "var(--color-accent)",
                  borderWidth: tooltip.pinned ? 2 : isSingle ? 1 : 2
                },
                children: [
                  tooltip.pinned && /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      size: "sm",
                      action: "TOOLTIP_CLOSE",
                      className: "absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center hover:scale-110 transition-transform",
                      style: { backgroundColor: "var(--color-error)", padding: 0 },
                      title: t("common.close"),
                      children: /* @__PURE__ */ jsx(Icon, { icon: X, size: "xs", style: { color: "var(--color-error-foreground)" } })
                    }
                  ),
                  tooltip.pinned && /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: "absolute -top-2 left-1/2 transform -translate-x-1/2 px-2 py-0.5 rounded-full",
                      style: { backgroundColor: "var(--color-success)" },
                      children: /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "semibold", style: { color: "var(--color-success-foreground)" }, children: t("stateMachine.pinned") })
                    }
                  ),
                  !isSingle && /* @__PURE__ */ jsxs(
                    HStack,
                    {
                      gap: "sm",
                      align: "center",
                      className: "font-bold mb-3 pb-2 border-b",
                      style: {
                        color: "var(--color-accent-foreground)",
                        borderColor: "var(--color-border)"
                      },
                      children: [
                        /* @__PURE__ */ jsx(Typography, { variant: "large", style: { color: "var(--color-accent-foreground)" }, children: bundle.from }),
                        /* @__PURE__ */ jsx(Typography, { variant: "label", style: { color: "var(--color-muted-foreground)" }, children: "\u2192" }),
                        /* @__PURE__ */ jsx(Typography, { variant: "large", style: { color: "var(--color-accent-foreground)" }, children: bundle.to }),
                        /* @__PURE__ */ jsx(
                          Box,
                          {
                            className: "ml-2 px-2 py-0.5 rounded-full",
                            style: { backgroundColor: "var(--color-accent)" },
                            children: /* @__PURE__ */ jsx(Typography, { variant: "caption", style: { color: "var(--color-accent-foreground)" }, children: t("stateMachine.eventCount", { count: bundle.labels.length }) })
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(VStack, { gap: "sm", children: bundle.labels.map((label, idx) => /* @__PURE__ */ jsxs(
                    Box,
                    {
                      className: !isSingle && idx > 0 ? "pt-2 border-t" : "",
                      style: { borderColor: "var(--color-border)" },
                      children: [
                        /* @__PURE__ */ jsxs(
                          Typography,
                          {
                            variant: "label",
                            weight: "semibold",
                            className: "mb-1",
                            style: {
                              color: config.colors.arrowText,
                              fontFamily: "JetBrains Mono, monospace",
                              fontSize: isSingle ? "14px" : "13px"
                            },
                            children: [
                              !isSingle && /* @__PURE__ */ jsx(Typography, { variant: "caption", as: "span", style: { color: "var(--color-muted-foreground)" }, children: "\u2022 " }),
                              label.event
                            ]
                          }
                        ),
                        label.guardText && /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", className: "ml-3 mb-0.5", children: [
                          /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: "caption",
                              weight: "semibold",
                              style: { color: config.colors.guardText },
                              children: "if:"
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: "caption",
                              style: { color: config.colors.guardText },
                              children: label.guardText
                            }
                          )
                        ] }),
                        label.effectTexts.length > 0 && /* @__PURE__ */ jsx(VStack, { gap: "none", className: "ml-3", children: label.effectTexts.map((effect, effIdx) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
                          /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: "caption",
                              weight: "semibold",
                              style: { color: config.colors.effectText },
                              children: effIdx === 0 ? "\u2192" : " "
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: "caption",
                              style: { color: config.colors.effectText },
                              children: effect
                            }
                          )
                        ] }, effIdx)) })
                      ]
                    },
                    label.id
                  )) })
                ]
              }
            )
          }
        ),
        getOrCreatePortalRoot()
      );
    };
    EntityBox = ({ entity, config }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "none",
          className: "absolute rounded-lg border-2 p-3",
          style: {
            left: entity.x,
            top: entity.y,
            width: entity.width,
            height: entity.height,
            backgroundColor: config.colors.background,
            borderColor: "var(--color-info)",
            zIndex: 5
          },
          children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "label",
                weight: "semibold",
                align: "center",
                className: "mb-2",
                style: { color: "var(--color-info)", fontSize: "14px" },
                children: entity.name
              }
            ),
            entity.fields.map((field, idx) => /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                style: { color: "var(--color-muted-foreground)", fontFamily: "JetBrains Mono, monospace" },
                children: field
              },
              idx
            ))
          ]
        }
      );
    };
    OutputsBox = ({ outputs, config }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "none",
          className: "absolute rounded-lg border-2 p-3",
          style: {
            left: outputs.x,
            top: outputs.y,
            width: outputs.width,
            height: outputs.height,
            backgroundColor: config.colors.background,
            borderColor: "var(--color-warning)",
            zIndex: 5
          },
          children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                weight: "semibold",
                align: "center",
                className: "mb-2",
                style: { color: "var(--color-warning)", fontSize: "13px" },
                children: t("stateMachine.externalEffects")
              }
            ),
            outputs.outputs.map((output, idx) => /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                className: "mb-0.5",
                style: { color: "var(--color-foreground)", fontFamily: "Inter, sans-serif" },
                children: output
              },
              idx
            ))
          ]
        }
      );
    };
    Legend = ({ config, y }) => {
      const { t } = useTranslate();
      const items = [
        { key: "initial", label: t("stateMachine.legend.initial"), color: config.colors.initialNode, isMultiEvent: false },
        { key: "final", label: t("stateMachine.legend.final"), color: config.colors.finalNode, isMultiEvent: false },
        { key: "state", label: t("stateMachine.legend.state"), color: config.colors.nodeBorder, isMultiEvent: false },
        { key: "multiEvent", label: t("stateMachine.legend.multiEvent"), color: "var(--color-accent)", isMultiEvent: true }
      ];
      return /* @__PURE__ */ jsx(
        HStack,
        {
          gap: "md",
          align: "center",
          className: "absolute",
          style: { left: 20, top: y, zIndex: 15 },
          children: items.map((item) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "w-3 h-3 rounded-full",
                style: {
                  backgroundColor: item.isMultiEvent ? item.color : config.colors.node,
                  border: !item.isMultiEvent ? `2px solid ${item.color}` : "none"
                }
              }
            ),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                style: { color: config.colors.arrowText },
                children: item.label
              }
            )
          ] }, item.key))
        }
      );
    };
    StateMachineView = ({
      layoutData,
      renderStateNode,
      className = "",
      isLoading: _isLoading,
      error: _error
    }) => {
      const { t } = useTranslate();
      const [tooltip, setTooltip] = useState({
        visible: false,
        pinned: false,
        x: 0,
        y: 0,
        bundle: null
      });
      const handleBundleHover = useCallback((bundle, x, y) => {
        if (tooltip.pinned) return;
        if (bundle) {
          setTooltip({ visible: true, pinned: false, x, y, bundle });
        } else {
          setTooltip((prev) => ({ ...prev, visible: false }));
        }
      }, [tooltip.pinned]);
      const handleBundleClick = useCallback((bundle) => {
        if (tooltip.pinned && tooltip.bundle?.id === bundle.id) {
          setTooltip((prev) => ({ ...prev, pinned: false, visible: false }));
        } else {
          const el = document.querySelector(`[data-bundle-id="${bundle.id}"]`);
          if (el) {
            const rect = el.getBoundingClientRect();
            setTooltip({
              visible: true,
              pinned: true,
              x: rect.left + rect.width / 2,
              y: rect.top - 8,
              bundle
            });
          }
        }
      }, [tooltip.pinned, tooltip.bundle?.id]);
      const handleCloseTooltip = useCallback(() => {
        setTooltip((prev) => ({ ...prev, pinned: false, visible: false }));
      }, []);
      useEventListener("UI:TOOLTIP_CLOSE", handleCloseTooltip);
      if (!layoutData) return null;
      const { width, height, title, states, labels, entity, outputs, config } = layoutData;
      const bundles = useMemo(() => {
        const bundleMap = {};
        labels.forEach((label) => {
          const key = `${label.from}->${label.to}`;
          if (!bundleMap[key]) bundleMap[key] = [];
          bundleMap[key].push(label);
        });
        const allPairs = new Set(Object.keys(bundleMap));
        return Object.entries(bundleMap).map(([key, bundleLabels]) => {
          const [from, to] = key.split("->");
          const reverseKey = `${to}->${from}`;
          const isBidirectional = allPairs.has(reverseKey);
          const isReverse = from > to;
          return {
            id: `bundle-${from}-${to}`,
            from,
            to,
            labels: bundleLabels,
            isBidirectional,
            isReverse
          };
        });
      }, [labels]);
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: cn("relative", className),
          style: {
            width,
            height,
            backgroundColor: config.colors.background,
            borderRadius: "8px"
          },
          children: [
            title && /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "label",
                weight: "semibold",
                align: "center",
                className: "absolute",
                style: {
                  left: 0,
                  right: 0,
                  top: 10,
                  color: config.colors.nodeText,
                  fontSize: "14px",
                  fontFamily: "Inter, sans-serif",
                  zIndex: 15
                },
                children: title
              }
            ),
            /* @__PURE__ */ jsxs(
              Box,
              {
                className: "absolute inset-0",
                style: { top: title ? 30 : 0 },
                children: [
                  entity && /* @__PURE__ */ jsx(EntityBox, { entity, config }),
                  states.map((state) => renderStateNode ? /* @__PURE__ */ jsx(React79__default.Fragment, { children: renderStateNode(state, config) }, state.id) : /* @__PURE__ */ jsx(
                    StateNode,
                    {
                      state,
                      config
                    },
                    state.id
                  )),
                  /* @__PURE__ */ jsx(
                    "svg",
                    {
                      className: "absolute inset-0",
                      width,
                      height: height - (title ? 30 : 0),
                      style: { overflow: "visible", zIndex: 20, pointerEvents: "none" },
                      children: bundles.map((bundle, idx) => /* @__PURE__ */ jsx(
                        TransitionBundleArrow,
                        {
                          bundle,
                          states,
                          bundleIndex: idx,
                          totalBundlesForPair: bundles.length,
                          config,
                          onClick: handleBundleClick,
                          onHover: handleBundleHover
                        },
                        bundle.id
                      ))
                    }
                  ),
                  outputs && /* @__PURE__ */ jsx(OutputsBox, { outputs, config })
                ]
              }
            ),
            /* @__PURE__ */ jsx(Legend, { config, y: height - 25 }),
            /* @__PURE__ */ jsx(BundleTooltip, { tooltip, config })
          ]
        }
      );
    };
    StateMachineView.displayName = "StateMachineView";
  }
});

// lib/visualizer/index.ts
function formatSExprGuardToDomain(guard, _entityName) {
  if (Array.isArray(guard)) {
    const [op, ...args] = guard;
    return `${op}(${args.map((a) => JSON.stringify(a)).join(", ")})`;
  }
  return JSON.stringify(guard);
}
function formatSExprEffectToDomain(effect, _entityName) {
  if (Array.isArray(effect)) {
    const [op, ...args] = effect;
    return `${op}(${args.map((a) => JSON.stringify(a)).join(", ")})`;
  }
  return JSON.stringify(effect);
}
function isArraySExpr(expr) {
  return Array.isArray(expr);
}
function isBinding(val) {
  return typeof val === "string" && val.startsWith("@");
}
function parseBinding(binding) {
  if (!isBinding(binding)) return null;
  const withoutAt = binding.substring(1);
  const parts = withoutAt.split(".");
  return {
    root: parts[0],
    path: parts.slice(1),
    raw: binding
  };
}
function formatGuard(guard) {
  let text = "";
  if (typeof guard === "string") {
    text = guard;
  } else if (Array.isArray(guard)) {
    text = formatSExprCompact(guard);
  }
  return text ? `[${text}]` : "";
}
function formatGuardHuman(guard, entityName) {
  if (!guard) return "";
  if (typeof guard === "string") {
    return `if ${guard}`;
  }
  if (isArraySExpr(guard)) {
    return formatSExprGuardToDomain(guard);
  }
  return "";
}
function formatEffectsHuman(effects, entityName) {
  if (!Array.isArray(effects) || effects.length === 0) return [];
  return effects.map((effect) => {
    if (isArraySExpr(effect)) {
      return formatSExprEffectToDomain(effect);
    }
    return String(effect);
  }).filter(Boolean);
}
function formatSExprCompact(expr) {
  if (!Array.isArray(expr) || expr.length === 0) return "[]";
  const op = expr[0];
  const args = expr.slice(1);
  const formattedArgs = args.map((a) => {
    if (isBinding(a)) {
      const parsed = parseBinding(a);
      if (parsed && parsed.path.length > 0) {
        return `${parsed.root}.${parsed.path.join(".")}`;
      }
      return parsed?.root || a;
    }
    if (typeof a === "string") return a;
    if (typeof a === "number" || typeof a === "boolean") return String(a);
    if (Array.isArray(a)) return formatSExprCompact(a);
    return "{...}";
  });
  return `${op} ${formattedArgs.join(" ")}`;
}
function getEffectSummary(effects) {
  if (!Array.isArray(effects) || effects.length === 0) return "";
  const setFields = [];
  const otherEffects = [];
  effects.forEach((effect) => {
    if (!Array.isArray(effect)) return;
    const op = effect[0];
    if (op === "set" && effect[1] && typeof effect[1] === "string") {
      const parsed = parseBinding(effect[1]);
      if (parsed && parsed.path.length > 0) {
        setFields.push(parsed.path[parsed.path.length - 1]);
      } else {
        setFields.push("field");
      }
    } else {
      otherEffects.push(effect);
    }
  });
  const summaries = [];
  if (setFields.length > 0) {
    summaries.push(`\u2192 ${setFields.join(", ")}`);
  }
  otherEffects.forEach((effect) => {
    const op = effect[0];
    switch (op) {
      case "emit":
        summaries.push(`\u2191 ${effect[1] || "event"}`);
        break;
      case "persist":
        summaries.push(`\u{1F4BE} ${effect[1] || "save"}`);
        break;
      case "navigate":
        summaries.push(`\u{1F517} nav`);
        break;
      case "spawn":
        summaries.push(`+ ${effect[1] || "spawn"}`);
        break;
      case "despawn":
        summaries.push(`- despawn`);
        break;
      default:
        summaries.push(op);
    }
  });
  return summaries.join(" | ");
}
function extractOutputsFromTransitions(transitions) {
  const outputs = /* @__PURE__ */ new Set();
  transitions.forEach((t) => {
    if (t.effects) {
      t.effects.forEach((effect) => {
        if (Array.isArray(effect)) {
          const op = effect[0];
          if (["emit", "persist", "navigate", "call-service"].includes(op)) {
            if (isArraySExpr(effect)) {
              const humanText = formatSExprEffectToDomain(effect);
              outputs.add(humanText);
            }
          }
        }
      });
    }
  });
  return Array.from(outputs);
}
function getNodeRadius(stateName, config) {
  const baseRadius = config.nodeRadius;
  const textLength = stateName.length;
  if (textLength > 12) return baseRadius + 25;
  if (textLength > 8) return baseRadius + 15;
  if (textLength > 6) return baseRadius + 8;
  return baseRadius;
}
function calculateLayout(states, transitions, options, config) {
  const positions = {};
  const entityBoxWidth = options.hasEntity ? 200 : 0;
  const outputBoxWidth = options.hasOutputs ? 200 : 0;
  const leftOffset = 100 + entityBoxWidth;
  const initialState = states.find((s) => s.isInitial) || states[0];
  states.filter((s) => s.isFinal);
  states.filter((s) => !s.isInitial && !s.isFinal);
  let maxLabelLength = 0;
  transitions.forEach((t) => {
    if (t.effects && t.effects.length > 0) {
      const summary = getEffectSummary(t.effects);
      maxLabelLength = Math.max(maxLabelLength, summary.length);
    }
    if (t.guard) {
      const guardStr = formatGuard(t.guard);
      maxLabelLength = Math.max(maxLabelLength, guardStr.length);
    }
    if (t.event) {
      maxLabelLength = Math.max(maxLabelLength, t.event.length);
    }
  });
  const labelWidth = Math.min(maxLabelLength * 10, 350);
  const dynamicSpacing = Math.min(Math.max(config.nodeSpacing, labelWidth + 100), 400);
  const stateColumn = {};
  if (initialState) {
    const queue = [{ name: initialState.name, col: 0 }];
    const visited = /* @__PURE__ */ new Set();
    while (queue.length > 0) {
      const { name, col } = queue.shift();
      if (visited.has(name)) continue;
      visited.add(name);
      if (stateColumn[name] === void 0) {
        stateColumn[name] = col;
      }
      transitions.forEach((t) => {
        if (t.from === name && t.from !== t.to && !visited.has(t.to)) {
          queue.push({ name: t.to, col: col + 1 });
        }
      });
    }
  }
  states.forEach((s) => {
    if (stateColumn[s.name] === void 0) {
      stateColumn[s.name] = 0;
    }
  });
  const columns = {};
  Object.entries(stateColumn).forEach(([name, col]) => {
    if (!columns[col]) columns[col] = [];
    columns[col].push(name);
  });
  Object.values(columns).forEach((stateNames) => {
    stateNames.sort((a, b) => {
      const stateA = states.find((s) => s.name === a);
      const stateB = states.find((s) => s.name === b);
      if (stateA?.isInitial) return -1;
      if (stateB?.isInitial) return 1;
      if (stateA?.isFinal && !stateB?.isFinal) return 1;
      if (stateB?.isFinal && !stateA?.isFinal) return -1;
      return a.localeCompare(b);
    });
  });
  const numColumns = Math.max(...Object.keys(columns).map(Number)) + 1;
  const maxRowsInColumn = Math.max(...Object.values(columns).map((arr) => arr.length));
  const minVerticalSpacing = 420;
  const tooltipPadding = 150;
  const width = Math.max(1400, numColumns * dynamicSpacing + entityBoxWidth + outputBoxWidth + 400);
  const height = Math.max(1e3, maxRowsInColumn * minVerticalSpacing + 350 + tooltipPadding);
  Object.entries(columns).forEach(([colStr, stateNames]) => {
    const col = parseInt(colStr);
    const x = leftOffset + col * dynamicSpacing;
    const numInColumn = stateNames.length;
    const verticalSpacing = Math.max(minVerticalSpacing, height / (numInColumn + 1));
    stateNames.forEach((stateName, rowIndex) => {
      const state = states.find((s) => s.name === stateName);
      if (state) {
        const y = verticalSpacing * (rowIndex + 1);
        positions[stateName] = { x, y, state };
      }
    });
  });
  return { positions, width, height: height + 60 };
}
function calculateTransitionPathData(from, to, transitions, positions, config) {
  const fromPos = positions[from];
  const toPos = positions[to];
  if (!fromPos || !toPos) return null;
  const relevantTransitions = transitions.filter((t) => t.from === from && t.to === to);
  if (relevantTransitions.length === 0) return null;
  const fromRadius = getNodeRadius(from, config);
  const toRadius = getNodeRadius(to, config);
  if (from === to) {
    const loopRadius = 50;
    const cx = fromPos.x;
    const cy = fromPos.y - fromRadius - loopRadius;
    const startAngle = -0.5;
    const endAngle = 0.5;
    const startX2 = fromPos.x + Math.cos(-Math.PI / 2 + startAngle) * fromRadius;
    const startY2 = fromPos.y + Math.sin(-Math.PI / 2 + startAngle) * fromRadius;
    const endX2 = fromPos.x + Math.cos(-Math.PI / 2 + endAngle) * fromRadius;
    const endY2 = fromPos.y + Math.sin(-Math.PI / 2 + endAngle) * fromRadius;
    const pathData = `M ${startX2} ${startY2} A ${loopRadius} ${loopRadius} 0 1 1 ${endX2} ${endY2}`;
    return {
      pathData,
      labelX: cx,
      labelY: cy - loopRadius * 0.5
    };
  }
  const dx = toPos.x - fromPos.x;
  const dy = toPos.y - fromPos.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist === 0) return null;
  const nx = dx / dist;
  const ny = dy / dist;
  const startX = fromPos.x + nx * fromRadius;
  const startY = fromPos.y + ny * fromRadius;
  const endX = toPos.x - nx * (toRadius + 5);
  const endY = toPos.y - ny * (toRadius + 5);
  const hasReverse = transitions.some((t) => t.from === to && t.to === from);
  const isReverse = hasReverse && from > to;
  const baseOffset = hasReverse ? 50 : 30;
  const curveOffset = baseOffset + (relevantTransitions.length > 1 ? 20 : 0);
  const curveDirection = isReverse ? 1 : -1;
  const midX = (startX + endX) / 2;
  const midY = (startY + endY) / 2 + curveOffset * curveDirection;
  return {
    pathData: `M ${startX} ${startY} Q ${midX} ${midY} ${endX} ${endY}`,
    labelX: midX,
    labelY: midY + curveDirection * 5
  };
}
function renderStateMachineToDomData(stateMachine, options = {}, config = DEFAULT_CONFIG) {
  const states = stateMachine.states || [];
  const transitions = stateMachine.transitions || [];
  const title = options.title || "";
  const entity = options.entity;
  const outputs = extractOutputsFromTransitions(transitions);
  const layoutOptions = {
    hasEntity: !!entity,
    hasOutputs: outputs.length > 0
  };
  const { positions, width, height } = calculateLayout(states, transitions, layoutOptions, config);
  const domStates = Object.entries(positions).map(([name, pos]) => ({
    id: `state-${name}`,
    name,
    x: pos.x,
    y: pos.y,
    radius: getNodeRadius(name, config),
    isInitial: pos.state.isInitial ?? false,
    isFinal: pos.state.isFinal ?? false,
    description: pos.state.description
  }));
  const domPaths = [];
  const domLabels = [];
  const drawnPairs = /* @__PURE__ */ new Set();
  transitions.forEach((transition, idx) => {
    const pairKey = `${transition.from}->${transition.to}`;
    if (!drawnPairs.has(pairKey)) {
      drawnPairs.add(pairKey);
      const pathData2 = calculateTransitionPathData(
        transition.from,
        transition.to,
        transitions,
        positions,
        config
      );
      if (pathData2) {
        domPaths.push({
          id: `path-${transition.from}-${transition.to}`,
          from: transition.from,
          to: transition.to,
          pathData: pathData2.pathData,
          labelX: pathData2.labelX,
          labelY: pathData2.labelY
        });
      }
    }
    const guardText = transition.guard ? formatGuardHuman(transition.guard) : void 0;
    const effectTexts = transition.effects ? formatEffectsHuman(transition.effects) : [];
    const hasDetails = !!guardText || effectTexts.length > 0;
    const pathData = calculateTransitionPathData(
      transition.from,
      transition.to,
      transitions,
      positions,
      config
    );
    if (pathData) {
      const sameEventIndex = domLabels.filter(
        (l) => l.from === transition.from && l.to === transition.to
      ).length;
      const labelOffset = sameEventIndex * 60;
      domLabels.push({
        id: `label-${transition.from}-${transition.to}-${idx}`,
        from: transition.from,
        to: transition.to,
        event: transition.event,
        x: pathData.labelX,
        y: pathData.labelY + labelOffset,
        guardText,
        effectTexts,
        hasDetails
      });
    }
  });
  let domEntity;
  if (entity) {
    const fieldCount = entity.fields ? entity.fields.length : 0;
    const boxWidth = 160;
    const boxHeight = Math.max(80, fieldCount * 22 + 50);
    domEntity = {
      name: entity.name || "Entity",
      fields: entity.fields?.map((f3) => typeof f3 === "string" ? f3 : f3.name) || [],
      x: 20,
      y: height / 2 - boxHeight / 2,
      width: boxWidth,
      height: boxHeight
    };
  }
  let domOutputs;
  if (outputs.length > 0) {
    const maxX = Math.max(...Object.values(positions).map((p) => p.x));
    const maxOutputLength = Math.max(...outputs.map((o) => o.length));
    const boxWidth = Math.max(200, maxOutputLength * 7 + 30);
    const lineHeight = 22;
    const boxHeight = outputs.length * lineHeight + 50;
    domOutputs = {
      outputs,
      x: maxX + config.nodeRadius + 300,
      y: height / 2 - boxHeight / 2,
      width: boxWidth,
      height: boxHeight
    };
  }
  return {
    width,
    height: height + 40,
    title: title || void 0,
    states: domStates,
    paths: domPaths,
    labels: domLabels,
    entity: domEntity,
    outputs: domOutputs,
    config
  };
}
var DEFAULT_CONFIG;
var init_visualizer = __esm({
  "lib/visualizer/index.ts"() {
    DEFAULT_CONFIG = {
      nodeRadius: 70,
      nodeSpacing: 650,
      // Increased to give more room for transitions
      initialIndicatorOffset: 45,
      arrowSize: 12,
      colors: {
        background: "#0d1117",
        node: "#161b22",
        nodeBorder: "#30363d",
        nodeText: "#e6edf3",
        initialNode: "#238636",
        finalNode: "#f85149",
        arrow: "#8b949e",
        arrowText: "#8b949e",
        effectText: "#ffb86c",
        guardText: "#ff79c6",
        initial: "#238636"
      },
      fonts: {
        node: '18px "Inter", sans-serif',
        event: '16px "JetBrains Mono", monospace',
        effect: '14px "JetBrains Mono", monospace'
      }
    };
  }
});

// lib/jazari/svg-paths.ts
function gearTeethPath(cx, cy, innerRadius, outerRadius, numTeeth) {
  const parts = [];
  const angleStep = Math.PI * 2 / numTeeth;
  const halfTooth = angleStep * 0.25;
  for (let i = 0; i < numTeeth; i++) {
    const baseAngle = i * angleStep;
    const x0 = cx + innerRadius * Math.cos(baseAngle - halfTooth);
    const y0 = cy + innerRadius * Math.sin(baseAngle - halfTooth);
    const x1 = cx + outerRadius * Math.cos(baseAngle - halfTooth * 0.4);
    const y1 = cy + outerRadius * Math.sin(baseAngle - halfTooth * 0.4);
    const x2 = cx + outerRadius * Math.cos(baseAngle + halfTooth * 0.4);
    const y2 = cy + outerRadius * Math.sin(baseAngle + halfTooth * 0.4);
    const x3 = cx + innerRadius * Math.cos(baseAngle + halfTooth);
    const y3 = cy + innerRadius * Math.sin(baseAngle + halfTooth);
    if (i === 0) {
      parts.push(`M ${x0.toFixed(1)} ${y0.toFixed(1)}`);
    } else {
      parts.push(`L ${x0.toFixed(1)} ${y0.toFixed(1)}`);
    }
    parts.push(`L ${x1.toFixed(1)} ${y1.toFixed(1)}`);
    parts.push(`L ${x2.toFixed(1)} ${y2.toFixed(1)}`);
    parts.push(`L ${x3.toFixed(1)} ${y3.toFixed(1)}`);
  }
  parts.push("Z");
  return parts.join(" ");
}
var init_svg_paths = __esm({
  "lib/jazari/svg-paths.ts"() {
  }
});
function extractTrait(schema, trait, traitIndex) {
  if (trait) return trait;
  if (!schema?.orbitals?.length) return null;
  for (const orbital of schema.orbitals) {
    const traits2 = orbital.traits ?? [];
    if (traitIndex < traits2.length) {
      const traitRef = traits2[traitIndex];
      if (isInlineTrait(traitRef)) return traitRef;
      return null;
    }
  }
  return null;
}
function extractEntityFields(schema) {
  if (!schema?.orbitals?.length) return [];
  const entity = schema.orbitals[0].entity;
  if (!entity || typeof entity !== "object" || !("fields" in entity)) return [];
  const inlineEntity = entity;
  if (!inlineEntity.fields) return [];
  return inlineEntity.fields.map((f3) => f3.name).filter((n) => typeof n === "string" && n.length > 0);
}
function toStateMachineDefinition(sm) {
  return {
    states: sm.states.map((s) => ({
      name: s.name,
      isInitial: s.isInitial,
      isFinal: s.isTerminal ?? s.isFinal
    })),
    transitions: sm.transitions.map((t) => ({
      from: t.from,
      to: t.to,
      event: t.event,
      guard: t.guard,
      effects: t.effects
    }))
  };
}
function renderJazariGearNode(state, config) {
  const outerR = state.radius * 0.5 + GEAR_TEETH_DEPTH;
  const innerR = state.radius * 0.5 - 2;
  const coreR = state.radius * 0.5 * GEAR_INNER_RADIUS;
  const fillColor = state.isInitial ? config.colors.initialNode : config.colors.nodeBorder;
  const teethD = gearTeethPath(state.radius, state.radius, innerR, outerR, GEAR_NUM_TEETH);
  const label = state.name.length > 10 ? `${state.name.slice(0, 9)}\u2026` : state.name;
  const fontSize = state.name.length > 7 ? 11 : 14;
  const size = state.radius * 2;
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: "absolute",
      style: {
        left: state.x - state.radius,
        top: state.y - state.radius,
        width: size,
        height: size,
        zIndex: 5
      },
      action: "STATE_CLICK",
      actionPayload: { stateName: state.name },
      children: /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, children: [
        state.isInitial && /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("filter", { id: `jazari-glow-${state.name}`, children: [
          /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "3", result: "blur" }),
          /* @__PURE__ */ jsxs("feMerge", { children: [
            /* @__PURE__ */ jsx("feMergeNode", { in: "blur" }),
            /* @__PURE__ */ jsx("feMergeNode", { in: "SourceGraphic" })
          ] })
        ] }) }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: teethD,
            fill: fillColor,
            fillOpacity: 0.2,
            stroke: fillColor,
            strokeWidth: 1.5,
            strokeDasharray: state.isFinal ? "4 3" : void 0,
            filter: state.isInitial ? `url(#jazari-glow-${state.name})` : void 0
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: state.radius,
            cy: state.radius,
            r: coreR,
            fill: fillColor,
            fillOpacity: 0.15,
            stroke: fillColor,
            strokeWidth: 1,
            strokeDasharray: state.isFinal ? "4 3" : void 0
          }
        ),
        /* @__PURE__ */ jsx(
          "text",
          {
            x: state.radius,
            y: state.radius,
            textAnchor: "middle",
            dominantBaseline: "central",
            fill: config.colors.nodeText,
            fontSize,
            fontWeight: 600,
            fontFamily: "'Noto Naskh Arabic', serif",
            children: label
          }
        )
      ] })
    }
  );
}
var JAZARI_VISUALIZER_CONFIG, GEAR_INNER_RADIUS, GEAR_NUM_TEETH, GEAR_TEETH_DEPTH, JazariStateMachine;
var init_JazariStateMachine = __esm({
  "components/core/molecules/JazariStateMachine.tsx"() {
    "use client";
    init_Box();
    init_Typography();
    init_LoadingState();
    init_ErrorState();
    init_StateMachineView();
    init_visualizer();
    init_svg_paths();
    init_cn();
    JAZARI_VISUALIZER_CONFIG = {
      ...DEFAULT_CONFIG,
      colors: {
        background: "var(--color-card)",
        node: "var(--color-card)",
        nodeBorder: "var(--color-border)",
        nodeText: "var(--color-foreground)",
        initialNode: "var(--color-success)",
        finalNode: "var(--color-error)",
        arrow: "var(--color-muted-foreground)",
        arrowText: "var(--color-foreground)",
        effectText: "var(--color-warning)",
        guardText: "var(--color-error)",
        initial: "var(--color-success)"
      },
      fonts: {
        node: "18px 'Noto Naskh Arabic', serif",
        event: "13px 'JetBrains Mono', monospace",
        effect: "12px 'JetBrains Mono', monospace"
      }
    };
    GEAR_INNER_RADIUS = 0.6;
    GEAR_NUM_TEETH = 12;
    GEAR_TEETH_DEPTH = 7;
    JazariStateMachine = ({
      schema,
      trait: traitProp,
      traitIndex = 0,
      entityFields: entityFieldsProp,
      direction = "ltr",
      className,
      isLoading = false,
      error = null
    }) => {
      const { t } = useTranslate();
      const resolvedTrait = useMemo(
        () => extractTrait(schema, traitProp, traitIndex),
        [schema, traitProp, traitIndex]
      );
      const entityFields = useMemo(
        () => entityFieldsProp ?? extractEntityFields(schema),
        [entityFieldsProp, schema]
      );
      const layoutData = useMemo(() => {
        if (!resolvedTrait?.stateMachine) return null;
        const sm = toStateMachineDefinition(resolvedTrait.stateMachine);
        const entityDef = entityFields.length > 0 ? { name: "entity", fields: entityFields } : void 0;
        return renderStateMachineToDomData(
          sm,
          { title: resolvedTrait.name, entity: entityDef },
          JAZARI_VISUALIZER_CONFIG
        );
      }, [resolvedTrait, entityFields]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("stateMachine.loading") });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error instanceof Error ? error.message : String(error) });
      }
      if (!resolvedTrait || !layoutData || layoutData.states.length === 0) {
        return /* @__PURE__ */ jsx(Box, { padding: "lg", className: cn("text-center", className), children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "opacity-60", children: t("stateMachine.noStateMachine") }) });
      }
      return /* @__PURE__ */ jsx(
        StateMachineView,
        {
          layoutData,
          renderStateNode: renderJazariGearNode,
          className: cn("jazari-state-machine", className)
        }
      );
    };
    JazariStateMachine.displayName = "JazariStateMachine";
  }
});

// lib/parseContentSegments.ts
function tryParseOrbitalSchema(code) {
  try {
    const parsed = JSON.parse(code);
    if (typeof parsed !== "object" || parsed === null) return null;
    if ("states" in parsed && "transitions" in parsed || Array.isArray(parsed.orbitals)) {
      return parsed;
    }
  } catch {
  }
  return null;
}
function parseMarkdownWithCodeBlocks2(content) {
  if (!content) return [];
  const segments = [];
  const codeBlockRegex = /```(\w+)?\n([\s\S]*?)```/g;
  let lastIndex = 0;
  let match;
  while ((match = codeBlockRegex.exec(content)) !== null) {
    const before = content.slice(lastIndex, match.index);
    if (before.trim()) {
      segments.push({ type: "markdown", content: before });
    }
    const language = match[1] || "text";
    const code = match[2].trim();
    if (language === "json" || language === "orb") {
      const schema = tryParseOrbitalSchema(code);
      if (schema) {
        segments.push({ type: "orbital", language, content: code, schema });
        lastIndex = codeBlockRegex.lastIndex;
        continue;
      }
    }
    segments.push({ type: "code", language, content: code });
    lastIndex = codeBlockRegex.lastIndex;
  }
  const remaining = content.slice(lastIndex);
  if (remaining.trim()) {
    segments.push({ type: "markdown", content: remaining });
  }
  return segments;
}
function parseContentSegments(content) {
  if (!content) return [];
  const segments = [];
  const tagRegex = /<question>([\s\S]*?)<\/question>\s*<answer>([\s\S]*?)<\/answer>/gi;
  let lastIndex = 0;
  let match;
  while ((match = tagRegex.exec(content)) !== null) {
    const before = content.slice(lastIndex, match.index);
    if (before.trim()) {
      segments.push(...parseMarkdownWithCodeBlocks2(before));
    }
    segments.push({
      type: "quiz",
      question: match[1].trim(),
      answer: match[2].trim()
    });
    lastIndex = tagRegex.lastIndex;
  }
  const remaining = content.slice(lastIndex);
  if (remaining.trim()) {
    segments.push(...parseMarkdownWithCodeBlocks2(remaining));
  }
  return segments;
}
var init_parseContentSegments = __esm({
  "lib/parseContentSegments.ts"() {
  }
});
var ContentRenderer;
var init_ContentRenderer = __esm({
  "components/core/molecules/ContentRenderer.tsx"() {
    init_Stack();
    init_MarkdownContent();
    init_CodeBlock();
    init_QuizBlock();
    init_ScaledDiagram();
    init_JazariStateMachine();
    init_parseContentSegments();
    init_cn();
    ContentRenderer = ({
      content,
      segments: segmentsProp,
      direction,
      className
    }) => {
      const { t: _t } = useTranslate();
      const segments = useMemo(
        () => segmentsProp ?? parseContentSegments(content),
        [segmentsProp, content]
      );
      if (segments.length === 0) return null;
      return /* @__PURE__ */ jsx(VStack, { gap: "md", className: cn("w-full", className), children: segments.map((segment, i) => {
        const key = `seg-${i}`;
        switch (segment.type) {
          case "markdown":
            return /* @__PURE__ */ jsx(
              MarkdownContent,
              {
                content: segment.content,
                direction
              },
              key
            );
          case "code":
            return /* @__PURE__ */ jsx(
              CodeBlock,
              {
                code: segment.content,
                language: toCodeLanguage(segment.language)
              },
              key
            );
          case "orbital": {
            const parsed = segment.schema;
            const isFullSchema = (v) => Array.isArray(v.orbitals);
            const inlineTrait = {
              name: "inline",
              scope: "instance",
              stateMachine: parsed
            };
            const schema = isFullSchema(parsed) ? parsed : {
              name: "inline",
              orbitals: [{
                name: "inline",
                entity: { name: "inline", fields: [] },
                traits: [inlineTrait],
                pages: []
              }]
            };
            return /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
              /* @__PURE__ */ jsx(
                CodeBlock,
                {
                  code: segment.content,
                  language: toCodeLanguage(segment.language)
                }
              ),
              /* @__PURE__ */ jsx(ScaledDiagram, { children: /* @__PURE__ */ jsx(
                JazariStateMachine,
                {
                  schema,
                  direction
                }
              ) })
            ] }, key);
          }
          case "quiz":
            return /* @__PURE__ */ jsx(
              QuizBlock,
              {
                question: segment.question,
                answer: segment.answer
              },
              key
            );
          default:
            return null;
        }
      }) });
    };
    ContentRenderer.displayName = "ContentRenderer";
  }
});
var BookChapterView;
var init_BookChapterView = __esm({
  "components/marketing/organisms/book/BookChapterView.tsx"() {
    init_Stack();
    init_Typography();
    init_Divider();
    init_ScaledDiagram();
    init_ContentRenderer();
    init_JazariStateMachine();
    init_cn();
    BookChapterView = ({
      chapter,
      orbitalSchema,
      direction,
      className
    }) => {
      const { t: _t } = useTranslate();
      const title = String(chapter.title ?? "");
      const content = String(chapter.content ?? "");
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "lg",
          className: cn("px-6 py-8 max-w-4xl mx-auto w-full", className),
          style: { direction },
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h1", className: "text-3xl font-bold", children: title }),
            /* @__PURE__ */ jsx(Divider, {}),
            !!orbitalSchema && /* @__PURE__ */ jsx(ScaledDiagram, { children: /* @__PURE__ */ jsx(
              JazariStateMachine,
              {
                schema: orbitalSchema,
                direction
              }
            ) }),
            /* @__PURE__ */ jsx(ContentRenderer, { content, direction })
          ]
        }
      );
    };
    BookChapterView.displayName = "BookChapterView";
  }
});
var BookCoverPage;
var init_BookCoverPage = __esm({
  "components/marketing/organisms/book/BookCoverPage.tsx"() {
    init_Stack();
    init_Typography();
    init_Button();
    init_Box();
    init_cn();
    BookCoverPage = ({
      title,
      subtitle,
      author,
      coverImageUrl,
      direction,
      className
    }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "lg",
          align: "center",
          justify: "center",
          className: cn(
            "min-h-[80vh] p-8 text-center",
            className
          ),
          style: { direction },
          children: [
            coverImageUrl && /* @__PURE__ */ jsx(
              Box,
              {
                className: "w-64 h-80 rounded-lg overflow-hidden shadow-xl",
                style: {
                  backgroundImage: `url(${coverImageUrl})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                },
                "aria-label": title,
                role: "img"
              }
            ),
            /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "max-w-lg", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h1", className: "text-4xl font-bold", children: title }),
              subtitle && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "h2",
                  className: "text-xl text-muted-foreground",
                  children: subtitle
                }
              ),
              author && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body",
                  className: "text-muted-foreground mt-4",
                  children: author
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "primary",
                size: "lg",
                action: "BOOK_START",
                className: "mt-8",
                children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "inherit", children: t("book.startReading") })
              }
            )
          ]
        }
      );
    };
    BookCoverPage.displayName = "BookCoverPage";
  }
});
var BookNavBar;
var init_BookNavBar = __esm({
  "components/marketing/organisms/book/BookNavBar.tsx"() {
    init_Stack();
    init_Button();
    init_Typography();
    init_ProgressBar();
    init_Box();
    init_cn();
    BookNavBar = ({
      currentPage,
      totalPages,
      chapterTitle: chapterTitle2,
      direction,
      className
    }) => {
      const { t } = useTranslate();
      const isRtl = direction === "rtl";
      const progress = totalPages > 1 ? currentPage / (totalPages - 1) * 100 : 0;
      const PrevIcon = isRtl ? ChevronRight : ChevronLeft;
      const NextIcon = isRtl ? ChevronLeft : ChevronRight;
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "sticky bottom-0 bg-background border-t border-border print:hidden z-10",
            className
          ),
          style: { direction },
          children: /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", className: "px-4 py-2", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  action: "BOOK_SHOW_TOC",
                  "aria-label": t("book.tableOfContents"),
                  children: /* @__PURE__ */ jsx(List, { size: 18 })
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  action: "BOOK_PRINT",
                  "aria-label": t("book.print"),
                  children: /* @__PURE__ */ jsx(Printer, { size: 18 })
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(Box, { className: "flex-1 mx-4 max-w-md", children: [
              chapterTitle2 && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: "text-center block truncate text-muted-foreground",
                  children: chapterTitle2
                }
              ),
              /* @__PURE__ */ jsx(ProgressBar, { value: progress, size: "sm", variant: "primary" })
            ] }),
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  action: "BOOK_PAGE_PREV",
                  actionPayload: { pageIndex: currentPage },
                  disabled: currentPage <= 0,
                  "aria-label": t("book.previousPage"),
                  children: /* @__PURE__ */ jsx(PrevIcon, { size: 18 })
                }
              ),
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "min-w-[3rem] text-center", children: [
                currentPage + 1,
                " / ",
                totalPages
              ] }),
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  action: "BOOK_PAGE_NEXT",
                  actionPayload: { pageIndex: currentPage },
                  disabled: currentPage >= totalPages - 1,
                  "aria-label": t("book.nextPage"),
                  children: /* @__PURE__ */ jsx(NextIcon, { size: 18 })
                }
              )
            ] })
          ] })
        }
      );
    };
    BookNavBar.displayName = "BookNavBar";
  }
});
var BookTableOfContents;
var init_BookTableOfContents = __esm({
  "components/marketing/organisms/book/BookTableOfContents.tsx"() {
    init_Stack();
    init_Typography();
    init_Button();
    init_Box();
    init_Badge();
    init_cn();
    BookTableOfContents = ({
      parts,
      currentChapterId,
      direction,
      className
    }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsxs(
        VStack,
        {
          gap: "lg",
          className: cn("p-8 max-w-2xl mx-auto", className),
          style: { direction },
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h1", className: "text-3xl font-bold text-center mb-4", children: t("book.tableOfContents") }),
            (Array.isArray(parts) ? parts : []).map((part, partIdx) => {
              const chapters = Array.isArray(part.chapters) ? part.chapters : [];
              return /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
                /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
                  /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: t("book.partNumber", { number: String(partIdx + 1) }) }),
                  /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "font-semibold", children: String(part.title ?? "") })
                ] }),
                /* @__PURE__ */ jsx(VStack, { gap: "xs", className: direction === "rtl" ? "pr-6" : "pl-6", children: chapters.map((chapter) => {
                  const id = chapter.id == null ? "" : String(chapter.id);
                  const isCurrent = id === currentChapterId;
                  return /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      size: "sm",
                      action: "BOOK_NAVIGATE",
                      actionPayload: { chapterId: id },
                      className: cn(
                        "justify-start text-left w-full",
                        direction === "rtl" && "text-right",
                        isCurrent && "bg-primary/10 text-primary"
                      ),
                      children: /* @__PURE__ */ jsx(Box, { className: "truncate", children: /* @__PURE__ */ jsx(Typography, { variant: "body", children: String(chapter.title ?? "") }) })
                    },
                    id
                  );
                }) })
              ] }, partIdx);
            })
          ]
        }
      );
    };
    BookTableOfContents.displayName = "BookTableOfContents";
  }
});

// components/core/organisms/book/types.ts
function resolveFieldMap(fieldMap) {
  if (!fieldMap) return IDENTITY_BOOK_FIELDS;
  if (typeof fieldMap === "string") return FIELD_MAP_REGISTRY[fieldMap] ?? IDENTITY_BOOK_FIELDS;
  return fieldMap;
}
function get(obj, key) {
  return obj[key];
}
function asStr(v) {
  return v == null ? "" : String(v);
}
function mapBookData(raw, fields = IDENTITY_BOOK_FIELDS) {
  const rawParts = get(raw, fields.parts) ?? [];
  const direction = get(raw, fields.direction) ?? "ltr";
  const cover = {
    title: asStr(get(raw, fields.title)),
    subtitle: asStr(get(raw, fields.subtitle)),
    author: asStr(get(raw, fields.author)),
    coverImageUrl: asStr(get(raw, fields.coverImageUrl)),
    direction
  };
  const schemaByChapterId = {};
  const chapters = [];
  const parts = rawParts.map((part) => {
    const rawChapters = get(part, fields.chapters) ?? [];
    const chapterRows = rawChapters.map((ch) => {
      const id = asStr(get(ch, fields.chapterId));
      const schema = get(ch, fields.chapterOrbitalSchema);
      if (schema) schemaByChapterId[id] = schema;
      const row = {
        id,
        title: asStr(get(ch, fields.chapterTitle)),
        content: asStr(get(ch, fields.chapterContent))
      };
      chapters.push(row);
      return row;
    });
    return {
      title: asStr(get(part, fields.partTitle)),
      chapters: chapterRows
    };
  });
  return { cover, direction, parts, chapters, schemaByChapterId };
}
var IDENTITY_BOOK_FIELDS, AR_BOOK_FIELDS, FIELD_MAP_REGISTRY;
var init_types = __esm({
  "components/core/organisms/book/types.ts"() {
    IDENTITY_BOOK_FIELDS = {
      title: "title",
      subtitle: "subtitle",
      author: "author",
      coverImageUrl: "coverImageUrl",
      direction: "direction",
      parts: "parts",
      partTitle: "title",
      chapters: "chapters",
      chapterId: "id",
      chapterTitle: "title",
      chapterContent: "content",
      chapterOrbitalSchema: "orbitalSchema"
    };
    AR_BOOK_FIELDS = {
      title: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      subtitle: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646_\u0627\u0644\u0641\u0631\u0639\u064A",
      author: "\u0627\u0644\u0645\u0624\u0644\u0641",
      coverImageUrl: "\u0635\u0648\u0631\u0629_\u0627\u0644\u063A\u0644\u0627\u0641",
      direction: "\u0627\u0644\u0627\u062A\u062C\u0627\u0647",
      parts: "\u0627\u0644\u0623\u062C\u0632\u0627\u0621",
      partTitle: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      chapters: "\u0627\u0644\u0641\u0635\u0648\u0644",
      chapterId: "\u0627\u0644\u0645\u0639\u0631\u0641",
      chapterTitle: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      chapterContent: "\u0627\u0644\u0645\u062D\u062A\u0648\u0649",
      chapterOrbitalSchema: "\u0627\u0644\u0645\u062E\u0637\u0637_\u0627\u0644\u0645\u062F\u0627\u0631\u064A"
    };
    FIELD_MAP_REGISTRY = {
      ar: AR_BOOK_FIELDS
    };
  }
});
var chapterId, chapterTitle, PRINT_STYLES, BookViewer;
var init_BookViewer = __esm({
  "components/marketing/organisms/book/BookViewer.tsx"() {
    init_Box();
    init_Stack();
    init_useEventBus();
    init_cn();
    init_BookCoverPage();
    init_BookTableOfContents();
    init_BookChapterView();
    init_BookNavBar();
    init_EmptyState();
    init_types();
    chapterId = (ch) => ch?.id == null ? void 0 : String(ch.id);
    chapterTitle = (ch) => ch?.title == null ? void 0 : String(ch.title);
    PRINT_STYLES = `
@media print {
  .book-viewer-page {
    overflow: visible !important;
    height: auto !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .book-viewer-page { transition: none !important; }
}
`;
    BookViewer = ({
      entity,
      initialPage = 0,
      fieldMap,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const [currentPage, setCurrentPage] = useState(initialPage);
      const resolvedFieldMap = useMemo(() => resolveFieldMap(fieldMap), [fieldMap]);
      const book = useMemo(() => {
        const entityArray = Array.isArray(entity) ? entity : entity ? [entity] : [];
        const raw = entityArray[0];
        if (!raw) return null;
        return mapBookData(raw, resolvedFieldMap);
      }, [entity, resolvedFieldMap]);
      const direction = book?.direction ?? "ltr";
      const chapters = useMemo(() => book ? book.chapters : [], [book]);
      const totalPages = 2 + chapters.length;
      const navigateTo = useCallback(
        (page) => {
          const clamped = Math.max(0, Math.min(page, totalPages - 1));
          setCurrentPage(clamped);
          const id = clamped >= 2 ? chapterId(chapters[clamped - 2]) : void 0;
          eventBus.emit("UI:BOOK_PAGE_CHANGE", { pageIndex: clamped, chapterId: id });
        },
        [totalPages, chapters, eventBus]
      );
      useEffect(() => {
        const unsubs = [
          eventBus.on("UI:BOOK_START", () => navigateTo(1)),
          eventBus.on("UI:BOOK_SHOW_TOC", () => navigateTo(1)),
          eventBus.on("UI:BOOK_PAGE_PREV", () => navigateTo(currentPage - 1)),
          eventBus.on("UI:BOOK_PAGE_NEXT", () => navigateTo(currentPage + 1)),
          eventBus.on("UI:BOOK_PRINT", () => window.print()),
          eventBus.on("UI:BOOK_NAVIGATE", (event) => {
            const targetId = event.payload?.chapterId;
            const idx = chapters.findIndex((ch) => chapterId(ch) === targetId);
            if (idx >= 0) navigateTo(idx + 2);
          })
        ];
        return () => unsubs.forEach((fn) => fn());
      }, [eventBus, currentPage, navigateTo, chapters]);
      useEffect(() => {
        const id = "book-viewer-print-styles";
        if (document.getElementById(id)) return;
        const style = document.createElement("style");
        style.id = id;
        style.textContent = PRINT_STYLES;
        document.head.appendChild(style);
        return () => {
          style.remove();
        };
      }, []);
      const currentChapterId = currentPage >= 2 ? chapterId(chapters[currentPage - 2]) : void 0;
      const currentChapterTitle = currentPage >= 2 ? chapterTitle(chapters[currentPage - 2]) : void 0;
      if (!book) return /* @__PURE__ */ jsx(EmptyState, { message: t("book.noData") });
      const cover = book.cover;
      const coverTitle = String(cover.title ?? "");
      return /* @__PURE__ */ jsxs(VStack, { className: cn("relative h-full overflow-hidden bg-background", className), children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            className: "flex-1 overflow-y-auto overflow-x-hidden book-viewer-page",
            style: { direction },
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "hidden print:block", children: [
                /* @__PURE__ */ jsx(
                  BookCoverPage,
                  {
                    title: coverTitle,
                    subtitle: String(cover.subtitle ?? "") || void 0,
                    author: String(cover.author ?? "") || void 0,
                    coverImageUrl: String(cover.coverImageUrl ?? "") || void 0,
                    direction
                  }
                ),
                /* @__PURE__ */ jsx(
                  BookTableOfContents,
                  {
                    parts: book.parts,
                    direction
                  }
                ),
                chapters.map((chapter) => {
                  const id = chapterId(chapter);
                  return /* @__PURE__ */ jsx(
                    BookChapterView,
                    {
                      chapter,
                      orbitalSchema: id ? book.schemaByChapterId[id] : void 0,
                      direction
                    },
                    id
                  );
                })
              ] }),
              /* @__PURE__ */ jsxs(Box, { className: "print:hidden", children: [
                currentPage === 0 && /* @__PURE__ */ jsx(
                  BookCoverPage,
                  {
                    title: coverTitle,
                    subtitle: String(cover.subtitle ?? "") || void 0,
                    author: String(cover.author ?? "") || void 0,
                    coverImageUrl: String(cover.coverImageUrl ?? "") || void 0,
                    direction
                  }
                ),
                currentPage === 1 && /* @__PURE__ */ jsx(
                  BookTableOfContents,
                  {
                    parts: book.parts,
                    currentChapterId,
                    direction
                  }
                ),
                currentPage >= 2 && chapters[currentPage - 2] && /* @__PURE__ */ jsx(
                  BookChapterView,
                  {
                    chapter: chapters[currentPage - 2],
                    orbitalSchema: currentChapterId ? book.schemaByChapterId[currentChapterId] : void 0,
                    direction
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          BookNavBar,
          {
            currentPage,
            totalPages,
            chapterTitle: currentPage === 0 ? coverTitle : currentPage === 1 ? t("book.tableOfContents") : currentChapterTitle,
            direction
          }
        )
      ] });
    };
    BookViewer.displayName = "BookViewer";
  }
});
function BoxPattern({
  p,
  m,
  radius,
  isLoading: _isLoading,
  error: _error,
  entity: _entity,
  ...boxProps
}) {
  return /* @__PURE__ */ jsx(
    Box,
    {
      padding: boxProps.padding ?? p,
      margin: boxProps.margin ?? m,
      rounded: boxProps.rounded ?? radius,
      ...boxProps
    }
  );
}
function SpacerPattern({ size = "flex" }) {
  if (size === "flex") {
    return /* @__PURE__ */ jsx(Spacer, {});
  }
  const sizeMap8 = {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem"
  };
  return /* @__PURE__ */ jsx(Box, { style: { width: sizeMap8[size], height: sizeMap8[size], flexShrink: 0 } });
}
function DividerPattern({
  orientation = "horizontal",
  variant = "solid",
  spacing = "md"
}) {
  const spacingMap = {
    xs: "my-1",
    sm: "my-2",
    md: "my-4",
    lg: "my-6"
  };
  const verticalSpacingMap = {
    xs: "mx-1",
    sm: "mx-2",
    md: "mx-4",
    lg: "mx-6"
  };
  return /* @__PURE__ */ jsx(
    Divider,
    {
      orientation,
      variant,
      className: orientation === "horizontal" ? spacingMap[spacing] : verticalSpacingMap[spacing]
    }
  );
}
var init_LayoutPatterns = __esm({
  "components/core/organisms/LayoutPatterns.tsx"() {
    init_Box();
    init_Spacer();
    init_Divider();
    BoxPattern.displayName = "BoxPattern";
    SpacerPattern.displayName = "SpacerPattern";
    DividerPattern.displayName = "DividerPattern";
  }
});
function generateRuleId() {
  return `rule-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
function questionsToOptions(questions, endOfSurveyLabel) {
  const opts = questions.map((q) => ({
    value: q.id,
    label: q.label
  }));
  if (endOfSurveyLabel !== null) {
    opts.push({ value: END_OF_SURVEY, label: endOfSurveyLabel });
  }
  return opts;
}
function isRuleBroken(rule, questions) {
  const sourceExists = questions.some((q) => q.id === rule.sourceQuestionId);
  const targetExists = rule.targetQuestionId === END_OF_SURVEY || questions.some((q) => q.id === rule.targetQuestionId);
  return !sourceExists || !targetExists;
}
var END_OF_SURVEY, RuleRow, NODE_WIDTH, NODE_HEIGHT, NODE_GAP_Y, PADDING, LogicGraph, BranchingLogicBuilder;
var init_BranchingLogicBuilder = __esm({
  "components/core/molecules/BranchingLogicBuilder.tsx"() {
    "use client";
    init_Select();
    init_Typography();
    init_Button();
    init_Input();
    init_Badge();
    init_Card();
    init_FilterPill();
    init_Box();
    init_useEventBus();
    init_cn();
    END_OF_SURVEY = "end-of-survey";
    RuleRow = ({
      rule,
      questions,
      readOnly,
      broken,
      onChange,
      onDelete
    }) => {
      const { t } = useTranslate();
      const operatorOptions = useMemo(
        () => [
          { value: "equals", label: t("branchingLogic.operatorEquals") },
          { value: "not-equals", label: t("branchingLogic.operatorNotEquals") },
          { value: "contains", label: t("branchingLogic.operatorContains") },
          { value: "in", label: t("branchingLogic.operatorIn") }
        ],
        [t]
      );
      const sourceOptions = useMemo(() => questionsToOptions(questions, null), [questions]);
      const targetOptions = useMemo(
        () => questionsToOptions(questions, t("branchingLogic.endOfSurvey")),
        [questions, t]
      );
      const sourceQuestion = questions.find((q) => q.id === rule.sourceQuestionId);
      const valueOptions = useMemo(() => {
        if (!sourceQuestion?.optionValues) return [];
        return sourceQuestion.optionValues.map((v) => ({ value: v, label: v }));
      }, [sourceQuestion]);
      const handleSource = (v) => {
        onChange({ ...rule, sourceQuestionId: v });
      };
      const handleOperator = (v) => {
        const next = v;
        const nextValue = next === "in" && !Array.isArray(rule.value) ? rule.value ? [rule.value] : [] : next !== "in" && Array.isArray(rule.value) ? rule.value[0] ?? "" : rule.value;
        onChange({ ...rule, operator: next, value: nextValue });
      };
      const handleScalarValue = (e) => {
        onChange({ ...rule, value: e.target.value });
      };
      const handleAddChip = (v) => {
        const val = v;
        if (!val) return;
        const current = Array.isArray(rule.value) ? rule.value : [];
        if (current.includes(val)) return;
        onChange({ ...rule, value: [...current, val] });
      };
      const handleRemoveChip = (chip) => {
        const current = Array.isArray(rule.value) ? rule.value : [];
        onChange({ ...rule, value: current.filter((c) => c !== chip) });
      };
      const handleTarget = (v) => {
        onChange({ ...rule, targetQuestionId: v });
      };
      const isMulti = rule.operator === "in";
      const chips = Array.isArray(rule.value) ? rule.value : [];
      const scalarValue = Array.isArray(rule.value) ? "" : rule.value;
      return /* @__PURE__ */ jsxs(
        Card,
        {
          variant: "bordered",
          padding: "sm",
          className: cn(
            "flex flex-col gap-2",
            broken && "border-error"
          ),
          children: [
            /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-center gap-2", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "semibold", className: "shrink-0", children: t("branchingLogic.if") }),
              /* @__PURE__ */ jsx(Box, { className: "min-w-[10rem] grow basis-40", children: /* @__PURE__ */ jsx(
                Select,
                {
                  options: sourceOptions,
                  value: rule.sourceQuestionId,
                  placeholder: t("branchingLogic.selectQuestion"),
                  onValueChange: handleSource,
                  disabled: readOnly,
                  error: broken ? t("branchingLogic.brokenReference") : void 0
                }
              ) }),
              /* @__PURE__ */ jsx(Box, { className: "min-w-[8rem] basis-32", children: /* @__PURE__ */ jsx(
                Select,
                {
                  options: operatorOptions,
                  value: rule.operator,
                  onValueChange: handleOperator,
                  disabled: readOnly
                }
              ) }),
              isMulti ? /* @__PURE__ */ jsxs(Box, { className: "flex min-w-[10rem] grow basis-40 flex-wrap items-center gap-1", children: [
                chips.map((chip) => /* @__PURE__ */ jsx(
                  FilterPill,
                  {
                    variant: "primary",
                    size: "sm",
                    label: chip,
                    removable: !readOnly,
                    onRemove: readOnly ? void 0 : () => handleRemoveChip(chip)
                  },
                  chip
                )),
                valueOptions.length > 0 ? /* @__PURE__ */ jsx(Box, { className: "min-w-[8rem]", children: /* @__PURE__ */ jsx(
                  Select,
                  {
                    options: valueOptions.filter((o) => !chips.includes(o.value)),
                    value: "",
                    placeholder: t("branchingLogic.addValue"),
                    onValueChange: handleAddChip,
                    disabled: readOnly
                  }
                ) }) : /* @__PURE__ */ jsx(
                  Input,
                  {
                    inputType: "text",
                    placeholder: t("branchingLogic.typeValuePressEnter"),
                    value: "",
                    onKeyDown: (e) => {
                      if (e.key !== "Enter") return;
                      const target = e.target;
                      const v = target.value.trim();
                      if (!v || chips.includes(v)) return;
                      onChange({ ...rule, value: [...chips, v] });
                      target.value = "";
                    },
                    disabled: readOnly
                  }
                )
              ] }) : /* @__PURE__ */ jsx(Box, { className: "min-w-[8rem] grow basis-32", children: valueOptions.length > 0 ? /* @__PURE__ */ jsx(
                Select,
                {
                  options: valueOptions,
                  value: scalarValue,
                  placeholder: t("branchingLogic.selectValue"),
                  onValueChange: (v) => onChange({ ...rule, value: v }),
                  disabled: readOnly
                }
              ) : /* @__PURE__ */ jsx(
                Input,
                {
                  inputType: "text",
                  placeholder: t("branchingLogic.value"),
                  value: scalarValue,
                  onChange: handleScalarValue,
                  disabled: readOnly
                }
              ) }),
              /* @__PURE__ */ jsxs(Typography, { variant: "label", weight: "semibold", className: "shrink-0 inline-flex items-center gap-1", children: [
                /* @__PURE__ */ jsx(ArrowRight, { className: "h-4 w-4" }),
                t("branchingLogic.goTo")
              ] }),
              /* @__PURE__ */ jsx(Box, { className: "min-w-[10rem] grow basis-40", children: /* @__PURE__ */ jsx(
                Select,
                {
                  options: targetOptions,
                  value: rule.targetQuestionId,
                  placeholder: t("branchingLogic.selectTarget"),
                  onValueChange: handleTarget,
                  disabled: readOnly,
                  error: broken && rule.targetQuestionId !== END_OF_SURVEY ? t("branchingLogic.brokenReference") : void 0
                }
              ) }),
              !readOnly && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  leftIcon: Trash,
                  action: "DELETE_RULE",
                  actionPayload: { ruleId: rule.id },
                  onClick: onDelete,
                  "aria-label": t("branchingLogic.deleteRule")
                }
              )
            ] }),
            broken && /* @__PURE__ */ jsx(Badge, { variant: "error", size: "sm", label: t("branchingLogic.brokenReference") })
          ]
        }
      );
    };
    NODE_WIDTH = 180;
    NODE_HEIGHT = 56;
    NODE_GAP_Y = 80;
    PADDING = 32;
    LogicGraph = ({ questions, rules }) => {
      const { t } = useTranslate();
      const endOfSurveyLabel = t("branchingLogic.endOfSurvey");
      const layout = useMemo(() => {
        const items = [
          ...questions.map((q) => ({ id: q.id, label: q.label, isEnd: false })),
          { id: END_OF_SURVEY, label: endOfSurveyLabel, isEnd: true }
        ];
        const positions = {};
        items.forEach((item, i) => {
          positions[item.id] = {
            x: PADDING,
            y: PADDING + i * (NODE_HEIGHT + NODE_GAP_Y)
          };
        });
        const width = NODE_WIDTH + PADDING * 2 + 220;
        const height = PADDING * 2 + items.length * (NODE_HEIGHT + NODE_GAP_Y);
        return { items, positions, width, height };
      }, [questions, endOfSurveyLabel]);
      return /* @__PURE__ */ jsx(Box, { className: "overflow-auto rounded-container border border-border bg-card p-2", children: /* @__PURE__ */ jsxs(
        "svg",
        {
          width: layout.width,
          height: layout.height,
          role: "img",
          "aria-label": t("branchingLogic.graphAriaLabel"),
          style: { display: "block" },
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
              "marker",
              {
                id: "branching-arrowhead",
                viewBox: "0 0 10 10",
                refX: "8",
                refY: "5",
                markerWidth: "8",
                markerHeight: "8",
                orient: "auto",
                children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: "var(--color-muted-foreground)" })
              }
            ) }),
            rules.map((rule, i) => {
              const from = layout.positions[rule.sourceQuestionId];
              const to = layout.positions[rule.targetQuestionId];
              if (!from || !to) return null;
              const startX = from.x + NODE_WIDTH;
              const startY = from.y + NODE_HEIGHT / 2;
              const endX = to.x + NODE_WIDTH;
              const endY = to.y + NODE_HEIGHT / 2;
              const offset = 40 + i % 4 * 30;
              const cx = Math.max(startX, endX) + offset;
              const path = `M ${startX} ${startY} C ${cx} ${startY}, ${cx} ${endY}, ${endX} ${endY}`;
              const labelText = rule.operator === "in" && Array.isArray(rule.value) ? `in [${rule.value.join(", ")}]` : `${rule.operator} ${Array.isArray(rule.value) ? rule.value.join(", ") : rule.value}`;
              const labelY = (startY + endY) / 2;
              return /* @__PURE__ */ jsxs("g", { children: [
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: path,
                    fill: "none",
                    stroke: "var(--color-muted-foreground)",
                    strokeWidth: 1.5,
                    markerEnd: "url(#branching-arrowhead)"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "rect",
                  {
                    x: cx - 4,
                    y: labelY - 10,
                    width: Math.min(160, labelText.length * 7 + 12),
                    height: 20,
                    rx: 4,
                    fill: "var(--color-card)",
                    stroke: "var(--color-border)"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "text",
                  {
                    x: cx + 4,
                    y: labelY + 4,
                    fontSize: "11",
                    fontFamily: "JetBrains Mono, monospace",
                    fill: "var(--color-foreground)",
                    children: labelText.length > 22 ? `${labelText.slice(0, 21)}\u2026` : labelText
                  }
                )
              ] }, rule.id);
            }),
            layout.items.map((item) => {
              const pos = layout.positions[item.id];
              return /* @__PURE__ */ jsxs("g", { children: [
                /* @__PURE__ */ jsx(
                  "rect",
                  {
                    x: pos.x,
                    y: pos.y,
                    width: NODE_WIDTH,
                    height: NODE_HEIGHT,
                    rx: 6,
                    fill: item.isEnd ? "var(--color-surface)" : "var(--color-card)",
                    stroke: item.isEnd ? "var(--color-error)" : "var(--color-border)",
                    strokeWidth: item.isEnd ? 2 : 1.5
                  }
                ),
                /* @__PURE__ */ jsx(
                  "text",
                  {
                    x: pos.x + NODE_WIDTH / 2,
                    y: pos.y + NODE_HEIGHT / 2 + 4,
                    textAnchor: "middle",
                    fontSize: "13",
                    fontFamily: "Inter, sans-serif",
                    fill: "var(--color-foreground)",
                    fontWeight: 600,
                    children: item.label.length > 22 ? `${item.label.slice(0, 21)}\u2026` : item.label
                  }
                )
              ] }, item.id);
            })
          ]
        }
      ) });
    };
    BranchingLogicBuilder = ({
      questions: questionsProp,
      rules: rulesProp,
      onRulesChange,
      rulesChangeEvent,
      readOnly = false,
      className
    }) => {
      const { t } = useTranslate();
      const eventBus = useEventBus();
      const questions = Array.isArray(questionsProp) ? questionsProp : [];
      const rulesInitial = Array.isArray(rulesProp) ? rulesProp : [];
      const [rules, setRules] = useState([...rulesInitial]);
      const [view, setView] = useState("edit");
      useEffect(() => {
        setRules(Array.isArray(rulesProp) ? [...rulesProp] : []);
      }, [rulesProp]);
      const updateRules = useCallback(
        (next) => {
          setRules(next);
          onRulesChange?.(next);
          if (rulesChangeEvent) {
            eventBus.emit(`UI:${rulesChangeEvent}`, { rules: next });
          }
        },
        [onRulesChange, rulesChangeEvent, eventBus]
      );
      const handleAddRule = useCallback(() => {
        const firstQ = questions[0];
        if (!firstQ) return;
        const target = questions[1]?.id ?? END_OF_SURVEY;
        const next = {
          id: generateRuleId(),
          sourceQuestionId: firstQ.id,
          operator: "equals",
          value: firstQ.optionValues?.[0] ?? "",
          targetQuestionId: target
        };
        updateRules([...rules, next]);
      }, [questions, rules, updateRules]);
      const handleRuleChange = useCallback(
        (id, next) => {
          updateRules(rules.map((r) => r.id === id ? next : r));
        },
        [rules, updateRules]
      );
      const handleRuleDelete = useCallback(
        (id) => {
          updateRules(rules.filter((r) => r.id !== id));
        },
        [rules, updateRules]
      );
      const brokenCount = useMemo(
        () => rules.filter((r) => isRuleBroken(r, questions)).length,
        [rules, questions]
      );
      const noQuestions = questions.length === 0;
      return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col gap-3", className), children: [
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-center justify-between gap-2", children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(GitBranch, { className: "h-5 w-5 text-foreground" }),
            /* @__PURE__ */ jsx(Typography, { variant: "subheading", weight: "semibold", children: t("branchingLogic.title") }),
            /* @__PURE__ */ jsx(
              Badge,
              {
                variant: "neutral",
                size: "sm",
                label: rules.length === 1 ? t("branchingLogic.ruleCountOne", { count: rules.length }) : t("branchingLogic.ruleCountOther", { count: rules.length })
              }
            ),
            brokenCount > 0 && /* @__PURE__ */ jsx(
              Badge,
              {
                variant: "error",
                size: "sm",
                label: t("branchingLogic.brokenCount", { count: brokenCount })
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1 rounded-sm border border-border bg-card p-0.5", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: view === "edit" ? "primary" : "ghost",
                size: "sm",
                leftIcon: Pencil,
                action: "VIEW_EDIT",
                onClick: () => setView("edit"),
                children: t("branchingLogic.rules")
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: view === "graph" ? "primary" : "ghost",
                size: "sm",
                leftIcon: Eye,
                action: "VIEW_GRAPH",
                onClick: () => setView("graph"),
                children: t("branchingLogic.logicGraph")
              }
            )
          ] })
        ] }),
        view === "edit" ? /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2", children: [
          rules.length === 0 ? /* @__PURE__ */ jsx(Card, { variant: "bordered", padding: "lg", className: "text-center", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: noQuestions ? t("branchingLogic.emptyNoQuestions") : t("branchingLogic.emptyNoRules") }) }) : rules.map((rule) => /* @__PURE__ */ jsx(
            RuleRow,
            {
              rule,
              questions,
              readOnly,
              broken: isRuleBroken(rule, questions),
              onChange: (next) => handleRuleChange(rule.id, next),
              onDelete: () => handleRuleDelete(rule.id)
            },
            rule.id
          )),
          !readOnly && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
            Button,
            {
              variant: "secondary",
              size: "sm",
              leftIcon: Plus,
              action: "ADD_RULE",
              onClick: handleAddRule,
              disabled: noQuestions,
              children: t("branchingLogic.addRule")
            }
          ) })
        ] }) : /* @__PURE__ */ jsx(LogicGraph, { questions, rules })
      ] });
    };
    BranchingLogicBuilder.displayName = "BranchingLogicBuilder";
  }
});
var Breadcrumb;
var init_Breadcrumb = __esm({
  "components/core/molecules/Breadcrumb.tsx"() {
    "use client";
    init_Icon();
    init_Typography();
    init_cn();
    init_useEventBus();
    Breadcrumb = ({
      items,
      fromNavStack = false,
      itemEvent,
      separator = "chevron-right",
      maxItems,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const navStack = useNavStack();
      const sourceItems = fromNavStack ? navStack.entries.map((entry, i) => ({
        label: entry.label,
        path: entry.href,
        isCurrent: i === navStack.entries.length - 1,
        event: itemEvent
      })) : items ?? [];
      if (fromNavStack && sourceItems.length === 0) return null;
      const displayItems = maxItems && sourceItems.length > maxItems ? [
        ...sourceItems.slice(0, 1),
        { label: "...", isCurrent: false },
        ...sourceItems.slice(-maxItems + 1)
      ] : sourceItems;
      return /* @__PURE__ */ jsx(
        "nav",
        {
          "aria-label": t("aria.breadcrumb"),
          className: cn("flex items-center gap-2", className),
          children: /* @__PURE__ */ jsx("ol", { className: "flex items-center gap-2", children: displayItems.map((item, index) => {
            const isLast = index === displayItems.length - 1;
            const isEllipsis = item.label === "...";
            return /* @__PURE__ */ jsxs("li", { className: "flex items-center gap-2", children: [
              isEllipsis ? /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", children: item.label }) : (item.href || item.path) && !item.event && !fromNavStack ? /* @__PURE__ */ jsxs(
                "a",
                {
                  href: item.href || item.path,
                  className: cn(
                    "flex items-center gap-1.5 transition-colors",
                    isLast ? "text-foreground font-bold" : "text-muted-foreground hover:text-foreground"
                  ),
                  "aria-current": isLast ? "page" : void 0,
                  children: [
                    item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm" })),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "small",
                        weight: isLast ? "medium" : "normal",
                        children: item.label
                      }
                    )
                  ]
                }
              ) : /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  onClick: () => {
                    const href = item.path ?? item.href;
                    if (item.event) {
                      eventBus.emit(`UI:${item.event}`, { label: item.label, href, index });
                    } else if (fromNavStack && href) {
                      navStack.goTo(href);
                    }
                    item.onClick?.();
                  },
                  className: cn(
                    "flex items-center gap-1.5 transition-colors",
                    "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                    isLast ? "text-foreground font-bold cursor-default" : "text-muted-foreground hover:text-foreground"
                  ),
                  "aria-current": isLast ? "page" : void 0,
                  disabled: isLast,
                  children: [
                    item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm" })),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "small",
                        weight: isLast ? "medium" : "normal",
                        children: item.label
                      }
                    )
                  ]
                }
              ),
              !isLast && (typeof separator === "string" ? /* @__PURE__ */ jsx(Icon, { name: separator, size: "sm", className: "text-muted-foreground" }) : /* @__PURE__ */ jsx(Icon, { icon: separator, size: "sm", className: "text-muted-foreground" }))
            ] }, index);
          }) })
        }
      );
    };
    Breadcrumb.displayName = "Breadcrumb";
  }
});
function useSafeEventBus2() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var log7, lookStyles4, ButtonGroup;
var init_ButtonGroup = __esm({
  "components/core/molecules/ButtonGroup.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_useEventBus();
    log7 = createLogger("almadar:ui:button-group");
    lookStyles4 = {
      "right-aligned-buttons": "",
      "floating-bar": "fixed bottom-section left-1/2 -translate-x-1/2 shadow-elevation-toast bg-card p-card-sm rounded-container",
      "inline-row": "gap-2 inline-flex",
      "dropdown-menu": "[&>button:not(:first-child)]:hidden",
      "command-palette-trigger": "[&>button:not(:first-child)]:hidden"
    };
    ButtonGroup = ({
      children,
      primary,
      secondary,
      variant = "default",
      orientation = "horizontal",
      className,
      // Filter-group pattern props (entity and filters are used for schema-driven filtering)
      entity: _entity,
      filters,
      look = "right-aligned-buttons"
    }) => {
      const eventBus = useSafeEventBus2();
      const variantClasses2 = {
        default: "gap-0",
        segmented: "gap-0 [&>button]:rounded-none [&>button:first-child]:rounded-l-lg [&>button:last-child]:rounded-r-lg [&>button:not(:first-child)]:border-l-0",
        toggle: "gap-0 [&>button]:rounded-none [&>button:first-child]:rounded-l-lg [&>button:last-child]:rounded-r-lg [&>button:not(:first-child)]:border-l-0"
      };
      const orientationClasses = {
        horizontal: "flex-row",
        vertical: "flex-col [&>button:first-child]:rounded-t-lg [&>button:last-child]:rounded-b-lg [&>button:not(:first-child)]:border-t-0 [&>button:not(:first-child)]:border-l"
      };
      const handleActionClick = (action) => {
        if (action.event) {
          eventBus.emit("UI:DISPATCH", { event: action.event });
        }
        if (action.navigatesTo) {
          eventBus.emit("UI:NAVIGATE", { url: action.navigatesTo });
        }
      };
      const renderFormActions = () => {
        const buttons = [];
        if (secondary) {
          secondary.forEach((action, index) => {
            buttons.push(
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: action.actionType === "submit" ? "submit" : "button",
                  variant: action.variant || "ghost",
                  onClick: () => handleActionClick(action),
                  children: action.label
                },
                `secondary-${index}`
              )
            );
          });
        }
        if (primary) {
          const isSubmit = primary.actionType === "submit";
          buttons.push(
            /* @__PURE__ */ jsx(
              Button,
              {
                type: isSubmit ? "submit" : "button",
                variant: primary.variant || "primary",
                onClick: () => handleActionClick(primary),
                "data-testid": isSubmit ? "form-submit" : void 0,
                children: primary.label
              },
              "primary"
            )
          );
        }
        return buttons;
      };
      const renderFilters = () => {
        if (!filters || filters.length === 0) return null;
        return filters.map((filter, index) => /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            onClick: () => {
              log7.debug("Filter clicked", { field: filter.field });
            },
            children: filter.label
          },
          `filter-${filter.field}-${index}`
        ));
      };
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "inline-flex gap-2",
            variantClasses2[variant],
            orientationClasses[orientation],
            lookStyles4[look],
            className
          ),
          role: "group",
          children: children || renderFilters() || renderFormActions()
        }
      );
    };
    ButtonGroup.displayName = "ButtonGroup";
  }
});
function resolveImageUrl(value) {
  if (typeof value === "string") {
    return value;
  }
  if (isFileValue(value)) {
    return value.url;
  }
  return void 0;
}
var init_getNestedValue = __esm({
  "lib/getNestedValue.ts"() {
  }
});
function useSwipeGesture(callbacks, options = {}) {
  const { threshold = 50, velocityThreshold = 0.3, preventDefault = false } = options;
  const startX = useRef(0);
  const startY = useRef(0);
  const startTime = useRef(0);
  const currentX = useRef(0);
  const tracking = useRef(false);
  const offsetXRef = useRef(0);
  const isSwipingRef = useRef(false);
  const onPointerDown = useCallback((e) => {
    startX.current = e.clientX;
    startY.current = e.clientY;
    currentX.current = e.clientX;
    startTime.current = Date.now();
    tracking.current = true;
    isSwipingRef.current = false;
    offsetXRef.current = 0;
    e.target.setPointerCapture?.(e.pointerId);
  }, []);
  const onPointerMove = useCallback((e) => {
    if (!tracking.current) return;
    if (preventDefault) e.preventDefault();
    currentX.current = e.clientX;
    const dx = e.clientX - startX.current;
    const dy = e.clientY - startY.current;
    if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
      isSwipingRef.current = true;
      offsetXRef.current = dx;
    }
  }, [preventDefault]);
  const onPointerUp = useCallback((e) => {
    if (!tracking.current) return;
    tracking.current = false;
    const dx = e.clientX - startX.current;
    const dy = e.clientY - startY.current;
    const elapsed = Date.now() - startTime.current;
    const velocity = Math.abs(dx) / Math.max(elapsed, 1);
    offsetXRef.current = 0;
    isSwipingRef.current = false;
    if (Math.abs(dx) < threshold && velocity < velocityThreshold) return;
    if (Math.abs(dx) > Math.abs(dy)) {
      if (dx < -threshold) callbacks.onSwipeLeft?.();
      else if (dx > threshold) callbacks.onSwipeRight?.();
    } else {
      if (dy < -threshold) callbacks.onSwipeUp?.();
      else if (dy > threshold) callbacks.onSwipeDown?.();
    }
  }, [threshold, velocityThreshold, callbacks]);
  const onPointerCancel = useCallback(() => {
    tracking.current = false;
    offsetXRef.current = 0;
    isSwipingRef.current = false;
  }, []);
  return {
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onPointerCancel,
    offsetX: offsetXRef.current,
    isSwiping: isSwipingRef.current
  };
}
var init_useSwipeGesture = __esm({
  "hooks/useSwipeGesture.ts"() {
    "use client";
  }
});
function dayWindowForViewport(width) {
  if (width <= 640) return 1;
  if (width <= 1024) return 3;
  return 7;
}
function useDayWindow(override) {
  const [w, setW] = useState(() => {
    if (override !== "auto") return override;
    if (typeof window === "undefined") return 7;
    return dayWindowForViewport(window.innerWidth);
  });
  useEffect(() => {
    if (override !== "auto") {
      setW(override);
      return void 0;
    }
    if (typeof window === "undefined") return void 0;
    const onResize = () => setW(dayWindowForViewport(window.innerWidth));
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [override]);
  return w;
}
function formatDateRange(start, end) {
  const startStr = start.toLocaleDateString(void 0, SHORT_DATE);
  const endStr = end.toLocaleDateString(void 0, SHORT_DATE);
  return start.toDateString() === end.toDateString() ? startStr : `${startStr} \u2013 ${endStr}`;
}
function getStartOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);
  d.setHours(0, 0, 0, 0);
  return d;
}
function getWeekDays(start) {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    days.push(day);
  }
  return days;
}
function eventStartDate(event, startField) {
  const raw = getNestedValue(event, startField);
  return new Date(raw ?? "");
}
function eventEndDate(event, endField) {
  const raw = getNestedValue(event, endField);
  if (raw === void 0 || raw === null || raw === "") return null;
  const end = new Date(raw);
  return Number.isNaN(end.getTime()) ? null : end;
}
function eventContinuesInSlot(event, day, slotTime, startField, endField) {
  const eventStart = eventStartDate(event, startField);
  const eventEnd = eventEndDate(event, endField);
  if (eventEnd === null || Number.isNaN(eventStart.getTime())) return false;
  const [slotHour] = slotTime.split(":").map(Number);
  const slotStart = new Date(day);
  slotStart.setHours(slotHour, 0, 0, 0);
  return slotStart.getTime() > eventStart.getTime() && slotStart.getTime() < eventEnd.getTime();
}
function generateDefaultTimeSlots(events2, startField, endField) {
  let first = DEFAULT_FIRST_HOUR;
  let last = DEFAULT_LAST_HOUR;
  for (const ev of events2) {
    const start = eventStartDate(ev, startField);
    if (Number.isNaN(start.getTime())) continue;
    const hour = start.getHours();
    if (hour < first) first = hour;
    if (hour > last) last = hour;
    const end = eventEndDate(ev, endField);
    if (end && end.toDateString() === start.toDateString()) {
      const endHour = end.getMinutes() === 0 && end.getSeconds() === 0 ? end.getHours() - 1 : end.getHours();
      if (endHour > last) last = endHour;
    }
  }
  const slots = [];
  for (let hour = first; hour <= last; hour++) {
    slots.push(slotLabel(hour));
  }
  return slots;
}
function eventInSlot(event, day, slotTime, startField) {
  const eventStart = eventStartDate(event, startField);
  if (Number.isNaN(eventStart.getTime())) return false;
  const [slotHour] = slotTime.split(":").map(Number);
  return eventStart.toDateString() === day.toDateString() && eventStart.getHours() === slotHour;
}
function CalendarGrid({
  weekStart,
  timeSlots,
  events: events2 = [],
  onSlotClick,
  onDayClick,
  onEventClick,
  className,
  longPressEvent,
  longPressPayload,
  swipeLeftEvent,
  swipeRightEvent,
  dayWindow = "auto",
  titleField = "title",
  startField = "startTime",
  endField = "endTime",
  colorField = "color",
  children,
  renderItem
}) {
  const evs = Array.isArray(events2) ? events2 : events2 ? [events2] : [];
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const longPressTimer = useRef(null);
  const resolvedWeekStart = useMemo(
    () => weekStart ? getStartOfWeek(weekStart) : getStartOfWeek(/* @__PURE__ */ new Date()),
    [weekStart]
  );
  const weekDays = useMemo(
    () => getWeekDays(resolvedWeekStart),
    [resolvedWeekStart]
  );
  const resolvedTimeSlots = useMemo(
    () => timeSlots ?? generateDefaultTimeSlots(evs, startField, endField),
    [timeSlots, evs, startField, endField]
  );
  const visibleCount = useDayWindow(dayWindow);
  const [dayOffset, setDayOffset] = useState(0);
  useEffect(() => {
    if (dayOffset + visibleCount > 7) {
      setDayOffset(Math.max(0, 7 - visibleCount));
    }
  }, [visibleCount, dayOffset]);
  const visibleDays = useMemo(
    () => weekDays.slice(dayOffset, dayOffset + visibleCount),
    [weekDays, dayOffset, visibleCount]
  );
  const canPrev = dayOffset > 0;
  const canNext = dayOffset + visibleCount < 7;
  const stepPrev = useCallback(() => {
    setDayOffset((d) => Math.max(0, d - visibleCount));
  }, [visibleCount]);
  const stepNext = useCallback(() => {
    setDayOffset((d) => Math.min(7 - visibleCount, d + visibleCount));
  }, [visibleCount]);
  const gridColsClass = visibleCount === 1 ? "grid-cols-2" : visibleCount === 3 ? "grid-cols-4" : "grid-cols-8";
  const handleSlotClick = useCallback(
    (day, time) => {
      onSlotClick?.(day, time);
    },
    [onSlotClick]
  );
  const handleEventClick = useCallback(
    (event, e) => {
      e.stopPropagation();
      onEventClick?.(event);
    },
    [onEventClick]
  );
  const eventsForDayCount = useCallback(
    (day) => evs.filter(
      (ev) => eventStartDate(ev, startField).toDateString() === day.toDateString()
    ).length,
    [events2, startField]
  );
  const swipeCallbacks = useMemo(() => ({
    onSwipeLeft: swipeLeftEvent ? () => eventBus.emit(`UI:${swipeLeftEvent}`, {}) : void 0,
    onSwipeRight: swipeRightEvent ? () => eventBus.emit(`UI:${swipeRightEvent}`, {}) : void 0
  }), [swipeLeftEvent, swipeRightEvent, eventBus]);
  const swipe = useSwipeGesture(swipeCallbacks);
  const clearLongPress = useCallback(() => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  }, []);
  const startLongPress = useCallback((day, time) => {
    if (!longPressEvent) return;
    longPressTimer.current = setTimeout(() => {
      eventBus.emit(`UI:${longPressEvent}`, { date: day.toISOString(), time, ...longPressPayload });
    }, 500);
  }, [longPressEvent, longPressPayload, eventBus]);
  const renderChip = children ?? renderItem;
  const renderEvent = (event) => {
    const color = getNestedValue(event, colorField);
    const label = String(getNestedValue(event, titleField) ?? "");
    const eventIndex = evs.indexOf(event);
    return /* @__PURE__ */ jsx(
      Box,
      {
        rounded: "md",
        padding: "xs",
        border: true,
        className: cn(
          "cursor-pointer hover:shadow-sm transition-shadow text-xs truncate",
          color ? color : "bg-primary/10 border-primary/30 text-primary"
        ),
        onClick: (e) => handleEventClick(event, e),
        children: renderChip ? renderChip(event, eventIndex) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate font-medium", children: label })
      },
      event.id
    );
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className,
      ...swipeLeftEvent || swipeRightEvent ? {
        onPointerDown: swipe.onPointerDown,
        onPointerMove: swipe.onPointerMove,
        onPointerUp: swipe.onPointerUp,
        onPointerCancel: swipe.onPointerCancel
      } : {},
      children: [
        visibleCount < 7 && /* @__PURE__ */ jsxs(HStack, { align: "center", justify: "between", className: "mb-2 px-2", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: "chevron-left",
              onClick: stepPrev,
              "aria-disabled": !canPrev || void 0,
              "aria-label": t("aria.previousDays"),
              children: t("nav.previous")
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: formatDateRange(visibleDays[0], visibleDays[visibleDays.length - 1]) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              iconRight: "chevron-right",
              onClick: stepNext,
              "aria-disabled": !canNext || void 0,
              "aria-label": t("aria.nextDays"),
              children: t("nav.next")
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsxs(Box, { className: cn("grid border-b border-border", gridColsClass), children: [
            /* @__PURE__ */ jsx(Box, { className: "p-2" }),
            visibleDays.map((day) => {
              const isToday = day.toDateString() === (/* @__PURE__ */ new Date()).toDateString();
              const count = eventsForDayCount(day);
              return /* @__PURE__ */ jsxs(
                Box,
                {
                  className: "border-l border-border",
                  children: [
                    /* @__PURE__ */ jsx(
                      DayCell,
                      {
                        date: day,
                        isToday,
                        onClick: onDayClick
                      }
                    ),
                    count > 0 && /* @__PURE__ */ jsx(Box, { className: "text-center pb-1", children: /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: count }) })
                  ]
                },
                day.toISOString()
              );
            })
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "max-h-[500px] overflow-y-auto", children: resolvedTimeSlots.map((time) => /* @__PURE__ */ jsxs(
            Box,
            {
              className: cn("grid border-b border-border", gridColsClass),
              children: [
                /* @__PURE__ */ jsx(Box, { className: "p-2 text-right pr-3", children: /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "small",
                    className: "text-muted-foreground",
                    children: time
                  }
                ) }),
                visibleDays.map((day) => {
                  const slotEvents = evs.filter(
                    (ev) => eventInSlot(ev, day, time, startField)
                  );
                  const continuingEvents = evs.filter(
                    (ev) => eventContinuesInSlot(ev, day, time, startField, endField)
                  );
                  const isToday = day.toDateString() === (/* @__PURE__ */ new Date()).toDateString();
                  return /* @__PURE__ */ jsx(
                    TimeSlotCell,
                    {
                      time,
                      isOccupied: slotEvents.length > 0 || continuingEvents.length > 0,
                      onClick: () => handleSlotClick(day, time),
                      className: cn(
                        "border-l border-border",
                        isToday && "bg-primary/10"
                      ),
                      ...longPressEvent ? {
                        onPointerDown: () => startLongPress(day, time),
                        onPointerUp: clearLongPress,
                        onPointerCancel: clearLongPress
                      } : {},
                      children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                        slotEvents.map(renderEvent),
                        continuingEvents.map((event) => {
                          const color = getNestedValue(event, colorField);
                          return /* @__PURE__ */ jsx(
                            Box,
                            {
                              rounded: "sm",
                              border: true,
                              className: cn(
                                "cursor-pointer h-2",
                                color ? cn(color, "opacity-50") : "bg-primary/10 border-primary/20"
                              ),
                              onClick: (e) => handleEventClick(event, e)
                            },
                            `${event.id}-cont`
                          );
                        })
                      ] })
                    },
                    `${day.toISOString()}-${time}`
                  );
                })
              ]
            },
            time
          )) })
        ] })
      ]
    }
  );
}
var SHORT_DATE, DEFAULT_FIRST_HOUR, DEFAULT_LAST_HOUR, slotLabel;
var init_CalendarGrid = __esm({
  "components/core/molecules/CalendarGrid.tsx"() {
    "use client";
    init_cn();
    init_getNestedValue();
    init_Box();
    init_Button();
    init_Stack();
    init_Typography();
    init_Badge();
    init_DayCell();
    init_TimeSlotCell();
    init_useEventBus();
    init_useSwipeGesture();
    SHORT_DATE = { month: "short", day: "numeric" };
    DEFAULT_FIRST_HOUR = 9;
    DEFAULT_LAST_HOUR = 17;
    slotLabel = (hour) => `${hour.toString().padStart(2, "0")}:00`;
    CalendarGrid.displayName = "CalendarGrid";
  }
});
function MiniMap({
  tiles = DEFAULT_TILES,
  units = DEFAULT_UNITS,
  width = 150,
  height = 150,
  mapWidth = 100,
  mapHeight = 100,
  viewportRect = DEFAULT_VIEWPORT,
  className,
  tileAssets,
  unitAssets
}) {
  const canvasRef = React79.useRef(null);
  const imgCacheRef = React79.useRef(/* @__PURE__ */ new Map());
  function loadImg(url) {
    const cached = imgCacheRef.current.get(url);
    if (cached) return cached.complete ? cached : null;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      if (ctx) ctx.clearRect(0, 0, 0, 0);
    };
    imgCacheRef.current.set(url, img);
    return null;
  }
  React79.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const scaleX2 = width / mapWidth;
    const scaleY2 = height / mapHeight;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = "#111";
    ctx.fillRect(0, 0, width, height);
    for (const tile of tiles) {
      const tileAsset = tileAssets?.[tile.color] ?? tileAssets?.["default"];
      const tileImg = tileAsset ? loadImg(tileAsset.url) : null;
      const tx = Math.floor(tile.x * scaleX2);
      const ty = Math.floor(tile.y * scaleY2);
      const tw = Math.max(1, Math.ceil(scaleX2));
      const th = Math.max(1, Math.ceil(scaleY2));
      if (tileImg) {
        ctx.drawImage(tileImg, tx, ty, tw, th);
      } else {
        ctx.fillStyle = tile.color;
        ctx.fillRect(tx, ty, tw, th);
      }
    }
    for (const unit of units) {
      if (unit.isPlayer) continue;
      const unitAsset = unitAssets?.[unit.color] ?? unitAssets?.["default"];
      const unitImg = unitAsset ? loadImg(unitAsset.url) : null;
      const ux = Math.floor(unit.x * scaleX2) - 1;
      const uy = Math.floor(unit.y * scaleY2) - 1;
      if (unitImg) {
        ctx.drawImage(unitImg, ux, uy, 5, 5);
      } else {
        ctx.fillStyle = unit.color;
        ctx.fillRect(ux, uy, 3, 3);
      }
    }
    if (viewportRect) {
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 1;
      ctx.strokeRect(
        Math.floor(viewportRect.x * scaleX2),
        Math.floor(viewportRect.y * scaleY2),
        Math.floor(viewportRect.w * scaleX2),
        Math.floor(viewportRect.h * scaleY2)
      );
    }
  }, [tiles, units, width, height, mapWidth, mapHeight, viewportRect, tileAssets, unitAssets]);
  const scaleX = width / mapWidth;
  const scaleY = height / mapHeight;
  const playerUnit = units.find((u) => u.isPlayer);
  const playerLeft = playerUnit ? Math.floor(playerUnit.x * scaleX) - 1 : null;
  const playerTop = playerUnit ? Math.floor(playerUnit.y * scaleY) - 1 : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("style", { children: `@keyframes minimap-blink{0%,49%{opacity:1}50%,100%{opacity:0}}` }),
    /* @__PURE__ */ jsxs(
      Box,
      {
        position: "relative",
        display: "inline-block",
        className: cn(
          "border border-border/20 rounded-container",
          className
        ),
        children: [
          /* @__PURE__ */ jsx(
            "canvas",
            {
              ref: canvasRef,
              width,
              height,
              className: "block",
              style: { width, height }
            }
          ),
          playerLeft !== null && playerTop !== null && /* @__PURE__ */ jsx(
            Box,
            {
              position: "absolute",
              style: {
                left: playerLeft,
                top: playerTop,
                width: 3,
                height: 3,
                backgroundColor: "#ffffff",
                animation: "minimap-blink 1s steps(2, end) infinite",
                pointerEvents: "none"
              }
            }
          )
        ]
      }
    )
  ] });
}
var DEFAULT_TILES, DEFAULT_UNITS, DEFAULT_VIEWPORT;
var init_MiniMap = __esm({
  "components/game/atoms/MiniMap.tsx"() {
    "use client";
    init_cn();
    init_Box();
    DEFAULT_TILES = [
      { x: 10, y: 10, color: "#4ade80" },
      { x: 20, y: 15, color: "#4ade80" },
      { x: 30, y: 25, color: "#22c55e" },
      { x: 50, y: 40, color: "#4ade80" },
      { x: 60, y: 55, color: "#16a34a" },
      { x: 40, y: 60, color: "#4ade80" },
      { x: 70, y: 30, color: "#22c55e" },
      { x: 80, y: 70, color: "#4ade80" }
    ];
    DEFAULT_UNITS = [
      { x: 30, y: 30, color: "#60a5fa", isPlayer: true }
    ];
    DEFAULT_VIEWPORT = { x: 20, y: 20, w: 40, h: 40 };
    MiniMap.displayName = "MiniMap";
  }
});
function useImageCache(urls) {
  const cacheRef = useRef(/* @__PURE__ */ new Map());
  const loadingRef = useRef(/* @__PURE__ */ new Set());
  const [pendingCount, setPendingCount] = useState(0);
  useEffect(() => {
    const cache2 = cacheRef.current;
    const loading = loadingRef.current;
    const newUrls = urls.filter((url) => url && !cache2.has(url) && !loading.has(url));
    if (newUrls.length === 0) return;
    setPendingCount((prev) => prev + newUrls.length);
    for (const url of newUrls) {
      loading.add(url);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        cache2.set(url, img);
        loading.delete(url);
        setPendingCount((prev) => Math.max(0, prev - 1));
        updateAssetStatus(url, "loaded");
      };
      img.onerror = () => {
        loading.delete(url);
        setPendingCount((prev) => Math.max(0, prev - 1));
        updateAssetStatus(url, "failed");
      };
      updateAssetStatus(url, "pending");
      img.src = url;
    }
  }, [urls.join(",")]);
  const getImage = useCallback((url) => {
    return cacheRef.current.get(url);
  }, []);
  return {
    getImage,
    isLoaded: pendingCount === 0,
    pendingCount
  };
}
var init_useImageCache = __esm({
  "hooks/useImageCache.ts"() {
    "use client";
    init_verificationRegistry();
  }
});
function useCamera(initial) {
  const cameraRef = useRef({
    x: initial?.x ?? 0,
    y: initial?.y ?? 0,
    zoom: initial?.zoom ?? 1
  });
  const targetCameraRef = useRef(null);
  const isDraggingRef = useRef(false);
  const dragDistanceRef = useRef(0);
  const lastMouseRef = useRef({ x: 0, y: 0 });
  const handleMouseDown = useCallback((e) => {
    isDraggingRef.current = true;
    dragDistanceRef.current = 0;
    lastMouseRef.current = { x: e.clientX, y: e.clientY };
    if (e.button === 1 || e.button === 2) {
      e.preventDefault();
    }
  }, []);
  const handleMouseUp = useCallback(() => {
    isDraggingRef.current = false;
  }, []);
  const handleMouseMove = useCallback((e, drawFn) => {
    if (!isDraggingRef.current) return false;
    const dx = e.clientX - lastMouseRef.current.x;
    const dy = e.clientY - lastMouseRef.current.y;
    dragDistanceRef.current += Math.abs(dx) + Math.abs(dy);
    cameraRef.current.x -= dx;
    cameraRef.current.y -= dy;
    lastMouseRef.current = { x: e.clientX, y: e.clientY };
    targetCameraRef.current = null;
    drawFn?.();
    return dragDistanceRef.current > 5;
  }, []);
  const handleMouseLeave = useCallback(() => {
    isDraggingRef.current = false;
  }, []);
  const handleWheel = useCallback((e, drawFn) => {
    e.preventDefault();
    const zoomDelta = e.deltaY > 0 ? 0.9 : 1.1;
    cameraRef.current.zoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, cameraRef.current.zoom * zoomDelta));
    drawFn?.();
  }, []);
  const handlePointerDown = useCallback((e) => {
    handleMouseDown(e);
  }, [handleMouseDown]);
  const handlePointerUp = useCallback(() => {
    handleMouseUp();
  }, [handleMouseUp]);
  const handlePointerMove = useCallback((e, drawFn) => {
    return handleMouseMove(e, drawFn);
  }, [handleMouseMove]);
  const panBy = useCallback((dx, dy, drawFn) => {
    cameraRef.current.x -= dx;
    cameraRef.current.y -= dy;
    targetCameraRef.current = null;
    drawFn?.();
  }, []);
  const zoomAtPoint = useCallback((factor, centerX, centerY, viewportSize, drawFn) => {
    const cam = cameraRef.current;
    const oldZoom = cam.zoom;
    const newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, oldZoom * factor));
    if (newZoom === oldZoom) {
      drawFn?.();
      return;
    }
    const inv = 1 / oldZoom - 1 / newZoom;
    cam.x += (centerX - viewportSize.width / 2) * inv;
    cam.y += (centerY - viewportSize.height / 2) * inv;
    cam.zoom = newZoom;
    targetCameraRef.current = null;
    drawFn?.();
  }, []);
  const screenToWorld = useCallback((clientX, clientY, canvas, viewportSize) => {
    const rect = canvas.getBoundingClientRect();
    const screenX = clientX - rect.left;
    const screenY = clientY - rect.top;
    const cam = cameraRef.current;
    const worldX = (screenX - viewportSize.width / 2) / cam.zoom + viewportSize.width / 2 + cam.x;
    const worldY = (screenY - viewportSize.height / 2) / cam.zoom + viewportSize.height / 2 + cam.y;
    return { x: worldX, y: worldY };
  }, []);
  const lerpToTarget = useCallback((t = 0.08) => {
    if (!targetCameraRef.current) return false;
    const cam = cameraRef.current;
    cam.x += (targetCameraRef.current.x - cam.x) * t;
    cam.y += (targetCameraRef.current.y - cam.y) * t;
    if (Math.abs(cam.x - targetCameraRef.current.x) < 0.5 && Math.abs(cam.y - targetCameraRef.current.y) < 0.5) {
      cam.x = targetCameraRef.current.x;
      cam.y = targetCameraRef.current.y;
      targetCameraRef.current = null;
    }
    return true;
  }, []);
  return {
    cameraRef,
    targetCameraRef,
    isDragging: () => isDraggingRef.current,
    dragDistance: () => dragDistanceRef.current,
    handleMouseDown,
    handleMouseUp,
    handleMouseMove,
    handleMouseLeave,
    handleWheel,
    handlePointerDown,
    handlePointerUp,
    handlePointerMove,
    panBy,
    zoomAtPoint,
    screenToWorld,
    lerpToTarget
  };
}
var MIN_ZOOM, MAX_ZOOM;
var init_useCamera = __esm({
  "hooks/useCamera.ts"() {
    "use client";
    MIN_ZOOM = 0.05;
    MAX_ZOOM = 10;
  }
});
function localPoint(canvas, clientX, clientY) {
  if (!canvas) return { x: clientX, y: clientY };
  const rect = canvas.getBoundingClientRect();
  return { x: clientX - rect.left, y: clientY - rect.top };
}
function useCanvasGestures(options) {
  const {
    canvasRef,
    enabled = true,
    wheelStep = 1.1,
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onZoom,
    onPanDelta,
    onMultiTouchStart
  } = options;
  const pointers = useRef(/* @__PURE__ */ new Map());
  const pinch = useRef(null);
  const computePinch = useCallback(() => {
    const pts = [...pointers.current.values()];
    const dx = pts[1].x - pts[0].x;
    const dy = pts[1].y - pts[0].y;
    return {
      distance: Math.hypot(dx, dy) || 1,
      centroid: { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 }
    };
  }, []);
  const handlePointerDown = useCallback(
    (e) => {
      if (!enabled) return;
      e.currentTarget.setPointerCapture(e.pointerId);
      pointers.current.set(e.pointerId, localPoint(canvasRef.current, e.clientX, e.clientY));
      if (pointers.current.size === 2) {
        onMultiTouchStart?.();
        pinch.current = computePinch();
      } else if (pointers.current.size === 1) {
        onPointerDown?.(e);
      }
    },
    [enabled, canvasRef, onMultiTouchStart, computePinch, onPointerDown]
  );
  const handlePointerMove = useCallback(
    (e) => {
      if (!enabled) return;
      if (pointers.current.has(e.pointerId)) {
        pointers.current.set(e.pointerId, localPoint(canvasRef.current, e.clientX, e.clientY));
      }
      if (pointers.current.size >= 2 && pinch.current) {
        const next = computePinch();
        const prev = pinch.current;
        if (next.distance !== prev.distance) {
          onZoom?.(next.distance / prev.distance, next.centroid.x, next.centroid.y);
        }
        onPanDelta?.(next.centroid.x - prev.centroid.x, next.centroid.y - prev.centroid.y);
        pinch.current = next;
        return;
      }
      onPointerMove?.(e);
    },
    [enabled, canvasRef, computePinch, onZoom, onPanDelta, onPointerMove]
  );
  const endPointer = useCallback(
    (e, fireUp) => {
      const wasMulti = pointers.current.size >= 2;
      pointers.current.delete(e.pointerId);
      if (pointers.current.size < 2) pinch.current = null;
      if (wasMulti && pointers.current.size === 1) return;
      if (pointers.current.size === 0 && fireUp) onPointerUp?.(e);
    },
    [onPointerUp]
  );
  const handlePointerUp = useCallback(
    (e) => {
      if (!enabled) return;
      endPointer(e, true);
    },
    [enabled, endPointer]
  );
  const handlePointerCancel = useCallback(
    (e) => {
      if (!enabled) return;
      endPointer(e, false);
    },
    [enabled, endPointer]
  );
  const handleWheel = useCallback(
    (e) => {
      if (!enabled) return;
      e.preventDefault();
      const { x, y } = localPoint(canvasRef.current, e.clientX, e.clientY);
      onZoom?.(e.deltaY < 0 ? wheelStep : 1 / wheelStep, x, y);
    },
    [enabled, canvasRef, wheelStep, onZoom]
  );
  return {
    onPointerDown: handlePointerDown,
    onPointerMove: handlePointerMove,
    onPointerUp: handlePointerUp,
    onPointerCancel: handlePointerCancel,
    onWheel: handleWheel
  };
}
var init_useCanvasGestures = __esm({
  "hooks/useCanvasGestures.ts"() {
  }
});

// lib/keyMapEvent.ts
function isEditableTarget(target) {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  return target.isContentEditable || target.contentEditable === "true";
}
function keyMapCode(e) {
  let code = e.code;
  if (e.altKey) code = `Alt+${code}`;
  if (e.shiftKey) code = `Shift+${code}`;
  if (e.metaKey || e.ctrlKey) code = `Mod+${code}`;
  return code;
}
function resolveKeyMapEvent(map, e) {
  if (!map || isEditableTarget(e.target)) return void 0;
  return map[keyMapCode(e)] ?? map[e.code];
}
var init_keyMapEvent = __esm({
  "lib/keyMapEvent.ts"() {
  }
});

// lib/isometric.ts
function isoToScreen(tileX, tileY, cellWidth, baseOffsetX, layout = "isometric") {
  const w = cellWidth;
  const fh = cellWidth / 2;
  if (layout === "hex") {
    const screenX2 = tileX * w + (tileY & 1) * (w / 2) + baseOffsetX;
    const screenY2 = tileY * (fh * 0.75);
    return { x: screenX2, y: screenY2 };
  }
  if (layout === "flat") {
    const screenX2 = tileX * w + baseOffsetX;
    const screenY2 = tileY * w;
    return { x: screenX2, y: screenY2 };
  }
  const screenX = (tileX - tileY) * (w / 2) + baseOffsetX;
  const screenY = (tileX + tileY) * (fh / 2);
  return { x: screenX, y: screenY };
}
function screenToIso(screenX, screenY, cellWidth, baseOffsetX, layout = "isometric") {
  const w = cellWidth;
  const fh = cellWidth / 2;
  if (layout === "hex") {
    const row = Math.round(screenY / (fh * 0.75));
    const col = Math.round((screenX - (row & 1) * (w / 2) - baseOffsetX) / w);
    return { x: col, y: row };
  }
  if (layout === "flat") {
    const col = Math.round((screenX - baseOffsetX) / w);
    const row = Math.round(screenY / w);
    return { x: col, y: row };
  }
  const adjustedX = screenX - baseOffsetX;
  const tileX = (adjustedX / (w / 2) + screenY / (fh / 2)) / 2;
  const tileY = (screenY / (fh / 2) - adjustedX / (w / 2)) / 2;
  return { x: Math.round(tileX), y: Math.round(tileY) };
}
var TILE_WIDTH, TILE_HEIGHT, FLOOR_HEIGHT, DIAMOND_TOP_Y, FEATURE_COLORS, BACKGROUND_FALLBACK_COLOR, MINIMAP_TERRAIN_COLORS;
var init_isometric = __esm({
  "lib/isometric.ts"() {
    TILE_WIDTH = 256;
    TILE_HEIGHT = 512;
    FLOOR_HEIGHT = 128;
    DIAMOND_TOP_Y = 374;
    FEATURE_COLORS = {
      goldMine: "#fbbf24",
      resonanceCrystal: "#a78bfa",
      traitCache: "#60a5fa",
      salvageYard: "#6b7280",
      portal: "#c084fc",
      castle: "#f59e0b",
      mountain: "#78716c",
      default: "#9ca3af"
    };
    BACKGROUND_FALLBACK_COLOR = "#1a1a2e";
    MINIMAP_TERRAIN_COLORS = {
      water: "#3b82f6",
      mountain: "#78716c",
      default: "#4ade80"
    };
  }
});

// lib/drawable/projector.ts
function create2DProjector(opts) {
  const { baseOffsetX, layout } = opts;
  const tw = opts.tileWidth ?? TILE_WIDTH;
  const tileWidth = layout === "free" ? 1 : tw;
  const floorHeight = layout === "free" ? 1 : tw / 2;
  const diamondTopY = layout === "free" ? 0 : opts.diamondTopY ?? tw * (DIAMOND_TOP_Y / TILE_WIDTH);
  const squareGrid = layout === "flat" || layout === "free";
  const project = (pos) => layout === "free" ? { x: pos.x, y: pos.y } : isoToScreen(pos.x, pos.y, tw, baseOffsetX, layout);
  const anchorPoint = (pos, anchor) => {
    const base = project(pos);
    if (anchor === "top-left") return base;
    const cx = base.x + tileWidth / 2;
    if (anchor === "ground") {
      const gy = squareGrid ? base.y + tileWidth * 0.92 : base.y + diamondTopY + floorHeight * 0.5;
      return { x: cx, y: gy };
    }
    const cy = squareGrid ? base.y + tileWidth / 2 : base.y + diamondTopY + floorHeight * 0.5;
    return { x: cx, y: cy };
  };
  const cellPath = (pos) => {
    const base = project(pos);
    if (squareGrid) {
      return [
        { x: base.x, y: base.y },
        { x: base.x + tileWidth, y: base.y },
        { x: base.x + tileWidth, y: base.y + tileWidth },
        { x: base.x, y: base.y + tileWidth }
      ];
    }
    const cx = base.x + tileWidth / 2;
    const topY = base.y + diamondTopY;
    return [
      { x: cx, y: topY },
      { x: base.x + tileWidth, y: topY + floorHeight / 2 },
      { x: cx, y: topY + floorHeight },
      { x: base.x, y: topY + floorHeight / 2 }
    ];
  };
  return { project, anchorPoint, cellPath, tileWidth, floorHeight, diamondTopY, squareGrid, worldPixelDirect: layout === "free" };
}
var init_projector = __esm({
  "lib/drawable/projector.ts"() {
    init_isometric();
  }
});

// lib/drawable/hitTest.ts
function shapeDrawnItem(n) {
  if (n.shape !== "rect") return { pos: n.position, id: n.id };
  return { pos: n.position, id: n.id, anchor: n.anchor, width: n.width, height: n.height, rotation: n.rotate };
}
function skinnedMeshDrawnItem(n) {
  const mesh = n.mesh;
  if (!mesh || n.bones.length === 0) return { pos: n.position, id: n.id };
  const bindWorld = computeWorldMatrices(n.bones, {});
  const curWorld = computeWorldMatrices(n.bones, resolveSkinPose(n));
  const bounds = vertexBounds(skinVertices(mesh, bindWorld, curWorld));
  if (!bounds) return { pos: n.position, id: n.id };
  return {
    pos: { ...n.position, x: n.position.x + bounds.minX, y: n.position.y + bounds.minY },
    id: n.id,
    anchor: "top-left",
    width: bounds.maxX - bounds.minX,
    height: bounds.maxY - bounds.minY
  };
}
function collectDrawnItems(nodes) {
  const out = [];
  for (const n of nodes) {
    switch (n.type) {
      case "draw-sprite":
        if (isValidScenePos(n.position)) out.push({ pos: n.position, id: n.id, anchor: n.anchor, width: n.width, height: n.height, rotation: n.rotation });
        break;
      case "draw-shape":
        if (isValidScenePos(n.position)) out.push(shapeDrawnItem(n));
        break;
      case "draw-skinned-mesh":
        if (isValidScenePos(n.position)) out.push(skinnedMeshDrawnItem(n));
        break;
      case "draw-text":
      case "draw-group":
      case "draw-mesh":
        if (isValidScenePos(n.position)) out.push({ pos: n.position, id: n.id });
        break;
      case "draw-sprite-layer":
        for (const it of n.items) {
          if (isValidScenePos(it.position)) out.push({ pos: it.position, id: it.id, anchor: it.anchor, width: it.width, height: it.height, rotation: it.rotation });
        }
        break;
      case "draw-shape-layer":
        for (const it of n.items) {
          if (isValidScenePos(it.position)) out.push(shapeDrawnItem(it));
        }
        break;
      case "draw-text-layer":
        for (const it of n.items) {
          if (isValidScenePos(it.position)) out.push({ pos: it.position, id: it.id });
        }
        break;
    }
  }
  return out;
}
function buildHitIndex(items) {
  const m = /* @__PURE__ */ new Map();
  for (const it of items) {
    if (it.id !== void 0) m.set(`${it.pos.x},${it.pos.y}`, it.id);
  }
  return m;
}
function withPreviewPosition(nodes, id, pos) {
  return nodes.map((n) => {
    if (n.type === "draw-sprite-layer" || n.type === "draw-shape-layer" || n.type === "draw-text-layer") {
      if (!n.items.some((it) => it.id === id)) return n;
      return { ...n, items: n.items.map((it) => it.id === id ? { ...it, position: pos } : it) };
    }
    if (n.type === "draw-group") {
      if (!Array.isArray(n.items)) return n;
      return { ...n, items: withPreviewPosition(n.items, id, pos) };
    }
    if (n.id === id && "position" in n) {
      return { ...n, position: pos };
    }
    return n;
  });
}
function hitTestSprites(items, projector, point) {
  for (let i = items.length - 1; i >= 0; i--) {
    const it = items[i];
    if (it.id === void 0) continue;
    const r = spriteRect(projector, { position: it.pos, anchor: it.anchor, width: it.width, height: it.height });
    const test = it.rotation ? rotatePoint(point, { x: r.x + r.w / 2, y: r.y + r.h / 2 }, -it.rotation) : point;
    if (test.x >= r.x && test.x <= r.x + r.w && test.y >= r.y && test.y <= r.y + r.h) return it.id;
  }
  return void 0;
}
function rotatePoint(p, center, radians) {
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const dx = p.x - center.x;
  const dy = p.y - center.y;
  return { x: center.x + dx * cos - dy * sin, y: center.y + dx * sin + dy * cos };
}
var init_hitTest = __esm({
  "lib/drawable/hitTest.ts"() {
    init_contract();
    init_DrawSkinnedMesh();
    init_skinning();
  }
});
function normalizeBackdrop(bg) {
  return typeof bg === "string" ? { url: bg, role: "decoration", category: "background" } : bg;
}
function selectionOverlayNodes(projector, item) {
  const r = spriteRect(projector, { position: item.pos, anchor: item.anchor, width: item.width, height: item.height });
  const tw = projector.tileWidth;
  const cellTopLeft = projector.anchorPoint(item.pos, "top-left");
  const offsetX = (r.x - cellTopLeft.x) / tw;
  const offsetY = (r.y - cellTopLeft.y) / tw;
  const width = r.w / tw;
  const height = r.h / tw;
  const handle = EDIT_HANDLE_SIZE_PX / tw;
  const ring = {
    type: "draw-shape",
    shape: "rect",
    position: item.pos,
    anchor: "top-left",
    offsetX,
    offsetY,
    width,
    height,
    stroke: EDIT_SELECTION_COLOR,
    strokeWidth: 2,
    fill: "none"
  };
  const handles = EDIT_SELECTION_CORNERS.map(([cx, cy]) => ({
    type: "draw-shape",
    shape: "rect",
    position: item.pos,
    anchor: "top-left",
    offsetX: offsetX + cx * width - handle / 2,
    offsetY: offsetY + cy * height - handle / 2,
    width: handle,
    height: handle,
    fill: EDIT_SELECTION_COLOR
  }));
  return [ring, ...handles];
}
function Canvas2D({
  className,
  isLoading = false,
  error = null,
  projection = "isometric",
  drawables,
  backgroundImage: backgroundImageRaw,
  tileClickEvent,
  unitClickEvent,
  tileHoverEvent,
  tileLeaveEvent,
  keyMap,
  keyUpMap,
  editable = false,
  selectedId = null,
  onSelect,
  onMove,
  selectEvent,
  moveEvent,
  camera = "pan-zoom",
  scale = 0.4,
  tileWidth,
  fit = false,
  showMinimap = true,
  followTarget,
  cameraPos,
  bgColor,
  children
}) {
  const instanceId = useMemo(() => Math.random().toString(36).slice(2, 8), []);
  const childDrawablesRef = useRef([]);
  childDrawablesRef.current = [];
  const registerChildDrawable = useCallback((node) => {
    childDrawablesRef.current.push(node);
  }, []);
  const hasJsxChildren = React79.Children.count(children) > 0;
  function isDrawableLayer(node) {
    return node.type === "draw-sprite-layer" || node.type === "draw-shape-layer" || node.type === "draw-text-layer";
  }
  const layerSummaries = drawables?.map((d) => {
    if (!isDrawableLayer(d)) return { type: d.type };
    return { type: d.type, itemsLen: d.items.length, firstItem: d.items[0] };
  });
  canvas2DLog.debug("Canvas2D render", { instanceId, projection, scale, cameraMode: camera, cameraPos: cameraPos ? JSON.stringify(cameraPos) : void 0, drawablesCount: drawables?.length, layerSummaries: layerSummaries ? JSON.stringify(layerSummaries) : void 0 });
  const backgroundImage = normalizeBackdrop(backgroundImageRaw);
  const isFree = projection === "free";
  const squareGrid = projection === "flat" || isFree || projection === "side";
  const layout = projection === "side" ? "free" : projection;
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const lerpRafRef = useRef(0);
  const [viewportSize, setViewportSize] = useState({ width: 800, height: 600 });
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    if (typeof ResizeObserver === "undefined") return;
    const observer2 = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        const w = Math.round(entry.contentRect.width) || 800;
        const h = Math.round(entry.contentRect.height) || 600;
        setViewportSize((prev) => {
          if (Math.abs(prev.width - w) < 2 && Math.abs(prev.height - h) < 2) return prev;
          return { width: w, height: h };
        });
      }
    });
    observer2.observe(el);
    return () => observer2.disconnect();
  }, []);
  const [atlasVersion, setAtlasVersion] = useState(0);
  const bumpAtlas = useCallback(() => setAtlasVersion((v) => v + 1), []);
  const detectedTileWidth = useMemo(() => {
    for (const n of drawables ?? []) {
      const refs = [];
      if (n.type === "draw-sprite") refs.push(n.asset);
      else if (n.type === "draw-sprite-layer") for (const it of n.items) refs.push(it.asset);
      for (const a of refs) {
        if (a && isAtlasAsset(a) && a.atlas) {
          const atlas = getAtlas(a.atlas, bumpAtlas);
          if (atlas) {
            if ("tileWidth" in atlas) return atlas.tileWidth;
            if ("subTextures" in atlas) {
              const first = Object.values(atlas.subTextures)[0];
              if (first && typeof first.width === "number") return first.width;
            }
          }
        }
      }
    }
    return void 0;
  }, [drawables, atlasVersion]);
  const nativeTileW = tileWidth ?? detectedTileWidth ?? TILE_WIDTH;
  const scaledTileWidth = nativeTileW;
  const scaledFloorHeight = nativeTileW / 2;
  const scaledDiamondTopY = nativeTileW * (DIAMOND_TOP_Y / TILE_WIDTH);
  const drawnItems = useMemo(() => collectDrawnItems(drawables ?? []), [drawables]);
  const scenePositions = useMemo(() => drawnItems.map((i) => i.pos), [drawnItems]);
  const hitIndex = useMemo(() => buildHitIndex(drawnItems), [drawnItems]);
  const gridExtent = useMemo(() => {
    if (scenePositions.length === 0) return { width: 0, height: 0 };
    let maxX = 0;
    let maxY = 0;
    for (const p of scenePositions) {
      if (p.x > maxX) maxX = p.x;
      if (p.y > maxY) maxY = p.y;
    }
    return { width: maxX + 1, height: maxY + 1 };
  }, [scenePositions]);
  const defaultGridFocus = useMemo(() => {
    if (isFree || projection === "side") return void 0;
    if (gridExtent.width < 2 || gridExtent.height < 2) return void 0;
    return { x: (gridExtent.width - 1) / 2, y: (gridExtent.height - 1) / 2 };
  }, [isFree, projection, gridExtent]);
  const baseOffsetX = useMemo(() => {
    if (isFree || projection === "flat" || projection === "side") return 0;
    return (gridExtent.height - 1) * (scaledTileWidth / 2);
  }, [isFree, projection, gridExtent.height, scaledTileWidth]);
  const effectiveZoom = useMemo(() => {
    if (isFree || projection === "side") return scale;
    if (!fit) {
      const z2 = TILE_WIDTH * scale * scale / nativeTileW;
      return Number.isFinite(z2) && z2 > 0 ? z2 : scale;
    }
    if (!viewportSize.width || gridExtent.width < 2 || gridExtent.height < 2) return scale;
    let boardW;
    let boardH;
    if (projection === "flat") {
      boardW = gridExtent.width * nativeTileW;
      boardH = gridExtent.height * nativeTileW;
    } else if (projection === "hex") {
      boardW = (gridExtent.width + 0.5) * nativeTileW;
      boardH = gridExtent.height * (nativeTileW / 2) * 0.75 + nativeTileW / 2;
    } else {
      boardW = (gridExtent.width + gridExtent.height) * (nativeTileW / 2);
      boardH = (gridExtent.width + gridExtent.height) * (nativeTileW / 4);
    }
    const z = Math.min(viewportSize.width * 0.85 / boardW, viewportSize.height * 0.85 / boardH);
    return Number.isFinite(z) && z > 0 ? z : scale;
  }, [isFree, projection, fit, viewportSize, gridExtent, nativeTileW, scale]);
  const projector = useMemo(
    () => create2DProjector({ tileWidth: nativeTileW, baseOffsetX, layout }),
    [nativeTileW, baseOffsetX, layout]
  );
  const unproject = useCallback((screenX, screenY) => {
    if (projection === "free" || projection === "side") return { x: Math.round(screenX), y: Math.round(screenY) };
    return screenToIso(screenX, screenY, nativeTileW, baseOffsetX, projection);
  }, [projection, nativeTileW, baseOffsetX]);
  const bgUrls = useMemo(() => backgroundImage ? [backgroundImage.url] : [], [backgroundImage]);
  const { getImage, pendingCount: _imagePendingCount } = useImageCache(bgUrls);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    bindCanvasCapture(() => canvas.toDataURL("image/png"));
    bindLastDrawables(() => drawables ?? null);
    return () => {
      bindCanvasCapture(() => null);
      bindLastDrawables(() => null);
    };
  }, [drawables]);
  const enableCamera = camera === "pan-zoom";
  const {
    cameraRef,
    targetCameraRef,
    dragDistance,
    handleMouseLeave,
    handlePointerDown,
    handlePointerUp,
    handlePointerMove,
    panBy,
    zoomAtPoint,
    screenToWorld,
    lerpToTarget
  } = useCamera({ zoom: effectiveZoom });
  const miniMapTiles = useMemo(() => {
    if (!showMinimap) return [];
    const color = MINIMAP_TERRAIN_COLORS.default;
    return scenePositions.map((p) => ({ x: p.x, y: p.y, color }));
  }, [showMinimap, scenePositions]);
  const miniMapWidth = gridExtent.width || 10;
  const miniMapHeight = gridExtent.height || 10;
  const drawableIsAnimated = (node) => {
    if (node.type === "draw-shape") return isAnimatedShape(node);
    if (node.type === "draw-sprite") return isAnimatedSprite(node);
    if (node.type === "draw-group")
      return isAnimatedGroup(node) || Array.isArray(node.items) && node.items.some(drawableIsAnimated);
    if (node.type === "draw-shape-layer") return Array.isArray(node.items) && node.items.some(isAnimatedShape);
    if (node.type === "draw-sprite-layer") return Array.isArray(node.items) && node.items.some(isAnimatedSprite);
    if (node.type === "draw-fx-layer") return Array.isArray(node.items) && node.items.length > 0;
    return false;
  };
  const animRafRef = useRef(0);
  const drawTimeRef = useRef(() => void 0);
  const draw = useCallback((timeMs = 0) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const scheduleAnimation = (nodes) => {
      if (!nodes.some(drawableIsAnimated)) return;
      cancelAnimationFrame(animRafRef.current);
      animRafRef.current = requestAnimationFrame(() => drawTimeRef.current(performance.now()));
    };
    const dpr = window.devicePixelRatio || 1;
    canvas.width = viewportSize.width * dpr;
    canvas.height = viewportSize.height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, viewportSize.width, viewportSize.height);
    if (backgroundImage) {
      const bgImg = getImage(backgroundImage.url);
      const bgSrc = bgImg ? resolveAssetSource(bgImg, backgroundImage, bumpAtlas) : null;
      if (bgSrc?.rect) {
        const k = Math.max(viewportSize.width / bgSrc.rect.sw, viewportSize.height / bgSrc.rect.sh);
        const dw = bgSrc.rect.sw * k;
        const dh = bgSrc.rect.sh * k;
        blit(ctx, bgSrc, (viewportSize.width - dw) / 2, (viewportSize.height - dh) / 2, dw, dh);
      } else if (bgImg) {
        const cam2 = cameraRef.current;
        const patW = bgImg.naturalWidth;
        const patH = bgImg.naturalHeight;
        const startX = -(cam2.x % patW + patW) % patW;
        const startY = -(cam2.y % patH + patH) % patH;
        for (let y = startY - patH; y < viewportSize.height; y += patH) {
          for (let x = startX - patW; x < viewportSize.width; x += patW) {
            ctx.drawImage(bgImg, x, y);
          }
        }
      }
    } else {
      ctx.fillStyle = bgColor ?? BACKGROUND_FALLBACK_COLOR;
      ctx.fillRect(0, 0, viewportSize.width, viewportSize.height);
    }
    if (!drawables || drawables.length === 0) {
      const childDrawables = childDrawablesRef.current;
      if (childDrawables.length === 0) return;
      const cam0 = cameraRef.current;
      if (camera !== "follow" && dragDistance() === 0) {
        const focus = cameraPos ?? defaultGridFocus;
        if (focus) {
          const p = projector.anchorPoint(focus, "center");
          cam0.x = p.x - viewportSize.width / 2;
          cam0.y = p.y - viewportSize.height / 2;
        }
      }
      const painter0 = createWebPainter(ctx, bumpAtlas);
      painter0.save();
      painter0.translate(viewportSize.width / 2, viewportSize.height / 2);
      painter0.scale(cam0.zoom, cam0.zoom);
      painter0.translate(-viewportSize.width / 2 - cam0.x, -viewportSize.height / 2 - cam0.y);
      const dctx0 = { projector, time: timeMs, invalidate: bumpAtlas };
      for (const node of childDrawables) paintDrawable(painter0, node, dctx0);
      painter0.restore();
      scheduleAnimation(childDrawables);
      return;
    }
    const cam = cameraRef.current;
    if (camera !== "follow" && dragDistance() === 0) {
      const focus = cameraPos ?? defaultGridFocus;
      if (focus) {
        const p = projector.anchorPoint(focus, "center");
        cam.x = p.x - viewportSize.width / 2;
        cam.y = p.y - viewportSize.height / 2;
      }
    }
    const containerRect = containerRef.current?.getBoundingClientRect();
    const canvasRect = canvas.getBoundingClientRect();
    canvas2DLog.debug("Canvas2D draw", { instanceId, viewportSize, baseOffsetX, cam: { x: cam.x, y: cam.y, zoom: cam.zoom }, cameraPos: cameraPos ? JSON.stringify(cameraPos) : void 0, containerRect: containerRect ? { width: containerRect.width, height: containerRect.height } : null, canvasRect: canvasRect ? { width: canvasRect.width, height: canvasRect.height } : null });
    const painter = createWebPainter(ctx, bumpAtlas);
    painter.save();
    painter.translate(viewportSize.width / 2, viewportSize.height / 2);
    painter.scale(cam.zoom, cam.zoom);
    painter.translate(-viewportSize.width / 2 - cam.x, -viewportSize.height / 2 - cam.y);
    const dctx = { projector, time: timeMs, invalidate: bumpAtlas };
    let paintNodes = drawables;
    if (editable) {
      const drag = editDragRef.current;
      if (drag && drag.moved) {
        paintNodes = withPreviewPosition(paintNodes, drag.id, { x: drag.previewX, y: drag.previewY });
      }
      const selectedItem = selectedId != null ? drawnItems.find((it) => it.id === selectedId) : void 0;
      if (selectedItem) {
        const overlaySource = drag && drag.moved && drag.id === selectedId ? { ...selectedItem, pos: { x: drag.previewX, y: drag.previewY } } : selectedItem;
        paintNodes = [...paintNodes, ...selectionOverlayNodes(projector, overlaySource)];
      }
    }
    for (const node of paintNodes) paintDrawable(painter, node, dctx);
    painter.restore();
    scheduleAnimation(paintNodes);
  }, [viewportSize, backgroundImage, bgColor, drawables, projector, cameraRef, bumpAtlas, getImage, cameraPos, defaultGridFocus, camera, dragDistance, editable, selectedId, drawnItems]);
  useEffect(() => {
    drawTimeRef.current = draw;
  }, [draw]);
  useEffect(() => () => cancelAnimationFrame(animRafRef.current), []);
  useEffect(() => {
    if (camera !== "follow" || !followTarget) return;
    const p = projector.anchorPoint(followTarget, "center");
    targetCameraRef.current = {
      x: p.x - viewportSize.width / 2,
      y: p.y - viewportSize.height / 2
    };
  }, [camera, followTarget, projector, viewportSize, targetCameraRef]);
  useEffect(() => {
    draw();
  }, [draw]);
  useEffect(() => {
    draw();
  }, [_imagePendingCount, draw]);
  const userZoomedRef = useRef(false);
  useEffect(() => {
    if (userZoomedRef.current) return;
    if (cameraRef.current.zoom === effectiveZoom) return;
    cameraRef.current.zoom = effectiveZoom;
    draw();
  }, [effectiveZoom, cameraRef, draw]);
  useEffect(() => {
    draw();
  }, [atlasVersion, draw]);
  useEffect(() => {
    if (camera !== "follow" || !followTarget) return;
    let running = true;
    const tick = () => {
      if (!running) return;
      const stillLerping = lerpToTarget();
      draw();
      if (stillLerping) lerpRafRef.current = requestAnimationFrame(tick);
    };
    lerpRafRef.current = requestAnimationFrame(tick);
    return () => {
      running = false;
      cancelAnimationFrame(lerpRafRef.current);
    };
  }, [camera, followTarget, lerpToTarget, draw]);
  const singlePointerActiveRef = useRef(false);
  const editDragRef = useRef(null);
  const pointerToScene = useCallback((clientX, clientY) => {
    const canvas = canvasRef.current;
    if (!canvas) return { x: 0, y: 0 };
    const world = screenToWorld(clientX, clientY, canvas, viewportSize);
    const adjustedX = world.x - scaledTileWidth / 2;
    const adjustedY = squareGrid ? world.y - scaledTileWidth / 2 : world.y - scaledDiamondTopY - scaledFloorHeight / 2;
    return unproject(adjustedX, adjustedY);
  }, [screenToWorld, viewportSize, scaledTileWidth, squareGrid, scaledDiamondTopY, scaledFloorHeight, unproject]);
  const handleCanvasPointerDown = useCallback((e) => {
    singlePointerActiveRef.current = true;
    if (editable) {
      if (!canvasRef.current) return;
      const world = screenToWorld(e.clientX, e.clientY, canvasRef.current, viewportSize);
      const hitId = hitTestSprites(drawnItems, projector, world);
      if (hitId === void 0) return;
      const item = [...drawnItems].reverse().find((it) => it.id === hitId);
      if (!item) return;
      editDragRef.current = {
        id: hitId,
        pointerId: e.pointerId,
        startClientX: e.clientX,
        startClientY: e.clientY,
        startSceneX: item.pos.x,
        startSceneY: item.pos.y,
        moved: false,
        previewX: item.pos.x,
        previewY: item.pos.y
      };
      return;
    }
    if (enableCamera) handlePointerDown(e);
  }, [editable, screenToWorld, viewportSize, drawnItems, projector, enableCamera, handlePointerDown]);
  const handleCanvasPointerMove = useCallback((e) => {
    if (editable) {
      const drag = editDragRef.current;
      if (!drag || drag.pointerId !== e.pointerId) return;
      const dxPx = e.clientX - drag.startClientX;
      const dyPx = e.clientY - drag.startClientY;
      if (!drag.moved && Math.abs(dxPx) + Math.abs(dyPx) <= 5) return;
      drag.moved = true;
      const nowScene = pointerToScene(e.clientX, e.clientY);
      const startScene = pointerToScene(drag.startClientX, drag.startClientY);
      drag.previewX = drag.startSceneX + (nowScene.x - startScene.x);
      drag.previewY = drag.startSceneY + (nowScene.y - startScene.y);
      draw();
      return;
    }
    if (enableCamera) handlePointerMove(e, () => draw());
  }, [editable, pointerToScene, draw, enableCamera, handlePointerMove]);
  const handleCanvasHover = useCallback((e) => {
    if (singlePointerActiveRef.current) return;
    if (!tileHoverEvent || !canvasRef.current) return;
    const isoPos = pointerToScene(e.clientX, e.clientY);
    eventBus.emit(`UI:${tileHoverEvent}`, { x: isoPos.x, y: isoPos.y });
  }, [pointerToScene, tileHoverEvent, eventBus]);
  const handleCanvasPointerUp = useCallback((e) => {
    if (editable) {
      singlePointerActiveRef.current = false;
      const drag = editDragRef.current;
      if (drag && drag.pointerId === e.pointerId) {
        editDragRef.current = null;
        if (drag.moved) {
          onMove?.(drag.id, drag.previewX, drag.previewY);
          if (moveEvent) eventBus.emit(`UI:${moveEvent}`, { id: drag.id, x: drag.previewX, y: drag.previewY });
          draw();
          return;
        }
        const next = selectedId === drag.id ? null : drag.id;
        onSelect?.(next);
        if (selectEvent) eventBus.emit(`UI:${selectEvent}`, { id: next });
        return;
      }
      onSelect?.(null);
      if (selectEvent) eventBus.emit(`UI:${selectEvent}`, { id: null });
      return;
    }
    singlePointerActiveRef.current = false;
    if (enableCamera) handlePointerUp();
    if (dragDistance() > 5) return;
    if (!canvasRef.current || !tileClickEvent && !unitClickEvent) return;
    const world = screenToWorld(e.clientX, e.clientY, canvasRef.current, viewportSize);
    const spriteHit = unitClickEvent ? hitTestSprites(drawnItems, projector, world) : void 0;
    if (spriteHit !== void 0 && unitClickEvent) {
      eventBus.emit(`UI:${unitClickEvent}`, { unitId: spriteHit });
      return;
    }
    const isoPos = pointerToScene(e.clientX, e.clientY);
    const hitId = hitIndex.get(`${isoPos.x},${isoPos.y}`);
    if (hitId !== void 0 && unitClickEvent) {
      eventBus.emit(`UI:${unitClickEvent}`, { unitId: hitId });
    } else if (tileClickEvent) {
      eventBus.emit(`UI:${tileClickEvent}`, { x: isoPos.x, y: isoPos.y });
    }
  }, [editable, selectedId, onMove, moveEvent, onSelect, selectEvent, eventBus, draw, enableCamera, handlePointerUp, dragDistance, screenToWorld, viewportSize, drawnItems, projector, tileClickEvent, unitClickEvent, hitIndex, pointerToScene]);
  const handleCanvasPointerLeave = useCallback(() => {
    handleMouseLeave();
    if (tileLeaveEvent) eventBus.emit(`UI:${tileLeaveEvent}`, {});
  }, [handleMouseLeave, tileLeaveEvent, eventBus]);
  const applyZoom = useCallback((factor, centerX, centerY) => {
    if (!enableCamera) return;
    userZoomedRef.current = true;
    zoomAtPoint(factor, centerX, centerY, viewportSize, () => draw());
  }, [enableCamera, zoomAtPoint, viewportSize, draw]);
  const applyPanDelta = useCallback((dx, dy) => {
    if (enableCamera) panBy(dx, dy, () => draw());
  }, [enableCamera, panBy, draw]);
  const cancelSinglePointer = useCallback(() => {
    singlePointerActiveRef.current = false;
    if (enableCamera) handlePointerUp();
  }, [enableCamera, handlePointerUp]);
  const gestureHandlers = useCanvasGestures({
    canvasRef,
    enabled: enableCamera || !!tileHoverEvent || !!tileClickEvent || !!unitClickEvent || editable,
    onPointerDown: handleCanvasPointerDown,
    onPointerMove: handleCanvasPointerMove,
    onPointerUp: handleCanvasPointerUp,
    onZoom: applyZoom,
    onPanDelta: applyPanDelta,
    onMultiTouchStart: cancelSinglePointer
  });
  const canvasWheelHandler = gestureHandlers.onWheel;
  useEffect(() => {
    const el = canvasRef.current;
    if (!el) return;
    el.addEventListener("wheel", canvasWheelHandler, { passive: false });
    return () => el.removeEventListener("wheel", canvasWheelHandler);
  }, [canvasWheelHandler]);
  useEffect(() => {
    if (!keyMap && !keyUpMap) return;
    const onDown = (e) => {
      const ev = resolveKeyMapEvent(keyMap, e);
      if (ev) {
        eventBus.emit(`UI:${ev}`, {});
        e.preventDefault();
      }
    };
    const onUp = (e) => {
      const ev = resolveKeyMapEvent(keyUpMap, e);
      if (ev) eventBus.emit(`UI:${ev}`, {});
    };
    window.addEventListener("keydown", onDown);
    window.addEventListener("keyup", onUp);
    return () => {
      window.removeEventListener("keydown", onDown);
      window.removeEventListener("keyup", onUp);
    };
  }, [keyMap, keyUpMap, eventBus]);
  useEffect(() => {
    if (!keyMap && !keyUpMap) return;
    canvasRef.current?.focus();
  }, [keyMap, keyUpMap]);
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center w-full h-full bg-[var(--color-card)] rounded-container", className), children: /* @__PURE__ */ jsxs(Stack, { direction: "vertical", gap: "md", align: "center", children: [
      /* @__PURE__ */ jsx(Icon, { name: "alert-circle", size: "xl" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-error", children: error.message })
    ] }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center w-full h-full bg-[var(--color-card)] rounded-container", className), children: /* @__PURE__ */ jsxs(Stack, { direction: "vertical", gap: "md", align: "center", children: [
      /* @__PURE__ */ jsx(Icon, { name: "loader", size: "xl", className: "animate-spin" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-muted-foreground", children: t("canvas.loadingMessage") || "Loading\u2026" })
    ] }) });
  }
  if ((!drawables || drawables.length === 0) && !hasJsxChildren) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: cn("relative w-full overflow-hidden rounded-container", className),
        style: { height: viewportSize.height },
        "data-testid": "canvas-2d-empty",
        children: /* @__PURE__ */ jsx(Box, { className: "flex items-center justify-center h-full bg-[var(--color-card)] rounded-container", children: /* @__PURE__ */ jsxs(Stack, { direction: "vertical", gap: "md", align: "center", children: [
          /* @__PURE__ */ jsx(Icon, { name: "map", size: "xl" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-muted-foreground", children: t("canvas.emptyMessage") || "No map data loaded" })
        ] }) })
      }
    );
  }
  return /* @__PURE__ */ jsx(DrawableRegistryContext.Provider, { value: registerChildDrawable, children: /* @__PURE__ */ jsxs(
    Box,
    {
      ref: containerRef,
      className: cn("relative overflow-hidden w-full h-full", className),
      children: [
        /* @__PURE__ */ jsx(
          "canvas",
          {
            ref: canvasRef,
            "data-testid": "canvas-2d",
            onPointerDown: gestureHandlers.onPointerDown,
            onPointerMove: (e) => {
              gestureHandlers.onPointerMove(e);
              handleCanvasHover(e);
            },
            onPointerUp: gestureHandlers.onPointerUp,
            onPointerCancel: gestureHandlers.onPointerCancel,
            onPointerLeave: handleCanvasPointerLeave,
            onContextMenu: (e) => e.preventDefault(),
            className: "cursor-pointer touch-none",
            tabIndex: isFree || keyMap || keyUpMap ? 0 : void 0,
            style: {
              width: viewportSize.width,
              height: viewportSize.height
            }
          }
        ),
        process.env.NODE_ENV !== "production" && (tileClickEvent || unitClickEvent) && /* @__PURE__ */ jsxs(Box, { "data-game-actions": "", className: "sr-only", "aria-hidden": "true", children: [
          tileClickEvent && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              "data-event": tileClickEvent,
              "data-x": "0",
              "data-y": "0",
              onClick: () => eventBus.emit(`UI:${tileClickEvent}`, { x: 0, y: 0 }),
              children: tileClickEvent
            }
          ),
          unitClickEvent && hitIndex.size > 0 && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              "data-event": unitClickEvent,
              "data-unit-id": [...hitIndex.values()][0],
              onClick: () => eventBus.emit(`UI:${unitClickEvent}`, { unitId: [...hitIndex.values()][0] }),
              children: unitClickEvent
            }
          )
        ] }),
        showMinimap && /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-2 right-2 pointer-events-none", style: { zIndex: 10 }, children: /* @__PURE__ */ jsx(
          MiniMap,
          {
            tiles: miniMapTiles,
            units: [],
            width: 150,
            height: 100,
            mapWidth: miniMapWidth,
            mapHeight: miniMapHeight
          }
        ) }),
        hasJsxChildren && /* @__PURE__ */ jsx("div", { "aria-hidden": "true", style: { position: "absolute", width: 0, height: 0, overflow: "hidden" }, children })
      ]
    }
  ) });
}
var canvas2DLog, EDIT_SELECTION_COLOR, EDIT_HANDLE_SIZE_PX, EDIT_SELECTION_CORNERS;
var init_Canvas2D = __esm({
  "components/game/molecules/Canvas2D.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_Button();
    init_Stack();
    init_Icon();
    init_Typography();
    init_MiniMap();
    init_useImageCache();
    init_atlasSlice();
    init_useCamera();
    init_useCanvasGestures();
    init_verificationRegistry();
    init_keyMapEvent();
    init_webPainter2d();
    init_projector();
    init_paintDispatch();
    init_DrawShape();
    init_DrawSprite();
    init_DrawGroup();
    init_registry();
    init_hitTest();
    init_contract();
    init_isometric();
    canvas2DLog = createLogger("almadar:ui:game-canvas");
    EDIT_SELECTION_COLOR = "#3b82f6";
    EDIT_HANDLE_SIZE_PX = 8;
    EDIT_SELECTION_CORNERS = [[0, 0], [1, 0], [0, 1], [1, 1]];
    Canvas2D.displayName = "Canvas2D";
  }
});
function to2DCamera(mode) {
  if (mode === "follow") return "follow";
  if (mode === "isometric" || mode === "top-down") return "fixed";
  return "pan-zoom";
}
function to3DCameraMode(mode) {
  return mode ?? "isometric";
}
function Canvas({
  mode = "2d",
  drawables,
  camera,
  projection,
  className,
  isLoading,
  unitScale,
  showMinimap,
  fit,
  tileWidth,
  backgroundImage,
  backgroundColor,
  worldWidth,
  worldHeight,
  pixelsPerUnit,
  showGrid,
  shadows,
  showCoordinates,
  showTileInfo,
  fogOfWar,
  lighting,
  post,
  tileClickEvent,
  unitClickEvent,
  tileHoverEvent,
  tileLeaveEvent,
  featureClickEvent,
  keyMap,
  keyUpMap,
  editable,
  selectedId,
  onSelect,
  onMove,
  selectEvent,
  moveEvent,
  children
}) {
  canvasLog.debug("Canvas render", { mode, drawablesCount: drawables?.length, projection, camera: camera ? JSON.stringify(camera) : void 0 });
  const zoom = camera?.zoom;
  const childDrawablesRef = useRef([]);
  if (mode === "3d") childDrawablesRef.current = [];
  const registerChildDrawable = useCallback((node) => {
    childDrawablesRef.current.push(node);
  }, []);
  const [childDrawables, setChildDrawables] = useState([]);
  useEffect(() => {
    if (mode !== "3d") return;
    const next = childDrawablesRef.current;
    canvasLog.debug("children:adopt", { registered: next.length, adopted: childDrawables.length });
    if (next.length === 0 && React79.Children.count(children) > 0) return;
    setChildDrawables(
      (prev) => prev.length === next.length && JSON.stringify(prev) === JSON.stringify(next) ? prev : [...next]
    );
  });
  if (mode === "3d") {
    const props3d = {
      className,
      drawables: [...drawables ?? [], ...childDrawables],
      isLoading,
      cameraMode: to3DCameraMode(camera?.mode),
      ...zoom !== void 0 ? { zoom } : {},
      ...camera?.fov !== void 0 ? { fov: camera.fov } : {},
      ...camera?.azimuth !== void 0 ? { azimuth: camera.azimuth } : {},
      ...camera?.elevation !== void 0 ? { elevation: camera.elevation } : {},
      ...camera?.target !== void 0 ? { followTarget: camera.target } : {},
      unitScale,
      backgroundColor,
      worldWidth,
      worldHeight,
      pixelsPerUnit,
      showGrid,
      shadows,
      showCoordinates,
      showTileInfo,
      fogOfWar,
      lighting,
      post,
      tileClickEvent,
      unitClickEvent,
      tileHoverEvent,
      tileLeaveEvent,
      featureClickEvent,
      keyMap,
      keyUpMap
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Suspense, { fallback: null, children: /* @__PURE__ */ jsx(Canvas3DHost2, { ...props3d }) }),
      React79.Children.count(children) > 0 && /* @__PURE__ */ jsx(DrawableRegistryContext.Provider, { value: registerChildDrawable, children: /* @__PURE__ */ jsx("div", { "aria-hidden": "true", style: { position: "absolute", width: 0, height: 0, overflow: "hidden" }, children }) })
    ] });
  }
  return /* @__PURE__ */ jsx(
    Canvas2D,
    {
      className,
      drawables,
      isLoading,
      projection,
      camera: to2DCamera(camera?.mode),
      ...zoom !== void 0 ? { scale: zoom } : {},
      ...fit !== void 0 ? { fit } : {},
      ...tileWidth !== void 0 ? { tileWidth } : {},
      ...camera?.target !== void 0 ? { followTarget: camera.target } : {},
      ...camera?.pos !== void 0 ? { cameraPos: camera.pos } : {},
      showMinimap,
      backgroundImage,
      ...backgroundColor !== void 0 ? { bgColor: backgroundColor } : {},
      tileClickEvent,
      unitClickEvent,
      tileHoverEvent,
      tileLeaveEvent,
      keyMap,
      keyUpMap,
      editable,
      selectedId,
      onSelect,
      onMove,
      selectEvent,
      moveEvent,
      ...children !== void 0 ? { children } : {}
    }
  );
}
var Canvas3DHost2, canvasLog;
var init_Canvas = __esm({
  "components/game/molecules/Canvas.tsx"() {
    "use client";
    init_registry();
    init_Canvas2D();
    Canvas3DHost2 = lazy(
      () => import('@almadar/ui/components/molecules/game/three').then((m) => ({ default: m.Canvas3DHost }))
    );
    canvasLog = createLogger("almadar:ui:game-canvas");
    Canvas.displayName = "Canvas";
  }
});
var Pagination;
var init_Pagination = __esm({
  "components/core/molecules/Pagination.tsx"() {
    "use client";
    init_Button();
    init_Typography();
    init_Input();
    init_Select();
    init_Stack();
    init_cn();
    init_useEventBus();
    Pagination = ({
      currentPage,
      totalPages,
      onPageChange = () => {
      },
      showPageSize = false,
      pageSizeOptions = [10, 20, 50, 100],
      pageSize,
      onPageSizeChange,
      showJumpToPage = false,
      showTotal = false,
      totalItems,
      maxVisiblePages = 7,
      className,
      pageChangeEvent,
      pageSizeChangeEvent
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const [jumpToPage, setJumpToPage] = useState("");
      const handlePageChange = (page) => {
        if (pageChangeEvent) eventBus.emit(`UI:${pageChangeEvent}`, { page });
        onPageChange(page);
      };
      const handlePageSizeChange = (size) => {
        if (pageSizeChangeEvent) eventBus.emit(`UI:${pageSizeChangeEvent}`, { pageSize: size });
        onPageSizeChange?.(size);
      };
      const handleJumpToPage = () => {
        const page = parseInt(jumpToPage, 10);
        if (page >= 1 && page <= totalPages) {
          handlePageChange(page);
          setJumpToPage("");
        }
      };
      const getPageNumbers = () => {
        const pages = [];
        const halfVisible = Math.floor(maxVisiblePages / 2);
        if (totalPages <= maxVisiblePages) {
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          if (currentPage <= halfVisible + 1) {
            for (let i = 1; i <= maxVisiblePages - 2; i++) {
              pages.push(i);
            }
            pages.push("ellipsis");
            pages.push(totalPages);
          } else if (currentPage >= totalPages - halfVisible) {
            pages.push(1);
            pages.push("ellipsis");
            for (let i = totalPages - maxVisiblePages + 3; i <= totalPages; i++) {
              pages.push(i);
            }
          } else {
            pages.push(1);
            pages.push("ellipsis");
            for (let i = currentPage - halfVisible + 2; i <= currentPage + halfVisible - 2; i++) {
              pages.push(i);
            }
            pages.push("ellipsis");
            pages.push(totalPages);
          }
        }
        return pages;
      };
      const pageNumbers = getPageNumbers();
      return /* @__PURE__ */ jsxs(HStack, { align: "center", className: cn("justify-between gap-4", className), children: [
        /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
          showTotal && totalItems !== void 0 && /* @__PURE__ */ jsxs(Typography, { variant: "small", color: "secondary", children: [
            t("pagination.total"),
            " ",
            totalItems
          ] }),
          showPageSize && pageSize && onPageSizeChange && /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: t("pagination.show") }),
            /* @__PURE__ */ jsx(
              Select,
              {
                value: String(pageSize),
                onValueChange: (v) => handlePageSizeChange(Number(v)),
                options: pageSizeOptions.map((size) => ({
                  value: String(size),
                  label: String(size)
                })),
                className: "px-2 py-1 text-sm"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "xs", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "secondary",
              size: "sm",
              onClick: () => handlePageChange(currentPage - 1),
              disabled: currentPage === 1,
              icon: "chevron-left",
              children: t("pagination.previous")
            }
          ),
          /* @__PURE__ */ jsx(HStack, { align: "center", gap: "xs", children: pageNumbers.map((page, index) => {
            if (page === "ellipsis") {
              return /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "small",
                  color: "muted",
                  className: "px-2",
                  children: "..."
                },
                `ellipsis-${index}`
              );
            }
            const isActive = page === currentPage;
            return /* @__PURE__ */ jsx(
              Button,
              {
                variant: isActive ? "primary" : "ghost",
                size: "sm",
                onClick: () => handlePageChange(page),
                className: "min-w-[2.5rem]",
                children: page
              },
              page
            );
          }) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "secondary",
              size: "sm",
              onClick: () => handlePageChange(currentPage + 1),
              disabled: currentPage === totalPages,
              iconRight: "chevron-right",
              children: t("pagination.next")
            }
          )
        ] }),
        showJumpToPage && /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: t("pagination.goTo") }),
          /* @__PURE__ */ jsx(
            Input,
            {
              type: "number",
              value: jumpToPage,
              onChange: (e) => setJumpToPage(e.target.value),
              placeholder: t("pagination.jumpPlaceholder"),
              className: "w-20",
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  handleJumpToPage();
                }
              }
            }
          ),
          /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleJumpToPage, children: t("pagination.go") })
        ] })
      ] });
    };
    Pagination.displayName = "Pagination";
  }
});
function normalizeFields(fields) {
  if (!fields) return [];
  return fields.map((f3) => typeof f3 === "string" ? f3 : f3.key ?? f3.name ?? "");
}
function asBooleanValue(value) {
  if (typeof value === "boolean") return value;
  if (value === "true") return true;
  if (value === "false") return false;
  return null;
}
function isDateField(key) {
  const lower = key.toLowerCase();
  return lower.includes("date") || lower.includes("time") || lower.endsWith("at") || lower.endsWith("_at");
}
function statusVariant(value) {
  const v = value.toLowerCase();
  if (["active", "completed", "done", "approved", "published", "resolved", "open"].includes(v)) return "success";
  if (["pending", "in_progress", "in-progress", "review", "draft", "processing"].includes(v)) return "warning";
  if (["inactive", "deleted", "rejected", "failed", "error", "blocked", "closed"].includes(v)) return "error";
  if (["new", "created", "scheduled", "queued"].includes(v)) return "info";
  return "default";
}
var fieldLabel, STATUS_FIELDS, gapStyles3, alignStyles2, CardGrid;
var init_CardGrid = __esm({
  "components/core/organisms/CardGrid.tsx"() {
    "use client";
    init_cn();
    init_format();
    init_getNestedValue();
    init_useEventBus();
    init_atoms();
    init_Badge();
    init_Box();
    init_Typography();
    init_Stack();
    init_Pagination();
    fieldLabel = humanizeFieldName;
    STATUS_FIELDS = /* @__PURE__ */ new Set(["status", "state", "priority", "type", "category", "role", "level", "tier"]);
    gapStyles3 = {
      none: "gap-0",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    };
    alignStyles2 = {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch"
    };
    CardGrid = ({
      minCardWidth = 280,
      maxCols,
      gap = "md",
      alignItems = "stretch",
      className,
      children,
      entity,
      isLoading = false,
      error = null,
      page,
      pageSize,
      totalCount,
      // CardGrid-specific
      fields,
      fieldNames,
      columns,
      itemActions,
      showTotal = true,
      imageField
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const effectiveFieldNames = normalizeFields(fields).length > 0 ? normalizeFields(fields) : fieldNames ?? normalizeFields(columns);
      const gridTemplateColumns = `repeat(auto-fit, minmax(min(${minCardWidth}px, 100%), 1fr))`;
      const normalizedData = Array.isArray(entity) ? entity : entity ? [entity] : [];
      const resolvedPage = page ?? 1;
      const resolvedTotalPages = totalCount && pageSize ? Math.ceil(totalCount / pageSize) : 1;
      const handlePageChange = (newPage) => {
        eventBus.emit("UI:PAGINATE", { page: newPage, pageSize });
      };
      const titleField = effectiveFieldNames?.[0];
      const statusField = effectiveFieldNames?.find((f3) => STATUS_FIELDS.has(f3.toLowerCase()));
      const bodyFields = effectiveFieldNames?.filter((f3) => f3 !== titleField && f3 !== statusField) ?? [];
      const primaryActions = itemActions?.filter((a) => a.variant !== "danger") ?? [];
      const dangerActions = itemActions?.filter((a) => a.variant === "danger") ?? [];
      const handleActionClick = (action, itemData) => (e) => {
        e.stopPropagation();
        if (action.navigatesTo) {
          const url = action.navigatesTo.replace(/\{\{row\.(\w+(?:\.\w+)*)\}\}/g, (_, field) => {
            const value = getNestedValue(itemData, field);
            return value !== void 0 && value !== null ? String(value) : "";
          });
          eventBus.emit("UI:NAVIGATE", { url, row: itemData });
          return;
        }
        if (action.event) {
          const payload = {
            id: itemData.id,
            row: itemData
          };
          eventBus.emit(`UI:${action.event}`, payload);
        }
        if (action.onClick) {
          action.onClick(itemData);
        }
      };
      const renderContent = () => {
        if (children) {
          return children;
        }
        if (isLoading) {
          return /* @__PURE__ */ jsx(Box, { className: "col-span-full text-center py-8 text-muted-foreground", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: t("loading.items") }) });
        }
        if (error) {
          return /* @__PURE__ */ jsx(Box, { className: "col-span-full text-center py-8 text-error", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: t("error.loadFailed", { message: error.message }) }) });
        }
        if (normalizedData.length === 0) {
          return /* @__PURE__ */ jsx(Box, { className: "col-span-full text-center py-12 text-muted-foreground", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: t("empty.noItems") || "No items found" }) });
        }
        return normalizedData.map((item, index) => {
          const itemData = item;
          const id = itemData.id || String(index);
          const titleValue = titleField ? getNestedValue(itemData, titleField) : void 0;
          const statusValue = statusField ? getNestedValue(itemData, statusField) : void 0;
          return /* @__PURE__ */ jsxs(
            Box,
            {
              "data-entity-row": true,
              className: cn(
                "bg-card rounded-lg border border-border",
                "shadow-sm hover:shadow-lg",
                "cursor-pointer hover:border-primary transition-all",
                "flex flex-col"
              ),
              action: "VIEW",
              actionPayload: { row: itemData },
              children: [
                imageField && (() => {
                  const imgUrl = resolveImageUrl(getNestedValue(itemData, imageField));
                  if (!imgUrl) return null;
                  return /* @__PURE__ */ jsx(Box, { className: "w-full aspect-video overflow-hidden rounded-t-lg", children: /* @__PURE__ */ jsx(
                    "img",
                    {
                      src: imgUrl,
                      alt: titleValue !== void 0 ? String(titleValue) : "",
                      className: "w-full h-full object-cover",
                      loading: "lazy"
                    }
                  ) });
                })(),
                /* @__PURE__ */ jsx(Box, { className: "p-4 pb-0", children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "justify-between items-start", children: [
                  /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
                    titleValue !== void 0 && titleValue !== null && /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "font-semibold truncate", children: String(titleValue) }),
                    statusValue !== void 0 && statusValue !== null && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Badge, { variant: statusVariant(String(statusValue)), children: String(statusValue) }) })
                  ] }),
                  dangerActions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-shrink-0", children: dangerActions.map((action, actionIdx) => /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: handleActionClick(action, itemData),
                      "data-testid": action.event ? `action-${action.event}` : void 0,
                      "data-row-id": String(itemData.id),
                      className: "text-error hover:bg-error/10 px-2",
                      children: action.label
                    },
                    actionIdx
                  )) })
                ] }) }),
                bodyFields.length > 0 && /* @__PURE__ */ jsx(Box, { className: "px-4 py-3 flex-1", children: /* @__PURE__ */ jsx(VStack, { gap: "xs", children: bodyFields.map((field) => {
                  const value = getNestedValue(itemData, field);
                  if (value === void 0 || value === null || value === "") return null;
                  const fieldValue = value;
                  const boolVal = asBooleanValue(fieldValue);
                  if (boolVal !== null) {
                    return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "justify-between", children: [
                      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: fieldLabel(field) }),
                      boolVal ? /* @__PURE__ */ jsx(Badge, { variant: "success", children: t("common.yes") || "Yes" }) : /* @__PURE__ */ jsx(Badge, { variant: "neutral", children: t("common.no") || "No" })
                    ] }, field);
                  }
                  const displayValue = isDateField(field) ? formatDate(fieldValue) : STATUS_FIELDS.has(field.toLowerCase()) ? void 0 : String(value);
                  if (!displayValue) return null;
                  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "justify-between", children: [
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: fieldLabel(field) }),
                    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-right truncate max-w-[60%]", children: displayValue })
                  ] }, field);
                }) }) }),
                primaryActions.length > 0 && /* @__PURE__ */ jsx(Box, { className: "px-4 py-3 mt-auto border-t border-border", children: /* @__PURE__ */ jsx(HStack, { gap: "sm", className: "justify-end", children: primaryActions.map((action, actionIdx) => /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: action.variant === "primary" ? "primary" : "ghost",
                    size: "sm",
                    onClick: handleActionClick(action, itemData),
                    "data-testid": action.event ? `action-${action.event}` : void 0,
                    "data-row-id": String(itemData.id),
                    children: action.label
                  },
                  actionIdx
                )) }) })
              ]
            },
            id
          );
        });
      };
      return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "grid",
              gapStyles3[gap],
              alignStyles2[alignItems],
              maxCols === 1 && "grid-cols-1",
              maxCols === 2 && "sm:grid-cols-2",
              maxCols === 3 && "sm:grid-cols-2 lg:grid-cols-3",
              maxCols === 4 && "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
              maxCols === 5 && "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5",
              maxCols === 6 && "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6",
              className
            ),
            style: !maxCols ? { gridTemplateColumns } : void 0,
            children: renderContent()
          }
        ),
        totalCount !== void 0 && pageSize !== void 0 && resolvedTotalPages > 1 && /* @__PURE__ */ jsx(
          Pagination,
          {
            currentPage: resolvedPage,
            totalPages: resolvedTotalPages,
            onPageChange: handlePageChange,
            showTotal,
            totalItems: totalCount
          }
        )
      ] });
    };
    CardGrid.displayName = "CardGrid";
  }
});
function useSafeEventBus3() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var Carousel;
var init_Carousel = __esm({
  "components/core/molecules/Carousel.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_useSwipeGesture();
    init_Box();
    init_Stack();
    init_Button();
    Carousel = ({
      items,
      renderItem,
      children,
      autoPlay = false,
      autoPlayInterval = 5e3,
      showDots = true,
      showArrows = true,
      loop = false,
      slideChangeEvent,
      slideChangePayload,
      className
    }) => {
      const [activeIndex, setActiveIndex] = useState(0);
      const scrollRef = useRef(null);
      const autoPlayRef = useRef(null);
      const eventBus = useSafeEventBus3();
      const { t } = useTranslate();
      const safeItems = items ?? [];
      const totalSlides = safeItems.length;
      const emitSlideChange = useCallback(
        (newIndex) => {
          if (slideChangeEvent) {
            eventBus.emit(`UI:${slideChangeEvent}`, {
              index: newIndex,
              ...slideChangePayload
            });
          }
        },
        [slideChangeEvent, slideChangePayload, eventBus]
      );
      const scrollToSlide = useCallback(
        (index) => {
          const container = scrollRef.current;
          if (!container) return;
          const slideWidth = container.offsetWidth;
          container.scrollTo({
            left: slideWidth * index,
            behavior: "smooth"
          });
        },
        []
      );
      const goToSlide = useCallback(
        (index) => {
          let targetIndex = index;
          if (loop) {
            if (targetIndex < 0) targetIndex = totalSlides - 1;
            if (targetIndex >= totalSlides) targetIndex = 0;
          } else {
            targetIndex = Math.max(0, Math.min(totalSlides - 1, targetIndex));
          }
          setActiveIndex(targetIndex);
          scrollToSlide(targetIndex);
          emitSlideChange(targetIndex);
        },
        [loop, totalSlides, scrollToSlide, emitSlideChange]
      );
      const goNext = useCallback(() => {
        goToSlide(activeIndex + 1);
      }, [goToSlide, activeIndex]);
      const goPrev = useCallback(() => {
        goToSlide(activeIndex - 1);
      }, [goToSlide, activeIndex]);
      const swipeHandlers = useSwipeGesture(
        {
          onSwipeLeft: goNext,
          onSwipeRight: goPrev
        },
        { threshold: 40 }
      );
      useEffect(() => {
        if (!autoPlay || totalSlides <= 1) return;
        autoPlayRef.current = setInterval(() => {
          setActiveIndex((prev) => {
            const next = loop ? (prev + 1) % totalSlides : Math.min(prev + 1, totalSlides - 1);
            setTimeout(() => {
              scrollToSlide(next);
              emitSlideChange(next);
            }, 0);
            return next;
          });
        }, autoPlayInterval);
        return () => {
          if (autoPlayRef.current) {
            clearInterval(autoPlayRef.current);
            autoPlayRef.current = null;
          }
        };
      }, [autoPlay, autoPlayInterval, loop, totalSlides, scrollToSlide, emitSlideChange]);
      const handleScroll = useCallback(() => {
        const container = scrollRef.current;
        if (!container) return;
        const slideWidth = container.offsetWidth;
        if (slideWidth === 0) return;
        const newIndex = Math.round(container.scrollLeft / slideWidth);
        setActiveIndex((prev) => {
          if (prev !== newIndex && newIndex >= 0 && newIndex < totalSlides) {
            return newIndex;
          }
          return prev;
        });
      }, [totalSlides]);
      const hasPrev = loop || activeIndex > 0;
      const hasNext = loop || activeIndex < totalSlides - 1;
      if (totalSlides === 0) return null;
      return /* @__PURE__ */ jsxs(Box, { position: "relative", overflow: "hidden", className: cn("w-full", className), children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            ref: scrollRef,
            display: "flex",
            overflow: "auto",
            className: cn(
              "w-full",
              "scroll-smooth",
              "scrollbar-none",
              "[scroll-snap-type:x_mandatory]",
              "[&::-webkit-scrollbar]:hidden",
              "[-ms-overflow-style:none]"
            ),
            style: {
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch"
            },
            onScroll: handleScroll,
            onPointerDown: swipeHandlers.onPointerDown,
            onPointerMove: swipeHandlers.onPointerMove,
            onPointerUp: swipeHandlers.onPointerUp,
            onPointerCancel: swipeHandlers.onPointerCancel,
            children: safeItems.map((item, index) => /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "flex-shrink-0 w-full",
                  "[scroll-snap-align:start]"
                ),
                style: {
                  scrollSnapAlign: "start"
                },
                children: (renderItem ?? children)?.(item, index)
              },
              index
            ))
          }
        ),
        showArrows && hasPrev && totalSlides > 1 && /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "left-2 top-1/2 -translate-y-1/2 z-10",
            children: /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: goPrev,
                "aria-label": t("aria.previousSlide"),
                className: cn(
                  "rounded-full",
                  "bg-surface/80",
                  "backdrop-blur-sm",
                  "shadow-sm",
                  "hover:bg-surface"
                ),
                children: /* @__PURE__ */ jsx(ChevronLeft, { className: "w-5 h-5" })
              }
            )
          }
        ),
        showArrows && hasNext && totalSlides > 1 && /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "right-2 top-1/2 -translate-y-1/2 z-10",
            children: /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: goNext,
                "aria-label": t("aria.nextSlide"),
                className: cn(
                  "rounded-full",
                  "bg-surface/80",
                  "backdrop-blur-sm",
                  "shadow-sm",
                  "hover:bg-surface"
                ),
                children: /* @__PURE__ */ jsx(ChevronRight, { className: "w-5 h-5" })
              }
            )
          }
        ),
        showDots && totalSlides > 1 && /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "bottom-3 left-0 right-0 z-10",
            children: /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", justify: "center", children: safeItems.map((_, index) => {
              const isActive = index === activeIndex;
              return /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn(
                    "rounded-full cursor-pointer transition-all duration-fast"
                  ),
                  style: {
                    width: isActive ? 10 : 8,
                    height: isActive ? 10 : 8,
                    backgroundColor: isActive ? "var(--color-primary)" : "var(--color-muted, #d4d4d8)",
                    opacity: isActive ? 1 : 0.6
                  },
                  onClick: () => goToSlide(index),
                  role: "button",
                  "aria-label": `Go to slide ${index + 1}`
                },
                index
              );
            }) })
          }
        )
      ] });
    };
    Carousel.displayName = "Carousel";
  }
});
var CaseStudyOrganism;
var init_CaseStudyOrganism = __esm({
  "components/marketing/organisms/CaseStudyOrganism.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Stack();
    init_Typography();
    init_SimpleGrid();
    init_CaseStudyCard();
    init_LoadingState();
    init_ErrorState();
    CaseStudyOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      heading,
      subtitle
    }) => {
      useEventBus();
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      const cols = Math.min(items.length, 3);
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("w-full", className), children: [
        (heading || subtitle) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "w-full", children: [
          heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", align: "center", children: heading }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "muted", align: "center", className: "max-w-2xl", children: subtitle })
        ] }),
        /* @__PURE__ */ jsx(SimpleGrid, { cols: cols > 0 ? cols : 1, gap: "lg", children: items.map((study) => /* @__PURE__ */ jsx(
          CaseStudyCard,
          {
            title: String(study.title ?? ""),
            description: String(study.description ?? ""),
            category: String(study.category ?? ""),
            categoryColor: study.categoryColor != null ? String(study.categoryColor) : void 0,
            href: String(study.href ?? ""),
            linkLabel: study.linkLabel != null ? String(study.linkLabel) : void 0
          },
          String(study.id ?? "")
        )) })
      ] });
    };
    CaseStudyOrganism.displayName = "CaseStudyOrganism";
  }
});
var CHART_COLORS, seriesColor, barColor, monthFormatter, formatTimeLabel, BarChart, PieChart, LineChart, ScatterChart, LOOK_FROM_CHART_TYPE, Chart;
var init_Chart = __esm({
  "components/core/molecules/Chart.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    init_useEventBus();
    CHART_COLORS = [
      "var(--color-primary)",
      "var(--color-success)",
      "var(--color-warning)",
      "var(--color-error)",
      "var(--color-info)",
      "var(--color-accent)"
    ];
    seriesColor = (series, idx) => series.color ?? CHART_COLORS[idx % CHART_COLORS.length];
    barColor = (series, sIdx, catIdx, seriesCount) => series.color ?? CHART_COLORS[(seriesCount === 1 ? catIdx : sIdx) % CHART_COLORS.length];
    monthFormatter = new Intl.DateTimeFormat(void 0, {
      month: "short",
      year: "2-digit"
    });
    formatTimeLabel = (raw) => {
      const parsed = new Date(raw);
      if (Number.isNaN(parsed.getTime())) return raw;
      return monthFormatter.format(parsed);
    };
    BarChart = ({ series, height, showValues, stack, timeAxis, histogram = false, horizontal = false, onPointClick }) => {
      const categories = useMemo(() => {
        const set = [];
        const seen = /* @__PURE__ */ new Set();
        for (const s of series) {
          for (const p of s.data) {
            if (!seen.has(p.label)) {
              seen.add(p.label);
              set.push(p.label);
            }
          }
        }
        return set;
      }, [series]);
      const valueAt = useCallback(
        (s, label) => {
          const p = s.data.find((d) => d.label === label);
          return p ? p.value : 0;
        },
        []
      );
      const columnTotals = useMemo(() => {
        if (stack === "none") return null;
        return categories.map(
          (label) => series.reduce((sum, s) => sum + valueAt(s, label), 0)
        );
      }, [categories, series, stack, valueAt]);
      const maxValue = useMemo(() => {
        if (stack === "normalize") return 100;
        if (stack === "stack" && columnTotals) {
          return Math.max(...columnTotals, 1);
        }
        let m = 1;
        for (const s of series) {
          for (const p of s.data) if (p.value > m) m = p.value;
        }
        return m;
      }, [series, stack, columnTotals]);
      if (horizontal) {
        return /* @__PURE__ */ jsx(VStack, { gap: "xs", align: "stretch", className: "w-full", style: { minHeight: height }, children: categories.map((label, catIdx) => {
          const displayLabel = timeAxis ? formatTimeLabel(label) : label;
          const total = columnTotals?.[catIdx] ?? 1;
          return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "w-full", children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                color: "secondary",
                className: "truncate text-right",
                style: { width: 80, flexShrink: 0 },
                children: displayLabel
              }
            ),
            /* @__PURE__ */ jsx(
              HStack,
              {
                gap: stack === "none" ? "xs" : "none",
                align: "center",
                className: "flex-1 min-w-0",
                style: { height: 24 },
                children: series.map((s, sIdx) => {
                  const value = valueAt(s, label);
                  const ratio = stack === "normalize" ? total === 0 ? 0 : value / total * 100 : value / maxValue * 100;
                  const color = barColor(s, sIdx, catIdx, series.length);
                  return /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: "h-full rounded-r-sm transition-all duration-slow ease-standard min-w-[2px] cursor-pointer hover:opacity-80",
                      style: {
                        width: `${ratio}%`,
                        backgroundColor: color
                      },
                      onClick: () => onPointClick?.(
                        { label, value, color },
                        s.name
                      ),
                      title: `${s.name}: ${value}`
                    },
                    s.name
                  );
                })
              }
            ),
            showValues && series.length === 1 && /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                color: "secondary",
                className: "tabular-nums",
                style: { width: 40, flexShrink: 0 },
                children: valueAt(series[0], label)
              }
            )
          ] }, label);
        }) });
      }
      return /* @__PURE__ */ jsx(
        HStack,
        {
          gap: histogram ? "none" : "xs",
          align: "end",
          className: "w-full",
          style: { height },
          children: categories.map((label, catIdx) => {
            const displayLabel = timeAxis ? formatTimeLabel(label) : label;
            if (stack === "none") {
              return /* @__PURE__ */ jsxs(
                VStack,
                {
                  gap: "xs",
                  align: "center",
                  flex: true,
                  className: "min-w-0",
                  style: { height: "100%" },
                  children: [
                    /* @__PURE__ */ jsx(HStack, { gap: histogram ? "none" : "xs", align: "end", justify: histogram ? void 0 : "center", className: "w-full flex-1 min-h-0", children: series.map((s, sIdx) => {
                      const value = valueAt(s, label);
                      const barHeight = value / maxValue * 100;
                      const color = barColor(s, sIdx, catIdx, series.length);
                      return /* @__PURE__ */ jsx(
                        Box,
                        {
                          className: cn(
                            "rounded-t-sm transition-all duration-slow ease-standard min-h-[4px] cursor-pointer hover:opacity-80",
                            histogram ? "flex-1 mx-0" : "flex-1"
                          ),
                          style: {
                            height: `${barHeight}%`,
                            // Cap width so a lone category doesn't paint the whole plot as one solid block; narrow columns are unaffected (flex-1 binds first).
                            ...!histogram && { maxWidth: 72 },
                            backgroundColor: color
                          },
                          onClick: () => onPointClick?.(
                            { label, value, color },
                            s.name
                          ),
                          title: `${s.name}: ${value}`
                        },
                        s.name
                      );
                    }) }),
                    showValues && series.length === 1 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "tabular-nums", children: valueAt(series[0], label) }),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        color: "secondary",
                        className: "truncate w-full text-center",
                        children: displayLabel
                      }
                    )
                  ]
                },
                label
              );
            }
            const total = columnTotals?.[catIdx] ?? 1;
            return /* @__PURE__ */ jsxs(
              VStack,
              {
                gap: "xs",
                align: "center",
                flex: true,
                className: "min-w-0",
                style: { height: "100%" },
                children: [
                  /* @__PURE__ */ jsx(VStack, { gap: "none", className: "w-full flex-1 min-h-0", justify: "end", children: series.map((s, sIdx) => {
                    const value = valueAt(s, label);
                    const ratio = stack === "normalize" ? total === 0 ? 0 : value / total * 100 : value / maxValue * 100;
                    const color = barColor(s, sIdx, catIdx, series.length);
                    return /* @__PURE__ */ jsx(
                      Box,
                      {
                        className: "w-full transition-all duration-slow ease-standard cursor-pointer hover:opacity-80",
                        style: {
                          height: `${ratio}%`,
                          backgroundColor: color
                        },
                        onClick: () => onPointClick?.(
                          { label, value, color },
                          s.name
                        ),
                        title: `${s.name}: ${value}`
                      },
                      s.name
                    );
                  }) }),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      color: "secondary",
                      className: "truncate w-full text-center",
                      children: displayLabel
                    }
                  )
                ]
              },
              label
            );
          })
        }
      );
    };
    PieChart = ({ data, height, showValues, donut = false, onPointClick }) => {
      const total = data.reduce((sum, d) => sum + d.value, 0);
      const size = Math.min(height, 200);
      const radius = size / 2 - 8;
      const innerRadius = donut ? radius * 0.6 : 0;
      const center = size / 2;
      const segments = useMemo(() => {
        if (!Number.isFinite(total) || total <= 0) return [];
        let currentAngle = -Math.PI / 2;
        return data.map((point, idx) => {
          const angle = point.value / total * 2 * Math.PI;
          const startAngle = currentAngle;
          const endAngle = currentAngle + angle;
          currentAngle = endAngle;
          const largeArc = angle > Math.PI ? 1 : 0;
          const x1 = center + radius * Math.cos(startAngle);
          const y1 = center + radius * Math.sin(startAngle);
          const x2 = center + radius * Math.cos(endAngle);
          const y2 = center + radius * Math.sin(endAngle);
          const fullCircle = angle >= 2 * Math.PI - 1e-9;
          const midAngle = startAngle + angle / 2;
          const xm = center + radius * Math.cos(midAngle);
          const ym = center + radius * Math.sin(midAngle);
          let d;
          if (innerRadius > 0) {
            const ix1 = center + innerRadius * Math.cos(startAngle);
            const iy1 = center + innerRadius * Math.sin(startAngle);
            const ix2 = center + innerRadius * Math.cos(endAngle);
            const iy2 = center + innerRadius * Math.sin(endAngle);
            if (fullCircle) {
              const ixm = center + innerRadius * Math.cos(midAngle);
              const iym = center + innerRadius * Math.sin(midAngle);
              d = `M ${ix1} ${iy1} L ${x1} ${y1} A ${radius} ${radius} 0 1 1 ${xm} ${ym} A ${radius} ${radius} 0 1 1 ${x2} ${y2} L ${ix2} ${iy2} A ${innerRadius} ${innerRadius} 0 1 0 ${ixm} ${iym} A ${innerRadius} ${innerRadius} 0 1 0 ${ix1} ${iy1} Z`;
            } else {
              d = `M ${ix1} ${iy1} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} L ${ix2} ${iy2} A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${ix1} ${iy1} Z`;
            }
          } else if (fullCircle) {
            d = `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 1 1 ${xm} ${ym} A ${radius} ${radius} 0 1 1 ${x2} ${y2} Z`;
          } else {
            d = `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`;
          }
          return {
            d,
            color: point.color || CHART_COLORS[idx % CHART_COLORS.length],
            label: point.label,
            value: point.value,
            percentage: (point.value / total * 100).toFixed(1)
          };
        });
      }, [data, total, radius, innerRadius, center]);
      return /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "center", justify: "center", className: "w-full", children: [
        /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, children: [
          segments.map((seg, idx) => /* @__PURE__ */ jsx(
            "path",
            {
              d: seg.d,
              fill: seg.color,
              stroke: "var(--color-card)",
              strokeWidth: "2",
              className: "transition-opacity duration-fast hover:opacity-80 cursor-pointer",
              onClick: () => onPointClick?.(
                { label: seg.label, value: seg.value, color: seg.color },
                "default"
              )
            },
            idx
          )),
          donut && /* @__PURE__ */ jsx(
            "text",
            {
              x: center,
              y: center,
              textAnchor: "middle",
              dominantBaseline: "middle",
              fill: "var(--color-foreground)",
              fontSize: "14",
              fontWeight: "bold",
              children: total
            }
          )
        ] }),
        showValues && /* @__PURE__ */ jsx(VStack, { gap: "xs", children: segments.map((seg, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "w-3 h-3 rounded-sm flex-shrink-0",
              style: { backgroundColor: seg.color }
            }
          ),
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "truncate", children: [
            seg.label,
            ": ",
            seg.percentage,
            "%"
          ] })
        ] }, idx)) })
      ] });
    };
    LineChart = ({ series, height, showValues, fill = false, timeAxis, onPointClick }) => {
      const width = 400;
      const padding = { top: 20, right: 20, bottom: 30, left: 40 };
      const chartWidth = width - padding.left - padding.right;
      const chartHeight = height - padding.top - padding.bottom;
      const labels = useMemo(() => {
        const seen = /* @__PURE__ */ new Set();
        const out = [];
        for (const s of series) {
          for (const p of s.data) {
            if (!seen.has(p.label)) {
              seen.add(p.label);
              out.push(p.label);
            }
          }
        }
        return out;
      }, [series]);
      const maxValue = useMemo(() => {
        let m = 1;
        for (const s of series) {
          for (const p of s.data) if (p.value > m) m = p.value;
        }
        return m;
      }, [series]);
      const xFor = useCallback(
        (idx) => padding.left + idx / Math.max(labels.length - 1, 1) * chartWidth,
        [labels.length, chartWidth, padding.left]
      );
      const yFor = useCallback(
        (value) => padding.top + chartHeight - value / maxValue * chartHeight,
        [maxValue, chartHeight, padding.top]
      );
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          width: "100%",
          height,
          viewBox: `0 0 ${width} ${height}`,
          preserveAspectRatio: "xMidYMid meet",
          children: [
            [0, 0.25, 0.5, 0.75, 1].map((frac) => {
              const y = padding.top + chartHeight * (1 - frac);
              return /* @__PURE__ */ jsx(
                "line",
                {
                  x1: padding.left,
                  y1: y,
                  x2: width - padding.right,
                  y2: y,
                  stroke: "var(--color-border)",
                  strokeDasharray: "4 4",
                  opacity: 0.5
                },
                frac
              );
            }),
            series.map((s, sIdx) => {
              const color = seriesColor(s, sIdx);
              const points = labels.map((label, idx) => {
                const point = s.data.find((d) => d.label === label);
                return {
                  x: xFor(idx),
                  y: yFor(point ? point.value : 0),
                  value: point ? point.value : 0,
                  label
                };
              });
              const linePath = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
              const areaPath = `${linePath} L ${points[points.length - 1]?.x ?? 0} ${padding.top + chartHeight} L ${padding.left} ${padding.top + chartHeight} Z`;
              return /* @__PURE__ */ jsxs("g", { children: [
                fill && /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: areaPath,
                    fill: color,
                    opacity: series.length > 1 ? 0.08 : 0.1
                  }
                ),
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: linePath,
                    fill: "none",
                    stroke: color,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeDasharray: s.dashed ? "6 4" : void 0
                  }
                ),
                points.map((p, idx) => /* @__PURE__ */ jsxs("g", { children: [
                  /* @__PURE__ */ jsx(
                    "circle",
                    {
                      cx: p.x,
                      cy: p.y,
                      r: "4",
                      fill: "var(--color-card)",
                      stroke: color,
                      strokeWidth: "2",
                      className: "cursor-pointer",
                      onClick: () => onPointClick?.(
                        { label: p.label, value: p.value, color },
                        s.name
                      )
                    }
                  ),
                  showValues && series.length === 1 && /* @__PURE__ */ jsx(
                    "text",
                    {
                      x: p.x,
                      y: p.y - 10,
                      textAnchor: "middle",
                      fill: "var(--color-foreground)",
                      fontSize: "10",
                      fontWeight: "500",
                      children: p.value
                    }
                  )
                ] }, idx))
              ] }, s.name);
            }),
            labels.map((label, idx) => /* @__PURE__ */ jsx(
              "text",
              {
                x: xFor(idx),
                y: height - 8,
                textAnchor: "middle",
                fill: "var(--color-muted-foreground)",
                fontSize: "9",
                children: timeAxis ? formatTimeLabel(label) : label
              },
              label
            ))
          ]
        }
      );
    };
    ScatterChart = ({ data, height, onPointClick }) => {
      const width = 400;
      const padding = { top: 20, right: 20, bottom: 30, left: 40 };
      const chartWidth = width - padding.left - padding.right;
      const chartHeight = height - padding.top - padding.bottom;
      const { minX, maxX, minY, maxY } = useMemo(() => {
        if (data.length === 0) {
          return { minX: 0, maxX: 1, minY: 0, maxY: 1 };
        }
        let mnX = data[0].x;
        let mxX = data[0].x;
        let mnY = data[0].y;
        let mxY = data[0].y;
        for (const p of data) {
          if (p.x < mnX) mnX = p.x;
          if (p.x > mxX) mxX = p.x;
          if (p.y < mnY) mnY = p.y;
          if (p.y > mxY) mxY = p.y;
        }
        return { minX: mnX, maxX: mxX, minY: mnY, maxY: mxY };
      }, [data]);
      const rangeX = maxX - minX || 1;
      const rangeY = maxY - minY || 1;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          width: "100%",
          height,
          viewBox: `0 0 ${width} ${height}`,
          preserveAspectRatio: "xMidYMid meet",
          children: [
            [0, 0.25, 0.5, 0.75, 1].map((frac) => {
              const y = padding.top + chartHeight * (1 - frac);
              return /* @__PURE__ */ jsx(
                "line",
                {
                  x1: padding.left,
                  y1: y,
                  x2: width - padding.right,
                  y2: y,
                  stroke: "var(--color-border)",
                  strokeDasharray: "4 4",
                  opacity: 0.5
                },
                frac
              );
            }),
            data.map((p, idx) => {
              const cx = padding.left + (p.x - minX) / rangeX * chartWidth;
              const cy = padding.top + chartHeight - (p.y - minY) / rangeY * chartHeight;
              const r = p.size ?? 5;
              const color = p.color ?? CHART_COLORS[idx % CHART_COLORS.length];
              return /* @__PURE__ */ jsx(
                "circle",
                {
                  cx,
                  cy,
                  r,
                  fill: color,
                  opacity: 0.7,
                  className: "cursor-pointer hover:opacity-100",
                  onClick: () => onPointClick?.(
                    {
                      label: p.label ?? `(${p.x}, ${p.y})`,
                      value: p.y,
                      color
                    },
                    "default"
                  ),
                  children: /* @__PURE__ */ jsx("title", { children: p.label ?? `(${p.x}, ${p.y})` })
                },
                idx
              );
            }),
            /* @__PURE__ */ jsx(
              "text",
              {
                x: padding.left,
                y: height - 8,
                fill: "var(--color-muted-foreground)",
                fontSize: "9",
                children: minX.toFixed(1)
              }
            ),
            /* @__PURE__ */ jsx(
              "text",
              {
                x: width - padding.right,
                y: height - 8,
                textAnchor: "end",
                fill: "var(--color-muted-foreground)",
                fontSize: "9",
                children: maxX.toFixed(1)
              }
            )
          ]
        }
      );
    };
    LOOK_FROM_CHART_TYPE = {
      bar: "bar-vertical",
      line: "line",
      pie: "pie",
      area: "area",
      donut: "donut",
      scatter: "scatter",
      histogram: "histogram"
    };
    Chart = ({
      title,
      subtitle,
      chartType,
      look,
      series,
      data: simpleData,
      scatterData,
      height = 200,
      showLegend = true,
      showValues = false,
      stack = "none",
      timeAxis = false,
      drillEvent,
      actions,
      isLoading = false,
      error,
      className
    }) => {
      const resolvedLook = look ?? (chartType ? LOOK_FROM_CHART_TYPE[chartType] : "bar-vertical");
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleAction = useCallback(
        (action) => {
          if (action.event) {
            eventBus.emit(`UI:${action.event}`, {});
          }
        },
        [eventBus]
      );
      const handlePointClick = useCallback(
        (point, seriesName) => {
          if (drillEvent) {
            eventBus.emit(`UI:${drillEvent}`, {
              label: point.label,
              value: point.value,
              seriesLabel: seriesName === "default" ? void 0 : seriesName
            });
          }
        },
        [drillEvent, eventBus]
      );
      const normalizedSeries = useMemo(() => {
        if (series && series.length > 0) return series;
        if (simpleData) return [{ name: "default", data: simpleData }];
        return [];
      }, [simpleData, series]);
      const firstSeriesData = normalizedSeries[0]?.data ?? [];
      const hasContent = resolvedLook === "scatter" ? (scatterData?.length ?? 0) > 0 : normalizedSeries.some((s) => s.data.length > 0);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.chartError"),
            message: error.message,
            className
          }
        );
      }
      if (!hasContent) {
        return /* @__PURE__ */ jsx(EmptyState, { title: t("empty.noData"), description: t("empty.noData"), className });
      }
      return /* @__PURE__ */ jsx(Card, { className: cn("p-6", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        (title || subtitle || actions && actions.length > 0) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", children: [
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
            title && /* @__PURE__ */ jsx(Typography, { variant: "h5", weight: "semibold", children: title }),
            subtitle && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: subtitle })
          ] }),
          actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", children: actions.map((action, idx) => /* @__PURE__ */ jsx(
            Badge,
            {
              variant: "default",
              className: "cursor-pointer hover:opacity-80 transition-opacity",
              onClick: () => handleAction(action),
              children: action.label
            },
            idx
          )) })
        ] }),
        /* @__PURE__ */ jsxs(Box, { className: "w-full", children: [
          resolvedLook === "bar-vertical" && /* @__PURE__ */ jsx(
            BarChart,
            {
              series: normalizedSeries,
              height,
              showValues,
              stack,
              timeAxis,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "bar-horizontal" && /* @__PURE__ */ jsx(
            BarChart,
            {
              series: normalizedSeries,
              height,
              showValues,
              stack,
              timeAxis,
              horizontal: true,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "histogram" && /* @__PURE__ */ jsx(
            BarChart,
            {
              series: normalizedSeries,
              height,
              showValues,
              stack: "none",
              timeAxis: false,
              histogram: true,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "line" && /* @__PURE__ */ jsx(
            LineChart,
            {
              series: normalizedSeries,
              height,
              showValues,
              timeAxis,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "area" && /* @__PURE__ */ jsx(
            LineChart,
            {
              series: normalizedSeries,
              height,
              showValues,
              timeAxis,
              fill: true,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "pie" && /* @__PURE__ */ jsx(
            PieChart,
            {
              data: firstSeriesData,
              height,
              showValues: showLegend,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "donut" && /* @__PURE__ */ jsx(
            PieChart,
            {
              data: firstSeriesData,
              height,
              showValues: showLegend,
              donut: true,
              onPointClick: handlePointClick
            }
          ),
          resolvedLook === "scatter" && /* @__PURE__ */ jsx(
            ScatterChart,
            {
              data: scatterData ?? [],
              height,
              onPointClick: handlePointClick
            }
          )
        ] }),
        showLegend && normalizedSeries.length > 1 && /* @__PURE__ */ jsx(HStack, { gap: "md", justify: "center", wrap: true, children: normalizedSeries.map((s, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "w-3 h-3 rounded-full flex-shrink-0",
              style: { backgroundColor: seriesColor(s, idx) }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: s.name })
        ] }, idx)) })
      ] }) });
    };
    Chart.displayName = "Chart";
  }
});
var ChartLegend;
var init_ChartLegend = __esm({
  "components/core/molecules/ChartLegend.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    ChartLegend = ({
      items,
      className,
      direction = "horizontal"
    }) => {
      const Wrapper = direction === "horizontal" ? HStack : VStack;
      return /* @__PURE__ */ jsx(Wrapper, { gap: "md", className: cn("flex-wrap", className), children: items.map((item) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "rounded-full shrink-0",
            style: {
              width: 10,
              height: 10,
              backgroundColor: item.color
            }
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: item.label })
      ] }, item.label)) });
    };
    ChartLegend.displayName = "ChartLegend";
  }
});

// components/core/organisms/trace-edit-focus.ts
function asString(v) {
  return typeof v === "string" ? v : void 0;
}
function asLevel(v) {
  if (typeof v === "string" && EDIT_FOCUS_LEVELS.has(v)) {
    return v;
  }
  return "node";
}
function isEventPayload(v) {
  return v !== null && v !== void 0 && typeof v === "object" && !Array.isArray(v) && !(v instanceof Date);
}
function parseEditFocus(value) {
  if (!isEventPayload(value)) return null;
  const payload = value;
  const orbital = asString(payload.orbital);
  if (orbital === void 0 || orbital.length === 0) return null;
  const focus = {
    level: asLevel(payload.level),
    orbital,
    label: asString(payload.label) ?? orbital
  };
  const trait = asString(payload.trait);
  if (trait !== void 0) focus.trait = trait;
  const transition = asString(payload.transition);
  if (transition !== void 0) focus.transition = transition;
  const state = asString(payload.state);
  if (state !== void 0) focus.state = state;
  const slot = asString(payload.slot);
  if (slot !== void 0) focus.slot = slot;
  const path = asString(payload.path);
  if (path !== void 0) focus.path = path;
  const patternType = asString(payload.patternType);
  if (patternType !== void 0) focus.patternType = patternType;
  const entity = asString(payload.entity);
  if (entity !== void 0) focus.entity = entity;
  const source = asString(payload.source);
  if (source !== void 0) focus.source = source;
  return focus;
}
var ELEMENT_SELECTED_EVENT, EDIT_FOCUS_LEVELS;
var init_trace_edit_focus = __esm({
  "components/core/organisms/trace-edit-focus.ts"() {
    ELEMENT_SELECTED_EVENT = "UI:ELEMENT_SELECTED";
    EDIT_FOCUS_LEVELS = /* @__PURE__ */ new Set([
      "node",
      "slot",
      "field",
      "effect",
      "trait",
      "page",
      "orbital"
    ]);
  }
});
function getJepaBadgeVariant(probability) {
  if (probability >= 0.9) return "success";
  if (probability >= 0.5) return "warning";
  return "danger";
}
function ChatBar({
  status = "idle",
  activeGate,
  jepaValidity,
  placeholder,
  context,
  className
}) {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const [inputValue, setInputValue] = useState("");
  const [focus, setFocus] = useState(null);
  const clearFocus = useCallback(() => {
    setFocus(null);
    eventBus.emit(ELEMENT_SELECTED_EVENT, { focus: null });
  }, [eventBus]);
  const handleKeyDown = useCallback((e) => {
    if (e.key !== "Enter" || e.shiftKey) return;
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    e.preventDefault();
    eventBus.emit("UI:CHAT_SEND", { message: trimmed });
  }, [inputValue, eventBus]);
  useEffect(() => {
    const unsubSend = eventBus.on("UI:CHAT_SEND", () => {
      setInputValue("");
      setFocus(null);
    });
    const unsubSelect = eventBus.on(ELEMENT_SELECTED_EVENT, (e) => {
      setFocus(parseEditFocus(e.payload?.focus));
    });
    return () => {
      unsubSend();
      unsubSelect();
    };
  }, [eventBus]);
  const trailingAction = status === "error" ? /* @__PURE__ */ jsxs(Button, { variant: "secondary", size: "sm", action: "RETRY_GENERATION", className: "rounded-none flex-shrink-0 h-auto", children: [
    /* @__PURE__ */ jsx(Icon, { name: "refresh-cw", size: "xs" }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("openFile.retry") })
  ] }) : status === "running" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: "PAUSE",
        title: t("chatBar.pauseTheAgentYouCanEdit"),
        className: "rounded-none flex-shrink-0 h-auto",
        children: /* @__PURE__ */ jsx(Icon, { name: "pause", size: "xs" })
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: "STOP",
        title: t("chatBar.cancelGeneration"),
        className: "rounded-none flex-shrink-0 h-auto border-l border-[var(--color-border)]",
        children: /* @__PURE__ */ jsx(Icon, { name: "square", size: "xs" })
      }
    )
  ] }) : status === "paused" ? /* @__PURE__ */ jsxs(
    Button,
    {
      variant: "primary",
      size: "sm",
      action: "RESUME",
      title: t("chatBar.resumeTheAgentYourCanvasEdits"),
      className: "rounded-none flex-shrink-0 h-auto",
      children: [
        /* @__PURE__ */ jsx(Icon, { name: "play", size: "xs" }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("chatBar.resume") })
      ]
    }
  ) : /* @__PURE__ */ jsx(
    Button,
    {
      variant: "primary",
      size: "sm",
      action: "CHAT_SEND",
      actionPayload: { message: inputValue.trim() },
      disabled: !inputValue.trim(),
      "aria-label": t("chatBar.sendMessage"),
      className: "rounded-none flex-shrink-0 h-auto",
      children: /* @__PURE__ */ jsx(Icon, { name: "send", size: "xs" })
    }
  );
  return /* @__PURE__ */ jsxs(Box, { className: `border-t border-[var(--color-border)] bg-[var(--color-card)] ${className ?? ""}`, children: [
    focus && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "items-center px-4 pt-2", children: /* @__PURE__ */ jsxs(Badge, { variant: "secondary", size: "sm", className: "flex items-center gap-1 max-w-full", children: [
      /* @__PURE__ */ jsx(Icon, { name: "mouse-pointer-2", size: "xs" }),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-inherit truncate", children: [
        t("chatBar.editing"),
        ": ",
        focus.label
      ] }),
      /* @__PURE__ */ jsx(
        Box,
        {
          onClick: clearFocus,
          title: t("chatBar.clearSelection"),
          className: "cursor-pointer flex items-center ml-1 hover:opacity-70",
          children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center px-4 py-2", children: [
      context && /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", className: "whitespace-nowrap flex-shrink-0", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-inherit", children: context }) }),
      /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0 flex items-stretch rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-background)] focus-within:border-[var(--color-primary)] overflow-hidden", children: [
        /* @__PURE__ */ jsx(
          Textarea,
          {
            value: inputValue,
            placeholder: placeholder ?? t("chatBar.askTheAgentAnything"),
            onChange: (e) => setInputValue(e.target.value),
            onKeyDown: handleKeyDown,
            rows: 1,
            className: "flex-1 min-w-0 min-h-0 text-sm border-0 rounded-none shadow-none bg-transparent resize-none focus:ring-0"
          }
        ),
        trailingAction
      ] }),
      (activeGate || jepaValidity !== void 0) && /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center flex-shrink-0", children: [
        activeGate && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "whitespace-nowrap", children: activeGate }),
        jepaValidity !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: getJepaBadgeVariant(jepaValidity), size: "sm", children: /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-inherit", children: [
          (jepaValidity * 100).toFixed(1),
          "%"
        ] }) })
      ] })
    ] })
  ] });
}
var init_ChatBar = __esm({
  "components/core/organisms/ChatBar.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_Typography();
    init_Button();
    init_Badge();
    init_Icon();
    init_Textarea();
    init_useEventBus();
    init_trace_edit_focus();
    ChatBar.displayName = "ChatBar";
  }
});
function bondPerpendicular(a, b) {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const px = dy;
  const py = -dx;
  const len = Math.sqrt(px * px + py * py);
  if (len < 1e-6) return [1, 0, 0];
  return [px / len, py / len, 0];
}
var chemistryLog, CHEM_BOND_STATE_COLOR, LONE_PAIR_ANGLES, ChemistryCanvas;
var init_ChemistryCanvas = __esm({
  "components/learning/molecules/ChemistryCanvas.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_LearningCanvas();
    init_learningScene3D();
    chemistryLog = createLogger("almadar:ui:chemistry-canvas");
    CHEM_BOND_STATE_COLOR = {
      default: "#6b7280",
      forming: "#16a34a",
      breaking: "#dc2626",
      highlight: "#f59e0b"
    };
    LONE_PAIR_ANGLES = [-90, 0, 90, 180];
    ChemistryCanvas = ({
      className,
      width = 600,
      height = 400,
      title,
      backgroundColor,
      mode = "2d",
      camera,
      lighting,
      post,
      atoms = [],
      bonds = [],
      arrows = [],
      bondStyle = "thick",
      containers = [],
      equation,
      equationColor,
      lattice3d,
      shapes = [],
      readouts,
      traces,
      showGrid,
      shadows,
      interactive,
      animate = false,
      onShapeClick,
      isLoading,
      error
    }) => {
      const derivedShapes = useMemo(() => {
        const out = [];
        const atomById = /* @__PURE__ */ new Map();
        for (const a of atoms) {
          if (a.id) atomById.set(a.id, a);
        }
        for (const c of containers) {
          const color = c.color ?? "#64748b";
          if (c.level != null) {
            const lv = c.level;
            out.push({
              type: "rect",
              x: c.x + 1,
              y: c.y + c.height * (1 - lv),
              width: c.width - 2,
              height: c.height * lv - 1,
              color: c.levelColor ?? "#60a5fa",
              fill: c.levelColor ?? "#60a5fa",
              opacity: 0.5
            });
          }
          out.push({
            type: "rect",
            x: c.x,
            y: c.y,
            width: c.width,
            height: c.height,
            color,
            fill: c.fill,
            lineWidth: c.lineWidth ?? 2
          });
          const divider = c.divider ?? "none";
          if (divider !== "none") {
            out.push({
              type: "line",
              x1: c.x + c.width / 2,
              y1: c.y,
              x2: c.x + c.width / 2,
              y2: c.y + c.height,
              color: c.dividerColor ?? color,
              ...divider === "dashed" || divider === "dotted" ? { dash: divider } : {}
            });
          }
          if (c.leftLabel) {
            out.push({
              type: "text",
              x: c.x + c.width * 0.25,
              y: c.y + 12,
              text: c.leftLabel,
              color: "#374151",
              fontSize: 11,
              align: "center"
            });
          }
          if (c.rightLabel) {
            out.push({
              type: "text",
              x: c.x + c.width * 0.75,
              y: c.y + 12,
              text: c.rightLabel,
              color: "#374151",
              fontSize: 11,
              align: "center"
            });
          }
          if (c.label) {
            out.push({
              type: "text",
              x: c.x + c.width / 2,
              y: c.y + c.height + 12,
              text: c.label,
              color: "#111827",
              fontSize: 12,
              align: "center"
            });
          }
        }
        for (const b of bonds) {
          const a = atomById.get(b.from);
          const c = atomById.get(b.to);
          if (!a || !c) continue;
          const state = b.state ?? "default";
          const color = b.color ?? CHEM_BOND_STATE_COLOR[state];
          const dash = state === "forming" || state === "breaking" ? "dashed" : void 0;
          if (bondStyle === "parallel") {
            const dx = c.x - a.x;
            const dy = c.y - a.y;
            const dist = Math.max(1e-6, Math.hypot(dx, dy));
            const ux = dx / dist;
            const uy = dy / dist;
            const px = -uy;
            const py = ux;
            const offsets = b.type === "double" ? [-3, 3] : b.type === "triple" ? [-4, 0, 4] : [0];
            for (const off of offsets) {
              out.push({
                type: "line",
                x1: a.x + px * off,
                y1: a.y + py * off,
                x2: c.x + px * off,
                y2: c.y + py * off,
                color,
                lineWidth: 2,
                ...dash ? { dash } : {}
              });
            }
          } else {
            const strokeWidth = b.type === "double" ? 4 : b.type === "triple" ? 6 : 2;
            out.push({
              type: "line",
              x1: a.x,
              y1: a.y,
              x2: c.x,
              y2: c.y,
              color,
              lineWidth: strokeWidth,
              ...dash ? { dash } : {}
            });
          }
        }
        for (const a of arrows) {
          const angle = (a.angle ?? 0) * (Math.PI / 180);
          const len = a.length ?? 60;
          const x2 = a.x + Math.cos(angle) * len;
          const y2 = a.y + Math.sin(angle) * len;
          out.push({
            type: "arrow",
            x1: a.x,
            y1: a.y,
            x2,
            y2,
            color: a.color ?? "#dc2626",
            lineWidth: 2
          });
          if (a.label) {
            out.push({
              type: "text",
              x: (a.x + x2) / 2,
              y: (a.y + y2) / 2 - 10,
              text: a.label,
              color: "#111827",
              fontSize: 12,
              align: "center"
            });
          }
        }
        for (const a of atoms) {
          out.push({
            type: "circle",
            x: a.x,
            y: a.y,
            radius: a.radius ?? 14,
            color: a.color ?? "#2563eb",
            fill: a.color ?? "#2563eb",
            id: a.id
          });
          if (a.element) {
            out.push({
              type: "text",
              x: a.x,
              y: a.y,
              text: a.element,
              color: "#ffffff",
              fontSize: 12,
              align: "center"
            });
          }
          const r = a.radius ?? 14;
          if (a.charge) {
            out.push({
              type: "text",
              x: a.x + r * 0.85,
              y: a.y - r * 0.85,
              text: a.charge,
              color: "#111827",
              fontSize: 9,
              align: "left"
            });
          }
          const lonePairs = Math.max(0, Math.min(4, a.lonePairs ?? 0));
          for (let k = 0; k < lonePairs; k++) {
            const angleRad = LONE_PAIR_ANGLES[k] * Math.PI / 180;
            const cx = a.x + (r + 6) * Math.cos(angleRad);
            const cy = a.y + (r + 6) * Math.sin(angleRad);
            const perpX = -Math.sin(angleRad);
            const perpY = Math.cos(angleRad);
            for (const sign of [1, -1]) {
              out.push({
                type: "circle",
                x: cx + perpX * 2.5 * sign,
                y: cy + perpY * 2.5 * sign,
                radius: 1.5,
                color: "#374151",
                fill: "#374151"
              });
            }
          }
        }
        if (equation) {
          out.push({
            type: "text",
            x: width / 2,
            y: 14,
            text: equation,
            color: equationColor ?? "#111827",
            fontSize: 13,
            align: "center"
          });
        }
        out.push(...shapes);
        return out;
      }, [atoms, bonds, arrows, bondStyle, containers, equation, equationColor, shapes, width]);
      const drawables3D = useMemo(() => {
        if (mode !== "3d") return [];
        if (shapes.length > 0) {
          chemistryLog.debug("shapes ignored in 3D mode (pixel-authored 2D vocabulary)", { count: shapes.length });
        }
        if (containers.length > 0) {
          chemistryLog.debug("containers ignored in 3D mode (pixel-authored 2D vocabulary)", { count: containers.length });
        }
        if (animate) {
          chemistryLog.debug("animate ignored in 3D mode (motion is entity-state driven)");
        }
        const out = [];
        const labelColor = labelColorForBackground(backgroundColor);
        const atomById = /* @__PURE__ */ new Map();
        for (const a of atoms) {
          if (a.id) atomById.set(a.id, a);
        }
        for (const b of bonds) {
          const a = atomById.get(b.from);
          const c = atomById.get(b.to);
          if (!a || !c) continue;
          const color = b.color ?? "#6b7280";
          const from = [a.x, a.y, a.z ?? 0];
          const to = [c.x, c.y, c.z ?? 0];
          const perp = bondPerpendicular(from, to);
          const bondRadius = Math.max(0.06, Math.min(a.radius ?? 0.45, c.radius ?? 0.45) * 0.22);
          const step = bondRadius * 2.2;
          const offsets = b.type === "double" ? [-step, step] : b.type === "triple" ? [-step, 0, step] : [0];
          for (const off of offsets) {
            const bond = cylinderBetween(
              [from[0] + perp[0] * off, from[1] + perp[1] * off, from[2] + perp[2] * off],
              [to[0] + perp[0] * off, to[1] + perp[1] * off, to[2] + perp[2] * off],
              bondRadius,
              color
            );
            if (bond) out.push(bond);
          }
        }
        for (const a of arrows) {
          const angle = (a.angle ?? 0) * (Math.PI / 180);
          const len = a.length ?? 60;
          const x2 = a.x + Math.cos(angle) * len;
          const y2 = a.y + Math.sin(angle) * len;
          const arrow = arrowBetween([a.x, a.y, 0], [x2, y2, 0], a.color ?? "#dc2626");
          if (arrow) out.push(arrow);
          if (a.label) {
            out.push(billboardLabel(a.label, (a.x + x2) / 2, (a.y + y2) / 2, 0, { color: labelColor }));
          }
        }
        for (const a of atoms) {
          const radius = a.radius ?? 0.45;
          const az = a.z ?? 0;
          out.push(meshSphere(a.id, a.x, a.y, az, radius, a.color ?? "#2563eb"));
          if (a.element) {
            out.push(billboardLabel(a.element, a.x, a.y, az + radius, { color: labelColor }));
          }
        }
        if (lattice3d) {
          out.push(...latticeDrawables(lattice3d, { labelColor }));
        }
        return out;
      }, [mode, atoms, bonds, arrows, shapes, containers, lattice3d, animate, backgroundColor]);
      const atomIndexById = useMemo(() => {
        const m = /* @__PURE__ */ new Map();
        atoms.forEach((a, i) => {
          if (a.id) m.set(a.id, i);
        });
        return m;
      }, [atoms]);
      if (mode === "3d") {
        return /* @__PURE__ */ jsx(
          LearningScene3D,
          {
            className,
            width,
            height,
            title,
            backgroundColor,
            drawables: drawables3D,
            camera,
            lighting,
            post,
            showGrid,
            shadows,
            interactive,
            isLoading,
            error,
            onItemClick: get3DClickPayload(onShapeClick, atomIndexById)
          }
        );
      }
      return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        /* @__PURE__ */ jsx(
          LearningCanvas,
          {
            width,
            height,
            backgroundColor,
            shapes: derivedShapes,
            readouts,
            traces,
            interactive: interactive ?? false,
            animate,
            onShapeClick,
            isLoading,
            error
          }
        )
      ] }) });
    };
  }
});
function ChoiceButton({
  text = "Charge forward into the fray",
  index,
  assetUrl,
  icon,
  disabled = false,
  selected = false,
  onClick,
  action,
  payload,
  className
}) {
  return /* @__PURE__ */ jsxs(
    Button,
    {
      variant: "ghost",
      disabled,
      action,
      actionPayload: payload,
      onClick,
      className: cn(
        "w-full text-left px-4 py-2.5 rounded-interactive border transition-all duration-150",
        "flex items-center gap-2",
        selected ? "bg-accent/15 border-accent text-foreground" : "bg-muted/40 border-border text-foreground hover:bg-muted hover:border-border",
        disabled && "opacity-40 cursor-not-allowed hover:bg-muted/40 hover:border-border",
        className
      ),
      children: [
        index !== void 0 && /* @__PURE__ */ jsxs(
          Typography,
          {
            as: "span",
            className: cn(
              "flex-shrink-0 font-mono font-bold text-sm",
              selected ? "text-accent" : "text-muted-foreground"
            ),
            children: [
              index,
              "."
            ]
          }
        ),
        assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 16, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "flex-shrink-0 text-sm", children: typeof icon === "string" ? (() => {
          const I = resolveIcon(icon);
          return I ? /* @__PURE__ */ jsx(I, { className: "w-4 h-4" }) : null;
        })() : /* @__PURE__ */ (() => {
          const I = icon;
          return /* @__PURE__ */ jsx(I, { className: "w-4 h-4" });
        })() }) : null,
        /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-sm leading-snug", children: text })
      ]
    }
  );
}
var init_ChoiceButton = __esm({
  "components/game/atoms/ChoiceButton.tsx"() {
    init_cn();
    init_Icon();
    init_Button();
    init_Box();
    init_Typography();
    init_GameIcon();
    ChoiceButton.displayName = "ChoiceButton";
  }
});
var CodeRunnerPanel;
var init_CodeRunnerPanel = __esm({
  "components/core/organisms/CodeRunnerPanel.tsx"() {
    "use client";
    init_Box();
    init_Button();
    init_Badge();
    init_Typography();
    init_Stack();
    init_CodeBlock();
    init_useEventBus();
    init_cn();
    CodeRunnerPanel = ({
      code: initialCode,
      language,
      runnable = true,
      onRun,
      runEvent = "RUN_CODE",
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const [code, setCode] = useState(initialCode);
      const [output, setOutput] = useState(null);
      const [error, setError] = useState(null);
      const [isRunning, setIsRunning] = useState(false);
      const [copied, setCopied] = useState(false);
      const handleRun = useCallback(async () => {
        if (!onRun) return;
        setIsRunning(true);
        setError(null);
        setOutput(null);
        try {
          const result = await onRun(code);
          setOutput(result);
          eventBus.emit(`UI:${runEvent}`, { language, exitCode: result.exitCode });
        } catch (err) {
          const message = err instanceof Error ? err.message : t("common.error");
          setError(message);
          eventBus.emit(`UI:${runEvent}`, { language, exitCode: 1, error: message });
        } finally {
          setIsRunning(false);
        }
      }, [code, language, onRun, runEvent, eventBus, t]);
      const handleReset = useCallback(() => {
        setCode(initialCode);
        setOutput(null);
        setError(null);
      }, [initialCode]);
      const handleCopy = useCallback(async () => {
        try {
          await navigator.clipboard.writeText(code);
          setCopied(true);
          eventBus.emit("UI:COPY_CODE", { language, success: true });
          setTimeout(() => setCopied(false), 2e3);
        } catch {
          eventBus.emit("UI:COPY_CODE", { language, success: false });
        }
      }, [code, language, eventBus]);
      if (!runnable || !onRun) {
        return /* @__PURE__ */ jsx(Box, { className, children: /* @__PURE__ */ jsx(CodeBlock, { language, code }) });
      }
      const hasOutput = output !== null || error !== null;
      return /* @__PURE__ */ jsxs(Box, { className: cn("space-y-3", className), children: [
        /* @__PURE__ */ jsxs(Box, { className: "group relative", style: { height: 360 }, children: [
          /* @__PURE__ */ jsx(
            CodeBlock,
            {
              language,
              code,
              editable: true,
              onChange: setCode,
              showLanguageBadge: true,
              showCopyButton: false,
              maxHeight: "100%"
            }
          ),
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "xs",
              align: "center",
              className: "absolute top-2 right-2 z-10 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto focus-within:opacity-100 focus-within:pointer-events-auto transition-opacity bg-[var(--color-card)]/90 backdrop-blur-sm rounded-md p-1 shadow-sm border border-border",
              children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: handleCopy,
                    icon: copied ? Check : Copy,
                    "aria-label": t("common.copy"),
                    className: copied ? "text-success" : ""
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: handleReset,
                    disabled: isRunning,
                    icon: RotateCcw,
                    "aria-label": "Reset"
                  }
                ),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "primary",
                    size: "sm",
                    onClick: handleRun,
                    disabled: isRunning,
                    icon: isRunning ? RotateCcw : Play,
                    className: isRunning ? "[&_svg]:animate-spin" : "",
                    children: isRunning ? t("common.loading") : "Run"
                  }
                )
              ]
            }
          )
        ] }),
        hasOutput && /* @__PURE__ */ jsxs(Box, { className: "rounded-lg border border-border bg-foreground overflow-hidden", children: [
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              align: "center",
              className: "px-3 py-2 bg-card border-b border-border",
              children: [
                /* @__PURE__ */ jsx(Terminal, { size: 16, className: "text-muted-foreground" }),
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground font-medium", children: "Output" }),
                output && /* @__PURE__ */ jsxs(
                  Badge,
                  {
                    variant: output.exitCode === 0 ? "success" : "danger",
                    size: "sm",
                    children: [
                      "Exit ",
                      output.exitCode
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx(VStack, { gap: "none", className: "p-3 font-mono text-sm", children: error ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-error whitespace-pre-wrap", children: error }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            output?.stdout ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background whitespace-pre-wrap", children: output.stdout }) : null,
            output?.stderr ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-error whitespace-pre-wrap", children: output.stderr }) : null,
            !output?.stdout && !output?.stderr ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background italic", children: "No output" }) : null,
            output && output.testResults.length > 0 && /* @__PURE__ */ jsx(Box, { className: "mt-3 pt-3 border-t border-border space-y-2", children: output.testResults.map((test, index) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", className: "text-xs", children: [
              test.passed ? /* @__PURE__ */ jsx(CheckCircle, { size: 14, className: "text-success mt-0.5" }) : /* @__PURE__ */ jsx(XCircle, { size: 14, className: "text-error mt-0.5" }),
              /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1", children: [
                /* @__PURE__ */ jsxs(
                  Typography,
                  {
                    variant: "small",
                    className: test.passed ? "text-success" : "text-error",
                    children: [
                      "Test ",
                      index + 1,
                      ": ",
                      test.passed ? "passed" : "failed"
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-background", children: [
                  "Input: ",
                  test.input
                ] }),
                /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-background", children: [
                  "Expected: ",
                  test.expectedOutput
                ] }),
                /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-background", children: [
                  "Actual: ",
                  test.actualOutput
                ] })
              ] })
            ] }, index)) })
          ] }) })
        ] })
      ] });
    };
    CodeRunnerPanel.displayName = "CodeRunnerPanel";
  }
});
function matchesQuery(query, text) {
  if (!query) return true;
  let qi = 0;
  const q = query.toLowerCase();
  const t = text.toLowerCase();
  for (let ti = 0; ti < t.length && qi < q.length; ti++) {
    if (t[ti] === q[qi]) qi++;
  }
  return qi === q.length;
}
function commandMatches(command, query) {
  if (!query) return true;
  if (matchesQuery(query, command.label)) return true;
  return (command.keywords ?? []).some((keyword) => matchesQuery(query, keyword));
}
function dispatchCommandPaletteCommand(command, deps) {
  if (command.disabled) return;
  if (command.event) deps.emit(`UI:${command.event}`, { commandId: command.id });
  if (command.action) deps.emit(`UI:${command.action}`, command.actionPayload ?? {});
  deps.onSelect?.(command);
}
var UNGROUPED, CommandPalette;
var init_CommandPalette = __esm({
  "components/core/molecules/CommandPalette.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_Typography();
    init_Icon();
    init_Input();
    init_Badge();
    init_cn();
    init_useEventBus();
    init_Modal();
    UNGROUPED = /* @__PURE__ */ Symbol("command-palette-ungrouped");
    CommandPalette = ({
      open,
      onOpenChange,
      commands,
      onSelect,
      placeholder = "Type a command...",
      emptyLabel = "No matching commands",
      className
    }) => {
      const eventBus = useEventBus();
      const [query, setQuery] = useState("");
      const [highlightIndex, setHighlightIndex] = useState(0);
      const filtered = useMemo(
        () => commands.filter((command) => commandMatches(command, query)),
        [commands, query]
      );
      const groups = useMemo(() => {
        const order = [];
        const byGroup = /* @__PURE__ */ new Map();
        for (const command of filtered) {
          const key = command.group ?? UNGROUPED;
          if (!byGroup.has(key)) {
            byGroup.set(key, []);
            order.push(key);
          }
          byGroup.get(key).push(command);
        }
        return order.map((key) => ({ group: key === UNGROUPED ? void 0 : key, items: byGroup.get(key) }));
      }, [filtered]);
      const resetQuery = useCallback(() => {
        setQuery("");
        setHighlightIndex(0);
      }, []);
      const handleClose = useCallback(() => {
        resetQuery();
        onOpenChange(false);
      }, [onOpenChange, resetQuery]);
      const handleSelect = useCallback(
        (command) => {
          if (command.disabled) return;
          dispatchCommandPaletteCommand(command, { emit: eventBus.emit, onSelect });
          handleClose();
        },
        [eventBus, onSelect, handleClose]
      );
      const handleQueryChange = useCallback((e) => {
        setQuery(e.target.value);
        setHighlightIndex(0);
      }, []);
      const handleKeyDown = useCallback(
        (e) => {
          if (filtered.length === 0) return;
          if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightIndex((prev) => prev < filtered.length - 1 ? prev + 1 : 0);
          } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightIndex((prev) => prev > 0 ? prev - 1 : filtered.length - 1);
          } else if (e.key === "Enter") {
            e.preventDefault();
            const command = filtered[highlightIndex];
            if (command) handleSelect(command);
          }
        },
        [filtered, highlightIndex, handleSelect]
      );
      return /* @__PURE__ */ jsx(
        Modal,
        {
          isOpen: open,
          onClose: handleClose,
          onExited: resetQuery,
          showCloseButton: false,
          size: "md",
          className,
          children: /* @__PURE__ */ jsx(Box, { "data-testid": "command-palette", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
            /* @__PURE__ */ jsx(
              Input,
              {
                inputType: "search",
                placeholder,
                value: query,
                onChange: handleQueryChange,
                onKeyDown: handleKeyDown,
                leftIcon: "search",
                clearable: query.length > 0,
                onClear: resetQuery,
                autoFocus: true,
                "data-testid": "command-palette-input"
              }
            ),
            filtered.length === 0 ? /* @__PURE__ */ jsx(Box, { className: "px-2 py-6 text-center", "data-testid": "command-palette-empty", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: emptyLabel }) }) : /* @__PURE__ */ jsx(
              Box,
              {
                className: "max-h-80 overflow-y-auto",
                role: "listbox",
                "aria-label": placeholder,
                children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: groups.map(({ group, items }) => /* @__PURE__ */ jsxs(Box, { children: [
                  group ? /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      color: "muted",
                      className: "px-3 pt-2 pb-1 block",
                      children: group
                    }
                  ) : null,
                  items.map((command) => {
                    const index = filtered.indexOf(command);
                    const isHighlighted = index === highlightIndex;
                    return /* @__PURE__ */ jsxs(
                      Box,
                      {
                        as: "button",
                        role: "option",
                        "aria-selected": isHighlighted,
                        "aria-disabled": command.disabled || void 0,
                        "data-testid": `command-palette-item-${command.id}`,
                        onMouseEnter: () => !command.disabled && setHighlightIndex(index),
                        onClick: () => handleSelect(command),
                        className: cn(
                          "w-full flex items-center gap-3 px-3 py-2 text-start rounded-sm",
                          "text-sm transition-colors",
                          "focus:outline-none",
                          isHighlighted && "bg-muted",
                          command.disabled && "opacity-50 cursor-not-allowed"
                        ),
                        children: [
                          command.icon ? /* @__PURE__ */ jsx(Icon, { icon: command.icon, size: "sm", className: "flex-shrink-0" }) : null,
                          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1 truncate", children: command.label }),
                          command.shortcut ? /* @__PURE__ */ jsx(Badge, { variant: "neutral", size: "sm", children: command.shortcut }) : null
                        ]
                      },
                      command.id
                    );
                  })
                ] }, String(group ?? "__ungrouped__"))) })
              }
            )
          ] }) })
        }
      );
    };
    CommandPalette.displayName = "CommandPalette";
  }
});
function formatCount(count) {
  if (count >= 1e3) {
    return `${(count / 1e3).toFixed(1)}k`;
  }
  return String(count);
}
var CommunityLinks;
var init_CommunityLinks = __esm({
  "components/marketing/molecules/CommunityLinks.tsx"() {
    "use client";
    init_Stack();
    init_Typography();
    init_Button();
    init_Icon();
    CommunityLinks = ({
      github,
      discord,
      twitter,
      heading,
      subtitle,
      className
    }) => {
      const openLink = (url) => () => {
        window.open(url, "_blank", "noopener,noreferrer");
      };
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", align: "center", className, children: [
        heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", className: "text-center", children: heading }),
        subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", className: "text-center", children: subtitle }),
        /* @__PURE__ */ jsxs(HStack, { gap: "md", className: "flex-wrap justify-center", children: [
          github && /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: openLink(github.url), children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
            /* @__PURE__ */ jsx(Icon, { name: "github", size: "sm" }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-inherit", children: github.stars != null ? `GitHub (${formatCount(github.stars)} stars)` : "GitHub" })
          ] }) }),
          discord && /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: openLink(discord.url), children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
            /* @__PURE__ */ jsx(Icon, { name: "message-circle", size: "sm" }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-inherit", children: discord.members != null ? `Discord (${formatCount(discord.members)} members)` : "Discord" })
          ] }) }),
          twitter && /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: openLink(twitter.url), children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
            /* @__PURE__ */ jsx(Icon, { name: "twitter", size: "sm" }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-inherit", children: twitter.followers != null ? `Twitter (${formatCount(twitter.followers)} followers)` : "Twitter" })
          ] }) })
        ] })
      ] });
    };
    CommunityLinks.displayName = "CommunityLinks";
  }
});
var variantConfig, ConfirmDialog;
var init_ConfirmDialog = __esm({
  "components/core/molecules/ConfirmDialog.tsx"() {
    "use client";
    init_Modal();
    init_Button();
    init_Icon();
    init_Typography();
    init_Box();
    init_Stack();
    init_cn();
    variantConfig = {
      danger: {
        icon: Trash2,
        iconBg: "bg-error",
        iconColor: "text-error-foreground",
        confirmVariant: "primary"
      },
      warning: {
        icon: AlertTriangle,
        iconBg: "bg-warning",
        iconColor: "text-warning-foreground",
        confirmVariant: "primary"
      },
      info: {
        icon: Check,
        iconBg: "bg-info",
        iconColor: "text-info-foreground",
        confirmVariant: "primary"
      },
      default: {
        icon: Check,
        iconBg: "bg-primary",
        iconColor: "text-primary-foreground",
        confirmVariant: "primary"
      }
    };
    ConfirmDialog = ({
      isOpen = true,
      onClose = () => {
      },
      onConfirm = () => {
      },
      title,
      message,
      description,
      confirmText,
      confirmLabel,
      cancelText,
      cancelLabel,
      variant = "danger",
      size = "sm",
      isLoading = false,
      error: _error,
      className
    }) => {
      const config = variantConfig[variant];
      const { t } = useTranslate();
      const resolvedMessage = message ?? description ?? "";
      const resolvedConfirmText = confirmText ?? confirmLabel ?? t("dialog.confirm");
      const resolvedCancelText = cancelText ?? cancelLabel ?? t("dialog.cancel");
      const handleConfirm = () => {
        onConfirm();
      };
      return /* @__PURE__ */ jsx(
        Modal,
        {
          isOpen,
          onClose,
          size,
          showCloseButton: false,
          closeOnOverlayClick: !isLoading,
          closeOnEscape: !isLoading,
          className,
          footer: /* @__PURE__ */ jsxs(HStack, { className: "justify-end gap-3", children: [
            /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: onClose, disabled: isLoading, children: resolvedCancelText }),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: config.confirmVariant,
                onClick: handleConfirm,
                disabled: isLoading,
                children: isLoading ? t("common.loading") : resolvedConfirmText
              }
            )
          ] }),
          children: /* @__PURE__ */ jsxs(HStack, { className: "gap-4", children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "flex-shrink-0 w-12 h-12 flex items-center justify-center",
                  config.iconBg
                ),
                children: /* @__PURE__ */ jsx(Icon, { icon: config.icon, size: "lg", className: config.iconColor })
              }
            ),
            /* @__PURE__ */ jsxs(Box, { className: "flex-1", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h5", className: "mb-2", children: title }),
              typeof resolvedMessage === "string" ? /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  className: "text-muted-foreground",
                  children: resolvedMessage
                }
              ) : resolvedMessage
            ] })
          ] })
        }
      );
    };
    ConfirmDialog.displayName = "ConfirmDialog";
  }
});
var ConnectionBlock;
var init_ConnectionBlock = __esm({
  "components/core/molecules/ConnectionBlock.tsx"() {
    "use client";
    init_MarkdownContent();
    init_cn();
    ConnectionBlock = ({ content, className }) => /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "bg-success/10 border-l-4 border-success rounded-r-lg p-5 mb-6",
          className
        ),
        children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
          /* @__PURE__ */ jsx(Link2, { className: "text-success flex-shrink-0 mt-1", size: 20 }),
          /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
            /* @__PURE__ */ jsx("h4", { className: "font-semibold text-success mb-2", children: "Building On What You Know" }),
            /* @__PURE__ */ jsx("div", { className: "prose dark:prose-invert prose-sm max-w-none text-foreground", children: /* @__PURE__ */ jsx(MarkdownContent, { content }) })
          ] })
        ] })
      }
    );
    ConnectionBlock.displayName = "ConnectionBlock";
  }
});
function ControlButton({
  assetUrl,
  label,
  icon,
  size = "md",
  shape = "circle",
  variant = "secondary",
  onPress,
  onRelease,
  pressEvent,
  releaseEvent,
  pressed,
  disabled,
  className
}) {
  const eventBus = useEventBus();
  const [isPressed, setIsPressed] = React79.useState(false);
  const actualPressed = pressed ?? isPressed;
  const handlePointerDown = React79.useCallback(
    (e) => {
      e.preventDefault();
      if (disabled) return;
      setIsPressed(true);
      if (pressEvent) eventBus.emit(`UI:${pressEvent}`, {});
      onPress?.();
    },
    [disabled, pressEvent, eventBus, onPress]
  );
  const handlePointerUp = React79.useCallback(
    (e) => {
      e.preventDefault();
      if (disabled) return;
      setIsPressed(false);
      if (releaseEvent) eventBus.emit(`UI:${releaseEvent}`, {});
      onRelease?.();
    },
    [disabled, releaseEvent, eventBus, onRelease]
  );
  const handlePointerLeave = React79.useCallback(
    (e) => {
      if (isPressed) {
        setIsPressed(false);
        if (releaseEvent) eventBus.emit(`UI:${releaseEvent}`, {});
        onRelease?.();
      }
    },
    [isPressed, releaseEvent, eventBus, onRelease]
  );
  return /* @__PURE__ */ jsx(
    Button,
    {
      variant,
      disabled,
      onPointerDown: handlePointerDown,
      onPointerUp: handlePointerUp,
      onPointerLeave: handlePointerLeave,
      onContextMenu: (e) => e.preventDefault(),
      className: cn(
        "flex items-center justify-center border-2 font-bold",
        "select-none touch-none",
        "transition-all duration-100",
        "active:scale-95",
        sizeMap2[size] ?? sizeMap2.md,
        shapeMap[shape] ?? shapeMap.circle,
        variantMap[variant] ?? variantMap.secondary,
        actualPressed && "scale-95 brightness-110 border-foreground",
        disabled && "opacity-50 cursor-not-allowed",
        className
      ),
      children: assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 24, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "text-2xl", children: typeof icon === "string" ? /^[a-zA-Z0-9-]+$/.test(icon) ? (() => {
        const I = resolveIcon(icon);
        return I ? /* @__PURE__ */ jsx(I, { className: "w-6 h-6" }) : null;
      })() : icon : /* @__PURE__ */ (() => {
        const I = icon;
        return /* @__PURE__ */ jsx(I, { className: "w-6 h-6" });
      })() }) : label ? /* @__PURE__ */ jsx(Typography, { as: "span", children: label }) : null
    }
  );
}
var sizeMap2, shapeMap, variantMap;
var init_ControlButton = __esm({
  "components/game/atoms/ControlButton.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Icon();
    init_Button();
    init_Box();
    init_Typography();
    init_GameIcon();
    sizeMap2 = {
      sm: "w-10 h-10 text-sm",
      md: "w-14 h-14 text-base",
      lg: "w-18 h-18 text-lg",
      xl: "w-24 h-24 text-xl"
    };
    shapeMap = {
      circle: "rounded-full",
      rounded: "rounded-interactive",
      square: "rounded-interactive"
    };
    variantMap = {
      primary: "bg-primary text-primary-foreground border-primary hover:bg-primary-hover",
      secondary: "bg-secondary text-secondary-foreground border-border hover:bg-secondary-hover",
      ghost: "bg-transparent text-foreground border-border hover:bg-muted"
    };
    ControlButton.displayName = "ControlButton";
  }
});
function ControlGrid({
  kind,
  buttons = DEFAULT_BUTTONS,
  layout = "horizontal",
  includeDiagonals = false,
  onAction,
  actionEvent,
  onDirection,
  directionEvent,
  directionEvents,
  directionReleaseEvents,
  directionAssets,
  size = "md",
  disabled,
  visibility = "auto",
  className
}) {
  const eventBus = useEventBus();
  const [active, setActive] = React79.useState(/* @__PURE__ */ new Set());
  const [coarse, setCoarse] = React79.useState(
    () => typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches
  );
  React79.useEffect(() => {
    if (visibility !== "auto" || typeof window === "undefined") return;
    const mq = window.matchMedia("(pointer: coarse)");
    const onChange = (e) => setCoarse(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [visibility]);
  const handlePress = React79.useCallback(
    (id) => {
      setActive((prev) => new Set(prev).add(id));
      if (actionEvent) eventBus.emit(`UI:${actionEvent}`, { id, pressed: true });
      onAction?.(id, true);
      if (kind === "dpad") {
        const semantic = directionEvents?.[id];
        if (semantic) eventBus.emit(`UI:${semantic}`, {});
        if (directionEvent) eventBus.emit(`UI:${directionEvent}`, { direction: id, pressed: true });
        onDirection?.(id, true);
      }
    },
    [kind, actionEvent, directionEvent, directionEvents, eventBus, onAction, onDirection]
  );
  const handleRelease = React79.useCallback(
    (id) => {
      setActive((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      if (actionEvent) eventBus.emit(`UI:${actionEvent}`, { id, pressed: false });
      onAction?.(id, false);
      if (kind === "dpad") {
        const semantic = directionReleaseEvents?.[id];
        if (semantic) eventBus.emit(`UI:${semantic}`, {});
        if (directionEvent) eventBus.emit(`UI:${directionEvent}`, { direction: id, pressed: false });
        onDirection?.(id, false);
      }
    },
    [kind, actionEvent, directionEvent, directionReleaseEvents, eventBus, onAction, onDirection]
  );
  if (visibility === "auto" && !coarse) return null;
  if (kind === "dpad") {
    const ds = dpadSizeMap[size];
    const dir = (d) => /* @__PURE__ */ jsx(
      ControlButton,
      {
        icon: directionAssets?.[d] ? void 0 : arrowIcons[d],
        assetUrl: directionAssets?.[d],
        size: sizeKey[size],
        variant: "secondary",
        pressed: active.has(d),
        onPress: () => handlePress(d),
        onRelease: () => handleRelease(d),
        disabled
      },
      d
    );
    const usesSemantic = !!directionEvents;
    const cell = (d) => !usesSemantic || directionEvents?.[d] ? dir(d) : /* @__PURE__ */ jsx(Box, {}, d);
    return /* @__PURE__ */ jsxs(Box, { className: cn("inline-grid grid-cols-3", ds.gap, ds.container, className), children: [
      /* @__PURE__ */ jsx(Box, {}),
      cell("up"),
      /* @__PURE__ */ jsx(Box, {}),
      cell("left"),
      /* @__PURE__ */ jsx(Box, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx(Box, { className: "w-6 h-6 rounded-interactive bg-muted border-2 border-muted-foreground" }) }),
      cell("right"),
      /* @__PURE__ */ jsx(Box, {}),
      cell("down"),
      /* @__PURE__ */ jsx(Box, {})
    ] });
  }
  if (layout === "diamond" && buttons.length === 4) {
    const [top, right, bottom, left] = buttons;
    return /* @__PURE__ */ jsxs(Box, { className: cn(layoutClass.diamond, className), children: [
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: top.icon,
          assetUrl: top.assetUrl,
          label: top.label,
          size: sizeKey[size],
          variant: top.variant,
          pressed: active.has(top.id),
          onPress: () => handlePress(top.id),
          onRelease: () => handleRelease(top.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: left.icon,
          assetUrl: left.assetUrl,
          label: left.label,
          size: sizeKey[size],
          variant: left.variant,
          pressed: active.has(left.id),
          onPress: () => handlePress(left.id),
          onRelease: () => handleRelease(left.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: right.icon,
          assetUrl: right.assetUrl,
          label: right.label,
          size: sizeKey[size],
          variant: right.variant,
          pressed: active.has(right.id),
          onPress: () => handlePress(right.id),
          onRelease: () => handleRelease(right.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: bottom.icon,
          assetUrl: bottom.assetUrl,
          label: bottom.label,
          size: sizeKey[size],
          variant: bottom.variant,
          pressed: active.has(bottom.id),
          onPress: () => handlePress(bottom.id),
          onRelease: () => handleRelease(bottom.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {})
    ] });
  }
  return /* @__PURE__ */ jsx(Box, { className: cn(layoutClass[layout], className), children: buttons.map((button) => /* @__PURE__ */ jsx(
    ControlButton,
    {
      icon: button.icon,
      assetUrl: button.assetUrl,
      label: button.label,
      size: sizeKey[size],
      variant: button.variant,
      pressed: active.has(button.id),
      onPress: () => handlePress(button.id),
      onRelease: () => handleRelease(button.id),
      disabled
    },
    button.id
  )) });
}
var sizeKey, layoutClass, dpadSizeMap, arrowIcons, DEFAULT_BUTTONS;
var init_ControlGrid = __esm({
  "components/game/molecules/ControlGrid.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_ControlButton();
    sizeKey = { sm: "sm", md: "md", lg: "lg" };
    layoutClass = {
      horizontal: "flex flex-row gap-2",
      vertical: "flex flex-col gap-2",
      diamond: "grid grid-cols-3 gap-1"
    };
    dpadSizeMap = {
      sm: { gap: "gap-0.5", container: "w-28" },
      md: { gap: "gap-1", container: "w-40" },
      lg: { gap: "gap-1.5", container: "w-52" }
    };
    arrowIcons = {
      up: "\u25B2",
      down: "\u25BC",
      left: "\u25C0",
      right: "\u25B6"
    };
    DEFAULT_BUTTONS = [
      { id: "jump", label: "Jump", icon: "chevron-up", variant: "primary" },
      { id: "attack", label: "Attack", icon: "sword", variant: "secondary" },
      { id: "dodge", label: "Dodge", icon: "wind", variant: "ghost" }
    ];
    ControlGrid.displayName = "ControlGrid";
  }
});
function CounterMinimal({
  entity,
  size = "md",
  onDecrement,
  onIncrement,
  decrementEvent,
  incrementEvent,
  className
}) {
  const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
  if (!resolved) return null;
  return /* @__PURE__ */ jsxs(HStack, { gap: "lg", align: "center", justify: "center", className, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "secondary",
        size: sizeStyles8[size].button,
        action: decrementEvent,
        onClick: onDecrement,
        disabled: resolved.decrementDisabled,
        icon: "minus",
        children: resolved.decrementLabel
      }
    ),
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h1",
        className: cn(
          sizeStyles8[size].display,
          "font-bold tabular-nums min-w-[3ch] text-center"
        ),
        children: resolved.count
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "secondary",
        size: sizeStyles8[size].button,
        action: incrementEvent,
        onClick: onIncrement,
        disabled: resolved.incrementDisabled,
        icon: "plus",
        children: resolved.incrementLabel
      }
    )
  ] });
}
function CounterStandard({
  entity,
  size = "md",
  title = "Counter",
  showReset = true,
  onDecrement,
  onIncrement,
  onReset,
  decrementEvent,
  incrementEvent,
  resetEvent,
  className
}) {
  const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
  if (!resolved) return null;
  return /* @__PURE__ */ jsx(Container, { size: "sm", padding: "lg", className, children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", align: "center", children: [
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h2",
        className: "text-muted-foreground",
        children: title
      }
    ),
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h1",
        className: cn(
          sizeStyles8[size].display,
          "font-bold tabular-nums text-primary"
        ),
        children: resolved.count
      }
    ),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: sizeStyles8[size].button,
          action: decrementEvent,
          onClick: onDecrement,
          disabled: resolved.decrementDisabled,
          icon: "minus"
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: sizeStyles8[size].button,
          action: incrementEvent,
          onClick: onIncrement,
          disabled: resolved.incrementDisabled,
          icon: "plus"
        }
      )
    ] }),
    showReset && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: resetEvent,
        onClick: onReset,
        icon: "rotate-ccw",
        children: "Reset"
      }
    )
  ] }) });
}
function CounterFull({
  entity,
  size = "md",
  title = "Counter",
  showReset = true,
  onDecrement,
  onIncrement,
  onReset,
  decrementEvent,
  incrementEvent,
  resetEvent,
  className
}) {
  const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
  if (!resolved) return null;
  return /* @__PURE__ */ jsx(Container, { size: "sm", padding: "lg", className, children: /* @__PURE__ */ jsxs(VStack, { gap: "xl", align: "center", children: [
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h2",
        className: "text-muted-foreground",
        children: title
      }
    ),
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", children: [
      /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "h1",
          className: cn(
            sizeStyles8[size].display,
            "font-bold tabular-nums text-primary"
          ),
          children: resolved.count
        }
      ),
      resolved.rangeText && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", children: resolved.rangeText })
    ] }),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: sizeStyles8[size].button,
          action: decrementEvent,
          onClick: onDecrement,
          disabled: resolved.decrementDisabled,
          icon: "minus",
          children: resolved.decrementLabel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: sizeStyles8[size].button,
          action: incrementEvent,
          onClick: onIncrement,
          disabled: resolved.incrementDisabled,
          icon: "plus",
          children: resolved.incrementLabel
        }
      )
    ] }),
    showReset && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: resetEvent,
        onClick: onReset,
        icon: "rotate-ccw",
        children: "Reset to 0"
      }
    )
  ] }) });
}
var sizeStyles8, CounterTemplate;
var init_CounterTemplate = __esm({
  "components/core/templates/CounterTemplate.tsx"() {
    init_cn();
    init_Container();
    init_Stack();
    init_Typography();
    init_Button();
    sizeStyles8 = {
      sm: { display: "text-4xl", button: "sm" },
      md: { display: "text-6xl", button: "md" },
      lg: { display: "text-8xl", button: "lg" }
    };
    CounterMinimal.displayName = "CounterMinimal";
    CounterStandard.displayName = "CounterStandard";
    CounterFull.displayName = "CounterFull";
    CounterTemplate = (props) => {
      switch (props.variant) {
        case "minimal":
          return /* @__PURE__ */ jsx(CounterMinimal, { ...props });
        case "full":
          return /* @__PURE__ */ jsx(CounterFull, { ...props });
        default:
          return /* @__PURE__ */ jsx(CounterStandard, { ...props });
      }
    };
    CounterTemplate.displayName = "CounterTemplate";
  }
});
var gapStyles4, columnStyles, colSpanStyles, rowSpanStyles, DashboardGrid;
var init_DashboardGrid = __esm({
  "components/core/organisms/layout/DashboardGrid.tsx"() {
    init_cn();
    init_Box();
    gapStyles4 = {
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6"
    };
    columnStyles = {
      2: "grid-cols-2",
      3: "grid-cols-3",
      4: "grid-cols-4"
    };
    colSpanStyles = {
      1: "col-span-1",
      2: "col-span-2",
      3: "col-span-3",
      4: "col-span-4"
    };
    rowSpanStyles = {
      1: "row-span-1",
      2: "row-span-2"
    };
    DashboardGrid = ({
      columns = 3,
      gap = "md",
      cells,
      className
    }) => {
      const { t: _t } = useTranslate();
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "grid w-full",
            columnStyles[columns],
            gapStyles4[gap],
            className
          ),
          children: cells.map((cell, idx) => /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "border-2 border-border bg-card",
                colSpanStyles[cell.colSpan ?? 1],
                rowSpanStyles[cell.rowSpan ?? 1]
              ),
              children: cell.content
            },
            cell.id != null ? String(cell.id) : idx
          ))
        }
      );
    };
    DashboardGrid.displayName = "DashboardGrid";
  }
});

// hooks/useAuthContext.ts
function useAuthContext() {
  return {
    user: null,
    loading: false,
    signIn: void 0,
    signOut: void 0
  };
}
var init_useAuthContext = __esm({
  "hooks/useAuthContext.ts"() {
  }
});
function resolveActiveNavHref(items, currentPath) {
  let best;
  for (const item of items) {
    for (const href of item.children?.length ? [item.href, ...item.children.map((c) => c.href)] : [item.href]) {
      if (currentPath === href) return href;
      if (currentPath.startsWith(href + "/") && (!best || href.length > best.length)) {
        best = href;
      }
    }
  }
  return best;
}
var DashboardLayout, NavLink, NavLinkTopnav, NavLinkBottom;
var init_DashboardLayout = __esm({
  "components/core/templates/DashboardLayout.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Box();
    init_Stack();
    init_Typography();
    init_Icon();
    init_useAuthContext();
    init_useEventBus();
    DashboardLayout = ({
      appName = "{{APP_TITLE}}",
      logo,
      navItems = [],
      user: userProp,
      headerActions,
      showSearch = false,
      searchEvent,
      onSearchSubmit,
      topBarActions = [],
      notifications,
      notificationClickEvent,
      onNotificationClick,
      showThemeToggle = true,
      sidebarFooter,
      sidebarContent,
      onSignOut: onSignOutProp,
      currentPath,
      layoutMode = "sidebar",
      children
    }) => {
      const eventBus = useEventBus();
      const searchEnabled = showSearch || Boolean(searchEvent) || Boolean(onSearchSubmit);
      const notificationsEnabled = Array.isArray(notifications);
      const unreadCount = notificationsEnabled ? notifications.filter((n) => n.read !== true).length : 0;
      const handleSearchSubmit = (value) => {
        if (searchEvent) eventBus.emit(`UI:${searchEvent}`, { value });
        if (onSearchSubmit) onSearchSubmit(value);
      };
      const handleNotificationClick = () => {
        if (notificationClickEvent) eventBus.emit(`UI:${notificationClickEvent}`, {});
        if (onNotificationClick) onNotificationClick();
      };
      const handleTopBarActionClick = (action) => {
        if (action.event) eventBus.emit(`UI:${action.event}`, {});
        if (action.navigatesTo) eventBus.emit("UI:NAVIGATE", { url: action.navigatesTo });
      };
      const [sidebarOpen, setSidebarOpen] = useState(false);
      const [userMenuOpen, setUserMenuOpen] = useState(false);
      const layoutRef = useRef(null);
      const [layoutWidth, setLayoutWidth] = useState(null);
      useEffect(() => {
        const el = layoutRef.current;
        if (!el || typeof ResizeObserver === "undefined") return;
        const ro = new ResizeObserver((entries) => {
          const w = entries[0]?.contentRect.width ?? el.clientWidth;
          setLayoutWidth(w);
        });
        ro.observe(el);
        return () => ro.disconnect();
      }, []);
      const isMobile = layoutWidth !== null && layoutWidth < 768;
      const isRail = layoutWidth !== null && layoutWidth >= 768 && layoutWidth < 1024;
      useEffect(() => {
        if (!isMobile && sidebarOpen) setSidebarOpen(false);
      }, [isMobile, sidebarOpen]);
      const location = useLocation();
      const ctxPagePath = useCurrentPagePath();
      const activePath = (currentPath || void 0) ?? ctxPagePath ?? location.pathname;
      const activeHref = useMemo(() => resolveActiveNavHref(navItems, activePath), [navItems, activePath]);
      const { user: authUser, signOut: authSignOut } = useAuthContext();
      const user = userProp || (authUser ? {
        name: authUser.displayName || authUser.email?.split("@")[0] || "User",
        email: authUser.email || "",
        avatar: authUser.photoURL || void 0
      } : null);
      const { t } = useTranslate();
      const handleSignOut = onSignOutProp || authSignOut;
      const showSidebar = layoutMode === "sidebar";
      const showHeader = layoutMode !== "minimal";
      const showBottomNav = layoutMode === "bottomnav";
      const isTopNav = layoutMode === "topnav";
      return /* @__PURE__ */ jsxs(
        Box,
        {
          ref: layoutRef,
          className: "@container/dashboard min-h-screen w-full bg-background dark:bg-background flex flex-row items-stretch",
          children: [
            showSidebar && isMobile && sidebarOpen && /* @__PURE__ */ jsx(
              Box,
              {
                className: "fixed inset-0 bg-foreground/50 dark:bg-foreground/70 z-20",
                onClick: () => setSidebarOpen(false)
              }
            ),
            showSidebar && /* @__PURE__ */ jsxs(
              Box,
              {
                as: "aside",
                className: cn(
                  "z-30 flex-shrink-0 bg-card dark:bg-card border-r border-border dark:border-border",
                  isRail ? "w-16" : "w-64",
                  "flex flex-col"
                ),
                style: isMobile ? {
                  position: "fixed",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
                  transition: "transform 200ms ease-in-out"
                } : { position: "static", transform: "none" },
                children: [
                  /* @__PURE__ */ jsxs(
                    HStack,
                    {
                      align: "center",
                      justify: isRail ? "center" : "between",
                      className: cn("h-16 border-b border-border dark:border-border", isRail ? "px-2" : "px-4"),
                      children: [
                        /* @__PURE__ */ jsxs(Link, { to: "/", className: "flex items-center gap-2", title: isRail ? appName : void 0, children: [
                          logo || /* @__PURE__ */ jsx(Box, { className: "w-8 h-8 bg-primary rounded-lg flex items-center justify-center", children: /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: "small",
                              className: "text-primary-foreground font-bold text-sm",
                              as: "span",
                              children: appName.charAt(0).toUpperCase()
                            }
                          ) }),
                          !isRail && /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: "label",
                              className: "font-semibold text-foreground dark:text-foreground",
                              as: "span",
                              children: appName
                            }
                          )
                        ] }),
                        isMobile && /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: "ghost",
                            className: "p-2 rounded-md hover:bg-muted dark:hover:bg-muted text-muted-foreground dark:text-muted-foreground",
                            onClick: () => setSidebarOpen(false),
                            children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "h-5 w-5" })
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    VStack,
                    {
                      as: "nav",
                      gap: "none",
                      className: cn(
                        "py-4 space-y-1 overflow-y-auto",
                        sidebarContent && !isRail ? "shrink-0" : "flex-1",
                        isRail ? "px-2" : "px-3"
                      ),
                      children: navItems.map((item) => /* @__PURE__ */ jsx(
                        NavLink,
                        {
                          item,
                          activeHref,
                          compact: isRail
                        },
                        item.href
                      ))
                    }
                  ),
                  sidebarContent && !isRail && /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto border-t border-border dark:border-border px-2 py-3", children: sidebarContent }),
                  sidebarFooter && /* @__PURE__ */ jsx(Box, { className: "p-4 border-t border-border dark:border-border", children: sidebarFooter })
                ]
              }
            ),
            /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0 min-h-screen", children: [
              showHeader && /* @__PURE__ */ jsx(
                Box,
                {
                  as: "header",
                  className: "sticky top-0 z-20 h-16 bg-card dark:bg-card border-b border-border dark:border-border",
                  children: /* @__PURE__ */ jsxs(
                    HStack,
                    {
                      align: "center",
                      justify: "between",
                      className: "h-full px-3 @sm/dashboard:px-4 gap-2 @sm/dashboard:gap-4",
                      children: [
                        showSidebar && isMobile && /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: "ghost",
                            className: "p-2 rounded-md hover:bg-muted dark:hover:bg-muted text-muted-foreground dark:text-muted-foreground touch-manipulation min-h-[44px] min-w-[44px] flex items-center justify-center",
                            onClick: () => setSidebarOpen(true),
                            "aria-label": t("aria.openSidebar"),
                            children: /* @__PURE__ */ jsx(Icon, { name: "menu", className: "h-5 w-5" })
                          }
                        ),
                        isTopNav && /* @__PURE__ */ jsxs(
                          HStack,
                          {
                            as: "nav",
                            align: "center",
                            gap: "none",
                            className: "hidden @md/dashboard:flex items-center gap-1 overflow-x-auto",
                            children: [
                              /* @__PURE__ */ jsxs(Link, { to: "/", className: "flex items-center gap-2 mr-3 shrink-0", children: [
                                logo || /* @__PURE__ */ jsx(Box, { className: "w-7 h-7 bg-primary rounded-lg flex items-center justify-center", children: /* @__PURE__ */ jsx(
                                  Typography,
                                  {
                                    variant: "small",
                                    className: "text-primary-foreground font-bold text-xs",
                                    as: "span",
                                    children: appName.charAt(0).toUpperCase()
                                  }
                                ) }),
                                /* @__PURE__ */ jsx(
                                  Typography,
                                  {
                                    variant: "label",
                                    className: "font-semibold text-foreground dark:text-foreground",
                                    as: "span",
                                    children: appName
                                  }
                                )
                              ] }),
                              navItems.map((item) => /* @__PURE__ */ jsx(
                                NavLinkTopnav,
                                {
                                  item,
                                  activeHref
                                },
                                item.href
                              ))
                            ]
                          }
                        ),
                        searchEnabled && /* @__PURE__ */ jsx(Box, { className: "hidden @sm/dashboard:block flex-1 min-w-0 @xl/dashboard:max-w-md", children: /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
                          /* @__PURE__ */ jsx(Icon, { name: "search", className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground dark:text-muted-foreground" }),
                          /* @__PURE__ */ jsx(
                            Input,
                            {
                              type: "search",
                              placeholder: t("common.search"),
                              className: "pl-10 w-full",
                              onKeyDown: (e) => {
                                if (e.key === "Enter") {
                                  handleSearchSubmit(e.target.value);
                                }
                              }
                            }
                          )
                        ] }) }),
                        !searchEnabled && /* @__PURE__ */ jsx(Box, { className: "flex-1" }),
                        /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "xs", children: [
                          headerActions,
                          showThemeToggle && /* @__PURE__ */ jsx(ThemeToggle, {}),
                          topBarActions.map((action, idx) => /* @__PURE__ */ jsxs(
                            Button,
                            {
                              variant: "ghost",
                              className: "relative p-2 rounded-full hover:bg-muted dark:hover:bg-muted",
                              onClick: () => handleTopBarActionClick(action),
                              "aria-label": action.label ?? (typeof action.icon === "string" ? action.icon : void 0),
                              children: [
                                /* @__PURE__ */ jsx(Icon, { icon: action.icon, className: "h-5 w-5 text-muted-foreground dark:text-muted-foreground" }),
                                action.badge !== void 0 && action.badge !== null && action.badge !== 0 && action.badge !== "" && /* @__PURE__ */ jsx(
                                  Box,
                                  {
                                    as: "span",
                                    className: cn(
                                      "absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full text-xs font-semibold flex items-center justify-center",
                                      action.variant === "danger" ? "bg-error text-error-foreground" : action.variant === "primary" ? "bg-primary text-primary-foreground" : "bg-foreground text-background"
                                    ),
                                    children: action.badge
                                  }
                                )
                              ]
                            },
                            `${action.event ?? action.navigatesTo ?? "action"}-${idx}`
                          )),
                          notificationsEnabled && /* @__PURE__ */ jsxs(
                            Button,
                            {
                              variant: "ghost",
                              className: "relative p-2 rounded-full hover:bg-muted dark:hover:bg-muted",
                              onClick: handleNotificationClick,
                              "aria-label": t("common.notifications"),
                              children: [
                                /* @__PURE__ */ jsx(Icon, { name: "bell", className: "h-5 w-5 text-muted-foreground dark:text-muted-foreground" }),
                                unreadCount > 0 && /* @__PURE__ */ jsx(
                                  Box,
                                  {
                                    as: "span",
                                    className: "absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-error rounded-full text-xs font-semibold text-error-foreground flex items-center justify-center",
                                    children: unreadCount > 99 ? "99+" : unreadCount
                                  }
                                )
                              ]
                            }
                          ),
                          user?.name && /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
                            /* @__PURE__ */ jsxs(
                              Button,
                              {
                                variant: "ghost",
                                className: "flex items-center gap-2 p-2 rounded-lg hover:bg-muted dark:hover:bg-muted",
                                onClick: () => setUserMenuOpen(!userMenuOpen),
                                children: [
                                  /* @__PURE__ */ jsx(
                                    Avatar,
                                    {
                                      src: user.avatar,
                                      alt: user.name,
                                      initials: user.name.split(" ").map((n) => n[0]).join("").substring(0, 2),
                                      size: "sm"
                                    }
                                  ),
                                  /* @__PURE__ */ jsx(
                                    Typography,
                                    {
                                      variant: "small",
                                      className: "hidden @sm/dashboard:block text-sm font-medium text-foreground dark:text-foreground",
                                      as: "span",
                                      children: user.name
                                    }
                                  ),
                                  /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "hidden @sm/dashboard:block h-4 w-4 text-muted-foreground dark:text-muted-foreground" })
                                ]
                              }
                            ),
                            userMenuOpen && /* @__PURE__ */ jsxs(Fragment, { children: [
                              /* @__PURE__ */ jsx(
                                Box,
                                {
                                  className: "fixed inset-0 z-20",
                                  onClick: () => setUserMenuOpen(false)
                                }
                              ),
                              /* @__PURE__ */ jsxs(Box, { className: "absolute right-0 mt-2 w-48 bg-card dark:bg-card rounded-lg shadow-lg border border-border dark:border-border py-1 z-30", children: [
                                /* @__PURE__ */ jsxs(Box, { className: "px-4 py-2 border-b border-border dark:border-border", children: [
                                  /* @__PURE__ */ jsx(
                                    Typography,
                                    {
                                      variant: "small",
                                      className: "text-sm font-medium text-foreground dark:text-foreground",
                                      as: "p",
                                      children: user.name
                                    }
                                  ),
                                  /* @__PURE__ */ jsx(
                                    Typography,
                                    {
                                      variant: "caption",
                                      className: "text-xs text-muted-foreground dark:text-muted-foreground",
                                      as: "p",
                                      children: user.email
                                    }
                                  )
                                ] }),
                                /* @__PURE__ */ jsxs(
                                  Button,
                                  {
                                    variant: "ghost",
                                    onClick: () => {
                                      setUserMenuOpen(false);
                                      handleSignOut?.();
                                    },
                                    className: "w-full flex items-center gap-2 px-4 py-2 text-sm text-error dark:text-error hover:bg-error/10 dark:hover:bg-error/20",
                                    children: [
                                      /* @__PURE__ */ jsx(Icon, { name: "log-out", className: "h-4 w-4" }),
                                      t("auth.signOut")
                                    ]
                                  }
                                )
                              ] })
                            ] })
                          ] })
                        ] })
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(
                Box,
                {
                  as: "main",
                  className: cn(
                    "flex-1 p-3 @sm/dashboard:p-4 @md/dashboard:p-6",
                    // Reserve space for the fixed bottom nav so content isn't
                    // hidden under the tab bar.
                    showBottomNav && "pb-20"
                  ),
                  children
                }
              ),
              showBottomNav && /* @__PURE__ */ jsx(
                Box,
                {
                  as: "nav",
                  className: "fixed bottom-0 inset-x-0 z-20 h-16 bg-card dark:bg-card border-t border-border dark:border-border",
                  children: /* @__PURE__ */ jsx(HStack, { align: "center", justify: "around", className: "h-full px-2", children: navItems.map((item) => /* @__PURE__ */ jsx(
                    NavLinkBottom,
                    {
                      item,
                      activeHref
                    },
                    item.href
                  )) })
                }
              )
            ] })
          ]
        }
      );
    };
    DashboardLayout.displayName = "DashboardLayout";
    NavLink = ({
      item,
      activeHref,
      compact = false
    }) => {
      const hasChildren = !!item.children?.length;
      const childActive = hasChildren && item.children.some((child) => child.href === activeHref);
      const isActive = item.href === activeHref || childActive;
      const [open, setOpen] = useState(childActive);
      const iconClassName = cn(
        "h-5 w-5",
        isActive ? "text-primary-foreground" : "text-muted-foreground"
      );
      if (compact) {
        if (hasChildren) {
          return /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                title: item.label,
                "aria-label": item.label,
                "aria-expanded": open,
                className: cn(
                  "flex items-center justify-center w-full px-2 py-2 rounded-lg transition-colors",
                  isActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                ),
                onClick: () => setOpen(!open),
                children: /* @__PURE__ */ jsxs(Box, { as: "span", className: "relative inline-flex", children: [
                  item.icon ? typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName }) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold", as: "span", children: item.label.charAt(0).toUpperCase() }),
                  item.badge && /* @__PURE__ */ jsx(
                    Badge,
                    {
                      variant: isActive ? "primary" : "default",
                      size: "sm",
                      className: "absolute -top-2 -right-2 px-1 py-0 text-[10px] leading-4",
                      children: item.badge
                    }
                  )
                ] })
              }
            ),
            open && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Box, { className: "fixed inset-0 z-20", onClick: () => setOpen(false) }),
              /* @__PURE__ */ jsx(Box, { className: "absolute left-full top-0 ml-2 w-48 bg-card dark:bg-card rounded-lg shadow-lg border border-border dark:border-border py-1 z-30", children: item.children.map((child) => {
                const childIsActive = child.href === activeHref;
                return /* @__PURE__ */ jsxs(
                  Link,
                  {
                    to: child.href,
                    onClick: () => setOpen(false),
                    className: cn(
                      "flex items-center gap-2 px-3 py-2 text-sm transition-colors",
                      childIsActive ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                    ),
                    children: [
                      child.icon && (typeof child.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: child.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(child.icon, { className: "h-4 w-4" })),
                      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1", as: "span", children: child.label }),
                      child.badge && /* @__PURE__ */ jsx(Badge, { variant: childIsActive ? "primary" : "default", size: "sm", children: child.badge })
                    ]
                  },
                  child.href
                );
              }) })
            ] })
          ] });
        }
        return /* @__PURE__ */ jsx(
          Link,
          {
            to: item.href,
            title: item.label,
            "aria-label": item.label,
            className: cn(
              "flex items-center justify-center px-2 py-2 rounded-lg transition-colors",
              isActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
            ),
            children: /* @__PURE__ */ jsxs(Box, { as: "span", className: "relative inline-flex", children: [
              item.icon ? typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName }) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold", as: "span", children: item.label.charAt(0).toUpperCase() }),
              item.badge && /* @__PURE__ */ jsx(
                Badge,
                {
                  variant: isActive ? "primary" : "default",
                  size: "sm",
                  className: "absolute -top-2 -right-2 px-1 py-0 text-[10px] leading-4",
                  children: item.badge
                }
              )
            ] })
          }
        );
      }
      if (hasChildren) {
        return /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "ghost",
              "aria-expanded": open,
              className: cn(
                "flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                isActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
              ),
              onClick: () => setOpen(!open),
              children: [
                item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName })),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "small",
                    color: isActive ? "inherit" : "primary",
                    className: "flex-1 text-left",
                    as: "span",
                    children: item.label
                  }
                ),
                item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge }),
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "chevron-down",
                    className: cn("h-4 w-4 shrink-0 transition-transform", open && "rotate-180")
                  }
                )
              ]
            }
          ),
          open && /* @__PURE__ */ jsx(
            VStack,
            {
              gap: "none",
              className: "mt-1 ml-4 pl-4 border-l border-border dark:border-border space-y-1",
              children: item.children.map((child) => {
                const childIsActive = child.href === activeHref;
                return /* @__PURE__ */ jsxs(
                  Link,
                  {
                    to: child.href,
                    className: cn(
                      "flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-colors",
                      childIsActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                    ),
                    children: [
                      child.icon && (typeof child.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: child.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(child.icon, { className: "h-4 w-4" })),
                      /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "small",
                          color: childIsActive ? "inherit" : "primary",
                          className: "flex-1",
                          as: "span",
                          children: child.label
                        }
                      ),
                      child.badge && /* @__PURE__ */ jsx(Badge, { variant: childIsActive ? "primary" : "default", size: "sm", children: child.badge })
                    ]
                  },
                  child.href
                );
              })
            }
          )
        ] });
      }
      return /* @__PURE__ */ jsxs(
        Link,
        {
          to: item.href,
          className: cn(
            "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
            isActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
          ),
          children: [
            item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName })),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "small",
                color: isActive ? "inherit" : "primary",
                className: "flex-1",
                as: "span",
                children: item.label
              }
            ),
            item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge })
          ]
        }
      );
    };
    NavLink.displayName = "NavLink";
    NavLinkTopnav = ({
      item,
      activeHref
    }) => {
      const hasChildren = !!item.children?.length;
      const childActive = hasChildren && item.children.some((child) => child.href === activeHref);
      const isActive = item.href === activeHref || childActive;
      const [open, setOpen] = useState(false);
      if (hasChildren) {
        return /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
          /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "ghost",
              "aria-expanded": open,
              className: cn(
                "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap",
                isActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
              ),
              onClick: () => setOpen(!open),
              children: [
                item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(item.icon, { className: "h-4 w-4" })),
                /* @__PURE__ */ jsx(Typography, { variant: "small", color: "inherit", className: "flex-1", as: "span", children: item.label }),
                item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge }),
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "chevron-down",
                    className: cn("h-3.5 w-3.5 shrink-0 transition-transform", open && "rotate-180")
                  }
                )
              ]
            }
          ),
          open && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Box, { className: "fixed inset-0 z-20", onClick: () => setOpen(false) }),
            /* @__PURE__ */ jsx(Box, { className: "absolute left-0 top-full mt-1 w-48 bg-card dark:bg-card rounded-lg shadow-lg border border-border dark:border-border py-1 z-30", children: item.children.map((child) => {
              const childIsActive = child.href === activeHref;
              return /* @__PURE__ */ jsxs(
                Link,
                {
                  to: child.href,
                  onClick: () => setOpen(false),
                  className: cn(
                    "flex items-center gap-2 px-3 py-2 text-sm transition-colors",
                    childIsActive ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                  ),
                  children: [
                    child.icon && (typeof child.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: child.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(child.icon, { className: "h-4 w-4" })),
                    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1", as: "span", children: child.label }),
                    child.badge && /* @__PURE__ */ jsx(Badge, { variant: childIsActive ? "primary" : "default", size: "sm", children: child.badge })
                  ]
                },
                child.href
              );
            }) })
          ] })
        ] });
      }
      return /* @__PURE__ */ jsxs(
        Link,
        {
          to: item.href,
          className: cn(
            "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap",
            isActive ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-muted hover:text-foreground"
          ),
          children: [
            item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(item.icon, { className: "h-4 w-4" })),
            /* @__PURE__ */ jsx(Typography, { variant: "small", color: "inherit", className: "flex-1", as: "span", children: item.label }),
            item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge })
          ]
        }
      );
    };
    NavLinkTopnav.displayName = "NavLinkTopnav";
    NavLinkBottom = ({
      item,
      activeHref
    }) => {
      const isActive = item.href === activeHref;
      const iconClassName = cn(
        "h-5 w-5",
        isActive ? "text-primary" : "text-muted-foreground"
      );
      return /* @__PURE__ */ jsxs(
        Link,
        {
          to: item.href,
          className: "flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-lg transition-colors flex-1 min-w-0",
          children: [
            item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName })),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                className: cn(
                  "text-xs leading-tight truncate max-w-full",
                  isActive ? "text-primary font-medium" : "text-muted-foreground"
                ),
                as: "span",
                children: item.label
              }
            ),
            item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", className: "text-xs px-1 py-0 min-w-0", children: item.badge })
          ]
        }
      );
    };
    NavLinkBottom.displayName = "NavLinkBottom";
  }
});

// lib/relationLabel.ts
function relationLabel(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value) || value instanceof Date)
    return null;
  for (const key of ["name", "title", "label"]) {
    const candidate = value[key];
    if (typeof candidate === "string" && candidate !== "") return candidate;
  }
  const id = value.id;
  return id !== void 0 && id !== null ? String(id) : null;
}
function relationDisplayLabels(value, options) {
  if (value === void 0 || value === null || value === "") return [];
  if (Array.isArray(value)) {
    return value.flatMap((item) => relationDisplayLabels(item, options));
  }
  const hydrated = relationLabel(value);
  if (hydrated !== null) return [hydrated];
  const raw = String(value);
  const match = options?.find((opt) => opt.value === raw);
  return [match ? match.label : raw];
}
function resolveRelationCellDisplay(value, options) {
  if (value === null || value === void 0 || value === "") return void 0;
  const isObjectShaped = typeof value === "object" && !(value instanceof Date) || Array.isArray(value) && value.some((v) => v !== null && typeof v === "object" && !(v instanceof Date));
  if (!isObjectShaped && !options) return void 0;
  const labels = relationDisplayLabels(value, options);
  return labels.length > 0 ? labels.join(", ") : void 0;
}
var init_relationLabel = __esm({
  "lib/relationLabel.ts"() {
  }
});
function downloadItemUrl(url, label) {
  const a = document.createElement("a");
  a.href = url;
  a.download = url.startsWith("data:") ? label : url.split("/").pop() ?? "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
function computeMenuStyle(position, triggerRect) {
  const isTop = position.startsWith("top");
  const isRight = position.endsWith("right") || position.endsWith("end");
  if (isTop) {
    return {
      top: triggerRect.top - MENU_GAP,
      transform: "translateY(-100%)",
      ...isRight ? { right: window.innerWidth - triggerRect.right } : { left: triggerRect.left }
    };
  }
  return {
    top: triggerRect.bottom + MENU_GAP,
    ...isRight ? { right: window.innerWidth - triggerRect.right } : { left: triggerRect.left }
  };
}
function SubMenu({
  items,
  itemRef,
  direction,
  eventBus
}) {
  const [rect, setRect] = useState(null);
  useEffect(() => {
    if (itemRef) {
      setRect(itemRef.getBoundingClientRect());
    }
  }, [itemRef]);
  if (!rect) return null;
  const isRtl = direction === "rtl";
  const style = {
    top: rect.top,
    ...isRtl ? { right: window.innerWidth - rect.left } : { left: rect.right }
  };
  const panel = /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("fixed z-50", menuContainerStyles),
      style,
      children: items.map((item, index) => {
        const isDivider = item.id === "divider" || item.label === "divider";
        const itemId = item.id ?? `item-${item.label.toLowerCase().replace(/\s+/g, "-")}-${index}`;
        const isDanger = item.variant === "danger";
        if (isDivider) {
          return /* @__PURE__ */ jsx(Divider, { className: "my-1" }, `divider-${index}`);
        }
        return /* @__PURE__ */ jsxs(
          Box,
          {
            as: "button",
            onClick: () => {
              if (item.disabled) return;
              if (item.event) eventBus.emit(`UI:${item.event}`, { itemId, label: item.label });
              if (item.url) downloadItemUrl(item.url, item.label);
              item.onClick?.();
            },
            "aria-disabled": item.disabled || void 0,
            title: item.title,
            "data-testid": item.event ? `action-${item.event}` : void 0,
            className: cn(
              "w-full flex items-center gap-3 px-4 py-2 text-start",
              "text-sm transition-colors",
              "hover:bg-muted focus:outline-none focus:bg-muted",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              item.disabled && "cursor-not-allowed",
              isDanger && "text-error hover:bg-error/10"
            ),
            children: [
              item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm", className: "flex-shrink-0" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm", className: "flex-shrink-0" })),
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: cn("flex-1", isDanger && "text-error"), children: item.label }),
              item.badge !== void 0 && /* @__PURE__ */ jsx("span", { className: "ml-auto text-xs font-medium", children: item.badge })
            ]
          },
          itemId
        );
      })
    }
  );
  return typeof document !== "undefined" ? createPortal(panel, getOrCreatePortalRoot()) : panel;
}
function MenuItemRow({
  item,
  itemId,
  hasSubMenu,
  isDanger,
  direction,
  isSubMenuOpen,
  activeSubMenuRef,
  eventBus,
  onItemClick,
  openSubMenu
}) {
  const rowRef = useRef(null);
  const { triggerProps } = useTapReveal({
    enabled: hasSubMenu,
    onReveal: () => openSubMenu(itemId, rowRef.current),
    refs: [rowRef]
  });
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: rowRef,
        as: "button",
        onClick: () => onItemClick({ ...item, id: itemId }, itemId),
        "aria-disabled": item.disabled || void 0,
        title: item.title,
        onMouseEnter: (e) => {
          if (hasSubMenu) openSubMenu(itemId, e.currentTarget);
        },
        onPointerDown: hasSubMenu ? triggerProps.onPointerDown : void 0,
        "data-testid": item.event ? `action-${item.event}` : void 0,
        className: cn(
          "w-full flex items-center justify-between gap-3 px-4 py-2 text-start",
          "text-sm transition-colors",
          "hover:bg-muted",
          "focus:outline-none focus:bg-muted",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          item.disabled && "cursor-not-allowed",
          isDanger && "text-error hover:bg-error/10"
        ),
        children: /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-3 flex-1 min-w-0", children: [
          item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm", className: "flex-shrink-0" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm", className: "flex-shrink-0" })),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "small",
              className: cn("flex-1", isDanger && "text-error"),
              children: item.label
            }
          ),
          item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: item.badge }),
          hasSubMenu && /* @__PURE__ */ jsx(
            Icon,
            {
              name: direction === "rtl" ? "chevron-left" : "chevron-right",
              size: "sm",
              className: "flex-shrink-0"
            }
          )
        ] })
      }
    ),
    hasSubMenu && isSubMenuOpen && item.subMenu && /* @__PURE__ */ jsx(
      SubMenu,
      {
        items: item.subMenu,
        itemRef: activeSubMenuRef,
        direction,
        eventBus
      }
    )
  ] });
}
var MENU_GAP, menuContainerStyles, Menu;
var init_Menu = __esm({
  "components/core/molecules/Menu.tsx"() {
    "use client";
    init_useTapReveal();
    init_Box();
    init_Icon();
    init_Divider();
    init_Typography();
    init_Badge();
    init_cn();
    init_portalRoot();
    init_useEventBus();
    MENU_GAP = 4;
    menuContainerStyles = cn(
      "bg-card",
      "border-[length:var(--border-width)] border-border",
      "shadow-elevation-popover",
      "rounded-sm",
      "min-w-0 sm:min-w-[200px] max-w-[calc(100vw-1rem)] py-1"
    );
    Menu = ({
      trigger,
      items,
      position = "bottom-left",
      className,
      header,
      footer
    }) => {
      const eventBus = useEventBus();
      const { direction } = useTranslate();
      const [isOpen, setIsOpen] = useState(false);
      const [activeSubMenu, setActiveSubMenu] = useState(null);
      const [activeSubMenuRef, setActiveSubMenuRef] = useState(null);
      const [triggerRect, setTriggerRect] = useState(null);
      const triggerRef = useRef(null);
      const menuRef = useRef(null);
      const updatePosition = () => {
        if (triggerRef.current) {
          setTriggerRect(triggerRef.current.getBoundingClientRect());
        }
      };
      const handleToggle = () => {
        if (!isOpen) {
          updatePosition();
        }
        setIsOpen(!isOpen);
        setActiveSubMenu(null);
        setActiveSubMenuRef(null);
      };
      const handleItemClick = (item, itemId) => {
        if (item.disabled) return;
        if (item.subMenu && item.subMenu.length > 0) {
          setActiveSubMenu(itemId);
        } else {
          if (item.event) eventBus.emit(`UI:${item.event}`, { itemId, label: item.label });
          if (item.url) downloadItemUrl(item.url, item.label);
          item.onClick?.();
          setIsOpen(false);
        }
      };
      const openSubMenu = (itemId, el) => {
        setActiveSubMenu(itemId);
        setActiveSubMenuRef(el);
      };
      useEffect(() => {
        if (isOpen) {
          updatePosition();
        }
      }, [isOpen]);
      useEffect(() => {
        const handleClickOutside = (e) => {
          if (isOpen && menuRef.current && !menuRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
            setIsOpen(false);
            setActiveSubMenu(null);
            setActiveSubMenuRef(null);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, [isOpen]);
      const rtlMirror = {
        "top-left": "top-right",
        "top-right": "top-left",
        "bottom-left": "bottom-right",
        "bottom-right": "bottom-left",
        "top-start": "top-end",
        "top-end": "top-start",
        "bottom-start": "bottom-end",
        "bottom-end": "bottom-start"
      };
      const effectivePosition = direction === "rtl" ? rtlMirror[position] ?? position : position;
      const triggerElement = React79__default.isValidElement(trigger) ? React79__default.cloneElement(trigger, {
        ref: triggerRef,
        onClick: handleToggle
      }) : /* @__PURE__ */ jsx(
        Box,
        {
          as: "span",
          ref: (el) => {
            triggerRef.current = el;
          },
          onClick: handleToggle,
          className: "inline-flex",
          children: typeof trigger === "string" || typeof trigger === "number" ? /* @__PURE__ */ jsx(Typography, { variant: "small", as: "span", children: trigger }) : trigger
        }
      );
      const renderMenuItems = (menuItems) => menuItems.map((item, index) => {
        const isDivider = item.id === "divider" || item.label === "divider";
        const itemId = item.id ?? `item-${item.label.toLowerCase().replace(/\s+/g, "-")}-${index}`;
        const hasSubMenu = !!(item.subMenu && item.subMenu.length > 0);
        const isDanger = item.variant === "danger";
        if (isDivider) {
          return /* @__PURE__ */ jsx(Divider, { className: "my-1" }, `divider-${index}`);
        }
        return /* @__PURE__ */ jsx(
          MenuItemRow,
          {
            item,
            itemId,
            hasSubMenu,
            isDanger,
            direction,
            isSubMenuOpen: activeSubMenu === itemId,
            activeSubMenuRef,
            eventBus,
            onItemClick: handleItemClick,
            openSubMenu
          },
          itemId
        );
      });
      const panel = isOpen && triggerRect ? /* @__PURE__ */ jsxs(
        "div",
        {
          ref: menuRef,
          className: cn("fixed z-50", menuContainerStyles, className),
          style: computeMenuStyle(effectivePosition, triggerRect),
          role: "menu",
          children: [
            header && /* @__PURE__ */ jsx("div", { className: "px-4 py-2 border-b border-border", children: header }),
            renderMenuItems(items),
            footer && /* @__PURE__ */ jsx("div", { className: "px-4 py-2 border-t border-border", children: footer })
          ]
        }
      ) : null;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        triggerElement,
        panel && typeof document !== "undefined" ? createPortal(panel, getOrCreatePortalRoot()) : panel
      ] });
    };
    Menu.displayName = "Menu";
  }
});
function useAlmadarDndSensors(withSortableKeyboard = true) {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: ALMADAR_DND_ACTIVATION_DISTANCE }
    }),
    useSensor(
      KeyboardSensor,
      withSortableKeyboard ? { coordinateGetter: sortableKeyboardCoordinates } : void 0
    )
  );
}
var ALMADAR_DND_ACTIVATION_DISTANCE, almadarDndCollisionDetection;
var init_useAlmadarDndCollision = __esm({
  "hooks/useAlmadarDndCollision.ts"() {
    "use client";
    ALMADAR_DND_ACTIVATION_DISTANCE = 5;
    almadarDndCollisionDetection = (args) => {
      const pw = pointerWithin(args);
      if (pw.length > 0) return pw;
      const ri = rectIntersection(args);
      if (ri.length > 0) return ri;
      return closestCorners(args);
    };
  }
});
function useDataDnd(args) {
  const {
    dragGroup,
    accepts,
    sortable,
    dropEvent,
    reorderEvent,
    positionEvent,
    dndItemIdField = "id",
    dndRoot,
    items,
    layout
  } = args;
  const isZone = Boolean(dragGroup || accepts || sortable);
  const enabled = isZone || Boolean(dndRoot);
  const eventBus = useEventBus();
  const parentRoot = React79__default.useContext(RootCtx);
  const isRoot = enabled && parentRoot === null;
  const zoneId = React79__default.useId();
  const ownGroup = dragGroup ?? accepts ?? zoneId;
  const [optimisticOrders, setOptimisticOrders] = React79__default.useState(() => /* @__PURE__ */ new Map());
  const optimisticOrdersRef = React79__default.useRef(optimisticOrders);
  optimisticOrdersRef.current = optimisticOrders;
  const clearOptimisticOrder = React79__default.useCallback((group) => {
    setOptimisticOrders((prev) => {
      if (!prev.has(group)) return prev;
      const next = new Map(prev);
      next.delete(group);
      return next;
    });
  }, []);
  const sharedOptimistic = isRoot ? optimisticOrders : parentRoot?.optimisticOrders ?? /* @__PURE__ */ new Map();
  const optimisticEntry = sharedOptimistic.get(ownGroup);
  const orderedItems = optimisticEntry ?? items;
  if (isZone && enabled) {
    dndLog.debug("hook:render", {
      group: ownGroup,
      isRoot,
      itemsLen: items.length,
      optimisticEntryLen: optimisticEntry ? optimisticEntry.length : null,
      orderedLen: orderedItems.length,
      sharedKeys: Array.from(sharedOptimistic.keys())
    });
  }
  const itemIdsSignature = orderedItems.map((it, idx) => {
    const raw = it[dndItemIdField];
    return raw != null ? String(raw) : `__idx_${idx}`;
  }).join("|");
  const itemIds = React79__default.useMemo(
    () => orderedItems.map((it, idx) => {
      const raw = it[dndItemIdField];
      return raw != null ? String(raw) : `__idx_${idx}`;
    }),
    [itemIdsSignature]
  );
  const itemsContentSig = items.map((it, idx) => {
    const raw = it[dndItemIdField];
    return raw != null ? String(raw) : `__${idx}`;
  }).join("|");
  React79__default.useEffect(() => {
    const root = isRoot ? null : parentRoot;
    if (root) {
      root.clearOptimisticOrder(ownGroup);
    } else {
      clearOptimisticOrder(ownGroup);
    }
  }, [itemsContentSig, ownGroup]);
  const zonesRef = React79__default.useRef(/* @__PURE__ */ new Map());
  const registerZone = React79__default.useCallback((zoneId2, meta2) => {
    zonesRef.current.set(zoneId2, meta2);
  }, []);
  const unregisterZone = React79__default.useCallback((zoneId2) => {
    zonesRef.current.delete(zoneId2);
  }, []);
  const [activeDrag, setActiveDrag] = React79__default.useState(null);
  const [overZoneGroup, setOverZoneGroup] = React79__default.useState(null);
  const meta = React79__default.useMemo(
    () => ({ group: ownGroup, dropEvent, reorderEvent, positionEvent, itemIds, rawItems: items, idField: dndItemIdField }),
    [ownGroup, dropEvent, reorderEvent, positionEvent, itemIds, items, dndItemIdField]
  );
  React79__default.useEffect(() => {
    const target = isRoot ? null : parentRoot;
    if (!target) {
      zonesRef.current.set(zoneId, meta);
      dndLog.debug("zone:register:self", { zoneId, group: meta.group, itemCount: meta.itemIds.length, isRoot });
      return () => {
        zonesRef.current.delete(zoneId);
        dndLog.debug("zone:unregister:self", { zoneId, group: meta.group });
      };
    }
    target.registerZone(zoneId, meta);
    dndLog.debug("zone:register", { zoneId, group: meta.group, itemCount: meta.itemIds.length, dropEvent: meta.dropEvent, reorderEvent: meta.reorderEvent });
    return () => {
      target.unregisterZone(zoneId);
      dndLog.debug("zone:unregister", { zoneId, group: meta.group });
    };
  }, [parentRoot, isRoot, zoneId, meta]);
  const sensors = useAlmadarDndSensors(true);
  const collisionDetection = almadarDndCollisionDetection;
  const findZoneByItem = React79__default.useCallback(
    (id) => {
      for (const z of zonesRef.current.values()) {
        if (z.itemIds.includes(id)) return z;
      }
      return void 0;
    },
    []
  );
  React79__default.useCallback(
    (group) => {
      for (const z of zonesRef.current.values()) {
        if (z.group === group) return z;
      }
      return void 0;
    },
    []
  );
  const handleDragEnd = React79__default.useCallback(
    (event) => {
      const { active, over } = event;
      const activeIdStr = String(active.id);
      dndLog.debug("dragEnd:received", {
        activeId: active.id,
        overId: over?.id,
        overData: over?.data?.current
      });
      let sourceMeta;
      let oldIndex = -1;
      let targetMeta;
      let newIndex = -1;
      for (const m of zonesRef.current.values()) {
        const rawIdx = m.rawItems.findIndex((it) => String(it[m.idField]) === activeIdStr);
        if (rawIdx >= 0) {
          sourceMeta = m;
          oldIndex = rawIdx;
        }
        const currentItems = optimisticOrdersRef.current.get(m.group) ?? m.rawItems;
        const curIdx = currentItems.findIndex((it) => String(it[m.idField]) === activeIdStr);
        if (curIdx >= 0) {
          targetMeta = m;
          newIndex = curIdx;
        }
      }
      if (!sourceMeta || !targetMeta) {
        dndLog.warn("dragEnd:abort:no-zone-resolved", { activeId: active.id, hasSource: !!sourceMeta, hasTarget: !!targetMeta });
        return;
      }
      const emitPositions = (zoneMeta) => {
        if (!zoneMeta.positionEvent) {
          dndLog.debug("dragEnd:positions:no-event", { group: zoneMeta.group });
          return;
        }
        const evt = `UI:${zoneMeta.positionEvent}`;
        const order = optimisticOrdersRef.current.get(zoneMeta.group) ?? zoneMeta.rawItems;
        order.forEach((it, idx) => {
          const id = String(it[zoneMeta.idField]);
          const position = idx * 1e3;
          eventBus.emit(evt, { id, position });
        });
        dndLog.info("dragEnd:positions:emitted", { event: evt, group: zoneMeta.group, count: order.length });
      };
      if (sourceMeta.group !== targetMeta.group) {
        if (targetMeta.dropEvent) {
          const evt = `UI:${targetMeta.dropEvent}`;
          dndLog.info("dragEnd:cross-container:emit", {
            event: evt,
            id: activeIdStr,
            sourceGroup: sourceMeta.group,
            targetGroup: targetMeta.group,
            newIndex
          });
          eventBus.emit(evt, {
            id: activeIdStr,
            sourceGroup: sourceMeta.group,
            targetGroup: targetMeta.group,
            newIndex
          });
        } else {
          dndLog.warn("dragEnd:cross-container:no-dropEvent-on-target", { targetGroup: targetMeta.group });
        }
        emitPositions(sourceMeta);
        emitPositions(targetMeta);
        return;
      }
      if (oldIndex === newIndex) {
        dndLog.debug("dragEnd:reorder:no-op", { sourceGroup: sourceMeta.group, oldIndex });
        return;
      }
      if (sourceMeta.reorderEvent) {
        const evt = `UI:${sourceMeta.reorderEvent}`;
        dndLog.info("dragEnd:reorder:emit", {
          event: evt,
          id: activeIdStr,
          oldIndex,
          newIndex
        });
        eventBus.emit(evt, {
          id: activeIdStr,
          oldIndex,
          newIndex
        });
      } else {
        dndLog.debug("dragEnd:reorder:no-reorderEvent", { sourceGroup: sourceMeta.group });
      }
      emitPositions(sourceMeta);
    },
    [eventBus]
  );
  const sortableData = React79__default.useMemo(() => ({ dndGroup: ownGroup }), [ownGroup]);
  const SortableItem = React79__default.useCallback(
    ({ id, children }) => {
      const {
        attributes,
        listeners: listeners7,
        setNodeRef,
        transform,
        transition,
        isDragging
      } = useSortable({ id, data: sortableData });
      const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        cursor: enabled ? "grab" : void 0,
        // Lift the dragged element above siblings so its visual movement
        // isn't hidden behind other cards / column boundaries.
        zIndex: isDragging ? 50 : void 0,
        position: isDragging ? "relative" : void 0
      };
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "touch-none",
          ref: setNodeRef,
          style,
          ...attributes,
          ...listeners7,
          children
        }
      );
    },
    [sortableData, enabled]
  );
  const DropZoneShell = ({ children }) => {
    const droppableId = `dnd-zone-${zoneId}`;
    const { setNodeRef, isOver } = useDroppable({
      id: droppableId,
      data: sortableData
    });
    const ctx = React79__default.useContext(RootCtx);
    const activeDrag2 = ctx?.activeDrag ?? null;
    const overZoneGroup2 = ctx?.overZoneGroup ?? null;
    const isThisZoneOver = overZoneGroup2 === ownGroup;
    const showForeignPlaceholder = isThisZoneOver && activeDrag2 != null && activeDrag2.sourceGroup !== ownGroup;
    dndLog.debug("dropzone:render", {
      group: ownGroup,
      isOver,
      isThisZoneOver,
      overZoneGroup: overZoneGroup2,
      activeDragSourceGroup: activeDrag2?.sourceGroup ?? null,
      activeDragHeight: activeDrag2?.height ?? null,
      showForeignPlaceholder,
      ctxAvailable: ctx != null
    });
    React79__default.useEffect(() => {
      dndLog.info("dropzone:isOver:change", { droppableId, group: ownGroup, isOver, isThisZoneOver, showForeignPlaceholder, activeDragSourceGroup: activeDrag2?.sourceGroup ?? null });
    }, [droppableId, isOver, isThisZoneOver, showForeignPlaceholder]);
    return /* @__PURE__ */ jsx(
      Box,
      {
        ref: setNodeRef,
        "data-dnd-zone": ownGroup,
        "data-dnd-is-over": isThisZoneOver ? "true" : "false",
        className: isThisZoneOver ? "ring-2 ring-primary/40 ring-offset-2 rounded-lg transition-all min-h-[3rem]" : "min-h-[3rem] rounded-lg transition-all",
        children
      }
    );
  };
  const rootContextValue = React79__default.useMemo(
    () => ({ registerZone, unregisterZone, activeDrag, overZoneGroup, optimisticOrders, clearOptimisticOrder }),
    [registerZone, unregisterZone, activeDrag, overZoneGroup, optimisticOrders, clearOptimisticOrder]
  );
  const handleDragStart = React79__default.useCallback((event) => {
    const sourceZone = findZoneByItem(event.active.id);
    const rect = event.active.rect.current.initial;
    const height = rect?.height && rect.height > 0 ? rect.height : 64;
    if (sourceZone) {
      setActiveDrag({ sourceGroup: sourceZone.group, height });
      dndLog.info("dragStart:activeDrag:set", { sourceGroup: sourceZone.group, height, isRoot, hookZoneId: zoneId });
    } else {
      dndLog.warn("dragStart:no-source-zone", { activeId: event.active.id, zoneCount: zonesRef.current.size, isRoot });
    }
    dndLog.info("dragStart", {
      activeId: event.active.id,
      activeData: event.active.data?.current,
      sourceGroup: sourceZone?.group,
      height,
      zoneCount: zonesRef.current.size,
      isRoot
    });
  }, [findZoneByItem, isRoot, zoneId]);
  const handleDragOver = React79__default.useCallback((event) => {
    const { active, over } = event;
    const overData = over?.data?.current;
    const overGroup = overData?.dndGroup ?? null;
    setOverZoneGroup(overGroup);
    if (!over || !overGroup) return;
    const activeIdStr = String(active.id);
    let sourceMeta;
    let sourceGroup;
    for (const m of zonesRef.current.values()) {
      const currentItems = optimisticOrdersRef.current.get(m.group) ?? m.rawItems;
      const found = currentItems.find((it) => String(it[m.idField]) === activeIdStr);
      if (found) {
        sourceMeta = m;
        sourceGroup = m.group;
        break;
      }
    }
    if (!sourceMeta || !sourceGroup) {
      dndLog.debug("dragOver:no-source-zone", { activeId: active.id });
      return;
    }
    let targetMeta;
    for (const m of zonesRef.current.values()) {
      if (m.group === overGroup) {
        targetMeta = m;
        break;
      }
    }
    if (!targetMeta) {
      dndLog.debug("dragOver:no-target-zone", { overGroup });
      return;
    }
    if (sourceGroup === overGroup) {
      setOptimisticOrders((prev) => {
        const currentItems = prev.get(sourceGroup) ?? sourceMeta.rawItems;
        const oldIndex = currentItems.findIndex((it) => String(it[sourceMeta.idField]) === activeIdStr);
        const newIndex = currentItems.findIndex((it) => String(it[sourceMeta.idField]) === String(over.id));
        if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) return prev;
        const reordered = arrayMove([...currentItems], oldIndex, newIndex);
        const next = new Map(prev);
        next.set(sourceGroup, reordered);
        return next;
      });
      return;
    }
    setOptimisticOrders((prev) => {
      const currentSource = prev.get(sourceGroup) ?? sourceMeta.rawItems;
      const currentTarget = prev.get(overGroup) ?? targetMeta.rawItems;
      const activeItem = currentSource.find((it) => String(it[sourceMeta.idField]) === activeIdStr);
      if (!activeItem) return prev;
      if (currentTarget.some((it) => String(it[targetMeta.idField]) === activeIdStr)) {
        return prev;
      }
      const newSource = currentSource.filter((it) => String(it[sourceMeta.idField]) !== activeIdStr);
      const overIdStr = String(over.id);
      const overIndex = currentTarget.findIndex((it) => String(it[targetMeta.idField]) === overIdStr);
      const insertAt = overIndex >= 0 ? overIndex : currentTarget.length;
      const newTarget = [
        ...currentTarget.slice(0, insertAt),
        activeItem,
        ...currentTarget.slice(insertAt)
      ];
      const next = new Map(prev);
      next.set(sourceGroup, newSource);
      next.set(overGroup, newTarget);
      dndLog.debug("dragOver:cross-zone:splice", { sourceGroup, overGroup, sourceLen: newSource.length, targetLen: newTarget.length, insertAt });
      return next;
    });
  }, []);
  const handleDragCancel = React79__default.useCallback((event) => {
    setActiveDrag(null);
    setOverZoneGroup(null);
    dndLog.warn("dragCancel", {
      activeId: event.active.id,
      reason: "dnd-kit cancelled the drag (escape key, pointer interrupted, or external)"
    });
  }, []);
  const handleDragEndWithCleanup = React79__default.useCallback((event) => {
    handleDragEnd(event);
    setActiveDrag(null);
    setOverZoneGroup(null);
  }, [handleDragEnd]);
  const wrapContainer = React79__default.useCallback(
    (children) => {
      if (!enabled) return children;
      const strategy = layout === "grid" ? rectSortingStrategy : verticalListSortingStrategy;
      if (!isZone) {
        if (!isRoot) return children;
        return /* @__PURE__ */ jsx(RootCtx.Provider, { value: rootContextValue, children: /* @__PURE__ */ jsx(
          DndContext,
          {
            sensors,
            collisionDetection,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragEnd: handleDragEndWithCleanup,
            onDragCancel: handleDragCancel,
            children
          }
        ) });
      }
      const inner = /* @__PURE__ */ jsx(DropZoneShell, { children: /* @__PURE__ */ jsx(SortableContext, { items: itemIds, strategy, children }) });
      if (isRoot) {
        return /* @__PURE__ */ jsx(RootCtx.Provider, { value: rootContextValue, children: /* @__PURE__ */ jsx(
          DndContext,
          {
            sensors,
            collisionDetection,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragEnd: handleDragEndWithCleanup,
            onDragCancel: handleDragCancel,
            children: inner
          }
        ) });
      }
      return inner;
    },
    [enabled, isZone, layout, sensors, collisionDetection, handleDragStart, handleDragOver, handleDragEndWithCleanup, handleDragCancel, itemIds, isRoot, rootContextValue]
  );
  return {
    enabled,
    isZone,
    wrapContainer,
    SortableItem,
    orderedItems
  };
}
var dndLog, RootCtx;
var init_useDataDnd = __esm({
  "components/core/molecules/useDataDnd.tsx"() {
    "use client";
    init_useEventBus();
    init_useAlmadarDndCollision();
    init_Box();
    dndLog = createLogger("almadar:ui:dnd");
    RootCtx = React79__default.createContext(null);
  }
});
function renderIconInput(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function statusVariant2(value) {
  const v = value.toLowerCase();
  if (["active", "completed", "done", "approved", "published", "resolved", "open", "online"].includes(v)) return "success";
  if (["pending", "in_progress", "in-progress", "review", "draft", "processing", "warning"].includes(v)) return "warning";
  if (["inactive", "deleted", "rejected", "failed", "error", "blocked", "closed", "offline"].includes(v)) return "error";
  if (["new", "created", "scheduled", "queued", "info"].includes(v)) return "info";
  return "default";
}
function resolveBadgeVariant(field, value) {
  const fromMap = field.colorMap?.[value];
  if (fromMap) {
    const normalised = fromMap === "destructive" ? "danger" : fromMap;
    if (BADGE_VARIANTS.has(normalised)) {
      return normalised;
    }
  }
  return statusVariant2(value);
}
function DataGrid({
  entity,
  fields,
  columns,
  itemActions,
  maxInlineActions,
  scrollX = false,
  cols,
  gap = "md",
  minCardWidth = 280,
  className,
  isLoading = false,
  error = null,
  imageField,
  selectable = false,
  selectionEvent,
  infiniteScroll,
  loadMoreEvent,
  hasMore,
  children,
  pageSize = 0,
  renderItem: schemaRenderItem,
  dragGroup,
  accepts,
  sortable,
  dropEvent,
  reorderEvent,
  positionEvent,
  dndItemIdField,
  dndRoot,
  look = "dense",
  relationsData
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [selectedIds, setSelectedIds] = useState(/* @__PURE__ */ new Set());
  const [visibleCount, setVisibleCount] = useState(pageSize || Infinity);
  const fieldDefs = (Array.isArray(fields) ? fields : void 0) ?? (Array.isArray(columns) ? columns : void 0) ?? [];
  const actionDefs = Array.isArray(itemActions) ? itemActions : [];
  const allDataRaw = Array.isArray(entity) ? entity : entity ? [entity] : [];
  const dnd = useDataDnd({
    items: allDataRaw,
    layout: "grid",
    dragGroup,
    accepts,
    sortable,
    dropEvent,
    reorderEvent,
    positionEvent,
    dndItemIdField,
    dndRoot
  });
  const allData = dnd.orderedItems;
  const data = pageSize > 0 ? allData.slice(0, visibleCount) : allData;
  const hasMoreLocal = pageSize > 0 && visibleCount < allData.length;
  const toggleSelection = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      if (selectionEvent) {
        const payload = { selectedIds: Array.from(next) };
        eventBus.emit(`UI:${selectionEvent}`, payload);
      }
      return next;
    });
  }, [selectionEvent, eventBus]);
  const toggleAll = useCallback(() => {
    setSelectedIds((prev) => {
      const allIds2 = data.map((item, i) => item.id || String(i));
      const allSelected2 = allIds2.length > 0 && allIds2.every((id) => prev.has(id));
      const next = allSelected2 ? /* @__PURE__ */ new Set() : new Set(allIds2);
      if (selectionEvent) {
        const payload = { selectedIds: Array.from(next) };
        eventBus.emit(`UI:${selectionEvent}`, payload);
      }
      return next;
    });
  }, [data, selectionEvent, eventBus]);
  const titleField = fieldDefs.find((f3) => f3.variant === "h3" || f3.variant === "h4") ?? fieldDefs[0];
  const badgeFields = fieldDefs.filter((f3) => f3.variant === "badge" && f3 !== titleField);
  const bodyFields = fieldDefs.filter((f3) => f3 !== titleField && !badgeFields.includes(f3));
  const inlineCap = Math.min(maxInlineActions ?? 1, 1);
  const inlineCardActions = actionDefs.filter((a) => a.variant === "primary").slice(0, inlineCap);
  const menuCardActions = actionDefs.filter((a) => !inlineCardActions.includes(a));
  const fireAction = (action, itemData) => {
    if (action.navigatesTo) {
      const url = action.navigatesTo.replace(
        /\{\{row\.(\w+(?:\.\w+)*)\}\}/g,
        (_, field) => String(itemData[field] ?? "")
      );
      eventBus.emit("UI:NAVIGATE", { url, row: itemData });
      return;
    }
    const payload = {
      id: itemData.id,
      row: itemData
    };
    eventBus.emit(`UI:${action.event}`, payload);
  };
  const handleActionClick = (action, itemData) => (e) => {
    e.stopPropagation();
    fireAction(action, itemData);
  };
  const cardClickAction = actionDefs.find((a) => a.variant !== "danger");
  const handleCardClick = cardClickAction ? (itemData) => () => fireAction(cardClickAction, itemData) : void 0;
  const stopCardClick = handleCardClick ? (e) => e.stopPropagation() : void 0;
  const renderItemFn = typeof schemaRenderItem === "function" ? schemaRenderItem : void 0;
  const itemRenderer = typeof children === "function" ? children : renderItemFn;
  const hasRenderProp = typeof itemRenderer === "function";
  useEffect(() => {
    if (data.length > 0 && !hasRenderProp && fieldDefs.length === 0) {
      const schemaArr = Array.isArray(schemaRenderItem) ? schemaRenderItem : null;
      const isFnLambda = schemaArr !== null && schemaArr.length >= 3 && (schemaArr[0] === "fn" || schemaArr[0] === "lambda");
      dataGridLog.warn("renderItem-unresolved", {
        rowCount: data.length,
        renderItemIsFnLambda: isFnLambda
      });
    }
  }, [data, hasRenderProp, schemaRenderItem, fieldDefs]);
  const gridTemplateColumns = cols ? void 0 : `repeat(auto-fit, minmax(min(${minCardWidth}px, 100%), 1fr))`;
  const colsClass = cols ? {
    1: "grid-cols-1",
    2: "sm:grid-cols-2 @max-sm:!grid-cols-1",
    3: "sm:grid-cols-2 lg:grid-cols-3 @max-lg:!grid-cols-2 @max-sm:!grid-cols-1",
    4: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 @max-xl:!grid-cols-3 @max-lg:!grid-cols-2 @max-sm:!grid-cols-1",
    5: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 @max-xl:!grid-cols-3 @max-lg:!grid-cols-2 @max-sm:!grid-cols-1",
    6: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 @max-xl:!grid-cols-3 @max-lg:!grid-cols-2 @max-sm:!grid-cols-1"
  }[cols] : void 0;
  if (isLoading) {
    return /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: t("loading.items") }) });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) });
  }
  if (data.length === 0) {
    const emptyNode = /* @__PURE__ */ jsx(Box, { className: "text-center py-12", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: t("empty.noItems") }) });
    return dnd.enabled ? /* @__PURE__ */ jsx(Fragment, { children: dnd.wrapContainer(emptyNode) }) : emptyNode;
  }
  const allIds = data.map((item, i) => item.id || String(i));
  const allSelected = allIds.length > 0 && allIds.every((id) => selectedIds.has(id));
  const someSelected = selectedIds.size > 0;
  const idFieldName = dndItemIdField ?? "id";
  return dnd.wrapContainer(
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      selectable && someSelected && /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center px-2 py-2 bg-muted rounded-sm", children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "checkbox",
            checked: allSelected,
            onChange: toggleAll,
            className: "w-4 h-4 accent-primary",
            "aria-label": t("aria.selectAll")
          }
        ),
        /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "font-semibold", children: [
          selectedIds.size,
          " ",
          t("common.selected") || "selected"
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("grid", gapStyles5[gap], scrollX ? "grid-flow-col overflow-x-auto" : colsClass, lookStyles5[look], className),
          style: scrollX ? { gridAutoFlow: "column", gridAutoColumns: `minmax(${minCardWidth}px, 1fr)` } : gridTemplateColumns ? { gridTemplateColumns } : void 0,
          children: data.map((item, index) => {
            const itemData = item;
            const id = itemData.id || String(index);
            const isSelected = selectedIds.has(id);
            const dndId = itemData[idFieldName] ?? `__idx_${index}`;
            const wrapDnd = (node) => dnd.isZone ? /* @__PURE__ */ jsx(dnd.SortableItem, { id: dndId, children: node }, dndId) : node;
            if (hasRenderProp) {
              return wrapDnd(
                /* @__PURE__ */ jsxs(
                  Box,
                  {
                    "data-entity-row": true,
                    "data-entity-id": id,
                    onClick: handleCardClick?.(itemData),
                    className: cn("relative group/rowactions", handleCardClick && "cursor-pointer", isSelected && "ring-2 ring-primary rounded-lg"),
                    children: [
                      itemRenderer(itemData, index),
                      actionDefs.length > 0 && /* @__PURE__ */ jsx(Box, { onClick: stopCardClick, className: "absolute top-2 right-2 z-10 opacity-0 group-hover/rowactions:opacity-100 focus-within:opacity-100 [@media(pointer:coarse)]:opacity-100 transition-opacity duration-fast", children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "rounded-md border border-border bg-card/95 backdrop-blur-sm shadow-sm p-0.5", children: [
                        inlineCardActions.map((action, idx) => /* @__PURE__ */ jsxs(
                          Button,
                          {
                            variant: "primary",
                            size: "sm",
                            onClick: handleActionClick(action, itemData),
                            "data-testid": `action-${action.event}`,
                            "data-row-id": String(itemData.id),
                            children: [
                              action.icon && renderIconInput(action.icon, { size: "xs", className: "mr-1" }),
                              action.label
                            ]
                          },
                          idx
                        )),
                        menuCardActions.length > 0 && /* @__PURE__ */ jsx(
                          Menu,
                          {
                            position: "bottom-end",
                            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                            items: menuCardActions.map((action) => ({
                              label: action.label,
                              icon: action.icon,
                              variant: action.variant === "danger" ? "danger" : "default",
                              onClick: () => fireAction(action, itemData)
                            }))
                          }
                        )
                      ] }) })
                    ]
                  },
                  id
                )
              );
            }
            const titleValue = getNestedValue(itemData, titleField?.name ?? "");
            const titleDisplay = resolveRelationCellDisplay(
              titleValue,
              titleField ? relationsData?.[titleField.name] : void 0
            ) ?? (titleValue !== void 0 && titleValue !== null ? String(titleValue) : void 0);
            return wrapDnd(
              /* @__PURE__ */ jsxs(
                Box,
                {
                  "data-entity-row": true,
                  "data-entity-id": id,
                  onClick: handleCardClick?.(itemData),
                  className: cn(
                    "bg-card rounded-lg",
                    "border border-border",
                    "shadow-elevation-card hover:shadow-elevation-dialog",
                    "hover:border-primary transition-all",
                    "flex flex-col",
                    handleCardClick && "cursor-pointer",
                    isSelected && "ring-2 ring-primary border-primary"
                  ),
                  children: [
                    imageField && (() => {
                      const imgUrl = resolveImageUrl(getNestedValue(itemData, imageField));
                      if (!imgUrl) return null;
                      return /* @__PURE__ */ jsx(Box, { className: "w-full aspect-video overflow-hidden rounded-t-lg", children: /* @__PURE__ */ jsx(
                        "img",
                        {
                          src: imgUrl,
                          alt: titleDisplay ?? "",
                          className: "w-full h-full object-cover",
                          loading: "lazy"
                        }
                      ) });
                    })(),
                    /* @__PURE__ */ jsx(Box, { className: cn("p-4", bodyFields.length > 0 && "pb-0"), children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "justify-between items-start", children: [
                      selectable && /* @__PURE__ */ jsx(
                        "input",
                        {
                          type: "checkbox",
                          checked: isSelected,
                          onChange: () => toggleSelection(id),
                          onClick: (e) => e.stopPropagation(),
                          className: "w-4 h-4 mt-1 flex-shrink-0 accent-primary",
                          "aria-label": t("card.selectItem", { item: titleDisplay ?? t("card.itemFallback") })
                        }
                      ),
                      /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
                        titleDisplay !== void 0 && /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center min-w-0", children: [
                          titleField?.icon && renderIconInput(titleField.icon, { size: "sm", className: "text-primary flex-shrink-0" }),
                          /* @__PURE__ */ jsx(
                            Typography,
                            {
                              variant: titleField?.variant === "h3" ? "h3" : "h4",
                              className: "font-semibold truncate min-w-0",
                              children: titleDisplay
                            }
                          )
                        ] }),
                        badgeFields.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: badgeFields.map((field) => {
                          const val = getNestedValue(itemData, field.name);
                          if (val === void 0 || val === null || val === "") return null;
                          return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                            field.icon && renderIconInput(field.icon, { size: "xs" }),
                            /* @__PURE__ */ jsx(Badge, { variant: resolveBadgeVariant(field, String(val)), children: resolveRelationCellDisplay(val, relationsData?.[field.name]) ?? humanizeEnumValue(formatValue(val, field.format)) })
                          ] }, field.name);
                        }) })
                      ] }),
                      actionDefs.length > 0 && /* @__PURE__ */ jsxs(HStack, { gap: "xs", onClick: stopCardClick, className: "flex-shrink-0", children: [
                        inlineCardActions.map((action, idx) => /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: "primary",
                            size: "sm",
                            onClick: handleActionClick(action, itemData),
                            "data-testid": `action-${action.event}`,
                            "data-row-id": String(itemData.id),
                            "aria-label": action.label,
                            title: action.label,
                            className: cn(action.icon && "px-2"),
                            children: action.icon ? renderIconInput(action.icon, { size: "xs" }) : action.label
                          },
                          idx
                        )),
                        menuCardActions.length > 0 && /* @__PURE__ */ jsx(
                          Menu,
                          {
                            position: "bottom-end",
                            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                            items: menuCardActions.map((action) => ({
                              label: action.label,
                              icon: action.icon,
                              variant: action.variant === "danger" ? "danger" : "default",
                              onClick: () => fireAction(action, itemData)
                            }))
                          }
                        )
                      ] })
                    ] }) }),
                    bodyFields.length > 0 && /* @__PURE__ */ jsx(Box, { className: "px-4 pt-2 pb-4 flex-1", children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                      bodyFields.filter((f3) => f3.variant === "caption" && f3.format !== "boolean").map((field) => {
                        const value = getNestedValue(itemData, field.name);
                        if (value === void 0 || value === null || value === "") return null;
                        return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", className: "line-clamp-2", children: resolveRelationCellDisplay(value, relationsData?.[field.name]) ?? formatValue(value, field.format) }, field.name);
                      }),
                      /* @__PURE__ */ jsx(HStack, { gap: "md", className: "flex-wrap gap-y-1", children: bodyFields.filter((f3) => f3.variant !== "caption" || f3.format === "boolean").map((field) => {
                        const value = getNestedValue(itemData, field.name);
                        if (value === void 0 || value === null || value === "") return null;
                        if (field.format === "boolean") {
                          return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                            field.icon && renderIconInput(field.icon, { size: "xs", className: "text-muted-foreground" }),
                            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: field.label ?? fieldLabel2(field.name) }),
                            /* @__PURE__ */ jsx(Badge, { variant: value ? "success" : "neutral", children: value ? t("common.yes") || "Yes" : t("common.no") || "No" })
                          ] }, field.name);
                        }
                        return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                          field.icon && renderIconInput(field.icon, { size: "xs", className: "text-muted-foreground" }),
                          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "sr-only", children: (field.label ?? fieldLabel2(field.name)) + ":" }),
                          /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: resolveRelationCellDisplay(value, relationsData?.[field.name]) ?? formatValue(value, field.format) })
                        ] }, field.name);
                      }) })
                    ] }) })
                  ]
                },
                id
              )
            );
          })
        }
      ),
      hasMoreLocal && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => setVisibleCount((prev) => prev + (pageSize || 5)),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
            t("common.showMore"),
            " (",
            t("common.remaining", { count: allData.length - visibleCount }),
            ")"
          ]
        }
      ) }),
      infiniteScroll && loadMoreEvent && /* @__PURE__ */ jsx(
        InfiniteScrollSentinel,
        {
          loadMoreEvent,
          isLoading,
          hasMore
        }
      )
    ] })
  );
}
var dataGridLog, fieldLabel2, BADGE_VARIANTS, gapStyles5, lookStyles5;
var init_DataGrid = __esm({
  "components/core/molecules/DataGrid.tsx"() {
    "use client";
    init_cn();
    init_format();
    init_relationLabel();
    init_getNestedValue();
    init_useEventBus();
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    init_Button();
    init_Icon();
    init_InfiniteScrollSentinel();
    init_Menu();
    init_useDataDnd();
    dataGridLog = createLogger("almadar:ui:data-grid");
    fieldLabel2 = humanizeFieldName;
    BADGE_VARIANTS = /* @__PURE__ */ new Set([
      "default",
      "primary",
      "secondary",
      "success",
      "warning",
      "danger",
      "error",
      "info",
      "neutral"
    ]);
    gapStyles5 = {
      none: "gap-0",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    };
    lookStyles5 = {
      dense: "gap-2 [&>*]:p-card-sm",
      spacious: "gap-8 [&>*]:p-card-lg",
      striped: "[&>*:nth-child(even)]:bg-muted/30",
      borderless: "[&>*]:border-0 [&>*]:shadow-none",
      "card-rows": "[&>*]:shadow-elevation-card [&>*]:rounded-container [&>*]:border [&>*]:border-border [&>*]:p-card-md"
    };
    DataGrid.displayName = "DataGrid";
  }
});
function renderIconInput2(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function statusVariant3(value) {
  const v = value.toLowerCase();
  if (["active", "completed", "done", "approved", "published", "resolved", "open", "online"].includes(v)) return "success";
  if (["pending", "in_progress", "in-progress", "review", "draft", "processing", "warning"].includes(v)) return "warning";
  if (["inactive", "deleted", "rejected", "failed", "error", "blocked", "closed", "offline"].includes(v)) return "error";
  if (["new", "created", "scheduled", "queued", "info"].includes(v)) return "info";
  return "default";
}
function formatValue2(value, format, boolLabels, relationOptions) {
  const relationDisplay = resolveRelationCellDisplay(value, relationOptions);
  if (relationDisplay !== void 0) return relationDisplay;
  if (value !== void 0 && value !== null && (format === "boolean" || typeof value === "boolean")) {
    const isNo = value === false || value === 0 || String(value) === "false";
    return isNo ? boolLabels?.no ?? "No" : boolLabels?.yes ?? "Yes";
  }
  return formatValue(value, format);
}
function groupData(items, field) {
  const groups = /* @__PURE__ */ new Map();
  for (const item of items) {
    const key = String(getNestedValue(item, field) ?? "");
    const group = groups.get(key);
    if (group) group.push(item);
    else groups.set(key, [item]);
  }
  return Array.from(groups.entries()).map(([label, groupItems]) => ({ label, items: groupItems }));
}
function DataList({
  entity,
  fields,
  columns,
  itemActions,
  maxInlineActions,
  itemClickEvent,
  gap = "none",
  variant = "default",
  groupBy,
  senderField,
  senderLabelField,
  currentUser,
  emptyMessage,
  className,
  isLoading = false,
  error = null,
  // Gesture props: reorderable, swipeLeftEvent, swipeRightEvent, longPressEvent
  // are consumed by the compiler to wrap items in SwipeableRow/SortableList.
  // DataList destructures them here to prevent DOM passthrough.
  reorderable: _reorderable,
  reorderEvent: _reorderEvent,
  swipeLeftEvent: _swipeLeftEvent,
  swipeLeftActions: _swipeLeftActions,
  swipeRightEvent: _swipeRightEvent,
  swipeRightActions: _swipeRightActions,
  longPressEvent: _longPressEvent,
  infiniteScroll,
  loadMoreEvent,
  hasMore,
  children,
  pageSize = 5,
  sortBy,
  sortDirection,
  renderItem: schemaRenderItem,
  dragGroup,
  accepts,
  sortable: sortableProp,
  dropEvent,
  reorderEvent: dndReorderEvent,
  positionEvent,
  dndItemIdField,
  dndRoot,
  look = "dense",
  relationsData
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [visibleCount, setVisibleCount] = React79__default.useState(pageSize || Infinity);
  const fieldDefs = fields ?? columns ?? [];
  const allDataRaw = Array.isArray(entity) ? entity : entity ? [entity] : [];
  const dnd = useDataDnd({
    items: allDataRaw,
    layout: "list",
    dragGroup,
    accepts,
    sortable: sortableProp,
    dropEvent,
    reorderEvent: dndReorderEvent,
    positionEvent,
    dndItemIdField,
    dndRoot
  });
  const orderedData = dnd.orderedItems;
  const allData = React79__default.useMemo(
    () => sortRows(orderedData, sortBy, sortDirection),
    [orderedData, sortBy, sortDirection]
  );
  const data = pageSize > 0 ? allData.slice(0, visibleCount) : allData;
  const hasMoreLocal = pageSize > 0 && visibleCount < allData.length;
  const renderItemFn = typeof schemaRenderItem === "function" ? schemaRenderItem : void 0;
  const itemRenderer = typeof children === "function" ? children : renderItemFn;
  const hasRenderProp = typeof itemRenderer === "function";
  React79__default.useEffect(() => {
    const renderItemTypeOf = typeof schemaRenderItem;
    const childrenTypeOf = typeof children;
    if (data.length > 0 && !hasRenderProp) {
      const firstRow = data[0];
      const sampleKeys = firstRow ? Object.keys(firstRow).slice(0, 6) : [];
      const isFnLambda = Array.isArray(schemaRenderItem) && schemaRenderItem.length >= 3 && (schemaRenderItem[0] === "fn" || schemaRenderItem[0] === "lambda");
      dataListLog.warn("renderItem-unresolved", {
        rowCount: data.length,
        fieldsCount: fieldDefs.length,
        renderItemTypeOf,
        renderItemIsArray: Array.isArray(schemaRenderItem),
        renderItemIsFnLambda: isFnLambda,
        renderItemHead: Array.isArray(schemaRenderItem) ? String(schemaRenderItem[0]) : void 0,
        childrenTypeOf,
        sampleRowKeys: sampleKeys
      });
    }
  }, [data, hasRenderProp, schemaRenderItem, children, fieldDefs]);
  const titleField = fieldDefs.find((f3) => f3.variant === "h3" || f3.variant === "h4") ?? fieldDefs[0];
  const badgeFields = fieldDefs.filter((f3) => f3.variant === "badge" && f3 !== titleField);
  const progressFields = fieldDefs.filter((f3) => f3.variant === "progress");
  const bodyFields = fieldDefs.filter(
    (f3) => f3 !== titleField && !badgeFields.includes(f3) && !progressFields.includes(f3)
  );
  const handleActionClick = (action, itemData) => (e) => {
    e.stopPropagation();
    const payload = {
      id: itemData.id,
      row: itemData
    };
    eventBus.emit(`UI:${action.event}`, payload);
  };
  const renderItemActions = (itemData, onPrimary = false) => {
    if (!itemActions || itemActions.length === 0) return null;
    const inline = maxInlineActions != null ? itemActions.slice(0, maxInlineActions) : itemActions;
    const overflow = maxInlineActions != null ? itemActions.slice(maxInlineActions) : [];
    return (
      // stopPropagation at the cluster: the "⋯" trigger opens the overflow
      // menu without also firing the row's default click (inline buttons
      // already stop it in handleActionClick; the Menu panel is portaled).
      /* @__PURE__ */ jsxs(HStack, { gap: "xs", onClick: rowClickEvent ? (e) => e.stopPropagation() : void 0, className: "flex-shrink-0", children: [
        inline.map((action, idx) => /* @__PURE__ */ jsxs(
          Button,
          {
            variant: action.variant ?? "ghost",
            size: "sm",
            onClick: handleActionClick(action, itemData),
            "data-testid": `action-${action.event}`,
            "data-row-id": String(itemData.id),
            className: cn(
              action.variant === "danger" && "text-error hover:bg-error/10",
              // Must sit on the Button itself: the variant's own text colour
              // beats an inherited one from the row wrapper.
              onPrimary && "!text-primary-foreground hover:bg-primary-foreground/15"
            ),
            children: [
              action.icon && renderIconInput2(action.icon, { size: "xs", className: "mr-1" }),
              action.label
            ]
          },
          idx
        )),
        overflow.length > 0 && /* @__PURE__ */ jsx(
          Menu,
          {
            position: "bottom-end",
            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
            items: overflow.map((action) => ({
              label: action.label,
              icon: action.icon,
              variant: action.variant === "danger" ? "danger" : "default",
              onClick: () => eventBus.emit(`UI:${action.event}`, {
                id: itemData.id,
                row: itemData
              })
            }))
          }
        )
      ] })
    );
  };
  const rowClickEvent = itemClickEvent || itemActions?.find((a) => a.variant !== "danger")?.event;
  const handleRowClick = (itemData) => () => {
    if (!rowClickEvent) return;
    const payload = {
      id: itemData.id,
      row: itemData
    };
    eventBus.emit(`UI:${rowClickEvent}`, payload);
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: t("loading.items") }) });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) });
  }
  if (data.length === 0) {
    const emptyNode = /* @__PURE__ */ jsx(Box, { className: "text-center py-12", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: emptyMessage || t("empty.noItems") }) });
    return dnd.enabled ? /* @__PURE__ */ jsx(Fragment, { children: dnd.wrapContainer(emptyNode) }) : emptyNode;
  }
  const gapClass = {
    none: "",
    sm: "gap-1",
    md: "gap-2",
    lg: "gap-4"
  }[gap];
  const isCard = variant === "card";
  const isCompact = variant === "compact";
  const isMessage = variant === "message";
  if (isMessage) {
    const items2 = [...data];
    const groups2 = groupBy ? groupData(items2, groupBy) : [{ label: "", items: items2 }];
    const contentField = titleField?.name ?? fieldDefs[0]?.name ?? "";
    const senderLabel = (itemData, raw) => {
      if (!senderLabelField) return raw;
      const v = getNestedValue(itemData, senderLabelField);
      return v === void 0 || v === null || v === "" ? raw : String(v);
    };
    return /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: cn("py-2", className), children: [
      groups2.map((group, gi) => /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
        group.label && /* @__PURE__ */ jsx(Divider, { label: group.label, className: "my-2" }),
        group.items.map((itemData, index) => {
          const id = itemData.id || `${gi}-${index}`;
          const sender = senderField ? String(getNestedValue(itemData, senderField) ?? "") : "";
          const isSent = Boolean(currentUser && sender === currentUser);
          const content = getNestedValue(itemData, contentField);
          const timestampField = fieldDefs.find((f3) => f3.format === "date");
          const timestamp = timestampField ? getNestedValue(itemData, timestampField.name) : null;
          const metaFields = fieldDefs.filter(
            (f3) => f3.name !== contentField && f3.name !== timestampField?.name
          );
          return /* @__PURE__ */ jsx(
            Box,
            {
              "data-entity-row": true,
              "data-entity-id": id,
              onClick: rowClickEvent ? handleRowClick(itemData) : void 0,
              className: cn(
                "flex px-4 group/rowactions",
                rowClickEvent && "cursor-pointer",
                isSent ? "justify-end" : "justify-start"
              ),
              children: /* @__PURE__ */ jsxs(
                Box,
                {
                  className: cn(
                    "max-w-[75%] px-4 py-2",
                    isSent ? "bg-primary text-primary-foreground rounded-2xl rounded-br-sm" : "bg-muted text-foreground rounded-2xl rounded-bl-sm"
                  ),
                  children: [
                    !isSent && senderField && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold mb-0.5", children: senderLabel(itemData, sender) }),
                    /* @__PURE__ */ jsx(Typography, { variant: "body", className: cn(isSent && "text-primary-foreground"), children: content !== void 0 && content !== null ? String(content) : "" }),
                    metaFields.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "mt-1 flex-wrap", children: metaFields.map((f3) => {
                      const v = getNestedValue(itemData, f3.name);
                      if (v === void 0 || v === null || v === "") return null;
                      return f3.variant === "badge" ? (
                        // `format` applies here too — a boolean field badged
                        // without it renders the raw "false" instead of "No".
                        /* @__PURE__ */ jsx(Badge, { variant: statusVariant3(String(v)), children: formatValue2(v, f3.format, void 0, relationsData?.[f3.name]) }, f3.name)
                      ) : /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "caption",
                          className: cn("text-xs", isSent ? "opacity-70" : "text-muted-foreground"),
                          children: formatValue2(v, f3.format, void 0, relationsData?.[f3.name])
                        },
                        f3.name
                      );
                    }) }),
                    /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "mt-1 items-center justify-between", children: [
                      timestamp != null ? /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "caption",
                          className: cn("text-xs", isSent ? "opacity-70" : "text-muted-foreground"),
                          children: formatDate(timestamp)
                        }
                      ) : /* @__PURE__ */ jsx("span", {}),
                      renderItemActions(itemData, isSent)
                    ] })
                  ]
                }
              )
            },
            id
          );
        })
      ] }, gi)),
      hasMoreLocal && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => setVisibleCount((prev) => prev + (pageSize || 5)),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
            t("common.showMore"),
            " (",
            t("common.remaining", { count: allData.length - visibleCount }),
            ")"
          ]
        }
      ) })
    ] });
  }
  const items = [...data];
  const groups = groupBy ? groupData(items, groupBy) : [{ label: "", items }];
  const idFieldName = dndItemIdField ?? "id";
  const renderItem = (itemData, index, isLast) => {
    const dndId = itemData[idFieldName] ?? `__idx_${index}`;
    const wrapDnd = (node) => dnd.isZone ? /* @__PURE__ */ jsx(dnd.SortableItem, { id: dndId, children: node }, dndId) : node;
    if (hasRenderProp) {
      const id2 = itemData.id || String(index);
      const actions = renderItemActions(itemData);
      return wrapDnd(
        /* @__PURE__ */ jsxs(Box, { "data-entity-row": true, "data-entity-id": id2, onClick: rowClickEvent ? handleRowClick(itemData) : void 0, className: cn("relative group/rowactions", rowClickEvent && "cursor-pointer"), children: [
          itemRenderer(itemData, index),
          actions && /* @__PURE__ */ jsxs(Box, { className: "absolute top-2 right-2 z-10 opacity-0 group-hover/rowactions:opacity-100 focus-within:opacity-100 [@media(pointer:coarse)]:opacity-100 transition-opacity duration-fast", children: [
            /* @__PURE__ */ jsx(Box, { className: "rounded-md border border-border bg-card/95 backdrop-blur-sm shadow-sm p-0.5 [@media(pointer:coarse)]:hidden", children: actions }),
            /* @__PURE__ */ jsx(Box, { className: "hidden [@media(pointer:coarse)]:block rounded-md border border-border bg-card/95 backdrop-blur-sm shadow-sm p-0.5", children: /* @__PURE__ */ jsx(
              Menu,
              {
                position: "bottom-end",
                trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                items: (itemActions ?? []).map((action) => ({
                  label: action.label,
                  icon: action.icon,
                  variant: action.variant === "danger" ? "danger" : "default",
                  onClick: () => eventBus.emit(`UI:${action.event}`, {
                    id: itemData.id,
                    row: itemData
                  })
                }))
              }
            ) })
          ] }),
          isCard && !isLast && /* @__PURE__ */ jsx(Box, { className: "mx-6 border-b border-border/40" })
        ] }, id2)
      );
    }
    const id = itemData.id || String(index);
    const titleValue = getNestedValue(itemData, titleField?.name ?? "");
    const titleDisplay = resolveRelationCellDisplay(
      titleValue,
      titleField ? relationsData?.[titleField.name] : void 0
    ) ?? (titleValue !== void 0 && titleValue !== null ? String(titleValue) : void 0);
    return wrapDnd(
      /* @__PURE__ */ jsxs(Box, { "data-entity-row": true, "data-entity-id": id, onClick: rowClickEvent ? handleRowClick(itemData) : void 0, className: cn(rowClickEvent && "cursor-pointer"), children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            className: cn(
              // items-start, not items-center: a multi-line row (title + meta +
              // progress) centred its action cluster in the vertical middle, so
              // the buttons floated between the meta fields instead of anchoring
              // to the title they act on (U-DATALIST-ACTIONS-FLOAT-MID-ROW).
              "group flex items-start gap-4 transition-all duration-fast",
              isCompact ? "px-4 py-2" : "px-6 py-4",
              "hover:bg-muted/80",
              !isCard && !isCompact && "rounded-lg border border-transparent hover:border-border"
            ),
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center", children: [
                  titleField?.icon && renderIconInput2(titleField.icon, { size: isCompact ? "xs" : "sm", className: "text-primary flex-shrink-0" }),
                  titleValue !== void 0 && titleValue !== null && /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: titleField?.variant === "h3" ? "h3" : "h4",
                      className: cn("font-semibold truncate flex-1", isCompact && "text-sm"),
                      children: titleDisplay
                    }
                  ),
                  badgeFields.map((field) => {
                    const val = getNestedValue(itemData, field.name);
                    if (val === void 0 || val === null) return null;
                    return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center flex-shrink-0", children: [
                      field.icon && renderIconInput2(field.icon, { size: "xs" }),
                      /* @__PURE__ */ jsx(Badge, { variant: statusVariant3(String(val)), children: formatValue2(val, field.format, void 0, relationsData?.[field.name]) })
                    ] }, field.name);
                  })
                ] }),
                bodyFields.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "md", className: cn("flex-wrap", isCompact ? "mt-0.5" : "mt-1.5"), children: bodyFields.map((field) => {
                  const value = getNestedValue(itemData, field.name);
                  if (value === void 0 || value === null || value === "") return null;
                  return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                    field.icon && renderIconInput2(field.icon, { size: "xs", className: "text-muted-foreground" }),
                    /* @__PURE__ */ jsxs(
                      Typography,
                      {
                        variant: "caption",
                        color: "secondary",
                        className: cn(field.format !== "boolean" && "sr-only"),
                        children: [
                          field.label ?? fieldLabel3(field.name),
                          ":"
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: formatValue2(value, field.format, { yes: t("common.yes"), no: t("common.no") }, relationsData?.[field.name]) })
                  ] }, field.name);
                }) }),
                progressFields.map((field) => {
                  const value = getNestedValue(itemData, field.name);
                  if (typeof value !== "number") return null;
                  return /* @__PURE__ */ jsxs(Box, { className: "mt-2 max-w-xs", children: [
                    /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center mb-1", children: [
                      field.icon && renderIconInput2(field.icon, { size: "xs", className: "text-muted-foreground" }),
                      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: field.label ?? fieldLabel3(field.name) })
                    ] }),
                    /* @__PURE__ */ jsx(ProgressBar, { value, max: 100 })
                  ] }, field.name);
                })
              ] }),
              renderItemActions(itemData)
            ]
          }
        ),
        (isCard || isCompact) && !isLast && /* @__PURE__ */ jsx(Box, { className: cn("border-b border-border/40", isCompact ? "mx-4" : "mx-6") })
      ] }, id)
    );
  };
  return dnd.wrapContainer(
    /* @__PURE__ */ jsxs(
      Box,
      {
        className: cn(
          isCard && "bg-card rounded-xl border border-border shadow-elevation-dialog overflow-hidden",
          // `gap-*` is inert on a block container, and Box only emits a display
          // class when its `display` prop is set — so every non-card list had
          // been asking for a gap that CSS silently dropped. flex-col makes it
          // real. `compact` keeps gap-0 on purpose: it separates with the row
          // divider above instead, never both (Almadar_UI_Beauty.md 6).
          !isCard && "flex flex-col",
          !isCard && !isCompact && gapClass,
          listLookStyles[look],
          className
        ),
        children: [
          groups.map((group, gi) => /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
            group.label && /* @__PURE__ */ jsx(Divider, { label: group.label, className: gi > 0 ? "mt-4" : "mt-0" }),
            group.items.map(
              (itemData, index) => renderItem(itemData, index, gi === groups.length - 1 && index === group.items.length - 1)
            )
          ] }, gi)),
          hasMoreLocal && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => setVisibleCount((prev) => prev + (pageSize || 5)),
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
                t("common.showMore"),
                " (",
                t("common.remaining", { count: allData.length - visibleCount }),
                ")"
              ]
            }
          ) }),
          infiniteScroll && loadMoreEvent && /* @__PURE__ */ jsx(
            InfiniteScrollSentinel,
            {
              loadMoreEvent,
              isLoading,
              hasMore
            }
          )
        ]
      }
    )
  );
}
var dataListLog, fieldLabel3, listLookStyles;
var init_DataList = __esm({
  "components/core/molecules/DataList.tsx"() {
    "use client";
    init_cn();
    init_format();
    init_relationLabel();
    init_getNestedValue();
    init_useEventBus();
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    init_Button();
    init_Icon();
    init_ProgressBar();
    init_Divider();
    init_InfiniteScrollSentinel();
    init_Menu();
    init_useDataDnd();
    dataListLog = createLogger("almadar:ui:data-list");
    fieldLabel3 = humanizeFieldName;
    listLookStyles = {
      dense: "[&_[data-entity-row]>div]:!py-1 [&_[data-entity-row]>div]:!px-3",
      spacious: "[&_[data-entity-row]>div]:!py-5 [&_[data-entity-row]>div]:!px-8",
      striped: "[&_[data-entity-row]:nth-child(even)>div]:bg-muted/30",
      borderless: "[&_[data-entity-row]>div]:!border-0 [&_[data-entity-row]>div]:!hover:border-transparent",
      "card-rows": "[&_[data-entity-row]>div]:shadow-elevation-card [&_[data-entity-row]>div]:rounded-container [&_[data-entity-row]>div]:!border [&_[data-entity-row]>div]:border-border [&_[data-entity-row]]:mb-2"
    };
    DataList.displayName = "DataList";
  }
});
function kindOf(v) {
  if (v === null) return "null";
  if (isArr(v)) return "array";
  if (isObj(v)) return "object";
  if (typeof v === "number") return "number";
  if (typeof v === "boolean") return "boolean";
  return "string";
}
function emptyOf(kind) {
  switch (kind) {
    case "object":
      return {};
    case "array":
      return [];
    case "number":
      return 0;
    case "boolean":
      return false;
    case "null":
      return null;
    default:
      return "";
  }
}
function templateFrom(arr) {
  if (arr.length === 0) return "";
  const first = arr[0];
  if (isObj(first)) {
    const blank = {};
    for (const k of Object.keys(first)) blank[k] = isObj(first[k]) ? {} : isArr(first[k]) ? [] : first[k];
    return blank;
  }
  if (isArr(first)) return [];
  return emptyOf(kindOf(first));
}
function ScalarControl({
  value,
  onChange
}) {
  if (typeof value === "boolean") {
    return /* @__PURE__ */ jsx(Switch, { checked: value, onChange: (c) => onChange(c) });
  }
  const numeric = typeof value === "number";
  const initial = value === null ? "" : String(value);
  const [draft, setDraft] = React79__default.useState(initial);
  React79__default.useEffect(() => setDraft(initial), [initial]);
  const commit = () => {
    if (numeric) {
      const n = draft.trim() === "" ? 0 : Number(draft);
      onChange(Number.isNaN(n) ? 0 : n);
    } else {
      onChange(draft);
    }
  };
  return /* @__PURE__ */ jsx(
    Input,
    {
      inputType: numeric ? "number" : "text",
      value: draft,
      placeholder: value === null ? "null" : void 0,
      onChange: (e) => setDraft(e.target.value),
      onBlur: commit,
      onKeyDown: (e) => {
        if (e.key === "Enter") commit();
      }
    }
  );
}
function KindSelect({
  kind,
  onChange
}) {
  return /* @__PURE__ */ jsx(
    "select",
    {
      value: kind === "null" ? "string" : kind,
      onChange: (e) => onChange(e.target.value),
      "aria-label": "Value type",
      className: cn(
        "h-6 rounded-sm bg-muted text-muted-foreground text-[10px] font-mono px-1",
        "border-[length:var(--border-width-thin)] border-border",
        "hover:bg-card focus:outline-none focus:ring-1 focus:ring-ring"
      ),
      children: KIND_OPTIONS.map((k) => /* @__PURE__ */ jsx("option", { value: k, children: TYPE_LABEL[k] }, k))
    }
  );
}
function ValueNode({
  value,
  onChange,
  depth,
  readonly
}) {
  const kind = kindOf(value);
  if (kind === "object" || kind === "array") {
    return /* @__PURE__ */ jsx(ContainerNode, { value, onChange, depth, readonly });
  }
  if (readonly) {
    return /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-mono text-foreground", children: value === null ? "null" : String(value) });
  }
  return /* @__PURE__ */ jsx(ScalarControl, { value, onChange });
}
function Row({
  rowKey,
  isArrayItem,
  value,
  depth,
  onValue,
  onRenameKey,
  onChangeKind,
  onRemove,
  readonly
}) {
  const [keyDraft, setKeyDraft] = React79__default.useState(rowKey);
  React79__default.useEffect(() => setKeyDraft(rowKey), [rowKey]);
  const container = isObj(value) || isArr(value);
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "group w-max min-w-full", children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", className: "py-0.5 w-max", children: [
      readonly ? /* @__PURE__ */ jsx("span", { className: cn(
        "h-6 rounded-sm bg-muted text-muted-foreground text-[10px] font-mono px-1 flex items-center",
        "border-[length:var(--border-width-thin)] border-border"
      ), children: TYPE_LABEL[kindOf(value)] }) : /* @__PURE__ */ jsx(KindSelect, { kind: kindOf(value), onChange: onChangeKind }),
      isArrayItem ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "w-6 shrink-0 font-mono", children: rowKey }) : readonly ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "w-20 shrink-0 font-mono truncate", children: rowKey }) : /* @__PURE__ */ jsx("div", { className: "w-20 shrink-0", children: /* @__PURE__ */ jsx(
        Input,
        {
          inputType: "text",
          value: keyDraft,
          onChange: (e) => setKeyDraft(e.target.value),
          onBlur: () => keyDraft !== rowKey && onRenameKey(keyDraft),
          onKeyDown: (e) => {
            if (e.key === "Enter" && keyDraft !== rowKey) onRenameKey(keyDraft);
          },
          className: "font-mono"
        }
      ) }),
      !container && /* @__PURE__ */ jsx("div", { className: "w-48 shrink-0", children: /* @__PURE__ */ jsx(ValueNode, { value, onChange: onValue, depth: depth + 1, readonly }) }),
      !readonly && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          icon: "x",
          onClick: onRemove,
          "aria-label": "Remove",
          className: "shrink-0 text-muted-foreground hover:text-error"
        }
      )
    ] }),
    container && /* @__PURE__ */ jsx("div", { className: "pl-2", children: /* @__PURE__ */ jsx(ValueNode, { value, onChange: onValue, depth: depth + 1, readonly }) })
  ] });
}
function ContainerNode({
  value,
  onChange,
  depth,
  readonly
}) {
  const [open, setOpen] = React79__default.useState(depth < 2);
  const array = isArr(value);
  const entries = array ? value.map((v, i) => [String(i), v]) : Object.entries(value);
  const setObjValue = (key, next) => {
    onChange({ ...value, [key]: next });
  };
  const renameKey = (oldKey, newKey) => {
    if (!newKey || newKey === oldKey) return;
    const out = {};
    for (const [k, v] of Object.entries(value)) out[k === oldKey ? newKey : k] = v;
    onChange(out);
  };
  const removeObjKey = (key) => {
    const out = {};
    for (const [k, v] of Object.entries(value)) if (k !== key) out[k] = v;
    onChange(out);
  };
  const changeObjKind = (key, k) => setObjValue(key, emptyOf(k));
  const setArrValue = (idx, next) => {
    const copy = [...value];
    copy[idx] = next;
    onChange(copy);
  };
  const removeArrIdx = (idx) => onChange(value.filter((_, i) => i !== idx));
  const changeArrKind = (idx, k) => setArrValue(idx, emptyOf(k));
  const add = () => {
    if (array) {
      onChange([...value, templateFrom(value)]);
    } else {
      const obj = value;
      let key = "key";
      let n = 1;
      while (key in obj) {
        key = `key${n}`;
        n += 1;
      }
      onChange({ ...obj, [key]: "" });
    }
  };
  const summary = array ? `${entries.length} item${entries.length === 1 ? "" : "s"}` : `${entries.length} field${entries.length === 1 ? "" : "s"}`;
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-full", children: [
    /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", children: /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        onClick: () => setOpen((o) => !o),
        className: "flex items-center gap-1 text-muted-foreground hover:text-foreground",
        "aria-label": open ? "Collapse" : "Expand",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: open ? "chevron-down" : "chevron-right", size: "sm" }),
          /* @__PURE__ */ jsx("span", { className: "font-mono text-xs", children: array ? "[ ]" : "{ }" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: summary })
        ]
      }
    ) }),
    open && /* @__PURE__ */ jsxs(
      VStack,
      {
        gap: "none",
        className: cn("ml-1.5 pl-1.5 w-max min-w-full border-l-[length:var(--border-width-thin)] border-border"),
        children: [
          entries.map(([k, v], idx) => /* @__PURE__ */ jsx(
            Row,
            {
              rowKey: k,
              isArrayItem: array,
              value: v,
              depth,
              onValue: (next) => array ? setArrValue(idx, next) : setObjValue(k, next),
              onRenameKey: (nk) => renameKey(k, nk),
              onChangeKind: (kind) => array ? changeArrKind(idx, kind) : changeObjKind(k, kind),
              onRemove: () => array ? removeArrIdx(idx) : removeObjKey(k),
              readonly
            },
            array ? idx : k
          )),
          !readonly && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: "plus",
              label: array ? "Add item" : "Add field",
              onClick: add,
              className: "self-start text-muted-foreground"
            }
          )
        ]
      }
    )
  ] });
}
var isObj, isArr, TYPE_LABEL, KIND_OPTIONS, JsonTreeEditor;
var init_JsonTreeEditor = __esm({
  "components/core/molecules/JsonTreeEditor.tsx"() {
    "use client";
    init_Stack();
    init_Button();
    init_Input();
    init_Switch();
    init_Typography();
    init_Icon();
    init_cn();
    isObj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
    isArr = (v) => Array.isArray(v);
    TYPE_LABEL = {
      object: "{}",
      array: "[]",
      string: "txt",
      number: "num",
      boolean: "y/n",
      null: "\u2014"
    };
    KIND_OPTIONS = ["string", "number", "boolean", "object", "array"];
    JsonTreeEditor = ({ value, onChange, className, readonly }) => {
      const root = value ?? "";
      return /* @__PURE__ */ jsx("div", { className: cn("w-full overflow-x-auto rounded-sm bg-card/40 p-2 border-[length:var(--border-width-thin)] border-border", className), children: /* @__PURE__ */ jsx(ValueNode, { value: root, onChange, depth: 0, readonly }) });
    };
  }
});
var FormSection, FormLayout, FormActions;
var init_FormSection = __esm({
  "components/core/molecules/FormSection.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Box();
    init_Typography();
    init_Button();
    init_Stack();
    init_Icon();
    init_useEventBus();
    FormSection = ({
      title,
      description,
      children,
      collapsible = false,
      defaultCollapsed = false,
      card = false,
      columns = 1,
      className
    }) => {
      const [collapsed, setCollapsed] = React79__default.useState(defaultCollapsed);
      const { t } = useTranslate();
      const eventBus = useEventBus();
      const gridClass = {
        1: "grid-cols-1",
        2: "grid-cols-1 md:grid-cols-2",
        3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
      }[columns];
      React79__default.useCallback(() => {
        if (collapsible) {
          setCollapsed((prev) => !prev);
          eventBus.emit("UI:TOGGLE_COLLAPSE", { collapsed: !collapsed });
        }
      }, [collapsible, collapsed, eventBus]);
      const content = /* @__PURE__ */ jsxs(Fragment, { children: [
        (title || description) && /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "mb-4", children: [
          title && /* @__PURE__ */ jsxs(
            HStack,
            {
              justify: "between",
              align: "center",
              className: cn(collapsible && "cursor-pointer"),
              action: collapsible ? "TOGGLE_COLLAPSE" : void 0,
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h3", weight: "semibold", children: title }),
                collapsible && /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    action: "TOGGLE_COLLAPSE",
                    children: /* @__PURE__ */ jsx(
                      Icon,
                      {
                        icon: ChevronDown,
                        size: "sm",
                        className: cn(
                          "text-muted-foreground transition-transform",
                          collapsed && "rotate-180"
                        )
                      }
                    )
                  }
                )
              ]
            }
          ),
          description && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: description })
        ] }),
        (!collapsible || !collapsed) && /* @__PURE__ */ jsx(Box, { className: cn("grid gap-4", gridClass), children })
      ] });
      if (card) {
        return /* @__PURE__ */ jsx(Card, { className: cn("p-6", className), children: content });
      }
      return /* @__PURE__ */ jsx(Box, { className, children: content });
    };
    FormSection.displayName = "FormSection";
    FormLayout = ({
      children,
      dividers = true,
      className
    }) => {
      return /* @__PURE__ */ jsx(
        VStack,
        {
          gap: "lg",
          className: cn(
            dividers && "[&>*+*]:pt-8 [&>*+*]:border-t [&>*+*]:border-border",
            className
          ),
          children
        }
      );
    };
    FormLayout.displayName = "FormLayout";
    FormActions = ({
      children,
      sticky = false,
      align = "right",
      className
    }) => {
      const alignClass2 = {
        left: "justify-start",
        right: "justify-end",
        between: "justify-between",
        center: "justify-center"
      }[align];
      return /* @__PURE__ */ jsx(
        HStack,
        {
          gap: "sm",
          align: "center",
          className: cn(
            "pt-6 border-t border-border",
            alignClass2,
            sticky && "sticky bottom-0 bg-card py-4 -mx-6 px-6 shadow-[0_-4px_6px_-1px_rgb(0,0,0,0.05)]",
            className
          ),
          children
        }
      );
    };
    FormActions.displayName = "FormActions";
  }
});
var ALL_CATEGORY, MAX_RENDERED, GridPicker;
var init_GridPicker = __esm({
  "components/core/molecules/GridPicker.tsx"() {
    "use client";
    init_cn();
    init_Input();
    init_Badge();
    init_Stack();
    ALL_CATEGORY = "__all__";
    MAX_RENDERED = 300;
    GridPicker = ({
      items,
      value,
      onChange,
      categories,
      searchPlaceholder,
      renderThumbnail,
      cellSize = 32,
      className
    }) => {
      const [search, setSearch] = useState("");
      const [activeCategory, setActiveCategory] = useState(ALL_CATEGORY);
      const gridRef = useRef(null);
      const categoryChips = useMemo(() => {
        if (categories !== void 0) return categories;
        const seen = [];
        for (const item of items) {
          if (!seen.includes(item.category)) seen.push(item.category);
        }
        return seen;
      }, [categories, items]);
      const filtered = useMemo(() => {
        const needle = search.trim().toLowerCase();
        return items.filter((item) => {
          const matchesCategory = activeCategory === ALL_CATEGORY || item.category === activeCategory;
          const matchesSearch = needle === "" || item.label.toLowerCase().includes(needle) || item.keywords !== void 0 && item.keywords.some((k) => k.toLowerCase().includes(needle));
          return matchesCategory && matchesSearch;
        });
      }, [items, search, activeCategory]);
      const visible = useMemo(() => filtered.slice(0, MAX_RENDERED), [filtered]);
      const truncated = filtered.length - visible.length;
      const select = useCallback(
        (item) => {
          onChange(item.id);
        },
        [onChange]
      );
      const handleKeyDown = useCallback(
        (e, index) => {
          const cells = gridRef.current?.querySelectorAll(
            "[data-gridpicker-cell]"
          );
          if (cells === void 0 || cells.length === 0) return;
          const columns = (() => {
            const grid = gridRef.current;
            if (grid === null) return 1;
            const style = window.getComputedStyle(grid);
            const cols = style.gridTemplateColumns.split(" ").filter(Boolean).length;
            return cols > 0 ? cols : 1;
          })();
          let next = -1;
          if (e.key === "ArrowRight") next = index + 1;
          else if (e.key === "ArrowLeft") next = index - 1;
          else if (e.key === "ArrowDown") next = index + columns;
          else if (e.key === "ArrowUp") next = index - columns;
          else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            select(filtered[index]);
            return;
          } else {
            return;
          }
          e.preventDefault();
          if (next >= 0 && next < cells.length) {
            cells[next].focus();
          }
        },
        [filtered, select]
      );
      return /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: cn("w-full", className), children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "search",
            icon: "search",
            value: search,
            placeholder: searchPlaceholder,
            clearable: true,
            onClear: () => setSearch(""),
            onChange: (e) => setSearch(e.target.value)
          }
        ),
        categoryChips.length > 0 && /* @__PURE__ */ jsxs(HStack, { gap: "xs", wrap: true, children: [
          /* @__PURE__ */ jsx(
            Badge,
            {
              variant: activeCategory === ALL_CATEGORY ? "primary" : "neutral",
              size: "sm",
              role: "button",
              tabIndex: 0,
              "aria-pressed": activeCategory === ALL_CATEGORY,
              className: "cursor-pointer",
              onClick: () => setActiveCategory(ALL_CATEGORY),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setActiveCategory(ALL_CATEGORY);
                }
              },
              children: "All"
            }
          ),
          categoryChips.map((category) => /* @__PURE__ */ jsx(
            Badge,
            {
              variant: activeCategory === category ? "primary" : "neutral",
              size: "sm",
              role: "button",
              tabIndex: 0,
              "aria-pressed": activeCategory === category,
              className: "cursor-pointer",
              onClick: () => setActiveCategory(category),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setActiveCategory(category);
                }
              },
              children: category
            },
            category
          ))
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            ref: gridRef,
            role: "listbox",
            className: "grid gap-1 overflow-y-auto max-h-64 p-1",
            style: {
              gridTemplateColumns: `repeat(auto-fill, minmax(${cellSize}px, 1fr))`
            },
            children: visible.map((item, index) => {
              const selected = item.id === value;
              return /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  role: "option",
                  "aria-selected": selected,
                  "aria-label": item.label,
                  title: item.label,
                  "data-gridpicker-cell": true,
                  tabIndex: selected || value === void 0 && index === 0 ? 0 : -1,
                  onClick: () => select(item),
                  onKeyDown: (e) => handleKeyDown(e, index),
                  className: cn(
                    "flex items-center justify-center rounded-sm",
                    "transition-colors hover:bg-muted",
                    "focus:outline-none focus:ring-1 focus:ring-ring",
                    selected && "bg-primary/10 ring-1 ring-primary"
                  ),
                  style: { width: cellSize, height: cellSize },
                  children: renderThumbnail(item)
                },
                item.id
              );
            })
          }
        ),
        truncated > 0 && /* @__PURE__ */ jsx("div", { className: "px-1 text-xs text-muted-foreground", children: `+${truncated} more \u2014 refine your search` })
      ] });
    };
    GridPicker.displayName = "GridPicker";
  }
});
function pascalToKebab(name) {
  return name.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").toLowerCase();
}
function kebabToPascal3(name) {
  return name.split("-").map((part) => /^\d+$/.test(part) ? part : part.charAt(0).toUpperCase() + part.slice(1)).join("");
}
var ICON_ITEMS, IconPicker;
var init_IconPicker = __esm({
  "components/core/molecules/IconPicker.tsx"() {
    "use client";
    init_Icon();
    init_GridPicker();
    ICON_ITEMS = (() => {
      const items = [];
      for (const [exportName, candidate] of Object.entries(LucideIcons2)) {
        if (!/^[A-Z]/.test(exportName)) continue;
        if (exportName.endsWith("Icon")) continue;
        if (exportName.startsWith("Lucide")) continue;
        const isComponent = candidate !== null && (typeof candidate === "object" || typeof candidate === "function") && "$$typeof" in candidate;
        if (!isComponent) continue;
        const kebab = pascalToKebab(exportName);
        if (kebabToPascal3(kebab) !== exportName) continue;
        items.push({ id: kebab, label: kebab, category: "icons" });
      }
      return items;
    })();
    IconPicker = ({ value, onChange, className }) => {
      const items = useMemo(() => ICON_ITEMS, []);
      return /* @__PURE__ */ jsx(
        GridPicker,
        {
          items,
          value,
          onChange,
          searchPlaceholder: "Search icons\u2026",
          renderThumbnail: (it) => /* @__PURE__ */ jsx(Icon, { name: it.id }),
          cellSize: 32,
          className
        }
      );
    };
    IconPicker.displayName = "IconPicker";
  }
});
function iconForKind(kind) {
  if (kind === "audio") return "music";
  if (kind === "model") return "box";
  return "file";
}
var THUMB_PX, IMAGE_KINDS, AssetPicker;
var init_AssetPicker = __esm({
  "components/core/molecules/AssetPicker.tsx"() {
    "use client";
    init_GridPicker();
    init_Icon();
    THUMB_PX = 32;
    IMAGE_KINDS = /* @__PURE__ */ new Set([
      "image",
      "spritesheet",
      "scene",
      "portrait"
    ]);
    AssetPicker = ({
      assets,
      value,
      onChange,
      className
    }) => {
      const byUrl = useMemo(() => {
        const map = /* @__PURE__ */ new Map();
        for (const entry of assets) map.set(entry.url, entry);
        return map;
      }, [assets]);
      const items = useMemo(
        () => assets.map((entry) => ({
          id: entry.url,
          label: entry.name,
          category: entry.category
        })),
        [assets]
      );
      const categories = useMemo(() => {
        const seen = [];
        for (const entry of assets) {
          if (!seen.includes(entry.category)) seen.push(entry.category);
        }
        return seen;
      }, [assets]);
      const renderThumbnail = useCallback(
        (item) => {
          const entry = byUrl.get(item.id);
          if (entry === void 0) return null;
          if (IMAGE_KINDS.has(entry.kind)) {
            return /* @__PURE__ */ jsx(
              "img",
              {
                src: entry.thumbnailUrl ?? entry.url,
                alt: entry.name,
                loading: "lazy",
                width: THUMB_PX,
                height: THUMB_PX,
                style: { width: THUMB_PX, height: THUMB_PX, objectFit: "cover" }
              }
            );
          }
          return /* @__PURE__ */ jsx(Icon, { name: iconForKind(entry.kind), size: "sm" });
        },
        [byUrl]
      );
      return /* @__PURE__ */ jsx(
        GridPicker,
        {
          items,
          value,
          onChange,
          categories,
          renderThumbnail,
          cellSize: THUMB_PX,
          className
        }
      );
    };
    AssetPicker.displayName = "AssetPicker";
  }
});
function currentValue(decl, override) {
  return override !== void 0 ? override : decl.default;
}
function TextLikeControl({
  field,
  numeric,
  secret,
  value,
  onCommit
}) {
  const initial = value === void 0 || value === null ? "" : String(value);
  const [draft, setDraft] = React79__default.useState(initial);
  React79__default.useEffect(() => setDraft(initial), [initial]);
  const commit = () => {
    if (numeric) {
      const n = draft.trim() === "" ? 0 : Number(draft);
      onCommit(field, Number.isNaN(n) ? 0 : n);
    } else {
      onCommit(field, draft);
    }
  };
  return /* @__PURE__ */ jsx(
    Input,
    {
      inputType: secret ? "password" : numeric ? "number" : "text",
      value: draft,
      onChange: (e) => setDraft(e.target.value),
      onBlur: commit,
      onKeyDown: (e) => {
        if (e.key === "Enter") commit();
      }
    }
  );
}
function isTraitConfigObject(v) {
  return v !== null && v !== void 0 && typeof v === "object" && !Array.isArray(v);
}
function isAssetObject(v) {
  return isTraitConfigObject(v) && typeof v.url === "string";
}
function FieldControl({
  name,
  decl,
  value,
  onChange,
  assets
}) {
  let control;
  const stringValue = typeof value === "string" ? value : void 0;
  const effectiveValue = value ?? decl.default;
  if (decl.type === "icon") {
    control = /* @__PURE__ */ jsx(IconPicker, { value: stringValue, onChange: (icon) => onChange(name, icon) });
  } else if (decl.type === "asset") {
    control = /* @__PURE__ */ jsx(
      AssetPicker,
      {
        assets: assets ?? [],
        value: stringValue,
        onChange: (url) => onChange(name, url)
      }
    );
  } else if (decl.type === "Asset") {
    const assetUrl = isAssetObject(effectiveValue) ? effectiveValue.url : "";
    const baseAsset = isAssetObject(effectiveValue) ? effectiveValue : {};
    control = /* @__PURE__ */ jsx(
      AssetPicker,
      {
        assets: assets ?? [],
        value: assetUrl,
        onChange: (url) => onChange(name, { ...baseAsset, url })
      }
    );
  } else if (decl.type === "boolean") {
    control = /* @__PURE__ */ jsx(Switch, { checked: value === true, onChange: (c) => onChange(name, c) });
  } else if (decl.type === "string" && decl.values !== void 0 && decl.values.length > 0) {
    control = /* @__PURE__ */ jsx(
      Select,
      {
        options: decl.values.map((v) => ({ value: v, label: v })),
        value: typeof value === "string" ? value : "",
        onValueChange: (v) => onChange(name, v)
      }
    );
  } else if (decl.type === "number") {
    control = /* @__PURE__ */ jsx(TextLikeControl, { field: name, numeric: true, value, onCommit: onChange });
  } else if (isSecretConfigType(decl.type)) {
    control = /* @__PURE__ */ jsx(TextLikeControl, { field: name, numeric: false, secret: true, value, onCommit: onChange });
  } else if (decl.type === "event") {
    control = /* @__PURE__ */ jsx(TextLikeControl, { field: name, numeric: false, value, onCommit: onChange });
  } else if (decl.type === "string") {
    control = /* @__PURE__ */ jsx(TextLikeControl, { field: name, numeric: false, value, onCommit: onChange });
  } else if (decl.type === "node") {
    control = /* @__PURE__ */ jsx(NodeSlotEditor, { value: effectiveValue, onChange: (next) => onChange(name, next) });
  } else if (decl.type.startsWith("[") || Array.isArray(effectiveValue)) {
    const arr = Array.isArray(effectiveValue) ? effectiveValue : [];
    control = /* @__PURE__ */ jsx(JsonTreeEditor, { value: arr, onChange: (next) => onChange(name, next) });
  } else if (decl.type === "object" || decl.type.startsWith("Map ") || !SCALAR_TYPES.has(decl.type) && isTraitConfigObject(effectiveValue)) {
    const obj = isTraitConfigObject(effectiveValue) ? effectiveValue : {};
    control = /* @__PURE__ */ jsx(JsonTreeEditor, { value: obj, onChange: (next) => onChange(name, next) });
  } else {
    control = /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
      decl.type,
      " \u2014 edit in source"
    ] });
  }
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "label", children: decl.label ?? name }),
    control,
    decl.description !== void 0 && decl.description !== "" && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: decl.description })
  ] });
}
var TIER_ORDER, SCALAR_TYPES, PropertyInspector;
var init_PropertyInspector = __esm({
  "components/core/molecules/PropertyInspector.tsx"() {
    "use client";
    init_cn();
    init_Stack();
    init_Typography();
    init_Button();
    init_Switch();
    init_Select();
    init_Input();
    init_FormSection();
    init_IconPicker();
    init_AssetPicker();
    init_JsonTreeEditor();
    init_NodeSlotEditor();
    TIER_ORDER = ["presentation", "domain", "policy", "infra", "internal"];
    SCALAR_TYPES = /* @__PURE__ */ new Set(["string", "number", "boolean", "icon", "asset", "Asset", "secret", "event"]);
    PropertyInspector = ({
      config,
      values,
      onChange,
      onReset,
      title,
      className,
      assets,
      tiers
    }) => {
      const allowedTiers = tiers ? new Set(tiers) : null;
      const fields = Object.entries(config).filter(([, decl]) => {
        if (!allowedTiers) return true;
        return allowedTiers.has(decl.tier ?? "presentation");
      });
      const byTier = /* @__PURE__ */ new Map();
      for (const [name, decl] of fields) {
        const tier = decl.tier ?? "presentation";
        const arr = byTier.get(tier) ?? [];
        arr.push([name, decl]);
        byTier.set(tier, arr);
      }
      const tierList = [...byTier.keys()].sort((a, b) => {
        const ia = TIER_ORDER.indexOf(a);
        const ib = TIER_ORDER.indexOf(b);
        return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
      });
      return /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: cn("w-full", className), children: [
        /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "bold", children: title ?? "Config" }),
          onReset !== void 0 && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: "rotate-ccw", label: "Reset", onClick: onReset })
        ] }),
        fields.length === 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: "No configurable properties." }),
        tierList.map((tier) => /* @__PURE__ */ jsx(FormSection, { title: tier, collapsible: true, defaultCollapsed: tier !== "presentation", children: /* @__PURE__ */ jsx(VStack, { gap: "sm", children: byTier.get(tier)?.map(([name, decl]) => /* @__PURE__ */ jsx(
          FieldControl,
          {
            name,
            decl,
            value: currentValue(decl, values?.[name]),
            onChange,
            assets
          },
          name
        )) }) }, tier))
      ] });
    };
  }
});
function normalize(value) {
  const wasArray = Array.isArray(value);
  const pattern = wasArray ? value[0] : value;
  const type = isObj2(pattern) && typeof pattern["type"] === "string" ? pattern["type"] : "";
  const props = {};
  if (isObj2(pattern)) {
    for (const [k, v] of Object.entries(pattern)) if (k !== "type") props[k] = v;
  }
  return { type, props, wasArray };
}
var isObj2, NodeSlotEditor;
var init_NodeSlotEditor = __esm({
  "components/core/molecules/NodeSlotEditor.tsx"() {
    "use client";
    init_Stack();
    init_Select();
    init_Typography();
    init_JsonTreeEditor();
    init_PropertyInspector();
    init_pattern_resolver();
    init_cn();
    isObj2 = (v) => v !== null && v !== void 0 && typeof v === "object" && !Array.isArray(v);
    NodeSlotEditor = ({ value, onChange, className }) => {
      const { type, props, wasArray } = normalize(value);
      const patterns = React79__default.useMemo(() => {
        try {
          return [...getKnownPatterns()].sort();
        } catch {
          return [];
        }
      }, []);
      const options = React79__default.useMemo(
        () => [{ value: "", label: "\u2014 none \u2014" }, ...patterns.map((p) => ({ value: p, label: p }))],
        [patterns]
      );
      const emit = (nextType, nextProps) => {
        if (!nextType) {
          onChange(wasArray ? [] : {});
          return;
        }
        const pattern = { type: nextType, ...nextProps };
        onChange(wasArray || value === void 0 ? [pattern] : pattern);
      };
      const schemaEntries = React79__default.useMemo(() => {
        if (!type) return [];
        const def = getPatternDefinition(type);
        if (!def?.propsSchema) return [];
        return Object.entries(def.propsSchema).map(([propName, propDef]) => {
          const decl = {
            type: propDef.types?.[0] ?? "string",
            description: propDef.description,
            label: propName,
            ...propDef.enumValues && propDef.enumValues.length > 0 ? { values: propDef.enumValues } : {}
          };
          return [propName, decl];
        });
      }, [type]);
      const hasSchema = schemaEntries.length > 0;
      return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: cn("w-full", className), children: [
        /* @__PURE__ */ jsx(
          Select,
          {
            options,
            value: type,
            onValueChange: (v) => emit(v, props)
          }
        ),
        type !== "" && /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "pl-1", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: "props" }),
          hasSchema ? /* @__PURE__ */ jsx(VStack, { gap: "xs", children: schemaEntries.map(([propName, decl]) => /* @__PURE__ */ jsx(
            FieldControl,
            {
              name: propName,
              decl,
              value: props[propName],
              onChange: (field, val) => emit(type, { ...props, [field]: val })
            },
            propName
          )) }) : /* @__PURE__ */ jsx(JsonTreeEditor, { value: props, onChange: (next) => emit(type, isObj2(next) ? next : {}) })
        ] })
      ] });
    };
  }
});
function useDraggable({ payload, disabled = false }) {
  const [isDragging, setIsDragging] = useState(false);
  const eventBus = useEventBus();
  const handleDragStart = useCallback(
    (e) => {
      if (disabled) {
        e.preventDefault();
        return;
      }
      e.dataTransfer.setData(ALMADAR_DND_MIME, JSON.stringify(payload));
      e.dataTransfer.effectAllowed = "copy";
      setIsDragging(true);
      eventBus.emit("UI:DRAG_START", { kind: payload.kind, data: payload.data });
    },
    [disabled, payload, eventBus]
  );
  const handleDragEnd = useCallback(
    (e) => {
      setIsDragging(false);
      eventBus.emit("UI:DRAG_END", { kind: payload.kind, data: payload.data });
    },
    [payload, eventBus]
  );
  const dragProps = useMemo(
    () => ({
      draggable: !disabled,
      onDragStart: handleDragStart,
      onDragEnd: handleDragEnd,
      "aria-grabbed": isDragging
    }),
    [disabled, handleDragStart, handleDragEnd, isDragging]
  );
  return { dragProps, isDragging };
}
var ALMADAR_DND_MIME;
var init_useDraggable = __esm({
  "hooks/useDraggable.ts"() {
    "use client";
    init_useEventBus();
    ALMADAR_DND_MIME = "application/x-almadar-dnd";
  }
});
function parsePayload(e) {
  try {
    const raw = e.dataTransfer.getData(ALMADAR_DND_MIME);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.kind !== "string" || !parsed.data) return null;
    return parsed;
  } catch {
    return null;
  }
}
function hasAlmadarPayload(e) {
  return e.dataTransfer.types.includes(ALMADAR_DND_MIME);
}
function useDropZone({ accepts, onDrop, disabled = false }) {
  const [isOver, setIsOver] = useState(false);
  const eventBus = useEventBus();
  const handleDragOver = useCallback(
    (e) => {
      if (disabled) return;
      if (!hasAlmadarPayload(e)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
      setIsOver(true);
    },
    [disabled]
  );
  const handleDragLeave = useCallback(
    (e) => {
      setIsOver(false);
    },
    []
  );
  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      setIsOver(false);
      if (disabled) return;
      const payload = parsePayload(e);
      if (!payload) return;
      if (!accepts.includes(payload.kind)) return;
      const position = { x: e.clientX, y: e.clientY };
      onDrop(payload, position);
      eventBus.emit("UI:DROP", { kind: payload.kind, data: payload.data, ...position });
    },
    [disabled, accepts, onDrop, eventBus]
  );
  const dropProps = useMemo(
    () => ({
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop
    }),
    [handleDragOver, handleDragLeave, handleDrop]
  );
  return { dropProps, isOver };
}
var init_useDropZone = __esm({
  "hooks/useDropZone.ts"() {
    "use client";
    init_useEventBus();
    init_useDraggable();
  }
});
function fileIcon(name) {
  const ext = name.split(".").pop()?.toLowerCase() ?? "";
  switch (ext) {
    case "ts":
    case "tsx":
      return "file-code";
    case "js":
    case "jsx":
      return "file-code";
    case "json":
    case "orb":
      return "file-json";
    case "css":
    case "scss":
      return "file-text";
    case "md":
      return "file-text";
    case "py":
      return "file-code";
    case "html":
      return "file-code";
    default:
      return "file";
  }
}
function siblingsOf(target, roots, childrenByParent) {
  if (target.parentId) {
    const parentSiblings = childrenByParent.get(target.parentId);
    if (parentSiblings?.some((sibling) => sibling.id === target.id)) return parentSiblings;
  }
  return roots;
}
function ancestorsOf(id, byId) {
  const out = /* @__PURE__ */ new Set();
  if (!id) return out;
  let cur = byId.get(id)?.parentId;
  while (cur && byId.has(cur) && !out.has(cur)) {
    out.add(cur);
    cur = byId.get(cur)?.parentId;
  }
  return out;
}
var TreeNodeItem, FlatTreeNodeItem, FlatFileTree, FileTree;
var init_FileTree = __esm({
  "components/core/molecules/FileTree.tsx"() {
    "use client";
    init_Box();
    init_Typography();
    init_Icon();
    init_useDraggable();
    init_useDropZone();
    TreeNodeItem = ({
      node,
      depth,
      indent,
      selectedPath,
      onFileSelect,
      defaultExpanded = false
    }) => {
      const [expanded, setExpanded] = useState(defaultExpanded || depth < 1);
      const isDir = node.type === "dir";
      const isSelected = node.path === selectedPath;
      const handleClick = useCallback(() => {
        if (isDir) {
          setExpanded((prev) => !prev);
        } else {
          onFileSelect?.(node.path);
        }
      }, [isDir, node.path, onFileSelect]);
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            className: `flex items-center gap-1.5 py-0.5 px-2 cursor-pointer rounded-sm transition-colors ${isSelected ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`,
            style: { paddingLeft: depth * indent + 8 },
            onClick: handleClick,
            role: "treeitem",
            "aria-selected": isSelected,
            "aria-expanded": isDir ? expanded : void 0,
            children: [
              isDir ? /* @__PURE__ */ jsx(
                Icon,
                {
                  name: expanded ? "chevron-down" : "chevron-right",
                  size: "xs",
                  className: "text-[var(--color-muted-foreground)] flex-shrink-0"
                }
              ) : /* @__PURE__ */ jsx(Box, { style: { width: 12, flexShrink: 0 } }),
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: isDir ? expanded ? "folder-open" : "folder" : fileIcon(node.name),
                  size: "xs",
                  className: isSelected ? "text-inherit" : isDir ? "text-[var(--color-warning)]" : "text-[var(--color-muted-foreground)]"
                }
              ),
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: `truncate font-mono text-xs !text-inherit ${isSelected ? "font-semibold" : ""}`,
                  children: node.name
                }
              ),
              !isDir && node.size !== void 0 && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: `text-[9px] ml-auto flex-shrink-0 ${isSelected ? "!text-inherit opacity-80" : "text-[var(--color-muted-foreground)]"}`,
                  children: node.size < 1024 ? `${node.size}B` : `${Math.round(node.size / 1024)}KB`
                }
              )
            ]
          }
        ),
        isDir && expanded && node.children && /* @__PURE__ */ jsx(Box, { role: "group", children: node.children.map((child) => /* @__PURE__ */ jsx(
          TreeNodeItem,
          {
            node: child,
            depth: depth + 1,
            indent,
            selectedPath,
            onFileSelect,
            defaultExpanded: depth < 0
          },
          child.path
        )) })
      ] });
    };
    FlatTreeNodeItem = ({
      item,
      depth,
      indent,
      childrenByParent,
      roots,
      onNodeSelect,
      onNodeAction,
      nodeActionIcon,
      nodeActionLabel,
      onNodeReorder,
      selectedId,
      look,
      isExpanded,
      onToggle
    }) => {
      const children = childrenByParent.get(item.id);
      const hasChildren = !!children && children.length > 0;
      const expanded = hasChildren && isExpanded(item.id, depth);
      const isSelected = selectedId !== void 0 && selectedId !== "" && item.id === selectedId;
      const nav = look === "nav";
      const rowRef = useRef(null);
      const handleClick = useCallback(() => {
        if (hasChildren && !onNodeSelect) onToggle(item.id, expanded);
        onNodeSelect?.(item.id);
      }, [hasChildren, expanded, item.id, onNodeSelect, onToggle]);
      const handleChevron = useCallback((e) => {
        e.stopPropagation();
        onToggle(item.id, expanded);
      }, [item.id, expanded, onToggle]);
      const handleAction = useCallback((e) => {
        e.stopPropagation();
        onNodeAction?.(item.id);
      }, [item.id, onNodeAction]);
      const { dragProps } = useDraggable({
        payload: { kind: "tree-node", data: { id: item.id } },
        disabled: !onNodeReorder
      });
      const handleRowDrop = useCallback(
        (payload, position) => {
          if (!onNodeReorder) return;
          const draggedId = typeof payload.data.id === "string" ? payload.data.id : void 0;
          if (!draggedId || draggedId === item.id) return;
          const rect = rowRef.current?.getBoundingClientRect();
          if (!rect || rect.height === 0) return;
          const relY = position.y - rect.top;
          const third = rect.height / 3;
          if (relY >= third && relY <= third * 2) {
            const existingChildren = childrenByParent.get(item.id);
            onNodeReorder(draggedId, item.id, existingChildren ? existingChildren.length : 0);
            return;
          }
          const siblings = siblingsOf(item, roots, childrenByParent);
          const newParentId = siblings === roots ? null : item.parentId ?? null;
          const targetIndex = siblings.findIndex((sibling) => sibling.id === item.id);
          const index = relY < third ? targetIndex < 0 ? 0 : targetIndex : targetIndex < 0 ? siblings.length : targetIndex + 1;
          onNodeReorder(draggedId, newParentId, index);
        },
        [onNodeReorder, item, roots, childrenByParent]
      );
      const { dropProps } = useDropZone({
        accepts: ["tree-node"],
        onDrop: handleRowDrop,
        disabled: !onNodeReorder
      });
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            ref: rowRef,
            className: `group/treerow flex items-center gap-1.5 px-2 cursor-pointer rounded-sm transition-colors ${nav ? "py-1" : "py-0.5"} ${isSelected ? "bg-primary text-primary-foreground" : nav ? "text-foreground hover:bg-muted" : "hover:bg-muted"}`,
            style: { paddingLeft: depth * indent + 8 },
            onClick: handleClick,
            role: "treeitem",
            "aria-selected": isSelected,
            "aria-expanded": hasChildren ? expanded : void 0,
            ...dragProps,
            ...dropProps,
            children: [
              hasChildren ? /* @__PURE__ */ jsx(Box, { onClick: handleChevron, className: "flex items-center flex-shrink-0", role: "button", "aria-label": expanded ? "Collapse" : "Expand", children: /* @__PURE__ */ jsx(
                Icon,
                {
                  name: expanded ? "chevron-down" : "chevron-right",
                  size: "xs",
                  className: isSelected ? "text-inherit" : "text-[var(--color-muted-foreground)]"
                }
              ) }) : /* @__PURE__ */ jsx(Box, { style: { width: 12, flexShrink: 0 } }),
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: item.icon || (nav ? "file-text" : hasChildren ? expanded ? "folder-open" : "folder" : "file"),
                  size: "xs",
                  className: isSelected ? "text-inherit" : nav || !hasChildren ? "text-[var(--color-muted-foreground)]" : "text-[var(--color-warning)]"
                }
              ),
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: `truncate ${nav ? "text-sm" : "font-mono text-xs"} !text-inherit ${isSelected ? "font-semibold" : ""}`,
                  children: item.label
                }
              ),
              onNodeAction && /* @__PURE__ */ jsx(
                Box,
                {
                  onClick: handleAction,
                  role: "button",
                  "aria-label": nodeActionLabel ?? "Node action",
                  title: nodeActionLabel,
                  className: `ml-auto flex-shrink-0 rounded-sm p-0.5 opacity-0 group-hover/treerow:opacity-100 transition-opacity ${isSelected ? "hover:bg-primary-foreground/20" : "hover:bg-border"}`,
                  children: /* @__PURE__ */ jsx(Icon, { name: nodeActionIcon ?? "plus", size: "xs", className: "text-inherit" })
                }
              )
            ]
          }
        ),
        hasChildren && expanded && /* @__PURE__ */ jsx(Box, { role: "group", children: children.map((child) => /* @__PURE__ */ jsx(
          FlatTreeNodeItem,
          {
            item: child,
            depth: depth + 1,
            indent,
            childrenByParent,
            roots,
            onNodeSelect,
            onNodeAction,
            nodeActionIcon,
            nodeActionLabel,
            onNodeReorder,
            selectedId,
            look,
            isExpanded,
            onToggle
          },
          child.id
        )) })
      ] });
    };
    FlatFileTree = ({
      items,
      selectedId,
      look = "files",
      onNodeSelect,
      onNodeAction,
      nodeActionIcon,
      nodeActionLabel,
      onNodeReorder,
      className,
      indent = 16
    }) => {
      const [overrides, setOverrides] = useState(() => /* @__PURE__ */ new Map());
      const byId = React79__default.useMemo(() => new Map(items.map((node) => [node.id, node])), [items]);
      const selectedAncestors = React79__default.useMemo(() => ancestorsOf(selectedId, byId), [selectedId, byId]);
      const lastSelectedRef = React79__default.useRef(selectedId);
      React79__default.useEffect(() => {
        if (selectedId === lastSelectedRef.current) return;
        lastSelectedRef.current = selectedId;
        setOverrides((prev) => {
          if (![...selectedAncestors].some((a) => prev.get(a) === false)) return prev;
          const next = new Map(prev);
          for (const a of selectedAncestors) if (next.get(a) === false) next.delete(a);
          return next;
        });
      }, [selectedId, selectedAncestors]);
      const isExpanded = useCallback(
        (id, depth) => overrides.get(id) ?? (depth < 1 || selectedAncestors.has(id)),
        [overrides, selectedAncestors]
      );
      const onToggle = useCallback((id, effective) => {
        setOverrides((prev) => {
          const next = new Map(prev);
          next.set(id, !effective);
          return next;
        });
      }, []);
      if (items.length === 0) return null;
      const ids = new Set(items.map((node) => node.id));
      const childrenByParent = /* @__PURE__ */ new Map();
      const roots = [];
      for (const item of items) {
        if (item.parentId && ids.has(item.parentId)) {
          const siblings = childrenByParent.get(item.parentId);
          if (siblings) siblings.push(item);
          else childrenByParent.set(item.parentId, [item]);
        } else {
          roots.push(item);
        }
      }
      return /* @__PURE__ */ jsx(Box, { className: `py-1 overflow-y-auto ${className ?? ""}`, role: "tree", children: roots.map((item) => /* @__PURE__ */ jsx(
        FlatTreeNodeItem,
        {
          item,
          depth: 0,
          indent,
          childrenByParent,
          roots,
          onNodeSelect,
          onNodeAction,
          nodeActionIcon,
          nodeActionLabel,
          onNodeReorder,
          selectedId,
          look,
          isExpanded,
          onToggle
        },
        item.id
      )) });
    };
    FileTree = ({
      tree,
      items,
      selectedPath,
      selectedId,
      look = "files",
      onFileSelect,
      onNodeSelect,
      onNodeAction,
      nodeActionIcon,
      nodeActionLabel,
      onNodeReorder,
      className,
      indent = 16
    }) => {
      if (items) {
        return /* @__PURE__ */ jsx(
          FlatFileTree,
          {
            items,
            selectedId,
            look,
            onNodeSelect,
            onNodeAction,
            nodeActionIcon,
            nodeActionLabel,
            onNodeReorder,
            className,
            indent
          }
        );
      }
      if (!tree || tree.length === 0) return null;
      return /* @__PURE__ */ jsx(Box, { className: `py-1 overflow-y-auto ${className ?? ""}`, role: "tree", children: tree.map((node) => /* @__PURE__ */ jsx(
        TreeNodeItem,
        {
          node,
          depth: 0,
          indent,
          selectedPath,
          onFileSelect,
          defaultExpanded: true
        },
        node.path
      )) });
    };
    FileTree.displayName = "FileTree";
  }
});
var FormField;
var init_FormField = __esm({
  "components/core/molecules/FormField.tsx"() {
    init_cn();
    init_Label();
    init_Typography();
    FormField = ({
      label,
      required,
      error,
      hint,
      className,
      children
    }) => {
      return /* @__PURE__ */ jsxs("div", { className: cn("space-y-1.5", className), children: [
        /* @__PURE__ */ jsx(Label, { required, children: label }),
        children,
        error && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", children: error }),
        hint && !error && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: hint })
      ] });
    };
    FormField.displayName = "FormField";
  }
});
function getOrCreateStore(query) {
  if (!queryStores.has(query)) {
    queryStores.set(query, {
      search: "",
      filters: {},
      sortField: void 0,
      sortDirection: void 0,
      listeners: /* @__PURE__ */ new Set()
    });
  }
  return queryStores.get(query);
}
function useQuerySingleton(query) {
  const [, forceUpdate] = useState({});
  if (!query) {
    return null;
  }
  const store = useMemo(() => getOrCreateStore(query), [query]);
  useMemo(() => {
    const listener = () => forceUpdate({});
    store.listeners.add(listener);
    return () => {
      store.listeners.delete(listener);
    };
  }, [store]);
  const notifyListeners = useCallback(() => {
    store.listeners.forEach((listener) => listener());
  }, [store]);
  const setSearch = useCallback((value) => {
    store.search = value;
    notifyListeners();
  }, [store, notifyListeners]);
  const setFilter = useCallback((key, value) => {
    store.filters = { ...store.filters, [key]: value };
    notifyListeners();
  }, [store, notifyListeners]);
  const clearFilters = useCallback(() => {
    store.filters = {};
    store.search = "";
    notifyListeners();
  }, [store, notifyListeners]);
  const setSort = useCallback((field, direction) => {
    store.sortField = field;
    store.sortDirection = direction;
    notifyListeners();
  }, [store, notifyListeners]);
  return {
    search: store.search,
    setSearch,
    filters: store.filters,
    setFilter,
    clearFilters,
    sortField: store.sortField,
    sortDirection: store.sortDirection,
    setSort
  };
}
function parseQueryBinding(binding) {
  const cleaned = binding.startsWith("@") ? binding.slice(1) : binding;
  const parts = cleaned.split(".");
  return {
    query: parts[0],
    field: parts.length > 1 ? parts.slice(1).join(".") : void 0
  };
}
var queryStores;
var init_useQuerySingleton = __esm({
  "hooks/useQuerySingleton.ts"() {
    "use client";
    queryStores = /* @__PURE__ */ new Map();
  }
});
var resolveFilterType, lookStyles6, FilterGroupControls, FilterGroupPopover, FilterGroup;
var init_FilterGroup = __esm({
  "components/core/molecules/FilterGroup.tsx"() {
    "use client";
    init_cn();
    init_Button();
    init_Input();
    init_Select();
    init_Badge();
    init_Stack();
    init_Icon();
    init_RangeSlider();
    init_useEventBus();
    init_useQuerySingleton();
    resolveFilterType = (filter) => filter.filterType ?? filter.type;
    lookStyles6 = {
      toolbar: "",
      chips: "gap-1 [&_input]:rounded-pill [&_select]:rounded-pill [&_button]:rounded-pill [&_input]:!px-3 [&_select]:!px-3 [&_input]:bg-muted [&_select]:bg-muted [&_label]:hidden",
      pills: "gap-2 [&_input]:rounded-pill [&_select]:rounded-pill [&_button]:rounded-pill",
      "popover-trigger": "",
      "inline-column-header": "hidden"
    };
    FilterGroupControls = ({
      entity,
      filters,
      onFilterChange,
      onClearAll,
      className,
      variant = "default",
      showIcon = true,
      query,
      isLoading,
      look = "toolbar",
      event,
      clearEvent
    }) => {
      const { t } = useTranslate();
      const eventBus = useEventBus();
      const queryState = useQuerySingleton(query);
      const [selectedValues, setSelectedValues] = useState(
        () => {
          if (queryState?.filters) {
            return Object.fromEntries(
              Object.entries(queryState.filters).filter(([_, v]) => v !== null && v !== void 0).map(([k, v]) => [k, String(v)])
            );
          }
          return {};
        }
      );
      useEffect(() => {
        if (queryState?.filters) {
          const newValues = Object.fromEntries(
            Object.entries(queryState.filters).filter(([_, v]) => v !== null && v !== void 0).map(([k, v]) => [k, String(v)])
          );
          setSelectedValues(newValues);
        }
      }, [queryState?.filters]);
      const handleFilterSelect = useCallback(
        (field, value) => {
          setSelectedValues((prev) => {
            if (value === null || value === "" || value === "all") {
              const next = { ...prev };
              delete next[field];
              return next;
            }
            return { ...prev, [field]: value };
          });
          if (queryState) {
            queryState.setFilter(field, value === "all" ? null : value);
          }
          onFilterChange?.(field, value === "all" ? null : value);
          const payload = {
            entity,
            field,
            value: value === "all" || value === null ? "" : value,
            query
          };
          if (event && event !== "FILTER") {
            eventBus.emit(`UI:${event}`, payload);
          }
          eventBus.emit("UI:FILTER", payload);
        },
        [onFilterChange, queryState, eventBus, entity, query, event]
      );
      const handleClearAll = useCallback(() => {
        setSelectedValues({});
        if (queryState) {
          queryState.clearFilters();
        }
        onClearAll?.();
        if (clearEvent && clearEvent !== "CLEAR_FILTERS") {
          eventBus.emit(`UI:${clearEvent}`, { entity, query });
        }
        eventBus.emit("UI:CLEAR_FILTERS", { entity, query });
      }, [onClearAll, queryState, eventBus, entity, query, clearEvent]);
      const activeFilterCount = Object.keys(selectedValues).length;
      if (variant === "pills") {
        return /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "md",
            align: "center",
            className: cn("flex-wrap", lookStyles6[look], className),
            children: [
              showIcon && /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4 text-muted-foreground" }),
              filters.map((filter) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsxs("span", { className: "text-sm font-medium text-muted-foreground", children: [
                  filter.label,
                  ":"
                ] }),
                /* @__PURE__ */ jsxs(
                  HStack,
                  {
                    gap: "none",
                    className: "rounded-sm overflow-hidden border-[length:var(--border-width)] border-border",
                    children: [
                      /* @__PURE__ */ jsx(
                        "button",
                        {
                          type: "button",
                          onClick: () => handleFilterSelect(filter.field, null),
                          className: cn(
                            "px-3 py-1.5 text-sm font-medium transition-all duration-fast",
                            !selectedValues[filter.field] ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:bg-muted"
                          ),
                          children: t("filterGroup.all")
                        }
                      ),
                      filter.options?.map((option) => /* @__PURE__ */ jsx(
                        "button",
                        {
                          type: "button",
                          onClick: () => handleFilterSelect(filter.field, option),
                          className: cn(
                            "px-3 py-1.5 text-sm font-medium transition-all duration-fast",
                            "border-l-[length:var(--border-width)] border-border",
                            selectedValues[filter.field] === option ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:bg-muted"
                          ),
                          children: option
                        },
                        option
                      ))
                    ]
                  }
                )
              ] }, filter.field)),
              activeFilterCount > 0 && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: handleClearAll,
                  leftIcon: "x",
                  children: t("filterGroup.clear")
                }
              )
            ]
          }
        );
      }
      if (variant === "vertical") {
        return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col gap-4", lookStyles6[look], className), children: [
          showIcon && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-muted-foreground", children: [
            /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4" }),
            /* @__PURE__ */ jsx("span", { className: "text-sm font-bold uppercase tracking-wide", children: t("filterGroup.filters") })
          ] }),
          filters.map((filter) => /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ jsx("label", { className: "text-xs font-bold text-muted-foreground uppercase tracking-wide", children: filter.label }),
            resolveFilterType(filter) === "date" ? /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: selectedValues[filter.field] || "",
                onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
                clearable: true,
                onClear: () => handleFilterSelect(filter.field, null)
              }
            ) : resolveFilterType(filter) === "daterange" || resolveFilterType(filter) === "date-range" ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
              /* @__PURE__ */ jsx(
                Input,
                {
                  type: "date",
                  value: selectedValues[`${filter.field}_from`] || "",
                  onChange: (e) => handleFilterSelect(
                    `${filter.field}_from`,
                    e.target.value || null
                  ),
                  placeholder: t("filterGroup.from"),
                  clearable: true,
                  onClear: () => handleFilterSelect(`${filter.field}_from`, null)
                }
              ),
              /* @__PURE__ */ jsx(
                Input,
                {
                  type: "date",
                  value: selectedValues[`${filter.field}_to`] || "",
                  onChange: (e) => handleFilterSelect(
                    `${filter.field}_to`,
                    e.target.value || null
                  ),
                  placeholder: t("filterGroup.to"),
                  clearable: true,
                  onClear: () => handleFilterSelect(`${filter.field}_to`, null)
                }
              )
            ] }) : resolveFilterType(filter) === "numberrange" || resolveFilterType(filter) === "number-range" ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
              /* @__PURE__ */ jsx(
                RangeSlider,
                {
                  min: filter.min ?? 0,
                  max: filter.max ?? 100,
                  step: filter.step ?? 1,
                  value: Number(
                    selectedValues[`${filter.field}_min`] ?? filter.min ?? 0
                  ),
                  onChange: (v) => handleFilterSelect(`${filter.field}_min`, String(v)),
                  showTooltip: true,
                  "aria-label": t("filterGroup.from")
                }
              ),
              /* @__PURE__ */ jsx(
                RangeSlider,
                {
                  min: filter.min ?? 0,
                  max: filter.max ?? 100,
                  step: filter.step ?? 1,
                  value: Number(
                    selectedValues[`${filter.field}_max`] ?? filter.max ?? 100
                  ),
                  onChange: (v) => handleFilterSelect(`${filter.field}_max`, String(v)),
                  showTooltip: true,
                  "aria-label": t("filterGroup.to")
                }
              )
            ] }) : resolveFilterType(filter) === "text" ? /* @__PURE__ */ jsx(
              Input,
              {
                value: selectedValues[filter.field] || "",
                onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
                placeholder: filter.label,
                clearable: true,
                onClear: () => handleFilterSelect(filter.field, null)
              }
            ) : /* @__PURE__ */ jsx(
              Select,
              {
                value: selectedValues[filter.field] || "all",
                onValueChange: (v) => handleFilterSelect(filter.field, v),
                options: [
                  { value: "all", label: t("filterGroup.all") },
                  ...filter.options?.map((opt) => ({
                    value: opt,
                    label: opt
                  })) || []
                ]
              }
            )
          ] }, filter.field)),
          activeFilterCount > 0 && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: handleClearAll,
              leftIcon: "x",
              className: "self-start",
              children: t("filterGroup.clearAll")
            }
          )
        ] });
      }
      if (variant === "compact") {
        return /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            align: "center",
            className: cn("flex-wrap", lookStyles6[look], className),
            children: [
              showIcon && /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4 text-muted-foreground" }),
              filters.map((filter) => /* @__PURE__ */ jsx("div", { className: "min-w-[120px]", children: resolveFilterType(filter) === "date" ? /* @__PURE__ */ jsx(
                Input,
                {
                  type: "date",
                  value: selectedValues[filter.field] || "",
                  onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
                  clearable: true,
                  onClear: () => handleFilterSelect(filter.field, null),
                  className: "text-sm"
                }
              ) : resolveFilterType(filter) === "daterange" || resolveFilterType(filter) === "date-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    type: "date",
                    value: selectedValues[`${filter.field}_from`] || "",
                    onChange: (e) => handleFilterSelect(
                      `${filter.field}_from`,
                      e.target.value || null
                    ),
                    className: "text-sm min-w-[100px]"
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    type: "date",
                    value: selectedValues[`${filter.field}_to`] || "",
                    onChange: (e) => handleFilterSelect(
                      `${filter.field}_to`,
                      e.target.value || null
                    ),
                    className: "text-sm min-w-[100px]"
                  }
                )
              ] }) : resolveFilterType(filter) === "numberrange" || resolveFilterType(filter) === "number-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(
                  RangeSlider,
                  {
                    min: filter.min ?? 0,
                    max: filter.max ?? 100,
                    step: filter.step ?? 1,
                    value: Number(
                      selectedValues[`${filter.field}_min`] ?? filter.min ?? 0
                    ),
                    onChange: (v) => handleFilterSelect(`${filter.field}_min`, String(v)),
                    className: "min-w-[100px]",
                    "aria-label": t("filterGroup.from")
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
                /* @__PURE__ */ jsx(
                  RangeSlider,
                  {
                    min: filter.min ?? 0,
                    max: filter.max ?? 100,
                    step: filter.step ?? 1,
                    value: Number(
                      selectedValues[`${filter.field}_max`] ?? filter.max ?? 100
                    ),
                    onChange: (v) => handleFilterSelect(`${filter.field}_max`, String(v)),
                    className: "min-w-[100px]",
                    "aria-label": t("filterGroup.to")
                  }
                )
              ] }) : resolveFilterType(filter) === "text" ? /* @__PURE__ */ jsx(
                Input,
                {
                  value: selectedValues[filter.field] || "",
                  onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
                  placeholder: filter.label,
                  clearable: true,
                  onClear: () => handleFilterSelect(filter.field, null),
                  className: "text-sm"
                }
              ) : /* @__PURE__ */ jsx(
                Select,
                {
                  value: selectedValues[filter.field] || "all",
                  onValueChange: (v) => handleFilterSelect(filter.field, v),
                  options: [
                    { value: "all", label: t("filterGroup.allOf", { label: filter.label }) },
                    ...filter.options?.map((opt) => ({
                      value: opt,
                      label: opt
                    })) || []
                  ],
                  className: "text-sm"
                }
              ) }, filter.field)),
              activeFilterCount > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
                Object.entries(selectedValues).map(([field, value]) => {
                  const filterDef = filters.find((f3) => f3.field === field);
                  return /* @__PURE__ */ jsxs(
                    Badge,
                    {
                      variant: "primary",
                      size: "md",
                      className: "cursor-pointer",
                      onClick: () => handleFilterSelect(field, null),
                      children: [
                        filterDef?.label,
                        ": ",
                        value,
                        /* @__PURE__ */ jsx(Icon, { name: "x", className: "ml-1 h-3 w-3" })
                      ]
                    },
                    field
                  );
                }),
                /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleClearAll, children: t("filterGroup.clearAll") })
              ] })
            ]
          }
        );
      }
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "p-4 rounded-container",
            "bg-card",
            "border-[length:var(--border-width)] border-border",
            lookStyles6[look],
            className
          ),
          children: /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "center", className: "flex-wrap", children: [
            showIcon && /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "xs",
                align: "center",
                className: "text-muted-foreground",
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4" }),
                  /* @__PURE__ */ jsx("span", { className: "text-xs font-bold uppercase tracking-wide", children: t("filterGroup.filters") })
                ]
              }
            ),
            filters.map((filter) => /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ jsx("label", { className: "text-xs font-bold text-muted-foreground uppercase tracking-wide", children: filter.label }),
              resolveFilterType(filter) === "date" ? /* @__PURE__ */ jsx(
                Input,
                {
                  type: "date",
                  value: selectedValues[filter.field] || "",
                  onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
                  clearable: true,
                  onClear: () => handleFilterSelect(filter.field, null),
                  className: "min-w-[160px]"
                }
              ) : resolveFilterType(filter) === "daterange" || resolveFilterType(filter) === "date-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    type: "date",
                    value: selectedValues[`${filter.field}_from`] || "",
                    onChange: (e) => handleFilterSelect(
                      `${filter.field}_from`,
                      e.target.value || null
                    ),
                    placeholder: t("filterGroup.from"),
                    clearable: true,
                    onClear: () => handleFilterSelect(`${filter.field}_from`, null),
                    className: "min-w-[130px]"
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
                /* @__PURE__ */ jsx(
                  Input,
                  {
                    type: "date",
                    value: selectedValues[`${filter.field}_to`] || "",
                    onChange: (e) => handleFilterSelect(
                      `${filter.field}_to`,
                      e.target.value || null
                    ),
                    placeholder: t("filterGroup.to"),
                    clearable: true,
                    onClear: () => handleFilterSelect(`${filter.field}_to`, null),
                    className: "min-w-[130px]"
                  }
                )
              ] }) : resolveFilterType(filter) === "numberrange" || resolveFilterType(filter) === "number-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(
                  RangeSlider,
                  {
                    min: filter.min ?? 0,
                    max: filter.max ?? 100,
                    step: filter.step ?? 1,
                    value: Number(
                      selectedValues[`${filter.field}_min`] ?? filter.min ?? 0
                    ),
                    onChange: (v) => handleFilterSelect(`${filter.field}_min`, String(v)),
                    showTooltip: true,
                    className: "min-w-[130px]",
                    "aria-label": t("filterGroup.from")
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
                /* @__PURE__ */ jsx(
                  RangeSlider,
                  {
                    min: filter.min ?? 0,
                    max: filter.max ?? 100,
                    step: filter.step ?? 1,
                    value: Number(
                      selectedValues[`${filter.field}_max`] ?? filter.max ?? 100
                    ),
                    onChange: (v) => handleFilterSelect(`${filter.field}_max`, String(v)),
                    showTooltip: true,
                    className: "min-w-[130px]",
                    "aria-label": t("filterGroup.to")
                  }
                )
              ] }) : resolveFilterType(filter) === "text" ? /* @__PURE__ */ jsx(
                Input,
                {
                  value: selectedValues[filter.field] || "",
                  onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
                  placeholder: filter.label,
                  clearable: true,
                  onClear: () => handleFilterSelect(filter.field, null),
                  className: "min-w-[160px]"
                }
              ) : /* @__PURE__ */ jsx(
                Select,
                {
                  value: selectedValues[filter.field] || "all",
                  onValueChange: (v) => handleFilterSelect(filter.field, v),
                  options: [
                    { value: "all", label: t("filterGroup.all") },
                    ...filter.options?.map((opt) => ({
                      value: opt,
                      label: opt
                    })) || []
                  ],
                  className: "min-w-[140px]"
                }
              )
            ] }, filter.field)),
            activeFilterCount > 0 && /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "ml-auto", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "md", children: t("filterGroup.activeCount", { count: activeFilterCount }) }),
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: handleClearAll,
                  leftIcon: "x",
                  children: t("filterGroup.clearAll")
                }
              )
            ] })
          ] })
        }
      );
    };
    FilterGroupControls.displayName = "FilterGroupControls";
    FilterGroupPopover = (props) => {
      const { t } = useTranslate();
      const [open, setOpen] = useState(false);
      const queryState = useQuerySingleton(props.query);
      const activeFilterCount = queryState?.filters ? Object.values(queryState.filters).filter((v) => v !== null && v !== void 0).length : 0;
      return /* @__PURE__ */ jsxs("div", { className: cn("relative inline-block", props.className), children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: activeFilterCount > 0 ? "secondary" : "ghost",
            size: "sm",
            leftIcon: "filter",
            onClick: () => setOpen((o) => !o),
            "aria-expanded": open,
            "aria-haspopup": "true",
            children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
              /* @__PURE__ */ jsx("span", { children: t("filterGroup.filters") }),
              activeFilterCount > 0 && /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", children: activeFilterCount })
            ] })
          }
        ),
        open && /* @__PURE__ */ jsx("div", { className: "absolute left-0 z-50 mt-2 min-w-[16rem] rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-card-md shadow-main", children: /* @__PURE__ */ jsx(
          FilterGroupControls,
          {
            ...props,
            className: void 0,
            look: "toolbar",
            variant: "vertical",
            showIcon: false
          }
        ) })
      ] });
    };
    FilterGroupPopover.displayName = "FilterGroupPopover";
    FilterGroup = (props) => props.look === "popover-trigger" ? /* @__PURE__ */ jsx(FilterGroupPopover, { ...props }) : /* @__PURE__ */ jsx(FilterGroupControls, { ...props });
    FilterGroup.displayName = "FilterGroup";
  }
});
var directionStyles, wrapStyles, alignStyles3, justifyStyles2, gapStyles6, Flex;
var init_Flex = __esm({
  "components/core/molecules/Flex.tsx"() {
    init_cn();
    directionStyles = {
      row: "flex-row",
      "row-reverse": "flex-row-reverse",
      col: "flex-col",
      "col-reverse": "flex-col-reverse"
    };
    wrapStyles = {
      nowrap: "flex-nowrap",
      wrap: "flex-wrap",
      "wrap-reverse": "flex-wrap-reverse"
    };
    alignStyles3 = {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline"
    };
    justifyStyles2 = {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
      evenly: "justify-evenly"
    };
    gapStyles6 = {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8",
      "2xl": "gap-12"
    };
    Flex = ({
      direction = "row",
      wrap = "nowrap",
      align = "stretch",
      justify = "start",
      gap = "none",
      inline = false,
      grow,
      shrink,
      basis,
      className,
      children,
      as: Component = "div"
    }) => {
      const flexStyle = {};
      if (grow !== void 0 || shrink !== void 0 || basis !== void 0) {
        const growValue = grow === true ? 1 : grow === false ? 0 : grow;
        const shrinkValue = shrink === true ? 1 : shrink === false ? 0 : shrink;
        flexStyle.flexGrow = growValue;
        flexStyle.flexShrink = shrinkValue;
        if (basis !== void 0) {
          flexStyle.flexBasis = typeof basis === "number" ? `${basis}px` : basis;
        }
      }
      return React79__default.createElement(Component, {
        className: cn(
          inline ? "inline-flex" : "flex",
          directionStyles[direction],
          wrapStyles[wrap],
          alignStyles3[align],
          justifyStyles2[justify],
          gapStyles6[gap],
          className
        ),
        style: Object.keys(flexStyle).length > 0 ? flexStyle : void 0,
        children
      });
    };
    Flex.displayName = "Flex";
  }
});
function getColsClass(cols) {
  if (typeof cols === "number" || cols === "none") {
    return colStyles2[cols];
  }
  const classes = [];
  if (cols.base !== void 0) {
    classes.push(colStyles2[cols.base]);
  }
  if (cols.sm !== void 0) {
    classes.push(`sm:${colStyles2[cols.sm]}`);
  }
  if (cols.md !== void 0) {
    classes.push(`md:${colStyles2[cols.md]}`);
  }
  if (cols.lg !== void 0) {
    classes.push(`lg:${colStyles2[cols.lg]}`);
  }
  if (cols.xl !== void 0) {
    classes.push(`xl:${colStyles2[cols.xl]}`);
  }
  return classes.join(" ");
}
var colStyles2, gapStyles7, rowGapStyles, colGapStyles, alignStyles4, justifyStyles3, flowStyles, Grid;
var init_Grid = __esm({
  "components/core/molecules/Grid.tsx"() {
    init_cn();
    colStyles2 = {
      none: "grid-cols-none",
      1: "grid-cols-1",
      2: "grid-cols-2",
      3: "grid-cols-3",
      4: "grid-cols-4",
      5: "grid-cols-5",
      6: "grid-cols-6",
      7: "grid-cols-7",
      8: "grid-cols-8",
      9: "grid-cols-9",
      10: "grid-cols-10",
      11: "grid-cols-11",
      12: "grid-cols-12"
    };
    gapStyles7 = {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8",
      "2xl": "gap-12"
    };
    rowGapStyles = {
      none: "gap-y-0",
      xs: "gap-y-1",
      sm: "gap-y-2",
      md: "gap-y-4",
      lg: "gap-y-6",
      xl: "gap-y-8",
      "2xl": "gap-y-12"
    };
    colGapStyles = {
      none: "gap-x-0",
      xs: "gap-x-1",
      sm: "gap-x-2",
      md: "gap-x-4",
      lg: "gap-x-6",
      xl: "gap-x-8",
      "2xl": "gap-x-12"
    };
    alignStyles4 = {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline"
    };
    justifyStyles3 = {
      start: "justify-items-start",
      center: "justify-items-center",
      end: "justify-items-end",
      stretch: "justify-items-stretch"
    };
    flowStyles = {
      row: "grid-flow-row",
      col: "grid-flow-col",
      "row-dense": "grid-flow-row-dense",
      "col-dense": "grid-flow-col-dense"
    };
    Grid = ({
      cols = 1,
      rows: rows2,
      gap = "md",
      rowGap,
      colGap,
      alignItems,
      justifyItems,
      flow,
      className,
      style,
      children,
      as: Component = "div"
    }) => {
      const mergedStyle = rows2 ? { gridTemplateRows: `repeat(${rows2}, minmax(0, 1fr))`, ...style } : style;
      return React79__default.createElement(
        Component,
        {
          className: cn(
            "grid",
            getColsClass(cols),
            rowGap ? rowGapStyles[rowGap] : colGap ? void 0 : gapStyles7[gap],
            colGap ? colGapStyles[colGap] : rowGap ? void 0 : void 0,
            rowGap && colGap ? `${rowGapStyles[rowGap]} ${colGapStyles[colGap]}` : void 0,
            alignItems && alignStyles4[alignItems],
            justifyItems && justifyStyles3[justifyItems],
            flow && flowStyles[flow],
            className
          ),
          style: mergedStyle
        },
        children
      );
    };
    Grid.displayName = "Grid";
  }
});
var InputGroup;
var init_InputGroup = __esm({
  "components/core/molecules/InputGroup.tsx"() {
    init_Input();
    init_Icon();
    init_Typography();
    init_cn();
    InputGroup = ({
      leftAddon,
      rightAddon,
      className: groupClassName,
      ...inputProps
    }) => {
      const { className: inputClassName, ...restInputProps } = inputProps;
      const renderAddon = (addon, position) => {
        if (!addon) return null;
        if (typeof addon === "function" || typeof addon === "object" && addon !== null && "render" in addon) {
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "flex items-center justify-center px-3",
                "bg-muted dark:bg-muted",
                "border border-border dark:border-border",
                position === "left" ? "rounded-l-lg border-r-0" : "rounded-r-lg border-l-0"
              ),
              children: /* @__PURE__ */ jsx(Icon, { icon: addon, size: "sm" })
            }
          );
        }
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "flex items-center justify-center px-3",
              "bg-muted dark:bg-muted",
              "border border-border dark:border-border",
              "text-foreground dark:text-foreground",
              position === "left" ? "rounded-l-lg border-r-0" : "rounded-r-lg border-l-0"
            ),
            children: typeof addon === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "small", children: addon }) : addon
          }
        );
      };
      return /* @__PURE__ */ jsxs("div", { className: cn("flex items-stretch", groupClassName), children: [
        leftAddon && renderAddon(leftAddon, "left"),
        /* @__PURE__ */ jsx("div", { className: "flex-1", children: /* @__PURE__ */ jsx(
          Input,
          {
            ...restInputProps,
            className: cn(
              leftAddon ? "rounded-l-none" : "",
              rightAddon ? "rounded-r-none" : "",
              inputClassName
            )
          }
        ) }),
        rightAddon && renderAddon(rightAddon, "right")
      ] });
    };
    InputGroup.displayName = "InputGroup";
  }
});
var PageTransition;
var init_PageTransition = __esm({
  "components/core/molecules/PageTransition.tsx"() {
    "use client";
    init_cn();
    PageTransition = ({ locationKey, children, className }) => /* @__PURE__ */ jsx("div", { className: cn("animate-page-in", className), children }, locationKey);
    PageTransition.displayName = "PageTransition";
  }
});
function ConfettiBurst({ item, lifeMs }) {
  const particles = createConfettiParticles(item.particleCount ?? 30, item.id);
  const left = (item.x ?? 0.5) * 100;
  const top = (item.z ?? item.y ?? 0.4) * 100;
  return /* @__PURE__ */ jsx(Box, { position: "absolute", style: { left: `${left}%`, top: `${top}%` }, children: particles.map((p) => {
    const rad = p.angle * Math.PI / 180;
    const tx = Math.cos(rad) * p.distance * (item.size ?? 1);
    const ty = Math.sin(rad) * p.distance * (item.size ?? 1) - 20;
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "absolute rounded-sm",
        style: {
          left: (p.left - 50) * 2,
          top: -10,
          width: p.size,
          height: p.size,
          backgroundColor: item.color ?? p.color,
          animation: `confetti-burst ${Math.max(lifeMs - p.delay, 200)}ms ease-out ${p.delay}ms forwards`,
          opacity: 0,
          "--confetti-tx": `${tx}px`,
          "--confetti-ty": `${ty}px`,
          "--confetti-rotate": `${p.rotation}deg`
        }
      },
      p.id
    );
  }) });
}
function SparkleBurst({ item, lifeMs }) {
  const count = item.particleCount ?? 8;
  const scale = item.size ?? 1;
  const left = (item.x ?? 0.5) * 100;
  const top = (item.z ?? item.y ?? 0.4) * 100;
  return /* @__PURE__ */ jsx(Box, { position: "absolute", style: { left: `${left}%`, top: `${top}%` }, children: Array.from({ length: count }, (_, i) => {
    const dx = (fxHash01(item.id, i * 4) - 0.5) * 160 * scale;
    const dy = (fxHash01(item.id, i * 4 + 1) - 0.5) * 120 * scale;
    const dot = (4 + fxHash01(item.id, i * 4 + 2) * 5) * scale;
    const delay = fxHash01(item.id, i * 4 + 3) * lifeMs * 0.4;
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "absolute rounded-full",
        style: {
          left: dx,
          top: dy,
          width: dot,
          height: dot,
          backgroundColor: item.color ?? "gold",
          opacity: 0,
          animation: `fx-overlay-sparkle ${Math.max(lifeMs - delay, 200)}ms ease-in-out ${delay}ms forwards`
        }
      },
      i
    );
  }) });
}
function OverlayFxNode({ item, tickMs }) {
  const lifeMs = lifeMsOf(item, tickMs);
  switch (item.effect ?? "sparkle") {
    case "confetti":
      return /* @__PURE__ */ jsx(ConfettiBurst, { item, lifeMs });
    case "flash":
      return /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          className: "inset-0",
          style: {
            backgroundColor: item.color ?? "#ffffff",
            opacity: 0,
            animation: `fx-overlay-flash ${lifeMs}ms ease-out forwards`
          }
        }
      );
    case "streak-glow":
      return /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          className: "inset-0",
          style: {
            boxShadow: `inset 0 0 ${60 * (item.size ?? 1)}px ${item.color ?? "var(--color-warning)"}`,
            opacity: 0,
            animation: `fx-overlay-glow ${lifeMs}ms ease-in-out forwards`
          }
        }
      );
    case "float-text": {
      if (!item.message) return null;
      return /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          style: {
            left: `${(item.x ?? 0.5) * 100}%`,
            top: `${(item.z ?? item.y ?? 0.4) * 100}%`,
            color: item.color ?? "var(--color-success)",
            fontWeight: 700,
            fontSize: 16 * (item.size ?? 1),
            textShadow: "0 1px 2px rgba(0,0,0,0.4)",
            opacity: 0,
            animation: `fx-overlay-float ${lifeMs}ms ease-out forwards`,
            whiteSpace: "nowrap"
          },
          children: item.message
        }
      );
    }
    case "shake":
      return null;
    default:
      return /* @__PURE__ */ jsx(SparkleBurst, { item, lifeMs });
  }
}
var DEFAULT_TICK_MS2, FX_OVERLAY_KEYFRAMES, lifeMsOf, FxOverlay;
var init_FxOverlay = __esm({
  "components/core/molecules/FxOverlay.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_fx();
    DEFAULT_TICK_MS2 = 500;
    FX_OVERLAY_KEYFRAMES = `
${CONFETTI_BURST_KEYFRAMES}
@keyframes fx-overlay-flash {
  0% { opacity: 0.75; }
  100% { opacity: 0; }
}
@keyframes fx-overlay-glow {
  0% { opacity: 0.9; }
  60% { opacity: 0.6; }
  100% { opacity: 0; }
}
@keyframes fx-overlay-sparkle {
  0% { opacity: 0; transform: scale(0); }
  30% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(0.3); }
}
@keyframes fx-overlay-float {
  0% { opacity: 0; transform: translate(-50%, 8px); }
  15% { opacity: 1; }
  100% { opacity: 0; transform: translate(-50%, -40px); }
}
@keyframes fx-overlay-shake {
  0% { transform: translateX(0); }
  15% { transform: translateX(-6px); }
  30% { transform: translateX(5px); }
  45% { transform: translateX(-4px); }
  60% { transform: translateX(3px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}
`;
    lifeMsOf = (it, tickMs) => Math.max(it.maxTtl ?? it.ttl, it.ttl, 1) * tickMs;
    FxOverlay = ({ items, tickMs = DEFAULT_TICK_MS2, children, className }) => {
      const screenItems = (Array.isArray(items) ? items : []).filter(
        (it) => Boolean(it) && typeof it.id === "string" && it.space !== "world"
      );
      const shakeItem = [...screenItems].reverse().find((it) => it.effect === "shake");
      const overlay = /* @__PURE__ */ jsxs(
        Box,
        {
          position: "absolute",
          className: cn("inset-0 pointer-events-none overflow-hidden z-50", !children && className),
          "aria-hidden": "true",
          children: [
            screenItems.map((it) => /* @__PURE__ */ jsx(OverlayFxNode, { item: it, tickMs }, it.id)),
            /* @__PURE__ */ jsx("style", { children: FX_OVERLAY_KEYFRAMES })
          ]
        }
      );
      if (children !== void 0 && children !== null) {
        return /* @__PURE__ */ jsxs(Box, { position: "relative", className, children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              style: shakeItem ? { animation: `fx-overlay-shake ${Math.min(lifeMsOf(shakeItem, tickMs), 600)}ms ease-in-out` } : void 0,
              children
            },
            shakeItem?.id ?? "steady"
          ),
          overlay
        ] });
      }
      return overlay;
    };
    FxOverlay.displayName = "FxOverlay";
  }
});
function computePopoverStyle(position, triggerRect, popoverWidth) {
  if (position === "left" || position === "right") {
    return {
      left: position === "left" ? triggerRect.left - popoverWidth - TRIGGER_GAP : triggerRect.right + TRIGGER_GAP,
      top: triggerRect.top + triggerRect.height / 2,
      transform: "translateY(-50%)"
    };
  }
  const viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1024;
  const centered = triggerRect.left + triggerRect.width / 2 - popoverWidth / 2;
  const maxLeft = viewportWidth - popoverWidth - VIEWPORT_EDGE_PADDING;
  const clamped = Math.max(
    VIEWPORT_EDGE_PADDING,
    Math.min(centered, Math.max(VIEWPORT_EDGE_PADDING, maxLeft))
  );
  return {
    left: clamped,
    top: position === "top" ? triggerRect.top - TRIGGER_GAP : triggerRect.bottom + TRIGGER_GAP,
    transform: position === "top" ? "translateY(-100%)" : void 0
  };
}
var arrowClasses, VIEWPORT_EDGE_PADDING, TRIGGER_GAP, Popover;
var init_Popover = __esm({
  "components/core/molecules/Popover.tsx"() {
    "use client";
    init_Typography();
    init_Presence();
    init_cn();
    init_portalRoot();
    init_useTapReveal();
    arrowClasses = {
      top: "top-full left-1/2 -translate-x-1/2 border-t-white border-l-transparent border-r-transparent border-b-transparent",
      bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-white border-l-transparent border-r-transparent border-t-transparent",
      left: "left-full top-1/2 -translate-y-1/2 border-l-white border-t-transparent border-b-transparent border-r-transparent",
      right: "right-full top-1/2 -translate-y-1/2 border-r-white border-t-transparent border-b-transparent border-l-transparent"
    };
    VIEWPORT_EDGE_PADDING = 8;
    TRIGGER_GAP = 8;
    Popover = ({
      content,
      children,
      position = "bottom",
      trigger = "click",
      showArrow = true,
      open,
      onOpenChange,
      className
    }) => {
      const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
      const isOpen = open !== void 0 ? open : uncontrolledOpen;
      const setIsOpen = (next) => {
        if (open === void 0) setUncontrolledOpen(next);
        onOpenChange?.(next);
      };
      const [triggerRect, setTriggerRect] = useState(null);
      const [popoverWidth, setPopoverWidth] = useState(0);
      const triggerRef = useRef(null);
      const popoverRef = useRef(null);
      const { mounted, className: panelAnim, onAnimationEnd } = usePresence(isOpen, { animation: "popover" });
      const updatePosition = () => {
        if (triggerRef.current) {
          setTriggerRect(triggerRef.current.getBoundingClientRect());
        }
        if (popoverRef.current) {
          setPopoverWidth(popoverRef.current.offsetWidth);
        }
      };
      const handleOpen = () => {
        updatePosition();
        setIsOpen(true);
      };
      const handleClose = () => {
        setIsOpen(false);
      };
      const handleToggle = () => {
        if (isOpen) {
          handleClose();
        } else {
          handleOpen();
        }
      };
      useEffect(() => {
        if (isOpen) {
          updatePosition();
        }
      }, [isOpen]);
      useEffect(() => {
        if (!isOpen) return;
        let raf = 0;
        let lastTop = Number.NaN;
        let lastLeft = Number.NaN;
        const track = () => {
          const rect = triggerRef.current?.getBoundingClientRect();
          if (rect && (rect.top !== lastTop || rect.left !== lastLeft)) {
            lastTop = rect.top;
            lastLeft = rect.left;
            updatePosition();
          }
          raf = requestAnimationFrame(track);
        };
        raf = requestAnimationFrame(track);
        return () => cancelAnimationFrame(raf);
      }, [isOpen]);
      useEffect(() => {
        if (!mounted) setPopoverWidth(0);
      }, [mounted]);
      useLayoutEffect(() => {
        if (isOpen && popoverRef.current) {
          const measured = popoverRef.current.offsetWidth;
          if (measured !== popoverWidth) {
            setPopoverWidth(measured);
          }
        }
      });
      useEffect(() => {
        if (trigger !== "click") {
          return;
        }
        const handleClickOutside = (e) => {
          if (isOpen && popoverRef.current && !popoverRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
            handleClose();
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, [isOpen, trigger]);
      const { triggerProps: tapTriggerProps } = useTapReveal({
        enabled: trigger === "hover",
        onReveal: handleOpen,
        onDismiss: handleClose,
        refs: [triggerRef, popoverRef]
      });
      const handlerProps = trigger === "click" ? {
        onClick: handleToggle
      } : {
        onMouseEnter: handleOpen,
        onMouseLeave: handleClose,
        onPointerDown: tapTriggerProps.onPointerDown
      };
      const childElement = React79__default.isValidElement(children) ? children : /* @__PURE__ */ jsx("span", { children });
      const childPointerDown = childElement.props.onPointerDown;
      const triggerElement = React79__default.cloneElement(
        childElement,
        {
          ref: triggerRef,
          ...handlerProps,
          ...trigger === "hover" ? {
            onPointerDown: (e) => {
              tapTriggerProps.onPointerDown(e);
              childPointerDown?.(e);
            }
          } : void 0
        }
      );
      const panel = mounted && triggerRect ? /* @__PURE__ */ jsxs(
        "div",
        {
          ref: popoverRef,
          className: cn(
            "fixed z-50 p-4",
            "bg-card border-2 border-border shadow-elevation-popover",
            panelAnim,
            className
          ),
          style: {
            ...computePopoverStyle(position, triggerRect, popoverWidth),
            ...popoverWidth === 0 ? { visibility: "hidden" } : void 0
          },
          role: "dialog",
          onAnimationEnd,
          onMouseEnter: trigger === "hover" ? handleOpen : void 0,
          onMouseLeave: trigger === "hover" ? handleClose : void 0,
          children: [
            typeof content === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "body", children: content }) : content,
            showArrow && /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute w-0 h-0 border-4",
                  arrowClasses[position]
                )
              }
            )
          ]
        }
      ) : null;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        triggerElement,
        panel && typeof document !== "undefined" ? createPortal(panel, getOrCreatePortalRoot()) : panel
      ] });
    };
    Popover.displayName = "Popover";
  }
});
function resolveAnchorRect(anchor) {
  if (typeof anchor === "string") {
    return document.querySelector(anchor)?.getBoundingClientRect() ?? null;
  }
  if (anchor instanceof DOMRect) return anchor;
  return anchor?.current?.getBoundingClientRect() ?? null;
}
function useAnchorRect(anchor, active) {
  const [rect, setRect] = useState(null);
  const read = useCallback(() => resolveAnchorRect(anchor), [anchor]);
  useEffect(() => {
    if (!active || typeof document === "undefined") {
      setRect(null);
      return;
    }
    const update = () => setRect(read());
    update();
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);
    let raf = 0;
    let tries = 0;
    const poll = () => {
      const found = read();
      if (found) {
        setRect(found);
      } else if (tries++ < 40) {
        raf = requestAnimationFrame(poll);
      }
    };
    if (!read()) raf = requestAnimationFrame(poll);
    return () => {
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [active, read]);
  return rect;
}
function placeCard(placement, rect, size) {
  const vw = typeof window !== "undefined" ? window.innerWidth : 1024;
  const vh = typeof window !== "undefined" ? window.innerHeight : 768;
  let top = 0;
  let left = 0;
  switch (placement) {
    case "top":
      top = rect.top - size.h - GAP;
      left = rect.left + rect.width / 2 - size.w / 2;
      break;
    case "left":
      left = rect.left - size.w - GAP;
      top = rect.top + rect.height / 2 - size.h / 2;
      break;
    case "right":
      left = rect.right + GAP;
      top = rect.top + rect.height / 2 - size.h / 2;
      break;
    case "bottom":
    default:
      top = rect.bottom + GAP;
      left = rect.left + rect.width / 2 - size.w / 2;
      break;
  }
  left = Math.max(EDGE, Math.min(left, vw - size.w - EDGE));
  top = Math.max(EDGE, Math.min(top, vh - size.h - EDGE));
  return { top, left };
}
var GAP, EDGE, Coachmark;
var init_Coachmark = __esm({
  "components/core/molecules/Coachmark.tsx"() {
    "use client";
    init_Box();
    init_Typography();
    init_Button();
    init_Icon();
    init_cn();
    init_portalRoot();
    GAP = 10;
    EDGE = 8;
    Coachmark = ({
      open,
      anchor,
      placement = "bottom",
      title,
      children,
      onDismiss,
      onPrimary,
      primaryLabel,
      onSecondary,
      secondaryLabel,
      showBeacon = false,
      fallbackCentered = false,
      className
    }) => {
      const cardRef = useRef(null);
      const { t } = useTranslate();
      const rect = useAnchorRect(anchor, open);
      const [pos, setPos] = useState(null);
      const centered = open && !rect && fallbackCentered;
      useLayoutEffect(() => {
        if (!open || !rect || !cardRef.current) {
          setPos(null);
          return;
        }
        const size = {
          w: cardRef.current.offsetWidth,
          h: cardRef.current.offsetHeight
        };
        setPos(placeCard(placement, rect, size));
      }, [open, rect, placement, children, title]);
      useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
          if (e.key === "Escape") onDismiss();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
      }, [open, onDismiss]);
      if (!open || typeof document === "undefined") return null;
      if (!rect && !centered) return null;
      const hasFooter = Boolean(onPrimary || onSecondary);
      const cardStyle = centered ? { top: "50%", left: "50%", transform: "translate(-50%, -50%)" } : pos ? { top: pos.top, left: pos.left } : { top: -9999, left: -9999 };
      const card = /* @__PURE__ */ jsxs(
        Box,
        {
          ref: cardRef,
          bg: "surface",
          border: true,
          rounded: "lg",
          shadow: "xl",
          padding: "md",
          role: "dialog",
          "aria-label": title,
          className: cn(
            "fixed z-50 max-w-xs w-72 transition-opacity duration-fast",
            centered || pos ? "opacity-100" : "opacity-0",
            className
          ),
          style: cardStyle,
          children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                "aria-label": t("aria.dismiss"),
                onClick: onDismiss,
                className: "absolute top-2 right-2 text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)]",
                children: /* @__PURE__ */ jsx(Icon, { name: "close", size: "xs" })
              }
            ),
            title && /* @__PURE__ */ jsx(Typography, { variant: "body1", weight: "semibold", className: "pr-6 mb-1", children: title }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", as: "div", children }),
            hasFooter && /* @__PURE__ */ jsxs("div", { className: "mt-3 flex items-center justify-end gap-2", children: [
              onSecondary && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onSecondary, children: secondaryLabel ?? "Skip" }),
              onPrimary && /* @__PURE__ */ jsx(Button, { variant: "primary", size: "sm", onClick: onPrimary, children: primaryLabel ?? "Got it" })
            ] })
          ]
        }
      );
      const beacon = showBeacon && rect ? /* @__PURE__ */ jsx(
        "div",
        {
          className: "fixed z-50 pointer-events-none",
          style: {
            top: rect.top + rect.height / 2 - 6,
            left: rect.left + rect.width / 2 - 6
          },
          "aria-hidden": "true",
          children: /* @__PURE__ */ jsxs("span", { className: "relative flex h-3 w-3", children: [
            /* @__PURE__ */ jsx("span", { className: "absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--color-primary)] opacity-75" }),
            /* @__PURE__ */ jsx("span", { className: "relative inline-flex h-3 w-3 rounded-full bg-[var(--color-primary)]" })
          ] })
        }
      ) : null;
      return createPortal(
        /* @__PURE__ */ jsxs(Fragment, { children: [
          beacon,
          card
        ] }),
        getOrCreatePortalRoot()
      );
    };
    Coachmark.displayName = "Coachmark";
  }
});
var DIM, OnboardingSpotlight;
var init_OnboardingSpotlight = __esm({
  "components/core/molecules/OnboardingSpotlight.tsx"() {
    "use client";
    init_Coachmark();
    init_cn();
    init_portalRoot();
    DIM = "fixed z-[45] bg-black/60";
    OnboardingSpotlight = ({
      steps,
      stepIndex,
      onNext,
      onSkip,
      onFinish,
      cutoutPadding = 6
    }) => {
      const step = steps[stepIndex];
      const rect = useAnchorRect(step?.anchor ?? "", Boolean(step));
      if (!step || typeof document === "undefined") return null;
      const isLast = stepIndex >= steps.length - 1;
      const backdrop = rect ? (() => {
        const p = cutoutPadding;
        const top = Math.max(0, rect.top - p);
        const left = Math.max(0, rect.left - p);
        const right = rect.right + p;
        const bottom = rect.bottom + p;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: DIM, style: { top: 0, left: 0, right: 0, height: top } }),
          /* @__PURE__ */ jsx("div", { className: DIM, style: { top: bottom, left: 0, right: 0, bottom: 0 } }),
          /* @__PURE__ */ jsx("div", { className: DIM, style: { top, left: 0, width: left, height: bottom - top } }),
          /* @__PURE__ */ jsx("div", { className: DIM, style: { top, left: right, right: 0, height: bottom - top } })
        ] });
      })() : /* @__PURE__ */ jsx("div", { className: cn(DIM, "inset-0") });
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        createPortal(backdrop, getOrCreatePortalRoot()),
        /* @__PURE__ */ jsxs(
          Coachmark,
          {
            open: true,
            anchor: step.anchor,
            placement: step.placement ?? "bottom",
            fallbackCentered: true,
            title: step.title,
            onDismiss: onSkip,
            onSecondary: onSkip,
            secondaryLabel: "Skip",
            onPrimary: isLast ? onFinish : onNext,
            primaryLabel: isLast ? "Done" : "Next",
            children: [
              /* @__PURE__ */ jsx("span", { children: step.body }),
              /* @__PURE__ */ jsx("span", { className: "mt-3 flex items-center gap-1.5", children: steps.map((_, i) => /* @__PURE__ */ jsx(
                "span",
                {
                  className: cn(
                    "h-1.5 w-1.5 rounded-full",
                    i === stepIndex ? "bg-[var(--color-primary)]" : "bg-[var(--color-border)]"
                  )
                },
                i
              )) })
            ]
          }
        )
      ] });
    };
    OnboardingSpotlight.displayName = "OnboardingSpotlight";
  }
});
function gateEnabled(level, ns = NAMESPACE) {
  return isLogLevelEnabled(level, ns);
}
function isDebugEnabled() {
  return gateEnabled("DEBUG");
}
function debug(...args) {
  if (!gateEnabled("DEBUG")) return;
  const [first, ...rest] = args;
  const message = typeof first === "string" ? first : "<debug>";
  if (rest.length === 0 && typeof first === "string") {
    log8.debug(message);
  } else {
    log8.debug(message, { args: rest.length > 0 ? formatArgs(rest) : formatArgs([first]) });
  }
}
function debugGroup(label) {
  if (gateEnabled("DEBUG")) console.group(`[${NAMESPACE}] ${label}`);
}
function debugGroupEnd() {
  if (gateEnabled("DEBUG")) console.groupEnd();
}
function formatArgs(values) {
  if (values.length === 1) return toLogMetaValue(values[0]);
  return values.map(toLogMetaValue);
}
function toLogMetaValue(v) {
  if (v === null || v === void 0) return v;
  if (v instanceof Error) return v;
  const t = typeof v;
  if (t === "string" || t === "number" || t === "boolean") return v;
  if (Array.isArray(v)) return v.map(toLogMetaValue);
  if (t === "object") {
    const out = {};
    for (const [k, val] of Object.entries(v)) {
      out[k] = toLogMetaValue(val);
    }
    return out;
  }
  return String(v);
}
var NAMESPACE, log8;
var init_debug = __esm({
  "lib/debug.ts"() {
    NAMESPACE = "almadar:ui:debug";
    log8 = createLogger(NAMESPACE);
    createLogger("almadar:ui:debug:input");
    createLogger("almadar:ui:debug:collision");
    createLogger("almadar:ui:debug:physics");
    createLogger("almadar:ui:debug:game-state");
  }
});
var isRelationsDebugEnabled, MANY_CARDINALITIES, RelationSelect;
var init_RelationSelect = __esm({
  "components/core/molecules/RelationSelect.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Icon();
    init_Stack();
    init_Input();
    init_Button();
    init_Spinner();
    init_Typography();
    init_debug();
    isRelationsDebugEnabled = () => isDebugEnabled();
    MANY_CARDINALITIES = [
      "many",
      "one-to-many",
      "many-to-many"
    ];
    RelationSelect = ({
      value,
      onChange,
      options = [],
      placeholder,
      required = false,
      disabled = false,
      isLoading = false,
      error,
      clearable = true,
      name,
      className,
      searchPlaceholder,
      emptyMessage
    }) => {
      const { t } = useTranslate();
      const resolvedPlaceholder = placeholder ?? t("relationSelect.selectPlaceholder");
      const resolvedSearchPlaceholder = searchPlaceholder ?? t("common.search");
      const resolvedEmptyMessage = emptyMessage ?? t("empty.noOptionsFound");
      const [isOpen, setIsOpen] = useState(false);
      const [searchQuery, setSearchQuery] = useState("");
      const containerRef = useRef(null);
      const searchInputRef = useRef(null);
      useEffect(() => {
        if (isRelationsDebugEnabled()) {
          debugGroup(`RelationSelect: ${name || "unnamed"}`);
          debug(`Options count: ${options.length}`);
          debug(`Current value: ${value || "none"}`);
          debug(`Is loading: ${isLoading}`);
          if (options.length > 0) {
            debug("Sample options:", options.slice(0, 3));
          } else {
            debug("\u26A0\uFE0F No options available!");
          }
          debugGroupEnd();
        }
      }, [name, options.length, value, isLoading]);
      const selectedOption = useMemo(() => {
        const found = options.find((opt) => opt.value === value);
        if (isRelationsDebugEnabled() && value && !found) {
          debug(`\u26A0\uFE0F Value "${value}" not found in options for ${name}`);
        }
        return found;
      }, [options, value, name]);
      const filteredOptions = useMemo(() => {
        if (!searchQuery.trim()) return options;
        const query = searchQuery.toLowerCase();
        return options.filter(
          (opt) => opt.label.toLowerCase().includes(query) || opt.description?.toLowerCase().includes(query)
        );
      }, [options, searchQuery]);
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (containerRef.current && !containerRef.current.contains(event.target)) {
            setIsOpen(false);
            setSearchQuery("");
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
      useEffect(() => {
        if (isOpen && searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, [isOpen]);
      const handleToggle = useCallback(() => {
        if (!disabled) {
          setIsOpen((prev) => !prev);
          if (!isOpen) {
            setSearchQuery("");
          }
        }
      }, [disabled, isOpen]);
      const handleSelect = useCallback(
        (option) => {
          if (option.disabled) return;
          onChange?.(option.value);
          setIsOpen(false);
          setSearchQuery("");
        },
        [onChange]
      );
      const handleClear = useCallback(
        (e) => {
          e.stopPropagation();
          onChange?.(void 0);
        },
        [onChange]
      );
      const handleKeyDown = useCallback(
        (e) => {
          if (e.key === "Escape") {
            setIsOpen(false);
            setSearchQuery("");
          } else if (e.key === "Enter" && filteredOptions.length === 1) {
            handleSelect(filteredOptions[0]);
          }
        },
        [filteredOptions, handleSelect]
      );
      return /* @__PURE__ */ jsxs(Box, { ref: containerRef, className: cn("relative", className), children: [
        /* @__PURE__ */ jsx(Input, { type: "hidden", name, value: value || "" }),
        /* @__PURE__ */ jsxs(
          Button,
          {
            type: "button",
            variant: "secondary",
            onClick: handleToggle,
            disabled,
            className: cn(
              "w-full justify-between font-normal",
              error && "border-error/50 focus:border-error focus:ring-error",
              isOpen && "ring-2 ring-primary border-primary"
            ),
            children: [
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body",
                  className: cn(
                    !selectedOption && "text-muted-foreground"
                  ),
                  children: isLoading ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ jsx(Spinner, { size: "sm" }),
                    /* @__PURE__ */ jsx(Typography, { as: "span", children: t("common.loading") })
                  ] }) : selectedOption ? selectedOption.label : resolvedPlaceholder
                }
              ),
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                clearable && selectedOption && !disabled && /* @__PURE__ */ jsx(
                  Box,
                  {
                    as: "button",
                    className: "p-0.5 hover:bg-muted rounded cursor-pointer",
                    onClick: handleClear,
                    children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "h-4 w-4 text-muted-foreground" })
                  }
                ),
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "chevron-down",
                    className: cn(
                      "h-4 w-4 text-muted-foreground transition-transform",
                      isOpen && "transform rotate-180"
                    )
                  }
                )
              ] })
            ]
          }
        ),
        isOpen && /* @__PURE__ */ jsxs(
          Box,
          {
            position: "absolute",
            bg: "surface",
            border: true,
            rounded: "md",
            shadow: "lg",
            className: "z-50 w-full mt-1",
            children: [
              /* @__PURE__ */ jsx(Box, { padding: "sm", className: "border-b border-border", children: /* @__PURE__ */ jsx(
                Input,
                {
                  ref: searchInputRef,
                  type: "text",
                  value: searchQuery,
                  onChange: (e) => setSearchQuery(e.target.value),
                  onKeyDown: handleKeyDown,
                  placeholder: resolvedSearchPlaceholder,
                  icon: Search,
                  className: "text-sm"
                }
              ) }),
              /* @__PURE__ */ jsx(Box, { overflow: "auto", className: "max-h-60", children: isLoading ? /* @__PURE__ */ jsx(Box, { padding: "md", display: "flex", className: "justify-center", children: /* @__PURE__ */ jsx(Spinner, { size: "md", color: "primary" }) }) : filteredOptions.length === 0 ? /* @__PURE__ */ jsx(Box, { padding: "md", children: /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body",
                  color: "muted",
                  className: "text-center",
                  children: resolvedEmptyMessage
                }
              ) }) : /* @__PURE__ */ jsx(VStack, { gap: "none", children: filteredOptions.map((option) => /* @__PURE__ */ jsxs(
                Box,
                {
                  as: "button",
                  fullWidth: true,
                  paddingX: "sm",
                  paddingY: "sm",
                  className: cn(
                    "text-left text-sm hover:bg-muted focus:outline-none focus:bg-muted",
                    option.value === value && "bg-primary/10 text-primary",
                    option.disabled && "opacity-50 cursor-not-allowed"
                  ),
                  onClick: () => handleSelect(option),
                  children: [
                    /* @__PURE__ */ jsx(Typography, { variant: "body", className: "font-medium", children: option.label }),
                    option.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: option.description })
                  ]
                },
                option.value
              )) }) })
            ]
          }
        ),
        error && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", className: "mt-1", children: error })
      ] });
    };
    RelationSelect.displayName = "RelationSelect";
  }
});
var SearchInput;
var init_SearchInput = __esm({
  "components/core/molecules/SearchInput.tsx"() {
    "use client";
    init_Input();
    init_Spinner();
    init_Box();
    init_cn();
    init_useEventBus();
    init_useQuerySingleton();
    SearchInput = ({
      value,
      onSearch,
      debounceMs = 300,
      isLoading = false,
      placeholder,
      clearable = true,
      className,
      event,
      entity,
      query,
      ...props
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolvedPlaceholder = placeholder ?? t("common.search");
      const queryState = useQuerySingleton(query);
      const initialValue = queryState?.search ?? value ?? "";
      const [searchValue, setSearchValue] = useState(initialValue);
      const [debounceTimer, setDebounceTimer] = useState(null);
      useEffect(() => {
        if (queryState && queryState.search !== searchValue) {
          setSearchValue(queryState.search);
        }
      }, [queryState?.search]);
      const handleChange = useCallback((e) => {
        const newValue = e.target.value;
        setSearchValue(newValue);
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        const timer = setTimeout(() => {
          if (queryState) {
            queryState.setSearch(newValue);
          }
          onSearch?.(newValue);
          if (event && event !== "SEARCH") {
            eventBus.emit(`UI:${event}`, { searchTerm: newValue, entity });
          }
          if (event || entity || query) {
            eventBus.emit("UI:SEARCH", { searchTerm: newValue, entity, query });
          }
        }, debounceMs);
        setDebounceTimer(timer);
      }, [onSearch, debounceMs, debounceTimer, event, entity, query, eventBus, queryState]);
      const handleClear = useCallback(() => {
        setSearchValue("");
        if (queryState) {
          queryState.setSearch("");
        }
        onSearch?.("");
        if (event || query) {
          eventBus.emit("UI:CLEAR_SEARCH", { searchTerm: "", entity, query });
        }
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
      }, [onSearch, debounceTimer, event, query, entity, eventBus, queryState]);
      useEffect(() => {
        if (value !== void 0 && value !== searchValue && !query) {
          setSearchValue(value);
        }
      }, [value, query]);
      useEffect(() => {
        return () => {
          if (debounceTimer) {
            clearTimeout(debounceTimer);
          }
        };
      }, [debounceTimer]);
      return /* @__PURE__ */ jsxs(Box, { className: cn("relative", className), children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "search",
            value: searchValue,
            onChange: handleChange,
            placeholder: resolvedPlaceholder,
            icon: Search,
            clearable: clearable && !isLoading,
            onClear: handleClear,
            disabled: isLoading,
            className: "pr-10",
            ...props
          }
        ),
        isLoading && /* @__PURE__ */ jsx(Box, { className: "absolute right-3 top-1/2 -translate-y-1/2", children: /* @__PURE__ */ jsx(Spinner, { size: "sm", color: "primary" }) })
      ] });
    };
    SearchInput.displayName = "SearchInput";
  }
});
var SidePanel;
var init_SidePanel = __esm({
  "components/core/molecules/SidePanel.tsx"() {
    "use client";
    init_Aside();
    init_Box();
    init_Button();
    init_Typography();
    init_Presence();
    init_cn();
    init_useEventBus();
    SidePanel = ({
      title,
      children,
      isOpen,
      onClose,
      width = "w-full sm:w-96",
      position = "right",
      showOverlay = true,
      className,
      closeEvent
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleClose = () => {
        if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
        onClose();
      };
      const { mounted, className: panelAnim, onAnimationEnd } = usePresence(isOpen, { animation: "drawer" });
      const drawerSign = position === "right" ? 1 : -1;
      if (!mounted) return null;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        showOverlay && /* @__PURE__ */ jsx(Presence, { show: isOpen, animation: "overlay", children: /* @__PURE__ */ jsx(
          Box,
          {
            className: "fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden",
            onClick: handleClose
          }
        ) }),
        /* @__PURE__ */ jsxs(
          Aside,
          {
            className: cn(
              "fixed top-16 lg:top-0 bottom-0 z-[60]",
              "bg-card",
              "border-l-2 border-border",
              position === "left" && "border-l-0 border-r-2",
              "flex flex-col",
              panelAnim,
              width,
              position === "right" ? "right-0" : "left-0",
              className
            ),
            style: { "--motion-drawer-sign": drawerSign },
            onAnimationEnd,
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "flex items-center justify-between p-4 border-b-2 border-border sticky top-0 bg-card z-10", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h6", children: title }),
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    icon: "x",
                    onClick: handleClose,
                    "aria-label": t("aria.closePanel"),
                    children: /* @__PURE__ */ jsx(Typography, { variant: "small", as: "span", className: "sr-only", children: t("aria.closePanel") })
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Box, { className: "p-4 flex-1 overflow-y-auto", children })
            ]
          }
        )
      ] });
    };
    SidePanel.displayName = "SidePanel";
  }
});
function computeTooltipStyle(position, triggerRect) {
  switch (position) {
    case "bottom":
      return {
        left: triggerRect.left + triggerRect.width / 2,
        top: triggerRect.bottom + TRIGGER_GAP2,
        transform: "translateX(-50%)"
      };
    case "left":
      return {
        left: triggerRect.left - TRIGGER_GAP2,
        top: triggerRect.top + triggerRect.height / 2,
        transform: "translate(-100%, -50%)"
      };
    case "right":
      return {
        left: triggerRect.right + TRIGGER_GAP2,
        top: triggerRect.top + triggerRect.height / 2,
        transform: "translateY(-50%)"
      };
    case "top":
    default:
      return {
        left: triggerRect.left + triggerRect.width / 2,
        top: triggerRect.top - TRIGGER_GAP2,
        transform: "translate(-50%, -100%)"
      };
  }
}
var TRIGGER_GAP2, arrowClasses2, Tooltip;
var init_Tooltip = __esm({
  "components/core/molecules/Tooltip.tsx"() {
    "use client";
    init_Typography();
    init_cn();
    init_portalRoot();
    init_useTapReveal();
    TRIGGER_GAP2 = 8;
    arrowClasses2 = {
      top: "top-full left-1/2 -translate-x-1/2 border-t-primary border-l-transparent border-r-transparent border-b-transparent",
      bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-primary border-l-transparent border-r-transparent border-t-transparent",
      left: "left-full top-1/2 -translate-y-1/2 border-l-primary border-t-transparent border-b-transparent border-r-transparent",
      right: "right-full top-1/2 -translate-y-1/2 border-r-primary border-t-transparent border-b-transparent border-l-transparent"
    };
    Tooltip = ({
      content,
      children,
      position = "top",
      delay = 200,
      hideDelay = 0,
      showArrow = true,
      className
    }) => {
      const [isVisible, setIsVisible] = useState(false);
      const [triggerRect, setTriggerRect] = useState(null);
      const triggerRef = useRef(null);
      const tooltipRef = useRef(null);
      const showTimeoutRef = useRef(null);
      const hideTimeoutRef = useRef(null);
      const updatePosition = () => {
        if (triggerRef.current) {
          setTriggerRect(triggerRef.current.getBoundingClientRect());
        }
      };
      const handleMouseEnter = () => {
        if (hideTimeoutRef.current) {
          clearTimeout(hideTimeoutRef.current);
        }
        updatePosition();
        showTimeoutRef.current = setTimeout(() => {
          setIsVisible(true);
        }, delay);
      };
      const handleMouseLeave = () => {
        if (showTimeoutRef.current) {
          clearTimeout(showTimeoutRef.current);
        }
        hideTimeoutRef.current = setTimeout(() => {
          setIsVisible(false);
        }, hideDelay);
      };
      const { triggerProps } = useTapReveal({
        onReveal: handleMouseEnter,
        onDismiss: handleMouseLeave,
        refs: [triggerRef, tooltipRef]
      });
      useLayoutEffect(() => {
        if (isVisible) {
          updatePosition();
        }
      }, [isVisible]);
      useEffect(() => {
        return () => {
          if (showTimeoutRef.current) clearTimeout(showTimeoutRef.current);
          if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        };
      }, []);
      const triggerElement = React79__default.isValidElement(children) ? children : /* @__PURE__ */ jsx("span", { children });
      const childPointerDown = triggerElement.props.onPointerDown;
      const trigger = React79__default.cloneElement(triggerElement, {
        ref: triggerRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        onPointerDown: (e) => {
          triggerProps.onPointerDown(e);
          childPointerDown?.(e);
        }
      });
      const tooltipContent = isVisible && triggerRect ? /* @__PURE__ */ jsxs(
        "div",
        {
          ref: tooltipRef,
          className: cn(
            "fixed z-50 px-3 py-2 max-w-xs",
            "bg-primary text-primary-foreground",
            "shadow-elevation-popover rounded-sm",
            "text-sm pointer-events-none",
            "break-words whitespace-normal",
            "h-auto min-h-fit",
            className
          ),
          style: computeTooltipStyle(position, triggerRect),
          role: "tooltip",
          children: [
            /* @__PURE__ */ jsx("div", { className: "w-full break-words whitespace-normal h-auto", children: typeof content === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-primary-foreground break-words whitespace-normal", children: content }) : /* @__PURE__ */ jsx("div", { className: "break-words whitespace-normal", children: content }) }),
            showArrow && /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute w-0 h-0 border-4",
                  arrowClasses2[position]
                )
              }
            )
          ]
        }
      ) : null;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        trigger,
        typeof window !== "undefined" && tooltipContent ? createPortal(tooltipContent, getOrCreatePortalRoot()) : tooltipContent
      ] });
    };
    Tooltip.displayName = "Tooltip";
  }
});
var WizardProgress;
var init_WizardProgress = __esm({
  "components/core/molecules/WizardProgress.tsx"() {
    "use client";
    init_Typography();
    init_Box();
    init_Icon();
    init_cn();
    init_useEventBus();
    WizardProgress = ({
      steps,
      currentStep,
      onStepClick,
      allowNavigation = true,
      compact = false,
      className,
      stepClickEvent
    }) => {
      const eventBus = useEventBus();
      const normalizedSteps = (steps ?? []).map(
        (s, i) => typeof s === "string" ? { id: `step-${i}`, title: s } : s
      );
      const totalSteps = normalizedSteps.length;
      const handleStepClick = (index) => {
        const isCompleted = index < currentStep;
        if (isCompleted && allowNavigation) {
          if (stepClickEvent) eventBus.emit(`UI:${stepClickEvent}`, { stepIndex: index });
          onStepClick?.(index);
        }
      };
      return /* @__PURE__ */ jsx(
        Box,
        {
          border: true,
          className: cn(
            "border-b-2 border-x-0 border-t-0 border-border",
            compact ? "px-4 py-2" : "px-6 py-4",
            className
          ),
          children: /* @__PURE__ */ jsx("div", { className: "flex items-center gap-2", children: normalizedSteps.map((step, index) => {
            const isActive = index === currentStep;
            const isCompleted = index < currentStep;
            return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => handleStepClick(index),
                  disabled: !isCompleted || !allowNavigation,
                  className: cn(
                    "flex items-center justify-center text-sm font-bold transition-colors",
                    "border-2 border-border",
                    compact ? "w-6 h-6" : "w-8 h-8",
                    isActive && "bg-foreground text-background",
                    isCompleted && "bg-foreground text-background cursor-pointer hover:bg-muted-foreground",
                    !isActive && !isCompleted && "bg-card text-foreground"
                  ),
                  children: isCompleted ? /* @__PURE__ */ jsx(Icon, { name: "check", size: "sm" }) : index + 1
                }
              ),
              !compact && /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "hidden md:block",
                    isActive ? "text-foreground font-bold" : "text-muted-foreground"
                  ),
                  children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "small",
                      weight: isActive ? "bold" : "normal",
                      children: step.title
                    }
                  )
                }
              ),
              index < totalSteps - 1 && /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "flex-1 h-0.5",
                    index < currentStep ? "bg-foreground" : "bg-muted"
                  )
                }
              )
            ] }, step.id || `step-${index}`);
          }) })
        }
      );
    };
    WizardProgress.displayName = "WizardProgress";
  }
});
function useSafeEventBus4() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var WizardNavigation;
var init_WizardNavigation = __esm({
  "components/core/molecules/WizardNavigation.tsx"() {
    "use client";
    init_Button();
    init_Typography();
    init_Box();
    init_Stack();
    init_Icon();
    init_cn();
    init_useEventBus();
    WizardNavigation = ({
      currentStep,
      totalSteps,
      isValid = true,
      showBack = true,
      showNext = true,
      showComplete = true,
      backLabel,
      nextLabel,
      completeLabel,
      onBack = "WIZARD_BACK",
      onNext = "WIZARD_NEXT",
      onComplete = "WIZARD_COMPLETE",
      onBackClick,
      onNextClick,
      onCompleteClick,
      compact = false,
      className
    }) => {
      const eventBus = useSafeEventBus4();
      const { t } = useTranslate();
      const resolvedBackLabel = backLabel ?? t("wizard.back");
      const resolvedNextLabel = nextLabel ?? t("wizard.next");
      const resolvedCompleteLabel = completeLabel ?? t("wizard.complete");
      const isFirstStep = currentStep === 0;
      const isLastStep = currentStep === totalSteps - 1;
      const handleBack = () => {
        if (onBackClick) {
          onBackClick();
        } else {
          eventBus.emit(`UI:${onBack}`, { currentStep, totalSteps });
        }
      };
      const handleNext = () => {
        if (onNextClick) {
          onNextClick();
        } else {
          eventBus.emit(`UI:${onNext}`, { currentStep, totalSteps });
        }
      };
      const handleComplete = () => {
        if (onCompleteClick) {
          onCompleteClick();
        } else {
          eventBus.emit(`UI:${onComplete}`, { currentStep, totalSteps });
        }
      };
      return /* @__PURE__ */ jsxs(
        Box,
        {
          border: true,
          className: cn(
            // `flex-wrap gap-2` lets the Back / Step / Next trio reflow on
            // narrow viewports rather than crushing the step counter.
            "border-t-2 border-x-0 border-b-0 border-border flex flex-wrap gap-2 justify-between items-center",
            compact ? "px-4 py-2" : "px-6 py-4",
            className
          ),
          children: [
            showBack ? /* @__PURE__ */ jsxs(Button, { variant: "secondary", onClick: handleBack, disabled: isFirstStep, children: [
              /* @__PURE__ */ jsx(Icon, { name: "chevron-left", size: "sm" }),
              resolvedBackLabel
            ] }) : /* @__PURE__ */ jsx(Box, {}),
            /* @__PURE__ */ jsx(HStack, { align: "center", gap: "sm", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("wizard.stepOf", { current: String(currentStep + 1), total: String(totalSteps) }) }) }),
            isLastStep && showComplete ? /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: handleComplete, disabled: !isValid, children: resolvedCompleteLabel }) : showNext ? /* @__PURE__ */ jsxs(Button, { variant: "primary", onClick: handleNext, disabled: !isValid, children: [
              resolvedNextLabel,
              /* @__PURE__ */ jsx(Icon, { name: "chevron-right", size: "sm" })
            ] }) : /* @__PURE__ */ jsx(Box, {})
          ]
        }
      );
    };
    WizardNavigation.displayName = "WizardNavigation";
  }
});
function parseDay(value) {
  if (value === void 0 || value === null || value === "") return null;
  const d = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
}
function Gantt({
  tasks = [],
  links = [],
  titleField = "title",
  startField = "start",
  endField = "end",
  durationField,
  statusField = "status",
  groupField = "",
  rangeStart,
  rangeEnd,
  showToday = true,
  dayWidth = 28,
  barClickEvent,
  className,
  isLoading = false,
  error = null
}) {
  const { t } = useTranslate();
  const placed = useMemo(() => {
    const rows2 = Array.isArray(tasks) ? tasks : tasks ? [tasks] : [];
    const out = [];
    rows2.forEach((row, idx) => {
      const start = parseDay(getNestedValue(row, startField));
      if (!start) return;
      let end = parseDay(getNestedValue(row, endField));
      if (!end && durationField) {
        const days2 = Number(getNestedValue(row, durationField));
        if (Number.isFinite(days2) && days2 > 0) {
          end = new Date(start.getTime() + days2 * DAY_MS);
        }
      }
      if (!end || end.getTime() < start.getTime()) end = new Date(start.getTime() + DAY_MS);
      out.push({
        row,
        id: String(row.id ?? idx),
        label: String(getNestedValue(row, titleField) ?? ""),
        status: String(getNestedValue(row, statusField) ?? "").toLowerCase(),
        group: groupField ? String(getNestedValue(row, groupField) ?? "") : "",
        start,
        end
      });
    });
    return out;
  }, [tasks, titleField, startField, endField, durationField, statusField, groupField]);
  const [axisStart, axisEnd] = useMemo(() => {
    const lo = parseDay(rangeStart) ?? (placed.length ? new Date(Math.min(...placed.map((p) => p.start.getTime())) - 2 * DAY_MS) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)));
    const hi = parseDay(rangeEnd) ?? (placed.length ? new Date(Math.max(...placed.map((p) => p.end.getTime())) + 2 * DAY_MS) : new Date(lo.getTime() + 30 * DAY_MS));
    return hi.getTime() > lo.getTime() ? [lo, hi] : [lo, new Date(lo.getTime() + DAY_MS)];
  }, [rangeStart, rangeEnd, placed]);
  const totalDays = Math.round((axisEnd.getTime() - axisStart.getTime()) / DAY_MS);
  const chartWidth = totalDays * dayWidth;
  const dayOffset = (d) => (d.getTime() - axisStart.getTime()) / DAY_MS * dayWidth;
  const displayItems = useMemo(() => {
    if (!groupField) return placed.map((task) => ({ kind: "task", task }));
    const items = [];
    const seen = /* @__PURE__ */ new Set();
    for (const task of placed) {
      if (!seen.has(task.group)) {
        seen.add(task.group);
        items.push({ kind: "group", label: task.group || "\u2014" });
      }
      items.push({ kind: "task", task });
    }
    return items;
  }, [placed, groupField]);
  const barGeometry = useMemo(() => {
    const offset = (d) => (d.getTime() - axisStart.getTime()) / DAY_MS * dayWidth;
    const map = /* @__PURE__ */ new Map();
    displayItems.forEach((item, idx) => {
      if (item.kind !== "task") return;
      const x0 = offset(item.task.start);
      const x1 = Math.max(offset(item.task.end), x0 + dayWidth / 2);
      map.set(item.task.id, { x0, x1, y: HEADER_HEIGHT + idx * ROW_HEIGHT + ROW_HEIGHT / 2 });
    });
    return map;
  }, [displayItems, axisStart, dayWidth]);
  const days = useMemo(() => {
    const out = [];
    for (let i = 0; i < totalDays; i++) out.push(new Date(axisStart.getTime() + i * DAY_MS));
    return out;
  }, [axisStart, totalDays]);
  const todayOffset = useMemo(() => {
    const today = parseDay(/* @__PURE__ */ new Date());
    if (!today || today < axisStart || today > axisEnd) return null;
    return (today.getTime() - axisStart.getTime()) / DAY_MS * dayWidth;
  }, [axisStart, axisEnd, dayWidth]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: cn("p-4", className), children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) });
  }
  if (placed.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("empty.noData"),
        className
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: cn("w-full overflow-auto rounded-md border border-border bg-card", className),
      children: /* @__PURE__ */ jsxs(Box, { className: "relative", style: { width: LABEL_WIDTH + chartWidth, minWidth: "100%" }, children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "sticky top-0 z-20 bg-card border-b border-border", style: { height: HEADER_HEIGHT }, children: [
          /* @__PURE__ */ jsx(Box, { className: "sticky left-0 z-10 shrink-0 bg-card border-r border-border", style: { width: LABEL_WIDTH, height: HEADER_HEIGHT } }),
          /* @__PURE__ */ jsx(Box, { className: "relative", style: { width: chartWidth, height: HEADER_HEIGHT }, children: days.map((day, i) => /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "absolute top-0 bottom-0 border-l border-border/50 flex items-end justify-center pb-1",
                day.getDay() === 0 || day.getDay() === 6 ? "bg-muted/40" : void 0
              ),
              style: { left: i * dayWidth, width: dayWidth },
              children: dayWidth >= 20 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: day.getDate() })
            },
            i
          )) })
        ] }),
        /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "relative", children: [
          displayItems.map(
            (item, idx) => item.kind === "group" ? /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "none",
                className: "border-b border-border bg-muted/30",
                style: { height: ROW_HEIGHT },
                children: [
                  /* @__PURE__ */ jsx(Box, { className: "sticky left-0 z-10 shrink-0 bg-muted/30 px-3 flex items-center border-r border-border", style: { width: LABEL_WIDTH, height: ROW_HEIGHT }, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "semibold", children: item.label }) }),
                  /* @__PURE__ */ jsx(Box, { style: { width: chartWidth, height: ROW_HEIGHT } })
                ]
              },
              `g-${idx}`
            ) : /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "none",
                className: "border-b border-border/50",
                style: { height: ROW_HEIGHT },
                children: [
                  /* @__PURE__ */ jsx(Box, { className: "sticky left-0 z-10 shrink-0 bg-card px-3 flex items-center border-r border-border", style: { width: LABEL_WIDTH, height: ROW_HEIGHT }, children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate", children: item.task.label }) }),
                  /* @__PURE__ */ jsx(Box, { className: "relative", style: { width: chartWidth, height: ROW_HEIGHT }, children: /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: cn(
                        "absolute top-1/2 -translate-y-1/2 h-4 rounded-sm transition-colors",
                        STATUS_BAR[item.task.status] ?? "bg-primary/80 hover:bg-primary",
                        barClickEvent ? "cursor-pointer" : void 0
                      ),
                      style: {
                        left: dayOffset(item.task.start),
                        width: Math.max(dayOffset(item.task.end) - dayOffset(item.task.start), dayWidth / 2)
                      },
                      action: barClickEvent,
                      actionPayload: { id: item.task.id }
                    }
                  ) })
                ]
              },
              item.task.id
            )
          ),
          links.length > 0 && /* @__PURE__ */ jsxs(
            "svg",
            {
              className: "absolute pointer-events-none",
              style: { left: LABEL_WIDTH, top: 0 },
              width: chartWidth,
              height: HEADER_HEIGHT + displayItems.length * ROW_HEIGHT,
              children: [
                /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("marker", { id: "gantt-arrow", markerWidth: "8", markerHeight: "8", refX: "7", refY: "4", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L8,4 L0,8 z", fill: "var(--muted-foreground, currentColor)" }) }) }),
                links.map((link, i) => {
                  const from = barGeometry.get(link.from);
                  const to = barGeometry.get(link.to);
                  if (!from || !to) return null;
                  const midX = from.x1 + Math.max(8, (to.x0 - from.x1) / 2);
                  return /* @__PURE__ */ jsx(
                    "path",
                    {
                      d: `M ${from.x1} ${from.y} L ${midX} ${from.y} L ${midX} ${to.y} L ${to.x0} ${to.y}`,
                      fill: "none",
                      stroke: "var(--muted-foreground, currentColor)",
                      strokeWidth: 1.5,
                      markerEnd: "url(#gantt-arrow)"
                    },
                    i
                  );
                })
              ]
            }
          ),
          showToday && todayOffset !== null && /* @__PURE__ */ jsx(
            Box,
            {
              className: "absolute top-0 bottom-0 w-0.5 bg-error/70 pointer-events-none",
              style: { left: LABEL_WIDTH + todayOffset }
            }
          )
        ] })
      ] })
    }
  );
}
var DAY_MS, ROW_HEIGHT, HEADER_HEIGHT, LABEL_WIDTH, STATUS_BAR;
var init_Gantt = __esm({
  "components/core/molecules/Gantt.tsx"() {
    "use client";
    init_cn();
    init_getNestedValue();
    init_Box();
    init_Stack();
    init_Typography();
    init_LoadingState();
    init_EmptyState();
    DAY_MS = 24 * 60 * 60 * 1e3;
    ROW_HEIGHT = 36;
    HEADER_HEIGHT = 44;
    LABEL_WIDTH = 192;
    STATUS_BAR = {
      complete: "bg-success/80 hover:bg-success",
      done: "bg-success/80 hover:bg-success",
      active: "bg-primary/80 hover:bg-primary",
      "in-progress": "bg-primary/80 hover:bg-primary",
      blocked: "bg-error/80 hover:bg-error",
      error: "bg-error/80 hover:bg-error",
      "at-risk": "bg-warning/80 hover:bg-warning",
      pending: "bg-muted-foreground/50 hover:bg-muted-foreground/70"
    };
    Gantt.displayName = "Gantt";
  }
});
var RepeatableFormSection;
var init_RepeatableFormSection = __esm({
  "components/core/molecules/RepeatableFormSection.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    init_Button();
    init_Card();
    init_Icon();
    init_useEventBus();
    RepeatableFormSection = ({
      sectionType,
      title,
      items,
      renderItem,
      minItems = 0,
      maxItems = Infinity,
      allowReorder = false,
      addLabel,
      emptyMessage,
      readOnly = false,
      className,
      onAdd,
      onRemove,
      onReorder,
      trackAddedInState = false,
      currentState,
      showAuditInfo = false
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolvedAddLabel = addLabel ?? t("common.add");
      const resolvedEmptyMessage = emptyMessage ?? t("empty.noItemsAdded");
      const safeItems = items ?? [];
      const canAdd = !readOnly && safeItems.length < maxItems;
      const canRemove = !readOnly && safeItems.length > minItems;
      const handleAdd = useCallback(() => {
        onAdd?.();
        const eventPayload = {
          sectionType,
          index: safeItems.length
        };
        if (trackAddedInState && currentState) {
          eventPayload.addedInState = currentState;
          eventPayload.addedAt = (/* @__PURE__ */ new Date()).toISOString();
        }
        eventBus.emit("UI:SECTION_ADDED", eventPayload);
      }, [
        sectionType,
        safeItems.length,
        onAdd,
        eventBus,
        trackAddedInState,
        currentState
      ]);
      const handleRemove = useCallback(
        (itemId, index) => {
          onRemove?.(itemId, index);
          eventBus.emit("UI:SECTION_REMOVED", { sectionType, index, itemId });
        },
        [sectionType, onRemove, eventBus]
      );
      return /* @__PURE__ */ jsxs(VStack, { gap: "md", className: cn("w-full", className), children: [
        /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }),
            /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
              "(",
              safeItems.length,
              maxItems !== Infinity ? `/${maxItems}` : "",
              ")"
            ] })
          ] }),
          canAdd && /* @__PURE__ */ jsxs(Button, { variant: "secondary", size: "sm", onClick: handleAdd, children: [
            /* @__PURE__ */ jsx(Icon, { name: "plus", size: "sm", className: "mr-1" }),
            resolvedAddLabel
          ] })
        ] }),
        safeItems.length === 0 ? /* @__PURE__ */ jsx(Card, { className: "p-6", children: /* @__PURE__ */ jsxs(VStack, { align: "center", gap: "sm", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: resolvedEmptyMessage }),
          canAdd && /* @__PURE__ */ jsxs(Button, { variant: "primary", size: "sm", onClick: handleAdd, children: [
            /* @__PURE__ */ jsx(Icon, { name: "plus", size: "sm", className: "mr-1" }),
            resolvedAddLabel
          ] })
        ] }) }) : /* @__PURE__ */ jsx(VStack, { gap: "sm", children: safeItems.map((item, index) => /* @__PURE__ */ jsx(Card, { className: "p-4", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
          showAuditInfo && (item.addedInState || item.addedAt) && /* @__PURE__ */ jsxs(
            HStack,
            {
              justify: "between",
              align: "center",
              className: "pb-2 border-b border-border",
              children: [
                /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: item.addedInState && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
                  "Added in:",
                  " ",
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      as: "span",
                      variant: "caption",
                      weight: "semibold",
                      children: item.addedInState
                    }
                  )
                ] }) }),
                item.addedAt && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: new Date(item.addedAt).toLocaleString() })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
            allowReorder && !readOnly && /* @__PURE__ */ jsx(Box, { className: "pt-2 cursor-move text-muted-foreground hover:text-foreground", children: /* @__PURE__ */ jsx(Icon, { name: "grip-vertical", size: "md" }) }),
            /* @__PURE__ */ jsx(Box, { className: "flex-1", children: renderItem(item, index) }),
            canRemove && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => handleRemove(item.id, index),
                className: "text-error hover:text-error hover:bg-error/10",
                children: /* @__PURE__ */ jsx(Icon, { name: "trash-2", size: "sm" })
              }
            )
          ] })
        ] }) }, item.id)) }),
        safeItems.length < minItems && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "warning", children: [
          "At least ",
          minItems,
          " item",
          minItems !== 1 ? "s" : "",
          " required"
        ] })
      ] });
    };
    RepeatableFormSection.displayName = "RepeatableFormSection";
  }
});
var actionTypeLabelKeys, actionTypeIcons, ViolationAlert;
var init_ViolationAlert = __esm({
  "components/core/molecules/ViolationAlert.tsx"() {
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    init_Button();
    init_Icon();
    actionTypeLabelKeys = {
      measure: "violationAlert.actionType.measure",
      admin: "violationAlert.actionType.admin",
      penalty: "violationAlert.actionType.penalty"
    };
    actionTypeIcons = {
      measure: "alert-triangle",
      admin: "alert-circle",
      penalty: "shield-alert"
    };
    ViolationAlert = ({
      violation,
      severity,
      dismissible = false,
      onDismiss,
      onNavigateToField,
      compact = false,
      className,
      message
    }) => {
      const { t } = useTranslate();
      const fallbackMessage = message ?? t("violationAlert.fallbackMessage");
      const resolvedViolation = violation ?? {
        law: "",
        article: "",
        message: fallbackMessage,
        actionType: "measure"
      };
      const effectiveSeverity = severity ?? (resolvedViolation.actionType === "measure" ? "warning" : "error");
      const bgColor = effectiveSeverity === "warning" ? "bg-warning/10 border-warning/30" : "bg-error/10 border-error/30";
      const textColor = effectiveSeverity === "warning" ? "text-warning" : "text-error";
      const iconColor = effectiveSeverity === "warning" ? "text-warning" : "text-error";
      if (compact) {
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "px-3 py-2 rounded-container border",
              bgColor,
              className
            ),
            children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", justify: "between", children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: actionTypeIcons[resolvedViolation.actionType],
                    size: "sm",
                    className: iconColor
                  }
                ),
                /* @__PURE__ */ jsxs(
                  Typography,
                  {
                    variant: "caption",
                    className: textColor,
                    weight: "semibold",
                    children: [
                      resolvedViolation.law,
                      " Art. ",
                      resolvedViolation.article
                    ]
                  }
                ),
                /* @__PURE__ */ jsx(Typography, { variant: "caption", className: textColor, children: resolvedViolation.message })
              ] }),
              dismissible && onDismiss && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: onDismiss,
                  className: "p-1",
                  children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "sm", className: iconColor })
                }
              )
            ] })
          }
        );
      }
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "p-4 rounded-lg border",
            bgColor,
            className
          ),
          children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
            /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: actionTypeIcons[resolvedViolation.actionType],
                    size: "md",
                    className: iconColor
                  }
                ),
                /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                  /* @__PURE__ */ jsxs(Typography, { variant: "label", weight: "bold", className: textColor, children: [
                    resolvedViolation.law,
                    " Art. ",
                    resolvedViolation.article
                  ] }),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      className: cn(textColor, "opacity-75"),
                      children: t(actionTypeLabelKeys[resolvedViolation.actionType])
                    }
                  )
                ] })
              ] }),
              dismissible && onDismiss && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: onDismiss,
                  className: "p-1",
                  children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "sm", className: iconColor })
                }
              )
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: textColor, children: resolvedViolation.message }),
            (resolvedViolation.adminAction || resolvedViolation.penaltyAction) && /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "pt-2 border-t",
                  effectiveSeverity === "warning" ? "border-warning/30" : "border-error/30"
                ),
                children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                  resolvedViolation.adminAction && /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        className: cn(textColor, "opacity-75"),
                        children: t("violationAlert.adminLabel")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        weight: "semibold",
                        className: textColor,
                        children: resolvedViolation.adminAction
                      }
                    )
                  ] }),
                  resolvedViolation.penaltyAction && /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        className: cn(textColor, "opacity-75"),
                        children: t("violationAlert.penaltyLabel")
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        weight: "semibold",
                        className: textColor,
                        children: resolvedViolation.penaltyAction
                      }
                    )
                  ] })
                ] })
              }
            ),
            resolvedViolation.fieldId && onNavigateToField && /* @__PURE__ */ jsxs(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => onNavigateToField(resolvedViolation.fieldId),
                className: cn(textColor, "self-start"),
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "arrow-right", size: "sm", className: "mr-1" }),
                  t("violationAlert.goToField")
                ]
              }
            )
          ] })
        }
      );
    };
    ViolationAlert.displayName = "ViolationAlert";
  }
});
var FormSectionHeader;
var init_FormSectionHeader = __esm({
  "components/core/molecules/FormSectionHeader.tsx"() {
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    init_Icon();
    FormSectionHeader = ({
      title,
      subtitle,
      isCollapsed = false,
      onToggle,
      badge,
      badgeVariant = "default",
      icon,
      hasErrors = false,
      isComplete = false,
      className
    }) => {
      const isClickable = !!onToggle;
      const effectiveBadgeVariant = hasErrors ? "danger" : isComplete ? "success" : badgeVariant;
      const statusIcon = hasErrors ? "alert-circle" : isComplete ? "check-circle" : null;
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "px-5 py-4 bg-muted/60 rounded-lg",
            "border border-border border-l-4 border-l-primary",
            isClickable && "cursor-pointer hover:bg-muted transition-colors",
            className
          ),
          onClick: isClickable ? onToggle : void 0,
          children: /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
              icon && (typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, size: "md", className: "text-primary shrink-0" }) : /* @__PURE__ */ jsx(Icon, { icon, size: "md", className: "text-primary shrink-0" })),
              statusIcon && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: statusIcon,
                  size: "md",
                  className: cn(
                    "shrink-0",
                    hasErrors ? "text-error" : "text-success"
                  )
                }
              ),
              /* @__PURE__ */ jsxs(Box, { className: "space-y-0.5", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "subheading", weight: "semibold", className: "text-foreground", children: title }),
                subtitle && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "leading-snug", children: subtitle })
              ] })
            ] }),
            /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
              badge && /* @__PURE__ */ jsx(Badge, { variant: effectiveBadgeVariant, size: "sm", children: badge }),
              isClickable && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "chevron-down",
                  size: "sm",
                  className: cn(
                    "text-muted-foreground transition-transform duration-fast shrink-0",
                    isCollapsed && "-rotate-90"
                  )
                }
              )
            ] })
          ] })
        }
      );
    };
    FormSectionHeader.displayName = "FormSectionHeader";
  }
});
var FlipCard;
var init_FlipCard = __esm({
  "components/core/molecules/FlipCard.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_FlipContainer();
    FlipCard = ({
      front,
      back,
      flipped = false,
      onFlip,
      className,
      height = "h-64"
    }) => {
      return /* @__PURE__ */ jsxs(
        FlipContainer,
        {
          flipped,
          className: cn(height, className),
          onClick: onFlip,
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute inset-0 w-full h-full rounded-lg shadow-elevation-dialog flex items-center justify-center p-6",
                style: { backfaceVisibility: "hidden", transform: "rotateY(0deg)" },
                children: front
              }
            ),
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute inset-0 w-full h-full rounded-lg shadow-elevation-dialog flex items-center justify-center p-6",
                style: { backfaceVisibility: "hidden", transform: "rotateY(180deg)" },
                children: back
              }
            )
          ]
        }
      );
    };
    FlipCard.displayName = "FlipCard";
  }
});
var EMOJI_ITEMS, EmojiPicker;
var init_EmojiPicker = __esm({
  "components/core/molecules/EmojiPicker.tsx"() {
    "use client";
    init_useEventBus();
    init_Button();
    init_GridPicker();
    init_Popover();
    EMOJI_ITEMS = (() => {
      const items = [];
      for (const name of ordered) {
        const entry = lib[name];
        if (entry === void 0 || entry.char === null || entry.char === "") continue;
        items.push({
          id: entry.char,
          label: name.replace(/_/g, " "),
          category: entry.category.replace(/_/g, " "),
          keywords: entry.keywords
        });
      }
      return items;
    })();
    EmojiPicker = ({
      pickEvent,
      position = "top",
      triggerIcon = "smile",
      triggerLabel = "Add emoji",
      className
    }) => {
      const eventBus = useEventBus();
      const [open, setOpen] = useState(false);
      const handlePick = (glyph) => {
        if (pickEvent !== void 0) {
          const payload = { emoji: glyph };
          eventBus.emit(`UI:${pickEvent}`, payload);
        }
        setOpen(false);
      };
      return /* @__PURE__ */ jsx(
        Popover,
        {
          position,
          trigger: "click",
          showArrow: false,
          open,
          onOpenChange: setOpen,
          content: /* @__PURE__ */ jsx(
            GridPicker,
            {
              items: EMOJI_ITEMS,
              onChange: handlePick,
              searchPlaceholder: "Search emoji\u2026",
              renderThumbnail: (item) => /* @__PURE__ */ jsx("span", { className: "text-xl leading-none", "aria-hidden": "true", children: item.id }),
              cellSize: 32,
              className: "w-80"
            }
          ),
          children: /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              icon: triggerIcon,
              "aria-label": triggerLabel,
              title: triggerLabel,
              className,
              "data-testid": "emoji-picker-trigger"
            }
          )
        }
      );
    };
    EmojiPicker.displayName = "EmojiPicker";
  }
});
function toISODate(d) {
  return d.toISOString().slice(0, 10);
}
function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}
function startOfQuarter(d) {
  return new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3, 1);
}
function startOfYear(d) {
  return new Date(d.getFullYear(), 0, 1);
}
function daysAgo(n) {
  const d = /* @__PURE__ */ new Date();
  d.setDate(d.getDate() - n);
  return d;
}
function resolvePresetRange(preset) {
  if (typeof preset.range === "function") return preset.range();
  if (preset.range) return preset.range;
  return TOKEN_RANGES[preset.value]?.() ?? null;
}
var TOKEN_RANGES, DEFAULT_PRESETS, DateRangePicker;
var init_DateRangePicker = __esm({
  "components/core/molecules/DateRangePicker.tsx"() {
    "use client";
    init_cn();
    init_Button();
    init_Input();
    init_Stack();
    init_Typography();
    init_useEventBus();
    TOKEN_RANGES = {
      "7d": () => ({ from: toISODate(daysAgo(7)), to: toISODate(/* @__PURE__ */ new Date()) }),
      "30d": () => ({ from: toISODate(daysAgo(30)), to: toISODate(/* @__PURE__ */ new Date()) }),
      month: () => ({ from: toISODate(startOfMonth(/* @__PURE__ */ new Date())), to: toISODate(/* @__PURE__ */ new Date()) }),
      quarter: () => ({ from: toISODate(startOfQuarter(/* @__PURE__ */ new Date())), to: toISODate(/* @__PURE__ */ new Date()) }),
      ytd: () => ({ from: toISODate(startOfYear(/* @__PURE__ */ new Date())), to: toISODate(/* @__PURE__ */ new Date()) })
    };
    DEFAULT_PRESETS = [
      { label: "Last 7 days", value: "7d" },
      { label: "Last 30 days", value: "30d" },
      { label: "This Month", value: "month" },
      { label: "This Quarter", value: "quarter" },
      { label: "YTD", value: "ytd" }
    ];
    DateRangePicker = ({
      from: fromProp,
      to: toProp,
      event,
      onChange,
      presets = DEFAULT_PRESETS,
      fromLabel = "From",
      toLabel = "To",
      className
    }) => {
      const eventBus = useEventBus();
      const [from, setFrom] = useState(fromProp ?? "");
      const [to, setTo] = useState(toProp ?? "");
      const [activePreset, setActivePreset] = useState(null);
      const emit = useCallback(
        (range) => {
          onChange?.(range);
          if (event) eventBus.emit(`UI:${event}`, range);
        },
        [onChange, event, eventBus]
      );
      const handleFromChange = useCallback(
        (next) => {
          setFrom(next);
          setActivePreset(null);
          emit({ from: next, to });
        },
        [to, emit]
      );
      const handleToChange = useCallback(
        (next) => {
          setTo(next);
          setActivePreset(null);
          emit({ from, to: next });
        },
        [from, emit]
      );
      const handlePreset = useCallback(
        (preset) => {
          const range = resolvePresetRange(preset);
          if (range === null) return;
          setFrom(range.from);
          setTo(range.to);
          setActivePreset(preset.value);
          emit(range);
        },
        [emit]
      );
      const renderablePresets = useMemo(
        () => presets.filter((p) => p.range !== void 0 || TOKEN_RANGES[p.value] !== void 0),
        [presets]
      );
      const presetButtons = useMemo(
        () => renderablePresets.map((preset) => /* @__PURE__ */ jsx(
          Button,
          {
            variant: activePreset === preset.value ? "primary" : "ghost",
            size: "sm",
            onClick: () => handlePreset(preset),
            children: preset.label
          },
          preset.value
        )),
        [renderablePresets, activePreset, handlePreset]
      );
      return /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: cn(className), children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "end", children: [
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: fromLabel }),
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: from,
                onChange: (e) => handleFromChange(e.target.value)
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: toLabel }),
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: to,
                onChange: (e) => handleToChange(e.target.value)
              }
            )
          ] })
        ] }),
        renderablePresets.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: presetButtons })
      ] });
    };
    DateRangePicker.displayName = "DateRangePicker";
  }
});
var DEFAULT_OPTIONS, DateRangeSelector;
var init_DateRangeSelector = __esm({
  "components/core/molecules/DateRangeSelector.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    DEFAULT_OPTIONS = [
      { label: "1W", value: "week" },
      { label: "1M", value: "month" },
      { label: "3M", value: "3months" },
      { label: "1Y", value: "year" }
    ];
    DateRangeSelector = ({
      options = DEFAULT_OPTIONS,
      selected = "month",
      onSelect,
      className
    }) => {
      return /* @__PURE__ */ jsx(HStack, { gap: "xs", className: cn(className), children: options.map((option) => /* @__PURE__ */ jsx(
        Button,
        {
          variant: selected === option.value ? "primary" : "ghost",
          size: "sm",
          onClick: () => onSelect?.(option.value),
          children: option.label
        },
        option.value
      )) });
    };
    DateRangeSelector.displayName = "DateRangeSelector";
  }
});
var LineChart2;
var init_LineChart = __esm({
  "components/core/molecules/LineChart.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    LineChart2 = ({
      data,
      width = 400,
      height = 200,
      showGrid = true,
      showValues = false,
      showArea = true,
      lineColor = "var(--color-primary)",
      areaColor = "var(--color-primary)",
      className
    }) => {
      const { t } = useTranslate();
      const gradientId = useId();
      const safeData = data ?? [];
      const sortedData = useMemo(() => {
        if (safeData.length === 0) return [];
        if (!safeData.some((d) => d.date != null)) return [...safeData];
        return [...safeData].sort(
          (a, b) => new Date(a.date ?? 0).getTime() - new Date(b.date ?? 0).getTime()
        );
      }, [safeData]);
      const points = useMemo(() => {
        if (sortedData.length === 0) return [];
        const values = sortedData.map((d) => d.value);
        const minVal = Math.min(...values);
        const maxVal = Math.max(...values);
        const range = maxVal - minVal || 1;
        const padding = 20;
        const chartWidth = width - padding * 2;
        const chartHeight = height - padding * 2;
        return sortedData.map((point, index) => ({
          x: padding + index / (sortedData.length - 1 || 1) * chartWidth,
          y: padding + chartHeight - (point.value - minVal) / range * chartHeight,
          value: point.value,
          label: point.label
        }));
      }, [sortedData, width, height]);
      const linePath = useMemo(() => {
        if (points.length === 0) return "";
        return points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
      }, [points]);
      const areaPath = useMemo(() => {
        if (points.length === 0 || !showArea) return "";
        const bottom = height - 20;
        const first = points[0];
        const last = points[points.length - 1];
        return `${linePath} L ${last.x} ${bottom} L ${first.x} ${bottom} Z`;
      }, [linePath, points, height, showArea]);
      if (safeData.length === 0) {
        return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center text-muted-foreground", className), style: { width, height }, children: t("empty.noData") });
      }
      return /* @__PURE__ */ jsx(Box, { className: cn(className), children: /* @__PURE__ */ jsxs(
        "svg",
        {
          viewBox: `0 0 ${width} ${height}`,
          width: "100%",
          height: "100%",
          preserveAspectRatio: "xMidYMid meet",
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, x1: "0", y1: "0", x2: "0", y2: "1", children: [
              /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: areaColor, stopOpacity: "0.3" }),
              /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: areaColor, stopOpacity: "0" })
            ] }) }),
            showGrid && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx("line", { x1: "20", y1: height * 0.25, x2: width - 20, y2: height * 0.25, stroke: "var(--color-border, #e5e7eb)", strokeWidth: "1" }),
              /* @__PURE__ */ jsx("line", { x1: "20", y1: height * 0.5, x2: width - 20, y2: height * 0.5, stroke: "var(--color-border, #e5e7eb)", strokeWidth: "1" }),
              /* @__PURE__ */ jsx("line", { x1: "20", y1: height * 0.75, x2: width - 20, y2: height * 0.75, stroke: "var(--color-border, #e5e7eb)", strokeWidth: "1" })
            ] }),
            showArea && areaPath && /* @__PURE__ */ jsx("path", { d: areaPath, fill: `url(#${gradientId})` }),
            linePath && /* @__PURE__ */ jsx(
              "path",
              {
                d: linePath,
                fill: "none",
                stroke: lineColor,
                strokeWidth: "2",
                strokeLinejoin: "round",
                strokeLinecap: "round"
              }
            ),
            points.map((point, index) => /* @__PURE__ */ jsx(
              "circle",
              {
                cx: point.x,
                cy: point.y,
                r: "4",
                fill: lineColor,
                stroke: "var(--color-background, white)",
                strokeWidth: "2"
              },
              index
            )),
            showValues && points.map((point, index) => /* @__PURE__ */ jsx(
              "text",
              {
                x: point.x,
                y: point.y - 10,
                textAnchor: "middle",
                fontSize: "11",
                fill: "var(--color-foreground, currentColor)",
                children: point.label ?? point.value
              },
              `label-${index}`
            ))
          ]
        }
      ) });
    };
    LineChart2.displayName = "LineChart";
  }
});
var sizeMap3, stateColors, ProgressDots;
var init_ProgressDots = __esm({
  "components/core/molecules/ProgressDots.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    sizeMap3 = {
      sm: { dot: 6, active: 8 },
      md: { dot: 8, active: 10 },
      lg: { dot: 10, active: 14 }
    };
    stateColors = {
      active: "var(--color-primary)",
      complete: "var(--color-success, #22c55e)",
      pending: "var(--color-muted, #d4d4d8)"
    };
    ProgressDots = ({
      count,
      currentIndex,
      getState: getState2,
      onDotClick,
      className,
      size = "md"
    }) => {
      const defaultGetState = useCallback(
        (index) => {
          if (index === currentIndex) return "active";
          return "pending";
        },
        [currentIndex]
      );
      const resolveState = getState2 ?? defaultGetState;
      const dims = sizeMap3[size];
      return /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", className: cn(className), children: Array.from({ length: count }, (_, index) => {
        const state = resolveState(index);
        const isActive = state === "active";
        const dotSize = isActive ? dims.active : dims.dot;
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "rounded-full transition-all duration-fast",
              onDotClick && "cursor-pointer"
            ),
            style: {
              width: dotSize,
              height: dotSize,
              backgroundColor: stateColors[state],
              transform: isActive ? "scale(1.2)" : "scale(1)"
            },
            onClick: onDotClick ? () => onDotClick(index) : void 0
          },
          index
        );
      }) });
    };
    ProgressDots.displayName = "ProgressDots";
  }
});

// lib/game.ts
function createInitialGameState(width, height, units, defaultTerrain = "floorStone") {
  const board = Array.from(
    { length: height },
    () => Array.from({ length: width }, () => ({
      terrain: defaultTerrain
    }))
  );
  const unitsMap = {};
  for (const unit of units) {
    unitsMap[unit.id] = unit;
    if (unit.position.y < height && unit.position.x < width) {
      board[unit.position.y][unit.position.x].unitId = unit.id;
    }
  }
  return {
    board,
    units: unitsMap,
    currentPhase: "observation",
    currentTurn: 1,
    activeTeam: "player",
    validMoves: [],
    attackTargets: []
  };
}
function calculateValidMoves(state, unitId) {
  const unit = state.units[unitId];
  if (!unit) return [];
  const moves = [];
  const { x, y } = unit.position;
  const range = unit.movement;
  for (let dy = -range; dy <= range; dy++) {
    for (let dx = -range; dx <= range; dx++) {
      const nx = x + dx;
      const ny = y + dy;
      const distance = Math.abs(dx) + Math.abs(dy);
      if (distance > 0 && distance <= range && ny >= 0 && ny < state.board.length && nx >= 0 && nx < state.board[0].length && !state.board[ny][nx].unitId && !state.board[ny][nx].isBlocked) {
        moves.push({ x: nx, y: ny });
      }
    }
  }
  return moves;
}
function calculateAttackTargets(state, unitId) {
  const unit = state.units[unitId];
  if (!unit) return [];
  const targets = [];
  const { x, y } = unit.position;
  const directions = [
    { dx: -1, dy: 0 },
    { dx: 1, dy: 0 },
    { dx: 0, dy: -1 },
    { dx: 0, dy: 1 }
  ];
  for (const { dx, dy } of directions) {
    const nx = x + dx;
    const ny = y + dy;
    if (ny >= 0 && ny < state.board.length && nx >= 0 && nx < state.board[0].length) {
      const targetTile = state.board[ny][nx];
      if (targetTile.unitId) {
        const targetUnit = state.units[targetTile.unitId];
        if (targetUnit && targetUnit.team !== unit.team) {
          targets.push({ x: nx, y: ny });
        }
      }
    }
  }
  return targets;
}
var init_game = __esm({
  "lib/game.ts"() {
  }
});

// lib/boardEntity.ts
function boardEntity(entity) {
  if (!entity) return void 0;
  return Array.isArray(entity) ? entity[0] : entity;
}
function str(v) {
  return v == null ? "" : String(v);
}
function num(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}
function bool(v) {
  return Boolean(v);
}
function rows(v) {
  return Array.isArray(v) ? v : [];
}
function vec2(v) {
  const o = v ?? {};
  return { x: num(o.x), y: num(o.y) };
}
function unitPosition(u) {
  return vec2(u.position);
}
function unitTeam(u) {
  return str(u.team);
}
function unitHealth(u) {
  return num(u.health);
}
var init_boardEntity = __esm({
  "lib/boardEntity.ts"() {
  }
});

// lib/makeAsset.ts
function makeAsset(url, role, overrides = {}) {
  const defaults = ROLE_DEFAULTS[role] ?? { dimension: "2d", animations: ["static"], aspect: "1:1" };
  return {
    url,
    role,
    category: url.split("/").pop()?.replace(/\.[^.]+$/, "") ?? role,
    ...defaults,
    ...overrides
  };
}
function makeAssetMap(record, role, overrides = {}) {
  const result = {};
  for (const [key, url] of Object.entries(record)) {
    result[key] = makeAsset(url, role, overrides);
  }
  return result;
}
var ROLE_DEFAULTS;
var init_makeAsset = __esm({
  "lib/makeAsset.ts"() {
    ROLE_DEFAULTS = {
      tile: { dimension: "2d", animations: ["static"], aspect: "1:1" },
      decoration: { dimension: "2d", animations: ["static"], aspect: "1:1" },
      effect: { dimension: "2d", animations: ["static"], aspect: "1:1" },
      item: { dimension: "2d", animations: ["static"], aspect: "5:7" },
      player: { dimension: "2d", animations: ["idle", "walk", "attack", "hit", "death"], aspect: "1:1" },
      enemy: { dimension: "2d", animations: ["idle", "walk", "attack", "hit", "death"], aspect: "1:1" },
      npc: { dimension: "2d", animations: ["idle", "walk", "attack", "hit", "death"], aspect: "1:1" },
      projectile: { dimension: "2d", animations: ["static"], aspect: "1:1" },
      vehicle: { dimension: "2d", animations: ["idle", "walk"], aspect: "1:1" },
      ui: { dimension: "2d", animations: ["static"], aspect: "1:1" }
    };
  }
});

// lib/gameShared.ts
var init_gameShared = __esm({
  "lib/gameShared.ts"() {
    init_game();
    init_boardEntity();
    init_makeAsset();
    init_useImageCache();
    init_isometric();
    init_spriteAnimation();
    init_spriteSheetConstants();
  }
});
function HealthBar({
  current = 3,
  max = 5,
  format = "hearts",
  level,
  showLabel = true,
  labelSuffix,
  size = "md",
  className,
  animated = true,
  frameAsset,
  fillAsset
}) {
  const sizes = sizeMap4[size];
  const percentage = max > 0 ? Math.max(0, Math.min(100, current / max * 100)) : 0;
  if (format === "hearts") {
    return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center gap-1", className), children: Array.from({ length: max }).map((_, i) => /* @__PURE__ */ jsx(
      Box,
      {
        as: "span",
        className: cn(animated && "transition-transform hover:scale-110"),
        children: heartIcon(i < current, sizes.heart)
      },
      i
    )) });
  }
  if (format === "bar") {
    return /* @__PURE__ */ jsx(
      Box,
      {
        position: "relative",
        overflow: "hidden",
        className: cn(
          "rounded-full",
          !frameAsset && "bg-muted",
          sizes.bar,
          "w-24",
          className
        ),
        style: frameAsset ? { backgroundImage: `url(${frameAsset.url})`, backgroundSize: "100% 100%" } : void 0,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: cn(
              "inset-y-0 left-0 rounded-full",
              !fillAsset && (percentage > 66 ? "bg-success" : percentage > 33 ? "bg-warning" : "bg-error"),
              animated && "transition-all duration-300"
            ),
            style: {
              width: `${percentage}%`,
              ...fillAsset ? { backgroundImage: `url(${fillAsset.url})`, backgroundSize: "auto 100%" } : {}
            }
          }
        )
      }
    );
  }
  if (format === "progress") {
    return /* @__PURE__ */ jsxs(Box, { className: cn("flex items-center gap-2", className), children: [
      level != null && /* @__PURE__ */ jsxs(
        Typography,
        {
          as: "span",
          className: cn(
            "flex-shrink-0 rounded-interactive font-bold",
            "bg-accent text-accent-foreground border border-accent",
            sizes.badge
          ),
          children: [
            "Lv.",
            level
          ]
        }
      ),
      /* @__PURE__ */ jsxs(Box, { className: "flex-1 flex flex-col gap-0.5", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            position: "relative",
            className: cn(
              "w-full overflow-hidden rounded-full",
              !frameAsset && "bg-muted border border-muted",
              sizes.bar
            ),
            style: frameAsset ? { backgroundImage: `url(${frameAsset.url})`, backgroundSize: "100% 100%" } : void 0,
            children: /* @__PURE__ */ jsx(
              Box,
              {
                position: "absolute",
                className: cn(
                  "inset-y-0 left-0 rounded-full",
                  !fillAsset && "bg-gradient-to-r from-accent to-info",
                  animated && "transition-all duration-500 ease-out"
                ),
                style: {
                  width: `${percentage}%`,
                  ...fillAsset ? { backgroundImage: `url(${fillAsset.url})`, backgroundSize: "auto 100%" } : {}
                }
              }
            )
          }
        ),
        showLabel && /* @__PURE__ */ jsxs(Typography, { as: "span", className: cn("text-foreground/70 tabular-nums", sizes.label), children: [
          current,
          " / ",
          max,
          labelSuffix ? ` ${labelSuffix}` : ""
        ] })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs(Typography, { as: "span", className: cn("font-mono font-bold", sizes.text, className), children: [
    current,
    "/",
    max
  ] });
}
var heartIcon, sizeMap4;
var init_HealthBar = __esm({
  "components/game/atoms/HealthBar.tsx"() {
    init_cn();
    init_Box();
    init_Typography();
    heartIcon = (filled, size) => /* @__PURE__ */ jsx(
      "svg",
      {
        className: cn("transition-all duration-200", size, filled ? "text-error" : "text-muted-foreground"),
        viewBox: "0 0 24 24",
        fill: filled ? "currentColor" : "none",
        stroke: "currentColor",
        strokeWidth: filled ? 0 : 2,
        children: /* @__PURE__ */ jsx("path", { d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" })
      }
    );
    sizeMap4 = {
      sm: { heart: "w-4 h-4", bar: "h-2", text: "text-sm", label: "text-xs", badge: "text-xs px-1.5 py-0.5" },
      md: { heart: "w-6 h-6", bar: "h-3", text: "text-base", label: "text-xs", badge: "text-xs px-2 py-0.5" },
      lg: { heart: "w-8 h-8", bar: "h-4", text: "text-lg", label: "text-sm", badge: "text-sm px-2.5 py-1" }
    };
    HealthBar.displayName = "HealthBar";
  }
});
function ScoreDisplay({
  assetUrl,
  value,
  score,
  label,
  icon,
  size = "md",
  className,
  locale = "en-US"
}) {
  const resolvedValue = typeof value === "number" && !Number.isNaN(value) ? value : typeof score === "number" && !Number.isNaN(score) ? score : 0;
  const formattedValue = new Intl.NumberFormat(locale).format(resolvedValue);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "flex items-center gap-2 font-bold",
        sizeMap5[size],
        className
      ),
      children: [
        assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 20, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "flex-shrink-0", children: typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon }) : /* @__PURE__ */ jsx(Icon, { icon }) }) : null,
        label && /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-muted-foreground", children: label }),
        /* @__PURE__ */ jsx(Typography, { as: "span", className: "tabular-nums", children: formattedValue })
      ]
    }
  );
}
var sizeMap5;
var init_ScoreDisplay = __esm({
  "components/game/atoms/ScoreDisplay.tsx"() {
    init_cn();
    init_Icon();
    init_Box();
    init_Typography();
    init_GameIcon();
    sizeMap5 = {
      sm: "text-sm",
      md: "text-lg",
      lg: "text-2xl",
      xl: "text-4xl"
    };
    ScoreDisplay.displayName = "ScoreDisplay";
  }
});
function formatTime2(seconds, format) {
  const clamped = Math.max(0, Math.floor(seconds));
  if (format === "ss") {
    return `${clamped}s`;
  }
  const mins = Math.floor(clamped / 60);
  const secs = clamped % 60;
  const padded = secs.toString().padStart(2, "0");
  if (format === "countdown") {
    return mins > 0 ? `${mins}:${padded}` : `${secs}`;
  }
  return `${mins.toString().padStart(2, "0")}:${padded}`;
}
function TimerDisplay({
  seconds = 90,
  running = true,
  format = "mm:ss",
  size = "md",
  className,
  lowThreshold,
  iconAsset
}) {
  const isLow = lowThreshold != null && seconds <= lowThreshold && seconds > 0;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "inline-flex items-center gap-1 justify-center rounded-container",
        "bg-card/80 border border-muted font-mono font-bold tabular-nums",
        sizeMap6[size],
        running && "border-success/50",
        isLow && "text-error border-error/50 animate-pulse",
        !isLow && "text-foreground",
        className
      ),
      children: [
        iconAsset && /* @__PURE__ */ jsx(GameIcon, { assetUrl: iconAsset, icon: "image", size: 16, className: "w-4 h-4 object-contain flex-shrink-0" }),
        formatTime2(seconds, format)
      ]
    }
  );
}
var sizeMap6;
var init_TimerDisplay = __esm({
  "components/game/atoms/TimerDisplay.tsx"() {
    init_cn();
    init_Box();
    init_GameIcon();
    sizeMap6 = {
      sm: "text-sm px-2 py-0.5",
      md: "text-lg px-3 py-1",
      lg: "text-2xl px-4 py-1.5"
    };
    TimerDisplay.displayName = "TimerDisplay";
  }
});
function DialogueBubble({
  speaker = "Hero",
  text = "The dungeon awaits. Choose your path wisely.",
  portrait = DEFAULT_PORTRAIT,
  position = "bottom",
  mood = "neutral",
  revealedChars,
  className
}) {
  const visibleText = revealedChars === void 0 ? text : text.slice(0, revealedChars);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "flex items-start gap-3 rounded-container bg-background/80 backdrop-blur-sm px-4 py-3 border border-border/10",
        position === "top" ? "rounded-bl-none" : "rounded-tl-none",
        className
      ),
      children: [
        portrait && /* @__PURE__ */ jsx(Box, { className: cn("flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border-2 transition-colors duration-300", MOOD_RING_CLASS[mood]), children: /* @__PURE__ */ jsx(GameIcon, { assetUrl: portrait, icon: "image", size: 48, alt: speaker ?? "speaker", className: "w-full h-full object-cover" }) }),
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1 min-w-0", children: [
          speaker && /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-sm font-bold text-warning", children: speaker }),
          /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-sm text-foreground leading-relaxed", children: visibleText })
        ] })
      ]
    }
  );
}
var DEFAULT_PORTRAIT, MOOD_RING_CLASS;
var init_DialogueBubble = __esm({
  "components/game/atoms/DialogueBubble.tsx"() {
    init_cn();
    init_Box();
    init_Typography();
    init_GameIcon();
    DEFAULT_PORTRAIT = {
      url: "https://almadar-kflow-assets.web.app/shared/ui-winter-ski-board/default/units/hero/hero.png",
      role: "effect",
      category: "character"
    };
    MOOD_RING_CLASS = {
      neutral: "border-warning/60",
      happy: "border-success/70",
      concerned: "border-info/70",
      angry: "border-error/70"
    };
    DialogueBubble.displayName = "DialogueBubble";
  }
});
function StatBadge({
  assetUrl,
  iconUrl,
  label,
  value,
  max,
  format = "number",
  icon,
  size = "md",
  variant = "default",
  className,
  // Ignored config props (used for schema binding)
  source: _source,
  field: _field
}) {
  const hasValue = value !== void 0 && value !== null;
  const numValue = typeof value === "number" ? value : parseInt(String(value), 10) || 0;
  const resolvedAsset = iconUrl ?? assetUrl;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "inline-flex items-center gap-2 rounded-container border backdrop-blur-sm",
        sizeMap7[size] ?? sizeMap7.md,
        variantMap2[variant] ?? variantMap2.default,
        className
      ),
      children: [
        resolvedAsset ? /* @__PURE__ */ jsx(GameIcon, { assetUrl: resolvedAsset, icon: "image", size: 16, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "flex-shrink-0 text-lg", children: typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: "w-4 h-4" }) : /* @__PURE__ */ jsx(Icon, { icon, className: "w-4 h-4" }) }) : null,
        /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-muted-foreground font-medium text-xs", children: label }),
        hasValue && format === "hearts" && max && /* @__PURE__ */ jsx(
          HealthBar,
          {
            current: numValue,
            max,
            format: "hearts",
            size: size === "lg" ? "md" : "sm"
          }
        ),
        hasValue && format === "bar" && max && /* @__PURE__ */ jsx(
          HealthBar,
          {
            current: numValue,
            max,
            format: "bar",
            size: size === "lg" ? "md" : "sm"
          }
        ),
        hasValue && format === "number" && /* @__PURE__ */ jsx(
          ScoreDisplay,
          {
            value: numValue,
            size: size === "lg" ? "md" : "sm",
            className: "font-display"
          }
        ),
        hasValue && format === "text" && /* @__PURE__ */ jsx(Typography, { as: "span", className: "font-bold text-foreground", children: value })
      ]
    }
  );
}
var sizeMap7, variantMap2;
var init_StatBadge = __esm({
  "components/game/molecules/StatBadge.tsx"() {
    init_cn();
    init_Icon();
    init_Box();
    init_Typography();
    init_GameIcon();
    init_HealthBar();
    init_ScoreDisplay();
    sizeMap7 = {
      xs: "text-xs px-1.5 py-0.5",
      sm: "text-xs px-2 py-1",
      md: "text-sm px-3 py-1.5",
      lg: "text-base px-4 py-2"
    };
    variantMap2 = {
      default: "bg-card/80 border-border text-foreground",
      primary: "bg-primary/15 border-primary/40 text-foreground",
      success: "bg-success/15 border-success/40 text-foreground",
      warning: "bg-warning/15 border-warning/40 text-foreground",
      danger: "bg-error/15 border-error/40 text-foreground"
    };
    StatBadge.displayName = "StatBadge";
  }
});
function convertElementsToStats(elements) {
  return elements.map((el) => {
    const [source, field] = el.bind?.split(".") ?? [];
    const labelMap = {
      "health-bar": "Health",
      "score-display": "Score",
      lives: "Lives",
      timer: "Time"
    };
    return {
      label: el.label || labelMap[el.type ?? ""] || el.type || "",
      source,
      field,
      // Pass through direct values from compiled render-ui effects
      ...el.value !== void 0 && { value: el.value },
      ...el.icon !== void 0 && { icon: el.icon },
      ...el.assetUrl !== void 0 && { assetUrl: el.assetUrl },
      ...el.format !== void 0 && { format: el.format },
      ...el.max !== void 0 && { max: el.max }
    };
  });
}
function GameHud({
  position: propPosition,
  stats: propStats,
  items,
  elements,
  size = "md",
  variant = "floating",
  className,
  transparent = true
}) {
  const rawStats = propStats ?? items ?? (elements && Array.isArray(elements) ? convertElementsToStats(elements) : DEFAULT_HUD_STATS);
  const stats = Array.isArray(rawStats) ? rawStats : [];
  const position = propPosition ?? "top";
  if (position === "corners") {
    const leftStats = stats.slice(0, Math.ceil(stats.length / 2));
    const rightStats = stats.slice(Math.ceil(stats.length / 2));
    return /* @__PURE__ */ jsxs(Box, { position: "relative", className: cn(positionMap[position], className), children: [
      /* @__PURE__ */ jsx(Box, { position: "absolute", className: "top-4 left-4 flex flex-col gap-2 pointer-events-auto", children: leftStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size }, i)) }),
      /* @__PURE__ */ jsx(Box, { position: "absolute", className: "top-4 right-4 flex flex-col gap-2 items-end pointer-events-auto", children: rightStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size }, i)) })
    ] });
  }
  if ((position === "top" || position === "bottom") && variant === "bar") {
    const mid = Math.ceil(stats.length / 2);
    const leftStats = stats.slice(0, mid);
    const rightStats = stats.slice(mid);
    return /* @__PURE__ */ jsxs(
      Card,
      {
        variant: "bordered",
        padding: "none",
        className: cn(
          "flex items-center justify-between w-full rounded-none bg-card",
          "px-4 py-2 gap-4",
          transparent && "backdrop-blur-sm",
          className
        ),
        style: transparent ? { backgroundColor: "color-mix(in srgb, var(--color-card) 40%, transparent)" } : void 0,
        children: [
          /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-3 flex-shrink-0", children: leftStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size }, i)) }),
          rightStats.length > 0 && /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-3 flex-shrink-0", children: rightStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size }, i)) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Card,
    {
      variant: "bordered",
      padding: "sm",
      className: cn(
        "z-10 relative flex items-center gap-4 bg-card",
        transparent && "backdrop-blur-sm",
        className
      ),
      style: transparent ? { backgroundColor: "color-mix(in srgb, var(--color-card) 30%, transparent)" } : void 0,
      children: stats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size }, i))
    }
  );
}
var positionMap, DEFAULT_HUD_STATS;
var init_GameHud = __esm({
  "components/game/molecules/GameHud.tsx"() {
    init_cn();
    init_Box();
    init_Card();
    init_StatBadge();
    positionMap = {
      corners: "inset-0 pointer-events-none"
    };
    DEFAULT_HUD_STATS = [
      { label: "HP", value: 75, max: 100, format: "bar", variant: "danger" },
      { label: "MP", value: 40, max: 60, format: "bar", variant: "primary" },
      { label: "Score", value: 4200, format: "number", variant: "warning" },
      { label: "Level", value: 4, format: "number", variant: "default" }
    ];
    GameHud.displayName = "GameHud";
  }
});
function GameMenu({
  title = "Epic Quest",
  subtitle,
  options,
  menuItems,
  onSelect,
  background,
  logo,
  className
}) {
  const resolvedOptions = (options?.length ? options : void 0) ?? (menuItems?.length ? menuItems : void 0) ?? DEFAULT_MENU_OPTIONS;
  const eventBus = useEventBus();
  const handleOptionClick = React79.useCallback(
    (option) => {
      if (option.event) {
        eventBus.emit(`UI:${option.event}`, { option });
      }
      if (onSelect) {
        onSelect(option);
      }
      if (option.navigatesTo) {
        eventBus.emit("UI:NAVIGATE", { url: option.navigatesTo, option });
      }
    },
    [eventBus, onSelect]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "min-h-screen w-full flex flex-col items-center justify-center p-8",
        !background && "bg-background",
        className
      ),
      style: background ? { background } : void 0,
      children: [
        /* @__PURE__ */ jsxs(
          Card,
          {
            variant: "bordered",
            padding: "lg",
            className: "bg-card flex flex-col items-center max-w-md w-full",
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "text-center mb-8 animate-fade-in", children: [
                logo && /* @__PURE__ */ jsx(GameIcon, { assetUrl: logo, icon: "image", size: 96, alt: title, className: "h-24 w-auto mx-auto mb-6 drop-shadow-2xl" }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "h1",
                    className: "text-4xl md:text-5xl font-bold text-foreground tracking-tight",
                    style: {
                      textShadow: "0 4px 12px rgba(0,0,0,0.5)"
                    },
                    children: title
                  }
                ),
                subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body", className: "mt-2 text-lg text-muted-foreground tracking-widest uppercase", children: subtitle })
              ] }),
              /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-4 w-full", children: resolvedOptions.map((option, index) => /* @__PURE__ */ jsx(
                ChoiceButton,
                {
                  text: option.label,
                  index: index + 1,
                  disabled: option.disabled,
                  onClick: () => handleOptionClick(option),
                  className: "text-lg py-4 px-8"
                },
                index
              )) })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { position: "absolute", className: "inset-0 pointer-events-none overflow-hidden -z-10", children: [
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "top-1/4 left-1/4 w-64 h-64 bg-info/10 rounded-container blur-3xl" }),
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-container blur-3xl" })
        ] })
      ]
    }
  );
}
var DEFAULT_MENU_OPTIONS;
var init_GameMenu = __esm({
  "components/game/molecules/GameMenu.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_Card();
    init_Typography();
    init_GameIcon();
    init_ChoiceButton();
    DEFAULT_MENU_OPTIONS = [
      { label: "New Game", event: "NEW_GAME", variant: "primary" },
      { label: "Continue", event: "CONTINUE", variant: "secondary" },
      { label: "Settings", event: "SETTINGS", variant: "ghost" }
    ];
    GameMenu.displayName = "GameMenu";
  }
});
function StateNode2({
  name,
  isCurrent = false,
  isSelected = false,
  isInitial = false,
  position,
  onClick,
  className
}) {
  return /* @__PURE__ */ jsx(
    Box,
    {
      position: "absolute",
      display: "flex",
      className: cn(
        "items-center justify-center rounded-pill border-3 transition-all cursor-pointer select-none",
        "min-w-[80px] h-[80px] px-3",
        isCurrent && "bg-primary/20 border-primary shadow-lg shadow-primary/30 scale-110",
        isSelected && !isCurrent && "bg-accent/20 border-accent ring-2 ring-accent/50",
        !isCurrent && !isSelected && "bg-card border-border hover:border-muted-foreground hover:scale-105",
        className
      ),
      style: {
        left: position.x,
        top: position.y,
        transform: "translate(-50%, -50%)"
      },
      onClick,
      children: /* @__PURE__ */ jsxs(Box, { className: "text-center", children: [
        isInitial && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground text-xs block", children: "\u25B6 start" }),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "body2",
            className: cn(
              "font-bold whitespace-nowrap",
              isCurrent ? "text-primary" : "text-foreground"
            ),
            children: name
          }
        )
      ] })
    }
  );
}
var init_StateNode = __esm({
  "components/game/molecules/StateNode.tsx"() {
    init_atoms();
    init_cn();
    StateNode2.displayName = "StateNode";
  }
});
function TransitionArrow({
  from,
  to,
  eventLabel,
  guardHint,
  isActive = false,
  onClick,
  className
}) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist === 0) return /* @__PURE__ */ jsx(Fragment, {});
  const nx = dx / dist;
  const ny = dy / dist;
  const startX = from.x + nx * NODE_RADIUS;
  const startY = from.y + ny * NODE_RADIUS;
  const endX = to.x - nx * NODE_RADIUS;
  const endY = to.y - ny * NODE_RADIUS;
  const midX = (startX + endX) / 2;
  const midY = (startY + endY) / 2;
  const perpX = -ny * 20;
  const perpY = nx * 20;
  const ctrlX = midX + perpX;
  const ctrlY = midY + perpY;
  const path = `M ${startX} ${startY} Q ${ctrlX} ${ctrlY} ${endX} ${endY}`;
  return /* @__PURE__ */ jsxs("g", { className: cn("cursor-pointer", className), onClick, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: path,
        fill: "none",
        stroke: isActive ? "var(--color-primary)" : "var(--color-border)",
        strokeWidth: isActive ? 3 : 2,
        markerEnd: isActive ? "url(#arrowhead-active)" : "url(#arrowhead)"
      }
    ),
    /* @__PURE__ */ jsx(
      "text",
      {
        x: ctrlX,
        y: ctrlY - 8,
        textAnchor: "middle",
        fill: isActive ? "var(--color-primary)" : "var(--color-foreground)",
        fontSize: 12,
        fontWeight: isActive ? "bold" : "normal",
        className: "select-none",
        children: eventLabel
      }
    ),
    guardHint && /* @__PURE__ */ jsx(
      "text",
      {
        x: ctrlX,
        y: ctrlY + 6,
        textAnchor: "middle",
        fill: "var(--color-warning)",
        fontSize: 10,
        className: "select-none",
        children: "\u26A0 " + guardHint
      }
    )
  ] });
}
var NODE_RADIUS;
var init_TransitionArrow = __esm({
  "components/game/molecules/TransitionArrow.tsx"() {
    init_cn();
    NODE_RADIUS = 40;
    TransitionArrow.displayName = "TransitionArrow";
  }
});
function layoutStates(states, width, height) {
  const cx = width / 2;
  const cy = height / 2;
  const radius = Math.min(cx, cy) - 60;
  const positions = {};
  states.forEach((state, i) => {
    const angle = 2 * Math.PI * i / Math.max(states.length, 1) - Math.PI / 2;
    positions[state] = { x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) };
  });
  return positions;
}
function StateGraph({
  states,
  transitions = [],
  currentState,
  selectedState,
  addingFrom,
  initialState,
  width = 500,
  height = 400,
  nodeClickEvent,
  className
}) {
  const eventBus = useEventBus();
  const nodes = states ?? [];
  const positions = React79.useMemo(() => layoutStates(nodes, width, height), [nodes, width, height]);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      position: "relative",
      className: cn("rounded-container border border-border bg-background overflow-hidden", className),
      style: { width, height },
      children: [
        /* @__PURE__ */ jsxs("svg", { width, height, className: "absolute inset-0", style: { pointerEvents: "none" }, children: [
          /* @__PURE__ */ jsxs("defs", { children: [
            /* @__PURE__ */ jsx("marker", { id: "arrowhead", markerWidth: "10", markerHeight: "7", refX: "10", refY: "3.5", orient: "auto", children: /* @__PURE__ */ jsx("polygon", { points: "0 0, 10 3.5, 0 7", fill: "var(--color-border)" }) }),
            /* @__PURE__ */ jsx("marker", { id: "arrowhead-active", markerWidth: "10", markerHeight: "7", refX: "10", refY: "3.5", orient: "auto", children: /* @__PURE__ */ jsx("polygon", { points: "0 0, 10 3.5, 0 7", fill: "var(--color-primary)" }) })
          ] }),
          transitions.map((tr, i) => {
            const fromPos = positions[tr.from];
            const toPos = positions[tr.to];
            if (!fromPos || !toPos) return null;
            return /* @__PURE__ */ jsx(
              TransitionArrow,
              {
                from: fromPos,
                to: toPos,
                eventLabel: tr.event,
                guardHint: tr.guardHint,
                isActive: tr.from === currentState
              },
              `${tr.from}-${tr.event}-${tr.to}-${i}`
            );
          })
        ] }),
        nodes.map((state) => {
          const pos = positions[state];
          if (!pos) return null;
          return /* @__PURE__ */ jsx(
            StateNode2,
            {
              name: state,
              position: pos,
              isCurrent: state === currentState,
              isSelected: state === selectedState || state === addingFrom,
              isInitial: state === initialState,
              onClick: nodeClickEvent ? () => eventBus.emit(`UI:${nodeClickEvent}`, { stateId: state }) : void 0
            },
            state
          );
        })
      ]
    }
  );
}
var init_StateGraph = __esm({
  "components/game/molecules/StateGraph.tsx"() {
    init_atoms();
    init_cn();
    init_useEventBus();
    init_StateNode();
    init_TransitionArrow();
  }
});
function unitAtlasUrl(unit) {
  return unit.spriteSheet?.url ?? null;
}
function resolveSheetUrl(atlasUrl, relativeSheetPath) {
  try {
    return new URL(relativeSheetPath, atlasUrl).toString();
  } catch {
    const base = atlasUrl.slice(0, atlasUrl.lastIndexOf("/") + 1);
    return `${base}${relativeSheetPath.replace(/^\.\//, "")}`;
  }
}
function useUnitSpriteAtlas(units) {
  const atlasCacheRef = useRef(/* @__PURE__ */ new Map());
  const loadingRef = useRef(/* @__PURE__ */ new Set());
  const [pendingCount, setPendingCount] = useState(0);
  const [, forceTick] = useState(0);
  const atlasUrls = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const unit of units) {
      const url = unitAtlasUrl(unit);
      if (url) set.add(url);
    }
    return [...set];
  }, [units]);
  useEffect(() => {
    const cache2 = atlasCacheRef.current;
    const loading = loadingRef.current;
    const toLoad = atlasUrls.filter((url) => !cache2.has(url) && !loading.has(url));
    if (toLoad.length === 0) return;
    let cancelled = false;
    setPendingCount((prev) => prev + toLoad.length);
    for (const url of toLoad) {
      loading.add(url);
      fetch(url).then((res) => res.ok ? res.json() : Promise.reject(new Error(String(res.status)))).then((atlas) => {
        if (cancelled) return;
        cache2.set(url, atlas);
      }).catch(() => {
      }).finally(() => {
        if (cancelled) return;
        loading.delete(url);
        setPendingCount((prev) => Math.max(0, prev - 1));
        forceTick((n) => n + 1);
      });
    }
    return () => {
      cancelled = true;
    };
  }, [atlasUrls]);
  const sheetUrls = useMemo(() => {
    const urls = /* @__PURE__ */ new Set();
    for (const unit of units) {
      const atlasUrl = unitAtlasUrl(unit);
      if (!atlasUrl) continue;
      const atlas = atlasCacheRef.current.get(atlasUrl);
      if (!atlas) continue;
      for (const rel of Object.values(atlas.sheets)) {
        if (rel) urls.add(resolveSheetUrl(atlasUrl, rel));
      }
    }
    return [...urls];
  }, [units, pendingCount]);
  const resolveUnitFrame = useCallback((unitId) => {
    const unit = units.find((u) => u.id === unitId);
    if (!unit) return null;
    const atlasUrl = unitAtlasUrl(unit);
    if (!atlasUrl) return null;
    const atlas = atlasCacheRef.current.get(atlasUrl);
    if (!atlas) return null;
    const animation = unit.animation ?? "idle";
    const frame = unit.frame ?? 0;
    const def = atlas.animations[animation] ?? atlas.animations.idle;
    if (!def) return null;
    const { sheetDir, flipX } = resolveSheetDirection("se");
    const rel = atlas.sheets[sheetDir] ?? atlas.sheets.se ?? atlas.sheets.sw;
    if (!rel) return null;
    const sheetUrl = resolveSheetUrl(atlasUrl, rel);
    const rect = frameRect(frame, def.row, atlas.columns, atlas.frameWidth, atlas.frameHeight);
    return {
      sheetUrl,
      sx: rect.sx,
      sy: rect.sy,
      sw: rect.sw,
      sh: rect.sh,
      flipX,
      applyBreathing: animation === "idle"
    };
  }, [units]);
  return { sheetUrls, resolveUnitFrame, pendingCount };
}
var init_useUnitSpriteAtlas = __esm({
  "hooks/useUnitSpriteAtlas.ts"() {
    "use client";
    init_spriteAnimation();
  }
});
function GameAudioToggle({
  size = "sm",
  className,
  onAsset,
  offAsset,
  toggleEvent
}) {
  const ctx = useGameAudioContextOptional();
  const [localMuted, setLocalMuted] = useState(false);
  const muted = ctx ? ctx.muted : localMuted;
  const setMuted = ctx ? ctx.setMuted : setLocalMuted;
  const eventBus = useEventBus();
  const handleToggle = useCallback(() => {
    const next = !muted;
    setMuted(next);
    if (toggleEvent) eventBus.emit(`UI:${toggleEvent}`, { muted: next });
  }, [muted, setMuted, toggleEvent, eventBus]);
  const activeAsset = muted ? offAsset : onAsset;
  return /* @__PURE__ */ jsx(
    Button,
    {
      variant: "ghost",
      size,
      onClick: handleToggle,
      className: cn("text-lg leading-none px-2", className),
      "aria-pressed": muted,
      children: activeAsset ? /* @__PURE__ */ jsx(GameIcon, { assetUrl: activeAsset, icon: "image", size: 20, alt: muted ? "Muted" : "Sound on", className: "w-5 h-5 object-contain" }) : muted ? "\u{1F507}" : "\u{1F50A}"
    }
  );
}
var init_GameAudioToggle = __esm({
  "components/game/atoms/GameAudioToggle.tsx"() {
    "use client";
    init_atoms();
    init_cn();
    init_useEventBus();
    init_GameIcon();
    GameAudioToggle.displayName = "GameAudioToggle";
  }
});
function pickPath(entry) {
  if (Array.isArray(entry.path)) {
    return entry.path[Math.floor(Math.random() * entry.path.length)];
  }
  return entry.path;
}
function useGameAudio({
  manifest,
  baseUrl = "",
  initialMuted = false,
  initialVolume = 1
}) {
  const [muted, setMutedState] = useState(initialMuted);
  const [masterVolume, setMasterVolumeState] = useState(initialVolume);
  const mutedRef = useRef(muted);
  const volumeRef = useRef(masterVolume);
  const manifestRef = useRef(manifest);
  mutedRef.current = muted;
  volumeRef.current = masterVolume;
  manifestRef.current = manifest;
  const poolsRef = useRef(/* @__PURE__ */ new Map());
  const getOrCreateElement = useCallback((key) => {
    const entry = manifestRef.current[key];
    if (!entry) return null;
    let pool = poolsRef.current.get(key);
    if (!pool) {
      pool = [];
      poolsRef.current.set(key, pool);
    }
    const maxSize = entry.poolSize ?? 1;
    for (const audio of pool) {
      if (audio.paused && (audio.ended || audio.currentTime === 0)) {
        return audio;
      }
    }
    if (pool.length < maxSize) {
      const src = baseUrl + pickPath(entry);
      const audio = new Audio(src);
      audio.loop = entry.loop ?? false;
      pool.push(audio);
      return audio;
    }
    if (!entry.loop) {
      let oldest = pool[0];
      for (const audio of pool) {
        if (audio.currentTime > oldest.currentTime) {
          oldest = audio;
        }
      }
      oldest.pause();
      oldest.currentTime = 0;
      return oldest;
    }
    return null;
  }, [baseUrl]);
  const play = useCallback((key) => {
    if (mutedRef.current) return;
    const entry = manifestRef.current[key];
    if (!entry) return;
    const audio = getOrCreateElement(key);
    if (!audio) return;
    audio.volume = Math.min(1, (entry.volume ?? 1) * volumeRef.current);
    if (!entry.loop) {
      audio.currentTime = 0;
    }
    const promise = audio.play();
    if (promise) {
      promise.catch(() => {
      });
    }
  }, [getOrCreateElement]);
  const stop = useCallback((key) => {
    const pool = poolsRef.current.get(key);
    if (!pool) return;
    for (const audio of pool) {
      audio.pause();
      audio.currentTime = 0;
    }
  }, []);
  const currentMusicKeyRef = useRef(null);
  const currentMusicElRef = useRef(null);
  const musicFadeRef = useRef(null);
  const pendingMusicKeyRef = useRef(null);
  const clearMusicFade = useCallback(() => {
    if (musicFadeRef.current) {
      clearInterval(musicFadeRef.current);
      musicFadeRef.current = null;
    }
  }, []);
  const playMusic = useCallback((key) => {
    if (key === currentMusicKeyRef.current) return;
    pendingMusicKeyRef.current = key;
    const entry = manifestRef.current[key];
    if (!entry) return;
    const fadeDurationMs = entry.crossfadeDurationMs ?? 1500;
    const stepMs = 50;
    const totalSteps = Math.max(1, fadeDurationMs / stepMs);
    const targetVolume = Math.min(1, (entry.volume ?? 1) * volumeRef.current);
    clearMusicFade();
    const src = baseUrl + (Array.isArray(entry.path) ? entry.path[0] : entry.path);
    const incoming = new Audio(src);
    incoming.loop = true;
    incoming.volume = 0;
    const outgoing = currentMusicElRef.current;
    const outgoingStartVol = outgoing?.volume ?? 0;
    currentMusicKeyRef.current = key;
    currentMusicElRef.current = incoming;
    if (!mutedRef.current) {
      incoming.play().catch(() => {
        currentMusicKeyRef.current = null;
        currentMusicElRef.current = outgoing;
      });
    }
    let step = 0;
    musicFadeRef.current = setInterval(() => {
      step++;
      const progress = Math.min(step / totalSteps, 1);
      incoming.volume = Math.min(1, targetVolume * progress);
      if (outgoing) {
        outgoing.volume = Math.max(0, outgoingStartVol * (1 - progress));
      }
      if (progress >= 1) {
        clearMusicFade();
        if (outgoing) {
          outgoing.pause();
          outgoing.src = "";
        }
      }
    }, stepMs);
  }, [baseUrl, clearMusicFade]);
  const stopMusic = useCallback((fadeDurationMs = 1e3) => {
    const outgoing = currentMusicElRef.current;
    if (!outgoing) return;
    currentMusicKeyRef.current = null;
    currentMusicElRef.current = null;
    pendingMusicKeyRef.current = null;
    clearMusicFade();
    const startVolume = outgoing.volume;
    const stepMs = 50;
    const totalSteps = Math.max(1, fadeDurationMs / stepMs);
    let step = 0;
    musicFadeRef.current = setInterval(() => {
      step++;
      const progress = step / totalSteps;
      outgoing.volume = Math.max(0, startVolume * (1 - progress));
      if (progress >= 1) {
        clearMusicFade();
        outgoing.pause();
        outgoing.src = "";
      }
    }, stepMs);
  }, [clearMusicFade]);
  const stopAll = useCallback(() => {
    for (const pool of poolsRef.current.values()) {
      for (const audio of pool) {
        audio.pause();
        audio.currentTime = 0;
      }
    }
    stopMusic(0);
  }, [stopMusic]);
  const setMuted = useCallback((value) => {
    setMutedState(value);
    if (value) {
      for (const [key, pool] of poolsRef.current.entries()) {
        if (manifestRef.current[key]?.loop) {
          for (const audio of pool) {
            if (!audio.paused) audio.pause();
          }
        }
      }
      currentMusicElRef.current?.pause();
    } else {
      for (const [key, pool] of poolsRef.current.entries()) {
        const entry = manifestRef.current[key];
        if (entry?.loop && entry?.autostart) {
          for (const audio of pool) {
            if (audio.paused) audio.play().catch(() => {
            });
          }
        }
      }
      const musicEl = currentMusicElRef.current;
      if (musicEl) {
        musicEl.play().catch(() => {
        });
      }
    }
  }, []);
  const setMasterVolume = useCallback((volume) => {
    const clamped = Math.max(0, Math.min(1, volume));
    setMasterVolumeState(clamped);
    for (const [key, pool] of poolsRef.current.entries()) {
      const entryVol = manifestRef.current[key]?.volume ?? 1;
      for (const audio of pool) {
        audio.volume = Math.min(1, entryVol * clamped);
      }
    }
    if (!musicFadeRef.current && currentMusicElRef.current) {
      const key = currentMusicKeyRef.current;
      const entryVol = key ? manifestRef.current[key]?.volume ?? 1 : 1;
      currentMusicElRef.current.volume = Math.min(1, entryVol * clamped);
    }
  }, []);
  const unlockedRef = useRef(false);
  useEffect(() => {
    const autoKeys = Object.keys(manifest).filter((k) => manifest[k].autostart);
    const hasPendingMusic = () => pendingMusicKeyRef.current !== null;
    const hasAutoStart = autoKeys.length > 0;
    if (!hasAutoStart && !hasPendingMusic()) return;
    const unlock = () => {
      if (unlockedRef.current) return;
      unlockedRef.current = true;
      if (!mutedRef.current) {
        for (const key of autoKeys) {
          play(key);
        }
        const pending = pendingMusicKeyRef.current;
        if (pending && pending !== currentMusicKeyRef.current) {
          playMusic(pending);
        }
      }
    };
    document.addEventListener("click", unlock, { once: true });
    document.addEventListener("keydown", unlock, { once: true });
    document.addEventListener("touchstart", unlock, { once: true });
    return () => {
      document.removeEventListener("click", unlock);
      document.removeEventListener("keydown", unlock);
      document.removeEventListener("touchstart", unlock);
    };
  }, [manifest, play, playMusic]);
  useEffect(() => {
    return () => {
      clearMusicFade();
      for (const pool of poolsRef.current.values()) {
        for (const audio of pool) {
          audio.pause();
          audio.src = "";
        }
      }
      poolsRef.current.clear();
      if (currentMusicElRef.current) {
        currentMusicElRef.current.pause();
        currentMusicElRef.current.src = "";
        currentMusicElRef.current = null;
      }
    };
  }, [clearMusicFade]);
  return {
    play,
    stop,
    stopAll,
    playMusic,
    stopMusic,
    muted,
    setMuted,
    masterVolume,
    setMasterVolume
  };
}
var init_useGameAudio = __esm({
  "hooks/useGameAudio.ts"() {
    "use client";
    useGameAudio.displayName = "useGameAudio";
  }
});
function GameAudioCue({
  cue,
  cueSeq,
  music,
  muted,
  volume,
  manifest,
  baseUrl
}) {
  const { play, playMusic, stopMusic, setMuted, setMasterVolume } = useGameAudio({
    manifest,
    baseUrl,
    initialMuted: muted,
    initialVolume: volume
  });
  const prevCueSeqRef = useRef(cueSeq);
  useEffect(() => {
    if (cue && cueSeq !== void 0 && cueSeq !== prevCueSeqRef.current) {
      play(cue);
    }
    prevCueSeqRef.current = cueSeq;
  }, [cue, cueSeq, play]);
  useEffect(() => {
    if (music) playMusic(music);
    else stopMusic();
  }, [music, playMusic, stopMusic]);
  useEffect(() => {
    if (muted !== void 0) setMuted(muted);
  }, [muted, setMuted]);
  useEffect(() => {
    if (volume !== void 0) setMasterVolume(volume);
  }, [volume, setMasterVolume]);
  return null;
}
var init_GameAudioCue = __esm({
  "components/game/atoms/GameAudioCue.tsx"() {
    "use client";
    init_useGameAudio();
    GameAudioCue.displayName = "GameAudioCue";
  }
});
function isKnownState(s) {
  return s in DEFAULT_STATE_STYLES;
}
function StateIndicator({
  assetUrl = DEFAULT_ASSET_URL,
  state = "idle",
  label,
  size = "md",
  animated = true,
  stateStyles,
  className
}) {
  const mergedStyles = stateStyles ? { ...DEFAULT_STATE_STYLES, ...stateStyles } : DEFAULT_STATE_STYLES;
  const knownState = isKnownState(state) ? state : null;
  const config = knownState !== null ? mergedStyles[knownState] ?? DEFAULT_STYLE : DEFAULT_STYLE;
  const displayLabel = label ?? state.charAt(0).toUpperCase() + state.slice(1);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "inline-flex",
      className: cn(
        "items-center gap-1 rounded-full text-foreground font-medium",
        config.bgClass,
        SIZE_CLASSES[size],
        animated && (knownState === null || !STATIC_STATES.has(knownState)) && "animate-pulse",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Box, { as: "span", children: assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 16, alt: displayLabel, className: "flex-shrink-0" }) : typeof config.icon === "string" ? /^[a-zA-Z0-9-]+$/.test(config.icon) ? /* @__PURE__ */ jsx(Icon, { name: config.icon }) : config.icon : /* @__PURE__ */ jsx(Icon, { icon: config.icon }) }),
        /* @__PURE__ */ jsx(Box, { as: "span", children: displayLabel })
      ]
    }
  );
}
var DEFAULT_ASSET_URL, DEFAULT_STATE_STYLES, DEFAULT_STYLE, STATIC_STATES, SIZE_CLASSES;
var init_StateIndicator = __esm({
  "components/game/atoms/StateIndicator.tsx"() {
    init_Box();
    init_Icon();
    init_cn();
    init_GameIcon();
    DEFAULT_ASSET_URL = {
      url: "https://almadar-kflow-assets.web.app/shared/ui-topdown-dungeon-board/default/features/chest/chest.png",
      role: "ui",
      category: "state"
    };
    DEFAULT_STATE_STYLES = {
      idle: { icon: "\u23F8", bgClass: "bg-muted" },
      active: { icon: "\u25B6", bgClass: "bg-success" },
      sleeping: { icon: "\u{1F4A4}", bgClass: "bg-muted" },
      moving: { icon: "\u{1F6B6}", bgClass: "bg-info" },
      eating: { icon: "\u{1F37D}\uFE0F", bgClass: "bg-success" },
      waiting: { icon: "\u23F3", bgClass: "bg-warning" },
      happy: { icon: "\u{1F60A}", bgClass: "bg-success" },
      scared: { icon: "\u{1F628}", bgClass: "bg-error" },
      done: { icon: "\u2713", bgClass: "bg-success" },
      error: { icon: "\u2717", bgClass: "bg-error" },
      ready: { icon: "\u2713", bgClass: "bg-success" },
      cooldown: { icon: "\u{1F504}", bgClass: "bg-warning" }
    };
    DEFAULT_STYLE = { icon: "?", bgClass: "bg-muted" };
    STATIC_STATES = /* @__PURE__ */ new Set(["idle", "done"]);
    SIZE_CLASSES = {
      sm: "text-xs px-1.5 py-0.5",
      md: "text-sm px-2 py-1",
      lg: "text-base px-3 py-1.5"
    };
    StateIndicator.displayName = "StateIndicator";
  }
});
function LinearView({
  trait,
  size = "md",
  className
}) {
  const currentIdx = trait.states.indexOf(trait.currentState);
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", children: [
    trait.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: trait.description }),
    /* @__PURE__ */ jsx(HStack, { className: "flex-wrap items-center", gap: "xs", children: trait.states.map((state, i) => {
      const isDone = i < currentIdx;
      const isCurrent = i === currentIdx;
      return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
        i > 0 && /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            className: cn(
              "text-lg",
              isDone || isCurrent ? "text-primary" : "text-muted-foreground"
            ),
            children: "\u2192"
          }
        ),
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "inline-flex",
            className: cn(
              "items-center justify-center rounded-pill px-3 py-1 border-2 transition-all",
              SIZE_CONFIG2[size || "md"].fontSize,
              isDone && "bg-success/20 border-success text-success",
              isCurrent && "bg-primary/20 border-primary text-primary font-bold shadow-elevation-card shadow-primary/20",
              !isDone && !isCurrent && "bg-muted border-border text-muted-foreground"
            ),
            children: [
              /* @__PURE__ */ jsx(Box, { as: "span", className: "mr-1", children: isDone ? "\u2714" : isCurrent ? "\u25CF" : "\u25CB" }),
              /* @__PURE__ */ jsx(Box, { as: "span", children: state })
            ]
          }
        )
      ] }, state);
    }) })
  ] });
}
function CompactView({
  trait,
  size = "md",
  stateStyles,
  className
}) {
  const { t } = useTranslate();
  const config = SIZE_CONFIG2[size || "md"];
  const currentTransitions = trait.transitions.filter((t2) => t2.from === trait.currentState);
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-center justify-between", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-foreground font-bold", children: trait.name }),
      /* @__PURE__ */ jsx(StateIndicator, { state: trait.currentState, size: "sm", stateStyles })
    ] }),
    trait.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", overflow: "wrap", children: trait.description }),
    currentTransitions.length > 0 && /* @__PURE__ */ jsxs(VStack, { className: "pt-2 border-t border-border", gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("trait.availableActions") + ":" }),
      /* @__PURE__ */ jsx(HStack, { className: "flex-wrap", gap: "xs", children: currentTransitions.map((transition, i) => /* @__PURE__ */ jsxs(
        Box,
        {
          display: "inline-flex",
          className: cn("items-center gap-1 px-2 py-1 rounded bg-muted", config.fontSize),
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-accent", children: transition.event }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u2192" }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-success", children: transition.to }),
            transition.guardHint && /* @__PURE__ */ jsx(Box, { as: "span", className: "text-warning ml-1 cursor-help", title: transition.guardHint, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-warning", children: "\u26A0" }) })
          ]
        },
        i
      )) })
    ] })
  ] });
}
function FullView({
  trait,
  size = "md",
  showTransitions = true,
  onStateClick,
  stateStyles,
  className
}) {
  const { t } = useTranslate();
  const config = SIZE_CONFIG2[size || "md"];
  const currentTransitions = trait.transitions.filter((t2) => t2.from === trait.currentState);
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-center justify-between", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-foreground font-bold", children: trait.name }),
      /* @__PURE__ */ jsx(StateIndicator, { state: trait.currentState, size: "sm", stateStyles })
    ] }),
    trait.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", overflow: "wrap", children: trait.description }),
    /* @__PURE__ */ jsx(HStack, { className: cn("flex-wrap", config.gap), children: trait.states.map((state) => {
      const isCurrent = state === trait.currentState;
      const hasOutgoing = trait.transitions.some((t2) => t2.from === state);
      return /* @__PURE__ */ jsx(
        Box,
        {
          display: "flex",
          className: cn(
            "items-center justify-center rounded-container border-2 transition-all px-2",
            config.nodeSize,
            isCurrent && "bg-primary/20 border-primary shadow-elevation-card shadow-primary/20",
            !isCurrent && hasOutgoing && "bg-muted border-border hover:border-muted-foreground",
            !isCurrent && !hasOutgoing && "bg-background border-border opacity-60",
            onStateClick && "cursor-pointer"
          ),
          onClick: () => onStateClick?.(state),
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: cn(
                config.fontSize,
                "whitespace-nowrap",
                isCurrent ? "text-primary font-bold" : "text-foreground/80"
              ),
              children: state
            }
          )
        },
        state
      );
    }) }),
    showTransitions && /* @__PURE__ */ jsxs(VStack, { className: "pt-2 border-t border-border", gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("trait.transitions") + ":" }),
      /* @__PURE__ */ jsx(VStack, { gap: "xs", children: trait.transitions.map((transition, i) => {
        const isActive = transition.from === trait.currentState;
        return /* @__PURE__ */ jsxs(
          HStack,
          {
            className: cn(
              "items-center px-2 py-1 rounded text-xs",
              isActive ? "bg-primary/10" : "bg-muted/50"
            ),
            gap: "xs",
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: isActive ? "text-primary font-medium" : "text-muted-foreground", children: transition.from }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u2014[" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-accent font-medium", children: transition.event }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "]\u2192" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: isActive ? "text-success font-medium" : "text-foreground/70", children: transition.to }),
              transition.guardHint && /* @__PURE__ */ jsx(Box, { as: "span", className: "text-warning ml-1 cursor-help", title: transition.guardHint, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-warning", children: "\u26A0 " + transition.guardHint }) })
            ]
          },
          i
        );
      }) })
    ] }),
    showTransitions && currentTransitions.length > 0 && /* @__PURE__ */ jsxs(VStack, { className: "pt-2 border-t border-border", gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-primary font-medium", children: t("trait.availableNow") + ":" }),
      /* @__PURE__ */ jsx(HStack, { className: "flex-wrap", gap: "xs", children: currentTransitions.map((t2, i) => /* @__PURE__ */ jsxs(
        Box,
        {
          display: "inline-flex",
          className: "items-center gap-1 px-2 py-1 rounded bg-primary/10 border border-primary/30 text-xs",
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-accent font-medium", children: t2.event }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u2192" }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-success", children: t2.to })
          ]
        },
        i
      )) })
    ] })
  ] });
}
function TraitStateViewer({
  trait,
  variant = "compact",
  size = "md",
  showTransitions = true,
  onStateClick,
  stateStyles,
  className
}) {
  switch (variant) {
    case "linear":
      return /* @__PURE__ */ jsx(LinearView, { trait, size, className });
    case "compact":
      return /* @__PURE__ */ jsx(
        CompactView,
        {
          trait,
          size,
          stateStyles,
          className
        }
      );
    case "full":
      return /* @__PURE__ */ jsx(
        FullView,
        {
          trait,
          size,
          showTransitions,
          onStateClick,
          stateStyles,
          className
        }
      );
  }
}
var SIZE_CONFIG2;
var init_TraitStateViewer = __esm({
  "components/game/molecules/TraitStateViewer.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Typography();
    init_Stack();
    init_StateIndicator();
    SIZE_CONFIG2 = {
      sm: { nodeSize: "min-w-12 h-8", fontSize: "text-xs", gap: "gap-2" },
      md: { nodeSize: "min-w-16 h-10", fontSize: "text-sm", gap: "gap-4" },
      lg: { nodeSize: "min-w-20 h-12", fontSize: "text-base", gap: "gap-6" }
    };
    TraitStateViewer.displayName = "TraitStateViewer";
  }
});
function TraitSlot({
  slotNumber,
  equippedItem,
  locked = false,
  lockLabel,
  selected = false,
  size = "md",
  showTooltip = true,
  categoryColors,
  tooltipFrameUrl,
  className,
  feedback,
  onItemDrop,
  draggable = false,
  onDragStart,
  onClick,
  onRemove,
  clickEvent,
  removeEvent,
  dropEvent
}) {
  const { emit } = useEventBus();
  const [isHovered, setIsHovered] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const slotRef = useRef(null);
  const config = SIZE_CONFIG3[size];
  const isEmpty = !equippedItem;
  const catColor = equippedItem && categoryColors ? categoryColors[equippedItem.category] : null;
  const handleClick = useCallback(() => {
    if (locked) return;
    if (clickEvent) {
      emit(`UI:${clickEvent}`, { slotNumber });
    } else {
      onClick?.();
    }
  }, [locked, clickEvent, slotNumber, emit, onClick]);
  const handleRemove = useCallback((e) => {
    e.stopPropagation();
    if (removeEvent) {
      emit(`UI:${removeEvent}`, { slotNumber });
    } else {
      onRemove?.();
    }
  }, [removeEvent, slotNumber, emit, onRemove]);
  const handleDragStart = useCallback((e) => {
    if (!equippedItem || !draggable) return;
    e.dataTransfer.setData(DRAG_MIME2, JSON.stringify(equippedItem));
    e.dataTransfer.effectAllowed = "move";
    onDragStart?.(equippedItem);
  }, [equippedItem, draggable, onDragStart]);
  const handleDragOver = useCallback((e) => {
    if (locked || !onItemDrop && !dropEvent) return;
    if (e.dataTransfer.types.includes(DRAG_MIME2)) {
      e.preventDefault();
      const allowed = e.dataTransfer.effectAllowed;
      e.dataTransfer.dropEffect = allowed === "copy" ? "copy" : "move";
      setIsDragOver(true);
    }
  }, [locked, onItemDrop, dropEvent]);
  const handleDragLeave = useCallback(() => {
    setIsDragOver(false);
  }, []);
  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragOver(false);
    if (locked || !onItemDrop && !dropEvent) return;
    const raw = e.dataTransfer.getData(DRAG_MIME2);
    if (!raw) return;
    try {
      const item = JSON.parse(raw);
      if (dropEvent) emit(`UI:${dropEvent}`, { slotNumber, itemId: item.id });
      else onItemDrop?.(item);
    } catch {
    }
  }, [locked, onItemDrop, dropEvent, emit, slotNumber]);
  const getTooltipStyle = () => {
    if (!slotRef.current) return {};
    const rect = slotRef.current.getBoundingClientRect();
    return {
      position: "fixed",
      left: rect.left + rect.width / 2,
      top: rect.top - 8,
      transform: "translate(-50%, -100%)",
      zIndex: 9999
    };
  };
  const itemMachine = equippedItem?.stateMachine || (equippedItem ? {
    name: equippedItem.name,
    states: ["idle", "active", "done"],
    currentState: "idle",
    transitions: [
      { from: "idle", to: "active", event: "ACTIVATE" },
      { from: "active", to: "done", event: "COMPLETE" }
    ],
    description: equippedItem.description
  } : null);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ref: slotRef,
      display: "flex",
      position: "relative",
      className: cn(
        "items-center justify-center rounded-container transition-all duration-200 bg-card/50",
        !locked && "cursor-pointer",
        locked && "cursor-not-allowed opacity-50",
        isEmpty && !locked && "border-2 border-dashed border-border hover:border-muted-foreground",
        isEmpty && locked && "border-2 border-dashed border-border",
        !isEmpty && "border-2",
        selected && "ring-2 ring-primary ring-offset-2 ring-offset-background",
        isDragOver && "ring-2 ring-accent ring-offset-1 scale-110 border-accent",
        !isDragOver && feedback === "correct" && "ring-2 ring-success ring-offset-1 ring-offset-background",
        !isDragOver && feedback === "wrong" && "ring-2 ring-error ring-offset-1 ring-offset-background",
        !locked && !isDragOver && "hover:scale-105",
        className
      ),
      style: {
        width: config.box,
        height: config.box,
        backgroundColor: catColor?.bg || void 0,
        borderColor: isDragOver ? void 0 : feedback === "correct" ? "var(--color-success)" : feedback === "wrong" ? "var(--color-error)" : catColor?.border || void 0
      },
      onClick: handleClick,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      draggable: draggable && !isEmpty,
      onDragStart: handleDragStart,
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
      children: [
        locked ? /* @__PURE__ */ jsxs(Box, { className: "text-center", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u{1F512}" }),
          lockLabel && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground block text-xs", children: lockLabel })
        ] }) : isEmpty ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground text-lg", children: "+" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          equippedItem.iconUrl ? /* @__PURE__ */ jsx(
            Box,
            {
              as: "img",
              className: "object-contain",
              style: { width: config.icon, height: config.icon },
              ...{ src: equippedItem.iconUrl.url, alt: equippedItem.name }
            }
          ) : /* @__PURE__ */ jsx(Typography, { variant: "body1", className: "text-center leading-none", style: { fontSize: config.icon }, children: equippedItem.iconEmoji || "\u2726" }),
          (onRemove || removeEvent) && /* @__PURE__ */ jsx(
            Box,
            {
              position: "absolute",
              className: "-top-1.5 -right-1.5 w-4 h-4 bg-error rounded-pill flex items-center justify-center cursor-pointer hover:bg-error/80 transition-colors",
              onClick: handleRemove,
              children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-foreground text-xs leading-none", children: "\xD7" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "-bottom-1 -left-1 w-4 h-4 bg-card rounded-pill flex items-center justify-center border border-border",
            children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground text-xs", children: slotNumber })
          }
        ),
        showTooltip && isHovered && itemMachine && !isEmpty && equippedItem && /* @__PURE__ */ jsxs(
          Box,
          {
            className: "p-3 bg-background border border-border rounded-container shadow-xl",
            style: {
              ...getTooltipStyle(),
              minWidth: 200,
              ...tooltipFrameUrl ? {
                borderImage: `url(${tooltipFrameUrl.url}) 60 fill / 15px / 0 stretch`,
                border: "none"
              } : {}
            },
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h6", className: "text-foreground mb-2 text-center", children: equippedItem.name }),
              equippedItem.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground block mb-2 text-center", children: equippedItem.description }),
              /* @__PURE__ */ jsx(TraitStateViewer, { trait: itemMachine, variant: "compact", size: "sm" }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  position: "absolute",
                  className: "-bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-border"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
var SIZE_CONFIG3, DRAG_MIME2;
var init_TraitSlot = __esm({
  "components/game/molecules/TraitSlot.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_Typography();
    init_TraitStateViewer();
    SIZE_CONFIG3 = {
      sm: { box: 40, icon: 20, font: "text-xs" },
      md: { box: 56, icon: 28, font: "text-sm" },
      lg: { box: 72, icon: 40, font: "text-base" }
    };
    DRAG_MIME2 = "application/x-almadar-slot-item";
    TraitSlot.displayName = "TraitSlot";
  }
});
function CollapsibleSection({ title, expanded, onToggle, children, assetManifest, className }) {
  const ui = assetManifest?.ui;
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        onClick: onToggle,
        className: "w-full justify-start text-left",
        children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx(
            GameIcon,
            {
              icon: expanded ? ChevronDown : ChevronRight,
              assetUrl: expanded ? ui?.["collapse"] : ui?.["expand"],
              size: 14
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "semibold", children: title })
        ] })
      }
    ),
    expanded && /* @__PURE__ */ jsx(Box, { padding: "xs", paddingX: "sm", children })
  ] });
}
function EditorSlider({ label, value, min, max, step = 0.1, onChange, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1", children: /* @__PURE__ */ jsx(
      "input",
      {
        type: "range",
        min,
        max,
        step,
        value,
        onChange: (e) => onChange(parseFloat(e.target.value)),
        className: "w-full h-1.5 bg-muted rounded-interactive appearance-none cursor-pointer accent-primary"
      }
    ) }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[40px] text-right text-muted-foreground", children: typeof step === "number" && step < 1 ? value.toFixed(1) : value })
  ] });
}
function EditorSelect({ label, value, options, onChange, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1", children: /* @__PURE__ */ jsx(
      "select",
      {
        value,
        onChange: (e) => onChange(e.target.value),
        className: "w-full px-2 py-1 text-xs bg-muted text-foreground border border-muted rounded cursor-pointer",
        children: options.map((opt) => /* @__PURE__ */ jsx("option", { value: opt.value, children: opt.label }, opt.value))
      }
    ) })
  ] });
}
function EditorCheckbox({ label, checked, onChange, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
      "input",
      {
        type: "checkbox",
        checked,
        onChange: (e) => onChange(e.target.checked),
        className: "w-4 h-4 accent-primary cursor-pointer"
      }
    ) })
  ] });
}
function EditorTextInput({ label, value, onChange, placeholder, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1", children: /* @__PURE__ */ jsx(
      "input",
      {
        type: "text",
        value,
        onChange: (e) => onChange(e.target.value),
        placeholder,
        className: "w-full px-2 py-1 text-xs bg-muted text-foreground border border-muted rounded"
      }
    ) })
  ] });
}
function StatusBar({ hoveredTile, mode, gridSize, unitCount, featureCount, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: `px-3 py-1.5 bg-background border-t border-border ${className ?? ""}`, children: [
    /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: mode }),
    /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-muted-foreground", children: [
      "Tile: ",
      hoveredTile ? `(${hoveredTile.x}, ${hoveredTile.y})` : "\u2014"
    ] }),
    gridSize && /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-muted-foreground", children: [
      "Grid: ",
      gridSize.width,
      "x",
      gridSize.height
    ] }),
    unitCount !== void 0 && /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-muted-foreground", children: [
      "Units: ",
      unitCount
    ] }),
    featureCount !== void 0 && /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-muted-foreground", children: [
      "Features: ",
      featureCount
    ] })
  ] });
}
function TerrainPalette({ terrains, selectedTerrain, onSelect, className }) {
  return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, className, children: terrains.map((terrain) => /* @__PURE__ */ jsx(
    Box,
    {
      onClick: () => onSelect(terrain),
      className: `w-8 h-8 rounded cursor-pointer border-2 transition-all ${selectedTerrain === terrain ? "border-foreground scale-110 shadow-lg" : "border-muted hover:border-muted-foreground"}`,
      style: { backgroundColor: TERRAIN_COLORS[terrain] || "var(--color-muted)" },
      title: terrain
    },
    terrain
  )) });
}
function EditorToolbar({ mode, onModeChange, className }) {
  const modes = ["select", "paint", "unit", "feature", "erase"];
  return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, className, children: modes.map((m) => /* @__PURE__ */ jsx(
    Button,
    {
      variant: mode === m ? "primary" : "ghost",
      size: "sm",
      onClick: () => onModeChange(m),
      children: MODE_LABELS[m]
    },
    m
  )) });
}
var TERRAIN_COLORS, FEATURE_TYPES, MODE_LABELS;
var init_editorUtils = __esm({
  "lib/editorUtils.tsx"() {
    init_Box();
    init_Stack();
    init_Typography();
    init_Button();
    init_Badge();
    init_GameIcon();
    TERRAIN_COLORS = {
      grass: "#4a7c3f",
      dirt: "#8b6c42",
      stone: "#7a7a7a",
      sand: "#c4a84d",
      water: "#3a6ea5",
      forest: "#2d5a1e",
      mountain: "#5a4a3a",
      lava: "#c44b2b",
      ice: "#a0d2e8",
      plains: "#6b8e4e",
      fortress: "#4a4a5a",
      castle: "#5a5a6a"
    };
    FEATURE_TYPES = [
      "goldMine",
      "resonanceCrystal",
      "traitCache",
      "salvageYard",
      "portal",
      "battleMarker",
      "treasure",
      "castle"
    ];
    CollapsibleSection.displayName = "CollapsibleSection";
    EditorSlider.displayName = "EditorSlider";
    EditorSelect.displayName = "EditorSelect";
    EditorCheckbox.displayName = "EditorCheckbox";
    EditorTextInput.displayName = "EditorTextInput";
    StatusBar.displayName = "StatusBar";
    TerrainPalette.displayName = "TerrainPalette";
    MODE_LABELS = {
      select: "Select",
      paint: "Paint",
      unit: "Unit",
      feature: "Feature",
      erase: "Erase"
    };
    EditorToolbar.displayName = "EditorToolbar";
  }
});
function SequenceBar({
  slots,
  maxSlots,
  onSlotDrop,
  onSlotRemove,
  slotDropEvent,
  slotRemoveEvent,
  playing = false,
  currentStep = -1,
  categoryColors,
  slotFeedback,
  size = "lg",
  className
}) {
  const { emit } = useEventBus();
  const handleDrop = useCallback((index) => (item) => {
    if (playing) return;
    if (slotDropEvent) emit(`UI:${slotDropEvent}`, { slotNumber: index, itemId: item.id });
    else onSlotDrop?.(index, item);
  }, [emit, slotDropEvent, onSlotDrop, playing]);
  const handleRemove = useCallback((index) => () => {
    if (playing) return;
    if (slotRemoveEvent) emit(`UI:${slotRemoveEvent}`, { slotNumber: index });
    else onSlotRemove?.(index);
  }, [emit, slotRemoveEvent, onSlotRemove, playing]);
  const paddedSlots = Array.from({ length: maxSlots }, (_, i) => slots[i]);
  return /* @__PURE__ */ jsx(HStack, { className: cn("items-center", className), gap: "sm", children: paddedSlots.map((slot, i) => /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
    i > 0 && /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "body1",
        className: cn(
          "text-lg",
          currentStep >= 0 && i <= currentStep ? "text-primary" : "text-muted-foreground"
        ),
        children: "\u2192"
      }
    ),
    /* @__PURE__ */ jsx(
      TraitSlot,
      {
        slotNumber: i + 1,
        equippedItem: slot,
        size,
        categoryColors,
        onItemDrop: handleDrop(i),
        onRemove: slot ? handleRemove(i) : void 0,
        draggable: !playing && !!slot,
        selected: currentStep === i,
        locked: playing,
        feedback: slotFeedback?.[i]
      }
    )
  ] }, i)) });
}
var init_SequenceBar = __esm({
  "components/game/molecules/SequenceBar.tsx"() {
    init_atoms();
    init_cn();
    init_useEventBus();
    init_TraitSlot();
    SequenceBar.displayName = "SequenceBar";
  }
});

// lib/puzzleObject.ts
function objId(o) {
  return o.id == null ? "" : String(o.id);
}
function objName(o) {
  return o.name == null ? "" : String(o.name);
}
function objIcon(o) {
  return o.icon == null ? "" : String(o.icon);
}
function objStates(o) {
  return Array.isArray(o.states) ? o.states : [];
}
function objCurrentState(o) {
  return o.currentState == null ? "" : String(o.currentState);
}
function objAvailableEvents(o) {
  return Array.isArray(o.availableEvents) ? o.availableEvents : [];
}
function objAvailableActions(o) {
  return Array.isArray(o.availableActions) ? o.availableActions : [];
}
function objRules(o) {
  return Array.isArray(o.rules) ? o.rules : [];
}
function objMaxRules(o) {
  const n = Number(o.maxRules);
  return Number.isFinite(n) && n > 0 ? n : 3;
}
var init_puzzleObject = __esm({
  "lib/puzzleObject.ts"() {
  }
});
function StateJsonView({
  name,
  initialState,
  states,
  transitions,
  label,
  defaultExpanded = false,
  className
}) {
  const { t } = useTranslate();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const jsonString = JSON.stringify(
    { name, initialState, states: states ?? [], transitions: transitions ?? [] },
    null,
    2
  );
  return /* @__PURE__ */ jsxs(VStack, { className: cn("rounded-lg border border-border overflow-hidden", className), gap: "none", children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-center justify-between p-2 bg-muted", gap: "sm", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground font-medium", children: label ?? t("stateArchitect.viewCode") }),
      /* @__PURE__ */ jsx(Button, { variant: "ghost", onClick: () => setExpanded(!expanded), className: "text-xs", children: expanded ? t("stateArchitect.hideJson") : t("stateArchitect.showJson") })
    ] }),
    expanded && /* @__PURE__ */ jsx(Box, { className: "p-3 bg-background overflow-x-auto", children: /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "caption",
        className: "text-foreground font-mono whitespace-pre text-xs leading-relaxed block",
        children: jsonString
      }
    ) })
  ] });
}
var init_StateJsonView = __esm({
  "components/game/molecules/StateJsonView.tsx"() {
    init_atoms();
    init_cn();
    StateJsonView.displayName = "StateJsonView";
  }
});

// lib/mechanics.ts
var projectileMotion, pendulum, springOscillator;
var init_mechanics = __esm({
  "lib/mechanics.ts"() {
    projectileMotion = {
      id: "mechanics-projectile",
      name: "Projectile Motion",
      description: "Launch a ball and observe parabolic trajectory under gravity.",
      domain: "natural",
      gravity: { x: 0, y: 9.81 },
      bodies: [
        { id: "ball", x: 50, y: 350, vx: 80, vy: -120, mass: 1, radius: 10, color: "#e94560", fixed: false },
        { id: "ground", x: 300, y: 390, vx: 0, vy: 0, mass: 1e3, radius: 400, color: "#333", fixed: true }
      ],
      showVelocity: true,
      parameters: {
        angle: { value: 45, min: 0, max: 90, step: 1, label: "Launch angle (deg)" },
        velocity: { value: 100, min: 10, max: 200, step: 5, label: "Initial velocity (m/s)" },
        gravity: { value: 9.81, min: 0, max: 20, step: 0.1, label: "Gravity (m/s\xB2)" }
      }
    };
    pendulum = {
      id: "mechanics-pendulum",
      name: "Simple Pendulum",
      description: "A mass on a string swinging under gravity.",
      domain: "natural",
      gravity: { x: 0, y: 9.81 },
      bodies: [
        { id: "pivot", x: 300, y: 50, vx: 0, vy: 0, mass: 1e3, radius: 5, color: "#888", fixed: true },
        { id: "bob", x: 400, y: 200, vx: 0, vy: 0, mass: 5, radius: 15, color: "#e94560", fixed: false }
      ],
      constraints: [{ bodyA: 0, bodyB: 1, length: 180, stiffness: 1 }],
      parameters: {
        length: { value: 180, min: 50, max: 300, step: 10, label: "String length (px)" },
        mass: { value: 5, min: 1, max: 20, step: 0.5, label: "Mass (kg)" },
        gravity: { value: 9.81, min: 0, max: 20, step: 0.1, label: "Gravity (m/s\xB2)" }
      }
    };
    springOscillator = {
      id: "mechanics-spring",
      name: "Spring Oscillator",
      description: "A mass bouncing on a spring \u2014 simple harmonic motion.",
      domain: "natural",
      gravity: { x: 0, y: 0 },
      bodies: [
        { id: "anchor", x: 300, y: 50, vx: 0, vy: 0, mass: 1e3, radius: 8, color: "#888", fixed: true },
        { id: "mass", x: 300, y: 250, vx: 0, vy: 0, mass: 2, radius: 20, color: "#0f3460", fixed: false }
      ],
      constraints: [{ bodyA: 0, bodyB: 1, length: 150, stiffness: 0.5 }],
      parameters: {
        stiffness: { value: 0.5, min: 0.1, max: 2, step: 0.05, label: "Spring stiffness (k)" },
        mass: { value: 2, min: 0.5, max: 10, step: 0.5, label: "Mass (kg)" },
        damping: { value: 0, min: 0, max: 0.5, step: 0.01, label: "Damping" }
      }
    };
  }
});

// lib/physicsPresets.ts
var ALL_PRESETS;
var init_physicsPresets = __esm({
  "lib/physicsPresets.ts"() {
    init_mechanics();
    init_mechanics();
    ALL_PRESETS = [
      projectileMotion,
      pendulum,
      springOscillator
    ];
  }
});

// lib/gameFonts.ts
function resolveGameFontFamily(input) {
  if (!input) return void 0;
  const resolved = GAME_FONT_KEYS[input];
  if (resolved) return `'${resolved}', ui-sans-serif, system-ui, sans-serif`;
  return input;
}
var GAME_FONT_KEYS;
var init_gameFonts = __esm({
  "lib/gameFonts.ts"() {
    GAME_FONT_KEYS = {
      fredoka: "Fredoka",
      future: "Kenney Future",
      "future-narrow": "Kenney Future Narrow",
      pixel: "Kenney Pixel",
      blocks: "Kenney Blocks",
      mini: "Kenney Mini"
    };
  }
});
var GameShell;
var init_GameShell = __esm({
  "components/game/templates/GameShell.tsx"() {
    init_cn();
    init_gameFonts();
    init_Box();
    init_Card();
    init_Typography();
    init_AtlasImage();
    GameShell = ({
      appName = "Game",
      hud,
      addons,
      controls,
      overlay,
      className,
      showTopBar = true,
      children,
      backgroundAsset,
      fontFamily,
      "data-theme": dataTheme
    }) => {
      const displayFont = resolveGameFontFamily(fontFamily);
      return /* @__PURE__ */ jsxs(
        Box,
        {
          "data-theme": dataTheme || void 0,
          className: cn("game-shell", className),
          style: {
            position: "relative",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            background: "var(--color-background, #0a0a0f)",
            color: "var(--color-foreground, #e0e0e0)",
            // The fontFamily knob is a scoped override of the theme contract's
            // display slot: titles/numerics take the game face, body text keeps
            // the active theme's --font-family-body. Set ONLY when explicitly
            // passed — an always-on inline stamp would shadow the orbital's
            // inline-theme font-family-display token (inline style beats the
            // theme provider's vars for the whole shell subtree).
            ...displayFont ? { "--font-family-display": displayFont } : {}
          },
          children: [
            backgroundAsset && /* @__PURE__ */ jsx(
              AtlasPanel,
              {
                asset: backgroundAsset,
                mode: "repeat",
                "aria-hidden": true,
                className: "game-shell__bg",
                style: { position: "absolute", inset: 0, opacity: 0.18, zIndex: 0, display: "block" }
              }
            ),
            /* @__PURE__ */ jsx(Box, { className: "game-shell__content", style: { position: "absolute", inset: 0, zIndex: 1 }, children }),
            (showTopBar || hud) && /* @__PURE__ */ jsxs(
              Box,
              {
                className: "game-shell__top pointer-events-none",
                style: {
                  position: "absolute",
                  top: 12,
                  left: 12,
                  right: 12,
                  zIndex: 2,
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 12
                },
                children: [
                  showTopBar && /* @__PURE__ */ jsx(
                    Card,
                    {
                      variant: "bordered",
                      padding: "none",
                      className: "game-shell__title bg-card pointer-events-auto",
                      style: { padding: "6px 16px", flexShrink: 0 },
                      children: /* @__PURE__ */ jsx(
                        Typography,
                        {
                          as: "span",
                          className: "font-display",
                          style: {
                            fontWeight: 700,
                            fontSize: "1.05rem",
                            letterSpacing: "0.06em",
                            textShadow: "0 2px 0 rgba(0,0,0,0.5)",
                            whiteSpace: "nowrap"
                          },
                          children: appName
                        }
                      )
                    }
                  ),
                  hud && /* @__PURE__ */ jsx(Box, { className: "game-shell__hud pointer-events-auto", style: { flex: 1, minWidth: 0 }, children: hud })
                ]
              }
            ),
            controls && /* @__PURE__ */ jsx(
              Box,
              {
                className: "game-shell__controls pointer-events-auto",
                style: {
                  position: "absolute",
                  left: 16,
                  bottom: 16,
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 10,
                  filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.5))"
                },
                children: controls
              }
            ),
            addons && /* @__PURE__ */ jsx(
              Box,
              {
                className: "game-shell__actions pointer-events-auto",
                style: {
                  position: "absolute",
                  right: 16,
                  bottom: 16,
                  zIndex: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: 10,
                  filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.5))"
                },
                children: addons
              }
            ),
            overlay && /* @__PURE__ */ jsx(
              Box,
              {
                className: "game-shell__overlay pointer-events-none",
                style: {
                  position: "absolute",
                  inset: 0,
                  zIndex: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                },
                children: /* @__PURE__ */ jsx(Box, { className: "pointer-events-auto", children: overlay })
              }
            )
          ]
        }
      );
    };
    GameShell.displayName = "GameShell";
  }
});
var init_molecules = __esm({
  "components/game/molecules/index.ts"() {
    init_gameShared();
    init_HealthBar();
    init_ScoreDisplay();
    init_ControlButton();
    init_TimerDisplay();
    init_DialogueBubble();
    init_ChoiceButton();
    init_ControlGrid();
    init_StatBadge();
    init_GameHud();
    init_GameMenu();
    init_StateGraph();
    init_Canvas2D();
    init_Canvas();
    init_useUnitSpriteAtlas();
    init_GameAudioToggle();
    init_GameAudioCue();
    init_useGameAudio();
    init_useCamera();
    init_TraitStateViewer();
    init_TraitSlot();
    init_editorUtils();
    init_ActionTile();
    init_ActionPalette();
    init_SequenceBar();
    init_puzzleObject();
    init_StateNode();
    init_TransitionArrow();
    init_StateJsonView();
    init_physicsPresets();
    init_GameShell();
  }
});
function formatTick(v) {
  if (Number.isInteger(v)) return String(v);
  return v.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
}
var MathCanvas;
var init_MathCanvas = __esm({
  "components/learning/molecules/MathCanvas.tsx"() {
    "use client";
    init_useEventBus();
    init_perf();
    init_keyMapEvent();
    init_atoms();
    init_Stack();
    init_gameFonts();
    init_LearningCanvas();
    MathCanvas = ({
      className,
      width = 600,
      height = 400,
      title,
      xMin = -10,
      xMax = 10,
      yMin = -10,
      yMax = 10,
      showAxes = true,
      showGrid = true,
      gridStep = 1,
      backgroundColor,
      gridColor = "var(--color-border, #9ca3af)",
      axisColor = "var(--color-muted-foreground, #374151)",
      showTickLabels = false,
      tickLabelFontSize = 10,
      labelFontSize = 12,
      fontFamily: fontFamilyProp,
      showCurveLabels = false,
      curves = [],
      points = [],
      vectors = [],
      regions = [],
      bars = [],
      guides = [],
      angles = [],
      hops = [],
      shapes = [],
      drawables,
      readouts,
      traces,
      interactive = false,
      animate = false,
      onShapeClick,
      keyMap,
      keyUpMap,
      isLoading,
      error
    }) => {
      const eventBus = useEventBus();
      const fontFamily = resolveGameFontFamily(fontFamilyProp);
      const keyMapKey = keyMap ? JSON.stringify(keyMap) : null;
      const keyUpMapKey = keyUpMap ? JSON.stringify(keyUpMap) : null;
      const stableKeyMap = useMemo(() => keyMap, [keyMapKey]);
      const stableKeyUpMap = useMemo(() => keyUpMap, [keyUpMapKey]);
      useEffect(() => {
        if (!stableKeyMap && !stableKeyUpMap) return;
        const onDown = (e) => {
          const ev = resolveKeyMapEvent(stableKeyMap, e);
          if (ev) {
            eventBus.emit(`UI:${ev}`, {});
            e.preventDefault();
          }
        };
        const onUp = (e) => {
          const ev = resolveKeyMapEvent(stableKeyUpMap, e);
          if (ev) eventBus.emit(`UI:${ev}`, {});
        };
        window.addEventListener("keydown", onDown);
        window.addEventListener("keyup", onUp);
        return () => {
          window.removeEventListener("keydown", onDown);
          window.removeEventListener("keyup", onUp);
        };
      }, [stableKeyMap, stableKeyUpMap, eventBus]);
      const derivedShapes = useMemo(() => {
        const _perfT = perfStart("mathcanvas:derive");
        const out = [];
        const margin = 24;
        const plotW = width - margin * 2;
        const plotH = height - margin * 2;
        const mapX = (x) => margin + (x - xMin) / (xMax - xMin) * plotW;
        const mapY = (y) => height - (margin + (y - yMin) / (yMax - yMin) * plotH);
        const xAxisY = Math.max(margin, Math.min(height - margin, mapY(0)));
        const yAxisX = Math.max(margin, Math.min(width - margin, mapX(0)));
        if (showGrid) {
          for (let x = Math.ceil(xMin / gridStep) * gridStep; x <= xMax; x += gridStep) {
            const px = mapX(x);
            out.push({ type: "line", x1: px, y1: margin, x2: px, y2: height - margin, color: gridColor, opacity: 0.35, lineWidth: 1 });
          }
          for (let y = Math.ceil(yMin / gridStep) * gridStep; y <= yMax; y += gridStep) {
            const py = mapY(y);
            out.push({ type: "line", x1: margin, y1: py, x2: width - margin, y2: py, color: gridColor, opacity: 0.35, lineWidth: 1 });
          }
        }
        if (showTickLabels) {
          const labelEveryX = Math.max(1, Math.ceil((xMax - xMin) / gridStep / Math.floor(plotW / 40)));
          let kx = 0;
          for (let x = Math.ceil(xMin / gridStep) * gridStep; x <= xMax; x += gridStep, kx++) {
            if (kx % labelEveryX === 0 && x !== 0) {
              out.push({ type: "text", fontFamily, x: mapX(x), y: xAxisY + 12, text: formatTick(x), color: "#6b7280", fontSize: tickLabelFontSize, align: "center" });
            }
          }
          const labelEveryY = Math.max(1, Math.ceil((yMax - yMin) / gridStep / Math.floor(plotH / 28)));
          let ky = 0;
          for (let y = Math.ceil(yMin / gridStep) * gridStep; y <= yMax; y += gridStep, ky++) {
            if (ky % labelEveryY === 0 && y !== 0) {
              out.push({ type: "text", fontFamily, x: yAxisX - 6, y: mapY(y), text: formatTick(y), color: "#6b7280", fontSize: tickLabelFontSize, align: "right" });
            }
          }
          if (xMin <= 0 && xMax >= 0 && yMin <= 0 && yMax >= 0) {
            out.push({ type: "text", fontFamily, x: yAxisX - 6, y: xAxisY + 12, text: "0", color: "#6b7280", fontSize: tickLabelFontSize, align: "right" });
          }
        }
        for (const region of regions) {
          if (!region.samples || region.samples.length === 0) continue;
          const baseline = region.baseline ?? 0;
          const clampedPoint = (p) => ({
            x: mapX(Math.min(xMax, Math.max(xMin, p.x))),
            y: mapY(Math.min(yMax, Math.max(yMin, p.y)))
          });
          const upper = region.samples.map(clampedPoint);
          const first = region.samples[0];
          const last = region.samples[region.samples.length - 1];
          const closing = region.samples2 && region.samples2.length > 0 ? [...region.samples2].reverse().map(clampedPoint) : [clampedPoint({ x: last.x, y: baseline }), clampedPoint({ x: first.x, y: baseline })];
          const color = region.color ?? "#2563eb";
          out.push({
            type: "polygon",
            points: [...upper, ...closing],
            fill: color,
            color,
            opacity: region.opacity ?? 0.2,
            lineWidth: 1
          });
          if (region.label) {
            const mid = Math.floor(region.samples.length / 2);
            out.push({
              type: "text",
              fontFamily,
              x: mapX((first.x + last.x) / 2),
              y: (mapY(region.samples[mid].y) + mapY(baseline)) / 2,
              text: region.label,
              color,
              fontSize: labelFontSize
            });
          }
        }
        for (const bar of bars) {
          if (bar.x + bar.width < xMin || bar.x > xMax) continue;
          const y0 = bar.y0 ?? 0;
          const color = bar.color ?? "#93c5fd";
          out.push({
            type: "rect",
            x: mapX(bar.x),
            y: mapY(Math.max(y0, bar.y1)),
            width: mapX(bar.x + bar.width) - mapX(bar.x),
            height: Math.abs(mapY(bar.y1) - mapY(y0)),
            color,
            fill: color,
            opacity: bar.opacity ?? 0.5,
            lineWidth: 1
          });
        }
        if (showAxes) {
          out.push({ type: "line", x1: margin, y1: xAxisY, x2: width - margin, y2: xAxisY, color: axisColor, lineWidth: 2 });
          out.push({ type: "line", x1: yAxisX, y1: margin, x2: yAxisX, y2: height - margin, color: axisColor, lineWidth: 2 });
        }
        for (const guide of guides) {
          const color = guide.color ?? "#9ca3af";
          const dash = guide.dash ?? "dashed";
          if (guide.kind === "vline") {
            if (guide.at < xMin || guide.at > xMax) continue;
            const px = mapX(guide.at);
            out.push({ type: "line", x1: px, y1: margin, x2: px, y2: height - margin, color, dash });
            if (guide.label) {
              out.push({ type: "text", fontFamily, x: px + 4, y: margin + 10, text: guide.label, color, fontSize: 11 });
            }
          } else {
            if (guide.at < yMin || guide.at > yMax) continue;
            const py = mapY(guide.at);
            out.push({ type: "line", x1: margin, y1: py, x2: width - margin, y2: py, color, dash });
            if (guide.label) {
              out.push({ type: "text", fontFamily, x: width - margin - 4, y: py - 8, text: guide.label, color, fontSize: labelFontSize, align: "right" });
            }
          }
        }
        for (const curve of curves) {
          if (!curve.samples || curve.samples.length < 2) continue;
          let d = "";
          let penDown = false;
          let lastInRange;
          for (let i = 1; i < curve.samples.length; i++) {
            const a = curve.samples[i - 1];
            const b = curve.samples[i];
            if (a.x < xMin && b.x < xMin || a.x > xMax && b.x > xMax) {
              penDown = false;
              continue;
            }
            const clip = (p, q, xLim) => {
              const t = q.x === p.x ? 0 : (xLim - p.x) / (q.x - p.x);
              return { x: xLim, y: p.y + t * (q.y - p.y) };
            };
            const ca = a.x < xMin ? clip(a, b, xMin) : a.x > xMax ? clip(a, b, xMax) : a;
            const cb = b.x < xMin ? clip(a, b, xMin) : b.x > xMax ? clip(a, b, xMax) : b;
            const pax = mapX(ca.x);
            const pay = mapY(ca.y);
            d += `${penDown ? "L" : "M"} ${pax} ${pay} L ${mapX(cb.x)} ${mapY(cb.y)} `;
            penDown = true;
            if (b.x >= xMin && b.x <= xMax) lastInRange = b;
          }
          if (!d) continue;
          out.push({
            type: "path",
            path: d,
            color: curve.color ?? "#2563eb",
            lineWidth: 2,
            dash: curve.dash
          });
          if (showCurveLabels && curve.label && lastInRange) {
            out.push({
              type: "text",
              fontFamily,
              x: mapX(lastInRange.x) + 6,
              y: mapY(lastInRange.y) - 6,
              text: curve.label,
              color: curve.color ?? "#2563eb",
              fontSize: labelFontSize
            });
          }
        }
        for (const hop of hops) {
          const x1 = mapX(hop.from);
          const x2 = mapX(hop.to);
          const peak = Math.min(36, plotH * 0.3);
          const color = hop.color ?? "#7c3aed";
          out.push({
            type: "ellipse",
            x: (x1 + x2) / 2,
            y: xAxisY,
            width: Math.abs(x2 - x1),
            height: 2 * peak,
            startAngle: 180,
            endAngle: 360,
            color
          });
          const s = Math.sign(hop.to - hop.from);
          out.push({
            type: "polygon",
            points: [
              { x: x2, y: xAxisY },
              { x: x2 - 4 * s, y: xAxisY - 7 },
              { x: x2 + 2 * s, y: xAxisY - 7 }
            ],
            fill: color,
            color
          });
          if (hop.label) {
            out.push({
              type: "text",
              fontFamily,
              x: (x1 + x2) / 2,
              y: xAxisY - peak - 8,
              text: hop.label,
              color,
              fontSize: labelFontSize,
              align: "center"
            });
          }
        }
        for (const angle of angles) {
          const radius = angle.radius ?? 0.8;
          const color = angle.color ?? "#0ea5e9";
          out.push({
            type: "ellipse",
            x: mapX(angle.x),
            y: mapY(angle.y),
            width: 2 * radius * plotW / (xMax - xMin),
            height: 2 * radius * plotH / (yMax - yMin),
            startAngle: -angle.to,
            endAngle: -angle.from,
            color
          });
          if (angle.label) {
            const mid = (angle.from + angle.to) / 2;
            const rad = mid * Math.PI / 180;
            out.push({
              type: "text",
              fontFamily,
              x: mapX(angle.x + 1.35 * radius * Math.cos(rad)),
              y: mapY(angle.y + 1.35 * radius * Math.sin(rad)),
              text: angle.label,
              color,
              fontSize: labelFontSize,
              align: "center"
            });
          }
        }
        for (const p of points) {
          if (p.x < xMin || p.x > xMax || p.y < yMin || p.y > yMax) continue;
          const isOpen = p.style === "open";
          out.push({
            type: "circle",
            x: mapX(p.x),
            y: mapY(p.y),
            radius: p.radius ?? 4,
            color: p.color ?? "#dc2626",
            fill: isOpen ? "#ffffff" : p.color ?? "#dc2626"
          });
          if (p.label) {
            out.push({ type: "text", fontFamily, x: mapX(p.x) + 8, y: mapY(p.y) - 8, text: p.label, color: p.color ?? "#111827", fontSize: labelFontSize });
          }
        }
        for (const v of vectors) {
          if (v.x < xMin || v.x > xMax || v.y < yMin || v.y > yMax) continue;
          const x1 = mapX(v.x);
          const y1 = mapY(v.y);
          const x2 = mapX(v.x + v.vx);
          const y2 = mapY(v.y + v.vy);
          out.push({ type: "arrow", x1, y1, x2, y2, color: v.color ?? "#7c3aed", lineWidth: 2 });
          if (v.label) {
            out.push({ type: "text", fontFamily, x: x2 + 6, y: y2 - 6, text: v.label, color: v.color ?? "#7c3aed", fontSize: labelFontSize });
          }
        }
        out.push(...shapes);
        perfEnd("mathcanvas:derive", _perfT);
        return out;
      }, [
        width,
        height,
        xMin,
        xMax,
        yMin,
        yMax,
        showAxes,
        showGrid,
        gridStep,
        gridColor,
        axisColor,
        showTickLabels,
        tickLabelFontSize,
        labelFontSize,
        fontFamily,
        showCurveLabels,
        curves,
        points,
        vectors,
        regions,
        bars,
        guides,
        angles,
        hops,
        shapes
      ]);
      const projector = useMemo(() => {
        if (!drawables?.length) return void 0;
        const margin = 24;
        const plotW = width - margin * 2;
        const plotH = height - margin * 2;
        const xScale = plotW / (xMax - xMin);
        const mapX = (x) => margin + (x - xMin) / (xMax - xMin) * plotW;
        const mapY = (y) => height - (margin + (y - yMin) / (yMax - yMin) * plotH);
        const project = (pos) => ({ x: mapX(pos.x), y: mapY(pos.y) });
        const anchorPoint = (pos, anchor) => {
          const base = project(pos);
          if (anchor === "top-left") return base;
          const cx = base.x + xScale / 2;
          if (anchor === "ground") return { x: cx, y: base.y + xScale * 0.92 };
          return { x: cx, y: base.y + xScale / 2 };
        };
        const cellPath = (pos) => {
          const base = project(pos);
          return [
            { x: base.x, y: base.y },
            { x: base.x + xScale, y: base.y },
            { x: base.x + xScale, y: base.y + xScale },
            { x: base.x, y: base.y + xScale }
          ];
        };
        return {
          project,
          anchorPoint,
          cellPath,
          tileWidth: xScale,
          floorHeight: xScale / 2,
          diamondTopY: 0,
          squareGrid: true,
          worldPixelDirect: false
        };
      }, [drawables?.length, width, height, xMin, xMax, yMin, yMax]);
      return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        /* @__PURE__ */ jsx(
          LearningCanvas,
          {
            width,
            height,
            backgroundColor,
            fontFamily,
            shapes: derivedShapes,
            drawables,
            projector,
            readouts,
            traces,
            interactive,
            animate,
            onShapeClick,
            isLoading,
            error
          }
        )
      ] }) });
    };
  }
});
function formatMeterValue(v) {
  return Number.isInteger(v) ? String(v) : String(Number(v.toFixed(2)));
}
function sceneObjectShapes(obj, canvasWidth, canvasHeight) {
  const out = [];
  const color = obj.color ?? "#334155";
  switch (obj.kind) {
    case "ground": {
      const xStart = obj.x1 ?? 0;
      const xEnd = obj.x2 ?? canvasWidth;
      const y = obj.y ?? 0;
      out.push({ type: "line", x1: xStart, y1: y, x2: xEnd, y2: y, color, lineWidth: 2 });
      for (let hx = xStart + 7; hx <= xEnd; hx += 14) {
        out.push({ type: "line", x1: hx, y1: y, x2: hx - 7, y2: y + 7, color, lineWidth: 1 });
      }
      if (obj.label) {
        out.push({
          type: "text",
          x: (xStart + xEnd) / 2,
          y: y - 10,
          text: obj.label,
          color: PHYSICS_LABEL_COLOR,
          fontSize: 11,
          align: "center"
        });
      }
      break;
    }
    case "wall": {
      const yStart = obj.y1 ?? 0;
      const yEnd = obj.y2 ?? canvasHeight;
      const x = obj.x ?? 0;
      out.push({ type: "line", x1: x, y1: yStart, x2: x, y2: yEnd, color, lineWidth: 2 });
      for (let hy = yStart + 7; hy <= yEnd; hy += 14) {
        out.push({ type: "line", x1: x, y1: hy, x2: x - 7, y2: hy + 7, color, lineWidth: 1 });
      }
      if (obj.label) {
        out.push({
          type: "text",
          x: x + 12,
          y: (yStart + yEnd) / 2,
          text: obj.label,
          color: PHYSICS_LABEL_COLOR,
          fontSize: 11,
          align: "left"
        });
      }
      break;
    }
    case "ramp": {
      const x1 = obj.x1 ?? 0;
      const y1 = obj.y1 ?? 0;
      const x2 = obj.x2 ?? canvasWidth;
      const y2 = obj.y2 ?? canvasHeight;
      out.push({
        type: "polygon",
        points: [
          { x: x1, y: y1 },
          { x: x2, y: y2 },
          { x: x1, y: y2 }
        ],
        color,
        fill: obj.fill ?? "#e2e8f0",
        lineWidth: 2
      });
      if (obj.label) {
        out.push({
          type: "text",
          x: (2 * x1 + x2) / 3,
          y: (y1 + 2 * y2) / 3,
          text: obj.label,
          color: PHYSICS_LABEL_COLOR,
          fontSize: 11,
          align: "center"
        });
      }
      break;
    }
    case "box": {
      const x = obj.x ?? 0;
      const y = obj.y ?? 0;
      const w = obj.width ?? 40;
      const h = obj.height ?? 40;
      out.push({ type: "rect", x, y, width: w, height: h, color, fill: obj.fill, lineWidth: 2 });
      if (obj.label) {
        out.push({
          type: "text",
          x: x + w / 2,
          y: y + h / 2,
          text: obj.label,
          color: PHYSICS_LABEL_COLOR,
          fontSize: 11,
          align: "center"
        });
      }
      break;
    }
    case "pivot": {
      const x = obj.x ?? 0;
      const y = obj.y ?? 0;
      out.push({ type: "circle", x, y, radius: 5, color, fill: color });
      out.push({ type: "line", x1: x - 14, y1: y - 8, x2: x + 14, y2: y - 8, color, lineWidth: 1 });
      for (let k = 0; k < 5; k++) {
        const hx = x - 14 + 7 * k;
        out.push({ type: "line", x1: hx, y1: y - 8, x2: hx - 6, y2: y - 14, color, lineWidth: 1 });
      }
      if (obj.label) {
        out.push({
          type: "text",
          x,
          y: y - 20,
          text: obj.label,
          color: PHYSICS_LABEL_COLOR,
          fontSize: 11,
          align: "center"
        });
      }
      break;
    }
  }
  return out;
}
function trailShapes(trail) {
  const n = trail.points.length;
  if (n < 2) return [];
  const color = trail.color ?? "#94a3b8";
  const lineWidth = trail.width ?? 2;
  const fade = trail.fade ?? true;
  const globalOpacity = trail.opacity ?? 1;
  const out = [];
  for (let i = 0; i < n - 1; i++) {
    const a = trail.points[i];
    const b = trail.points[i + 1];
    const segmentOpacity = fade ? 0.12 + 0.68 * i / (n - 1) : 0.6;
    out.push({
      type: "line",
      x1: a.x,
      y1: a.y,
      x2: b.x,
      y2: b.y,
      color,
      lineWidth,
      opacity: segmentOpacity * globalOpacity
    });
  }
  return out;
}
function constraintShapes(c, a, b) {
  const color = c.color ?? "#9ca3af";
  const kind = c.kind ?? "rod";
  if (kind === "rod") {
    return [{ type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y, color, lineWidth: 2 }];
  }
  if (kind === "string") {
    return [{ type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y, color, lineWidth: 2, dash: "dashed" }];
  }
  const COILS = 8;
  const AMP = 7;
  const LEAD = 10;
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const dist = Math.max(1e-6, Math.hypot(dx, dy));
  const ux = dx / dist;
  const uy = dy / dist;
  const perpX = -uy;
  const perpY = ux;
  const aPrime = { x: a.x + LEAD * ux, y: a.y + LEAD * uy };
  const bPrime = { x: b.x - LEAD * ux, y: b.y - LEAD * uy };
  const m = 2 * COILS;
  const polyline = [{ x: a.x, y: a.y }, aPrime];
  for (let j = 1; j <= m; j++) {
    const t = j / (m + 1);
    const baseX = aPrime.x + t * (bPrime.x - aPrime.x);
    const baseY = aPrime.y + t * (bPrime.y - aPrime.y);
    const sign = j % 2 === 0 ? 1 : -1;
    polyline.push({ x: baseX + sign * AMP * perpX, y: baseY + sign * AMP * perpY });
  }
  polyline.push(bPrime, { x: b.x, y: b.y });
  const out = [];
  for (let i = 1; i < polyline.length; i++) {
    out.push({
      type: "line",
      x1: polyline[i - 1].x,
      y1: polyline[i - 1].y,
      x2: polyline[i].x,
      y2: polyline[i].y,
      color,
      lineWidth: 2
    });
  }
  return out;
}
function vectorShapes(v, bodyById) {
  let ax;
  let ay;
  if (v.body) {
    const anchor = bodyById.get(v.body);
    if (!anchor) return [];
    ax = anchor.x;
    ay = anchor.y;
  } else {
    ax = v.x ?? 0;
    ay = v.y ?? 0;
  }
  const scale = v.scale ?? 1;
  const color = v.color ?? "#dc2626";
  const tx = ax + v.dx * scale;
  const ty = ay + v.dy * scale;
  const out = [{ type: "arrow", x1: ax, y1: ay, x2: tx, y2: ty, color, lineWidth: 2, dash: v.dash }];
  if (v.label) {
    const dist = Math.max(1e-6, Math.hypot(tx - ax, ty - ay));
    const ux = (tx - ax) / dist;
    const uy = (ty - ay) / dist;
    out.push({
      type: "text",
      x: tx + 8 * ux,
      y: ty + 8 * uy,
      text: v.label,
      color,
      fontSize: 11,
      align: "center"
    });
  }
  return out;
}
function angleMarkerShapes(a) {
  const radius = a.radius ?? 26;
  const color = a.color ?? "#0ea5e9";
  const out = [
    {
      type: "ellipse",
      x: a.x,
      y: a.y,
      width: radius * 2,
      height: radius * 2,
      startAngle: a.from,
      endAngle: a.to,
      color,
      lineWidth: 2
    }
  ];
  if (a.label) {
    const mid = (a.from + a.to) / 2 * (Math.PI / 180);
    out.push({
      type: "text",
      x: a.x + (radius + 13) * Math.cos(mid),
      y: a.y + (radius + 13) * Math.sin(mid),
      text: a.label,
      color,
      fontSize: 11,
      align: "center"
    });
  }
  return out;
}
function fieldShapes(field, canvasWidth, canvasHeight) {
  const spacing = field.spacing ?? 48;
  const size = field.size ?? 14;
  const color = field.color ?? "#94a3b8";
  const regionX = field.x ?? 0;
  const regionY = field.y ?? 0;
  const regionW = field.width ?? canvasWidth;
  const regionH = field.height ?? canvasHeight;
  const out = [];
  for (let gx = regionX + spacing / 2; gx < regionX + regionW; gx += spacing) {
    for (let gy = regionY + spacing / 2; gy < regionY + regionH; gy += spacing) {
      if (field.kind === "arrows") {
        const rad = (field.angle ?? 0) * Math.PI / 180;
        const hx = Math.cos(rad) * size / 2;
        const hy = Math.sin(rad) * size / 2;
        out.push({ type: "arrow", x1: gx - hx, y1: gy - hy, x2: gx + hx, y2: gy + hy, color, lineWidth: 2 });
      } else if (field.kind === "into") {
        const r = size / 3;
        const d = 0.6 * r * Math.SQRT1_2;
        out.push({ type: "circle", x: gx, y: gy, radius: r, color });
        out.push({ type: "line", x1: gx - d, y1: gy - d, x2: gx + d, y2: gy + d, color, lineWidth: 1 });
        out.push({ type: "line", x1: gx - d, y1: gy + d, x2: gx + d, y2: gy - d, color, lineWidth: 1 });
      } else {
        const r = size / 3;
        out.push({ type: "circle", x: gx, y: gy, radius: r, color });
        out.push({ type: "circle", x: gx, y: gy, radius: 1.5, color, fill: color });
      }
    }
  }
  return out;
}
function meterShapes(meters, canvasHeight) {
  const n = meters.length;
  const out = [];
  const sharedMax = Math.max(1e-6, ...meters.map((m) => m.value));
  meters.forEach((meter, i) => {
    const rowY = canvasHeight - 10 - 16 * (n - i);
    const color = meter.color ?? "#3b82f6";
    const M = meter.max ?? sharedMax;
    const w = Math.round(Math.min(1, Math.max(0, meter.value / M)) * 110);
    out.push({ type: "text", x: 8, y: rowY + 8, text: meter.label, color: PHYSICS_LABEL_COLOR, fontSize: 10 });
    out.push({ type: "rect", x: 52, y: rowY, width: w, height: 10, color, fill: color });
    out.push({
      type: "text",
      x: 166,
      y: rowY + 8,
      text: formatMeterValue(meter.value),
      color: "#6b7280",
      fontSize: 9
    });
  });
  return out;
}
var physicsLog2, PHYSICS_LABEL_COLOR, PhysicsCanvas;
var init_PhysicsCanvas = __esm({
  "components/learning/molecules/PhysicsCanvas.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_LearningCanvas();
    init_learningScene3D();
    physicsLog2 = createLogger("almadar:ui:physics-canvas");
    PHYSICS_LABEL_COLOR = "#374151";
    PhysicsCanvas = ({
      className,
      width = 600,
      height = 400,
      title,
      backgroundColor,
      mode = "2d",
      camera,
      lighting,
      post,
      bodies = [],
      constraints = [],
      showVelocity = true,
      showForces = false,
      velocityScale = 20,
      forceScale = 20,
      sceneObjects = [],
      trails = [],
      vectors = [],
      surface3d,
      vectors3d = [],
      vectorScale = 1,
      angles = [],
      field,
      meters = [],
      shapes = [],
      readouts,
      traces,
      showGrid,
      shadows,
      interactive,
      animate = false,
      onShapeClick,
      isLoading,
      error
    }) => {
      const derivedShapes = useMemo(() => {
        const out = [];
        const bodyById = /* @__PURE__ */ new Map();
        for (const b of bodies) {
          if (b.id) bodyById.set(b.id, b);
        }
        if (field) out.push(...fieldShapes(field, width, height));
        for (const obj of sceneObjects) out.push(...sceneObjectShapes(obj, width, height));
        for (const trail of trails) out.push(...trailShapes(trail));
        for (const c of constraints) {
          const a = bodyById.get(c.from);
          const b = bodyById.get(c.to);
          if (!a || !b) continue;
          out.push(...constraintShapes(c, a, b));
        }
        for (const b of bodies) {
          out.push({
            type: "circle",
            x: b.x,
            y: b.y,
            radius: b.radius ?? 12,
            color: b.color ?? "#2563eb",
            fill: b.color ?? "#2563eb",
            id: b.id
          });
          if (b.label) {
            out.push({
              type: "text",
              x: b.x + (b.radius ?? 12) + 6,
              y: b.y - (b.radius ?? 12) - 6,
              text: b.label,
              color: "#111827",
              fontSize: 12
            });
          }
          if (showVelocity && b.vx != null && b.vy != null && (b.vx !== 0 || b.vy !== 0)) {
            out.push({
              type: "arrow",
              x1: b.x,
              y1: b.y,
              x2: b.x + b.vx * velocityScale,
              y2: b.y + b.vy * velocityScale,
              color: "#16a34a",
              lineWidth: 2
            });
          }
          if (showForces && b.fx != null && b.fy != null && (b.fx !== 0 || b.fy !== 0)) {
            out.push({
              type: "arrow",
              x1: b.x,
              y1: b.y,
              x2: b.x + b.fx * forceScale,
              y2: b.y + b.fy * forceScale,
              color: "#dc2626",
              lineWidth: 2
            });
          }
        }
        for (const v of vectors) out.push(...vectorShapes(v, bodyById));
        for (const a of angles) out.push(...angleMarkerShapes(a));
        if (meters.length > 0) out.push(...meterShapes(meters, height));
        out.push(...shapes);
        return out;
      }, [
        bodies,
        constraints,
        showVelocity,
        showForces,
        velocityScale,
        forceScale,
        sceneObjects,
        trails,
        vectors,
        angles,
        field,
        meters,
        shapes,
        width,
        height
      ]);
      const drawables3D = useMemo(() => {
        if (mode !== "3d") return [];
        if (shapes.length > 0) {
          physicsLog2.debug("shapes ignored in 3D mode (pixel-authored 2D vocabulary)", { count: shapes.length });
        }
        if (sceneObjects.length > 0) {
          physicsLog2.debug("sceneObjects ignored in 3D mode (pixel-authored 2D vocabulary)", { count: sceneObjects.length });
        }
        if (vectors.length > 0) {
          physicsLog2.debug("vectors ignored in 3D mode (pixel-authored 2D vocabulary)", { count: vectors.length });
        }
        if (angles.length > 0) {
          physicsLog2.debug("angles ignored in 3D mode (pixel-authored 2D vocabulary)", { count: angles.length });
        }
        if (field) {
          physicsLog2.debug("field ignored in 3D mode (pixel-authored 2D vocabulary)");
        }
        if (meters.length > 0) {
          physicsLog2.debug("meters ignored in 3D mode (pixel-authored 2D vocabulary)", { count: meters.length });
        }
        if (animate) {
          physicsLog2.debug("animate ignored in 3D mode (motion is entity-state driven)");
        }
        const out = [];
        const labelColor = labelColorForBackground(backgroundColor);
        const bodyById = /* @__PURE__ */ new Map();
        for (const b of bodies) {
          if (b.id) bodyById.set(b.id, b);
        }
        for (const c of constraints) {
          const a = bodyById.get(c.from);
          const b = bodyById.get(c.to);
          if (!a || !b) continue;
          const rodRadius = Math.max(0.05, Math.min(a.radius ?? 0.5, b.radius ?? 0.5) * 0.15);
          const rod = cylinderBetween([a.x, a.y, a.z ?? 0], [b.x, b.y, b.z ?? 0], rodRadius, c.color ?? "#9ca3af");
          if (rod) out.push(rod);
        }
        for (const b of bodies) {
          const radius = b.radius ?? 0.5;
          const bz = b.z ?? 0;
          out.push(meshSphere(b.id, b.x, b.y, bz, radius, b.color ?? "#2563eb"));
          if (b.label) {
            out.push(billboardLabel(b.label, b.x, b.y, bz + radius, { color: labelColor }));
          }
          const vx = b.vx ?? 0;
          const vy = b.vy ?? 0;
          const vz = b.vz ?? 0;
          const arrowRadius = Math.max(0.05, radius * 0.15);
          if (showVelocity && (vx !== 0 || vy !== 0 || vz !== 0)) {
            const arrow = arrowBetween(
              [b.x, b.y, bz],
              [b.x + vx * velocityScale, b.y + vy * velocityScale, bz + vz * velocityScale],
              "#16a34a",
              arrowRadius
            );
            if (arrow) out.push(arrow);
          }
          const fx = b.fx ?? 0;
          const fy = b.fy ?? 0;
          const fz = b.fz ?? 0;
          if (showForces && (fx !== 0 || fy !== 0 || fz !== 0)) {
            const arrow = arrowBetween(
              [b.x, b.y, bz],
              [b.x + fx * forceScale, b.y + fy * forceScale, bz + fz * forceScale],
              "#dc2626",
              arrowRadius
            );
            if (arrow) out.push(arrow);
          }
        }
        for (const trail of trails) {
          if (trail.fade !== void 0) {
            physicsLog2.debug("trail.fade ignored in 3D mode (2D-only fade curve \u2014 3D draws an opaque tube)", { id: trail.id });
          }
          const points = trail.points.map((p) => [p.x, p.y, p.z ?? 0]);
          out.push(
            ...polylineTube(points, trail.width ?? 0.05, trail.color ?? "#94a3b8", {
              ...trail.opacity !== void 0 ? { opacity: trail.opacity } : {}
            })
          );
        }
        if (surface3d) {
          out.push(...heightFieldMesh(surface3d));
        }
        if (vectors3d.length > 0) {
          out.push(
            ...arrowField(
              vectors3d.map((v) => ({
                id: v.id,
                from: [v.x, v.y, v.z ?? 0],
                delta: [v.dx, v.dy, v.dz ?? 0],
                color: v.color,
                label: v.label,
                width: v.width
              })),
              { scale: vectorScale, labelColor }
            )
          );
        }
        return out;
      }, [
        mode,
        bodies,
        constraints,
        showVelocity,
        showForces,
        velocityScale,
        forceScale,
        shapes,
        sceneObjects,
        trails,
        vectors,
        surface3d,
        vectors3d,
        vectorScale,
        angles,
        field,
        meters,
        animate,
        backgroundColor
      ]);
      const bodyIndexById = useMemo(() => {
        const m = /* @__PURE__ */ new Map();
        vectors3d.forEach((v, i) => {
          if (v.id) m.set(v.id, i);
        });
        bodies.forEach((b, i) => {
          if (b.id) m.set(b.id, i);
        });
        return m;
      }, [bodies, vectors3d]);
      if (mode === "3d") {
        return /* @__PURE__ */ jsx(
          LearningScene3D,
          {
            className,
            width,
            height,
            title,
            backgroundColor,
            drawables: drawables3D,
            camera,
            lighting,
            post,
            showGrid,
            shadows,
            interactive,
            isLoading,
            error,
            onItemClick: get3DClickPayload(onShapeClick, bodyIndexById)
          }
        );
      }
      return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        /* @__PURE__ */ jsx(
          LearningCanvas,
          {
            width,
            height,
            backgroundColor,
            shapes: derivedShapes,
            readouts,
            traces,
            interactive: interactive ?? false,
            animate,
            onShapeClick,
            isLoading,
            error
          }
        )
      ] }) });
    };
  }
});

// lib/graphViewLayouts.ts
function buildAdjacency(nodeIds, edges) {
  const known = new Set(nodeIds);
  const out = /* @__PURE__ */ new Map();
  const inMap = /* @__PURE__ */ new Map();
  for (const id of nodeIds) {
    out.set(id, []);
    inMap.set(id, []);
  }
  for (const edge of edges) {
    if (!known.has(edge.source) || !known.has(edge.target)) continue;
    out.get(edge.source)?.push(edge.target);
    inMap.get(edge.target)?.push(edge.source);
  }
  return { out, in: inMap };
}
function findRoots(nodeIds, adjacency) {
  return nodeIds.filter((id) => (adjacency.in.get(id)?.length ?? 0) === 0);
}
function assignLayers(nodeIds, adjacency, roots) {
  const layer = new Map(nodeIds.map((id) => [id, 0]));
  const onStack = /* @__PURE__ */ new Set();
  const visit = (id) => {
    onStack.add(id);
    const currentLayer = layer.get(id) ?? 0;
    for (const next of adjacency.out.get(id) ?? []) {
      if (onStack.has(next)) continue;
      const candidate = currentLayer + 1;
      if (candidate > (layer.get(next) ?? 0)) {
        layer.set(next, candidate);
      }
      visit(next);
    }
    onStack.delete(id);
  };
  for (const root of roots) visit(root);
  return layer;
}
function computeVisitOrder(nodeIds, adjacency, roots) {
  const order = /* @__PURE__ */ new Map();
  const visited = /* @__PURE__ */ new Set();
  let counter = 0;
  const visit = (id) => {
    if (visited.has(id)) return;
    visited.add(id);
    order.set(id, counter++);
    for (const next of adjacency.out.get(id) ?? []) visit(next);
  };
  for (const root of roots) visit(root);
  for (const id of nodeIds) {
    if (!visited.has(id)) order.set(id, counter++);
  }
  return order;
}
function bfsDepthAndOrder(nodeIds, adjacency, roots) {
  const depth = new Map(nodeIds.map((id) => [id, 0]));
  const visitOrder = /* @__PURE__ */ new Map();
  const visited = /* @__PURE__ */ new Set();
  const queue = [];
  let counter = 0;
  for (const root of roots) {
    if (visited.has(root)) continue;
    visited.add(root);
    depth.set(root, 0);
    visitOrder.set(root, counter++);
    queue.push(root);
  }
  let head = 0;
  while (head < queue.length) {
    const id = queue[head++];
    const d = depth.get(id) ?? 0;
    for (const next of adjacency.out.get(id) ?? []) {
      if (visited.has(next)) continue;
      visited.add(next);
      depth.set(next, d + 1);
      visitOrder.set(next, counter++);
      queue.push(next);
    }
  }
  for (const id of nodeIds) {
    if (!visited.has(id)) visitOrder.set(id, counter++);
  }
  return { depth, visitOrder };
}
function edgeWalkOrder(nodeIds, adjacency) {
  const visited = /* @__PURE__ */ new Set();
  const result = [];
  for (const start of nodeIds) {
    if (visited.has(start)) continue;
    let current = start;
    while (current !== void 0 && !visited.has(current)) {
      visited.add(current);
      result.push(current);
      const outs = adjacency.out.get(current) ?? [];
      current = outs.find((next) => !visited.has(next));
    }
  }
  return result;
}
function groupByTier(nodeIds, tierOf, maxTier) {
  const groups = Array.from({ length: maxTier + 1 }, () => []);
  for (const id of nodeIds) {
    groups[tierOf.get(id) ?? 0].push(id);
  }
  return groups;
}
function distributeAxis(count, start, end) {
  if (count <= 0) return [];
  const slot = (end - start) / count;
  return Array.from({ length: count }, (_, i) => start + slot * (i + 0.5));
}
function orderByParentPositionThenInput(group, adjacency, positioned, inputIndex) {
  const withKey = group.map((id) => {
    const parentValues = (adjacency.in.get(id) ?? []).map((p) => positioned.get(p)).filter((v) => v !== void 0);
    const avg = parentValues.length > 0 ? parentValues.reduce((a, b) => a + b, 0) / parentValues.length : Number.POSITIVE_INFINITY;
    return { id, avg, idx: inputIndex.get(id) ?? 0 };
  });
  withKey.sort((a, b) => a.avg !== b.avg ? a.avg - b.avg : a.idx - b.idx);
  return withKey.map((k) => k.id);
}
function layoutFlow(nodeIds, adjacency, roots, width, height, margin) {
  const inputIndex = new Map(nodeIds.map((id, i) => [id, i]));
  const layers = assignLayers(nodeIds, adjacency, roots);
  const maxLayer = Math.max(...Array.from(layers.values()));
  const layerGroups = groupByTier(nodeIds, layers, maxLayer);
  const positions = /* @__PURE__ */ new Map();
  const yById = /* @__PURE__ */ new Map();
  for (let l = 0; l <= maxLayer; l++) {
    const x = margin + l * (width - 2 * margin) / Math.max(1, maxLayer);
    const ordered2 = orderByParentPositionThenInput(layerGroups[l], adjacency, yById, inputIndex);
    const ys = distributeAxis(ordered2.length, margin, height - margin);
    ordered2.forEach((id, i) => {
      positions.set(id, { id, x, y: ys[i] });
      yById.set(id, ys[i]);
    });
  }
  return nodeIds.map((id) => positions.get(id));
}
function layoutTree2(nodeIds, adjacency, roots, width, height, margin) {
  const effectiveRoots = roots.length > 0 ? roots : [nodeIds[0]];
  const layers = assignLayers(nodeIds, adjacency, effectiveRoots);
  const maxLayer = Math.max(...Array.from(layers.values()));
  const visitOrder = computeVisitOrder(nodeIds, adjacency, effectiveRoots);
  const layerGroups = groupByTier(nodeIds, layers, maxLayer);
  const positions = /* @__PURE__ */ new Map();
  for (let l = 0; l <= maxLayer; l++) {
    const ordered2 = [...layerGroups[l]].sort(
      (a, b) => (visitOrder.get(a) ?? 0) - (visitOrder.get(b) ?? 0)
    );
    const y = margin + l * (height - 2 * margin) / Math.max(1, maxLayer);
    const xs = distributeAxis(ordered2.length, margin, width - margin);
    ordered2.forEach((id, i) => positions.set(id, { id, x: xs[i], y }));
  }
  return nodeIds.map((id) => positions.get(id));
}
function layoutRadial(nodeIds, adjacency, roots, width, height, margin) {
  const cx = width / 2;
  const cy = height / 2;
  const maxRadius = Math.min(width, height) / 2 - margin;
  if (roots.length === 0) {
    const order = edgeWalkOrder(nodeIds, adjacency);
    const k = order.length;
    const positions2 = /* @__PURE__ */ new Map();
    order.forEach((id, i) => {
      const angle = i / k * 2 * Math.PI;
      positions2.set(id, { id, x: cx + maxRadius * Math.cos(angle), y: cy + maxRadius * Math.sin(angle) });
    });
    return nodeIds.map((id) => positions2.get(id));
  }
  const { depth, visitOrder } = bfsDepthAndOrder(nodeIds, adjacency, roots);
  const maxDepth = Math.max(...Array.from(depth.values()));
  const ringGroups = groupByTier(nodeIds, depth, maxDepth);
  const positions = /* @__PURE__ */ new Map();
  for (let d = 0; d <= maxDepth; d++) {
    const ordered2 = [...ringGroups[d]].sort(
      (a, b) => (visitOrder.get(a) ?? 0) - (visitOrder.get(b) ?? 0)
    );
    const radius = d * maxRadius / Math.max(1, maxDepth);
    const k = ordered2.length;
    ordered2.forEach((id, i) => {
      const angle = i / k * 2 * Math.PI;
      positions.set(id, { id, x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) });
    });
  }
  return nodeIds.map((id) => positions.get(id));
}
function computeStaticLayout(mode, input) {
  const { nodeIds, edges, width, height } = input;
  const margin = input.margin ?? 40;
  if (nodeIds.length === 0) return [];
  if (nodeIds.length === 1) return [{ id: nodeIds[0], x: width / 2, y: height / 2 }];
  const adjacency = buildAdjacency(nodeIds, edges);
  const roots = findRoots(nodeIds, adjacency);
  if (mode === "flow") return layoutFlow(nodeIds, adjacency, roots, width, height, margin);
  if (mode === "tree") return layoutTree2(nodeIds, adjacency, roots, width, height, margin);
  return layoutRadial(nodeIds, adjacency, roots, width, height, margin);
}
var init_graphViewLayouts = __esm({
  "lib/graphViewLayouts.ts"() {
  }
});
function resolveNodeColor(node, groups) {
  if (node.color) return node.color;
  if (node.group) {
    const idx = groups.indexOf(node.group);
    return GROUP_COLORS[idx % GROUP_COLORS.length];
  }
  return DEFAULT_NODE_COLOR;
}
var GROUP_COLORS, DEFAULT_NODE_COLOR, DEFAULT_EDGE_COLOR, DEFAULT_NODE_SIZE, GraphView;
var init_GraphView = __esm({
  "components/core/molecules/GraphView.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_graphViewLayouts();
    GROUP_COLORS = [
      "#3b82f6",
      // blue-500
      "#10b981",
      // emerald-500
      "#f59e0b",
      // amber-500
      "#ef4444",
      // red-500
      "#8b5cf6",
      // violet-500
      "#ec4899",
      // pink-500
      "#06b6d4",
      // cyan-500
      "#84cc16"
      // lime-500
    ];
    DEFAULT_NODE_COLOR = "#3b82f6";
    DEFAULT_EDGE_COLOR = "#9ca3af";
    DEFAULT_NODE_SIZE = 8;
    GraphView = ({
      nodes,
      edges,
      onNodeClick,
      onNodeHover,
      width: propWidth,
      height: propHeight,
      className,
      showLabels = true,
      zoomToFit = true,
      layout = "force"
    }) => {
      const { t } = useTranslate();
      const containerRef = useRef(null);
      const animRef = useRef(0);
      const arrowMarkerId = useId();
      const [simNodes, setSimNodes] = useState([]);
      const [settled, setSettled] = useState(false);
      const [hoveredId, setHoveredId] = useState(null);
      const [dimensions, setDimensions] = useState({ width: propWidth ?? 600, height: propHeight ?? 400 });
      const w = propWidth ?? dimensions.width;
      const h = propHeight ?? dimensions.height;
      const groups = useMemo(
        () => [...new Set(nodes.map((n) => n.group).filter((g) => Boolean(g)))],
        [nodes]
      );
      const connectedIds = useMemo(() => {
        if (!hoveredId) return /* @__PURE__ */ new Set();
        const connected = /* @__PURE__ */ new Set([hoveredId]);
        for (const edge of edges) {
          if (edge.source === hoveredId) connected.add(edge.target);
          if (edge.target === hoveredId) connected.add(edge.source);
        }
        return connected;
      }, [hoveredId, edges]);
      useEffect(() => {
        if (propWidth && propHeight) return;
        const el = containerRef.current;
        if (!el) return;
        const update = () => {
          setDimensions({
            width: el.clientWidth || 600,
            height: el.clientHeight || 400
          });
        };
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
      }, [propWidth, propHeight]);
      useEffect(() => {
        if (nodes.length === 0) {
          setSimNodes([]);
          setSettled(true);
          return;
        }
        const initialNodes = nodes.map((n, idx) => {
          const angle = idx / nodes.length * 2 * Math.PI;
          const radius = Math.min(w, h) * 0.3;
          return {
            id: n.id,
            label: n.label,
            color: resolveNodeColor(n, groups),
            size: n.size ?? DEFAULT_NODE_SIZE,
            group: n.group,
            x: w / 2 + radius * Math.cos(angle) + (Math.random() - 0.5) * 20,
            y: h / 2 + radius * Math.sin(angle) + (Math.random() - 0.5) * 20,
            vx: 0,
            vy: 0,
            fx: 0,
            fy: 0
          };
        });
        if (layout !== "force") {
          const points = computeStaticLayout(layout, {
            nodeIds: nodes.map((n) => n.id),
            edges,
            width: w,
            height: h
          });
          const pointById = new Map(points.map((p) => [p.id, p]));
          const laidOut = initialNodes.map((node) => {
            const point = pointById.get(node.id);
            return point ? { ...node, x: point.x, y: point.y } : node;
          });
          setSimNodes(laidOut);
          setSettled(true);
          return;
        }
        let iterations = 0;
        const maxIterations = 120;
        let currentNodes = initialNodes;
        const tick = () => {
          const centerX = w / 2;
          const centerY = h / 2;
          for (const node of currentNodes) {
            node.fx = 0;
            node.fy = 0;
          }
          for (let i = 0; i < currentNodes.length; i++) {
            for (let j = i + 1; j < currentNodes.length; j++) {
              const a = currentNodes[i];
              const b = currentNodes[j];
              const dx = b.x - a.x;
              const dy = b.y - a.y;
              const dist = Math.sqrt(dx * dx + dy * dy) || 1;
              const force = 800 / (dist * dist);
              const fx = dx / dist * force;
              const fy = dy / dist * force;
              a.fx -= fx;
              a.fy -= fy;
              b.fx += fx;
              b.fy += fy;
            }
          }
          for (const edge of edges) {
            const source = currentNodes.find((n) => n.id === edge.source);
            const target = currentNodes.find((n) => n.id === edge.target);
            if (!source || !target) continue;
            const dx = target.x - source.x;
            const dy = target.y - source.y;
            const dist = Math.sqrt(dx * dx + dy * dy) || 1;
            const force = (dist - 100) * 0.05;
            const fx = dx / dist * force;
            const fy = dy / dist * force;
            source.fx += fx;
            source.fy += fy;
            target.fx -= fx;
            target.fy -= fy;
          }
          for (const node of currentNodes) {
            node.fx += (centerX - node.x) * 0.01;
            node.fy += (centerY - node.y) * 0.01;
          }
          const damping = 0.85;
          const margin = 40;
          for (const node of currentNodes) {
            node.vx = (node.vx + node.fx) * damping;
            node.vy = (node.vy + node.fy) * damping;
            node.x += node.vx;
            node.y += node.vy;
            node.x = Math.max(margin, Math.min(w - margin, node.x));
            node.y = Math.max(margin, Math.min(h - margin, node.y));
          }
          iterations++;
          setSimNodes([...currentNodes]);
          if (iterations < maxIterations) {
            animRef.current = requestAnimationFrame(tick);
          } else {
            setSettled(true);
          }
        };
        setSettled(false);
        animRef.current = requestAnimationFrame(tick);
        return () => {
          cancelAnimationFrame(animRef.current);
        };
      }, [nodes, edges, w, h, groups, layout]);
      const viewBox = useMemo(() => {
        if (!zoomToFit || !settled || simNodes.length === 0) {
          return `0 0 ${w} ${h}`;
        }
        const pad = 60;
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for (const node of simNodes) {
          minX = Math.min(minX, node.x - node.size);
          minY = Math.min(minY, node.y - node.size);
          maxX = Math.max(maxX, node.x + node.size);
          maxY = Math.max(maxY, node.y + node.size);
        }
        const fitW = maxX - minX + pad * 2;
        const fitH = maxY - minY + pad * 2;
        return `${minX - pad} ${minY - pad} ${fitW} ${fitH}`;
      }, [zoomToFit, settled, simNodes, w, h]);
      const nodeMap = useMemo(() => {
        const map = /* @__PURE__ */ new Map();
        for (const n of simNodes) {
          map.set(n.id, n);
        }
        return map;
      }, [simNodes]);
      const handleNodeMouseEnter = useCallback(
        (node) => {
          setHoveredId(node.id);
          if (onNodeHover) {
            onNodeHover({ id: node.id, label: node.label, color: node.color, size: node.size, group: node.group });
          }
        },
        [onNodeHover]
      );
      const handleNodeMouseLeave = useCallback(() => {
        setHoveredId(null);
        if (onNodeHover) {
          onNodeHover(null);
        }
      }, [onNodeHover]);
      const handleNodeClickInternal = useCallback(
        (node) => {
          if (onNodeClick) {
            onNodeClick({ id: node.id, label: node.label, color: node.color, size: node.size, group: node.group });
          }
        },
        [onNodeClick]
      );
      const handleNodePointerDown = useCallback(
        (e, node) => {
          if (e.pointerType === "mouse") return;
          handleNodeMouseEnter(node);
          handleNodeClickInternal(node);
        },
        [handleNodeMouseEnter, handleNodeClickInternal]
      );
      if (nodes.length === 0) {
        return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center", className), style: { width: w, height: h }, children: /* @__PURE__ */ jsx(Box, { className: "text-muted-foreground text-sm", children: t("display.noGraphData") }) });
      }
      return /* @__PURE__ */ jsx(
        Box,
        {
          ref: containerRef,
          className: cn("relative overflow-hidden rounded-lg border border-border bg-card", className),
          style: { width: propWidth ?? "100%", height: h },
          children: /* @__PURE__ */ jsxs(
            "svg",
            {
              width: "100%",
              height: "100%",
              viewBox,
              preserveAspectRatio: "xMidYMid meet",
              children: [
                layout !== "force" && /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
                  "marker",
                  {
                    id: arrowMarkerId,
                    viewBox: "0 0 10 10",
                    refX: "9",
                    refY: "5",
                    markerWidth: "6",
                    markerHeight: "6",
                    orient: "auto-start-reverse",
                    children: /* @__PURE__ */ jsx("path", { d: "M0,0 L10,5 L0,10 z", fill: "currentColor" })
                  }
                ) }),
                edges.map((edge, idx) => {
                  const source = nodeMap.get(edge.source);
                  const target = nodeMap.get(edge.target);
                  if (!source || !target) return null;
                  const isHighlighted = hoveredId ? connectedIds.has(edge.source) && connectedIds.has(edge.target) : true;
                  return /* @__PURE__ */ jsxs("g", { children: [
                    /* @__PURE__ */ jsx(
                      "line",
                      {
                        x1: source.x,
                        y1: source.y,
                        x2: target.x,
                        y2: target.y,
                        stroke: edge.color ?? DEFAULT_EDGE_COLOR,
                        color: edge.color ?? DEFAULT_EDGE_COLOR,
                        strokeWidth: 1.5,
                        opacity: isHighlighted ? 0.8 : 0.15,
                        markerEnd: layout !== "force" ? `url(#${arrowMarkerId})` : void 0
                      }
                    ),
                    showLabels && edge.label && /* @__PURE__ */ jsx(
                      "text",
                      {
                        x: (source.x + target.x) / 2,
                        y: (source.y + target.y) / 2 - 6,
                        textAnchor: "middle",
                        fill: "var(--color-muted-foreground)",
                        fontSize: 9,
                        opacity: isHighlighted ? 0.9 : 0.2,
                        children: edge.label
                      }
                    )
                  ] }, `edge-${idx}`);
                }),
                simNodes.map((node) => {
                  const isHighlighted = hoveredId ? connectedIds.has(node.id) : true;
                  const isHovered = hoveredId === node.id;
                  return /* @__PURE__ */ jsxs(
                    "g",
                    {
                      style: { cursor: onNodeClick ? "pointer" : "default" },
                      onMouseEnter: () => handleNodeMouseEnter(node),
                      onMouseLeave: handleNodeMouseLeave,
                      onClick: () => handleNodeClickInternal(node),
                      onPointerDown: (e) => handleNodePointerDown(e, node),
                      children: [
                        /* @__PURE__ */ jsx(
                          "circle",
                          {
                            cx: node.x,
                            cy: node.y,
                            r: isHovered ? node.size * 1.4 : node.size,
                            fill: node.color,
                            opacity: isHighlighted ? 1 : 0.3,
                            stroke: isHovered ? "#ffffff" : "none",
                            strokeWidth: isHovered ? 2 : 0
                          }
                        ),
                        showLabels && /* @__PURE__ */ jsx(
                          "text",
                          {
                            x: node.x,
                            y: node.y + node.size + 12,
                            textAnchor: "middle",
                            fill: "var(--color-foreground)",
                            fontSize: 11,
                            fontWeight: isHovered ? "bold" : "normal",
                            opacity: isHighlighted ? 0.9 : 0.2,
                            children: node.label ?? node.id
                          }
                        )
                      ]
                    },
                    node.id
                  );
                })
              ]
            }
          )
        }
      );
    };
    GraphView.displayName = "GraphView";
  }
});
function MapView(props) {
  return /* @__PURE__ */ jsx(
    Suspense,
    {
      fallback: /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("relative w-full overflow-hidden rounded-lg bg-muted/20", props.className),
          style: { height: props.height ?? "400px" },
          "data-testid": "map-view"
        }
      ),
      children: /* @__PURE__ */ jsx(MapViewImpl, { ...props })
    }
  );
}
var MapViewImpl;
var init_MapView = __esm({
  "components/core/molecules/MapView.tsx"() {
    "use client";
    init_Box();
    init_cn();
    MapViewImpl = lazy(async () => {
      const [reactLeaflet, leafletMod] = await Promise.all([
        import('react-leaflet'),
        import('leaflet')
      ]);
      await import('leaflet/dist/leaflet.css');
      const { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } = reactLeaflet;
      const L = leafletMod.default;
      const defaultIcon = L.icon({
        iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
        iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
        shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      });
      L.Marker.prototype.options.icon = defaultIcon;
      const { useEffect: useEffect72, useRef: useRef70, useCallback: useCallback109, useState: useState109 } = React79__default;
      const { Typography: Typography2 } = await Promise.resolve().then(() => (init_Typography(), Typography_exports));
      const { useEventBus: useEventBus2 } = await Promise.resolve().then(() => (init_useEventBus(), useEventBus_exports));
      function MapUpdater({ centerLat, centerLng, zoom }) {
        const map = useMap();
        const prevRef = useRef70({ centerLat, centerLng, zoom });
        useEffect72(() => {
          const prev = prevRef.current;
          if (prev.centerLat !== centerLat || prev.centerLng !== centerLng || prev.zoom !== zoom) {
            map.setView([centerLat, centerLng], zoom);
            prevRef.current = { centerLat, centerLng, zoom };
          }
        }, [map, centerLat, centerLng, zoom]);
        return null;
      }
      function MapClickHandler({ onMapClick }) {
        const map = useMap();
        useEffect72(() => {
          if (!onMapClick) return;
          const handler = (e) => {
            onMapClick(e.latlng.lat, e.latlng.lng);
          };
          map.on("click", handler);
          return () => {
            map.off("click", handler);
          };
        }, [map, onMapClick]);
        return null;
      }
      function MapViewInner({
        markers = [],
        routes = [],
        centerLat = 51.505,
        centerLng = -0.09,
        zoom = 13,
        height = "400px",
        onMarkerClick,
        onMapClick,
        mapClickEvent,
        markerClickEvent,
        showClickedPin = false,
        className,
        showAttribution = true
      }) {
        const eventBus = useEventBus2();
        const [clickedPosition, setClickedPosition] = useState109(null);
        const handleMapClick = useCallback109((lat, lng) => {
          if (showClickedPin) {
            setClickedPosition({ lat, lng });
          }
          onMapClick?.(lat, lng);
          if (mapClickEvent) {
            eventBus.emit(`UI:${mapClickEvent}`, { latitude: lat, longitude: lng });
          }
        }, [onMapClick, mapClickEvent, eventBus, showClickedPin]);
        const handleMarkerClick = useCallback109((marker) => {
          onMarkerClick?.(marker);
          if (markerClickEvent) {
            eventBus.emit(`UI:${markerClickEvent}`, { ...marker });
          }
        }, [onMarkerClick, markerClickEvent, eventBus]);
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: cn("relative isolate z-0 w-full overflow-hidden rounded-lg", className),
            style: { height },
            "data-testid": "map-view",
            children: /* @__PURE__ */ jsxs(
              MapContainer,
              {
                center: [centerLat, centerLng],
                zoom,
                style: { height: "100%", width: "100%" },
                attributionControl: showAttribution,
                children: [
                  /* @__PURE__ */ jsx(
                    TileLayer,
                    {
                      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                      attribution: showAttribution ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' : void 0
                    }
                  ),
                  /* @__PURE__ */ jsx(MapUpdater, { centerLat, centerLng, zoom }),
                  /* @__PURE__ */ jsx(MapClickHandler, { onMapClick: handleMapClick }),
                  showClickedPin && clickedPosition && /* @__PURE__ */ jsx(Marker, { position: [clickedPosition.lat, clickedPosition.lng], children: /* @__PURE__ */ jsx(Popup, { children: /* @__PURE__ */ jsxs(Typography2, { variant: "body2", children: [
                    clickedPosition.lat.toFixed(5),
                    ", ",
                    clickedPosition.lng.toFixed(5)
                  ] }) }) }),
                  markers.map((marker) => /* @__PURE__ */ jsx(
                    Marker,
                    {
                      position: [marker.lat, marker.lng],
                      eventHandlers: onMarkerClick || markerClickEvent ? { click: () => handleMarkerClick(marker) } : void 0,
                      children: marker.label ? /* @__PURE__ */ jsxs(Popup, { children: [
                        /* @__PURE__ */ jsx(Typography2, { variant: "body2", children: marker.label }),
                        marker.category ? /* @__PURE__ */ jsx(Typography2, { variant: "caption", className: "text-muted-foreground", children: marker.category }) : null
                      ] }) : null
                    },
                    marker.id
                  )),
                  routes.map((route) => /* @__PURE__ */ jsx(
                    Polyline,
                    {
                      positions: route.waypoints.map((wp) => [wp.lat, wp.lng]),
                      pathOptions: {
                        color: route.color ?? "var(--primary, #2563eb)",
                        weight: route.weight ?? 4,
                        opacity: route.opacity ?? 0.8,
                        dashArray: route.dashArray
                      },
                      children: route.label ? /* @__PURE__ */ jsx(Popup, { children: /* @__PURE__ */ jsx(Typography2, { variant: "body2", children: route.label }) }) : null
                    },
                    route.id
                  ))
                ]
              },
              `map-${centerLat}-${centerLng}-${zoom}`
            )
          }
        );
      }
      return { default: MapViewInner };
    });
  }
});
function useSafeEventBus5() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var sizeStyles9, LONG_PRESS_DELAY, LONG_PRESS_INTERVAL, NumberStepper;
var init_NumberStepper = __esm({
  "components/core/molecules/NumberStepper.tsx"() {
    "use client";
    init_cn();
    init_Icon();
    init_useEventBus();
    sizeStyles9 = {
      sm: {
        button: "w-7 h-7",
        text: "text-sm min-w-[2rem]",
        icon: "w-3 h-3"
      },
      md: {
        button: "w-9 h-9",
        text: "text-base min-w-[2.5rem]",
        icon: "w-4 h-4"
      },
      lg: {
        button: "w-11 h-11",
        text: "text-lg min-w-[3rem]",
        icon: "w-5 h-5"
      }
    };
    LONG_PRESS_DELAY = 400;
    LONG_PRESS_INTERVAL = 100;
    NumberStepper = ({
      value = 0,
      min,
      max,
      step = 1,
      size = "md",
      disabled = false,
      onChange,
      action,
      actionPayload,
      className,
      label
    }) => {
      const eventBus = useSafeEventBus5();
      const { t } = useTranslate();
      const intervalRef = useRef(null);
      const timeoutRef = useRef(null);
      const isAtMin = min !== void 0 && value <= min;
      const isAtMax = max !== void 0 && value >= max;
      const styles = sizeStyles9[size];
      const emitChange = useCallback(
        (newValue) => {
          const clamped = Math.round(newValue / step) * step;
          const finalValue = Math.max(min ?? -Infinity, Math.min(max ?? Infinity, clamped));
          onChange?.(finalValue);
          if (action) {
            eventBus.emit(`UI:${action}`, { ...actionPayload, value: finalValue });
          }
        },
        [onChange, action, actionPayload, eventBus, min, max, step]
      );
      const startLongPress = useCallback(
        (delta) => {
          timeoutRef.current = setTimeout(() => {
            intervalRef.current = setInterval(() => {
              emitChange(value + delta);
            }, LONG_PRESS_INTERVAL);
          }, LONG_PRESS_DELAY);
        },
        [emitChange, value]
      );
      const stopLongPress = useCallback(() => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }, []);
      useEffect(() => {
        return () => {
          stopLongPress();
        };
      }, [stopLongPress]);
      const handleDecrement = () => {
        if (!isAtMin) emitChange(value - step);
      };
      const handleIncrement = () => {
        if (!isAtMax) emitChange(value + step);
      };
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "inline-flex items-center",
            "rounded-sm",
            "border-[length:var(--border-width)] border-border",
            "bg-surface",
            disabled && "opacity-50 cursor-not-allowed",
            className
          ),
          role: "group",
          "aria-label": label ?? "Number stepper",
          children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: handleDecrement,
                onMouseDown: () => !isAtMin && startLongPress(-step),
                onMouseUp: stopLongPress,
                onMouseLeave: stopLongPress,
                onTouchStart: () => !isAtMin && startLongPress(-step),
                onTouchEnd: stopLongPress,
                disabled: disabled || isAtMin,
                className: cn(
                  "inline-flex items-center justify-center",
                  "rounded-l-sm",
                  "text-foreground",
                  "hover:bg-muted",
                  "active:bg-muted",
                  "transition-colors duration-instant",
                  "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
                  "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
                  styles.button
                ),
                "aria-label": t("aria.decrease"),
                children: /* @__PURE__ */ jsx(Icon, { name: "minus", className: styles.icon })
              }
            ),
            /* @__PURE__ */ jsx(
              "span",
              {
                className: cn(
                  "text-center font-medium tabular-nums",
                  "text-foreground",
                  "border-x-[length:var(--border-width)] border-border",
                  "px-1 select-none",
                  styles.text
                ),
                "aria-live": "polite",
                "aria-atomic": "true",
                children: value
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: handleIncrement,
                onMouseDown: () => !isAtMax && startLongPress(step),
                onMouseUp: stopLongPress,
                onMouseLeave: stopLongPress,
                onTouchStart: () => !isAtMax && startLongPress(step),
                onTouchEnd: stopLongPress,
                disabled: disabled || isAtMax,
                className: cn(
                  "inline-flex items-center justify-center",
                  "rounded-r-sm",
                  "text-foreground",
                  "hover:bg-muted",
                  "active:bg-muted",
                  "transition-colors duration-instant",
                  "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
                  "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
                  styles.button
                ),
                "aria-label": t("aria.increase"),
                children: /* @__PURE__ */ jsx(Icon, { name: "plus", className: styles.icon })
              }
            )
          ]
        }
      );
    };
    NumberStepper.displayName = "NumberStepper";
  }
});
function useSafeEventBus6() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var sizeStyles10, StarRating;
var init_StarRating = __esm({
  "components/core/molecules/StarRating.tsx"() {
    "use client";
    init_cn();
    init_Icon();
    init_useEventBus();
    sizeStyles10 = {
      sm: { star: "w-4 h-4", gap: "gap-0.5" },
      md: { star: "w-6 h-6", gap: "gap-1" },
      lg: { star: "w-8 h-8", gap: "gap-1.5" }
    };
    StarRating = ({
      value = 0,
      max = 5,
      readOnly = false,
      precision = "full",
      size = "md",
      action,
      actionPayload,
      onChange,
      className,
      label
    }) => {
      const [hoverValue, setHoverValue] = useState(null);
      const eventBus = useSafeEventBus6();
      const styles = sizeStyles10[size];
      const displayValue = hoverValue ?? value;
      const emitChange = useCallback(
        (newValue) => {
          onChange?.(newValue);
          if (action) {
            eventBus.emit(`UI:${action}`, { ...actionPayload, value: newValue });
          }
        },
        [onChange, action, actionPayload, eventBus]
      );
      const handleStarClick = (starIndex, isHalf) => {
        if (readOnly) return;
        const newValue = isHalf && precision === "half" ? starIndex + 0.5 : starIndex + 1;
        emitChange(newValue);
      };
      const handleStarHover = (starIndex, isHalf) => {
        if (readOnly) return;
        const newValue = isHalf && precision === "half" ? starIndex + 0.5 : starIndex + 1;
        setHoverValue(newValue);
      };
      const handleKeyDown = (e) => {
        if (readOnly) return;
        const stepSize = precision === "half" ? 0.5 : 1;
        if (e.key === "ArrowRight" || e.key === "ArrowUp") {
          e.preventDefault();
          emitChange(Math.min(max, value + stepSize));
        } else if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
          e.preventDefault();
          emitChange(Math.max(0, value - stepSize));
        }
      };
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "inline-flex items-center",
            styles.gap,
            !readOnly && "cursor-pointer",
            className
          ),
          role: readOnly ? "img" : "slider",
          "aria-label": label ?? `Rating: ${value} out of ${max}`,
          "aria-valuemin": 0,
          "aria-valuemax": max,
          "aria-valuenow": value,
          tabIndex: readOnly ? void 0 : 0,
          onKeyDown: handleKeyDown,
          onPointerLeave: () => setHoverValue(null),
          children: Array.from({ length: max }, (_, i) => {
            const fillLevel = Math.max(0, Math.min(1, displayValue - i));
            const isFull = fillLevel >= 1;
            const isHalf = fillLevel >= 0.5 && fillLevel < 1;
            return /* @__PURE__ */ jsxs(
              "span",
              {
                className: "relative inline-block",
                onClick: () => handleStarClick(i, false),
                onPointerMove: (e) => {
                  if (readOnly) return;
                  const rect = e.currentTarget.getBoundingClientRect();
                  const isLeftHalf = e.clientX - rect.left < rect.width / 2;
                  handleStarHover(i, isLeftHalf);
                },
                children: [
                  /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "star",
                      className: cn(
                        styles.star,
                        "text-foreground/30",
                        "transition-colors duration-instant"
                      ),
                      strokeWidth: 1.5
                    }
                  ),
                  (isFull || isHalf) && /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "star",
                      className: cn(
                        styles.star,
                        "absolute inset-0",
                        "text-warning fill-warning",
                        "transition-colors duration-instant"
                      ),
                      strokeWidth: 1.5,
                      style: isHalf ? { clipPath: "inset(0 50% 0 0)" } : void 0
                    }
                  ),
                  !readOnly && precision === "half" && /* @__PURE__ */ jsx(
                    "span",
                    {
                      className: "absolute inset-0 w-1/2",
                      onClick: (e) => {
                        e.stopPropagation();
                        handleStarClick(i, true);
                      }
                    }
                  )
                ]
              },
              i
            );
          })
        }
      );
    };
    StarRating.displayName = "StarRating";
  }
});
function useSafeEventBus7() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}KB`;
  return `${Math.round(bytes / (1024 * 1024))}MB`;
}
var UploadDropZone;
var init_UploadDropZone = __esm({
  "components/core/molecules/UploadDropZone.tsx"() {
    "use client";
    init_cn();
    init_Icon();
    init_Typography();
    init_useEventBus();
    UploadDropZone = ({
      accept,
      maxSize,
      maxFiles = 1,
      label,
      description,
      icon,
      disabled = false,
      action,
      actionPayload,
      onFiles,
      className
    }) => {
      const { t } = useTranslate();
      const resolvedLabel = label ?? t("upload.dropOrBrowse");
      const [isDragOver, setIsDragOver] = useState(false);
      const [error, setError] = useState(null);
      const inputRef = useRef(null);
      const eventBus = useSafeEventBus7();
      const defaultDescription = [
        accept ? t("upload.accepted", { accept }) : null,
        maxSize ? t("upload.maxSize", { size: formatFileSize(maxSize) }) : null,
        maxFiles > 1 ? t("upload.maxFiles", { count: maxFiles }) : null
      ].filter(Boolean).join(". ");
      const validateFiles = useCallback(
        (files) => {
          if (files.length > maxFiles) {
            return { valid: [], error: t("upload.error.maxFiles", { count: maxFiles }) };
          }
          if (accept) {
            const acceptedTypes = accept.split(",").map((s) => s.trim());
            const invalid = files.filter((file) => {
              return !acceptedTypes.some((type) => {
                if (type.endsWith("/*")) {
                  return file.type.startsWith(type.replace("/*", "/"));
                }
                return file.type === type || file.name.endsWith(type);
              });
            });
            if (invalid.length > 0) {
              return { valid: [], error: t("upload.error.invalidType", { name: invalid[0].name }) };
            }
          }
          if (maxSize) {
            const tooLarge = files.filter((file) => file.size > maxSize);
            if (tooLarge.length > 0) {
              return {
                valid: [],
                error: t("upload.error.tooLarge", { name: tooLarge[0].name, size: formatFileSize(maxSize) })
              };
            }
          }
          return { valid: files, error: null };
        },
        [accept, maxSize, maxFiles, t]
      );
      const handleFiles = useCallback(
        (files) => {
          const { valid, error: validationError } = validateFiles(files);
          setError(validationError);
          if (valid.length > 0) {
            onFiles?.(valid);
            if (action) {
              void Promise.all(
                valid.map(
                  (f3) => new Promise(
                    (resolvePayload, rejectPayload) => {
                      const reader = new FileReader();
                      reader.onload = () => resolvePayload({
                        name: f3.name,
                        size: f3.size,
                        type: f3.type,
                        content: String(reader.result ?? "")
                      });
                      reader.onerror = () => rejectPayload(reader.error);
                      reader.readAsDataURL(f3);
                    }
                  )
                )
              ).then((payloadFiles) => {
                eventBus.emit(`UI:${action}`, {
                  ...actionPayload,
                  files: payloadFiles
                });
              }).catch(() => {
                setError(t("Could not read the selected file"));
              });
            }
          }
        },
        [validateFiles, onFiles, action, actionPayload, eventBus, t]
      );
      const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disabled) setIsDragOver(true);
      };
      const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
      };
      const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        if (disabled) return;
        const files = Array.from(e.dataTransfer.files);
        handleFiles(files);
      };
      const handleClick = () => {
        if (!disabled) inputRef.current?.click();
      };
      const handleInputChange = (e) => {
        const files = Array.from(e.target.files ?? []);
        if (files.length > 0) handleFiles(files);
        e.target.value = "";
      };
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "relative flex flex-col items-center justify-center",
            "p-8 rounded-sm",
            "border-2 border-dashed",
            "transition-colors duration-fast",
            "cursor-pointer",
            isDragOver ? "border-primary bg-primary bg-opacity-5" : "border-border bg-surface",
            error && "border-error",
            disabled && "opacity-50 cursor-not-allowed",
            "hover:border-primary hover:bg-muted",
            className
          ),
          onDragOver: handleDragOver,
          onDragLeave: handleDragLeave,
          onDrop: handleDrop,
          onClick: handleClick,
          role: "button",
          tabIndex: disabled ? -1 : 0,
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleClick();
            }
          },
          "aria-label": resolvedLabel,
          children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: inputRef,
                type: "file",
                accept,
                multiple: maxFiles > 1,
                onChange: handleInputChange,
                className: "hidden",
                disabled,
                "aria-hidden": "true"
              }
            ),
            error ? /* @__PURE__ */ jsx(Icon, { name: "file-warning", size: "lg", className: "text-error mb-2" }) : icon ? typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, size: "lg", className: "text-muted-foreground mb-2" }) : /* @__PURE__ */ jsx(Icon, { icon, size: "lg", className: "text-muted-foreground mb-2" }) : /* @__PURE__ */ jsx(Icon, { name: "upload", size: "lg", className: "text-muted-foreground mb-2" }),
            /* @__PURE__ */ jsx(Typography, { variant: "body1", className: "text-center font-medium mb-1", children: isDragOver ? t("upload.dropFilesHere") : resolvedLabel }),
            error ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", className: "text-center", children: error }) : /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-center", children: description ?? defaultDescription })
          ]
        }
      );
    };
    UploadDropZone.displayName = "UploadDropZone";
  }
});
function useSafeEventBus8() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var Lightbox;
var init_Lightbox = __esm({
  "components/core/molecules/Lightbox.tsx"() {
    "use client";
    init_Icon();
    init_cn();
    init_useEventBus();
    Lightbox = ({
      images = [],
      currentIndex = 0,
      isOpen = false,
      showCounter = true,
      closeAction,
      onClose,
      onIndexChange,
      className
    }) => {
      const safeImages = Array.isArray(images) ? images : [];
      const [index, setIndex] = useState(currentIndex);
      const [touchStartX, setTouchStartX] = useState(null);
      const eventBus = useSafeEventBus8();
      const { t } = useTranslate();
      useEffect(() => {
        setIndex(currentIndex);
      }, [currentIndex]);
      const handleClose = useCallback(() => {
        if (closeAction) {
          eventBus.emit(`UI:${closeAction}`, {});
        }
        onClose?.();
      }, [closeAction, eventBus, onClose]);
      const goTo = useCallback(
        (newIndex) => {
          if (safeImages.length === 0) return;
          const clamped = Math.max(0, Math.min(safeImages.length - 1, newIndex));
          setIndex(clamped);
          onIndexChange?.(clamped);
        },
        [safeImages.length, onIndexChange]
      );
      const goPrev = useCallback(() => goTo(index - 1), [goTo, index]);
      const goNext = useCallback(() => goTo(index + 1), [goTo, index]);
      useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
          switch (e.key) {
            case "Escape":
              handleClose();
              break;
            case "ArrowLeft":
              goPrev();
              break;
            case "ArrowRight":
              goNext();
              break;
          }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
      }, [isOpen, handleClose, goPrev, goNext]);
      useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = "hidden";
          return () => {
            document.body.style.overflow = "";
          };
        }
      }, [isOpen]);
      if (!isOpen || safeImages.length === 0) return null;
      const currentImage = safeImages[index];
      const hasPrev = index > 0;
      const hasNext = index < safeImages.length - 1;
      const handleTouchStart = (e) => {
        setTouchStartX(e.touches[0].clientX);
      };
      const handleTouchEnd = (e) => {
        if (touchStartX === null) return;
        const diff = e.changedTouches[0].clientX - touchStartX;
        const threshold = 50;
        if (diff > threshold && hasPrev) goPrev();
        if (diff < -threshold && hasNext) goNext();
        setTouchStartX(null);
      };
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "fixed inset-0 z-50 flex items-center justify-center",
            // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: lightbox scrim behind images
            "bg-black bg-opacity-90",
            className
          ),
          onClick: handleClose,
          role: "dialog",
          "data-pattern": "lightbox",
          "aria-modal": "true",
          "aria-label": currentImage?.alt ?? "Image viewer",
          children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: (e) => {
                  e.stopPropagation();
                  handleClose();
                },
                className: cn(
                  "absolute top-4 right-4 z-10",
                  "p-2 rounded-full",
                  "text-[var(--color-foreground)] bg-[var(--color-card)]",
                  "hover:bg-opacity-70 transition-opacity",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                ),
                "aria-label": t("aria.closeModal"),
                children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "w-6 h-6" })
              }
            ),
            hasPrev && safeImages.length > 1 && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: (e) => {
                  e.stopPropagation();
                  goPrev();
                },
                className: cn(
                  "absolute left-4 z-10",
                  "p-2 rounded-full",
                  "text-[var(--color-foreground)] bg-[var(--color-card)]",
                  "hover:bg-opacity-70 transition-opacity",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                ),
                "aria-label": t("aria.previousImage"),
                children: /* @__PURE__ */ jsx(Icon, { name: "chevron-left", className: "w-8 h-8" })
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: "flex items-center justify-center w-full h-full p-12",
                onClick: (e) => e.stopPropagation(),
                onTouchStart: handleTouchStart,
                onTouchEnd: handleTouchEnd,
                children: currentImage && /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: currentImage.src,
                    alt: currentImage.alt ?? "",
                    className: "max-w-full max-h-full object-contain select-none",
                    draggable: false
                  }
                )
              }
            ),
            hasNext && safeImages.length > 1 && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: (e) => {
                  e.stopPropagation();
                  goNext();
                },
                className: cn(
                  "absolute right-4 z-10",
                  "p-2 rounded-full",
                  "text-[var(--color-foreground)] bg-[var(--color-card)]",
                  "hover:bg-opacity-70 transition-opacity",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                ),
                "aria-label": t("aria.nextImage"),
                children: /* @__PURE__ */ jsx(Icon, { name: "chevron-right", className: "w-8 h-8" })
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "absolute bottom-4 left-0 right-0 text-center", children: [
              showCounter && safeImages.length > 1 && /* @__PURE__ */ jsxs("div", { className: "text-[var(--color-foreground)] text-sm mb-1", children: [
                index + 1,
                " of ",
                safeImages.length
              ] }),
              currentImage?.caption && /* @__PURE__ */ jsx("div", { className: "text-[var(--color-foreground)] text-sm opacity-80 px-8", children: currentImage.caption })
            ] })
          ]
        }
      );
    };
    Lightbox.displayName = "Lightbox";
  }
});
function renderIconInput3(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function columnLabel(col) {
  return col.header ?? col.label ?? humanizeFieldName(col.key);
}
function asFieldValue(v) {
  if (v === void 0 || v === null) return v;
  const t = typeof v;
  if (t === "string" || t === "number" || t === "boolean") return v;
  if (v instanceof Date) return v;
  if (Array.isArray(v)) return v;
  if (t === "object") return v;
  return void 0;
}
function statusVariant4(value) {
  const v = value.toLowerCase();
  if (["active", "completed", "done", "approved", "published", "resolved", "open", "online", "ok"].includes(v)) return "success";
  if (["pending", "in_progress", "in-progress", "review", "draft", "processing", "warn", "warning"].includes(v)) return "warning";
  if (["inactive", "deleted", "rejected", "failed", "error", "blocked", "closed", "offline"].includes(v)) return "error";
  if (["new", "created", "scheduled", "queued", "info"].includes(v)) return "info";
  return "default";
}
function groupData2(items, field) {
  const groups = /* @__PURE__ */ new Map();
  for (const item of items) {
    const key = String(getNestedValue(item, field) ?? "");
    const group = groups.get(key);
    if (group) group.push(item);
    else groups.set(key, [item]);
  }
  return Array.from(groups.entries()).map(([label, groupItems]) => ({ label, items: groupItems }));
}
function TableView({
  entity,
  columns,
  fields,
  itemActions,
  itemClickEvent = "",
  selectable = false,
  selectEvent,
  selectedIds,
  sortEvent,
  sortColumn,
  sortDirection,
  className,
  emptyMessage,
  isLoading = false,
  error = null,
  groupBy,
  pageSize = 0,
  children,
  renderItem: _schemaRenderItem,
  look = "dense",
  // DnD props consumed by useDataDnd.
  dragGroup,
  accepts,
  sortable,
  dropEvent,
  reorderEvent,
  positionEvent,
  dndItemIdField,
  dndRoot,
  relationsData
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [visibleCount, setVisibleCount] = React79__default.useState(pageSize > 0 ? pageSize : Infinity);
  const [localSelected, setLocalSelected] = React79__default.useState(/* @__PURE__ */ new Set());
  const colDefs = (Array.isArray(columns) ? columns : void 0) ?? (Array.isArray(fields) ? fields : void 0) ?? [];
  const actionDefs = Array.isArray(itemActions) ? itemActions : [];
  const overflowActions = actionDefs;
  const fireAction = (action, row) => eventBus.emit(`UI:${action.event}`, {
    id: row.id,
    row
  });
  const allDataRaw = Array.isArray(entity) ? entity : entity ? [entity] : [];
  const dnd = useDataDnd({
    items: allDataRaw,
    layout: "list",
    dragGroup,
    accepts,
    sortable,
    dropEvent,
    reorderEvent,
    positionEvent,
    dndItemIdField,
    dndRoot
  });
  const ordered2 = dnd.orderedItems;
  const data = pageSize > 0 ? ordered2.slice(0, visibleCount) : ordered2;
  const hasMore = pageSize > 0 && visibleCount < ordered2.length;
  const hasRenderProp = typeof children === "function";
  const idField = dndItemIdField ?? "id";
  React79__default.useEffect(() => {
    tableViewLog.debug("render", {
      rowCount: data.length,
      colCount: colDefs.length,
      look,
      isLoading: Boolean(isLoading),
      hasError: Boolean(error),
      dnd: dnd.enabled
    });
    if (data.length > 0 && !hasRenderProp && colDefs.length === 0) {
      tableViewLog.warn("columns-unresolved", {
        rowCount: data.length,
        columnsIsArray: Array.isArray(columns),
        fieldsIsArray: Array.isArray(fields)
      });
    }
  }, [data, colDefs, look, isLoading, error, dnd.enabled, hasRenderProp, columns, fields]);
  const selected = selectedIds ? new Set(selectedIds) : localSelected;
  const emitSelection = (next) => {
    if (!selectedIds) setLocalSelected(next);
    if (selectEvent) {
      const payload = { selectedIds: Array.from(next) };
      eventBus.emit(`UI:${selectEvent}`, payload);
    }
  };
  const allSelected = selectable && data.length > 0 && data.every((r, i) => selected.has(String(r[idField] ?? i)));
  const toggleAll = () => {
    if (allSelected) emitSelection(/* @__PURE__ */ new Set());
    else emitSelection(new Set(data.map((r, i) => String(r[idField] ?? i))));
  };
  const toggleRow = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    emitSelection(next);
  };
  const handleSort = (col) => {
    if (!col.sortable || !sortEvent) return;
    const dir = sortColumn === (col.field ?? col.key) && sortDirection === "asc" ? "desc" : "asc";
    eventBus.emit(`UI:${sortEvent}`, { column: col.field ?? col.key, direction: dir });
  };
  const rowClickEvent = itemClickEvent || actionDefs.find((a) => a.variant !== "danger")?.event;
  const handleRowClick = (row) => () => {
    if (!rowClickEvent) return;
    const payload = {
      id: row.id,
      row
    };
    eventBus.emit(`UI:${rowClickEvent}`, payload);
  };
  const colFloors = React79__default.useMemo(
    () => colDefs.map((col) => {
      const longest = data.reduce((widest, row) => {
        const cell = formatCell(asFieldValue(getNestedValue(row, col.field ?? col.key)), col.format, relationsData?.[col.field ?? col.key]);
        return Math.max(widest, cell.length);
      }, columnLabel(col).length);
      const chrome = col.format === "badge" ? BADGE_CHROME_CH : 0;
      return Math.min(longest + chrome, MAX_MEASURED_COL_CH);
    }),
    [colDefs, data]
  );
  const statusNode = isLoading ? /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: t("loading.items") }) }) : error ? /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) }) : data.length === 0 ? /* @__PURE__ */ jsx(Box, { className: "text-center py-12", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: emptyMessage || t("empty.noItems") }) }) : null;
  const lk = LOOKS[look];
  const hasActions = actionDefs.length > 0;
  const actionsTrack = hasActions ? "3rem" : null;
  const gridTemplateColumns = [
    selectable ? "auto" : null,
    ...colDefs.map((c, i) => c.width ?? `minmax(${colFloors[i]}ch, 1fr)`),
    actionsTrack
  ].filter(Boolean).join(" ");
  const header = /* @__PURE__ */ jsxs(
    Box,
    {
      role: "row",
      style: { gridTemplateColumns },
      className: cn(
        "grid items-center gap-3 sticky top-0 z-10",
        "bg-[var(--color-surface-subtle)] border-b border-[var(--color-border)]",
        "text-muted-foreground uppercase text-xs font-semibold tracking-wide",
        lk.headPad
      ),
      children: [
        selectable && /* @__PURE__ */ jsx(Box, { className: "flex items-center", children: /* @__PURE__ */ jsx(Checkbox, { checked: allSelected, onChange: toggleAll, "aria-label": t("aria.selectAllRows") }) }),
        colDefs.map((col) => {
          const active = sortColumn === (col.field ?? col.key);
          return /* @__PURE__ */ jsxs(
            Box,
            {
              role: "columnheader",
              onClick: () => handleSort(col),
              className: cn(
                "flex items-center gap-1 min-w-0",
                alignClass[col.align ?? "left"],
                col.sortable && sortEvent && "cursor-pointer select-none hover:text-foreground"
              ),
              children: [
                col.icon && renderIconInput3(col.icon, { size: "xs" }),
                /* @__PURE__ */ jsx("span", { className: "truncate", children: columnLabel(col) }),
                col.sortable && sortEvent && /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: active ? sortDirection === "asc" ? "chevron-up" : "chevron-down" : "chevrons-up-down",
                    size: "xs",
                    className: cn("flex-shrink-0", active ? "text-foreground" : "opacity-40")
                  }
                )
              ]
            },
            col.key
          );
        }),
        hasActions && /* @__PURE__ */ jsx(Box, { "aria-hidden": true, className: "sticky right-0 bg-[var(--color-surface-subtle)] border-l border-[var(--color-border)] h-full" })
      ]
    }
  );
  const renderRow = (row, index) => {
    const id = String(row[idField] ?? index);
    const rowInner = /* @__PURE__ */ jsxs(
      Box,
      {
        role: "row",
        "data-entity-row": true,
        "data-entity-id": id,
        onClick: rowClickEvent ? handleRowClick(row) : void 0,
        style: !hasRenderProp ? { gridTemplateColumns } : void 0,
        className: cn(
          "group items-center gap-3 transition-colors duration-fast",
          hasRenderProp ? "flex" : "grid",
          rowClickEvent && "cursor-pointer",
          lk.rowPad,
          lk.divider && "border-b border-[var(--color-border)]",
          lk.striped && index % 2 === 1 && "bg-[var(--color-surface-subtle)]",
          "hover:bg-[var(--color-surface-subtle)]",
          look === "bordered" && "[&>*]:border-r [&>*]:border-[var(--color-border)] [&>*:last-child]:border-r-0"
        ),
        children: [
          selectable && /* @__PURE__ */ jsx(Box, { className: "flex items-center", onClick: rowClickEvent ? (e) => e.stopPropagation() : void 0, children: /* @__PURE__ */ jsx(
            Checkbox,
            {
              checked: selected.has(id),
              onChange: () => toggleRow(id),
              "aria-label": t("table.selectRow", { id })
            }
          ) }),
          hasRenderProp ? /* @__PURE__ */ jsx(Box, { className: "flex-1 min-w-0", children: children(row, index) }) : colDefs.map((col) => {
            const raw = asFieldValue(getNestedValue(row, col.field ?? col.key));
            const cellBase = cn(
              "flex items-center min-w-0",
              alignClass[col.align ?? "left"],
              weightClass[col.weight ?? "normal"],
              col.className
            );
            if (col.format === "badge" && raw != null && raw !== "") {
              const relationDisplay = resolveRelationCellDisplay(raw, relationsData?.[col.field ?? col.key]);
              const label = relationDisplay ?? humanizeEnumValue(String(raw));
              return /* @__PURE__ */ jsx(Box, { role: "cell", className: cellBase, children: /* @__PURE__ */ jsx(Badge, { variant: statusVariant4(String(raw)), size: "sm", className: "whitespace-nowrap", children: label }) }, col.key);
            }
            return /* @__PURE__ */ jsx(Box, { role: "cell", className: cellBase, children: /* @__PURE__ */ jsx("span", { className: "truncate text-foreground", children: formatCell(raw, col.format, relationsData?.[col.field ?? col.key]) }) }, col.key);
          }),
          hasActions && /* @__PURE__ */ jsx(
            HStack,
            {
              gap: "xs",
              onClick: rowClickEvent ? (e) => e.stopPropagation() : void 0,
              className: cn(
                // Pinned: the fixed column tracks routinely overflow the caller's
                // scroll container, which would leave the kebab off-screen.
                // Opaque + hairline edge so it reads as a pinned column, not a
                // floating control, while scrolled cells pass underneath.
                "justify-end flex-shrink-0 sticky right-0 z-[1] transition-colors",
                "border-l border-[var(--color-border)]",
                lk.striped && index % 2 === 1 ? "bg-[var(--color-surface-subtle)]" : "bg-[var(--color-card)] group-hover:bg-[var(--color-surface-subtle)]"
              ),
              children: overflowActions.length > 0 && /* @__PURE__ */ jsx(
                Menu,
                {
                  position: "bottom-end",
                  trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", "data-row-id": String(row.id), children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                  items: overflowActions.map((action) => ({
                    label: action.label,
                    icon: action.icon,
                    event: action.event,
                    variant: action.variant === "danger" ? "danger" : "default",
                    onClick: () => fireAction(action, row)
                  }))
                }
              )
            }
          )
        ]
      }
    );
    return dnd.isZone ? /* @__PURE__ */ jsx(dnd.SortableItem, { id: row[idField] ?? id, children: rowInner }, id) : /* @__PURE__ */ jsx(React79__default.Fragment, { children: rowInner }, id);
  };
  const items = Array.from(data);
  const groups = groupBy ? groupData2(items, groupBy) : [{ label: "", items }];
  let runningIndex = 0;
  const body = /* @__PURE__ */ jsx(Box, { role: "rowgroup", children: groups.map((group, gi) => /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
    group.label && /* @__PURE__ */ jsx(Divider, { label: group.label, className: gi > 0 ? "mt-3" : "mt-0" }),
    group.items.map((row) => renderRow(row, runningIndex++))
  ] }, gi)) });
  const showHeader = colDefs.length > 0 || hasRenderProp;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      role: "table",
      className: cn("w-full text-sm", className),
      children: [
        showHeader && header,
        dnd.wrapContainer(statusNode ? /* @__PURE__ */ jsx(Box, { role: "rowgroup", children: statusNode }) : body),
        !statusNode && hasMore && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(Button, { variant: "ghost", size: "sm", onClick: () => setVisibleCount((p) => p + (pageSize || 5)), children: [
          /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
          t("common.showMore"),
          " (",
          t("common.remaining", { count: ordered2.length - visibleCount }),
          ")"
        ] }) })
      ]
    }
  );
}
var tableViewLog, formatCell, MAX_MEASURED_COL_CH, BADGE_CHROME_CH, alignClass, weightClass, LOOKS;
var init_TableView = __esm({
  "components/core/molecules/TableView.tsx"() {
    "use client";
    init_cn();
    init_format();
    init_relationLabel();
    init_getNestedValue();
    init_useEventBus();
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    init_Button();
    init_Icon();
    init_Checkbox();
    init_Divider();
    init_Menu();
    init_useDataDnd();
    tableViewLog = createLogger("almadar:ui:table-view");
    formatCell = (value, format, relationOptions) => {
      const relationDisplay = resolveRelationCellDisplay(value, relationOptions);
      if (relationDisplay !== void 0) return relationDisplay;
      return formatValue(value, format);
    };
    MAX_MEASURED_COL_CH = 32;
    BADGE_CHROME_CH = 4;
    alignClass = {
      left: "justify-start text-left",
      center: "justify-center text-center",
      right: "justify-end text-right"
    };
    weightClass = {
      normal: "",
      medium: "font-medium",
      semibold: "font-semibold"
    };
    LOOKS = {
      dense: { rowPad: "px-card-md py-2", headPad: "px-card-md py-2", striped: false, divider: true },
      spacious: { rowPad: "px-card-lg py-card-md", headPad: "px-card-lg py-card-sm", striped: false, divider: true },
      striped: { rowPad: "px-card-md py-card-sm", headPad: "px-card-md py-card-sm", striped: true, divider: false },
      borderless: { rowPad: "px-card-md py-card-sm", headPad: "px-card-md py-card-sm", striped: false, divider: false },
      bordered: { rowPad: "px-card-md py-card-sm", headPad: "px-card-md py-card-sm", striped: false, divider: true }
    };
    TableView.displayName = "TableView";
  }
});
function formatNumber(value, format) {
  if (value == null) return "0";
  const v = typeof value === "number" ? value : value;
  switch (format) {
    case "currency":
      return typeof v === "number" ? `$${v.toFixed(2)}` : String(v);
    case "percent":
      return typeof v === "number" ? `${Math.round(v)}%` : String(v);
    case "number":
      return typeof v === "number" ? v.toLocaleString() : String(v);
    default:
      return String(v);
  }
}
function composeDisplayValue(value, format, max, prefix, suffix) {
  const formatted = formatNumber(value, format);
  const withMax = max != null && max > 0 ? `${formatted} / ${max}` : formatted;
  return `${prefix ?? ""}${withMax}${suffix ?? ""}`;
}
var lookStyles7, variantColor, StatDisplay;
var init_StatDisplay = __esm({
  "components/core/molecules/StatDisplay.tsx"() {
    "use client";
    init_cn();
    init_Card();
    init_Typography();
    init_Box();
    init_Stack();
    init_Sparkline();
    init_Icon();
    init_useEventBus();
    lookStyles7 = {
      elevated: "",
      flat: "shadow-none border-[length:var(--border-width)] border-border",
      "progress-backed": "",
      gauge: "",
      sparkline: ""
    };
    variantColor = {
      default: "text-foreground",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      info: "text-info"
    };
    StatDisplay = ({
      label,
      value,
      max,
      target,
      trend,
      trendPolarity = "higher-is-better",
      trendFormat = "absolute",
      sparklineData,
      clickEvent,
      prefix,
      suffix,
      icon: iconProp,
      iconBg = "bg-muted",
      iconColor = "text-foreground",
      format,
      size = "md",
      variant = "default",
      compact = false,
      look = "elevated",
      className,
      isLoading = false,
      error = null
    }) => {
      const eventBus = useEventBus();
      const handleClick = useCallback(() => {
        if (clickEvent) eventBus.emit(`UI:${clickEvent}`, { metricLabel: label });
      }, [clickEvent, eventBus, label]);
      const ResolvedIcon = typeof iconProp === "string" ? resolveIcon(iconProp) : typeof iconProp === "function" ? iconProp : null;
      const iconSizes3 = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-6 w-6" };
      const valueSizes = { sm: "text-lg", md: "text-2xl", lg: "text-3xl" };
      const padSizes = { sm: "p-3", md: "p-4", lg: "p-6" };
      const displayValue = composeDisplayValue(value, format, max, prefix, suffix);
      const numericValue = typeof value === "number" ? value : Number(value);
      const showTarget = typeof target === "number" && target > 0 && Number.isFinite(numericValue);
      const targetPct = showTarget ? Math.max(0, Math.min(100, numericValue / target * 100)) : 0;
      const showTrend = typeof trend === "number" && trend !== 0 && Number.isFinite(trend);
      const trendUp = showTrend && trend > 0;
      const trendIsGood = trendPolarity === "lower-is-better" ? !trendUp : trendUp;
      const trendMagnitude = Math.abs(trend);
      const trendSuffix = trendFormat === "percent" ? "%" : "";
      const trendLabel = showTrend ? `${trendUp ? "\u2191" : "\u2193"} ${trendMagnitude}${trendSuffix}` : "";
      if (error) {
        return /* @__PURE__ */ jsx(Card, { className: cn(padSizes[size], className), children: /* @__PURE__ */ jsx(Typography, { variant: "small", color: "error", children: error.message }) });
      }
      if (isLoading) {
        return /* @__PURE__ */ jsx(Card, { className: cn(padSizes[size], className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "animate-pulse", children: [
          /* @__PURE__ */ jsx(Box, { className: "h-3 bg-muted rounded w-16" }),
          /* @__PURE__ */ jsx(Box, { className: "h-6 bg-muted rounded w-12" })
        ] }) });
      }
      if (compact) {
        return /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            className: cn("items-center", clickEvent && "cursor-pointer hover:opacity-80", className),
            onClick: clickEvent ? handleClick : void 0,
            children: [
              ResolvedIcon && /* @__PURE__ */ jsx(ResolvedIcon, { className: cn(iconSizes3[size], iconColor) }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: label }),
              /* @__PURE__ */ jsx(Typography, { variant: "h4", className: cn("font-bold", valueSizes[size], variantColor[variant]), children: displayValue }),
              showTrend && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: cn("font-semibold", trendIsGood ? "text-success" : "text-error"), children: trendLabel }),
              sparklineData && sparklineData.length > 1 && /* @__PURE__ */ jsx(Sparkline, { data: sparklineData, color: "auto", width: 60, height: 20 })
            ]
          }
        );
      }
      return /* @__PURE__ */ jsx(
        Card,
        {
          className: cn(padSizes[size], lookStyles7[look], clickEvent && "cursor-pointer hover:shadow-md transition-shadow", className),
          onClick: clickEvent ? handleClick : void 0,
          children: /* @__PURE__ */ jsxs(HStack, { align: "start", justify: "between", children: [
            /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "space-y-1 flex-1", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: label }),
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "end", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h4", className: cn("font-bold", valueSizes[size], variantColor[variant]), children: displayValue }),
                showTrend && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    className: cn("font-semibold pb-1", trendIsGood ? "text-success" : "text-error"),
                    children: trendLabel
                  }
                )
              ] }),
              showTarget && /* @__PURE__ */ jsx(Box, { className: "mt-2 h-1.5 w-full bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn("h-full rounded-full transition-all", `bg-${variant === "default" ? "primary" : variant}`),
                  style: { width: `${targetPct}%` }
                }
              ) })
            ] }),
            /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "end", children: [
              ResolvedIcon && /* @__PURE__ */ jsx(Box, { className: cn("p-3 rounded-md", iconBg), children: /* @__PURE__ */ jsx(ResolvedIcon, { className: cn(iconSizes3[size], iconColor) }) }),
              sparklineData && sparklineData.length > 1 && /* @__PURE__ */ jsx(Sparkline, { data: sparklineData, color: "auto" })
            ] })
          ] })
        }
      );
    };
    StatDisplay.displayName = "StatDisplay";
  }
});
function getColorForValue(value, max, thresholds) {
  const percentage = value / max * 100;
  for (const threshold of thresholds) {
    if (percentage <= threshold.value) {
      return threshold.color;
    }
  }
  return thresholds[thresholds.length - 1]?.color ?? "var(--color-primary)";
}
var DEFAULT_THRESHOLDS, radialSizes, Meter;
var init_Meter = __esm({
  "components/core/molecules/Meter.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_useEventBus();
    DEFAULT_THRESHOLDS = [
      { value: 30, color: "var(--color-error)" },
      { value: 70, color: "var(--color-warning)" },
      { value: 100, color: "var(--color-success)" }
    ];
    radialSizes = {
      sm: { size: 80, stroke: 6, fontSize: "12px" },
      md: { size: 120, stroke: 8, fontSize: "16px" },
      lg: { size: 160, stroke: 10, fontSize: "20px" }
    };
    Meter = ({
      value,
      min = 0,
      max = 100,
      label,
      unit,
      variant = "linear",
      thresholds = DEFAULT_THRESHOLDS,
      segments = 5,
      showValue = true,
      size = "md",
      actions,
      isLoading = false,
      error,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleAction = useCallback(
        (action) => {
          if (action.event) {
            eventBus.emit(`UI:${action.event}`, { value });
          }
        },
        [eventBus, value]
      );
      const safeVal = value ?? 0;
      const percentage = useMemo(() => {
        const range = max - min;
        if (range <= 0) return 0;
        return Math.min(Math.max((safeVal - min) / range * 100, 0), 100);
      }, [safeVal, min, max]);
      const activeColor = useMemo(
        () => getColorForValue(safeVal, max, thresholds),
        [safeVal, max, thresholds]
      );
      const displayValue = useMemo(() => {
        const formatted = Number.isInteger(safeVal) ? safeVal : safeVal.toFixed(1);
        return unit ? `${formatted}${unit}` : `${formatted}`;
      }, [safeVal, unit]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.meterError"),
            message: error.message,
            className
          }
        );
      }
      if (variant === "radial") {
        const dims = radialSizes[size];
        const radius = (dims.size - dims.stroke * 2) / 2;
        const circumference = 2 * Math.PI * radius;
        const offset = circumference - percentage / 100 * circumference;
        const center = dims.size / 2;
        return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", children: [
          label && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", weight: "medium", children: label }),
          /* @__PURE__ */ jsxs(Box, { className: "relative inline-flex items-center justify-center", children: [
            /* @__PURE__ */ jsxs(
              "svg",
              {
                width: dims.size,
                height: dims.size,
                viewBox: `0 0 ${dims.size} ${dims.size}`,
                className: "transform -rotate-90",
                children: [
                  /* @__PURE__ */ jsx(
                    "circle",
                    {
                      cx: center,
                      cy: center,
                      r: radius,
                      fill: "none",
                      stroke: "var(--color-muted)",
                      strokeWidth: dims.stroke
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "circle",
                    {
                      cx: center,
                      cy: center,
                      r: radius,
                      fill: "none",
                      stroke: activeColor,
                      strokeWidth: dims.stroke,
                      strokeDasharray: circumference,
                      strokeDashoffset: offset,
                      strokeLinecap: "round",
                      className: "transition-all duration-slow ease-emphasized"
                    }
                  )
                ]
              }
            ),
            showValue && /* @__PURE__ */ jsx(Box, { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "h5",
                weight: "bold",
                className: "tabular-nums",
                style: { fontSize: dims.fontSize },
                children: displayValue
              }
            ) })
          ] }),
          actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", children: actions.map((action, idx) => /* @__PURE__ */ jsx(
            Badge,
            {
              variant: "default",
              className: "cursor-pointer hover:opacity-80 transition-opacity",
              onClick: () => handleAction(action),
              children: action.label
            },
            idx
          )) })
        ] }) });
      }
      if (variant === "segmented") {
        const activeSegments = Math.round(percentage / 100 * segments);
        return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
          (label || showValue) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
            label && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", weight: "medium", children: label }),
            showValue && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "bold", className: "tabular-nums", children: displayValue })
          ] }),
          /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "w-full", children: Array.from({ length: segments }).map((_, idx) => {
            const isActive = idx < activeSegments;
            const segColor = isActive ? getColorForValue((idx + 1) / segments * max, max, thresholds) : void 0;
            return /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "h-2 flex-1 rounded-sm transition-all duration-normal",
                  !isActive && "bg-muted"
                ),
                style: isActive ? { backgroundColor: segColor } : void 0
              },
              idx
            );
          }) }),
          thresholds.some((t2) => t2.label) && /* @__PURE__ */ jsx(HStack, { justify: "between", className: "w-full", children: thresholds.map((t2, idx) => /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: t2.label || "" }, idx)) })
        ] }) });
      }
      return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        (label || showValue) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
          label && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", weight: "medium", children: label }),
          showValue && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "bold", className: "tabular-nums", children: displayValue })
        ] }),
        /* @__PURE__ */ jsx(Box, { className: "w-full h-3 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ jsx(
          Box,
          {
            className: "h-full rounded-full transition-all duration-slow ease-emphasized",
            style: {
              width: `${percentage}%`,
              backgroundColor: activeColor
            }
          }
        ) }),
        /* @__PURE__ */ jsxs(HStack, { justify: "between", className: "w-full", children: [
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", children: [
            min,
            unit ? ` ${unit}` : ""
          ] }),
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", children: [
            max,
            unit ? ` ${unit}` : ""
          ] })
        ] }),
        actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", children: actions.map((action, idx) => /* @__PURE__ */ jsx(
          Badge,
          {
            variant: "default",
            className: "cursor-pointer hover:opacity-80 transition-opacity",
            onClick: () => handleAction(action),
            children: action.label
          },
          idx
        )) })
      ] }) });
    };
    Meter.displayName = "Meter";
  }
});
function useSafeEventBus9() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var SwipeableRow;
var init_SwipeableRow = __esm({
  "components/core/molecules/SwipeableRow.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_Stack();
    init_Button();
    init_Icon();
    SwipeableRow = ({
      leftActions = [],
      rightActions = [],
      threshold = 80,
      children,
      itemData,
      className
    }) => {
      const eventBus = useSafeEventBus9();
      const [revealState, setRevealState] = useState("closed");
      const [offsetX, setOffsetX] = useState(0);
      const [isSwiping, setIsSwiping] = useState(false);
      const startXRef = useRef(0);
      const startYRef = useRef(0);
      const trackingRef = useRef(false);
      const lockedAxisRef = useRef(null);
      const actionsWidth = threshold;
      const handleActionClick = useCallback(
        (action) => {
          eventBus.emit(`UI:${action.event}`, {
            ...action.eventPayload,
            row: itemData
          });
          setRevealState("closed");
          setOffsetX(0);
        },
        [eventBus, itemData]
      );
      const handlePointerDown = useCallback(
        (e) => {
          if (e.button !== 0) return;
          startXRef.current = e.clientX;
          startYRef.current = e.clientY;
          trackingRef.current = true;
          lockedAxisRef.current = null;
          setIsSwiping(false);
          e.currentTarget.setPointerCapture(e.pointerId);
        },
        []
      );
      const handlePointerMove = useCallback(
        (e) => {
          if (!trackingRef.current) return;
          const dx = e.clientX - startXRef.current;
          const dy = e.clientY - startYRef.current;
          if (lockedAxisRef.current === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
            lockedAxisRef.current = Math.abs(dx) > Math.abs(dy) ? "horizontal" : "vertical";
          }
          if (lockedAxisRef.current !== "horizontal") return;
          setIsSwiping(true);
          let newOffset = dx;
          if (revealState === "left") {
            newOffset = actionsWidth + dx;
          } else if (revealState === "right") {
            newOffset = -actionsWidth + dx;
          }
          const maxLeft = leftActions.length > 0 ? actionsWidth : 0;
          const maxRight = rightActions.length > 0 ? actionsWidth : 0;
          const clamped = Math.max(-maxRight, Math.min(maxLeft, newOffset));
          setOffsetX(clamped);
        },
        [revealState, actionsWidth, leftActions.length, rightActions.length]
      );
      const handlePointerUp = useCallback(
        () => {
          trackingRef.current = false;
          if (!isSwiping) {
            if (revealState !== "closed") {
              setRevealState("closed");
              setOffsetX(0);
            }
            setIsSwiping(false);
            return;
          }
          setIsSwiping(false);
          if (offsetX > threshold / 2 && leftActions.length > 0) {
            setRevealState("right");
            setOffsetX(actionsWidth);
          } else if (offsetX < -(threshold / 2) && rightActions.length > 0) {
            setRevealState("left");
            setOffsetX(-actionsWidth);
          } else {
            setRevealState("closed");
            setOffsetX(0);
          }
        },
        [isSwiping, offsetX, threshold, leftActions.length, rightActions.length, actionsWidth, revealState]
      );
      const handlePointerCancel = useCallback(() => {
        trackingRef.current = false;
        setIsSwiping(false);
        setRevealState("closed");
        setOffsetX(0);
      }, []);
      const renderActions = (actions, side) => {
        if (actions.length === 0) return null;
        return /* @__PURE__ */ jsx(
          HStack,
          {
            gap: "xs",
            align: "stretch",
            className: cn(
              "absolute top-0 bottom-0",
              side === "left" ? "left-0" : "right-0"
            ),
            style: {
              width: `${actionsWidth}px`
            },
            children: actions.map((action, idx) => /* @__PURE__ */ jsxs(
              Button,
              {
                variant: action.variant ?? "secondary",
                size: "sm",
                icon: action.icon,
                onClick: () => handleActionClick(action),
                className: "flex-1 rounded-none h-full",
                children: [
                  action.icon ? typeof action.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: action.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: action.icon, size: "sm" }) : null,
                  action.label
                ]
              },
              `${action.event}-${idx}`
            ))
          }
        );
      };
      return /* @__PURE__ */ jsxs(
        Box,
        {
          overflow: "hidden",
          position: "relative",
          className: cn(
            "touch-pan-y",
            className
          ),
          children: [
            renderActions(leftActions, "left"),
            renderActions(rightActions, "right"),
            /* @__PURE__ */ jsx(
              Box,
              {
                style: {
                  transform: `translateX(${offsetX}px)`,
                  transition: isSwiping ? "none" : "transform 200ms ease-out"
                },
                className: cn(
                  "relative bg-surface",
                  "select-none"
                ),
                onPointerDown: handlePointerDown,
                onPointerMove: handlePointerMove,
                onPointerUp: handlePointerUp,
                onPointerCancel: handlePointerCancel,
                children
              }
            )
          ]
        }
      );
    };
    SwipeableRow.displayName = "SwipeableRow";
  }
});
function useDragReorder(initialItems, onReorder) {
  const [items, setItems] = useState(initialItems);
  const [dragIndex, setDragIndex] = useState(-1);
  const [dragOverIndex, setDragOverIndex] = useState(-1);
  const itemsRef = useRef(initialItems);
  if (initialItems !== itemsRef.current) {
    itemsRef.current = initialItems;
    setItems(initialItems);
  }
  const isDragging = dragIndex >= 0;
  const handleDragStart = useCallback((index) => (e) => {
    e.preventDefault();
    setDragIndex(index);
    setDragOverIndex(index);
    e.target.setPointerCapture?.(e.pointerId);
  }, []);
  const handleDragMove = useCallback((index) => (e) => {
    if (dragIndex < 0) return;
    const target = document.elementFromPoint(e.clientX, e.clientY);
    if (!target) return;
    let el = target;
    while (el && !el.dataset.dragIndex) {
      el = el.parentElement;
    }
    if (el?.dataset.dragIndex) {
      const overIndex = parseInt(el.dataset.dragIndex, 10);
      if (!isNaN(overIndex) && overIndex !== dragOverIndex) {
        setDragOverIndex(overIndex);
      }
    }
  }, [dragIndex, dragOverIndex]);
  const handleDragEnd = useCallback(() => {
    if (dragIndex >= 0 && dragOverIndex >= 0 && dragIndex !== dragOverIndex) {
      const newItems = [...items];
      const [movedItem] = newItems.splice(dragIndex, 1);
      newItems.splice(dragOverIndex, 0, movedItem);
      setItems(newItems);
      onReorder(dragIndex, dragOverIndex, items[dragIndex]);
    }
    setDragIndex(-1);
    setDragOverIndex(-1);
  }, [dragIndex, dragOverIndex, items, onReorder]);
  const getDragHandleProps = useCallback((index) => ({
    onPointerDown: handleDragStart(index),
    style: { cursor: "grab", touchAction: "none" },
    "aria-grabbed": dragIndex === index,
    role: "button"
  }), [handleDragStart, dragIndex]);
  const getItemProps = useCallback((index) => ({
    onPointerMove: handleDragMove(index),
    onPointerUp: handleDragEnd,
    "aria-dropeffect": "move",
    "data-drag-index": String(index),
    style: {
      opacity: dragIndex === index ? 0.5 : 1,
      transition: isDragging ? "transform 150ms ease" : void 0,
      transform: isDragging && dragOverIndex >= 0 ? index === dragIndex ? "scale(1.02)" : index > dragIndex && index <= dragOverIndex ? "translateY(-100%)" : index < dragIndex && index >= dragOverIndex ? "translateY(100%)" : void 0 : void 0
    }
  }), [handleDragMove, handleDragEnd, dragIndex, dragOverIndex, isDragging]);
  return {
    items,
    dragIndex,
    dragOverIndex,
    isDragging,
    getDragHandleProps,
    getItemProps
  };
}
var init_useDragReorder = __esm({
  "hooks/useDragReorder.ts"() {
    "use client";
  }
});
function useSafeEventBus10() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
function SortableListInner({
  items: initialItemsProp = EMPTY_ITEMS,
  renderItem,
  reorderEvent,
  reorderPayload,
  dragHandlePosition = "left",
  className
}) {
  const eventBus = useSafeEventBus10();
  const initialItems = Array.isArray(initialItemsProp) ? initialItemsProp : initialItemsProp ? [initialItemsProp] : [];
  const handleReorder = useCallback(
    (fromIndex, toIndex, item) => {
      eventBus.emit(`UI:${reorderEvent}`, {
        fromIndex,
        toIndex,
        item,
        ...reorderPayload
      });
    },
    [eventBus, reorderEvent, reorderPayload]
  );
  const {
    items,
    dragIndex,
    dragOverIndex,
    isDragging,
    getDragHandleProps,
    getItemProps
  } = useDragReorder(initialItems, handleReorder);
  return /* @__PURE__ */ jsx(VStack, { gap: "none", className: cn("w-full", className), children: items.map((item, index) => {
    const { "aria-dropeffect": ariaDropEffect, ...itemProps } = getItemProps(index);
    const { "aria-grabbed": ariaGrabbed, ...handleRest } = getDragHandleProps(index);
    const isBeingDragged = dragIndex === index;
    const showDropIndicator = isDragging && dragOverIndex === index && dragOverIndex !== dragIndex;
    const dragHandle = /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex items-center justify-center",
          "text-muted-foreground",
          "hover:text-foreground",
          "transition-colors duration-instant",
          "px-1"
        ),
        "aria-grabbed": ariaGrabbed,
        ...handleRest,
        children: /* @__PURE__ */ jsx(Icon, { name: "grip-vertical", size: "sm" })
      }
    );
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "aria-dropeffect": ariaDropEffect,
        ...itemProps,
        children: [
          showDropIndicator && /* @__PURE__ */ jsx(
            Box,
            {
              className: "h-0.5 bg-primary rounded-full",
              style: { margin: "0 8px" }
            }
          ),
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              align: "center",
              className: cn(
                "transition-opacity duration-fast",
                isBeingDragged && "opacity-50"
              ),
              children: [
                dragHandlePosition === "left" && dragHandle,
                /* @__PURE__ */ jsx(Box, { className: "flex-1 min-w-0", children: typeof renderItem === "function" ? renderItem(item, index) : JSON.stringify(item) }),
                dragHandlePosition === "right" && dragHandle
              ]
            }
          )
        ]
      },
      index
    );
  }) });
}
var EMPTY_ITEMS, SortableList;
var init_SortableList = __esm({
  "components/core/molecules/SortableList.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_useDragReorder();
    init_Box();
    init_Stack();
    init_Stack();
    init_Icon();
    EMPTY_ITEMS = [];
    SortableList = SortableListInner;
    SortableList.displayName = "SortableList";
  }
});
function usePullToRefresh(onRefresh, options = {}) {
  const { threshold = 60, maxPull = 120 } = options;
  const [pullDistance, setPullDistance] = useState(0);
  const [isPulling, setIsPulling] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const startY = useRef(0);
  const scrollTopRef = useRef(0);
  const onTouchStart = useCallback((e) => {
    const container = e.currentTarget;
    scrollTopRef.current = container.scrollTop;
    if (scrollTopRef.current <= 0) {
      startY.current = e.touches[0].clientY;
      setIsPulling(true);
    }
  }, []);
  const onTouchMove = useCallback((e) => {
    if (!isPulling || isRefreshing) return;
    const container = e.currentTarget;
    if (container.scrollTop > 0) {
      setPullDistance(0);
      return;
    }
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0) {
      const distance = Math.min(dy * 0.5, maxPull);
      setPullDistance(distance);
    }
  }, [isPulling, isRefreshing, maxPull]);
  const onTouchEnd = useCallback(() => {
    if (!isPulling) return;
    setIsPulling(false);
    if (pullDistance >= threshold && !isRefreshing) {
      setIsRefreshing(true);
      setPullDistance(threshold);
      onRefresh();
    } else {
      setPullDistance(0);
    }
  }, [isPulling, pullDistance, threshold, isRefreshing, onRefresh]);
  const endRefresh = useCallback(() => {
    setIsRefreshing(false);
    setPullDistance(0);
  }, []);
  const containerProps = {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    style: {
      transform: pullDistance > 0 ? `translateY(${pullDistance}px)` : void 0,
      transition: isPulling ? "none" : "transform 300ms ease-out"
    }
  };
  return {
    pullDistance,
    isPulling,
    isRefreshing,
    containerProps,
    endRefresh
  };
}
var init_usePullToRefresh = __esm({
  "hooks/usePullToRefresh.ts"() {
    "use client";
  }
});
function useSafeEventBus11() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var SAFETY_TIMEOUT_MS, PullToRefresh;
var init_PullToRefresh = __esm({
  "components/core/molecules/PullToRefresh.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_usePullToRefresh();
    init_Box();
    init_Spinner();
    SAFETY_TIMEOUT_MS = 5e3;
    PullToRefresh = ({
      refreshEvent,
      refreshPayload,
      threshold = 60,
      children,
      className
    }) => {
      const eventBus = useSafeEventBus11();
      const safetyTimerRef = useRef(null);
      const handleRefresh = useCallback(() => {
        eventBus.emit(`UI:${refreshEvent}`, refreshPayload ?? {});
      }, [eventBus, refreshEvent, refreshPayload]);
      const { pullDistance, isPulling, isRefreshing, containerProps, endRefresh } = usePullToRefresh(handleRefresh, { threshold });
      useEffect(() => {
        if (isRefreshing) {
          safetyTimerRef.current = setTimeout(() => {
            endRefresh();
          }, SAFETY_TIMEOUT_MS);
          return () => {
            if (safetyTimerRef.current) {
              clearTimeout(safetyTimerRef.current);
              safetyTimerRef.current = null;
            }
          };
        }
      }, [isRefreshing, endRefresh]);
      useEffect(() => {
        return () => {
          if (safetyTimerRef.current) {
            clearTimeout(safetyTimerRef.current);
          }
        };
      }, []);
      const pullProgress = Math.min(pullDistance / threshold, 1);
      const showIndicator = pullDistance > 0 || isRefreshing;
      return /* @__PURE__ */ jsxs(Box, { position: "relative", overflow: "hidden", className: cn("w-full", className), children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            display: "flex",
            className: cn(
              "top-0 left-0 right-0 z-10",
              "items-center justify-center",
              "transition-opacity duration-fast",
              showIndicator ? "opacity-100" : "opacity-0"
            ),
            style: {
              height: threshold,
              transform: `translateY(${showIndicator ? 0 : -threshold}px)`,
              pointerEvents: "none"
            },
            children: /* @__PURE__ */ jsx(
              Box,
              {
                className: "transition-transform duration-fast",
                style: {
                  transform: `scale(${isRefreshing ? 1 : pullProgress})`,
                  opacity: isRefreshing ? 1 : pullProgress
                },
                children: /* @__PURE__ */ jsx(
                  Spinner,
                  {
                    size: pullProgress >= 0.5 ? "md" : "sm",
                    className: cn(
                      "text-primary",
                      isRefreshing && "animate-spin"
                    )
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            fullWidth: true,
            className: cn(
              "min-h-0",
              isPulling && "select-none"
            ),
            ...containerProps,
            children
          }
        )
      ] });
    };
    PullToRefresh.displayName = "PullToRefresh";
  }
});
var iconSizeMap, gapMap, FeatureCard;
var init_FeatureCard = __esm({
  "components/marketing/molecules/FeatureCard.tsx"() {
    "use client";
    init_cn();
    init_Card();
    init_Stack();
    init_Icon();
    init_Typography();
    init_Button();
    iconSizeMap = {
      sm: "lg",
      md: "xl",
      lg: "xl"
    };
    gapMap = {
      sm: "sm",
      md: "md",
      lg: "lg"
    };
    FeatureCard = ({
      icon,
      title,
      description,
      href,
      linkLabel = "Learn more",
      variant = "bordered",
      size = "md",
      className
    }) => {
      const renderIcon = () => {
        if (!icon) return null;
        return /* @__PURE__ */ jsx(
          Icon,
          {
            icon: typeof icon === "string" ? void 0 : icon,
            name: typeof icon === "string" ? icon : void 0,
            size: iconSizeMap[size],
            className: "text-accent"
          }
        );
      };
      const handleLinkClick = () => {
        if (href) {
          window.open(href, "_blank", "noopener,noreferrer");
        }
      };
      return /* @__PURE__ */ jsx(
        Card,
        {
          variant,
          padding: size,
          className: cn(
            variant === "interactive" && "hover:border-primary",
            className
          ),
          onClick: variant === "interactive" && href ? handleLinkClick : void 0,
          children: /* @__PURE__ */ jsxs(VStack, { gap: gapMap[size], align: "start", children: [
            renderIcon(),
            /* @__PURE__ */ jsx(Typography, { variant: "h4", className: size === "sm" ? "text-base" : void 0, children: title }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: description }),
            href && variant !== "interactive" && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: handleLinkClick,
                className: "text-primary -ml-2",
                children: linkLabel
              }
            )
          ] })
        }
      );
    };
    FeatureCard.displayName = "FeatureCard";
  }
});
var FeatureGrid;
var init_FeatureGrid = __esm({
  "components/core/molecules/FeatureGrid.tsx"() {
    "use client";
    init_cn();
    init_SimpleGrid();
    init_FeatureCard();
    FeatureGrid = ({
      items,
      columns = 3,
      gap = "md",
      className
    }) => {
      return /* @__PURE__ */ jsx(
        SimpleGrid,
        {
          cols: columns,
          gap,
          className: cn(className),
          children: (Array.isArray(items) ? items : []).map((item, index) => /* @__PURE__ */ jsx(FeatureCard, { ...item }, `${item.title}-${index}`))
        }
      );
    };
    FeatureGrid.displayName = "FeatureGrid";
  }
});
var PricingCard;
var init_PricingCard = __esm({
  "components/marketing/molecules/PricingCard.tsx"() {
    "use client";
    init_cn();
    init_Card();
    init_Stack();
    init_Badge();
    init_Typography();
    init_Icon();
    init_Divider();
    init_Spacer();
    init_Button();
    PricingCard = ({
      name,
      price,
      description,
      features,
      action,
      highlighted = false,
      badge,
      className
    }) => {
      return /* @__PURE__ */ jsx(
        Card,
        {
          variant: highlighted ? "elevated" : "bordered",
          padding: "lg",
          className: cn(
            "flex flex-col h-full",
            "hover:-translate-y-1 transition-all",
            highlighted && [
              "border-[length:2px] border-primary",
              "shadow-elevation-dialog",
              "scale-[1.05]",
              "ring-2 ring-primary"
            ],
            className
          ),
          children: /* @__PURE__ */ jsxs(VStack, { gap: "md", className: "flex-1", children: [
            badge && /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", children: badge }),
            /* @__PURE__ */ jsx(Typography, { variant: "h3", children: name }),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "h2",
                className: "text-primary font-bold",
                children: price
              }
            ),
            description && /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: description }),
            /* @__PURE__ */ jsx(Divider, {}),
            /* @__PURE__ */ jsx(VStack, { gap: "sm", children: features.map((feature) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "check",
                  size: "sm",
                  className: "flex-shrink-0 text-success"
                }
              ),
              /* @__PURE__ */ jsx(Typography, { variant: "body2", children: feature })
            ] }, feature)) }),
            /* @__PURE__ */ jsx(Spacer, {}),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: highlighted ? "primary" : "secondary",
                size: "lg",
                className: "w-full",
                children: action.label
              }
            )
          ] })
        }
      );
    };
    PricingCard.displayName = "PricingCard";
  }
});
var PricingGrid;
var init_PricingGrid = __esm({
  "components/marketing/molecules/PricingGrid.tsx"() {
    "use client";
    init_cn();
    init_SimpleGrid();
    init_PricingCard();
    PricingGrid = ({
      plans,
      className
    }) => {
      const cols = Math.min(plans.length, 4);
      return /* @__PURE__ */ jsx(
        SimpleGrid,
        {
          cols: cols > 0 ? cols : 1,
          gap: "lg",
          className: cn("items-stretch", className),
          children: plans.map((plan) => /* @__PURE__ */ jsx(PricingCard, { ...plan }, plan.name))
        }
      );
    };
    PricingGrid.displayName = "PricingGrid";
  }
});
var StatsGrid;
var init_StatsGrid = __esm({
  "components/marketing/molecules/StatsGrid.tsx"() {
    "use client";
    init_cn();
    init_SimpleGrid();
    init_Stack();
    init_Typography();
    StatsGrid = ({
      stats,
      columns = 3,
      className
    }) => {
      return /* @__PURE__ */ jsx(SimpleGrid, { cols: columns, gap: "lg", className: cn("w-full", className), children: stats.map((stat) => /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "center", className: "py-4", children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "h2",
            className: "font-bold text-primary",
            children: stat.value
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: stat.label })
      ] }, stat.label)) });
    };
    StatsGrid.displayName = "StatsGrid";
  }
});
var ServiceCatalog;
var init_ServiceCatalog = __esm({
  "components/marketing/molecules/ServiceCatalog.tsx"() {
    "use client";
    init_cn();
    init_Card();
    init_Stack();
    init_Badge();
    init_Typography();
    init_SimpleGrid();
    ServiceCatalog = ({
      services,
      className
    }) => {
      return /* @__PURE__ */ jsx(SimpleGrid, { cols: 4, gap: "sm", className: cn(className), children: services.map((service) => /* @__PURE__ */ jsx(Card, { variant: "bordered", padding: "sm", children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "start", children: [
        /* @__PURE__ */ jsx(
          Badge,
          {
            size: "sm",
            className: service.layerColor,
            children: service.layer
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "body", children: service.name })
      ] }) }, service.name)) });
    };
    ServiceCatalog.displayName = "ServiceCatalog";
  }
});
var LogosVariant, QuotesVariant, BadgesVariant, SocialProof;
var init_SocialProof = __esm({
  "components/core/molecules/SocialProof.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Stack();
    init_Card();
    init_Badge();
    init_Typography();
    init_SimpleGrid();
    LogosVariant = ({ items }) => /* @__PURE__ */ jsx(HStack, { gap: "xl", justify: "center", className: "flex-wrap", children: items.map((item) => /* @__PURE__ */ jsx(
      Box,
      {
        className: "opacity-60 hover:opacity-100 transition-opacity cursor-default",
        children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "center", children: [
          item.logo && /* @__PURE__ */ jsx(
            Box,
            {
              className: "w-12 h-12 bg-contain bg-center bg-no-repeat",
              style: { backgroundImage: `url(${item.logo})` }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: item.name })
        ] })
      },
      item.name
    )) });
    LogosVariant.displayName = "SocialProof.LogosVariant";
    QuotesVariant = ({ items }) => {
      const cols = items.length >= 3 ? 3 : items.length >= 2 ? 2 : 1;
      return /* @__PURE__ */ jsx(SimpleGrid, { cols, gap: "md", children: items.map((item) => /* @__PURE__ */ jsx(Card, { variant: "bordered", padding: "md", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "start", children: [
        item.quote && /* @__PURE__ */ jsxs(Typography, { variant: "body", className: "italic", children: [
          "\u201C",
          item.quote,
          "\u201D"
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: item.name })
      ] }) }, item.name)) });
    };
    QuotesVariant.displayName = "SocialProof.QuotesVariant";
    BadgesVariant = ({ items }) => /* @__PURE__ */ jsx(HStack, { gap: "sm", justify: "center", className: "flex-wrap", children: items.map((item) => /* @__PURE__ */ jsx(Badge, { size: "md", children: item.name }, item.name)) });
    BadgesVariant.displayName = "SocialProof.BadgesVariant";
    SocialProof = ({
      items,
      variant = "logos",
      className
    }) => {
      return /* @__PURE__ */ jsxs(Box, { className: cn(className), children: [
        variant === "logos" && /* @__PURE__ */ jsx(LogosVariant, { items }),
        variant === "quotes" && /* @__PURE__ */ jsx(QuotesVariant, { items }),
        variant === "badges" && /* @__PURE__ */ jsx(BadgesVariant, { items })
      ] });
    };
    SocialProof.displayName = "SocialProof";
  }
});
var StepCircle, StepFlow;
var init_StepFlow = __esm({
  "components/marketing/molecules/StepFlow.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Center();
    init_Typography();
    init_Icon();
    init_Divider();
    StepCircle = ({ step, index }) => {
      if (step.icon) {
        return /* @__PURE__ */ jsx(
          Center,
          {
            className: cn(
              "w-10 h-10 rounded-full flex-shrink-0",
              "flex items-center justify-center",
              "bg-primary text-primary-foreground"
            ),
            children: /* @__PURE__ */ jsx(
              Icon,
              {
                icon: typeof step.icon === "string" ? void 0 : step.icon,
                name: typeof step.icon === "string" ? step.icon : void 0,
                size: "sm",
                className: "text-primary-foreground"
              }
            )
          }
        );
      }
      return /* @__PURE__ */ jsx(
        Center,
        {
          className: cn(
            "w-10 h-10 rounded-full flex-shrink-0",
            "flex items-center justify-center",
            "bg-primary text-primary-foreground"
          ),
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              as: "span",
              variant: "small",
              weight: "semibold",
              className: "text-primary-foreground leading-none",
              children: step.number ?? index + 1
            }
          )
        }
      );
    };
    StepCircle.displayName = "StepCircle";
    StepFlow = ({
      steps,
      orientation = "horizontal",
      showConnectors = true,
      className
    }) => {
      if (orientation === "vertical") {
        return /* @__PURE__ */ jsx(VStack, { gap: "none", className: cn("w-full", className), children: steps.map((step, index) => /* @__PURE__ */ jsx(React79__default.Fragment, { children: /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "start", className: "w-full", children: [
          /* @__PURE__ */ jsxs(VStack, { gap: "none", align: "center", children: [
            /* @__PURE__ */ jsx(StepCircle, { step, index }),
            showConnectors && index < steps.length - 1 && /* @__PURE__ */ jsx(Box, { className: "w-px h-8 bg-border" })
          ] }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 pt-1", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h4", children: step.title }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: step.description })
          ] })
        ] }) }, index)) });
      }
      return /* @__PURE__ */ jsx(Box, { className: cn("w-full flex flex-col md:flex-row items-start gap-0", className), children: steps.map((step, index) => /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "flex-1 w-full md:w-auto", children: [
          /* @__PURE__ */ jsx(StepCircle, { step, index }),
          /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "text-center", children: step.title }),
          /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", className: "text-center", children: step.description })
        ] }),
        showConnectors && index < steps.length - 1 && /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 self-center py-2 md:pt-5 md:py-0 md:px-2", children: /* @__PURE__ */ jsx(Divider, { orientation: "horizontal", className: "w-12 md:w-12" }) })
      ] }, index)) });
    };
    StepFlow.displayName = "StepFlow";
  }
});
var SplitSection;
var init_SplitSection = __esm({
  "components/marketing/molecules/SplitSection.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    init_Icon();
    SplitSection = ({
      title,
      description,
      bullets,
      image,
      imagePosition = "right",
      background = "default",
      children,
      className
    }) => {
      const textContent = /* @__PURE__ */ jsxs(VStack, { gap: "md", className: "flex-1 min-w-0", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "h2", children: title }),
        typeof description === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: description }) : description,
        Array.isArray(bullets) && bullets.length > 0 && /* @__PURE__ */ jsx(VStack, { gap: "sm", children: bullets.map((bullet, index) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", className: "mt-0.5", children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "check",
              size: "sm",
              className: "text-primary flex-shrink-0 mt-0.5"
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "body2", children: bullet })
        ] }, index)) })
      ] });
      const mediaContent = children ?? (image ? /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "flex-1 min-w-0 min-h-[240px] rounded-md",
            "bg-cover bg-center"
          ),
          style: { backgroundImage: `url(${image.src})` },
          role: "img",
          "aria-label": image.alt
        }
      ) : null);
      const isImageLeft = imagePosition === "left";
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "w-full",
            background === "alt" ? "bg-muted" : "bg-background",
            className
          ),
          padding: "lg",
          children: /* @__PURE__ */ jsxs(Box, { className: cn("w-full flex flex-col md:flex-row gap-8 md:gap-12 lg:gap-16 items-center", isImageLeft && "md:flex-row-reverse"), children: [
            /* @__PURE__ */ jsx(Box, { className: "flex-1 min-w-0 md:min-w-[45%]", children: textContent }),
            /* @__PURE__ */ jsx(Box, { className: "flex-1 min-w-0 md:max-w-[50%]", children: mediaContent })
          ] })
        }
      );
    };
    SplitSection.displayName = "SplitSection";
  }
});
function normalizeTags(tags) {
  if (tags.length === 0) return [];
  if (typeof tags[0] === "string") {
    return tags.map((label) => ({ label }));
  }
  return tags;
}
var variantMap3, TagCloud;
var init_TagCloud = __esm({
  "components/marketing/molecules/TagCloud.tsx"() {
    "use client";
    init_cn();
    init_Stack();
    init_Badge();
    variantMap3 = {
      default: "default",
      primary: "primary",
      accent: "info"
    };
    TagCloud = ({
      tags,
      variant = "default",
      className
    }) => {
      const normalizedTags = normalizeTags(tags);
      return /* @__PURE__ */ jsx(HStack, { gap: "sm", className: cn("flex-wrap justify-center", className), children: normalizedTags.map((tag, index) => {
        const badgeVariant = tag.variant ? variantMap3[tag.variant] ?? "default" : variantMap3[variant] ?? "default";
        return /* @__PURE__ */ jsx(Badge, { variant: badgeVariant, label: tag.label }, index);
      }) });
    };
    TagCloud.displayName = "TagCloud";
  }
});
var TagInput;
var init_TagInput = __esm({
  "components/core/molecules/TagInput.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Input();
    init_Badge();
    init_Stack();
    init_Typography();
    TagInput = ({
      value,
      onChange,
      placeholder,
      disabled = false,
      variant = "default",
      unique = true,
      helperText,
      className,
      addEvent,
      removeEvent
    }) => {
      const eventBus = useEventBus();
      const [draft, setDraft] = useState("");
      const commit = useCallback(() => {
        const tag = draft.trim();
        if (!tag) return;
        if (unique && value.includes(tag)) {
          setDraft("");
          return;
        }
        const next = [...value, tag];
        onChange?.(next);
        if (addEvent) {
          eventBus.emit(`UI:${addEvent}`, { tag, value: next });
        }
        setDraft("");
      }, [draft, value, onChange, unique, addEvent, eventBus]);
      const removeAt = useCallback(
        (index) => {
          if (disabled) return;
          const tag = value[index];
          const next = value.slice();
          next.splice(index, 1);
          onChange?.(next);
          if (removeEvent) {
            eventBus.emit(`UI:${removeEvent}`, { tag, index, value: next });
          }
        },
        [value, onChange, disabled, removeEvent, eventBus]
      );
      const handleKeyDown = useCallback(
        (e) => {
          if (disabled) return;
          if (e.key === "Enter") {
            e.preventDefault();
            commit();
          } else if (e.key === "Backspace" && draft.length === 0 && value.length > 0) {
            e.preventDefault();
            removeAt(value.length - 1);
          }
        },
        [commit, draft.length, value, removeAt, disabled]
      );
      return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: cn("w-full", className), children: [
        value.length > 0 ? /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: value.map((tag, index) => /* @__PURE__ */ jsx(
          Badge,
          {
            variant,
            size: "sm",
            onRemove: disabled ? void 0 : () => removeAt(index),
            removeLabel: `Remove ${tag}`,
            children: tag
          },
          `${tag}-${index}`
        )) }) : null,
        /* @__PURE__ */ jsx(
          Input,
          {
            value: draft,
            placeholder: placeholder ?? "Type and press Enter\u2026",
            disabled,
            onChange: (e) => setDraft(e.target.value),
            onKeyDown: handleKeyDown
          }
        ),
        helperText ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: helperText }) : null
      ] });
    };
    TagInput.displayName = "TagInput";
  }
});
var ShowcaseCard;
var init_ShowcaseCard = __esm({
  "components/marketing/molecules/ShowcaseCard.tsx"() {
    "use client";
    init_cn();
    init_Card();
    init_Box();
    init_Stack();
    init_Badge();
    init_Typography();
    ShowcaseCard = ({
      title,
      description,
      image,
      href,
      badge,
      accentColor,
      className
    }) => {
      const cardVariant = href ? "interactive" : "bordered";
      const handleClick = () => {
        if (href) {
          window.open(href, "_blank", "noopener,noreferrer");
        }
      };
      return /* @__PURE__ */ jsxs(
        Card,
        {
          variant: cardVariant,
          padding: "none",
          className: cn("overflow-hidden w-full", className),
          style: accentColor ? { borderTopColor: accentColor, borderTopWidth: "3px" } : void 0,
          onClick: href ? handleClick : void 0,
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "w-full aspect-video bg-cover bg-center",
                  "rounded-t-md"
                ),
                style: { backgroundImage: `url(${image.src})` },
                role: "img",
                "aria-label": image.alt
              }
            ),
            /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-4", children: [
              badge && /* @__PURE__ */ jsx(Badge, { variant: "primary", label: badge }),
              /* @__PURE__ */ jsx(Typography, { variant: "h3", children: title }),
              description && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: description })
            ] })
          ]
        }
      );
    };
    ShowcaseCard.displayName = "ShowcaseCard";
  }
});
function PatternDefs({
  patternId,
  variant,
  size,
  color,
  strokeWidth
}) {
  const dims = getTileDimensions(variant, size);
  return /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
    "pattern",
    {
      id: patternId,
      x: "0",
      y: "0",
      width: dims.width,
      height: dims.height,
      patternUnits: "userSpaceOnUse",
      children: /* @__PURE__ */ jsx(
        PatternTile,
        {
          variant,
          size,
          color,
          strokeWidth
        }
      )
    }
  ) });
}
function BackgroundMode({
  patternId,
  variant,
  size,
  color,
  strokeWidth,
  opacity,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            opacity
          }
        )
      ]
    }
  );
}
function SideMode({
  patternId,
  variant,
  size,
  color,
  strokeWidth,
  opacity,
  side,
  className
}) {
  const maskId = `${patternId}-mask`;
  const gradientId = `${patternId}-grad`;
  const x1 = side === "left" ? "0%" : "100%";
  const x2 = side === "left" ? "60%" : "40%";
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, x1, y1: "0%", x2, y2: "0%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "white", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "white", stopOpacity: "0" })
          ] }),
          /* @__PURE__ */ jsx("mask", { id: maskId, children: /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${gradientId})` }) })
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            mask: `url(#${maskId})`,
            opacity
          }
        )
      ]
    }
  );
}
function DualMode({
  patternId,
  variant,
  size,
  color,
  strokeWidth,
  opacity,
  className
}) {
  const maskId = `${patternId}-dmask`;
  const gradientId = `${patternId}-dgrad`;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "white", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "35%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "65%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "white", stopOpacity: "1" })
          ] }),
          /* @__PURE__ */ jsx("mask", { id: maskId, children: /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${gradientId})` }) })
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            mask: `url(#${maskId})`,
            opacity
          }
        )
      ]
    }
  );
}
function AroundMode({
  patternId,
  variant,
  size,
  color,
  strokeWidth,
  opacity,
  className
}) {
  const maskId = `${patternId}-amask`;
  const gradientId = `${patternId}-agrad`;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("radialGradient", { id: gradientId, cx: "50%", cy: "50%", r: "50%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "55%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "85%", stopColor: "white", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "white", stopOpacity: "1" })
          ] }),
          /* @__PURE__ */ jsx("mask", { id: maskId, children: /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${gradientId})` }) })
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            mask: `url(#${maskId})`,
            opacity
          }
        )
      ]
    }
  );
}
function FrameStrip({
  patternId,
  variant,
  size,
  color,
  strokeWidth,
  opacity,
  height
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: "w-full pointer-events-none",
      style: { height },
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            opacity
          }
        )
      ]
    }
  );
}
var GeometricPattern;
var init_GeometricPattern = __esm({
  "components/marketing/molecules/GeometricPattern.tsx"() {
    "use client";
    init_cn();
    init_PatternTile();
    init_Box();
    GeometricPattern = ({
      variant = "star8",
      mode = "background",
      opacity = 0.06,
      color = "var(--color-primary)",
      scale = 1,
      strokeWidth = 0.5,
      children,
      className
    }) => {
      const reactId = useId();
      const patternId = `gp${reactId.replace(/:/g, "")}`;
      const size = 60 * scale;
      const stripHeight = 40 * scale;
      if (mode === "frame") {
        const topId = `${patternId}-top`;
        const botId = `${patternId}-bot`;
        return /* @__PURE__ */ jsxs(Box, { className: cn("relative", className), children: [
          /* @__PURE__ */ jsx(
            FrameStrip,
            {
              patternId: topId,
              variant,
              size,
              color,
              strokeWidth,
              opacity,
              height: stripHeight
            }
          ),
          children,
          /* @__PURE__ */ jsx(
            FrameStrip,
            {
              patternId: botId,
              variant,
              size,
              color,
              strokeWidth,
              opacity,
              height: stripHeight
            }
          )
        ] });
      }
      if (mode === "around") {
        return /* @__PURE__ */ jsx(
          AroundMode,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth,
            opacity,
            className
          }
        );
      }
      if (mode === "dual") {
        return /* @__PURE__ */ jsx(
          DualMode,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth,
            opacity,
            className
          }
        );
      }
      if (mode === "left" || mode === "right") {
        return /* @__PURE__ */ jsx(
          SideMode,
          {
            patternId,
            variant,
            size,
            color,
            strokeWidth,
            opacity,
            side: mode,
            className
          }
        );
      }
      return /* @__PURE__ */ jsx(
        BackgroundMode,
        {
          patternId,
          variant,
          size,
          color,
          strokeWidth,
          opacity,
          className
        }
      );
    };
    GeometricPattern.displayName = "GeometricPattern";
  }
});
function ArchSVG({
  facing,
  w,
  h,
  color,
  strokeWidth
}) {
  const paths = [];
  const archCount = 3;
  const archH = h / archCount;
  const rings = 5;
  for (let a = 0; a < archCount; a++) {
    const baseY = a * archH + archH;
    const topY = a * archH + archH * 0.05;
    for (let r = 0; r < rings; r++) {
      const scale = 1 - r * 0.17;
      const archW = w * 0.95 * scale;
      const aTopY = topY + (1 - scale) * (baseY - topY) * 0.5;
      const aBaseY = baseY - (1 - scale) * archH * 0.05;
      const edgeX2 = facing === "right" ? w : 0;
      const innerX2 = facing === "right" ? w - archW : archW;
      const midY = (aTopY + aBaseY) / 2;
      const radius = Math.sqrt(archW * archW + (aBaseY - midY) * (aBaseY - midY));
      if (facing === "right") {
        paths.push(
          `M ${f2(edgeX2)},${f2(aBaseY)} A ${f2(radius)} ${f2(radius)} 0 0 0 ${f2(innerX2)},${f2(aTopY + (aBaseY - aTopY) * 0.5)} A ${f2(radius)} ${f2(radius)} 0 0 0 ${f2(edgeX2)},${f2(aTopY)}`
        );
      } else {
        paths.push(
          `M ${f2(edgeX2)},${f2(aBaseY)} A ${f2(radius)} ${f2(radius)} 0 0 1 ${f2(innerX2)},${f2(aTopY + (aBaseY - aTopY) * 0.5)} A ${f2(radius)} ${f2(radius)} 0 0 1 ${f2(edgeX2)},${f2(aTopY)}`
        );
      }
    }
    const edgeX = facing === "right" ? w : 0;
    const innerX = facing === "right" ? w * 0.05 : w * 0.95;
    paths.push(`M ${f2(edgeX)},${f2(baseY)} L ${f2(innerX)},${f2(baseY)}`);
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function VineSVG({
  facing,
  w,
  h,
  color,
  strokeWidth
}) {
  const paths = [];
  const dir = facing === "right" ? -1 : 1;
  const edgeX = facing === "right" ? w * 0.85 : w * 0.15;
  const segments = 5;
  const segH = h / segments;
  for (let i = 0; i < segments; i++) {
    const y0 = i * segH;
    const y1 = y0 + segH;
    const sway = w * 0.12 * (i % 2 === 0 ? 1 : -1);
    paths.push(
      `M ${f2(edgeX + sway)},${f2(y0)} C ${f2(edgeX - sway)},${f2(y0 + segH * 0.33)} ${f2(edgeX + sway)},${f2(y0 + segH * 0.66)} ${f2(edgeX - sway)},${f2(y1)}`
    );
    const branchY = y0 + segH * 0.35;
    const branchX = edgeX;
    const leafW = w * 0.55;
    const leafH = segH * 0.35;
    const leafTipX = branchX + dir * leafW;
    const leafTipY = branchY - leafH * 0.2;
    paths.push(
      `M ${f2(branchX)},${f2(branchY)} C ${f2(branchX + dir * leafW * 0.3)},${f2(branchY - leafH)} ${f2(leafTipX - dir * leafW * 0.1)},${f2(leafTipY - leafH * 0.3)} ${f2(leafTipX)},${f2(leafTipY)}`
    );
    paths.push(
      `M ${f2(leafTipX)},${f2(leafTipY)} C ${f2(leafTipX - dir * leafW * 0.2)},${f2(leafTipY + leafH * 0.6)} ${f2(branchX + dir * leafW * 0.15)},${f2(branchY + leafH * 0.4)} ${f2(branchX)},${f2(branchY + leafH * 0.1)}`
    );
    const tendrilY = y0 + segH * 0.7;
    const tendrilW = w * 0.35;
    const tendrilTipX = edgeX + dir * tendrilW;
    paths.push(
      `M ${f2(edgeX)},${f2(tendrilY)} Q ${f2(edgeX + dir * tendrilW * 0.6)},${f2(tendrilY - segH * 0.12)} ${f2(tendrilTipX)},${f2(tendrilY + segH * 0.05)}`
    );
    const spR = leafW * 0.08;
    paths.push(
      `M ${f2(leafTipX)},${f2(leafTipY)} A ${f2(spR)} ${f2(spR)} 0 1 ${facing === "right" ? 0 : 1} ${f2(leafTipX + dir * spR * 0.5)},${f2(leafTipY + spR)}`
    );
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function LatticeSVG({
  facing,
  w,
  h,
  color,
  strokeWidth
}) {
  const paths = [];
  const cols = 5;
  const rows2 = Math.ceil(h / (w / cols));
  const cellW = w / cols;
  const cellH = cellW;
  const bulge = cellW * 0.3;
  for (let row = 0; row < rows2; row++) {
    for (let col = 0; col < cols; col++) {
      const cx = col * cellW + cellW / 2;
      const cy = row * cellH + cellH / 2;
      const hw = cellW * 0.5;
      const hh = cellH * 0.5;
      paths.push(
        `M ${f2(cx)},${f2(cy - hh)} Q ${f2(cx + bulge)},${f2(cy)} ${f2(cx)},${f2(cy + hh)}`
      );
      paths.push(
        `M ${f2(cx)},${f2(cy - hh)} Q ${f2(cx - bulge)},${f2(cy)} ${f2(cx)},${f2(cy + hh)}`
      );
      paths.push(
        `M ${f2(cx - hw)},${f2(cy)} Q ${f2(cx)},${f2(cy - bulge * 0.5)} ${f2(cx + hw)},${f2(cy)}`
      );
      paths.push(
        `M ${f2(cx - hw)},${f2(cy)} Q ${f2(cx)},${f2(cy + bulge * 0.5)} ${f2(cx + hw)},${f2(cy)}`
      );
    }
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function f2(n) {
  return n.toFixed(2);
}
var colorTokenVars, VARIANT_MAP2, EdgeDecoration;
var init_EdgeDecoration = __esm({
  "components/core/molecules/EdgeDecoration.tsx"() {
    "use client";
    init_cn();
    colorTokenVars = {
      primary: "var(--color-primary)",
      secondary: "var(--color-secondary)",
      success: "var(--color-success)",
      warning: "var(--color-warning)",
      error: "var(--color-error)",
      muted: "var(--color-muted)"
    };
    VARIANT_MAP2 = {
      arch: ArchSVG,
      vine: VineSVG,
      lattice: LatticeSVG
    };
    EdgeDecoration = ({
      variant = "arch",
      side = "both",
      opacity = 0.15,
      color = "primary",
      strokeWidth = 0.5,
      width = 15,
      className
    }) => {
      const id = useId();
      const Variant = VARIANT_MAP2[variant];
      const resolvedColor = color in colorTokenVars ? colorTokenVars[color] : color;
      const sides = side === "both" ? ["left", "right"] : [side];
      return /* @__PURE__ */ jsx(Fragment, { children: sides.map((s) => /* @__PURE__ */ jsx(
        "svg",
        {
          className: cn(
            "absolute top-0 h-full pointer-events-none",
            s === "left" ? "left-0" : "right-0",
            className
          ),
          style: {
            width: `${width}%`,
            opacity
          },
          viewBox: `0 0 200 ${200 * 3}`,
          preserveAspectRatio: "none",
          "aria-hidden": "true",
          children: /* @__PURE__ */ jsx(
            Variant,
            {
              facing: s,
              w: 200,
              h: 600,
              color: resolvedColor,
              strokeWidth
            }
          )
        },
        `${id}-${s}`
      )) });
    };
    EdgeDecoration.displayName = "EdgeDecoration";
  }
});
var sizeStyles11, VoteStack;
var init_VoteStack = __esm({
  "components/core/molecules/VoteStack.tsx"() {
    "use client";
    init_cn();
    init_Icon();
    init_useEventBus();
    sizeStyles11 = {
      sm: {
        button: "w-7 h-7",
        text: "text-sm min-w-[2rem]",
        icon: "w-3 h-3"
      },
      md: {
        button: "w-9 h-9",
        text: "text-base min-w-[2.5rem]",
        icon: "w-4 h-4"
      },
      lg: {
        button: "w-11 h-11",
        text: "text-lg min-w-[3rem]",
        icon: "w-5 h-5"
      }
    };
    VoteStack = ({
      count,
      userVote = null,
      onVote,
      voteEvent,
      disabled = false,
      size = "md",
      variant = "vertical",
      className,
      label
    }) => {
      const styles = sizeStyles11[size];
      const isUp = userVote === "up";
      const isDown = userVote === "down";
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleUp = useCallback(() => {
        const next = isUp ? null : "up";
        onVote?.(next);
        if (voteEvent) {
          eventBus.emit(`UI:${voteEvent}`, { next });
        }
      }, [isUp, onVote, voteEvent, eventBus]);
      const handleDown = useCallback(() => {
        const next = isDown ? null : "down";
        onVote?.(next);
        if (voteEvent) {
          eventBus.emit(`UI:${voteEvent}`, { next });
        }
      }, [isDown, onVote, voteEvent, eventBus]);
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "inline-flex items-center justify-center",
            // Shrink-wrap in stretch contexts (slot/sidecar wrappers are
            // flex-column with stretch alignment): without this the root spans
            // the full wrapper width and the count row's `w-full` turns the
            // compact pill into a page-wide band.
            "w-fit",
            variant === "vertical" ? "flex-col" : "flex-row",
            "rounded-sm",
            "border-[length:var(--border-width)] border-border",
            "bg-surface",
            disabled && "opacity-50 cursor-not-allowed",
            className
          ),
          role: "group",
          "aria-label": label ?? "Vote",
          children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: handleUp,
                disabled,
                "aria-label": t("aria.upvote"),
                "aria-pressed": isUp,
                className: cn(
                  "inline-flex items-center justify-center",
                  variant === "vertical" ? "rounded-t-sm" : "rounded-l-sm",
                  isUp ? "text-primary" : "text-muted-foreground",
                  "hover:bg-muted",
                  "active:bg-muted",
                  "transition-colors duration-instant",
                  "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
                  "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
                  styles.button
                ),
                children: /* @__PURE__ */ jsx(Icon, { name: "chevron-up", className: styles.icon })
              }
            ),
            /* @__PURE__ */ jsx(
              "span",
              {
                className: cn(
                  "text-center font-bold tabular-nums select-none",
                  "text-foreground",
                  variant === "vertical" ? "border-y-[length:var(--border-width)] border-border w-full" : "border-x-[length:var(--border-width)] border-border h-full",
                  "px-1 py-0.5",
                  styles.text
                ),
                "aria-live": "polite",
                "aria-atomic": "true",
                children: count
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: handleDown,
                disabled,
                "aria-label": t("aria.downvote"),
                "aria-pressed": isDown,
                className: cn(
                  "inline-flex items-center justify-center",
                  variant === "vertical" ? "rounded-b-sm" : "rounded-r-sm",
                  isDown ? "text-primary" : "text-muted-foreground",
                  "hover:bg-muted",
                  "active:bg-muted",
                  "transition-colors duration-instant",
                  "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
                  "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
                  styles.button
                ),
                children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: styles.icon })
              }
            )
          ]
        }
      );
    };
    VoteStack.displayName = "VoteStack";
  }
});
var DEFAULT_LIKERT_OPTIONS, radioSizes, buttonSizes, questionSizes, LikertScale;
var init_LikertScale = __esm({
  "components/core/molecules/LikertScale.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_Button();
    init_Label();
    init_Radio();
    DEFAULT_LIKERT_OPTIONS = [
      { value: 1, label: "Strongly Disagree" },
      { value: 2, label: "Disagree" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Agree" },
      { value: 5, label: "Strongly Agree" }
    ];
    radioSizes = {
      sm: { label: "text-xs", gap: "gap-1.5" },
      md: { label: "text-sm", gap: "gap-2" },
      lg: { label: "text-base", gap: "gap-2.5" }
    };
    buttonSizes = {
      sm: "px-2 py-1 text-xs",
      md: "px-3 py-1.5 text-sm",
      lg: "px-4 py-2 text-base"
    };
    questionSizes = {
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg"
    };
    LikertScale = React79__default.forwardRef(
      ({
        question,
        options = DEFAULT_LIKERT_OPTIONS,
        value = null,
        onChange,
        changeEvent,
        disabled = false,
        size = "md",
        variant = "radios",
        className
      }, ref) => {
        const groupId = React79__default.useId();
        const eventBus = useEventBus();
        const handleSelect = useCallback(
          (next) => {
            if (disabled) return;
            onChange?.(next);
            if (changeEvent) {
              eventBus.emit(`UI:${changeEvent}`, { value: next });
            }
          },
          [disabled, onChange, changeEvent, eventBus]
        );
        return /* @__PURE__ */ jsxs(
          Box,
          {
            ref,
            className: cn(
              "w-full",
              disabled && "opacity-50 cursor-not-allowed",
              className
            ),
            role: "radiogroup",
            "aria-label": question ?? "Likert scale",
            children: [
              question && /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn(
                    "mb-3 font-medium text-foreground",
                    questionSizes[size]
                  ),
                  children: question
                }
              ),
              variant === "buttons" ? /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn(
                    "inline-flex w-full items-stretch rounded-sm overflow-hidden",
                    "border-[length:var(--border-width)] border-border",
                    "bg-surface"
                  ),
                  children: options.map((opt, idx) => {
                    const selected = value !== null && value !== void 0 && value === opt.value;
                    return /* @__PURE__ */ jsx(
                      Button,
                      {
                        type: "button",
                        role: "radio",
                        "aria-checked": selected,
                        disabled,
                        onClick: () => handleSelect(opt.value),
                        className: cn(
                          "flex-1 text-center font-medium transition-colors duration-instant",
                          "focus:outline-none focus:ring-[length:var(--focus-ring-width)] focus:ring-ring focus:ring-inset",
                          "disabled:cursor-not-allowed",
                          "rounded-none gap-0 shadow-none border-none",
                          idx > 0 && "border-l-[length:var(--border-width)] border-border",
                          buttonSizes[size],
                          selected ? "bg-primary text-primary-foreground" : "bg-surface text-foreground hover:bg-muted"
                        ),
                        children: opt.label
                      },
                      String(opt.value)
                    );
                  })
                }
              ) : /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn(
                    "flex w-full items-start justify-between",
                    radioSizes[size].gap
                  ),
                  children: options.map((opt) => {
                    const selected = value !== null && value !== void 0 && value === opt.value;
                    const inputId = `${groupId}-${String(opt.value)}`;
                    return /* @__PURE__ */ jsxs(
                      Box,
                      {
                        className: cn(
                          "flex flex-1 flex-col items-center",
                          radioSizes[size].gap
                        ),
                        children: [
                          /* @__PURE__ */ jsx(
                            Radio,
                            {
                              id: inputId,
                              name: groupId,
                              size,
                              checked: selected,
                              disabled,
                              onChange: () => handleSelect(opt.value)
                            }
                          ),
                          /* @__PURE__ */ jsx(
                            Label,
                            {
                              htmlFor: inputId,
                              className: cn(
                                "text-center select-none",
                                radioSizes[size].label,
                                selected ? "text-foreground font-medium" : "text-muted-foreground",
                                disabled ? "cursor-not-allowed" : "cursor-pointer"
                              ),
                              children: opt.label
                            }
                          )
                        ]
                      },
                      String(opt.value)
                    );
                  })
                }
              )
            ]
          }
        );
      }
    );
    LikertScale.displayName = "LikertScale";
  }
});
var DEFAULT_MATRIX_COLUMNS, sizeStyles12, MatrixQuestion;
var init_MatrixQuestion = __esm({
  "components/core/molecules/MatrixQuestion.tsx"() {
    "use client";
    init_cn();
    init_Typography();
    init_Box();
    init_Radio();
    init_useEventBus();
    DEFAULT_MATRIX_COLUMNS = [
      { value: 1, label: "Strongly Disagree" },
      { value: 2, label: "Disagree" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Agree" },
      { value: 5, label: "Strongly Agree" }
    ];
    sizeStyles12 = {
      sm: {
        cell: "px-2 py-1.5 text-xs",
        radio: "sm",
        label: "text-xs"
      },
      md: {
        cell: "px-3 py-2 text-sm",
        radio: "md",
        label: "text-sm"
      }
    };
    MatrixQuestion = ({
      title,
      rows: rows2,
      columns = DEFAULT_MATRIX_COLUMNS,
      values,
      onChange,
      changeEvent,
      disabled = false,
      size = "md",
      className
    }) => {
      const styles = sizeStyles12[size];
      const safeRows = rows2 ?? [];
      const safeValues = values ?? {};
      const eventBus = useEventBus();
      const handleChange = useCallback(
        (rowId, value) => {
          if (disabled) return;
          onChange?.(rowId, value);
          if (changeEvent) {
            eventBus.emit(`UI:${changeEvent}`, { rowId, value });
          }
        },
        [onChange, changeEvent, eventBus, disabled]
      );
      return /* @__PURE__ */ jsxs(Box, { className: cn("w-full", className), children: [
        title && /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "mb-3", children: title }),
        /* @__PURE__ */ jsx(Box, { overflow: "auto", className: "overflow-x-auto", children: /* @__PURE__ */ jsxs(Box, { as: "table", className: "w-full border-collapse", children: [
          /* @__PURE__ */ jsx(Box, { as: "thead", children: /* @__PURE__ */ jsxs(Box, { as: "tr", className: "border-b border-border", children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                as: "th",
                role: "columnheader",
                className: cn("text-left font-medium text-muted-foreground", styles.cell)
              }
            ),
            columns.map((col) => /* @__PURE__ */ jsx(
              Box,
              {
                as: "th",
                role: "columnheader",
                className: cn(
                  "text-center font-medium text-muted-foreground",
                  styles.cell
                ),
                children: col.label
              },
              String(col.value)
            ))
          ] }) }),
          /* @__PURE__ */ jsx(Box, { as: "tbody", children: safeRows.map((row, idx) => {
            const groupName = `matrix-${row.id}`;
            const selected = safeValues[row.id];
            return /* @__PURE__ */ jsxs(
              Box,
              {
                as: "tr",
                className: cn(
                  "border-b border-border",
                  idx % 2 === 1 && "bg-muted/30"
                ),
                children: [
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      as: "th",
                      role: "rowheader",
                      className: cn(
                        "text-left font-normal text-foreground",
                        styles.cell,
                        styles.label
                      ),
                      children: row.label
                    }
                  ),
                  columns.map((col) => {
                    const isChecked = selected !== void 0 && selected === col.value;
                    const inputId = `${groupName}-${String(col.value)}`;
                    return /* @__PURE__ */ jsx(
                      Box,
                      {
                        as: "td",
                        className: cn("text-center", styles.cell),
                        children: /* @__PURE__ */ jsx(
                          Box,
                          {
                            display: "inline-flex",
                            className: cn(
                              "items-center justify-center",
                              disabled && "opacity-60"
                            ),
                            children: /* @__PURE__ */ jsx(
                              Radio,
                              {
                                id: inputId,
                                name: groupName,
                                value: String(col.value),
                                checked: isChecked,
                                disabled,
                                size: styles.radio,
                                onChange: () => handleChange(row.id, col.value),
                                "aria-label": `${row.label}: ${col.label}`
                              }
                            )
                          }
                        )
                      },
                      String(col.value)
                    );
                  })
                ]
              },
              row.id
            );
          }) })
        ] }) })
      ] });
    };
    MatrixQuestion.displayName = "MatrixQuestion";
  }
});
var QrScanner;
var init_QrScanner = __esm({
  "components/core/molecules/QrScanner.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Icon();
    init_useEventBus();
    QrScanner = ({
      onScan,
      scanEvent,
      onError,
      facingMode = "environment",
      paused = false,
      showOverlay = true,
      showCameraControls = true,
      fallback,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const videoRef = useRef(null);
      const streamRef = useRef(null);
      const scanIntervalRef = useRef(null);
      const [currentFacing, setCurrentFacing] = useState(facingMode);
      const [isPaused, setIsPaused] = useState(paused);
      const [cameraError, setCameraError] = useState(null);
      const [isReady, setIsReady] = useState(false);
      const stopStream = useCallback(() => {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach((track) => track.stop());
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        setIsReady(false);
      }, []);
      const startStream = useCallback(async () => {
        if (typeof navigator === "undefined" || !navigator.mediaDevices?.getUserMedia) {
          const err = new Error("Camera API not available in this environment");
          setCameraError(err);
          onError?.(err);
          return;
        }
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: currentFacing }
          });
          streamRef.current = stream;
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            await videoRef.current.play().catch(() => {
            });
          }
          setCameraError(null);
          setIsReady(true);
        } catch (e) {
          const err = e instanceof Error ? e : new Error(String(e));
          setCameraError(err);
          onError?.(err);
          setIsReady(false);
        }
      }, [currentFacing, onError]);
      useEffect(() => {
        if (isPaused) {
          stopStream();
          return;
        }
        void startStream();
        return () => {
          stopStream();
        };
      }, [currentFacing, isPaused, startStream, stopStream]);
      useEffect(() => {
        setIsPaused(paused);
      }, [paused]);
      useEffect(() => {
        setCurrentFacing(facingMode);
      }, [facingMode]);
      useEffect(() => {
        if (!isReady || isPaused) return;
        scanIntervalRef.current = setInterval(() => {
        }, 200);
        return () => {
          if (scanIntervalRef.current) {
            clearInterval(scanIntervalRef.current);
            scanIntervalRef.current = null;
          }
        };
      }, [isReady, isPaused]);
      const toggleFacing = useCallback(() => {
        setCurrentFacing((f3) => f3 === "environment" ? "user" : "environment");
      }, []);
      const togglePause = useCallback(() => {
        setIsPaused((p) => !p);
      }, []);
      const handleMockScan = useCallback(() => {
        const result = {
          text: "https://example.com/mock-qr",
          format: "QR_CODE",
          timestamp: Date.now()
        };
        onScan?.(result);
        if (scanEvent) {
          eventBus.emit(`UI:${scanEvent}`, { ...result });
        }
      }, [onScan, scanEvent, eventBus]);
      const videoExtraProps = {
        playsInline: true,
        muted: true
      };
      if (cameraError && fallback) {
        return /* @__PURE__ */ jsx(Box, { position: "relative", className, children: fallback });
      }
      return /* @__PURE__ */ jsxs(
        Box,
        {
          position: "relative",
          overflow: "hidden",
          rounded: "sm",
          className: cn(
            // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
            "bg-black",
            "aspect-square w-full max-w-md",
            className
          ),
          "data-pattern": "qr-scanner",
          role: "region",
          "aria-label": t("aria.qrScanner"),
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                as: "video",
                ref: videoRef,
                position: "absolute",
                fullWidth: true,
                fullHeight: true,
                className: "inset-0 object-cover",
                "aria-hidden": "true",
                ...videoExtraProps
              }
            ),
            showOverlay && isReady && !isPaused && /* @__PURE__ */ jsxs(Box, { position: "absolute", className: "pointer-events-none inset-0", children: [
              /* @__PURE__ */ jsx(Box, { position: "absolute", className: "left-[15%] top-[15%] h-8 w-8 border-l-2 border-t-2 border-white" }),
              /* @__PURE__ */ jsx(Box, { position: "absolute", className: "right-[15%] top-[15%] h-8 w-8 border-r-2 border-t-2 border-white" }),
              /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-[15%] left-[15%] h-8 w-8 border-b-2 border-l-2 border-white" }),
              /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-[15%] right-[15%] h-8 w-8 border-b-2 border-r-2 border-white" }),
              /* @__PURE__ */ jsx(Box, { position: "absolute", className: "left-[15%] right-[15%] top-1/2 h-px bg-white opacity-60" })
            ] }),
            cameraError && !fallback && /* @__PURE__ */ jsxs(
              Box,
              {
                position: "absolute",
                display: "flex",
                padding: "lg",
                className: "inset-0 flex-col items-center justify-center gap-2 bg-black bg-opacity-80 text-center",
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "camera", className: "h-8 w-8 text-white", "aria-hidden": "true" }),
                  /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-white", children: t("qrScanner.cameraUnavailable") }),
                  /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-white opacity-70", children: cameraError.message })
                ]
              }
            ),
            isPaused && !cameraError && /* @__PURE__ */ jsx(
              Box,
              {
                position: "absolute",
                display: "flex",
                className: "inset-0 items-center justify-center bg-black bg-opacity-60",
                children: /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-white", children: t("qrScanner.paused") })
              }
            ),
            showCameraControls && /* @__PURE__ */ jsxs(
              Box,
              {
                position: "absolute",
                display: "flex",
                className: "bottom-3 left-1/2 -translate-x-1/2 gap-2",
                children: [
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "button",
                      onClick: togglePause,
                      className: cn(
                        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                        "rounded-full bg-black bg-opacity-60 p-2 text-white",
                        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                        "hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                      ),
                      "aria-label": isPaused ? t("qrScanner.resumeScanning") : t("qrScanner.pauseScanning"),
                      children: isPaused ? /* @__PURE__ */ jsx(Icon, { name: "play", className: "h-4 w-4" }) : /* @__PURE__ */ jsx(Icon, { name: "pause", className: "h-4 w-4" })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "button",
                      onClick: toggleFacing,
                      className: cn(
                        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                        "rounded-full bg-black bg-opacity-60 p-2 text-white",
                        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                        "hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                      ),
                      "aria-label": currentFacing === "environment" ? t("qrScanner.switchToFrontCamera") : t("qrScanner.switchToRearCamera"),
                      children: /* @__PURE__ */ jsx(Icon, { name: "refresh-cw", className: "h-4 w-4" })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "button",
                      onClick: handleMockScan,
                      className: cn(
                        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                        "rounded-full bg-black bg-opacity-60 px-3 py-2 text-xs text-white",
                        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                        "hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                      ),
                      "aria-label": t("aria.mockScanDev"),
                      children: t("qrScanner.mockScan")
                    }
                  )
                ]
              }
            )
          ]
        }
      );
    };
    QrScanner.displayName = "QrScanner";
  }
});
var formatPriceDelta, constraintHint, validateSelection, OptionConstraintGroup;
var init_OptionConstraintGroup = __esm({
  "components/core/molecules/OptionConstraintGroup.tsx"() {
    init_cn();
    init_useEventBus();
    init_Typography();
    init_Box();
    init_Label();
    init_Radio();
    init_Checkbox();
    formatPriceDelta = (delta) => {
      const sign = delta >= 0 ? "+" : "-";
      return `${sign}$${Math.abs(delta).toFixed(2)}`;
    };
    constraintHint = (constraint, t) => {
      if (constraint.type === "single") {
        return constraint.required ? t("optionConstraint.requiredOne") : t("optionConstraint.optionalOne");
      }
      const { min, max } = constraint;
      if (min && max) {
        return min === max ? t("optionConstraint.pickExactly", { count: min }) : t("optionConstraint.pickRange", { min, max });
      }
      if (min) return t("optionConstraint.pickAtLeast", { count: min });
      if (max) return t("optionConstraint.pickUpTo", { count: max });
      return t("optionConstraint.optional");
    };
    validateSelection = (selected, constraint, t) => {
      if (constraint.type === "single") {
        if (constraint.required && selected.length === 0) {
          return t("optionConstraint.error.pickOne");
        }
        if (selected.length > 1) {
          return t("optionConstraint.error.pickOnlyOne");
        }
        return void 0;
      }
      const { min, max } = constraint;
      if (min !== void 0 && selected.length < min) {
        const remaining = min - selected.length;
        return t("optionConstraint.error.pickMore", { count: remaining });
      }
      if (max !== void 0 && selected.length > max) {
        const excess = selected.length - max;
        return t("optionConstraint.error.removeOptions", { count: excess });
      }
      return void 0;
    };
    OptionConstraintGroup = ({
      groupId,
      title,
      description,
      options,
      constraint = { type: "single" },
      selected = [],
      onChange,
      changeEvent,
      size = "md",
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const hint = constraintHint(constraint, t);
      const error = validateSelection(selected, constraint, t);
      const inputName = `option-${groupId}`;
      const labelTextSize = size === "sm" ? "text-sm" : "text-base";
      const optionGap = size === "sm" ? "gap-2" : "gap-2.5";
      const emitChange = useCallback((next) => {
        onChange?.(next);
        if (changeEvent) {
          eventBus.emit(`UI:${changeEvent}`, { selected: next });
        }
      }, [onChange, changeEvent, eventBus]);
      const toggle = (optionId, checked) => {
        if (constraint.type === "single") {
          emitChange(checked ? [optionId] : []);
          return;
        }
        if (checked) {
          if (selected.includes(optionId)) return;
          emitChange([...selected, optionId]);
        } else {
          emitChange(selected.filter((id) => id !== optionId));
        }
      };
      return /* @__PURE__ */ jsxs(
        Box,
        {
          as: "fieldset",
          className: cn("space-y-2", className),
          "aria-describedby": `${groupId}-hint`,
          children: [
            /* @__PURE__ */ jsxs(Box, { className: "flex items-baseline justify-between gap-2", children: [
              /* @__PURE__ */ jsx(Typography, { as: "legend", variant: "label", weight: "semibold", children: title }),
              /* @__PURE__ */ jsx(
                Typography,
                {
                  id: `${groupId}-hint`,
                  variant: "caption",
                  color: constraint.type === "single" && constraint.required ? "error" : "muted",
                  children: hint
                }
              )
            ] }),
            description && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: description }),
            /* @__PURE__ */ jsx(Box, { className: cn("flex flex-col", optionGap), children: options.map((option) => {
              const isChecked = selected.includes(option.id);
              const isDisabled = option.disabled || option.outOfStock;
              const optionId = `${inputName}-${option.id}`;
              return /* @__PURE__ */ jsxs(
                Label,
                {
                  htmlFor: optionId,
                  className: cn(
                    "flex items-center gap-2.5 cursor-pointer select-none font-normal",
                    isDisabled && "cursor-not-allowed opacity-60"
                  ),
                  children: [
                    constraint.type === "single" ? /* @__PURE__ */ jsx(
                      Radio,
                      {
                        id: optionId,
                        name: inputName,
                        value: option.id,
                        checked: isChecked,
                        disabled: isDisabled,
                        onChange: (e) => toggle(option.id, e.target.checked),
                        className: "h-4 w-4 accent-primary",
                        "aria-invalid": !!error
                      }
                    ) : /* @__PURE__ */ jsx(
                      Checkbox,
                      {
                        id: optionId,
                        name: inputName,
                        value: option.id,
                        checked: isChecked,
                        disabled: isDisabled,
                        onChange: (e) => toggle(option.id, e.target.checked),
                        className: "h-4 w-4 accent-primary",
                        "aria-invalid": !!error
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        as: "span",
                        className: cn(
                          "flex-1",
                          labelTextSize,
                          "text-foreground",
                          option.outOfStock && "line-through"
                        ),
                        children: option.label
                      }
                    ),
                    option.priceDelta !== void 0 && option.priceDelta !== 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatPriceDelta(option.priceDelta) }),
                    option.outOfStock && /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "caption",
                        color: "warning",
                        className: "rounded border border-warning/40 px-1.5 py-0.5",
                        children: t("optionConstraint.outOfStock")
                      }
                    )
                  ]
                },
                option.id
              );
            }) }),
            error && /* @__PURE__ */ jsx(Box, { role: "alert", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", children: error }) })
          ]
        }
      );
    };
    OptionConstraintGroup.displayName = "OptionConstraintGroup";
  }
});
function getShapeClasses(shape) {
  switch (shape) {
    case "round":
      return "rounded-full w-24 h-24";
    case "square":
      return "rounded-md w-24 h-24";
    case "rectangle":
      return "rounded-md w-36 h-20";
  }
}
function getStatusIcon(status) {
  switch (status) {
    case "seated":
      return /* @__PURE__ */ jsx(Icon, { name: "users", className: "w-4 h-4" });
    case "ordered":
      return /* @__PURE__ */ jsx(Icon, { name: "coffee", className: "w-4 h-4" });
    case "awaiting-bill":
      return /* @__PURE__ */ jsx(Icon, { name: "alert-circle", className: "w-4 h-4" });
    default:
      return null;
  }
}
var STATUS_CLASSES, STATUS_BADGE, PositionedCanvas;
var init_PositionedCanvas = __esm({
  "components/core/molecules/PositionedCanvas.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_atoms();
    init_Icon();
    STATUS_CLASSES = {
      empty: "bg-surface border-border text-foreground",
      seated: "bg-surface border-success text-success",
      ordered: "bg-surface border-warning text-warning",
      "awaiting-bill": "bg-surface border-info text-info",
      cleaning: "bg-muted border-border text-muted-foreground"
    };
    STATUS_BADGE = {
      empty: { variant: "default", label: "Empty" },
      seated: { variant: "success", label: "Seated" },
      ordered: { variant: "warning", label: "Ordered" },
      "awaiting-bill": { variant: "info", label: "Awaiting bill" },
      cleaning: { variant: "neutral", label: "Cleaning" }
    };
    PositionedCanvas = ({
      items: itemsProp,
      width = 800,
      height = 600,
      selectedId = null,
      editable = false,
      onSelect,
      onMove,
      selectEvent,
      moveEvent,
      className
    }) => {
      const containerRef = useRef(null);
      const dragRef = useRef(null);
      const [draggingId, setDraggingId] = useState(null);
      const eventBus = useEventBus();
      const items = Array.isArray(itemsProp) ? itemsProp : [];
      const handlePointerDown = useCallback(
        (e, item) => {
          if (!editable) return;
          const target = e.currentTarget;
          const rect = target.getBoundingClientRect();
          dragRef.current = {
            id: item.id,
            pointerId: e.pointerId,
            offsetX: e.clientX - rect.left,
            offsetY: e.clientY - rect.top,
            moved: false
          };
          target.setPointerCapture(e.pointerId);
          setDraggingId(item.id);
        },
        [editable]
      );
      const handlePointerMove = useCallback(
        (e) => {
          const drag = dragRef.current;
          const container = containerRef.current;
          if (!drag || !container || drag.pointerId !== e.pointerId) return;
          const containerRect = container.getBoundingClientRect();
          const target = e.currentTarget;
          const itemWidth = target.offsetWidth;
          const itemHeight = target.offsetHeight;
          const newX = e.clientX - containerRect.left - drag.offsetX;
          const newY = e.clientY - containerRect.top - drag.offsetY;
          const clampedX = Math.max(0, Math.min(width - itemWidth, newX));
          const clampedY = Math.max(0, Math.min(height - itemHeight, newY));
          drag.moved = true;
          onMove?.(drag.id, clampedX, clampedY);
          if (moveEvent) {
            eventBus.emit(`UI:${moveEvent}`, { id: drag.id, x: clampedX, y: clampedY });
          }
        },
        [width, height, onMove, moveEvent, eventBus]
      );
      const handlePointerUp = useCallback(
        (e, item) => {
          const drag = dragRef.current;
          if (!drag || drag.pointerId !== e.pointerId) return;
          const target = e.currentTarget;
          if (target.hasPointerCapture(e.pointerId)) {
            target.releasePointerCapture(e.pointerId);
          }
          const wasDrag = drag.moved;
          dragRef.current = null;
          setDraggingId(null);
          if (!wasDrag) {
            const itemId = item.id;
            const next = selectedId === itemId ? null : itemId;
            onSelect?.(next);
            if (selectEvent) {
              eventBus.emit(`UI:${selectEvent}`, { id: next });
            }
          }
        },
        [selectedId, onSelect, selectEvent, eventBus]
      );
      const handleContainerClick = useCallback(
        (e) => {
          if (e.target === e.currentTarget) {
            onSelect?.(null);
            if (selectEvent) {
              eventBus.emit(`UI:${selectEvent}`, { id: null });
            }
          }
        },
        [onSelect, selectEvent, eventBus]
      );
      return (
        // Outer scroll viewport: caps the visual footprint to the parent's
        // available width on small screens. The inner plane keeps its fixed
        // {width × height} coordinate system (items are positioned by
        // absolute item.x/item.y), so a phone-sized viewport pans inside
        // the larger logical canvas rather than busting the layout.
        /* @__PURE__ */ jsx(Box, { className: cn("max-w-full overflow-auto rounded-md", className), children: /* @__PURE__ */ jsx(
          Box,
          {
            ref: containerRef,
            "data-testid": "positioned-canvas",
            className: "relative bg-background border border-border rounded-container overflow-hidden touch-none",
            style: { width, height },
            onClick: handleContainerClick,
            children: items.map((item) => {
              const itemId = item.id;
              const label = item.label;
              const x = item.x;
              const y = item.y;
              const capacity = item.capacity;
              const partySize = item.partySize;
              const serverName = item.serverName;
              const status = item.status ?? "empty";
              const shape = item.shape ?? "round";
              const isSelected = selectedId === itemId;
              const isDragging = draggingId === itemId;
              const statusBadge = STATUS_BADGE[status];
              return /* @__PURE__ */ jsxs(
                Box,
                {
                  "data-testid": `item-node-${itemId}`,
                  "data-status": status,
                  className: cn(
                    "absolute flex flex-col items-center justify-center gap-1 border-2 select-none",
                    "transition-shadow",
                    STATUS_CLASSES[status],
                    getShapeClasses(shape),
                    editable ? "cursor-move" : "cursor-pointer",
                    isSelected && "outline outline-2 outline-offset-2 outline-primary shadow-md",
                    isDragging && "shadow-lg z-10"
                  ),
                  style: { left: x, top: y, touchAction: "none" },
                  onPointerDown: (e) => handlePointerDown(e, item),
                  onPointerMove: handlePointerMove,
                  onPointerUp: (e) => handlePointerUp(e, item),
                  onPointerCancel: (e) => handlePointerUp(e, item),
                  children: [
                    /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1", children: [
                      getStatusIcon(status),
                      /* @__PURE__ */ jsx(Typography, { variant: "body2", weight: "semibold", children: label })
                    ] }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: partySize !== void 0 && status === "seated" ? `${partySize}/${capacity}` : `Cap ${capacity}` }),
                    status === "seated" && serverName && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "truncate max-w-[80%]", children: serverName }),
                    isSelected && /* @__PURE__ */ jsx(
                      Badge,
                      {
                        variant: statusBadge.variant,
                        size: "sm",
                        className: "absolute -top-2 -right-2",
                        children: statusBadge.label
                      }
                    )
                  ]
                },
                itemId
              );
            })
          }
        ) })
      );
    };
    PositionedCanvas.displayName = "PositionedCanvas";
  }
});
function safeUrl(raw, kinds) {
  const url = raw.trim();
  if (url.startsWith("#") || url.startsWith("/")) return url;
  const lower = url.toLowerCase();
  for (const kind of kinds) {
    if (lower.startsWith(kind)) return url;
  }
  return null;
}
function sanitizeNode(el) {
  const children = Array.from(el.children);
  for (const child of children) {
    const tag = child.tagName.toLowerCase();
    if (DROP_TAGS.has(tag)) {
      child.remove();
      continue;
    }
    const allowed = ALLOWED_ATTRS[tag];
    if (!allowed) {
      sanitizeNode(child);
      child.replaceWith(...Array.from(child.childNodes));
      continue;
    }
    for (const attr of Array.from(child.attributes)) {
      const name = attr.name.toLowerCase();
      if (!allowed.includes(name)) {
        child.removeAttribute(attr.name);
        continue;
      }
      if (name === "href") {
        const url = safeUrl(attr.value, ["http://", "https://", "mailto:"]);
        if (url === null) child.removeAttribute(attr.name);
        else child.setAttribute("href", url);
      }
      if (name === "src") {
        const url = safeUrl(attr.value, ["http://", "https://", "data:image/"]);
        if (url === null) child.remove();
        else child.setAttribute("src", url);
      }
    }
    sanitizeNode(child);
  }
}
function sanitizeRichHtml(html) {
  if (!html || typeof html !== "string") return "";
  if (typeof window === "undefined" || typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  sanitizeNode(doc.body);
  if (!doc.body.querySelector("img, hr") && (doc.body.textContent ?? "").trim().length === 0) {
    return "";
  }
  return doc.body.innerHTML.replace(/​/g, "");
}
function htmlIsEmpty(el) {
  if (el.querySelector("img, hr")) return false;
  return (el.textContent ?? "").trim().length === 0;
}
function closestBlock(node, root) {
  let cur = node;
  while (cur && cur !== root) {
    if (cur instanceof Element && BLOCK_TAGS.has(cur.tagName)) return cur;
    cur = cur.parentNode;
  }
  return null;
}
function RichTextStyles() {
  return /* @__PURE__ */ jsx("style", { children: RICH_TEXT_CSS });
}
function readToolbarState(root) {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return IDLE_TOOLBAR;
  const anchor = sel.anchorNode;
  if (!anchor || !root.contains(anchor)) return IDLE_TOOLBAR;
  let block = null;
  let link = false;
  let node = anchor;
  while (node && node !== root) {
    if (node instanceof Element) {
      const tag = node.tagName.toLowerCase();
      if (!block && (tag === "h1" || tag === "h2" || tag === "h3" || tag === "blockquote" || tag === "pre")) {
        block = tag;
      }
      if (tag === "a") link = true;
    }
    node = node.parentNode;
  }
  return {
    bold: document.queryCommandState("bold"),
    italic: document.queryCommandState("italic"),
    underline: document.queryCommandState("underline"),
    strikeThrough: document.queryCommandState("strikeThrough"),
    block,
    bullets: document.queryCommandState("insertUnorderedList"),
    numbers: document.queryCommandState("insertOrderedList"),
    link
  };
}
function ToolbarButton({ icon: IconCmp, label, active, onExec }) {
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      variant: "ghost",
      size: "sm",
      "aria-label": label,
      "aria-pressed": active,
      title: label,
      className: cn(
        "h-8 w-8 p-0 gap-0 justify-center",
        active && "bg-muted text-foreground"
      ),
      onMouseDown: (e) => {
        e.preventDefault();
        onExec();
      },
      children: /* @__PURE__ */ jsx(IconCmp, { size: 15 })
    }
  );
}
var CHANGE_DEBOUNCE_MS, ALLOWED_ATTRS, DROP_TAGS, MD_BLOCK_PREFIXES, BLOCK_TAGS, MD_INLINE_RULES, RICH_TEXT_CSS, IDLE_TOOLBAR, RichTextEditor;
var init_RichTextEditor = __esm({
  "components/core/molecules/RichTextEditor.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Button();
    init_useEventBus();
    CHANGE_DEBOUNCE_MS = 400;
    ALLOWED_ATTRS = {
      p: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      ul: [],
      ol: [],
      li: [],
      blockquote: [],
      pre: [],
      code: [],
      b: [],
      strong: [],
      i: [],
      em: [],
      u: [],
      s: [],
      strike: [],
      br: [],
      hr: [],
      div: [],
      span: [],
      a: ["href"],
      img: ["src", "alt"]
    };
    DROP_TAGS = /* @__PURE__ */ new Set(["script", "style", "iframe", "object", "embed", "link", "meta", "form", "input", "button", "textarea", "select"]);
    MD_BLOCK_PREFIXES = {
      "#": { kind: "block", tag: "h1" },
      "##": { kind: "block", tag: "h2" },
      "###": { kind: "block", tag: "h3" },
      ">": { kind: "block", tag: "blockquote" },
      "```": { kind: "block", tag: "pre" },
      "-": { kind: "list", command: "insertUnorderedList" },
      "*": { kind: "list", command: "insertUnorderedList" },
      "1.": { kind: "list", command: "insertOrderedList" }
    };
    BLOCK_TAGS = /* @__PURE__ */ new Set(["P", "DIV", "LI", "H1", "H2", "H3", "H4", "BLOCKQUOTE", "PRE"]);
    MD_INLINE_RULES = [
      { pattern: /\*\*([^*\n]+)\*\*$/, wrap: "strong" },
      { pattern: /(^|[^*])\*([^*\n]+)\*$/, wrap: "em" },
      { pattern: /`([^`\n]+)`$/, wrap: "code" }
    ];
    RICH_TEXT_CSS = `
.almadar-rich-text { line-height: 1.7; color: var(--color-foreground); }
.almadar-rich-text h1 { font-size: 1.875rem; font-weight: 700; line-height: 1.25; margin: 1.25em 0 0.4em; }
.almadar-rich-text h2 { font-size: 1.5rem; font-weight: 650; line-height: 1.3; margin: 1.1em 0 0.4em; }
.almadar-rich-text h3 { font-size: 1.25rem; font-weight: 600; line-height: 1.35; margin: 1em 0 0.35em; }
.almadar-rich-text h1:first-child, .almadar-rich-text h2:first-child, .almadar-rich-text h3:first-child { margin-top: 0; }
.almadar-rich-text p { margin: 0.5em 0; }
.almadar-rich-text ul { list-style: disc; padding-inline-start: 1.5rem; margin: 0.5em 0; }
.almadar-rich-text ol { list-style: decimal; padding-inline-start: 1.5rem; margin: 0.5em 0; }
.almadar-rich-text li { margin: 0.25em 0; }
.almadar-rich-text blockquote { border-inline-start: 3px solid var(--color-primary); padding-inline-start: 1rem; font-style: italic; color: var(--color-muted-foreground); margin: 0.75em 0; }
.almadar-rich-text pre { background: var(--color-muted); border: 1px solid var(--color-border); border-radius: 0.375rem; padding: 0.75rem 1rem; font-family: ui-monospace, monospace; font-size: 0.875em; white-space: pre-wrap; margin: 0.75em 0; }
.almadar-rich-text code { font-family: ui-monospace, monospace; font-size: 0.875em; background: var(--color-muted); border-radius: 0.25rem; padding: 0.1em 0.35em; }
.almadar-rich-text pre code { background: transparent; padding: 0; }
.almadar-rich-text a { color: var(--color-primary); text-decoration: underline; }
.almadar-rich-text hr { border: none; border-top: 1px solid var(--color-border); margin: 1.25em 0; }
.almadar-rich-text img { max-width: 100%; border-radius: 0.375rem; }
`;
    IDLE_TOOLBAR = {
      bold: false,
      italic: false,
      underline: false,
      strikeThrough: false,
      block: null,
      bullets: false,
      numbers: false,
      link: false
    };
    RichTextEditor = ({
      value,
      onChange,
      changeEvent,
      readOnly = false,
      placeholder,
      showToolbar = true,
      className
    }) => {
      const { t } = useTranslate();
      const ref = useRef(null);
      const [toolbar, setToolbar] = useState(IDLE_TOOLBAR);
      const [empty, setEmpty] = useState(() => !value || !sanitizeRichHtml(value).trim());
      const eventBus = useEventBus();
      const onChangeRef = useRef(onChange);
      const changeEventRef = useRef(changeEvent);
      useEffect(() => {
        onChangeRef.current = onChange;
        changeEventRef.current = changeEvent;
      }, [onChange, changeEvent]);
      const emitTimerRef = useRef(null);
      const emitNow = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        const html = sanitizeRichHtml(el.innerHTML);
        onChangeRef.current?.(html);
        const evt = changeEventRef.current;
        if (evt) eventBus.emit(`UI:${evt}`, { value: html });
      }, [eventBus]);
      const scheduleEmit = useCallback(() => {
        if (emitTimerRef.current) clearTimeout(emitTimerRef.current);
        emitTimerRef.current = setTimeout(() => {
          emitTimerRef.current = null;
          emitNow();
        }, CHANGE_DEBOUNCE_MS);
      }, [emitNow]);
      const flushEmit = useCallback(() => {
        if (!emitTimerRef.current) return;
        clearTimeout(emitTimerRef.current);
        emitTimerRef.current = null;
        emitNow();
      }, [emitNow]);
      useEffect(() => () => {
        if (emitTimerRef.current) {
          clearTimeout(emitTimerRef.current);
          emitTimerRef.current = null;
          emitNow();
        }
      }, [emitNow]);
      useEffect(() => {
        if (readOnly) return;
        const el = ref.current;
        if (!el) return;
        if (document.activeElement === el) return;
        const next = sanitizeRichHtml(value ?? "") || "<p><br></p>";
        if (el.innerHTML !== next) {
          el.innerHTML = next;
          setEmpty(htmlIsEmpty(el));
        }
      }, [readOnly, value]);
      useEffect(() => {
        if (readOnly) return;
        document.execCommand("defaultParagraphSeparator", false, "p");
      }, [readOnly]);
      useEffect(() => {
        if (readOnly || !showToolbar) return;
        const onSelectionChange = () => {
          const el = ref.current;
          if (!el) return;
          setToolbar(readToolbarState(el));
        };
        document.addEventListener("selectionchange", onSelectionChange);
        return () => document.removeEventListener("selectionchange", onSelectionChange);
      }, [readOnly, showToolbar]);
      const tryInlineMarkdown = useCallback(() => {
        const root = ref.current;
        if (!root) return false;
        const sel = window.getSelection();
        if (!sel || !sel.isCollapsed || sel.rangeCount === 0) return false;
        const node = sel.anchorNode;
        if (!node || node.nodeType !== Node.TEXT_NODE || !root.contains(node)) return false;
        if (node.parentElement?.closest("code, pre")) return false;
        const text = (node.textContent ?? "").slice(0, sel.anchorOffset);
        for (const rule of MD_INLINE_RULES) {
          const m = rule.pattern.exec(text);
          if (!m) continue;
          const inner = rule.wrap === "em" ? m[2] : m[1];
          if (!inner || !inner.trim()) continue;
          const lead = rule.wrap === "em" ? m[1]?.length ?? 0 : 0;
          const range = document.createRange();
          range.setStart(node, m.index + lead);
          range.setEnd(node, sel.anchorOffset);
          const el = document.createElement(rule.wrap);
          el.textContent = inner;
          range.deleteContents();
          range.insertNode(el);
          const after = document.createTextNode("\u200B");
          el.parentNode?.insertBefore(after, el.nextSibling);
          const caret = document.createRange();
          caret.setStart(after, 1);
          caret.collapse(true);
          sel.removeAllRanges();
          sel.addRange(caret);
          return true;
        }
        return false;
      }, []);
      const tryBlockMarkdown = useCallback(() => {
        const root = ref.current;
        if (!root) return false;
        const sel = window.getSelection();
        if (!sel || !sel.isCollapsed || sel.rangeCount === 0) return false;
        const node = sel.anchorNode;
        if (!node || node.nodeType !== Node.TEXT_NODE || !root.contains(node)) return false;
        const block = closestBlock(node, root);
        if (block ? block.firstChild !== node : root.firstChild !== node) return false;
        const prefix = (node.textContent ?? "").slice(0, sel.anchorOffset);
        const rule = MD_BLOCK_PREFIXES[prefix];
        if (!rule) return false;
        if (node.parentElement?.closest("pre, code")) return false;
        if (rule.kind === "list" && node.parentElement?.closest("li")) return false;
        node.deleteData(0, prefix.length);
        const caret = document.createRange();
        caret.setStart(node, 0);
        caret.collapse(true);
        sel.removeAllRanges();
        sel.addRange(caret);
        if (rule.kind === "list") {
          const container = block ?? node.parentElement;
          const list = document.createElement(rule.command === "insertOrderedList" ? "ol" : "ul");
          const li = document.createElement("li");
          if (block) {
            while (block.firstChild) li.appendChild(block.firstChild);
            list.appendChild(li);
            block.replaceWith(list);
          } else if (container) {
            li.appendChild(node);
            list.appendChild(li);
            container.appendChild(list);
          }
          if (!li.firstChild) li.appendChild(document.createElement("br"));
          const liCaret = document.createRange();
          liCaret.selectNodeContents(li);
          liCaret.collapse(true);
          sel.removeAllRanges();
          sel.addRange(liCaret);
        } else {
          document.execCommand("formatBlock", false, rule.tag);
        }
        return true;
      }, []);
      const afterEdit = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        tryInlineMarkdown();
        setEmpty(htmlIsEmpty(el));
        setToolbar(readToolbarState(el));
        scheduleEmit();
      }, [scheduleEmit, tryInlineMarkdown]);
      const handleKeyDown = useCallback((e) => {
        if (e.key === " " && tryBlockMarkdown()) {
          e.preventDefault();
          afterEdit();
        }
      }, [afterEdit, tryBlockMarkdown]);
      const execInline = useCallback((command) => {
        document.execCommand(command, false);
        afterEdit();
      }, [afterEdit]);
      const execBlock = useCallback((tag) => {
        const next = toolbar.block === tag ? "p" : tag;
        document.execCommand("formatBlock", false, next);
        afterEdit();
      }, [afterEdit, toolbar.block]);
      const execList = useCallback((command) => {
        document.execCommand(command, false);
        afterEdit();
      }, [afterEdit]);
      const execLink = useCallback(() => {
        if (toolbar.link) {
          document.execCommand("unlink", false);
          afterEdit();
          return;
        }
        const url = window.prompt(t("richTextEditor.linkPrompt"));
        if (!url) return;
        const safe = safeUrl(url, ["http://", "https://", "mailto:"]) ?? `https://${url}`;
        document.execCommand("createLink", false, safe);
        afterEdit();
      }, [afterEdit, t, toolbar.link]);
      const imageInputRef = useRef(null);
      const savedRangeRef = useRef(null);
      const execImage = useCallback(() => {
        const root = ref.current;
        const sel = window.getSelection();
        savedRangeRef.current = root && sel && sel.rangeCount > 0 && root.contains(sel.anchorNode) ? sel.getRangeAt(0).cloneRange() : null;
        imageInputRef.current?.click();
      }, []);
      const handleImageFile = useCallback((e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
          const url = typeof reader.result === "string" ? reader.result : "";
          if (!url.startsWith("data:image/")) return;
          const root = ref.current;
          if (!root) return;
          root.focus();
          const sel = window.getSelection();
          if (sel && savedRangeRef.current && root.contains(savedRangeRef.current.startContainer)) {
            sel.removeAllRanges();
            sel.addRange(savedRangeRef.current);
          }
          document.execCommand("insertImage", false, url);
          afterEdit();
        };
        reader.readAsDataURL(file);
      }, [afterEdit]);
      const execRule = useCallback(() => {
        document.execCommand("insertHorizontalRule", false);
        afterEdit();
      }, [afterEdit]);
      if (readOnly) {
        return /* @__PURE__ */ jsxs(Box, { className: cn("almadar-rich-text max-w-none", className), children: [
          /* @__PURE__ */ jsx(RichTextStyles, {}),
          /* @__PURE__ */ jsx(Box, { dangerouslySetInnerHTML: { __html: sanitizeRichHtml(value ?? "") } })
        ] });
      }
      return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col gap-2", className), children: [
        /* @__PURE__ */ jsx(RichTextStyles, {}),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: imageInputRef,
            type: "file",
            accept: "image/*",
            className: "hidden",
            "aria-hidden": "true",
            tabIndex: -1,
            onChange: handleImageFile
          }
        ),
        showToolbar && /* @__PURE__ */ jsxs(
          Box,
          {
            role: "toolbar",
            "aria-label": t("richTextEditor.editorToolbar"),
            className: cn(
              "sticky top-0 z-10 flex flex-wrap items-center gap-0.5 self-start",
              "rounded-md border border-border bg-background/95 px-1 py-0.5 shadow-sm"
            ),
            children: [
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Bold, label: t("richTextEditor.bold"), active: toolbar.bold, onExec: () => execInline("bold") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Italic, label: t("richTextEditor.italic"), active: toolbar.italic, onExec: () => execInline("italic") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Underline, label: t("richTextEditor.underline"), active: toolbar.underline, onExec: () => execInline("underline") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Strikethrough, label: t("richTextEditor.strikethrough"), active: toolbar.strikeThrough, onExec: () => execInline("strikeThrough") }),
              /* @__PURE__ */ jsx(Box, { className: "mx-1 h-5 w-px bg-border" }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Heading1, label: t("richTextEditor.heading1"), active: toolbar.block === "h1", onExec: () => execBlock("h1") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Heading2, label: t("richTextEditor.heading2"), active: toolbar.block === "h2", onExec: () => execBlock("h2") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Heading3, label: t("richTextEditor.heading3"), active: toolbar.block === "h3", onExec: () => execBlock("h3") }),
              /* @__PURE__ */ jsx(Box, { className: "mx-1 h-5 w-px bg-border" }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: List, label: t("richTextEditor.bulletList"), active: toolbar.bullets, onExec: () => execList("insertUnorderedList") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: ListOrdered, label: t("richTextEditor.numberedList"), active: toolbar.numbers, onExec: () => execList("insertOrderedList") }),
              /* @__PURE__ */ jsx(Box, { className: "mx-1 h-5 w-px bg-border" }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Quote, label: t("richTextEditor.quote"), active: toolbar.block === "blockquote", onExec: () => execBlock("blockquote") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Code, label: t("richTextEditor.code"), active: toolbar.block === "pre", onExec: () => execBlock("pre") }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Link$1, label: toolbar.link ? t("richTextEditor.removeLink") : t("richTextEditor.link"), active: toolbar.link, onExec: execLink }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Image$1, label: t("richTextEditor.image"), onExec: execImage }),
              /* @__PURE__ */ jsx(ToolbarButton, { icon: Minus, label: t("richTextEditor.divider"), onExec: execRule })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            ref,
            contentEditable: true,
            suppressContentEditableWarning: true,
            role: "textbox",
            "aria-multiline": "true",
            "aria-label": t("richTextEditor.editorSurface"),
            "data-placeholder": placeholder ?? t("richTextEditor.placeholder"),
            "data-empty": empty ? "true" : "false",
            className: cn(
              "almadar-rich-text max-w-none min-h-[8rem] outline-none",
              "data-[empty=true]:before:content-[attr(data-placeholder)]",
              "data-[empty=true]:before:text-muted-foreground/60",
              "data-[empty=true]:before:pointer-events-none",
              "data-[empty=true]:before:absolute",
              "relative cursor-text"
            ),
            onInput: afterEdit,
            onKeyDown: handleKeyDown,
            onBlur: flushEmit
          }
        )
      ] });
    };
    RichTextEditor.displayName = "RichTextEditor";
  }
});
function renderIconInput4(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function DocumentPanel({
  id,
  title,
  subtitle,
  coverImage,
  icon,
  value,
  actions,
  maxInlineActions,
  editing = false,
  titleCommitEvent,
  contentChangeEvent,
  editEvent,
  doneEvent,
  editLabel,
  doneLabel,
  autosaveHint,
  placeholder,
  className
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [titleDraft, setTitleDraft] = useState(null);
  const recordId = id ?? "";
  const actionDefs = actions ?? [];
  const inlineCap = Math.min(maxInlineActions ?? 1, 1);
  const inlineActions = actionDefs.filter((a) => a.variant === "primary").slice(0, inlineCap);
  const menuActions = actionDefs.filter((a) => !inlineActions.includes(a));
  const fireAction = (action) => {
    if (!action.event) return;
    eventBus.emit(`UI:${action.event}`, { id: recordId, title: title ?? "" });
  };
  const commitTitle = () => {
    if (!titleCommitEvent) return;
    const next = (titleDraft ?? "").trim();
    setTitleDraft(null);
    if (!next || next === title) return;
    eventBus.emit(`UI:${titleCommitEvent}`, { title: next, id: recordId });
  };
  const untitled = t("documentPanel.untitled") || "Untitled";
  const titleNode = titleCommitEvent && titleDraft !== null ? /* @__PURE__ */ jsx(
    Input,
    {
      value: titleDraft,
      autoFocus: true,
      "aria-label": t("common.title"),
      className: "h-auto py-1 text-3xl font-bold tracking-tight",
      onFocus: (e) => e.currentTarget.select(),
      onChange: (e) => setTitleDraft(e.target.value),
      onBlur: commitTitle,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          commitTitle();
        } else if (e.key === "Escape") {
          e.preventDefault();
          setTitleDraft(null);
        }
      },
      "data-testid": "document-title-input"
    }
  ) : titleCommitEvent ? /* @__PURE__ */ jsx(
    Box,
    {
      role: "button",
      tabIndex: 0,
      className: "cursor-text rounded px-1 -mx-1 transition-colors hover:bg-muted/40",
      onClick: () => setTitleDraft(title ?? ""),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setTitleDraft(title ?? "");
        }
      },
      "data-testid": "document-title-editable",
      children: /* @__PURE__ */ jsx(Typography, { variant: "h2", weight: "bold", className: cn(!title && "text-muted-foreground"), children: title || untitled })
    }
  ) : /* @__PURE__ */ jsx(Typography, { variant: "h2", weight: "bold", children: title || untitled });
  const emitWithId = (event) => () => {
    if (event) eventBus.emit(`UI:${event}`, { id: recordId });
  };
  return /* @__PURE__ */ jsxs(Card, { variant: "elevated", className: cn("w-full overflow-hidden", className), children: [
    coverImage ? /* @__PURE__ */ jsx(Box, { className: "h-44 w-full sm:h-52", "data-testid": "document-cover", children: /* @__PURE__ */ jsx(
      "img",
      {
        src: coverImage,
        alt: "",
        "aria-hidden": "true",
        className: "h-full w-full object-cover"
      }
    ) }) : null,
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-6 sm:p-8", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "justify-between items-start", children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
          icon ? /* @__PURE__ */ jsx(Box, { className: "text-muted-foreground", "data-testid": "document-icon", children: renderIconInput4(icon, { size: "lg" }) }) : null,
          titleNode,
          subtitle ? /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: subtitle }) : null
        ] }),
        /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-shrink-0 pt-1 items-center", children: editing ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "hidden sm:block", children: autosaveHint ?? (t("documentPanel.autosaveHint") || "") }),
          /* @__PURE__ */ jsx(Button, { variant: "primary", size: "sm", onClick: emitWithId(doneEvent), "data-testid": "document-done", children: doneLabel ?? (t("documentPanel.done") || "Done") })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          editEvent && /* @__PURE__ */ jsxs(Button, { variant: "ghost", size: "sm", onClick: emitWithId(editEvent), "data-testid": "document-edit", children: [
            /* @__PURE__ */ jsx(Icon, { name: "edit", size: "xs", className: "mr-1" }),
            editLabel ?? (t("documentPanel.edit") || "Edit")
          ] }),
          inlineActions.map((action, idx) => /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "primary",
              size: "sm",
              onClick: () => fireAction(action),
              "data-testid": `action-${action.event}`,
              children: [
                action.icon && renderIconInput4(action.icon, { size: "xs", className: "mr-1" }),
                action.label
              ]
            },
            idx
          )),
          menuActions.length > 0 && /* @__PURE__ */ jsx(
            Menu,
            {
              position: "bottom-end",
              trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
              items: menuActions.map((action) => ({
                label: action.label,
                icon: action.icon,
                variant: action.variant === "danger" ? "danger" : "default",
                onClick: () => fireAction(action)
              }))
            }
          )
        ] }) })
      ] }),
      editing ? /* @__PURE__ */ jsx(RichTextEditor, { value, changeEvent: contentChangeEvent, placeholder }) : /* @__PURE__ */ jsx(
        Box,
        {
          onClick: emitWithId(editEvent),
          className: cn(
            "rounded-md px-1 -mx-1 min-h-[16rem]",
            editEvent && "cursor-text transition-colors hover:bg-muted/30"
          ),
          "data-testid": "document-body",
          children: value && value !== "" ? /* @__PURE__ */ jsx(RichTextEditor, { value, readOnly: true }) : /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: placeholder ?? (t("documentPanel.placeholder") || "") })
        }
      )
    ] })
  ] });
}
var init_DocumentPanel = __esm({
  "components/core/molecules/DocumentPanel.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Box();
    init_Stack();
    init_Typography();
    init_Button();
    init_Card();
    init_Icon();
    init_Input();
    init_Menu();
    init_RichTextEditor();
  }
});
function renderIconInput5(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function fieldName(field) {
  return field.name ?? field.key ?? "";
}
function relationId(value) {
  if (value !== null && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date)) {
    const id = value.id;
    if (id !== void 0 && id !== null) return String(id);
  }
  return String(value);
}
function fieldKind(field, value) {
  if (field.kind) return field.kind;
  if (field.type === "image") return "image";
  if (field.options && field.options.length > 0) return "select";
  if (typeof value === "boolean" || field.format === "boolean") return "boolean";
  if (Array.isArray(value) || relationLabel(value ?? null) !== null) return "readonly";
  return "text";
}
function DocumentDetails({
  entity,
  fields,
  metaCommitEvent,
  relationEvent,
  title,
  className
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [fieldDraft, setFieldDraft] = useState(null);
  const recordId = entity?.id !== void 0 && entity?.id !== null ? String(entity.id) : "";
  const fieldDefs = (fields ?? []).filter((f3) => fieldName(f3) !== "");
  if (fieldDefs.length === 0) return null;
  const commitField = (name, next, current) => {
    setFieldDraft(null);
    if (!metaCommitEvent || next === current) return;
    eventBus.emit(`UI:${metaCommitEvent}`, { id: recordId, patch: { id: recordId, [name]: next } });
  };
  const relationChip = (item, name, key) => {
    const label = relationLabel(item) ?? humanizeEnumValue(String(item));
    if (!relationEvent) {
      return /* @__PURE__ */ jsx(Badge, { variant: "default", children: label }, key);
    }
    const emitClick = () => eventBus.emit(`UI:${relationEvent}`, { field: name, id: relationId(item), name: label });
    return /* @__PURE__ */ jsx(
      Badge,
      {
        variant: "default",
        role: "button",
        tabIndex: 0,
        className: "cursor-pointer transition-colors hover:bg-accent",
        onClick: emitClick,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            emitClick();
          }
        },
        "data-testid": `relation-chip-${name}`,
        children: label
      },
      key
    );
  };
  const renderValue = (field) => {
    const name = fieldName(field);
    const raw = getNestedValue(entity ?? {}, name);
    const kind = fieldKind(field, raw);
    const label = field.label ?? field.header ?? humanizeFieldName(name);
    if (kind === "image") {
      const url = typeof raw === "string" ? raw : "";
      if (!url) return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: "\u2014" });
      return /* @__PURE__ */ jsx(
        "img",
        {
          src: url,
          alt: label,
          loading: "lazy",
          className: "max-h-32 w-full rounded-md border border-border object-cover",
          "data-testid": `document-property-image-${name}`
        }
      );
    }
    if (kind === "boolean") {
      return /* @__PURE__ */ jsx(
        Switch,
        {
          checked: Boolean(raw),
          disabled: !metaCommitEvent,
          "aria-label": label,
          onChange: (checked) => commitField(name, checked, Boolean(raw))
        }
      );
    }
    if (kind === "select") {
      return /* @__PURE__ */ jsx(
        Select,
        {
          value: raw !== void 0 && raw !== null ? String(raw) : "",
          disabled: !metaCommitEvent,
          "aria-label": label,
          className: "h-8 w-full",
          options: (field.options ?? []).map((opt) => ({ value: opt, label: humanizeEnumValue(opt) })),
          onChange: (e) => commitField(name, e.target.value, raw)
        }
      );
    }
    if (kind === "readonly" || !metaCommitEvent) {
      if (Array.isArray(raw)) {
        if (raw.length === 0) {
          return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: "\u2014" });
        }
        return /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: raw.map((item, i) => relationChip(item, name, i)) });
      }
      if (raw !== void 0 && raw !== null && raw !== "" && relationLabel(raw) !== null) {
        return relationChip(raw, name);
      }
      const shown2 = raw === void 0 || raw === null || raw === "" ? "\u2014" : formatValue(raw, field.format);
      return /* @__PURE__ */ jsx(Typography, { variant: "small", className: "break-words", children: shown2 });
    }
    if (fieldDraft?.name === name) {
      return /* @__PURE__ */ jsx(
        Input,
        {
          value: fieldDraft.value,
          autoFocus: true,
          "aria-label": label,
          className: "h-8 w-full",
          onChange: (e) => setFieldDraft({ name, value: e.target.value }),
          onBlur: () => commitField(name, fieldDraft.value.trim(), raw),
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commitField(name, fieldDraft.value.trim(), raw);
            } else if (e.key === "Escape") {
              e.preventDefault();
              setFieldDraft(null);
            }
          },
          "data-testid": `document-property-input-${name}`
        }
      );
    }
    const shown = raw === void 0 || raw === null || raw === "" ? "\u2014" : relationLabel(raw) ?? formatValue(raw, field.format);
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: "button",
        tabIndex: 0,
        className: cn(
          "cursor-text rounded px-1 -mx-1 transition-colors hover:bg-muted/40",
          (raw === void 0 || raw === null || raw === "") && "text-muted-foreground"
        ),
        onClick: () => setFieldDraft({ name, value: raw !== void 0 && raw !== null ? String(raw) : "" }),
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setFieldDraft({ name, value: raw !== void 0 && raw !== null ? String(raw) : "" });
          }
        },
        "data-testid": `document-property-${name}`,
        children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "break-words", children: shown })
      }
    );
  };
  return /* @__PURE__ */ jsx(Card, { variant: "bordered", className: cn("w-full", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-4", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", weight: "medium", className: "uppercase tracking-wide", children: title ?? (t("documentDetails.title") || "Details") }),
    /* @__PURE__ */ jsx(VStack, { gap: "sm", children: fieldDefs.map((field) => {
      const name = fieldName(field);
      const label = field.label ?? field.header ?? humanizeFieldName(name);
      return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
          field.icon && renderIconInput5(field.icon, { size: "xs", className: "text-muted-foreground" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: label })
        ] }),
        /* @__PURE__ */ jsx(Box, { className: "min-w-0", children: renderValue(field) })
      ] }, name);
    }) })
  ] }) });
}
var init_DocumentDetails = __esm({
  "components/core/molecules/DocumentDetails.tsx"() {
    "use client";
    init_cn();
    init_format();
    init_getNestedValue();
    init_relationLabel();
    init_useEventBus();
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    init_Card();
    init_Icon();
    init_Input();
    init_Select();
    init_Switch();
  }
});
function collectInitiallyCollapsed(nodes, acc) {
  for (const n of nodes) {
    const replies = n.replies;
    if (n.collapsed) acc.add(n.id);
    if (replies && replies.length > 0) {
      collectInitiallyCollapsed(replies, acc);
    }
  }
}
var ReplyTreeNode, ReplyTree;
var init_ReplyTree = __esm({
  "components/core/molecules/ReplyTree.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_atoms();
    init_VoteStack();
    ReplyTreeNode = ({
      node,
      depth,
      maxDepth,
      collapsedSet,
      toggleCollapse,
      onVote,
      onReply,
      onFlag,
      onContinueThread,
      voteEvent,
      replyEvent,
      flagEvent,
      continueThreadEvent,
      showActions
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const nodeId = node.id;
      const authorName = node.authorName;
      const authorAvatarUrl = node.authorAvatarUrl;
      const content = node.content;
      const postedAt = node.postedAt;
      const voteCount = node.voteCount;
      const userVote = node.userVote;
      const replies = node.replies;
      const hasReplies = !!replies && replies.length > 0;
      const isCollapsed = collapsedSet.has(nodeId);
      const atMaxDepth = depth >= maxDepth;
      const [replyOpen, setReplyOpen] = useState(false);
      const [draft, setDraft] = useState("");
      const handleVote = useCallback(
        (next) => {
          onVote?.(nodeId, next);
          if (voteEvent) eventBus.emit(`UI:${voteEvent}`, { nodeId, vote: next });
        },
        [nodeId, onVote, voteEvent, eventBus]
      );
      const handleReply = useCallback(() => {
        onReply?.(nodeId);
        setReplyOpen((open) => !open);
      }, [nodeId, onReply]);
      const handleSubmitReply = useCallback(() => {
        const text = draft.trim();
        if (!text) return;
        if (replyEvent) eventBus.emit(`UI:${replyEvent}`, { parentNodeId: nodeId, content: text });
        setDraft("");
        setReplyOpen(false);
      }, [nodeId, draft, replyEvent, eventBus]);
      const handleCancelReply = useCallback(() => {
        setDraft("");
        setReplyOpen(false);
      }, []);
      const handleFlag = useCallback(() => {
        onFlag?.(nodeId);
        if (flagEvent) eventBus.emit(`UI:${flagEvent}`, { nodeId });
      }, [nodeId, onFlag, flagEvent, eventBus]);
      const handleContinue = useCallback(() => {
        onContinueThread?.(nodeId);
        if (continueThreadEvent) eventBus.emit(`UI:${continueThreadEvent}`, { nodeId });
      }, [nodeId, onContinueThread, continueThreadEvent, eventBus]);
      const handleToggle = useCallback(() => {
        toggleCollapse(nodeId);
      }, [nodeId, toggleCollapse]);
      return /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-stretch min-w-0", children: [
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-col items-center flex-shrink-0 w-6", children: [
          hasReplies ? /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: handleToggle,
              "aria-label": isCollapsed ? t("replyTree.expandReplies") : t("replyTree.collapseReplies"),
              "aria-expanded": !isCollapsed,
              leftIcon: isCollapsed ? "chevron-right" : "chevron-down",
              className: cn(
                "w-6 h-6 p-0 min-w-0",
                "rounded-sm text-muted-foreground",
                "hover:bg-muted hover:text-foreground"
              )
            }
          ) : /* @__PURE__ */ jsx(Box, { className: "w-6 h-6", "aria-hidden": "true" }),
          hasReplies && !isCollapsed && /* @__PURE__ */ jsx(
            Box,
            {
              className: "flex-1 w-px bg-border mt-1",
              "aria-hidden": "true"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2 flex-1 min-w-0 pb-3", children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-center min-w-0", children: [
            /* @__PURE__ */ jsx(
              Avatar,
              {
                src: authorAvatarUrl,
                name: authorName,
                size: "sm"
              }
            ),
            /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", children: authorName }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: postedAt })
          ] }),
          /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap break-words", children: content }),
          showActions && /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-center", children: [
            /* @__PURE__ */ jsx(
              VoteStack,
              {
                count: voteCount ?? 0,
                userVote: userVote ?? null,
                onVote: handleVote,
                size: "sm",
                variant: "horizontal",
                label: t("replyTree.voteOnReplyBy", { author: authorName })
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                leftIcon: "message-square",
                onClick: handleReply,
                "aria-label": t("replyTree.replyTo", { author: authorName }),
                children: t("replyTree.reply")
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                leftIcon: "flag",
                onClick: handleFlag,
                "aria-label": t("replyTree.flagReplyBy", { author: authorName }),
                children: t("replyTree.flag")
              }
            )
          ] }),
          replyOpen && /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2 mt-1", children: [
            /* @__PURE__ */ jsx(
              Input,
              {
                inputType: "textarea",
                rows: 2,
                value: draft,
                placeholder: t("replyTree.replyToPlaceholder", { author: authorName }),
                onChange: (e) => setDraft(e.target.value),
                "aria-label": t("replyTree.replyTo", { author: authorName })
              }
            ),
            /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-center", children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "primary",
                  size: "sm",
                  leftIcon: "send",
                  onClick: handleSubmitReply,
                  disabled: !draft.trim(),
                  children: t("replyTree.send")
                }
              ),
              /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleCancelReply, children: t("common.cancel") })
            ] })
          ] }),
          hasReplies && !isCollapsed && (atMaxDepth ? /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: handleContinue,
              rightIcon: "chevron-right",
              className: cn(
                "self-start gap-1 px-0 h-auto",
                "text-sm text-primary hover:underline hover:bg-transparent"
              ),
              children: t("replyTree.continueThread")
            }
          ) : /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-2 mt-1", children: replies.map((child) => /* @__PURE__ */ jsx(
            ReplyTreeNode,
            {
              node: child,
              depth: depth + 1,
              maxDepth,
              collapsedSet,
              toggleCollapse,
              onVote,
              onReply,
              onFlag,
              onContinueThread,
              voteEvent,
              replyEvent,
              flagEvent,
              continueThreadEvent,
              showActions
            },
            child.id
          )) }))
        ] })
      ] });
    };
    ReplyTree = ({
      nodes,
      maxDepth = 6,
      onVote,
      onReply,
      onFlag,
      onContinueThread,
      voteEvent,
      replyEvent,
      flagEvent,
      continueThreadEvent,
      showActions = true,
      className
    }) => {
      const { t } = useTranslate();
      const nodeList = Array.isArray(nodes) ? nodes : nodes ? [nodes] : [];
      const [collapsedSet, setCollapsedSet] = useState(() => {
        const acc = /* @__PURE__ */ new Set();
        collectInitiallyCollapsed(nodeList, acc);
        return acc;
      });
      const toggleCollapse = useCallback((id) => {
        setCollapsedSet((prev) => {
          const next = new Set(prev);
          if (next.has(id)) {
            next.delete(id);
          } else {
            next.add(id);
          }
          return next;
        });
      }, []);
      if (nodeList.length === 0) {
        return /* @__PURE__ */ jsx(Box, { className: cn("text-sm text-muted-foreground", className), children: t("replyTree.noRepliesYet") });
      }
      return /* @__PURE__ */ jsx(Box, { className: cn("flex flex-col gap-2 min-w-0", className), children: nodeList.map((node) => /* @__PURE__ */ jsx(
        ReplyTreeNode,
        {
          node,
          depth: 0,
          maxDepth,
          collapsedSet,
          toggleCollapse,
          onVote,
          onReply,
          onFlag,
          onContinueThread,
          voteEvent,
          replyEvent,
          flagEvent,
          continueThreadEvent,
          showActions
        },
        node.id
      )) });
    };
    ReplyTree.displayName = "ReplyTree";
  }
});
function computeDiff(before, after) {
  const beforeLines = before.split("\n");
  const afterLines = after.split("\n");
  const m = beforeLines.length;
  const n = afterLines.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i2 = m - 1; i2 >= 0; i2--) {
    for (let j2 = n - 1; j2 >= 0; j2--) {
      if (beforeLines[i2] === afterLines[j2]) {
        dp[i2][j2] = dp[i2 + 1][j2 + 1] + 1;
      } else {
        dp[i2][j2] = Math.max(dp[i2 + 1][j2], dp[i2][j2 + 1]);
      }
    }
  }
  const out = [];
  let i = 0;
  let j = 0;
  let bn = 1;
  let an = 1;
  while (i < m && j < n) {
    if (beforeLines[i] === afterLines[j]) {
      out.push({
        type: "unchanged",
        beforeLineNumber: bn++,
        afterLineNumber: an++,
        content: beforeLines[i]
      });
      i++;
      j++;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      out.push({ type: "removed", beforeLineNumber: bn++, content: beforeLines[i] });
      i++;
    } else {
      out.push({ type: "added", afterLineNumber: an++, content: afterLines[j] });
      j++;
    }
  }
  while (i < m) {
    out.push({ type: "removed", beforeLineNumber: bn++, content: beforeLines[i++] });
  }
  while (j < n) {
    out.push({ type: "added", afterLineNumber: an++, content: afterLines[j++] });
  }
  return out;
}
var INLINE_STYLES, VersionDiff;
var init_VersionDiff = __esm({
  "components/core/molecules/VersionDiff.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_atoms();
    init_Stack();
    INLINE_STYLES = {
      added: { bg: "bg-success/10", prefix: "+", text: "text-success" },
      removed: { bg: "bg-error/10", prefix: "-", text: "text-error" },
      unchanged: { bg: "", prefix: " ", text: "text-foreground" },
      context: { bg: "", prefix: " ", text: "text-muted-foreground" }
    };
    VersionDiff = ({
      revisions: revisionsProp,
      beforeId,
      afterId,
      view = "side-by-side",
      onSelectBefore,
      onSelectAfter,
      onRevert,
      selectBeforeEvent,
      selectAfterEvent,
      revertEvent,
      language,
      className
    }) => {
      const { t } = useTranslate();
      const eventBus = useEventBus();
      const revisions = Array.isArray(revisionsProp) ? revisionsProp : [];
      const fallbackBefore = revisions[0]?.id ?? "";
      const fallbackAfter = revisions[1]?.id ?? revisions[0]?.id ?? "";
      const [internalBefore, setInternalBefore] = useState(beforeId ?? fallbackBefore);
      const [internalAfter, setInternalAfter] = useState(afterId ?? fallbackAfter);
      const [internalView, setInternalView] = useState(view);
      const activeBeforeId = beforeId ?? internalBefore;
      const activeAfterId = afterId ?? internalAfter;
      const activeView = view ?? internalView;
      const beforeRev = useMemo(
        () => revisions.find((r) => r.id === activeBeforeId) ?? revisions[0],
        [revisions, activeBeforeId]
      );
      const afterRev = useMemo(
        () => revisions.find((r) => r.id === activeAfterId) ?? revisions[1] ?? revisions[0],
        [revisions, activeAfterId]
      );
      const diff = useMemo(
        () => computeDiff(beforeRev?.content ?? "", afterRev?.content ?? ""),
        [beforeRev, afterRev]
      );
      const stats = useMemo(() => {
        let added = 0;
        let removed = 0;
        for (const line of diff) {
          if (line.type === "added") added++;
          else if (line.type === "removed") removed++;
        }
        return { added, removed };
      }, [diff]);
      const handleBeforeChange = useCallback(
        (v) => {
          const id = v;
          setInternalBefore(id);
          onSelectBefore?.(id);
          if (selectBeforeEvent) eventBus.emit(`UI:${selectBeforeEvent}`, { id });
        },
        [onSelectBefore, selectBeforeEvent, eventBus]
      );
      const handleAfterChange = useCallback(
        (v) => {
          const id = v;
          setInternalAfter(id);
          onSelectAfter?.(id);
          if (selectAfterEvent) eventBus.emit(`UI:${selectAfterEvent}`, { id });
        },
        [onSelectAfter, selectAfterEvent, eventBus]
      );
      const handleViewToggle = useCallback(() => {
        setInternalView((v) => v === "side-by-side" ? "inline" : "side-by-side");
      }, []);
      const handleRevert = useCallback(() => {
        if (beforeRev) {
          onRevert?.(beforeRev.id);
          if (revertEvent) eventBus.emit(`UI:${revertEvent}`, { id: beforeRev.id });
        }
      }, [beforeRev, onRevert, revertEvent, eventBus]);
      const options = useMemo(
        () => revisions.map((r) => ({ value: r.id, label: r.label })),
        [revisions]
      );
      const beforeLines = useMemo(
        () => diff.filter((l) => l.type === "removed" || l.type === "unchanged" || l.type === "context"),
        [diff]
      );
      const afterLines = useMemo(
        () => diff.filter((l) => l.type === "added" || l.type === "unchanged" || l.type === "context"),
        [diff]
      );
      return /* @__PURE__ */ jsx(Card, { className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
        /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            align: "center",
            justify: "between",
            className: "px-4 py-2 border-b border-border bg-muted/30 flex-wrap",
            children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "flex-wrap", children: [
                /* @__PURE__ */ jsx(Icon, { name: "git-commit", size: "sm", className: "text-muted-foreground" }),
                /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "whitespace-nowrap", children: t("versionDiff.compare") }),
                /* @__PURE__ */ jsx(Box, { className: "min-w-0 md:min-w-[160px]", children: /* @__PURE__ */ jsx(
                  Select,
                  {
                    options,
                    value: activeBeforeId,
                    onValueChange: handleBeforeChange,
                    "aria-label": t("versionDiff.beforeRevision")
                  }
                ) }),
                /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: t("versionDiff.to") }),
                /* @__PURE__ */ jsx(Box, { className: "min-w-0 md:min-w-[160px]", children: /* @__PURE__ */ jsx(
                  Select,
                  {
                    options,
                    value: activeAfterId,
                    onValueChange: handleAfterChange,
                    "aria-label": t("versionDiff.afterRevision")
                  }
                ) }),
                language && /* @__PURE__ */ jsx(Badge, { variant: "default", children: language }),
                /* @__PURE__ */ jsxs(Badge, { variant: "success", children: [
                  "+",
                  stats.added
                ] }),
                /* @__PURE__ */ jsxs(Badge, { variant: "error", children: [
                  "-",
                  stats.removed
                ] })
              ] }),
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    icon: activeView === "side-by-side" ? "align-left" : "columns",
                    onClick: handleViewToggle,
                    "aria-label": activeView === "side-by-side" ? t("versionDiff.switchToInline") : t("versionDiff.switchToSideBySide")
                  }
                ),
                (onRevert || revertEvent) && /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    icon: "rotate-ccw",
                    onClick: handleRevert,
                    children: t("versionDiff.revert")
                  }
                )
              ] })
            ]
          }
        ),
        (beforeRev?.author || beforeRev?.timestamp || afterRev?.author || afterRev?.timestamp) && /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            align: "center",
            justify: "between",
            className: "px-4 py-1 border-b border-border bg-muted/10",
            children: [
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "truncate", children: [
                beforeRev?.label,
                beforeRev?.author ? t("versionDiff.byAuthor", { author: beforeRev.author }) : "",
                beforeRev?.timestamp ? ` (${beforeRev.timestamp})` : ""
              ] }),
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "truncate", children: [
                afterRev?.label,
                afterRev?.author ? t("versionDiff.byAuthor", { author: afterRev.author }) : "",
                afterRev?.timestamp ? ` (${afterRev.timestamp})` : ""
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: "overflow-auto bg-muted/20", style: { maxHeight: 600 }, children: activeView === "side-by-side" ? /* @__PURE__ */ jsxs(Box, { className: "grid grid-cols-1 md:grid-cols-2", children: [
          /* @__PURE__ */ jsx(Box, { className: "border-b md:border-b-0 md:border-r border-border", children: /* @__PURE__ */ jsx(VStack, { gap: "none", className: "font-mono text-xs", children: beforeLines.map((line, idx) => {
            const isRemoved = line.type === "removed";
            return /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "none",
                align: "start",
                className: cn(
                  "px-3 py-0.5",
                  isRemoved && "bg-error/10"
                ),
                children: [
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      color: "secondary",
                      className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
                      children: line.beforeLineNumber ?? ""
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      className: cn(
                        "font-mono flex-1 min-w-0 whitespace-pre",
                        isRemoved ? "text-error" : "text-foreground"
                      ),
                      children: line.content || " "
                    }
                  )
                ]
              },
              `b-${idx}`
            );
          }) }) }),
          /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(VStack, { gap: "none", className: "font-mono text-xs", children: afterLines.map((line, idx) => {
            const isAdded = line.type === "added";
            return /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "none",
                align: "start",
                className: cn(
                  "px-3 py-0.5",
                  isAdded && "bg-success/10"
                ),
                children: [
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      color: "secondary",
                      className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
                      children: line.afterLineNumber ?? ""
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      className: cn(
                        "font-mono flex-1 min-w-0 whitespace-pre",
                        isAdded ? "text-success" : "text-foreground"
                      ),
                      children: line.content || " "
                    }
                  )
                ]
              },
              `a-${idx}`
            );
          }) }) })
        ] }) : /* @__PURE__ */ jsx(VStack, { gap: "none", className: "font-mono text-xs", children: diff.map((line, idx) => {
          const style = INLINE_STYLES[line.type];
          return /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "none",
              align: "start",
              className: cn("px-4 py-0.5", style.bg),
              children: [
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    color: "secondary",
                    className: "w-8 text-right mr-2 select-none tabular-nums flex-shrink-0",
                    children: line.beforeLineNumber ?? ""
                  }
                ),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    color: "secondary",
                    className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
                    children: line.afterLineNumber ?? ""
                  }
                ),
                /* @__PURE__ */ jsxs(
                  Typography,
                  {
                    variant: "caption",
                    className: cn(
                      "font-mono flex-1 min-w-0 whitespace-pre",
                      style.text
                    ),
                    children: [
                      /* @__PURE__ */ jsx(Box, { as: "span", className: "select-none opacity-50 mr-2", children: style.prefix }),
                      line.content || " "
                    ]
                  }
                )
              ]
            },
            `i-${idx}`
          );
        }) }) })
      ] }) });
    };
    VersionDiff.displayName = "VersionDiff";
  }
});
var DocBreadcrumb;
var init_DocBreadcrumb = __esm({
  "components/core/molecules/DocBreadcrumb.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    init_Icon();
    DocBreadcrumb = ({
      items,
      className
    }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("w-full", className),
          role: "navigation",
          "aria-label": t("aria.breadcrumb"),
          children: /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", wrap: true, children: items.map((item, idx) => {
            const isLast = idx === items.length - 1;
            return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
              idx > 0 && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "chevron-right",
                  size: "xs",
                  className: "text-muted-foreground shrink-0"
                }
              ),
              isLast || !item.href ? /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: cn(
                    isLast ? "text-foreground font-medium" : "text-muted-foreground"
                  ),
                  as: "span",
                  children: item.label
                }
              ) : /* @__PURE__ */ jsx(
                Box,
                {
                  className: "no-underline cursor-pointer",
                  onClick: () => {
                    if (item.href) window.location.href = item.href;
                  },
                  role: "link",
                  tabIndex: 0,
                  children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      className: "text-muted-foreground hover:text-primary transition-colors cursor-pointer",
                      as: "span",
                      children: item.label
                    }
                  )
                }
              )
            ] }, idx);
          }) })
        }
      );
    };
    DocBreadcrumb.displayName = "DocBreadcrumb";
  }
});
function DocPagination({ prev, next, className }) {
  if (!prev && !next) return null;
  return /* @__PURE__ */ jsxs(
    HStack,
    {
      justify: "between",
      align: "stretch",
      gap: "md",
      className: cn("w-full", className),
      children: [
        prev ? /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(linkCardStyles, "group"),
            onClick: () => {
              window.location.href = prev.href;
            },
            role: "link",
            tabIndex: 0,
            children: /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
              /* @__PURE__ */ jsx(Icon, { name: "arrow-left", size: "md", className: "text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" }),
              /* @__PURE__ */ jsxs(VStack, { gap: "none", align: "start", children: [
                prev.category ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: prev.category }) : null,
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body",
                    className: "group-hover:text-primary transition-colors",
                    children: prev.label
                  }
                )
              ] })
            ] })
          }
        ) : /* @__PURE__ */ jsx(Box, { className: "flex-1" }),
        next ? /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(linkCardStyles, "group text-right"),
            onClick: () => {
              window.location.href = next.href;
            },
            role: "link",
            tabIndex: 0,
            children: /* @__PURE__ */ jsxs(HStack, { align: "center", justify: "end", gap: "sm", children: [
              /* @__PURE__ */ jsxs(VStack, { gap: "none", align: "end", children: [
                next.category ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: next.category }) : null,
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body",
                    className: "group-hover:text-primary transition-colors",
                    children: next.label
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Icon, { name: "arrow-right", size: "md", className: "text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" })
            ] })
          }
        ) : /* @__PURE__ */ jsx(Box, { className: "flex-1" })
      ]
    }
  );
}
var linkCardStyles;
var init_DocPagination = __esm({
  "components/core/molecules/DocPagination.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Stack();
    init_Icon();
    init_Typography();
    linkCardStyles = [
      "border border-border",
      "rounded-container",
      "p-4",
      "transition-all",
      "hover:border-primary",
      "hover:shadow-elevation-dialog",
      "no-underline",
      "flex-1",
      "min-w-0",
      "cursor-pointer"
    ].join(" ");
  }
});
function DocSearch({
  placeholder,
  onSearch,
  className
}) {
  const { t } = useTranslate();
  const resolvedPlaceholder = placeholder ?? t("docSearch.placeholder");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const containerRef = useRef(null);
  const debounceRef = useRef(void 0);
  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const performSearch = useCallback(
    (value) => {
      if (!onSearch || !value.trim()) {
        setResults([]);
        setIsOpen(false);
        return;
      }
      const searchResult = onSearch(value.trim());
      if (searchResult instanceof Promise) {
        void searchResult.then((items) => {
          setResults(items);
          setIsOpen(items.length > 0);
          setActiveIndex(-1);
        });
      } else {
        setResults(searchResult);
        setIsOpen(searchResult.length > 0);
        setActiveIndex(-1);
      }
    },
    [onSearch]
  );
  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      setQuery(value);
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      debounceRef.current = setTimeout(() => {
        performSearch(value);
      }, 300);
    },
    [performSearch]
  );
  const handleFocus = useCallback(() => {
    if (results.length > 0) {
      setIsOpen(true);
    }
  }, [results]);
  const navigateTo = useCallback((href) => {
    setIsOpen(false);
    setQuery("");
    setResults([]);
    window.location.href = href;
  }, []);
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
        return;
      }
      if (!isOpen || results.length === 0) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveIndex(
          (prev) => prev < results.length - 1 ? prev + 1 : 0
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveIndex(
          (prev) => prev > 0 ? prev - 1 : results.length - 1
        );
      } else if (e.key === "Enter") {
        e.preventDefault();
        const idx = activeIndex >= 0 ? activeIndex : 0;
        if (results[idx]) {
          navigateTo(results[idx].href);
        }
      }
    },
    [isOpen, results, activeIndex, navigateTo]
  );
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      position: "relative",
      className: cn("w-full", className),
      ref: containerRef,
      children: [
        /* @__PURE__ */ jsx(Box, { position: "relative", children: /* @__PURE__ */ jsx(
          Input,
          {
            inputType: "search",
            placeholder: resolvedPlaceholder,
            value: query,
            onChange: handleChange,
            onFocus: handleFocus,
            onKeyDown: handleKeyDown,
            leftIcon: "search",
            clearable: query.length > 0,
            onClear: () => {
              setQuery("");
              setResults([]);
              setIsOpen(false);
            }
          }
        ) }),
        isOpen && results.length > 0 ? /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "top-full left-0 right-0 mt-1 z-50 bg-card border border-border rounded-container shadow-elevation-popover max-h-80 overflow-y-auto",
            children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: results.map((result, index) => /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "px-4 py-3 cursor-pointer transition-colors",
                  "hover:bg-muted",
                  index === activeIndex && "bg-muted",
                  index < results.length - 1 && "border-b border-border"
                ),
                onClick: () => navigateTo(result.href),
                role: "option",
                tabIndex: -1,
                children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                  /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
                    result.category ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: result.category }) : null,
                    /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "medium", children: result.title })
                  ] }),
                  result.excerpt ? /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      color: "muted",
                      truncate: true,
                      children: result.excerpt
                    }
                  ) : null
                ] })
              },
              `${result.href}-${index}`
            )) })
          }
        ) : null
      ]
    }
  );
}
var init_DocSearch = __esm({
  "components/core/molecules/DocSearch.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Stack();
    init_Typography();
    init_Input();
  }
});
var DocSidebarCategory, DocSidebar;
var init_DocSidebar = __esm({
  "components/core/molecules/DocSidebar.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Stack();
    init_Typography();
    init_Icon();
    DocSidebarCategory = ({ item, depth }) => {
      const [expanded, setExpanded] = useState(
        () => item.items?.some(function hasActive(child) {
          if (child.active) return true;
          return child.items?.some(hasActive) ?? false;
        }) ?? false
      );
      if (item.items && item.items.length > 0) {
        return /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              align: "center",
              className: cn(
                "cursor-pointer select-none rounded-sm px-2 py-1.5",
                "hover:bg-muted",
                depth > 0 && "pl-4"
              ),
              onClick: () => setExpanded((prev) => !prev),
              role: "button",
              tabIndex: 0,
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setExpanded((prev) => !prev);
                }
              },
              children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: expanded ? "chevron-down" : "chevron-right",
                    size: "xs",
                    className: "text-muted-foreground shrink-0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    className: "text-xs uppercase tracking-wider text-muted-foreground font-semibold",
                    as: "span",
                    children: item.label
                  }
                )
              ]
            }
          ),
          expanded && /* @__PURE__ */ jsx(VStack, { gap: "none", className: "pl-4", children: item.items.map((child, idx) => /* @__PURE__ */ jsx(DocSidebarCategory, { item: child, depth: depth + 1 }, idx)) })
        ] });
      }
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "block rounded-sm px-3 py-1.5 text-sm transition-colors no-underline cursor-pointer",
            "hover:bg-muted",
            depth > 0 && "ml-2",
            item.active ? "bg-primary/8 text-primary font-semibold" : "text-muted-foreground"
          ),
          onClick: () => {
            if (item.href) window.location.href = item.href;
          },
          role: "link",
          tabIndex: 0,
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body2",
              className: cn(
                item.active ? "text-primary font-semibold" : "text-muted-foreground"
              ),
              as: "span",
              children: item.label
            }
          )
        }
      );
    };
    DocSidebar = ({
      items,
      className
    }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("w-full", className),
          role: "navigation",
          "aria-label": t("aria.docsSidebar"),
          children: /* @__PURE__ */ jsx(VStack, { gap: "xs", children: items.map((item, idx) => /* @__PURE__ */ jsx(DocSidebarCategory, { item, depth: 0 }, idx)) })
        }
      );
    };
    DocSidebar.displayName = "DocSidebar";
  }
});
var DocTOC;
var init_DocTOC = __esm({
  "components/core/molecules/DocTOC.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    DocTOC = ({
      items,
      activeId,
      className
    }) => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("w-full", className),
          role: "navigation",
          "aria-label": t("aria.tableOfContents"),
          children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: items.map((item) => {
            const isActive = item.id === activeId;
            const indent = item.level >= 3 ? "pl-4" : "pl-0";
            return /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "block py-1.5 no-underline transition-colors border-l-2 cursor-pointer",
                  "pl-3",
                  indent,
                  isActive ? "border-l-primary" : "border-l-transparent hover:border-l-[var(--color-muted)]"
                ),
                onClick: () => {
                  const el = document.getElementById(item.id);
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                },
                role: "link",
                tabIndex: 0,
                children: /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    className: cn(
                      "transition-colors",
                      isActive ? "text-primary font-medium" : "text-muted-foreground hover:text-foreground"
                    ),
                    as: "span",
                    children: item.label
                  }
                )
              },
              item.id
            );
          }) })
        }
      );
    };
    DocTOC.displayName = "DocTOC";
  }
});
var colorTokenVars2, GradientDivider;
var init_GradientDivider = __esm({
  "components/core/molecules/GradientDivider.tsx"() {
    "use client";
    init_cn();
    init_Box();
    colorTokenVars2 = {
      primary: "var(--color-primary)",
      secondary: "var(--color-secondary)",
      success: "var(--color-success)",
      warning: "var(--color-warning)",
      error: "var(--color-error)",
      muted: "var(--color-muted)"
    };
    GradientDivider = ({
      color,
      className
    }) => {
      const centerColor = color ? color in colorTokenVars2 ? colorTokenVars2[color] : color : "var(--color-primary)";
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn("w-full h-px", className),
          style: {
            background: `linear-gradient(to right, transparent, ${centerColor}, transparent)`
          }
        }
      );
    };
    GradientDivider.displayName = "GradientDivider";
  }
});
var MarketingFooter;
var init_MarketingFooter = __esm({
  "components/marketing/molecules/MarketingFooter.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    MarketingFooter = ({
      columns,
      copyright,
      logo,
      className
    }) => {
      const safeColumns = Array.isArray(columns) ? columns : [];
      return /* @__PURE__ */ jsx(
        Box,
        {
          as: "footer",
          className: cn(
            "bg-surface",
            "border-t border-border",
            "pt-12 pb-8 px-4",
            className
          ),
          children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "lg", align: "start", className: "flex-wrap w-full justify-between", children: [
              logo && /* @__PURE__ */ jsx(VStack, { gap: "sm", className: "min-w-[140px] mb-4", children: logo.href ? /* @__PURE__ */ jsx("a", { href: logo.href, children: /* @__PURE__ */ jsx("img", { src: logo.src, alt: logo.alt, className: "h-8 w-auto" }) }) : /* @__PURE__ */ jsx("img", { src: logo.src, alt: logo.alt, className: "h-8 w-auto" }) }),
              safeColumns.map((col) => /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "min-w-[140px] mb-4", children: [
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body2",
                    className: "font-semibold text-foreground mb-1",
                    children: col.title
                  }
                ),
                (Array.isArray(col.items) ? col.items : []).map((item) => /* @__PURE__ */ jsx(
                  "a",
                  {
                    href: item.href,
                    className: cn(
                      "text-sm no-underline",
                      "text-foreground/60",
                      "hover:text-accent",
                      "transition-colors duration-150"
                    ),
                    target: item.href.startsWith("http") ? "_blank" : void 0,
                    rel: item.href.startsWith("http") ? "noopener noreferrer" : void 0,
                    children: item.label
                  },
                  item.label
                ))
              ] }, col.title))
            ] }),
            copyright && /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                className: "text-foreground/30 text-center w-full pt-6",
                children: copyright
              }
            )
          ] })
        }
      );
    };
    MarketingFooter.displayName = "MarketingFooter";
  }
});
var PullQuote;
var init_PullQuote = __esm({
  "components/marketing/molecules/PullQuote.tsx"() {
    "use client";
    init_cn();
    init_Box();
    init_Typography();
    PullQuote = ({
      children,
      className
    }) => {
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            "border-l-4 border-l-primary",
            "pl-6 py-2 my-6",
            className
          ),
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "large",
              className: "italic text-foreground opacity-90",
              children
            }
          )
        }
      );
    };
    PullQuote.displayName = "PullQuote";
  }
});
function persistenceStroke(kind) {
  switch (kind) {
    case "persistent":
      return { strokeWidth: 2.5 };
    case "runtime":
      return { strokeDasharray: "6 3", strokeWidth: 2 };
    case "singleton":
      return { strokeWidth: 3.5 };
    case "instance":
      return { strokeDasharray: "2 3", strokeWidth: 2 };
  }
}
var AvlEntity;
var init_AvlEntity = __esm({
  "components/avl/atoms/AvlEntity.tsx"() {
    "use client";
    AvlEntity = ({
      x = 0,
      y = 0,
      r = 18,
      fieldCount = 0,
      persistence = "persistent",
      label,
      color = "var(--color-primary)",
      opacity = 1,
      className
    }) => {
      const strokeProps = persistenceStroke(persistence);
      const facets = Array.from({ length: fieldCount }, (_, i) => {
        const angle = Math.PI * 2 * i / fieldCount - Math.PI / 2;
        const innerR = r + 2;
        const outerR = r + 10;
        return {
          x1: x + innerR * Math.cos(angle),
          y1: y + innerR * Math.sin(angle),
          x2: x + outerR * Math.cos(angle),
          y2: y + outerR * Math.sin(angle)
        };
      });
      return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r, fill: color, opacity: 0.15 }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: x,
            cy: y,
            r,
            fill: "none",
            stroke: color,
            strokeWidth: strokeProps.strokeWidth,
            strokeDasharray: strokeProps.strokeDasharray
          }
        ),
        persistence === "singleton" && /* @__PURE__ */ jsx(
          "circle",
          {
            cx: x,
            cy: y,
            r: r - 4,
            fill: "none",
            stroke: color,
            strokeWidth: 1.5
          }
        ),
        facets.map((f3, i) => /* @__PURE__ */ jsx(
          "line",
          {
            x1: f3.x1,
            y1: f3.y1,
            x2: f3.x2,
            y2: f3.y2,
            stroke: color,
            strokeWidth: 1,
            opacity: 0.6
          },
          i
        )),
        label && /* @__PURE__ */ jsx(
          "text",
          {
            x,
            y: y + r + (fieldCount > 0 ? 18 : 14),
            textAnchor: "middle",
            fill: color,
            fontSize: 10,
            fontFamily: "inherit",
            fontWeight: "bold",
            children: label
          }
        )
      ] });
    };
    AvlEntity.displayName = "AvlEntity";
  }
});
function typeShape(kind, x, y, s, color) {
  switch (kind) {
    case "string":
      return /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: color });
    case "number":
      return /* @__PURE__ */ jsx(
        "polygon",
        {
          points: `${x},${y - s} ${x + s},${y + s * 0.7} ${x - s},${y + s * 0.7}`,
          fill: color
        }
      );
    case "boolean":
      return /* @__PURE__ */ jsx("rect", { x: x - s * 0.8, y: y - s * 0.8, width: s * 1.6, height: s * 1.6, fill: color });
    case "date":
      return /* @__PURE__ */ jsx(
        "polygon",
        {
          points: `${x},${y - s} ${x + s},${y} ${x},${y + s} ${x - s},${y}`,
          fill: color
        }
      );
    case "enum":
      return /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 });
    case "object":
      return /* @__PURE__ */ jsx(
        "polygon",
        {
          points: Array.from({ length: 6 }, (_, i) => {
            const a = Math.PI * 2 * i / 6 - Math.PI / 6;
            return `${x + s * Math.cos(a)},${y + s * Math.sin(a)}`;
          }).join(" "),
          fill: color,
          opacity: 0.8
        }
      );
    case "array":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.6, x2: x + s, y2: y - s * 0.6, stroke: color, strokeWidth: 2 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y, x2: x + s, y2: y, stroke: color, strokeWidth: 2 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y + s * 0.6, x2: x + s, y2: y + s * 0.6, stroke: color, strokeWidth: 2 })
      ] });
  }
}
var AvlFieldType;
var init_AvlFieldType = __esm({
  "components/avl/atoms/AvlFieldType.tsx"() {
    "use client";
    AvlFieldType = ({
      x = 0,
      y = 0,
      kind,
      size = 5,
      label,
      color = "var(--color-primary)",
      opacity = 1,
      className
    }) => {
      return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        typeShape(kind, x, y, size, color),
        label && /* @__PURE__ */ jsx(
          "text",
          {
            x,
            y: y + size + 10,
            textAnchor: "middle",
            fill: color,
            fontSize: 8,
            fontFamily: "inherit",
            opacity: 0.7,
            children: label
          }
        )
      ] });
    };
    AvlFieldType.displayName = "AvlFieldType";
  }
});
var AvlPage;
var init_AvlPage = __esm({
  "components/avl/atoms/AvlPage.tsx"() {
    "use client";
    AvlPage = ({
      x = 0,
      y = 0,
      size = 12,
      label,
      color = "var(--color-primary)",
      opacity = 1,
      className
    }) => {
      const half = size / 2;
      return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: x - half,
            y: y - half,
            width: size,
            height: size,
            fill: color,
            opacity: 0.3,
            stroke: color,
            strokeWidth: 1.5
          }
        ),
        label && /* @__PURE__ */ jsx(
          "text",
          {
            x,
            y: y + half + 12,
            textAnchor: "middle",
            fill: color,
            fontSize: 8,
            fontFamily: "inherit",
            children: label
          }
        )
      ] });
    };
    AvlPage.displayName = "AvlPage";
  }
});
var NODE_W, NODE_H, GAP2, ARROW_W, MiniStateMachine;
var init_MiniStateMachine = __esm({
  "components/avl/molecules/MiniStateMachine.tsx"() {
    "use client";
    init_AvlState();
    init_AvlEffect();
    init_avl_atom_types();
    NODE_W = 24;
    NODE_H = 16;
    GAP2 = 8;
    ARROW_W = 16;
    MiniStateMachine = ({ data, className }) => {
      const states = data.states;
      if (states.length === 0) return null;
      const transitionCounts = {};
      for (const s of states) transitionCounts[s.name] = 0;
      for (const t of data.transitions) {
        transitionCounts[t.from] = (transitionCounts[t.from] ?? 0) + 1;
        transitionCounts[t.to] = (transitionCounts[t.to] ?? 0) + 1;
      }
      const maxTC = Math.max(...Object.values(transitionCounts), 0);
      const effectTypes = /* @__PURE__ */ new Set();
      for (const t of data.transitions) {
        for (const e of t.effects) effectTypes.add(e.type);
      }
      const effectList = Array.from(effectTypes).slice(0, 6);
      const totalW = states.length * NODE_W + (states.length - 1) * (GAP2 + ARROW_W + GAP2);
      const svgW = Math.max(totalW + 4, 60);
      const svgH = NODE_H + (effectList.length > 0 ? 18 : 4);
      return /* @__PURE__ */ jsxs("svg", { width: svgW, height: svgH, viewBox: `0 0 ${svgW} ${svgH}`, className, children: [
        states.map((s, i) => {
          const x = 2 + i * (NODE_W + GAP2 + ARROW_W + GAP2);
          const tc = transitionCounts[s.name] ?? 0;
          const role = getStateRole(s.name, s.isInitial ?? void 0, s.isTerminal ?? void 0, tc, maxTC);
          return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
            /* @__PURE__ */ jsx(
              AvlState,
              {
                x,
                y: 0,
                width: NODE_W,
                height: NODE_H,
                name: "",
                role,
                isInitial: s.isInitial ?? void 0,
                isTerminal: s.isTerminal ?? void 0
              }
            ),
            i < states.length - 1 && /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "line",
                {
                  x1: x + NODE_W + GAP2,
                  y1: NODE_H / 2,
                  x2: x + NODE_W + GAP2 + ARROW_W - 3,
                  y2: NODE_H / 2,
                  stroke: "var(--color-muted-foreground)",
                  strokeWidth: 1,
                  opacity: 0.4
                }
              ),
              /* @__PURE__ */ jsx(
                "polygon",
                {
                  points: `${x + NODE_W + GAP2 + ARROW_W - 3},${NODE_H / 2 - 2.5} ${x + NODE_W + GAP2 + ARROW_W},${NODE_H / 2} ${x + NODE_W + GAP2 + ARROW_W - 3},${NODE_H / 2 + 2.5}`,
                  fill: "var(--color-muted-foreground)",
                  opacity: 0.4
                }
              )
            ] })
          ] }, s.name);
        }),
        effectList.length > 0 && /* @__PURE__ */ jsx("g", { children: effectList.map((et, i) => /* @__PURE__ */ jsx(
          AvlEffect,
          {
            x: 2 + i * 14,
            y: NODE_H + 4,
            effectType: et,
            size: 10,
            showBackground: true
          },
          et
        )) })
      ] });
    };
    MiniStateMachine.displayName = "MiniStateMachine";
  }
});
function toFieldKind(type) {
  const normalized = type.toLowerCase();
  if (["string", "number", "boolean", "date", "enum", "object", "array"].includes(normalized)) {
    return normalized;
  }
  return "string";
}
var PERSISTENCE_BORDER, PERSISTENCE_ICON, ModuleCardInner, ModuleCard;
var init_ModuleCard = __esm({
  "components/avl/molecules/ModuleCard.tsx"() {
    "use client";
    init_AvlEntity();
    init_AvlFieldType();
    init_AvlPage();
    init_avl_atom_types();
    init_MiniStateMachine();
    PERSISTENCE_BORDER = {
      persistent: "border-l-[3px] border-l-primary border-solid",
      runtime: "border-l-[3px] border-l-primary border-dashed",
      singleton: "border-l-[3px] border-l-primary border-double",
      instance: "border-l-[3px] border-l-primary border-dotted"
    };
    PERSISTENCE_ICON = {
      persistent: "\u26C1",
      // ⛁ cylinder
      runtime: "\u27F3",
      // ⟳ cycle
      singleton: "\u25CE",
      // ◎ double ring
      instance: "\u22A1"
      // ⊡ box
    };
    ModuleCardInner = ({ data }) => {
      const {
        orbitalName,
        entityName,
        persistence,
        fields,
        traits: traits2,
        pages,
        traitDetails,
        externalLinks
      } = data;
      const cols = Math.min(3, Math.max(2, Math.ceil(fields.length / 3)));
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] shadow-sm overflow-hidden",
          style: { minWidth: 280, maxWidth: 400 },
          children: [
            /* @__PURE__ */ jsx(Handle, { type: "target", position: Position.Left, className: "!w-2.5 !h-2.5 !bg-warning" }),
            /* @__PURE__ */ jsx(Handle, { type: "source", position: Position.Right, className: "!w-2.5 !h-2.5 !bg-warning" }),
            /* @__PURE__ */ jsx("div", { className: "px-3 py-2 border-b border-[var(--color-border)]", children: /* @__PURE__ */ jsx("span", { className: "text-base font-bold text-[var(--color-foreground)]", children: orbitalName }) }),
            /* @__PURE__ */ jsxs("div", { className: `px-3 py-2 border-b border-[var(--color-border)] ${PERSISTENCE_BORDER[persistence] ?? ""}`, children: [
              /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5 mb-1.5", children: [
                /* @__PURE__ */ jsx("svg", { width: 18, height: 18, viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx(AvlEntity, { x: 10, y: 10, r: 8, persistence }) }),
                /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold text-[var(--color-foreground)]", children: entityName }),
                /* @__PURE__ */ jsx("span", { className: "ml-auto text-xs opacity-50", title: persistence, children: PERSISTENCE_ICON[persistence] ?? "" })
              ] }),
              fields.length > 0 && /* @__PURE__ */ jsx("div", { className: `grid gap-x-3 gap-y-0.5`, style: { gridTemplateColumns: `repeat(${cols}, 1fr)` }, children: fields.map((f3) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ jsx("svg", { width: 14, height: 14, viewBox: "0 0 16 16", children: /* @__PURE__ */ jsx(AvlFieldType, { x: 8, y: 8, kind: toFieldKind(f3.type), size: 6 }) }),
                /* @__PURE__ */ jsx("span", { className: "text-xs text-[var(--color-muted-foreground)] truncate", children: f3.name })
              ] }, f3.name)) })
            ] }),
            traits2.map((trait) => {
              const detail = traitDetails[trait.name];
              const traitEmits = externalLinks.filter((l) => l.direction === "out" && l.traitName === trait.name);
              const traitListens = externalLinks.filter((l) => l.direction === "in" && l.traitName === trait.name);
              return /* @__PURE__ */ jsxs("div", { className: "px-3 py-2 border-b border-[var(--color-border)]", children: [
                /* @__PURE__ */ jsx("div", { className: "text-xs font-semibold text-[var(--color-foreground)] mb-1", children: trait.name }),
                detail && /* @__PURE__ */ jsx(MiniStateMachine, { data: detail, className: "mb-1" }),
                (traitEmits.length > 0 || traitListens.length > 0) && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-[9px] mt-1", children: [
                  traitListens.map((l) => /* @__PURE__ */ jsxs("span", { style: { color: CONNECTION_COLORS.emitListen.color }, children: [
                    "\u25C0~~",
                    " ",
                    l.eventName
                  ] }, l.eventName)),
                  traitListens.length > 0 && traitEmits.length > 0 && /* @__PURE__ */ jsx("span", { className: "flex-1" }),
                  traitEmits.map((l) => /* @__PURE__ */ jsxs("span", { style: { color: CONNECTION_COLORS.emitListen.color }, className: "ml-auto", children: [
                    l.eventName,
                    " ",
                    "~~\u25B6"
                  ] }, l.eventName))
                ] })
              ] }, trait.name);
            }),
            pages.length > 0 && /* @__PURE__ */ jsx("div", { className: "px-3 py-1.5 flex items-center gap-2 flex-wrap", children: pages.map((p) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-0.5", children: [
              /* @__PURE__ */ jsx("svg", { width: 10, height: 10, viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx(AvlPage, { x: 6, y: 6, size: 5 }) }),
              /* @__PURE__ */ jsx("span", { className: "text-xs font-mono text-[var(--color-muted-foreground)]", children: p.route })
            ] }, p.name)) })
          ]
        }
      );
    };
    ModuleCardInner.displayName = "ModuleCardInner";
    ModuleCard = (props) => {
      const nodeId = useNodeId();
      if (nodeId !== null) return /* @__PURE__ */ jsx(ModuleCardInner, { ...props });
      return /* @__PURE__ */ jsx(ReactFlowProvider, { children: /* @__PURE__ */ jsx(ModuleCardInner, { ...props }) });
    };
    ModuleCard.displayName = "ModuleCard";
  }
});
var PageHeader;
var init_PageHeader = __esm({
  "components/core/molecules/PageHeader.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Box();
    init_Typography();
    init_useEventBus();
    PageHeader = ({
      title,
      subtitle,
      showBack = false,
      backEvent = "BACK",
      breadcrumbs,
      status,
      actions,
      isLoading,
      tabs,
      activeTab,
      onTabChange,
      children,
      className
    }) => {
      const eventBus = useEventBus();
      const statusBadge = typeof status === "string" ? status ? { label: status } : void 0 : status;
      const handleBack = () => {
        eventBus.emit(`UI:${backEvent}`);
      };
      const createActionHandler = (action) => () => {
        if (action.event) {
          eventBus.emit(`UI:${action.event}`);
        }
        if (action.navigatesTo) {
          eventBus.emit("UI:NAVIGATE", { url: action.navigatesTo });
        }
        if (action.onClick) {
          action.onClick();
        }
      };
      const statusColors2 = {
        default: "bg-muted text-foreground",
        success: "bg-success/10 text-success",
        warning: "bg-warning/10 text-warning",
        danger: "bg-error/10 text-error",
        info: "bg-info/10 text-info"
      };
      return /* @__PURE__ */ jsxs(Box, { className: cn("mb-6", className), children: [
        breadcrumbs && breadcrumbs.length > 0 && /* @__PURE__ */ jsx(Box, { as: "nav", className: "mb-4", children: /* @__PURE__ */ jsx(Box, { as: "ol", className: "flex items-center gap-2 text-sm", children: breadcrumbs.map((crumb, idx) => /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
          idx > 0 && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", children: "/" }),
          crumb.href ? /* @__PURE__ */ jsx(
            "a",
            {
              href: crumb.href,
              className: "text-muted-foreground hover:text-foreground",
              children: crumb.label
            }
          ) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground font-medium", children: crumb.label })
        ] }, idx)) }) }),
        /* @__PURE__ */ jsxs(Box, { className: "flex items-start justify-between gap-4", children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-4", children: [
            showBack && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                onClick: handleBack,
                className: "mt-1 p-2 rounded-lg",
                children: /* @__PURE__ */ jsx(ArrowLeft, { className: "h-5 w-5 text-muted-foreground" })
              }
            ),
            /* @__PURE__ */ jsxs(Box, { children: [
              /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-3", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h1", className: "text-2xl font-bold text-foreground", children: title != null ? String(title) : "" }),
                statusBadge && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "small",
                    className: cn(
                      "px-2.5 py-1 rounded-full text-xs font-medium",
                      statusColors2[statusBadge.variant || "default"]
                    ),
                    children: statusBadge.label
                  }
                )
              ] }),
              subtitle != null && subtitle !== "" && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", className: "mt-1 text-sm", children: String(subtitle) })
            ] })
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2 shrink-0", children: actions?.map((action, idx) => /* @__PURE__ */ jsx(
            Button,
            {
              "data-event": action.event,
              "data-testid": action.event ? `action-${action.event}` : void 0,
              variant: action.variant || (idx === 0 ? "primary" : "secondary"),
              leftIcon: action.icon || void 0,
              onClick: createActionHandler(action),
              isLoading: action.loading || isLoading,
              disabled: action.disabled || isLoading,
              children: action.label
            },
            `action-${idx}`
          )) })
        ] }),
        tabs && tabs.length > 0 && /* @__PURE__ */ jsx(Box, { className: "mt-6 border-b border-border", children: /* @__PURE__ */ jsx(Box, { as: "nav", className: "flex gap-6", children: tabs.map((tab) => /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "ghost",
            onClick: () => onTabChange?.(tab.value),
            className: cn(
              "pb-3 text-sm font-bold border-b-2 transition-colors rounded-none",
              activeTab === tab.value ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
            ),
            children: [
              tab.label,
              tab.count !== void 0 && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "small",
                  className: cn(
                    "ml-2 px-2 py-0.5 rounded-full text-xs",
                    activeTab === tab.value ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"
                  ),
                  children: tab.count
                }
              )
            ]
          },
          tab.value
        )) }) }),
        children
      ] });
    };
    PageHeader.displayName = "PageHeader";
  }
});
var lookStyles8, Header;
var init_Header = __esm({
  "components/core/molecules/Header.tsx"() {
    "use client";
    init_SearchInput();
    init_Avatar();
    init_Badge();
    init_Button();
    init_Box();
    init_Icon();
    init_Stack();
    init_Typography();
    init_cn();
    lookStyles8 = {
      "compact-bar": "",
      hero: "py-section min-h-[200px] [&_h1]:text-display-1",
      breadcrumb: "py-2 text-sm [&_h1]:text-base [&_h1]:font-medium",
      contextual: "py-3 [&_h1]:text-lg",
      "editorial-banner": "py-12 [&_h1]:text-display-2 [&_h1]:font-display-bold border-b border-border"
    };
    Header = ({
      logo,
      logoSrc,
      brandName = "KFlow",
      navigationItems,
      showMenuToggle = true,
      isMenuOpen = false,
      onMenuToggle,
      showSearch = false,
      searchPlaceholder,
      onSearch,
      userAvatar,
      userName,
      onUserClick,
      actions,
      sticky = true,
      variant = "mobile",
      look = "compact-bar",
      onLogoClick,
      className
    }) => {
      const { t } = useTranslate();
      const resolvedSearchPlaceholder = searchPlaceholder ?? t("common.search");
      const userInitials = userAvatar?.initials || userName?.[0]?.toUpperCase() || "U";
      return /* @__PURE__ */ jsxs(
        Box,
        {
          as: "header",
          className: cn(
            "h-16 border-b border-border",
            "flex items-center px-4 justify-between bg-card",
            sticky && "sticky top-0 z-50",
            variant === "mobile" && "lg:hidden",
            lookStyles8[look],
            className
          ),
          children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "center", className: "gap-3", children: [
              showMenuToggle && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  onClick: onMenuToggle,
                  className: "p-2 -ml-2 text-foreground hover:bg-muted transition-colors",
                  "aria-label": isMenuOpen ? t("aria.closeMenu") : t("aria.openMenu"),
                  children: isMenuOpen ? /* @__PURE__ */ jsx(X, { size: 24 }) : /* @__PURE__ */ jsx(Menu$1, { size: 24 })
                }
              ),
              /* @__PURE__ */ jsxs(
                HStack,
                {
                  gap: "none",
                  align: "center",
                  className: cn(
                    "gap-2",
                    onLogoClick && "cursor-pointer"
                  ),
                  onClick: onLogoClick,
                  children: [
                    logo ? typeof logo === "string" ? /* @__PURE__ */ jsx(Avatar, { src: logo, alt: brandName, size: "sm" }) : logo : logoSrc ? /* @__PURE__ */ jsx(Avatar, { src: logoSrc, alt: brandName, size: "sm" }) : null,
                    brandName && /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "h5",
                        className: "text-lg font-bold text-foreground",
                        children: brandName
                      }
                    )
                  ]
                }
              )
            ] }),
            variant === "desktop" && navigationItems && navigationItems.length > 0 && /* @__PURE__ */ jsx(
              Box,
              {
                role: "navigation",
                className: "hidden md:flex items-center gap-1 flex-1 justify-center",
                children: navigationItems.map((item, index) => /* @__PURE__ */ jsxs(
                  Button,
                  {
                    variant: "ghost",
                    onClick: item.onClick,
                    className: cn(
                      "flex items-center gap-2 px-3 py-2 rounded-lg transition-colors",
                      item.active ? "bg-primary/10 text-primary" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                    ),
                    children: [
                      item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm" })),
                      /* @__PURE__ */ jsx(Typography, { variant: "label", className: "font-medium", children: item.label }),
                      item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: item.badge })
                    ]
                  },
                  index
                ))
              }
            ),
            showSearch && /* @__PURE__ */ jsx(Box, { className: "hidden lg:block flex-1 max-w-md mx-4", children: /* @__PURE__ */ jsx(SearchInput, { placeholder: resolvedSearchPlaceholder, onSearch }) }),
            /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "center", className: "gap-3", children: [
              actions,
              (userAvatar || userName) && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  onClick: onUserClick,
                  className: cn(
                    "w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center",
                    "text-primary font-bold text-xs",
                    "hover:ring-2 hover:ring-ring transition-all",
                    onUserClick && "cursor-pointer"
                  ),
                  children: userAvatar?.src ? /* @__PURE__ */ jsx(
                    Avatar,
                    {
                      src: userAvatar.src,
                      alt: userAvatar.alt || userName,
                      size: "sm"
                    }
                  ) : userInitials
                }
              )
            ] })
          ]
        }
      );
    };
    Header.displayName = "Header";
  }
});
var Navigation;
var init_Navigation = __esm({
  "components/core/molecules/Navigation.tsx"() {
    init_Menu();
    init_Button();
    init_Badge();
    init_Box();
    init_cn();
    Navigation = ({
      items,
      orientation = "horizontal",
      className
    }) => {
      const renderNavigationItem = (item, hasSubMenu) => {
        if (hasSubMenu) {
          const menuItems = item.subMenu.map((subItem) => ({
            id: subItem.id,
            label: subItem.label,
            icon: subItem.icon,
            badge: subItem.badge,
            disabled: subItem.disabled,
            onClick: subItem.onClick
          }));
          return /* @__PURE__ */ jsx(
            Menu,
            {
              trigger: /* @__PURE__ */ jsxs(
                Button,
                {
                  variant: item.isActive ? "primary" : "ghost",
                  size: "sm",
                  icon: item.icon,
                  disabled: item.disabled,
                  children: [
                    item.label,
                    item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: item.badge })
                  ]
                }
              ),
              items: menuItems,
              position: orientation === "horizontal" ? "bottom-left" : "bottom-right"
            },
            item.id
          );
        }
        return /* @__PURE__ */ jsxs(
          Button,
          {
            variant: item.isActive ? "primary" : "ghost",
            size: "sm",
            icon: item.icon,
            onClick: item.onClick,
            disabled: item.disabled,
            className: "relative",
            children: [
              item.label,
              item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", className: "absolute -top-1 -right-1", children: item.badge })
            ]
          },
          item.id
        );
      };
      return /* @__PURE__ */ jsx(
        Box,
        {
          as: "nav",
          className: cn(
            "flex",
            orientation === "horizontal" ? "flex-row items-center gap-1" : "flex-col gap-1",
            className
          ),
          role: "navigation",
          children: items.map((item) => {
            const hasSubMenu = !!(item.subMenu && item.subMenu.length > 0);
            return renderNavigationItem(item, hasSubMenu);
          })
        }
      );
    };
    Navigation.displayName = "Navigation";
  }
});
var paddingStyles4, variantStyles7, Section;
var init_Section = __esm({
  "components/core/molecules/Section.tsx"() {
    init_cn();
    init_Typography();
    init_Box();
    paddingStyles4 = {
      none: "p-0",
      sm: "p-3",
      md: "p-4",
      lg: "p-6",
      xl: "p-8"
    };
    variantStyles7 = {
      default: "",
      card: [
        "bg-card",
        "border-[length:var(--border-width)] border-border",
        "shadow",
        "rounded-md"
      ].join(" "),
      bordered: [
        "border-[length:var(--border-width)] border-border",
        "rounded-md"
      ].join(" "),
      filled: "bg-muted rounded-md"
    };
    Section = ({
      title,
      description,
      action,
      padding = "md",
      variant = "default",
      divider = false,
      className,
      children,
      headerClassName,
      contentClassName,
      as: Component = "section"
    }) => {
      const hasHeader = title || description || action;
      return React79__default.createElement(
        Component,
        {
          className: cn(
            paddingStyles4[padding],
            variantStyles7[variant],
            className
          )
        },
        hasHeader && /* @__PURE__ */ jsxs(
          Box,
          {
            className: cn(
              "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4",
              divider && "pb-4 mb-4 border-b-[length:var(--border-width)] border-border",
              !divider && "mb-4",
              headerClassName
            ),
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
                title && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "h4",
                    className: "text-foreground font-semibold",
                    children: title
                  }
                ),
                description && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body",
                    color: "muted",
                    className: "mt-1",
                    children: description
                  }
                )
              ] }),
              action && /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 flex items-center gap-2", children: action })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: contentClassName, children })
      );
    };
    Section.displayName = "Section";
  }
});
var SidebarNavItem, Sidebar;
var init_Sidebar = __esm({
  "components/core/molecules/Sidebar.tsx"() {
    "use client";
    init_Badge();
    init_Button();
    init_Box();
    init_Icon();
    init_Typography();
    init_cn();
    init_useEventBus();
    SidebarNavItem = ({ item, collapsed }) => {
      const isActive = item.active ?? item.isActive;
      return /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          onClick: item.onClick,
          className: cn(
            "w-full flex items-center gap-3 px-3 py-2.5 transition-all duration-fast group relative",
            "rounded-sm border-[length:var(--border-width-thin)] border-transparent",
            isActive ? [
              "bg-primary text-primary-foreground",
              "font-medium shadow-sm",
              "border-primary translate-x-1 rtl:-translate-x-1 -translate-y-0.5"
            ].join(" ") : [
              "text-foreground",
              "hover:bg-muted hover:border-border",
              "active:bg-primary active:text-primary-foreground"
            ].join(" ")
          ),
          title: collapsed ? item.label : void 0,
          children: [
            item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm", className: cn("min-w-[20px] flex-shrink-0", isActive && "text-primary-foreground") }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm", className: cn("min-w-[20px] flex-shrink-0", isActive && "text-primary-foreground") })),
            !collapsed && /* @__PURE__ */ jsx(Typography, { variant: "body", color: isActive ? "inherit" : "primary", className: "font-medium truncate flex-1 text-start", children: item.label }),
            !collapsed && item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: item.badge }),
            collapsed && /* @__PURE__ */ jsx(Box, { className: cn(
              "absolute start-full ms-2 px-2 py-1 text-xs opacity-0 group-hover:opacity-100",
              "pointer-events-none whitespace-nowrap z-50 transition-opacity",
              "bg-primary text-primary-foreground",
              "border-[length:var(--border-width-thin)] border-border",
              "rounded-sm"
            ), children: item.label })
          ]
        }
      );
    };
    Sidebar = ({
      logo,
      logoSrc,
      brandName = "KFlow",
      items,
      userSection,
      footerContent,
      collapsed: controlledCollapsed,
      defaultCollapsed = false,
      collapseChangeEvent,
      hideCollapseButton = false,
      showCloseButton = false,
      closeEvent,
      logoClickEvent,
      className
    }) => {
      const { emit } = useEventBus();
      const { t } = useTranslate();
      const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);
      const collapsed = controlledCollapsed !== void 0 ? controlledCollapsed : internalCollapsed;
      const handleToggle = useCallback(() => {
        const newCollapsed = !collapsed;
        if (controlledCollapsed === void 0) {
          setInternalCollapsed(newCollapsed);
        }
        if (collapseChangeEvent) {
          emit(collapseChangeEvent, { collapsed: newCollapsed });
        }
      }, [collapsed, controlledCollapsed, collapseChangeEvent, emit]);
      const handleClose = useCallback(() => {
        if (closeEvent) {
          emit(closeEvent, {});
        }
      }, [closeEvent, emit]);
      const handleLogoClick = useCallback(() => {
        if (logoClickEvent) {
          emit(logoClickEvent, {});
        }
      }, [logoClickEvent, emit]);
      return /* @__PURE__ */ jsxs(
        Box,
        {
          as: "aside",
          className: cn(
            "flex flex-col h-full",
            "bg-card border-e border-border",
            "transition-all duration-normal ease-standard",
            collapsed ? "w-20" : "w-64",
            className
          ),
          children: [
            /* @__PURE__ */ jsxs(Box, { className: "h-16 flex items-center justify-between px-4 border-b border-border flex-shrink-0", children: [
              /* @__PURE__ */ jsxs(
                Box,
                {
                  className: cn(
                    "flex items-center gap-3 cursor-pointer",
                    collapsed && "justify-center w-full"
                  ),
                  onClick: handleLogoClick,
                  children: [
                    logo ? typeof logo === "string" ? /* @__PURE__ */ jsx("img", { src: logo, alt: brandName, className: "h-8 w-8" }) : logo : logoSrc ? /* @__PURE__ */ jsx("img", { src: logoSrc, alt: brandName, className: "h-8 w-8" }) : /* @__PURE__ */ jsx(Box, { className: "h-8 w-8 bg-primary flex items-center justify-center rounded-sm", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-primary-foreground font-bold text-sm", children: "K" }) }),
                    !collapsed && /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-xl font-bold text-foreground", children: brandName })
                  ]
                }
              ),
              !hideCollapseButton && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  onClick: handleToggle,
                  className: cn(
                    "p-1.5 hover:bg-muted text-foreground hidden lg:block",
                    "rounded-sm",
                    collapsed && "mx-auto"
                  ),
                  title: collapsed ? t("sidebar.expand") : t("sidebar.collapse"),
                  children: collapsed ? /* @__PURE__ */ jsx(ChevronRight, { size: 18 }) : /* @__PURE__ */ jsx(ChevronLeft, { size: 18 })
                }
              ),
              showCloseButton && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  onClick: handleClose,
                  className: "p-1.5 hover:bg-muted text-foreground lg:hidden rounded-sm",
                  "aria-label": t("sidebar.close"),
                  children: /* @__PURE__ */ jsx(X, { size: 18 })
                }
              )
            ] }),
            /* @__PURE__ */ jsx(Box, { as: "nav", className: "flex-1 py-6 px-3 space-y-1 overflow-y-auto", children: items.map((item) => /* @__PURE__ */ jsx(
              SidebarNavItem,
              {
                item,
                collapsed
              },
              item.id
            )) }),
            (footerContent || userSection) && /* @__PURE__ */ jsxs(Box, { className: "p-3 border-t border-border space-y-1 flex-shrink-0", children: [
              /* @__PURE__ */ jsxs(Box, { className: cn(
                "flex items-center",
                collapsed ? "justify-center flex-col gap-4" : "justify-between px-2"
              ), children: [
                footerContent && /* @__PURE__ */ jsx(Box, { className: "flex items-center", children: footerContent }),
                userSection && /* @__PURE__ */ jsx(Box, { className: "flex items-center", children: userSection })
              ] }),
              collapsed && !hideCollapseButton && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  onClick: handleToggle,
                  className: "w-full flex justify-center p-2 mt-2 text-muted-foreground hover:text-foreground lg:hidden",
                  children: /* @__PURE__ */ jsx(ChevronRight, { size: 20 })
                }
              )
            ] })
          ]
        }
      );
    };
    Sidebar.displayName = "Sidebar";
  }
});
var gapStyles8, alignStyles5, ratioStyles, breakpointPrefixes, Split;
var init_Split = __esm({
  "components/core/molecules/Split.tsx"() {
    init_cn();
    init_Box();
    gapStyles8 = {
      none: "gap-0",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    };
    alignStyles5 = {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch"
    };
    ratioStyles = {
      "1:1": ["w-1/2", "w-1/2"],
      "1:2": ["w-1/3", "w-2/3"],
      "2:1": ["w-2/3", "w-1/3"],
      "1:3": ["w-1/4", "w-3/4"],
      "3:1": ["w-3/4", "w-1/4"],
      "1:4": ["w-1/5", "w-4/5"],
      "4:1": ["w-4/5", "w-1/5"],
      "2:3": ["w-2/5", "w-3/5"],
      "3:2": ["w-3/5", "w-2/5"]
    };
    breakpointPrefixes = {
      sm: "sm:",
      md: "md:",
      lg: "lg:",
      xl: "xl:"
    };
    Split = ({
      ratio = "1:1",
      gap = "md",
      reverse = false,
      stackOnMobile = true,
      stackBreakpoint = "md",
      align = "stretch",
      className,
      leftClassName,
      rightClassName,
      children
    }) => {
      const [left, right] = children;
      const [leftRatio, rightRatio] = ratioStyles[ratio];
      const bp = breakpointPrefixes[stackBreakpoint];
      const leftWidth = stackOnMobile ? `w-full ${bp}${leftRatio}` : leftRatio;
      const rightWidth = stackOnMobile ? `w-full ${bp}${rightRatio}` : rightRatio;
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: cn(
            "flex",
            stackOnMobile ? `flex-col ${bp}flex-row` : "flex-row",
            reverse && `${bp}flex-row-reverse`,
            gapStyles8[gap],
            alignStyles5[align],
            className
          ),
          children: [
            /* @__PURE__ */ jsx(Box, { className: cn(leftWidth, leftClassName), children: left }),
            /* @__PURE__ */ jsx(Box, { className: cn(rightWidth, rightClassName), children: right })
          ]
        }
      );
    };
    Split.displayName = "Split";
  }
});
var WizardContainer;
var init_WizardContainer = __esm({
  "components/core/molecules/WizardContainer.tsx"() {
    "use client";
    init_Button();
    init_Typography();
    init_Box();
    init_Stack();
    init_Icon();
    init_cn();
    init_useEventBus();
    WizardContainer = ({
      steps,
      currentStep: controlledStep,
      onStepChange,
      onComplete,
      showProgress = true,
      allowBack = true,
      compact = false,
      className,
      nextEvent,
      backEvent,
      completeEvent
    }) => {
      const { t } = useTranslate();
      const eventBus = useEventBus();
      const [internalStep, setInternalStep] = useState(0);
      const normalizedControlledStep = (() => {
        if (controlledStep === void 0 || controlledStep === null)
          return void 0;
        if (typeof controlledStep === "number") return controlledStep;
        if (typeof controlledStep === "string") return parseInt(controlledStep, 10);
        const num2 = Number(controlledStep);
        return isNaN(num2) ? void 0 : num2;
      })();
      const currentStep = normalizedControlledStep !== void 0 ? normalizedControlledStep : internalStep;
      const totalSteps = steps.length;
      const currentStepData = steps[currentStep];
      const isFirstStep = currentStep === 0;
      const isLastStep = currentStep === totalSteps - 1;
      const goToStep = useCallback(
        (stepIndex) => {
          if (stepIndex < 0 || stepIndex >= totalSteps) return;
          if (controlledStep === void 0) {
            setInternalStep(stepIndex);
          }
          onStepChange?.(stepIndex);
        },
        [controlledStep, totalSteps, onStepChange]
      );
      const handleNext = () => {
        if (currentStepData.isValid && !currentStepData.isValid()) {
          return;
        }
        if (isLastStep) {
          if (completeEvent) eventBus.emit(`UI:${completeEvent}`, { step: currentStep });
          onComplete?.();
        } else {
          if (nextEvent) eventBus.emit(`UI:${nextEvent}`, { step: currentStep + 1 });
          goToStep(currentStep + 1);
        }
      };
      const handleBack = () => {
        if (!isFirstStep && allowBack) {
          if (backEvent) eventBus.emit(`UI:${backEvent}`, { step: currentStep - 1 });
          goToStep(currentStep - 1);
        }
      };
      return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col h-full", className), children: [
        showProgress && /* @__PURE__ */ jsx(
          Box,
          {
            border: true,
            className: cn(
              "border-b-2 border-x-0 border-t-0 border-border",
              compact ? "px-4 py-2" : "px-6 py-4"
            ),
            children: /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", className: "flex-wrap", children: steps.map((step, index) => {
              const isActive = index === currentStep;
              const isCompleted = index < currentStep;
              const stepKey = step.id ?? step.tabId ?? `step-${index}`;
              const stepTitle = step.title ?? step.name ?? `Step ${index + 1}`;
              return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    onClick: () => isCompleted && allowBack && goToStep(index),
                    disabled: !isCompleted || !allowBack,
                    className: cn(
                      "w-8 h-8 flex items-center justify-center text-sm font-bold transition-colors",
                      "border-2 border-border",
                      isActive && "bg-primary text-primary-foreground",
                      isCompleted && "bg-primary text-primary-foreground cursor-pointer hover:bg-primary-hover",
                      !isActive && !isCompleted && "bg-card text-foreground"
                    ),
                    children: isCompleted ? /* @__PURE__ */ jsx(Icon, { icon: Check, size: "sm" }) : index + 1
                  }
                ),
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    className: cn(
                      "hidden md:block",
                      isActive ? "text-foreground font-bold" : "text-muted-foreground"
                    ),
                    children: /* @__PURE__ */ jsx(
                      Typography,
                      {
                        variant: "small",
                        weight: isActive ? "bold" : "normal",
                        children: stepTitle
                      }
                    )
                  }
                ),
                index < totalSteps - 1 && /* @__PURE__ */ jsx(
                  Box,
                  {
                    className: cn(
                      "flex-1 h-0.5",
                      index < currentStep ? "bg-primary" : "bg-border"
                    )
                  }
                )
              ] }, stepKey);
            }) })
          }
        ),
        !compact && currentStepData && /* @__PURE__ */ jsxs(
          Box,
          {
            paddingX: "lg",
            paddingY: "md",
            border: true,
            className: "border-b-2 border-x-0 border-t-0 border-border",
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "h2", children: currentStepData.title ?? currentStepData.name ?? `Step ${currentStep + 1}` }),
              currentStepData.description && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  className: "text-muted-foreground mt-1",
                  children: currentStepData.description
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: cn("flex-1 overflow-auto", compact ? "p-4" : "p-6"), children: currentStepData?.content }),
        /* @__PURE__ */ jsxs(
          Box,
          {
            border: true,
            className: cn(
              "border-t-2 border-x-0 border-b-0 border-border flex justify-between",
              compact ? "px-4 py-2" : "px-6 py-4"
            ),
            children: [
              /* @__PURE__ */ jsxs(
                Button,
                {
                  variant: "secondary",
                  onClick: handleBack,
                  disabled: isFirstStep || !allowBack,
                  children: [
                    /* @__PURE__ */ jsx(Icon, { icon: ChevronLeft, size: "sm" }),
                    t("wizard.back")
                  ]
                }
              ),
              /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: "text-muted-foreground",
                  children: t("wizard.stepOf", { current: String(currentStep + 1), total: String(steps.length) })
                }
              ) }),
              /* @__PURE__ */ jsxs(Button, { variant: "primary", onClick: handleNext, children: [
                isLastStep ? t("wizard.complete") : t("wizard.next"),
                !isLastStep && /* @__PURE__ */ jsx(Icon, { icon: ChevronRight, size: "sm" })
              ] })
            ]
          }
        )
      ] });
    };
    WizardContainer.displayName = "WizardContainer";
  }
});
function calculateComplexity(schema) {
  if (!schema) return 1;
  const entities = schema.dataEntities || 0;
  const pages = schema.ui?.pages?.length || 0;
  const traits2 = schema.traits || 0;
  const sections = schema.ui?.pages?.reduce(
    (acc, page) => acc + (page.sections || 0),
    0
  ) || 0;
  return entities * 3 + pages * 2 + traits2 * 2 + sections * 1;
}
function getOrbitalType(complexity) {
  if (complexity <= 3) return "1s";
  if (complexity <= 8) return "2s";
  if (complexity <= 15) return "2p";
  if (complexity <= 25) return "3s";
  if (complexity <= 40) return "3p";
  if (complexity <= 60) return "3d";
  return "4f";
}
var ORBITAL_CONFIGS, SIZE_MAP, OrbitalSphere, DumbbellOrbital, CloverleafOrbital, OrbitalVisualization;
var init_OrbitalVisualization = __esm({
  "components/core/molecules/OrbitalVisualization.tsx"() {
    "use client";
    init_Box();
    init_Typography();
    init_cn();
    ORBITAL_CONFIGS = {
      "1s": {
        type: "1s",
        name: "1s Orbital",
        color: "#C45B5B",
        glowColor: "rgba(196, 91, 91, 0.3)",
        lobes: 1,
        hasNode: false,
        scale: 0.6
      },
      "2s": {
        type: "2s",
        name: "2s Orbital",
        color: "#D4875B",
        glowColor: "rgba(212, 135, 91, 0.3)",
        lobes: 1,
        hasNode: false,
        scale: 0.8
      },
      "2p": {
        type: "2p",
        name: "2p Orbital",
        color: "#C9B458",
        glowColor: "rgba(201, 180, 88, 0.3)",
        lobes: 2,
        hasNode: false,
        scale: 1
      },
      "3s": {
        type: "3s",
        name: "3s Orbital",
        color: "#5BA87A",
        glowColor: "rgba(91, 168, 122, 0.3)",
        lobes: 1,
        hasNode: true,
        scale: 1
      },
      "3p": {
        type: "3p",
        name: "3p Orbital",
        color: "#5B8DC4",
        glowColor: "rgba(91, 141, 196, 0.3)",
        lobes: 2,
        hasNode: true,
        scale: 1.1
      },
      "3d": {
        type: "3d",
        name: "3d Orbital",
        color: "#6B5B8A",
        glowColor: "rgba(107, 91, 138, 0.3)",
        lobes: 4,
        hasNode: true,
        scale: 1.2
      },
      "4f": {
        type: "4f",
        name: "4f Orbital",
        color: "#8A5B9C",
        glowColor: "rgba(138, 91, 156, 0.3)",
        lobes: 6,
        hasNode: true,
        scale: 1.3
      }
    };
    SIZE_MAP = {
      sm: 120,
      md: 200,
      lg: 300,
      xl: 400
    };
    OrbitalSphere = ({
      config,
      size,
      animated
    }) => {
      const sphereSize = size * config.scale * 0.4;
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "absolute rounded-full",
          style: {
            width: sphereSize,
            height: sphereSize,
            background: `radial-gradient(circle at 30% 30%, ${config.color}dd, ${config.color}88 50%, ${config.color}44 100%)`,
            boxShadow: `
          inset -10px -10px 20px rgba(0,0,0,0.3),
          inset 5px 5px 15px rgba(255,255,255,0.2),
          0 0 ${size * 0.15}px ${config.glowColor},
          0 0 ${size * 0.3}px ${config.glowColor}
        `,
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            animation: animated ? "orbital-pulse 3s ease-in-out infinite" : void 0
          }
        }
      );
    };
    DumbbellOrbital = ({
      config,
      size,
      animated,
      rotation = 0
    }) => {
      const lobeSize = size * config.scale * 0.25;
      const offset = size * 0.18;
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: "absolute",
          style: {
            width: size,
            height: size,
            left: "50%",
            top: "50%",
            transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
            animation: animated ? "orbital-rotate 8s linear infinite" : void 0
          },
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute rounded-full",
                style: {
                  width: lobeSize,
                  height: lobeSize * 1.4,
                  background: `radial-gradient(ellipse at 50% 30%, ${config.color}dd, ${config.color}66 70%, transparent 100%)`,
                  boxShadow: `0 0 ${size * 0.1}px ${config.glowColor}`,
                  left: "50%",
                  top: `calc(50% - ${offset}px)`,
                  transform: "translate(-50%, -100%)",
                  borderRadius: "50% 50% 40% 40%"
                }
              }
            ),
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute rounded-full",
                style: {
                  width: lobeSize,
                  height: lobeSize * 1.4,
                  background: `radial-gradient(ellipse at 50% 70%, ${config.color}dd, ${config.color}66 70%, transparent 100%)`,
                  boxShadow: `0 0 ${size * 0.1}px ${config.glowColor}`,
                  left: "50%",
                  bottom: `calc(50% - ${offset}px)`,
                  transform: "translate(-50%, 100%)",
                  borderRadius: "40% 40% 50% 50%"
                }
              }
            ),
            config.hasNode && /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute rounded-full bg-foreground",
                style: {
                  width: size * 0.06,
                  height: size * 0.06,
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  boxShadow: `0 0 ${size * 0.05}px rgba(255,255,255,0.8)`
                }
              }
            )
          ]
        }
      );
    };
    CloverleafOrbital = ({
      config,
      size,
      animated
    }) => {
      const lobes = config.lobes;
      const angleStep = 360 / lobes;
      const lobeSize = size * 0.18;
      const lobeDistance = size * 0.22;
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: "absolute",
          style: {
            width: size,
            height: size,
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            animation: animated ? "orbital-rotate 12s linear infinite" : void 0
          },
          children: [
            Array.from({ length: lobes }).map((_, i) => {
              const angle = i * angleStep * (Math.PI / 180);
              const x = Math.cos(angle) * lobeDistance;
              const y = Math.sin(angle) * lobeDistance;
              return /* @__PURE__ */ jsx(
                Box,
                {
                  className: "absolute rounded-full",
                  style: {
                    width: lobeSize,
                    height: lobeSize * 1.3,
                    background: `radial-gradient(ellipse at 50% 40%, ${config.color}dd, ${config.color}55 80%, transparent 100%)`,
                    boxShadow: `0 0 ${size * 0.08}px ${config.glowColor}`,
                    left: `calc(50% + ${x}px)`,
                    top: `calc(50% + ${y}px)`,
                    transform: `translate(-50%, -50%) rotate(${i * angleStep + 90}deg)`
                  }
                },
                i
              );
            }),
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute rounded-full bg-foreground",
                style: {
                  width: size * 0.08,
                  height: size * 0.08,
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  boxShadow: `0 0 ${size * 0.06}px rgba(255,255,255,0.9)`
                }
              }
            )
          ]
        }
      );
    };
    OrbitalVisualization = ({
      schema,
      complexity: overrideComplexity,
      size = "md",
      showLabel = true,
      animated = true,
      onClick,
      className = ""
    }) => {
      const complexity = useMemo(() => {
        if (overrideComplexity !== void 0) return overrideComplexity;
        return calculateComplexity(schema);
      }, [schema, overrideComplexity]);
      const orbitalType = useMemo(() => getOrbitalType(complexity), [complexity]);
      const config = ORBITAL_CONFIGS[orbitalType];
      const pixelSize = SIZE_MAP[size];
      const renderOrbital = () => {
        switch (config.lobes) {
          case 1:
            return /* @__PURE__ */ jsx(OrbitalSphere, { config, size: pixelSize, animated });
          case 2:
            return /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                DumbbellOrbital,
                {
                  config,
                  size: pixelSize,
                  animated,
                  rotation: 0
                }
              ),
              config.hasNode && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(
                  DumbbellOrbital,
                  {
                    config,
                    size: pixelSize * 0.7,
                    animated,
                    rotation: 60
                  }
                ),
                /* @__PURE__ */ jsx(
                  DumbbellOrbital,
                  {
                    config,
                    size: pixelSize * 0.7,
                    animated,
                    rotation: 120
                  }
                )
              ] })
            ] });
          case 4:
          case 6:
            return /* @__PURE__ */ jsx(
              CloverleafOrbital,
              {
                config,
                size: pixelSize,
                animated
              }
            );
          default:
            return /* @__PURE__ */ jsx(OrbitalSphere, { config, size: pixelSize, animated });
        }
      };
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: cn("relative flex flex-col items-center justify-center", className),
          style: { width: pixelSize, height: pixelSize + (showLabel ? 60 : 0) },
          onClick,
          role: onClick ? "button" : void 0,
          tabIndex: onClick ? 0 : void 0,
          children: [
            /* @__PURE__ */ jsxs(
              Box,
              {
                className: "relative",
                style: {
                  width: pixelSize,
                  height: pixelSize,
                  perspective: pixelSize * 2,
                  cursor: onClick ? "pointer" : "default"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: "absolute rounded-full opacity-30",
                      style: {
                        width: pixelSize * 0.8,
                        height: pixelSize * 0.8,
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        background: `radial-gradient(circle, ${config.glowColor} 0%, transparent 70%)`,
                        filter: "blur(20px)"
                      }
                    }
                  ),
                  renderOrbital()
                ]
              }
            ),
            showLabel && /* @__PURE__ */ jsxs(Box, { className: "mt-4 text-center", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-lg font-semibold text-foreground", children: config.name }),
              /* @__PURE__ */ jsxs(Typography, { variant: "small", color: "muted", children: [
                "Complexity: ",
                complexity,
                " units"
              ] })
            ] }),
            /* @__PURE__ */ jsx("style", { children: `
        @keyframes orbital-pulse {
          0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
          50% { transform: translate(-50%, -50%) scale(1.05); opacity: 0.9; }
        }

        @keyframes orbital-rotate {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }
      ` })
          ]
        }
      );
    };
    OrbitalVisualization.displayName = "OrbitalVisualization";
  }
});
var SignaturePad;
var init_SignaturePad = __esm({
  "components/core/molecules/SignaturePad.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_useEventBus();
    SignaturePad = ({
      label,
      helperText,
      strokeColor,
      strokeWidth = 2,
      height = 200,
      readOnly = false,
      value,
      onChange,
      signEvent,
      clearEvent,
      isLoading = false,
      error,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolvedLabel = label ?? t("signaturePad.label");
      const resolvedHelperText = helperText ?? t("signaturePad.helperText");
      const canvasRef = useRef(null);
      const [isDrawing, setIsDrawing] = useState(false);
      const [hasSignature, setHasSignature] = useState(!!value);
      useEffect(() => {
        if (value && canvasRef.current) {
          const ctx = canvasRef.current.getContext("2d");
          if (!ctx) return;
          const img = new Image();
          img.onload = () => {
            ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
            ctx.drawImage(img, 0, 0);
            setHasSignature(true);
          };
          img.src = value;
        }
      }, [value]);
      const getCoords = useCallback(
        (e) => {
          const canvas = canvasRef.current;
          if (!canvas) return { x: 0, y: 0 };
          const rect = canvas.getBoundingClientRect();
          if ("touches" in e) {
            const touch = e.touches[0];
            return {
              x: touch.clientX - rect.left,
              y: touch.clientY - rect.top
            };
          }
          return {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
          };
        },
        []
      );
      const startDrawing = useCallback(
        (e) => {
          if (readOnly) return;
          const ctx = canvasRef.current?.getContext("2d");
          if (!ctx) return;
          const { x, y } = getCoords(e);
          ctx.beginPath();
          ctx.moveTo(x, y);
          setIsDrawing(true);
        },
        [readOnly, getCoords]
      );
      const draw = useCallback(
        (e) => {
          if (!isDrawing || readOnly) return;
          const ctx = canvasRef.current?.getContext("2d");
          if (!ctx) return;
          const { x, y } = getCoords(e);
          const resolvedColor = strokeColor || "var(--color-foreground)";
          ctx.strokeStyle = resolvedColor;
          ctx.lineWidth = strokeWidth;
          ctx.lineCap = "round";
          ctx.lineJoin = "round";
          ctx.lineTo(x, y);
          ctx.stroke();
        },
        [isDrawing, readOnly, strokeColor, strokeWidth, getCoords]
      );
      const stopDrawing = useCallback(() => {
        if (isDrawing) {
          setIsDrawing(false);
          setHasSignature(true);
          const dataUrl = canvasRef.current?.toDataURL("image/png") ?? null;
          onChange?.(dataUrl);
        }
      }, [isDrawing, onChange]);
      const clearSignature = useCallback(() => {
        const ctx = canvasRef.current?.getContext("2d");
        if (ctx && canvasRef.current) {
          ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        }
        setHasSignature(false);
        onChange?.(null);
        if (clearEvent) {
          eventBus.emit(`UI:${clearEvent}`, {});
        }
      }, [onChange, clearEvent, eventBus]);
      const confirmSignature = useCallback(() => {
        const dataUrl = canvasRef.current?.toDataURL("image/png") ?? null;
        if (signEvent) {
          eventBus.emit(`UI:${signEvent}`, { signature: dataUrl });
        }
      }, [signEvent, eventBus]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.signaturePadError"),
            message: error.message,
            className
          }
        );
      }
      return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        resolvedLabel && /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "medium", children: resolvedLabel }),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "w-full rounded-md border border-border",
              "bg-background",
              readOnly && "opacity-60 cursor-not-allowed",
              !readOnly && "cursor-crosshair"
            ),
            children: /* @__PURE__ */ jsx(
              "canvas",
              {
                ref: canvasRef,
                width: 600,
                height,
                className: "w-full touch-none",
                style: { height },
                onMouseDown: startDrawing,
                onMouseMove: draw,
                onMouseUp: stopDrawing,
                onMouseLeave: stopDrawing,
                onTouchStart: startDrawing,
                onTouchMove: draw,
                onTouchEnd: stopDrawing
              }
            )
          }
        ),
        resolvedHelperText && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: resolvedHelperText }),
        !readOnly && /* @__PURE__ */ jsxs(HStack, { gap: "sm", justify: "end", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: Eraser,
              onClick: clearSignature,
              disabled: !hasSignature,
              children: t("signaturePad.clear")
            }
          ),
          signEvent && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "primary",
              size: "sm",
              icon: Check,
              onClick: confirmSignature,
              disabled: !hasSignature,
              children: t("signaturePad.confirm")
            }
          )
        ] })
      ] }) });
    };
    SignaturePad.displayName = "SignaturePad";
  }
});
var DocumentViewer;
var init_DocumentViewer = __esm({
  "components/core/molecules/DocumentViewer.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    init_Tabs();
    init_useEventBus();
    DocumentViewer = ({
      title,
      src,
      content,
      documentType = "pdf",
      currentPage: propPage,
      totalPages,
      height = 600,
      showToolbar = true,
      showDownload = false,
      showPrint = false,
      actions,
      documents,
      isLoading = false,
      error,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const [zoom, setZoom] = useState(100);
      const [currentPage, setCurrentPage] = useState(propPage ?? 1);
      const [activeDocIndex, setActiveDocIndex] = useState(0);
      const handleAction = useCallback(
        (action) => {
          if (action.event) {
            eventBus.emit(`UI:${action.event}`, { page: currentPage });
          }
        },
        [eventBus, currentPage]
      );
      const handleDownload = useCallback(() => {
        const downloadSrc = documents?.[activeDocIndex]?.src ?? src;
        if (downloadSrc) {
          eventBus.emit("UI:DOCUMENT_DOWNLOAD", { src: downloadSrc });
          window.open(downloadSrc, "_blank");
        }
      }, [documents, activeDocIndex, src, eventBus]);
      const handlePrint = useCallback(() => {
        eventBus.emit("UI:DOCUMENT_PRINT", {});
        window.print();
      }, [eventBus]);
      const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z + 25, 200)), []);
      const handleZoomOut = useCallback(() => setZoom((z) => Math.max(z - 25, 50)), []);
      const handlePagePrev = useCallback(() => {
        setCurrentPage((p) => Math.max(p - 1, 1));
        eventBus.emit("UI:DOCUMENT_PAGE_CHANGE", { page: currentPage - 1 });
      }, [eventBus, currentPage]);
      const handlePageNext = useCallback(() => {
        if (totalPages) {
          setCurrentPage((p) => Math.min(p + 1, totalPages));
          eventBus.emit("UI:DOCUMENT_PAGE_CHANGE", { page: currentPage + 1 });
        }
      }, [totalPages, eventBus, currentPage]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.documentError"),
            message: error.message,
            className
          }
        );
      }
      const activeDoc = documents?.[activeDocIndex];
      const activeSrc = activeDoc?.src ?? src;
      const activeContent = activeDoc?.content ?? content;
      const activeDocType = activeDoc?.documentType ?? documentType;
      if (!activeSrc && !activeContent) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            icon: FileText,
            title: t("display.noDocument"),
            description: "No document to display.",
            className
          }
        );
      }
      const tabItems = documents?.map((doc, idx) => ({
        id: `doc-${idx}`,
        label: doc.label,
        content: null
        // We handle content rendering separately
      }));
      const renderContent = () => {
        if (activeDocType === "pdf" && activeSrc) {
          return /* @__PURE__ */ jsx(
            "iframe",
            {
              src: activeSrc,
              title: title || "Document",
              className: "w-full border-0",
              style: {
                height: typeof height === "number" ? height : height,
                transform: `scale(${zoom / 100})`,
                transformOrigin: "top left",
                width: `${1e4 / zoom}%`
              }
            }
          );
        }
        if (activeDocType === "html" && activeContent) {
          return /* @__PURE__ */ jsx(
            Box,
            {
              className: "w-full overflow-auto p-4",
              style: { height, fontSize: `${zoom}%` },
              dangerouslySetInnerHTML: { __html: activeContent }
            }
          );
        }
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: "w-full overflow-auto p-4 font-mono text-sm",
            style: { height, fontSize: `${zoom}%` },
            children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap break-words", children: activeContent })
          }
        );
      };
      return /* @__PURE__ */ jsx(Card, { className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
        tabItems && tabItems.length > 1 && /* @__PURE__ */ jsx(Box, { className: "border-b border-border", children: /* @__PURE__ */ jsx(
          Tabs,
          {
            tabs: tabItems,
            activeTab: `doc-${activeDocIndex}`,
            onTabChange: (id) => {
              const idx = parseInt(id.replace("doc-", ""), 10);
              setActiveDocIndex(idx);
            }
          }
        ) }),
        showToolbar && /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            align: "center",
            justify: "between",
            className: "px-4 py-2 border-b border-border bg-muted/30",
            children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
                /* @__PURE__ */ jsx(Icon, { icon: FileText, size: "sm", className: "text-muted-foreground" }),
                title && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "truncate max-w-[200px]", children: title })
              ] }),
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomOut, onClick: handleZoomOut }),
                /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "tabular-nums w-10 text-center", children: [
                  zoom,
                  "%"
                ] }),
                /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomIn, onClick: handleZoomIn }),
                totalPages && totalPages > 1 && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Box, { className: "w-px h-4 bg-border mx-1" }),
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ChevronLeft, onClick: handlePagePrev, disabled: currentPage <= 1 }),
                  /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "tabular-nums", children: [
                    currentPage,
                    " / ",
                    totalPages
                  ] }),
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ChevronRight, onClick: handlePageNext, disabled: currentPage >= totalPages })
                ] }),
                /* @__PURE__ */ jsx(Box, { className: "w-px h-4 bg-border mx-1" }),
                showDownload && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: Download, onClick: handleDownload }),
                showPrint && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: Printer, onClick: handlePrint }),
                actions?.map((action, idx) => /* @__PURE__ */ jsx(
                  Badge,
                  {
                    variant: "default",
                    className: "cursor-pointer hover:opacity-80 transition-opacity",
                    onClick: () => handleAction(action),
                    children: action.label
                  },
                  idx
                ))
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: "w-full overflow-hidden bg-muted/20", children: renderContent() })
      ] }) });
    };
    DocumentViewer.displayName = "DocumentViewer";
  }
});
function measureLabelWidth(text, fontFamily = "system-ui") {
  if (typeof document === "undefined") return text.length * 6;
  if (!labelMeasureCtx) labelMeasureCtx = document.createElement("canvas").getContext("2d");
  if (!labelMeasureCtx) return text.length * 6;
  labelMeasureCtx.font = `12px ${fontFamily}`;
  return labelMeasureCtx.measureText(text).width + 4;
}
function getGroupColor(group, groups) {
  if (!group) return groups.length > 0 ? "var(--color-muted-foreground)" : GROUP_COLORS2[0];
  const idx = groups.indexOf(group);
  return GROUP_COLORS2[idx % GROUP_COLORS2.length];
}
function hashSeed(str2) {
  let h = 1779033703 ^ str2.length;
  for (let i = 0; i < str2.length; i++) {
    h = Math.imul(h ^ str2.charCodeAt(i), 3432918353);
    h = h << 13 | h >>> 19;
  }
  return (h ^= h >>> 16) >>> 0;
}
function mulberry32(a) {
  return function() {
    a |= 0;
    a = a + 1831565813 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
function edgeKeyOf(a, b) {
  return a < b ? `${a}\0${b}` : `${b}\0${a}`;
}
function resolveColor3(color, el) {
  const m = /^var\((--[^,)]+)(?:,\s*([^)]+))?\)$/.exec(color.trim());
  if (!m) return color;
  const resolved = getComputedStyle(el).getPropertyValue(m[1]).trim();
  return resolved || (m[2]?.trim() ?? "#888888");
}
function truncateLabel(label) {
  return label.length > MAX_LABEL_CHARS ? label.slice(0, MAX_LABEL_CHARS - 1) + "\u2026" : label;
}
var GROUP_COLORS2, GROUP_GRAVITY, UNGROUPED_GRAVITY, labelMeasureCtx, MAX_LABEL_CHARS, NO_NODES, NO_EDGES, NO_SIM, GraphCanvas;
var init_GraphCanvas = __esm({
  "components/core/molecules/GraphCanvas.tsx"() {
    "use client";
    init_cn();
    init_portalRoot();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    init_useEventBus();
    init_useCanvasGestures();
    GROUP_COLORS2 = [
      "var(--color-primary)",
      "var(--color-success)",
      "var(--color-warning)",
      "var(--color-error)",
      "var(--color-info)",
      "var(--color-accent)"
    ];
    GROUP_GRAVITY = 0.3;
    UNGROUPED_GRAVITY = 0.02;
    labelMeasureCtx = null;
    MAX_LABEL_CHARS = 22;
    NO_NODES = [];
    NO_EDGES = [];
    NO_SIM = [];
    GraphCanvas = ({
      title,
      nodes: propNodes = NO_NODES,
      edges: propEdges = NO_EDGES,
      proposedEdges = NO_EDGES,
      similarity: propSimilarity = NO_SIM,
      height = 400,
      showLabels = true,
      interactive = true,
      draggable = true,
      actions,
      onNodeClick,
      onMarkClick,
      onNodeDoubleClick,
      onBadgeClick,
      nodeClickEvent,
      selectedNodeId,
      repulsion = 800,
      linkDistance = 100,
      nodeSpacing = 28,
      linkOpacity = 0.18,
      layout = "force",
      isLoading = false,
      error,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const canvasRef = useRef(null);
      const animRef = useRef(0);
      const [zoom, setZoom] = useState(1);
      const [offset, setOffset] = useState({ x: 0, y: 0 });
      const zoomRef = useRef(zoom);
      zoomRef.current = zoom;
      const offsetRef = useRef(offset);
      offsetRef.current = offset;
      const [hoveredNode, setHoveredNode] = useState(null);
      const nodesRef = useRef([]);
      const laidOutRef = useRef(false);
      const [, forceUpdate] = useState(0);
      const [logicalW, setLogicalW] = useState(800);
      const hasProposed = useMemo(() => propNodes.some((n) => n.mark?.kind === "proposed"), [propNodes]);
      const [pulseTick, setPulseTick] = useState(0);
      useEffect(() => {
        if (!hasProposed) return;
        let raf = 0;
        const loop = () => {
          setPulseTick((t2) => (t2 + 1) % 1e6);
          raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => cancelAnimationFrame(raf);
      }, [hasProposed]);
      useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || typeof ResizeObserver === "undefined") return;
        const measure = () => {
          const width = Math.round(canvas.clientWidth);
          if (width > 0) setLogicalW(width);
        };
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(canvas);
        return () => ro.disconnect();
      }, []);
      const interactionRef = useRef({
        mode: "none",
        dragNodeId: null,
        pressedNodeId: null,
        startMouse: { x: 0, y: 0 },
        startOffset: { x: 0, y: 0 },
        downPos: { x: 0, y: 0 }
      });
      const toCoords = useCallback(
        (e) => {
          const canvas = canvasRef.current;
          if (!canvas) return null;
          const rect = canvas.getBoundingClientRect();
          const screenX = e.clientX - rect.left;
          const screenY = e.clientY - rect.top;
          return {
            screenX,
            screenY,
            graphX: (screenX - offset.x) / zoom,
            graphY: (screenY - offset.y) / zoom
          };
        },
        [offset, zoom]
      );
      const nodeAt = useCallback((graphX, graphY) => {
        return nodesRef.current.find((n) => {
          const dist = Math.sqrt((n.x - graphX) ** 2 + (n.y - graphY) ** 2);
          return dist < (n.size || 8) + 4;
        });
      }, []);
      const handleAction = useCallback(
        (action) => {
          if (action.event) {
            eventBus.emit(`UI:${action.event}`, {});
          }
        },
        [eventBus]
      );
      const handleNodeClick = useCallback(
        (node) => {
          if (nodeClickEvent) {
            eventBus.emit(`UI:${nodeClickEvent}`, { id: node.id, row: node });
          }
          onNodeClick?.(node);
        },
        [nodeClickEvent, eventBus, onNodeClick]
      );
      const groups = useMemo(
        () => [...new Set(propNodes.map((n) => n.group).filter(Boolean))],
        [propNodes]
      );
      const nodesKey = useMemo(() => propNodes.map((n) => n.id).join(""), [propNodes]);
      const edgesKey = useMemo(
        () => propEdges.map((e) => `${e.source}${e.target}`).join(""),
        [propEdges]
      );
      useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || propNodes.length === 0) return;
        const viewW = logicalW;
        const viewH = height;
        const layoutScale = Math.max(1, Math.min(3, Math.sqrt(propNodes.length / 12)));
        const w = viewW * layoutScale;
        const h = viewH * layoutScale;
        const labelFont = resolveColor3("var(--font-family)", canvas) || "system-ui";
        const clamp01 = (v) => Math.min(1, Math.max(0, v));
        const prevPos = /* @__PURE__ */ new Map();
        for (const pn of nodesRef.current) if (pn.x != null && pn.y != null) prevPos.set(pn.id, { x: pn.x, y: pn.y });
        const simNodes = propNodes.map((n, idx) => {
          const prev = prevPos.get(n.id);
          let x = prev?.x ?? n.x ?? 0;
          let y = prev?.y ?? n.y ?? 0;
          if (!prev && (!n.x || !n.y)) {
            if (layout === "circular") {
              const angle = idx / propNodes.length * 2 * Math.PI;
              const radius = Math.min(w, h) * 0.35;
              x = w / 2 + radius * Math.cos(angle);
              y = h / 2 + radius * Math.sin(angle);
            } else if (layout === "grid") {
              const cols = Math.ceil(Math.sqrt(propNodes.length));
              const gapX = w / (cols + 1);
              const gapY = h / (Math.ceil(propNodes.length / cols) + 1);
              x = gapX * (idx % cols + 1);
              y = gapY * (Math.floor(idx / cols) + 1);
            } else {
              const rand = mulberry32(hashSeed(n.id));
              x = w * 0.2 + rand() * w * 0.6;
              y = h * 0.2 + rand() * h * 0.6;
            }
          }
          return { ...n, x, y, vx: 0, vy: 0 };
        });
        nodesRef.current = simNodes;
        const prevIds = /* @__PURE__ */ new Set([...prevPos.keys()]);
        const newIdList = simNodes.map((n) => n.id);
        const kept = newIdList.filter((id) => prevIds.has(id)).length;
        const overlap = prevIds.size === 0 ? 0 : kept / Math.max(prevIds.size, newIdList.length);
        const fullRelayout = !laidOutRef.current || overlap < 0.5;
        if (layout === "force") {
          if (fullRelayout) {
            const LABEL_GAP = 12;
            const LABEL_H = 16;
            for (const n of simNodes) n.labelW = showLabels && n.label ? measureLabelWidth(truncateLabel(n.label), labelFont) : 0;
            const SIMILARITY_NEIGHBORS = 5;
            const SIMILARITY_MIN_WEIGHT = 0.25;
            const drawnPairs = /* @__PURE__ */ new Set();
            for (const edge of propEdges) drawnPairs.add(edgeKeyOf(edge.source, edge.target));
            const similarityNeighbors = /* @__PURE__ */ new Map();
            const bySource = /* @__PURE__ */ new Map();
            for (const pair of propSimilarity) {
              if (pair.weight < SIMILARITY_MIN_WEIGHT) continue;
              if (drawnPairs.has(edgeKeyOf(pair.source, pair.target))) continue;
              const arr = bySource.get(pair.source) ?? [];
              arr.push(pair);
              bySource.set(pair.source, arr);
            }
            for (const [id, arr] of bySource) {
              arr.sort((a, b) => b.weight - a.weight);
              similarityNeighbors.set(id, new Set(arr.slice(0, SIMILARITY_NEIGHBORS).map((p) => p.target)));
            }
            const activeSimilarity = propSimilarity.filter((pair) => {
              if (drawnPairs.has(edgeKeyOf(pair.source, pair.target))) return false;
              const a = similarityNeighbors.get(pair.source);
              const b = similarityNeighbors.get(pair.target);
              return (a?.has(pair.target) ?? false) || (b?.has(pair.source) ?? false);
            });
            const groupTarget = /* @__PURE__ */ new Map();
            const multiCluster = groups.length > 1;
            if (multiCluster) {
              const ring = Math.min(w, h) * 0.34;
              groups.forEach((g, i) => {
                const a = i / groups.length * 2 * Math.PI;
                groupTarget.set(g, { x: w / 2 + ring * Math.cos(a), y: h / 2 + ring * Math.sin(a) });
              });
            }
            const present = new Set(simNodes.map((n) => n.id));
            const edgeLinks = propEdges.filter((e) => present.has(e.source) && present.has(e.target)).map((e) => ({ source: e.source, target: e.target, weight: clamp01(e.weight ?? 1) }));
            const simLinks = activeSimilarity.filter((p) => present.has(p.source) && present.has(p.target)).map((p) => ({ source: p.source, target: p.target, weight: clamp01(p.weight) }));
            const collideRadius = (n) => Math.max(n.size || 8, (n.labelW ?? 0) / 2) + nodeSpacing / 2;
            const simulation = forceSimulation(simNodes).force("edge", forceLink(edgeLinks).id((d) => d.id).distance((l) => linkDistance * (0.35 + (1 - l.weight) * 0.3)).strength(0.9)).force("similarity", forceLink(simLinks).id((d) => d.id).distance((l) => linkDistance * (1.35 - 0.55 * l.weight)).strength(0.03)).force("charge", forceManyBody().strength(-repulsion * 0.5)).force("collide", forceCollide().radius(collideRadius).strength(0.9)).force("x", forceX((n) => groupTarget.get(n.group ?? "")?.x ?? w / 2).strength((n) => multiCluster && n.group ? GROUP_GRAVITY : UNGROUPED_GRAVITY)).force("y", forceY((n) => groupTarget.get(n.group ?? "")?.y ?? h / 2).strength((n) => multiCluster && n.group ? GROUP_GRAVITY : UNGROUPED_GRAVITY)).stop();
            for (let i = 0; i < 300; i++) simulation.tick();
            const pad = nodeSpacing / 2;
            const rectsOf = (n) => {
              const r = n.size || 8;
              const lw = showLabels ? n.labelW ?? 0 : 0;
              return {
                circle: [n.x - r - pad, n.y - r - pad, n.x + r + pad, n.y + r + pad],
                label: [n.x - lw / 2 - pad, n.y + r + LABEL_GAP - 8, n.x + lw / 2 + pad, n.y + r + LABEL_GAP + LABEL_H]
              };
            };
            const sep = (r1, r2) => {
              const ox = Math.min(r1[2], r2[2]) - Math.max(r1[0], r2[0]);
              const oy = Math.min(r1[3], r2[3]) - Math.max(r1[1], r2[1]);
              if (ox <= 0 || oy <= 0) return null;
              return ox <= oy ? { axis: "x", depth: ox, sign: r1[0] + r1[2] < r2[0] + r2[2] ? 1 : -1 } : { axis: "y", depth: oy, sign: r1[1] + r1[3] < r2[1] + r2[3] ? 1 : -1 };
            };
            for (let pass = 0; pass < 24; pass++) {
              let moved = false;
              for (let i = 0; i < simNodes.length; i++) {
                for (let j = i + 1; j < simNodes.length; j++) {
                  const a = simNodes[i];
                  const b = simNodes[j];
                  const ra = rectsOf(a);
                  const rb = rectsOf(b);
                  let best = null;
                  for (const [r1, r2] of [[ra.circle, rb.circle], [ra.circle, rb.label], [ra.label, rb.circle], [ra.label, rb.label]]) {
                    const s = sep(r1, r2);
                    if (s && (!best || s.depth < best.depth)) best = s;
                  }
                  if (best) {
                    moved = true;
                    const push = best.depth / 2;
                    if (best.axis === "x") {
                      a.x = Math.max(30, Math.min(w - 30, a.x - push * best.sign));
                      b.x = Math.max(30, Math.min(w - 30, b.x + push * best.sign));
                    } else {
                      a.y = Math.max(30, Math.min(h - 30, a.y - push * best.sign));
                      b.y = Math.max(30, Math.min(h - 30, b.y + push * best.sign));
                    }
                  }
                }
              }
              if (!moved) break;
            }
            const fitPad = 40;
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
            for (const node of nodesRef.current) {
              const r = node.size || 8;
              const lw = showLabels ? node.labelW ?? 0 : 0;
              minX = Math.min(minX, node.x - r, node.x - lw / 2);
              minY = Math.min(minY, node.y - r);
              maxX = Math.max(maxX, node.x + r, node.x + lw / 2);
              maxY = Math.max(maxY, node.y + r + LABEL_GAP + LABEL_H);
            }
            const bboxW = Math.max(1, maxX - minX + fitPad * 2);
            const bboxH = Math.max(1, maxY - minY + fitPad * 2);
            const nextZoom = Math.min(1, viewW / bboxW, viewH / bboxH);
            setZoom(nextZoom);
            setOffset({ x: fitPad - minX * nextZoom, y: fitPad - minY * nextZoom });
            laidOutRef.current = true;
          } else {
            const centroids = /* @__PURE__ */ new Map();
            for (const node of simNodes) {
              if (!prevPos.has(node.id)) continue;
              const g = node.group ?? "__none__";
              let c = centroids.get(g);
              if (!c) {
                c = { x: 0, y: 0, n: 0 };
                centroids.set(g, c);
              }
              c.x += node.x;
              c.y += node.y;
              c.n += 1;
            }
            const ringCount = /* @__PURE__ */ new Map();
            for (const node of simNodes) {
              if (prevPos.has(node.id)) continue;
              const g = node.group ?? "__none__";
              const c = centroids.get(g);
              const cx = c && c.n > 0 ? c.x / c.n : w / 2;
              const cy = c && c.n > 0 ? c.y / c.n : h / 2;
              const k = ringCount.get(g) ?? 0;
              ringCount.set(g, k + 1);
              const angle = k * 2.399963;
              const r = 22 + k * 8;
              node.x = Math.max(30, Math.min(w - 30, cx + r * Math.cos(angle)));
              node.y = Math.max(30, Math.min(h - 30, cy + r * Math.sin(angle)));
            }
          }
          forceUpdate((n) => n + 1);
        } else {
          forceUpdate((n) => n + 1);
        }
        return () => {
          cancelAnimationFrame(animRef.current);
        };
      }, [nodesKey, edgesKey, propSimilarity, layout, repulsion, linkDistance, nodeSpacing, showLabels]);
      useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        const w = logicalW;
        const h = height;
        const nodes = nodesRef.current;
        const accentColor = resolveColor3("var(--color-accent)", canvas);
        const fontFamily = resolveColor3("var(--font-family)", canvas) || "system-ui";
        const fgColor = resolveColor3("var(--color-foreground)", canvas);
        const mutedColor = resolveColor3("var(--color-muted-foreground)", canvas) || fgColor;
        const bgColor = resolveColor3("var(--color-background)", canvas) || "#ffffff";
        const accentFg = resolveColor3("var(--color-accent-foreground)", canvas) || "#ffffff";
        const dpr = typeof window !== "undefined" && window.devicePixelRatio || 1;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);
        ctx.save();
        ctx.translate(offset.x, offset.y);
        ctx.scale(zoom, zoom);
        const neighbors = /* @__PURE__ */ new Set();
        if (hoveredNode) {
          neighbors.add(hoveredNode);
          for (const edge of propEdges) {
            if (edge.source === hoveredNode) neighbors.add(String(edge.target));
            else if (edge.target === hoveredNode) neighbors.add(String(edge.source));
          }
        }
        for (const edge of propEdges) {
          const source = nodes.find((n) => n.id === edge.source);
          const target = nodes.find((n) => n.id === edge.target);
          if (!source || !target) continue;
          const incident = !!hoveredNode && (edge.source === hoveredNode || edge.target === hoveredNode);
          const w2 = edge.weight ?? 1;
          ctx.globalAlpha = hoveredNode ? incident ? 1 : 0.05 : linkOpacity * w2;
          ctx.beginPath();
          ctx.moveTo(source.x, source.y);
          ctx.lineTo(target.x, target.y);
          ctx.strokeStyle = incident ? accentColor : edge.color || "#888888";
          ctx.lineWidth = incident ? 2 : Math.max(0.75, w2);
          ctx.stroke();
          if (edge.label && showLabels) {
            const mx = (source.x + target.x) / 2;
            const my = (source.y + target.y) / 2;
            ctx.fillStyle = mutedColor;
            ctx.font = `9px ${fontFamily}`;
            ctx.textAlign = "center";
            ctx.textBaseline = "alphabetic";
            ctx.fillText(edge.label, mx, my - 4);
          }
        }
        ctx.globalAlpha = 1;
        ctx.setLineDash([4, 4]);
        for (const edge of proposedEdges) {
          const source = nodes.find((n) => n.id === edge.source);
          const target = nodes.find((n) => n.id === edge.target);
          if (!source || !target) continue;
          ctx.globalAlpha = 0.4;
          ctx.beginPath();
          ctx.moveTo(source.x, source.y);
          ctx.lineTo(target.x, target.y);
          ctx.strokeStyle = edge.color || mutedColor;
          ctx.lineWidth = 1;
          ctx.stroke();
        }
        ctx.setLineDash([]);
        ctx.globalAlpha = 1;
        for (const node of nodes) {
          const size = node.size || 8;
          const color = resolveColor3(node.color || getGroupColor(node.group, groups), canvas);
          const isHovered = hoveredNode === node.id;
          const isSelected = selectedNodeId !== void 0 && node.id === selectedNodeId;
          const mark = node.mark;
          ctx.globalAlpha = hoveredNode && !neighbors.has(node.id) ? 0.2 : mark?.kind === "proposed" ? 0.55 : 1;
          const radius = isSelected ? size + 4 : isHovered ? size + 2 : size;
          ctx.beginPath();
          ctx.arc(node.x, node.y, radius, 0, Math.PI * 2);
          ctx.fillStyle = mark?.kind === "proposed" ? mutedColor : color;
          ctx.fill();
          if (mark?.kind === "proposed") {
            ctx.setLineDash([3, 3]);
            ctx.strokeStyle = resolveColor3(mark.tint ?? "var(--color-warning)", canvas);
            ctx.lineWidth = 1.5;
          } else if (isSelected) {
            ctx.strokeStyle = accentColor;
            ctx.lineWidth = 3;
          } else {
            ctx.strokeStyle = isHovered ? "#ffffff" : "#00000020";
            ctx.lineWidth = isHovered ? 2 : 1;
          }
          ctx.stroke();
          ctx.setLineDash([]);
          if (mark?.kind === "suggested") {
            ctx.beginPath();
            ctx.arc(node.x, node.y, radius + 3, 0, Math.PI * 2);
            ctx.strokeStyle = accentColor;
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(node.x + radius * 0.7, node.y - radius * 0.7, 2.5, 0, Math.PI * 2);
            ctx.fillStyle = accentColor;
            ctx.fill();
          } else if (mark?.kind === "proposed") {
            const phase = pulseTick % 60 / 60;
            const baseAlpha = hoveredNode && !neighbors.has(node.id) ? 0.2 : 0.55;
            ctx.globalAlpha = baseAlpha * (0.4 + 0.4 * (1 - Math.abs(phase * 2 - 1)));
            ctx.beginPath();
            ctx.arc(node.x, node.y, radius + 6 + Math.sin(phase * Math.PI * 2) * 3, 0, Math.PI * 2);
            ctx.strokeStyle = resolveColor3(mark.tint ?? "var(--color-warning)", canvas);
            ctx.lineWidth = 1.5;
            ctx.stroke();
            ctx.globalAlpha = baseAlpha;
          }
          if (showLabels && node.label) {
            const displayLabel = truncateLabel(node.label);
            ctx.font = `${isSelected || isHovered ? "700" : "600"} 12px ${fontFamily}`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            const ly = node.y + radius + 14;
            ctx.lineWidth = 4;
            ctx.lineJoin = "round";
            ctx.strokeStyle = bgColor;
            ctx.strokeText(displayLabel, node.x, ly);
            ctx.fillStyle = fgColor;
            ctx.fillText(displayLabel, node.x, ly);
          }
          if (node.badge && node.badge > 1) {
            const bx = node.x + radius * 0.7;
            const by = node.y - radius * 0.7;
            const br = Math.max(7, Math.min(11, radius * 0.45));
            ctx.beginPath();
            ctx.arc(bx, by, br, 0, Math.PI * 2);
            ctx.fillStyle = accentColor;
            ctx.fill();
            ctx.strokeStyle = bgColor;
            ctx.lineWidth = 2;
            ctx.stroke();
            ctx.fillStyle = accentFg;
            ctx.font = `600 9px ${fontFamily}`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(String(node.badge), bx, by + 0.5);
          }
        }
        ctx.restore();
      });
      const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z * 1.2, 3)), []);
      const handleZoomOut = useCallback(() => setZoom((z) => Math.max(z / 1.2, 0.3)), []);
      const handleReset = useCallback(() => {
        setZoom(1);
        setOffset({ x: 0, y: 0 });
      }, []);
      const applyZoom = useCallback((factor, cx, cy) => {
        if (!interactive) return;
        const oldZoom = zoomRef.current;
        const newZoom = Math.max(0.3, Math.min(3, oldZoom * factor));
        if (newZoom === oldZoom) return;
        const o = offsetRef.current;
        setOffset({
          x: cx - (cx - o.x) * (newZoom / oldZoom),
          y: cy - (cy - o.y) * (newZoom / oldZoom)
        });
        setZoom(newZoom);
      }, [interactive]);
      const applyPanDelta = useCallback((dx, dy) => {
        if (!interactive) return;
        setOffset((o) => ({ x: o.x + dx, y: o.y + dy }));
      }, [interactive]);
      const cancelSinglePointer = useCallback(() => {
        interactionRef.current.mode = "none";
        interactionRef.current.dragNodeId = null;
        interactionRef.current.pressedNodeId = null;
      }, []);
      const handlePointerDown = useCallback(
        (e) => {
          const coords = toCoords(e);
          if (!coords) return;
          const node = nodeAt(coords.graphX, coords.graphY);
          const state = interactionRef.current;
          state.downPos = { x: e.clientX, y: e.clientY };
          state.startMouse = { x: e.clientX, y: e.clientY };
          state.startOffset = { ...offset };
          state.pressedNodeId = node?.id ?? null;
          if (draggable && node) {
            state.mode = "dragging";
            state.dragNodeId = node.id;
          } else if (interactive) {
            state.mode = "panning";
            state.dragNodeId = null;
          } else {
            state.mode = "none";
            state.dragNodeId = null;
          }
        },
        [toCoords, nodeAt, draggable, interactive, offset]
      );
      const handlePointerMove = useCallback(
        (e) => {
          const state = interactionRef.current;
          if (state.mode === "panning") {
            const dx = e.clientX - state.startMouse.x;
            const dy = e.clientY - state.startMouse.y;
            setOffset({ x: state.startOffset.x + dx, y: state.startOffset.y + dy });
            return;
          }
          if (state.mode === "dragging" && state.dragNodeId) {
            const coords2 = toCoords(e);
            if (!coords2) return;
            const node2 = nodesRef.current.find((n) => n.id === state.dragNodeId);
            if (node2) {
              node2.x = coords2.graphX;
              node2.y = coords2.graphY;
              node2.vx = 0;
              node2.vy = 0;
              forceUpdate((n) => n + 1);
            }
            return;
          }
          const coords = toCoords(e);
          if (!coords) return;
          const node = nodeAt(coords.graphX, coords.graphY);
          setHoveredNode(node?.id ?? null);
        },
        [toCoords, nodeAt]
      );
      const handlePointerUp = useCallback(
        (e) => {
          const state = interactionRef.current;
          const moved = Math.abs(e.clientX - state.downPos.x) + Math.abs(e.clientY - state.downPos.y);
          state.mode = "none";
          state.dragNodeId = null;
          if (moved < 4) {
            const coords = toCoords(e);
            if (!coords) return;
            const node = (state.pressedNodeId ? nodesRef.current.find((n) => n.id === state.pressedNodeId) : void 0) ?? nodeAt(coords.graphX, coords.graphY);
            state.pressedNodeId = null;
            if (node) {
              if (node.badge && node.badge > 1 && onBadgeClick) {
                const r = (node.size || 8) + (selectedNodeId === node.id ? 4 : 0);
                const bx = node.x + r * 0.7;
                const by = node.y - r * 0.7;
                const br = Math.max(7, Math.min(11, r * 0.45)) + 3;
                if (Math.hypot(coords.graphX - bx, coords.graphY - by) <= br) {
                  onBadgeClick(node);
                  return;
                }
              }
              if (node.mark && onMarkClick) {
                onMarkClick(node);
                return;
              }
              handleNodeClick(node);
            }
          }
        },
        [toCoords, nodeAt, handleNodeClick, onBadgeClick, onMarkClick, selectedNodeId]
      );
      const handlePointerLeave = useCallback(() => {
        setHoveredNode(null);
        interactionRef.current.pressedNodeId = null;
      }, []);
      const gestureHandlers = useCanvasGestures({
        canvasRef,
        enabled: interactive || draggable,
        onPointerDown: handlePointerDown,
        onPointerMove: handlePointerMove,
        onPointerUp: handlePointerUp,
        onZoom: applyZoom,
        onPanDelta: applyPanDelta,
        onMultiTouchStart: cancelSinglePointer
      });
      const wheelHandler = gestureHandlers.onWheel;
      useEffect(() => {
        const el = canvasRef.current;
        if (!el) return;
        el.addEventListener("wheel", wheelHandler, { passive: false });
        return () => el.removeEventListener("wheel", wheelHandler);
      }, [wheelHandler]);
      const handleDoubleClick = useCallback(
        (e) => {
          const coords = toCoords(e);
          if (!coords) return;
          const node = nodeAt(coords.graphX, coords.graphY);
          if (node) onNodeDoubleClick?.(node);
        },
        [toCoords, nodeAt, onNodeDoubleClick]
      );
      const hoveredObj = hoveredNode ? nodesRef.current.find((n) => n.id === hoveredNode) : void 0;
      const canvasEl = canvasRef.current;
      const showLabelTooltip = Boolean(
        hoveredObj?.label && hoveredObj.label.length > MAX_LABEL_CHARS && hoveredObj.x != null && canvasEl
      );
      const labelTooltipStyle = (() => {
        if (!showLabelTooltip || !canvasEl || !hoveredObj || hoveredObj.x == null || hoveredObj.y == null) return void 0;
        const rect = canvasEl.getBoundingClientRect();
        return {
          left: rect.left + offset.x + hoveredObj.x * zoom,
          top: rect.top + offset.y + hoveredObj.y * zoom - 10,
          transform: "translate(-50%, -100%)"
        };
      })();
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.graphError"),
            message: error.message,
            className
          }
        );
      }
      if (propNodes.length === 0) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            title: t("display.noGraphData"),
            description: "No nodes to display.",
            className
          }
        );
      }
      return /* @__PURE__ */ jsx(Card, { className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
        (title || actions && actions.length > 0 || interactive) && /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            align: "center",
            justify: "between",
            className: "px-4 py-2 border-b border-border",
            children: [
              title && /* @__PURE__ */ jsx(Typography, { variant: "h6", weight: "semibold", children: title }),
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                interactive && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomOut, onClick: handleZoomOut }),
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomIn, onClick: handleZoomIn }),
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: RotateCcw, onClick: handleReset })
                ] }),
                actions?.map((action, idx) => /* @__PURE__ */ jsx(
                  Badge,
                  {
                    variant: "default",
                    className: "cursor-pointer hover:opacity-80 transition-opacity",
                    onClick: () => handleAction(action),
                    children: action.label
                  },
                  idx
                ))
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "w-full bg-background", children: [
          /* @__PURE__ */ jsx(
            "canvas",
            {
              ref: canvasRef,
              width: Math.round(logicalW * (typeof window !== "undefined" && window.devicePixelRatio || 1)),
              height: Math.round(height * (typeof window !== "undefined" && window.devicePixelRatio || 1)),
              className: "w-full cursor-grab active:cursor-grabbing touch-none",
              style: { height },
              onPointerDown: gestureHandlers.onPointerDown,
              onPointerMove: gestureHandlers.onPointerMove,
              onPointerUp: gestureHandlers.onPointerUp,
              onPointerCancel: gestureHandlers.onPointerCancel,
              onPointerLeave: handlePointerLeave,
              onDoubleClick: handleDoubleClick
            }
          ),
          typeof window !== "undefined" && showLabelTooltip && labelTooltipStyle && createPortal(
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "fixed z-50 px-3 py-2 max-w-xs",
                  "bg-primary text-primary-foreground",
                  "shadow-elevation-popover rounded-sm",
                  "text-sm pointer-events-none",
                  "break-words whitespace-normal"
                ),
                style: labelTooltipStyle,
                role: "tooltip",
                children: hoveredObj?.label
              }
            ),
            getOrCreatePortalRoot()
          )
        ] }),
        groups.length > 1 && /* @__PURE__ */ jsx(HStack, { gap: "md", className: "px-4 py-2 border-t border-border", wrap: true, children: groups.map((group, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "w-3 h-3 rounded-full flex-shrink-0",
              style: { backgroundColor: GROUP_COLORS2[idx % GROUP_COLORS2.length] }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: group })
        ] }, group)) })
      ] }) });
    };
    GraphCanvas.displayName = "GraphCanvas";
  }
});
var ImportSourcePicker;
var init_ImportSourcePicker = __esm({
  "components/core/molecules/import/ImportSourcePicker.tsx"() {
    "use client";
    init_Box();
    init_Icon();
    init_Typography();
    init_cn();
    ImportSourcePicker = ({
      sources,
      onSelect,
      onFilesSelected,
      title,
      moreSources,
      className
    }) => {
      const fileInputRef = useRef(null);
      const handlePick = (source) => {
        if (source.disabled) return;
        if (source.kind === "file") {
          const input = fileInputRef.current;
          if (!input) return;
          input.accept = source.accept ?? "";
          input.multiple = source.multiple ?? false;
          input.click();
          return;
        }
        onSelect?.(source.id);
      };
      const handleFiles = (event) => {
        const files = event.target.files ? Array.from(event.target.files) : [];
        event.target.value = "";
        if (files.length > 0) onFilesSelected?.(files);
      };
      return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col gap-2", className), children: [
        title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
        sources.map((source) => /* @__PURE__ */ jsxs(
          Box,
          {
            role: "button",
            tabIndex: source.disabled ? -1 : 0,
            "aria-disabled": source.disabled,
            onClick: () => handlePick(source),
            onKeyDown: (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handlePick(source);
              }
            },
            className: cn(
              "flex items-center gap-3 rounded-md border border-border bg-card px-4 py-3 text-left",
              source.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-accent hover:text-accent-foreground"
            ),
            children: [
              source.icon ? /* @__PURE__ */ jsx(Icon, { icon: source.icon, size: "md" }) : null,
              /* @__PURE__ */ jsxs(Box, { className: "flex flex-col", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "label", children: source.label }),
                source.description ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: source.description }) : null
              ] })
            ]
          },
          source.id
        )),
        moreSources,
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: fileInputRef,
            type: "file",
            className: "hidden",
            onChange: handleFiles,
            "data-testid": "import-source-file-input"
          }
        )
      ] });
    };
  }
});
function formatFieldValue(value) {
  if (value === null) return "\u2014";
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.map(formatFieldValue).join(", ");
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
function unitTitle(unit) {
  for (const key of TITLE_KEYS) {
    const value = unit.fields[key];
    if (typeof value === "string" && value.length > 0) return value;
  }
  return unit.ref;
}
function fieldSummary(unit) {
  return Object.entries(unit.fields).filter(([key]) => !TITLE_KEYS.includes(key)).map(([key, value]) => `${key}: ${formatFieldValue(value)}`).join(" \xB7 ");
}
var TITLE_KEYS, ImportPreviewTree;
var init_ImportPreviewTree = __esm({
  "components/core/molecules/import/ImportPreviewTree.tsx"() {
    "use client";
    init_Box();
    init_Badge();
    init_Button();
    init_Icon();
    init_Typography();
    init_cn();
    TITLE_KEYS = ["title", "name", "label"];
    ImportPreviewTree = ({
      units,
      skipped = [],
      entityDisplay,
      onConfirm,
      onCancel,
      confirmLabel = "Confirm import",
      cancelLabel = "Cancel",
      indent = 16,
      className
    }) => {
      const groups = /* @__PURE__ */ new Map();
      for (const unit of units) {
        const group = groups.get(unit.targetEntity);
        if (group) group.push(unit);
        else groups.set(unit.targetEntity, [unit]);
      }
      const renderUnit = (unit, childrenByParent, depth) => {
        const summary = fieldSummary(unit);
        const children = childrenByParent.get(unit.ref) ?? [];
        return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              className: "flex flex-col py-1",
              style: { paddingLeft: depth * indent },
              "data-testid": `import-preview-unit-${unit.ref}`,
              children: [
                /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ jsx(Icon, { icon: "file-text", size: "xs", className: "text-muted-foreground" }),
                  /* @__PURE__ */ jsx(Typography, { variant: "body2", children: unitTitle(unit) })
                ] }),
                summary ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: summary }) : null
              ]
            }
          ),
          children.map((child) => renderUnit(child, childrenByParent, depth + 1))
        ] }, unit.ref);
      };
      return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col gap-4", className), children: [
        units.length === 0 ? /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-muted-foreground", children: "No units staged." }) : null,
        Array.from(groups.entries()).map(([entity, groupUnits]) => {
          const refs = new Set(groupUnits.map((unit) => unit.ref));
          const childrenByParent = /* @__PURE__ */ new Map();
          const roots = [];
          for (const unit of groupUnits) {
            if (unit.parentRef && refs.has(unit.parentRef)) {
              const siblings = childrenByParent.get(unit.parentRef);
              if (siblings) siblings.push(unit);
              else childrenByParent.set(unit.parentRef, [unit]);
            } else {
              roots.push(unit);
            }
          }
          const label = entityDisplay[entity]?.plural ?? entity;
          return /* @__PURE__ */ jsxs(Box, { border: true, className: "rounded-md border-border bg-card p-3", children: [
            /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 pb-2", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "label", children: label }),
              /* @__PURE__ */ jsx(Badge, { amount: groupUnits.length })
            ] }),
            roots.map((unit) => renderUnit(unit, childrenByParent, 0))
          ] }, entity);
        }),
        skipped.length > 0 ? /* @__PURE__ */ jsxs(Box, { border: true, className: "rounded-md border-border bg-card p-3", children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 pb-2", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "label", children: "Skipped" }),
            /* @__PURE__ */ jsx(Badge, { amount: skipped.length })
          ] }),
          skipped.map((element) => /* @__PURE__ */ jsxs(Box, { className: "flex items-baseline gap-2 py-1", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: element.ref }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: element.reason })
          ] }, element.ref))
        ] }) : null,
        onConfirm || onCancel ? /* @__PURE__ */ jsxs(Box, { className: "flex items-center justify-end gap-2", children: [
          onCancel ? /* @__PURE__ */ jsx(Button, { variant: "default", label: cancelLabel, onClick: onCancel }) : null,
          onConfirm ? /* @__PURE__ */ jsx(Button, { variant: "primary", label: confirmLabel, onClick: onConfirm }) : null
        ] }) : null
      ] });
    };
  }
});
var PIPELINE, DEFAULT_LABELS, ImportProgress;
var init_ImportProgress = __esm({
  "components/core/molecules/import/ImportProgress.tsx"() {
    "use client";
    init_Box();
    init_Badge();
    init_Icon();
    init_Typography();
    init_cn();
    PIPELINE = [
      "fetching",
      "mapping",
      "reviewing",
      "committing"
    ];
    DEFAULT_LABELS = {
      fetching: "Fetching",
      mapping: "Mapping",
      reviewing: "Reviewing",
      committing: "Committing",
      done: "Done",
      failed: "Failed"
    };
    ImportProgress = ({
      step,
      counts,
      labels,
      className
    }) => {
      const label = (key) => labels?.[key] ?? DEFAULT_LABELS[key];
      const currentIndex = step === "done" || step === "failed" ? PIPELINE.length : PIPELINE.indexOf(step);
      return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col gap-3", className), children: [
        /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
          PIPELINE.map((key, index) => {
            const isComplete = index < currentIndex;
            const isActive = index === currentIndex;
            return /* @__PURE__ */ jsxs(React79__default.Fragment, { children: [
              index > 0 ? /* @__PURE__ */ jsx(Box, { className: "h-px w-4 bg-border" }) : null,
              /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1", "data-testid": `import-progress-step-${key}`, children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    icon: isComplete ? "check" : isActive ? "loader" : "circle",
                    size: "sm",
                    className: cn(
                      isComplete ? "text-success" : isActive ? "text-primary" : "text-muted-foreground"
                    )
                  }
                ),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    className: cn(isActive ? "text-foreground" : "text-muted-foreground"),
                    children: label(key)
                  }
                )
              ] })
            ] }, key);
          }),
          step === "done" || step === "failed" ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Box, { className: "h-px w-4 bg-border" }),
            /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1", "data-testid": `import-progress-step-${step}`, children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  icon: step === "done" ? "check" : "x",
                  size: "sm",
                  className: step === "done" ? "text-success" : "text-error"
                }
              ),
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: step === "done" ? "text-success" : "text-error",
                  children: label(step)
                }
              )
            ] })
          ] }) : null
        ] }),
        counts ? /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
          counts.staged !== void 0 ? /* @__PURE__ */ jsx(Badge, { label: `Staged ${counts.staged}` }) : null,
          counts.committed !== void 0 ? /* @__PURE__ */ jsx(Badge, { variant: "success", label: `Committed ${counts.committed}` }) : null,
          counts.failed !== void 0 ? /* @__PURE__ */ jsx(Badge, { variant: "danger", label: `Failed ${counts.failed}` }) : null
        ] }) : null
      ] });
    };
  }
});

// components/core/molecules/import/index.ts
var init_import = __esm({
  "components/core/molecules/import/index.ts"() {
    init_ImportSourcePicker();
    init_ImportPreviewTree();
    init_ImportProgress();
  }
});
var ReflectionBlock;
var init_ReflectionBlock = __esm({
  "components/core/molecules/ReflectionBlock.tsx"() {
    "use client";
    init_useEventBus();
    init_cn();
    ReflectionBlock = ({
      prompt,
      index,
      savedNote,
      saveEvent = "SAVE_REFLECTION",
      className
    }) => {
      const [note, setNote] = useState(savedNote ?? "");
      const [isExpanded, setIsExpanded] = useState(false);
      const { emit } = useEventBus();
      const handleSave = () => {
        emit(`UI:${saveEvent}`, { index, note });
        setIsExpanded(false);
      };
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "my-6 border-l-4 border-warning bg-warning/10 rounded-r-lg p-4",
            className
          ),
          children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
            /* @__PURE__ */ jsx(PauseCircle, { className: "text-warning flex-shrink-0 mt-1", size: 20 }),
            /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
              /* @__PURE__ */ jsx("div", { className: "font-medium text-warning mb-2", children: "Pause & Reflect" }),
              /* @__PURE__ */ jsx("p", { className: "text-foreground text-sm mb-3", children: prompt }),
              isExpanded ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(
                  "textarea",
                  {
                    className: "w-full p-2 border border-input rounded text-sm bg-card text-foreground focus:ring-2 focus:ring-ring focus:border-transparent",
                    placeholder: "Your thoughts...",
                    value: note,
                    onChange: (e) => setNote(e.target.value),
                    rows: 2
                  }
                ),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    onClick: handleSave,
                    className: "mt-2 text-sm px-3 py-1 bg-warning text-warning-foreground rounded hover:opacity-90 transition-colors",
                    children: "Save & Continue"
                  }
                )
              ] }) : /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => setIsExpanded(true),
                  className: "text-sm text-warning hover:underline",
                  children: savedNote ? "\u2713 Answered \xB7 Edit" : "Answer this question"
                }
              )
            ] })
          ] })
        }
      );
    };
    ReflectionBlock.displayName = "ReflectionBlock";
  }
});

// lib/parseLessonSegments.ts
function extractTagContent(content, tagName) {
  const closedTagRegex = new RegExp(`<${tagName}>([\\s\\S]*?)<\\/${tagName}>`, "i");
  const closedMatch = content.match(closedTagRegex);
  if (closedMatch) {
    return { content: closedMatch[1].trim(), fullMatch: closedMatch[0] };
  }
  const unclosedTagRegex = new RegExp(
    `<${tagName}>([\\s\\S]*?)(?=<(?:activate|connect|reflect|bloom|prq|question|answer|visualize)|\\n\\n#|$)`,
    "i"
  );
  const unclosedMatch = content.match(unclosedTagRegex);
  if (unclosedMatch) {
    return { content: unclosedMatch[1].trim(), fullMatch: unclosedMatch[0] };
  }
  return null;
}
function parseLessonSegments(lesson) {
  if (!lesson) return [];
  let content = lesson.replace(/<prq>[\s\S]*?<\/prq>/gi, "").trim();
  const segments = [];
  const activateResult = extractTagContent(content, "activate");
  if (activateResult) {
    segments.push({ type: "activate", question: activateResult.content });
    content = content.replace(activateResult.fullMatch, "").trim();
  }
  const connectResult = extractTagContent(content, "connect");
  if (connectResult) {
    segments.push({ type: "connect", content: connectResult.content });
    content = content.replace(connectResult.fullMatch, "").trim();
  }
  const tagRegex = new RegExp(
    '(?<reflect><reflect>(?<reflectClosed>[\\s\\S]*?)<\\/reflect>)|(?<reflectUnclosed><reflect>(?<reflectOpen>[\\s\\S]*?)(?=<(?:activate|connect|reflect|bloom|prq|question|answer|visualize)|\\n\\n#|$))|(?<bloom><bloom\\s+level="(?<bloomLevel>remember|understand|apply|analyze|evaluate|create)">(?<bloomClosed>[\\s\\S]*?)<\\/bloom>)|(?<bloomUnclosed><bloom\\s+level="(?<bloomLevelUn>remember|understand|apply|analyze|evaluate|create)">(?<bloomOpen>[\\s\\S]*?)(?=<(?:activate|connect|reflect|bloom|prq|question|answer|visualize)|\\n\\n#|$))|(?<quiz><question>(?<quizQuestion>[\\s\\S]*?)<\\/question>\\s*<answer>(?<quizAnswer>[\\s\\S]*?)<\\/answer>)|(?<visualize><visualize\\s+type="(?<vizType>algorithms|math|physics|biology|chemistry|probability)"\\s+description="(?<vizDesc>[^"]*?)"\\s*\\/?>)',
    "gi"
  );
  let lastIndex = 0;
  let match;
  while ((match = tagRegex.exec(content)) !== null) {
    const before = content.slice(lastIndex, match.index);
    if (before.trim()) {
      segments.push(...parseMarkdownWithCodeBlocks(before));
    }
    const g = match.groups ?? {};
    if (g.reflect || g.reflectUnclosed) {
      const prompt = (g.reflectClosed ?? g.reflectOpen ?? "").trim();
      if (prompt) segments.push({ type: "reflect", prompt });
    } else if (g.bloom || g.bloomUnclosed) {
      const level = g.bloomLevel ?? g.bloomLevelUn;
      const bloomContent = g.bloomClosed ?? g.bloomOpen ?? "";
      if (level && bloomContent) {
        const qMatch = bloomContent.match(/<question>([\s\S]*?)<\/question>/i);
        const aMatch = bloomContent.match(/<answer>([\s\S]*?)<\/answer>/i);
        if (qMatch && aMatch) {
          segments.push({ type: "bloom", level, question: qMatch[1].trim(), answer: aMatch[1].trim() });
        } else if (qMatch) {
          segments.push({ type: "bloom", level, question: qMatch[1].trim(), answer: "(Answer not provided)" });
        } else {
          const clean = bloomContent.replace(/^\*\*Question\s*\d*:?\*\*\s*/i, "").replace(/^\*\*Q\d*:?\*\*\s*/i, "").trim();
          if (clean) segments.push({ type: "bloom", level, question: clean, answer: "(See answers section below)" });
        }
      }
    } else if (g.quiz) {
      segments.push({ type: "quiz", question: g.quizQuestion.trim(), answer: g.quizAnswer.trim() });
    } else if (g.visualize) {
      segments.push({
        type: "visualization",
        visualizationType: g.vizType,
        description: g.vizDesc ?? ""
      });
    }
    lastIndex = tagRegex.lastIndex;
  }
  const remaining = content.slice(lastIndex);
  if (remaining.trim()) segments.push(...parseMarkdownWithCodeBlocks(remaining));
  return segments;
}
var init_parseLessonSegments = __esm({
  "lib/parseLessonSegments.ts"() {
    init_lessonSegmentUtils();
  }
});
var positionClasses, FloatingToolbar;
var init_FloatingToolbar = __esm({
  "components/core/molecules/FloatingToolbar.tsx"() {
    "use client";
    init_Button();
    init_Box();
    init_Divider();
    init_Typography();
    init_ButtonGroup();
    init_cn();
    init_useEventBus();
    positionClasses = {
      "bottom-center": "bottom-6 left-1/2 -translate-x-1/2",
      "bottom-left": "bottom-6 left-6",
      "bottom-right": "bottom-6 right-6",
      "top-center": "top-6 left-1/2 -translate-x-1/2",
      "top-left": "top-6 left-6",
      "top-right": "top-6 right-6"
    };
    FloatingToolbar = ({
      items,
      position = "bottom-center",
      children,
      className
    }) => {
      const eventBus = useEventBus();
      return /* @__PURE__ */ jsx(Box, { className: cn("fixed z-50", positionClasses[position]), children: /* @__PURE__ */ jsxs(
        ButtonGroup,
        {
          variant: "default",
          orientation: "horizontal",
          className: cn(
            "items-center gap-1 rounded-full border border-border",
            "bg-card/95 backdrop-blur-sm shadow-elevation-popover p-1",
            className
          ),
          children: [
            items.map((item) => /* @__PURE__ */ jsx(
              Button,
              {
                variant: item.active ? "primary" : "ghost",
                size: "sm",
                icon: item.icon,
                action: item.action,
                actionPayload: item.actionPayload,
                disabled: item.disabled,
                "aria-pressed": item.active,
                "aria-label": item.label,
                className: "rounded-full",
                "data-testid": item.testId ?? `floating-toolbar-item-${item.id}`,
                onClick: () => {
                  if (item.event) eventBus.emit(`UI:${item.event}`, { actionId: item.id });
                },
                children: /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: item.label })
              },
              item.id
            )),
            children && items.length > 0 && /* @__PURE__ */ jsx(Divider, { orientation: "vertical", className: "h-6 mx-1" }),
            children
          ]
        }
      ) });
    };
    FloatingToolbar.displayName = "FloatingToolbar";
  }
});

// components/core/molecules/index.ts
var init_molecules2 = __esm({
  "components/core/molecules/index.ts"() {
    init_ErrorBoundary();
    init_JsonTreeEditor();
    init_NodeSlotEditor();
    init_FileTree();
    init_FormField();
    init_EmptyState();
    init_LoadingState();
    init_ErrorState();
    init_Skeleton();
    init_Accordion();
    init_Alert();
    init_Breadcrumb();
    init_ButtonGroup();
    init_CommandPalette();
    init_FilterGroup();
    init_Card2();
    init_Container();
    init_Flex();
    init_FloatingActionButton();
    init_Grid();
    init_InputGroup();
    init_Menu();
    init_Modal();
    init_PageTransition();
    init_FxOverlay();
    init_Pagination();
    init_Popover();
    init_Coachmark();
    init_OnboardingSpotlight();
    init_RelationSelect();
    init_SearchInput();
    init_SidePanel();
    init_SimpleGrid();
    init_Tabs();
    init_Toast();
    init_Tooltip();
    init_Drawer();
    init_WizardProgress();
    init_WizardNavigation();
    init_MarkdownContent();
    init_CodeBlock();
    init_QuizBlock();
    init_ScaledDiagram();
    init_CalendarGrid();
    init_Gantt();
    init_RepeatableFormSection();
    init_ViolationAlert();
    init_FormSectionHeader();
    init_FlipCard();
    init_GridPicker();
    init_AssetPicker();
    init_IconPicker();
    init_EmojiPicker();
    init_DateRangePicker();
    init_DateRangeSelector();
    init_ChartLegend();
    init_LineChart();
    init_ProgressDots();
    init_molecules();
    init_MathCanvas();
    init_PhysicsCanvas();
    init_BiologyCanvas();
    init_ChemistryCanvas();
    init_AlgorithmCanvas();
    init_AlgoGraphCanvas();
    init_learningScene3D();
    init_GraphView();
    init_MapView();
    init_NumberStepper();
    init_StarRating();
    init_UploadDropZone();
    init_Lightbox();
    init_DataGrid();
    init_DataList();
    init_TableView();
    init_StatDisplay();
    init_Meter();
    init_SwipeableRow();
    init_SortableList();
    init_Carousel();
    init_PullToRefresh();
    init_InstallBox();
    init_FeatureCard();
    init_FeatureGrid();
    init_CTABanner();
    init_HeroSection();
    init_PricingCard();
    init_PricingGrid();
    init_StatsGrid();
    init_ServiceCatalog();
    init_CaseStudyCard();
    init_ArticleSection();
    init_SocialProof();
    init_StepFlow();
    init_SplitSection();
    init_TagCloud();
    init_TagInput();
    init_CommunityLinks();
    init_TeamCard();
    init_ShowcaseCard();
    init_GeometricPattern();
    init_EdgeDecoration();
    init_VoteStack();
    init_LikertScale();
    init_MatrixQuestion();
    init_QrScanner();
    init_OptionConstraintGroup();
    init_PositionedCanvas();
    init_RichTextEditor();
    init_DocumentPanel();
    init_DocumentDetails();
    init_ReplyTree();
    init_BranchingLogicBuilder();
    init_VersionDiff();
    init_DocBreadcrumb();
    init_DocPagination();
    init_DocSearch();
    init_DocSidebar();
    init_DocTOC();
    init_GradientDivider();
    init_MarketingFooter();
    init_PullQuote();
    init_BehaviorView();
    init_ModuleCard();
    init_PageHeader();
    init_FormSection();
    init_PropertyInspector();
    init_Header();
    init_Navigation();
    init_Section();
    init_Sidebar();
    init_Split();
    init_ConfirmDialog();
    init_WizardContainer();
    init_OrbitalVisualization();
    init_JazariStateMachine();
    init_ContentRenderer();
    init_Chart();
    init_SignaturePad();
    init_DocumentViewer();
    init_GraphCanvas();
    init_import();
    init_ActivationBlock();
    init_ReflectionBlock();
    init_ConnectionBlock();
    init_BloomQuizBlock();
    init_parseLessonSegments();
    init_lessonSegmentUtils();
    init_FloatingToolbar();
  }
});

// components/core/organisms/types.ts
var EntityDisplayEvents;
var init_types2 = __esm({
  "components/core/organisms/types.ts"() {
    EntityDisplayEvents = {
      SORT: "SORT",
      PAGINATE: "PAGINATE",
      SEARCH: "SEARCH",
      FILTER: "FILTER",
      CLEAR_FILTERS: "CLEAR_FILTERS",
      SELECT: "SELECT",
      DESELECT: "DESELECT"
    };
  }
});
function normalizeColumns(columns) {
  return columns.map((col) => {
    if (typeof col === "string") {
      const header2 = humanizeFieldName(col);
      return { key: col, header: header2 };
    }
    const key = col.key ?? col.name ?? "";
    const header = col.header ?? col.label ?? humanizeFieldName(String(key));
    return { ...col, key, header };
  });
}
function asBooleanValue2(value) {
  if (typeof value === "boolean") return value;
  if (value === "true") return true;
  if (value === "false") return false;
  return null;
}
function DataTable({
  fields,
  columns,
  entity,
  itemActions,
  isLoading = false,
  error,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyAction,
  selectable = false,
  selectedIds = [],
  sortBy,
  sortDirection = "asc",
  searchable = false,
  searchValue = "",
  searchPlaceholder,
  page,
  pageSize,
  totalCount,
  rowActions: externalRowActions,
  bulkActions,
  headerActions,
  showTotal = true,
  className,
  look = "dense",
  relationsData
}) {
  const [openActionMenu, setOpenActionMenu] = useState(
    null
  );
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const resolvedEmptyTitle = emptyTitle ?? t("table.empty.title");
  const resolvedEmptyDescription = emptyDescription ?? t("table.empty.description");
  const resolvedSearchPlaceholder = searchPlaceholder ?? t("common.search");
  const items = useMemo(
    () => Array.isArray(entity) ? entity : [],
    [entity]
  );
  const currentPage = page ?? 1;
  const currentPageSize = pageSize ?? 20;
  const total = totalCount ?? items.length;
  const totalPages = Math.ceil(total / currentPageSize);
  const withEventClick = (action) => {
    if (action.onClick || !action.event) return action;
    const event = action.event;
    return {
      ...action,
      onClick: (row) => {
        eventBus.emit(`UI:${event}`, { row });
      }
    };
  };
  const rowActions = (externalRowActions ?? itemActions?.filter((a) => a.placement !== "bulk").map((action) => ({
    label: action.label,
    icon: action.icon,
    variant: action.variant,
    event: action.event,
    onClick: (row) => {
      if (action.navigatesTo) {
        const url = action.navigatesTo.replace(/:id\b/g, String(row.id)).replace(
          /\{\{id\}\}/g,
          String(row.id)
        );
        eventBus.emit("UI:NAVIGATE", { url, row });
        return;
      }
      if (action.event) {
        eventBus.emit(`UI:${action.event}`, {
          row
        });
      }
    }
  })))?.map(withEventClick);
  const normalizedBulkActions = bulkActions?.map((action) => {
    if (action.onClick || !action.event) return action;
    const event = action.event;
    return {
      ...action,
      onClick: (selectedRows2) => {
        eventBus.emit(`UI:${event}`, { rows: selectedRows2 });
      }
    };
  });
  const viewAction = itemActions?.find(
    (a) => a.event === "VIEW" || a.navigatesTo
  );
  const handleRowClick = useCallback(
    (row) => {
      if (viewAction) {
        if (viewAction.navigatesTo) {
          const url = viewAction.navigatesTo.replace(/:id\b/g, String(row.id)).replace(
            /\{\{id\}\}/g,
            String(row.id)
          );
          eventBus.emit("UI:NAVIGATE", { url, row, entity });
          return;
        }
        eventBus.emit("UI:VIEW", { row });
      }
    },
    [viewAction, eventBus]
  );
  const isRowClickable = !!viewAction;
  const effectiveColumns = fields ?? columns ?? [];
  const normalizedColumns = useMemo(
    () => normalizeColumns(effectiveColumns),
    [effectiveColumns]
  );
  const allSelected = items.length > 0 && selectedIds.length === items.length;
  const someSelected = selectedIds.length > 0 && !allSelected;
  const handleSelectAll = useCallback(() => {
    if (allSelected) {
      eventBus.emit(`UI:${EntityDisplayEvents.DESELECT}`, {
        ids: []
      });
    } else {
      eventBus.emit(`UI:${EntityDisplayEvents.SELECT}`, {
        ids: items.map((row) => row.id)
      });
    }
  }, [allSelected, items, eventBus]);
  const handleSelectRow = useCallback(
    (id) => {
      if (selectedIds.includes(id)) {
        eventBus.emit(`UI:${EntityDisplayEvents.DESELECT}`, {
          ids: selectedIds.filter((i) => i !== id)
        });
      } else {
        eventBus.emit(`UI:${EntityDisplayEvents.SELECT}`, {
          ids: [...selectedIds, id]
        });
      }
    },
    [selectedIds, eventBus]
  );
  const handleSort = useCallback(
    (key) => {
      const newDirection = sortBy === key && sortDirection === "asc" ? "desc" : "asc";
      eventBus.emit(`UI:${EntityDisplayEvents.SORT}`, {
        field: key,
        direction: newDirection
      });
    },
    [sortBy, sortDirection, eventBus]
  );
  const handleSearch = useCallback(
    (value) => {
      eventBus.emit(`UI:${EntityDisplayEvents.SEARCH}`, {
        query: value
      });
    },
    [eventBus]
  );
  const handlePageChange = useCallback(
    (newPage) => {
      eventBus.emit(`UI:${EntityDisplayEvents.PAGINATE}`, {
        page: newPage,
        pageSize: currentPageSize
      });
    },
    [eventBus, currentPageSize]
  );
  const selectedRows = useMemo(
    () => items.filter((row) => selectedIds.includes(row.id)),
    [items, selectedIds]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "bg-card border-2 border-border rounded-none overflow-hidden",
        lookStyles9[look],
        className
      ),
      children: [
        (searchable || bulkActions || headerActions) && /* @__PURE__ */ jsxs(HStack, { className: "px-4 py-3 border-b-2 border-border flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4", children: [
          /* @__PURE__ */ jsxs(HStack, { className: "flex-col sm:flex-row items-stretch sm:items-center gap-3", children: [
            searchable && /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
              /* @__PURE__ */ jsx(Search, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
              /* @__PURE__ */ jsx(
                Input,
                {
                  type: "search",
                  value: searchValue,
                  onChange: (e) => handleSearch(e.target.value),
                  placeholder: resolvedSearchPlaceholder,
                  className: "pl-9 w-full sm:w-64"
                }
              )
            ] }),
            normalizedBulkActions && selectedIds.length > 0 && /* @__PURE__ */ jsxs(HStack, { className: "items-center gap-2 pl-0 sm:pl-3 border-l-0 sm:border-l border-border", children: [
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "small",
                  className: "text-muted-foreground whitespace-nowrap",
                  children: t("table.bulk.selected", {
                    count: String(selectedIds.length)
                  })
                }
              ),
              /* @__PURE__ */ jsx(HStack, { className: "flex-wrap gap-2", children: normalizedBulkActions.map((action, idx) => /* @__PURE__ */ jsx(
                Button,
                {
                  variant: action.variant === "danger" ? "danger" : "secondary",
                  size: "sm",
                  leftIcon: action.icon,
                  onClick: () => action.onClick?.(selectedRows),
                  children: action.label
                },
                idx
              )) })
            ] })
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "flex sm:ml-auto", children: headerActions })
        ] }),
        /* @__PURE__ */ jsx(Box, { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs("table", { className: "w-full", children: [
          /* @__PURE__ */ jsx("thead", { className: "bg-[var(--color-table-header)] border-b-2 border-border", children: /* @__PURE__ */ jsxs("tr", { children: [
            selectable && /* @__PURE__ */ jsx("th", { className: "w-12 px-4 py-3", children: /* @__PURE__ */ jsx(
              Checkbox,
              {
                checked: allSelected,
                ref: (el) => {
                  if (el) el.indeterminate = someSelected;
                },
                onChange: handleSelectAll
              }
            ) }),
            normalizedColumns.map((col) => /* @__PURE__ */ jsx(
              "th",
              {
                "data-column": String(col.key),
                className: cn(
                  "px-4 py-3 text-left text-xs font-bold text-foreground uppercase tracking-wider whitespace-nowrap",
                  col.sortable && "cursor-pointer select-none hover:bg-[var(--color-table-row-hover)]"
                ),
                style: { width: col.width },
                onClick: () => col.sortable && handleSort(String(col.key)),
                children: /* @__PURE__ */ jsxs(HStack, { className: "items-center gap-1", children: [
                  col.header,
                  col.sortable && sortBy === col.key && (sortDirection === "asc" ? /* @__PURE__ */ jsx(ChevronUp, { className: "h-4 w-4" }) : /* @__PURE__ */ jsx(ChevronDown, { className: "h-4 w-4" }))
                ] })
              },
              String(col.key)
            )),
            rowActions && /* @__PURE__ */ jsx("th", { className: "w-12 px-4 py-3" })
          ] }) }),
          /* @__PURE__ */ jsx("tbody", { className: "divide-y divide-border", children: isLoading ? /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx(
            "td",
            {
              colSpan: normalizedColumns.length + (selectable ? 1 : 0) + (rowActions ? 1 : 0),
              className: "px-4 py-12 text-center",
              children: /* @__PURE__ */ jsxs(VStack, { className: "items-center gap-2", children: [
                /* @__PURE__ */ jsx(Spinner, { size: "lg" }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "small",
                    className: "text-muted-foreground",
                    children: t("common.loading")
                  }
                )
              ] })
            }
          ) }) : error ? /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsxs(
            "td",
            {
              colSpan: normalizedColumns.length + (selectable ? 1 : 0) + (rowActions ? 1 : 0),
              className: "px-4 py-12 text-center text-error",
              children: [
                t("error.generic") + ": ",
                error.message
              ]
            }
          ) }) : items.length === 0 ? /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx(
            "td",
            {
              colSpan: normalizedColumns.length + (selectable ? 1 : 0) + (rowActions ? 1 : 0),
              className: "px-4 py-12",
              children: /* @__PURE__ */ jsx(
                EmptyState,
                {
                  icon: typeof emptyIcon === "string" ? resolveIcon(emptyIcon) : emptyIcon,
                  title: resolvedEmptyTitle,
                  description: resolvedEmptyDescription,
                  actionLabel: emptyAction?.label,
                  actionEvent: emptyAction?.event
                }
              )
            }
          ) }) : items.map((row, rowIndex) => /* @__PURE__ */ jsxs(
            "tr",
            {
              "data-entity-row": true,
              className: cn(
                "border-b border-[var(--color-table-border)] last:border-0 hover:bg-[var(--color-table-row-hover)] transition-colors",
                selectedIds.includes(row.id) && "bg-primary/10 font-medium",
                isRowClickable && "cursor-pointer"
              ),
              onClick: () => isRowClickable && handleRowClick(row),
              children: [
                selectable && /* @__PURE__ */ jsx("td", { className: "px-4 py-3", children: /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    checked: selectedIds.includes(row.id),
                    onChange: () => handleSelectRow(row.id)
                  }
                ) }),
                normalizedColumns.map((col) => {
                  const cellValue = getNestedValue(
                    row,
                    String(col.key)
                  );
                  return /* @__PURE__ */ jsx(
                    "td",
                    {
                      "data-column": String(col.key),
                      className: "px-4 py-3 text-sm text-foreground whitespace-nowrap sm:whitespace-normal",
                      children: col.render ? col.render(cellValue, row, rowIndex) : (() => {
                        const relationDisplay = resolveRelationCellDisplay(
                          cellValue,
                          relationsData?.[String(col.key)]
                        );
                        if (relationDisplay !== void 0) return relationDisplay;
                        const boolVal = asBooleanValue2(cellValue);
                        if (boolVal !== null) {
                          return boolVal ? /* @__PURE__ */ jsx(Badge, { variant: "success", children: t("common.yes") }) : /* @__PURE__ */ jsx(Badge, { variant: "neutral", children: t("common.no") });
                        }
                        return String(cellValue ?? "");
                      })()
                    },
                    String(col.key)
                  );
                }),
                rowActions && /* @__PURE__ */ jsxs("td", { className: "px-4 py-3 relative", children: [
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      className: "p-1 rounded hover:bg-muted",
                      onClick: (e) => {
                        e.stopPropagation();
                        setOpenActionMenu(
                          openActionMenu === row.id ? null : row.id
                        );
                      },
                      children: /* @__PURE__ */ jsx(MoreHorizontal, { className: "h-4 w-4 text-muted-foreground" })
                    }
                  ),
                  openActionMenu === row.id && /* @__PURE__ */ jsxs(Fragment, { children: [
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        className: "fixed inset-0 z-40",
                        onClick: (e) => {
                          e.stopPropagation();
                          setOpenActionMenu(null);
                        }
                      }
                    ),
                    /* @__PURE__ */ jsx(VStack, { className: "absolute right-0 mt-1 w-48 bg-card rounded-lg shadow-lg border border-border py-1 z-50", children: (rowActions ?? []).filter(
                      (action) => !action.show || action.show(row)
                    ).map((action, idx) => /* @__PURE__ */ jsxs(
                      Button,
                      {
                        variant: "ghost",
                        "data-event": action.event,
                        "data-testid": action.event ? `action-${action.event}` : void 0,
                        className: cn(
                          "w-full flex items-center gap-2 px-4 py-2 text-sm",
                          action.variant === "danger" ? "text-error hover:bg-error/10" : "text-foreground hover:bg-muted"
                        ),
                        onClick: (e) => {
                          e.stopPropagation();
                          action.onClick?.(row);
                          setOpenActionMenu(null);
                        },
                        children: [
                          action.icon && (typeof action.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: action.icon, size: "sm" }) : /* @__PURE__ */ jsx(action.icon, { className: "h-4 w-4" })),
                          action.label
                        ]
                      },
                      idx
                    )) })
                  ] })
                ] })
              ]
            },
            row.id
          )) })
        ] }) }),
        totalCount !== void 0 && totalPages > 1 && /* @__PURE__ */ jsx(Box, { className: "px-4 py-3 border-t-2 border-border", children: /* @__PURE__ */ jsx(
          Pagination,
          {
            currentPage,
            totalPages,
            onPageChange: handlePageChange,
            showTotal,
            totalItems: total
          }
        ) })
      ]
    }
  );
}
var lookStyles9;
var init_DataTable = __esm({
  "components/core/organisms/DataTable.tsx"() {
    "use client";
    init_cn();
    init_format();
    init_getNestedValue();
    init_relationLabel();
    init_atoms();
    init_Box();
    init_Stack();
    init_Typography();
    init_molecules2();
    init_Icon();
    init_useEventBus();
    init_types2();
    lookStyles9 = {
      dense: "",
      spacious: "[&_tbody_tr_td]:py-5 [&_thead_tr_th]:py-4",
      striped: "[&_tbody_tr:nth-child(odd)]:bg-muted/30",
      borderless: "border-0 [&_thead]:border-b-0 [&_tbody_tr]:border-b-0 [&_tbody]:divide-y-0",
      "card-rows": "border-0 [&_tbody]:divide-y-0 [&_tbody_tr]:border-b-0 [&_tbody_tr]:shadow-elevation-card [&_tbody_tr]:rounded-container [&_tbody_tr]:bg-card [&_tbody]:[&_tr]:my-2"
    };
    DataTable.displayName = "DataTable";
  }
});
function getBadgeVariant(fieldName2, value) {
  const name = fieldName2.toLowerCase();
  const val = String(value).toLowerCase();
  if (name.includes("status")) {
    if (val.includes("complete") || val.includes("done") || val.includes("active"))
      return "success";
    if (val.includes("progress") || val.includes("pending")) return "warning";
    if (val.includes("block") || val.includes("cancel")) return "danger";
    return "info";
  }
  if (name.includes("priority")) {
    if (val.includes("high") || val.includes("urgent")) return "danger";
    if (val.includes("medium") || val.includes("normal")) return "warning";
    if (val.includes("low")) return "info";
  }
  return "default";
}
function formatFieldValue2(value, fieldName2) {
  if (typeof value === "number") {
    if (fieldName2.toLowerCase().includes("progress") || fieldName2.toLowerCase().includes("percent")) {
      return `${value}%`;
    }
    if (fieldName2.toLowerCase().includes("budget") || fieldName2.toLowerCase().includes("cost")) {
      return `$${value.toLocaleString()}`;
    }
    return value.toLocaleString();
  }
  if (value instanceof Date) {
    return value.toLocaleDateString();
  }
  return String(value);
}
function renderRichFieldValue(value, fieldName2, fieldType, meta) {
  if (value === void 0 || value === null) return "\u2014";
  const str2 = String(value);
  switch (fieldType) {
    case "image": {
      if (!str2) return "\u2014";
      return /* @__PURE__ */ jsx(Box, { className: "mt-1 max-w-full", children: /* @__PURE__ */ jsx(
        "img",
        {
          src: str2,
          alt: formatFieldLabel(fieldName2),
          className: "max-w-full max-h-64 rounded-md object-contain",
          loading: "lazy"
        }
      ) });
    }
    case "url": {
      if (str2.match(/\.(png|jpe?g|gif|svg|webp|avif)(\?|$)/i) || str2.startsWith("data:image/")) {
        return /* @__PURE__ */ jsx(Box, { className: "mt-1 max-w-full", children: /* @__PURE__ */ jsx(
          "img",
          {
            src: str2,
            alt: formatFieldLabel(fieldName2),
            className: "max-w-full max-h-64 rounded-md object-contain",
            loading: "lazy"
          }
        ) });
      }
      if (/^https?:\/\//i.test(str2)) {
        return /* @__PURE__ */ jsx(
          "a",
          {
            href: str2,
            target: "_blank",
            rel: "noreferrer",
            className: "text-primary hover:underline break-all",
            children: str2
          }
        );
      }
      return str2;
    }
    case "markdown":
    case "richtext":
      return /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "break-words", children: str2 }), children: /* @__PURE__ */ jsx(
        Box,
        {
          className: "prose prose-sm max-w-none",
          style: {
            color: "var(--color-foreground)",
            "--tw-prose-body": "var(--color-foreground)",
            "--tw-prose-headings": "var(--color-foreground)",
            "--tw-prose-bold": "var(--color-foreground)",
            "--tw-prose-links": "var(--color-primary)",
            "--tw-prose-code": "var(--color-foreground)",
            "--tw-prose-hr": "var(--color-border)",
            "--tw-prose-quotes": "var(--color-foreground)",
            "--tw-prose-quote-borders": "var(--color-primary)",
            "--tw-prose-captions": "var(--color-muted-foreground)",
            "--tw-prose-th-borders": "var(--color-border)",
            "--tw-prose-td-borders": "var(--color-border)"
          },
          children: /* @__PURE__ */ jsx(ReactMarkdown2, { children: str2 })
        }
      ) });
    case "code":
      return /* @__PURE__ */ jsx(Box, { className: "mt-1 rounded-md bg-muted p-3 overflow-x-auto", children: /* @__PURE__ */ jsx("pre", { className: "text-sm font-mono whitespace-pre-wrap break-words m-0", children: /* @__PURE__ */ jsx("code", { children: str2 }) }) });
    case "html":
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "mt-1 prose prose-sm max-w-none break-words",
          style: {
            color: "var(--color-foreground)",
            "--tw-prose-body": "var(--color-foreground)",
            "--tw-prose-headings": "var(--color-foreground)",
            "--tw-prose-bold": "var(--color-foreground)",
            "--tw-prose-links": "var(--color-primary)",
            "--tw-prose-code": "var(--color-foreground)",
            "--tw-prose-hr": "var(--color-border)",
            "--tw-prose-quotes": "var(--color-foreground)",
            "--tw-prose-quote-borders": "var(--color-primary)",
            "--tw-prose-captions": "var(--color-muted-foreground)",
            "--tw-prose-th-borders": "var(--color-border)",
            "--tw-prose-td-borders": "var(--color-border)"
          },
          children: /* @__PURE__ */ jsx(Typography, { variant: "body", children: str2 })
        }
      );
    case "date":
    case "datetime":
    case "timestamp": {
      const d = new Date(str2);
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString(void 0, {
          year: "numeric",
          month: "long",
          day: "numeric",
          ...fieldType !== "date" ? { hour: "2-digit", minute: "2-digit" } : {}
        });
      }
      return str2;
    }
    case "money": {
      const n = typeof value === "number" ? value : Number(str2);
      if (!isNaN(n)) {
        return new Intl.NumberFormat(void 0, {
          style: "currency",
          currency: "USD"
        }).format(n);
      }
      return str2;
    }
    case "relation": {
      const labels = relationDisplayLabels(value, meta?.options);
      if (labels.length === 0) return "\u2014";
      if (labels.length === 1) return labels[0];
      return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: labels.map((label, i) => /* @__PURE__ */ jsx(Badge, { variant: "default", children: label }, i)) });
    }
    case "file": {
      if (value !== null && typeof value === "object" && !Array.isArray(value)) {
        const file = value;
        const label = typeof file.name === "string" && file.name ? file.name : "file";
        const size = typeof file.sizeBytes === "number" ? ` \xB7 ${formatFileSize(file.sizeBytes)}` : "";
        return /* @__PURE__ */ jsxs(
          "a",
          {
            href: typeof file.url === "string" ? file.url : void 0,
            download: label,
            className: "inline-flex items-center gap-1.5 rounded-md border border-border bg-muted px-2 py-1 text-sm text-foreground no-underline hover:bg-accent",
            children: [
              /* @__PURE__ */ jsx(Icon, { icon: FileText, size: "sm", className: "text-muted-foreground" }),
              label,
              size && /* @__PURE__ */ jsx(Typography, { as: "span", variant: "caption", color: "muted", children: size })
            ]
          }
        );
      }
      return str2;
    }
    case "boolean": {
      if (typeof value === "boolean") return value ? "Yes" : "No";
      if (str2 === "true") return "Yes";
      if (str2 === "false") return "No";
      return str2;
    }
    case "array": {
      if (Array.isArray(value) && value.length > 0) {
        return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: value.map((item, i) => /* @__PURE__ */ jsx(Badge, { variant: "default", children: String(item) }, i)) });
      }
      if (Array.isArray(value)) return "\u2014";
      return str2;
    }
    case "email":
      return /* @__PURE__ */ jsx("a", { href: `mailto:${str2}`, className: "text-primary hover:underline break-all", children: str2 });
    case "phone":
      return /* @__PURE__ */ jsx("a", { href: `tel:${str2}`, className: "text-primary hover:underline", children: str2 });
    default:
      if (meta?.values && meta.values.length > 0 && meta.values.includes(str2)) {
        return /* @__PURE__ */ jsx(Badge, { variant: getBadgeVariant(fieldName2, str2), children: humanizeEnumValue(str2) });
      }
      return formatFieldValue2(value, fieldName2);
  }
}
function normalizeFieldDefs(fields) {
  if (!fields) return [];
  return fields.map((f3) => {
    if (typeof f3 === "string") return f3;
    if ("key" in f3) return f3.key;
    if ("name" in f3) return f3.name;
    return String(f3);
  });
}
function buildFieldLabelMap(fields) {
  const map = {};
  if (!fields) return map;
  for (const f3 of fields) {
    if (typeof f3 === "object" && "key" in f3 && f3.header !== void 0 && f3.header !== "") {
      map[f3.key] = f3.header;
    }
  }
  return map;
}
function buildFieldTypeMap(fields) {
  const map = {};
  if (!fields) return map;
  for (const f3 of fields) {
    if (typeof f3 === "object" && f3.type !== void 0) {
      map["name" in f3 ? f3.name : f3.key] = f3.type;
    }
  }
  return map;
}
function buildFieldMetaMap(fields) {
  const map = {};
  if (!fields) return map;
  for (const f3 of fields) {
    if (typeof f3 === "object" && (f3.type !== void 0 || f3.values !== void 0 || f3.relation !== void 0)) {
      map["name" in f3 ? f3.name : f3.key] = { type: f3.type, values: f3.values, relation: f3.relation };
    }
  }
  return map;
}
var formatFieldLabel, ReactMarkdown2, DetailPanel;
var init_DetailPanel = __esm({
  "components/core/organisms/DetailPanel.tsx"() {
    "use client";
    init_atoms();
    init_Box();
    init_Input();
    init_Stack();
    init_SimpleGrid();
    init_Menu();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    init_cn();
    init_portalRoot();
    init_slotContained();
    init_format();
    init_getNestedValue();
    init_relationLabel();
    init_useEventBus();
    init_UploadDropZone();
    formatFieldLabel = humanizeFieldName;
    ReactMarkdown2 = lazy(() => import('react-markdown'));
    DetailPanel = ({
      title: propTitle,
      onTitleCommit,
      subtitle,
      status,
      avatar,
      sections: propSections,
      actions,
      maxInlineActions = 2,
      backAction,
      footer,
      slideOver = false,
      showActions = true,
      className,
      entity,
      fields: propFields,
      fieldNames,
      initialData,
      isLoading = false,
      error,
      relationsData
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const contained = useContext(SlotContainedContext);
      const [titleDraft, setTitleDraft] = React79__default.useState(null);
      const isFieldDefArray = (arr) => {
        if (!arr || arr.length === 0) return false;
        const first = arr[0];
        return typeof first === "string" || typeof first === "object" && first !== null && ("key" in first || "name" in first);
      };
      const effectiveFieldNames = isFieldDefArray(propFields) ? normalizeFieldDefs(propFields) : fieldNames;
      const fieldTypeMap = isFieldDefArray(propFields) ? buildFieldTypeMap(propFields) : {};
      const fieldMetaMap = isFieldDefArray(propFields) ? buildFieldMetaMap(propFields) : {};
      const fieldLabelMap = isFieldDefArray(propFields) ? buildFieldLabelMap(propFields) : {};
      const labelFor = (field) => fieldLabelMap[field] ?? formatFieldLabel(field);
      const metaFor = (field) => {
        const base = fieldMetaMap[field];
        const options = relationsData?.[field];
        if (!base && !options) return void 0;
        return { ...base, options };
      };
      const handleActionClick = useCallback(
        (action, data2) => {
          if (action.navigatesTo) {
            const url = action.navigatesTo.replace(
              /\{\{(\w+)\}\}/g,
              (_, key) => String(data2?.[key] ?? "")
            );
            eventBus.emit("UI:NAVIGATE", { url, row: data2 });
            return;
          }
          if (action.event) {
            const payload = data2 ? { id: data2.id, row: data2 } : {};
            eventBus.emit(`UI:${action.event}`, payload);
          }
          if (action.onClick) {
            action.onClick();
          }
        },
        [eventBus]
      );
      const entityRecord = Array.isArray(entity) ? entity[0] : entity;
      const data = entityRecord ?? initialData;
      let title = propTitle;
      let sections = propSections ? [...propSections] : void 0;
      const normalizedData = data && typeof data === "object" && !Array.isArray(data) ? data : void 0;
      if (sections && normalizedData) {
        sections = sections.map((section) => ({
          ...section,
          fields: section.fields.map((field) => {
            if (typeof field === "string") {
              const value = getNestedValue(normalizedData, field);
              return {
                label: labelFor(field),
                value: formatFieldValue2(value, field)
              };
            }
            return field;
          })
        }));
      }
      if (normalizedData && effectiveFieldNames) {
        const primaryField = effectiveFieldNames[0];
        const titleDerivedFromPrimary = Boolean(
          !title && primaryField && normalizedData[primaryField]
        );
        if (titleDerivedFromPrimary) {
          title = String(normalizedData[primaryField]);
        }
        const statusFields = effectiveFieldNames.filter(
          (f3) => f3.toLowerCase().includes("status") || f3.toLowerCase().includes("priority")
        );
        const progressFields = effectiveFieldNames.filter(
          (f3) => f3.toLowerCase().includes("progress") || f3.toLowerCase().includes("percent")
        );
        const metricFields = effectiveFieldNames.filter(
          (f3) => (f3.toLowerCase().includes("budget") || f3.toLowerCase().includes("cost") || f3.toLowerCase().includes("count")) && !progressFields.includes(f3)
        );
        const dateFields = effectiveFieldNames.filter(
          (f3) => f3.toLowerCase().includes("date") || f3.toLowerCase().includes("time")
        );
        const descriptionFields = effectiveFieldNames.filter(
          (f3) => f3.toLowerCase().includes("description") || f3.toLowerCase().includes("note")
        );
        const otherFields = effectiveFieldNames.filter(
          (f3) => (!titleDerivedFromPrimary || f3 !== primaryField) && !statusFields.includes(f3) && !progressFields.includes(f3) && !metricFields.includes(f3) && !dateFields.includes(f3) && !descriptionFields.includes(f3)
        );
        sections = [];
        if (otherFields.length > 0) {
          const overviewFields = [];
          otherFields.forEach((field) => {
            const value = getNestedValue(normalizedData, field);
            if (value !== void 0 && value !== null) {
              overviewFields.push({
                label: labelFor(field),
                value: renderRichFieldValue(value, field, fieldTypeMap[field], metaFor(field))
              });
            }
          });
          if (overviewFields.length > 0) {
            sections.push({ title: "Overview", fields: overviewFields });
          }
        }
        if (progressFields.length > 0 || metricFields.length > 0) {
          const metricsFields = [];
          [...progressFields, ...metricFields].forEach((field) => {
            const value = getNestedValue(normalizedData, field);
            if (value !== void 0 && value !== null) {
              metricsFields.push({
                label: labelFor(field),
                value: renderRichFieldValue(value, field, fieldTypeMap[field], metaFor(field))
              });
            }
          });
          if (metricsFields.length > 0) {
            sections.push({ title: "Metrics", fields: metricsFields });
          }
        }
        if (dateFields.length > 0) {
          const timelineFields = [];
          dateFields.forEach((field) => {
            const value = getNestedValue(normalizedData, field);
            if (value !== void 0 && value !== null) {
              timelineFields.push({
                label: labelFor(field),
                value: renderRichFieldValue(value, field, fieldTypeMap[field], metaFor(field))
              });
            }
          });
          if (timelineFields.length > 0) {
            sections.push({ title: "Timeline", fields: timelineFields });
          }
        }
        if (descriptionFields.length > 0) {
          const descFields = [];
          descriptionFields.forEach((field) => {
            const value = getNestedValue(normalizedData, field);
            if (value !== void 0 && value !== null) {
              descFields.push({
                label: labelFor(field),
                value: renderRichFieldValue(value, field, fieldTypeMap[field], metaFor(field))
              });
            }
          });
          if (descFields.length > 0) {
            sections.push({ title: "Details", fields: descFields });
          }
        }
      }
      const renderSlot = useRenderSlot();
      const navStack = useNavStack();
      const { setCurrentLabel } = navStack;
      const resolvedTitle = normalizedData ? title : void 0;
      useEffect(() => {
        if (renderSlot === "main" && !slideOver && resolvedTitle) {
          setCurrentLabel(resolvedTitle);
        }
      }, [renderSlot, slideOver, resolvedTitle, setCurrentLabel]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(
          LoadingState,
          {
            message: t("common.loading"),
            className
          }
        );
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("error.loadingData"),
            message: error.message || t("error.genericLoad"),
            retryEvent: "RETRY",
            className
          }
        );
      }
      if (!normalizedData && !isLoading && effectiveFieldNames && effectiveFieldNames.length > 0) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            title: t("error.notFound"),
            description: "The requested item could not be found.",
            className
          }
        );
      }
      const allFields = [];
      if (sections) {
        for (const section of sections) {
          for (const field of section.fields) {
            if (typeof field === "string") {
              const value = normalizedData ? getNestedValue(normalizedData, field) : void 0;
              allFields.push({
                label: labelFor(field),
                value: renderRichFieldValue(value, field, fieldTypeMap[field], metaFor(field))
              });
            } else {
              allFields.push(field);
            }
          }
        }
      }
      const closeAction = actions?.find(
        (a) => a.event === "CLOSE" || a.event === "CANCEL" || a.label?.toLowerCase() === "close"
      );
      const otherActions = actions?.filter((a) => a !== closeAction) ?? [];
      const statusBadges = /* @__PURE__ */ jsxs(Fragment, { children: [
        normalizedData && effectiveFieldNames && effectiveFieldNames.filter(
          (f3) => f3.toLowerCase().includes("status") || f3.toLowerCase().includes("priority")
        ).map((field) => {
          const value = getNestedValue(normalizedData, field);
          if (!value) return null;
          return /* @__PURE__ */ jsx(
            Badge,
            {
              variant: getBadgeVariant(field, String(value)),
              children: humanizeEnumValue(String(value))
            },
            field
          );
        }),
        status && /* @__PURE__ */ jsx(Badge, { variant: status.variant ?? "default", children: status.label })
      ] });
      const commitTitle = () => {
        if (!onTitleCommit) return;
        const next = (titleDraft ?? "").trim();
        setTitleDraft(null);
        if (!next || next === title) return;
        onTitleCommit(next, normalizedData?.id !== void 0 ? String(normalizedData.id) : "");
      };
      const titleNode = onTitleCommit && titleDraft !== null ? /* @__PURE__ */ jsx(
        Input,
        {
          value: titleDraft,
          autoFocus: true,
          "aria-label": t("common.title"),
          className: "h-auto py-1 text-3xl font-bold tracking-tight",
          onChange: (e) => setTitleDraft(e.target.value),
          onBlur: commitTitle,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commitTitle();
            } else if (e.key === "Escape") {
              e.preventDefault();
              setTitleDraft(null);
            }
          },
          "data-testid": "detail-title-input"
        }
      ) : onTitleCommit ? /* @__PURE__ */ jsx(
        Box,
        {
          role: "button",
          tabIndex: 0,
          className: "cursor-text rounded px-1 -mx-1 transition-colors hover:bg-muted/40",
          onClick: () => setTitleDraft(title ?? ""),
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setTitleDraft(title ?? "");
            }
          },
          "data-testid": "detail-title-editable",
          children: /* @__PURE__ */ jsx(Typography, { variant: "h2", weight: "bold", children: title || "Details" })
        }
      ) : /* @__PURE__ */ jsx(Typography, { variant: "h2", weight: "bold", children: title || "Details" });
      const content = /* @__PURE__ */ jsx(Card, { variant: "elevated", children: /* @__PURE__ */ jsxs(VStack, { gap: "md", className: "p-6", children: [
        /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", gap: "md", children: [
          /* @__PURE__ */ jsxs(HStack, { align: "start", gap: "sm", className: "min-w-0", children: [
            backAction && /* @__PURE__ */ jsx(
              Button,
              {
                variant: backAction.variant || "ghost",
                size: "sm",
                action: backAction.navigatesTo ? void 0 : backAction.event,
                actionPayload: { row: normalizedData },
                onClick: backAction.navigatesTo ? () => handleActionClick(backAction, normalizedData) : void 0,
                icon: backAction.icon ?? ArrowLeft,
                "data-testid": backAction.event ? `action-${backAction.event}` : "action-back",
                children: backAction.label
              }
            ),
            avatar,
            /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "min-w-0", children: [
              /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", wrap: true, children: [
                titleNode,
                statusBadges
              ] }),
              subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: subtitle })
            ] })
          ] }),
          showActions && /* @__PURE__ */ jsxs(HStack, { justify: "end", align: "center", gap: "xs", className: "shrink-0", children: [
            otherActions.slice(0, maxInlineActions).map((action, idx) => /* @__PURE__ */ jsx(
              Button,
              {
                variant: action.variant || "secondary",
                size: "sm",
                action: action.navigatesTo ? void 0 : action.event,
                actionPayload: { row: normalizedData },
                onClick: action.navigatesTo ? () => handleActionClick(action, normalizedData) : void 0,
                icon: action.icon,
                "data-testid": action.event ? `action-${action.event}` : void 0,
                "data-row-id": normalizedData?.id !== void 0 ? String(normalizedData.id) : void 0,
                children: action.label
              },
              idx
            )),
            otherActions.length > maxInlineActions && /* @__PURE__ */ jsx(
              Menu,
              {
                position: "bottom-end",
                trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "action-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                items: otherActions.slice(maxInlineActions).map((action) => ({
                  // ONE firing path: onClick → handleActionClick (emits with
                  // the {id, row} payload). Passing `event` too would make
                  // Menu emit a second, payload-less copy of the same event.
                  label: action.label,
                  icon: action.icon,
                  variant: action.variant === "danger" ? "danger" : "default",
                  onClick: () => handleActionClick(action, normalizedData)
                }))
              }
            ),
            closeAction && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                action: closeAction.event,
                actionPayload: { row: normalizedData },
                onClick: closeAction.event ? void 0 : () => handleActionClick(closeAction, normalizedData),
                icon: X,
                "data-testid": closeAction.event ? `action-${closeAction.event}` : "action-close"
              }
            )
          ] })
        ] }),
        normalizedData && effectiveFieldNames && effectiveFieldNames.filter(
          (f3) => f3.toLowerCase().includes("progress") || f3.toLowerCase().includes("percent")
        ).map((field) => {
          const value = getNestedValue(normalizedData, field);
          if (value === void 0 || value === null || typeof value !== "number")
            return null;
          return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "w-full", children: [
            /* @__PURE__ */ jsxs(HStack, { justify: "between", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: formatFieldLabel(field) }),
              /* @__PURE__ */ jsxs(Typography, { variant: "small", weight: "medium", children: [
                value,
                "%"
              ] })
            ] }),
            /* @__PURE__ */ jsx(ProgressBar, { value })
          ] }, field);
        }),
        allFields.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(SimpleGrid, { minChildWidth: "250px", maxCols: 2, gap: "lg", children: allFields.map((field, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
            field.icon && /* @__PURE__ */ jsx(
              Icon,
              {
                icon: field.icon,
                size: "md",
                className: "text-muted-foreground mt-1"
              }
            ),
            /* @__PURE__ */ jsxs(VStack, { gap: "xs", flex: true, className: "min-w-0", children: [
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  color: "muted",
                  weight: "medium",
                  className: "uppercase tracking-wider",
                  children: field.label
                }
              ),
              /* @__PURE__ */ jsx(Typography, { variant: "body", className: "break-words", children: field.value || "\u2014" })
            ] })
          ] }, idx)) })
        ] }),
        footer && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Divider, {}),
          footer
        ] })
      ] }) });
      if (!slideOver) {
        return /* @__PURE__ */ jsx(Box, { className, children: content });
      }
      const panel = /* @__PURE__ */ jsx(Box, { className: cn(contained ? "absolute" : "fixed", "inset-y-0 right-0 w-full max-w-2xl bg-card shadow-lg z-50 overflow-y-auto p-6", className), children: content });
      if (contained || typeof document === "undefined") return panel;
      return createPortal(panel, getOrCreatePortalRoot());
    };
    DetailPanel.displayName = "DetailPanel";
  }
});
var SplitPane;
var init_SplitPane = __esm({
  "components/core/organisms/layout/SplitPane.tsx"() {
    "use client";
    init_cn();
    SplitPane = ({
      direction = "horizontal",
      ratio: ratioProp = 50,
      minSize = 100,
      resizable = true,
      left,
      right,
      className,
      leftClassName,
      rightClassName,
      onRatioChange
    }) => {
      const [uncontrolledRatio, setUncontrolledRatio] = useState(ratioProp);
      const ratio = onRatioChange ? ratioProp : uncontrolledRatio;
      const containerRef = useRef(null);
      const isDragging = useRef(false);
      const handlePointerDown = useCallback(
        (e) => {
          if (!resizable) return;
          e.preventDefault();
          isDragging.current = true;
          e.currentTarget.setPointerCapture(e.pointerId);
          const handlePointerMove = (ev) => {
            if (!isDragging.current || !containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();
            let newRatio;
            if (direction === "horizontal") {
              const x = ev.clientX - rect.left;
              newRatio = x / rect.width * 100;
            } else {
              const y = ev.clientY - rect.top;
              newRatio = y / rect.height * 100;
            }
            const minRatio = minSize / (direction === "horizontal" ? rect.width : rect.height) * 100;
            const maxRatio = 100 - minRatio;
            newRatio = Math.max(minRatio, Math.min(maxRatio, newRatio));
            if (onRatioChange) {
              onRatioChange(newRatio);
            } else {
              setUncontrolledRatio(newRatio);
            }
          };
          const handlePointerUp = () => {
            isDragging.current = false;
            document.removeEventListener("pointermove", handlePointerMove);
            document.removeEventListener("pointerup", handlePointerUp);
            document.removeEventListener("pointercancel", handlePointerUp);
          };
          document.addEventListener("pointermove", handlePointerMove);
          document.addEventListener("pointerup", handlePointerUp);
          document.addEventListener("pointercancel", handlePointerUp);
        },
        [direction, minSize, resizable, onRatioChange]
      );
      const isHorizontal = direction === "horizontal";
      return /* @__PURE__ */ jsxs(
        "div",
        {
          ref: containerRef,
          className: cn(
            "flex w-full h-full",
            isHorizontal ? "flex-row" : "flex-col",
            className
          ),
          children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn("flex flex-col overflow-auto", leftClassName),
                style: {
                  [isHorizontal ? "width" : "height"]: `${ratio}%`,
                  flexShrink: 0
                },
                children: left
              }
            ),
            resizable && /* @__PURE__ */ jsx(
              "div",
              {
                onPointerDown: handlePointerDown,
                className: cn(
                  "flex-shrink-0 bg-border transition-colors touch-none",
                  isHorizontal ? "w-1 cursor-col-resize hover:w-1.5 hover:bg-muted-foreground" : "h-1 cursor-row-resize hover:h-1.5 hover:bg-muted-foreground"
                )
              }
            ),
            /* @__PURE__ */ jsx("div", { className: cn("flex flex-col flex-1 min-h-0 min-w-0 overflow-auto", rightClassName), children: right })
          ]
        }
      );
    };
    SplitPane.displayName = "SplitPane";
  }
});
var DockLayout;
var init_DockLayout = __esm({
  "components/core/organisms/layout/DockLayout.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_cn();
    init_SplitPane();
    DockLayout = ({
      rail,
      sidebar,
      main,
      bottomPanel,
      statusBar,
      secondarySidebar,
      railWidth = 56,
      secondarySidebarWidth = 280,
      sidebarCollapsed = false,
      sidebarWidth = 20,
      onSidebarWidthChange,
      sidebarMinSize = 160,
      bottomPanelCollapsed = false,
      bottomPanelHeight = 30,
      onBottomPanelHeightChange,
      bottomPanelMinSize = 120,
      secondarySidebarCollapsed = false,
      className,
      railClassName,
      sidebarClassName,
      mainClassName,
      bottomPanelClassName,
      statusBarClassName,
      secondarySidebarClassName
    }) => {
      const showSidebar = Boolean(sidebar) && !sidebarCollapsed;
      const showBottomPanel = Boolean(bottomPanel) && !bottomPanelCollapsed;
      const showSecondarySidebar = Boolean(secondarySidebar) && !secondarySidebarCollapsed;
      const centerRow = /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "flex-1 min-h-0 min-w-0", children: [
        /* @__PURE__ */ jsx(Box, { className: cn("flex-1 min-w-0 min-h-0 overflow-auto", mainClassName), children: main }),
        showSecondarySidebar && /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-shrink-0 h-full overflow-auto border-l border-border",
              secondarySidebarClassName
            ),
            style: { width: secondarySidebarWidth },
            children: secondarySidebar
          }
        )
      ] });
      const sidebarAndCenter = showSidebar ? /* @__PURE__ */ jsx(
        SplitPane,
        {
          direction: "horizontal",
          ratio: sidebarWidth,
          onRatioChange: onSidebarWidthChange,
          minSize: sidebarMinSize,
          resizable: true,
          left: /* @__PURE__ */ jsx(Box, { className: cn("h-full overflow-auto", sidebarClassName), children: sidebar }),
          right: centerRow,
          className: "flex-1 min-h-0 min-w-0"
        }
      ) : centerRow;
      const body = /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "flex-1 min-h-0 min-w-0", children: [
        rail && /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-shrink-0 min-h-0 overflow-auto border-r border-border",
              railClassName
            ),
            style: { width: railWidth },
            children: rail
          }
        ),
        sidebarAndCenter
      ] });
      const bodyPlusBottom = showBottomPanel ? /* @__PURE__ */ jsx(
        SplitPane,
        {
          direction: "vertical",
          ratio: 100 - bottomPanelHeight,
          onRatioChange: (topRatio) => onBottomPanelHeightChange?.(100 - topRatio),
          minSize: bottomPanelMinSize,
          resizable: true,
          left: body,
          right: /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "h-full overflow-auto border-t border-border",
                bottomPanelClassName
              ),
              children: bottomPanel
            }
          ),
          className: "flex-1 min-h-0"
        }
      ) : body;
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("w-full h-full overflow-hidden", className), children: [
        bodyPlusBottom,
        statusBar && /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-shrink-0 border-t border-border bg-background",
              statusBarClassName
            ),
            children: statusBar
          }
        )
      ] });
    };
    DockLayout.displayName = "DockLayout";
  }
});
function extractTitle(children) {
  if (!React79__default.isValidElement(children)) return void 0;
  const props = children.props;
  if (typeof props.title === "string") {
    return props.title;
  }
  return void 0;
}
var DrawerSlot;
var init_DrawerSlot = __esm({
  "components/core/organisms/DrawerSlot.tsx"() {
    "use client";
    init_Drawer();
    init_useEventBus();
    DrawerSlot = ({
      children,
      title: overrideTitle,
      position = "right",
      size = "md",
      className,
      sourceTrait
    }) => {
      const eventBus = useEventBus();
      const schemaCtx = useEntitySchemaOptional();
      const isOpen = Boolean(children);
      const title = overrideTitle || extractTitle(children);
      const handleClose = () => {
        const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
        const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
        eventBus.emit(`${prefix}CLOSE`);
        eventBus.emit(`${prefix}CANCEL`);
      };
      if (!isOpen) return null;
      return /* @__PURE__ */ jsx(
        Drawer,
        {
          isOpen,
          onClose: handleClose,
          title,
          position,
          width: size,
          className,
          children: /* @__PURE__ */ jsx(RenderSlotProvider, { slot: "drawer", children })
        }
      );
    };
    DrawerSlot.displayName = "DrawerSlot";
  }
});
var FeatureDetailPageTemplate;
var init_FeatureDetailPageTemplate = __esm({
  "components/marketing/templates/FeatureDetailPageTemplate.tsx"() {
    init_cn();
    init_Stack();
    init_HeroSection();
    init_SplitSection();
    init_CTABanner();
    FeatureDetailPageTemplate = ({
      entity,
      className
    }) => {
      const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
      if (!resolved) return null;
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("w-full", className), children: [
        resolved.hero && /* @__PURE__ */ jsx(
          HeroSection,
          {
            tag: resolved.hero.tag,
            title: resolved.hero.title,
            titleAccent: resolved.hero.titleAccent,
            subtitle: resolved.hero.subtitle,
            primaryAction: resolved.hero.primaryAction,
            secondaryAction: resolved.hero.secondaryAction,
            background: resolved.hero.background
          }
        ),
        (Array.isArray(resolved.sections) ? resolved.sections : []).map((section, index) => /* @__PURE__ */ jsx(
          SplitSection,
          {
            title: section.title,
            description: section.description,
            bullets: section.bullets,
            image: section.image,
            imagePosition: section.imagePosition ?? (index % 2 === 0 ? "right" : "left"),
            background: index % 2 === 0 ? "default" : "alt"
          },
          `section-${index}`
        )),
        resolved.ctaTitle && /* @__PURE__ */ jsx(
          CTABanner,
          {
            title: resolved.ctaTitle,
            primaryAction: resolved.ctaAction,
            background: "dark"
          }
        )
      ] });
    };
    FeatureDetailPageTemplate.displayName = "FeatureDetailPageTemplate";
  }
});
var FeatureGridOrganism;
var init_FeatureGridOrganism = __esm({
  "components/marketing/organisms/FeatureGridOrganism.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Stack();
    init_Typography();
    init_FeatureGrid();
    init_LoadingState();
    init_ErrorState();
    FeatureGridOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      columns = 3,
      heading,
      subtitle
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      useCallback(
        (feature) => {
          eventBus.emit("UI:FEATURE_CLICK", {
            id: String(feature.id ?? ""),
            href: String(feature.href ?? "")
          });
        },
        [eventBus]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      const featureCards = items.map((feature) => {
        const href = feature.href != null ? String(feature.href) : void 0;
        return {
          icon: feature.icon != null ? String(feature.icon) : void 0,
          title: String(feature.title ?? ""),
          description: String(feature.description ?? ""),
          href,
          linkLabel: feature.linkLabel != null ? String(feature.linkLabel) : void 0,
          variant: href ? "interactive" : "bordered"
        };
      });
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("w-full", className), children: [
        (heading || subtitle) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "w-full", children: [
          heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", align: "center", children: heading }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "muted", align: "center", className: "max-w-2xl", children: subtitle })
        ] }),
        /* @__PURE__ */ jsx(
          FeatureGrid,
          {
            items: featureCards,
            columns
          }
        )
      ] });
    };
    FeatureGridOrganism.displayName = "FeatureGridOrganism";
  }
});
function toSharedContext2(formCtx) {
  return createMinimalContext(
    {
      formValues: formCtx.formValues,
      globalVariables: formCtx.globalVariables,
      localVariables: formCtx.localVariables ?? {},
      ...formCtx.entity
    },
    {},
    "active"
  );
}
function evaluateFormExpression(expr, formCtx) {
  const ctx = toSharedContext2(formCtx);
  return evaluate(expr, ctx);
}
function isOrbitalEntitySchema(value) {
  if (value === null || value === void 0 || typeof value !== "object" || Array.isArray(value)) return false;
  const fields = value.fields;
  return Array.isArray(fields);
}
function isPlainEntityRow(value) {
  if (value === null || value === void 0 || typeof value !== "object" || Array.isArray(value)) return false;
  const fields = value.fields;
  return !Array.isArray(fields);
}
function getEnumOptions(field) {
  if (field.options && field.options.length > 0) {
    return [...field.options];
  }
  if (field.values && field.values.length > 0) {
    return field.values.map((v) => ({
      value: v,
      label: v.charAt(0).toUpperCase() + v.slice(1).replace(/_/g, " ")
    }));
  }
  const validation = field.validation;
  if (validation?.enum && validation.enum.length > 0) {
    return validation.enum.map((v) => ({
      value: v,
      label: v.charAt(0).toUpperCase() + v.slice(1).replace(/_/g, " ")
    }));
  }
  return [];
}
function determineInputType(field) {
  if (field.inputType) {
    return field.inputType;
  }
  if (field.type === "relation" || field.relation) {
    return "relation";
  }
  if (field.type === "array") {
    return "array";
  }
  if (field.type === "enum" || field.values || getEnumOptions(field).length > 0) {
    return "select";
  }
  switch (field.type?.toLowerCase()) {
    case "email":
      return "email";
    case "password":
      return "password";
    case "url":
      return "url";
    case "file":
      return "file";
    case "image":
      return "image";
    case "money":
      return "currency";
    case "number":
    case "integer":
    case "float":
      return "number";
    case "date":
      return "date";
    case "datetime":
    case "timestamp":
      return "datetime-local";
    case "boolean":
      return "checkbox";
    case "textarea":
    case "text":
      return field.max && field.max > 200 ? "textarea" : "text";
    default:
      return "text";
  }
}
function formatDateValue(value) {
  if (!value) return "";
  if (value instanceof Date) {
    return value.toISOString().split("T")[0];
  }
  if (typeof value === "string") {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split("T")[0];
    }
    return value;
  }
  return "";
}
function formatDateTimeValue(value) {
  if (!value) return "";
  if (value instanceof Date) {
    return value.toISOString().slice(0, 16);
  }
  if (typeof value === "string") {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return date.toISOString().slice(0, 16);
    }
    return value;
  }
  return "";
}
var layoutStyles, gapStyles9, Form;
var init_Form = __esm({
  "components/core/organisms/Form.tsx"() {
    "use client";
    init_cn();
    init_Input();
    init_Button();
    init_Select();
    init_Textarea();
    init_Checkbox();
    init_Box();
    init_Stack();
    init_Typography();
    init_Icon();
    init_RelationSelect();
    init_TagInput();
    init_UploadDropZone();
    init_Alert();
    init_useEventBus();
    init_debug();
    layoutStyles = {
      vertical: "flex flex-col",
      horizontal: "flex flex-row flex-wrap items-end",
      inline: "flex flex-row flex-wrap items-center"
    };
    gapStyles9 = {
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6"
    };
    Form = ({
      children,
      onSubmit,
      onCancel,
      layout = "vertical",
      gap = "md",
      className,
      // Schema-based props
      entity,
      fields,
      // No `= {}` default: a fresh `{}` evaluated inline on every render
      // would change the prop reference every tick and bust the useMemo
      // cache below (`[entity, initialData]` deps), reigniting the
      // setFormData useEffect on every keystroke and producing an
      // infinite re-render loop with stuck form inputs. The memo and
      // submit handler both handle `undefined` already via the
      // `typeof initialData === 'object'` guard.
      initialData,
      isLoading = false,
      error,
      submitLabel,
      cancelLabel,
      showCancel,
      showSubmit = true,
      title,
      submitEvent = "SAVE",
      cancelEvent = "CANCEL",
      relationsData = {},
      relationsLoading = {},
      fieldOverrides,
      // Inspection form extensions - may come as boolean true from generated code (meaning enabled but config loaded separately)
      conditionalFields: conditionalFieldsRaw = {},
      hiddenCalculations: hiddenCalculationsRaw = [],
      violationTriggers: violationTriggersRaw = [],
      evaluationContext: externalContext,
      sections = [],
      onFieldChange,
      ...props
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolvedSubmitLabel = submitLabel ?? t("common.save");
      const resolvedCancelLabel = cancelLabel ?? t("common.cancel");
      const isSchemaEntity = isOrbitalEntitySchema(entity);
      const resolvedEntity = isSchemaEntity ? entity : void 0;
      const entityName = typeof entity === "string" ? entity : resolvedEntity?.name;
      const normalizedInitialData = React79__default.useMemo(() => {
        const entityRowAsInitial = isPlainEntityRow(entity) ? entity : void 0;
        const callerInitial = initialData !== null && typeof initialData === "object" && !Array.isArray(initialData) ? initialData : {};
        const merged = entityRowAsInitial !== void 0 ? { ...entityRowAsInitial, ...callerInitial } : callerInitial;
        const toId = (value) => {
          if (value === null || value === void 0 || typeof value !== "object" || value instanceof Date) return value;
          if (Array.isArray(value)) {
            return value.map(
              (item) => item !== null && typeof item === "object" && !Array.isArray(item) && !(item instanceof Date) && item.id !== void 0 && item.id !== null ? String(item.id) : item
            );
          }
          return value.id !== void 0 && value.id !== null ? String(value.id) : value;
        };
        const normalized = {};
        for (const [key, value] of Object.entries(merged)) {
          normalized[key] = key === "id" ? value : toId(value);
        }
        return normalized;
      }, [entity, initialData]);
      const entityDerivedFields = React79__default.useMemo(() => {
        if (fields && fields.length > 0) return void 0;
        if (!resolvedEntity) return void 0;
        return resolvedEntity.fields.map(
          (f3) => ({
            name: f3.name,
            type: f3.type,
            required: f3.required,
            // EntityField.default is typed `unknown` upstream — safe cast: schema defaults are always FieldValues.
            defaultValue: f3.default,
            // EntityField is a discriminated union — `values` lives on Scalar/Enum, `relation` lives on Relation.
            values: "values" in f3 ? f3.values : void 0,
            min: f3.min,
            max: f3.max,
            relation: "relation" in f3 ? { entity: f3.relation.entity, cardinality: f3.relation.cardinality } : void 0
          })
        );
      }, [entity, fields]);
      const conditionalFields = typeof conditionalFieldsRaw === "boolean" ? {} : conditionalFieldsRaw;
      const hiddenCalculations = typeof hiddenCalculationsRaw === "boolean" ? [] : hiddenCalculationsRaw;
      const violationTriggers = typeof violationTriggersRaw === "boolean" ? [] : violationTriggersRaw;
      const [formData, setFormData] = React79__default.useState(
        normalizedInitialData
      );
      const [collapsedSections, setCollapsedSections] = React79__default.useState(
        /* @__PURE__ */ new Set()
      );
      const [submitError, setSubmitError] = React79__default.useState(null);
      const formRef = React79__default.useRef(null);
      const formMode = props.mode;
      const mountedRef = React79__default.useRef(false);
      if (!mountedRef.current) {
        mountedRef.current = true;
        debug("forms", "mount", {
          mode: formMode,
          submitEvent,
          cancelEvent,
          fieldNames: (fields ?? []).map((f3) => f3.name ?? f3.field).filter(Boolean),
          initialDataKeys: Object.keys(normalizedInitialData),
          initialData: normalizedInitialData
        });
      }
      const shouldShowCancel = showCancel ?? (fields && fields.length > 0);
      const evalContext = React79__default.useMemo(
        () => ({
          formValues: formData,
          globalVariables: externalContext?.globalVariables ?? {},
          localVariables: externalContext?.localVariables ?? {},
          entity: externalContext?.entity ?? {}
        }),
        [formData, externalContext]
      );
      React79__default.useEffect(() => {
        debug("forms", "initialData-sync", {
          mode: formMode,
          normalizedInitialData,
          prevFormData: formData,
          willSet: Object.keys(normalizedInitialData).length > 0
        });
        if (Object.keys(normalizedInitialData).length > 0) {
          setFormData(normalizedInitialData);
        }
      }, [normalizedInitialData]);
      const processCalculations = React79__default.useCallback(
        (changedFieldId, newFormData) => {
          if (!hiddenCalculations.length) return;
          const context = {
            formValues: newFormData,
            globalVariables: externalContext?.globalVariables ?? {},
            localVariables: externalContext?.localVariables ?? {},
            entity: externalContext?.entity ?? {}
          };
          hiddenCalculations.forEach((calc) => {
            if (calc.triggerFields.includes(changedFieldId)) {
              const value = evaluateFormExpression(calc.expression, context);
              eventBus.emit("UI:GLOBAL_VARIABLE_SET", {
                variable: calc.variableName,
                value
              });
              debug(
                "forms",
                `Calculation triggered: ${calc.variableName} = ${String(value)}`
              );
            }
          });
        },
        [hiddenCalculations, externalContext, eventBus]
      );
      const checkViolations = React79__default.useCallback(
        (changedFieldId, newFormData) => {
          if (!violationTriggers.length) return;
          const context = {
            formValues: newFormData,
            globalVariables: externalContext?.globalVariables ?? {},
            localVariables: externalContext?.localVariables ?? {},
            entity: externalContext?.entity ?? {}
          };
          violationTriggers.forEach((trigger) => {
            const conditionMet = evaluateFormExpression(trigger.condition, context);
            if (conditionMet) {
              eventBus.emit("UI:VIOLATION_DETECTED", {
                fieldId: trigger.fieldId ?? changedFieldId,
                ...trigger.violation
              });
              debug(
                "forms",
                `Violation detected: ${trigger.violation.law} ${trigger.violation.article}`
              );
            }
          });
        },
        [violationTriggers, externalContext, eventBus]
      );
      const handleChange = (name, value) => {
        const newFormData = { ...formData, [name]: value };
        debug("forms", "field-change", { mode: formMode, name, value, prevFormData: formData, newFormData });
        setFormData(newFormData);
        eventBus.emit("UI:FIELD_CHANGED", {
          fieldId: name,
          value,
          formValues: newFormData
        });
        onFieldChange?.({ fieldId: name, value, formValues: newFormData });
        processCalculations(name, newFormData);
        checkViolations(name, newFormData);
      };
      const isFieldVisible = React79__default.useCallback(
        (fieldName2) => {
          const condition = conditionalFields[fieldName2];
          if (!condition) return true;
          return Boolean(evaluateFormExpression(condition, evalContext));
        },
        [conditionalFields, evalContext]
      );
      const isSectionVisible = React79__default.useCallback(
        (section) => {
          if (!section.condition) return true;
          return Boolean(evaluateFormExpression(section.condition, evalContext));
        },
        [evalContext]
      );
      const toggleSection = (sectionId) => {
        setCollapsedSections((prev) => {
          const next = new Set(prev);
          if (next.has(sectionId)) {
            next.delete(sectionId);
          } else {
            next.add(sectionId);
          }
          return next;
        });
      };
      const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitError(null);
        debug("forms", "submit-enter", {
          mode: formMode,
          submitEvent,
          formData,
          normalizedInitialData
        });
        const mergedData = {
          ...normalizedInitialData,
          ...formData
        };
        const payload = { data: mergedData };
        debug("forms", "submit-emit", { mode: formMode, submitEvent: `UI:${submitEvent}`, payloadData: payload.data });
        eventBus.emit(`UI:${submitEvent}`, payload);
        if (onSubmit) {
          eventBus.emit(`UI:${onSubmit}`, payload);
        }
      };
      const handleInvalid = (e) => {
        const target = e.target;
        const fieldName2 = target.getAttribute("data-field-name") ?? target.name ?? "";
        const fieldMessage = target.validationMessage || "Invalid value";
        debug("forms", "invalid", { mode: formMode, fieldName: fieldName2, fieldMessage });
        queueMicrotask(() => {
          const form = formRef.current;
          if (!form) return;
          const invalidEls = Array.from(
            form.querySelectorAll(
              ":invalid"
            )
          );
          if (invalidEls.length === 0) return;
          const missing = invalidEls.map(
            (el) => el.getAttribute("data-field-name") ?? el.name ?? ""
          );
          const messages = invalidEls.map((el) => ({
            field: el.getAttribute("data-field-name") ?? el.name ?? "",
            message: el.validationMessage
          }));
          const summary = missing.length === 1 ? `${missing[0]}: ${messages[0]?.message}` : `Please fix ${missing.length} fields: ${missing.join(", ")}`;
          setSubmitError(summary);
          eventBus.emit("UI:VALIDATION_FAILED", {
            submitEvent,
            missing,
            messages,
            summary
          });
        });
      };
      const handleCancel = () => {
        eventBus.emit(`UI:${cancelEvent}`);
        eventBus.emit("UI:CLOSE");
        if (onCancel) {
          eventBus.emit(`UI:${onCancel}`);
        }
      };
      const renderField = React79__default.useCallback(
        (field) => {
          const fieldName2 = field.name || field.field;
          if (!fieldName2) return null;
          if (!isFieldVisible(fieldName2)) {
            return null;
          }
          const inputType = determineInputType(field);
          const label = field.label || fieldName2.charAt(0).toUpperCase() + fieldName2.slice(1).replace(/([A-Z])/g, " $1");
          const currentValue2 = formData[fieldName2] ?? field.defaultValue ?? "";
          return /* @__PURE__ */ jsxs(VStack, { gap: "xs", "data-field": fieldName2, children: [
            inputType !== "checkbox" && /* @__PURE__ */ jsxs(Typography, { as: "label", variant: "label", weight: "bold", children: [
              label,
              field.required && /* @__PURE__ */ jsx(Typography, { as: "span", color: "error", className: "ml-1", children: "*" })
            ] }),
            renderFieldInput(field, fieldName2, inputType, currentValue2, label),
            field.hint && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: field.hint })
          ] }, fieldName2);
        },
        [formData, isFieldVisible, relationsData, relationsLoading, isLoading]
      );
      const effectiveFields = entityDerivedFields ?? fields;
      const normalizedFields = React79__default.useMemo(() => {
        if (!effectiveFields || effectiveFields.length === 0) return [];
        return effectiveFields.map((field) => {
          if (typeof field === "string") {
            const entityField = resolvedEntity?.fields?.find((f3) => f3.name === field);
            if (entityField) {
              return {
                name: field,
                type: entityField.type,
                required: entityField.required,
                hint: entityField.description,
                // EntityField.default is typed `unknown` upstream — safe cast: schema defaults are always FieldValues.
                defaultValue: entityField.default,
                // EntityField is a discriminated union — `values` lives on Scalar/Enum, `relation` lives on Relation.
                values: "values" in entityField ? entityField.values : void 0,
                min: entityField.min,
                max: entityField.max,
                relation: "relation" in entityField ? { entity: entityField.relation.entity, cardinality: entityField.relation.cardinality } : void 0
              };
            }
            return { name: field, type: "string" };
          }
          return field;
        }).map((field) => {
          const fieldName2 = field.name || field.field;
          const override = fieldOverrides?.find((o) => o.name === fieldName2);
          if (!override) return field;
          return {
            ...field,
            ...override.label !== void 0 ? { label: override.label } : {},
            ...override.placeholder !== void 0 ? { placeholder: override.placeholder } : {},
            ...override.hint !== void 0 ? { hint: override.hint } : {}
          };
        });
      }, [effectiveFields, resolvedEntity, fieldOverrides]);
      const schemaFields = React79__default.useMemo(() => {
        if (normalizedFields.length === 0) return null;
        if (isDebugEnabled()) {
          debugGroup(`Form: ${entityName || "unknown"}`);
          debug(`Fields count: ${normalizedFields.length}`);
          debug("Conditional fields:", Object.keys(conditionalFields));
          debugGroupEnd();
        }
        return normalizedFields.map(renderField).filter(Boolean);
      }, [normalizedFields, renderField, entityName, conditionalFields]);
      const sectionElements = React79__default.useMemo(() => {
        if (!sections || sections.length === 0) return null;
        return sections.map((section) => {
          if (!isSectionVisible(section)) {
            return null;
          }
          const isCollapsed = collapsedSections.has(section.id);
          return /* @__PURE__ */ jsxs(Box, { border: true, rounded: "lg", overflow: "hidden", children: [
            /* @__PURE__ */ jsxs(
              Box,
              {
                className: cn(
                  "px-4 py-3 bg-muted flex items-center justify-between",
                  section.collapsible && "cursor-pointer hover:bg-muted/80"
                ),
                onClick: section.collapsible ? () => toggleSection(section.id) : void 0,
                children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "semibold", children: section.title }),
                  section.collapsible && /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "chevron-down",
                      size: "md",
                      className: cn(
                        "text-muted-foreground transition-transform",
                        isCollapsed && "rotate-180"
                      )
                    }
                  )
                ]
              }
            ),
            !isCollapsed && /* @__PURE__ */ jsx(Box, { padding: "md", children: /* @__PURE__ */ jsx(VStack, { gap: gap === "sm" ? "sm" : gap === "lg" ? "lg" : "md", children: section.fields.map(renderField).filter(Boolean) }) })
          ] }, section.id);
        }).filter(Boolean);
      }, [sections, isSectionVisible, collapsedSections, renderField, gap]);
      function renderFieldInput(field, fieldName2, inputType, currentValue2, label) {
        const commonProps = {
          id: fieldName2,
          name: fieldName2,
          "data-field-name": fieldName2,
          required: field.required,
          disabled: isLoading,
          placeholder: field.placeholder,
          pattern: field.pattern
        };
        switch (inputType) {
          case "checkbox":
            return /* @__PURE__ */ jsx(
              Checkbox,
              {
                ...commonProps,
                label: label + (field.required ? " *" : ""),
                checked: Boolean(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.checked)
              }
            );
          case "textarea":
            return /* @__PURE__ */ jsx(
              Textarea,
              {
                ...commonProps,
                value: String(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value),
                minLength: field.min,
                maxLength: field.max
              }
            );
          case "select": {
            const options = getEnumOptions(field);
            return /* @__PURE__ */ jsx(
              Select,
              {
                ...commonProps,
                options,
                value: String(currentValue2),
                onValueChange: (v) => handleChange(fieldName2, v),
                placeholder: field.placeholder || `Select ${label}...`
              }
            );
          }
          case "relation": {
            const relationOptions = relationsData[fieldName2] || [];
            const relationLoading = relationsLoading[fieldName2] || false;
            if (field.relation?.cardinality !== void 0 && MANY_CARDINALITIES.includes(field.relation.cardinality)) {
              const selectedValues = Array.isArray(currentValue2) ? currentValue2.map((v) => String(v)) : [];
              return /* @__PURE__ */ jsx(
                Select,
                {
                  ...commonProps,
                  multiple: true,
                  searchable: true,
                  clearable: true,
                  options: [...relationOptions],
                  value: selectedValues,
                  onValueChange: (value) => handleChange(fieldName2, Array.isArray(value) ? value : [value]),
                  placeholder: field.placeholder || `Select ${label}...`
                }
              );
            }
            return /* @__PURE__ */ jsx(
              RelationSelect,
              {
                ...commonProps,
                value: currentValue2 ? String(currentValue2) : void 0,
                onChange: (value) => handleChange(fieldName2, value),
                options: relationOptions,
                isLoading: relationLoading,
                placeholder: field.placeholder || `Select ${label}...`,
                searchPlaceholder: `Search ${field.relation?.entity || label}...`,
                clearable: !field.required
              }
            );
          }
          case "array": {
            const arrayValue = Array.isArray(currentValue2) ? currentValue2.map((v) => String(v)) : currentValue2 != null && currentValue2 !== "" ? [String(currentValue2)] : [];
            return /* @__PURE__ */ jsx(
              TagInput,
              {
                placeholder: field.placeholder,
                disabled: isLoading,
                value: arrayValue,
                onChange: (next) => handleChange(fieldName2, [...next])
              }
            );
          }
          case "number":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "number",
                value: currentValue2 !== void 0 && currentValue2 !== "" ? String(currentValue2) : "",
                onChange: (e) => handleChange(
                  fieldName2,
                  e.target.value ? Number(e.target.value) : void 0
                ),
                min: field.min,
                max: field.max
              }
            );
          case "currency":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "number",
                step: "0.01",
                icon: DollarSign,
                value: currentValue2 !== void 0 && currentValue2 !== "" ? String(currentValue2) : "",
                onChange: (e) => handleChange(
                  fieldName2,
                  e.target.value ? Number(e.target.value) : void 0
                ),
                min: field.min,
                max: field.max
              }
            );
          case "file":
            return /* @__PURE__ */ jsx(
              UploadDropZone,
              {
                accept: field.pattern,
                maxFiles: 1,
                disabled: isLoading,
                onFiles: (files) => {
                  const f3 = files[0];
                  if (!f3) return;
                  const reader = new FileReader();
                  reader.onload = () => handleChange(fieldName2, {
                    name: f3.name,
                    mimeType: f3.type,
                    sizeBytes: f3.size,
                    url: typeof reader.result === "string" ? reader.result : ""
                  });
                  reader.readAsDataURL(f3);
                }
              }
            );
          case "image": {
            const imageUrl = typeof currentValue2 === "string" ? currentValue2 : "";
            return /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
              imageUrl ? /* @__PURE__ */ jsx(
                "img",
                {
                  src: imageUrl,
                  alt: "",
                  "aria-hidden": "true",
                  className: "h-24 w-full max-w-xs rounded-md border border-border object-cover",
                  "data-testid": `image-preview-${fieldName2}`
                }
              ) : null,
              /* @__PURE__ */ jsx(
                UploadDropZone,
                {
                  accept: "image/*",
                  maxFiles: 1,
                  maxSize: 2 * 1024 * 1024,
                  disabled: isLoading,
                  onFiles: (files) => {
                    const f3 = files[0];
                    if (!f3) return;
                    const reader = new FileReader();
                    reader.onload = () => handleChange(
                      fieldName2,
                      typeof reader.result === "string" ? reader.result : ""
                    );
                    reader.readAsDataURL(f3);
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                Input,
                {
                  ...commonProps,
                  type: "url",
                  placeholder: t("form.imageUrlFallback"),
                  value: imageUrl,
                  onChange: (e) => handleChange(fieldName2, e.target.value)
                }
              )
            ] });
          }
          case "date":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "date",
                value: formatDateValue(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value)
              }
            );
          case "datetime-local":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "datetime-local",
                value: formatDateTimeValue(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value)
              }
            );
          case "email":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "email",
                value: String(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value),
                minLength: field.min,
                maxLength: field.max
              }
            );
          case "url":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "url",
                value: String(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value),
                minLength: field.min,
                maxLength: field.max
              }
            );
          case "password":
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "password",
                value: String(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value),
                minLength: field.min,
                maxLength: field.max
              }
            );
          case "text":
          default:
            return /* @__PURE__ */ jsx(
              Input,
              {
                ...commonProps,
                type: "text",
                value: String(currentValue2),
                onChange: (e) => handleChange(fieldName2, e.target.value),
                minLength: field.min,
                maxLength: field.max
              }
            );
        }
      }
      return /* @__PURE__ */ jsxs(
        "form",
        {
          ref: formRef,
          "data-pattern": "form-section",
          className: cn(layoutStyles[layout], gapStyles9[gap], className),
          onSubmit: handleSubmit,
          onInvalid: handleInvalid,
          ...props,
          children: [
            submitError && /* @__PURE__ */ jsx(Alert, { variant: "error", className: "mb-4", children: submitError }),
            error && /* @__PURE__ */ jsx(Alert, { variant: "error", className: "mb-4", children: error.message || t("error.occurred") }),
            sectionElements && sectionElements.length > 0 && /* @__PURE__ */ jsx(VStack, { gap: gap === "sm" ? "sm" : gap === "lg" ? "lg" : "md", children: sectionElements }),
            schemaFields,
            children,
            (schemaFields && schemaFields.length > 0 || sectionElements && sectionElements.length > 0) && (showSubmit || shouldShowCancel) && /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "pt-4", children: [
              showSubmit && /* @__PURE__ */ jsx(
                Button,
                {
                  type: "submit",
                  variant: "primary",
                  disabled: isLoading,
                  "data-event": submitEvent,
                  "data-testid": `action-${submitEvent}`,
                  children: isLoading ? t("form.saving") : resolvedSubmitLabel
                }
              ),
              shouldShowCancel && /* @__PURE__ */ jsx(
                Button,
                {
                  type: "button",
                  variant: "secondary",
                  onClick: handleCancel,
                  disabled: isLoading,
                  "data-event": cancelEvent,
                  "data-testid": `action-${cancelEvent}`,
                  children: resolvedCancelLabel
                }
              )
            ] })
          ]
        }
      );
    };
    Form.displayName = "Form";
  }
});
var GenericAppTemplate;
var init_GenericAppTemplate = __esm({
  "components/core/templates/GenericAppTemplate.tsx"() {
    init_cn();
    init_Box();
    init_Stack();
    init_Typography();
    GenericAppTemplate = ({
      entity,
      title,
      subtitle,
      children,
      headerActions,
      footer,
      className
    }) => {
      return /* @__PURE__ */ jsxs(Box, { display: "flex", fullHeight: true, className: cn("flex-col", className), children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            padding: "md",
            border: true,
            className: "border-b-2 border-x-0 border-t-0 border-border flex items-center justify-between flex-shrink-0",
            children: [
              /* @__PURE__ */ jsxs(Box, { children: [
                /* @__PURE__ */ jsx(Typography, { variant: "h3", children: title }),
                subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "secondary", className: "mt-1", children: subtitle })
              ] }),
              headerActions && /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: headerActions })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { fullWidth: true, overflow: "auto", className: "flex-1", children: /* @__PURE__ */ jsx(Box, { padding: "lg", children }) }),
        footer && /* @__PURE__ */ jsx(
          Box,
          {
            padding: "md",
            border: true,
            bg: "muted",
            className: "border-t-2 border-x-0 border-b-0 border-border flex-shrink-0",
            children: footer
          }
        )
      ] });
    };
    GenericAppTemplate.displayName = "GenericAppTemplate";
  }
});
var HeroOrganism, _HeroClickInterceptor;
var init_HeroOrganism = __esm({
  "components/marketing/organisms/HeroOrganism.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_HeroSection();
    init_LoadingState();
    init_ErrorState();
    HeroOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      children
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolved = useMemo(
        () => Array.isArray(entity) ? entity[0] : entity && typeof entity === "object" ? entity : void 0,
        [entity]
      );
      const primaryAction = resolved?.primaryAction;
      const secondaryAction = resolved?.secondaryAction;
      const handlePrimaryClick = useCallback(() => {
        if (primaryAction) {
          eventBus.emit("UI:CTA_PRIMARY", {
            label: String(primaryAction.label ?? ""),
            href: String(primaryAction.href ?? "")
          });
        }
      }, [eventBus, primaryAction]);
      const handleSecondaryClick = useCallback(() => {
        if (secondaryAction) {
          eventBus.emit("UI:CTA_SECONDARY", {
            label: String(secondaryAction.label ?? ""),
            href: String(secondaryAction.href ?? "")
          });
        }
      }, [eventBus, secondaryAction]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      if (!resolved) {
        return null;
      }
      const imageRaw = resolved.image;
      const image = imageRaw ? { src: String(imageRaw.src ?? ""), alt: String(imageRaw.alt ?? "") } : void 0;
      return /* @__PURE__ */ jsxs(
        HeroSection,
        {
          tag: resolved.tag != null ? String(resolved.tag) : void 0,
          title: String(resolved.title ?? ""),
          titleAccent: resolved.titleAccent != null ? String(resolved.titleAccent) : void 0,
          subtitle: String(resolved.subtitle ?? ""),
          primaryAction: primaryAction ? { label: String(primaryAction.label ?? ""), href: String(primaryAction.href ?? "") } : void 0,
          secondaryAction: secondaryAction ? { label: String(secondaryAction.label ?? ""), href: String(secondaryAction.href ?? "") } : void 0,
          installCommand: resolved.installCommand != null ? String(resolved.installCommand) : void 0,
          image,
          imagePosition: resolved.imagePosition,
          background: resolved.background,
          className: cn(className),
          children: [
            children,
            /* @__PURE__ */ jsx(
              _HeroClickInterceptor,
              {
                hasPrimary: !!primaryAction,
                hasSecondary: !!secondaryAction,
                onPrimaryClick: handlePrimaryClick,
                onSecondaryClick: handleSecondaryClick
              }
            )
          ]
        }
      );
    };
    HeroOrganism.displayName = "HeroOrganism";
    _HeroClickInterceptor = ({ hasPrimary, hasSecondary, onPrimaryClick, onSecondaryClick }) => {
      const handleCapture = useCallback(
        (e) => {
          const target = e.target;
          const button = target.closest("button");
          if (!button) return;
          const isPrimary = button.classList.contains("bg-primary") || button.getAttribute("data-variant") === "primary";
          const isSecondary = button.classList.contains("bg-secondary") || button.getAttribute("data-variant") === "secondary";
          if (isPrimary && hasPrimary) {
            onPrimaryClick();
          } else if (isSecondary && hasSecondary) {
            onSecondaryClick();
          } else if (hasPrimary && !isSecondary) {
            onPrimaryClick();
          }
        },
        [hasPrimary, hasSecondary, onPrimaryClick, onSecondaryClick]
      );
      return /* @__PURE__ */ jsx(
        "span",
        {
          onClickCapture: handleCapture,
          style: { display: "contents" },
          "aria-hidden": "true"
        }
      );
    };
    _HeroClickInterceptor.displayName = "_HeroClickInterceptor";
  }
});
var LandingPageTemplate;
var init_LandingPageTemplate = __esm({
  "components/marketing/templates/LandingPageTemplate.tsx"() {
    init_cn();
    init_Stack();
    init_Box();
    init_Container();
    init_HeroSection();
    init_FeatureGrid();
    init_StatsGrid();
    init_StepFlow();
    init_ShowcaseCard();
    init_SimpleGrid();
    init_CTABanner();
    init_CommunityLinks();
    init_SectionHeader();
    LandingPageTemplate = ({
      entity,
      featureColumns = 3,
      className
    }) => {
      const { t } = useTranslate();
      const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
      if (!resolved) return null;
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("w-full", className), children: [
        resolved.hero && /* @__PURE__ */ jsx(
          HeroSection,
          {
            tag: resolved.hero.tag,
            title: resolved.hero.title,
            titleAccent: resolved.hero.titleAccent,
            subtitle: resolved.hero.subtitle,
            primaryAction: resolved.hero.primaryAction,
            secondaryAction: resolved.hero.secondaryAction,
            installCommand: resolved.hero.installCommand,
            image: resolved.hero.image,
            imagePosition: resolved.hero.imagePosition,
            background: resolved.hero.background
          }
        ),
        Array.isArray(resolved.features) && resolved.features.length > 0 && /* @__PURE__ */ jsx(Box, { className: "bg-muted/20 py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          /* @__PURE__ */ jsx(SectionHeader, { title: t("template.features") }),
          /* @__PURE__ */ jsx(
            FeatureGrid,
            {
              items: resolved.features.map((f3) => ({
                icon: f3.icon,
                title: f3.title,
                description: f3.description,
                href: f3.href
              })),
              columns: featureColumns
            }
          )
        ] }) }) }),
        resolved.stats && resolved.stats.length > 0 && /* @__PURE__ */ jsx(Box, { className: "py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsx(
          StatsGrid,
          {
            stats: resolved.stats.map((s) => ({
              value: s.value,
              label: s.label
            }))
          }
        ) }) }),
        resolved.steps && resolved.steps.length > 0 && /* @__PURE__ */ jsx(Box, { className: "bg-muted/20 py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          /* @__PURE__ */ jsx(SectionHeader, { title: t("template.howItWorks") }),
          /* @__PURE__ */ jsx(
            StepFlow,
            {
              steps: resolved.steps.map((s, i) => ({
                number: i + 1,
                title: s.title,
                description: s.description,
                icon: s.icon
              }))
            }
          )
        ] }) }) }),
        resolved.showcase && resolved.showcase.length > 0 && /* @__PURE__ */ jsx(Box, { className: "py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          /* @__PURE__ */ jsx(SectionHeader, { title: t("template.showcase") }),
          /* @__PURE__ */ jsx(SimpleGrid, { cols: Math.min(resolved.showcase.length, 3), gap: "lg", children: resolved.showcase.map((item) => /* @__PURE__ */ jsx(
            ShowcaseCard,
            {
              title: item.title,
              description: item.description,
              image: item.image,
              href: item.href,
              badge: item.badge
            },
            item.id
          )) })
        ] }) }) }),
        /* @__PURE__ */ jsx(
          CTABanner,
          {
            title: resolved.ctaTitle,
            subtitle: resolved.ctaSubtitle,
            primaryAction: resolved.ctaPrimaryAction,
            secondaryAction: resolved.ctaSecondaryAction,
            background: "dark"
          }
        ),
        (resolved.communityGithub ?? resolved.communityDiscord) && /* @__PURE__ */ jsx(Box, { className: "bg-foreground text-background py-12", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsx(
          CommunityLinks,
          {
            github: resolved.communityGithub ? { url: resolved.communityGithub } : void 0,
            discord: resolved.communityDiscord ? { url: resolved.communityDiscord } : void 0,
            heading: "Join the Community"
          }
        ) }) })
      ] });
    };
    LandingPageTemplate.displayName = "LandingPageTemplate";
  }
});
function normalizeFields2(fields) {
  if (!fields) return [];
  return fields.map((f3) => typeof f3 === "string" ? f3 : f3.key ?? f3.name ?? "");
}
function entityFieldsFromListItem(item) {
  const {
    icon: _icon,
    metadata: _metadata,
    onClick: _onClick,
    avatar: _avatar,
    _fields,
    ...rest
  } = item;
  const result = {};
  for (const [key, value] of Object.entries(rest)) {
    if (typeof value === "function" || value !== null && typeof value === "object" && "$$typeof" in value) {
      continue;
    }
    result[key] = value;
  }
  if (_fields && typeof _fields === "object") {
    for (const [k, v] of Object.entries(_fields)) {
      if (typeof v !== "function") {
        result[k] = v;
      }
    }
  }
  return result;
}
function getStatusStyle(fieldName2, value) {
  const val = String(value).toLowerCase();
  if (val.includes("complete") || val.includes("done"))
    return STATUS_STYLES.complete;
  if (val.includes("active") || val.includes("progress"))
    return STATUS_STYLES.active;
  if (val.includes("pending") || val.includes("waiting"))
    return STATUS_STYLES.pending;
  if (val.includes("block") || val.includes("cancel"))
    return STATUS_STYLES.blocked;
  if (val.includes("high") || val.includes("urgent")) return STATUS_STYLES.high;
  if (val.includes("medium") || val.includes("normal"))
    return STATUS_STYLES.medium;
  if (val.includes("low")) return STATUS_STYLES.low;
  return STATUS_STYLES.default;
}
function formatValue3(value, fieldName2) {
  if (typeof value === "number") {
    if (fieldName2.toLowerCase().includes("progress") || fieldName2.toLowerCase().includes("percent")) {
      return `${value}%`;
    }
    if (fieldName2.toLowerCase().includes("budget") || fieldName2.toLowerCase().includes("cost")) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
      }).format(value);
    }
    return value.toLocaleString();
  }
  if (value instanceof Date) {
    return value.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric"
    });
  }
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return new Date(value).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric"
    });
  }
  return String(value);
}
function formatFieldLabel2(fieldName2) {
  return humanizeFieldName(fieldName2).replace(/\sId$/, "").trim();
}
var STATUS_STYLES, StatusBadge, ProgressIndicator, List3;
var init_List = __esm({
  "components/core/organisms/List.tsx"() {
    "use client";
    init_atoms();
    init_Stack();
    init_Menu();
    init_EmptyState();
    init_LoadingState();
    init_cn();
    init_format();
    init_getNestedValue();
    init_useEventBus();
    init_types2();
    STATUS_STYLES = {
      complete: {
        bg: "bg-success/10",
        text: "text-success",
        dot: "bg-success ring-4 ring-success/20",
        border: "border-success/30"
      },
      active: {
        bg: "bg-info/10",
        text: "text-info",
        dot: "bg-info ring-4 ring-info/20",
        border: "border-info/30"
      },
      pending: {
        bg: "bg-warning/10",
        text: "text-warning",
        dot: "bg-warning ring-4 ring-warning/20",
        border: "border-warning/30"
      },
      blocked: {
        bg: "bg-error/10",
        text: "text-error",
        dot: "bg-error ring-4 ring-error/20",
        border: "border-error/30"
      },
      high: {
        bg: "bg-warning/10",
        text: "text-warning",
        dot: "bg-warning ring-4 ring-warning/20",
        border: "border-warning/30"
      },
      medium: {
        bg: "bg-accent/10",
        text: "text-accent",
        dot: "bg-accent ring-4 ring-accent/20",
        border: "border-accent/30"
      },
      low: {
        bg: "bg-muted",
        text: "text-muted-foreground",
        dot: "bg-muted-foreground ring-4 ring-muted-foreground/20",
        border: "border-border"
      },
      default: {
        bg: "bg-muted",
        text: "text-muted-foreground",
        dot: "bg-muted-foreground ring-4 ring-muted-foreground/20",
        border: "border-border"
      }
    };
    StatusBadge = ({
      value,
      fieldName: fieldName2
    }) => {
      const style = getStatusStyle(fieldName2, value);
      return /* @__PURE__ */ jsxs(
        Typography,
        {
          as: "span",
          className: cn(
            "inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-semibold tracking-wide",
            "border shadow-sm backdrop-blur-sm transition-colors",
            style.bg,
            style.text,
            style.border
          ),
          children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                as: "span",
                className: cn(
                  "w-1.5 h-1.5 rounded-full shadow-sm",
                  style.dot
                )
              }
            ),
            value
          ]
        }
      );
    };
    ProgressIndicator = ({ value }) => {
      const clampedValue = Math.min(100, Math.max(0, value));
      return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 min-w-[100px]", children: [
        /* @__PURE__ */ jsx(Box, { className: "flex-1 h-1.5 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "h-full rounded-full transition-all duration-slow",
              clampedValue >= 100 ? "bg-success" : clampedValue >= 70 ? "bg-info" : clampedValue >= 40 ? "bg-warning" : "bg-muted-foreground"
            ),
            style: { width: `${clampedValue}%` }
          }
        ) }),
        /* @__PURE__ */ jsxs(
          Typography,
          {
            as: "span",
            className: "text-xs font-medium text-muted-foreground tabular-nums w-8 text-right",
            children: [
              clampedValue,
              "%"
            ]
          }
        )
      ] });
    };
    List3 = ({
      entity,
      isLoading = false,
      error,
      selectable = false,
      selectedIds = [],
      itemActions,
      emptyMessage,
      className,
      renderItem: customRenderItem,
      fields,
      fieldNames,
      entityType
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const resolvedEmptyMessage = emptyMessage ?? t("empty.noData");
      const effectiveFieldNames = normalizeFields2(fields).length > 0 ? normalizeFields2(fields) : fieldNames;
      const rawItems = useMemo(() => {
        if (Array.isArray(entity)) return entity;
        if (entity && typeof entity === "object" && "id" in entity) return [entity];
        return [];
      }, [entity]);
      const getItemActions = React79__default.useCallback(
        (item) => {
          if (!itemActions) return [];
          if (typeof itemActions === "function") {
            return itemActions(item);
          }
          return itemActions.map((action, idx) => ({
            id: `${item.id}-action-${idx}`,
            label: action.label,
            event: action.event,
            onClick: () => {
              const row = entityFieldsFromListItem(item);
              if (action.navigatesTo) {
                const url = action.navigatesTo.replace(
                  /\{\{(\w+)\}\}/g,
                  (_, key) => String(row[key] ?? item.id ?? "")
                );
                eventBus.emit("UI:NAVIGATE", { url, row });
                return;
              }
              if (action.event) {
                eventBus.emit(`UI:${action.event}`, { row });
              }
            }
          }));
        },
        [itemActions, eventBus]
      );
      const normalizedItemActions = itemActions ? getItemActions : void 0;
      if (isLoading) {
        return /* @__PURE__ */ jsx(
          LoadingState,
          {
            message: t("error.loadingItems"),
            className
          }
        );
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            icon: Package,
            title: t("error.somethingWentWrong"),
            description: error.message,
            className
          }
        );
      }
      const safeItems = Array.isArray(rawItems) ? rawItems.map((item, index) => {
        if (typeof item === "object" && item !== null) {
          const normalizedItem = {
            ...item,
            id: item.id || `item-${index}`
          };
          if (effectiveFieldNames && effectiveFieldNames.length > 0) {
            const firstField = effectiveFieldNames[0];
            if (!normalizedItem.title && getNestedValue(item, firstField)) {
              normalizedItem.title = String(
                getNestedValue(item, firstField)
              );
            }
            normalizedItem._fields = effectiveFieldNames.reduce(
              (acc, field) => {
                const value = getNestedValue(item, field);
                if (value !== void 0 && value !== null) {
                  acc[field] = value;
                }
                return acc;
              },
              {}
            );
          }
          return normalizedItem;
        }
        return { id: `item-${index}`, title: String(item) };
      }) : [];
      const handleSelect = (itemId, checked) => {
        if (!selectable) return;
        const currentIds = [...selectedIds].map(String);
        if (checked) {
          const newIds = [...currentIds, itemId];
          eventBus.emit(`UI:${EntityDisplayEvents.SELECT}`, { ids: newIds });
        } else {
          const newIds = currentIds.filter((id) => id !== itemId);
          eventBus.emit(`UI:${EntityDisplayEvents.DESELECT}`, { ids: newIds });
        }
      };
      const defaultRenderItem = (item, index, isLast) => {
        const isSelected = selectedIds.map(String).includes(item.id);
        const actions = normalizedItemActions ? normalizedItemActions(item) : [];
        actions.length > 0;
        const viewAction = actions.find(
          (a) => a.label.toLowerCase().includes("view") || a.label.toLowerCase() === "open"
        );
        const editAction = actions.find(
          (a) => a.label.toLowerCase().includes("edit")
        );
        const hasExplicitClick = !!(viewAction?.event || item.onClick);
        const rowAction = viewAction?.event ?? "VIEW";
        const rowActionPayload = { row: entityFieldsFromListItem(item) };
        const primaryField = effectiveFieldNames?.[0];
        const statusField = effectiveFieldNames?.find(
          (f3) => f3.toLowerCase().includes("status")
        );
        const priorityField = effectiveFieldNames?.find(
          (f3) => f3.toLowerCase().includes("priority")
        );
        const progressField = effectiveFieldNames?.find(
          (f3) => f3.toLowerCase().includes("progress") || f3.toLowerCase().includes("percent")
        );
        const dateFields = effectiveFieldNames?.filter(
          (f3) => f3.toLowerCase().includes("date") || f3.toLowerCase().includes("due")
        ) || [];
        const metadataFields = effectiveFieldNames?.filter(
          (f3) => f3 !== primaryField && f3 !== statusField && f3 !== priorityField && f3 !== progressField && !dateFields.includes(f3)
        ).slice(0, 2) || [];
        const statusValue = statusField ? item._fields?.[statusField] : null;
        statusValue ? getStatusStyle(statusField, String(statusValue)) : null;
        const progressValue = progressField ? item._fields?.[progressField] : null;
        const hasProgress = typeof progressValue === "number";
        return /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              className: cn(
                "group flex items-center gap-5 px-6 py-5",
                "transition-all duration-normal ease-standard",
                hasExplicitClick && "cursor-pointer",
                // Hover state
                "hover:bg-muted/80",
                // Selected state
                isSelected && "bg-primary/10 shadow-inner",
                item.disabled && "opacity-50 cursor-not-allowed grayscale"
              ),
              action: rowAction,
              actionPayload: rowActionPayload,
              children: [
                selectable && /* @__PURE__ */ jsx(
                  Box,
                  {
                    className: "flex-shrink-0 pt-0.5",
                    action: isSelected ? EntityDisplayEvents.DESELECT : EntityDisplayEvents.SELECT,
                    actionPayload: { ids: isSelected ? selectedIds.filter((sid) => String(sid) !== item.id) : [...selectedIds.map(String), item.id] },
                    children: /* @__PURE__ */ jsx(
                      Checkbox,
                      {
                        checked: isSelected,
                        onChange: (e) => handleSelect(item.id, e.target.checked),
                        className: cn(
                          "transition-transform active:scale-95",
                          isSelected ? "border-primary bg-primary" : "border-border"
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0 space-y-2.5", children: [
                  /* @__PURE__ */ jsxs(HStack, { className: "flex items-center gap-4", children: [
                    /* @__PURE__ */ jsx(
                      Typography,
                      {
                        as: "h3",
                        className: cn(
                          "text-base font-semibold text-foreground truncate flex-1",
                          "tracking-tight leading-snug",
                          item.completed && "line-through text-muted-foreground"
                        ),
                        children: item.title || "Untitled"
                      }
                    ),
                    /* @__PURE__ */ jsxs(HStack, { className: "flex items-center gap-2 flex-shrink-0", children: [
                      !!statusValue && /* @__PURE__ */ jsx(
                        StatusBadge,
                        {
                          value: String(statusValue),
                          fieldName: statusField
                        }
                      ),
                      !!(priorityField && item._fields?.[priorityField]) && /* @__PURE__ */ jsx(
                        StatusBadge,
                        {
                          value: String(item._fields[priorityField]),
                          fieldName: priorityField
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ jsxs(HStack, { className: "flex items-center gap-6 text-sm font-medium text-muted-foreground", children: [
                    dateFields.slice(0, 1).map((field) => {
                      const value = item._fields?.[field];
                      if (!value) return null;
                      return /* @__PURE__ */ jsxs(
                        Typography,
                        {
                          as: "span",
                          className: "flex items-center gap-2 text-muted-foreground group-hover:text-foreground transition-colors",
                          children: [
                            /* @__PURE__ */ jsx(Calendar, { className: "w-3.5 h-3.5" }),
                            /* @__PURE__ */ jsx(Typography, { as: "span", children: formatValue3(value, field) })
                          ]
                        },
                        field
                      );
                    }),
                    metadataFields.map((field, i) => {
                      const value = item._fields?.[field];
                      if (value === void 0 || value === null) return null;
                      return /* @__PURE__ */ jsxs(
                        Typography,
                        {
                          as: "span",
                          className: "truncate flex items-center gap-1.5 text-muted-foreground",
                          children: [
                            /* @__PURE__ */ jsxs(Typography, { as: "span", className: "opacity-75", children: [
                              formatFieldLabel2(field),
                              ":"
                            ] }),
                            /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-foreground", children: formatValue3(value, field) })
                          ]
                        },
                        field
                      );
                    }),
                    hasProgress && /* @__PURE__ */ jsx(Box, { className: "ml-auto", children: /* @__PURE__ */ jsx(ProgressIndicator, { value: progressValue }) })
                  ] })
                ] }),
                /* @__PURE__ */ jsxs(HStack, { className: "flex items-center gap-1 flex-shrink-0", children: [
                  editAction && /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      action: editAction.event,
                      className: cn(
                        "p-2 rounded-lg transition-all duration-fast",
                        "hover:bg-primary/10 hover:text-primary",
                        "text-muted-foreground",
                        "active:scale-95"
                      ),
                      title: editAction.label,
                      "data-testid": editAction.event ? `action-${editAction.event}` : void 0,
                      children: /* @__PURE__ */ jsx(Pencil, { className: "w-4 h-4" })
                    }
                  ),
                  viewAction && /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      action: viewAction.event,
                      className: cn(
                        "p-2 rounded-lg transition-all duration-fast",
                        "hover:bg-muted hover:text-foreground",
                        "text-muted-foreground",
                        "active:scale-95"
                      ),
                      title: viewAction.label,
                      "data-testid": viewAction.event ? `action-${viewAction.event}` : void 0,
                      children: /* @__PURE__ */ jsx(Eye, { className: "w-4 h-4" })
                    }
                  ),
                  (() => {
                    const filteredActions = actions.filter(
                      (a) => !a.label.toLowerCase().includes("edit") && !a.label.toLowerCase().includes("view") && !a.label.toLowerCase().includes("open")
                    );
                    return filteredActions.length > 0 ? /* @__PURE__ */ jsx(
                      Menu,
                      {
                        trigger: /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: "ghost",
                            className: cn(
                              "p-2 rounded-lg transition-all duration-fast",
                              "hover:bg-muted hover:shadow-sm",
                              "text-muted-foreground hover:text-foreground",
                              "active:scale-95"
                            ),
                            children: /* @__PURE__ */ jsx(MoreHorizontal, { className: "w-4 h-4" })
                          }
                        ),
                        items: filteredActions,
                        position: "bottom-right"
                      }
                    ) : null;
                  })(),
                  hasExplicitClick && /* @__PURE__ */ jsx(ChevronRight, { className: "w-4 h-4 text-muted-foreground/50 group-hover:text-muted-foreground group-hover:translate-x-0.5 transition-all" })
                ] })
              ]
            }
          ),
          !isLast && /* @__PURE__ */ jsx(Box, { className: "ml-[calc(1.5rem)] mr-6 border-b border-border/40" })
        ] }, item.id);
      };
      if (safeItems.length === 0) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            icon: Package,
            title: t("error.noItemsFound"),
            description: resolvedEmptyMessage,
            className
          }
        );
      }
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: cn(
            // Container with refined styling
            "bg-card backdrop-blur-sm",
            "rounded-xl",
            // Increased rounding
            "border border-border",
            "shadow-lg",
            // Softer, improved shadow
            "overflow-hidden",
            className
          ),
          children: safeItems.map(
            (item, index) => customRenderItem ? customRenderItem(item, index) : defaultRenderItem(item, index, index === safeItems.length - 1)
          )
        }
      );
    };
    List3.displayName = "List";
  }
});
function MasterDetail({
  entity,
  masterFields,
  detailFields: _detailFields,
  // Captured but not used here - detail handled separately
  loading: externalLoading,
  isLoading: externalIsLoading,
  error: externalError,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const loading = externalLoading ?? false;
  const isLoading = externalIsLoading ?? false;
  const error = externalError ?? null;
  return /* @__PURE__ */ jsx(
    DataTable,
    {
      fields: masterFields,
      columns: masterFields,
      entity,
      isLoading: loading || isLoading,
      error,
      className,
      emptyTitle: t("table.empty.title"),
      emptyDescription: t("empty.createFirst"),
      ...rest
    }
  );
}
var init_MasterDetail = __esm({
  "components/core/organisms/MasterDetail.tsx"() {
    "use client";
    init_DataTable();
    MasterDetail.displayName = "MasterDetail";
  }
});
var DefaultEmptyDetail, MasterDetailLayout;
var init_MasterDetailLayout = __esm({
  "components/core/organisms/layout/MasterDetailLayout.tsx"() {
    init_cn();
    init_Typography();
    DefaultEmptyDetail = () => {
      const { t } = useTranslate();
      return /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center h-full border-2 border-dashed border-border", children: /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "body2",
          className: "text-muted-foreground",
          children: t("masterDetail.selectItem")
        }
      ) });
    };
    MasterDetailLayout = ({
      master,
      detail,
      emptyDetail,
      hasSelection = false,
      masterWidth = "350px",
      className,
      masterClassName,
      detailClassName
    }) => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn("w-full h-full md:grid md:grid-cols-[var(--master-detail-cols)]", className),
          style: { "--master-detail-cols": `${masterWidth} 1fr` },
          children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "border-r border-border overflow-auto",
                  hasSelection && "hidden md:block",
                  masterClassName
                ),
                children: master
              }
            ),
            /* @__PURE__ */ jsx("div", { className: cn("overflow-auto", !hasSelection && "hidden md:block", detailClassName), children: hasSelection ? detail : emptyDetail || /* @__PURE__ */ jsx(DefaultEmptyDetail, {}) })
          ]
        }
      );
    };
    MasterDetailLayout.displayName = "MasterDetailLayout";
  }
});
var COLUMN_CLASSES, ASPECT_CLASSES, MediaGallery;
var init_MediaGallery = __esm({
  "components/core/organisms/MediaGallery.tsx"() {
    "use client";
    init_getNestedValue();
    init_cn();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    init_useEventBus();
    COLUMN_CLASSES = {
      2: "grid-cols-2",
      3: "grid-cols-2 sm:grid-cols-3",
      4: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4",
      5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
      6: "grid-cols-3 sm:grid-cols-4 lg:grid-cols-6"
    };
    ASPECT_CLASSES = {
      square: "aspect-square",
      landscape: "aspect-video",
      portrait: "aspect-[3/4]"
    };
    MediaGallery = ({
      title,
      items: propItems,
      columns = 3,
      selectable = false,
      selectedItems = [],
      selectionEvent = "SELECTION_CHANGE",
      showUpload = false,
      actions,
      aspectRatio = "square",
      entity,
      isLoading = false,
      error,
      className
    }) => {
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const [lightboxItem, setLightboxItem] = useState(null);
      const [failedIds, setFailedIds] = useState(/* @__PURE__ */ new Set());
      const closeLightbox = useCallback(() => setLightboxItem(null), []);
      useEventListener("UI:LIGHTBOX_CLOSE", closeLightbox);
      const handleImageError = useCallback((id) => {
        setFailedIds((prev) => {
          if (prev.has(id)) return prev;
          const next = new Set(prev);
          next.add(id);
          return next;
        });
      }, []);
      const handleItemClick = useCallback(
        (item) => {
          if (selectable) {
            const isSelected = selectedItems.includes(item.id);
            const newSelection = isSelected ? selectedItems.filter((id) => id !== item.id) : [...selectedItems, item.id];
            eventBus.emit(`UI:${selectionEvent}`, { selection: newSelection });
          } else {
            setLightboxItem(item);
          }
          eventBus.emit("UI:MEDIA_SELECT", { row: item });
        },
        [selectable, selectedItems, selectionEvent, eventBus]
      );
      const entityData = Array.isArray(entity) ? entity : [];
      const items = React79__default.useMemo(() => {
        if (propItems && propItems.length > 0) return propItems;
        if (entityData.length === 0) return [];
        return entityData.map((record, idx) => {
          return {
            id: String(record.id ?? idx),
            src: resolveImageUrl(record.src ?? ("url" in record ? record.url : void 0) ?? ("image" in record ? record.image : void 0)) ?? "",
            alt: record.alt ? String(record.alt) : void 0,
            thumbnail: resolveImageUrl(record.thumbnail),
            caption: record.caption ? String(record.caption) : "title" in record ? String(record.title) : void 0
          };
        });
      }, [propItems, entityData]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.galleryError"),
            message: error.message,
            className
          }
        );
      }
      if (items.length === 0 && !showUpload) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            icon: Image$1,
            title: t("display.noMedia"),
            description: t("mediaGallery.noMediaDescription"),
            className
          }
        );
      }
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Card, { className: cn("p-6", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
          (title || showUpload || actions && actions.length > 0) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
            title && /* @__PURE__ */ jsx(Typography, { variant: "h5", weight: "semibold", children: title }),
            /* @__PURE__ */ jsxs(HStack, { gap: "sm", children: [
              showUpload && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "secondary",
                  size: "sm",
                  icon: Upload,
                  action: "MEDIA_UPLOAD",
                  children: t("mediaGallery.upload")
                }
              ),
              actions?.map((action, idx) => /* @__PURE__ */ jsx(
                Box,
                {
                  action: action.event,
                  className: "cursor-pointer hover:opacity-80 transition-opacity",
                  children: /* @__PURE__ */ jsx(Badge, { variant: "default", children: action.label })
                },
                idx
              ))
            ] })
          ] }),
          selectable && selectedItems.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: /* @__PURE__ */ jsx(Badge, { variant: "info", children: t("table.bulk.selected", { count: selectedItems.length }) }) }),
          /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "grid gap-3",
                COLUMN_CLASSES[columns]
              ),
              children: items.map((item) => {
                const isSelected = selectedItems.includes(item.id);
                return /* @__PURE__ */ jsxs(
                  Box,
                  {
                    className: cn(
                      "group relative overflow-hidden rounded-md cursor-pointer",
                      "border-2 transition-all duration-fast",
                      isSelected ? "border-primary ring-2 ring-primary/30" : "border-transparent hover:border-border",
                      ASPECT_CLASSES[aspectRatio]
                    ),
                    onClick: () => handleItemClick(item),
                    children: [
                      failedIds.has(item.id) ? /* @__PURE__ */ jsx(Box, { className: "w-full h-full flex items-center justify-center bg-muted text-muted-foreground", children: /* @__PURE__ */ jsx(Icon, { icon: Image$1, size: "lg" }) }) : /* @__PURE__ */ jsx(
                        "img",
                        {
                          src: item.thumbnail || item.src,
                          alt: item.alt || item.caption || "",
                          className: "w-full h-full object-cover",
                          loading: "lazy",
                          onError: () => handleImageError(item.id)
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Box,
                        {
                          className: cn(
                            "absolute inset-0 bg-foreground/0 group-hover:bg-foreground/20",
                            "transition-colors duration-fast flex items-center justify-center"
                          ),
                          children: /* @__PURE__ */ jsx(
                            Icon,
                            {
                              icon: ZoomIn,
                              size: "md",
                              className: "text-white opacity-0 group-hover:opacity-100 transition-opacity duration-fast"
                            }
                          )
                        }
                      ),
                      item.caption && // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: caption scrim over image
                      /* @__PURE__ */ jsx(Box, { className: "absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/60 to-transparent", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-white truncate", children: item.caption }) }),
                      selectable && isSelected && /* @__PURE__ */ jsx(Box, { className: "absolute top-2 right-2 w-5 h-5 rounded-full bg-primary flex items-center justify-center", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-primary-foreground text-xs", children: "\u2713" }) })
                    ]
                  },
                  item.id
                );
              })
            }
          )
        ] }) }),
        lightboxItem && /* @__PURE__ */ jsx(
          Box,
          {
            className: "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center",
            action: "LIGHTBOX_CLOSE",
            children: /* @__PURE__ */ jsxs(
              VStack,
              {
                align: "center",
                justify: "center",
                className: "w-full h-full p-8",
                onClick: (e) => e.stopPropagation(),
                children: [
                  /* @__PURE__ */ jsx(HStack, { justify: "end", className: "w-full max-w-4xl mb-2", children: /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      size: "sm",
                      icon: X,
                      action: "LIGHTBOX_CLOSE",
                      className: "text-foreground hover:bg-muted/50"
                    }
                  ) }),
                  /* @__PURE__ */ jsx(
                    "img",
                    {
                      src: lightboxItem.src,
                      alt: lightboxItem.alt || lightboxItem.caption || "",
                      className: "max-w-full max-h-[80vh] object-contain rounded-md"
                    }
                  ),
                  lightboxItem.caption && /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-foreground mt-3 text-center", children: lightboxItem.caption })
                ]
              }
            )
          }
        )
      ] });
    };
    MediaGallery.displayName = "MediaGallery";
  }
});
function extractTitle2(children) {
  if (!React79__default.isValidElement(children)) return void 0;
  const props = children.props;
  if (typeof props.title === "string") {
    return props.title;
  }
  return void 0;
}
var ModalSlot;
var init_ModalSlot = __esm({
  "components/core/organisms/ModalSlot.tsx"() {
    "use client";
    init_Modal();
    init_useEventBus();
    ModalSlot = ({
      children,
      title: overrideTitle,
      size = "md",
      className,
      sourceTrait
    }) => {
      const eventBus = useEventBus();
      const schemaCtx = useEntitySchemaOptional();
      const isOpen = Boolean(children);
      const title = overrideTitle || extractTitle2(children);
      const handleClose = () => {
        const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
        const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
        eventBus.emit(`${prefix}CLOSE`);
        eventBus.emit(`${prefix}CANCEL`);
      };
      if (!isOpen) return null;
      return /* @__PURE__ */ jsx(
        Modal,
        {
          isOpen,
          onClose: handleClose,
          title,
          size,
          className,
          children: /* @__PURE__ */ jsx(RenderSlotProvider, { slot: "modal", children })
        }
      );
    };
    ModalSlot.displayName = "ModalSlot";
  }
});
var PricingOrganism;
var init_PricingOrganism = __esm({
  "components/marketing/organisms/PricingOrganism.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Stack();
    init_Typography();
    init_PricingGrid();
    init_LoadingState();
    init_ErrorState();
    PricingOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      heading,
      subtitle
    }) => {
      useEventBus();
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      const plans = items.map((plan) => ({
        name: String(plan.name ?? ""),
        price: String(plan.price ?? ""),
        description: plan.description != null ? String(plan.description) : void 0,
        features: (plan.features ?? []).map((f3) => String(f3)),
        action: { label: String(plan.actionLabel ?? ""), href: String(plan.actionHref ?? "") },
        highlighted: Boolean(plan.highlighted),
        badge: plan.badge != null ? String(plan.badge) : void 0
      }));
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("w-full", className), children: [
        (heading || subtitle) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "w-full", children: [
          heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", align: "center", children: heading }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "muted", align: "center", className: "max-w-2xl", children: subtitle })
        ] }),
        /* @__PURE__ */ jsx(PricingGrid, { plans })
      ] });
    };
    PricingOrganism.displayName = "PricingOrganism";
  }
});
var PricingPageTemplate;
var init_PricingPageTemplate = __esm({
  "components/marketing/templates/PricingPageTemplate.tsx"() {
    init_cn();
    init_Stack();
    init_Box();
    init_Container();
    init_HeroSection();
    init_PricingGrid();
    init_Accordion();
    init_CTABanner();
    init_SectionHeader();
    PricingPageTemplate = ({
      entity,
      className
    }) => {
      const { t } = useTranslate();
      const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
      if (!resolved) return null;
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("w-full", className), children: [
        resolved.hero && /* @__PURE__ */ jsx(
          HeroSection,
          {
            tag: resolved.hero.tag,
            title: resolved.hero.title,
            titleAccent: resolved.hero.titleAccent,
            subtitle: resolved.hero.subtitle,
            background: resolved.hero.background
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: "py-16", children: /* @__PURE__ */ jsx(Container, { size: "xl", padding: "lg", children: /* @__PURE__ */ jsx(
          PricingGrid,
          {
            plans: (Array.isArray(resolved.plans) ? resolved.plans : []).map((plan) => ({
              name: plan.name,
              price: plan.price,
              description: plan.description,
              features: plan.features,
              action: { label: plan.actionLabel, href: plan.actionHref },
              highlighted: plan.highlighted,
              badge: plan.badge
            }))
          }
        ) }) }),
        resolved.faq && resolved.faq.length > 0 && /* @__PURE__ */ jsx(Box, { className: "bg-muted/20 py-16", children: /* @__PURE__ */ jsx(Container, { size: "lg", padding: "lg", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          /* @__PURE__ */ jsx(SectionHeader, { title: t("template.faq") }),
          /* @__PURE__ */ jsx(
            Accordion,
            {
              items: resolved.faq.map((item, index) => ({
                id: `faq-${index}`,
                title: item.question,
                content: item.answer
              }))
            }
          )
        ] }) }) }),
        resolved.ctaTitle && /* @__PURE__ */ jsx(
          CTABanner,
          {
            title: resolved.ctaTitle,
            subtitle: resolved.ctaSubtitle,
            primaryAction: resolved.ctaAction,
            background: "dark"
          }
        )
      ] });
    };
    PricingPageTemplate.displayName = "PricingPageTemplate";
  }
});

// lib/traitRegistry.ts
function getAllTraits() {
  return Array.from(traits.values());
}
function subscribeToTraitChanges(listener) {
  listeners2.add(listener);
  return () => listeners2.delete(listener);
}
var traits, listeners2;
var init_traitRegistry = __esm({
  "lib/traitRegistry.ts"() {
    traits = /* @__PURE__ */ new Map();
    listeners2 = /* @__PURE__ */ new Set();
  }
});

// lib/tickRegistry.ts
function getAllTicks() {
  return Array.from(ticks.values());
}
function subscribeToTickChanges(listener) {
  listeners3.add(listener);
  return () => listeners3.delete(listener);
}
var ticks, listeners3;
var init_tickRegistry = __esm({
  "lib/tickRegistry.ts"() {
    ticks = /* @__PURE__ */ new Map();
    listeners3 = /* @__PURE__ */ new Set();
  }
});

// lib/guardRegistry.ts
function getGuardHistory() {
  return [...guardHistory];
}
function subscribeToGuardChanges(listener) {
  listeners4.add(listener);
  return () => listeners4.delete(listener);
}
var guardHistory, listeners4;
var init_guardRegistry = __esm({
  "lib/guardRegistry.ts"() {
    guardHistory = [];
    listeners4 = /* @__PURE__ */ new Set();
  }
});

// lib/entityDebug.ts
function getEntitySnapshot() {
  if (!entityProvider) {
    return null;
  }
  const entities = entityProvider();
  return {
    entities,
    timestamp: Date.now(),
    totalCount: entities.length,
    singletons: {},
    runtime: entities.map((e) => ({ id: e.id, type: e.type, data: e.fields })),
    persistent: {}
  };
}
var entityProvider;
var init_entityDebug = __esm({
  "lib/entityDebug.ts"() {
    entityProvider = null;
  }
});

// lib/debugRegistry.ts
function getDebugEvents() {
  return [...events];
}
function subscribeToDebugEvents(listener) {
  listeners5.add(listener);
  return () => listeners5.delete(listener);
}
var events, listeners5;
var init_debugRegistry = __esm({
  "lib/debugRegistry.ts"() {
    events = [];
    listeners5 = /* @__PURE__ */ new Set();
  }
});
function useDebugData() {
  const [data, setData] = React79.useState(() => ({
    traits: [],
    ticks: [],
    guards: [],
    events: [],
    entitySnapshot: null,
    verification: {
      checks: [],
      transitions: [],
      bridge: null,
      summary: { totalChecks: 0, passed: 0, failed: 0, warnings: 0, pending: 0 }
    },
    lastUpdate: Date.now()
  }));
  React79.useEffect(() => {
    const updateData = () => {
      setData({
        traits: getAllTraits(),
        ticks: getAllTicks(),
        guards: getGuardHistory(),
        events: getDebugEvents(),
        entitySnapshot: getEntitySnapshot(),
        verification: {
          checks: getAllChecks(),
          transitions: getTransitions(),
          bridge: getBridgeHealth(),
          summary: getSummary()
        },
        lastUpdate: Date.now()
      });
    };
    updateData();
    const unsubTraits = subscribeToTraitChanges(updateData);
    const unsubTicks = subscribeToTickChanges(updateData);
    const unsubGuards = subscribeToGuardChanges(updateData);
    const unsubEvents = subscribeToDebugEvents(updateData);
    const unsubVerification = subscribeToVerification(updateData);
    const pollInterval = setInterval(() => {
      setData((prev) => ({
        ...prev,
        entitySnapshot: getEntitySnapshot(),
        lastUpdate: Date.now()
      }));
    }, 500);
    return () => {
      unsubTraits();
      unsubTicks();
      unsubGuards();
      unsubEvents();
      unsubVerification();
      clearInterval(pollInterval);
    };
  }, []);
  return data;
}
var init_useDebugData = __esm({
  "components/core/organisms/debug/hooks/useDebugData.ts"() {
    "use client";
    init_traitRegistry();
    init_tickRegistry();
    init_guardRegistry();
    init_entityDebug();
    init_debugRegistry();
    init_verificationRegistry();
  }
});

// lib/debugUtils.ts
function isDebugEnabled2() {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(DEBUG_STORAGE_KEY) === "true";
}
function onDebugToggle(listener) {
  listeners6.add(listener);
  return () => listeners6.delete(listener);
}
var DEBUG_STORAGE_KEY, listeners6;
var init_debugUtils = __esm({
  "lib/debugUtils.ts"() {
    DEBUG_STORAGE_KEY = "orbital-debug";
    listeners6 = /* @__PURE__ */ new Set();
  }
});
function layoutGraph(states, transitions, initialState, width, height) {
  if (states.length === 0) return [];
  const layers = /* @__PURE__ */ new Map();
  const queue = [initialState];
  layers.set(initialState, 0);
  while (queue.length > 0) {
    const current = queue.shift();
    const layer = layers.get(current);
    for (const tr of transitions) {
      if (tr.from === current && !layers.has(tr.to)) {
        layers.set(tr.to, layer + 1);
        queue.push(tr.to);
      }
    }
  }
  for (const s of states) {
    if (!layers.has(s)) layers.set(s, layers.size > 0 ? Math.max(...layers.values()) + 1 : 0);
  }
  const layerGroups = /* @__PURE__ */ new Map();
  for (const [state, layer] of layers) {
    const group = layerGroups.get(layer) ?? [];
    group.push(state);
    layerGroups.set(layer, group);
  }
  const maxLayer = Math.max(...layerGroups.keys(), 0);
  const padX = 24;
  const padY = 20;
  const usableW = width - padX * 2;
  const usableH = height - padY * 2;
  const positions = [];
  for (const [layer, group] of layerGroups) {
    const y = maxLayer === 0 ? usableH / 2 + padY : padY + layer / maxLayer * usableH;
    for (let i = 0; i < group.length; i++) {
      const x = group.length === 1 ? width / 2 : padX + i / (group.length - 1) * usableW;
      positions.push({ x, y, state: group[i] });
    }
  }
  return positions;
}
function WalkMinimap() {
  const [walkStep, setWalkStep] = React79.useState(null);
  const [traits2, setTraits] = React79.useState([]);
  const [coveredEdges, setCoveredEdges] = React79.useState([]);
  const [completedTraits, setCompletedTraits] = React79.useState(/* @__PURE__ */ new Set());
  const prevTraitRef = React79.useRef(null);
  React79.useEffect(() => {
    const interval = setInterval(() => {
      const w = window;
      const step = w.__orbitalWalkStep;
      const traitConfigs = w.__orbitalWalkTraits;
      const edges = w.__orbitalCoveredEdges;
      if (step) setWalkStep(step);
      if (traitConfigs) setTraits(traitConfigs);
      if (edges) setCoveredEdges(edges);
      if (step && prevTraitRef.current && prevTraitRef.current !== step.traitName) {
        setCompletedTraits((prev) => new Set(prev).add(prevTraitRef.current));
      }
      if (step) prevTraitRef.current = step.traitName;
    }, 250);
    return () => clearInterval(interval);
  }, []);
  if (!walkStep || traits2.length === 0) return null;
  const activeTrait = traits2.find((t) => t.name === walkStep.traitName);
  const engineCount = coveredEdges.filter((e) => e.phase === "engine").length;
  const domCount = coveredEdges.filter((e) => e.phase === "dom").length;
  const totalTransitions = traits2.reduce((sum, t) => sum + t.transitions.length, 0);
  const activeEdgeKeys = new Set(
    coveredEdges.filter((e) => e.trait === walkStep.traitName).map((e) => `${e.from}+${e.event}->${e.to}`)
  );
  const activeEdgePhases = new Map(
    coveredEdges.filter((e) => e.trait === walkStep.traitName).map((e) => [`${e.from}+${e.event}->${e.to}`, e.phase])
  );
  const currentEdgeKey = `${walkStep.from}+${walkStep.event}->${walkStep.to}`;
  const graphW = 260;
  const graphH = 120;
  const nodeR = 10;
  const positions = activeTrait ? layoutGraph(activeTrait.states, activeTrait.transitions, activeTrait.initialState, graphW, graphH) : [];
  const posMap = new Map(positions.map((p) => [p.state, p]));
  const visitedStates = new Set(
    coveredEdges.filter((e) => e.trait === walkStep.traitName).flatMap((e) => [e.from, e.to])
  );
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-64 flex-shrink-0 border-l border-border bg-[var(--color-card)] overflow-hidden", children: [
    /* @__PURE__ */ jsx(Box, { className: "px-2 py-1.5 border-b border-border overflow-x-auto", children: /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-nowrap", children: traits2.map((t) => {
      const isDone = completedTraits.has(t.name);
      const isActive = t.name === walkStep.traitName;
      const variant = isDone ? "success" : isActive ? "info" : "neutral";
      const shortName = t.name.replace(/^[A-Z][a-z]+/, "");
      return /* @__PURE__ */ jsxs(
        Badge,
        {
          variant,
          size: "sm",
          className: `flex-shrink-0 text-[9px] ${isActive ? "ring-1 ring-info" : ""}`,
          children: [
            isDone ? "\u2713" : isActive ? "\u25CF" : "\u25CB",
            " ",
            shortName || t.name
          ]
        },
        t.name
      );
    }) }) }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1 flex items-center justify-center px-1 py-1", children: activeTrait && /* @__PURE__ */ jsxs("svg", { width: graphW, height: graphH, viewBox: `0 0 ${graphW} ${graphH}`, children: [
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsx("marker", { id: "mm-arrow", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#888" }) }),
        /* @__PURE__ */ jsx("marker", { id: "mm-arrow-green", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#22c55e" }) }),
        /* @__PURE__ */ jsx("marker", { id: "mm-arrow-cyan", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#06b6d4" }) }),
        /* @__PURE__ */ jsx("marker", { id: "mm-arrow-yellow", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#eab308" }) })
      ] }),
      activeTrait.transitions.map((tr, i) => {
        const fromPos = posMap.get(tr.from);
        const toPos = posMap.get(tr.to);
        if (!fromPos || !toPos) return null;
        const key = `${tr.from}+${tr.event}->${tr.to}`;
        const isCurrent = key === currentEdgeKey && !walkStep.isRepositioning;
        const isCovered = activeEdgeKeys.has(key);
        const phase = activeEdgePhases.get(key);
        let stroke = "#555";
        let markerEnd = "url(#mm-arrow)";
        let strokeWidth = 1;
        let opacity = 0.4;
        if (isCurrent) {
          stroke = "#eab308";
          markerEnd = "url(#mm-arrow-yellow)";
          strokeWidth = 2.5;
          opacity = 1;
        } else if (isCovered && phase === "dom") {
          stroke = "#06b6d4";
          markerEnd = "url(#mm-arrow-cyan)";
          strokeWidth = 1.5;
          opacity = 0.9;
        } else if (isCovered) {
          stroke = "#22c55e";
          markerEnd = "url(#mm-arrow-green)";
          strokeWidth = 1.5;
          opacity = 0.9;
        }
        if (tr.from === tr.to) {
          const cx = fromPos.x;
          const cy = fromPos.y - nodeR - 8;
          return /* @__PURE__ */ jsxs("g", { children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                d: `M${cx - 5},${fromPos.y - nodeR} C${cx - 18},${cy - 14} ${cx + 18},${cy - 14} ${cx + 5},${fromPos.y - nodeR}`,
                fill: "none",
                stroke,
                strokeWidth,
                opacity,
                markerEnd
              }
            ),
            /* @__PURE__ */ jsx("text", { x: cx, y: cy - 12, textAnchor: "middle", fontSize: "7", fill: stroke, opacity, children: tr.event.length > 10 ? tr.event.slice(0, 8) + ".." : tr.event })
          ] }, `e-${i}`);
        }
        const dx = toPos.x - fromPos.x;
        const dy = toPos.y - fromPos.y;
        const len = Math.sqrt(dx * dx + dy * dy) || 1;
        const nx = -dy / len;
        const ny = dx / len;
        const hasReverse = activeTrait.transitions.some(
          (t2) => t2.from === tr.to && t2.to === tr.from
        );
        const offset = hasReverse ? 4 : 0;
        const x1 = fromPos.x + dx / len * nodeR + nx * offset;
        const y1 = fromPos.y + dy / len * nodeR + ny * offset;
        const x2 = toPos.x - dx / len * (nodeR + 6) + nx * offset;
        const y2 = toPos.y - dy / len * (nodeR + 6) + ny * offset;
        const mx = (x1 + x2) / 2 + nx * 8;
        const my = (y1 + y2) / 2 + ny * 8;
        return /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(
            "line",
            {
              x1,
              y1,
              x2,
              y2,
              stroke,
              strokeWidth,
              opacity,
              markerEnd,
              children: isCurrent && /* @__PURE__ */ jsx("animate", { attributeName: "opacity", values: "1;0.4;1", dur: "0.8s", repeatCount: "indefinite" })
            }
          ),
          /* @__PURE__ */ jsx("text", { x: mx, y: my, textAnchor: "middle", fontSize: "7", fill: stroke, opacity: Math.min(opacity + 0.2, 1), children: tr.event.length > 12 ? tr.event.slice(0, 10) + ".." : tr.event })
        ] }, `e-${i}`);
      }),
      positions.map((pos) => {
        const isCurrentState = pos.state === walkStep.from || pos.state === walkStep.to;
        const isVisited = visitedStates.has(pos.state);
        const isInitial = pos.state === activeTrait.initialState;
        let fill = "#333";
        let strokeColor = "#555";
        let sw = 1;
        if (isCurrentState) {
          fill = "#1e40af";
          strokeColor = "#3b82f6";
          sw = 2;
        } else if (isVisited) {
          fill = "#166534";
          strokeColor = "#22c55e";
          sw = 1.5;
        }
        return /* @__PURE__ */ jsxs("g", { children: [
          isInitial && /* @__PURE__ */ jsx("circle", { cx: pos.x, cy: pos.y, r: nodeR + 3, fill: "none", stroke: "#3b82f6", strokeWidth: 1, opacity: 0.4 }),
          /* @__PURE__ */ jsx(
            "circle",
            {
              cx: pos.x,
              cy: pos.y,
              r: nodeR,
              fill,
              stroke: strokeColor,
              strokeWidth: sw,
              children: isCurrentState && /* @__PURE__ */ jsx("animate", { attributeName: "r", values: `${nodeR};${nodeR + 2};${nodeR}`, dur: "1s", repeatCount: "indefinite" })
            }
          ),
          /* @__PURE__ */ jsx(
            "text",
            {
              x: pos.x,
              y: pos.y + nodeR + 10,
              textAnchor: "middle",
              fontSize: "8",
              fill: "#aaa",
              children: pos.state.length > 10 ? pos.state.slice(0, 8) + ".." : pos.state
            }
          )
        ] }, pos.state);
      })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { className: "px-2 py-1 border-t border-border", children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center justify-between", children: [
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-xs font-mono text-success", children: [
        "Engine: ",
        engineCount,
        "/",
        totalTransitions
      ] }),
      domCount > 0 && /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-xs font-mono text-info", children: [
        "DOM: ",
        domCount
      ] }),
      /* @__PURE__ */ jsx(Badge, { variant: walkStep.phase === "engine" ? "info" : "warning", size: "sm", className: "text-[9px]", children: walkStep.phase === "engine" ? "Engine" : "DOM" })
    ] }) })
  ] });
}
var init_WalkMinimap = __esm({
  "components/core/organisms/debug/WalkMinimap.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    WalkMinimap.displayName = "WalkMinimap";
  }
});
function TraitsTab({ traits: traits2 }) {
  const { t } = useTranslate();
  if (traits2.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noActiveTraits"),
        description: t("debug.traitsMountHint"),
        className: "py-8"
      }
    );
  }
  const accordionItems = traits2.map((trait) => ({
    id: trait.id,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 w-full", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-primary", children: trait.name }),
      /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: trait.currentState }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: t("debug.transitionsCount", { count: trait.transitionCount }) })
    ] }),
    content: /* @__PURE__ */ jsxs(Stack, { gap: "sm", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.states") }),
        /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: trait.states.map((state) => /* @__PURE__ */ jsx(
          Badge,
          {
            variant: state === trait.currentState ? "success" : "default",
            size: "sm",
            children: state
          },
          state
        )) })
      ] }),
      trait.transitions.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.transitions") }),
        /* @__PURE__ */ jsx(Stack, { gap: "xs", children: trait.transitions.map((t2, i) => /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "font-mono", children: [
          t2.from,
          " \u2192 ",
          t2.to,
          " ",
          /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
            "(",
            t2.event,
            ")"
          ] }),
          t2.guard && /* @__PURE__ */ jsxs("span", { className: "text-warning", children: [
            " [",
            t2.guard,
            "]"
          ] })
        ] }, i)) })
      ] }),
      trait.guards.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.guards") }),
        /* @__PURE__ */ jsx(Stack, { gap: "xs", children: trait.guards.map((g, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", children: g.name }),
          /* @__PURE__ */ jsx(Badge, { variant: g.lastResult === true ? "success" : g.lastResult === false ? "danger" : "default", size: "sm", children: g.lastResult === void 0 ? "?" : g.lastResult ? "\u2713" : "\u2717" })
        ] }, i)) })
      ] })
    ] })
  }));
  return /* @__PURE__ */ jsx("div", { className: "debug-tab debug-tab--traits", children: /* @__PURE__ */ jsx(Accordion, { items: accordionItems, multiple: true }) });
}
var init_TraitsTab = __esm({
  "components/core/organisms/debug/tabs/TraitsTab.tsx"() {
    init_Accordion();
    init_Badge();
    init_Typography();
    init_Stack();
    init_EmptyState();
    TraitsTab.displayName = "TraitsTab";
  }
});
function TicksTab({ ticks: ticks2 }) {
  const { t } = useTranslate();
  const activeTicks = ticks2.filter((t2) => t2.active);
  const inactiveTicks = ticks2.filter((t2) => !t2.active);
  if (ticks2.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noTicks"),
        description: "Ticks will appear when trait tick handlers are running",
        className: "py-8"
      }
    );
  }
  const formatTime3 = (ms) => {
    if (ms === 0) return "never";
    const seconds = Math.floor((Date.now() - ms) / 1e3);
    if (seconds < 1) return "just now";
    if (seconds < 60) return `${seconds}s ago`;
    return `${Math.floor(seconds / 60)}m ago`;
  };
  const TickCard = ({ tick, active }) => /* @__PURE__ */ jsxs(Card, { className: `p-3 ${!active ? "opacity-50" : ""}`, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-2", children: [
      /* @__PURE__ */ jsx("span", { className: `w-2 h-2 rounded-full ${active ? "bg-success" : "bg-muted-foreground"}` }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-warning", children: tick.name }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: tick.traitName })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-3 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsxs("span", { children: [
        tick.interval,
        "ms"
      ] }),
      /* @__PURE__ */ jsxs("span", { children: [
        tick.runCount,
        " runs"
      ] }),
      /* @__PURE__ */ jsxs("span", { children: [
        tick.executionTime.toFixed(1),
        "ms exec"
      ] }),
      /* @__PURE__ */ jsx("span", { children: formatTime3(tick.lastRun) })
    ] }),
    tick.guardName && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsxs(Badge, { variant: tick.guardPassed ? "success" : "danger", size: "sm", children: [
      tick.guardName,
      ": ",
      tick.guardPassed ? "\u2713" : "\u2717"
    ] }) })
  ] });
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--ticks", children: [
    activeTicks.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsxs(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: [
        "Active (",
        activeTicks.length,
        ")"
      ] }),
      /* @__PURE__ */ jsx(Stack, { gap: "sm", children: activeTicks.map((tick) => /* @__PURE__ */ jsx(TickCard, { tick, active: true }, tick.id)) })
    ] }),
    inactiveTicks.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: [
        "Inactive (",
        inactiveTicks.length,
        ")"
      ] }),
      /* @__PURE__ */ jsx(Stack, { gap: "sm", children: inactiveTicks.map((tick) => /* @__PURE__ */ jsx(TickCard, { tick, active: false }, tick.id)) })
    ] })
  ] });
}
var init_TicksTab = __esm({
  "components/core/organisms/debug/tabs/TicksTab.tsx"() {
    init_Badge();
    init_Typography();
    init_Stack();
    init_Card();
    init_EmptyState();
    TicksTab.displayName = "TicksTab";
  }
});
function EntitiesTab({ snapshot }) {
  const { t } = useTranslate();
  if (!snapshot) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noEntityData"),
        description: t("debug.debugModeHint"),
        className: "py-8"
      }
    );
  }
  const singletonEntries = Object.entries(snapshot.singletons);
  const runtimeEntities = snapshot.runtime;
  const persistentEntries = Object.entries(snapshot.persistent);
  if (singletonEntries.length === 0 && runtimeEntities.length === 0 && persistentEntries.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noEntities"),
        description: t("debug.entitiesSpawnHint"),
        className: "py-8"
      }
    );
  }
  const singletonItems = singletonEntries.map(([name, data]) => ({
    id: `singleton-${name}`,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", children: t("debug.singleton") }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-info", children: name })
    ] }),
    content: /* @__PURE__ */ jsx("pre", { className: "text-xs text-muted-foreground bg-muted p-2 rounded overflow-auto max-h-40", children: JSON.stringify(data, null, 2) })
  }));
  const runtimeItems = runtimeEntities.slice(0, 20).map((entity) => ({
    id: entity.id,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-info", children: entity.type }),
      /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground", children: [
        "#",
        entity.id.slice(0, 8)
      ] })
    ] }),
    content: /* @__PURE__ */ jsx("pre", { className: "text-xs text-muted-foreground bg-muted p-2 rounded overflow-auto max-h-40", children: JSON.stringify(entity.data, null, 2) })
  }));
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--entities", children: [
    singletonItems.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.singletonsCount", { count: singletonItems.length }) }),
      /* @__PURE__ */ jsx(Accordion, { items: singletonItems, multiple: true })
    ] }),
    runtimeItems.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.runtimeCount", { count: runtimeEntities.length }) }),
      /* @__PURE__ */ jsx(Accordion, { items: runtimeItems, multiple: true }),
      runtimeEntities.length > 20 && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-center mt-2", children: t("debug.moreEntities", { count: runtimeEntities.length - 20 }) })
    ] }),
    persistentEntries.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.persistent") }),
      /* @__PURE__ */ jsx(Stack, { gap: "xs", children: persistentEntries.map(([type, info]) => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between py-1", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", children: type }),
        /* @__PURE__ */ jsx(Badge, { variant: info.loaded ? "success" : "default", size: "sm", children: info.loaded ? t("debug.loadedCount", { count: info.count }) : t("debug.notLoaded") })
      ] }, type)) })
    ] })
  ] });
}
var init_EntitiesTab = __esm({
  "components/core/organisms/debug/tabs/EntitiesTab.tsx"() {
    init_Accordion();
    init_Badge();
    init_Typography();
    init_Stack();
    init_EmptyState();
    EntitiesTab.displayName = "EntitiesTab";
  }
});
function EventFlowTab({ events: events2 }) {
  const { t } = useTranslate();
  const [filter, setFilter] = React79.useState("all");
  const containerRef = React79.useRef(null);
  const [autoScroll, setAutoScroll] = React79.useState(true);
  React79.useEffect(() => {
    if (autoScroll && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [events2.length, autoScroll]);
  const filteredEvents = React79.useMemo(() => {
    if (filter === "all") return events2;
    return events2.filter((e) => e.type === filter);
  }, [events2, filter]);
  const formatTime3 = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) + "." + String(date.getMilliseconds()).padStart(3, "0");
  };
  if (events2.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noEventsYet"),
        description: t("debug.eventsExecuteHint"),
        className: "py-8"
      }
    );
  }
  const eventTypes = Object.keys(TYPE_BADGES).filter(
    (type) => events2.some((e) => e.type === type)
  );
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--events", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-3 flex-wrap", children: [
      /* @__PURE__ */ jsxs(ButtonGroup, { children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: filter === "all" ? "primary" : "secondary",
            onClick: () => setFilter("all"),
            children: t("debug.allCount", { count: events2.length })
          }
        ),
        eventTypes.map((type) => {
          const count = events2.filter((e) => e.type === type).length;
          const { icon } = TYPE_BADGES[type];
          return /* @__PURE__ */ jsxs(
            Button,
            {
              size: "sm",
              variant: filter === type ? "primary" : "secondary",
              onClick: () => setFilter(type),
              children: [
                icon,
                " ",
                count
              ]
            },
            type
          );
        })
      ] }),
      /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs text-muted-foreground ml-auto cursor-pointer", children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: autoScroll,
            onChange: (e) => setAutoScroll(e.target.checked)
          }
        ),
        t("debug.autoScroll")
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: containerRef,
        className: "max-h-64 overflow-y-auto space-y-1 bg-muted rounded p-2",
        children: filteredEvents.slice(-100).map((event) => {
          const { variant, icon } = TYPE_BADGES[event.type] || { variant: "default", icon: "\u2022" };
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: "flex items-start gap-2 text-xs py-1 hover:bg-muted/50 rounded px-1",
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono min-w-[65px]", children: formatTime3(event.timestamp) }),
                /* @__PURE__ */ jsx("span", { children: icon }),
                /* @__PURE__ */ jsx(Badge, { variant, size: "sm", className: "min-w-[60px] justify-center", children: event.source }),
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: event.message })
              ]
            },
            event.id
          );
        })
      }
    )
  ] });
}
var TYPE_BADGES;
var init_EventFlowTab = __esm({
  "components/core/organisms/debug/tabs/EventFlowTab.tsx"() {
    "use client";
    init_Badge();
    init_Typography();
    init_ButtonGroup();
    init_Button();
    init_Checkbox();
    init_EmptyState();
    TYPE_BADGES = {
      trait: { variant: "primary", icon: "\u{1F504}" },
      tick: { variant: "warning", icon: "\u23F1\uFE0F" },
      guard: { variant: "warning", icon: "\u{1F6E1}\uFE0F" },
      entity: { variant: "info", icon: "\u{1F4E6}" },
      event: { variant: "success", icon: "\u26A1" },
      state: { variant: "danger", icon: "\u{1F4CA}" }
    };
    EventFlowTab.displayName = "EventFlowTab";
  }
});
function GuardsPanel({ guards }) {
  const { t } = useTranslate();
  const [filter, setFilter] = React79.useState("all");
  if (guards.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noGuardEvaluations"),
        description: t("debug.guardEvaluationsHint"),
        className: "py-8"
      }
    );
  }
  const passedCount = guards.filter((g) => g.result).length;
  const failedCount = guards.length - passedCount;
  const filteredGuards = React79.useMemo(() => {
    if (filter === "all") return guards;
    if (filter === "passed") return guards.filter((g) => g.result);
    return guards.filter((g) => !g.result);
  }, [guards, filter]);
  const formatTime3 = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  };
  const accordionItems = filteredGuards.slice(-50).reverse().map((guard) => ({
    id: guard.id,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 w-full", children: [
      /* @__PURE__ */ jsx(Badge, { variant: guard.result ? "success" : "danger", size: "sm", children: guard.result ? "\u2713" : "\u2717" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-warning", children: guard.guardName }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: guard.context.type === "transition" ? `${guard.context.transitionFrom} \u2192 ${guard.context.transitionTo}` : guard.context.tickName }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: formatTime3(guard.timestamp) })
    ] }),
    content: /* @__PURE__ */ jsxs(Stack, { gap: "sm", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground", children: t("debug.expression") }),
        /* @__PURE__ */ jsx("code", { className: "block mt-1 text-xs text-warning bg-warning/10 px-2 py-1 rounded", children: guard.expression })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground", children: t("debug.inputs") }),
        /* @__PURE__ */ jsx("pre", { className: "mt-1 text-xs text-muted-foreground bg-muted p-2 rounded overflow-auto max-h-24", children: JSON.stringify(guard.inputs, null, 2) })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground", children: t("debug.trait") }),
        /* @__PURE__ */ jsx(Typography, { variant: "small", children: guard.context.traitName })
      ] })
    ] })
  }));
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--guards", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex gap-3", children: [
        /* @__PURE__ */ jsxs(Badge, { variant: "success", size: "sm", children: [
          "\u2713 ",
          passedCount
        ] }),
        /* @__PURE__ */ jsxs(Badge, { variant: "danger", size: "sm", children: [
          "\u2717 ",
          failedCount
        ] })
      ] }),
      /* @__PURE__ */ jsxs(ButtonGroup, { children: [
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: filter === "all" ? "primary" : "secondary", onClick: () => setFilter("all"), children: t("debug.filterAll") }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: filter === "passed" ? "primary" : "secondary", onClick: () => setFilter("passed"), children: t("debug.filterPassed") }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: filter === "failed" ? "primary" : "secondary", onClick: () => setFilter("failed"), children: t("debug.filterFailed") })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "max-h-80 overflow-y-auto", children: /* @__PURE__ */ jsx(Accordion, { items: accordionItems }) })
  ] });
}
var init_GuardsPanel = __esm({
  "components/core/organisms/debug/tabs/GuardsPanel.tsx"() {
    "use client";
    init_Accordion();
    init_Badge();
    init_Typography();
    init_Stack();
    init_ButtonGroup();
    init_Button();
    init_EmptyState();
    GuardsPanel.displayName = "GuardsPanel";
  }
});
function VerificationTab({ checks, summary }) {
  const { t } = useTranslate();
  if (checks.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noVerificationChecks"),
        description: "Checks will appear as the app executes transitions and effects",
        className: "py-8"
      }
    );
  }
  const sortOrder = { fail: 0, warn: 1, pending: 2, pass: 3 };
  const sorted = [...checks].sort(
    (a, b) => (sortOrder[a.status] ?? 4) - (sortOrder[b.status] ?? 4)
  );
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--verification", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 mb-3 p-2 bg-muted rounded", children: [
      /* @__PURE__ */ jsxs(Badge, { variant: "success", size: "sm", children: [
        summary.passed,
        " passed"
      ] }),
      summary.failed > 0 && /* @__PURE__ */ jsxs(Badge, { variant: "danger", size: "sm", children: [
        summary.failed,
        " failed"
      ] }),
      summary.warnings > 0 && /* @__PURE__ */ jsxs(Badge, { variant: "warning", size: "sm", children: [
        summary.warnings,
        " warnings"
      ] }),
      summary.pending > 0 && /* @__PURE__ */ jsxs(Badge, { variant: "default", size: "sm", children: [
        summary.pending,
        " pending"
      ] }),
      /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: [
        summary.totalChecks,
        " total checks"
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "max-h-64 overflow-y-auto space-y-1", children: /* @__PURE__ */ jsx(Stack, { gap: "xs", children: sorted.map((check) => {
      const config = STATUS_CONFIG[check.status] || STATUS_CONFIG.pending;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "flex items-start gap-2 p-2 rounded hover:bg-muted/50",
          children: [
            /* @__PURE__ */ jsx(Badge, { variant: config.variant, size: "sm", className: "min-w-[20px] justify-center mt-0.5", children: config.icon }),
            /* @__PURE__ */ jsxs("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "break-words", children: check.label }),
              check.details && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground break-words", children: check.details })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono text-xs shrink-0", children: new Date(check.updatedAt).toLocaleTimeString("en-US", {
              hour12: false,
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            }) })
          ]
        },
        check.id
      );
    }) }) })
  ] });
}
var STATUS_CONFIG;
var init_VerificationTab = __esm({
  "components/core/organisms/debug/tabs/VerificationTab.tsx"() {
    "use client";
    init_Badge();
    init_Typography();
    init_Stack();
    init_EmptyState();
    STATUS_CONFIG = {
      pass: { variant: "success", icon: "\u2713", label: "PASS" },
      fail: { variant: "danger", icon: "\u2717", label: "FAIL" },
      warn: { variant: "warning", icon: "!", label: "WARN" },
      pending: { variant: "default", icon: "?", label: "PENDING" }
    };
    VerificationTab.displayName = "VerificationTab";
  }
});
function EffectBadge({ effect }) {
  const variant = EFFECT_STATUS_VARIANT[effect.status] || "default";
  const icon = effect.status === "executed" ? "\u2713" : effect.status === "failed" ? "\u2717" : "-";
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1 text-xs font-mono bg-muted rounded px-1.5 py-0.5", children: [
    /* @__PURE__ */ jsx(Badge, { variant, size: "sm", className: "!text-[9px] !px-1 !py-0", children: icon }),
    /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: effect.type }),
    effect.error && /* @__PURE__ */ jsx("span", { className: "text-error truncate max-w-[120px]", title: effect.error, children: effect.error })
  ] });
}
function TransitionTimeline({ transitions }) {
  const { t } = useTranslate();
  const containerRef = React79.useRef(null);
  const [autoScroll, setAutoScroll] = React79.useState(true);
  const [expandedId, setExpandedId] = React79.useState(null);
  React79.useEffect(() => {
    if (autoScroll && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [transitions.length, autoScroll]);
  if (transitions.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noTransitionsRecorded"),
        description: t("debug.transitionsProcessHint"),
        className: "py-8"
      }
    );
  }
  const formatTime3 = (ts) => {
    const d = new Date(ts);
    return d.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) + "." + String(d.getMilliseconds()).padStart(3, "0");
  };
  const sorted = [...transitions].reverse();
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--timeline", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("debug.transitionsRecorded", { count: transitions.length }) }),
      /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs text-muted-foreground cursor-pointer", children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: autoScroll,
            onChange: (e) => setAutoScroll(e.target.checked)
          }
        ),
        t("debug.autoScroll")
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: containerRef,
        className: "max-h-80 overflow-y-auto space-y-0",
        children: sorted.map((trace, idx) => {
          const isExpanded = expandedId === trace.id;
          const hasFailedEffects = trace.effects.some((e) => e.status === "failed");
          const allPassed = trace.effects.length > 0 && trace.effects.every((e) => e.status === "executed");
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: `
                                relative pl-6 pb-3 border-l-2 cursor-pointer
                                hover:bg-muted/50 rounded-r
                                ${hasFailedEffects ? "border-error" : "border-border"}
                            `,
              onClick: () => setExpandedId(isExpanded ? null : trace.id),
              children: [
                /* @__PURE__ */ jsx("div", { className: `
                                absolute left-[-5px] top-1 w-2 h-2 rounded-full
                                ${hasFailedEffects ? "bg-error" : allPassed ? "bg-success" : "bg-muted-foreground"}
                            ` }),
                /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-xs py-1 px-2", children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono min-w-[65px]", children: formatTime3(trace.timestamp) }),
                  /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", className: "min-w-[60px] justify-center", children: trace.traitName }),
                  /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "font-mono text-muted-foreground", children: [
                    trace.from,
                    " ",
                    /* @__PURE__ */ jsx("span", { className: "text-muted-foreground/50", children: "\u2192" }),
                    " ",
                    trace.to
                  ] }),
                  /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: trace.event }),
                  trace.guardResult !== void 0 && /* @__PURE__ */ jsxs(
                    Badge,
                    {
                      variant: trace.guardResult ? "success" : "danger",
                      size: "sm",
                      children: [
                        t("debug.guardLabel"),
                        " ",
                        trace.guardResult ? "\u2713" : "\u2717"
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: t("debug.effectsCount", { count: trace.effects.length }) })
                ] }),
                isExpanded && trace.effects.length > 0 && /* @__PURE__ */ jsx("div", { className: "ml-2 mt-1 mb-2 pl-2 border-l border-border space-y-1", children: trace.effects.map((effect, eIdx) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ jsx(EffectBadge, { effect }),
                  effect.args.length > 0 && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono text-xs truncate max-w-[200px]", children: JSON.stringify(effect.args) }),
                  effect.durationMs !== void 0 && /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: [
                    effect.durationMs,
                    "ms"
                  ] })
                ] }, eIdx)) })
              ]
            },
            trace.id
          );
        })
      }
    )
  ] });
}
var EFFECT_STATUS_VARIANT;
var init_TransitionTimeline = __esm({
  "components/core/organisms/debug/tabs/TransitionTimeline.tsx"() {
    "use client";
    init_Badge();
    init_Typography();
    init_EmptyState();
    init_Checkbox();
    EFFECT_STATUS_VARIANT = {
      executed: "success",
      failed: "danger",
      skipped: "warning"
    };
    TransitionTimeline.displayName = "TransitionTimeline";
  }
});
function StatRow({ label, value, variant }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between py-1.5 border-b border-border last:border-b-0", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: label }),
    variant ? /* @__PURE__ */ jsx(Badge, { variant, size: "sm", children: String(value) }) : /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "semibold", className: "font-mono", children: String(value) })
  ] });
}
function ServerBridgeTab({ bridge }) {
  const { t } = useTranslate();
  if (!bridge) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noBridgeData"),
        description: t("debug.bridgeInitHint"),
        className: "py-8"
      }
    );
  }
  const formatTime3 = (ts) => {
    if (ts === 0) return t("debug.never");
    const d = new Date(ts);
    return d.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  };
  return /* @__PURE__ */ jsx("div", { className: "debug-tab debug-tab--bridge", children: /* @__PURE__ */ jsxs(Stack, { gap: "sm", children: [
    /* @__PURE__ */ jsxs(Card, { className: "p-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 mb-3", children: [
        /* @__PURE__ */ jsx("div", { className: `w-3 h-3 rounded-full ${bridge.connected ? "bg-success animate-pulse" : "bg-error"}` }),
        /* @__PURE__ */ jsx(Typography, { variant: "h6", children: bridge.connected ? t("debug.connected") : t("debug.disconnected") })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { gap: "xs", children: [
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.status"),
            value: bridge.connected ? t("debug.connected") : t("debug.disconnected"),
            variant: bridge.connected ? "success" : "danger"
          }
        ),
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.eventsForwarded"),
            value: bridge.eventsForwarded
          }
        ),
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.eventsReceived"),
            value: bridge.eventsReceived
          }
        ),
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.lastHeartbeat"),
            value: formatTime3(bridge.lastHeartbeat)
          }
        )
      ] })
    ] }),
    bridge.lastError && /* @__PURE__ */ jsxs(Card, { className: "p-3 border-error/30 bg-error/10", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "semibold", className: "text-error mb-1", children: t("debug.lastError") }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-error font-mono break-all", children: bridge.lastError })
    ] }),
    bridge.connected && /* @__PURE__ */ jsx("div", { className: "text-center py-2", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("debug.totalEventsProcessed", { count: bridge.eventsForwarded + bridge.eventsReceived }) }) })
  ] }) });
}
var init_ServerBridgeTab = __esm({
  "components/core/organisms/debug/tabs/ServerBridgeTab.tsx"() {
    "use client";
    init_Badge();
    init_Typography();
    init_Stack();
    init_Card();
    init_EmptyState();
    ServerBridgeTab.displayName = "ServerBridgeTab";
  }
});
function extractPayloadFields(schema, eventName) {
  if (!schema) return [];
  for (const orbital of schema.orbitals) {
    const traitRefs = orbital.traits ?? [];
    for (const traitRef of traitRefs) {
      if (!isInlineTrait(traitRef)) continue;
      const inlineTrait = traitRef;
      const sm = inlineTrait.stateMachine;
      if (!sm) continue;
      const events2 = sm.events ?? [];
      for (const evt of events2) {
        if (evt.name !== eventName) continue;
        const payloadFields = evt.payloadSchema ?? [];
        return payloadFields.map((f3) => ({
          name: f3.name,
          type: f3.type ?? "string"
        }));
      }
    }
  }
  return [];
}
function buildAutoPayload(fields) {
  const payload = {};
  for (const field of fields) {
    switch (field.type) {
      case "number":
      case "integer":
      case "float":
        payload[field.name] = 1;
        break;
      case "boolean":
        payload[field.name] = true;
        break;
      default:
        payload[field.name] = `test-${field.name}`;
        break;
    }
  }
  return payload;
}
function getAvailableEvents(traits2) {
  const eventMap = /* @__PURE__ */ new Map();
  for (const trait of traits2) {
    for (const t of trait.transitions) {
      if (t.from !== trait.currentState) continue;
      const existing = eventMap.get(t.event);
      if (existing) {
        existing.traits.add(trait.name);
        existing.transitions.push({ ...t, traitName: trait.name });
      } else {
        eventMap.set(t.event, {
          traits: /* @__PURE__ */ new Set([trait.name]),
          transitions: [{ ...t, traitName: trait.name }]
        });
      }
    }
  }
  return Array.from(eventMap.entries()).map(([event, data]) => ({
    event,
    traits: Array.from(data.traits),
    transitions: data.transitions
  }));
}
function getAllEvents(traits2) {
  const all = /* @__PURE__ */ new Set();
  for (const trait of traits2) {
    for (const t of trait.transitions) {
      all.add(t.event);
    }
  }
  return all;
}
function EventDispatcherTab({ traits: traits2, schema }) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [log20, setLog] = React79.useState([]);
  const prevStatesRef = React79.useRef(/* @__PURE__ */ new Map());
  React79.useEffect(() => {
    for (const trait of traits2) {
      const prev = prevStatesRef.current.get(trait.id);
      if (prev && prev !== trait.currentState) {
        setLog((l) => [
          { traitName: trait.name, event: "?", from: prev, to: trait.currentState, timestamp: Date.now() },
          ...l
        ].slice(0, 5));
      }
      prevStatesRef.current.set(trait.id, trait.currentState);
    }
  }, [traits2]);
  if (traits2.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noActiveTraits"),
        description: t("debug.traitsInitHint"),
        className: "py-8"
      }
    );
  }
  const availableEvents = getAvailableEvents(traits2);
  const allEvents = getAllEvents(traits2);
  const unavailableEvents = Array.from(allEvents).filter(
    (e) => !availableEvents.some((ae) => ae.event === e)
  );
  const handleFireEvent = (eventName) => {
    const payloadFields = extractPayloadFields(schema, eventName);
    const payload = payloadFields.length > 0 ? buildAutoPayload(payloadFields) : {};
    eventBus.emit(`UI:${eventName}`, payload);
  };
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--dispatch", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.activeStates") }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: traits2.map((trait) => /* @__PURE__ */ jsxs(Badge, { variant: "success", size: "sm", children: [
        trait.name,
        ": ",
        trait.currentState
      ] }, trait.id)) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.availableEvents") }),
      availableEvents.length === 0 ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground italic", children: t("debug.noTransitionsFromState") }) : /* @__PURE__ */ jsx(Stack, { gap: "xs", children: availableEvents.map(({ event, transitions }) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            onClick: () => handleFireEvent(event),
            variant: "primary",
            size: "sm",
            className: "font-mono text-xs",
            children: event
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: transitions.map((t2) => `${t2.from} -> ${t2.to}`).join(", ") }),
        transitions.some((tr) => tr.guard) && /* @__PURE__ */ jsx(Badge, { variant: "warning", size: "sm", children: t("debug.guarded") })
      ] }, event)) })
    ] }),
    unavailableEvents.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.otherEvents") }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: unavailableEvents.map((event) => /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", className: "opacity-50", children: event }, event)) })
    ] }),
    log20.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.recentTransitions") }),
      /* @__PURE__ */ jsx(Stack, { gap: "xs", children: log20.map((entry, i) => /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "font-mono text-xs", children: [
        /* @__PURE__ */ jsx("span", { className: "text-primary", children: entry.traitName }),
        " ",
        /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: entry.from }),
        " -> ",
        /* @__PURE__ */ jsx("span", { className: "text-success", children: entry.to })
      ] }, i)) })
    ] })
  ] });
}
var init_EventDispatcherTab = __esm({
  "components/core/organisms/debug/tabs/EventDispatcherTab.tsx"() {
    "use client";
    init_Badge();
    init_Button();
    init_Typography();
    init_Stack();
    init_EmptyState();
    init_useEventBus();
    EventDispatcherTab.displayName = "EventDispatcherTab";
  }
});

// components/core/organisms/debug/RuntimeDebugger.css
var init_RuntimeDebugger = __esm({
  "components/core/organisms/debug/RuntimeDebugger.css"() {
  }
});
function ServerResponseRow({ sr }) {
  const { t } = useTranslate();
  const entityEntries = Object.entries(sr.dataEntities);
  return /* @__PURE__ */ jsxs("div", { className: "ml-4 pl-2 border-l border-primary py-0.5 text-xs font-mono", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs("span", { className: sr.success ? "text-success" : "text-error", children: [
        sr.success ? "\u2713" : "\u2717",
        " ",
        t("debug.server")
      ] }),
      /* @__PURE__ */ jsx("span", { className: "text-primary", children: sr.orbitalName }),
      sr.clientEffects > 0 && /* @__PURE__ */ jsx("span", { className: "px-1 rounded bg-primary/10 text-primary", children: t("debug.clientEffectsCount", { count: sr.clientEffects }) }),
      sr.emittedEvents.length > 0 && /* @__PURE__ */ jsxs("span", { className: "px-1 rounded bg-primary/10 text-primary", children: [
        t("debug.emitLabel"),
        " ",
        sr.emittedEvents.join(", ")
      ] }),
      sr.error && /* @__PURE__ */ jsx("span", { className: "px-1 rounded bg-error/10 text-error truncate max-w-[300px]", children: sr.error })
    ] }),
    entityEntries.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1 mt-0.5", children: entityEntries.map(([name, count]) => /* @__PURE__ */ jsxs("span", { className: "px-1 rounded bg-[var(--color-card)] text-foreground", children: [
      name,
      ": ",
      t("debug.rowsCount", { count })
    ] }, name)) })
  ] });
}
function TransitionRow({ trace }) {
  const { t } = useTranslate();
  const isServerEntry = !!trace.serverResponse && trace.traitName.startsWith("server:");
  const hasFailedEffects = trace.effects.some((e) => e.status === "failed");
  if (isServerEntry && trace.serverResponse) {
    return /* @__PURE__ */ jsxs("div", { className: "py-0.5 border-b border-border last:border-0", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2 text-xs font-mono", children: [
        /* @__PURE__ */ jsx("span", { className: "mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 bg-primary" }),
        /* @__PURE__ */ jsx(Badge, { variant: "warning", size: "sm", className: "flex-shrink-0", children: trace.event }),
        /* @__PURE__ */ jsx("span", { className: "text-primary flex-shrink-0", children: t("debug.serverResponse") })
      ] }),
      /* @__PURE__ */ jsx(ServerResponseRow, { sr: trace.serverResponse })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "py-0.5 border-b border-border last:border-0", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2 text-xs font-mono", children: [
      /* @__PURE__ */ jsx("span", { className: cn(
        "mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0",
        hasFailedEffects ? "bg-error" : "bg-success"
      ) }),
      /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", className: "flex-shrink-0", children: trace.event }),
      /* @__PURE__ */ jsx("span", { className: "text-foreground flex-shrink-0", children: trace.traitName }),
      /* @__PURE__ */ jsxs("span", { className: "text-foreground/70 flex-shrink-0", children: [
        trace.from,
        " ",
        "\u2192",
        " ",
        trace.to
      ] })
    ] }),
    trace.effects.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1 ml-6 mt-0.5", children: trace.effects.map((eff, i) => /* @__PURE__ */ jsxs("span", { className: cn(
      "px-1 rounded text-xs",
      eff.status === "executed" ? "bg-success/10 text-success" : eff.status === "failed" ? "bg-error/10 text-error" : "bg-warning/10 text-warning"
    ), children: [
      eff.status === "executed" ? "\u2713" : eff.status === "failed" ? "\u2717" : "-",
      " ",
      eff.type,
      eff.args.length > 0 && /* @__PURE__ */ jsx("span", { className: "text-foreground/50 ml-0.5", children: JSON.stringify(eff.args).slice(0, 40) })
    ] }, i)) }),
    trace.serverResponse && /* @__PURE__ */ jsx(ServerResponseRow, { sr: trace.serverResponse })
  ] });
}
function VerifyModePanel({
  className,
  failedChecks,
  transitions,
  traitStates,
  serverCount,
  localCount
}) {
  const { t } = useTranslate();
  const [expanded, setExpanded] = React79.useState(true);
  const scrollRef = React79.useRef(null);
  const prevCountRef = React79.useRef(0);
  React79.useEffect(() => {
    if (expanded && transitions.length > prevCountRef.current && scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
    prevCountRef.current = transitions.length;
  }, [transitions.length, expanded]);
  const hudBottom = typeof document !== "undefined" ? document.getElementById("runtime-debugger-portal") : null;
  const panel = /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "runtime-debugger runtime-debugger--verify",
        "flex flex-col bg-[var(--color-card)] text-[var(--color-foreground)] border-t-2 border-accent",
        hudBottom ? "" : "fixed bottom-0 left-0 right-0",
        className
      ),
      "data-testid": "debugger-verify",
      "data-expanded": expanded ? "true" : "false",
      style: { height: expanded ? "25vh" : "auto", zIndex: hudBottom ? void 0 : 40 },
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            onClick: () => setExpanded((v) => !v),
            className: "px-3 py-1.5 flex items-center gap-3 text-xs font-mono border-b border-border flex-shrink-0 w-full text-left hover:bg-[var(--color-card-hover,transparent)] cursor-pointer",
            "aria-expanded": expanded,
            "aria-label": expanded ? t("debug.collapseVerificationTimeline") : t("debug.expandVerificationTimeline"),
            "data-testid": "debugger-verify-toggle",
            children: [
              /* @__PURE__ */ jsx("span", { className: "text-foreground/50 w-3", "aria-hidden": true, children: expanded ? "\u25BE" : "\u25B8" }),
              /* @__PURE__ */ jsx(Badge, { variant: failedChecks > 0 ? "danger" : "success", size: "sm", children: failedChecks > 0 ? t("debug.failCount", { count: failedChecks }) : t("debug.ok") }),
              /* @__PURE__ */ jsx("span", { className: "text-foreground/70", children: t("debug.localCount", { count: localCount }) }),
              /* @__PURE__ */ jsx("span", { className: "text-primary", children: t("debug.serverCount", { count: serverCount }) }),
              traitStates && /* @__PURE__ */ jsx("span", { className: "text-accent truncate max-w-[400px]", children: traitStates }),
              !expanded && transitions.length > 0 && /* @__PURE__ */ jsx("span", { className: "ml-auto text-foreground/50", children: t("debug.transitionsCount", { count: transitions.length }) })
            ]
          }
        ),
        expanded && /* @__PURE__ */ jsxs("div", { className: "flex-1 flex overflow-hidden", children: [
          /* @__PURE__ */ jsx("div", { ref: scrollRef, className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ jsx("div", { className: "px-2 py-1", children: transitions.length === 0 ? /* @__PURE__ */ jsx("div", { className: "text-foreground/50 text-xs font-mono py-2 text-center", children: t("debug.waitingForTransitions") }) : /* @__PURE__ */ jsx("div", { className: "space-y-0.5", children: transitions.map((trace) => /* @__PURE__ */ jsx(TransitionRow, { trace }, trace.id)) }) }) }),
          /* @__PURE__ */ jsx(WalkMinimap, {})
        ] })
      ]
    }
  );
  return hudBottom ? createPortal(panel, hudBottom) : panel;
}
function RuntimeDebugger({
  position = "bottom-right",
  defaultCollapsed = true,
  className,
  mode = "floating",
  defaultTab,
  schema
}) {
  const { t } = useTranslate();
  const [isCollapsed, setIsCollapsed] = React79.useState(mode === "verify" ? true : defaultCollapsed);
  const [isVisible, setIsVisible] = React79.useState(mode === "inline" || mode === "verify" || isDebugEnabled2());
  const debugData = useDebugData();
  React79.useEffect(() => {
    if (mode === "inline") return;
    return onDebugToggle((enabled) => {
      setIsVisible(enabled);
      if (enabled) {
        setIsCollapsed(false);
      }
    });
  }, [mode]);
  React79.useEffect(() => {
    if (mode === "inline") return;
    const handleKeyDown = (e) => {
      if (e.key === "`" && isVisible) {
        const target = e.target;
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") return;
        setIsCollapsed((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isVisible, mode]);
  if (!isVisible) {
    return null;
  }
  const positionClasses2 = {
    "bottom-right": "bottom-4 right-4",
    "bottom-left": "bottom-4 left-4",
    "top-right": "top-4 right-4",
    "top-left": "top-4 left-4"
  };
  const { verification } = debugData;
  const failedChecks = verification.summary.failed;
  const tabItems = [
    {
      id: "dispatch",
      label: t("debug.tabDispatch"),
      badge: debugData.traits.length || void 0,
      content: /* @__PURE__ */ jsx(EventDispatcherTab, { traits: debugData.traits, schema })
    },
    {
      id: "verify",
      label: failedChecks > 0 ? t("debug.tabVerifyAlert") : t("debug.tabVerify"),
      badge: verification.summary.totalChecks || void 0,
      content: /* @__PURE__ */ jsx(VerificationTab, { checks: verification.checks, summary: verification.summary })
    },
    {
      id: "timeline",
      label: t("debug.tabTimeline"),
      badge: verification.transitions.length || void 0,
      content: /* @__PURE__ */ jsx(TransitionTimeline, { transitions: verification.transitions })
    },
    {
      id: "bridge",
      label: t("debug.tabBridge"),
      badge: verification.bridge?.connected ? void 0 : 1,
      content: /* @__PURE__ */ jsx(ServerBridgeTab, { bridge: verification.bridge })
    },
    {
      id: "traits",
      label: t("debug.tabTraits"),
      badge: debugData.traits.length || void 0,
      content: /* @__PURE__ */ jsx(TraitsTab, { traits: debugData.traits })
    },
    {
      id: "ticks",
      label: t("debug.tabTicks"),
      badge: debugData.ticks.filter((tick) => tick.active).length || void 0,
      content: /* @__PURE__ */ jsx(TicksTab, { ticks: debugData.ticks })
    },
    {
      id: "entities",
      label: t("debug.tabEntities"),
      badge: debugData.entitySnapshot?.runtime.length || void 0,
      content: /* @__PURE__ */ jsx(EntitiesTab, { snapshot: debugData.entitySnapshot })
    },
    {
      id: "events",
      label: t("debug.tabEvents"),
      badge: debugData.events.length > 0 ? debugData.events.length : void 0,
      content: /* @__PURE__ */ jsx(EventFlowTab, { events: debugData.events })
    },
    {
      id: "guards",
      label: t("debug.tabGuards"),
      badge: debugData.guards.filter((g) => !g.result).length || void 0,
      content: /* @__PURE__ */ jsx(GuardsPanel, { guards: debugData.guards })
    }
  ];
  if (mode === "inline") {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "runtime-debugger",
          "runtime-debugger--inline",
          className
        ),
        "data-testid": "debugger-inline",
        children: /* @__PURE__ */ jsxs(Card, { className: cn(
          "runtime-debugger__panel",
          isCollapsed ? "runtime-debugger__panel--inline-collapsed" : "runtime-debugger__panel--inline"
        ), children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "runtime-debugger__header",
              onClick: () => setIsCollapsed((prev) => !prev),
              style: { cursor: "pointer", userSelect: "none" },
              children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ jsxs(Typography, { variant: "h6", style: { fontSize: "0.75rem" }, children: [
                  isCollapsed ? "\u25B6" : "\u25BC",
                  " ",
                  t("debug.debugger")
                ] }),
                failedChecks > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: t("debug.failedCount", { count: failedChecks }) }) : debugData.traits.length > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: t("debug.traitsCount", { count: debugData.traits.length }) }) : /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: t("debug.idle") })
              ] })
            }
          ),
          !isCollapsed && /* @__PURE__ */ jsx("div", { className: "runtime-debugger__content", children: /* @__PURE__ */ jsx(
            Tabs,
            {
              items: tabItems,
              defaultActiveTab: defaultTab,
              variant: "pills",
              className: "runtime-debugger__tabs"
            }
          ) })
        ] })
      }
    );
  }
  if (mode === "verify") {
    const traitStates = debugData.traits.map((t2) => `${t2.name}:${t2.currentState}`).join(" | ");
    const serverEntries = verification.transitions.filter((t2) => t2.serverResponse);
    const localEntries = verification.transitions.filter((t2) => !t2.serverResponse);
    return /* @__PURE__ */ jsx(
      VerifyModePanel,
      {
        className,
        failedChecks,
        transitions: verification.transitions,
        traitStates,
        serverCount: serverEntries.length,
        localCount: localEntries.length
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "runtime-debugger",
        "fixed",
        positionClasses2[position],
        isCollapsed ? "runtime-debugger--collapsed" : "runtime-debugger--expanded",
        className
      ),
      "data-testid": isCollapsed ? "debugger-collapsed" : "debugger-expanded",
      style: { zIndex: 99999 },
      children: isCollapsed ? /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => setIsCollapsed(false),
          variant: "secondary",
          size: "sm",
          className: "runtime-debugger__toggle",
          title: t("debug.openDebugger"),
          children: failedChecks > 0 ? /* @__PURE__ */ jsxs("span", { className: "relative", children: [
            /* @__PURE__ */ jsx("span", { children: "V" }),
            /* @__PURE__ */ jsx("span", { className: "absolute -top-1 -right-2 w-2 h-2 bg-error rounded-full" })
          ] }) : /* @__PURE__ */ jsx("span", { children: "V" })
        }
      ) : /* @__PURE__ */ jsxs(Card, { className: "runtime-debugger__panel", children: [
        /* @__PURE__ */ jsxs("div", { className: "runtime-debugger__header", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx("span", { className: "text-lg", children: "V" }),
            /* @__PURE__ */ jsx(Typography, { variant: "h6", children: t("debug.kflowVerifier") }),
            failedChecks > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: t("debug.failedCount", { count: failedChecks }) }) : verification.summary.totalChecks > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: t("debug.allPassing") }) : /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: t("debug.runtime") })
          ] }),
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: () => setIsCollapsed(true),
              variant: "ghost",
              size: "sm",
              title: t("debug.close"),
              children: "x"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "runtime-debugger__content", children: /* @__PURE__ */ jsx(
          Tabs,
          {
            items: tabItems,
            defaultActiveTab: defaultTab,
            variant: "pills",
            className: "runtime-debugger__tabs"
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "runtime-debugger__footer", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground/50", children: t("debug.toggleHint") }) })
      ] })
    }
  );
}
var init_RuntimeDebugger2 = __esm({
  "components/core/organisms/debug/RuntimeDebugger.tsx"() {
    "use client";
    init_cn();
    init_useDebugData();
    init_debugUtils();
    init_Tabs();
    init_Button();
    init_Card();
    init_Badge();
    init_Typography();
    init_WalkMinimap();
    init_TraitsTab();
    init_TicksTab();
    init_EntitiesTab();
    init_EventFlowTab();
    init_GuardsPanel();
    init_VerificationTab();
    init_TransitionTimeline();
    init_ServerBridgeTab();
    init_EventDispatcherTab();
    init_RuntimeDebugger();
    RuntimeDebugger.displayName = "RuntimeDebugger";
  }
});
var SegmentRenderer;
var init_SegmentRenderer = __esm({
  "components/core/organisms/SegmentRenderer.tsx"() {
    "use client";
    init_MarkdownContent();
    init_CodeBlock();
    init_MermaidDiagram();
    init_QuizBlock();
    init_ActivationBlock();
    init_ConnectionBlock();
    init_ReflectionBlock();
    init_BloomQuizBlock();
    init_CodeRunnerPanel();
    init_cn();
    SegmentRenderer = ({
      segments,
      className,
      containerClassName,
      userProgress,
      onRunCodeSimulation,
      onRenderVisualization
    }) => {
      if (segments.length === 0) return null;
      let reflectIndex = 0;
      let bloomIndex = 0;
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "border border-border rounded-lg p-2 md:p-4 overflow-x-auto space-y-6",
            containerClassName,
            className
          ),
          children: segments.map((segment, index) => {
            if (segment.type === "markdown") {
              return /* @__PURE__ */ jsx(MarkdownContent, { content: segment.content }, `md-${index}`);
            }
            if (segment.type === "code") {
              if (segment.language === "mermaid") {
                return /* @__PURE__ */ jsx(MermaidDiagram, { code: segment.content }, `code-${index}`);
              }
              if (segment.runnable && onRunCodeSimulation) {
                return /* @__PURE__ */ jsx(
                  CodeRunnerPanel,
                  {
                    language: segment.language,
                    code: segment.content,
                    runnable: true,
                    onRun: (code) => onRunCodeSimulation(code, segment.language)
                  },
                  `code-${index}`
                );
              }
              return /* @__PURE__ */ jsx(
                CodeBlock,
                {
                  language: segment.language ?? "text",
                  code: segment.content
                },
                `code-${index}`
              );
            }
            if (segment.type === "quiz") {
              return /* @__PURE__ */ jsx(QuizBlock, { question: segment.question, answer: segment.answer }, `quiz-${index}`);
            }
            if (segment.type === "activate") {
              return /* @__PURE__ */ jsx(
                ActivationBlock,
                {
                  question: segment.question,
                  savedResponse: userProgress?.activationResponse
                },
                `activate-${index}`
              );
            }
            if (segment.type === "connect") {
              return /* @__PURE__ */ jsx(ConnectionBlock, { content: segment.content }, `connect-${index}`);
            }
            if (segment.type === "reflect") {
              const ri = reflectIndex++;
              return /* @__PURE__ */ jsx(
                ReflectionBlock,
                {
                  prompt: segment.prompt,
                  index: ri,
                  savedNote: userProgress?.reflectionNotes?.[ri]
                },
                `reflect-${index}`
              );
            }
            if (segment.type === "bloom") {
              const bi = bloomIndex++;
              return /* @__PURE__ */ jsx(
                BloomQuizBlock,
                {
                  level: segment.level,
                  question: segment.question,
                  answer: segment.answer,
                  index: bi,
                  isAnswered: userProgress?.bloomAnswered?.[bi]
                },
                `bloom-${index}`
              );
            }
            if (segment.type === "visualization") {
              return onRenderVisualization ? onRenderVisualization(segment.visualizationType, segment.description, index) ?? null : null;
            }
            return null;
          })
        }
      );
    };
    SegmentRenderer.displayName = "SegmentRenderer";
  }
});
var ShowcaseOrganism;
var init_ShowcaseOrganism = __esm({
  "components/marketing/organisms/ShowcaseOrganism.tsx"() {
    "use client";
    init_cn();
    init_useEventBus();
    init_Stack();
    init_Typography();
    init_SimpleGrid();
    init_ShowcaseCard();
    init_LoadingState();
    init_ErrorState();
    ShowcaseOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      columns = 3,
      heading,
      subtitle
    }) => {
      useEventBus();
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("w-full", className), children: [
        (heading || subtitle) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "w-full", children: [
          heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", align: "center", children: heading }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "muted", align: "center", className: "max-w-2xl", children: subtitle })
        ] }),
        /* @__PURE__ */ jsx(SimpleGrid, { cols: columns, gap: "lg", children: items.map((item) => {
          const imageRaw = item.image;
          return /* @__PURE__ */ jsx(
            ShowcaseCard,
            {
              title: String(item.title ?? ""),
              description: item.description != null ? String(item.description) : void 0,
              image: { src: String(imageRaw?.src ?? ""), alt: String(imageRaw?.alt ?? "") },
              href: item.href != null ? String(item.href) : void 0,
              badge: item.badge != null ? String(item.badge) : void 0,
              accentColor: item.accentColor != null ? String(item.accentColor) : void 0
            },
            String(item.id ?? "")
          );
        }) })
      ] });
    };
    ShowcaseOrganism.displayName = "ShowcaseOrganism";
  }
});
var StatCard;
var init_StatCard = __esm({
  "components/core/organisms/StatCard.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Box();
    init_Stack();
    init_Button();
    init_Sparkline();
    init_useEventBus();
    init_Icon();
    StatCard = ({
      label: propLabel,
      title: propTitle,
      value: propValue,
      previousValue,
      currentValue: currentValue2,
      trend: manualTrend,
      trendDirection: manualDirection,
      invertTrend = false,
      icon: iconProp,
      iconBg = "bg-muted",
      iconColor = "text-foreground",
      subtitle,
      action,
      className,
      // Schema-based props
      entity,
      metrics,
      sparklineData,
      isLoading: externalLoading,
      error: externalError
    }) => {
      const Icon2 = typeof iconProp === "string" ? resolveIcon(iconProp) ?? void 0 : iconProp;
      const labelToUse = propLabel ?? propTitle;
      const eventBus = useEventBus();
      const { t } = useTranslate();
      const handleActionClick = React79__default.useCallback(() => {
        if (action?.event) {
          eventBus.emit(`UI:${action.event}`, {});
        }
        if (action?.onClick) {
          action.onClick();
        }
      }, [action, eventBus]);
      const data = Array.isArray(entity) ? entity : entity ? [entity] : [];
      const isLoading = externalLoading ?? false;
      const error = externalError;
      const computeMetricValue = React79__default.useCallback(
        (metric, items) => {
          if (metric.value !== void 0) {
            return metric.value;
          }
          const field = metric.field;
          if (!field) {
            return 0;
          }
          if (field === "count") {
            return items.length;
          }
          if (field.includes(":")) {
            const [fieldName2, fieldValue] = field.split(":");
            return items.filter((item) => item[fieldName2] === fieldValue).length;
          }
          const fieldExistsOnItems = items.some((item) => field in item);
          if (fieldExistsOnItems) {
            return items.reduce((acc, item) => {
              const val = item[field];
              return acc + (typeof val === "number" ? val : 0);
            }, 0);
          }
          const statusFields = ["status", "state", "phase"];
          for (const statusField of statusFields) {
            const hasStatusField = items.some((item) => statusField in item);
            if (hasStatusField) {
              const count = items.filter(
                (item) => item[statusField] === field
              ).length;
              if (count > 0 || items.length === 0) {
                return count;
              }
            }
          }
          return 0;
        },
        []
      );
      const schemaStats = React79__default.useMemo(() => {
        if (!metrics || metrics.length === 0) return null;
        return metrics.map((metric) => ({
          label: metric.label,
          value: computeMetricValue(metric, data),
          format: metric.format
        }));
      }, [metrics, data, computeMetricValue]);
      const calculatedTrend = React79__default.useMemo(() => {
        if (manualTrend !== void 0) return manualTrend;
        if (previousValue === void 0 || currentValue2 === void 0)
          return void 0;
        if (previousValue === 0) return currentValue2 > 0 ? 100 : 0;
        return (currentValue2 - previousValue) / previousValue * 100;
      }, [manualTrend, previousValue, currentValue2]);
      if (schemaStats && schemaStats.length > 1) {
        if (isLoading) {
          return /* @__PURE__ */ jsx(
            Box,
            {
              className: cn("grid gap-4", className),
              style: { gridTemplateColumns: `repeat(${schemaStats.length}, 1fr)` },
              children: schemaStats.map((_, idx) => /* @__PURE__ */ jsx(Card, { className: "p-4", children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "animate-pulse", children: [
                /* @__PURE__ */ jsx(Box, { className: "h-3 bg-muted rounded w-16" }),
                /* @__PURE__ */ jsx(Box, { className: "h-6 bg-muted rounded w-12" })
              ] }) }, idx))
            }
          );
        }
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: cn("grid gap-4", className),
            style: { gridTemplateColumns: `repeat(${schemaStats.length}, 1fr)` },
            children: schemaStats.map((stat, idx) => /* @__PURE__ */ jsxs(Card, { className: "p-4", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: stat.label }),
              /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "text-xl", children: stat.value })
            ] }, idx))
          }
        );
      }
      const label = schemaStats?.[0]?.label || labelToUse || t("statCard.defaultLabel");
      const normalizedPropValue = Array.isArray(propValue) ? propValue[0] ?? propValue.length : propValue;
      const value = schemaStats?.[0]?.value ?? normalizedPropValue ?? 0;
      const trendDirection = manualDirection || (calculatedTrend === void 0 || calculatedTrend === 0 ? "neutral" : calculatedTrend > 0 ? "up" : "down");
      const isPositive = invertTrend ? trendDirection === "down" : trendDirection === "up";
      const TrendIcon = trendDirection === "up" ? TrendingUp : trendDirection === "down" ? TrendingDown : Minus;
      if (error) {
        return /* @__PURE__ */ jsx(Card, { className: cn("p-6", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "space-y-1", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: label }),
          /* @__PURE__ */ jsx(Typography, { variant: "small", color: "error", children: t("error.generic") + ": " + error.message })
        ] }) });
      }
      if (isLoading) {
        return /* @__PURE__ */ jsx(Card, { className: cn("p-6", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "animate-pulse", children: [
          /* @__PURE__ */ jsx(Box, { className: "h-4 bg-muted rounded w-24" }),
          /* @__PURE__ */ jsx(Box, { className: "h-8 bg-muted rounded w-32" }),
          /* @__PURE__ */ jsx(Box, { className: "h-4 bg-muted rounded w-20" })
        ] }) });
      }
      return /* @__PURE__ */ jsxs(Card, { className: cn("p-6", className), children: [
        /* @__PURE__ */ jsxs(HStack, { align: "start", justify: "between", children: [
          /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "space-y-1", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: label }),
            /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "text-2xl", children: value }),
            calculatedTrend !== void 0 && /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "xs", children: [
              /* @__PURE__ */ jsxs(
                HStack,
                {
                  align: "center",
                  gap: "none",
                  className: cn(
                    "gap-0.5 text-sm font-bold",
                    isPositive ? "text-success" : trendDirection === "neutral" ? "text-muted-foreground" : "text-error"
                  ),
                  children: [
                    /* @__PURE__ */ jsx(TrendIcon, { className: "h-4 w-4" }),
                    /* @__PURE__ */ jsxs(Typography, { variant: "caption", as: "span", children: [
                      Math.abs(calculatedTrend).toFixed(1),
                      "%"
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", as: "span", children: t("statCard.vsLastPeriod") })
            ] }),
            subtitle && !calculatedTrend && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: subtitle })
          ] }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "end", children: [
            Icon2 && /* @__PURE__ */ jsx(Box, { className: cn("p-3", iconBg), children: /* @__PURE__ */ jsx(Icon2, { className: cn("h-6 w-6", iconColor) }) }),
            sparklineData && sparklineData.length > 1 && /* @__PURE__ */ jsx(Sparkline, { data: sparklineData, color: "auto" })
          ] })
        ] }),
        action && /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "ghost",
            onClick: handleActionClick,
            className: "mt-4 text-sm font-bold text-foreground hover:underline",
            "data-testid": action.event ? `action-${action.event}` : void 0,
            children: [
              action.label,
              " \u2192"
            ]
          }
        )
      ] });
    };
    StatCard.displayName = "StatCard";
  }
});
var StatsOrganism;
var init_StatsOrganism = __esm({
  "components/marketing/organisms/StatsOrganism.tsx"() {
    "use client";
    init_cn();
    init_StatsGrid();
    init_LoadingState();
    init_ErrorState();
    StatsOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      columns = 3
    }) => {
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      const stats = items.map((item) => ({
        value: String(item.value ?? ""),
        label: String(item.label ?? "")
      }));
      return /* @__PURE__ */ jsx(
        StatsGrid,
        {
          stats,
          columns,
          className: cn(className)
        }
      );
    };
    StatsOrganism.displayName = "StatsOrganism";
  }
});
var StepFlowOrganism;
var init_StepFlowOrganism = __esm({
  "components/marketing/organisms/StepFlowOrganism.tsx"() {
    "use client";
    init_cn();
    init_Stack();
    init_Typography();
    init_StepFlow();
    init_LoadingState();
    init_ErrorState();
    StepFlowOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      orientation = "horizontal",
      showConnectors = true,
      heading,
      subtitle
    }) => {
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      const steps = items.map((item) => ({
        number: item.number != null ? Number(item.number) : void 0,
        title: String(item.title ?? ""),
        description: String(item.description ?? ""),
        icon: item.icon != null ? String(item.icon) : void 0
      }));
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("w-full", className), children: [
        (heading || subtitle) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "w-full", children: [
          heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", align: "center", children: heading }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "muted", align: "center", className: "max-w-2xl", children: subtitle })
        ] }),
        /* @__PURE__ */ jsx(
          StepFlow,
          {
            steps,
            orientation,
            showConnectors
          }
        )
      ] });
    };
    StepFlowOrganism.displayName = "StepFlowOrganism";
  }
});

// components/core/molecules/markdown/index.ts
var init_markdown = __esm({
  "components/core/molecules/markdown/index.ts"() {
    init_MarkdownContent();
    init_CodeBlock();
  }
});
function groupByOrbital(subagents) {
  const map = /* @__PURE__ */ new Map();
  for (const sub of subagents) {
    const key = sub.orbitalName ?? "(unattached)";
    const arr = map.get(key) ?? [];
    arr.push(sub);
    map.set(key, arr);
  }
  return map;
}
function statusIconName(status) {
  switch (status) {
    case "running":
      return "loader";
    case "complete":
      return "check";
    case "error":
      return "x";
    default:
      return "circle";
  }
}
function lastMessage(sub) {
  if (sub.messages.length === 0) return void 0;
  return sub.messages[sub.messages.length - 1].message;
}
function formatHHMMSS(ts) {
  const d = new Date(ts);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}
function compactJson(value) {
  if (value === void 0 || value === null) return "";
  if (typeof value === "string") return value;
  try {
    const json = JSON.stringify(value);
    if (json.length <= 240) return json;
    return json.slice(0, 239) + "\u2026";
  } catch {
    return String(value);
  }
}
function tryPrettyJson(s) {
  try {
    return JSON.stringify(JSON.parse(s), null, 2);
  } catch {
    return null;
  }
}
function summarizeArgs(args) {
  const keys = Object.keys(args);
  if (keys.length === 0) return "";
  return keys.slice(0, 3).join(", ") + (keys.length > 3 ? ", \u2026" : "");
}
function previewText(text, max = 120) {
  if (!text) return "";
  return text.length > max ? text.slice(0, max - 1) + "\u2026" : text;
}
function coordinatorToActivityItems(activities) {
  return activities.flatMap((a) => {
    switch (a.type) {
      case "tool_call":
        return [{
          type: "tool_call",
          tool: a.tool,
          args: a.args,
          timestamp: a.timestamp
        }];
      case "tool_result":
        return [{
          type: "tool_result",
          tool: a.tool,
          result: a.result,
          success: a.success,
          timestamp: a.timestamp
        }];
      case "message":
        return [{
          type: "message",
          role: a.role,
          content: a.content,
          timestamp: a.timestamp
        }];
      case "error":
        return [{
          type: "message",
          role: "system",
          content: `Error: ${a.message}`,
          timestamp: a.timestamp
        }];
      case "coordinator_decision":
      case "plan_committed":
      case "pending_question":
      case "clarification_question":
        return [];
      case "file_operation":
        return [{
          type: "file_operation",
          operation: a.operation,
          path: a.path,
          success: a.success,
          timestamp: a.timestamp
        }];
      case "schema_diff":
        return [{
          type: "schema_diff",
          filePath: a.filePath,
          hunks: a.hunks,
          timestamp: a.timestamp
        }];
    }
  });
}
function pluckCoordinatorState(activities) {
  let decision = null;
  let plan = null;
  const pendingQuestions = [];
  for (const a of activities) {
    if (a.type === "coordinator_decision") decision = a;
    else if (a.type === "plan_committed") plan = a;
    else if (a.type === "pending_question") pendingQuestions.push(a);
  }
  return { decision, plan, pendingQuestions };
}
function subagentMessagesToActivities(messages) {
  return messages.map((m) => {
    if (m.tool) {
      return {
        type: "tool_call",
        tool: m.tool,
        args: { preview: m.message },
        timestamp: m.timestamp
      };
    }
    return {
      type: "message",
      role: "system",
      content: m.message,
      timestamp: m.timestamp
    };
  });
}
function buildTimelineItems(messages, activities, subagents) {
  const items = [];
  if (messages) {
    messages.forEach((m, i) => items.push({ source: "message", data: m, index: i }));
  }
  if (activities) {
    activities.forEach((a) => items.push({ source: "activity", data: a }));
  }
  subagents.forEach((s) => items.push({ source: "subagent", data: s }));
  return items;
}
function timelineItemIcon(item) {
  switch (item.source) {
    case "message": {
      const m = item.data;
      if (m.role === "tool") return { name: "terminal", color: "text-[var(--color-primary)]" };
      if (m.reasoningContent) return { name: "sparkles", color: "text-[var(--color-primary)]" };
      if (m.role === "user") return { name: "user", color: "text-[var(--color-primary)]" };
      return { name: "message-square", color: "text-[var(--color-muted-foreground)]" };
    }
    case "activity": {
      const a = item.data;
      switch (a.type) {
        case "tool_call":
          return { name: "terminal", color: "text-[var(--color-primary)]" };
        case "tool_result":
          return { name: a.success !== false ? "check" : "x", color: a.success !== false ? "text-[var(--color-success)]" : "text-[var(--color-danger)]" };
        case "error":
          return { name: "alert-triangle", color: "text-[var(--color-danger)]" };
        case "file_operation":
          return { name: "file", color: "text-[var(--color-muted-foreground)]" };
        case "schema_diff":
          return { name: "git-commit", color: "text-[var(--color-muted-foreground)]" };
        default:
          return { name: "info", color: "text-[var(--color-muted-foreground)]" };
      }
    }
    case "subagent":
      return { name: "bot", color: "text-[var(--color-primary)]" };
  }
}
function timelineItemLabel(item) {
  switch (item.source) {
    case "message": {
      const m = item.data;
      if (m.role === "tool") return "tool";
      if (m.reasoningContent) return "thinking";
      return m.role;
    }
    case "activity":
      return item.data.type;
    case "subagent":
      return "subagent";
  }
}
function timelineItemPreview(item) {
  switch (item.source) {
    case "message": {
      const m = item.data;
      if (m.role === "tool") return `${m.toolName ?? "tool"} \u2192 ${m.toolCallId?.slice(0, 8) ?? ""}`;
      if (m.reasoningContent) return previewText(m.reasoningContent, 120);
      return previewText(m.content, 120);
    }
    case "activity": {
      const a = item.data;
      switch (a.type) {
        case "tool_call":
          return `${a.tool}(${summarizeArgs(a.args)})`;
        case "tool_result":
          return `${a.tool}: ${compactJson(a.result)}`;
        case "message":
          return previewText(a.content, 120);
        case "error":
          return previewText(a.message, 120);
        case "file_operation":
          return `${a.operation} ${a.path}`;
        case "schema_diff":
          return `diff ${a.filePath}`;
        default:
          return String(a.type);
      }
    }
    case "subagent":
      return `${item.data.name} \xB7 ${item.data.task}`;
  }
}
function timelineItemTimeLabel(item) {
  if (item.source === "activity") return formatHHMMSS(item.data.timestamp);
  if (item.source === "subagent") {
    const ts = item.data.messages[0]?.timestamp;
    return ts !== void 0 ? formatHHMMSS(ts) : void 0;
  }
  return void 0;
}
function TraceDetailContent({ item }) {
  const { t } = useTranslate();
  switch (item.source) {
    case "message": {
      const m = item.data;
      return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "items-center", children: /* @__PURE__ */ jsx(Badge, { variant: roleBadgeVariant[m.role], className: "text-[10px] uppercase", children: m.role }) }),
        typeof m.reasoningContent === "string" && m.reasoningContent.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-1", children: t("subagentTrace.reasoning") }),
          /* @__PURE__ */ jsx(MarkdownContent, { content: m.reasoningContent })
        ] }),
        m.content.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-1", children: t("subagentTrace.content") }),
          m.role === "tool" ? (() => {
            const pretty = tryPrettyJson(m.content);
            return pretty !== null ? /* @__PURE__ */ jsx(CodeBlock, { code: pretty, language: "json", maxHeight: "24rem" }) : /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap font-mono text-[11px]", children: m.content });
          })() : /* @__PURE__ */ jsx(MarkdownContent, { content: m.content })
        ] }),
        Array.isArray(m.toolCalls) && m.toolCalls.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-1", children: t("subagentTrace.toolCalls") }),
          /* @__PURE__ */ jsx(
            Accordion,
            {
              multiple: true,
              items: m.toolCalls.map((tc, i) => ({
                id: `tc-detail-${i}`,
                title: `${tc.name}(${summarizeArgs(tc.args)})`,
                content: /* @__PURE__ */ jsx(CodeBlock, { code: JSON.stringify(tc.args, null, 2), language: "json", maxHeight: "24rem" })
              }))
            }
          )
        ] })
      ] });
    }
    case "activity": {
      const a = item.data;
      switch (a.type) {
        case "tool_call":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "default", className: "text-[10px]", children: "tool_call" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: a.tool }),
            /* @__PURE__ */ jsx(CodeBlock, { code: JSON.stringify(a.args, null, 2), language: "json", maxHeight: "60vh" })
          ] });
        case "tool_result":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: a.success !== false ? "default" : "warning", className: "text-[10px]", children: a.success !== false ? "success" : "fail" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: a.tool }),
            /* @__PURE__ */ jsx(CodeBlock, { code: JSON.stringify(a.result, null, 2), language: "json", maxHeight: "60vh" })
          ] });
        case "message":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: a.role }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "whitespace-pre-wrap", children: a.content })
          ] });
        case "error":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "warning", className: "text-[10px]", children: "error" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "whitespace-pre-wrap text-[var(--color-danger)]", children: a.message })
          ] });
        case "file_operation":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: "file" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) })
            ] }),
            /* @__PURE__ */ jsxs(Typography, { variant: "body2", children: [
              a.operation,
              " ",
              a.path
            ] })
          ] });
        case "schema_diff":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: "diff" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: a.filePath })
          ] });
        default:
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp) }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: String(a.type) })
          ] });
      }
    }
    case "subagent": {
      const s = item.data;
      const activities = subagentMessagesToActivities(s.messages);
      const ts = s.messages[0]?.timestamp;
      return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
          /* @__PURE__ */ jsx(Badge, { variant: "default", className: "text-[10px]", children: s.role }),
          ts !== void 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(ts) })
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", weight: "semibold", children: s.name }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: s.task }),
        activities.length > 0 && /* @__PURE__ */ jsx(Box, { className: "border-t border-[var(--color-border)] pt-2", children: /* @__PURE__ */ jsx(InlineActivityStream, { activities, autoScroll: false }) })
      ] });
    }
  }
}
var InlineActivityRow, InlineActivityStream, CoordinatorCard, SubagentRow, OrbitalGroup, SubagentRichCard, roleBadgeVariant, ChatMessageRow, CoordinatorConversation, SubagentTracePanel;
var init_SubagentTracePanel = __esm({
  "components/core/organisms/SubagentTracePanel.tsx"() {
    "use client";
    init_Box();
    init_Stack();
    init_Typography();
    init_Badge();
    init_Icon();
    init_Button();
    init_Modal();
    init_Accordion();
    init_markdown();
    InlineActivityRow = ({ activity }) => {
      const time = formatHHMMSS(activity.timestamp);
      const baseRow = "items-start px-3 py-1 hover:bg-[var(--color-surface)]";
      if (activity.type === "tool_call") {
        return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
          /* @__PURE__ */ jsx(Icon, { name: "terminal", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-primary)]" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] font-mono break-all whitespace-pre-wrap", children: [
            /* @__PURE__ */ jsx(Typography, { as: "span", variant: "caption", weight: "semibold", className: "text-[11px] font-mono", children: activity.tool }),
            activity.args !== void 0 && /* @__PURE__ */ jsxs(Typography, { as: "span", variant: "caption", color: "muted", className: "text-[11px] font-mono", children: [
              " ",
              compactJson(activity.args)
            ] })
          ] }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
        ] });
      }
      if (activity.type === "tool_result") {
        const success = activity.success !== false;
        return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: success ? "check" : "x",
              size: "xs",
              className: `mt-0.5 flex-shrink-0 ${success ? "text-[var(--color-success)]" : "text-[var(--color-danger)]"}`
            }
          ),
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] font-mono break-all whitespace-pre-wrap", children: [
            /* @__PURE__ */ jsxs(Typography, { as: "span", variant: "caption", color: "muted", className: "text-[11px] font-mono", children: [
              activity.tool,
              ":",
              " "
            ] }),
            /* @__PURE__ */ jsx(Typography, { as: "span", variant: "caption", className: "text-[11px] font-mono", children: compactJson(activity.result) })
          ] }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
        ] });
      }
      if (activity.type === "message") {
        const role = activity.role;
        const iconName = role === "user" ? "user" : role === "system" ? "info" : "sparkles";
        const roleColor = role === "user" ? "text-[var(--color-primary)]" : role === "system" ? "text-[var(--color-muted-foreground)]" : "text-[var(--color-foreground)]";
        return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
          /* @__PURE__ */ jsx(Icon, { name: iconName, size: "xs", className: `mt-0.5 flex-shrink-0 ${roleColor}` }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] whitespace-pre-wrap break-words", children: activity.content }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
        ] });
      }
      if (activity.type === "error") {
        return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
          /* @__PURE__ */ jsx(Icon, { name: "alert-triangle", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-danger)]" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] text-[var(--color-danger)] whitespace-pre-wrap break-words", children: activity.message }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
        ] });
      }
      return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
        /* @__PURE__ */ jsx(Icon, { name: "file", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-muted-foreground)]" }),
        /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "flex-1 min-w-0 text-[11px] font-mono break-all", children: [
          "[",
          activity.type,
          "] ",
          compactJson(activity)
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
      ] });
    };
    InlineActivityStream = ({ activities, autoScroll = true, className }) => {
      const endRef = React79__default.useRef(null);
      React79__default.useEffect(() => {
        if (!autoScroll) return;
        endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      }, [activities.length, autoScroll]);
      return /* @__PURE__ */ jsxs(Box, { className, children: [
        activities.map((a, i) => /* @__PURE__ */ jsx(InlineActivityRow, { activity: a }, `${a.timestamp}-${i}`)),
        /* @__PURE__ */ jsx(Box, { ref: endRef })
      ] });
    };
    CoordinatorCard = ({ snapshot, className }) => {
      const { t } = useTranslate();
      const { decision, plan, pendingQuestions } = snapshot;
      if (!decision && !plan && pendingQuestions.length === 0) return null;
      return /* @__PURE__ */ jsxs(
        Box,
        {
          className: `px-3 py-2 border-b border-[var(--color-border)] bg-[var(--color-muted)]/30 ${className ?? ""}`,
          children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center mb-2", children: [
              /* @__PURE__ */ jsx(Icon, { name: "compass", size: "xs" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold text-[11px]", children: t("subagentTrace.coordinator") })
            ] }),
            decision && /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "mb-2", children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] uppercase tracking-wide", children: t("subagentTrace.organism") }),
                /* @__PURE__ */ jsx(Badge, { variant: "default", className: "text-[10px]", children: decision.organism }),
                decision.priorOrganism && decision.priorOrganism !== decision.organism && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: t("subagentTrace.wasOrganism", { organism: decision.priorOrganism }) })
              ] }),
              decision.reason && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[11px] mt-0.5", children: decision.reason })
            ] }),
            plan && plan.orbitals.length > 0 && /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "mb-2", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] uppercase tracking-wide mb-0.5", children: plan.orbitals.length === 1 ? t("subagentTrace.planOrbital", { count: plan.orbitals.length }) : t("subagentTrace.planOrbitals", { count: plan.orbitals.length }) }),
              /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: plan.orbitals.map((o) => /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: o }, o)) })
            ] }),
            pendingQuestions.length > 0 && /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] uppercase tracking-wide mb-0.5", children: pendingQuestions.length === 1 ? t("subagentTrace.pendingQuestion", { count: pendingQuestions.length }) : t("subagentTrace.pendingQuestions", { count: pendingQuestions.length }) }),
              pendingQuestions.map((q) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-start", children: [
                /* @__PURE__ */ jsx(Icon, { name: "help-circle", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-warning)]" }),
                /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-[11px] flex-1 min-w-0", children: [
                  q.question,
                  q.orbitalName && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "text-[10px] ml-1", children: [
                    "(",
                    q.orbitalName,
                    ")"
                  ] })
                ] })
              ] }, q.questionId))
            ] })
          ]
        }
      );
    };
    SubagentRow = ({ subagent }) => {
      const recent = lastMessage(subagent);
      return /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "sm",
          className: "items-start px-3 py-2 border-b border-[var(--color-border)]",
          children: [
            /* @__PURE__ */ jsx(Box, { className: "pt-0.5", children: /* @__PURE__ */ jsx(Icon, { name: statusIconName(subagent.status), size: "xs" }) }),
            /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-medium truncate", children: subagent.name }),
                /* @__PURE__ */ jsx(Badge, { variant: "default", children: subagent.role })
              ] }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "truncate", children: recent ?? subagent.task })
            ] })
          ]
        }
      );
    };
    OrbitalGroup = ({ orbitalName, subagents }) => {
      const { t } = useTranslate();
      const runningCount = subagents.filter((s) => s.status === "running").length;
      const completeCount = subagents.filter((s) => s.status === "complete").length;
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "border-b border-[var(--color-border)]", children: [
        /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            className: "items-center px-3 py-2 bg-[var(--color-surface)] border-b border-[var(--color-border)]",
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "circle", size: "xs" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1 truncate", children: orbitalName }),
              /* @__PURE__ */ jsx(Badge, { variant: "default", children: runningCount > 0 ? t("subagentTrace.countRunning", { count: runningCount }) : t("subagentTrace.countDone", { count: completeCount }) })
            ]
          }
        ),
        subagents.map((sub) => /* @__PURE__ */ jsx(SubagentRow, { subagent: sub }, sub.id))
      ] });
    };
    SubagentRichCard = ({ subagent }) => {
      const { t } = useTranslate();
      const activities = React79__default.useMemo(
        () => subagentMessagesToActivities(subagent.messages),
        [subagent.messages]
      );
      return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "border-b border-[var(--color-border)] p-3", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center mb-2", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              style: {
                width: 8,
                height: 8,
                borderRadius: "50%",
                flexShrink: 0,
                backgroundColor: subagent.status === "complete" ? "var(--color-success)" : subagent.status === "error" ? "var(--color-error)" : "var(--color-primary)",
                ...subagent.status === "running" ? { animation: "pulse 1.5s infinite" } : {}
              }
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1 truncate", children: subagent.name }),
          /* @__PURE__ */ jsx(Badge, { variant: subagent.role === "deterministic" ? "default" : subagent.role === "llm" ? "info" : "warning", children: subagent.role }),
          subagent.durationMs !== void 0 && subagent.durationMs > 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: subagent.durationMs < 1e3 ? `${subagent.durationMs}ms` : `${(subagent.durationMs / 1e3).toFixed(1)}s` })
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-2", children: subagent.task }),
        activities.length > 0 ? /* @__PURE__ */ jsx(Box, { className: "max-h-64 overflow-y-auto border-t border-[var(--color-border)]", children: /* @__PURE__ */ jsx(InlineActivityStream, { activities, autoScroll: true }) }) : /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "italic text-[10px]", children: subagent.status === "complete" ? t("subagentTrace.noConversationLog") : t("subagentTrace.waitingForProcessData") })
      ] });
    };
    roleBadgeVariant = {
      system: "neutral",
      user: "info",
      assistant: "default",
      tool: "warning"
    };
    ChatMessageRow = ({ message, index }) => {
      const { t } = useTranslate();
      const { role, content, toolCalls, reasoningContent, toolCallId, toolName } = message;
      if (role === "tool") {
        const pretty = tryPrettyJson(content);
        const title = `${toolName ?? "tool"} \u2192${toolCallId ? ` ${toolCallId.slice(0, 8)}` : ""}`;
        const body = pretty !== null ? /* @__PURE__ */ jsx(CodeBlock, { code: pretty, language: "json", maxHeight: "24rem" }) : /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap font-mono text-[11px]", children: content });
        const items = [{ id: `tool-${index}`, title, content: body }];
        return /* @__PURE__ */ jsx(Box, { className: "px-3 py-2 border-b border-[var(--color-border)]", children: /* @__PURE__ */ jsx(Accordion, { items }) });
      }
      const hasReasoning = typeof reasoningContent === "string" && reasoningContent.length > 0;
      const hasToolCalls = Array.isArray(toolCalls) && toolCalls.length > 0;
      return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "px-3 py-2 border-b border-[var(--color-border)]", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
          /* @__PURE__ */ jsx(Badge, { variant: roleBadgeVariant[role], className: "text-[10px] uppercase", children: role }),
          hasReasoning && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: [
            "\xB7 ",
            t("subagentTrace.thinking")
          ] }),
          hasToolCalls && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: [
            "\xB7 ",
            toolCalls.length === 1 ? t("subagentTrace.toolCallCount", { count: toolCalls.length }) : t("subagentTrace.toolCallCountPlural", { count: toolCalls.length })
          ] })
        ] }),
        hasReasoning && /* @__PURE__ */ jsx(Accordion, { items: [{
          id: `reasoning-${index}`,
          title: t("subagentTrace.reasoning"),
          content: /* @__PURE__ */ jsx(MarkdownContent, { content: reasoningContent })
        }] }),
        content.length > 0 && /* @__PURE__ */ jsx(MarkdownContent, { content }),
        hasToolCalls && /* @__PURE__ */ jsx(
          Accordion,
          {
            multiple: true,
            items: toolCalls.map((tc, i) => ({
              id: `tc-${index}-${i}`,
              title: `${tc.name}(${summarizeArgs(tc.args)})`,
              content: /* @__PURE__ */ jsx(CodeBlock, { code: JSON.stringify(tc.args, null, 2), language: "json", maxHeight: "24rem" })
            }))
          }
        )
      ] });
    };
    CoordinatorConversation = ({ messages, autoScroll = true, className }) => {
      const endRef = React79__default.useRef(null);
      React79__default.useEffect(() => {
        if (!autoScroll) return;
        endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      }, [messages.length, autoScroll]);
      return /* @__PURE__ */ jsxs(Box, { className, children: [
        messages.map((m, i) => /* @__PURE__ */ jsx(ChatMessageRow, { message: m, index: i }, `msg-${i}`)),
        /* @__PURE__ */ jsx(Box, { ref: endRef })
      ] });
    };
    SubagentTracePanel = ({
      subagents,
      focusedOrbital,
      disclosureLevel,
      open,
      onClose,
      className,
      mode = "overlay",
      coordinatorActivities,
      coordinatorMessages
    }) => {
      const { t } = useTranslate();
      const [selectedItem, setSelectedItem] = useState(null);
      const densityLabel = (rich) => rich ? t("subagentTrace.densityRich") : t("subagentTrace.densityCompact");
      if (mode === "overlay" && !open) return null;
      const isTabMode = mode === "tab";
      const isRichMode = isTabMode || disclosureLevel >= 3;
      if (isTabMode) {
        const timelineItems = buildTimelineItems(coordinatorMessages, coordinatorActivities, subagents);
        const hasData = timelineItems.length > 0;
        return /* @__PURE__ */ jsxs(Box, { className: `h-full w-full bg-[var(--color-card)] overflow-hidden flex flex-col ${className ?? ""}`, children: [
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
                /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1", children: t("subagentTrace.trace") }),
                onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
              ]
            }
          ),
          !hasData && /* @__PURE__ */ jsx(Box, { className: "flex-1 flex items-center justify-center px-4", children: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", className: "text-center", children: t("subagentTrace.noAgentActivity") }) }),
          hasData && /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: timelineItems.map((item, i) => {
            const { name: iconName, color: iconColor } = timelineItemIcon(item);
            const isLast = i === timelineItems.length - 1;
            return /* @__PURE__ */ jsxs(
              Box,
              {
                className: "flex items-start px-3 py-2 border-b border-[var(--color-border)] hover:bg-[var(--color-muted)]/30 transition-colors duration-fast cursor-pointer",
                onClick: () => setSelectedItem(item),
                children: [
                  /* @__PURE__ */ jsxs(Box, { className: "flex flex-col items-center mr-3 mt-0.5", style: { width: 20 }, children: [
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        className: "rounded-full flex-shrink-0",
                        style: {
                          width: 8,
                          height: 8,
                          backgroundColor: "var(--color-primary)"
                        }
                      }
                    ),
                    !isLast && /* @__PURE__ */ jsx(
                      Box,
                      {
                        className: "flex-1",
                        style: {
                          width: 2,
                          backgroundColor: "var(--color-border)",
                          marginTop: 4,
                          minHeight: 24
                        }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
                    /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                      /* @__PURE__ */ jsx(Icon, { name: iconName, size: "xs", className: `flex-shrink-0 ${iconColor}` }),
                      timelineItemTimeLabel(item) && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: timelineItemTimeLabel(item) }),
                      /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: timelineItemLabel(item) })
                    ] }),
                    /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-start", children: [
                      /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", className: "flex-1 min-w-0 line-clamp-2", children: timelineItemPreview(item) }),
                      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", className: "flex-shrink-0 mt-0", onClick: (e) => {
                        e.stopPropagation();
                        setSelectedItem(item);
                      }, children: /* @__PURE__ */ jsx(Icon, { name: "maximize-2", size: "xs" }) })
                    ] })
                  ] })
                ]
              },
              `${item.source}-${i}`
            );
          }) }) }),
          /* @__PURE__ */ jsx(
            Modal,
            {
              isOpen: selectedItem !== null,
              onClose: () => setSelectedItem(null),
              title: selectedItem ? `${timelineItemLabel(selectedItem)}${timelineItemTimeLabel(selectedItem) ? ` \xB7 ${timelineItemTimeLabel(selectedItem)}` : ""}` : "",
              size: "lg",
              children: selectedItem && /* @__PURE__ */ jsx(TraceDetailContent, { item: selectedItem })
            }
          )
        ] });
      }
      const filtered = focusedOrbital ? subagents.filter((s) => s.orbitalName === focusedOrbital) : subagents;
      const wrapperClass = isRichMode ? `absolute inset-x-3 bottom-3 sm:inset-x-auto sm:top-3 sm:right-3 sm:bottom-3 w-full sm:w-[28rem] max-w-[calc(100vw-1.5rem)] max-h-[60vh] sm:max-h-none bg-[var(--color-card)] border border-[var(--color-border)] rounded-md shadow-lg overflow-hidden flex flex-col ${className ?? ""}` : `absolute inset-x-3 bottom-3 sm:inset-x-auto sm:top-3 sm:right-3 sm:bottom-3 w-full sm:w-80 max-w-[calc(100vw-1.5rem)] max-h-[60vh] sm:max-h-none bg-[var(--color-card)] border border-[var(--color-border)] rounded-md shadow-lg overflow-hidden flex flex-col ${className ?? ""}`;
      const wrapperStyle = { zIndex: 20 };
      const hasCoordinatorData = coordinatorMessages && coordinatorMessages.length > 0 || coordinatorActivities && coordinatorActivities.length > 0;
      if (filtered.length === 0 && !hasCoordinatorData) {
        return /* @__PURE__ */ jsxs(Box, { className: wrapperClass, style: wrapperStyle, children: [
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
                /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1", children: t("subagentTrace.subagents") }),
                onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
              ]
            }
          ),
          /* @__PURE__ */ jsx(Box, { className: "flex-1 flex items-center justify-center px-4", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-center", children: focusedOrbital ? t("subagentTrace.noSubagentsForOrbital", { orbital: focusedOrbital }) : t("subagentTrace.noSubagentsActive") }) })
        ] });
      }
      if (focusedOrbital) {
        return /* @__PURE__ */ jsxs(Box, { className: wrapperClass, style: wrapperStyle, children: [
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
                /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold truncate", children: focusedOrbital }),
                  /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
                    filtered.length === 1 ? t("subagentTrace.subagentCount", { count: filtered.length }) : t("subagentTrace.subagentCountPlural", { count: filtered.length }),
                    " \xB7 ",
                    densityLabel(isRichMode)
                  ] })
                ] }),
                onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
              ]
            }
          ),
          /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto", children: filtered.map((sub) => isRichMode ? /* @__PURE__ */ jsx(SubagentRichCard, { subagent: sub }, sub.id) : /* @__PURE__ */ jsx(SubagentRow, { subagent: sub }, sub.id)) })
        ] });
      }
      const grouped = groupByOrbital(filtered);
      const coordinatorSnapshot = pluckCoordinatorState(coordinatorActivities ?? []);
      return /* @__PURE__ */ jsxs(Box, { className: wrapperClass, style: wrapperStyle, children: [
        /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "font-semibold flex-1", children: [
                t("subagentTrace.subagentsWithCount", { count: filtered.length }),
                " \xB7 ",
                densityLabel(isRichMode)
              ] }),
              onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "flex-1 overflow-y-auto", children: [
          !focusedOrbital && isRichMode && /* @__PURE__ */ jsx(CoordinatorCard, { snapshot: coordinatorSnapshot }),
          coordinatorMessages && coordinatorMessages.length > 0 ? /* @__PURE__ */ jsxs(Box, { className: "border-b border-[var(--color-border)]", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center px-3 py-1.5 bg-[var(--color-card)] border-b border-[var(--color-border)]", children: [
              /* @__PURE__ */ jsx(Box, { style: { width: 6, height: 6, borderRadius: "50%", backgroundColor: "var(--color-primary)", flexShrink: 0 } }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold text-[11px]", children: t("subagentTrace.coordinator") }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: t("subagentTrace.messagesCount", { count: coordinatorMessages.length }) })
            ] }),
            /* @__PURE__ */ jsx(Box, { className: "max-h-[36rem] overflow-y-auto", children: /* @__PURE__ */ jsx(CoordinatorConversation, { messages: coordinatorMessages, autoScroll: true }) })
          ] }) : coordinatorActivities && coordinatorActivities.length > 0 && (() => {
            const filteredCoordinator = coordinatorActivities;
            if (filteredCoordinator.length === 0) return null;
            return /* @__PURE__ */ jsxs(Box, { className: "border-b border-[var(--color-border)]", children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center px-3 py-1.5 bg-[var(--color-card)] border-b border-[var(--color-border)]", children: [
                /* @__PURE__ */ jsx(Box, { style: { width: 6, height: 6, borderRadius: "50%", backgroundColor: "var(--color-primary)", flexShrink: 0 } }),
                /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold text-[11px]", children: t("subagentTrace.coordinator") }),
                /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: t("subagentTrace.eventsCount", { count: filteredCoordinator.length }) })
              ] }),
              /* @__PURE__ */ jsx(Box, { className: "max-h-60 overflow-y-auto", children: /* @__PURE__ */ jsx(
                InlineActivityStream,
                {
                  activities: coordinatorToActivityItems(filteredCoordinator),
                  autoScroll: true
                }
              ) })
            ] });
          })(),
          isRichMode ? filtered.map((sub) => /* @__PURE__ */ jsx(SubagentRichCard, { subagent: sub }, sub.id)) : Array.from(grouped.entries()).map(([orbitalName, subs]) => /* @__PURE__ */ jsx(
            OrbitalGroup,
            {
              orbitalName,
              subagents: subs
            },
            orbitalName
          ))
        ] })
      ] });
    };
    SubagentTracePanel.displayName = "SubagentTracePanel";
  }
});
var TabbedContainer;
var init_TabbedContainer = __esm({
  "components/core/organisms/layout/TabbedContainer.tsx"() {
    "use client";
    init_cn();
    init_Typography();
    TabbedContainer = ({
      tabs,
      defaultTab,
      activeTab: controlledActiveTab,
      onTabChange,
      position = "top",
      className
    }) => {
      const safeTabs = tabs || [];
      const [internalActiveTab, setInternalActiveTab] = useState(
        defaultTab || safeTabs[0]?.id || ""
      );
      const activeTab = controlledActiveTab !== void 0 ? controlledActiveTab : internalActiveTab;
      const handleTabChange = useCallback(
        (tabId) => {
          if (controlledActiveTab === void 0) {
            setInternalActiveTab(tabId);
          }
          onTabChange?.(tabId);
        },
        [controlledActiveTab, onTabChange]
      );
      const activeTabDef = safeTabs.find((tab) => tab.id === activeTab);
      const activeContent = activeTabDef?.content || (activeTabDef?.sectionId ? /* @__PURE__ */ jsxs("div", { className: "p-4 text-muted-foreground", children: [
        "Section: ",
        activeTabDef.sectionId
      ] }) : null);
      const isVertical = position === "left";
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "flex w-full h-full",
            isVertical ? "flex-row" : "flex-col",
            className
          ),
          children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                role: "tablist",
                className: cn(
                  "flex flex-shrink-0",
                  isVertical ? "flex-col border-r-2 border-border" : "flex-row border-b-2 border-border"
                ),
                children: safeTabs.map((tab) => {
                  const isActive = tab.id === activeTab;
                  const isDisabled = tab.disabled;
                  return /* @__PURE__ */ jsxs(
                    "button",
                    {
                      role: "tab",
                      "aria-selected": isActive,
                      "aria-controls": `tabpanel-${tab.id}`,
                      "aria-disabled": isDisabled,
                      disabled: isDisabled,
                      onClick: () => !isDisabled && handleTabChange(tab.id),
                      className: cn(
                        "flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors",
                        "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                        "disabled:opacity-50 disabled:cursor-not-allowed",
                        isActive ? "bg-primary text-primary-foreground" : "bg-card text-foreground hover:bg-muted",
                        isVertical ? "justify-start" : "justify-center"
                      ),
                      children: [
                        /* @__PURE__ */ jsx(
                          Typography,
                          {
                            variant: "small",
                            weight: isActive ? "bold" : "normal",
                            color: "inherit",
                            children: tab.label
                          }
                        ),
                        tab.badge !== void 0 && /* @__PURE__ */ jsx(
                          "span",
                          {
                            className: cn(
                              "px-1.5 py-0.5 text-xs font-medium rounded",
                              isActive ? "bg-primary-foreground text-primary" : "bg-primary text-primary-foreground"
                            ),
                            children: tab.badge
                          }
                        )
                      ]
                    },
                    tab.id
                  );
                })
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                role: "tabpanel",
                id: `tabpanel-${activeTab}`,
                "aria-labelledby": `tab-${activeTab}`,
                className: "flex-1 overflow-auto",
                children: activeContent
              }
            )
          ]
        }
      );
    };
    TabbedContainer.displayName = "TabbedContainer";
  }
});
var TeamOrganism;
var init_TeamOrganism = __esm({
  "components/marketing/organisms/TeamOrganism.tsx"() {
    "use client";
    init_cn();
    init_Stack();
    init_Typography();
    init_SimpleGrid();
    init_TeamCard();
    init_LoadingState();
    init_ErrorState();
    TeamOrganism = ({
      entity,
      isLoading = false,
      error,
      className,
      heading,
      subtitle
    }) => {
      const { t } = useTranslate();
      const items = useMemo(
        () => Array.isArray(entity) ? entity : entity && typeof entity === "object" ? [entity] : [],
        [entity]
      );
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(ErrorState, { message: error.message, className });
      }
      const cols = Math.min(items.length, 4);
      return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("w-full", className), children: [
        (heading || subtitle) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", className: "w-full", children: [
          heading && /* @__PURE__ */ jsx(Typography, { variant: "h2", align: "center", children: heading }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "muted", align: "center", className: "max-w-2xl", children: subtitle })
        ] }),
        /* @__PURE__ */ jsx(SimpleGrid, { cols: cols > 0 ? cols : 1, gap: "lg", children: items.map((member) => /* @__PURE__ */ jsx(
          TeamCard,
          {
            name: String(member.name ?? ""),
            nameAr: member.nameAr != null ? String(member.nameAr) : void 0,
            role: String(member.role ?? ""),
            bio: String(member.bio ?? ""),
            avatar: member.avatar != null ? String(member.avatar) : void 0
          },
          String(member.id ?? "")
        )) })
      ] });
    };
    TeamOrganism.displayName = "TeamOrganism";
  }
});
function formatDate2(value) {
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleDateString(void 0, { year: "numeric", month: "short", day: "numeric" });
}
var lookStyles10, STATUS_STYLES2, Timeline;
var init_Timeline = __esm({
  "components/core/organisms/Timeline.tsx"() {
    "use client";
    init_cn();
    init_atoms();
    init_Stack();
    init_LoadingState();
    init_ErrorState();
    init_EmptyState();
    lookStyles10 = {
      "vertical-compact": "gap-1 [&>*]:py-1",
      "vertical-spacious": "",
      horizontal: "flex-row [&>*]:flex-row [&>*]:items-center",
      swimlane: "flex-row gap-6 [&>*]:flex-row [&>*]:items-center"
    };
    STATUS_STYLES2 = {
      complete: {
        dotColor: "text-success",
        lineColor: "bg-success",
        icon: CheckCircle2
      },
      active: {
        dotColor: "text-primary",
        lineColor: "bg-primary",
        icon: Clock
      },
      pending: {
        dotColor: "text-muted-foreground",
        lineColor: "bg-border",
        icon: Circle
      },
      error: {
        dotColor: "text-error",
        lineColor: "bg-error",
        icon: AlertCircle
      }
    };
    Timeline = ({
      title,
      items: propItems,
      fields,
      itemActions,
      entity,
      isLoading = false,
      error,
      className,
      look = "vertical-spacious"
    }) => {
      const { t } = useTranslate();
      const entityData = entity ?? [];
      const items = React79__default.useMemo(() => {
        if (propItems) return propItems;
        if (entityData.length === 0) return [];
        return entityData.map((record, idx) => {
          const resolvedFields = fields ?? [];
          const titleField = resolvedFields[0] || "title";
          const descField = resolvedFields[1] || "description";
          const dateField = resolvedFields.find(
            (f3) => f3.toLowerCase().includes("date")
          ) || "date";
          const statusField = resolvedFields.find(
            (f3) => f3.toLowerCase().includes("status")
          ) || "status";
          return {
            id: String(record.id ?? idx),
            title: String(record[titleField] ?? ""),
            description: record[descField] ? String(record[descField]) : void 0,
            date: record[dateField] ? String(record[dateField]) : void 0,
            status: record[statusField] || "pending"
          };
        });
      }, [propItems, entityData, fields]);
      if (isLoading) {
        return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
      }
      if (error) {
        return /* @__PURE__ */ jsx(
          ErrorState,
          {
            title: t("display.timelineError"),
            message: error.message,
            className
          }
        );
      }
      if (items.length === 0) {
        return /* @__PURE__ */ jsx(
          EmptyState,
          {
            title: t("display.noEvents"),
            description: "No timeline events to display.",
            className
          }
        );
      }
      return /* @__PURE__ */ jsx(Card, { className: cn("p-6", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        title && /* @__PURE__ */ jsx(Typography, { variant: "h5", weight: "semibold", children: title }),
        /* @__PURE__ */ jsx(VStack, { gap: "none", className: cn("relative", lookStyles10[look]), children: items.map((item, idx) => {
          const status = item.status || "pending";
          const style = STATUS_STYLES2[status] || STATUS_STYLES2.pending;
          const ItemIcon = item.icon || style.icon;
          const isLast = idx === items.length - 1;
          return /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "start", className: "relative", children: [
            /* @__PURE__ */ jsxs(VStack, { align: "center", className: "flex-shrink-0 relative", style: { width: "24px" }, children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  icon: ItemIcon,
                  size: "sm",
                  className: cn(style.dotColor, "z-10 bg-card")
                }
              ),
              !isLast && /* @__PURE__ */ jsx(
                Box,
                {
                  className: cn(
                    "w-0.5 flex-1 min-h-[24px]",
                    style.lineColor,
                    "opacity-40"
                  )
                }
              )
            ] }),
            /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: cn("flex-1 min-w-0", !isLast && "pb-6"), children: [
              /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", wrap: true, children: [
                /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", children: item.title }),
                item.date && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "flex-shrink-0", children: formatDate2(item.date) })
              ] }),
              item.description && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: item.description }),
              item.tags && item.tags.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: item.tags.map((tag, tagIdx) => /* @__PURE__ */ jsx(Badge, { variant: "default", children: tag }, tagIdx)) }),
              itemActions && itemActions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "mt-1", children: itemActions.map((action, actionIdx) => {
                const { icon: _icon, ...rowSafe } = item;
                return /* @__PURE__ */ jsx(
                  Box,
                  {
                    action: action.event,
                    actionPayload: { row: rowSafe },
                    className: "cursor-pointer hover:opacity-80 transition-opacity",
                    children: /* @__PURE__ */ jsx(Badge, { variant: "default", children: action.label })
                  },
                  actionIdx
                );
              }) })
            ] })
          ] }, item.id);
        }) })
      ] }) });
    };
    Timeline.displayName = "Timeline";
  }
});
function extractToastProps(children) {
  if (!React79__default.isValidElement(children)) {
    if (typeof children === "string") {
      return { message: children };
    }
    return {};
  }
  const props = children.props;
  return {
    message: typeof props.message === "string" ? props.message : void 0,
    variant: props.variant,
    title: typeof props.title === "string" ? props.title : void 0
  };
}
var ToastSlot;
var init_ToastSlot = __esm({
  "components/core/organisms/ToastSlot.tsx"() {
    "use client";
    init_Toast();
    init_Box();
    init_useEventBus();
    ToastSlot = ({
      children,
      variant: overrideVariant,
      title: overrideTitle,
      duration = 5e3,
      className,
      sourceTrait
    }) => {
      const eventBus = useEventBus();
      const schemaCtx = useEntitySchemaOptional();
      const isVisible = Boolean(children);
      const extracted = extractToastProps(children);
      const variant = overrideVariant || extracted.variant || "info";
      const title = overrideTitle || extracted.title;
      const message = extracted.message || (typeof children === "string" ? children : "");
      const handleDismiss = () => {
        const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
        const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
        eventBus.emit(`${prefix}DISMISS`);
        eventBus.emit(`${prefix}CLOSE`);
      };
      if (!isVisible) return null;
      const isCustomContent = React79__default.isValidElement(children) && !message;
      return /* @__PURE__ */ jsx(Box, { className: "fixed bottom-4 right-4 z-50", children: isCustomContent ? children : /* @__PURE__ */ jsx(
        Toast,
        {
          variant,
          title,
          message: message || "Notification",
          duration,
          onDismiss: handleDismiss,
          className
        }
      ) });
    };
    ToastSlot.displayName = "ToastSlot";
  }
});

// components/core/organisms/component-registry.generated.ts
var COMPONENT_REGISTRY;
var init_component_registry_generated = __esm({
  "components/core/organisms/component-registry.generated.ts"() {
    init_AboutPageTemplate();
    init_Accordion();
    init_ActionPalette();
    init_ActionTile();
    init_ActivationBlock();
    init_ComponentPatterns();
    init_AlgoGraphCanvas();
    init_AlgorithmCanvas();
    init_AnimatedCounter();
    init_AnimatedGraphic();
    init_AnimatedReveal();
    init_ArticleSection();
    init_Aside();
    init_AtlasImage();
    init_AuthLayout();
    init_Avatar();
    init_Badge();
    init_BehaviorView();
    init_BiologyCanvas();
    init_BloomQuizBlock();
    init_BookChapterView();
    init_BookCoverPage();
    init_BookNavBar();
    init_BookTableOfContents();
    init_BookViewer();
    init_LayoutPatterns();
    init_BranchingLogicBuilder();
    init_Breadcrumb();
    init_ButtonGroup();
    init_CTABanner();
    init_CalendarGrid();
    init_Canvas();
    init_Canvas2D();
    init_Card();
    init_CardGrid();
    init_Carousel();
    init_CaseStudyCard();
    init_CaseStudyOrganism();
    init_Center();
    init_Chart();
    init_ChartLegend();
    init_ChatBar();
    init_Checkbox();
    init_ChemistryCanvas();
    init_ChoiceButton();
    init_CodeBlock();
    init_CodeRunnerPanel();
    init_CommandPalette();
    init_CommunityLinks();
    init_ConditionalWrapper();
    init_ConfettiEffect();
    init_ConfirmDialog();
    init_ConnectionBlock();
    init_Container();
    init_ContentRenderer();
    init_ContentSection();
    init_ControlButton();
    init_ControlGrid();
    init_CounterTemplate();
    init_DashboardGrid();
    init_DashboardLayout();
    init_DataGrid();
    init_DataList();
    init_DataTable();
    init_DateRangePicker();
    init_DateRangeSelector();
    init_DayCell();
    init_DetailPanel();
    init_Dialog();
    init_DialogueBubble();
    init_DocBreadcrumb();
    init_DocPagination();
    init_DocSearch();
    init_DocSidebar();
    init_DocTOC();
    init_DockLayout();
    init_DocumentDetails();
    init_DocumentPanel();
    init_DocumentViewer();
    init_DrawFxLayer();
    init_DrawGroup();
    init_DrawMesh();
    init_DrawShape();
    init_DrawShapeLayer();
    init_DrawSkinnedMesh();
    init_DrawSprite();
    init_DrawSpriteLayer();
    init_DrawText();
    init_DrawTextLayer();
    init_Drawer();
    init_DrawerSlot();
    init_EdgeDecoration();
    init_EmojiPicker();
    init_EmptyState();
    init_ErrorBoundary();
    init_ErrorState();
    init_FeatureCard();
    init_FeatureDetailPageTemplate();
    init_FeatureGrid();
    init_FeatureGridOrganism();
    init_FileTree();
    init_FilterGroup();
    init_FilterPill();
    init_Flex();
    init_FlipCard();
    init_FlipContainer();
    init_FloatingActionButton();
    init_FloatingToolbar();
    init_Form();
    init_FormField();
    init_FormSection();
    init_FormSectionHeader();
    init_FxOverlay();
    init_GameAudioCue();
    init_GameAudioToggle();
    init_GameHud();
    init_GameIcon();
    init_GameMenu();
    init_GameShell();
    init_Gantt();
    init_GenericAppTemplate();
    init_GeometricPattern();
    init_GradientDivider();
    init_GraphCanvas();
    init_GraphView();
    init_Grid();
    init_Stack();
    init_Header();
    init_HealthBar();
    init_HeroOrganism();
    init_HeroSection();
    init_Icon();
    init_ImportPreviewTree();
    init_ImportProgress();
    init_ImportSourcePicker();
    init_InfiniteScrollSentinel();
    init_Input();
    init_InputGroup();
    init_InstallBox();
    init_JazariStateMachine();
    init_LandingPageTemplate();
    init_LawReferenceTooltip();
    init_LearningCanvas();
    init_Lightbox();
    init_LikertScale();
    init_LineChart();
    init_List();
    init_LoadingState();
    init_MapView();
    init_MarkdownContent();
    init_MarketingFooter();
    init_MarketingStatCard();
    init_MasterDetail();
    init_MasterDetailLayout();
    init_MathCanvas();
    init_MatrixQuestion();
    init_MediaGallery();
    init_Menu();
    init_Meter();
    init_Modal();
    init_ModalSlot();
    init_ModuleCard();
    init_Navigation();
    init_NumberStepper();
    init_OptionConstraintGroup();
    init_OrbitalVisualization();
    init_Overlay();
    init_PageHeader();
    init_PageTransition();
    init_Pagination();
    init_PatternTile();
    init_PhysicsCanvas();
    init_Popover();
    init_PositionedCanvas();
    init_Presence();
    init_PricingCard();
    init_PricingGrid();
    init_PricingOrganism();
    init_PricingPageTemplate();
    init_ProgressBar();
    init_ProgressDots();
    init_PullQuote();
    init_PullToRefresh();
    init_QrScanner();
    init_QuizBlock();
    init_Radio();
    init_RangeSlider();
    init_ReflectionBlock();
    init_RelationSelect();
    init_RepeatableFormSection();
    init_ReplyTree();
    init_RichTextEditor();
    init_RuntimeDebugger2();
    init_ScaledDiagram();
    init_ScoreDisplay();
    init_SearchInput();
    init_Section();
    init_SectionHeader();
    init_SegmentRenderer();
    init_Select();
    init_SequenceBar();
    init_ServiceCatalog();
    init_ShowcaseCard();
    init_ShowcaseOrganism();
    init_SidePanel();
    init_Sidebar();
    init_SignaturePad();
    init_SimpleGrid();
    init_Skeleton();
    init_SocialProof();
    init_SortableList();
    init_Sparkline();
    init_Spinner();
    init_Split();
    init_SplitPane();
    init_SplitSection();
    init_StarRating();
    init_StatBadge();
    init_StatCard();
    init_StatDisplay();
    init_StateGraph();
    init_StateJsonView();
    init_StateMachineView();
    init_StatsGrid();
    init_StatsOrganism();
    init_StatusDot();
    init_StepFlow();
    init_StepFlowOrganism();
    init_SubagentTracePanel();
    init_SvgBranch();
    init_SvgConnection();
    init_SvgFlow();
    init_SvgGrid();
    init_SvgLobe();
    init_SvgMesh();
    init_SvgMorph();
    init_SvgNode();
    init_SvgPulse();
    init_SvgRing();
    init_SvgShield();
    init_SvgStack();
    init_SwipeableRow();
    init_Switch();
    init_TabbedContainer();
    init_TableView();
    init_Tabs();
    init_TagCloud();
    init_TagInput();
    init_TeamCard();
    init_TeamOrganism();
    init_TextHighlight();
    init_Textarea();
    init_ThemeToggle();
    init_TimeSlotCell();
    init_Timeline();
    init_TimerDisplay();
    init_Toast();
    init_ToastSlot();
    init_Tooltip();
    init_TraitFrame();
    init_TraitSlot();
    init_TrendIndicator();
    init_TypewriterText();
    init_Typography();
    init_UISlotRenderer();
    init_UploadDropZone();
    init_VersionDiff();
    init_ViolationAlert();
    init_VoteStack();
    init_WizardContainer();
    init_WizardNavigation();
    init_WizardProgress();
    COMPONENT_REGISTRY = {
      "AboutPageTemplate": AboutPageTemplate,
      "Accordion": Accordion,
      "ActionPalette": ActionPalette,
      "ActionTile": ActionTile,
      "ActivationBlock": ActivationBlock,
      "Alert": AlertPattern,
      "AlertPattern": AlertPattern,
      "AlgoGraphCanvas": AlgoGraphCanvas,
      "AlgorithmCanvas": AlgorithmCanvas,
      "AnimatedCounter": AnimatedCounter,
      "AnimatedGraphic": AnimatedGraphic,
      "AnimatedReveal": AnimatedReveal,
      "ArticleSection": ArticleSection,
      "Aside": Aside,
      "AtlasImage": AtlasImage,
      "AtlasPanel": AtlasPanel,
      "AuthLayout": AuthLayout,
      "Avatar": Avatar,
      "Badge": Badge,
      "BehaviorView": BehaviorView,
      "BiologyCanvas": BiologyCanvas,
      "BloomQuizBlock": BloomQuizBlock,
      "BookChapterView": BookChapterView,
      "BookCoverPage": BookCoverPage,
      "BookNavBar": BookNavBar,
      "BookTableOfContents": BookTableOfContents,
      "BookViewer": BookViewer,
      "Box": BoxPattern,
      "BoxPattern": BoxPattern,
      "BranchingLogicBuilder": BranchingLogicBuilder,
      "Breadcrumb": Breadcrumb,
      "Button": ButtonPattern,
      "ButtonGroup": ButtonGroup,
      "ButtonPattern": ButtonPattern,
      "CTABanner": CTABanner,
      "CalendarGrid": CalendarGrid,
      "Canvas": Canvas,
      "Canvas2D": Canvas2D,
      "Card": Card,
      "CardGrid": CardGrid,
      "Carousel": Carousel,
      "CaseStudyCard": CaseStudyCard,
      "CaseStudyOrganism": CaseStudyOrganism,
      "Center": Center,
      "Chart": Chart,
      "ChartLegend": ChartLegend,
      "ChatBar": ChatBar,
      "Checkbox": Checkbox,
      "ChemistryCanvas": ChemistryCanvas,
      "ChoiceButton": ChoiceButton,
      "CodeBlock": CodeBlock,
      "CodeRunnerPanel": CodeRunnerPanel,
      "CommandPalette": CommandPalette,
      "CommunityLinks": CommunityLinks,
      "ConditionalWrapper": ConditionalWrapper,
      "ConfettiEffect": ConfettiEffect,
      "ConfirmDialog": ConfirmDialog,
      "ConnectionBlock": ConnectionBlock,
      "Container": Container,
      "ContentRenderer": ContentRenderer,
      "ContentSection": ContentSection,
      "ControlButton": ControlButton,
      "ControlGrid": ControlGrid,
      "CounterTemplate": CounterTemplate,
      "DashboardGrid": DashboardGrid,
      "DashboardLayout": DashboardLayout,
      "DataGrid": DataGrid,
      "DataList": DataList,
      "DataTable": DataTable,
      "DateRangePicker": DateRangePicker,
      "DateRangeSelector": DateRangeSelector,
      "DayCell": DayCell,
      "DetailPanel": DetailPanel,
      "Dialog": Dialog,
      "DialogueBubble": DialogueBubble,
      "Divider": DividerPattern,
      "DividerPattern": DividerPattern,
      "DocBreadcrumb": DocBreadcrumb,
      "DocPagination": DocPagination,
      "DocSearch": DocSearch,
      "DocSidebar": DocSidebar,
      "DocTOC": DocTOC,
      "DockLayout": DockLayout,
      "DocumentDetails": DocumentDetails,
      "DocumentPanel": DocumentPanel,
      "DocumentViewer": DocumentViewer,
      "DrawFxLayer": DrawFxLayer,
      "DrawGroup": DrawGroup,
      "DrawMesh": DrawMesh,
      "DrawShape": DrawShape,
      "DrawShapeLayer": DrawShapeLayer,
      "DrawSkinnedMesh": DrawSkinnedMesh,
      "DrawSprite": DrawSprite,
      "DrawSpriteLayer": DrawSpriteLayer,
      "DrawText": DrawText,
      "DrawTextLayer": DrawTextLayer,
      "Drawer": Drawer,
      "DrawerSlot": DrawerSlot,
      "EdgeDecoration": EdgeDecoration,
      "EmojiPicker": EmojiPicker,
      "EmptyState": EmptyState,
      "ErrorBoundary": ErrorBoundary,
      "ErrorState": ErrorState,
      "FeatureCard": FeatureCard,
      "FeatureDetailPageTemplate": FeatureDetailPageTemplate,
      "FeatureGrid": FeatureGrid,
      "FeatureGridOrganism": FeatureGridOrganism,
      "FileTree": FileTree,
      "FilterGroup": FilterGroup,
      "FilterPill": FilterPill,
      "Flex": Flex,
      "FlipCard": FlipCard,
      "FlipContainer": FlipContainer,
      "FloatingActionButton": FloatingActionButton,
      "FloatingToolbar": FloatingToolbar,
      "Form": Form,
      "FormField": FormField,
      "FormLayout": FormLayout,
      "FormSectionHeader": FormSectionHeader,
      "FxOverlay": FxOverlay,
      "GameAudioCue": GameAudioCue,
      "GameAudioToggle": GameAudioToggle,
      "GameHud": GameHud,
      "GameIcon": GameIcon,
      "GameMenu": GameMenu,
      "GameShell": GameShell,
      "Gantt": Gantt,
      "GenericAppTemplate": GenericAppTemplate,
      "GeometricPattern": GeometricPattern,
      "GradientDivider": GradientDivider,
      "GraphCanvas": GraphCanvas,
      "GraphView": GraphView,
      "Grid": Grid,
      "HStack": HStack,
      "Header": Header,
      "HealthBar": HealthBar,
      "HeroOrganism": HeroOrganism,
      "HeroSection": HeroSection,
      "Icon": Icon,
      "ImportPreviewTree": ImportPreviewTree,
      "ImportProgress": ImportProgress,
      "ImportSourcePicker": ImportSourcePicker,
      "InfiniteScrollSentinel": InfiniteScrollSentinel,
      "Input": Input,
      "InputGroup": InputGroup,
      "InstallBox": InstallBox,
      "JazariStateMachine": JazariStateMachine,
      "Label": LabelPattern,
      "LabelPattern": LabelPattern,
      "LandingPageTemplate": LandingPageTemplate,
      "LawReferenceTooltip": LawReferenceTooltip,
      "LearningCanvas": LearningCanvas,
      "Lightbox": Lightbox,
      "LikertScale": LikertScale,
      "LineChart": LineChart2,
      "List": List3,
      "LoadingState": LoadingState,
      "MapView": MapView,
      "MarkdownContent": MarkdownContent,
      "MarketingFooter": MarketingFooter,
      "MarketingStatCard": MarketingStatCard,
      "MasterDetail": MasterDetail,
      "MasterDetailLayout": MasterDetailLayout,
      "MathCanvas": MathCanvas,
      "MatrixQuestion": MatrixQuestion,
      "MediaGallery": MediaGallery,
      "Menu": Menu,
      "Meter": Meter,
      "Modal": Modal,
      "ModalSlot": ModalSlot,
      "ModuleCard": ModuleCard,
      "Navigation": Navigation,
      "NumberStepper": NumberStepper,
      "OptionConstraintGroup": OptionConstraintGroup,
      "OrbitalVisualization": OrbitalVisualization,
      "Overlay": Overlay,
      "PageHeader": PageHeader,
      "PageTransition": PageTransition,
      "Pagination": Pagination,
      "PatternTile": PatternTile,
      "PhysicsCanvas": PhysicsCanvas,
      "Popover": Popover,
      "PositionedCanvas": PositionedCanvas,
      "Presence": Presence,
      "PricingCard": PricingCard,
      "PricingGrid": PricingGrid,
      "PricingOrganism": PricingOrganism,
      "PricingPageTemplate": PricingPageTemplate,
      "ProgressBar": ProgressBar,
      "ProgressDots": ProgressDots,
      "PullQuote": PullQuote,
      "PullToRefresh": PullToRefresh,
      "QrScanner": QrScanner,
      "QuizBlock": QuizBlock,
      "Radio": Radio,
      "RangeSlider": RangeSlider,
      "ReflectionBlock": ReflectionBlock,
      "RelationSelect": RelationSelect,
      "RepeatableFormSection": RepeatableFormSection,
      "ReplyTree": ReplyTree,
      "RichTextEditor": RichTextEditor,
      "RuntimeDebugger": RuntimeDebugger,
      "ScaledDiagram": ScaledDiagram,
      "ScoreDisplay": ScoreDisplay,
      "SearchInput": SearchInput,
      "Section": Section,
      "SectionHeader": SectionHeader,
      "SegmentRenderer": SegmentRenderer,
      "Select": Select,
      "SequenceBar": SequenceBar,
      "ServiceCatalog": ServiceCatalog,
      "ShowcaseCard": ShowcaseCard,
      "ShowcaseOrganism": ShowcaseOrganism,
      "SidePanel": SidePanel,
      "Sidebar": Sidebar,
      "SignaturePad": SignaturePad,
      "SimpleGrid": SimpleGrid,
      "Skeleton": Skeleton,
      "SocialProof": SocialProof,
      "SortableList": SortableList,
      "Spacer": SpacerPattern,
      "SpacerPattern": SpacerPattern,
      "Sparkline": Sparkline,
      "Spinner": Spinner,
      "Split": Split,
      "SplitPane": SplitPane,
      "SplitSection": SplitSection,
      "Stack": Stack,
      "StarRating": StarRating,
      "StatBadge": StatBadge,
      "StatCard": StatCard,
      "StatDisplay": StatDisplay,
      "StateGraph": StateGraph,
      "StateJsonView": StateJsonView,
      "StateMachineView": StateMachineView,
      "StatsGrid": StatsGrid,
      "StatsOrganism": StatsOrganism,
      "StatusDot": StatusDot,
      "StepFlow": StepFlow,
      "StepFlowOrganism": StepFlowOrganism,
      "SubagentTracePanel": SubagentTracePanel,
      "SvgBranch": SvgBranch,
      "SvgConnection": SvgConnection,
      "SvgFlow": SvgFlow,
      "SvgGrid": SvgGrid,
      "SvgLobe": SvgLobe,
      "SvgMesh": SvgMesh,
      "SvgMorph": SvgMorph,
      "SvgNode": SvgNode,
      "SvgPulse": SvgPulse,
      "SvgRing": SvgRing,
      "SvgShield": SvgShield,
      "SvgStack": SvgStack,
      "SwipeableRow": SwipeableRow,
      "Switch": Switch,
      "TabbedContainer": TabbedContainer,
      "TableView": TableView,
      "Tabs": Tabs,
      "TagCloud": TagCloud,
      "TagInput": TagInput,
      "TeamCard": TeamCard,
      "TeamOrganism": TeamOrganism,
      "TextHighlight": TextHighlight,
      "Textarea": Textarea,
      "ThemeToggle": ThemeToggle,
      "TimeSlotCell": TimeSlotCell,
      "Timeline": Timeline,
      "TimerDisplay": TimerDisplay,
      "Toast": Toast,
      "ToastSlot": ToastSlot,
      "Tooltip": Tooltip,
      "TraitFrame": TraitFrame,
      "TraitSlot": TraitSlot,
      "TrendIndicator": TrendIndicator,
      "TypewriterText": TypewriterText,
      "Typography": Typography,
      "UISlotComponent": UISlotComponent,
      "UISlotRenderer": UISlotRenderer,
      "UploadDropZone": UploadDropZone,
      "VStack": VStack,
      "VersionDiff": VersionDiff,
      "ViolationAlert": ViolationAlert,
      "VoteStack": VoteStack,
      "WizardContainer": WizardContainer,
      "WizardNavigation": WizardNavigation,
      "WizardProgress": WizardProgress,
      // Semantic aliases
      "Text": TextPattern
    };
  }
});

// components/core/organisms/UISlotRenderer.tsx
var UISlotRenderer_exports = {};
__export(UISlotRenderer_exports, {
  SlotContainedContext: () => SlotContainedContext,
  SlotContentRenderer: () => SlotContentRenderer,
  SuspenseConfigProvider: () => SuspenseConfigProvider,
  UISlotComponent: () => UISlotComponent,
  UISlotRenderer: () => UISlotRenderer,
  renderPatternValue: () => renderPatternValue
});
function SuspenseConfigProvider({
  config,
  children
}) {
  return React79__default.createElement(
    SuspenseConfigContext.Provider,
    { value: config },
    children
  );
}
function getSlotFallback(slot, config) {
  if (config.slotFallbacks?.[slot]) return config.slotFallbacks[slot];
  const variant = SLOT_SKELETON_MAP[slot] ?? "text";
  return /* @__PURE__ */ jsx(Skeleton, { variant });
}
function getComponentForPattern(patternType) {
  const mapping = getComponentForPattern$1(patternType);
  if (!mapping) {
    return null;
  }
  return COMPONENT_REGISTRY[mapping] ?? null;
}
function enrichFormFields(fields, entityDef) {
  const fieldMap = new Map(entityDef.fields.map((f3) => [f3.name, f3]));
  return fields.map((field) => {
    if (typeof field === "string") {
      const entityField = fieldMap.get(field);
      if (entityField) {
        const enriched = {
          name: field,
          label: humanizeFieldName(field),
          type: entityField.type,
          required: entityField.required ?? false
        };
        if (entityField.description) {
          enriched.hint = entityField.description;
        }
        if (entityField.values && entityField.values.length > 0) {
          enriched.values = entityField.values;
        } else if (entityField.enumValues && entityField.enumValues.length > 0) {
          enriched.values = entityField.enumValues;
        }
        if (entityField.relation) {
          enriched.relation = {
            entity: entityField.relation.entity,
            cardinality: entityField.relation.cardinality
          };
        }
        return enriched;
      }
      return { name: field, label: humanizeFieldName(field) };
    }
    if (field && typeof field === "object" && !Array.isArray(field) && !React79__default.isValidElement(field) && !(field instanceof Date)) {
      const obj = field;
      const fieldName2 = typeof obj.name === "string" ? obj.name : typeof obj.field === "string" ? obj.field : void 0;
      if (!fieldName2) return field;
      if (obj.type || obj.inputType) return field;
      const entityField = fieldMap.get(fieldName2);
      if (!entityField) return field;
      const enriched = { ...obj, type: entityField.type };
      if (entityField.required && !("required" in obj)) {
        enriched.required = true;
      }
      if (entityField.description && !obj.hint && !obj.help) {
        enriched.hint = entityField.description;
      }
      if (!obj.values && !obj.options) {
        if (entityField.values && entityField.values.length > 0) {
          enriched.values = entityField.values;
        } else if (entityField.enumValues && entityField.enumValues.length > 0) {
          enriched.values = entityField.enumValues;
        }
      }
      if (!obj.relation && entityField.relation) {
        enriched.relation = {
          entity: entityField.relation.entity,
          cardinality: entityField.relation.cardinality
        };
      }
      return enriched;
    }
    return field;
  });
}
function enrichDetailFields(fields, entityDef) {
  const fieldMap = new Map(entityDef.fields.map((f3) => [f3.name, f3]));
  const metaFor = (name) => {
    const entityField = fieldMap.get(name);
    if (!entityField) return void 0;
    const meta = { type: entityField.type };
    const values = entityField.values ?? entityField.enumValues;
    if (values && values.length > 0) meta.values = values;
    if (entityField.relation) {
      meta.relation = {
        entity: entityField.relation.entity,
        cardinality: entityField.relation.cardinality
      };
    }
    return meta;
  };
  return fields.map((field) => {
    if (typeof field === "string") {
      const meta = metaFor(field);
      return meta ? { key: field, ...meta } : field;
    }
    if (field && typeof field === "object" && !Array.isArray(field) && !React79__default.isValidElement(field) && !(field instanceof Date)) {
      const obj = field;
      const fieldName2 = typeof obj.key === "string" ? obj.key : typeof obj.name === "string" ? obj.name : void 0;
      if (!fieldName2 || obj.type) return field;
      const meta = metaFor(fieldName2);
      return meta ? { ...obj, ...meta } : field;
    }
    return field;
  });
}
function renderContainedPortal(t, slot, content, onDismiss) {
  const slotContent = /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: content.sourceTrait, children: /* @__PURE__ */ jsx(SlotContentRenderer, { content, onDismiss }) });
  const slotId = `slot-${slot}`;
  switch (slot) {
    case "modal":
      if (SELF_OVERLAY_PATTERN_TYPES.has(content.pattern)) {
        return /* @__PURE__ */ jsx(Box, { id: slotId, className: "contents", children: slotContent });
      }
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: "absolute inset-0 z-50 flex items-start justify-center overflow-auto",
          style: { backgroundColor: "rgba(0, 0, 0, 0.5)", paddingTop: "10%" },
          onClick: onDismiss,
          children: /* @__PURE__ */ jsxs(
            Box,
            {
              bg: "surface",
              border: true,
              shadow: "lg",
              rounded: "md",
              className: "pointer-events-auto w-full overflow-auto flex flex-col",
              style: { minWidth: "520px", maxWidth: "700px", maxHeight: "80%" },
              onClick: (e) => e.stopPropagation(),
              children: [
                /* @__PURE__ */ jsxs(Box, { className: cn(
                  "flex items-center p-4",
                  content.props.title ? "justify-between border-b border-border" : "justify-end"
                ), children: [
                  content.props.title ? /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "text-lg font-semibold", children: String(content.props.title) }) : null,
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      as: "button",
                      className: "text-muted-foreground hover:text-foreground cursor-pointer",
                      onClick: onDismiss,
                      "data-event": "CLOSE",
                      "data-testid": "action-CLOSE",
                      "aria-label": t("aria.closeModal"),
                      children: "\u2715"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-auto p-4", children: slotContent })
              ]
            }
          )
        }
      );
    case "drawer":
      if (content.pattern === "detail-panel" && content.props.slideOver === true) {
        return /* @__PURE__ */ jsx(
          Box,
          {
            id: slotId,
            className: "absolute inset-0 z-50 overflow-hidden",
            style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
            onClick: onDismiss,
            children: /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute inset-y-0 right-0 pointer-events-auto",
                onClick: (e) => e.stopPropagation(),
                children: slotContent
              }
            )
          }
        );
      }
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: "absolute inset-0 z-50 overflow-hidden",
          style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          onClick: onDismiss,
          children: /* @__PURE__ */ jsxs(
            Box,
            {
              bg: "surface",
              className: cn(
                "absolute top-0 bottom-0 w-80 max-w-[80%] overflow-auto pointer-events-auto",
                content.props.position === "left" ? "left-0" : "right-0"
              ),
              onClick: (e) => e.stopPropagation(),
              children: [
                /* @__PURE__ */ jsxs(Box, { className: cn(
                  "flex items-center p-4",
                  content.props.title ? "justify-between border-b border-border" : "justify-end"
                ), children: [
                  content.props.title ? /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "text-lg font-semibold", children: String(content.props.title) }) : null,
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      as: "button",
                      className: "text-muted-foreground hover:text-foreground cursor-pointer",
                      onClick: onDismiss,
                      "data-event": "CLOSE",
                      "data-testid": "action-CLOSE",
                      "aria-label": t("aria.closeDrawer"),
                      children: "\u2715"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx(Box, { className: "p-4", children: slotContent })
              ]
            }
          )
        }
      );
    case "toast":
      return /* @__PURE__ */ jsx(Box, { id: slotId, className: "absolute top-4 right-4 z-50", children: /* @__PURE__ */ jsx(
        Toast,
        {
          variant: content.props.variant ?? "info",
          title: content.props.title,
          message: content.props.message ?? "",
          onDismiss
        }
      ) });
    case "overlay":
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: "absolute inset-0 z-50 flex items-center justify-center overflow-auto",
          style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          onClick: onDismiss,
          children: /* @__PURE__ */ jsx(Box, { className: "max-h-full overflow-auto", onClick: (e) => e.stopPropagation(), children: slotContent })
        }
      );
    case "center":
      return /* @__PURE__ */ jsx(Box, { id: slotId, className: "absolute inset-0 z-50 flex items-center justify-center pointer-events-none overflow-auto", children: /* @__PURE__ */ jsx(Box, { className: "pointer-events-auto max-h-full overflow-auto", children: slotContent }) });
    default:
      return /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent });
  }
}
function MaybeTraitScope({
  sourceTrait,
  children
}) {
  const schemaCtx = useEntitySchemaOptional();
  const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
  const wrap = sourceTrait !== void 0 && orbital !== void 0;
  scopeWrapLog.debug("decide", {
    sourceTrait,
    schemaCtxPresent: schemaCtx !== null,
    orbitalsByTraitSize: schemaCtx?.orbitalsByTrait.size ?? 0,
    orbital,
    wrap
  });
  if (wrap) {
    return /* @__PURE__ */ jsx(TraitScopeProvider, { orbital, trait: sourceTrait, children });
  }
  if (sourceTrait !== void 0 && schemaCtx !== null) {
    scopeWrapLog.warn("decline", {
      sourceTrait,
      orbitalsByTraitSize: schemaCtx.orbitalsByTrait.size,
      reason: "sourceTrait not in orbitalsByTrait \u2014 children render unscoped"
    });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function UISlotComponent(props) {
  return /* @__PURE__ */ jsx(RenderSlotProvider, { slot: props.slot, children: /* @__PURE__ */ jsx(UISlotComponentInner, { ...props }) });
}
function UISlotComponentInner({
  slot,
  portal = false,
  position,
  className,
  children,
  pattern,
  sourceTrait,
  fallback,
  mode = "replace"
}) {
  const { slots, clear } = useUISlots();
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const suspenseConfig = useContext(SuspenseConfigContext);
  const contained = useContext(SlotContainedContext);
  const schemaCtx = useEntitySchemaOptional();
  const rawContent = slots[slot];
  const regionClassName = fallback !== void 0 ? cn("contents", className) : className;
  const binding = useEntityBindingSnapshot(rawContent?.sourceTrait);
  const content = useMemo(() => {
    if (!rawContent) return rawContent;
    const resolvedProps = resolveRenderBindingMarkers(
      rawContent.props,
      rawContent.sourceTrait,
      binding.entity,
      binding.config,
      binding.state
    );
    return resolvedProps === rawContent.props ? rawContent : { ...rawContent, props: resolvedProps };
  }, [rawContent, binding.entity, binding.config, binding.state]);
  if (children !== void 0) {
    if (pattern === "clear") {
      return null;
    }
    if (isPortalSlot(slot)) {
      if (contained) {
        return /* @__PURE__ */ jsx(
          Box,
          {
            id: `slot-${slot}`,
            className: cn("ui-slot", `ui-slot-${slot}`, className),
            "data-pattern": pattern,
            "data-source-trait": sourceTrait,
            children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children })
          }
        );
      }
      return /* @__PURE__ */ jsx(CompiledPortal, { slot, className, pattern, sourceTrait, children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children }) });
    }
    return /* @__PURE__ */ jsx(
      Box,
      {
        id: `slot-${slot}`,
        className: cn("ui-slot", `ui-slot-${slot}`, className),
        "data-pattern": pattern,
        "data-source-trait": sourceTrait,
        children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children })
      }
    );
  }
  if (!content) {
    if (fallback !== void 0) {
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: `slot-${slot}`,
          className: cn("ui-slot", `ui-slot-${slot}`, regionClassName),
          "data-testid": `ui-slot-${slot}`,
          "data-slot-mode": "fallback",
          children: fallback
        }
      );
    }
    if (!portal) {
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: `slot-${slot}`,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-testid": `ui-slot-${slot}`,
          "data-slot-mode": "empty"
        }
      );
    }
    return null;
  }
  const handleDismiss = () => {
    if (slot === "modal" || slot === "drawer") {
      const trait = content?.sourceTrait;
      const orbital = trait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(trait) : void 0;
      const prefix = orbital !== void 0 && trait !== void 0 ? `UI:${orbital}.${trait}.` : "UI:";
      eventBus.emit(`${prefix}CLOSE`);
      eventBus.emit(`${prefix}CANCEL`);
    }
    clear(slot);
  };
  if (portal) {
    const inlineFallback = mode === "append" && fallback !== void 0 ? /* @__PURE__ */ jsx(
      Box,
      {
        id: `slot-${slot}-fallback`,
        className: cn("ui-slot", `ui-slot-${slot}-fallback`, regionClassName),
        "data-testid": `ui-slot-${slot}-fallback`,
        "data-slot-mode": "append",
        children: fallback
      }
    ) : null;
    if (contained) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        inlineFallback,
        renderContainedPortal(t, slot, content, handleDismiss)
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      inlineFallback,
      /* @__PURE__ */ jsx(
        SlotPortal,
        {
          slot,
          content,
          position,
          onDismiss: handleDismiss
        }
      )
    ] });
  }
  const slotContent = /* @__PURE__ */ jsx(SlotContentRenderer, { content, onDismiss: handleDismiss });
  const wrappedContent = suspenseConfig.enabled ? /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, { fallback: getSlotFallback(slot, suspenseConfig), children: slotContent }) }) : /* @__PURE__ */ jsx(ErrorBoundary, { children: slotContent });
  const showFallback = mode === "append" && fallback !== void 0;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      id: `slot-${slot}`,
      className: cn("ui-slot", `ui-slot-${slot}`, regionClassName),
      "data-pattern": content.pattern,
      "data-source-trait": content.sourceTrait,
      "data-testid": `ui-slot-${slot}`,
      "data-slot-mode": showFallback ? "append" : "content",
      children: [
        showFallback ? fallback : null,
        /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: content.sourceTrait, children: wrappedContent })
      ]
    }
  );
}
function CompiledPortal({ slot, className, pattern, sourceTrait, children }) {
  const [portalRoot, setPortalRoot] = useState(null);
  const slotsBus = useUISlots();
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const compiledPortalSchemaCtx = useEntitySchemaOptional();
  useEffect(() => {
    setPortalRoot(getOrCreatePortalRoot());
  }, []);
  useEffect(() => {
    if (portalRoot) getOrCreatePortalRoot();
  });
  const handleDismiss = () => {
    if (slot === "modal" || slot === "drawer") {
      const orbital = sourceTrait !== void 0 && compiledPortalSchemaCtx !== null ? compiledPortalSchemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
      const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
      eventBus.emit(`${prefix}CLOSE`);
      eventBus.emit(`${prefix}CANCEL`);
    }
    slotsBus.clear(slot);
  };
  if (!portalRoot) return null;
  const slotId = `slot-${slot}`;
  let wrapper;
  switch (slot) {
    case "modal": {
      const innerContent = /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      );
      wrapper = pattern !== void 0 && SELF_OVERLAY_PATTERN_TYPES.has(pattern) ? innerContent : /* @__PURE__ */ jsx(Modal, { isOpen: true, onClose: handleDismiss, showCloseButton: true, size: "lg", children: innerContent });
      break;
    }
    case "drawer":
      wrapper = /* @__PURE__ */ jsx(Drawer, { isOpen: true, onClose: handleDismiss, position: "right", children: /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      ) });
      break;
    case "toast":
      wrapper = /* @__PURE__ */ jsx(Box, { className: "fixed top-4 right-4 z-50", children: /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      ) });
      break;
    default:
      wrapper = /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      );
  }
  return createPortal(wrapper, portalRoot);
}
function SlotPortal({
  slot,
  content,
  position,
  onDismiss
}) {
  const [portalRoot, setPortalRoot] = useState(null);
  useEffect(() => {
    setPortalRoot(getOrCreatePortalRoot());
  }, []);
  useEffect(() => {
    if (portalRoot) getOrCreatePortalRoot();
  });
  if (!portalRoot) return null;
  const slotId = `slot-${slot}`;
  const slotContent = /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: content.sourceTrait, children: /* @__PURE__ */ jsx(SlotContentRenderer, { content, onDismiss }) });
  let wrapper;
  switch (slot) {
    case "modal":
      wrapper = SELF_OVERLAY_PATTERN_TYPES.has(content.pattern) ? /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent }) : /* @__PURE__ */ jsx(
        Modal,
        {
          isOpen: true,
          onClose: onDismiss,
          title: content.props.title,
          size: content.props.size,
          children: /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent })
        }
      );
      break;
    case "drawer":
      wrapper = /* @__PURE__ */ jsx(
        Drawer,
        {
          isOpen: true,
          onClose: onDismiss,
          title: content.props.title,
          position: content.props.position ?? "right",
          width: content.props.width,
          children: /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent })
        }
      );
      break;
    case "toast":
      wrapper = /* @__PURE__ */ jsx(Box, { id: slotId, className: cn("fixed z-50", getToastPosition(position)), children: /* @__PURE__ */ jsx(
        Toast,
        {
          variant: content.props.variant ?? "info",
          title: content.props.title,
          message: content.props.message ?? "",
          onDismiss
        }
      ) });
      break;
    case "overlay":
      wrapper = /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: "fixed inset-0 z-50 bg-foreground/50 flex items-center justify-center",
          onClick: onDismiss,
          children: /* @__PURE__ */ jsx(Box, { onClick: (e) => e.stopPropagation(), children: slotContent })
        }
      );
      break;
    case "center":
      wrapper = /* @__PURE__ */ jsx(Box, { id: slotId, className: "fixed inset-0 z-50 flex items-center justify-center pointer-events-none", children: /* @__PURE__ */ jsx(Box, { className: "pointer-events-auto", children: slotContent }) });
      break;
    default:
      wrapper = /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent });
  }
  return createPortal(wrapper, portalRoot);
}
function getToastPosition(position) {
  switch (position) {
    case "top-left":
      return "top-4 left-4";
    case "top-right":
      return "top-4 right-4";
    case "bottom-left":
      return "bottom-4 left-4";
    case "bottom-right":
      return "bottom-4 right-4";
    default:
      return "top-4 right-4";
  }
}
function renderPatternChildren(children, onDismiss, parentId = "root", parentPath = "root", sourceTrait, orbCtx) {
  if (children === void 0 || children === null) return null;
  const childrenArray = Array.isArray(children) ? children : typeof children === "string" || typeof children === "object" && "type" in children ? [children] : [];
  if (childrenArray.length === 0) return null;
  return childrenArray.map((child, index) => {
    if (typeof child === "string") {
      const match = TRAIT_BINDING_RE.exec(child);
      if (match) {
        const traitName = match[1];
        const key = `${parentId}-${index}-trait:${traitName}`;
        return /* @__PURE__ */ jsx(TraitFrame, { traitName }, key);
      }
      return /* @__PURE__ */ jsx(React79__default.Fragment, { children: child }, `${parentId}-${index}`);
    }
    if (!child || typeof child !== "object") return null;
    const childId = `${parentId}-${index}`;
    const childPath = parentPath === "root" ? `root.children.${index}` : `${parentPath}.children.${index}`;
    const childAsRecord = child;
    const { type: _childType, props: nestedProps, _id: _childNodeId, _sourceTrait: childSourceTrait, children: _childChildren, ...flatProps } = childAsRecord;
    const resolvedProps = nestedProps !== void 0 ? nestedProps : flatProps;
    if (_childChildren !== void 0 && nestedProps === void 0) {
      resolvedProps.children = _childChildren;
    }
    const childKids = resolvedProps.children;
    const childlessStack = (_childType === "stack" || _childType === "vstack" || _childType === "hstack") && resolvedProps.className === void 0 && resolvedProps.style === void 0 && (childKids === void 0 || childKids === null || Array.isArray(childKids) && !childKids.length);
    if (childlessStack) {
      return null;
    }
    const childContent = {
      id: childId,
      pattern: child.type,
      props: resolvedProps,
      priority: 0,
      nodeId: child._id,
      // Inherit sourceTrait from the parent slot so nested patterns
      // (e.g. form-section inside a stack) can resolve entityDef via
      // the trait's linkedEntity for form-field enrichment. The orbCtx
      // (slot/transition/state/entity) propagates the same way so every
      // nested node carries a complete contextual-edit address. A child
      // carrying its own `_sourceTrait` (multi-source slot stack) owns it
      // outright — inheriting the synthetic wrapper's sentinel instead
      // would erase the real owner.
      ...childSourceTrait !== void 0 ? { sourceTrait: childSourceTrait } : sourceTrait !== void 0 && { sourceTrait },
      ...orbCtx ?? {}
    };
    const renderedChild = /* @__PURE__ */ jsx(
      SlotContentRenderer,
      {
        content: childContent,
        onDismiss,
        patternPath: childPath
      },
      childId
    );
    return childSourceTrait !== void 0 ? /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: childSourceTrait, children: renderedChild }, childId) : renderedChild;
  });
}
function toDrawableNodes(children) {
  if (children === void 0 || children === null) return [];
  const arr = Array.isArray(children) ? children : [children];
  const nodes = [];
  for (const child of arr) {
    if (!child || typeof child !== "object") continue;
    const rec = child;
    const { type, props: nested, _id: _drop, ...flat } = rec;
    const fields = nested !== void 0 ? nested : flat;
    nodes.push({ ...fields, type });
  }
  return nodes;
}
function isPatternConfig(value) {
  if (value === null || value === void 0) return false;
  if (typeof value !== "object") return false;
  if (Array.isArray(value)) return false;
  if (React79__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  if (typeof value === "function") return false;
  const record = value;
  return "type" in record && typeof record.type === "string" && getComponentForPattern$1(record.type) !== null;
}
function renderPatternValue(value) {
  if (value === null || value === void 0) return null;
  if (typeof value === "boolean" || typeof value === "function") return null;
  if (typeof value === "number") return value;
  if (typeof value === "string") return renderPatternChildren(value, () => {
  });
  if (value instanceof Date) return value.toLocaleString();
  if (React79__default.isValidElement(value)) return value;
  if (Array.isArray(value)) {
    return value.map((item, index) => /* @__PURE__ */ jsx(React79__default.Fragment, { children: renderPatternValue(item) }, index));
  }
  if (isPatternConfig(value)) {
    const { type, ...props } = value;
    return renderPatternChildren({ type, props }, () => {
    });
  }
  return null;
}
function isPlainConfigObject(value) {
  if (React79__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}
function subtreeHasTraitRef(value) {
  if (isEvaluatorResolvedData(value)) return false;
  const cached = traitRefPresenceCache.get(value);
  if (cached !== void 0) return cached;
  let found = false;
  const children = Array.isArray(value) ? value : Object.values(value);
  for (const child of children) {
    if (typeof child === "string" && TRAIT_BINDING_RE.test(child)) {
      found = true;
      break;
    }
    if (isRenderBindingMarker(child)) continue;
    if (Array.isArray(child)) {
      if (subtreeHasTraitRef(child)) {
        found = true;
        break;
      }
    } else if (child !== null && typeof child === "object" && isPlainConfigObject(child)) {
      if (subtreeHasTraitRef(child)) {
        found = true;
        break;
      }
    }
  }
  traitRefPresenceCache.set(value, found);
  return found;
}
function substituteTraitRefsDeep(value, pathKey) {
  if (isRenderBindingMarker(value)) return value;
  if (typeof value === "string") {
    const match = TRAIT_BINDING_RE.exec(value);
    if (match) {
      const traitName = match[1];
      return /* @__PURE__ */ jsx(TraitFrame, { traitName }, `${pathKey}:${traitName}`);
    }
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean" || value === null || value === void 0 || typeof value === "function") {
    return value;
  }
  if (Array.isArray(value)) {
    if (!subtreeHasTraitRef(value)) return value;
    return value.map(
      (item, i) => substituteTraitRefsDeep(item, `${pathKey}[${i}]`)
    );
  }
  if (typeof value === "object" && isPlainConfigObject(value)) {
    if (!subtreeHasTraitRef(value)) return value;
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = substituteTraitRefsDeep(v, `${pathKey}.${k}`);
    }
    return out;
  }
  return value;
}
function renderPatternProps(props, onDismiss, propsSchema) {
  const rendered = {};
  for (const [key, value] of Object.entries(props)) {
    if (key === "children") {
      rendered[key] = value;
    } else if (isPatternConfig(value)) {
      const nestedProps = {};
      for (const [k, v] of Object.entries(value)) {
        if (k !== "type") nestedProps[k] = v;
      }
      const childContent = {
        id: `prop-${key}`,
        pattern: value.type,
        props: nestedProps,
        priority: 0
      };
      rendered[key] = /* @__PURE__ */ jsx(SlotContentRenderer, { content: childContent, onDismiss });
    } else if (Array.isArray(value)) {
      if (!isEvaluatorResolvedData(value) && value.some((el) => isPatternConfig(el))) ; else if (!subtreeHasTraitRef(value)) {
        rendered[key] = value;
        continue;
      }
      const isDataArray = propsSchema?.[key]?.items?.types?.includes("object") ?? false;
      rendered[key] = value.map((item, i) => {
        const el = item;
        if (!isDataArray && isPatternConfig(el)) {
          const nestedProps = {};
          for (const [k, v] of Object.entries(el)) {
            if (k !== "type") nestedProps[k] = v;
          }
          const childContent = {
            id: `prop-${key}-${i}`,
            pattern: el.type,
            props: nestedProps,
            priority: 0
          };
          return /* @__PURE__ */ jsx(SlotContentRenderer, { content: childContent, onDismiss }, i);
        }
        return substituteTraitRefsDeep(el, `prop:${key}[${i}]`);
      });
    } else {
      rendered[key] = substituteTraitRefsDeep(value, `prop:${key}`);
    }
  }
  return rendered;
}
function SlotContentRenderer({
  content,
  onDismiss,
  patternPath
}) {
  const ambientScope = useTraitScope();
  const bindingTrait = content.sourceTrait ?? ambientScope?.trait;
  const binding = useEntityBindingSnapshot(bindingTrait);
  const liveProps = useMemo(
    () => resolveRenderBindingMarkers(content.props, bindingTrait, binding.entity, binding.config, binding.state),
    [content.props, bindingTrait, binding.entity, binding.config, binding.state]
  );
  const entityProp = liveProps.entity;
  if (content.pattern === "form-section") {
    slotLog.debug("SlotContentRenderer:form-section-render", {
      contentId: content.id,
      sourceTrait: content.sourceTrait,
      entityRefId: refId(entityProp),
      entityIsObject: entityProp !== null && typeof entityProp === "object" && !Array.isArray(entityProp)
    });
  }
  if (typeof entityProp === "string" && entityProp.length > 0) {
    if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production") {
      throw new Error(
        `[UISlotRenderer] Received string 'entity: "${entityProp}"' at render time. The V2 flow requires pre-resolved data; declare a fetch success listener and pass 'entity: @payload.data'. See docs/Almadar_Entity_V2_Plan.md \xA76.`
      );
    }
  }
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const schemaCtx = useEntitySchemaOptional();
  let entityDef;
  if (typeof entityProp === "string" && entityProp.length > 0 && schemaCtx) {
    entityDef = schemaCtx.entities.get(entityProp);
  } else if (schemaCtx && content.sourceTrait !== void 0) {
    const linkedEntity = schemaCtx.traitLinkedEntities.get(content.sourceTrait);
    if (linkedEntity !== void 0) {
      entityDef = schemaCtx.entities.get(linkedEntity);
    }
  }
  const orbitalName = schemaCtx && content.sourceTrait !== void 0 ? schemaCtx.orbitalsByTrait.get(content.sourceTrait) : void 0;
  const PatternComponent = getComponentForPattern(content.pattern);
  if (PatternComponent) {
    const childrenConfig = liveProps.children;
    const isSingleChild = typeof childrenConfig === "string" || typeof childrenConfig === "object" && childrenConfig !== null && !Array.isArray(childrenConfig) && "type" in childrenConfig;
    const hasChildren = PATTERNS_WITH_CHILDREN.has(content.pattern) || Array.isArray(childrenConfig) && childrenConfig.length > 0 || isSingleChild;
    const isDrawHost = isDrawHostPattern(content.pattern);
    const arr = Array.isArray(childrenConfig) ? childrenConfig : childrenConfig ? [childrenConfig] : [];
    const hasTraitChildren = arr.some(
      (c) => typeof c === "string" && TRAIT_BINDING_RE.test(c)
    );
    const drawHostUsesReactChildren = isDrawHost && hasTraitChildren;
    const myPath = patternPath ?? "root";
    const renderedChildren = hasChildren && (!isDrawHost || drawHostUsesReactChildren) ? renderPatternChildren(childrenConfig, onDismiss, content.id, myPath, content.sourceTrait, {
      slot: content.slot,
      transitionEvent: content.transitionEvent,
      fromState: content.fromState,
      entity: content.entity
    }) : void 0;
    const incomingChildren = liveProps.children;
    const childrenIsRenderFn = typeof incomingChildren === "function";
    const { children: _childrenConfig, ...restPropsNoChildren } = liveProps;
    const restProps = childrenIsRenderFn ? { ...restPropsNoChildren, children: incomingChildren } : restPropsNoChildren;
    const nodeSlotOverrides = {};
    for (const slotKey of CONTENT_NODE_SLOTS) {
      const slotVal = restProps[slotKey];
      if (slotVal === void 0 || slotVal === null) continue;
      if (React79__default.isValidElement(slotVal) || typeof slotVal === "string" || typeof slotVal === "number" || typeof slotVal === "boolean") continue;
      const typelessChildren = !Array.isArray(slotVal) && typeof slotVal === "object" && !("type" in slotVal) && Array.isArray(slotVal.children) ? slotVal.children : void 0;
      if (typelessChildren !== void 0 || Array.isArray(slotVal) || typeof slotVal === "object" && "type" in slotVal) {
        nodeSlotOverrides[slotKey] = renderPatternChildren(
          typelessChildren ?? slotVal,
          onDismiss,
          `${content.id}-${slotKey}`,
          `${myPath}.${slotKey}`,
          content.sourceTrait,
          { slot: content.slot, transitionEvent: content.transitionEvent, fromState: content.fromState, entity: content.entity }
        );
      }
    }
    const patternDef = getPatternDefinition$1(content.pattern);
    const propsSchema = patternDef?.propsSchema;
    const renderedProps = renderPatternProps(restProps, onDismiss, propsSchema);
    if (propsSchema) {
      for (const [propKey, propValue] of Object.entries(renderedProps)) {
        if (typeof propValue !== "string") continue;
        const propDef = propsSchema[propKey];
        if (!propDef || propDef.kind !== "callback") continue;
        if (propValue === "") continue;
        renderedProps[propKey] = wrapCallbackForEvent(
          `UI:${propValue}`,
          propDef.callbackArgs,
          (eventKey, payload) => eventBus.emit(eventKey, payload)
        );
      }
    }
    if (propsSchema) {
      for (const [propKey, propDef] of Object.entries(propsSchema)) {
        const isDate = propDef.types?.some(
          (t2) => t2 === "date" || t2 === "datetime" || t2 === "timestamp"
        );
        if (!isDate) continue;
        const v = renderedProps[propKey];
        if (typeof v === "string" || typeof v === "number") {
          renderedProps[propKey] = new Date(v);
        } else if (v == null && propDef.required) {
          renderedProps[propKey] = /* @__PURE__ */ new Date();
        }
      }
    }
    const finalProps = renderedProps;
    for (const [k, v] of Object.entries(nodeSlotOverrides)) {
      finalProps[k] = v;
    }
    if (isDrawHost && !drawHostUsesReactChildren && Array.isArray(childrenConfig) && childrenConfig.length > 0) {
      finalProps.drawables = toDrawableNodes(childrenConfig);
    }
    const entityVal = finalProps.entity;
    const resolvedItems = Array.isArray(entityVal) && entityVal[0] !== "fn" ? entityVal : null;
    if (resolvedItems && resolvedItems.length > 0 && !finalProps.fields && !finalProps.columns) {
      const sample = resolvedItems[0];
      if (sample && typeof sample === "object" && !Array.isArray(sample) && !React79__default.isValidElement(sample) && !(sample instanceof Date)) {
        const keys = Object.keys(sample).filter((k) => k !== "id" && k !== "_id");
        finalProps.fields = keys.map((k, i) => ({ name: k, variant: i === 0 ? "h4" : "body" }));
      }
    }
    const fieldsContract = getPatternFieldsContract(content.pattern) ?? (getPatternDefinition$1(content.pattern) === null && content.pattern.includes("form") ? "form" : void 0);
    if (fieldsContract && entityDef && Array.isArray(finalProps.fields) && finalProps.fields[0] !== "fn") {
      finalProps.fields = fieldsContract === "form" ? enrichFormFields([...finalProps.fields], entityDef) : enrichDetailFields([...finalProps.fields], entityDef);
    }
    const acceptsChildren = PATTERNS_WITH_CHILDREN.has(content.pattern);
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "slot-content contents",
        "data-pattern": content.pattern,
        "data-id": content.id,
        "data-node-id": content.nodeId,
        "data-source-trait": content.sourceTrait,
        "data-pattern-path": myPath,
        "data-pattern-type": content.pattern,
        "data-accepts-children": acceptsChildren ? "true" : void 0,
        "data-orb-trait": content.sourceTrait,
        "data-orb-slot": content.slot,
        "data-orb-transition": content.transitionEvent,
        "data-orb-state": content.fromState,
        "data-orb-entity": content.entity,
        "data-orb-path": myPath,
        "data-orb-pattern": content.pattern,
        "data-orb-orbital": orbitalName,
        children: renderedChildren !== void 0 ? /* @__PURE__ */ jsx(PatternComponent, { ...finalProps, children: renderedChildren }) : /* @__PURE__ */ jsx(PatternComponent, { ...finalProps })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: "slot-content",
      "data-pattern": content.pattern,
      "data-id": content.id,
      "data-node-id": content.nodeId,
      "data-source-trait": content.sourceTrait,
      "data-orb-trait": content.sourceTrait,
      "data-orb-slot": content.slot,
      "data-orb-transition": content.transitionEvent,
      "data-orb-state": content.fromState,
      "data-orb-entity": content.entity,
      "data-orb-path": patternPath ?? "root",
      "data-orb-pattern": content.pattern,
      "data-orb-orbital": orbitalName,
      children: liveProps.children ?? /* @__PURE__ */ jsxs(Box, { className: "p-4 text-sm text-muted-foreground border border-dashed border-border rounded", children: [
        "Unknown pattern: ",
        content.pattern,
        content.sourceTrait && /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "ml-2", children: [
          "(from ",
          content.sourceTrait,
          ")"
        ] })
      ] })
    }
  );
}
function UISlotRenderer({
  includeHud = false,
  hudMode = "fixed",
  includeFloating = false,
  className,
  suspense
}) {
  const isContained = hudMode === "inline";
  const suspenseConfig = suspense === true ? { enabled: true } : suspense && typeof suspense === "object" ? suspense : { enabled: false };
  const content = /* @__PURE__ */ jsxs(Box, { className: cn(
    "ui-slot-renderer relative min-h-full",
    className
  ), children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex min-h-full flex-col lg:flex-row", children: [
      /* @__PURE__ */ jsx(UISlotComponent, { slot: "sidebar", className: "ui-slot-sidebar min-w-0 lg:shrink-0" }),
      /* @__PURE__ */ jsx(UISlotComponent, { slot: "main", className: "ui-slot-main flex-1 min-w-0 min-h-[200px]" })
    ] }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "modal", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "drawer", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "overlay", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "center", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "toast", portal: true, position: "top-right" }),
    includeHud && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        UISlotComponent,
        {
          slot: "hud-top",
          className: isContained ? "absolute top-0 left-0 right-0 z-40" : "fixed top-0 inset-x-0 z-40"
        }
      ),
      /* @__PURE__ */ jsx(
        UISlotComponent,
        {
          slot: "hud-bottom",
          className: isContained ? "absolute bottom-0 left-0 right-0 z-40" : "fixed bottom-0 inset-x-0 z-40"
        }
      )
    ] }),
    includeFloating && /* @__PURE__ */ jsx(
      UISlotComponent,
      {
        slot: "floating",
        className: isContained ? "absolute top-2 left-2 z-50" : "fixed z-50",
        draggable: true
      }
    )
  ] });
  let wrapped = content;
  if (suspenseConfig.enabled) {
    wrapped = /* @__PURE__ */ jsx(SuspenseConfigProvider, { config: suspenseConfig, children: wrapped });
  }
  if (isContained) {
    wrapped = /* @__PURE__ */ jsx(SlotContainedContext.Provider, { value: true, children: wrapped });
  }
  return wrapped;
}
var scopeWrapLog, TRAIT_BINDING_RE, SuspenseConfigContext, SLOT_SKELETON_MAP, CONTENT_NODE_SLOTS, PATTERNS_WITH_CHILDREN, traitRefPresenceCache;
var init_UISlotRenderer = __esm({
  "components/core/organisms/UISlotRenderer.tsx"() {
    "use client";
    init_resolve_render_bindings();
    init_Modal();
    init_Drawer();
    init_Toast();
    init_Box();
    init_Typography();
    init_useEventBus();
    init_slot_types();
    init_cn();
    init_format();
    init_portalRoot();
    init_slotContained();
    init_ErrorBoundary();
    init_Skeleton();
    init_renderer();
    init_wrapCallbackForEvent();
    init_TraitFrame();
    init_component_registry_generated();
    scopeWrapLog = createLogger("almadar:ui:scope-wrap");
    TRAIT_BINDING_RE = /^@trait\.([A-Z][A-Za-z0-9]*)$/;
    SuspenseConfigContext = createContext({ enabled: false });
    SuspenseConfigProvider.displayName = "SuspenseConfigProvider";
    SLOT_SKELETON_MAP = {
      main: "table",
      sidebar: "card",
      modal: "form",
      drawer: "form"
    };
    CONTENT_NODE_SLOTS = /* @__PURE__ */ new Set([
      "logo",
      "master",
      "detail",
      "trigger",
      "content",
      "addons",
      "hud",
      "fallback",
      "controls",
      "overlay"
    ]);
    PATTERNS_WITH_CHILDREN = /* @__PURE__ */ new Set([
      "stack",
      "vstack",
      "hstack",
      "box",
      "canvas",
      "canvas-2d",
      "grid",
      "center",
      "card",
      "tooltip",
      "popover",
      "container",
      "simple-grid",
      "custom",
      "dashboard-layout",
      "game-shell",
      "game-template",
      "scaled-diagram",
      "master-detail",
      "form-field",
      "form-section",
      "form",
      "accordion",
      "tabs",
      "tab-content",
      "collapsible",
      "alert",
      "dialog"
    ]);
    traitRefPresenceCache = /* @__PURE__ */ new WeakMap();
    UISlotRenderer.displayName = "UISlotRenderer";
  }
});
function useTraitContent(traitName) {
  const slotManager = useUISlots();
  const [content, setContent] = useState(
    () => slotManager.getTraitContent(traitName)
  );
  useEffect(() => {
    setContent(slotManager.getTraitContent(traitName));
    const unsubscribe = slotManager.subscribeTrait(traitName, (nextContent) => {
      setContent(nextContent ?? slotManager.getTraitContent(traitName));
    });
    return unsubscribe;
  }, [slotManager, traitName]);
  return content;
}
function TraitFrame({
  traitName,
  fallback = null
}) {
  const content = useTraitContent(traitName);
  const entitySchema = useEntitySchemaOptional();
  const orbital = entitySchema?.orbitalsByTrait.get(traitName);
  if (!content) {
    return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  }
  const SlotContentRenderer2 = getSlotContentRenderer();
  const rendered = /* @__PURE__ */ jsx(
    SlotContentRenderer2,
    {
      content,
      onDismiss: () => {
      }
    }
  );
  if (!orbital) {
    return rendered;
  }
  return /* @__PURE__ */ jsx(TraitScopeProvider, { orbital, trait: traitName, children: rendered });
}
function getSlotContentRenderer() {
  if (_slotContentRenderer) return _slotContentRenderer;
  const mod = (init_UISlotRenderer(), __toCommonJS(UISlotRenderer_exports));
  _slotContentRenderer = mod.SlotContentRenderer;
  return _slotContentRenderer;
}
var _slotContentRenderer;
var init_TraitFrame = __esm({
  "components/core/atoms/TraitFrame.tsx"() {
    TraitFrame.displayName = "TraitFrame";
    _slotContentRenderer = null;
  }
});

// components/core/atoms/index.ts
var init_atoms = __esm({
  "components/core/atoms/index.ts"() {
    init_svg();
    init_Button();
    init_Input();
    init_Label();
    init_Textarea();
    init_Select();
    init_Checkbox();
    init_Card();
    init_Badge();
    init_AtlasImage();
    init_GameIcon();
    init_FilterPill();
    init_Spinner();
    init_Avatar();
    init_Box();
    init_Center();
    init_Divider();
    init_Icon();
    init_ProgressBar();
    init_Radio();
    init_Sparkline();
    init_Switch();
    init_Spacer();
    init_Stack();
    init_TextHighlight();
    init_Typography();
    init_ThemeToggle();
    init_Overlay();
    init_Presence();
    init_FlipContainer();
    init_Dialog();
    init_Aside();
    init_ConditionalWrapper();
    init_LawReferenceTooltip();
    init_DayCell();
    init_TimeSlotCell();
    init_StatusDot();
    init_TrendIndicator();
    init_RangeSlider();
    init_AnimatedCounter();
    init_InfiniteScrollSentinel();
    init_ConfettiEffect();
    init_TypewriterText();
    init_SectionHeader();
    init_MarketingStatCard();
    init_ContentSection();
    init_PatternTile();
    init_AnimatedReveal();
    init_AnimatedGraphic();
    init_TraitFrame();
    init_molecules();
    init_LearningCanvas();
  }
});

// components/index.ts
init_atoms();
init_molecules2();

// components/core/organisms/index.ts
init_types2();
init_DataTable();
init_StatCard();
init_DetailPanel();
init_Form();
init_List();
init_CardGrid();
init_MasterDetail();
init_StateMachineView();

// components/core/organisms/book/index.ts
init_BookViewer();
init_BookChapterView();
init_BookCoverPage();
init_BookTableOfContents();
init_BookNavBar();
init_types();

// components/core/organisms/layout/index.ts
init_SplitPane();
init_MasterDetailLayout();
init_DashboardGrid();
init_TabbedContainer();
init_DockLayout();

// components/core/organisms/index.ts
init_molecules();
init_UISlotRenderer();
init_ModalSlot();
init_DrawerSlot();
init_ToastSlot();
init_Timeline();
init_MediaGallery();

// components/core/organisms/debug/index.ts
init_RuntimeDebugger2();

// components/core/organisms/index.ts
init_HeroOrganism();
init_FeatureGridOrganism();
init_PricingOrganism();
init_StatsOrganism();
init_StepFlowOrganism();
init_ShowcaseOrganism();
init_TeamOrganism();
init_CaseStudyOrganism();
init_CodeRunnerPanel();
init_SegmentRenderer();
init_ChatBar();
init_trace_edit_focus();
init_SubagentTracePanel();

// components/core/templates/index.ts
init_DashboardLayout();
init_AuthLayout();
init_CounterTemplate();
init_GenericAppTemplate();
init_LandingPageTemplate();
init_PricingPageTemplate();
init_FeatureDetailPageTemplate();
init_AboutPageTemplate();

// components/index.ts
init_cn();
var log9 = createLogger("almadar:ui:orbital-history");
function useOrbitalHistory(options) {
  const { appId, authToken, userId, onHistoryChange, onRevertSuccess } = options;
  const getHeaders = useCallback(() => {
    const headers = {
      "Content-Type": "application/json"
    };
    if (authToken) {
      headers["Authorization"] = `Bearer ${authToken}`;
    }
    if (userId) {
      headers["x-user-id"] = userId;
    }
    return headers;
  }, [authToken, userId]);
  const [timeline, setTimeline] = useState([]);
  const [currentVersion, setCurrentVersion] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const refresh = useCallback(async () => {
    if (!appId) return;
    setIsLoading(true);
    setError(null);
    try {
      const headers = getHeaders();
      const [changesetsRes, snapshotsRes] = await Promise.all([
        fetch(`/api/graphs/${appId}/history/changesets`, { headers }),
        fetch(`/api/graphs/${appId}/history/snapshots`, { headers })
      ]);
      if (!changesetsRes.ok) {
        throw new Error(`Failed to fetch changesets: ${changesetsRes.status}`);
      }
      if (!snapshotsRes.ok) {
        throw new Error(`Failed to fetch snapshots: ${snapshotsRes.status}`);
      }
      const changesetsData = await changesetsRes.json();
      const snapshotsData = await snapshotsRes.json();
      const changesetItems = (changesetsData.changesets || []).map((cs) => ({
        id: cs.id,
        type: "changeset",
        version: cs.version,
        timestamp: cs.timestamp,
        description: `Version ${cs.version}`,
        source: cs.source,
        summary: cs.summary
      }));
      const snapshotItems = (snapshotsData.snapshots || []).map((snap) => ({
        id: snap.id,
        type: "snapshot",
        version: snap.version,
        timestamp: snap.timestamp,
        description: snap.reason || `Snapshot v${snap.version}`,
        reason: snap.reason
      }));
      const mergedTimeline = [...changesetItems, ...snapshotItems].sort(
        (a, b) => b.timestamp - a.timestamp
      );
      setTimeline(mergedTimeline);
      if (mergedTimeline.length > 0) {
        setCurrentVersion(mergedTimeline[0].version);
      }
    } catch (err) {
      log9.error("Failed to load history", { error: err instanceof Error ? err : String(err) });
      setError(err instanceof Error ? err.message : "Failed to load history");
    } finally {
      setIsLoading(false);
    }
  }, [appId, getHeaders]);
  const revertToSnapshot = useCallback(async (snapshotId) => {
    if (!appId) {
      return { success: false, error: "No app ID provided" };
    }
    try {
      const response = await fetch(`/api/graphs/${appId}/history/revert/${snapshotId}`, {
        method: "POST",
        headers: getHeaders()
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Failed to revert: ${response.status}`);
      }
      const data = await response.json();
      if (data.success && data.schema) {
        await refresh();
        onRevertSuccess?.(data.schema);
        return {
          success: true,
          restoredSchema: data.schema
        };
      }
      return {
        success: false,
        error: data.error || "Unknown error during revert"
      };
    } catch (err) {
      log9.error("Failed to revert", { error: err instanceof Error ? err : String(err) });
      return {
        success: false,
        error: err instanceof Error ? err.message : "Failed to revert"
      };
    }
  }, [appId, getHeaders, refresh, onRevertSuccess]);
  useEffect(() => {
    if (appId && authToken && userId) {
      refresh();
    }
  }, [appId, authToken, userId]);
  useEffect(() => {
    onHistoryChange?.(timeline);
  }, [timeline]);
  return {
    timeline,
    currentVersion,
    isLoading,
    error,
    revertToSnapshot,
    refresh
  };
}
var log10 = createLogger("almadar:ui:filesystem");
function useFileSystem() {
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedPath, setSelectedPath] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileContents, setFileContents] = useState(/* @__PURE__ */ new Map());
  const boot = useCallback(async () => {
    setStatus("booting");
    setError(null);
    setIsLoading(true);
    try {
      log10.debug("Booting WebContainer");
      await new Promise((resolve) => setTimeout(resolve, 100));
      setStatus("ready");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to boot");
      setStatus("error");
    } finally {
      setIsLoading(false);
    }
  }, []);
  const mountFiles = useCallback(async (filesToMount) => {
    setIsLoading(true);
    try {
      let filesArray;
      if (Array.isArray(filesToMount)) {
        filesArray = filesToMount;
      } else {
        filesArray = [];
        const flattenTree = (obj, basePath = "") => {
          for (const [key, value] of Object.entries(obj)) {
            const path = basePath ? `${basePath}/${key}` : key;
            if (value && "file" in value) {
              filesArray.push({ path, content: value.file.contents || "" });
            } else if (value && "directory" in value) {
              flattenTree(value.directory, path);
            }
          }
        };
        flattenTree(filesToMount);
      }
      const newContents = /* @__PURE__ */ new Map();
      for (const file of filesArray) {
        newContents.set(file.path, file.content);
      }
      setFileContents(newContents);
      const newTree = [];
      for (const file of filesArray) {
        const parts = file.path.split("/").filter(Boolean);
        let current = newTree;
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i];
          const isFile = i === parts.length - 1;
          const currentPath = "/" + parts.slice(0, i + 1).join("/");
          let node = current.find((n) => n.name === part);
          if (!node) {
            node = {
              path: currentPath,
              name: part,
              type: isFile ? "file" : "directory",
              children: isFile ? void 0 : []
            };
            current.push(node);
          }
          if (!isFile && node && node.children) {
            current = node.children;
          }
        }
      }
      setFiles(newTree);
      setStatus("running");
    } catch (err) {
      log10.error("Failed to mount files", { error: err instanceof Error ? err : String(err) });
    } finally {
      setIsLoading(false);
    }
  }, []);
  const readFile = useCallback(async (path) => {
    return fileContents.get(path) || "";
  }, [fileContents]);
  const writeFile = useCallback(async (path, content) => {
    setFileContents((prev) => {
      const next = new Map(prev);
      next.set(path, content);
      return next;
    });
  }, []);
  const selectFile = useCallback(async (path) => {
    const content = fileContents.get(path) || "";
    const ext = path.split(".").pop()?.toLowerCase() || "";
    const languageMap = {
      ts: "typescript",
      tsx: "typescript",
      js: "javascript",
      jsx: "javascript",
      json: "json",
      md: "markdown",
      css: "css",
      html: "html",
      orb: "json"
    };
    setSelectedPath(path);
    setSelectedFile({
      path,
      content,
      language: languageMap[ext] || "plaintext",
      isDirty: false
    });
  }, [fileContents]);
  const updateContent = useCallback((pathOrContent, contentArg) => {
    const path = contentArg !== void 0 ? pathOrContent : selectedPath;
    const content = contentArg !== void 0 ? contentArg : pathOrContent;
    if (!path) {
      log10.warn("updateContent called without path and no file selected");
      return;
    }
    setFileContents((prev) => {
      const next = new Map(prev);
      next.set(path, content);
      return next;
    });
    if (selectedPath === path) {
      setSelectedFile((prev) => prev ? { ...prev, content, isDirty: true } : null);
    }
  }, [selectedPath]);
  const updateSelectedContent = useCallback((content) => {
    setSelectedFile((prev) => prev ? { ...prev, content, isDirty: true } : null);
  }, []);
  const refreshTree = useCallback(async () => {
    log10.debug("Refreshing tree");
  }, []);
  const runCommand = useCallback(async (command) => {
    log10.debug("Running command", { command });
    return { exitCode: 0, output: "" };
  }, []);
  const startDevServer = useCallback(async () => {
    log10.debug("Starting dev server");
    setPreviewUrl("http://localhost:5173");
  }, []);
  return {
    status,
    error,
    isLoading,
    files,
    selectedFile,
    selectedPath,
    previewUrl,
    boot,
    mountFiles,
    readFile,
    writeFile,
    selectFile,
    updateContent,
    updateSelectedContent,
    refreshTree,
    runCommand,
    startDevServer
  };
}
var log11 = createLogger("almadar:ui:extensions");
var defaultManifest = {
  languages: {
    typescript: { extensions: [".ts", ".tsx"], icon: "ts", color: "#3178c6" },
    javascript: { extensions: [".js", ".jsx"], icon: "js", color: "#f7df1e" },
    json: { extensions: [".json", ".orb"], icon: "json", color: "#000000" },
    css: { extensions: [".css"], icon: "css", color: "#264de4" },
    html: { extensions: [".html"], icon: "html", color: "#e34c26" },
    markdown: { extensions: [".md", ".mdx"], icon: "md", color: "#083fa1" }
  },
  extensions: []
};
function useExtensions(options) {
  const { appId, loadOnMount = true } = options;
  const [extensions, setExtensions] = useState([]);
  const [manifest] = useState(defaultManifest);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const loadExtension = useCallback(async (extensionId) => {
    log11.debug("Loading extension", { extensionId });
  }, []);
  const loadExtensions = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const defaultExtensions = [
        { id: "typescript", name: "TypeScript", language: "typescript", loaded: true },
        { id: "javascript", name: "JavaScript", language: "javascript", loaded: true },
        { id: "json", name: "JSON", language: "json", loaded: true },
        { id: "css", name: "CSS", language: "css", loaded: true },
        { id: "html", name: "HTML", language: "html", loaded: true },
        { id: "markdown", name: "Markdown", language: "markdown", loaded: true }
      ];
      setExtensions(defaultExtensions);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load extensions");
    } finally {
      setIsLoading(false);
    }
  }, []);
  const getExtensionForFile = useCallback((filename) => {
    const ext = filename.split(".").pop()?.toLowerCase();
    if (!ext) return null;
    const languageMap = {
      ts: "typescript",
      tsx: "typescript",
      js: "javascript",
      jsx: "javascript",
      json: "json",
      md: "markdown",
      css: "css",
      html: "html",
      orb: "json"
    };
    const language = languageMap[ext];
    if (!language) return null;
    return extensions.find((e) => e.language === language) || null;
  }, [extensions]);
  useEffect(() => {
    if (!appId || !loadOnMount) return;
    const loadExtensions2 = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const defaultExtensions = [
          { id: "typescript", name: "TypeScript", language: "typescript", loaded: true },
          { id: "javascript", name: "JavaScript", language: "javascript", loaded: true },
          { id: "json", name: "JSON", language: "json", loaded: true },
          { id: "css", name: "CSS", language: "css", loaded: true },
          { id: "html", name: "HTML", language: "html", loaded: true },
          { id: "markdown", name: "Markdown", language: "markdown", loaded: true }
        ];
        setExtensions(defaultExtensions);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to load extensions");
      } finally {
        setIsLoading(false);
      }
    };
    loadExtensions2();
  }, [appId, loadOnMount]);
  return {
    extensions,
    manifest,
    isLoading,
    error,
    loadExtension,
    loadExtensions,
    getExtensionForFile
  };
}
var log12 = createLogger("almadar:ui:file-editor");
function useFileEditor(options) {
  const { extensions, fileSystem, onSchemaUpdate } = options;
  const [openFiles, setOpenFiles] = useState([]);
  const [activeFilePath, setActiveFilePath] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const activeFile = openFiles.find((f3) => f3.path === activeFilePath) || null;
  const openFile = useCallback(async (path) => {
    const existing = openFiles.find((f3) => f3.path === path);
    if (existing) {
      setActiveFilePath(path);
      return;
    }
    try {
      const content = await fileSystem.readFile(path);
      const ext = extensions.getExtensionForFile(path);
      const newFile = {
        path,
        content,
        isDirty: false,
        language: ext?.language
      };
      setOpenFiles((prev) => [...prev, newFile]);
      setActiveFilePath(path);
    } catch (err) {
      log12.error("Failed to open file", { error: err instanceof Error ? err : String(err) });
    }
  }, [openFiles, fileSystem, extensions]);
  const closeFile = useCallback((path) => {
    setOpenFiles((prev) => prev.filter((f3) => f3.path !== path));
    if (activeFilePath === path) {
      const remaining = openFiles.filter((f3) => f3.path !== path);
      setActiveFilePath(remaining.length > 0 ? remaining[0].path : null);
    }
  }, [activeFilePath, openFiles]);
  const setActiveFile = useCallback((path) => {
    setActiveFilePath(path);
  }, []);
  const updateFileContent = useCallback((path, content) => {
    setOpenFiles(
      (prev) => prev.map(
        (f3) => f3.path === path ? { ...f3, content, isDirty: true } : f3
      )
    );
  }, []);
  const handleFileEdit = useCallback(async (path, content) => {
    try {
      await fileSystem.writeFile(path, content);
      let action = "saved";
      if (path.endsWith(".orb") || path.endsWith("schema.json")) {
        try {
          const schema = JSON.parse(content);
          await onSchemaUpdate?.(schema);
          action = "updated_schema";
        } catch {
        }
      } else if (path.includes("/extensions/")) {
        action = path.endsWith(".new") ? "converted_extension" : "saved_extension";
      }
      return { success: true, action };
    } catch (err) {
      return {
        success: false,
        error: err instanceof Error ? err.message : "Failed to save file"
      };
    }
  }, [fileSystem, onSchemaUpdate]);
  const saveFile = useCallback(async (path) => {
    const file = openFiles.find((f3) => f3.path === path);
    if (!file) return;
    setIsSaving(true);
    try {
      await fileSystem.writeFile(path, file.content);
      setOpenFiles(
        (prev) => prev.map(
          (f3) => f3.path === path ? { ...f3, isDirty: false } : f3
        )
      );
      if (path.endsWith(".orb") || path.endsWith("schema.json")) {
        try {
          const schema = JSON.parse(file.content);
          await onSchemaUpdate?.(schema);
        } catch {
        }
      }
    } catch (err) {
      log12.error("Failed to save file", { error: err instanceof Error ? err : String(err) });
    } finally {
      setIsSaving(false);
    }
  }, [openFiles, fileSystem, onSchemaUpdate]);
  const saveAllFiles = useCallback(async () => {
    setIsSaving(true);
    try {
      const dirtyFiles = openFiles.filter((f3) => f3.isDirty);
      for (const file of dirtyFiles) {
        await saveFile(file.path);
      }
    } finally {
      setIsSaving(false);
    }
  }, [openFiles, saveFile]);
  return {
    openFiles,
    activeFile,
    isSaving,
    openFile,
    closeFile,
    setActiveFile,
    updateFileContent,
    handleFileEdit,
    saveFile,
    saveAllFiles
  };
}
var log13 = createLogger("almadar:ui:compile");
function useCompile() {
  const [isCompiling, setIsCompiling] = useState(false);
  const [stage, setStage] = useState("idle");
  const [lastResult, setLastResult] = useState(null);
  const [error, setError] = useState(null);
  const compileSchema = useCallback(async (schema) => {
    setIsCompiling(true);
    setStage("compiling");
    setError(null);
    try {
      log13.debug("Compiling schema", { name: schema.name });
      const result = {
        success: true,
        files: []
      };
      setLastResult(result);
      setStage("done");
      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Compilation failed";
      setError(errorMessage);
      setStage("error");
      setLastResult({ success: false, errors: [errorMessage] });
      return null;
    } finally {
      setIsCompiling(false);
    }
  }, []);
  return {
    isCompiling,
    stage,
    lastResult,
    error,
    compileSchema
  };
}
var log14 = createLogger("almadar:ui:preview");
function usePreview(options) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(!!options?.appId);
  const [error, setError] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [app, setApp] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isExecutingEvent, setIsExecutingEvent] = useState(false);
  const [errorToast, setErrorToast] = useState(null);
  const [currentStateName, setCurrentStateName] = useState(null);
  const [notificationsList, setNotificationsList] = useState([]);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const notifications = useMemo(() => ({
    notifications: notificationsList,
    isPanelOpen,
    closePanel: () => setIsPanelOpen(false),
    dismissNotification: (id) => {
      setNotificationsList((prev) => prev.filter((n) => n.id !== id));
    },
    markAsRead: (id) => {
      setNotificationsList(
        (prev) => prev.map((n) => n.id === id ? { ...n, read: true } : n)
      );
    },
    clearAll: () => setNotificationsList([])
  }), [notificationsList, isPanelOpen]);
  useEffect(() => {
    const appId = options?.appId;
    if (!appId) {
      setApp(null);
      setIsLoading(false);
      return;
    }
    log14.debug("Setting up preview for app", { appId });
    setPreviewUrl(`/api/orbitals/${appId}`);
    setIsLoading(false);
  }, [options?.appId]);
  const startPreview = useCallback(async () => {
    log14.debug("startPreview called");
  }, []);
  const stopPreview = useCallback(async () => {
    setIsLoading(true);
    try {
      log14.debug("Stopping preview server");
      setPreviewUrl(null);
      setApp(null);
    } finally {
      setIsLoading(false);
    }
  }, []);
  const refresh = useCallback(async () => {
    if (!previewUrl) return;
    log14.debug("Refreshing preview");
    setPreviewUrl(`${previewUrl.split("?")[0]}?t=${Date.now()}`);
  }, [previewUrl]);
  const handleRefresh = useCallback(async () => {
    log14.debug("Handle refresh");
    await refresh();
  }, [refresh]);
  const handleReset = useCallback(async () => {
    log14.debug("Resetting preview");
    setError(null);
    setLoadError(null);
    setErrorToast(null);
    setIsExecutingEvent(false);
    setCurrentStateName(null);
  }, []);
  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);
  const dismissErrorToast = useCallback(() => {
    setErrorToast(null);
  }, []);
  return {
    previewUrl,
    isLoading,
    error,
    loadError,
    app,
    isFullscreen,
    isExecutingEvent,
    errorToast,
    currentStateName,
    notifications,
    startPreview,
    stopPreview,
    refresh,
    handleRefresh,
    handleReset,
    toggleFullscreen,
    setErrorToast,
    dismissErrorToast
  };
}
var log15 = createLogger("almadar:ui:agent-chat");
function useAgentChat(options) {
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState("idle");
  const [activities, setActivities] = useState([]);
  const [todos, setTodos] = useState([]);
  const [schemaDiffs, setSchemaDiffs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [threadId] = useState(null);
  const [interrupt, setInterrupt] = useState(null);
  const sendMessage = useCallback(async (content) => {
    setIsLoading(true);
    setStatus("running");
    setError(null);
    try {
      const userMessage = {
        id: Date.now().toString(),
        role: "user",
        content,
        timestamp: Date.now()
      };
      setMessages((prev) => [...prev, userMessage]);
      log15.debug("Sending message", { content });
      const assistantMessage = {
        id: (Date.now() + 1).toString(),
        role: "assistant",
        content: "Agent chat is not yet implemented.",
        timestamp: Date.now()
      };
      setMessages((prev) => [...prev, assistantMessage]);
      setStatus("idle");
      options?.onComplete?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to send message");
      setStatus("error");
    } finally {
      setIsLoading(false);
    }
  }, [options]);
  const startGeneration = useCallback(async (skill, prompt, genOptions) => {
    setStatus("running");
    setIsLoading(true);
    setError(null);
    const skillName = Array.isArray(skill) ? skill[0] : skill;
    try {
      log15.debug("Starting generation", () => ({ skillName, prompt, genOptions: JSON.stringify(genOptions) }));
      await new Promise((resolve) => setTimeout(resolve, 100));
      setStatus("complete");
      options?.onComplete?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Generation failed");
      setStatus("error");
    } finally {
      setIsLoading(false);
    }
  }, [options]);
  const continueConversation = useCallback(async (message) => {
    log15.debug("Continue conversation", { message: Array.isArray(message) ? message : [message] });
  }, []);
  const resumeWithDecision = useCallback(async (decisions) => {
    log15.debug("Resume with decision", () => ({ decisions: JSON.stringify(decisions), count: decisions.length }));
    setInterrupt(null);
  }, []);
  const cancel = useCallback(() => {
    setStatus("idle");
    setIsLoading(false);
    setInterrupt(null);
  }, []);
  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);
  const clearHistory = useCallback(() => {
    setMessages([]);
    setActivities([]);
    setTodos([]);
    setSchemaDiffs([]);
    setError(null);
  }, []);
  return {
    messages,
    status,
    activities,
    todos,
    schemaDiffs,
    isLoading,
    error,
    threadId,
    interrupt,
    sendMessage,
    startGeneration,
    continueConversation,
    resumeWithDecision,
    cancel,
    clearMessages,
    clearHistory
  };
}
var log16 = createLogger("almadar:ui:validation");
function useValidation() {
  const [result, setResult] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [error, setError] = useState(null);
  const [stage, setStage] = useState("idle");
  const [isFixing, setIsFixing] = useState(false);
  const [progressMessage, setProgressMessage] = useState(null);
  const validate = useCallback(async (appId) => {
    setIsValidating(true);
    setError(null);
    setStage("validating");
    setProgressMessage("Validating schema...");
    try {
      log16.debug("Validating app", { appId });
      const validationResult = {
        valid: true,
        errors: [],
        warnings: []
      };
      setResult(validationResult);
      setStage("complete");
      setProgressMessage(null);
      return validationResult;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Validation failed";
      setError(errorMessage);
      const failedResult = {
        valid: false,
        errors: [{ code: "VALIDATION_ERROR", message: errorMessage, severity: "error" }],
        warnings: []
      };
      setResult(failedResult);
      setStage("complete");
      setProgressMessage(null);
      return failedResult;
    } finally {
      setIsValidating(false);
    }
  }, []);
  const clearResult = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);
  const reset = useCallback(() => {
    setResult(null);
    setError(null);
    setStage("idle");
    setIsFixing(false);
    setProgressMessage(null);
    setIsValidating(false);
  }, []);
  return {
    result,
    isValidating,
    error,
    stage,
    isFixing,
    progressMessage,
    errors: result?.errors ?? [],
    warnings: result?.warnings ?? [],
    isValid: result?.valid ?? false,
    validate,
    clearResult,
    reset
  };
}
var log17 = createLogger("almadar:ui:deep-agent");
function useDeepAgentGeneration() {
  const [requests, setRequests] = useState([]);
  const [currentRequest, setCurrentRequest] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [progress, setProgress] = useState({ stage: "idle", percent: 0, message: "" });
  const [error, setError] = useState(null);
  const [interrupt, setInterrupt] = useState(null);
  const generate = useCallback(async (prompt) => {
    setIsGenerating(true);
    setIsLoading(true);
    setIsComplete(false);
    setError(null);
    setProgress({ stage: "starting", percent: 0, message: "Starting generation..." });
    const request = {
      id: Date.now().toString(),
      prompt,
      status: "running"
    };
    setCurrentRequest(request);
    setRequests((prev) => [...prev, request]);
    try {
      log17.debug("Generating from prompt", { prompt });
      await new Promise((resolve) => setTimeout(resolve, 100));
      request.status = "completed";
      setCurrentRequest(request);
      setIsComplete(true);
      setProgress({ stage: "complete", percent: 100, message: "Generation complete" });
      return null;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Generation failed";
      setError(errorMessage);
      request.status = "failed";
      request.error = errorMessage;
      setCurrentRequest(request);
      return null;
    } finally {
      setIsGenerating(false);
      setIsLoading(false);
    }
  }, []);
  const startGeneration = useCallback(async (skill, prompt, _options) => {
    log17.debug("Starting generation with skill", { skill });
    await generate(prompt);
  }, [generate]);
  const cancelGeneration = useCallback(() => {
    if (currentRequest) {
      currentRequest.status = "failed";
      currentRequest.error = "Cancelled by user";
      setCurrentRequest(null);
    }
    setIsGenerating(false);
    setIsLoading(false);
    setIsComplete(false);
    setProgress({ stage: "idle", percent: 0, message: "" });
  }, [currentRequest]);
  const clearRequests = useCallback(() => {
    setRequests([]);
    setCurrentRequest(null);
    setError(null);
    setProgress({ stage: "idle", percent: 0, message: "" });
    setIsComplete(false);
  }, []);
  const submitInterruptDecisions = useCallback((decisions) => {
    log17.debug("Submitting interrupt decisions", () => ({ decisions: JSON.stringify(decisions), count: decisions.length }));
    setInterrupt(null);
  }, []);
  return {
    requests,
    currentRequest,
    isGenerating,
    isLoading,
    isComplete,
    progress,
    error,
    interrupt,
    generate,
    startGeneration,
    cancelGeneration,
    clearRequests,
    submitInterruptDecisions
  };
}

// hooks/index.ts
init_useEventBus();

// hooks/useKeyboardRouter.ts
init_useEventBus();
function mergeCaptureTables(tables) {
  const merged = {};
  for (const table of tables) {
    for (const [target, entry] of Object.entries(table)) {
      const current = merged[target];
      if (!current) {
        merged[target] = { mode: entry.mode, keys: new Set(entry.keys) };
        continue;
      }
      for (const key of entry.keys) current.keys.add(key);
      if (current.mode === "any" || entry.mode === "any") current.mode = "any";
      else if (current.mode !== entry.mode) {
        current.mode = Array.from(/* @__PURE__ */ new Set([...current.mode.split("|"), entry.mode])).sort().join("|");
      }
    }
  }
  return merged;
}
function keyChord(event) {
  const parts = [];
  if (event.ctrlKey) parts.push("Control");
  if (event.altKey) parts.push("Alt");
  if (event.shiftKey) parts.push("Shift");
  if (event.metaKey) parts.push("Meta");
  parts.push(event.key);
  return parts.join("+");
}
function useKeyboardRouter(options) {
  const {
    captureTable,
    editorFocusEvent = "EDITOR_FOCUS",
    editorBlurEvent = "EDITOR_BLUR",
    keyEvent = "KEY",
    enabled = true
  } = options;
  const eventBus = useEventBus();
  const captureTableRef = useRef(captureTable);
  captureTableRef.current = captureTable;
  const focusedEditorIdRef = useRef(null);
  useEffect(() => {
    const unsubFocus = eventBus.on(`UI:${editorFocusEvent}`, (event) => {
      const editorId = event.payload?.editorId;
      if (typeof editorId === "string") {
        focusedEditorIdRef.current = editorId;
      }
    });
    const unsubBlur = eventBus.on(`UI:${editorBlurEvent}`, (event) => {
      const editorId = event.payload?.editorId;
      if (typeof editorId === "string" && focusedEditorIdRef.current === editorId) {
        focusedEditorIdRef.current = null;
      }
    });
    return () => {
      unsubFocus();
      unsubBlur();
    };
  }, [eventBus, editorFocusEvent, editorBlurEvent]);
  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (event) => {
      if (event.isComposing) return;
      const target = focusedEditorIdRef.current ?? "shell";
      const entry = captureTableRef.current[target];
      const captured = entry !== void 0 && (entry.keys.has(event.key) || entry.keys.has(keyChord(event)));
      if (captured) {
        event.preventDefault();
      }
      eventBus.emit(`UI:${keyEvent}`, {
        editorId: target,
        key: event.key,
        code: event.code,
        ctrl: event.ctrlKey,
        alt: event.altKey,
        shift: event.shiftKey,
        meta: event.metaKey,
        repeat: event.repeat
      });
    };
    window.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [eventBus, enabled, keyEvent]);
}
function expressionEqual(a, b) {
  if (Object.is(a, b)) return true;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!expressionEqual(a[i], b[i])) return false;
    }
    return true;
  }
  if (a !== null && b !== null && typeof a === "object" && typeof b === "object" && !Array.isArray(a) && !Array.isArray(b) && !(a instanceof Date) && !(b instanceof Date)) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (const key of aKeys) {
      if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
      if (!expressionEqual(
        a[key],
        b[key]
      )) return false;
    }
    return true;
  }
  return false;
}
function isPlainSlotObject(value) {
  if (value === null || value === void 0 || typeof value !== "object") return false;
  if (Array.isArray(value)) return false;
  if (React79__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  if (isRenderBindingMarker(value)) return false;
  return true;
}
function shareValue(prev, next) {
  if (Object.is(prev, next)) return { value: prev, equal: true };
  const prevMarker = isRenderBindingMarker(prev) ? prev : void 0;
  const nextMarker = isRenderBindingMarker(next) ? next : void 0;
  if (prevMarker !== void 0 || nextMarker !== void 0) {
    if (prevMarker !== void 0 && nextMarker !== void 0 && expressionEqual(prevMarker.expression, nextMarker.expression)) {
      return { value: prev, equal: true };
    }
    return { value: next, equal: false };
  }
  if (prev instanceof Date || next instanceof Date) {
    return prev instanceof Date && next instanceof Date && prev.getTime() === next.getTime() ? { value: prev, equal: true } : { value: next, equal: false };
  }
  if (typeof prev === "function" || typeof next === "function") return { value: next, equal: false };
  if (React79__default.isValidElement(prev) || React79__default.isValidElement(next)) return { value: next, equal: false };
  if (Array.isArray(prev) && Array.isArray(next)) {
    let equal = prev.length === next.length;
    const out = new Array(next.length);
    for (let i = 0; i < next.length; i++) {
      const child = shareValue(prev[i], next[i]);
      out[i] = child.value;
      if (!child.equal) equal = false;
    }
    return equal ? { value: prev, equal: true } : { value: out, equal: false };
  }
  if (isPlainSlotObject(prev) && isPlainSlotObject(next)) {
    const prevKeys = Object.keys(prev);
    const nextKeys = Object.keys(next);
    let equal = prevKeys.length === nextKeys.length;
    const out = {};
    for (const key of nextKeys) {
      if (!Object.prototype.hasOwnProperty.call(prev, key)) {
        equal = false;
        out[key] = next[key];
        continue;
      }
      const child = shareValue(prev[key], next[key]);
      out[key] = child.value;
      if (!child.equal) equal = false;
    }
    return equal ? { value: prev, equal: true } : { value: out, equal: false };
  }
  return { value: next, equal: false };
}
function reconcileSlotProps(prev, next) {
  const result = shareValue(prev, next);
  return { value: result.value, equal: result.equal };
}

// hooks/useUISlots.ts
var log18 = createLogger("almadar:ui:ui-slots");
var DEFAULT_SOURCE_KEY = "__default__";
var MULTI_SOURCE_STACK_TRAIT = "__multi_source_stack__";
var ALL_SLOTS2 = UI_SLOTS.filter(
  (slot) => !slot.includes(".") && slot !== "hud" && slot !== "screen"
);
var DEFAULT_SLOTS = ALL_SLOTS2.reduce(
  (acc, slot) => {
    acc[slot] = null;
    return acc;
  },
  {}
);
var DEFAULT_SOURCES = ALL_SLOTS2.reduce(
  (acc, slot) => {
    acc[slot] = {};
    return acc;
  },
  {}
);
function aggregateSlot(sources) {
  if (!sources) return null;
  const entries = Object.entries(sources);
  if (entries.length === 0) return null;
  if (entries.length === 1) return entries[0][1];
  const children = entries.map(([sourceKey, entry]) => ({
    type: entry.pattern,
    ...entry.props,
    ...sourceKey !== DEFAULT_SOURCE_KEY && { _sourceTrait: sourceKey }
  }));
  const stackId = `slot-content-stack-${entries.map(([k]) => k).join("-")}`;
  return {
    id: stackId,
    pattern: "stack",
    props: {
      direction: "vertical",
      gap: "lg",
      children
    },
    priority: 0,
    animation: "fade",
    sourceTrait: MULTI_SOURCE_STACK_TRAIT
  };
}
function useUISlotManager() {
  const [sources, setSources] = useState(DEFAULT_SOURCES);
  const subscribersRef = useRef(/* @__PURE__ */ new Set());
  const timersRef = useRef(/* @__PURE__ */ new Map());
  const traitIndexRef = useRef(/* @__PURE__ */ new Map());
  const traitSubscribersRef = useRef(/* @__PURE__ */ new Map());
  const slots = useMemo(() => {
    const out = { ...DEFAULT_SLOTS };
    for (const slot of ALL_SLOTS2) {
      out[slot] = aggregateSlot(sources[slot]);
    }
    return out;
  }, [sources]);
  useEffect(() => {
    return () => {
      timersRef.current.forEach((timer) => clearTimeout(timer));
      timersRef.current.clear();
    };
  }, []);
  const notifySubscribers = useCallback((slot, content) => {
    subscribersRef.current.forEach((callback) => {
      try {
        callback(slot, content);
      } catch (error) {
        log18.error("Subscriber error", { error: error instanceof Error ? error : String(error) });
      }
    });
  }, []);
  const notifyTraitSubscribers = useCallback(
    (traitName, content) => {
      const subs = traitSubscribersRef.current.get(traitName);
      if (!subs) return;
      subs.forEach((callback) => {
        try {
          callback(content);
        } catch (error) {
          log18.error("Trait subscriber error", { traitName, error: error instanceof Error ? error : String(error) });
        }
      });
    },
    []
  );
  const indexTraitRender = useCallback(
    (traitName, content) => {
      traitIndexRef.current.set(traitName, content);
    },
    []
  );
  const unindexTrait = useCallback((traitName) => {
    traitIndexRef.current.delete(traitName);
  }, []);
  const render = useCallback(
    (config) => {
      const sourceKey = config.sourceTrait ?? DEFAULT_SOURCE_KEY;
      const id = `slot-content-${config.target}-${sourceKey}`;
      const content = {
        id,
        pattern: config.pattern,
        props: config.props ?? {},
        priority: config.priority ?? 0,
        animation: config.animation ?? "fade",
        onDismiss: config.onDismiss,
        sourceTrait: config.sourceTrait,
        slot: config.target,
        transitionEvent: config.transitionEvent,
        fromState: config.fromState,
        entity: config.entity
      };
      if (config.autoDismissMs && config.autoDismissMs > 0) {
        content.autoDismissAt = Date.now() + config.autoDismissMs;
        const prevTimer = timersRef.current.get(id);
        if (prevTimer) clearTimeout(prevTimer);
        const timer = setTimeout(() => {
          setSources((prev) => {
            const slotSources = prev[config.target];
            if (slotSources && slotSources[sourceKey] === content) {
              content.onDismiss?.();
              const next = { ...slotSources };
              delete next[sourceKey];
              const updated = { ...prev, [config.target]: next };
              notifySubscribers(config.target, aggregateSlot(next));
              return updated;
            }
            return prev;
          });
          timersRef.current.delete(id);
        }, config.autoDismissMs);
        timersRef.current.set(id, timer);
      }
      setSources((prev) => {
        const slotSources = prev[config.target] ?? {};
        const existing = slotSources[sourceKey];
        if (existing && existing.priority > content.priority) {
          log18.warn("Slot already has higher priority content", {
            slot: config.target,
            sourceKey,
            existingPriority: existing.priority,
            newPriority: content.priority
          });
          return prev;
        }
        if (existing && existing.priority === content.priority && existing.pattern === content.pattern && existing.animation === content.animation && existing.transitionEvent === content.transitionEvent && existing.fromState === content.fromState && existing.entity === content.entity && existing.nodeId === content.nodeId && existing.autoDismissAt === void 0 && content.autoDismissAt === void 0 && existing.onDismiss === void 0 === (content.onDismiss === void 0)) {
          const reconciled = reconcileSlotProps(existing.props, content.props);
          if (reconciled.equal) {
            log18.debug("slot:flush-bail", { slot: config.target, sourceKey, pattern: content.pattern });
            return prev;
          }
          content.props = reconciled.value;
        }
        const nextSources = {
          ...slotSources,
          [sourceKey]: content
        };
        const nextAll = { ...prev, [config.target]: nextSources };
        const priorWriters = Object.keys(slotSources);
        if (priorWriters.length === 1 && priorWriters[0] !== sourceKey) {
          log18.warn("slot:contention", {
            slot: config.target,
            writers: [priorWriters[0], sourceKey],
            patternTypes: [slotSources[priorWriters[0]].pattern, content.pattern]
          });
        }
        if (content.sourceTrait) {
          indexTraitRender(content.sourceTrait, content);
          notifyTraitSubscribers(content.sourceTrait, content);
        }
        log18.info("slot:written", {
          slot: config.target,
          sourceKey,
          sourceTrait: content.sourceTrait,
          patternType: content.pattern,
          priority: content.priority
        });
        notifySubscribers(config.target, aggregateSlot(nextSources));
        return nextAll;
      });
      return id;
    },
    [notifySubscribers, notifyTraitSubscribers, indexTraitRender]
  );
  const clear = useCallback(
    (slot) => {
      setSources((prev) => {
        const slotSources = prev[slot];
        if (!slotSources || Object.keys(slotSources).length === 0) {
          return prev;
        }
        for (const content of Object.values(slotSources)) {
          const timer = timersRef.current.get(content.id);
          if (timer) {
            clearTimeout(timer);
            timersRef.current.delete(content.id);
          }
          content.onDismiss?.();
          if (content.sourceTrait) {
            unindexTrait(content.sourceTrait);
            notifyTraitSubscribers(content.sourceTrait, null);
          }
        }
        notifySubscribers(slot, null);
        return { ...prev, [slot]: {} };
      });
    },
    [notifySubscribers, notifyTraitSubscribers, unindexTrait]
  );
  const clearBySource = useCallback(
    (slot, sourceTrait) => {
      const sourceKey = sourceTrait;
      setSources((prev) => {
        const slotSources = prev[slot];
        if (!slotSources || !(sourceKey in slotSources)) {
          log18.debug("slot:clear-noop", { slot, sourceTrait, reason: !slotSources ? "no-slot" : "no-source" });
          return prev;
        }
        const content = slotSources[sourceKey];
        const timer = timersRef.current.get(content.id);
        if (timer) {
          clearTimeout(timer);
          timersRef.current.delete(content.id);
        }
        content.onDismiss?.();
        if (content.sourceTrait) {
          unindexTrait(content.sourceTrait);
          notifyTraitSubscribers(content.sourceTrait, null);
        }
        const nextSources = { ...slotSources };
        delete nextSources[sourceKey];
        log18.info("slot:cleared", { slot, sourceTrait, lastPatternType: content.pattern });
        notifySubscribers(slot, aggregateSlot(nextSources));
        return { ...prev, [slot]: nextSources };
      });
    },
    [notifySubscribers, notifyTraitSubscribers, unindexTrait]
  );
  const clearById = useCallback(
    (id) => {
      setSources((prev) => {
        for (const slot of ALL_SLOTS2) {
          const slotSources = prev[slot];
          if (!slotSources) continue;
          const matchKey = Object.keys(slotSources).find(
            (k) => slotSources[k].id === id
          );
          if (!matchKey) continue;
          const content = slotSources[matchKey];
          const timer = timersRef.current.get(id);
          if (timer) {
            clearTimeout(timer);
            timersRef.current.delete(id);
          }
          content.onDismiss?.();
          if (content.sourceTrait) {
            unindexTrait(content.sourceTrait);
            notifyTraitSubscribers(content.sourceTrait, null);
          }
          const nextSources = { ...slotSources };
          delete nextSources[matchKey];
          notifySubscribers(slot, aggregateSlot(nextSources));
          return { ...prev, [slot]: nextSources };
        }
        return prev;
      });
    },
    [notifySubscribers, notifyTraitSubscribers, unindexTrait]
  );
  const clearAll = useCallback(() => {
    timersRef.current.forEach((timer) => clearTimeout(timer));
    timersRef.current.clear();
    setSources((prev) => {
      for (const slot of ALL_SLOTS2) {
        const slotSources = prev[slot];
        if (!slotSources) continue;
        for (const content of Object.values(slotSources)) {
          content.onDismiss?.();
          if (content.sourceTrait) {
            notifyTraitSubscribers(content.sourceTrait, null);
          }
        }
        notifySubscribers(slot, null);
      }
      return DEFAULT_SOURCES;
    });
    traitIndexRef.current.clear();
  }, [notifySubscribers, notifyTraitSubscribers]);
  const subscribe = useCallback((callback) => {
    subscribersRef.current.add(callback);
    return () => {
      subscribersRef.current.delete(callback);
    };
  }, []);
  const hasContent = useCallback(
    (slot) => slots[slot] !== null,
    [slots]
  );
  const getContent = useCallback(
    (slot) => slots[slot] ?? null,
    [slots]
  );
  const getTraitContent = useCallback(
    (traitName) => traitIndexRef.current.get(traitName) ?? null,
    []
  );
  const subscribeTrait = useCallback(
    (traitName, callback) => {
      let set = traitSubscribersRef.current.get(traitName);
      if (!set) {
        set = /* @__PURE__ */ new Set();
        traitSubscribersRef.current.set(traitName, set);
      }
      set.add(callback);
      return () => {
        const s = traitSubscribersRef.current.get(traitName);
        if (!s) return;
        s.delete(callback);
        if (s.size === 0) {
          traitSubscribersRef.current.delete(traitName);
        }
      };
    },
    []
  );
  const updateTraitContent = useCallback(
    (traitName, content) => {
      const id = `slot-content-trait-${traitName}`;
      const fullContent = { ...content, id, sourceTrait: traitName };
      indexTraitRender(traitName, fullContent);
      notifyTraitSubscribers(traitName, fullContent);
      return id;
    },
    [indexTraitRender, notifyTraitSubscribers]
  );
  return {
    slots,
    render,
    clear,
    clearBySource,
    clearById,
    clearAll,
    subscribe,
    hasContent,
    getContent,
    getTraitContent,
    subscribeTrait,
    updateTraitContent
  };
}

// hooks/useUIEvents.ts
init_useEventBus();
var UI_PREFIX = "UI:";
function useUIEvents(dispatch, traitName, validEvents, eventBusInstance) {
  const defaultEventBus = useEventBus();
  const eventBus = eventBusInstance ?? defaultEventBus;
  const validEventsKey = validEvents.slice().sort().join(",");
  const stableValidEvents = useMemo(
    () => validEvents,
    [validEventsKey]
    // intentional — validEventsKey is the stable dep
  );
  useEffect(() => {
    const unsubscribes = [];
    for (const smEvent of stableValidEvents) {
      const handler = (event) => {
        if (event.source && event.source.dispatched) {
          return;
        }
        dispatch(smEvent, event.payload);
      };
      unsubscribes.push(
        eventBus.on(`${UI_PREFIX}${traitName}.${smEvent}`, handler)
      );
    }
    return () => {
      for (const unsub of unsubscribes) {
        if (typeof unsub === "function") unsub();
      }
    };
  }, [eventBus, dispatch, traitName, stableValidEvents]);
}
function useTraitListens(dispatch, listens, eventBusInstance) {
  const defaultEventBus = useEventBus();
  const eventBus = eventBusInstance ?? defaultEventBus;
  const stableKey = listens.map((l) => `${l.sourceKey}->${l.trigger}`).sort().join("|");
  const stableListens = useMemo(
    () => listens,
    [stableKey]
    // intentional
  );
  useEffect(() => {
    const unsubscribes = [];
    for (const spec of stableListens) {
      const handler = (event) => {
        dispatch(spec.trigger, event.payload);
      };
      unsubscribes.push(eventBus.on(`${UI_PREFIX}${spec.sourceKey}`, handler));
    }
    return () => {
      for (const unsub of unsubscribes) {
        if (typeof unsub === "function") unsub();
      }
    };
  }, [eventBus, dispatch, stableListens]);
}
var log19 = createLogger("almadar:ui:shared-entity-store");
var EMPTY_ENTITY_STATE = {};
function createSharedEntityStore() {
  const states = /* @__PURE__ */ new Map();
  const subscribers = /* @__PURE__ */ new Map();
  const getSnapshot2 = (entityId) => states.get(entityId) ?? EMPTY_ENTITY_STATE;
  const subscribe = (entityId, callback) => {
    let set = subscribers.get(entityId);
    if (!set) {
      set = /* @__PURE__ */ new Set();
      subscribers.set(entityId, set);
    }
    set.add(callback);
    return () => {
      const current = subscribers.get(entityId);
      if (!current) return;
      current.delete(callback);
      if (current.size === 0) {
        subscribers.delete(entityId);
      }
    };
  };
  const commit = (entityId, nextState) => {
    states.set(entityId, nextState);
    const set = subscribers.get(entityId);
    if (!set) return;
    set.forEach((callback) => {
      try {
        callback();
      } catch (error) {
        log19.error("Shared entity subscriber error", {
          entityId,
          error: error instanceof Error ? error : String(error)
        });
      }
    });
  };
  const seed = (entityId, initialState) => {
    if (!states.has(entityId)) {
      states.set(entityId, initialState);
    }
  };
  return { getSnapshot: getSnapshot2, subscribe, commit, seed };
}
function useSharedEntityStore() {
  const storeRef = useRef(null);
  if (storeRef.current === null) {
    storeRef.current = createSharedEntityStore();
  }
  return storeRef.current;
}
var SharedEntityStoreContext = createContext(null);
function useSharedEntityStoreContext() {
  const store = useContext(SharedEntityStoreContext);
  if (!store) {
    throw new Error(
      "useSharedEntityStoreContext: no SharedEntityStoreContext.Provider found in the component tree"
    );
  }
  return store;
}
function useSharedEntitySnapshot(store, entityId) {
  return useSyncExternalStore(
    (onStoreChange) => store.subscribe(entityId, onStoreChange),
    () => store.getSnapshot(entityId)
  );
}
function runTickFrame(entityId, orderedWriters, store) {
  let scratch = store.getSnapshot(entityId);
  for (const writer of orderedWriters) {
    const writes = writer(scratch);
    scratch = mergeEntityFrame(scratch, writes);
  }
  store.commit(entityId, scratch);
  return scratch;
}

// hooks/index.ts
init_useQuerySingleton();

// locales/en.json
var en_default = {
  $meta: {
    locale: "en",
    direction: "ltr"
  },
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.confirm": "Are you sure?",
  "common.create": "Create",
  "common.edit": "Edit",
  "common.title": "Title",
  "common.view": "View",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.search": "Search...",
  "common.filter": "Filter",
  "common.actions": "Actions",
  "common.yes": "Yes",
  "common.no": "No",
  "common.selected": "selected",
  "common.ok": "OK",
  "common.done": "Done",
  "common.apply": "Apply",
  "common.reset": "Reset",
  "common.refresh": "Refresh",
  "common.export": "Export",
  "common.import": "Import",
  "common.copy": "Copy",
  "common.settings": "Settings",
  "nav.previous": "Previous",
  "nav.next": "Next",
  "nav.back": "Back",
  "nav.home": "Home",
  "form.submit": "Submit",
  "form.saving": "Saving...",
  "form.required": "This field is required",
  "form.invalidEmail": "Enter a valid email address",
  "form.selectPlaceholder": "Select {{label}}...",
  "form.searchPlaceholder": "Search {{entity}}...",
  "table.empty.title": "No items found",
  "table.empty.description": "No items to display.",
  "table.search.placeholder": "Search...",
  "table.pagination.showing": "Showing {{start}} to {{end}} of {{total}} results",
  "table.pagination.page": "Page {{page}} of {{totalPages}}",
  "table.bulk.selected": "{{count}} selected",
  "table.loading": "Loading...",
  "status.loading": "Loading...",
  "status.scheduled": "Scheduled",
  "status.inProgress": "In Progress",
  "status.completed": "Completed",
  "status.cancelled": "Cancelled",
  "status.pending": "Pending",
  "status.active": "Active",
  "status.inactive": "Inactive",
  "status.draft": "Draft",
  "status.archived": "Archived",
  "error.generic": "Something went wrong",
  "error.retry": "Try again",
  "error.notFound": "Not found",
  "error.loadFailed": "Failed to load: {{message}}",
  "error.configMissing": "Configuration not found for: {{id}}",
  "common.loading": "Loading...",
  "common.showMore": "Show More",
  "common.showLess": "Show Less",
  "common.noResults": "No results found",
  "common.saveChanges": "Save Changes",
  "common.retry": "Retry",
  "common.open": "Open",
  "common.back": "Back",
  "empty.noItems": "No items",
  "empty.noData": "No data available",
  "empty.noItemsYet": "No items yet",
  "empty.noItemsAdded": "No items added yet",
  "empty.noOptionsFound": "No options found",
  "list.addItemPlaceholder": "Add new item...",
  "error.occurred": "An error occurred",
  "error.failedToLoad": "Failed to load data",
  "wizard.back": "Back",
  "wizard.next": "Next",
  "wizard.complete": "Complete",
  "wizard.stepOf": "Step {{current}} of {{total}}",
  "pagination.previous": "Previous",
  "pagination.next": "Next",
  "pagination.total": "Total:",
  "pagination.show": "Show:",
  "pagination.goTo": "Go to:",
  "pagination.go": "Go",
  "auth.signIn": "Sign in",
  "auth.signOut": "Sign out",
  "dialog.confirm": "Confirm",
  "dialog.cancel": "Cancel",
  "dialog.loading": "Loading...",
  "dialog.delete.title": "Delete {{item}}?",
  "dialog.delete.message": "This action cannot be undone.",
  "trait.availableActions": "Available Actions",
  "trait.transitions": "Transitions",
  "trait.availableNow": "Available now",
  "book.startReading": "Start Reading",
  "book.tableOfContents": "Table of Contents",
  "book.partNumber": "Part {{number}}",
  "book.print": "Print",
  "book.previousPage": "Previous page",
  "book.nextPage": "Next page",
  "quiz.showAnswer": "Show answer",
  "quiz.hideAnswer": "Hide answer",
  "aria.closeModal": "Close modal",
  "aria.closeToast": "Dismiss toast",
  "aria.closeAlert": "Dismiss alert",
  "aria.removeFilter": "Remove filter",
  "aria.closeDrawer": "Close drawer",
  "aria.closePanel": "Close panel",
  "aria.previousImage": "Previous image",
  "aria.nextImage": "Next image",
  "aria.dismiss": "Dismiss",
  "aria.previousSlide": "Previous slide",
  "aria.nextSlide": "Next slide",
  "aria.previousDays": "Previous days",
  "aria.nextDays": "Next days",
  "aria.decrease": "Decrease",
  "aria.increase": "Increase",
  "aria.breadcrumb": "Breadcrumb",
  "aria.tableOfContents": "Table of contents",
  "aria.docsSidebar": "Documentation sidebar",
  "aria.selectAllRows": "Select all rows",
  "aria.selectAll": "Select all",
  "aria.upvote": "Upvote",
  "aria.downvote": "Downvote",
  "aria.qrScanner": "QR scanner",
  "aria.mockScanDev": "Mock scan (dev)",
  "aria.openMenu": "Open menu",
  "aria.closeMenu": "Close menu",
  "aria.openSidebar": "Open sidebar",
  "sidebar.expand": "Expand sidebar",
  "sidebar.collapse": "Collapse sidebar",
  "sidebar.close": "Close sidebar",
  "loading.items": "Loading items...",
  "card.imageAlt": "Image",
  "canvas.emptyMessage": "No content",
  "canvas.errorTitle": "Canvas error",
  "book.noData": "No data",
  "common.notifications": "Notifications",
  "common.remaining": "{{count}} remaining",
  "error.somethingWentWrong": "Something went wrong",
  "error.loadingItems": "Loading items...",
  "error.noItemsFound": "No items found",
  "debug.noEntityData": "No entity data",
  "debug.noEntities": "No entities",
  "debug.noTicks": "No ticks registered",
  "debug.noActiveTraits": "No active traits",
  "debug.noGuardEvaluations": "No guard evaluations",
  "debug.noBridgeData": "No bridge data",
  "debug.status": "Status",
  "debug.eventsForwarded": "Events Forwarded (Client \u2192 Server)",
  "debug.eventsReceived": "Events Received (Server \u2192 Client)",
  "debug.lastHeartbeat": "Last Heartbeat",
  "debug.noEventsYet": "No events yet",
  "debug.noTransitionsRecorded": "No transitions recorded",
  "debug.noVerificationChecks": "No verification checks yet",
  "display.chartError": "Chart error",
  "display.codeViewerError": "Code viewer error",
  "display.noCode": "No code",
  "display.documentError": "Document error",
  "display.noDocument": "No document",
  "display.graphError": "Graph error",
  "display.noGraphData": "No graph data",
  "display.galleryError": "Gallery error",
  "display.noMedia": "No media",
  "display.meterError": "Meter error",
  "display.signaturePadError": "Signature pad error",
  "display.timelineError": "Timeline error",
  "display.noEvents": "No events",
  "template.features": "Features",
  "template.howItWorks": "How It Works",
  "template.showcase": "Showcase",
  "template.faq": "Frequently Asked Questions",
  "template.ourTeam": "Our Team",
  "template.caseStudies": "Case Studies",
  "versionDiff.compare": "Compare",
  "versionDiff.to": "to",
  "versionDiff.beforeRevision": "Before revision",
  "versionDiff.afterRevision": "After revision",
  "versionDiff.switchToInline": "Switch to inline view",
  "versionDiff.switchToSideBySide": "Switch to side-by-side view",
  "versionDiff.revert": "Revert",
  "versionDiff.byAuthor": " by {{author}}",
  "violationAlert.actionType.measure": "Corrective Measure",
  "violationAlert.actionType.admin": "Administrative Action",
  "violationAlert.actionType.penalty": "Penalty Proceedings",
  "violationAlert.fallbackMessage": "Violation",
  "violationAlert.adminLabel": "Admin:",
  "violationAlert.penaltyLabel": "Penalty:",
  "violationAlert.goToField": "Go to field",
  "branchingLogic.title": "Branching logic",
  "branchingLogic.if": "If",
  "branchingLogic.goTo": "go to",
  "branchingLogic.rules": "Rules",
  "branchingLogic.logicGraph": "Logic graph",
  "branchingLogic.addRule": "Add rule",
  "branchingLogic.deleteRule": "Delete rule",
  "branchingLogic.endOfSurvey": "End of survey",
  "branchingLogic.brokenReference": "Broken reference",
  "branchingLogic.selectQuestion": "Select question",
  "branchingLogic.selectTarget": "Select target",
  "branchingLogic.selectValue": "Select value",
  "branchingLogic.addValue": "Add value",
  "branchingLogic.value": "Value",
  "branchingLogic.typeValuePressEnter": "Type value, press Enter",
  "branchingLogic.operatorEquals": "equals",
  "branchingLogic.operatorNotEquals": "does not equal",
  "branchingLogic.operatorContains": "contains",
  "branchingLogic.operatorIn": "is one of",
  "branchingLogic.graphAriaLabel": "Branching logic graph",
  "branchingLogic.ruleCountOne": "{{count}} rule",
  "branchingLogic.ruleCountOther": "{{count}} rules",
  "branchingLogic.brokenCount": "{{count}} broken",
  "branchingLogic.emptyNoQuestions": "Add questions before building branching rules.",
  "branchingLogic.emptyNoRules": "No rules yet. Add a rule to define branching logic.",
  "filterGroup.filters": "Filters",
  "filterGroup.all": "All",
  "filterGroup.clear": "Clear",
  "filterGroup.clearAll": "Clear all",
  "filterGroup.from": "From",
  "filterGroup.to": "To",
  "filterGroup.allOf": "All {{label}}",
  "filterGroup.activeCount": "{{count}} active",
  "debug.guardEvaluationsHint": "Guard evaluations will appear when transitions or ticks with guards execute",
  "debug.expression": "Expression",
  "debug.inputs": "Inputs",
  "debug.trait": "Trait",
  "debug.filterAll": "All",
  "debug.filterPassed": "Passed",
  "debug.filterFailed": "Failed",
  "debug.traitsInitHint": "Traits will appear when the state machine initializes",
  "debug.traitsMountHint": "Traits will appear when components using them are mounted",
  "debug.activeStates": "Active States",
  "debug.availableEvents": "Available Events",
  "debug.noTransitionsFromState": "No transitions from current state",
  "debug.guarded": "guarded",
  "debug.otherEvents": "Other Events (not available from current state)",
  "debug.recentTransitions": "Recent Transitions",
  "debug.transitionsCount": "{{count}} transitions",
  "debug.states": "States",
  "debug.transitions": "Transitions",
  "debug.guards": "Guards",
  "debug.debugModeHint": "Debug mode may not be enabled",
  "debug.entitiesSpawnHint": "Entities will appear when spawned",
  "debug.singleton": "Singleton",
  "debug.singletonsCount": "Singletons ({{count}})",
  "debug.runtimeCount": "Runtime ({{count}})",
  "debug.moreEntities": "+{{count}} more entities",
  "debug.persistent": "Persistent",
  "debug.loadedCount": "{{count}} loaded",
  "debug.notLoaded": "not loaded",
  "debug.eventsExecuteHint": "Events will appear as traits, ticks, and other systems execute",
  "debug.allCount": "All ({{count}})",
  "debug.autoScroll": "Auto-scroll",
  "debug.transitionsProcessHint": "Transitions will appear as the state machine processes events",
  "debug.transitionsRecorded": "{{count}} transitions recorded",
  "debug.guardLabel": "guard:",
  "debug.effectsCount": "{{count}} effects",
  "debug.bridgeInitHint": "The ServerBridge has not been initialized. Bridge health will appear once the runtime connects to the server.",
  "debug.never": "Never",
  "debug.connected": "Connected",
  "debug.disconnected": "Disconnected",
  "debug.lastError": "Last Error",
  "debug.totalEventsProcessed": "{{count}} total events processed",
  "debug.server": "server",
  "debug.clientEffectsCount": "{{count}} clientEffects",
  "debug.emitLabel": "emit:",
  "debug.rowsCount": "{{count}} rows",
  "debug.serverResponse": "server response",
  "debug.collapseVerificationTimeline": "Collapse verification timeline",
  "debug.expandVerificationTimeline": "Expand verification timeline",
  "debug.failCount": "{{count}} fail",
  "debug.ok": "OK",
  "debug.localCount": "{{count}} local",
  "debug.serverCount": "{{count}} server",
  "debug.waitingForTransitions": "Waiting for transitions...",
  "debug.tabDispatch": "Dispatch",
  "debug.tabVerify": "Verify",
  "debug.tabVerifyAlert": "Verify (!)",
  "debug.tabTimeline": "Timeline",
  "debug.tabBridge": "Bridge",
  "debug.tabTraits": "Traits",
  "debug.tabTicks": "Ticks",
  "debug.tabEntities": "Entities",
  "debug.tabEvents": "Events",
  "debug.tabGuards": "Guards",
  "debug.debugger": "Debugger",
  "debug.failedCount": "{{count}} failed",
  "debug.traitsCount": "{{count}} traits",
  "debug.idle": "Idle",
  "debug.openDebugger": "Open Debugger (`)",
  "debug.kflowVerifier": "KFlow Verifier",
  "debug.allPassing": "All passing",
  "debug.runtime": "Runtime",
  "debug.close": "Close (`)",
  "debug.toggleHint": "Press ` to toggle | window.__orbitalVerification for automation",
  "replyTree.expandReplies": "Expand replies",
  "replyTree.collapseReplies": "Collapse replies",
  "replyTree.voteOnReplyBy": "Vote on reply by {{author}}",
  "replyTree.replyTo": "Reply to {{author}}",
  "replyTree.replyToPlaceholder": "Reply to {{author}}\u2026",
  "replyTree.reply": "Reply",
  "replyTree.flagReplyBy": "Flag reply by {{author}}",
  "replyTree.flag": "Flag",
  "replyTree.send": "Send",
  "replyTree.continueThread": "Continue thread",
  "replyTree.noRepliesYet": "No replies yet.",
  "signaturePad.label": "Signature",
  "signaturePad.helperText": "Draw your signature above",
  "signaturePad.clear": "Clear",
  "signaturePad.confirm": "Confirm",
  "qrScanner.cameraUnavailable": "Camera unavailable",
  "qrScanner.paused": "Paused",
  "qrScanner.resumeScanning": "Resume scanning",
  "qrScanner.pauseScanning": "Pause scanning",
  "qrScanner.switchToFrontCamera": "Switch to front camera",
  "qrScanner.switchToRearCamera": "Switch to rear camera",
  "qrScanner.mockScan": "Mock Scan",
  "docSearch.placeholder": "Search documentation...",
  "stateMachine.loading": "Loading state machine\u2026",
  "stateMachine.noStateMachine": "No state machine to visualize",
  "avl.trigger": "Trigger",
  "avl.guard": "Guard",
  "avl.effects": "Effects",
  "avl.props": "Props",
  "avl.entity": "Entity",
  "avl.traits": "Traits",
  "avl.transition": "Transition",
  "avl.onEntity": "on {{entity}}",
  "avl.linkedTo": "linked to {{entity}}",
  "avl.pressEscToZoomOut": "Press Esc to zoom out",
  "avl.zoomIn": "Zoom in",
  "avl.zoomOut": "Zoom out",
  "avl.orbitalLabel": "Orbital: {{name}}",
  "avl.orbitalLabelHighlighted": "Orbital: {{name}} (highlighted)",
  "avl.noTraitData": "No trait data",
  "avl.computingLayout": "Computing layout...",
  "avl.noStateMachine": "No state machine",
  "avl.listensFor": "listens for {{event}}",
  "avl.emits": "emits {{event}}",
  "avl.pageLayout": "Page Layout",
  "avl.overlaySuffix": "(overlay)",
  "orbPreview.previewBadge": "Preview",
  "orbPreview.doubleClickToOpen": "Double-click to open",
  "orbPreview.dropToAddAndOpen": "Drop to add and open",
  "orbPreview.dispatching": "Coordinator is dispatching to this orbital",
  "orbPreview.noPreview": "No preview available",
  "orbPreview.screensCount": "{{count}} screens",
  "detailView.noTransitionData": "No transition data",
  "orbInspector.required": "req",
  "orbInspector.addField": "Add Field",
  "orbInspector.serviceMode": "Service Mode",
  "orbInspector.standalone": "Standalone",
  "orbInspector.embedded": "Embedded",
  "orbInspector.rendersOwnUi": "Renders its own UI",
  "orbInspector.headless": "Headless, wired to other behaviors",
  "orbInspector.addEffect": "Add Effect",
  "orbInspector.guardExpression": "Guard expression",
  "orbInspector.selectPatternForStyles": "Select a pattern to view its style tokens.",
  "orbInspector.tokens": "Tokens",
  "orbInspector.noTokenContract": "No token contract declared for this pattern.",
  "orbInspector.variant": "Variant",
  "orbInspector.size": "Size",
  "orbInspector.statesCount": "{{count}} states",
  "orbInspector.onEntity": " on {{entity}}",
  "orbInspector.projectThemeTokens": "Project theme tokens",
  "orbInspector.tokenGroup.colors": "Colors",
  "orbInspector.tokenGroup.radii": "Radii",
  "orbInspector.tokenGroup.spacing": "Spacing",
  "orbInspector.tokenGroup.shadows": "Shadows",
  "orbInspector.tab.inspector": "Inspector",
  "orbInspector.tab.styles": "Styles",
  "orbInspector.tab.design": "Design",
  "orbInspector.tab.prototype": "Prototype",
  "orbInspector.tab.code": "Code",
  "canvas.goBackToOverview": "Go back to overview",
  "canvas.overview": "Overview",
  "canvas.expanded": "Expanded",
  "canvas.modulesCount": "{{count}} modules",
  "canvas.screensCount": "{{count}} screens",
  "canvas.switchToView": "Switch to {{label}} view",
  "lawReference.viewFullText": "View full law text",
  "statCard.defaultLabel": "Stat",
  "statCard.vsLastPeriod": "vs last period",
  "mediaGallery.upload": "Upload",
  "mediaGallery.noMediaDescription": "No media items to display.",
  "pagination.jumpPlaceholder": "Page",
  "table.selectRow": "Select row {{id}}",
  "card.selectItem": "Select {{item}}",
  "card.itemFallback": "item",
  "fileTree.noFiles": "No files",
  "masterDetail.selectItem": "Select an item to view details",
  "empty.createFirst": "Create your first item to get started.",
  "upload.dropOrBrowse": "Drop files here or click to browse",
  "upload.dropFilesHere": "Drop files here",
  "upload.accepted": "Accepted: {{accept}}",
  "upload.maxSize": "Max size: {{size}}",
  "upload.maxFiles": "Up to {{count}} files",
  "upload.error.maxFiles": "Maximum {{count}} files allowed",
  "upload.error.invalidType": "Invalid file type: {{name}}",
  "upload.error.tooLarge": "File too large: {{name}} (max {{size}})",
  "optionConstraint.requiredOne": "Required, pick 1",
  "optionConstraint.optionalOne": "Optional, pick up to 1",
  "optionConstraint.pickExactly": "Pick exactly {{count}}",
  "optionConstraint.pickRange": "Pick {{min}}-{{max}}",
  "optionConstraint.pickAtLeast": "Pick at least {{count}}",
  "optionConstraint.pickUpTo": "Pick up to {{count}}",
  "optionConstraint.optional": "Optional",
  "optionConstraint.outOfStock": "Out of stock",
  "optionConstraint.error.pickOne": "Pick 1 option",
  "optionConstraint.error.pickOnlyOne": "Pick only 1 option",
  "optionConstraint.error.pickMore": "Pick at least {{count}} more",
  "optionConstraint.error.removeOptions": "Remove {{count}} options",
  "stateMachine.pinned": "Pinned",
  "stateMachine.eventCount": "{{count}} events",
  "stateMachine.externalEffects": "External Effects",
  "stateMachine.legend.initial": "Initial",
  "stateMachine.legend.final": "Final",
  "stateMachine.legend.state": "State",
  "stateMachine.legend.multiEvent": "Multi-event",
  "relationSelect.selectPlaceholder": "Select...",
  "battle.cancel": "Cancel",
  "battle.defeat": "Defeat",
  "battle.endTurn": "End Turn",
  "battle.playAgain": "Play Again",
  "battle.turnsPlayed": "Turns Played",
  "battle.victory": "Victory",
  "builder.allPlaced": "All placed",
  "builder.blueprint": "Blueprint",
  "builder.build": "Build",
  "builder.components": "Components",
  "builder.empty": "Empty",
  "builder.reset": "Reset",
  "builder.success": "Success",
  "classifier.allCorrect": "All correct!",
  "classifier.check": "Check",
  "classifier.correct": "correct",
  "classifier.itemsToSort": "Items to sort",
  "classifier.reset": "Reset",
  "common.error": "Error",
  "debugger.allFound": "All bugs found!",
  "debugger.bugsFound": "bugs found",
  "debugger.findBugs": "Find {{count}} bugs",
  "debugger.reset": "Reset",
  "debugger.submit": "Submit",
  "error.genericLoad": "Failed to load",
  "error.loadingData": "Loading data",
  "eventHandler.addRule": "Add Rule",
  "eventHandler.chainComplete": "Chain complete!",
  "eventHandler.clickObject": "Click objects",
  "eventHandler.eventLog": "Event Log",
  "eventHandler.heardEvent": "{{object}} heard {{event}} \u2192 {{action}}",
  "eventHandler.noEvents": "No events yet",
  "eventHandler.noListeners": "No listeners for {{event}}",
  "eventHandler.rules": "{{count}}/{{max}} rules",
  "eventHandler.simulationStarted": "Simulating: {{events}}",
  "eventHandler.state": "State",
  "eventHandler.then": "then",
  "eventHandler.when": "When",
  "game.goal": "Goal",
  "game.hint": "Hint",
  "game.play": "Play",
  "game.reset": "Reset",
  "game.runTests": "Run Tests",
  "negotiator.chooseAction": "Choose an action",
  "negotiator.failed": "Negotiation failed",
  "negotiator.finalScore": "Final score",
  "negotiator.history": "History",
  "negotiator.opponent": "Opponent",
  "negotiator.playAgain": "Play Again",
  "negotiator.round": "Round {{current}} of {{total}}",
  "negotiator.success": "Negotiation successful",
  "negotiator.target": "Target",
  "negotiator.you": "You",
  "platformer.level": "Level",
  "platformer.lost": "Game Over",
  "platformer.nextLevel": "Next Level",
  "platformer.noLives": "No lives left",
  "platformer.playAgain": "Play Again",
  "platformer.score": "Score",
  "platformer.won": "You won!",
  "puzzle.tryAgainButton": "Try Again",
  "roguelike.atk": "ATK",
  "roguelike.cleared": "Dungeon cleared! Depth reached: {{depth}}",
  "roguelike.defeat": "Defeated!",
  "roguelike.depth": "Depth",
  "roguelike.enemy": "Enemy",
  "roguelike.hp": "HP",
  "roguelike.phase": "Phase",
  "roguelike.playAgain": "Play Again",
  "roguelike.player": "Hero",
  "roguelike.victory": "Victory!",
  "sequencer.actions": "Actions",
  "sequencer.dragActions": "Drag actions here",
  "sequencer.levelComplete": "Level complete!",
  "sequencer.yourSequence": "Your sequence",
  "simulator.correct": "Correct",
  "simulator.incorrect": "Incorrect",
  "simulator.parameters": "Parameters",
  "simulator.reset": "Reset",
  "simulator.simulate": "Simulate",
  "simulator.target": "Target",
  "stateArchitect.addTransition": "Add transition from {{state}}",
  "stateArchitect.addTransitionPrompt": "Click target state",
  "stateArchitect.allPassed": "All tests passed!",
  "stateArchitect.clickTarget": "Click a target state (current: {{state}})",
  "stateArchitect.gotState": "Got state: {{state}}",
  "stateArchitect.graph": "Graph",
  "stateArchitect.hideJson": "Hide JSON",
  "stateArchitect.showJson": "Show JSON",
  "stateArchitect.testResults": "Test Results",
  "stateArchitect.transitions": "{{count}} transitions",
  "stateArchitect.variables": "Variables: {{name}}",
  "stateArchitect.viewCode": "View Code",
  "td.defeat": "Defeat",
  "td.gold": "Gold",
  "td.lives": "Lives",
  "td.livesReachedZero": "Your base was overrun",
  "td.placeTower": "Place tower",
  "td.playAgain": "Play Again",
  "td.startWave": "Start Wave",
  "td.survivedAllWaves": "Survived all waves!",
  "td.victory": "Victory!",
  "td.wave": "Wave",
  "td.waveInProgress": "Wave in progress\u2026",
  "documentDetails.title": "Details",
  "documentPanel.untitled": "Untitled",
  "documentPanel.edit": "Edit",
  "documentPanel.done": "Done",
  "documentPanel.autosaveHint": "Saves as you type",
  "documentPanel.placeholder": "Start writing\u2026",
  "richTextEditor.editorToolbar": "Formatting toolbar",
  "richTextEditor.editorSurface": "Rich text editor",
  "richTextEditor.bold": "Bold",
  "richTextEditor.italic": "Italic",
  "richTextEditor.underline": "Underline",
  "richTextEditor.strikethrough": "Strikethrough",
  "richTextEditor.heading1": "Heading 1",
  "richTextEditor.heading2": "Heading 2",
  "richTextEditor.heading3": "Heading 3",
  "richTextEditor.bulletList": "Bullet list",
  "richTextEditor.numberedList": "Numbered list",
  "richTextEditor.quote": "Quote",
  "richTextEditor.code": "Code",
  "richTextEditor.link": "Add link",
  "richTextEditor.removeLink": "Remove link",
  "richTextEditor.divider": "Divider",
  "richTextEditor.linkPrompt": "Link address",
  "richTextEditor.image": "Insert image",
  "richTextEditor.imagePrompt": "Image URL",
  "richTextEditor.placeholder": "Start writing\u2026",
  "form.imageUrlFallback": "\u2026or paste an image address",
  "mermaid.unrenderable": "This diagram could not be displayed. Its source is shown below."
};

// hooks/useTranslate.ts
var { $meta: _meta, ...coreMessages } = en_default;
var coreLocale = coreMessages;
var I18nContext = createContext({
  locale: "en",
  direction: "ltr",
  t: (key, params) => {
    let msg = coreLocale[key] ?? key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        msg = msg.split(`{{${k}}}`).join(String(v));
      }
    }
    return msg;
  }
});
I18nContext.displayName = "I18nContext";
var I18nProvider = I18nContext.Provider;
function useTranslate118() {
  return useContext(I18nContext);
}
function createTranslate(messages) {
  return (key, params) => {
    let msg = messages[key] ?? coreLocale[key] ?? key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        msg = msg.split(`{{${k}}}`).join(String(v));
      }
    }
    return msg;
  };
}

// hooks/index.ts
init_useAuthContext();
init_useSwipeGesture();
init_useLongPress();
init_useDragReorder();
function useMediaQuery(query) {
  const subscribe = useCallback(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    [query]
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  );
}

// hooks/index.ts
init_useInfiniteScroll();
init_usePullToRefresh();
init_useCanvasGestures();
init_useTapReveal();
init_useDraggable();
init_useDropZone();
function useRenderInterpolation(options = {}) {
  const tickIntervalMs = options.tickIntervalMs ?? 1e3 / 30;
  const prevRef = useRef(null);
  const currRef = useRef(null);
  const rafRef = useRef(null);
  const onSnapshot = useCallback((entities) => {
    prevRef.current = currRef.current;
    currRef.current = { entities, arrivedAt: performance.now() };
  }, []);
  const getInterpolated = useCallback((now) => {
    const out = /* @__PURE__ */ new Map();
    const curr = currRef.current;
    if (!curr) return out;
    const prev = prevRef.current;
    if (!prev) {
      for (const e of curr.entities) out.set(e.id, { x: e.x, y: e.y });
      return out;
    }
    const rawAlpha = (now - curr.arrivedAt) / tickIntervalMs;
    const alpha = rawAlpha < 0 ? 0 : rawAlpha > 1 ? 1 : rawAlpha;
    const prevMap = /* @__PURE__ */ new Map();
    for (const e of prev.entities) prevMap.set(e.id, e);
    for (const c of curr.entities) {
      const p = prevMap.get(c.id);
      if (!p) {
        out.set(c.id, { x: c.x, y: c.y });
      } else {
        out.set(c.id, {
          x: p.x + (c.x - p.x) * alpha,
          y: p.y + (c.y - p.y) * alpha
        });
      }
    }
    return out;
  }, [tickIntervalMs]);
  const startLoop = useCallback(
    (draw) => {
      let active = true;
      const loop = () => {
        if (!active) return;
        try {
          draw(getInterpolated(performance.now()));
        } catch {
        }
        rafRef.current = requestAnimationFrame(loop);
      };
      rafRef.current = requestAnimationFrame(loop);
      return () => {
        active = false;
        if (rafRef.current !== null) {
          cancelAnimationFrame(rafRef.current);
          rafRef.current = null;
        }
      };
    },
    [getInterpolated]
  );
  useEffect(() => {
    return () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, []);
  return { onSnapshot, getInterpolated, startLoop };
}
var API_BASE = typeof process !== "undefined" && process.env?.VITE_API_URL ? process.env.VITE_API_URL : "http://localhost:3000";
function getUserId() {
  return localStorage.getItem("userId") || "anonymous";
}
async function fetchWithAuth(endpoint, options) {
  const userId = getUserId();
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "x-user-id": userId,
      ...options?.headers
    }
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(error.error || error.message || "Request failed");
  }
  return response.json();
}
function useGitHubStatus() {
  return useQuery({
    queryKey: ["github", "status"],
    queryFn: () => fetchWithAuth("/api/github/status"),
    staleTime: 6e4,
    // 1 minute
    retry: false
  });
}
function useConnectGitHub() {
  const connectGitHub = useCallback(() => {
    const userId = getUserId();
    const state = btoa(JSON.stringify({ userId, returnUrl: window.location.href }));
    window.location.href = `${API_BASE}/api/github/oauth/authorize?state=${state}`;
  }, []);
  return { connectGitHub };
}
function useDisconnectGitHub() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => fetchWithAuth("/api/github/disconnect", { method: "POST" }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["github", "status"] });
      queryClient.removeQueries({ queryKey: ["github", "repos"] });
    }
  });
}
function useGitHubRepos(page = 1, perPage = 30) {
  return useQuery({
    queryKey: ["github", "repos", page, perPage],
    queryFn: () => fetchWithAuth(`/api/github/repos?page=${page}&per_page=${perPage}`),
    enabled: true,
    // Only fetch if user is connected
    staleTime: 3e5
    // 5 minutes
  });
}
function useGitHubRepo(owner, repo, enabled = true) {
  return useQuery({
    queryKey: ["github", "repo", owner, repo],
    queryFn: () => fetchWithAuth(`/api/github/repos/${owner}/${repo}`),
    enabled: enabled && !!owner && !!repo,
    staleTime: 3e5
    // 5 minutes
  });
}
function useGitHubBranches(owner, repo, enabled = true) {
  return useQuery({
    queryKey: ["github", "branches", owner, repo],
    queryFn: () => fetchWithAuth(`/api/github/repos/${owner}/${repo}/branches`),
    enabled: enabled && !!owner && !!repo,
    staleTime: 6e4
    // 1 minute
  });
}

// types/slot-host.ts
function assertUniqueSlotsPerHost(manifest) {
  const seenBySlot = /* @__PURE__ */ new Map();
  for (const [regionId, region] of Object.entries(manifest.regions)) {
    const existingRegionId = seenBySlot.get(region.slot);
    if (existingRegionId !== void 0) {
      throw new Error(
        `assertUniqueSlotsPerHost: regions "${existingRegionId}" and "${regionId}" both bind slot "${region.slot}" \u2014 a slot may be mounted by only one region per host.`
      );
    }
    seenBySlot.set(region.slot, regionId);
  }
}

export { ALL_PRESETS, ALMADAR_DND_MIME, AR_BOOK_FIELDS, AboutPageTemplate, Accordion, Card2 as ActionCard, ActionPalette, ActionTile, ActivationBlock, Alert, AlgoGraphCanvas, AlgorithmCanvas, AnimatedCounter, AnimatedGraphic, AnimatedReveal, ArticleSection, Aside, AssetPicker, AtlasImage, AtlasPanel, AuthLayout, Avatar, Badge, BehaviorView, BiologyCanvas, BloomQuizBlock, BookChapterView, BookCoverPage, BookNavBar, BookTableOfContents, BookViewer, Box, BranchingLogicBuilder, Breadcrumb, Button, ButtonGroup, CTABanner, CalendarGrid, Canvas, Canvas2D, Card, CardBody, CardContent, CardFooter, CardGrid, CardHeader, CardTitle, Carousel, CaseStudyCard, CaseStudyOrganism, Center, Chart, ChartLegend, ChatBar, Checkbox, ChemistryCanvas, ChoiceButton, Coachmark, CodeBlock, CodeRunnerPanel, CollapsibleSection, CommandPalette, CommunityLinks, ConditionalWrapper, ConfettiEffect, ConfirmDialog, ConnectionBlock, Container, ContentRenderer, ContentSection, ControlButton, ControlGrid, CounterTemplate, DEFAULT_LIKERT_OPTIONS, DEFAULT_MATRIX_COLUMNS, DEFAULT_SLOTS, DIAMOND_TOP_Y, DashboardGrid, DashboardLayout, DataGrid, DataList, DataTable, DateRangePicker, DateRangeSelector, DayCell, DetailPanel, Dialog, DialogueBubble, Divider, DocBreadcrumb, DocPagination, DocSearch, DocSidebar, DocTOC, DockLayout, DocumentDetails, DocumentPanel, DocumentViewer, StateMachineView as DomStateMachineVisualizer, Drawer, DrawerSlot, ELEMENT_SELECTED_EVENT, EdgeDecoration, EditorCheckbox, EditorSelect, EditorSlider, EditorTextInput, EditorToolbar, EmojiPicker, EmptyState, EntityDisplayEvents, ErrorBoundary, ErrorState, FEATURE_COLORS, FEATURE_TYPES, FLOOR_HEIGHT, FeatureCard, FeatureDetailPageTemplate, FeatureGrid, FeatureGridOrganism, FileTree, FilterGroup, FilterPill, Flex, FlipCard, FlipContainer, FloatingActionButton, FloatingToolbar, Form, FormActions, FormField, FormLayout, FormSection, FormSectionHeader, FxOverlay, GameAudioCue, GameAudioToggle, GameHud, GameIcon, GameMenu, GameShell, Gantt, GenericAppTemplate, GeometricPattern, GradientDivider, GraphCanvas, GraphView, Grid, GridPicker, HStack, Header, HealthBar, HeroOrganism, HeroSection, I18nProvider, IDENTITY_BOOK_FIELDS, Icon, IconPicker, ImportPreviewTree, ImportProgress, ImportSourcePicker, InfiniteScrollSentinel, Input, InputGroup, InstallBox, JazariStateMachine, JsonTreeEditor, Label, LandingPageTemplate, LawReferenceTooltip, LearningCanvas, LearningScene3D, Lightbox, LikertScale, LineChart2 as LineChart, List3 as List, LoadingState, MapView, MarkdownContent, MarketingFooter, MarketingStatCard, MasterDetail, MasterDetailLayout, MathCanvas, MatrixQuestion, MediaGallery, Menu, Meter, Modal, ModalSlot, ModuleCard, Navigation, NodeSlotEditor, NumberStepper, OnboardingSpotlight, OptionConstraintGroup, StateMachineView as OrbitalStateMachineView, OrbitalVisualization, Overlay, PageHeader, PageTransition, Pagination, PatternTile, PhysicsCanvas, Popover, PositionedCanvas, Presence, PricingCard, PricingGrid, PricingOrganism, PricingPageTemplate, ProgressBar, ProgressDots, PropertyInspector, PullQuote, PullToRefresh, QrScanner, QuizBlock, Radio, RangeSlider, ReflectionBlock, RelationSelect, RepeatableFormSection, ReplyTree, RichTextEditor, RuntimeDebugger, SHEET_COLUMNS, SPRITE_SHEET_LAYOUT, ScaledDiagram, ScoreDisplay, SearchInput, Section, SectionHeader, SegmentRenderer, Select, SequenceBar, ServiceCatalog, SharedEntityStoreContext, ShowcaseCard, ShowcaseOrganism, SidePanel, Sidebar, SignaturePad, SimpleGrid, Skeleton, SlotContentRenderer, SocialProof, SortableList, Spacer, Sparkline, Spinner, Split, SplitPane, SplitSection, Stack, StarRating, StatBadge, StatCard, StatDisplay, StateGraph, StateJsonView, StateMachineView, StateNode2 as StateNode, StatsGrid, StatsOrganism, StatusBar, StatusDot, StepFlow, StepFlowOrganism, SubagentTracePanel, SvgBranch, SvgConnection, SvgFlow, SvgGrid, SvgLobe, SvgMesh, SvgMorph, SvgNode, SvgPulse, SvgRing, SvgShield, SvgStack, SwipeableRow, Switch, TERRAIN_COLORS, TILE_HEIGHT, TILE_WIDTH, TabbedContainer, TableView, Tabs, TagCloud, TagInput, TeamCard, TeamOrganism, TerrainPalette, TextHighlight, Textarea, ThemeToggle, TimeSlotCell, Timeline, TimerDisplay, Toast, ToastSlot, Tooltip, TraitFrame, TraitSlot, TraitStateViewer, TransitionArrow, TrendIndicator, TypewriterText, Typography, UISlotComponent, UISlotRenderer, UploadDropZone, VStack, VersionDiff, ViolationAlert, VoteStack, WizardContainer, WizardNavigation, WizardProgress, arrowBetween, assertUniqueSlotsPerHost, billboardLabel, boardEntity, bool, calculateAttackTargets, calculateValidMoves, cn, createInitialGameState, createSharedEntityStore, createTranslate, createUnitAnimationState, cylinderBetween, dispatchCommandPaletteCommand, get3DClickPayload, getCurrentFrame, getTileDimensions, inferDirection, isoToScreen, keyChord, makeAsset, makeAssetMap, mapBookData, mergeCaptureTables, meshSphere, num, objAvailableActions, objAvailableEvents, objCurrentState, objIcon, objId, objMaxRules, objName, objRules, objStates, parseEditFocus, parseLessonSegments, parseMarkdownWithCodeBlocks, parseQueryBinding, pendulum, projectileMotion, registerCodeLanguageLoader, renderPatternValue, resolveFieldMap, resolveFrame, resolveSheetDirection, rows, runTickFrame, sanitizeRichHtml, screenToIso, springOscillator, str, tickAnimationState, toCodeLanguage, transitionAnimation, unitHealth, unitPosition, unitTeam, useAgentChat, useAnchorRect, useAtlasSliceDataUrl, useAuthContext, useCamera, useCanvasGestures, useCompile, useConnectGitHub, useDeepAgentGeneration, useDisconnectGitHub, useDragReorder, useDraggable, useDropZone, useEmitEvent, useEventBus, useEventListener, useExtensions, useFileEditor, useFileSystem, useGameAudio, useGitHubBranches, useGitHubRepo, useGitHubRepos, useGitHubStatus, useImageCache, useInfiniteScroll, useKeyboardRouter, useLongPress, useMediaQuery, useOrbitalHistory, usePresence, usePreview, usePullToRefresh, useQuerySingleton, useRenderInterpolation, useSharedEntitySnapshot, useSharedEntityStore, useSharedEntityStoreContext, useSwipeGesture, useTapReveal, useTraitListens, useTranslate118 as useTranslate, useUIEvents, useUISlotManager, useUnitSpriteAtlas, useValidation, vec2 };
